
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredc1b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredc1b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9awXB", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6ace9d7cd2d8eb0d$export$ffb0004e005737fa; });
$parcel$export(module.exports, "jsx", function () { return $6ace9d7cd2d8eb0d$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $6ace9d7cd2d8eb0d$export$25062201e9e25d76; });

var $ih19M = parcelRequire("ih19M");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("bh6RR");
parcelRequire("gbgGf");
parcelRequire("3Tqyg");
parcelRequire("ieFqf");

parcelRequire("adG4d");
parcelRequire("cdpIC");
parcelRequire("9v6T8");
parcelRequire("fPHYJ");
var $6ace9d7cd2d8eb0d$export$ffb0004e005737fa = $ih19M.Fragment;
function $6ace9d7cd2d8eb0d$export$34b9dba7ce09269b(type, props, key) {
    if (!(0, $iwq56.h).call(props, "css")) return $ih19M.jsx(type, props, key);
    return $ih19M.jsx((0, $iwq56.E), (0, $iwq56.c)(type, props), key);
}
function $6ace9d7cd2d8eb0d$export$25062201e9e25d76(type, props, key) {
    if (!(0, $iwq56.h).call(props, "css")) return $ih19M.jsxs(type, props, key);
    return $ih19M.jsxs((0, $iwq56.E), (0, $iwq56.c)(type, props), key);
}

});
parcelRegister("ih19M", function(module, exports) {
"use strict";

module.exports = (parcelRequire("0qhf8"));

});
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("iwq56", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $d7bf72605dee4607$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $d7bf72605dee4607$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $d7bf72605dee4607$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $d7bf72605dee4607$export$971d5caa766a69d7; });
$parcel$export(module.exports, "u", function () { return $d7bf72605dee4607$export$3b14a55fb2447963; });
$parcel$export(module.exports, "b", function () { return $d7bf72605dee4607$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "h", function () { return $d7bf72605dee4607$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $d7bf72605dee4607$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $d7bf72605dee4607$export$a9c23c6ac3fc3eca; });

var $bh6RR = parcelRequire("bh6RR");

var $gbgGf = parcelRequire("gbgGf");

var $4WYaH = parcelRequire("4WYaH");

var $ieFqf = parcelRequire("ieFqf");

var $fFdqN = parcelRequire("fFdqN");

var $cdpIC = parcelRequire("cdpIC");

var $9v6T8 = parcelRequire("9v6T8");

var $fPHYJ = parcelRequire("fPHYJ");
var $d7bf72605dee4607$export$407448d2b89b1813 = false;
var $d7bf72605dee4607$export$23f2a1d2818174ef = typeof document !== "undefined";
/* import { type EmotionCache } from '@emotion/utils' */ var $d7bf72605dee4607$var$EmotionCacheContext = /* #__PURE__ */ $bh6RR.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $gbgGf.default)({
    key: "css"
}) : null);
var $d7bf72605dee4607$export$e7094788287c5e9b = $d7bf72605dee4607$var$EmotionCacheContext.Provider;
var $d7bf72605dee4607$export$71511d61b312f219 = function useEmotionCache() /*: EmotionCache | null*/ {
    return (0, $bh6RR.useContext)($d7bf72605dee4607$var$EmotionCacheContext);
};
var $d7bf72605dee4607$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.AbstractComponent<Props> */ {
    return /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $bh6RR.useContext)($d7bf72605dee4607$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$d7bf72605dee4607$export$23f2a1d2818174ef) $d7bf72605dee4607$export$efccba1c4a2ef57b = function withEmotionCache(func) /*: React.StatelessFunctionalComponent<Props> */ {
    return function(props) {
        var cache = (0, $bh6RR.useContext)($d7bf72605dee4607$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $gbgGf.default)({
                key: "css"
            });
            return /*#__PURE__*/ $bh6RR.createElement($d7bf72605dee4607$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $d7bf72605dee4607$export$971d5caa766a69d7 = /* #__PURE__ */ $bh6RR.createContext({});
var $d7bf72605dee4607$export$3b14a55fb2447963 = function useTheme() {
    return $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7);
};
var $d7bf72605dee4607$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $4WYaH.default)({}, outerTheme, theme);
};
var $d7bf72605dee4607$var$createCacheWithTheme = /* #__PURE__ */ (0, $ieFqf.default)(function(outerTheme) {
    return (0, $ieFqf.default)(function(theme) {
        return $d7bf72605dee4607$var$getTheme(outerTheme, theme);
    });
});
/*
type ThemeProviderProps = {
  theme: Object | (Object => Object),
  children: React.Node
}
*/ var $d7bf72605dee4607$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $d7bf72605dee4607$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $bh6RR.createElement($d7bf72605dee4607$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $d7bf72605dee4607$export$4368d992c4eafac0(Component) /*: React.AbstractComponent<$Diff<Config, { theme: Object }>> */ {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7);
        return /*#__PURE__*/ $bh6RR.createElement(Component, (0, $4WYaH.default)({
            theme: theme,
            ref: ref
        }, props));
    };
    var WithTheme = /*#__PURE__*/ $bh6RR.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $fFdqN.default)(WithTheme, Component);
}
var $d7bf72605dee4607$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $d7bf72605dee4607$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $d7bf72605dee4607$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($d7bf72605dee4607$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$d7bf72605dee4607$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $d7bf72605dee4607$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $cdpIC.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fPHYJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $cdpIC.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$d7bf72605dee4607$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $d7bf72605dee4607$var$Emotion = /* #__PURE__ */ $d7bf72605dee4607$export$efccba1c4a2ef57b(/* <any, any> */ function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$d7bf72605dee4607$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $cdpIC.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $9v6T8.serializeStyles)(registeredStyles, undefined, $bh6RR.useContext($d7bf72605dee4607$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($d7bf72605dee4607$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $d7bf72605dee4607$var$typePropName && !$d7bf72605dee4607$export$407448d2b89b1813) newProps[key] = props[key];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($d7bf72605dee4607$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $bh6RR.createElement(WrappedComponent, newProps));
});
var $d7bf72605dee4607$export$a9c23c6ac3fc3eca = $d7bf72605dee4607$var$Emotion;

});
parcelRegister("gbgGf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7a9ccd09b383ef$export$2e2bcd8739ae039; });

var $k2OLv = parcelRequire("k2OLv");

var $sdBdz = parcelRequire("sdBdz");

var $ieFqf = parcelRequire("ieFqf");

var $cthCm = parcelRequire("cthCm");
var $bc7a9ccd09b383ef$var$isBrowser = typeof document !== "undefined";
var $bc7a9ccd09b383ef$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $sdBdz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $sdBdz.token)(character)) break;
        (0, $sdBdz.next)();
    }
    return (0, $sdBdz.slice)(begin, (0, $sdBdz.position));
};
var $bc7a9ccd09b383ef$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $sdBdz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $sdBdz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $bc7a9ccd09b383ef$var$identifierWithPointTracking((0, $sdBdz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $sdBdz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $sdBdz.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $sdBdz.from)(character);
    }
    while (character = (0, $sdBdz.next)());
    return parsed;
};
var $bc7a9ccd09b383ef$var$getRules = function getRules(value, points) {
    return (0, $sdBdz.dealloc)($bc7a9ccd09b383ef$var$toRules((0, $sdBdz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $bc7a9ccd09b383ef$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $bc7a9ccd09b383ef$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$bc7a9ccd09b383ef$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $bc7a9ccd09b383ef$var$fixedElements.set(element, true);
    var points = [];
    var rules = $bc7a9ccd09b383ef$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $bc7a9ccd09b383ef$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
/* eslint-disable no-fallthrough */ function $bc7a9ccd09b383ef$var$prefix(value, length) {
    switch((0, $sdBdz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $sdBdz.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $sdBdz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MOZ) + value + (0, $sdBdz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
        // order
        case 6165:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.replace)(value, /(\w+).+(:[^]+)/, (0, $sdBdz.WEBKIT) + "box-$1$2" + (0, $sdBdz.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-item-" + (0, $sdBdz.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + "flex-line-pack" + (0, $sdBdz.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $sdBdz.WEBKIT) + "box-" + (0, $sdBdz.replace)(value, "-grow", "") + (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $sdBdz.WEBKIT) + (0, $sdBdz.replace)(value, /([^-])(transform)/g, "$1" + (0, $sdBdz.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(zoom-|grab)/, (0, $sdBdz.WEBKIT) + "$1"), /(image-set)/, (0, $sdBdz.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $sdBdz.replace)(value, /(image-set\([^]*)/, (0, $sdBdz.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $sdBdz.replace)((0, $sdBdz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $sdBdz.WEBKIT) + "box-pack:$3" + (0, $sdBdz.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $sdBdz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $sdBdz.replace)(value, /(.+)-inline(.+)/, (0, $sdBdz.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $sdBdz.strlen)(value) - 1 - length > 6) switch((0, $sdBdz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $sdBdz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $sdBdz.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $sdBdz.WEBKIT) + "$2-$3" + "$1" + (0, $sdBdz.MOZ) + ((0, $sdBdz.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $sdBdz.indexof)(value, "stretch") ? $bc7a9ccd09b383ef$var$prefix((0, $sdBdz.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $sdBdz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $sdBdz.charat)(value, (0, $sdBdz.strlen)(value) - 3 - (~(0, $sdBdz.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $sdBdz.replace)(value, ":", ":" + (0, $sdBdz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $sdBdz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $sdBdz.WEBKIT) + ((0, $sdBdz.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $sdBdz.WEBKIT) + "$2$3" + "$1" + (0, $sdBdz.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $sdBdz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + (0, $sdBdz.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $sdBdz.WEBKIT) + value + (0, $sdBdz.MS) + value + value;
    }
    return value;
}
var $bc7a9ccd09b383ef$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $sdBdz.DECLARATION:
                element["return"] = $bc7a9ccd09b383ef$var$prefix(element.value, element.length);
                break;
            case 0, $sdBdz.KEYFRAMES:
                return (0, $sdBdz.serialize)([
                    (0, $sdBdz.copy)(element, {
                        value: (0, $sdBdz.replace)(element.value, "@", "@" + (0, $sdBdz.WEBKIT))
                    })
                ], callback);
            case 0, $sdBdz.RULESET:
                if (element.length) return (0, $sdBdz.combine)(element.props, function(value) {
                    switch((0, $sdBdz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(read-\w+)/, ":" + (0, $sdBdz.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $sdBdz.serialize)([
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ":" + (0, $sdBdz.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, ":" + (0, $sdBdz.MOZ) + "$1")
                                    ]
                                }),
                                (0, $sdBdz.copy)(element, {
                                    props: [
                                        (0, $sdBdz.replace)(value, /:(plac\w+)/, (0, $sdBdz.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
/* import type { StylisPlugin } from './types' */ /*
export type Options = {
  nonce?: string,
  stylisPlugins?: StylisPlugin[],
  key: string,
  container?: HTMLElement,
  speedy?: boolean,
  prepend?: boolean,
  insertionPoint?: HTMLElement
}
*/ var $bc7a9ccd09b383ef$var$getServerStylisCache = $bc7a9ccd09b383ef$var$isBrowser ? undefined : (0, $ieFqf.default)(function() {
    return (0, $cthCm.default)(function() {
        var cache = {};
        return function(name) {
            return cache[name];
        };
    });
});
var $bc7a9ccd09b383ef$var$defaultStylisPlugins = [
    $bc7a9ccd09b383ef$var$prefixer
];
var $bc7a9ccd09b383ef$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if ($bc7a9ccd09b383ef$var$isBrowser && key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $bc7a9ccd09b383ef$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    if ($bc7a9ccd09b383ef$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
            var attrib = node.getAttribute("data-emotion").split(" ");
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $bc7a9ccd09b383ef$var$compat,
        $bc7a9ccd09b383ef$var$removeLabel
    ];
    if ($bc7a9ccd09b383ef$var$isBrowser) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $sdBdz.stringify),
            (0, $sdBdz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $sdBdz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $sdBdz.serialize)((0, $sdBdz.compile)(styles), serializer);
        };
        _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $sdBdz.stringify)
        ];
        var _serializer = (0, $sdBdz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $sdBdz.serialize)((0, $sdBdz.compile)(styles), _serializer);
        };
        var serverStylisCache = $bc7a9ccd09b383ef$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function /*: string */ getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function /*: string | void */ _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $k2OLv.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("k2OLv", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $e97b5f72ed127b53$export$9d753cd7ae895cce; });
var $e97b5f72ed127b53$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e97b5f72ed127b53$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e97b5f72ed127b53$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $e97b5f72ed127b53$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e97b5f72ed127b53$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e97b5f72ed127b53$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e97b5f72ed127b53$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("sdBdz", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $783faa7ec18221fc$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $783faa7ec18221fc$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $783faa7ec18221fc$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $783faa7ec18221fc$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $783faa7ec18221fc$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $783faa7ec18221fc$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $783faa7ec18221fc$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $783faa7ec18221fc$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $783faa7ec18221fc$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $783faa7ec18221fc$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $783faa7ec18221fc$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $783faa7ec18221fc$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $783faa7ec18221fc$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $783faa7ec18221fc$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $783faa7ec18221fc$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $783faa7ec18221fc$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $783faa7ec18221fc$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $783faa7ec18221fc$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $783faa7ec18221fc$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $783faa7ec18221fc$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $783faa7ec18221fc$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $783faa7ec18221fc$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $783faa7ec18221fc$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $783faa7ec18221fc$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $783faa7ec18221fc$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $783faa7ec18221fc$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $783faa7ec18221fc$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $783faa7ec18221fc$export$38bcb760f1d4871c; });
var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(j += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $783faa7ec18221fc$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(j) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(y = $783faa7ec18221fc$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, y, y, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(j += $783faa7ec18221fc$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) j += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(g = j += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $783faa7ec18221fc$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $783faa7ec18221fc$export$2f35ab04d2335697(e, v + 1, v = $783faa7ec18221fc$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $783faa7ec18221fc$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span") ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch") ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $783faa7ec18221fc$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                    props: [
                                        $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("ieFqf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d469aa6647f846c1$export$2e2bcd8739ae039; });
var $d469aa6647f846c1$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("cthCm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9145dbf8e0e857b1$export$2e2bcd8739ae039; });
function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("4WYaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39ab41060f0dd572$export$2e2bcd8739ae039; });
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39ab41060f0dd572$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("fFdqN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6751a8254c8738e$export$2e2bcd8739ae039; });

var $adG4d = parcelRequire("adG4d");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $b6751a8254c8738e$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(targetComponent, sourceComponent);
};

});
parcelRegister("adG4d", function(module, exports) {
"use strict";

var $lhF4u = parcelRequire("lhF4u");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($lhF4u.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component["$$typeof"]] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("lhF4u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("g4WQO"));

});
parcelRegister("g4WQO", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bb4aab9d21a68c2e$export$2b8d127b894957b9; }, function (v) { return $bb4aab9d21a68c2e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bb4aab9d21a68c2e$export$cea3a54a6425200c; }, function (v) { return $bb4aab9d21a68c2e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae; }, function (v) { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d; }, function (v) { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac; }, function (v) { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35; }, function (v) { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bb4aab9d21a68c2e$export$ffb0004e005737fa; }, function (v) { return $bb4aab9d21a68c2e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bb4aab9d21a68c2e$export$b624eff549462981; }, function (v) { return $bb4aab9d21a68c2e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bb4aab9d21a68c2e$export$7897aa7841a5380c; }, function (v) { return $bb4aab9d21a68c2e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bb4aab9d21a68c2e$export$602eac185826482c; }, function (v) { return $bb4aab9d21a68c2e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bb4aab9d21a68c2e$export$e2c29f18771995cb; }, function (v) { return $bb4aab9d21a68c2e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bb4aab9d21a68c2e$export$5f8d39834fd61797; }, function (v) { return $bb4aab9d21a68c2e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5; }, function (v) { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bb4aab9d21a68c2e$export$92387174baf9b227; }, function (v) { return $bb4aab9d21a68c2e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6; }, function (v) { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bb4aab9d21a68c2e$export$b706b080d889d2c9; }, function (v) { return $bb4aab9d21a68c2e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc; }, function (v) { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d; }, function (v) { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bb4aab9d21a68c2e$export$455c2e768291efa6; }, function (v) { return $bb4aab9d21a68c2e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bb4aab9d21a68c2e$export$9522e17588c12572; }, function (v) { return $bb4aab9d21a68c2e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bb4aab9d21a68c2e$export$2110ac352bb060b9; }, function (v) { return $bb4aab9d21a68c2e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab; }, function (v) { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de; }, function (v) { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bb4aab9d21a68c2e$export$b82d16f27459e05a; }, function (v) { return $bb4aab9d21a68c2e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8; }, function (v) { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6; }, function (v) { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bb4aab9d21a68c2e$export$9b621391a187a31a; }, function (v) { return $bb4aab9d21a68c2e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f; }, function (v) { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb4aab9d21a68c2e$export$2b8d127b894957b9;
var $bb4aab9d21a68c2e$export$cea3a54a6425200c;
var $bb4aab9d21a68c2e$export$a7c73072b1a182ae;
var $bb4aab9d21a68c2e$export$9f27bc3417b4524d;
var $bb4aab9d21a68c2e$export$db77ccec0bb4ccac;
var $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35;
var $bb4aab9d21a68c2e$export$ffb0004e005737fa;
var $bb4aab9d21a68c2e$export$b624eff549462981;
var $bb4aab9d21a68c2e$export$7897aa7841a5380c;
var $bb4aab9d21a68c2e$export$602eac185826482c;
var $bb4aab9d21a68c2e$export$e2c29f18771995cb;
var $bb4aab9d21a68c2e$export$5f8d39834fd61797;
var $bb4aab9d21a68c2e$export$74bf444e3cd11ea5;
var $bb4aab9d21a68c2e$export$92387174baf9b227;
var $bb4aab9d21a68c2e$export$ec112efeb987d9c6;
var $bb4aab9d21a68c2e$export$b706b080d889d2c9;
var $bb4aab9d21a68c2e$export$5be5a87408f70ddc;
var $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d;
var $bb4aab9d21a68c2e$export$455c2e768291efa6;
var $bb4aab9d21a68c2e$export$9522e17588c12572;
var $bb4aab9d21a68c2e$export$2110ac352bb060b9;
var $bb4aab9d21a68c2e$export$56885ab8b9c456ab;
var $bb4aab9d21a68c2e$export$d927fcb6adf8f9de;
var $bb4aab9d21a68c2e$export$b82d16f27459e05a;
var $bb4aab9d21a68c2e$export$522c17b4f5e123e8;
var $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6;
var $bb4aab9d21a68c2e$export$9b621391a187a31a;
var $bb4aab9d21a68c2e$export$f5bbd400c2f4426f;
"use strict";
var $bb4aab9d21a68c2e$var$b = "function" === typeof Symbol && Symbol.for, $bb4aab9d21a68c2e$var$c = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.element") : 60103, $bb4aab9d21a68c2e$var$d = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.portal") : 60106, $bb4aab9d21a68c2e$var$e = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fragment") : 60107, $bb4aab9d21a68c2e$var$f = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.strict_mode") : 60108, $bb4aab9d21a68c2e$var$g = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.profiler") : 60114, $bb4aab9d21a68c2e$var$h = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.provider") : 60109, $bb4aab9d21a68c2e$var$k = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.context") : 60110, $bb4aab9d21a68c2e$var$l = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.async_mode") : 60111, $bb4aab9d21a68c2e$var$m = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bb4aab9d21a68c2e$var$n = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.forward_ref") : 60112, $bb4aab9d21a68c2e$var$p = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense") : 60113, $bb4aab9d21a68c2e$var$q = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense_list") : 60120, $bb4aab9d21a68c2e$var$r = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.memo") : 60115, $bb4aab9d21a68c2e$var$t = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.lazy") : 60116, $bb4aab9d21a68c2e$var$v = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.block") : 60121, $bb4aab9d21a68c2e$var$w = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fundamental") : 60117, $bb4aab9d21a68c2e$var$x = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.responder") : 60118, $bb4aab9d21a68c2e$var$y = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.scope") : 60119;
function $bb4aab9d21a68c2e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bb4aab9d21a68c2e$var$c:
                switch(a = a.type, a){
                    case $bb4aab9d21a68c2e$var$l:
                    case $bb4aab9d21a68c2e$var$m:
                    case $bb4aab9d21a68c2e$var$e:
                    case $bb4aab9d21a68c2e$var$g:
                    case $bb4aab9d21a68c2e$var$f:
                    case $bb4aab9d21a68c2e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bb4aab9d21a68c2e$var$k:
                            case $bb4aab9d21a68c2e$var$n:
                            case $bb4aab9d21a68c2e$var$t:
                            case $bb4aab9d21a68c2e$var$r:
                            case $bb4aab9d21a68c2e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bb4aab9d21a68c2e$var$d:
                return u;
        }
    }
}
function $bb4aab9d21a68c2e$var$A(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$m;
}
$bb4aab9d21a68c2e$export$2b8d127b894957b9 = $bb4aab9d21a68c2e$var$l;
$bb4aab9d21a68c2e$export$cea3a54a6425200c = $bb4aab9d21a68c2e$var$m;
$bb4aab9d21a68c2e$export$a7c73072b1a182ae = $bb4aab9d21a68c2e$var$k;
$bb4aab9d21a68c2e$export$9f27bc3417b4524d = $bb4aab9d21a68c2e$var$h;
$bb4aab9d21a68c2e$export$db77ccec0bb4ccac = $bb4aab9d21a68c2e$var$c;
$bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = $bb4aab9d21a68c2e$var$n;
$bb4aab9d21a68c2e$export$ffb0004e005737fa = $bb4aab9d21a68c2e$var$e;
$bb4aab9d21a68c2e$export$b624eff549462981 = $bb4aab9d21a68c2e$var$t;
$bb4aab9d21a68c2e$export$7897aa7841a5380c = $bb4aab9d21a68c2e$var$r;
$bb4aab9d21a68c2e$export$602eac185826482c = $bb4aab9d21a68c2e$var$d;
$bb4aab9d21a68c2e$export$e2c29f18771995cb = $bb4aab9d21a68c2e$var$g;
$bb4aab9d21a68c2e$export$5f8d39834fd61797 = $bb4aab9d21a68c2e$var$f;
$bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = $bb4aab9d21a68c2e$var$p;
$bb4aab9d21a68c2e$export$92387174baf9b227 = function(a) {
    return $bb4aab9d21a68c2e$var$A(a) || $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$l;
};
$bb4aab9d21a68c2e$export$ec112efeb987d9c6 = $bb4aab9d21a68c2e$var$A;
$bb4aab9d21a68c2e$export$b706b080d889d2c9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$k;
};
$bb4aab9d21a68c2e$export$5be5a87408f70ddc = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$h;
};
$bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb4aab9d21a68c2e$var$c;
};
$bb4aab9d21a68c2e$export$455c2e768291efa6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$n;
};
$bb4aab9d21a68c2e$export$9522e17588c12572 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$e;
};
$bb4aab9d21a68c2e$export$2110ac352bb060b9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$t;
};
$bb4aab9d21a68c2e$export$56885ab8b9c456ab = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$r;
};
$bb4aab9d21a68c2e$export$d927fcb6adf8f9de = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$d;
};
$bb4aab9d21a68c2e$export$b82d16f27459e05a = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$g;
};
$bb4aab9d21a68c2e$export$522c17b4f5e123e8 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$f;
};
$bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$p;
};
$bb4aab9d21a68c2e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bb4aab9d21a68c2e$var$e || a === $bb4aab9d21a68c2e$var$m || a === $bb4aab9d21a68c2e$var$g || a === $bb4aab9d21a68c2e$var$f || a === $bb4aab9d21a68c2e$var$p || a === $bb4aab9d21a68c2e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bb4aab9d21a68c2e$var$t || a.$$typeof === $bb4aab9d21a68c2e$var$r || a.$$typeof === $bb4aab9d21a68c2e$var$h || a.$$typeof === $bb4aab9d21a68c2e$var$k || a.$$typeof === $bb4aab9d21a68c2e$var$n || a.$$typeof === $bb4aab9d21a68c2e$var$w || a.$$typeof === $bb4aab9d21a68c2e$var$x || a.$$typeof === $bb4aab9d21a68c2e$var$y || a.$$typeof === $bb4aab9d21a68c2e$var$v);
};
$bb4aab9d21a68c2e$export$f5bbd400c2f4426f = $bb4aab9d21a68c2e$var$z;

});




parcelRegister("cdpIC", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $8e4aa61dd4b95f07$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $8e4aa61dd4b95f07$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $8e4aa61dd4b95f07$export$6f077d94b33a01aa; });
var $8e4aa61dd4b95f07$var$isBrowser = typeof document !== "undefined";
function $8e4aa61dd4b95f07$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $8e4aa61dd4b95f07$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $8e4aa61dd4b95f07$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $8e4aa61dd4b95f07$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $8e4aa61dd4b95f07$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = "";
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            if (!$8e4aa61dd4b95f07$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$8e4aa61dd4b95f07$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("9v6T8", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $6eac5a28f6e72cd5$export$6321afa313b251b5; });

var $171Pu = parcelRequire("171Pu");

var $amwve = parcelRequire("amwve");

var $cthCm = parcelRequire("cthCm");
var $6eac5a28f6e72cd5$var$isDevelopment = false;
var $6eac5a28f6e72cd5$var$hyphenateRegex = /[A-Z]|^ms/g;
var $6eac5a28f6e72cd5$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $6eac5a28f6e72cd5$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $6eac5a28f6e72cd5$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $6eac5a28f6e72cd5$var$processStyleName = /* #__PURE__ */ (0, $cthCm.default)(function(styleName) {
    return $6eac5a28f6e72cd5$var$isCustomProperty(styleName) ? styleName : styleName.replace($6eac5a28f6e72cd5$var$hyphenateRegex, "-$&").toLowerCase();
});
var $6eac5a28f6e72cd5$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($6eac5a28f6e72cd5$var$animationRegex, function(match, p1, p2) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return p1;
            });
    }
    if ((0, $amwve.default)[key] !== 1 && !$6eac5a28f6e72cd5$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $6eac5a28f6e72cd5$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $6eac5a28f6e72cd5$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $6eac5a28f6e72cd5$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $6eac5a28f6e72cd5$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $6eac5a28f6e72cd5$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $6eac5a28f6e72cd5$var$cursor;
                var result = interpolation(mergedProps);
                $6eac5a28f6e72cd5$var$cursor = previousCursor;
                return $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $6eac5a28f6e72cd5$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== "object") {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($6eac5a28f6e72cd5$var$isProcessableValue(asString)) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === "NO_COMPONENT_SELECTOR" && $6eac5a28f6e72cd5$var$isDevelopment) throw new Error($6eac5a28f6e72cd5$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($6eac5a28f6e72cd5$var$isProcessableValue(value[_i])) string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + $6eac5a28f6e72cd5$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case "animation":
                    case "animationName":
                        string += $6eac5a28f6e72cd5$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $6eac5a28f6e72cd5$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list
var $6eac5a28f6e72cd5$var$cursor;
function $6eac5a28f6e72cd5$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $6eac5a28f6e72cd5$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $6eac5a28f6e72cd5$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    }
    $6eac5a28f6e72cd5$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $6eac5a28f6e72cd5$var$labelPattern.exec(styles)) !== null)identifierName += "-" + match[1];
    var name = (0, $171Pu.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $6eac5a28f6e72cd5$var$cursor
    };
}

});
parcelRegister("171Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf7dd2d70c55cf3$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0cf7dd2d70c55cf3$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("amwve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78b52bced097bc64$export$2e2bcd8739ae039; });
var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fPHYJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $b86dbba518057278$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $b86dbba518057278$export$811a713a7276cb9d; });

var $bh6RR = parcelRequire("bh6RR");
var $b86dbba518057278$var$isBrowser = typeof document !== "undefined";
var $b86dbba518057278$var$syncFallback = function syncFallback(create) {
    return create();
};
var $b86dbba518057278$var$useInsertionEffect = $bh6RR.useInsertionEffect ? $bh6RR.useInsertionEffect : false;
var $b86dbba518057278$export$db21c7ffa21794e7 = !$b86dbba518057278$var$isBrowser ? $b86dbba518057278$var$syncFallback : $b86dbba518057278$var$useInsertionEffect || $b86dbba518057278$var$syncFallback;
var $b86dbba518057278$export$811a713a7276cb9d = $b86dbba518057278$var$useInsertionEffect || $bh6RR.useLayoutEffect;

});


parcelRegister("3Tqyg", function(module, exports) {
function $2d5b1ac1574da936$var$_extends() {
    module.exports = $2d5b1ac1574da936$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $2d5b1ac1574da936$var$_extends.apply(this, arguments);
}
module.exports = $2d5b1ac1574da936$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("99w1R", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $6a9dcc96d11bcd0d$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $6a9dcc96d11bcd0d$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $6a9dcc96d11bcd0d$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $6a9dcc96d11bcd0d$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $6a9dcc96d11bcd0d$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $6a9dcc96d11bcd0d$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $6a9dcc96d11bcd0d$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRoutes", function () { return $6a9dcc96d11bcd0d$export$5d3fca4a98652595; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $6a9dcc96d11bcd0d$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $6a9dcc96d11bcd0d$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $6a9dcc96d11bcd0d$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $6a9dcc96d11bcd0d$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $6a9dcc96d11bcd0d$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $6a9dcc96d11bcd0d$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $6a9dcc96d11bcd0d$export$52b333d321859367; });
/**
 * React Router v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $fSADM = parcelRequire("fSADM");
function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $fSADM.matchPath)(pattern, (0, $fSADM.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $bh6RR.useMemo(()=>(0, $fSADM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $fSADM.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $fSADM.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $fSADM.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $fSADM.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $fSADM.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $fSADM.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $fSADM.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $6a9dcc96d11bcd0d$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($6a9dcc96d11bcd0d$var$DataRouterHook || {});
var $6a9dcc96d11bcd0d$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($6a9dcc96d11bcd0d$var$DataRouterStateHook || {});
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $fSADM.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return $bh6RR.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((m)=>(0, $fSADM.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $fSADM.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $fSADM.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $fSADM.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned[key]) $6a9dcc96d11bcd0d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        if (v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl) $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $fSADM.resolveTo)(to, (0, $fSADM.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $fSADM.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $fSADM.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $fSADM.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $6a9dcc96d11bcd0d$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $fSADM.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $fSADM.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($6a9dcc96d11bcd0d$var$AwaitRenderStatus || {});
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : "_data" in promise ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $fSADM.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $fSADM.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $fSADM.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $bh6RR.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("fSADM", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $b8f852338811df1a$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $b8f852338811df1a$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $b8f852338811df1a$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $b8f852338811df1a$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $b8f852338811df1a$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $b8f852338811df1a$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $b8f852338811df1a$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $b8f852338811df1a$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $b8f852338811df1a$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $b8f852338811df1a$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $b8f852338811df1a$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $b8f852338811df1a$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $b8f852338811df1a$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $b8f852338811df1a$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $b8f852338811df1a$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $b8f852338811df1a$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $b8f852338811df1a$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $b8f852338811df1a$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $b8f852338811df1a$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $b8f852338811df1a$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $b8f852338811df1a$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.19.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $b8f852338811df1a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $b8f852338811df1a$export$30d21fd6d7295f52(pathname);
        matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $b8f852338811df1a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:[\w-]+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $b8f852338811df1a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $b8f852338811df1a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $b8f852338811df1a$export$480182c6abbb2ff6(data, init) {
    return new $b8f852338811df1a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $b8f852338811df1a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $b8f852338811df1a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $b8f852338811df1a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.unstable_patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // FIFO queue of previously discovered routes to prevent re-calling on
    // subsequent navigations to the same path
    let discoveredRoutesMaxSize = 1000;
    let discoveredRoutes = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) initialMatches = fogOfWar.matches;
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnNavigation() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $b8f852338811df1a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$b8f852338811df1a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $b8f852338811df1a$var$findNearestBoundary(matches).route.id,
            {
                type: $b8f852338811df1a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($b8f852338811df1a$var$isErrorResult(result) && $b8f852338811df1a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $b8f852338811df1a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: updatedMatches || matches
        }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $b8f852338811df1a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $b8f852338811df1a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($b8f852338811df1a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$b8f852338811df1a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult) || $b8f852338811df1a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $b8f852338811df1a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $b8f852338811df1a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $b8f852338811df1a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $b8f852338811df1a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($b8f852338811df1a$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $b8f852338811df1a$var$ResultType.redirect,
                        response: $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $b8f852338811df1a$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: $b8f852338811df1a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.add(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $b8f852338811df1a$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            // Don't bother re-calling patchRouteOnMiss for a path we've already
            // processed.  the last execution would have patched the route tree
            // accordingly so `matches` here are already accurate.
            if (discoveredRoutes.has(pathname)) return {
                active: false,
                matches: matches
            };
            if (!matches) {
                let fogMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $b8f852338811df1a$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: newMatches
                };
            }
            let newPartialMatches = $b8f852338811df1a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) {
                addToFifoQueue(pathname, discoveredRoutes);
                return {
                    type: "success",
                    matches: null
                };
            }
            partialMatches = newPartialMatches;
        }
    }
    function addToFifoQueue(path, queue) {
        if (queue.size >= discoveredRoutesMaxSize) {
            let first = queue.values().next().value;
            queue.delete(first);
        }
        queue.add(path);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($b8f852338811df1a$var$isHandlerResult(e) && $b8f852338811df1a$var$isResponse(e.result)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $b8f852338811df1a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $b8f852338811df1a$var$callDataStrategyImpl(unstable_dataStrategy || $b8f852338811df1a$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($b8f852338811df1a$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($b8f852338811df1a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $b8f852338811df1a$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: $b8f852338811df1a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$b8f852338811df1a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnNavigation() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $b8f852338811df1a$var$loadLazyRouteChildren(patchRoutesOnNavigationImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnNavigationImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $b8f852338811df1a$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $b8f852338811df1a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $b8f852338811df1a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $b8f852338811df1a$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $b8f852338811df1a$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $b8f852338811df1a$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $b8f852338811df1a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $b8f852338811df1a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $b8f852338811df1a$var$ResultType.data,
                    result: undefined
                });
            };
            return $b8f852338811df1a$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$b8f852338811df1a$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $b8f852338811df1a$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type } = handlerResult;
    if ($b8f852338811df1a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $b8f852338811df1a$var$ResultType.error,
                error: e
            };
        }
        if (type === $b8f852338811df1a$var$ResultType.error) return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: new $b8f852338811df1a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $b8f852338811df1a$var$ResultType.error) {
        if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init2;
            if (result.data instanceof Error) {
                var _result$init;
                return {
                    type: $b8f852338811df1a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status
                };
            }
            // Convert thrown unstable_data() to ErrorResponse instances
            result = new $b8f852338811df1a$export$6c6580e81da25755(((_result$init2 = result.init) == null ? void 0 : _result$init2.status) || 500, undefined, result.data);
        }
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: result,
            statusCode: $b8f852338811df1a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init3, _result$init4;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init3 = result.init) == null ? void 0 : _result$init3.status,
            headers: ((_result$init4 = result.init) == null ? void 0 : _result$init4.headers) && new Headers(result.init.headers)
        };
    }
    if ($b8f852338811df1a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init5, _result$init6;
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: (_result$init6 = result.init) != null && _result$init6.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $b8f852338811df1a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $b8f852338811df1a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($b8f852338811df1a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $b8f852338811df1a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $b8f852338811df1a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $b8f852338811df1a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnNavigation()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b8f852338811df1a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $b8f852338811df1a$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $b8f852338811df1a$var$ResultType.data || result.type === $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isRedirectHandlerResult(result) {
    return $b8f852338811df1a$var$isResponse(result.result) && $b8f852338811df1a$var$redirectStatusCodes.has(result.result.status);
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $b8f852338811df1a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $b8f852338811df1a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $b8f852338811df1a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($b8f852338811df1a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $b8f852338811df1a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});


parcelRegister("87sJk", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $5e95436251e0e3e2$export$bf730a2d8bf68b42; }, function (v) { return $5e95436251e0e3e2$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5e95436251e0e3e2$export$bf730a2d8bf68b42;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $5e95436251e0e3e2$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5e95436251e0e3e2$var$p = "function" === typeof Object.is ? Object.is : $5e95436251e0e3e2$var$n, $5e95436251e0e3e2$var$q = $bh6RR.useSyncExternalStore, $5e95436251e0e3e2$var$r = $bh6RR.useRef, $5e95436251e0e3e2$var$t = $bh6RR.useEffect, $5e95436251e0e3e2$var$u = $bh6RR.useMemo, $5e95436251e0e3e2$var$v = $bh6RR.useDebugValue;
$5e95436251e0e3e2$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $5e95436251e0e3e2$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $5e95436251e0e3e2$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($5e95436251e0e3e2$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $5e95436251e0e3e2$var$q(a, c[0], c[1]);
    $5e95436251e0e3e2$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $5e95436251e0e3e2$var$v(d);
    return d;
};

});

parcelRegister("eVhD3", function(module, exports) {
$parcel$export(module.exports, "AuthApi", function () { return (parcelRequire("2gpGl")).AuthApi; });
$parcel$export(module.exports, "CommentApi", function () { return (parcelRequire("2gpGl")).CommentApi; });
$parcel$export(module.exports, "ConnectApi", function () { return (parcelRequire("2gpGl")).ConnectApi; });
$parcel$export(module.exports, "CustomerApi", function () { return (parcelRequire("2gpGl")).CustomerApi; });
$parcel$export(module.exports, "EntityConnectStatus", function () { return (parcelRequire("2gpGl")).EntityConnectStatus; });
$parcel$export(module.exports, "EntityNotificationConfigScope", function () { return (parcelRequire("2gpGl")).EntityNotificationConfigScope; });
$parcel$export(module.exports, "EntityNotificationEntityType", function () { return (parcelRequire("2gpGl")).EntityNotificationEntityType; });
$parcel$export(module.exports, "EntityNotificationEvent", function () { return (parcelRequire("2gpGl")).EntityNotificationEvent; });
$parcel$export(module.exports, "EntityOnboardingStage", function () { return (parcelRequire("2gpGl")).EntityOnboardingStage; });
$parcel$export(module.exports, "EntityPostMediaType", function () { return (parcelRequire("2gpGl")).EntityPostMediaType; });
$parcel$export(module.exports, "EntityPostVisibility", function () { return (parcelRequire("2gpGl")).EntityPostVisibility; });
$parcel$export(module.exports, "EntityReportComplaintType", function () { return (parcelRequire("2gpGl")).EntityReportComplaintType; });
$parcel$export(module.exports, "EntityReportEntityType", function () { return (parcelRequire("2gpGl")).EntityReportEntityType; });
$parcel$export(module.exports, "EntityTipStatus", function () { return (parcelRequire("2gpGl")).EntityTipStatus; });
$parcel$export(module.exports, "EntityTrackVisibility", function () { return (parcelRequire("2gpGl")).EntityTrackVisibility; });
$parcel$export(module.exports, "EntityTransactionType", function () { return (parcelRequire("2gpGl")).EntityTransactionType; });
$parcel$export(module.exports, "EntityUnlockEntityType", function () { return (parcelRequire("2gpGl")).EntityUnlockEntityType; });
$parcel$export(module.exports, "EntityUnlockStatus", function () { return (parcelRequire("2gpGl")).EntityUnlockStatus; });
$parcel$export(module.exports, "EntityUserRole", function () { return (parcelRequire("2gpGl")).EntityUserRole; });
$parcel$export(module.exports, "FileApi", function () { return (parcelRequire("2gpGl")).FileApi; });
$parcel$export(module.exports, "LikeApi", function () { return (parcelRequire("2gpGl")).LikeApi; });
$parcel$export(module.exports, "NotificationApi", function () { return (parcelRequire("2gpGl")).NotificationApi; });
$parcel$export(module.exports, "PostApi", function () { return (parcelRequire("2gpGl")).PostApi; });
$parcel$export(module.exports, "ReportApi", function () { return (parcelRequire("2gpGl")).ReportApi; });
$parcel$export(module.exports, "StreamApi", function () { return (parcelRequire("2gpGl")).StreamApi; });
$parcel$export(module.exports, "SubscriptionApi", function () { return (parcelRequire("2gpGl")).SubscriptionApi; });
$parcel$export(module.exports, "TipApi", function () { return (parcelRequire("2gpGl")).TipApi; });
$parcel$export(module.exports, "TrackApi", function () { return (parcelRequire("2gpGl")).TrackApi; });
$parcel$export(module.exports, "TransactionApi", function () { return (parcelRequire("2gpGl")).TransactionApi; });
$parcel$export(module.exports, "UnlockApi", function () { return (parcelRequire("2gpGl")).UnlockApi; });
$parcel$export(module.exports, "UserApi", function () { return (parcelRequire("2gpGl")).UserApi; });
$parcel$export(module.exports, "Configuration", function () { return (parcelRequire("7ppL5")).Configuration; });
// tslint:disable
/**
 * Ryddm API
 * Ryddm API.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ parcelRequire("2gpGl");
parcelRequire("7ppL5");

});
parcelRegister("2gpGl", function(module, exports) {

$parcel$export(module.exports, "EntityConnectStatus", function () { return $1f603b97a2aa30d6$export$cd09cf72d1730375; });
$parcel$export(module.exports, "EntityNotificationConfigScope", function () { return $1f603b97a2aa30d6$export$e6b04316f6c13ed6; });
$parcel$export(module.exports, "EntityNotificationEntityType", function () { return $1f603b97a2aa30d6$export$d7d4185850f8f5b4; });
$parcel$export(module.exports, "EntityNotificationEvent", function () { return $1f603b97a2aa30d6$export$9509982552593ae5; });
$parcel$export(module.exports, "EntityOnboardingStage", function () { return $1f603b97a2aa30d6$export$6b6c75aa4d504a00; });
$parcel$export(module.exports, "EntityPostMediaType", function () { return $1f603b97a2aa30d6$export$513b3049a560168d; });
$parcel$export(module.exports, "EntityPostVisibility", function () { return $1f603b97a2aa30d6$export$75814ed959e29300; });
$parcel$export(module.exports, "EntityReportComplaintType", function () { return $1f603b97a2aa30d6$export$19c9ca07037bc945; });
$parcel$export(module.exports, "EntityReportEntityType", function () { return $1f603b97a2aa30d6$export$47ddd1a5659843fe; });
$parcel$export(module.exports, "EntityTipStatus", function () { return $1f603b97a2aa30d6$export$832197bc1252cbbd; });
$parcel$export(module.exports, "EntityTrackVisibility", function () { return $1f603b97a2aa30d6$export$fcda3c70f8c953ec; });
$parcel$export(module.exports, "EntityTransactionType", function () { return $1f603b97a2aa30d6$export$3527c3c3973190e2; });
$parcel$export(module.exports, "EntityUnlockEntityType", function () { return $1f603b97a2aa30d6$export$c489df26e3bedd1c; });
$parcel$export(module.exports, "EntityUnlockStatus", function () { return $1f603b97a2aa30d6$export$df944f2236cc8772; });
$parcel$export(module.exports, "EntityUserRole", function () { return $1f603b97a2aa30d6$export$419779fd57d8a21f; });
$parcel$export(module.exports, "AuthApi", function () { return $1f603b97a2aa30d6$export$4a5ab2a34a4b26f9; });
$parcel$export(module.exports, "CommentApi", function () { return $1f603b97a2aa30d6$export$569b2c8fc0552525; });
$parcel$export(module.exports, "ConnectApi", function () { return $1f603b97a2aa30d6$export$8dd770e5815a509c; });
$parcel$export(module.exports, "CustomerApi", function () { return $1f603b97a2aa30d6$export$db097d7a94bea193; });
$parcel$export(module.exports, "FileApi", function () { return $1f603b97a2aa30d6$export$be85d78436eb3caf; });
$parcel$export(module.exports, "LikeApi", function () { return $1f603b97a2aa30d6$export$f4d3d044741564bb; });
$parcel$export(module.exports, "NotificationApi", function () { return $1f603b97a2aa30d6$export$e8fd42033d129624; });
$parcel$export(module.exports, "PostApi", function () { return $1f603b97a2aa30d6$export$51444d8b6a1912f3; });
$parcel$export(module.exports, "ReportApi", function () { return $1f603b97a2aa30d6$export$86e5bee652cd816e; });
$parcel$export(module.exports, "StreamApi", function () { return $1f603b97a2aa30d6$export$7d740e068388f14a; });
$parcel$export(module.exports, "SubscriptionApi", function () { return $1f603b97a2aa30d6$export$79802d927b7d883c; });
$parcel$export(module.exports, "TipApi", function () { return $1f603b97a2aa30d6$export$29fe426b57068b65; });
$parcel$export(module.exports, "TrackApi", function () { return $1f603b97a2aa30d6$export$2f8f7bdb7e386612; });
$parcel$export(module.exports, "TransactionApi", function () { return $1f603b97a2aa30d6$export$392ee3f1e8966c92; });
$parcel$export(module.exports, "UnlockApi", function () { return $1f603b97a2aa30d6$export$2b72467a8fb6e56d; });
$parcel$export(module.exports, "UserApi", function () { return $1f603b97a2aa30d6$export$2a63ac7615f78125; });
//@ts-nocheck
/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Ryddm API
 * Ryddm API.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ 
var $hH01d = parcelRequire("hH01d");

var $gGHUs = parcelRequire("gGHUs");
const $1f603b97a2aa30d6$var$BASE_PATH = "https://localhost".replace(/\/+$/, "");
const $1f603b97a2aa30d6$export$83cb526776fb323d = {
    csv: ",",
    ssv: " ",
    tsv: "	",
    pipes: "|"
};
class $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    constructor(configuration, basePath = $1f603b97a2aa30d6$var$BASE_PATH, fetch = $gGHUs){
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
class $1f603b97a2aa30d6$export$a27bea7cdb975d70 extends Error {
    constructor(field, msg){
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
var $1f603b97a2aa30d6$export$9574cacdb00bcba3;
(function(EntityConnectPayoutStatus) {
    EntityConnectPayoutStatus["Succeeded"] = "succeeded";
    EntityConnectPayoutStatus["Failed"] = "failed";
    EntityConnectPayoutStatus["Incomplete"] = "incomplete";
})($1f603b97a2aa30d6$export$9574cacdb00bcba3 || ($1f603b97a2aa30d6$export$9574cacdb00bcba3 = {}));
var $1f603b97a2aa30d6$export$cd09cf72d1730375;
(function(EntityConnectStatus) {
    EntityConnectStatus["Restricted"] = "restricted";
    EntityConnectStatus["Pending"] = "pending";
    EntityConnectStatus["Enabled"] = "enabled";
    EntityConnectStatus["Complete"] = "complete";
})($1f603b97a2aa30d6$export$cd09cf72d1730375 || ($1f603b97a2aa30d6$export$cd09cf72d1730375 = {}));
var $1f603b97a2aa30d6$export$3928e0b25799b13b;
(function(EntityCustomerPaymentMethodSetupStatus) {
    EntityCustomerPaymentMethodSetupStatus["Succeeded"] = "succeeded";
    EntityCustomerPaymentMethodSetupStatus["Failed"] = "failed";
    EntityCustomerPaymentMethodSetupStatus["Incomplete"] = "incomplete";
})($1f603b97a2aa30d6$export$3928e0b25799b13b || ($1f603b97a2aa30d6$export$3928e0b25799b13b = {}));
var $1f603b97a2aa30d6$export$ce14051f513b837a;
(function(EntityLikeEntityType) {
    EntityLikeEntityType["User"] = "user";
    EntityLikeEntityType["Track"] = "track";
    EntityLikeEntityType["Post"] = "post";
    EntityLikeEntityType["Comment"] = "comment";
})($1f603b97a2aa30d6$export$ce14051f513b837a || ($1f603b97a2aa30d6$export$ce14051f513b837a = {}));
var $1f603b97a2aa30d6$export$e6b04316f6c13ed6;
(function(EntityNotificationConfigScope) {
    EntityNotificationConfigScope["Enabled"] = "enabled";
    EntityNotificationConfigScope["Custom"] = "custom";
    EntityNotificationConfigScope["Disabled"] = "disabled";
})($1f603b97a2aa30d6$export$e6b04316f6c13ed6 || ($1f603b97a2aa30d6$export$e6b04316f6c13ed6 = {}));
var $1f603b97a2aa30d6$export$d7d4185850f8f5b4;
(function(EntityNotificationEntityType) {
    EntityNotificationEntityType["User"] = "user";
    EntityNotificationEntityType["Track"] = "track";
    EntityNotificationEntityType["Post"] = "post";
    EntityNotificationEntityType["Comment"] = "comment";
    EntityNotificationEntityType["Tip"] = "tip";
    EntityNotificationEntityType["Unlock"] = "unlock";
    EntityNotificationEntityType["Subscription"] = "subscription";
    EntityNotificationEntityType["ConnectPayout"] = "connect_payout";
})($1f603b97a2aa30d6$export$d7d4185850f8f5b4 || ($1f603b97a2aa30d6$export$d7d4185850f8f5b4 = {}));
var $1f603b97a2aa30d6$export$9509982552593ae5;
(function(EntityNotificationEvent) {
    EntityNotificationEvent["AppUserFollowCreated"] = "app_user_follow_created";
    EntityNotificationEvent["AppTrackCreated"] = "app_track_created";
    EntityNotificationEvent["AppTrackBlocked"] = "app_track_blocked";
    EntityNotificationEvent["AppTrackLikeCreated"] = "app_track_like_created";
    EntityNotificationEvent["AppPostCreated"] = "app_post_created";
    EntityNotificationEvent["AppPostBlocked"] = "app_post_blocked";
    EntityNotificationEvent["AppPostLikeCreated"] = "app_post_like_created";
    EntityNotificationEvent["AppCommentCreated"] = "app_comment_created";
    EntityNotificationEvent["AppCommentReplyCreated"] = "app_comment_reply_created";
    EntityNotificationEvent["AppCommentBlocked"] = "app_comment_blocked";
    EntityNotificationEvent["AppCommentLikeCreated"] = "app_comment_like_created";
    EntityNotificationEvent["AppTipPaymentSucceeded"] = "app_tip_payment_succeeded";
    EntityNotificationEvent["AppTipPaymentFailed"] = "app_tip_payment_failed";
    EntityNotificationEvent["AppTipCreated"] = "app_tip_created";
    EntityNotificationEvent["AppTrackUnlockPaymentSucceeded"] = "app_track_unlock_payment_succeeded";
    EntityNotificationEvent["AppTrackUnlockPaymentFailed"] = "app_track_unlock_payment_failed";
    EntityNotificationEvent["AppTrackUnlockCreated"] = "app_track_unlock_created";
    EntityNotificationEvent["AppPostUnlockPaymentSucceeded"] = "app_post_unlock_payment_succeeded";
    EntityNotificationEvent["AppPostUnlockPaymentFailed"] = "app_post_unlock_payment_failed";
    EntityNotificationEvent["AppPostUnlockCreated"] = "app_post_unlock_created";
    EntityNotificationEvent["AppSubscriptionPaymentSucceeded"] = "app_subscription_payment_succeeded";
    EntityNotificationEvent["AppSubscriptionPaymentFailed"] = "app_subscription_payment_failed";
    EntityNotificationEvent["AppSubscriptionCreated"] = "app_subscription_created";
    EntityNotificationEvent["AppPayoutPaid"] = "app_payout_paid";
    EntityNotificationEvent["AppPayoutFailed"] = "app_payout_failed";
    EntityNotificationEvent["EmailWelcome"] = "email_welcome";
    EntityNotificationEvent["EmailUserBlocked"] = "email_user_blocked";
    EntityNotificationEvent["EmailTrackBlocked"] = "email_track_blocked";
    EntityNotificationEvent["EmailPostBlocked"] = "email_post_blocked";
    EntityNotificationEvent["EmailCommentBlocked"] = "email_comment_blocked";
    EntityNotificationEvent["EmailUserDeleteConfirmation"] = "email_user_delete_confirmation";
    EntityNotificationEvent["EmailUserDeleted"] = "email_user_deleted";
})($1f603b97a2aa30d6$export$9509982552593ae5 || ($1f603b97a2aa30d6$export$9509982552593ae5 = {}));
var $1f603b97a2aa30d6$export$678975e2ed472613;
(function(EntityNotificationType) {
    EntityNotificationType["Application"] = "application";
    EntityNotificationType["Email"] = "email";
    EntityNotificationType["Push"] = "push";
})($1f603b97a2aa30d6$export$678975e2ed472613 || ($1f603b97a2aa30d6$export$678975e2ed472613 = {}));
var $1f603b97a2aa30d6$export$6b6c75aa4d504a00;
(function(EntityOnboardingStage) {
    EntityOnboardingStage["SelectRole"] = "select_role";
    EntityOnboardingStage["CreateProfile"] = "create_profile";
    EntityOnboardingStage["SelectGenres"] = "select_genres";
    EntityOnboardingStage["FollowArtists"] = "follow_artists";
    EntityOnboardingStage["UploadTracks"] = "upload_tracks";
    EntityOnboardingStage["EnableMonetization"] = "enable_monetization";
    EntityOnboardingStage["ConfigureNotifications"] = "configure_notifications";
    EntityOnboardingStage["AcceptTermsAndConditions"] = "accept_terms_and_conditions";
    EntityOnboardingStage["Finished"] = "finished";
})($1f603b97a2aa30d6$export$6b6c75aa4d504a00 || ($1f603b97a2aa30d6$export$6b6c75aa4d504a00 = {}));
var $1f603b97a2aa30d6$export$513b3049a560168d;
(function(EntityPostMediaType) {
    EntityPostMediaType["Image"] = "image";
    EntityPostMediaType["Video"] = "video";
})($1f603b97a2aa30d6$export$513b3049a560168d || ($1f603b97a2aa30d6$export$513b3049a560168d = {}));
var $1f603b97a2aa30d6$export$75814ed959e29300;
(function(EntityPostVisibility) {
    EntityPostVisibility["Public"] = "public";
    EntityPostVisibility["Subscribers"] = "subscribers";
})($1f603b97a2aa30d6$export$75814ed959e29300 || ($1f603b97a2aa30d6$export$75814ed959e29300 = {}));
var $1f603b97a2aa30d6$export$19c9ca07037bc945;
(function(EntityReportComplaintType) {
    EntityReportComplaintType["Spam"] = "spam";
    EntityReportComplaintType["Fake"] = "fake";
    EntityReportComplaintType["Violence"] = "violence";
    EntityReportComplaintType["Pornography"] = "pornography";
    EntityReportComplaintType["ChildAbuse"] = "child_abuse";
    EntityReportComplaintType["Copyright"] = "copyright";
})($1f603b97a2aa30d6$export$19c9ca07037bc945 || ($1f603b97a2aa30d6$export$19c9ca07037bc945 = {}));
var $1f603b97a2aa30d6$export$47ddd1a5659843fe;
(function(EntityReportEntityType) {
    EntityReportEntityType["Post"] = "post";
    EntityReportEntityType["User"] = "user";
    EntityReportEntityType["Track"] = "track";
    EntityReportEntityType["Comment"] = "comment";
})($1f603b97a2aa30d6$export$47ddd1a5659843fe || ($1f603b97a2aa30d6$export$47ddd1a5659843fe = {}));
var $1f603b97a2aa30d6$export$9e4e35ff0cd7f06;
(function(EntityReportStatus) {
    EntityReportStatus["Open"] = "open";
    EntityReportStatus["Resolved"] = "resolved";
})($1f603b97a2aa30d6$export$9e4e35ff0cd7f06 || ($1f603b97a2aa30d6$export$9e4e35ff0cd7f06 = {}));
var $1f603b97a2aa30d6$export$4283ef5eb5fc6872;
(function(EntityStreamEntityType) {
    EntityStreamEntityType["User"] = "user";
    EntityStreamEntityType["Track"] = "track";
    EntityStreamEntityType["Post"] = "post";
    EntityStreamEntityType["Comment"] = "comment";
})($1f603b97a2aa30d6$export$4283ef5eb5fc6872 || ($1f603b97a2aa30d6$export$4283ef5eb5fc6872 = {}));
var $1f603b97a2aa30d6$export$fdbe6c860c432e91;
(function(EntitySubscriptionStatus) {
    EntitySubscriptionStatus["Active"] = "active";
    EntitySubscriptionStatus["CanceledAtPeriodEnd"] = "canceled_at_period_end";
    EntitySubscriptionStatus["Canceled"] = "canceled";
    EntitySubscriptionStatus["Incomplete"] = "incomplete";
    EntitySubscriptionStatus["IncompleteExpired"] = "incomplete_expired";
})($1f603b97a2aa30d6$export$fdbe6c860c432e91 || ($1f603b97a2aa30d6$export$fdbe6c860c432e91 = {}));
var $1f603b97a2aa30d6$export$832197bc1252cbbd;
(function(EntityTipStatus) {
    EntityTipStatus["Succeeded"] = "succeeded";
    EntityTipStatus["Failed"] = "failed";
    EntityTipStatus["Incomplete"] = "incomplete";
})($1f603b97a2aa30d6$export$832197bc1252cbbd || ($1f603b97a2aa30d6$export$832197bc1252cbbd = {}));
var $1f603b97a2aa30d6$export$fcda3c70f8c953ec;
(function(EntityTrackVisibility) {
    EntityTrackVisibility["Public"] = "public";
    EntityTrackVisibility["Subscribers"] = "subscribers";
})($1f603b97a2aa30d6$export$fcda3c70f8c953ec || ($1f603b97a2aa30d6$export$fcda3c70f8c953ec = {}));
var $1f603b97a2aa30d6$export$4c71f34fd5e7fa97;
(function(EntityTransactionCurrency) {
    EntityTransactionCurrency["Usd"] = "usd";
})($1f603b97a2aa30d6$export$4c71f34fd5e7fa97 || ($1f603b97a2aa30d6$export$4c71f34fd5e7fa97 = {}));
var $1f603b97a2aa30d6$export$1c1195e431d25a2f;
(function(EntityTransactionStatus) {
    EntityTransactionStatus["Succeeded"] = "succeeded";
    EntityTransactionStatus["Failed"] = "failed";
    EntityTransactionStatus["Incomplete"] = "incomplete";
})($1f603b97a2aa30d6$export$1c1195e431d25a2f || ($1f603b97a2aa30d6$export$1c1195e431d25a2f = {}));
var $1f603b97a2aa30d6$export$3527c3c3973190e2;
(function(EntityTransactionType) {
    EntityTransactionType["Tip"] = "tip";
    EntityTransactionType["Unlock"] = "unlock";
    EntityTransactionType["Subscription"] = "subscription";
    EntityTransactionType["Payout"] = "payout";
})($1f603b97a2aa30d6$export$3527c3c3973190e2 || ($1f603b97a2aa30d6$export$3527c3c3973190e2 = {}));
var $1f603b97a2aa30d6$export$c489df26e3bedd1c;
(function(EntityUnlockEntityType) {
    EntityUnlockEntityType["Post"] = "post";
    EntityUnlockEntityType["Track"] = "track";
})($1f603b97a2aa30d6$export$c489df26e3bedd1c || ($1f603b97a2aa30d6$export$c489df26e3bedd1c = {}));
var $1f603b97a2aa30d6$export$df944f2236cc8772;
(function(EntityUnlockStatus) {
    EntityUnlockStatus["Succeeded"] = "succeeded";
    EntityUnlockStatus["Failed"] = "failed";
    EntityUnlockStatus["Incomplete"] = "incomplete";
})($1f603b97a2aa30d6$export$df944f2236cc8772 || ($1f603b97a2aa30d6$export$df944f2236cc8772 = {}));
var $1f603b97a2aa30d6$export$419779fd57d8a21f;
(function(EntityUserRole) {
    EntityUserRole["Fan"] = "fan";
    EntityUserRole["Artist"] = "artist";
    EntityUserRole["Admin"] = "admin";
    EntityUserRole["Empty"] = "";
})($1f603b97a2aa30d6$export$419779fd57d8a21f || ($1f603b97a2aa30d6$export$419779fd57d8a21f = {}));
var $1f603b97a2aa30d6$export$e2c81fe6da469e18;
(function(ServiceConnectLinkType) {
    ServiceConnectLinkType["Onboarding"] = "account_onboarding";
    ServiceConnectLinkType["Update"] = "account_update";
})($1f603b97a2aa30d6$export$e2c81fe6da469e18 || ($1f603b97a2aa30d6$export$e2c81fe6da469e18 = {}));
const $1f603b97a2aa30d6$export$ca1a67fd1d88777 = function(configuration) {
    return {
        /**
     * Exchanges auth provider token with auth service token.
     * @summary Exchanges token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exchangeToken (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling exchangeToken.");
            const localVarPath = `/auth/token/exchange`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Signs new auth service token with extended period of validity.
     * @summary Refreshes token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ refreshToken (options = {}) {
            const localVarPath = `/auth/token/refresh`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$fe9b9a9cf30a5627 = function(configuration) {
    return {
        /**
     * Exchanges auth provider token with auth service token.
     * @summary Exchanges token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exchangeToken (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ca1a67fd1d88777(configuration).exchangeToken(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Signs new auth service token with extended period of validity.
     * @summary Refreshes token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ refreshToken (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ca1a67fd1d88777(configuration).refreshToken(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$c7ea0c10377c62a = function(configuration, fetch, basePath) {
    return {
        /**
     * Exchanges auth provider token with auth service token.
     * @summary Exchanges token.
     * @param {ExchangeTokenRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ exchangeToken (fields, options) {
            return $1f603b97a2aa30d6$export$fe9b9a9cf30a5627(configuration).exchangeToken(fields, options)(fetch, basePath);
        },
        /**
     * Signs new auth service token with extended period of validity.
     * @summary Refreshes token.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ refreshToken (options) {
            return $1f603b97a2aa30d6$export$fe9b9a9cf30a5627(configuration).refreshToken(options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$4a5ab2a34a4b26f9 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Exchanges auth provider token with auth service token.
   * @summary Exchanges token.
   * @param {ExchangeTokenRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */ exchangeToken(fields, options) {
        return $1f603b97a2aa30d6$export$fe9b9a9cf30a5627(this.configuration).exchangeToken(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Signs new auth service token with extended period of validity.
   * @summary Refreshes token.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */ refreshToken(options) {
        return $1f603b97a2aa30d6$export$fe9b9a9cf30a5627(this.configuration).refreshToken(options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$32f3cfcc496b270 = function(configuration) {
    return {
        /**
     * Blocks comment record.
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockComment (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockComment.");
            const localVarPath = `/comment/admin/comment/block`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates comment.
     * @summary Creates comment.
     * @param {CreateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createComment (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createComment.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes comment.
     * @summary Deletes comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteComment (commentId, options = {}) {
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("commentId", "Required parameter commentId was null or undefined when calling deleteComment.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (commentId !== undefined) localVarQueryParameter["commentId"] = commentId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComment (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getComment.");
            const localVarPath = `/comment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCommentInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getCommentInternal.");
            const localVarPath = `/comment/internal/comment/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comments.
     * @summary Retrieves comments.
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComments (postId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling getComments.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves comment replies.
     * @summary Retrieves comment replies.
     * @param {string} commentId
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReplies (commentId, postId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("commentId", "Required parameter commentId was null or undefined when calling getReplies.");
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling getReplies.");
            const localVarPath = `/comment/replies`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (commentId !== undefined) localVarQueryParameter["commentId"] = commentId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates comment.
     * @summary Updates comment.
     * @param {UpdateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateComment (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateComment.");
            const localVarPath = `/comment`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$ebd5a72e5df7a200 = function(configuration) {
    return {
        /**
     * Blocks comment record.
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockComment (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).blockComment(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates comment.
     * @summary Creates comment.
     * @param {CreateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createComment (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).createComment(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes comment.
     * @summary Deletes comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteComment (commentId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).deleteComment(commentId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComment (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).getComment(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCommentInternal (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).getCommentInternal(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comments.
     * @summary Retrieves comments.
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComments (postId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).getComments(postId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves comment replies.
     * @summary Retrieves comment replies.
     * @param {string} commentId
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReplies (commentId, postId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).getReplies(commentId, postId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates comment.
     * @summary Updates comment.
     * @param {UpdateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateComment (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$32f3cfcc496b270(configuration).updateComment(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$15e2b81be2ba0d7f = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks comment record.
     * @summary Blocks comment.
     * @param {BlockCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockComment (fields, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).blockComment(fields, options)(fetch, basePath);
        },
        /**
     * Creates comment.
     * @summary Creates comment.
     * @param {CreateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createComment (fields, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).createComment(fields, options)(fetch, basePath);
        },
        /**
     * Deletes comment.
     * @summary Deletes comment.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteComment (commentId, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).deleteComment(commentId, options)(fetch, basePath);
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComment (id, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).getComment(id, options)(fetch, basePath);
        },
        /**
     * Retrieves comment record by comment id.
     * @summary Retrieves comment.
     * @param {string} id comment id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCommentInternal (id, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).getCommentInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves comments.
     * @summary Retrieves comments.
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getComments (postId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).getComments(postId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves comment replies.
     * @summary Retrieves comment replies.
     * @param {string} commentId
     * @param {string} postId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReplies (commentId, postId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).getReplies(commentId, postId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Updates comment.
     * @summary Updates comment.
     * @param {UpdateCommentRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateComment (fields, options) {
            return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(configuration).updateComment(fields, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$569b2c8fc0552525 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Blocks comment record.
   * @summary Blocks comment.
   * @param {BlockCommentRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ blockComment(fields, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).blockComment(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates comment.
   * @summary Creates comment.
   * @param {CreateCommentRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ createComment(fields, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).createComment(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes comment.
   * @summary Deletes comment.
   * @param {string} commentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ deleteComment(commentId, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).deleteComment(commentId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comment record by comment id.
   * @summary Retrieves comment.
   * @param {string} id comment id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getComment(id, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).getComment(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comment record by comment id.
   * @summary Retrieves comment.
   * @param {string} id comment id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getCommentInternal(id, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).getCommentInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comments.
   * @summary Retrieves comments.
   * @param {string} postId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getComments(postId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).getComments(postId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves comment replies.
   * @summary Retrieves comment replies.
   * @param {string} commentId
   * @param {string} postId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ getReplies(commentId, postId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).getReplies(commentId, postId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Updates comment.
   * @summary Updates comment.
   * @param {UpdateCommentRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CommentApi
   */ updateComment(fields, options) {
        return $1f603b97a2aa30d6$export$ebd5a72e5df7a200(this.configuration).updateComment(fields, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$2ad57ce8a40d338c = function(configuration) {
    return {
        /**
     * Creates connect payout.
     * @summary Creates connect payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createConnectPayout (options = {}) {
            const localVarPath = `/connect/artist/connect/payout`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account balance.
     * @summary Retrieves connect balance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectBalance (options = {}) {
            const localVarPath = `/connect/artist/connect/balance`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account by user id.
     * @summary Retrieves connect by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectByUserId (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getConnectByUserId.");
            const localVarPath = `/connect/internal/connect/user-id`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account link.
     * @summary Retrieves connect link.
     * @param {'account_onboarding' | 'account_update'} connectLinkType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLink (connectLinkType, options = {}) {
            // verify required parameter 'connectLinkType' is not null or undefined
            if (connectLinkType === null || connectLinkType === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("connectLinkType", "Required parameter connectLinkType was null or undefined when calling getConnectLink.");
            const localVarPath = `/connect/artist/connect/link`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (connectLinkType !== undefined) localVarQueryParameter["connectLinkType"] = connectLinkType;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account login link.
     * @summary Retrieves connect login link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLoginLink (options = {}) {
            const localVarPath = `/connect/artist/connect/login-link`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect payout record by id.
     * @summary Retrieves connect payout.
     * @param {string} id connect payout id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectPayout (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getConnectPayout.");
            const localVarPath = `/connect/artist/connect/payout/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect readiness.
     * @summary Retrieves connect readiness.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectReadiness (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getConnectReadiness.");
            const localVarPath = `/connect/readiness`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves connect account status.
     * @summary Retrieves connect status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectStatus (options = {}) {
            const localVarPath = `/connect/artist/connect/status`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$13a874359e1093f = function(configuration) {
    return {
        /**
     * Creates connect payout.
     * @summary Creates connect payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createConnectPayout (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).createConnectPayout(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account balance.
     * @summary Retrieves connect balance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectBalance (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).getConnectBalance(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account by user id.
     * @summary Retrieves connect by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectByUserId (userId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).getConnectByUserId(userId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account link.
     * @summary Retrieves connect link.
     * @param {'account_onboarding' | 'account_update'} connectLinkType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLink (connectLinkType, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).getConnectLink(connectLinkType, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account login link.
     * @summary Retrieves connect login link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLoginLink (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).getConnectLoginLink(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect payout record by id.
     * @summary Retrieves connect payout.
     * @param {string} id connect payout id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectPayout (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).getConnectPayout(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect readiness.
     * @summary Retrieves connect readiness.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectReadiness (userId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).getConnectReadiness(userId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves connect account status.
     * @summary Retrieves connect status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectStatus (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$2ad57ce8a40d338c(configuration).getConnectStatus(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$d4167ec3416de109 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates connect payout.
     * @summary Creates connect payout.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createConnectPayout (options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).createConnectPayout(options)(fetch, basePath);
        },
        /**
     * Retrieves connect account balance.
     * @summary Retrieves connect balance.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectBalance (options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).getConnectBalance(options)(fetch, basePath);
        },
        /**
     * Retrieves connect account by user id.
     * @summary Retrieves connect by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectByUserId (userId, options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).getConnectByUserId(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves connect account link.
     * @summary Retrieves connect link.
     * @param {'account_onboarding' | 'account_update'} connectLinkType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLink (connectLinkType, options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).getConnectLink(connectLinkType, options)(fetch, basePath);
        },
        /**
     * Retrieves connect account login link.
     * @summary Retrieves connect login link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectLoginLink (options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).getConnectLoginLink(options)(fetch, basePath);
        },
        /**
     * Retrieves connect payout record by id.
     * @summary Retrieves connect payout.
     * @param {string} id connect payout id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectPayout (id, options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).getConnectPayout(id, options)(fetch, basePath);
        },
        /**
     * Retrieves connect readiness.
     * @summary Retrieves connect readiness.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectReadiness (userId, options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).getConnectReadiness(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves connect account status.
     * @summary Retrieves connect status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getConnectStatus (options) {
            return $1f603b97a2aa30d6$export$13a874359e1093f(configuration).getConnectStatus(options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$8dd770e5815a509c extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates connect payout.
   * @summary Creates connect payout.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ createConnectPayout(options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).createConnectPayout(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account balance.
   * @summary Retrieves connect balance.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectBalance(options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).getConnectBalance(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account by user id.
   * @summary Retrieves connect by user id.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectByUserId(userId, options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).getConnectByUserId(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account link.
   * @summary Retrieves connect link.
   * @param {'account_onboarding' | 'account_update'} connectLinkType
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectLink(connectLinkType, options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).getConnectLink(connectLinkType, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account login link.
   * @summary Retrieves connect login link.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectLoginLink(options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).getConnectLoginLink(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect payout record by id.
   * @summary Retrieves connect payout.
   * @param {string} id connect payout id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectPayout(id, options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).getConnectPayout(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect readiness.
   * @summary Retrieves connect readiness.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectReadiness(userId, options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).getConnectReadiness(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves connect account status.
   * @summary Retrieves connect status.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ConnectApi
   */ getConnectStatus(options) {
        return $1f603b97a2aa30d6$export$13a874359e1093f(this.configuration).getConnectStatus(options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$71469ebb96998ae5 = function(configuration) {
    return {
        /**
     * Creates customer payment method.
     * @summary Creates customer payment method.
     * @param {CreateCustomerPaymentMethodRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethod (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createCustomerPaymentMethod.");
            const localVarPath = `/customer/pm`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates customer payment method setup.
     * @summary Creates customer payment method setup.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethodSetup (options = {}) {
            const localVarPath = `/customer/pm/setup`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes customer customer payment method.
     * @summary Deletes customer customer payment method.
     * @param {string} customerPaymentMethodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCustomerPaymentMethod (customerPaymentMethodId, options = {}) {
            // verify required parameter 'customerPaymentMethodId' is not null or undefined
            if (customerPaymentMethodId === null || customerPaymentMethodId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("customerPaymentMethodId", "Required parameter customerPaymentMethodId was null or undefined when calling deleteCustomerPaymentMethod.");
            const localVarPath = `/customer/pm`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (customerPaymentMethodId !== undefined) localVarQueryParameter["customerPaymentMethodId"] = customerPaymentMethodId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves customer by user id.
     * @summary Retrieves customer by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerByUserId (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getCustomerByUserId.");
            const localVarPath = `/customer/internal/customer/user-id`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves customer default payment method.
     * @summary Retrieves customer default payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethodDefault (options = {}) {
            const localVarPath = `/customer/pm/default`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves customer payment methods.
     * @summary Retrieves customer payment methods.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethods (limit, offset, options = {}) {
            const localVarPath = `/customer/pm`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Sets customer payment method as default.
     * @summary Sets customer payment method as default.
     * @param {SetCustomerPaymentMethodDefaultRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ setCustomerPaymentMethodDefault (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling setCustomerPaymentMethodDefault.");
            const localVarPath = `/customer/pm/default`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$4a4146b511e85d27 = function(configuration) {
    return {
        /**
     * Creates customer payment method.
     * @summary Creates customer payment method.
     * @param {CreateCustomerPaymentMethodRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethod (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$71469ebb96998ae5(configuration).createCustomerPaymentMethod(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates customer payment method setup.
     * @summary Creates customer payment method setup.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethodSetup (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$71469ebb96998ae5(configuration).createCustomerPaymentMethodSetup(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes customer customer payment method.
     * @summary Deletes customer customer payment method.
     * @param {string} customerPaymentMethodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCustomerPaymentMethod (customerPaymentMethodId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$71469ebb96998ae5(configuration).deleteCustomerPaymentMethod(customerPaymentMethodId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves customer by user id.
     * @summary Retrieves customer by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerByUserId (userId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$71469ebb96998ae5(configuration).getCustomerByUserId(userId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves customer default payment method.
     * @summary Retrieves customer default payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethodDefault (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$71469ebb96998ae5(configuration).getCustomerPaymentMethodDefault(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves customer payment methods.
     * @summary Retrieves customer payment methods.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethods (limit, offset, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$71469ebb96998ae5(configuration).getCustomerPaymentMethods(limit, offset, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Sets customer payment method as default.
     * @summary Sets customer payment method as default.
     * @param {SetCustomerPaymentMethodDefaultRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ setCustomerPaymentMethodDefault (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$71469ebb96998ae5(configuration).setCustomerPaymentMethodDefault(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$58166fedf0785aa6 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates customer payment method.
     * @summary Creates customer payment method.
     * @param {CreateCustomerPaymentMethodRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethod (fields, options) {
            return $1f603b97a2aa30d6$export$4a4146b511e85d27(configuration).createCustomerPaymentMethod(fields, options)(fetch, basePath);
        },
        /**
     * Creates customer payment method setup.
     * @summary Creates customer payment method setup.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCustomerPaymentMethodSetup (options) {
            return $1f603b97a2aa30d6$export$4a4146b511e85d27(configuration).createCustomerPaymentMethodSetup(options)(fetch, basePath);
        },
        /**
     * Deletes customer customer payment method.
     * @summary Deletes customer customer payment method.
     * @param {string} customerPaymentMethodId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCustomerPaymentMethod (customerPaymentMethodId, options) {
            return $1f603b97a2aa30d6$export$4a4146b511e85d27(configuration).deleteCustomerPaymentMethod(customerPaymentMethodId, options)(fetch, basePath);
        },
        /**
     * Retrieves customer by user id.
     * @summary Retrieves customer by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerByUserId (userId, options) {
            return $1f603b97a2aa30d6$export$4a4146b511e85d27(configuration).getCustomerByUserId(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves customer default payment method.
     * @summary Retrieves customer default payment method.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethodDefault (options) {
            return $1f603b97a2aa30d6$export$4a4146b511e85d27(configuration).getCustomerPaymentMethodDefault(options)(fetch, basePath);
        },
        /**
     * Retrieves customer payment methods.
     * @summary Retrieves customer payment methods.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getCustomerPaymentMethods (limit, offset, options) {
            return $1f603b97a2aa30d6$export$4a4146b511e85d27(configuration).getCustomerPaymentMethods(limit, offset, options)(fetch, basePath);
        },
        /**
     * Sets customer payment method as default.
     * @summary Sets customer payment method as default.
     * @param {SetCustomerPaymentMethodDefaultRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ setCustomerPaymentMethodDefault (fields, options) {
            return $1f603b97a2aa30d6$export$4a4146b511e85d27(configuration).setCustomerPaymentMethodDefault(fields, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$db097d7a94bea193 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates customer payment method.
   * @summary Creates customer payment method.
   * @param {CreateCustomerPaymentMethodRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ createCustomerPaymentMethod(fields, options) {
        return $1f603b97a2aa30d6$export$4a4146b511e85d27(this.configuration).createCustomerPaymentMethod(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates customer payment method setup.
   * @summary Creates customer payment method setup.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ createCustomerPaymentMethodSetup(options) {
        return $1f603b97a2aa30d6$export$4a4146b511e85d27(this.configuration).createCustomerPaymentMethodSetup(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes customer customer payment method.
   * @summary Deletes customer customer payment method.
   * @param {string} customerPaymentMethodId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ deleteCustomerPaymentMethod(customerPaymentMethodId, options) {
        return $1f603b97a2aa30d6$export$4a4146b511e85d27(this.configuration).deleteCustomerPaymentMethod(customerPaymentMethodId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves customer by user id.
   * @summary Retrieves customer by user id.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ getCustomerByUserId(userId, options) {
        return $1f603b97a2aa30d6$export$4a4146b511e85d27(this.configuration).getCustomerByUserId(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves customer default payment method.
   * @summary Retrieves customer default payment method.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ getCustomerPaymentMethodDefault(options) {
        return $1f603b97a2aa30d6$export$4a4146b511e85d27(this.configuration).getCustomerPaymentMethodDefault(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves customer payment methods.
   * @summary Retrieves customer payment methods.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ getCustomerPaymentMethods(limit, offset, options) {
        return $1f603b97a2aa30d6$export$4a4146b511e85d27(this.configuration).getCustomerPaymentMethods(limit, offset, options)(this.fetch, this.basePath);
    }
    /**
   * Sets customer payment method as default.
   * @summary Sets customer payment method as default.
   * @param {SetCustomerPaymentMethodDefaultRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CustomerApi
   */ setCustomerPaymentMethodDefault(fields, options) {
        return $1f603b97a2aa30d6$export$4a4146b511e85d27(this.configuration).setCustomerPaymentMethodDefault(fields, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$df3fa95981fb43d6 = function(configuration) {
    return {
        /**
     * Creates new file.
     * @summary Creates file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createFile (options = {}) {
            const localVarPath = `/file/internal/file`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves file record.
     * @summary Retrieves file.
     * @param {string} id file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getFileInternal.");
            const localVarPath = `/file/internal/file/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves file url and redirects to it.
     * @summary Retrieves file url.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileURL (fileId, options = {}) {
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fileId", "Required parameter fileId was null or undefined when calling getFileURL.");
            const localVarPath = `/file/public/file/url`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (fileId !== undefined) localVarQueryParameter["fileId"] = fileId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$616f9911b7e0fb3c = function(configuration) {
    return {
        /**
     * Creates new file.
     * @summary Creates file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createFile (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$df3fa95981fb43d6(configuration).createFile(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves file record.
     * @summary Retrieves file.
     * @param {string} id file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileInternal (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$df3fa95981fb43d6(configuration).getFileInternal(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves file url and redirects to it.
     * @summary Retrieves file url.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileURL (fileId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$df3fa95981fb43d6(configuration).getFileURL(fileId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$7a8ca909023cbdbb = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates new file.
     * @summary Creates file.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createFile (options) {
            return $1f603b97a2aa30d6$export$616f9911b7e0fb3c(configuration).createFile(options)(fetch, basePath);
        },
        /**
     * Retrieves file record.
     * @summary Retrieves file.
     * @param {string} id file id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileInternal (id, options) {
            return $1f603b97a2aa30d6$export$616f9911b7e0fb3c(configuration).getFileInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves file url and redirects to it.
     * @summary Retrieves file url.
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFileURL (fileId, options) {
            return $1f603b97a2aa30d6$export$616f9911b7e0fb3c(configuration).getFileURL(fileId, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$be85d78436eb3caf extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates new file.
   * @summary Creates file.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */ createFile(options) {
        return $1f603b97a2aa30d6$export$616f9911b7e0fb3c(this.configuration).createFile(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves file record.
   * @summary Retrieves file.
   * @param {string} id file id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */ getFileInternal(id, options) {
        return $1f603b97a2aa30d6$export$616f9911b7e0fb3c(this.configuration).getFileInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves file url and redirects to it.
   * @summary Retrieves file url.
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof FileApi
   */ getFileURL(fileId, options) {
        return $1f603b97a2aa30d6$export$616f9911b7e0fb3c(this.configuration).getFileURL(fileId, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$4fa7293aa73553f8 = function(configuration) {
    return {
        /**
     * Creates comment like.
     * @summary Creates comment like.
     * @param {CreateCommentLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentLike (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createCommentLike.");
            const localVarPath = `/like/comment`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates post like.
     * @summary Creates post like.
     * @param {CreatePostLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostLike (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createPostLike.");
            const localVarPath = `/like/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates track like.
     * @summary Creates track like.
     * @param {CreateTrackLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackLike (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTrackLike.");
            const localVarPath = `/like/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates user follow.
     * @summary Creates user follow.
     * @param {CreateUserFollowRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserFollow (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createUserFollow.");
            const localVarPath = `/like/user`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes comment like.
     * @summary Deletes comment like.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCommentLike (commentId, options = {}) {
            // verify required parameter 'commentId' is not null or undefined
            if (commentId === null || commentId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("commentId", "Required parameter commentId was null or undefined when calling deleteCommentLike.");
            const localVarPath = `/like/comment`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (commentId !== undefined) localVarQueryParameter["commentId"] = commentId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes post like.
     * @summary Deletes post like.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePostLike (postId, options = {}) {
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling deletePostLike.");
            const localVarPath = `/like/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes track like.
     * @summary Deletes track like.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrackLike (trackId, options = {}) {
            // verify required parameter 'trackId' is not null or undefined
            if (trackId === null || trackId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("trackId", "Required parameter trackId was null or undefined when calling deleteTrackLike.");
            const localVarPath = `/like/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackId !== undefined) localVarQueryParameter["trackId"] = trackId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes user follow.
     * @summary Deletes user follow.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserFollow (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling deleteUserFollow.");
            const localVarPath = `/like/user`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIds (options = {}) {
            const localVarPath = `/like/user/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getFollowedUserIdsInternal.");
            const localVarPath = `/like/internal/like/user/followed-ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that following source user.
     * @summary Retrieves ids of users that following source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowingUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getFollowingUserIdsInternal.");
            const localVarPath = `/like/internal/like/user/following-ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIds (options = {}) {
            const localVarPath = `/like/comment/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getLikedCommentIdsInternal.");
            const localVarPath = `/like/internal/like/comment/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIds (options = {}) {
            const localVarPath = `/like/post/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getLikedPostIdsInternal.");
            const localVarPath = `/like/internal/like/post/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIds (options = {}) {
            const localVarPath = `/like/track/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getLikedTrackIdsInternal.");
            const localVarPath = `/like/internal/like/track/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$f56459552dcdadb0 = function(configuration) {
    return {
        /**
     * Creates comment like.
     * @summary Creates comment like.
     * @param {CreateCommentLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentLike (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).createCommentLike(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates post like.
     * @summary Creates post like.
     * @param {CreatePostLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostLike (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).createPostLike(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates track like.
     * @summary Creates track like.
     * @param {CreateTrackLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackLike (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).createTrackLike(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates user follow.
     * @summary Creates user follow.
     * @param {CreateUserFollowRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserFollow (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).createUserFollow(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes comment like.
     * @summary Deletes comment like.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCommentLike (commentId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).deleteCommentLike(commentId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Deletes post like.
     * @summary Deletes post like.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePostLike (postId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).deletePostLike(postId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Deletes track like.
     * @summary Deletes track like.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrackLike (trackId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).deleteTrackLike(trackId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Deletes user follow.
     * @summary Deletes user follow.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserFollow (userId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).deleteUserFollow(userId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getFollowedUserIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getFollowedUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that following source user.
     * @summary Retrieves ids of users that following source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowingUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getFollowingUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getLikedCommentIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getLikedCommentIdsInternal(userId, limit, offset, random, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getLikedPostIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getLikedPostIdsInternal(userId, limit, offset, random, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getLikedTrackIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$4fa7293aa73553f8(configuration).getLikedTrackIdsInternal(userId, limit, offset, random, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$88c6e0d4f50554a2 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates comment like.
     * @summary Creates comment like.
     * @param {CreateCommentLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentLike (fields, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).createCommentLike(fields, options)(fetch, basePath);
        },
        /**
     * Creates post like.
     * @summary Creates post like.
     * @param {CreatePostLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostLike (fields, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).createPostLike(fields, options)(fetch, basePath);
        },
        /**
     * Creates track like.
     * @summary Creates track like.
     * @param {CreateTrackLikeRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackLike (fields, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).createTrackLike(fields, options)(fetch, basePath);
        },
        /**
     * Creates user follow.
     * @summary Creates user follow.
     * @param {CreateUserFollowRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserFollow (fields, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).createUserFollow(fields, options)(fetch, basePath);
        },
        /**
     * Deletes comment like.
     * @summary Deletes comment like.
     * @param {string} commentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteCommentLike (commentId, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).deleteCommentLike(commentId, options)(fetch, basePath);
        },
        /**
     * Deletes post like.
     * @summary Deletes post like.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePostLike (postId, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).deletePostLike(postId, options)(fetch, basePath);
        },
        /**
     * Deletes track like.
     * @summary Deletes track like.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrackLike (trackId, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).deleteTrackLike(trackId, options)(fetch, basePath);
        },
        /**
     * Deletes user follow.
     * @summary Deletes user follow.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserFollow (userId, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).deleteUserFollow(userId, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIds (options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getFollowedUserIds(options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user followed.
     * @summary Retrieves ids of users that source user followed.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedUserIdsInternal (userId, limit, offset, random, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getFollowedUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that following source user.
     * @summary Retrieves ids of users that following source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowingUserIdsInternal (userId, limit, offset, random, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getFollowingUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIds (options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getLikedCommentIds(options)(fetch, basePath);
        },
        /**
     * Retrieves liked comment ids.
     * @summary Retrieves liked comment ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedCommentIdsInternal (userId, limit, offset, random, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getLikedCommentIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIds (options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getLikedPostIds(options)(fetch, basePath);
        },
        /**
     * Retrieves liked post ids.
     * @summary Retrieves liked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPostIdsInternal (userId, limit, offset, random, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getLikedPostIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIds (options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getLikedTrackIds(options)(fetch, basePath);
        },
        /**
     * Retrieves liked track ids.
     * @summary Retrieves liked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTrackIdsInternal (userId, limit, offset, random, options) {
            return $1f603b97a2aa30d6$export$f56459552dcdadb0(configuration).getLikedTrackIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$f4d3d044741564bb extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates comment like.
   * @summary Creates comment like.
   * @param {CreateCommentLikeRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createCommentLike(fields, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).createCommentLike(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates post like.
   * @summary Creates post like.
   * @param {CreatePostLikeRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createPostLike(fields, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).createPostLike(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates track like.
   * @summary Creates track like.
   * @param {CreateTrackLikeRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createTrackLike(fields, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).createTrackLike(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates user follow.
   * @summary Creates user follow.
   * @param {CreateUserFollowRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ createUserFollow(fields, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).createUserFollow(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes comment like.
   * @summary Deletes comment like.
   * @param {string} commentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deleteCommentLike(commentId, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).deleteCommentLike(commentId, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes post like.
   * @summary Deletes post like.
   * @param {string} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deletePostLike(postId, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).deletePostLike(postId, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes track like.
   * @summary Deletes track like.
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deleteTrackLike(trackId, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).deleteTrackLike(trackId, options)(this.fetch, this.basePath);
    }
    /**
   * Deletes user follow.
   * @summary Deletes user follow.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ deleteUserFollow(userId, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).deleteUserFollow(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user followed.
   * @summary Retrieves ids of users that source user followed.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getFollowedUserIds(options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getFollowedUserIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user followed.
   * @summary Retrieves ids of users that source user followed.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getFollowedUserIdsInternal(userId, limit, offset, random, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getFollowedUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that following source user.
   * @summary Retrieves ids of users that following source user.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getFollowingUserIdsInternal(userId, limit, offset, random, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getFollowingUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked comment ids.
   * @summary Retrieves liked comment ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedCommentIds(options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getLikedCommentIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked comment ids.
   * @summary Retrieves liked comment ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedCommentIdsInternal(userId, limit, offset, random, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getLikedCommentIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked post ids.
   * @summary Retrieves liked post ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedPostIds(options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getLikedPostIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked post ids.
   * @summary Retrieves liked post ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedPostIdsInternal(userId, limit, offset, random, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getLikedPostIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked track ids.
   * @summary Retrieves liked track ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedTrackIds(options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getLikedTrackIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked track ids.
   * @summary Retrieves liked track ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LikeApi
   */ getLikedTrackIdsInternal(userId, limit, offset, random, options) {
        return $1f603b97a2aa30d6$export$f56459552dcdadb0(this.configuration).getLikedTrackIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$75657c5701f02f07 = function(configuration) {
    return {
        /**
     * Retrieves notification record by notification id.
     * @summary Retrieves notification.
     * @param {string} id notification id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotification (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getAppNotification.");
            const localVarPath = `/notification/application/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves application notifications.
     * @summary Retrieves application notifications.
     * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotifications (entityType, limit, offset, options = {}) {
            const localVarPath = `/notification/application`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (entityType !== undefined) localVarQueryParameter["entityType"] = entityType;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Get unread application notifications count.
     * @summary Get unread application notifications count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotificationsUnreadCount (options = {}) {
            const localVarPath = `/notification/application/count`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Gets notification config.
     * @summary Gets notification config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getNotificationConfig (options = {}) {
            const localVarPath = `/notification/config`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Read notification.
     * @summary Read notification.
     * @param {ReadAppNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotification (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling readAppNotification.");
            const localVarPath = `/notification/application/read`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Read all notifications.
     * @summary Read all notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotifications (options = {}) {
            const localVarPath = `/notification/application/read-all`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates notification config.
     * @summary Updates notification config.
     * @param {UpdateNotificationConfigRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateNotificationConfig (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateNotificationConfig.");
            const localVarPath = `/notification/config`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$a9469e214f56a2ac = function(configuration) {
    return {
        /**
     * Retrieves notification record by notification id.
     * @summary Retrieves notification.
     * @param {string} id notification id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotification (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$75657c5701f02f07(configuration).getAppNotification(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves application notifications.
     * @summary Retrieves application notifications.
     * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotifications (entityType, limit, offset, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$75657c5701f02f07(configuration).getAppNotifications(entityType, limit, offset, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Get unread application notifications count.
     * @summary Get unread application notifications count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotificationsUnreadCount (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$75657c5701f02f07(configuration).getAppNotificationsUnreadCount(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Gets notification config.
     * @summary Gets notification config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getNotificationConfig (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$75657c5701f02f07(configuration).getNotificationConfig(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Read notification.
     * @summary Read notification.
     * @param {ReadAppNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotification (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$75657c5701f02f07(configuration).readAppNotification(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Read all notifications.
     * @summary Read all notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotifications (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$75657c5701f02f07(configuration).readAppNotifications(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Updates notification config.
     * @summary Updates notification config.
     * @param {UpdateNotificationConfigRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateNotificationConfig (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$75657c5701f02f07(configuration).updateNotificationConfig(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$555a825217a8a15e = function(configuration, fetch, basePath) {
    return {
        /**
     * Retrieves notification record by notification id.
     * @summary Retrieves notification.
     * @param {string} id notification id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotification (id, options) {
            return $1f603b97a2aa30d6$export$a9469e214f56a2ac(configuration).getAppNotification(id, options)(fetch, basePath);
        },
        /**
     * Retrieves application notifications.
     * @summary Retrieves application notifications.
     * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotifications (entityType, limit, offset, options) {
            return $1f603b97a2aa30d6$export$a9469e214f56a2ac(configuration).getAppNotifications(entityType, limit, offset, options)(fetch, basePath);
        },
        /**
     * Get unread application notifications count.
     * @summary Get unread application notifications count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getAppNotificationsUnreadCount (options) {
            return $1f603b97a2aa30d6$export$a9469e214f56a2ac(configuration).getAppNotificationsUnreadCount(options)(fetch, basePath);
        },
        /**
     * Gets notification config.
     * @summary Gets notification config.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getNotificationConfig (options) {
            return $1f603b97a2aa30d6$export$a9469e214f56a2ac(configuration).getNotificationConfig(options)(fetch, basePath);
        },
        /**
     * Read notification.
     * @summary Read notification.
     * @param {ReadAppNotificationRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotification (fields, options) {
            return $1f603b97a2aa30d6$export$a9469e214f56a2ac(configuration).readAppNotification(fields, options)(fetch, basePath);
        },
        /**
     * Read all notifications.
     * @summary Read all notifications.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ readAppNotifications (options) {
            return $1f603b97a2aa30d6$export$a9469e214f56a2ac(configuration).readAppNotifications(options)(fetch, basePath);
        },
        /**
     * Updates notification config.
     * @summary Updates notification config.
     * @param {UpdateNotificationConfigRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateNotificationConfig (fields, options) {
            return $1f603b97a2aa30d6$export$a9469e214f56a2ac(configuration).updateNotificationConfig(fields, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$e8fd42033d129624 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Retrieves notification record by notification id.
   * @summary Retrieves notification.
   * @param {string} id notification id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getAppNotification(id, options) {
        return $1f603b97a2aa30d6$export$a9469e214f56a2ac(this.configuration).getAppNotification(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves application notifications.
   * @summary Retrieves application notifications.
   * @param {'user' | 'track' | 'post' | 'comment' | 'tip' | 'unlock' | 'subscription' | 'connect_payout'} [entityType]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getAppNotifications(entityType, limit, offset, options) {
        return $1f603b97a2aa30d6$export$a9469e214f56a2ac(this.configuration).getAppNotifications(entityType, limit, offset, options)(this.fetch, this.basePath);
    }
    /**
   * Get unread application notifications count.
   * @summary Get unread application notifications count.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getAppNotificationsUnreadCount(options) {
        return $1f603b97a2aa30d6$export$a9469e214f56a2ac(this.configuration).getAppNotificationsUnreadCount(options)(this.fetch, this.basePath);
    }
    /**
   * Gets notification config.
   * @summary Gets notification config.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ getNotificationConfig(options) {
        return $1f603b97a2aa30d6$export$a9469e214f56a2ac(this.configuration).getNotificationConfig(options)(this.fetch, this.basePath);
    }
    /**
   * Read notification.
   * @summary Read notification.
   * @param {ReadAppNotificationRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ readAppNotification(fields, options) {
        return $1f603b97a2aa30d6$export$a9469e214f56a2ac(this.configuration).readAppNotification(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Read all notifications.
   * @summary Read all notifications.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ readAppNotifications(options) {
        return $1f603b97a2aa30d6$export$a9469e214f56a2ac(this.configuration).readAppNotifications(options)(this.fetch, this.basePath);
    }
    /**
   * Updates notification config.
   * @summary Updates notification config.
   * @param {UpdateNotificationConfigRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */ updateNotificationConfig(fields, options) {
        return $1f603b97a2aa30d6$export$a9469e214f56a2ac(this.configuration).updateNotificationConfig(fields, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$5cb766cdc0787e4b = function(configuration) {
    return {
        /**
     * Blocks post record.
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockPost (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockPost.");
            const localVarPath = `/post/admin/post/block`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new post.
     * @summary Creates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPost (options = {}) {
            const localVarPath = `/post/artist/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes post.
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePost (postId, options = {}) {
            // verify required parameter 'postId' is not null or undefined
            if (postId === null || postId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("postId", "Required parameter postId was null or undefined when calling deletePost.");
            const localVarPath = `/post/artist/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (postId !== undefined) localVarQueryParameter["postId"] = postId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves artist posts.
     * @summary Retrieves artist posts.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistPosts (artistId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'artistId' is not null or undefined
            if (artistId === null || artistId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("artistId", "Required parameter artistId was null or undefined when calling getArtistPosts.");
            const localVarPath = `/post/artist`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves exclusive posts.
     * @summary Retrieves exclusive posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusivePosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/exclusive`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves latest posts.
     * @summary Retrieves latest posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestPosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/latest`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked posts.
     * @summary Retrieves liked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPosts (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/liked`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves popular posts.
     * @summary Retrieves popular posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularPosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/popular`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves post record by post id.
     * @summary Retrieves post.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPost (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getPost.");
            const localVarPath = `/post/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves post by post id.
     * @summary Retrieves post by post id.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPostInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getPostInternal.");
            const localVarPath = `/post/internal/post/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public posts.
     * @summary Retrieves public posts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicPosts (options = {}) {
            const localVarPath = `/post/public/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves recommended posts.
     * @summary Retrieves recommended posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedPosts (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/recommended`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves trending posts.
     * @summary Retrieves trending posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingPosts (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/trending`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked posts.
     * @summary Retrieves unlocked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPosts (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/post/unlocked`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Get user posts count.
     * @summary Get user posts count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserPostsCount (options = {}) {
            const localVarPath = `/post/artist/post/count`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates post record.
     * @summary Updates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updatePost (options = {}) {
            const localVarPath = `/post/artist/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$f234a50b39b81833 = function(configuration) {
    return {
        /**
     * Blocks post record.
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockPost (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).blockPost(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates new post.
     * @summary Creates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPost (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).createPost(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes post.
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePost (postId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).deletePost(postId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves artist posts.
     * @summary Retrieves artist posts.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getArtistPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves exclusive posts.
     * @summary Retrieves exclusive posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusivePosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getExclusivePosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves latest posts.
     * @summary Retrieves latest posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getLatestPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked posts.
     * @summary Retrieves liked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPosts (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getLikedPosts(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves popular posts.
     * @summary Retrieves popular posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getPopularPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves post record by post id.
     * @summary Retrieves post.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPost (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getPost(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves post by post id.
     * @summary Retrieves post by post id.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPostInternal (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getPostInternal(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public posts.
     * @summary Retrieves public posts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicPosts (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getPublicPosts(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves recommended posts.
     * @summary Retrieves recommended posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedPosts (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getRecommendedPosts(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves trending posts.
     * @summary Retrieves trending posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingPosts (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getTrendingPosts(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked posts.
     * @summary Retrieves unlocked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPosts (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getUnlockedPosts(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Get user posts count.
     * @summary Get user posts count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserPostsCount (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).getUserPostsCount(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates post record.
     * @summary Updates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updatePost (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$5cb766cdc0787e4b(configuration).updatePost(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$4c1cdc9130b4aa88 = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks post record.
     * @summary Blocks post.
     * @param {BlockPostRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockPost (fields, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).blockPost(fields, options)(fetch, basePath);
        },
        /**
     * Creates new post.
     * @summary Creates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPost (options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).createPost(options)(fetch, basePath);
        },
        /**
     * Deletes post.
     * @summary Deletes post.
     * @param {string} postId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deletePost (postId, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).deletePost(postId, options)(fetch, basePath);
        },
        /**
     * Retrieves artist posts.
     * @summary Retrieves artist posts.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistPosts (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getArtistPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves exclusive posts.
     * @summary Retrieves exclusive posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusivePosts (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getExclusivePosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves latest posts.
     * @summary Retrieves latest posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestPosts (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getLatestPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves liked posts.
     * @summary Retrieves liked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedPosts (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getLikedPosts(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves popular posts.
     * @summary Retrieves popular posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularPosts (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getPopularPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves post record by post id.
     * @summary Retrieves post.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPost (id, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getPost(id, options)(fetch, basePath);
        },
        /**
     * Retrieves post by post id.
     * @summary Retrieves post by post id.
     * @param {string} id post id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPostInternal (id, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getPostInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves public posts.
     * @summary Retrieves public posts.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicPosts (options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getPublicPosts(options)(fetch, basePath);
        },
        /**
     * Retrieves recommended posts.
     * @summary Retrieves recommended posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedPosts (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getRecommendedPosts(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves trending posts.
     * @summary Retrieves trending posts.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingPosts (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getTrendingPosts(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked posts.
     * @summary Retrieves unlocked posts.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPosts (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getUnlockedPosts(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Get user posts count.
     * @summary Get user posts count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserPostsCount (options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).getUserPostsCount(options)(fetch, basePath);
        },
        /**
     * Updates post record.
     * @summary Updates post.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updatePost (options) {
            return $1f603b97a2aa30d6$export$f234a50b39b81833(configuration).updatePost(options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$51444d8b6a1912f3 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Blocks post record.
   * @summary Blocks post.
   * @param {BlockPostRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ blockPost(fields, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).blockPost(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new post.
   * @summary Creates post.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ createPost(options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).createPost(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes post.
   * @summary Deletes post.
   * @param {string} postId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ deletePost(postId, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).deletePost(postId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves artist posts.
   * @summary Retrieves artist posts.
   * @param {string} artistId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getArtistPosts(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getArtistPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves exclusive posts.
   * @summary Retrieves exclusive posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getExclusivePosts(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getExclusivePosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves latest posts.
   * @summary Retrieves latest posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getLatestPosts(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getLatestPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked posts.
   * @summary Retrieves liked posts.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getLikedPosts(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getLikedPosts(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves popular posts.
   * @summary Retrieves popular posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPopularPosts(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getPopularPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves post record by post id.
   * @summary Retrieves post.
   * @param {string} id post id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPost(id, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getPost(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves post by post id.
   * @summary Retrieves post by post id.
   * @param {string} id post id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPostInternal(id, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getPostInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public posts.
   * @summary Retrieves public posts.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getPublicPosts(options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getPublicPosts(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves recommended posts.
   * @summary Retrieves recommended posts.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getRecommendedPosts(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getRecommendedPosts(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves trending posts.
   * @summary Retrieves trending posts.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getTrendingPosts(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getTrendingPosts(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked posts.
   * @summary Retrieves unlocked posts.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getUnlockedPosts(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getUnlockedPosts(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Get user posts count.
   * @summary Get user posts count.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ getUserPostsCount(options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).getUserPostsCount(options)(this.fetch, this.basePath);
    }
    /**
   * Updates post record.
   * @summary Updates post.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PostApi
   */ updatePost(options) {
        return $1f603b97a2aa30d6$export$f234a50b39b81833(this.configuration).updatePost(options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$298ba5a3ce00f2c8 = function(configuration) {
    return {
        /**
     * Creates report complaint.
     * @summary Creates report complaint.
     * @param {CreateReportComplaintRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createReportComplaint (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createReportComplaint.");
            const localVarPath = `/report/complaint`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves report.
     * @summary Retrieves report.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReport (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getReport.");
            const localVarPath = `/report/admin/report/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves report complaint.
     * @summary Retrieves report complaint.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaint (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getReportComplaint.");
            const localVarPath = `/report/admin/report/complaint/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves report complaints.
     * @summary Retrieves report complaints.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaints (reportId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'reportId' is not null or undefined
            if (reportId === null || reportId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("reportId", "Required parameter reportId was null or undefined when calling getReportComplaints.");
            const localVarPath = `/report/admin/report/complaint`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (reportId !== undefined) localVarQueryParameter["reportId"] = reportId;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves reports.
     * @summary Retrieves reports.
     * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReports (entityType, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/report/admin/report`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (entityType !== undefined) localVarQueryParameter["entityType"] = entityType;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Resolves report.
     * @summary Resolves report.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resolveReport (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling resolveReport.");
            const localVarPath = `/report/admin/report/resolve`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$e01283755cdb5707 = function(configuration) {
    return {
        /**
     * Creates report complaint.
     * @summary Creates report complaint.
     * @param {CreateReportComplaintRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createReportComplaint (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$298ba5a3ce00f2c8(configuration).createReportComplaint(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves report.
     * @summary Retrieves report.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReport (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$298ba5a3ce00f2c8(configuration).getReport(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves report complaint.
     * @summary Retrieves report complaint.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaint (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$298ba5a3ce00f2c8(configuration).getReportComplaint(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves report complaints.
     * @summary Retrieves report complaints.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaints (reportId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$298ba5a3ce00f2c8(configuration).getReportComplaints(reportId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves reports.
     * @summary Retrieves reports.
     * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReports (entityType, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$298ba5a3ce00f2c8(configuration).getReports(entityType, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Resolves report.
     * @summary Resolves report.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resolveReport (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$298ba5a3ce00f2c8(configuration).resolveReport(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$8b7678fe62a5c77 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates report complaint.
     * @summary Creates report complaint.
     * @param {CreateReportComplaintRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createReportComplaint (fields, options) {
            return $1f603b97a2aa30d6$export$e01283755cdb5707(configuration).createReportComplaint(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves report.
     * @summary Retrieves report.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReport (id, options) {
            return $1f603b97a2aa30d6$export$e01283755cdb5707(configuration).getReport(id, options)(fetch, basePath);
        },
        /**
     * Retrieves report complaint.
     * @summary Retrieves report complaint.
     * @param {string} id report id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaint (id, options) {
            return $1f603b97a2aa30d6$export$e01283755cdb5707(configuration).getReportComplaint(id, options)(fetch, basePath);
        },
        /**
     * Retrieves report complaints.
     * @summary Retrieves report complaints.
     * @param {string} reportId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReportComplaints (reportId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$e01283755cdb5707(configuration).getReportComplaints(reportId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves reports.
     * @summary Retrieves reports.
     * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getReports (entityType, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$e01283755cdb5707(configuration).getReports(entityType, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Resolves report.
     * @summary Resolves report.
     * @param {ResolveReportRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ resolveReport (fields, options) {
            return $1f603b97a2aa30d6$export$e01283755cdb5707(configuration).resolveReport(fields, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$86e5bee652cd816e extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates report complaint.
   * @summary Creates report complaint.
   * @param {CreateReportComplaintRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ createReportComplaint(fields, options) {
        return $1f603b97a2aa30d6$export$e01283755cdb5707(this.configuration).createReportComplaint(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves report.
   * @summary Retrieves report.
   * @param {string} id report id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReport(id, options) {
        return $1f603b97a2aa30d6$export$e01283755cdb5707(this.configuration).getReport(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves report complaint.
   * @summary Retrieves report complaint.
   * @param {string} id report id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReportComplaint(id, options) {
        return $1f603b97a2aa30d6$export$e01283755cdb5707(this.configuration).getReportComplaint(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves report complaints.
   * @summary Retrieves report complaints.
   * @param {string} reportId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReportComplaints(reportId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$e01283755cdb5707(this.configuration).getReportComplaints(reportId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves reports.
   * @summary Retrieves reports.
   * @param {'post' | 'user' | 'track' | 'comment'} [entityType]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ getReports(entityType, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$e01283755cdb5707(this.configuration).getReports(entityType, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Resolves report.
   * @summary Resolves report.
   * @param {ResolveReportRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportApi
   */ resolveReport(fields, options) {
        return $1f603b97a2aa30d6$export$e01283755cdb5707(this.configuration).resolveReport(fields, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$98ce312589c0aec = function(configuration) {
    return {
        /**
     * Creates comment stream.
     * @summary Creates comment stream.
     * @param {CreateCommentStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createCommentStream.");
            const localVarPath = `/stream/comment`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates post stream.
     * @summary Creates post stream.
     * @param {CreatePostStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createPostStream.");
            const localVarPath = `/stream/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates track stream.
     * @summary Creates track stream.
     * @param {CreateTrackStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTrackStream.");
            const localVarPath = `/stream/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates user stream.
     * @summary Creates user stream.
     * @param {CreateUserStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserStream (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createUserStream.");
            const localVarPath = `/stream/user`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$3b4408a65aba20ad = function(configuration) {
    return {
        /**
     * Creates comment stream.
     * @summary Creates comment stream.
     * @param {CreateCommentStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentStream (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$98ce312589c0aec(configuration).createCommentStream(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates post stream.
     * @summary Creates post stream.
     * @param {CreatePostStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostStream (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$98ce312589c0aec(configuration).createPostStream(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates track stream.
     * @summary Creates track stream.
     * @param {CreateTrackStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackStream (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$98ce312589c0aec(configuration).createTrackStream(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates user stream.
     * @summary Creates user stream.
     * @param {CreateUserStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserStream (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$98ce312589c0aec(configuration).createUserStream(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$85d7fb4fb637ac92 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates comment stream.
     * @summary Creates comment stream.
     * @param {CreateCommentStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createCommentStream (fields, options) {
            return $1f603b97a2aa30d6$export$3b4408a65aba20ad(configuration).createCommentStream(fields, options)(fetch, basePath);
        },
        /**
     * Creates post stream.
     * @summary Creates post stream.
     * @param {CreatePostStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostStream (fields, options) {
            return $1f603b97a2aa30d6$export$3b4408a65aba20ad(configuration).createPostStream(fields, options)(fetch, basePath);
        },
        /**
     * Creates track stream.
     * @summary Creates track stream.
     * @param {CreateTrackStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackStream (fields, options) {
            return $1f603b97a2aa30d6$export$3b4408a65aba20ad(configuration).createTrackStream(fields, options)(fetch, basePath);
        },
        /**
     * Creates user stream.
     * @summary Creates user stream.
     * @param {CreateUserStreamRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserStream (fields, options) {
            return $1f603b97a2aa30d6$export$3b4408a65aba20ad(configuration).createUserStream(fields, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$7d740e068388f14a extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates comment stream.
   * @summary Creates comment stream.
   * @param {CreateCommentStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createCommentStream(fields, options) {
        return $1f603b97a2aa30d6$export$3b4408a65aba20ad(this.configuration).createCommentStream(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates post stream.
   * @summary Creates post stream.
   * @param {CreatePostStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createPostStream(fields, options) {
        return $1f603b97a2aa30d6$export$3b4408a65aba20ad(this.configuration).createPostStream(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates track stream.
   * @summary Creates track stream.
   * @param {CreateTrackStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createTrackStream(fields, options) {
        return $1f603b97a2aa30d6$export$3b4408a65aba20ad(this.configuration).createTrackStream(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates user stream.
   * @summary Creates user stream.
   * @param {CreateUserStreamRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof StreamApi
   */ createUserStream(fields, options) {
        return $1f603b97a2aa30d6$export$3b4408a65aba20ad(this.configuration).createUserStream(fields, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$a054088e26b5b8b8 = function(configuration) {
    return {
        /**
     * Cancels subscription.
     * @summary Cancels subscription.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelSubscription (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling cancelSubscription.");
            const localVarPath = `/subscription/cancel`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new subscription.
     * @summary Creates subscription.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSubscription (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createSubscription.");
            const localVarPath = `/subscription`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to and that ends soon.
     * @summary Retrieves ids of users that source user subscribed to and that ends soon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedAtPeriodEndUserIds (options = {}) {
            const localVarPath = `/subscription/subscribed-at-period-end-ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIds (options = {}) {
            const localVarPath = `/subscription/subscribed-ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getSubscribedUserIdsInternal.");
            const localVarPath = `/subscription/internal/subscription/subscribed-ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves ids of users that subscribing to source user.
     * @summary Retrieves ids of users that subscribing to source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribingUserIdsInternal (userId, limit, offset, random, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getSubscribingUserIdsInternal.");
            const localVarPath = `/subscription/internal/subscription/subscribing-ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (random !== undefined) localVarQueryParameter["random"] = random;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves subscription record by subscription id.
     * @summary Retrieves subscription.
     * @param {string} id subscription id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscription (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getSubscription.");
            const localVarPath = `/subscription/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user subscription price.
     * @summary Retrieves user subscription price.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserSubscriptionPrice (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUserSubscriptionPrice.");
            const localVarPath = `/subscription/user/price`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Renews subscription.
     * @summary Renews subscription.
     * @param {RenewSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ renewSubscription (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling renewSubscription.");
            const localVarPath = `/subscription/renew`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$13ba686ae7277c35 = function(configuration) {
    return {
        /**
     * Cancels subscription.
     * @summary Cancels subscription.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelSubscription (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).cancelSubscription(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates new subscription.
     * @summary Creates subscription.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSubscription (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).createSubscription(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to and that ends soon.
     * @summary Retrieves ids of users that source user subscribed to and that ends soon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedAtPeriodEndUserIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).getSubscribedAtPeriodEndUserIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).getSubscribedUserIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).getSubscribedUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves ids of users that subscribing to source user.
     * @summary Retrieves ids of users that subscribing to source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribingUserIdsInternal (userId, limit, offset, random, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).getSubscribingUserIdsInternal(userId, limit, offset, random, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves subscription record by subscription id.
     * @summary Retrieves subscription.
     * @param {string} id subscription id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscription (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).getSubscription(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user subscription price.
     * @summary Retrieves user subscription price.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserSubscriptionPrice (userId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).getUserSubscriptionPrice(userId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Renews subscription.
     * @summary Renews subscription.
     * @param {RenewSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ renewSubscription (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$a054088e26b5b8b8(configuration).renewSubscription(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$a14d222a060290a9 = function(configuration, fetch, basePath) {
    return {
        /**
     * Cancels subscription.
     * @summary Cancels subscription.
     * @param {CancelSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ cancelSubscription (fields, options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).cancelSubscription(fields, options)(fetch, basePath);
        },
        /**
     * Creates new subscription.
     * @summary Creates subscription.
     * @param {CreateSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createSubscription (fields, options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).createSubscription(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user subscribed to and that ends soon.
     * @summary Retrieves ids of users that source user subscribed to and that ends soon.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedAtPeriodEndUserIds (options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).getSubscribedAtPeriodEndUserIds(options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIds (options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).getSubscribedUserIds(options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that source user subscribed to.
     * @summary Retrieves ids of users that source user subscribed to.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedUserIdsInternal (userId, limit, offset, random, options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).getSubscribedUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves ids of users that subscribing to source user.
     * @summary Retrieves ids of users that subscribing to source user.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {boolean} [random]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribingUserIdsInternal (userId, limit, offset, random, options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).getSubscribingUserIdsInternal(userId, limit, offset, random, options)(fetch, basePath);
        },
        /**
     * Retrieves subscription record by subscription id.
     * @summary Retrieves subscription.
     * @param {string} id subscription id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscription (id, options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).getSubscription(id, options)(fetch, basePath);
        },
        /**
     * Retrieves user subscription price.
     * @summary Retrieves user subscription price.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserSubscriptionPrice (userId, options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).getUserSubscriptionPrice(userId, options)(fetch, basePath);
        },
        /**
     * Renews subscription.
     * @summary Renews subscription.
     * @param {RenewSubscriptionRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ renewSubscription (fields, options) {
            return $1f603b97a2aa30d6$export$13ba686ae7277c35(configuration).renewSubscription(fields, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$79802d927b7d883c extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Cancels subscription.
   * @summary Cancels subscription.
   * @param {CancelSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ cancelSubscription(fields, options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).cancelSubscription(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new subscription.
   * @summary Creates subscription.
   * @param {CreateSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ createSubscription(fields, options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).createSubscription(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user subscribed to and that ends soon.
   * @summary Retrieves ids of users that source user subscribed to and that ends soon.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribedAtPeriodEndUserIds(options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).getSubscribedAtPeriodEndUserIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user subscribed to.
   * @summary Retrieves ids of users that source user subscribed to.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribedUserIds(options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).getSubscribedUserIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that source user subscribed to.
   * @summary Retrieves ids of users that source user subscribed to.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribedUserIdsInternal(userId, limit, offset, random, options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).getSubscribedUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves ids of users that subscribing to source user.
   * @summary Retrieves ids of users that subscribing to source user.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {boolean} [random]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscribingUserIdsInternal(userId, limit, offset, random, options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).getSubscribingUserIdsInternal(userId, limit, offset, random, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves subscription record by subscription id.
   * @summary Retrieves subscription.
   * @param {string} id subscription id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getSubscription(id, options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).getSubscription(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user subscription price.
   * @summary Retrieves user subscription price.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ getUserSubscriptionPrice(userId, options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).getUserSubscriptionPrice(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Renews subscription.
   * @summary Renews subscription.
   * @param {RenewSubscriptionRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SubscriptionApi
   */ renewSubscription(fields, options) {
        return $1f603b97a2aa30d6$export$13ba686ae7277c35(this.configuration).renewSubscription(fields, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$44a18ac66b7b6b41 = function(configuration) {
    return {
        /**
     * Creates new tip.
     * @summary Creates tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTip (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTip.");
            const localVarPath = `/tip`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves tip record by tip id.
     * @summary Retrieves tip.
     * @param {string} id tip id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTip (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getTip.");
            const localVarPath = `/tip/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$52466198ed381a8b = function(configuration) {
    return {
        /**
     * Creates new tip.
     * @summary Creates tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTip (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$44a18ac66b7b6b41(configuration).createTip(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves tip record by tip id.
     * @summary Retrieves tip.
     * @param {string} id tip id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTip (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$44a18ac66b7b6b41(configuration).getTip(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$4a9cbb4cafff9797 = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates new tip.
     * @summary Creates tip.
     * @param {CreateTipRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTip (fields, options) {
            return $1f603b97a2aa30d6$export$52466198ed381a8b(configuration).createTip(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves tip record by tip id.
     * @summary Retrieves tip.
     * @param {string} id tip id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTip (id, options) {
            return $1f603b97a2aa30d6$export$52466198ed381a8b(configuration).getTip(id, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$29fe426b57068b65 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates new tip.
   * @summary Creates tip.
   * @param {CreateTipRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TipApi
   */ createTip(fields, options) {
        return $1f603b97a2aa30d6$export$52466198ed381a8b(this.configuration).createTip(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves tip record by tip id.
   * @summary Retrieves tip.
   * @param {string} id tip id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TipApi
   */ getTip(id, options) {
        return $1f603b97a2aa30d6$export$52466198ed381a8b(this.configuration).getTip(id, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$14504bceefed84d7 = function(configuration) {
    return {
        /**
     * Blocks track record.
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockTrack (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockTrack.");
            const localVarPath = `/track/admin/track/block`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new track.
     * @summary Creates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrack (options = {}) {
            const localVarPath = `/track/artist/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes track.
     * @summary Deletes track.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrack (trackId, options = {}) {
            // verify required parameter 'trackId' is not null or undefined
            if (trackId === null || trackId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("trackId", "Required parameter trackId was null or undefined when calling deleteTrack.");
            const localVarPath = `/track/artist/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackId !== undefined) localVarQueryParameter["trackId"] = trackId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves artist tracks.
     * @summary Retrieves artist tracks.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistTracks (artistId, limit, offset, searchTerm, options = {}) {
            // verify required parameter 'artistId' is not null or undefined
            if (artistId === null || artistId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("artistId", "Required parameter artistId was null or undefined when calling getArtistTracks.");
            const localVarPath = `/track/artist`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves exclusive tracks.
     * @summary Retrieves exclusive tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusiveTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/exclusive`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves latest tracks.
     * @summary Retrieves latest tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/latest`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves liked tracks.
     * @summary Retrieves liked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTracks (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/liked`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves popular tracks.
     * @summary Retrieves popular tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/popular`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public tracks.
     * @summary Retrieves public tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracks (options = {}) {
            const localVarPath = `/track/public/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public tracks by given ids.
     * @summary Retrieves public tracks by given ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracksByIds (trackIds, options = {}) {
            const localVarPath = `/track/public/track/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (trackIds !== undefined) localVarQueryParameter["trackIds"] = trackIds;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves recommended tracks.
     * @summary Retrieves recommended tracks.
     * @param {string} [genres]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedTracks (genres, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/recommended`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (genres !== undefined) localVarQueryParameter["genres"] = genres;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrack (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getTrack.");
            const localVarPath = `/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrackInternal (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getTrackInternal.");
            const localVarPath = `/track/internal/track/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves tracks author valid state.
     * @summary Retrieves tracks author valid state.
     * @param {string} trackIds
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksAuthorValid (trackIds, userId, options = {}) {
            // verify required parameter 'trackIds' is not null or undefined
            if (trackIds === null || trackIds === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("trackIds", "Required parameter trackIds was null or undefined when calling getTracksAuthorValid.");
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getTracksAuthorValid.");
            const localVarPath = `/track/internal/track/author-valid`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackIds !== undefined) localVarQueryParameter["trackIds"] = trackIds;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves tracks by ids.
     * @summary Retrieves tracks by ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksByIds (trackIds, options = {}) {
            const localVarPath = `/track/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (trackIds !== undefined) localVarQueryParameter["trackIds"] = trackIds;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves trending tracks.
     * @summary Retrieves trending tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingTracks (artistId, limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/trending`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (artistId !== undefined) localVarQueryParameter["artistId"] = artistId;
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked tracks.
     * @summary Retrieves unlocked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTracks (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/track/unlocked`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Get user tracks count.
     * @summary Get user tracks count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserTracksCount (options = {}) {
            const localVarPath = `/track/artist/track/count`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates track record.
     * @summary Updates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateTrack (options = {}) {
            const localVarPath = `/track/artist/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$6285ceb542196e4d = function(configuration) {
    return {
        /**
     * Blocks track record.
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockTrack (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).blockTrack(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates new track.
     * @summary Creates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrack (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).createTrack(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes track.
     * @summary Deletes track.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrack (trackId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).deleteTrack(trackId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves artist tracks.
     * @summary Retrieves artist tracks.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getArtistTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves exclusive tracks.
     * @summary Retrieves exclusive tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusiveTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getExclusiveTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves latest tracks.
     * @summary Retrieves latest tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getLatestTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves liked tracks.
     * @summary Retrieves liked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTracks (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getLikedTracks(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves popular tracks.
     * @summary Retrieves popular tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getPopularTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public tracks.
     * @summary Retrieves public tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracks (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getPublicTracks(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public tracks by given ids.
     * @summary Retrieves public tracks by given ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracksByIds (trackIds, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getPublicTracksByIds(trackIds, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves recommended tracks.
     * @summary Retrieves recommended tracks.
     * @param {string} [genres]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedTracks (genres, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getRecommendedTracks(genres, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrack (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getTrack(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrackInternal (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getTrackInternal(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves tracks author valid state.
     * @summary Retrieves tracks author valid state.
     * @param {string} trackIds
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksAuthorValid (trackIds, userId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getTracksAuthorValid(trackIds, userId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves tracks by ids.
     * @summary Retrieves tracks by ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksByIds (trackIds, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getTracksByIds(trackIds, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves trending tracks.
     * @summary Retrieves trending tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingTracks (artistId, limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getTrendingTracks(artistId, limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked tracks.
     * @summary Retrieves unlocked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTracks (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getUnlockedTracks(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Get user tracks count.
     * @summary Get user tracks count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserTracksCount (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).getUserTracksCount(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates track record.
     * @summary Updates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateTrack (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$14504bceefed84d7(configuration).updateTrack(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$79af1ab2b3df3649 = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks track record.
     * @summary Blocks track.
     * @param {BlockTrackRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockTrack (fields, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).blockTrack(fields, options)(fetch, basePath);
        },
        /**
     * Creates new track.
     * @summary Creates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrack (options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).createTrack(options)(fetch, basePath);
        },
        /**
     * Deletes track.
     * @summary Deletes track.
     * @param {string} trackId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteTrack (trackId, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).deleteTrack(trackId, options)(fetch, basePath);
        },
        /**
     * Retrieves artist tracks.
     * @summary Retrieves artist tracks.
     * @param {string} artistId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getArtistTracks (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getArtistTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves exclusive tracks.
     * @summary Retrieves exclusive tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getExclusiveTracks (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getExclusiveTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves latest tracks.
     * @summary Retrieves latest tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLatestTracks (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getLatestTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves liked tracks.
     * @summary Retrieves liked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getLikedTracks (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getLikedTracks(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves popular tracks.
     * @summary Retrieves popular tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularTracks (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getPopularTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves public tracks.
     * @summary Retrieves public tracks.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracks (options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getPublicTracks(options)(fetch, basePath);
        },
        /**
     * Retrieves public tracks by given ids.
     * @summary Retrieves public tracks by given ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicTracksByIds (trackIds, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getPublicTracksByIds(trackIds, options)(fetch, basePath);
        },
        /**
     * Retrieves recommended tracks.
     * @summary Retrieves recommended tracks.
     * @param {string} [genres]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedTracks (genres, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getRecommendedTracks(genres, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrack (id, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getTrack(id, options)(fetch, basePath);
        },
        /**
     * Retrieves track record by track id.
     * @summary Retrieves track.
     * @param {string} id track id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrackInternal (id, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getTrackInternal(id, options)(fetch, basePath);
        },
        /**
     * Retrieves tracks author valid state.
     * @summary Retrieves tracks author valid state.
     * @param {string} trackIds
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksAuthorValid (trackIds, userId, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getTracksAuthorValid(trackIds, userId, options)(fetch, basePath);
        },
        /**
     * Retrieves tracks by ids.
     * @summary Retrieves tracks by ids.
     * @param {string} [trackIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTracksByIds (trackIds, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getTracksByIds(trackIds, options)(fetch, basePath);
        },
        /**
     * Retrieves trending tracks.
     * @summary Retrieves trending tracks.
     * @param {string} [artistId]
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getTrendingTracks (artistId, limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getTrendingTracks(artistId, limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked tracks.
     * @summary Retrieves unlocked tracks.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTracks (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getUnlockedTracks(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Get user tracks count.
     * @summary Get user tracks count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserTracksCount (options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).getUserTracksCount(options)(fetch, basePath);
        },
        /**
     * Updates track record.
     * @summary Updates track.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateTrack (options) {
            return $1f603b97a2aa30d6$export$6285ceb542196e4d(configuration).updateTrack(options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$2f8f7bdb7e386612 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Blocks track record.
   * @summary Blocks track.
   * @param {BlockTrackRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ blockTrack(fields, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).blockTrack(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new track.
   * @summary Creates track.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ createTrack(options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).createTrack(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes track.
   * @summary Deletes track.
   * @param {string} trackId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ deleteTrack(trackId, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).deleteTrack(trackId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves artist tracks.
   * @summary Retrieves artist tracks.
   * @param {string} artistId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getArtistTracks(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getArtistTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves exclusive tracks.
   * @summary Retrieves exclusive tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getExclusiveTracks(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getExclusiveTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves latest tracks.
   * @summary Retrieves latest tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getLatestTracks(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getLatestTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves liked tracks.
   * @summary Retrieves liked tracks.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getLikedTracks(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getLikedTracks(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves popular tracks.
   * @summary Retrieves popular tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getPopularTracks(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getPopularTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public tracks.
   * @summary Retrieves public tracks.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getPublicTracks(options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getPublicTracks(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public tracks by given ids.
   * @summary Retrieves public tracks by given ids.
   * @param {string} [trackIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getPublicTracksByIds(trackIds, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getPublicTracksByIds(trackIds, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves recommended tracks.
   * @summary Retrieves recommended tracks.
   * @param {string} [genres]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getRecommendedTracks(genres, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getRecommendedTracks(genres, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves track record by track id.
   * @summary Retrieves track.
   * @param {string} id track id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTrack(id, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getTrack(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves track record by track id.
   * @summary Retrieves track.
   * @param {string} id track id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTrackInternal(id, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getTrackInternal(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves tracks author valid state.
   * @summary Retrieves tracks author valid state.
   * @param {string} trackIds
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTracksAuthorValid(trackIds, userId, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getTracksAuthorValid(trackIds, userId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves tracks by ids.
   * @summary Retrieves tracks by ids.
   * @param {string} [trackIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTracksByIds(trackIds, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getTracksByIds(trackIds, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves trending tracks.
   * @summary Retrieves trending tracks.
   * @param {string} [artistId]
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getTrendingTracks(artistId, limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getTrendingTracks(artistId, limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked tracks.
   * @summary Retrieves unlocked tracks.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getUnlockedTracks(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getUnlockedTracks(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Get user tracks count.
   * @summary Get user tracks count.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ getUserTracksCount(options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).getUserTracksCount(options)(this.fetch, this.basePath);
    }
    /**
   * Updates track record.
   * @summary Updates track.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TrackApi
   */ updateTrack(options) {
        return $1f603b97a2aa30d6$export$6285ceb542196e4d(this.configuration).updateTrack(options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$db7ab0198431f2e9 = function(configuration) {
    return {
        /**
     * Retrieves income transactions.
     * @summary Retrieves income transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getIncomeTransactions (limit, offset, transactionType, options = {}) {
            const localVarPath = `/transaction/artist/transaction/income`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (transactionType !== undefined) localVarQueryParameter["transactionType"] = transactionType;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves outgoing transactions.
     * @summary Retrieves outgoing transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getOutgoingTransactions (limit, offset, transactionType, options = {}) {
            const localVarPath = `/transaction/outgoing`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (transactionType !== undefined) localVarQueryParameter["transactionType"] = transactionType;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$a136dbc1c4657b7a = function(configuration) {
    return {
        /**
     * Retrieves income transactions.
     * @summary Retrieves income transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getIncomeTransactions (limit, offset, transactionType, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$db7ab0198431f2e9(configuration).getIncomeTransactions(limit, offset, transactionType, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves outgoing transactions.
     * @summary Retrieves outgoing transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getOutgoingTransactions (limit, offset, transactionType, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$db7ab0198431f2e9(configuration).getOutgoingTransactions(limit, offset, transactionType, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$4a088f1f327fddcf = function(configuration, fetch, basePath) {
    return {
        /**
     * Retrieves income transactions.
     * @summary Retrieves income transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getIncomeTransactions (limit, offset, transactionType, options) {
            return $1f603b97a2aa30d6$export$a136dbc1c4657b7a(configuration).getIncomeTransactions(limit, offset, transactionType, options)(fetch, basePath);
        },
        /**
     * Retrieves outgoing transactions.
     * @summary Retrieves outgoing transactions.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getOutgoingTransactions (limit, offset, transactionType, options) {
            return $1f603b97a2aa30d6$export$a136dbc1c4657b7a(configuration).getOutgoingTransactions(limit, offset, transactionType, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$392ee3f1e8966c92 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Retrieves income transactions.
   * @summary Retrieves income transactions.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */ getIncomeTransactions(limit, offset, transactionType, options) {
        return $1f603b97a2aa30d6$export$a136dbc1c4657b7a(this.configuration).getIncomeTransactions(limit, offset, transactionType, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves outgoing transactions.
   * @summary Retrieves outgoing transactions.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {'tip' | 'unlock' | 'subscription' | 'payout'} [transactionType]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */ getOutgoingTransactions(limit, offset, transactionType, options) {
        return $1f603b97a2aa30d6$export$a136dbc1c4657b7a(this.configuration).getOutgoingTransactions(limit, offset, transactionType, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1 = function(configuration) {
    return {
        /**
     * Creates new post unlock.
     * @summary Creates post unlock.
     * @param {CreatePostUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostUnlock (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createPostUnlock.");
            const localVarPath = `/unlock/post`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new track unlock.
     * @summary Creates track unlock.
     * @param {CreateTrackUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackUnlock (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createTrackUnlock.");
            const localVarPath = `/unlock/track`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlock record by unlock id.
     * @summary Retrieves unlock.
     * @param {string} id unlock id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlock (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getUnlock.");
            const localVarPath = `/unlock/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIds (options = {}) {
            const localVarPath = `/unlock/post/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIdsInternal (userId, limit, offset, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUnlockedPostIdsInternal.");
            const localVarPath = `/unlock/internal/unlock/post/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIds (options = {}) {
            const localVarPath = `/unlock/track/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIdsInternal (userId, limit, offset, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUnlockedTrackIdsInternal.");
            const localVarPath = `/unlock/internal/unlock/track/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$a23f3f0dda2f9a61 = function(configuration) {
    return {
        /**
     * Creates new post unlock.
     * @summary Creates post unlock.
     * @param {CreatePostUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostUnlock (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1(configuration).createPostUnlock(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates new track unlock.
     * @summary Creates track unlock.
     * @param {CreateTrackUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackUnlock (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1(configuration).createTrackUnlock(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlock record by unlock id.
     * @summary Retrieves unlock.
     * @param {string} id unlock id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlock (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1(configuration).getUnlock(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1(configuration).getUnlockedPostIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIdsInternal (userId, limit, offset, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1(configuration).getUnlockedPostIdsInternal(userId, limit, offset, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIds (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1(configuration).getUnlockedTrackIds(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIdsInternal (userId, limit, offset, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$b3dc68dd5d1c8fb1(configuration).getUnlockedTrackIdsInternal(userId, limit, offset, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$7e5a0bf60b34fc4f = function(configuration, fetch, basePath) {
    return {
        /**
     * Creates new post unlock.
     * @summary Creates post unlock.
     * @param {CreatePostUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createPostUnlock (fields, options) {
            return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(configuration).createPostUnlock(fields, options)(fetch, basePath);
        },
        /**
     * Creates new track unlock.
     * @summary Creates track unlock.
     * @param {CreateTrackUnlockRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createTrackUnlock (fields, options) {
            return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(configuration).createTrackUnlock(fields, options)(fetch, basePath);
        },
        /**
     * Retrieves unlock record by unlock id.
     * @summary Retrieves unlock.
     * @param {string} id unlock id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlock (id, options) {
            return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(configuration).getUnlock(id, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIds (options) {
            return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(configuration).getUnlockedPostIds(options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked post ids.
     * @summary Retrieves unlocked post ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedPostIdsInternal (userId, limit, offset, options) {
            return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(configuration).getUnlockedPostIdsInternal(userId, limit, offset, options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIds (options) {
            return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(configuration).getUnlockedTrackIds(options)(fetch, basePath);
        },
        /**
     * Retrieves unlocked track ids.
     * @summary Retrieves unlocked track ids.
     * @param {string} userId
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUnlockedTrackIdsInternal (userId, limit, offset, options) {
            return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(configuration).getUnlockedTrackIdsInternal(userId, limit, offset, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$2b72467a8fb6e56d extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Creates new post unlock.
   * @summary Creates post unlock.
   * @param {CreatePostUnlockRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ createPostUnlock(fields, options) {
        return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(this.configuration).createPostUnlock(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new track unlock.
   * @summary Creates track unlock.
   * @param {CreateTrackUnlockRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ createTrackUnlock(fields, options) {
        return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(this.configuration).createTrackUnlock(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlock record by unlock id.
   * @summary Retrieves unlock.
   * @param {string} id unlock id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlock(id, options) {
        return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(this.configuration).getUnlock(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked post ids.
   * @summary Retrieves unlocked post ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedPostIds(options) {
        return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(this.configuration).getUnlockedPostIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked post ids.
   * @summary Retrieves unlocked post ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedPostIdsInternal(userId, limit, offset, options) {
        return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(this.configuration).getUnlockedPostIdsInternal(userId, limit, offset, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked track ids.
   * @summary Retrieves unlocked track ids.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedTrackIds(options) {
        return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(this.configuration).getUnlockedTrackIds(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves unlocked track ids.
   * @summary Retrieves unlocked track ids.
   * @param {string} userId
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UnlockApi
   */ getUnlockedTrackIdsInternal(userId, limit, offset, options) {
        return $1f603b97a2aa30d6$export$a23f3f0dda2f9a61(this.configuration).getUnlockedTrackIdsInternal(userId, limit, offset, options)(this.fetch, this.basePath);
    }
}
const $1f603b97a2aa30d6$export$ad52db59a1eaf662 = function(configuration) {
    return {
        /**
     * Blocks user record.
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockUser (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling blockUser.");
            const localVarPath = `/user/admin/user/block`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new user.
     * @summary Creates user.
     * @param {CreateUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling createUser.");
            const localVarPath = `/user/internal/user`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Creates new user delete confirmation.
     * @summary Creates user delete confirmation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserDeleteConfirmation (options = {}) {
            const localVarPath = `/user/delete-confirmation`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "POST"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Deletes user profile.
     * @summary Deletes user profile.
     * @param {string} userDeleteConfirmationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserProfile (userDeleteConfirmationCode, options = {}) {
            // verify required parameter 'userDeleteConfirmationCode' is not null or undefined
            if (userDeleteConfirmationCode === null || userDeleteConfirmationCode === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userDeleteConfirmationCode", "Required parameter userDeleteConfirmationCode was null or undefined when calling deleteUserProfile.");
            const localVarPath = `/user/profile`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "DELETE"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userDeleteConfirmationCode !== undefined) localVarQueryParameter["userDeleteConfirmationCode"] = userDeleteConfirmationCode;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves followed artists.
     * @summary Retrieves followed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/followed`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves popular artists.
     * @summary Retrieves popular artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/popular`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public artists.
     * @summary Retrieves public artists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicArtists (options = {}) {
            const localVarPath = `/user/public/user/artists`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves public user record by user id.
     * @summary Retrieves public user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicUser (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getPublicUser.");
            const localVarPath = `/user/public/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves recommended artists.
     * @summary Retrieves recommended artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/recommended`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves subscribed artists.
     * @summary Retrieves subscribed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedArtists (limit, offset, searchTerm, options = {}) {
            const localVarPath = `/user/subscribed`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (limit !== undefined) localVarQueryParameter["limit"] = limit;
            if (offset !== undefined) localVarQueryParameter["offset"] = offset;
            if (searchTerm !== undefined) localVarQueryParameter["searchTerm"] = searchTerm;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser (id, options = {}) {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("id", "Required parameter id was null or undefined when calling getUser.");
            const localVarPath = `/user/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user record by auth provider id.
     * @summary Retrieves user by auth id.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByAuthId (authId, options = {}) {
            // verify required parameter 'authId' is not null or undefined
            if (authId === null || authId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("authId", "Required parameter authId was null or undefined when calling getUserByAuthId.");
            const localVarPath = `/user/internal/user/auth-id`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (authId !== undefined) localVarQueryParameter["authId"] = authId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByUserId (userId, options = {}) {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("userId", "Required parameter userId was null or undefined when calling getUserByUserId.");
            const localVarPath = `/user/internal/user/user-id`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userId !== undefined) localVarQueryParameter["userId"] = userId;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Gets user profile.
     * @summary Gets user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfile (options = {}) {
            const localVarPath = `/user/profile`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves username availability status.
     * @summary Retrieves username availability.
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfileUsernameAvailable (username, options = {}) {
            // verify required parameter 'username' is not null or undefined
            if (username === null || username === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("username", "Required parameter username was null or undefined when calling getUserProfileUsernameAvailable.");
            const localVarPath = `/user/profile/username/available`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (username !== undefined) localVarQueryParameter["username"] = username;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Retrieves users by ids.
     * @summary Retrieves users by ids.
     * @param {string} [userIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByIds (userIds, options = {}) {
            const localVarPath = `/user/ids`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "GET"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (userIds !== undefined) localVarQueryParameter["userIds"] = userIds;
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile.
     * @summary Updates user profile.
     * @param {UpdateUserProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfile (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfile.");
            const localVarPath = `/user/profile`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile avatar.
     * @summary Updates user profile avatar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileAvatar (options = {}) {
            const localVarPath = `/user/profile/avatar`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile onboarding stage.
     * @summary Updates user profile onboarding stage.
     * @param {UpdateUserProfileOnboardingStageRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileOnboardingStage (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfileOnboardingStage.");
            const localVarPath = `/user/profile/onboarding`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile role.
     * @summary Updates user profile role.
     * @param {UpdateUserProfileRoleRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileRole (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfileRole.");
            const localVarPath = `/user/profile/role`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
     * Updates user profile username.
     * @summary Updates user profile username.
     * @param {UpdateUserProfileUsernameRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileUsername (fields, options = {}) {
            // verify required parameter 'fields' is not null or undefined
            if (fields === null || fields === undefined) throw new $1f603b97a2aa30d6$export$a27bea7cdb975d70("fields", "Required parameter fields was null or undefined when calling updateUserProfileUsername.");
            const localVarPath = `/user/profile/username/update`;
            const localVarUrlObj = $hH01d.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({
                method: "PUT"
            }, options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWT required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === "function" ? configuration.apiKey("Authorization") : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = true;
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(fields || {}) : fields || "";
            return {
                url: $hH01d.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};
const $1f603b97a2aa30d6$export$7b43f41e93e60955 = function(configuration) {
    return {
        /**
     * Blocks user record.
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockUser (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).blockUser(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Creates new user.
     * @summary Creates user.
     * @param {CreateUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).createUser(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Creates new user delete confirmation.
     * @summary Creates user delete confirmation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserDeleteConfirmation (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).createUserDeleteConfirmation(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Deletes user profile.
     * @summary Deletes user profile.
     * @param {string} userDeleteConfirmationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserProfile (userDeleteConfirmationCode, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).deleteUserProfile(userDeleteConfirmationCode, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response;
                    else throw response;
                });
            };
        },
        /**
     * Retrieves followed artists.
     * @summary Retrieves followed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getFollowedArtists(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves popular artists.
     * @summary Retrieves popular artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getPopularArtists(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public artists.
     * @summary Retrieves public artists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicArtists (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getPublicArtists(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves public user record by user id.
     * @summary Retrieves public user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicUser (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getPublicUser(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves recommended artists.
     * @summary Retrieves recommended artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getRecommendedArtists(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves subscribed artists.
     * @summary Retrieves subscribed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedArtists (limit, offset, searchTerm, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getSubscribedArtists(limit, offset, searchTerm, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser (id, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getUser(id, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user record by auth provider id.
     * @summary Retrieves user by auth id.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByAuthId (authId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getUserByAuthId(authId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByUserId (userId, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getUserByUserId(userId, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Gets user profile.
     * @summary Gets user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfile (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getUserProfile(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves username availability status.
     * @summary Retrieves username availability.
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfileUsernameAvailable (username, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getUserProfileUsernameAvailable(username, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Retrieves users by ids.
     * @summary Retrieves users by ids.
     * @param {string} [userIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByIds (userIds, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).getUsersByIds(userIds, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile.
     * @summary Updates user profile.
     * @param {UpdateUserProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfile (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).updateUserProfile(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile avatar.
     * @summary Updates user profile avatar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileAvatar (options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).updateUserProfileAvatar(options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile onboarding stage.
     * @summary Updates user profile onboarding stage.
     * @param {UpdateUserProfileOnboardingStageRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileOnboardingStage (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).updateUserProfileOnboardingStage(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile role.
     * @summary Updates user profile role.
     * @param {UpdateUserProfileRoleRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileRole (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).updateUserProfileRole(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        },
        /**
     * Updates user profile username.
     * @summary Updates user profile username.
     * @param {UpdateUserProfileUsernameRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileUsername (fields, options) {
            const localVarFetchArgs = $1f603b97a2aa30d6$export$ad52db59a1eaf662(configuration).updateUserProfileUsername(fields, options);
            return (fetch = $gGHUs, basePath = $1f603b97a2aa30d6$var$BASE_PATH)=>{
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response)=>{
                    if (response.status >= 200 && response.status < 300) return response.json();
                    else throw response;
                });
            };
        }
    };
};
const $1f603b97a2aa30d6$export$3d28cb048adea4bd = function(configuration, fetch, basePath) {
    return {
        /**
     * Blocks user record.
     * @summary Blocks user.
     * @param {BlockUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ blockUser (fields, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).blockUser(fields, options)(fetch, basePath);
        },
        /**
     * Creates new user.
     * @summary Creates user.
     * @param {CreateUserRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUser (fields, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).createUser(fields, options)(fetch, basePath);
        },
        /**
     * Creates new user delete confirmation.
     * @summary Creates user delete confirmation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ createUserDeleteConfirmation (options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).createUserDeleteConfirmation(options)(fetch, basePath);
        },
        /**
     * Deletes user profile.
     * @summary Deletes user profile.
     * @param {string} userDeleteConfirmationCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ deleteUserProfile (userDeleteConfirmationCode, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).deleteUserProfile(userDeleteConfirmationCode, options)(fetch, basePath);
        },
        /**
     * Retrieves followed artists.
     * @summary Retrieves followed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getFollowedArtists (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getFollowedArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves popular artists.
     * @summary Retrieves popular artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPopularArtists (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getPopularArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves public artists.
     * @summary Retrieves public artists.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicArtists (options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getPublicArtists(options)(fetch, basePath);
        },
        /**
     * Retrieves public user record by user id.
     * @summary Retrieves public user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getPublicUser (id, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getPublicUser(id, options)(fetch, basePath);
        },
        /**
     * Retrieves recommended artists.
     * @summary Retrieves recommended artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getRecommendedArtists (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getRecommendedArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves subscribed artists.
     * @summary Retrieves subscribed artists.
     * @param {number} [limit]
     * @param {number} [offset]
     * @param {string} [searchTerm]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getSubscribedArtists (limit, offset, searchTerm, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getSubscribedArtists(limit, offset, searchTerm, options)(fetch, basePath);
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user.
     * @param {string} id user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUser (id, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getUser(id, options)(fetch, basePath);
        },
        /**
     * Retrieves user record by auth provider id.
     * @summary Retrieves user by auth id.
     * @param {string} authId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByAuthId (authId, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getUserByAuthId(authId, options)(fetch, basePath);
        },
        /**
     * Retrieves user record by user id.
     * @summary Retrieves user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserByUserId (userId, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getUserByUserId(userId, options)(fetch, basePath);
        },
        /**
     * Gets user profile.
     * @summary Gets user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfile (options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getUserProfile(options)(fetch, basePath);
        },
        /**
     * Retrieves username availability status.
     * @summary Retrieves username availability.
     * @param {string} username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUserProfileUsernameAvailable (username, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getUserProfileUsernameAvailable(username, options)(fetch, basePath);
        },
        /**
     * Retrieves users by ids.
     * @summary Retrieves users by ids.
     * @param {string} [userIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ getUsersByIds (userIds, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).getUsersByIds(userIds, options)(fetch, basePath);
        },
        /**
     * Updates user profile.
     * @summary Updates user profile.
     * @param {UpdateUserProfileRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfile (fields, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).updateUserProfile(fields, options)(fetch, basePath);
        },
        /**
     * Updates user profile avatar.
     * @summary Updates user profile avatar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileAvatar (options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).updateUserProfileAvatar(options)(fetch, basePath);
        },
        /**
     * Updates user profile onboarding stage.
     * @summary Updates user profile onboarding stage.
     * @param {UpdateUserProfileOnboardingStageRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileOnboardingStage (fields, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).updateUserProfileOnboardingStage(fields, options)(fetch, basePath);
        },
        /**
     * Updates user profile role.
     * @summary Updates user profile role.
     * @param {UpdateUserProfileRoleRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileRole (fields, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).updateUserProfileRole(fields, options)(fetch, basePath);
        },
        /**
     * Updates user profile username.
     * @summary Updates user profile username.
     * @param {UpdateUserProfileUsernameRequest} fields data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */ updateUserProfileUsername (fields, options) {
            return $1f603b97a2aa30d6$export$7b43f41e93e60955(configuration).updateUserProfileUsername(fields, options)(fetch, basePath);
        }
    };
};
class $1f603b97a2aa30d6$export$2a63ac7615f78125 extends $1f603b97a2aa30d6$export$70edad7ad5bb3f5d {
    /**
   * Blocks user record.
   * @summary Blocks user.
   * @param {BlockUserRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ blockUser(fields, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).blockUser(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new user.
   * @summary Creates user.
   * @param {CreateUserRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ createUser(fields, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).createUser(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Creates new user delete confirmation.
   * @summary Creates user delete confirmation.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ createUserDeleteConfirmation(options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).createUserDeleteConfirmation(options)(this.fetch, this.basePath);
    }
    /**
   * Deletes user profile.
   * @summary Deletes user profile.
   * @param {string} userDeleteConfirmationCode
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ deleteUserProfile(userDeleteConfirmationCode, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).deleteUserProfile(userDeleteConfirmationCode, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves followed artists.
   * @summary Retrieves followed artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getFollowedArtists(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getFollowedArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves popular artists.
   * @summary Retrieves popular artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getPopularArtists(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getPopularArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public artists.
   * @summary Retrieves public artists.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getPublicArtists(options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getPublicArtists(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves public user record by user id.
   * @summary Retrieves public user.
   * @param {string} id user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getPublicUser(id, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getPublicUser(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves recommended artists.
   * @summary Retrieves recommended artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getRecommendedArtists(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getRecommendedArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves subscribed artists.
   * @summary Retrieves subscribed artists.
   * @param {number} [limit]
   * @param {number} [offset]
   * @param {string} [searchTerm]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getSubscribedArtists(limit, offset, searchTerm, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getSubscribedArtists(limit, offset, searchTerm, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user record by user id.
   * @summary Retrieves user.
   * @param {string} id user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUser(id, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getUser(id, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user record by auth provider id.
   * @summary Retrieves user by auth id.
   * @param {string} authId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserByAuthId(authId, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getUserByAuthId(authId, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves user record by user id.
   * @summary Retrieves user by user id.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserByUserId(userId, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getUserByUserId(userId, options)(this.fetch, this.basePath);
    }
    /**
   * Gets user profile.
   * @summary Gets user profile.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserProfile(options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getUserProfile(options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves username availability status.
   * @summary Retrieves username availability.
   * @param {string} username
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUserProfileUsernameAvailable(username, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getUserProfileUsernameAvailable(username, options)(this.fetch, this.basePath);
    }
    /**
   * Retrieves users by ids.
   * @summary Retrieves users by ids.
   * @param {string} [userIds]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ getUsersByIds(userIds, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).getUsersByIds(userIds, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile.
   * @summary Updates user profile.
   * @param {UpdateUserProfileRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfile(fields, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).updateUserProfile(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile avatar.
   * @summary Updates user profile avatar.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileAvatar(options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).updateUserProfileAvatar(options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile onboarding stage.
   * @summary Updates user profile onboarding stage.
   * @param {UpdateUserProfileOnboardingStageRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileOnboardingStage(fields, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).updateUserProfileOnboardingStage(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile role.
   * @summary Updates user profile role.
   * @param {UpdateUserProfileRoleRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileRole(fields, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).updateUserProfileRole(fields, options)(this.fetch, this.basePath);
    }
    /**
   * Updates user profile username.
   * @summary Updates user profile username.
   * @param {UpdateUserProfileUsernameRequest} fields data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */ updateUserProfileUsername(fields, options) {
        return $1f603b97a2aa30d6$export$7b43f41e93e60955(this.configuration).updateUserProfileUsername(fields, options)(this.fetch, this.basePath);
    }
}

});
parcelRegister("hH01d", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $jDr7D = parcelRequire("jDr7D");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $5iXBv = parcelRequire("5iXBv");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $5iXBv.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $jDr7D.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $5iXBv.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $5iXBv.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("jDr7D", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("5iXBv", function(module, exports) {
"use strict";

var $88Tjm = parcelRequire("88Tjm");

var $1vzis = parcelRequire("1vzis");

var $aYeQo = parcelRequire("aYeQo");
module.exports = {
    formats: $aYeQo,
    parse: $1vzis,
    stringify: $88Tjm
};

});
parcelRegister("88Tjm", function(module, exports) {
"use strict";

var $aLN2C = parcelRequire("aLN2C");

var $6fzSR = parcelRequire("6fzSR");

var $aYeQo = parcelRequire("aYeQo");
var $5ed9f9c214c4a8f4$var$has = Object.prototype.hasOwnProperty;
var $5ed9f9c214c4a8f4$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $5ed9f9c214c4a8f4$var$isArray = Array.isArray;
var $5ed9f9c214c4a8f4$var$push = Array.prototype.push;
var $5ed9f9c214c4a8f4$var$pushToArray = function(arr, valueOrArray) {
    $5ed9f9c214c4a8f4$var$push.apply(arr, $5ed9f9c214c4a8f4$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $5ed9f9c214c4a8f4$var$toISO = Date.prototype.toISOString;
var $5ed9f9c214c4a8f4$var$defaultFormat = $aYeQo.default;
var $5ed9f9c214c4a8f4$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $6fzSR.encode,
    encodeValuesOnly: false,
    format: $5ed9f9c214c4a8f4$var$defaultFormat,
    formatter: $aYeQo.formatters[$5ed9f9c214c4a8f4$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $5ed9f9c214c4a8f4$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $5ed9f9c214c4a8f4$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $5ed9f9c214c4a8f4$var$sentinel = {};
var $5ed9f9c214c4a8f4$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($5ed9f9c214c4a8f4$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($5ed9f9c214c4a8f4$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $5ed9f9c214c4a8f4$var$isArray(obj)) obj = $6fzSR.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $5ed9f9c214c4a8f4$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($5ed9f9c214c4a8f4$var$isNonNullishPrimitive(obj) || $6fzSR.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $5ed9f9c214c4a8f4$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $5ed9f9c214c4a8f4$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $5ed9f9c214c4a8f4$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $6fzSR.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($5ed9f9c214c4a8f4$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $5ed9f9c214c4a8f4$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $5ed9f9c214c4a8f4$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $5ed9f9c214c4a8f4$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $aLN2C();
        valueSideChannel.set($5ed9f9c214c4a8f4$var$sentinel, sideChannel);
        $5ed9f9c214c4a8f4$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $5ed9f9c214c4a8f4$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $5ed9f9c214c4a8f4$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $5ed9f9c214c4a8f4$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $5ed9f9c214c4a8f4$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $aYeQo.default;
    if (typeof opts.format !== "undefined") {
        if (!$5ed9f9c214c4a8f4$var$has.call($aYeQo.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $aYeQo.formatters[format];
    var filter = $5ed9f9c214c4a8f4$var$defaults.filter;
    if (typeof opts.filter === "function" || $5ed9f9c214c4a8f4$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $5ed9f9c214c4a8f4$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $5ed9f9c214c4a8f4$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $5ed9f9c214c4a8f4$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $5ed9f9c214c4a8f4$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $5ed9f9c214c4a8f4$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $5ed9f9c214c4a8f4$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $5ed9f9c214c4a8f4$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $5ed9f9c214c4a8f4$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $5ed9f9c214c4a8f4$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $5ed9f9c214c4a8f4$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $5ed9f9c214c4a8f4$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $5ed9f9c214c4a8f4$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $5ed9f9c214c4a8f4$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $5ed9f9c214c4a8f4$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $5ed9f9c214c4a8f4$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($5ed9f9c214c4a8f4$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $5ed9f9c214c4a8f4$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $aLN2C();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $5ed9f9c214c4a8f4$var$pushToArray(keys, $5ed9f9c214c4a8f4$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("aLN2C", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");

var $jLsQW = parcelRequire("jLsQW");

var $5reXs = parcelRequire("5reXs");

var $eDiIz = parcelRequire("eDiIz");
var $7d7455b7eca66e61$var$$WeakMap = $avqmt("%WeakMap%", true);
var $7d7455b7eca66e61$var$$Map = $avqmt("%Map%", true);
var $7d7455b7eca66e61$var$$weakMapGet = $jLsQW("WeakMap.prototype.get", true);
var $7d7455b7eca66e61$var$$weakMapSet = $jLsQW("WeakMap.prototype.set", true);
var $7d7455b7eca66e61$var$$weakMapHas = $jLsQW("WeakMap.prototype.has", true);
var $7d7455b7eca66e61$var$$mapGet = $jLsQW("Map.prototype.get", true);
var $7d7455b7eca66e61$var$$mapSet = $jLsQW("Map.prototype.set", true);
var $7d7455b7eca66e61$var$$mapHas = $jLsQW("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $7d7455b7eca66e61$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $7d7455b7eca66e61$var$listGet = function(objects, key) {
    var node = $7d7455b7eca66e61$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $7d7455b7eca66e61$var$listSet = function(objects, key, value) {
    var node = $7d7455b7eca66e61$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $7d7455b7eca66e61$var$listHas = function(objects, key) {
    return !!$7d7455b7eca66e61$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eDiIz("Side channel does not contain " + $5reXs(key));
        },
        get: function(key) {
            if ($7d7455b7eca66e61$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7d7455b7eca66e61$var$$weakMapGet($wm, key);
            } else if ($7d7455b7eca66e61$var$$Map) {
                if ($m) return $7d7455b7eca66e61$var$$mapGet($m, key);
            } else {
                if ($o) return $7d7455b7eca66e61$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($7d7455b7eca66e61$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $7d7455b7eca66e61$var$$weakMapHas($wm, key);
            } else if ($7d7455b7eca66e61$var$$Map) {
                if ($m) return $7d7455b7eca66e61$var$$mapHas($m, key);
            } else {
                if ($o) return $7d7455b7eca66e61$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($7d7455b7eca66e61$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $7d7455b7eca66e61$var$$WeakMap();
                $7d7455b7eca66e61$var$$weakMapSet($wm, key, value);
            } else if ($7d7455b7eca66e61$var$$Map) {
                if (!$m) $m = new $7d7455b7eca66e61$var$$Map();
                $7d7455b7eca66e61$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $7d7455b7eca66e61$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("avqmt", function(module, exports) {
"use strict";
var $7a613f7503e09dde$var$undefined1;

var $ki6v4 = parcelRequire("ki6v4");

var $6ZF4E = parcelRequire("6ZF4E");

var $jFaeR = parcelRequire("jFaeR");

var $aNqH3 = parcelRequire("aNqH3");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $guz3A = parcelRequire("guz3A");
var $7a613f7503e09dde$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $7a613f7503e09dde$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7a613f7503e09dde$var$$gOPD) try {
    $7a613f7503e09dde$var$$gOPD({}, "");
} catch (e) {
    $7a613f7503e09dde$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $eDiIz();
};
var $7a613f7503e09dde$var$ThrowTypeError = $7a613f7503e09dde$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7a613f7503e09dde$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $7a613f7503e09dde$var$hasProto = (parcelRequire("1q0DH"))();
var $7a613f7503e09dde$var$getProto = Object.getPrototypeOf || ($7a613f7503e09dde$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === "undefined" || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGenerator%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncIteratorPrototype%": $7a613f7503e09dde$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $ki6v4,
    "%eval%": eval,
    "%EvalError%": $6ZF4E,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $7a613f7503e09dde$var$$Function,
    "%GeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $jFaeR,
    "%ReferenceError%": $aNqH3,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $iOgL8,
    "%ThrowTypeError%": $7a613f7503e09dde$var$ThrowTypeError,
    "%TypedArray%": $7a613f7503e09dde$var$TypedArray,
    "%TypeError%": $eDiIz,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $guz3A,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($7a613f7503e09dde$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto(e));
    $7a613f7503e09dde$var$INTRINSICS["%Error.prototype%"] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $7a613f7503e09dde$var$getProto) value = $7a613f7503e09dde$var$getProto(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $7Dte4 = parcelRequire("7Dte4");
var $7a613f7503e09dde$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $iOgL8("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $iOgL8("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eDiIz("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $iOgL8("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eDiIz("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eDiIz('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $iOgL8("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $iOgL8("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eDiIz("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($7a613f7503e09dde$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7a613f7503e09dde$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("ki6v4", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("6ZF4E", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("jFaeR", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("aNqH3", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("iOgL8", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eDiIz", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("guz3A", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("5CmBX", function(module, exports) {
"use strict";
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $fNdnD = parcelRequire("fNdnD");
module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $41720a79fda68d9e$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $fNdnD();
};

});
parcelRegister("fNdnD", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("1q0DH", function(module, exports) {
"use strict";
var $1088b720f9e31113$var$test = {
    __proto__: null,
    foo: {}
};
var $1088b720f9e31113$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $1088b720f9e31113$var$test
    }).foo === $1088b720f9e31113$var$test.foo && !($1088b720f9e31113$var$test instanceof $1088b720f9e31113$var$$Object);
};

});

parcelRegister("a7ABz", function(module, exports) {
"use strict";

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$max = Math.max;
var $923fbadf1e720976$var$funcType = "[object Function]";
var $923fbadf1e720976$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $923fbadf1e720976$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $923fbadf1e720976$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $923fbadf1e720976$var$toStr.apply(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $923fbadf1e720976$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $923fbadf1e720976$var$concatty(args, arguments));
    };
    var boundLength = $923fbadf1e720976$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $923fbadf1e720976$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("7Dte4", function(module, exports) {
"use strict";
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $a7ABz = parcelRequire("a7ABz");
/** @type {import('.')} */ module.exports = $a7ABz.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});


parcelRegister("jLsQW", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");

var $e9CQ6 = parcelRequire("e9CQ6");
var $e638c9b041e57a82$var$$indexOf = $e9CQ6($avqmt("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $avqmt(name, !!allowMissing);
    if (typeof intrinsic === "function" && $e638c9b041e57a82$var$$indexOf(name, ".prototype.") > -1) return $e9CQ6(intrinsic);
    return intrinsic;
};

});
parcelRegister("e9CQ6", function(module, exports) {
"use strict";

var $a7ABz = parcelRequire("a7ABz");

var $avqmt = parcelRequire("avqmt");

var $64wPI = parcelRequire("64wPI");

var $eDiIz = parcelRequire("eDiIz");
var $a4e008a795944d5c$var$$apply = $avqmt("%Function.prototype.apply%");
var $a4e008a795944d5c$var$$call = $avqmt("%Function.prototype.call%");
var $a4e008a795944d5c$var$$reflectApply = $avqmt("%Reflect.apply%", true) || $a7ABz.call($a4e008a795944d5c$var$$call, $a4e008a795944d5c$var$$apply);

var $4jAFO = parcelRequire("4jAFO");
var $a4e008a795944d5c$var$$max = $avqmt("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eDiIz("a function is required");
    var func = $a4e008a795944d5c$var$$reflectApply($a7ABz, $a4e008a795944d5c$var$$call, arguments);
    return $64wPI(func, 1 + $a4e008a795944d5c$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $a4e008a795944d5c$var$applyBind = function applyBind() {
    return $a4e008a795944d5c$var$$reflectApply($a7ABz, $a4e008a795944d5c$var$$apply, arguments);
};
if ($4jAFO) $4jAFO(module.exports, "apply", {
    value: $a4e008a795944d5c$var$applyBind
});
else module.exports.apply = $a4e008a795944d5c$var$applyBind;

});
parcelRegister("64wPI", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");

var $26m4v = parcelRequire("26m4v");

var $46bc95c30a58fa4c$var$hasDescriptors = (parcelRequire("73hDB"))();

var $crSdH = parcelRequire("crSdH");

var $eDiIz = parcelRequire("eDiIz");
var $46bc95c30a58fa4c$var$$floor = $avqmt("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eDiIz("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $46bc95c30a58fa4c$var$$floor(length) !== length) throw new $eDiIz("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $crSdH) {
        var desc = $crSdH(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($46bc95c30a58fa4c$var$hasDescriptors) $26m4v(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $26m4v(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("26m4v", function(module, exports) {
"use strict";

var $4jAFO = parcelRequire("4jAFO");

var $iOgL8 = parcelRequire("iOgL8");

var $eDiIz = parcelRequire("eDiIz");

var $crSdH = parcelRequire("crSdH");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eDiIz("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eDiIz("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eDiIz("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eDiIz("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eDiIz("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eDiIz("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$crSdH && $crSdH(obj, property);
    if ($4jAFO) $4jAFO(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $iOgL8("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("4jAFO", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");
/** @type {import('.')} */ var $3245625cab00454b$var$$defineProperty = $avqmt("%Object.defineProperty%", true) || false;
if ($3245625cab00454b$var$$defineProperty) try {
    $3245625cab00454b$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $3245625cab00454b$var$$defineProperty = false;
}
module.exports = $3245625cab00454b$var$$defineProperty;

});

parcelRegister("crSdH", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");
var $9102109fbf1ea315$var$$gOPD = $avqmt("%Object.getOwnPropertyDescriptor%", true);
if ($9102109fbf1ea315$var$$gOPD) try {
    $9102109fbf1ea315$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$var$$gOPD = null;
}
module.exports = $9102109fbf1ea315$var$$gOPD;

});


parcelRegister("73hDB", function(module, exports) {
"use strict";

var $4jAFO = parcelRequire("4jAFO");
var $52267eb4294466ed$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$4jAFO;
};
$52267eb4294466ed$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$4jAFO) return null;
    try {
        return $4jAFO([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $52267eb4294466ed$var$hasPropertyDescriptors;

});




parcelRegister("5reXs", function(module, exports) {
var $3f5b13b16a751ddf$var$hasMap = typeof Map === "function" && Map.prototype;
var $3f5b13b16a751ddf$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $3f5b13b16a751ddf$var$mapSize = $3f5b13b16a751ddf$var$hasMap && $3f5b13b16a751ddf$var$mapSizeDescriptor && typeof $3f5b13b16a751ddf$var$mapSizeDescriptor.get === "function" ? $3f5b13b16a751ddf$var$mapSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$mapForEach = $3f5b13b16a751ddf$var$hasMap && Map.prototype.forEach;
var $3f5b13b16a751ddf$var$hasSet = typeof Set === "function" && Set.prototype;
var $3f5b13b16a751ddf$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $3f5b13b16a751ddf$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $3f5b13b16a751ddf$var$setSize = $3f5b13b16a751ddf$var$hasSet && $3f5b13b16a751ddf$var$setSizeDescriptor && typeof $3f5b13b16a751ddf$var$setSizeDescriptor.get === "function" ? $3f5b13b16a751ddf$var$setSizeDescriptor.get : null;
var $3f5b13b16a751ddf$var$setForEach = $3f5b13b16a751ddf$var$hasSet && Set.prototype.forEach;
var $3f5b13b16a751ddf$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $3f5b13b16a751ddf$var$weakMapHas = $3f5b13b16a751ddf$var$hasWeakMap ? WeakMap.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $3f5b13b16a751ddf$var$weakSetHas = $3f5b13b16a751ddf$var$hasWeakSet ? WeakSet.prototype.has : null;
var $3f5b13b16a751ddf$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $3f5b13b16a751ddf$var$weakRefDeref = $3f5b13b16a751ddf$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $3f5b13b16a751ddf$var$booleanValueOf = Boolean.prototype.valueOf;
var $3f5b13b16a751ddf$var$objectToString = Object.prototype.toString;
var $3f5b13b16a751ddf$var$functionToString = Function.prototype.toString;
var $3f5b13b16a751ddf$var$$match = String.prototype.match;
var $3f5b13b16a751ddf$var$$slice = String.prototype.slice;
var $3f5b13b16a751ddf$var$$replace = String.prototype.replace;
var $3f5b13b16a751ddf$var$$toUpperCase = String.prototype.toUpperCase;
var $3f5b13b16a751ddf$var$$toLowerCase = String.prototype.toLowerCase;
var $3f5b13b16a751ddf$var$$test = RegExp.prototype.test;
var $3f5b13b16a751ddf$var$$concat = Array.prototype.concat;
var $3f5b13b16a751ddf$var$$join = Array.prototype.join;
var $3f5b13b16a751ddf$var$$arrSlice = Array.prototype.slice;
var $3f5b13b16a751ddf$var$$floor = Math.floor;
var $3f5b13b16a751ddf$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $3f5b13b16a751ddf$var$gOPS = Object.getOwnPropertySymbols;
var $3f5b13b16a751ddf$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $3f5b13b16a751ddf$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $3f5b13b16a751ddf$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $3f5b13b16a751ddf$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $3f5b13b16a751ddf$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $3f5b13b16a751ddf$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $3f5b13b16a751ddf$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $3f5b13b16a751ddf$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$3f5b13b16a751ddf$var$$floor(-num) : $3f5b13b16a751ddf$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $3f5b13b16a751ddf$var$$slice.call(str, intStr.length + 1);
            return $3f5b13b16a751ddf$var$$replace.call(intStr, sepRegex, "$&_") + "." + $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $3f5b13b16a751ddf$var$$replace.call(str, sepRegex, "$&_");
}

var $5Io6y = parcelRequire("5Io6y");
var $3f5b13b16a751ddf$var$inspectCustom = $5Io6y.custom;
var $3f5b13b16a751ddf$var$inspectSymbol = $3f5b13b16a751ddf$var$isSymbol($3f5b13b16a751ddf$var$inspectCustom) ? $3f5b13b16a751ddf$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($3f5b13b16a751ddf$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($3f5b13b16a751ddf$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $3f5b13b16a751ddf$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($3f5b13b16a751ddf$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($3f5b13b16a751ddf$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $3f5b13b16a751ddf$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $3f5b13b16a751ddf$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $3f5b13b16a751ddf$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $3f5b13b16a751ddf$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($3f5b13b16a751ddf$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $3f5b13b16a751ddf$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($3f5b13b16a751ddf$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var name = $3f5b13b16a751ddf$var$nameOf(obj);
        var keys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $3f5b13b16a751ddf$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($3f5b13b16a751ddf$var$isSymbol(obj)) {
        var symString = $3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $3f5b13b16a751ddf$var$symToString.call(obj);
        return typeof obj === "object" && !$3f5b13b16a751ddf$var$hasShammedSymbols ? $3f5b13b16a751ddf$var$markBoxed(symString) : symString;
    }
    if ($3f5b13b16a751ddf$var$isElement(obj)) {
        var s = "<" + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $3f5b13b16a751ddf$var$wrapQuotes($3f5b13b16a751ddf$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $3f5b13b16a751ddf$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($3f5b13b16a751ddf$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (indent && !$3f5b13b16a751ddf$var$singleLineValues(xs)) return "[" + $3f5b13b16a751ddf$var$indentedJoin(xs, indent) + "]";
        return "[ " + $3f5b13b16a751ddf$var$$join.call(xs, ", ") + " ]";
    }
    if ($3f5b13b16a751ddf$var$isError(obj)) {
        var parts = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$3f5b13b16a751ddf$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $3f5b13b16a751ddf$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($3f5b13b16a751ddf$var$inspectSymbol && typeof obj[$3f5b13b16a751ddf$var$inspectSymbol] === "function" && $5Io6y) return $5Io6y(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($3f5b13b16a751ddf$var$isMap(obj)) {
        var mapParts = [];
        if ($3f5b13b16a751ddf$var$mapForEach) $3f5b13b16a751ddf$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf("Map", $3f5b13b16a751ddf$var$mapSize.call(obj), mapParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isSet(obj)) {
        var setParts = [];
        if ($3f5b13b16a751ddf$var$setForEach) $3f5b13b16a751ddf$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $3f5b13b16a751ddf$var$collectionOf("Set", $3f5b13b16a751ddf$var$setSize.call(obj), setParts, indent);
    }
    if ($3f5b13b16a751ddf$var$isWeakMap(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf("WeakMap");
    if ($3f5b13b16a751ddf$var$isWeakSet(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf("WeakSet");
    if ($3f5b13b16a751ddf$var$isWeakRef(obj)) return $3f5b13b16a751ddf$var$weakCollectionOf("WeakRef");
    if ($3f5b13b16a751ddf$var$isNumber(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(Number(obj)));
    if ($3f5b13b16a751ddf$var$isBigInt(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect($3f5b13b16a751ddf$var$bigIntValueOf.call(obj)));
    if ($3f5b13b16a751ddf$var$isBoolean(obj)) return $3f5b13b16a751ddf$var$markBoxed($3f5b13b16a751ddf$var$booleanValueOf.call(obj));
    if ($3f5b13b16a751ddf$var$isString(obj)) return $3f5b13b16a751ddf$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$3f5b13b16a751ddf$var$isDate(obj) && !$3f5b13b16a751ddf$var$isRegExp(obj)) {
        var ys = $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect);
        var isPlainObject = $3f5b13b16a751ddf$var$gPO ? $3f5b13b16a751ddf$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $3f5b13b16a751ddf$var$toStringTag && Object(obj) === obj && $3f5b13b16a751ddf$var$toStringTag in obj ? $3f5b13b16a751ddf$var$$slice.call($3f5b13b16a751ddf$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $3f5b13b16a751ddf$var$$join.call($3f5b13b16a751ddf$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $3f5b13b16a751ddf$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $3f5b13b16a751ddf$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $3f5b13b16a751ddf$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $3f5b13b16a751ddf$var$quote(s) {
    return $3f5b13b16a751ddf$var$$replace.call(String(s), /"/g, "&quot;");
}
function $3f5b13b16a751ddf$var$isArray(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === "[object Array]" && (!$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === "object" && $3f5b13b16a751ddf$var$toStringTag in obj));
}
function $3f5b13b16a751ddf$var$isDate(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === "[object Date]" && (!$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === "object" && $3f5b13b16a751ddf$var$toStringTag in obj));
}
function $3f5b13b16a751ddf$var$isRegExp(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === "[object RegExp]" && (!$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === "object" && $3f5b13b16a751ddf$var$toStringTag in obj));
}
function $3f5b13b16a751ddf$var$isError(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === "[object Error]" && (!$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === "object" && $3f5b13b16a751ddf$var$toStringTag in obj));
}
function $3f5b13b16a751ddf$var$isString(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === "[object String]" && (!$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === "object" && $3f5b13b16a751ddf$var$toStringTag in obj));
}
function $3f5b13b16a751ddf$var$isNumber(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === "[object Number]" && (!$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === "object" && $3f5b13b16a751ddf$var$toStringTag in obj));
}
function $3f5b13b16a751ddf$var$isBoolean(obj) {
    return $3f5b13b16a751ddf$var$toStr(obj) === "[object Boolean]" && (!$3f5b13b16a751ddf$var$toStringTag || !(typeof obj === "object" && $3f5b13b16a751ddf$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $3f5b13b16a751ddf$var$isSymbol(obj) {
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$3f5b13b16a751ddf$var$symToString) return false;
    try {
        $3f5b13b16a751ddf$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$3f5b13b16a751ddf$var$bigIntValueOf) return false;
    try {
        $3f5b13b16a751ddf$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $3f5b13b16a751ddf$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $3f5b13b16a751ddf$var$has(obj, key) {
    return $3f5b13b16a751ddf$var$hasOwn.call(obj, key);
}
function $3f5b13b16a751ddf$var$toStr(obj) {
    return $3f5b13b16a751ddf$var$objectToString.call(obj);
}
function $3f5b13b16a751ddf$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $3f5b13b16a751ddf$var$$match.call($3f5b13b16a751ddf$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $3f5b13b16a751ddf$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $3f5b13b16a751ddf$var$isMap(x) {
    if (!$3f5b13b16a751ddf$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $3f5b13b16a751ddf$var$mapSize.call(x);
        try {
            $3f5b13b16a751ddf$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakMap(x) {
    if (!$3f5b13b16a751ddf$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        try {
            $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakRef(x) {
    if (!$3f5b13b16a751ddf$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $3f5b13b16a751ddf$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isSet(x) {
    if (!$3f5b13b16a751ddf$var$setSize || !x || typeof x !== "object") return false;
    try {
        $3f5b13b16a751ddf$var$setSize.call(x);
        try {
            $3f5b13b16a751ddf$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isWeakSet(x) {
    if (!$3f5b13b16a751ddf$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $3f5b13b16a751ddf$var$weakSetHas.call(x, $3f5b13b16a751ddf$var$weakSetHas);
        try {
            $3f5b13b16a751ddf$var$weakMapHas.call(x, $3f5b13b16a751ddf$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $3f5b13b16a751ddf$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $3f5b13b16a751ddf$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $3f5b13b16a751ddf$var$inspectString($3f5b13b16a751ddf$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $3f5b13b16a751ddf$var$$replace.call($3f5b13b16a751ddf$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $3f5b13b16a751ddf$var$lowbyte);
    return $3f5b13b16a751ddf$var$wrapQuotes(s, "single", opts);
}
function $3f5b13b16a751ddf$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $3f5b13b16a751ddf$var$$toUpperCase.call(n.toString(16));
}
function $3f5b13b16a751ddf$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $3f5b13b16a751ddf$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $3f5b13b16a751ddf$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $3f5b13b16a751ddf$var$indentedJoin(entries, indent) : $3f5b13b16a751ddf$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $3f5b13b16a751ddf$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($3f5b13b16a751ddf$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $3f5b13b16a751ddf$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $3f5b13b16a751ddf$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $3f5b13b16a751ddf$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $3f5b13b16a751ddf$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $3f5b13b16a751ddf$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $3f5b13b16a751ddf$var$arrObjKeys(obj, inspect) {
    var isArr = $3f5b13b16a751ddf$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $3f5b13b16a751ddf$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $3f5b13b16a751ddf$var$gOPS === "function" ? $3f5b13b16a751ddf$var$gOPS(obj) : [];
    var symMap;
    if ($3f5b13b16a751ddf$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$3f5b13b16a751ddf$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($3f5b13b16a751ddf$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($3f5b13b16a751ddf$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $3f5b13b16a751ddf$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($3f5b13b16a751ddf$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("5Io6y", function(module, exports) {
"use strict";

});



parcelRegister("6fzSR", function(module, exports) {
"use strict";

var $aYeQo = parcelRequire("aYeQo");
var $48cffa948cd48b24$var$has = Object.prototype.hasOwnProperty;
var $48cffa948cd48b24$var$isArray = Array.isArray;
var $48cffa948cd48b24$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $48cffa948cd48b24$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($48cffa948cd48b24$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $48cffa948cd48b24$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $48cffa948cd48b24$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($48cffa948cd48b24$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$48cffa948cd48b24$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($48cffa948cd48b24$var$isArray(target) && !$48cffa948cd48b24$var$isArray(source)) mergeTarget = $48cffa948cd48b24$var$arrayToObject(target, options);
    if ($48cffa948cd48b24$var$isArray(target) && $48cffa948cd48b24$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($48cffa948cd48b24$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($48cffa948cd48b24$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $48cffa948cd48b24$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $48cffa948cd48b24$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $48cffa948cd48b24$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $48cffa948cd48b24$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $48cffa948cd48b24$var$limit){
        var segment = string.length >= $48cffa948cd48b24$var$limit ? string.slice(j, j + $48cffa948cd48b24$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $aYeQo.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $48cffa948cd48b24$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $48cffa948cd48b24$var$hexTable[0xC0 | c >> 6] + $48cffa948cd48b24$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $48cffa948cd48b24$var$hexTable[0xE0 | c >> 12] + $48cffa948cd48b24$var$hexTable[0x80 | c >> 6 & 0x3F] + $48cffa948cd48b24$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $48cffa948cd48b24$var$hexTable[0xF0 | c >> 18] + $48cffa948cd48b24$var$hexTable[0x80 | c >> 12 & 0x3F] + $48cffa948cd48b24$var$hexTable[0x80 | c >> 6 & 0x3F] + $48cffa948cd48b24$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $48cffa948cd48b24$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $48cffa948cd48b24$var$compactQueue(queue);
    return value;
};
var $48cffa948cd48b24$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $48cffa948cd48b24$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $48cffa948cd48b24$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $48cffa948cd48b24$var$maybeMap = function maybeMap(val, fn) {
    if ($48cffa948cd48b24$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $48cffa948cd48b24$var$arrayToObject,
    assign: $48cffa948cd48b24$var$assign,
    combine: $48cffa948cd48b24$var$combine,
    compact: $48cffa948cd48b24$var$compact,
    decode: $48cffa948cd48b24$var$decode,
    encode: $48cffa948cd48b24$var$encode,
    isBuffer: $48cffa948cd48b24$var$isBuffer,
    isRegExp: $48cffa948cd48b24$var$isRegExp,
    maybeMap: $48cffa948cd48b24$var$maybeMap,
    merge: $48cffa948cd48b24$var$merge
};

});
parcelRegister("aYeQo", function(module, exports) {
"use strict";
var $7fcb05b1ebb63679$var$replace = String.prototype.replace;
var $7fcb05b1ebb63679$var$percentTwenties = /%20/g;
var $7fcb05b1ebb63679$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $7fcb05b1ebb63679$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $7fcb05b1ebb63679$var$replace.call(value, $7fcb05b1ebb63679$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $7fcb05b1ebb63679$var$Format.RFC1738,
    RFC3986: $7fcb05b1ebb63679$var$Format.RFC3986
};

});



parcelRegister("1vzis", function(module, exports) {
"use strict";

var $6fzSR = parcelRequire("6fzSR");
var $119410e761f024ce$var$has = Object.prototype.hasOwnProperty;
var $119410e761f024ce$var$isArray = Array.isArray;
var $119410e761f024ce$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $6fzSR.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $119410e761f024ce$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $119410e761f024ce$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $119410e761f024ce$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $119410e761f024ce$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $119410e761f024ce$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $119410e761f024ce$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $119410e761f024ce$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $119410e761f024ce$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $119410e761f024ce$var$defaults.decoder, charset, "key");
            val = $6fzSR.maybeMap($119410e761f024ce$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $119410e761f024ce$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $119410e761f024ce$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $119410e761f024ce$var$isArray(val) ? [
            val
        ] : val;
        var existing = $119410e761f024ce$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $6fzSR.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $119410e761f024ce$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $119410e761f024ce$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $119410e761f024ce$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $119410e761f024ce$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $119410e761f024ce$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $119410e761f024ce$var$parseObject(keys, val, options, valuesParsed);
};
var $119410e761f024ce$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $119410e761f024ce$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $119410e761f024ce$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $119410e761f024ce$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $119410e761f024ce$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $119410e761f024ce$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $119410e761f024ce$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $119410e761f024ce$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $119410e761f024ce$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $119410e761f024ce$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $119410e761f024ce$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $119410e761f024ce$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $119410e761f024ce$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $6fzSR.isRegExp(opts.delimiter) ? opts.delimiter : $119410e761f024ce$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $119410e761f024ce$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $119410e761f024ce$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $119410e761f024ce$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $119410e761f024ce$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $119410e761f024ce$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $119410e761f024ce$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $119410e761f024ce$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $119410e761f024ce$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $119410e761f024ce$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $6fzSR.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $6fzSR.compact(obj);
};

});



parcelRegister("gGHUs", function(module, exports) {
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
parcelRequire("5DqoN");
module.exports = self.fetch.bind(self);

});
parcelRegister("5DqoN", function(module, exports) {
/* eslint-disable no-prototype-builtins */ var $41a5128afd572ffa$var$g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== "undefined" && $parcel$global || {};
var $41a5128afd572ffa$var$support = {
    searchParams: "URLSearchParams" in $41a5128afd572ffa$var$g,
    iterable: "Symbol" in $41a5128afd572ffa$var$g && "iterator" in Symbol,
    blob: "FileReader" in $41a5128afd572ffa$var$g && "Blob" in $41a5128afd572ffa$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in $41a5128afd572ffa$var$g,
    arrayBuffer: "ArrayBuffer" in $41a5128afd572ffa$var$g
};
function $41a5128afd572ffa$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($41a5128afd572ffa$var$support.arrayBuffer) {
    var $41a5128afd572ffa$var$viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var $41a5128afd572ffa$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $41a5128afd572ffa$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $41a5128afd572ffa$var$normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $41a5128afd572ffa$var$normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $41a5128afd572ffa$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($41a5128afd572ffa$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $41a5128afd572ffa$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $41a5128afd572ffa$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $41a5128afd572ffa$var$normalizeName(name);
    value = $41a5128afd572ffa$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype["delete"] = function(name) {
    delete this.map[$41a5128afd572ffa$var$normalizeName(name)];
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $41a5128afd572ffa$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($41a5128afd572ffa$var$normalizeName(name));
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$41a5128afd572ffa$var$normalizeName(name)] = $41a5128afd572ffa$var$normalizeValue(value);
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $41a5128afd572ffa$var$iteratorFor(items);
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $41a5128afd572ffa$var$iteratorFor(items);
};
$41a5128afd572ffa$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $41a5128afd572ffa$var$iteratorFor(items);
};
if ($41a5128afd572ffa$var$support.iterable) $41a5128afd572ffa$export$79b704688b15c0f4.prototype[Symbol.iterator] = $41a5128afd572ffa$export$79b704688b15c0f4.prototype.entries;
function $41a5128afd572ffa$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function $41a5128afd572ffa$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $41a5128afd572ffa$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $41a5128afd572ffa$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $41a5128afd572ffa$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $41a5128afd572ffa$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
}
function $41a5128afd572ffa$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function $41a5128afd572ffa$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $41a5128afd572ffa$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = "";
        } else if (typeof body === "string") this._bodyText = body;
        else if ($41a5128afd572ffa$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($41a5128afd572ffa$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($41a5128afd572ffa$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($41a5128afd572ffa$var$support.arrayBuffer && $41a5128afd572ffa$var$support.blob && $41a5128afd572ffa$var$isDataView(body)) {
            this._bodyArrayBuffer = $41a5128afd572ffa$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($41a5128afd572ffa$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $41a5128afd572ffa$var$isArrayBufferView(body))) this._bodyArrayBuffer = $41a5128afd572ffa$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if ($41a5128afd572ffa$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if ($41a5128afd572ffa$var$support.blob) this.blob = function() {
        var rejected = $41a5128afd572ffa$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $41a5128afd572ffa$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($41a5128afd572ffa$var$support.blob) return this.blob().then($41a5128afd572ffa$var$readBlobAsArrayBuffer);
        else throw new Error("could not read as ArrayBuffer");
    };
    this.text = function() {
        var rejected = $41a5128afd572ffa$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $41a5128afd572ffa$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($41a5128afd572ffa$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if ($41a5128afd572ffa$var$support.formData) this.formData = function() {
        return this.text().then($41a5128afd572ffa$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $41a5128afd572ffa$var$methods = [
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
];
function $41a5128afd572ffa$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $41a5128afd572ffa$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $41a5128afd572ffa$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $41a5128afd572ffa$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $41a5128afd572ffa$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $41a5128afd572ffa$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new $41a5128afd572ffa$export$79b704688b15c0f4(options.headers);
    this.method = $41a5128afd572ffa$var$normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ("AbortController" in $41a5128afd572ffa$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
$41a5128afd572ffa$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $41a5128afd572ffa$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $41a5128afd572ffa$var$decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $41a5128afd572ffa$var$parseHeaders(rawHeaders) {
    var headers = new $41a5128afd572ffa$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn("Response " + error.message);
            }
        }
    });
    return headers;
}
$41a5128afd572ffa$var$Body.call($41a5128afd572ffa$export$7fa6c5b6f8193917.prototype);
function $41a5128afd572ffa$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $41a5128afd572ffa$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
    this.headers = new $41a5128afd572ffa$export$79b704688b15c0f4(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
$41a5128afd572ffa$var$Body.call($41a5128afd572ffa$export$9f633d56d7ec90d3.prototype);
$41a5128afd572ffa$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $41a5128afd572ffa$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $41a5128afd572ffa$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$41a5128afd572ffa$export$9f633d56d7ec90d3.error = function() {
    var response = new $41a5128afd572ffa$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ""
    });
    response.ok = false;
    response.status = 0;
    response.type = "error";
    return response;
};
var $41a5128afd572ffa$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$41a5128afd572ffa$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($41a5128afd572ffa$var$redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new $41a5128afd572ffa$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $41a5128afd572ffa$export$fe58bcf938607f6a = $41a5128afd572ffa$var$g.DOMException;
try {
    new $41a5128afd572ffa$export$fe58bcf938607f6a();
} catch (err) {
    $41a5128afd572ffa$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $41a5128afd572ffa$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $41a5128afd572ffa$export$fe58bcf938607f6a.prototype.constructor = $41a5128afd572ffa$export$fe58bcf938607f6a;
}
function $41a5128afd572ffa$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $41a5128afd572ffa$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $41a5128afd572ffa$export$fe58bcf938607f6a("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $41a5128afd572ffa$var$parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $41a5128afd572ffa$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request timed out"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $41a5128afd572ffa$export$fe58bcf938607f6a("Aborted", "AbortError"));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === "" && $41a5128afd572ffa$var$g.location.href ? $41a5128afd572ffa$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if ($41a5128afd572ffa$var$support.blob) xhr.responseType = "blob";
            else if ($41a5128afd572ffa$var$support.arrayBuffer) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof $41a5128afd572ffa$export$79b704688b15c0f4 || $41a5128afd572ffa$var$g.Headers && init.headers instanceof $41a5128afd572ffa$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($41a5128afd572ffa$var$normalizeName(name));
                xhr.setRequestHeader(name, $41a5128afd572ffa$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
$41a5128afd572ffa$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$41a5128afd572ffa$var$g.fetch) {
    $41a5128afd572ffa$var$g.fetch = $41a5128afd572ffa$export$e7aa7bc5c1b3cfb3;
    $41a5128afd572ffa$var$g.Headers = $41a5128afd572ffa$export$79b704688b15c0f4;
    $41a5128afd572ffa$var$g.Request = $41a5128afd572ffa$export$7fa6c5b6f8193917;
    $41a5128afd572ffa$var$g.Response = $41a5128afd572ffa$export$9f633d56d7ec90d3;
}

});



parcelRegister("7ppL5", function(module, exports) {

$parcel$export(module.exports, "Configuration", function () { return $a5069f5ccce04c6b$export$fa89be98fe0936f2; });
// tslint:disable
/**
 * Ryddm API
 * Ryddm API.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ class $a5069f5ccce04c6b$export$fa89be98fe0936f2 {
    constructor(param = {}){
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.accessToken = param.accessToken;
        this.basePath = param.basePath;
    }
}

});


parcelRegister("cJvLm", function(module, exports) {

var $aVwRw = parcelRequire("aVwRw");

var $bHI1v = parcelRequire("bHI1v");

var $hgzUM = parcelRequire("hgzUM");

var $2UEyU = parcelRequire("2UEyU");

var $gfEo4 = parcelRequire("gfEo4");

var $6UAL8 = parcelRequire("6UAL8");

var $fvgno = parcelRequire("fvgno");

var $Nc6lr = parcelRequire("Nc6lr");

var $bhkER = parcelRequire("bhkER");

var $whwjs = parcelRequire("whwjs");

var $8daht = parcelRequire("8daht");

var $I1WkL = parcelRequire("I1WkL");

var $iXWCl = parcelRequire("iXWCl");

var $3wAMG = parcelRequire("3wAMG");

var $034CO = parcelRequire("034CO");

var $kdViD = parcelRequire("kdViD");

var $lBLhK = parcelRequire("lBLhK");

var $1uGI4 = parcelRequire("1uGI4");

var $boi6x = parcelRequire("boi6x");

var $8wAqI = parcelRequire("8wAqI");

var $8xb3v = parcelRequire("8xb3v");

var $3Q8Dc = parcelRequire("3Q8Dc");
$parcel$exportWildcard(module.exports, $aVwRw);
$parcel$exportWildcard(module.exports, $bHI1v);
$parcel$exportWildcard(module.exports, $hgzUM);
$parcel$exportWildcard(module.exports, $2UEyU);
$parcel$exportWildcard(module.exports, $gfEo4);
$parcel$exportWildcard(module.exports, $6UAL8);
$parcel$exportWildcard(module.exports, $fvgno);
$parcel$exportWildcard(module.exports, $Nc6lr);
$parcel$exportWildcard(module.exports, $bhkER);
$parcel$exportWildcard(module.exports, $whwjs);
$parcel$exportWildcard(module.exports, $8daht);
$parcel$exportWildcard(module.exports, $I1WkL);
$parcel$exportWildcard(module.exports, $iXWCl);
$parcel$exportWildcard(module.exports, $3wAMG);
$parcel$exportWildcard(module.exports, $034CO);
$parcel$exportWildcard(module.exports, $kdViD);
$parcel$exportWildcard(module.exports, $lBLhK);
$parcel$exportWildcard(module.exports, $1uGI4);
$parcel$exportWildcard(module.exports, $boi6x);
$parcel$exportWildcard(module.exports, $8wAqI);
$parcel$exportWildcard(module.exports, $8xb3v);
$parcel$exportWildcard(module.exports, $3Q8Dc);

});
parcelRegister("aVwRw", function(module, exports) {

$parcel$export(module.exports, "AlertCard", function () { return (parcelRequire("brwRj")).AlertCard; });
$parcel$export(module.exports, "AlertModal", function () { return (parcelRequire("hn85R")).AlertModal; });
parcelRequire("jIG3J");
var $brwRj = parcelRequire("brwRj");
var $hn85R = parcelRequire("hn85R");

var $h7gla = parcelRequire("h7gla");

var $6tPng = parcelRequire("6tPng");
$parcel$exportWildcard(module.exports, $h7gla);
$parcel$exportWildcard(module.exports, $6tPng);

});
parcelRegister("jIG3J", function(module, exports) {

$parcel$export(module.exports, "AlertCard", function () { return (parcelRequire("brwRj")).AlertCard; });
$parcel$export(module.exports, "AlertModal", function () { return (parcelRequire("hn85R")).AlertModal; });

var $brwRj = parcelRequire("brwRj");

var $hn85R = parcelRequire("hn85R");

});
parcelRegister("brwRj", function(module, exports) {

$parcel$export(module.exports, "AlertCard", function () { return $355ef5fb953181b5$export$15f660e0f0f2d11f; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("cJvLm");
var $h7gla = parcelRequire("h7gla");

var $c2KsG = parcelRequire("c2KsG");
const $355ef5fb953181b5$export$15f660e0f0f2d11f = ({ alertMessage: alertMessage, onTimeout: onTimeout, onCloseClick: onCloseClick })=>{
    const theme = (0, $iwq56.u)();
    const { type: type, message: message } = alertMessage;
    const isInfoMessage = type === (0, $h7gla.AlertMessageType).Info;
    const isWarnMessage = type === (0, $h7gla.AlertMessageType).Warn;
    const isErrorMessage = type === (0, $h7gla.AlertMessageType).Error;
    (0, $bh6RR.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            onTimeout();
        }, 5000);
        return ()=>clearTimeout(timeoutId);
    });
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: [
            (0, $c2KsG.styles)(theme).card.main.shared,
            isInfoMessage && (0, $c2KsG.styles)(theme).card.main.info,
            isWarnMessage && (0, $c2KsG.styles)(theme).card.main.warn,
            isErrorMessage && (0, $c2KsG.styles)(theme).card.main.error,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $c2KsG.styles)(theme).card.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $c2KsG.styles)(theme).card.content.message,
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $c2KsG.styles)(theme).card.close.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $c2KsG.styles)(theme).card.close.button,
                    onClick: (e)=>onCloseClick(e),
                    type: "button",
                    "aria-label": "close alert",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CrossCircle, {
                        css: (0, $c2KsG.styles)(theme).card.close.icon
                    })
                })
            })
        ]
    });
};
$355ef5fb953181b5$export$15f660e0f0f2d11f.propTypes = {};

});
parcelRegister("j8bpm", function(module, exports) {

$parcel$export(module.exports, "cards", function () { return (parcelRequire("jwfyL")).cards; });
$parcel$export(module.exports, "icons", function () { return (parcelRequire("bq9l8")).icons; });
$parcel$export(module.exports, "logos", function () { return (parcelRequire("9uBbu")).logos; });

var $jwfyL = parcelRequire("jwfyL");

var $bq9l8 = parcelRequire("bq9l8");

var $9uBbu = parcelRequire("9uBbu");

});
parcelRegister("jwfyL", function(module, exports) {

$parcel$export(module.exports, "cards", function () { return $4bdc4d79880fe366$export$f9417f756858637d; });

var $jMOzA = parcelRequire("jMOzA");

var $90j5e = parcelRequire("90j5e");

var $KC5Q5 = parcelRequire("KC5Q5");

var $kAftw = parcelRequire("kAftw");

var $6gLI0 = parcelRequire("6gLI0");

var $6DMPP = parcelRequire("6DMPP");

var $jIs0h = parcelRequire("jIs0h");

var $4L2DP = parcelRequire("4L2DP");

var $dpTj6 = parcelRequire("dpTj6");
const $4bdc4d79880fe366$export$f9417f756858637d = {
    Amex: $jMOzA.default,
    Card: $90j5e.default,
    Diners: $KC5Q5.default,
    Discover: $kAftw.default,
    Eft: $6gLI0.default,
    Jcb: $6DMPP.default,
    Mastercard: $jIs0h.default,
    UnionPay: $4L2DP.default,
    Visa: $dpTj6.default
};

});
parcelRegister("jMOzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13ca9ae53ca5fa3e$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $13ca9ae53ca5fa3e$var$SvgAmex = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#26A6D1",
                d: "M1 254c0-79.354 0-158.708.227-238.19C6.179 10.012 11.065 4.54 18.32 1.969c.007-.002-.21-.632-.321-.969 1.389 0 2.778 0 4.945.2 2.581.4 4.385.774 6.19.775 114.519.027 229.038.03 343.558-.017 2.103 0 4.205-.625 6.307-.958 1.389 0 2.778 0 4.244.255.687.76 1.22 1.46 1.92 1.742 6.241 2.513 11.33 6.256 14.113 12.643.135.311 1.129.249 1.723.36 0 79.02 0 158.042-.22 237.173a897.575 897.575 0 0 0-12.342 12.246c-.004.004.367.38.562.581-125.354 0-250.708 0-376.19-.22-3.55-4.088-6.956-7.968-10.425-11.793-.206-.227-.912-.002-1.385.013m360.865-93.365-25.44-25.741 39.032-40.048c-1.385-.332-1.975-.596-2.566-.597-16.333-.027-32.667-.101-48.998.077-1.716.018-3.845 1.159-5.04 2.46-3.146 3.428-5.883 7.231-9.061 11.234-4.642-4.79-7.454-8.108-10.721-10.891-1.712-1.458-4.22-2.787-6.375-2.797-36.666-.169-73.332-.087-109.999-.184-2.936-.008-4.51.93-5.702 3.589-2.498 5.567-5.317 10.989-8.356 17.186-3.052-6.058-5.855-11.168-8.214-16.476-1.404-3.158-3.187-4.403-6.774-4.33-12.162.246-24.331.094-36.498.093h-5.8l-.624 7.244c-2.619-7.733-8.503-7.517-14.734-7.314-8.657.282-17.335.22-25.995-.005-3.299-.085-4.986.957-6.456 3.996-11.671 24.126-23.556 48.15-35.354 72.214-.637 1.3-1.09 2.689-1.85 4.592 14.566 0 28.537-.112 42.505.081 3.355.047 5.292-.874 6.319-4.12.697-2.203 1.81-4.296 2.917-6.342.506-.935 1.409-2.285 2.196-2.33 3.816-.22 7.868-.785 11.395.262 1.82.54 2.735 4.173 4.021 6.43.41.72.824 1.477 1.023 2.27.798 3.17 2.854 3.847 5.934 3.815 14.498-.15 28.999-.059 43.499-.08 1.27-.002 2.542-.195 3.888-.306l.897-6.287 1.186-1.166c.685 8.13 5.699 8.218 11.17 7.82 3.482-.252 7.026-.334 10.49.02 5.466.557 9.882-.235 11.402-6.454.036-.145.567-.17 1.134-.321l.8 6.431c.972.102 1.777.259 2.583.26 34 .013 68 .052 101.998-.087 1.9-.008 4.107-1.116 5.63-2.37 3.69-3.033 7.06-6.455 11.163-10.283 2.741 3.016 5.332 5.6 7.606 8.439 2.725 3.401 6.003 4.497 10.372 4.424 14.496-.243 28.998-.048 43.498-.046 1.55 0 3.1-.166 4.649-.255l1.124-1.706a2765.876 2765.876 0 0 1-13.874-12.401z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#20AFDF",
                d: "M378.531 1c-1.633.333-3.735.957-5.838.958-114.52.047-229.04.044-343.559.017-1.804 0-3.608-.375-5.773-.775C141.354 1 259.708 1 378.531 1z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M401 15.527c-.594.362-1.588.424-1.723.113-2.783-6.387-7.872-10.13-14.113-12.643-.7-.282-1.233-.982-1.504-1.742C389.587 1 395.173 1 401 1v14.527zM17.53 1c.582.337.798.967.79.969-7.255 2.57-12.14 8.043-17.093 13.372C1 10.401 1 5.801 1 1h16.53zM389.48 266c-.675-.202-1.046-.577-1.042-.581 4.024-4.062 8.072-8.099 12.341-11.778.221 4.281.221 8.203.221 12.359h-11.52zM1 254.48c.473-.495 1.179-.72 1.385-.493 3.469 3.825 6.876 7.705 9.956 11.793C8.408 266 4.816 266 1 266v-11.52z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FAFDFE",
                d: "M362.114 160.885a5223.48 5223.48 0 0 0 13.625 12.151l-1.124 1.706c-1.55.089-3.1.255-4.649.255-14.5-.002-29.002-.197-43.498.046-4.37.073-7.647-1.023-10.372-4.424-2.274-2.838-4.865-5.423-7.606-8.439-4.102 3.828-7.473 7.25-11.162 10.284-1.524 1.253-3.73 2.361-5.63 2.37-34 .138-68 .1-102 .085-.805 0-1.61-.157-2.582-.259l-.8-6.431c-.567.152-1.098.176-1.134.32-1.52 6.22-5.936 7.012-11.402 6.454-3.464-.353-7.008-.271-10.49-.018-5.471.397-10.485.308-11.17-7.82l-1.186 1.165-.897 6.287c-1.346.11-2.617.304-3.888.306-14.5.021-29-.07-43.5.08-3.079.032-5.135-.646-5.933-3.814-.2-.794-.613-1.551-1.023-2.271-1.286-2.257-2.202-5.89-4.02-6.43-3.528-1.047-7.58-.483-11.396-.263-.787.046-1.69 1.396-2.196 2.331-1.107 2.046-2.22 4.139-2.917 6.343-1.027 3.245-2.964 4.166-6.32 4.12-13.967-.194-27.938-.082-42.505-.082.761-1.903 1.214-3.293 1.851-4.592 11.798-24.065 23.683-48.088 35.354-72.214 1.47-3.039 3.157-4.081 6.456-3.996 8.66.224 17.338.287 25.995.005 6.231-.203 12.115-.419 14.734 7.314l.624-7.244h5.8c12.167 0 24.336.153 36.498-.093 3.587-.073 5.37 1.172 6.774 4.33 2.36 5.308 5.162 10.418 8.214 16.476 3.039-6.197 5.858-11.62 8.356-17.186 1.193-2.66 2.766-3.597 5.702-3.59 36.667.098 73.333.016 109.999.185 2.155.01 4.663 1.34 6.375 2.797 3.267 2.783 6.079 6.102 10.721 10.891 3.178-4.003 5.915-7.806 9.062-11.234 1.194-1.301 3.323-2.442 5.039-2.46 16.331-.178 32.665-.104 48.998-.077.59.001 1.181.265 2.566.597l-39.032 40.048c8.642 8.743 17.04 17.242 25.69 25.991m-238.127-53.15v50.149c-1.614-1.07-2.352-2.287-2.967-3.564-5.123-10.646-10.197-21.315-15.341-31.95-2.606-5.386-4.027-12.842-8.353-15.488-4.533-2.772-11.916-.728-18.031-1.13-3.507-.23-5.288 1.031-6.782 4.219-7.697 16.42-15.656 32.718-23.5 49.069-.605 1.26-1.033 2.604-1.78 4.515 2.441 0 4.29-.276 6.03.047 7.96 1.48 12.987-1.437 14.863-9.45.714-3.053 2.894-3.531 5.686-3.466 6.327.147 12.725.61 18.974-.104 7.125-.815 11.232 1.527 13.197 8.437.491 1.73 2.497 4.251 3.89 4.306 9.61.378 19.243.2 29.54.2v-42.923c6.76 11.455 12.956 22.857 18.095 34.716 2.795 6.45 6.248 9.273 13.39 8.423 3.447-.41 5.29-1.37 6.754-4.442 5.655-11.866 11.533-23.626 17.356-35.411.608-1.232 1.408-2.369 2.118-3.55l.823.272v42.621h14.822v-57.395c-7.776 0-15.242-.16-22.689.153-1.284.053-2.932 1.882-3.646 3.282-3.253 6.37-6.232 12.88-9.311 19.337-2.444 5.126-4.892 10.25-7.75 16.24-6.396-12.366-12.245-23.74-18.182-35.067-.732-1.397-1.927-3.638-2.915-3.642-8.046-.033-16.094.373-24.29 1.596m122.512-1.921H227.4v57.342c1.085.157 1.889.374 2.693.375 18.483.023 36.966.114 55.446-.106 1.996-.024 4.309-1.507 5.894-2.95 5.62-5.118 10.99-10.512 16.613-15.955 5.691 5.69 10.955 10.998 16.282 16.241 1.041 1.025 2.295 2.515 3.507 2.57 5.895.268 11.81.121 17.718.121l.496-1.186-28.878-28.305 29.316-28.147c-5.012 0-8.833.266-12.6-.07-4.353-.39-7.511 1.06-10.485 4.245-4.718 5.053-9.875 9.698-15.437 15.089-4.779-5.024-9.323-9.426-13.411-14.218-3.29-3.856-6.942-5.351-12.091-5.173-11.642.403-23.307.127-35.962.127z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#2AA8D2",
                d: "M124.063 107.26c8.122-.748 16.17-1.154 24.216-1.12.988.003 2.183 2.244 2.915 3.64 5.937 11.328 11.786 22.702 18.181 35.068 2.86-5.99 5.307-11.114 7.75-16.24 3.08-6.458 6.059-12.968 9.312-19.337.714-1.4 2.362-3.229 3.646-3.282 7.447-.313 14.913-.153 22.689-.153v57.395H197.95V120.61l-.823-.271c-.71 1.18-1.51 2.317-2.118 3.549-5.823 11.785-11.701 23.545-17.356 35.41-1.464 3.073-3.307 4.032-6.755 4.443-7.141.85-10.594-1.973-13.39-8.423-5.138-11.86-11.334-23.26-18.093-34.716v42.922c-10.298 0-19.93.18-29.542-.199-1.392-.055-3.398-2.576-3.89-4.306-1.964-6.91-6.07-9.252-13.196-8.437-6.25.715-12.647.25-18.974.104-2.792-.065-4.972.413-5.686 3.466-1.876 8.013-6.903 10.93-14.864 9.45-1.738-.323-3.588-.047-6.03-.047.748-1.91 1.176-3.255 1.78-4.515 7.845-16.351 15.804-32.649 23.5-49.07 1.495-3.187 3.276-4.448 6.783-4.217 6.115.401 13.498-1.643 18.03 1.13 4.327 2.645 5.748 10.101 8.354 15.487 5.144 10.635 10.218 21.304 15.341 31.95.615 1.277 1.353 2.494 2.967 3.564 0-16.716 0-33.433.075-50.624m-39.499 31.508h11.948l-10.674-23.256-10.614 23.256h9.34z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#2CA8D2",
                d: "M247 105.814c12.156 0 23.821.276 35.463-.127 5.149-.178 8.8 1.317 12.09 5.173 4.09 4.792 8.633 9.194 13.412 14.218 5.562-5.391 10.72-10.036 15.437-15.09 2.974-3.184 6.132-4.633 10.485-4.244 3.767.336 7.588.07 12.6.07l-29.316 28.147 28.878 28.305-.496 1.186c-5.908 0-11.823.147-17.718-.12-1.212-.056-2.466-1.546-3.507-2.57-5.327-5.244-10.59-10.551-16.282-16.242-5.624 5.443-10.993 10.837-16.613 15.954-1.585 1.444-3.898 2.927-5.894 2.95-18.48.22-36.963.13-55.446.107-.804-.001-1.608-.218-2.693-.375v-57.342H247m44.03 21.677c-5.724-7.956-13.214-10.958-23.136-9.87-8.182.898-16.541.184-25.05.184v10.5h33.104v11.938h-33.429c0 2.277.171 3.948-.033 5.572-.552 4.39.82 6.2 5.667 5.999 9.481-.393 18.991-.052 28.488-.174 1.718-.022 3.987-.256 5.046-1.332 5.244-5.325 10.168-10.967 15.898-17.258-1.454-1.215-3.75-3.135-6.554-5.56z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F4FAFD",
                d: "M84.091 138.768h-8.867l10.614-23.256 10.674 23.256h-12.42z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FAFDFE",
                d: "M291.284 127.743c2.55 2.172 4.847 4.092 6.301 5.307-5.73 6.291-10.654 11.933-15.898 17.258-1.06 1.076-3.328 1.31-5.046 1.332-9.497.122-19.007-.219-28.488.174-4.848.2-6.22-1.61-5.667-6 .204-1.623.033-3.294.033-5.571h33.429v-11.938h-33.103v-10.5c8.508 0 16.867.714 25.049-.184 9.922-1.088 17.412 1.914 23.39 10.122z"
            })
        ]
    });
var $13ca9ae53ca5fa3e$export$2e2bcd8739ae039 = $13ca9ae53ca5fa3e$var$SvgAmex;

});

parcelRegister("90j5e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1729fcaec5a85c2$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $c1729fcaec5a85c2$var$SvgCard = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#322A37",
                d: "M382 266c-.75 0-1.5 0-2.859-.265-2.12-.088-3.63.089-5.141.265-76.02 0-152.042 0-228.62-.165-.832-.055-1.106.055-1.38.165-41.02 0-82.042 0-123.522-.32-1.138-1.087-1.816-1.856-2.333-3.003.95-4.59 2.093-8.72-1.35-12.57-1.158-1.296-1.736-3.572-1.717-5.39.212-20.523.548-41.044.963-61.563.09-4.459.975-8.918.846-13.358-.1-3.394-1.828-6.772-1.747-10.131.127-5.242 1.262-10.453 1.808-15.693.985-9.466-1.975-18.351-4.287-27.31-.673-2.609-1.763-5.11-2.193-7.66 128.083-.002 255.698.003 383.313-.042 2.067-.001 4.133-.61 6.455-.942L401 108c0 45.688 0 91.375-.358 137.548-4.332 8.8-10.022 15.473-18.488 19.514-.163.078-.108.615-.154.938M39.907 154.001c44.368-.01 88.736-.002 133.103-.084 1.976-.004 3.95-.821 6.388-1.756 6.463-4.342 6.72-12.643.468-18.665a57.21 57.21 0 0 1-2.478-2.095c-.977-.133-1.953-.383-2.93-.384-44.422-.019-88.843-.025-133.265.025-1.397.002-2.794.617-4.18 1.613-.006.445-.011.889-.403 1.914-6.945 4.54-6.733 12.93.651 18.465.261.353.522.705.955 1.351.25-.106.501-.212 1.691-.384m317.464-22.61c-.643-.127-1.287-.365-1.93-.366-21.575-.022-43.15-.037-64.726.017-1.235.003-2.469.593-3.707 1.57-.009.439-.017.878-.426 1.851-1.62 1.522-3.24 3.044-5.59 4.831-.327.704-.935 1.406-.938 2.11-.057 15.071-.088 30.142.03 45.212.01 1.233 1.134 2.458 2.197 3.896 1.134 1.294 2.269 2.588 3.729 4.478.665-.002 1.33-.004 2.919-.17 23.025.065 46.05.13 69.517.755.974-.392 1.947-.783 3.12-1.684 1.147-1.296 2.295-2.592 4.219-4.118.396-.662 1.135-1.323 1.138-1.986.07-15.292.094-30.583-.02-45.874-.008-.98-1.213-1.95-2.399-3.308-1.501-1.534-3.003-3.067-4.629-5.242a38.528 38.528 0 0 1-2.504-1.972M72.186 188.72c4.52-3.34 4.7-8.123 2.877-12.503-.91-2.186-4.225-4.611-6.572-4.741-9.6-.53-19.246-.319-28.873-.17-4.653.072-7.28 2.844-7.774 7.405-.56 5.168.97 9.138 6.314 11.943.63.434 1.254 1.24 1.887 1.247 8.874.091 17.749.123 26.621-.005.788-.012 1.558-1.24 2.755-2.213.172.031.343.062.867.632a14.395 14.395 0 0 0 1.898-1.595m28.387-18.231c-.804.408-1.608.817-2.814 1.726-6.638 6.214-5.17 14.27 3.436 18.564.497.378.99 1.083 1.492 1.088 8.64.09 17.281.145 25.92.028.806-.01 1.595-1.229 2.982-2.282 8.106-3.074 9.25-11.107 2.34-18.566-.651.02-1.302.041-2.878.201-10.015-.073-20.03-.147-30.478-.76z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#312936",
                d: "M20 1c120.354 0 240.708 0 361.545.352 5.16 4.32 10.013 8.104 14.44 12.334 2.092 1.998 3.369 4.85 5.015 7.314 0 11.354 0 22.708-.26 34.513-.433.437-.606.425-.866.263-.342-.04-.597.07-1.232.197-1.141.01-1.902.003-2.961-.291-1.777-.419-3.255-.666-4.733-.666-126.576-.018-253.153-.02-379.73.024-1.733 0-3.467.608-5.538.945-.786.01-1.235.008-1.77-.156-.354-.062-.622.037-1.098.225-.478.26-.644.502-.98.852-.462.055-.647.074-.832.094 0-11.688 0-23.375.359-35.547 4.446-8.25 9.123-15.44 17.855-18.797.413-.159.53-1.086.786-1.656z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#EEC67A",
                d: "M401 59c0 14.688 0 29.375-.466 44.532-133.147.458-265.829.446-398.52-.03-.01-12.786-.016-25.107-.012-37.427.003-7.068.01-7.07 6.904-7.07C139.604 59.001 270.302 59 401 59z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#322832",
                d: "M9.999 109.002c.899 2.55 1.989 5.051 2.662 7.66 2.312 8.959 5.272 17.844 4.287 27.31-.546 5.24-1.681 10.45-1.808 15.693-.08 3.359 1.648 6.737 1.747 10.13.129 4.44-.755 8.9-.846 13.359-.415 20.519-.75 41.04-.963 61.562-.019 1.82.559 4.095 1.718 5.391 3.442 3.85 2.298 7.98.996 12.52-7.043-2.302-11.457-6.95-13.892-13.796-.266-.494-.507-.686-.88-1.123C2.306 246.92 1.653 246.46 1 246c0-.75 0-1.5.215-2.746.496-.688.692-.946 1.092-1.566.424-2.108.675-3.919.676-5.73.022-42.315.016-84.631.453-126.95 2.48-.004 4.521-.005 6.563-.006z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#ECC789",
                d: "m2.024 103.967 398.51.034c.466-.001.466.499.29.836-.236.452-.377.63-.345.67.147.185.343.332.521.493 0 0 0 .5-.433.551-1.764.013-3.095-.06-4.426-.06-130.074-.007-260.148-.01-390.222.011-1.64 0-3.28.325-4.919.498 0 0 0-.5.256-.911.426-.981.597-1.552.768-2.122z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#D6BB8D",
                d: "M2.015 103.502c-.162 1.035-.333 1.606-.76 2.337C1 90.312 1 74.625 1.466 58.464 134.953 57.994 267.977 57.997 401 58v.75c-130.698.251-261.396.252-392.094.254-6.895 0-6.901.003-6.904 7.07-.004 12.321.002 24.642.013 37.428z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#795F35",
                d: "M401 57.75c-133.023.247-266.047.244-399.535.246C1 58 1 57.5 1 57.25c.185-.27.37-.29 1.286-.29 133.393.027 266.053.033 398.714.04v.75z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#1D1429",
                d: "M1 107.25c1.64-.423 3.279-.747 4.919-.748 130.074-.021 260.148-.018 390.222-.01 1.331 0 2.662.072 4.426.31.433.198.433.698.433.948-.17.254-.34.259-1.23.258-133.072-.004-265.422-.003-398.021-.017C1.499 107.977 1 108 1 108v-.75z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#1B0519",
                d: "M401 56.75c-132.66.243-265.321.237-398.437.175-.395-.369-.23-.61.493-.853.451-.071.94-.082.94-.082.45.003.898.006 2.15.005 130.48-.011 260.156-.018 389.833-.026.76.007 1.522.013 2.898.008.615-.011 1.084-.052 1.084-.052l.78.056c.259.019.259.519.259.769z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M3.993 249.047c2.342 6.63 6.756 11.278 13.637 13.958 1.032.82 1.71 1.588 2.38 2.676C13.738 266 7.476 266 1 266v-19.531c.652-.01 1.305.45 2.092 1.467.325.833.58 1.017.901 1.111zM401 20.531c-1.646-1.996-2.923-4.847-5.015-6.845-4.427-4.23-9.28-8.014-13.972-12.334C388.261 1 394.523 1 401 1v19.531zM382.47 266c-.424-.323-.48-.86-.316-.938 8.466-4.041 14.156-10.714 18.488-19.045.358 6.574.358 13.164.358 19.983h-18.53zM19.53 1c.215.57.097 1.497-.316 1.656C10.482 6.012 5.805 13.203 1.359 20.985 1 14.409 1 7.819 1 1h18.53z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#48403E",
                d: "M1 108.469c0-.469.5-.492.754-.226.26.435.264.603.26 1.239-.004 44.48 0 88.491.003 132.503-.11.323-.306.581-.802.894C1 198.312 1 153.625 1 108.47z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3B353F",
                d: "M374.417 266c1.094-.176 2.605-.353 4.35-.265-1.156.265-2.545.265-4.35.265z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#D8B580",
                d: "M401 105.75c-.178.09-.374-.058-.521-.243-.032-.04.109-.218.345-.42.176-.087.176.413.176.663z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3B353F",
                d: "M144.25 266c.024-.11.298-.22.661-.165.089.165-.411.165-.661.165z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FDFCFD",
                d: "M365.01 190.003c-1.149 1.296-2.297 2.592-3.973 4.203-1.364.48-2.198.644-3.033.808-23.025-.064-46.05-.129-69.916-.236-1.361-.156-1.882-.27-2.404-.384-1.134-1.294-2.269-2.588-3.595-4.423-.25-17.34-.308-34.14-.367-50.941 1.62-1.523 3.24-3.045 5.53-4.818 24.695-.236 48.721-.222 72.747-.208 1.502 1.534 3.004 3.067 4.777 5.263.26 17.353.246 34.044.233 50.736z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FBFAFC",
                d: "M179.956 134.161c6.162 5.357 5.905 13.658-1.254 18.236-46.184.244-91.67.255-137.158.25-1.494 0-2.989-.171-4.483-.263-7.184-4.886-7.396-13.274.211-18.111 47.011-.326 93.36-.357 139.708-.373.992 0 1.984.17 2.976.261z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F5F2F5",
                d: "M100.998 189.988c-8.409-3.503-9.877-11.56-2.674-18.078 1.27-.497 1.976-.69 2.682-.883 10.015.073 20.03.147 30.854.297a33.9 33.9 0 0 1 2.285.358c6.695 6.823 5.55 14.856-3.31 18.024-10.447.156-20.142.22-29.837.282z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F5F3F5",
                d: "M37.978 189.84c-5.163-1.992-6.693-5.962-6.134-11.13.494-4.56 3.12-7.333 7.774-7.405 9.627-.149 19.274-.36 28.873.17 2.347.13 5.661 2.555 6.572 4.741 1.824 4.38 1.643 9.163-3.405 12.753l-1.723.807c-.171-.032-.342-.063-1.184-.035-10.705.072-20.739.086-30.773.099z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#342C3E",
                d: "M2.023 109.015c-.005-.169-.01-.337-.02-.758 132.345-.252 264.695-.253 397.512-.243-1.6.335-3.667.945-5.734.946-127.615.045-255.23.04-383.313.041l-7.276.005c-.681.001-1.169.009-1.169.009z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#19151C",
                d: "M179.911 133.829c-.947.241-1.939.07-2.93.071-46.35.016-92.698.047-139.516.082-.463-.438-.458-.882.01-1.656 47.144-.335 93.826-.34 140.507-.345.628.505 1.256 1.01 1.929 1.848z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#1A171E",
                d: "M359.937 133.684c-23.964.306-47.99.292-72.485.262-.461-.456-.453-.895.025-1.65 23.808-.322 47.147-.326 70.486-.33.637.465 1.275.931 1.974 1.718z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#010004",
                d: "M37.16 152.71c1.395-.234 2.89-.063 4.384-.063 45.487.005 90.974-.006 136.925-.003-1.51.452-3.483 1.27-5.459 1.273-44.367.082-88.735.075-133.804.104-.7.019-1.162.07-1.162.07-.26-.352-.522-.704-.883-1.382z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#39313C",
                d: "M177.685 131.69c-46.384.296-93.066.3-140.215.302.929-.333 2.326-.948 3.723-.95 44.422-.05 88.843-.044 133.265-.025.977 0 1.953.25 3.227.674z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#161318",
                d: "M365.397 189.888c-.375-16.577-.362-33.268-.352-50.429.645.505 1.85 1.475 1.857 2.454.115 15.29.09 30.582.02 45.874-.002.663-.741 1.324-1.525 2.1z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#1E1821",
                d: "M281.357 139.162c.424 16.668.482 33.468.504 50.705-.643-.793-1.767-2.018-1.776-3.251-.12-15.07-.088-30.14-.03-45.211.002-.705.61-1.407 1.302-2.243z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3B353F",
                d: "M357.667 131.678c-23.043.292-46.382.296-70.188.287.767-.33 2-.92 3.236-.923 21.575-.054 43.15-.039 64.726-.017.643 0 1.287.239 2.226.653z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#261F27",
                d: "M38.068 190.246c9.944-.42 19.978-.433 30.473-.35-.317.76-1.087 1.987-1.875 1.999-8.872.128-17.747.096-26.62.005-.634-.006-1.259-.813-1.978-1.654zM101.096 190.383c9.597-.458 19.292-.52 29.445-.48-.339.762-1.128 1.98-1.935 1.991-8.638.117-17.28.061-25.919-.028-.501-.005-.995-.71-1.59-1.483zM100.79 170.757c-.49.463-1.196.656-2.265.903.44-.355 1.244-.764 2.264-.903z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#18101D",
                d: "M358.225 195.295c.614-.445 1.448-.61 2.712-.835-.544.332-1.517.723-2.712.835z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#261F27",
                d: "M134.036 171.364c-.383.224-.875.13-1.713-.11.304-.167.955-.187 1.713.11zM70.112 190.045c.221-.455.62-.641 1.352-.824-.168.366-.672.73-1.352.824z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#18101D",
                d: "M285.847 194.692c.359-.184.88-.07 1.78.168-.287.126-.952.128-1.78-.168z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3B363D",
                d: "M38.13 154.238c-.086-.147.375-.198.607-.184-.02.12-.27.225-.607.184z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3D273B",
                d: "M395.68 55.682c-129.378.295-259.054.302-389.196.3 1.267-.334 3-.941 4.735-.942 126.576-.044 253.153-.042 379.73-.024 1.477 0 2.955.247 4.732.666zM399.874 55.776c.087.15-.382.19-.617.185.02-.114.275-.224.617-.185zM3.91 55.83c.086.16-.403.17-.647.153.025-.117.293-.216.647-.154z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#282432",
                d: "M2.015 109.482c.008-.467.496-.475.74-.473.244 42.318.25 84.634.228 126.95 0 1.81-.252 3.621-.676 5.73-.294-43.716-.297-87.728-.292-132.207z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#342C3E",
                d: "M3.9 248.83c-.228.123-.483-.061-.745-.564.238-.121.479.071.745.565z"
            })
        ]
    });
var $c1729fcaec5a85c2$export$2e2bcd8739ae039 = $c1729fcaec5a85c2$var$SvgCard;

});

parcelRegister("KC5Q5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33bf9c110bb78090$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $33bf9c110bb78090$var$SvgDiners = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#0079BE",
                d: "M1 255c0-80.688 0-161.376.288-242.232a419.034 419.034 0 0 0 9.616-10.352c.249-.277.074-.935.096-1.416 126.355 0 252.71 0 379.22.27 3.21 3.726 6.248 7.198 9.351 10.61.236.259.942.09 1.429.12 0 80.688 0 161.376-.29 242.233a418.18 418.18 0 0 0-9.627 10.353c-.247.275-.065.934-.083 1.414-126.355 0-252.71 0-379.22-.268-3.207-3.722-6.243-7.19-9.344-10.6-.24-.262-.947-.098-1.436-.132m106.243-72.755c18.075 26.648 42.918 40.508 75.413 40.09a1421.56 1421.56 0 0 1 35.986-.007c50.312.626 94.28-45.153 89.713-95.891-3.94-43.782-40.001-80.056-83.948-81.512-16.807-.557-33.66-.462-50.47.035-17.468.517-33.253 6.543-46.99 17.343-35.686 28.058-44.21 79.244-19.704 119.942z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M10.513 1c.465.481.64 1.139.391 1.416-3.073 3.427-6.209 6.8-9.616 9.885C1 8.418 1 4.836 1 1h9.513zM401 11.517c-.487.453-1.193.622-1.429.363-3.103-3.412-6.14-6.884-8.883-10.61C394.258 1 397.515 1 401 1v10.517zM1 255.483c.49-.449 1.197-.613 1.436-.35 3.101 3.408 6.137 6.877 8.876 10.599C7.742 266 4.485 266 1 266v-10.517zM391.487 266c-.47-.48-.65-1.14-.404-1.414 3.077-3.428 6.215-6.799 9.628-9.885.289 3.881.289 7.463.289 11.299h-9.513z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FCFDFE",
                d: "M107.074 181.925c-24.336-40.378-15.813-91.564 19.873-119.622 13.737-10.8 29.522-16.826 46.99-17.343 16.81-.497 33.663-.592 50.47-.035 43.947 1.456 80.007 37.73 83.948 81.512 4.567 50.738-39.4 96.517-89.713 95.891a1421.56 1421.56 0 0 0-35.986.007c-32.495.418-57.338-13.442-75.582-40.41m-5.444-47.44c.116 14.088 3.618 27.275 10.336 39.662 21.025 38.77 68.842 52.1 106.624 29.675 35.722-21.203 49.276-68.363 30.677-106.743-16.872-34.818-53.35-51.796-90.322-42.038-33.28 8.784-57.424 41.815-57.315 79.444z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#027ABE",
                d: "M101.613 133.992c-.092-37.136 24.052-70.167 57.332-78.951 36.972-9.758 73.45 7.22 90.322 42.038 18.599 38.38 5.045 85.54-30.677 106.743-37.782 22.425-85.6 9.095-106.624-29.675-6.718-12.387-10.22-25.574-10.353-40.155m122.952 20.97c14.62-33.803-8.18-64.131-26.855-68.886v95.118c12.364-5.42 21.002-13.837 26.855-26.231m-65.027 25.21c4.387 1.694 2.365-2.131 2.37-3.196.131-29.3.109-58.602.09-87.903 0-1.047-.22-2.094-.407-3.779-19.193 9.142-29.23 23.901-31.24 44.185-2.022 20.395 9.366 40.323 29.187 50.693z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F9FCFD",
                d: "M224.39 155.3c-5.678 12.057-14.316 20.474-26.68 25.894V86.076c18.675 4.755 41.475 35.083 26.68 69.224z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FDFEFE",
                d: "M159.177 180.028c-19.46-10.225-30.848-30.153-28.826-50.548 2.01-20.284 12.047-35.043 31.24-44.185.188 1.685.406 2.732.407 3.779.019 29.301.041 58.602-.09 87.903-.005 1.065 2.017 4.89-2.73 3.051z"
            })
        ]
    });
var $33bf9c110bb78090$export$2e2bcd8739ae039 = $33bf9c110bb78090$var$SvgDiners;

});

parcelRegister("kAftw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e649779c05e7e494$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $e649779c05e7e494$var$SvgDiscover = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#E0E6E8",
                d: "M1 249c0-76.688 0-153.375.299-230.218 1.44-1.341 2.476-2.658 3.744-3.69 4.37-3.55 6.928-9.238 13.06-10.8C19.272 3.992 20.044 2.136 21 1c118.02 0 236.042 0 354.199.314.662 1.084 1.216 2.538 1.71 2.518 4.267-.174 6.678 2.823 9.414 5.229 6.642 5.838 12.242 13.218 12.397 21.779.624 34.621.17 69.262-.233 103.948-1.337 1.453-2.329 2.855-3.47 4.574-1.366 2.05-2.582 3.78-3.795 5.512-17.455 24.937-41.133 42.73-67.57 56.716-19.042 10.074-38.82 18.923-58.797 27.015-16.169 6.55-33.057 11.374-49.756 16.542-10.414 3.222-21.038 5.786-31.626 8.412-10.9 2.703-21.868 5.127-32.809 7.666-6.886 1.598-13.776 3.184-20.664 4.775-36.02 0-72.042 0-108.201-.31-1.724-1.424-3.271-2.601-4.91-3.635-1.219-.77-2.85-1.077-3.787-2.072-2.965-3.148-5.595-6.613-8.573-9.748-.764-.804-2.33-.844-3.529-1.235m225.992-135.463c-9.501-7.882-20.308-8.684-31.121-4.175-14.056 5.861-20.467 21.973-13.29 36.093 5.254 10.339 21.432 18.423 36.271 12.679 9.874-3.822 15.826-10.596 17.518-20.765 1.542-9.265-1.507-17.244-9.378-23.832M52.977 158.463c9.705-2.049 17.57-10.927 19.305-21.795 1.725-10.796-2.862-20.265-11.89-25.659-9.672-5.78-20.236-3.809-30.55-3.923-.768-.008-2.227 2.297-2.24 3.538a2204.35 2204.35 0 0 0 .009 45.948c.013 1.185 1.578 3.38 2.4 3.37 7.448-.09 14.89-.567 22.966-1.48m299.805-3.571c3.612 5.61 9.322 7.065 15.936 3.995l-15.68-20.463c.86-.616 1.223-.954 1.65-1.16.443-.215.983-.232 1.42-.455 5.997-3.061 9.199-7.932 8.801-14.7-.376-6.394-2.967-11.97-9.725-13.227-8.14-1.513-16.49-1.888-25.005-2.782v53.702h10.365v-19.724l1.086-.18c3.564 4.808 7.128 9.616 11.152 14.994m-41.277-17.925c2.163 0 4.338-.148 6.486.035 3.202.272 4.41-.895 4.424-4.228.014-3.436-1.083-4.846-4.59-4.7-4.57.189-9.156.046-13.806.046v-12.415h18.696v-8.49H292.99v52.683h29.752v-8.803h-18.842v-14.128h7.604m-183.757 16.227c6.926-9.57 3.491-19.78-6.689-23.72-3.49-1.35-6.987-2.819-10.182-4.732-1.437-.86-3.092-3.068-2.914-4.438.184-1.406 2.395-3.45 3.878-3.595 2.95-.29 6.04.384 9.01.968 1.15.225 2.134 1.288 3.281 2.025l4.86-6.436c-5.299-5.597-11.523-6.784-18.363-6.25-7.47.585-12.851 5.605-14.098 13.29-1.071 6.6 2.331 11.703 9.645 14.64 3.486 1.4 7.139 2.596 10.268 4.588 1.606 1.022 3.299 3.773 3.02 5.412-.334 1.953-2.402 4.33-4.311 5.161-6.454 2.81-11.276-.565-15.604-5.656l-6.016 6c7.296 12.39 27.096 12.276 34.215 2.743m146.047-13.9 13.84-31.768c-8.585-1.62-11.346-.94-13.156 3.245-1.947 4.505-3.698 9.095-5.676 13.586-2.335 5.303-4.821 10.54-7.592 16.568-2.46-5.546-4.44-9.99-6.402-14.44-1.981-4.493-3.956-8.99-5.917-13.491-2.901-6.658-6.002-7.851-13.635-4.988 1.245 2.817 2.482 5.626 3.727 8.43 6.096 13.736 12.13 27.5 18.406 41.154.559 1.216 2.725 2.391 4.095 2.337 1.315-.053 3.094-1.458 3.752-2.74 2.9-5.644 5.47-11.46 8.558-17.893M149.873 109.26c-1.997 1.452-4.08 2.799-5.977 4.37-14.57 12.078-12.986 32.82 3.29 42.39 9.186 5.4 18.747 5.317 28.33 1.514v-10.862c-10.635 6.13-19.546 5.784-25.837-.728-5.566-5.761-6.519-14.554-2.51-21.387 2.99-5.1 7.517-8.352 13.158-8.28 5.157.065 10.29 1.937 15.468 3.02v-9.525c-8.434-4.598-16.769-5.13-25.922-.512m-68.16-2.43c-3.697-.566-4.939.952-4.885 4.715.189 13.33.073 26.664.073 39.997 0 9.641 0 9.645 9.86 8.301.282-.038.528-.34.903-.596v-52.126c-1.85-.105-3.488-.199-5.95-.292z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FF6E02",
                d: "M130.469 266c6.42-1.591 13.309-3.177 20.195-4.775 10.94-2.54 21.91-4.963 32.81-7.666 10.587-2.626 21.211-5.19 31.625-8.412 16.7-5.168 33.587-9.993 49.756-16.542 19.978-8.092 39.755-16.941 58.797-27.015 26.437-13.986 50.115-31.779 67.57-56.716 1.213-1.732 2.43-3.462 4.169-5.4.883 1.655 1.547 3.514 1.551 5.375.067 27.53.025 55.062.093 82.593.005 1.886.673 3.77 1.005 6.083-.072 11.66-8.23 23.579-18.205 27.68-1.94.798-3.24 3.156-4.835 4.795H130.469z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M375.469 266c1.126-1.639 2.426-3.997 4.366-4.795 9.975-4.101 18.133-16.02 18.57-27.926.404-33.298.416-65.921.428-98.544.056-34.633.511-69.274-.113-103.895-.155-8.56-5.755-15.94-12.397-21.78-2.736-2.405-5.147-5.402-9.415-5.228-.493.02-1.047-1.434-1.24-2.518C384.322 1 392.644 1 400.958 1c-.007 88.333-.007 176.667-.007 265H375.47zM1 249.47c1.198-.079 2.765-.039 3.529.765 2.978 3.135 5.608 6.6 8.573 9.748.937.995 2.568 1.302 3.788 2.072 1.638 1.034 3.185 2.21 4.44 3.635C14.414 266 7.828 266 1 266v-16.53zM20.531 1c-.487 1.137-1.259 2.993-2.428 3.291-6.132 1.563-8.69 7.25-13.06 10.802-1.268 1.03-2.304 2.348-3.744 3.22C1 12.402 1 6.804 1 1h19.531z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FE7005",
                d: "M227.286 113.745c7.577 6.38 10.626 14.36 9.084 23.624-1.692 10.17-7.644 16.943-17.518 20.765-14.84 5.744-31.017-2.34-36.271-12.679-7.177-14.12-.766-30.232 13.29-36.093 10.813-4.51 21.62-3.707 31.415 4.383z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#0D0D0D",
                d: "M52.661 158.737c-7.76.638-15.202 1.115-22.65 1.205-.822.01-2.387-2.185-2.4-3.37a2204.35 2204.35 0 0 1-.008-45.948c.012-1.24 1.471-3.546 2.238-3.538 10.315.114 20.879-1.857 30.552 3.923 9.027 5.394 13.614 14.863 11.89 25.659-1.736 10.868-9.6 19.746-19.622 22.07m2.786-38.788c-4.459-1.39-8.88-2.927-13.393-4.108-2.341-.613-3.746.553-3.734 3.207.043 9.629-.072 19.26.136 28.885.024 1.11 1.791 3.183 2.585 3.106 3.893-.378 8.044-.638 11.527-2.214 10.59-4.793 12.975-20 2.88-28.876z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#0B0B0B",
                d: "M352.552 154.606a7415.313 7415.313 0 0 1-10.922-14.71l-1.086.18v19.725h-10.365v-53.702c8.515.894 16.866 1.27 25.005 2.782 6.758 1.257 9.35 6.833 9.725 13.228.398 6.767-2.804 11.638-8.8 14.699-.438.223-.978.24-1.421.454-.427.207-.79.545-1.65 1.161l15.68 20.463c-6.614 3.07-12.324 1.615-16.166-4.28m-3.256-37.619c-1.935-.419-3.898-1.24-5.794-1.106-1.14.081-3.031 1.586-3.107 2.565-.34 4.385-.148 8.812-.148 13.278 5.425.5 10.194.072 12.35-4.453 1.576-3.306 1.488-7.494-3.301-10.284z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#101010",
                d: "M311.016 136.966h-7.115v14.128h18.842v8.803h-29.752v-52.684h29.724v8.491h-18.696v12.415c4.65 0 9.235.143 13.807-.046 3.506-.146 4.603 1.264 4.589 4.7-.014 3.333-1.222 4.5-4.424 4.228-2.148-.183-4.323-.035-6.975-.035z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#0D0D0D",
                d: "M127.491 153.456c-6.862 9.27-26.662 9.383-33.958-3.006l6.016-6c4.328 5.09 9.15 8.466 15.604 5.656 1.91-.831 3.977-3.208 4.31-5.16.28-1.64-1.413-4.391-3.019-5.413-3.13-1.992-6.782-3.188-10.268-4.588-7.314-2.937-10.716-8.04-9.645-14.64 1.247-7.685 6.627-12.705 14.098-13.29 6.84-.534 13.064.653 18.363 6.25l-4.86 6.436c-1.147-.737-2.131-1.8-3.28-2.025-2.972-.584-6.06-1.257-9.011-.968-1.483.146-3.694 2.189-3.878 3.595-.178 1.37 1.477 3.578 2.914 4.438 3.195 1.913 6.692 3.382 10.182 4.732 10.18 3.94 13.615 14.15 6.432 23.983zM273.595 139.633c-2.889 6.093-5.458 11.909-8.358 17.554-.658 1.281-2.437 2.686-3.752 2.739-1.37.054-3.536-1.12-4.095-2.337-6.276-13.653-12.31-27.418-18.406-41.153-1.245-2.805-2.482-5.614-3.727-8.431 7.633-2.863 10.734-1.67 13.635 4.988 1.961 4.502 3.936 8.998 5.917 13.491 1.963 4.45 3.942 8.894 6.402 14.44 2.77-6.028 5.257-11.265 7.592-16.568 1.978-4.491 3.729-9.081 5.676-13.586 1.81-4.186 4.571-4.865 13.156-3.245a8691.678 8691.678 0 0 1-14.04 32.108z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#0F0F10",
                d: "M150.237 109.145c8.79-4.503 17.124-3.97 25.558.627v9.525c-5.178-1.083-10.311-2.955-15.468-3.02-5.64-.072-10.168 3.18-13.159 8.28-4.008 6.833-3.055 15.626 2.51 21.387 6.292 6.512 15.203 6.858 25.838.728v10.862c-9.583 3.803-19.144 3.887-28.33-1.514-16.276-9.57-17.86-30.312-3.29-42.39 1.896-1.571 3.98-2.918 6.34-4.485z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#161617",
                d: "M82.126 106.83c2.05.092 3.688.186 5.538.29v52.127c-.375.256-.621.558-.903.596-9.86 1.344-9.86 1.34-9.86-8.3 0-13.334.116-26.668-.073-39.998-.054-3.763 1.188-5.281 5.298-4.716z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F9852C",
                d: "M398.487 134.788c.334 32.57.322 65.193-.055 98.062-.724-1.638-1.392-3.522-1.397-5.408-.068-27.531-.026-55.062-.093-82.593-.004-1.861-.668-3.72-1.4-5.693.616-1.513 1.608-2.915 2.945-4.368z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#D6DBDE",
                d: "M55.772 120.135c9.77 8.69 7.387 23.898-3.204 28.69-3.483 1.577-7.634 1.837-11.527 2.215-.794.077-2.561-1.996-2.585-3.106-.208-9.625-.093-19.256-.136-28.885-.012-2.654 1.393-3.82 3.734-3.207 4.514 1.181 8.934 2.718 13.718 4.293z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#CFD4D7",
                d: "M349.702 117.096c4.383 2.681 4.47 6.869 2.895 10.175-2.156 4.525-6.925 4.953-12.35 4.453 0-4.466-.191-8.893.148-13.278.076-.98 1.968-2.484 3.107-2.565 1.896-.134 3.86.687 6.2 1.215z"
            })
        ]
    });
var $e649779c05e7e494$export$2e2bcd8739ae039 = $e649779c05e7e494$var$SvgDiscover;

});

parcelRegister("6gLI0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15b4775d7029a00e$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $15b4775d7029a00e$var$SvgEft = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#8D1339",
                d: "M1 251c0-79.021 0-158.043.347-237.436C5.805 9.775 9.936 6.381 14.003 2.912c.507-.433.673-1.265.997-1.912 124.355 0 248.71 0 373.45.353 3.877 4.267 7.348 8.199 10.884 12.07.349.381 1.101.394 1.666.577 0 79.688 0 159.376-.352 239.44-3.828 5.059-7.52 9.472-13.435 11.24-.186.056-.147.863-.213 1.32-123.688 0-247.376 0-371.442-.353-5.548-4.017-10.527-7.842-12.923-14.068-.135-.35-1.071-.393-1.635-.579M257.53 30.073c-7.378 9.024-10.524 19.517-10.557 31.015-.048 16.655.004 33.31.068 49.965.01 2.652.018 5.358.51 7.948 4.145 21.815 20.807 35.772 43.36 35.904 31.643.185 63.288.051 94.932.042 1.129 0 2.257-.132 3.594-.215v-38.414h-100.97c0-6.874.313-13.185-.1-19.448-.32-4.843 1.578-5.816 6.021-5.79 28.312.17 56.626.097 84.94.053 7.054-.011 9.67-2.6 9.745-9.592.084-7.827.036-15.656.022-23.484-.044-24.69-19.34-44.047-44.084-44.142-16.82-.064-33.644-.152-50.463.032-14.256.157-26.688 4.94-37.017 16.126M223.779 238.23c.74-1.101 1.834-2.106 2.162-3.319 2.512-9.295 5.402-18.535 7.11-27.985 1.255-6.939-3.63-11.798-10.806-11.955-8.32-.182-16.648-.068-24.973-.045-8.993.025-13.918 3.744-16.315 12.319-4.12 14.73-8.219 29.464-12.307 44.202-.383 1.38-.63 2.8-1.042 4.669 2.965 0 5.491-.308 7.912.067 4.44.689 6.362-.935 7.487-5.36 3.193-12.562 6.862-25.006 10.526-37.442.498-1.689 1.974-4.327 3.112-4.389 7.383-.398 14.798-.204 22.758-.204-1.626 6.06-3.16 11.304-4.41 16.615-.745 3.158-2.467 4.37-5.644 4.285-5.29-.142-10.588-.039-16.091-.039l-3.449 13.811c7.7 0 14.742.541 21.644-.206 4.053-.438 7.885-2.925 12.326-5.024m-131.29 5.384h14.245l3.393-12.972H72.173c.778-8.146 1.81-9.152 8.684-9.111 6.663.04 13.326.1 19.989.145 13.06.087 14.396-1.182 15.212-14.42.49-7.94-3.29-12.287-11.323-12.49a552.988 552.988 0 0 0-25.485-.068c-8.168.17-13.026 4.02-15.247 11.854a586.4 586.4 0 0 0-5.468 20.746c-2.388 9.77 2.42 16.031 12.469 16.243 6.827.144 13.659.055 21.486.073m209.028 0c7.489-.016 14.978-.018 22.466-.052 12.059-.053 18.451-6.197 18.994-18.224.34-7.524-3.557-12.097-11.067-12.457-5.645-.27-11.314-.022-16.97-.09-1.73-.02-3.455-.324-5.12-.491-.283-4.188 1.645-5.184 4.86-5.15 8.654.091 17.309.087 25.961-.032 1.292-.018 3.415-.554 3.712-1.372 1.258-3.471 1.973-7.14 2.967-11.054-13.081 0-25.397-.31-37.69.1-9.56.318-15.335 7.868-14.856 18.25.361 7.828 5.49 11.831 15.325 11.897 5.912.04 11.825.007 17.824.007-.873 5.156-.872 5.225-5.344 5.244-10.435.043-20.87.014-31.442.014l-3.1 13.434c4.542 0 8.516 0 13.48-.024m-10.803-35.494c.67-8.379-3.225-12.944-11.663-13.147-8.322-.2-16.654-.068-24.981-.043-8.187.024-13.214 3.462-15.608 11.28a278.538 278.538 0 0 0-5.595 21.22c-2.139 9.645 2.503 15.642 12.418 15.997 7.983.287 15.993.26 23.978-.008 8.524-.288 13.409-4.34 15.711-12.722 1.981-7.214 3.694-14.501 5.74-22.577M146.82 184.23h5.956l2.963-12.545c-4.164 0-7.783-.011-11.402.002-9.438.033-14.602 3.866-17.093 12.774-4.788 17.121-9.542 34.252-14.305 51.38-.685 2.462-1.344 4.932-2.095 7.695h14.05c2.727-9.901 5.466-19.809 8.178-29.724.733-2.681 1.575-4.876 5.086-5.098 8.425-.534 8.424-.672 10.59-8.898.378-1.435.656-2.895 1.03-4.564l-10.71-.587c.379-8.147 1.463-9.696 7.752-10.435m21.573.8c-7.337.38-11.905 3.734-14.045 11.176-4.319 15.02-8.35 30.12-12.472 45.195-.155.566-.02 1.211-.02 2.245 3.23 0 6.223-.22 9.168.058 3.303.312 4.62-.98 5.395-4.165 1.766-7.265 3.968-14.424 6.034-21.614 2.475-8.615 2.494-8.602 11.644-8.785.802-.016 1.6-.214 2.554-.349l3.124-13.608h-10.77c.638-2.949 1.303-5.35 1.597-7.798.086-.716-.883-1.558-2.21-2.355z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M1 251.473c.564-.287 1.5-.245 1.635.106 2.396 6.226 7.375 10.051 12.455 14.068C10.406 266 5.813 266 1 266v-14.527zM14.526 1c.15.647-.016 1.48-.523 1.912-4.067 3.47-8.198 6.863-12.656 10.184C1 9.07 1 5.141 1 1h13.526zM387.474 266c-.408-.457-.447-1.264-.26-1.32 5.914-1.768 9.606-6.181 13.434-10.772.352 4.022.352 7.951.352 12.092h-13.526zM401 13.523c-.565.294-1.317.281-1.666-.1-3.536-3.871-7.007-7.803-10.415-12.07C392.926 1 396.852 1 401 1v12.523z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FEFDFE",
                d: "M257.771 29.808c10.089-10.922 22.52-15.704 36.777-15.86 16.819-.185 33.642-.097 50.463-.033 24.744.095 44.04 19.453 44.084 44.142.014 7.828.062 15.657-.022 23.484-.076 6.991-2.69 9.58-9.746 9.592-28.313.044-56.627.117-84.939-.052-4.443-.027-6.342.946-6.022 5.789.414 6.263.101 12.574.101 19.448h100.97v38.414c-1.337.083-2.465.215-3.594.215-31.644.01-63.289.143-94.932-.042-22.553-.132-39.215-14.09-43.36-35.904-.492-2.59-.5-5.296-.51-7.948-.064-16.655-.116-33.31-.068-49.965.033-11.498 3.179-21.99 10.798-31.28M327.5 64.13h19.427V51.227h-5.087c-14.294 0-28.59-.155-42.88.046-12.668.18-11.097-2.902-10.889 11.886.004.258.372.51.73.971H327.5z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FDFAFB",
                d: "M223.524 238.497c-4.186 1.832-8.018 4.319-12.071 4.757-6.902.747-13.944.206-21.644.206l3.449-13.81c5.503 0 10.8-.104 16.091.038 3.177.086 4.9-1.127 5.643-4.285 1.252-5.311 2.785-10.556 4.41-16.615-7.96 0-15.374-.194-22.757.204-1.138.062-2.614 2.7-3.112 4.39-3.664 12.435-7.333 24.879-10.526 37.44-1.125 4.426-3.046 6.05-7.487 5.361-2.42-.375-4.947-.067-7.912-.067.413-1.87.659-3.288 1.042-4.669 4.088-14.738 8.188-29.473 12.307-44.202 2.397-8.575 7.322-12.294 16.315-12.319 8.325-.023 16.653-.137 24.973.045 7.176.157 12.061 5.016 10.807 11.955-1.709 9.45-4.599 18.69-7.111 27.985-.328 1.213-1.423 2.218-2.417 3.586z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FCF8F9",
                d: "M91.991 243.613c-7.328-.017-14.16.072-20.987-.072-10.048-.212-14.857-6.473-12.469-16.243a586.4 586.4 0 0 1 5.468-20.746c2.221-7.835 7.079-11.684 15.247-11.854a552.988 552.988 0 0 1 25.485.068c8.033.203 11.813 4.55 11.323 12.49-.816 13.238-2.152 14.507-15.212 14.42-6.663-.044-13.326-.106-19.99-.145-6.873-.041-7.905.965-8.683 9.111h37.954l-3.393 12.972-14.743-.001m9.847-34.38c-1.18-.531-2.349-1.484-3.545-1.52-5.451-.165-10.913.031-16.366-.108-3.646-.093-5.14 1.491-4.772 5.38 7.13 0 14.223.128 21.301-.128 1.143-.041 2.224-1.786 3.382-3.625z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FCF9FA",
                d: "M301.023 243.626c-4.469.012-8.443.012-12.986.012l3.1-13.434c10.573 0 21.008.03 31.443-.014 4.472-.019 4.471-.088 5.344-5.244-6 0-11.912.033-17.824-.007-9.835-.066-14.964-4.07-15.325-11.897-.479-10.382 5.296-17.932 14.857-18.25 12.292-.41 24.608-.1 37.689-.1-.994 3.914-1.709 7.583-2.967 11.054-.297.818-2.42 1.354-3.712 1.372-8.652.119-17.307.123-25.96.032-3.216-.034-5.144.962-4.861 5.15 1.665.167 3.39.47 5.12.491 5.656.068 11.325-.18 16.97.09 7.51.36 11.406 4.933 11.067 12.457-.543 12.027-6.935 18.17-18.994 18.224-7.488.034-14.977.036-22.961.064z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FDFCFC",
                d: "M290.608 208.53c-1.939 7.666-3.652 14.953-5.633 22.167-2.302 8.381-7.187 12.434-15.71 12.722-7.986.269-15.996.295-23.98.008-9.914-.355-14.556-6.352-12.417-15.998a278.538 278.538 0 0 1 5.595-21.218c2.394-7.819 7.421-11.257 15.608-11.281 8.327-.025 16.659-.158 24.981.043 8.438.203 12.334 4.768 11.556 13.557m-38.49.932-5.726 19.487c8.089 0 15.027.087 21.959-.09 1.108-.027 2.87-1.013 3.166-1.931 1.892-5.857 3.457-11.82 5.186-17.945-8.726 0-16.318 0-24.585.479z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FCFAFA",
                d: "M146.387 184.231c-5.856.738-6.94 2.287-7.32 10.434l10.71.587c-.373 1.669-.651 3.13-1.03 4.564-2.165 8.226-2.164 8.364-10.59 8.898-3.51.222-4.352 2.417-5.085 5.098-2.712 9.915-5.451 19.823-8.177 29.724h-14.051c.751-2.763 1.41-5.233 2.095-7.696 4.763-17.127 9.517-34.258 14.305-51.379 2.491-8.908 7.655-12.741 17.093-12.774 3.619-.013 7.238-.002 11.402-.002l-2.963 12.545-6.39.001z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FCF9FA",
                d: "M168.813 185.036c.906.791 1.875 1.633 1.789 2.35-.294 2.446-.959 4.848-1.596 7.797h10.77l-3.125 13.608c-.954.135-1.752.333-2.554.349-9.15.183-9.169.17-11.644 8.785-2.066 7.19-4.268 14.35-6.034 21.614-.774 3.185-2.092 4.477-5.395 4.165-2.945-.278-5.938-.058-9.168-.058 0-1.034-.135-1.679.02-2.245 4.122-15.075 8.153-30.176 12.472-45.195 2.14-7.442 6.708-10.796 14.465-11.17z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#90183D",
                d: "M327 64.13h-38.2c-.357-.46-.725-.713-.729-.97-.208-14.79-1.779-11.708 10.89-11.887 14.29-.201 28.585-.046 42.879-.046h5.087V64.13H327z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#8F163B",
                d: "M101.814 209.673c-1.134 1.398-2.215 3.143-3.358 3.184-7.078.256-14.17.129-21.301.129-.368-3.89 1.126-5.474 4.772-5.381 5.453.14 10.915-.057 16.366.108 1.196.036 2.364.989 3.52 1.96z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#90183D",
                d: "M252.455 209.222c7.93-.239 15.522-.239 24.248-.239-1.729 6.125-3.294 12.088-5.186 17.945-.296.918-2.058 1.904-3.166 1.932-6.932.176-13.87.089-21.96.089 2.054-6.99 3.89-13.238 6.064-19.727z"
            })
        ]
    });
var $15b4775d7029a00e$export$2e2bcd8739ae039 = $15b4775d7029a00e$var$SvgEft;

});

parcelRegister("6DMPP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afca6e4e139c9dfb$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $afca6e4e139c9dfb$var$SvgJcb = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F3F3F3",
                d: "M1 250c0-79.021 0-158.043.28-237.24 3.422-3.355 6.596-6.501 9.658-9.753.344-.365.057-1.324.062-2.007 124.688 0 249.376 0 374.236.312 6.103 4.268 12.035 8.218 14.316 15.579.052.17.946.078 1.448.109 0 77.355 0 154.71-.306 232.237-3.826 4.552-7.298 8.972-10.895 13.287-1.09 1.307-2.523 2.326-3.799 3.476-123.021 0-246.043 0-369.238-.3-6.34-4.065-11.944-8.34-14.313-15.628-.053-.164-.947-.054-1.449-.072m101.863-82.234-26.294-3.272v68.329c16.778 0 33.239.098 49.696-.103 2.55-.032 5.23-1.13 7.602-2.259 13.153-6.26 19.09-17.136 19.112-31.342.082-52.825.038-105.65.027-158.477 0-1.455-.167-2.911-.291-4.955h-5.605c-12.332 0-24.69.513-36.989-.118-18.938-.972-33.681 13.88-33.813 32.944-.18 25.995-.1 51.993.059 77.988.01 1.546 1.416 4.09 2.674 4.46 7.913 2.32 15.878 5.173 24 5.902 10.606.953 16.749-5.755 16.863-16.45.1-9.497.026-18.996.028-28.495v-8.667h26.465c0 13.439.292 26.436-.087 39.414-.34 11.633-6.042 19.353-17.358 22.139-8.138 2.004-16.755 2.063-26.09 2.962M240 69.5V36.014c-17.175 0-33.838-.72-50.405.235-12.527.721-24.37 12.46-25.276 25.403-1.13 16.158-.271 32.455-.271 48.53 4.092-1.95 8.219-4.58 12.728-5.951 17.23-5.242 34.574-3.856 51.832.124 1.028.237 2.5 1.527 2.57 2.422.293 3.68.123 7.396.123 10.282-8.903-1.957-17.035-4.515-25.345-5.401-14.55-1.553-24.504 7.466-24.95 21.477-.475 14.955 8.088 24.348 23.057 23.758 7.32-.288 14.562-2.836 21.812-4.482 1.668-.379 3.223-1.255 5.484-2.166 0 2.854-.278 4.883.053 6.807.946 5.498-1.423 7.34-6.755 8.283-21.026 3.719-41.624 4.924-61-7.255v74.995c12.65 0 24.96.041 37.27-.022 4.49-.023 9.085.274 13.446-.556 15.417-2.934 25.583-16.15 25.606-32.998.058-43 .02-86 .02-129.999m84.41 93V35.966c-2.254-.108-3.88-.25-5.506-.253-12.827-.018-25.655-.04-38.483-.001-18.511.055-32.102 13.43-32.417 32.064-.177 10.492-.06 20.99-.033 31.485.003 1.091.288 2.182.48 3.543 14.27 0 28.244-.13 42.214.08 4.097.061 8.372.51 12.225 1.801 5.894 1.975 9.035 6.567 9.214 12.934.178 6.29-2.62 10.848-8.123 13.8-1.174.63-2.361 1.237-3.887 2.034 2.929 1.095 5.383 1.729 7.567 2.877 9.828 5.165 11.441 18.435 2.495 24.881-3.784 2.727-9.096 4.21-13.837 4.55-9.613.691-19.31.22-28.973.226-6.284.003-12.568 0-19.078 0v67.085c14.274 0 28.233.008 42.192-.002 20.624-.014 33.69-12.89 33.917-33.586.131-11.993.03-23.99.033-36.984m-46.167-6.669c1.804-.165 3.68-.068 5.397-.546 4.34-1.209 6.005-4.562 5.838-8.73-.17-4.253-2.367-7.65-6.745-7.978-6.373-.477-12.807-.123-19.24-.123v17.377h14.75m7.705-30.423c2.744-6.43 1.01-11.921-4.657-12.585-5.857-.686-11.857-.153-17.85-.153v15.962c4.849 0 9.347.313 13.775-.114 2.806-.27 5.506-1.644 8.732-3.11z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M401 16.529c-.502.44-1.396.531-1.448.362-2.28-7.361-8.213-11.31-13.848-15.579C390.927 1 395.854 1 401 1v15.529zM386.473 266c.803-1.15 2.237-2.17 3.326-3.476 3.597-4.315 7.07-8.735 10.895-12.82.306 5.551.306 10.807.306 16.296h-14.527zM1 250.471c.502-.453 1.396-.563 1.45-.4 2.368 7.29 7.973 11.564 13.844 15.63C11.073 266 6.145 266 1 266v-15.529zM10.513 1c.482.683.769 1.642.425 2.007-3.062 3.252-6.236 6.398-9.657 9.285C1 8.418 1 4.836 1 1h9.513z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#285998",
                d: "M103.328 167.78c8.87-.913 17.486-.972 25.624-2.976 11.316-2.786 17.018-10.506 17.358-22.139.379-12.978.087-25.975.087-39.414h-26.465v8.667c-.002 9.499.073 18.998-.028 28.496-.114 10.694-6.257 17.402-16.862 16.45-8.123-.73-16.088-3.582-24.001-5.903-1.258-.37-2.665-2.914-2.674-4.46-.16-25.995-.238-51.993-.059-77.988.132-19.064 14.875-33.916 33.813-32.944 12.3.63 24.657.118 36.989.118h5.605c.124 2.044.29 3.5.291 4.955.011 52.826.055 105.652-.027 158.477-.022 14.206-5.96 25.083-19.112 31.342-2.371 1.129-5.052 2.227-7.602 2.259-16.457.201-32.918.103-49.696.103v-68.329c8.868 1.104 17.58 2.188 26.76 3.286z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#CA483A",
                d: "M240 70c0 43.5.037 86.5-.021 129.499-.023 16.848-10.189 30.064-25.606 32.998-4.36.83-8.957.533-13.446.556-12.31.063-24.62.022-37.27.022V158.08c19.376 12.179 39.974 10.974 61 7.255 5.332-.943 7.701-2.785 6.755-8.283-.33-1.924-.053-3.953-.053-6.807-2.261.911-3.816 1.787-5.484 2.166-7.25 1.646-14.491 4.194-21.812 4.482-14.969.59-23.532-8.803-23.056-23.758.445-14.011 10.399-23.03 24.95-21.477 8.31.886 16.441 3.444 25.344 5.4 0-2.885.17-6.601-.122-10.28-.071-.896-1.543-2.186-2.571-2.423-17.258-3.98-34.601-5.366-51.832-.124-4.509 1.371-8.636 4-12.728 5.952 0-16.076-.858-32.373.271-48.53.905-12.944 12.749-24.683 25.276-25.404 16.567-.955 33.23-.235 50.405-.235V70z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#489952",
                d: "M324.41 163c-.004 12.495.097 24.49-.034 36.484-.226 20.697-13.293 33.572-33.917 33.586-13.96.01-27.918.002-42.192.002v-67.085c6.51 0 12.794.003 19.078 0 9.663-.005 19.36.465 28.973-.226 4.74-.34 10.053-1.823 13.837-4.55 8.946-6.446 7.333-19.716-2.495-24.881-2.184-1.148-4.638-1.782-7.567-2.877 1.526-.797 2.713-1.404 3.887-2.034 5.503-2.952 8.3-7.51 8.123-13.8-.18-6.367-3.32-10.959-9.214-12.934-3.853-1.29-8.128-1.74-12.225-1.801-13.97-.21-27.945-.08-42.213-.08-.193-1.361-.478-2.452-.48-3.543-.027-10.495-.145-20.993.032-31.485.315-18.634 13.906-32.009 32.417-32.064 12.828-.039 25.656-.017 38.483.001 1.626.003 3.252.145 5.506.253V163z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#4F9D59",
                d: "M277.773 155.831h-14.281v-17.377c6.433 0 12.867-.354 19.24.123 4.378.327 6.574 3.725 6.745 7.977.167 4.169-1.497 7.522-5.838 8.731-1.716.478-3.593.381-5.866.546z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#519E5A",
                d: "M285.708 125.702c-2.987 1.172-5.687 2.545-8.493 2.816-4.428.427-8.926.114-13.776.114V112.67c5.994 0 11.994-.533 17.85.153 5.667.664 7.402 6.154 4.42 12.879z"
            })
        ]
    });
var $afca6e4e139c9dfb$export$2e2bcd8739ae039 = $afca6e4e139c9dfb$var$SvgJcb;

});

parcelRegister("jIs0h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4a8bc772a8e8085$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $d4a8bc772a8e8085$var$SvgMastercard = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#311E02",
                d: "M1 244c0-73.354 0-146.708.315-220.653 5.2-9.429 11.427-16.91 20.947-21.099.36-.158.497-.82.738-1.248 118.354 0 236.708 0 355.653.315 9.316 5.312 17.103 11.234 21.1 20.945.147.358.82.498 1.247.74 0 73.354 0 146.708-.315 220.653-5.2 9.43-11.429 16.908-20.948 21.098-.36.159-.496.821-.737 1.249-118.354 0-236.708 0-355.653-.315-9.314-5.313-17.104-11.233-21.1-20.945-.147-.358-.82-.498-1.247-.74m200.688-32.117c.712-.043 1.425-.086 2.646.363 33.314 24.616 75.422 27.214 109.848 6.778 34.042-20.208 52.355-59.16 46.699-99.327-7.648-54.308-58.115-92.762-112.64-85.493-17.629 2.35-33.677 8.905-47.91 20.911-.682.064-1.363.128-2.577-.298-.533-.4-1.06-.808-1.6-1.198-32.945-23.854-76.092-25.781-109.553-4.896-34.674 21.643-52.136 61.369-44.822 101.97 9.567 53.117 58.537 89.186 111.935 82.105 17.646-2.34 33.693-8.909 47.974-20.915z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M22.531 1c.228.428.09 1.09-.269 1.248-9.52 4.188-15.746 11.67-20.947 20.63C1 15.74 1 8.481 1 1h21.531zM379.469 266c-.228-.428-.091-1.09.268-1.249 9.52-4.19 15.749-11.668 20.948-20.63C401 251.26 401 258.52 401 266h-21.531zM401 22.531c-.428.227-1.1.087-1.247-.27-3.997-9.712-11.784-15.634-20.631-20.946C386.26 1 393.519 1 401 1v21.531zM1 244.469c.428-.227 1.1-.087 1.247.27 3.996 9.713 11.786 15.633 20.631 20.946C15.74 266 8.481 266 1 266v-21.531z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F69E1B",
                d: "M201.01 55.013c13.554-11.904 29.602-18.458 47.23-20.809 54.526-7.269 104.993 31.185 112.64 85.493 5.657 40.166-12.656 79.119-46.698 99.327-34.426 20.436-76.534 17.838-109.887-7.274 2.323-2.841 4.696-5.175 7.046-7.531 19.374-19.43 28.698-43.263 28.343-70.298-.422-32.072-13.762-58.496-38.674-78.908z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#EA001B",
                d: "M200.977 211.993c-13.57 11.896-29.617 18.465-47.263 20.805-53.398 7.08-102.368-28.988-111.935-82.104-7.314-40.602 10.148-80.328 44.822-101.97 33.46-20.886 76.608-18.959 109.554 4.895.54.39 1.066.798 1.657 1.703-4.569 5.285-9.639 9.713-13.754 14.898-34.76 43.8-27.202 106.506 16.92 141.773z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FF5F00",
                d: "M201.333 211.938c-44.477-35.212-52.035-97.919-17.275-141.718 4.115-5.185 9.185-9.613 14.02-14.653.89-.324 1.571-.388 2.592-.503 25.252 20.361 38.592 46.785 39.014 78.857.355 27.035-8.969 50.869-28.343 70.298-2.35 2.356-4.723 4.69-7.3 7.284-.928.294-1.64.337-2.708.435z"
            })
        ]
    });
var $d4a8bc772a8e8085$export$2e2bcd8739ae039 = $d4a8bc772a8e8085$var$SvgMastercard;

});

parcelRegister("4L2DP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f1297b4a8343d37$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $8f1297b4a8343d37$var$SvgUnionPay = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#046862",
                d: "M371 1c2.042 0 4.083 0 6.475.382.608.973.73 1.954 1.145 2.097 9.67 3.361 16.162 9.917 19.958 19.35.248.615 1.59.79 2.422 1.171 0 72.688 0 145.375-.36 218.458-.97 1.129-1.807 1.768-2.157 2.61-3.418 8.235-9.266 14.099-17.16 18.102-1.261.64-2.223 1.872-3.323 2.83-.75 0-1.5 0-2.822-.347-2.43-.77-4.29-1.56-6.15-1.562-48.637-.072-97.275-.061-145.934-.469.585-2.442 1.344-4.449 1.773-6.524 3.609-17.467 7.156-34.946 10.723-52.42 1.35-6.618 2.765-13.223 4.04-19.855 1.896-9.86 3.694-19.74 5.844-29.799 1.023-1.14 2.054-1.992 2.387-3.063.982-3.148 2.253-6.36 2.382-9.587.28-6.99 4.169-7.584 10.044-7.71 11.126-.24 21-3.913 25.371-15.38 4.673-12.26 1.647-19.913-12.35-20.644-4.787-.25-9.586-.283-14.366-.84 1.887-9.64 3.712-18.863 5.644-28.064a8700.498 8700.498 0 0 1 10-47c1.427-6.607 3.02-13.178 4.997-19.774 28.947-.01 57.432.027 85.917-.093 1.836-.008 3.667-1.218 5.5-1.869m-58.242 173.2-3.388 6.417c9.94 2.628 15.664-1 19.56-8.914 2.545-5.172 5.794-9.998 8.724-14.981 6.677-11.36 13.351-22.72 20.085-34.18-11.439-2.545-15.922 4.57-20.083 12.93l-1.49-13.817-13.26 1.981c.757 5.295 1.2 10.384 2.254 15.344 2.19 10.31 1.818 19.995-5.568 28.363-2.008 2.276-4.05 4.522-6.834 6.857m-34.586-29.734c.387 7.285 4.058 11.05 11.18 11.084 6.059.028 12.135-.053 18.167-.537 1.357-.108 3.322-1.875 3.71-3.245 1.706-6.03 2.987-12.184 4.323-18.315.787-3.609 1.389-7.258 2.108-11.07-7.235-.03-13.69 3.706-20.184-.14-.882-.523-2.586.165-3.854.503-8.486 2.26-14.124 9.913-15.45 21.72z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#DD2524",
                d: "M26 266c-.444 0-.889 0-1.432-.331-.565-.77-.956-1.374-1.507-1.622-10.755-4.847-19.223-11.564-20.37-24.44-.022-.251-1.104-.407-1.691-.607 0-70.02 0-140.042.358-210.57.653-.61 1.194-.688 1.207-.82.993-9.696 6.437-16.29 14.466-21.23C19.516 4.85 21.686 2.807 24 1c.444 0 .889 0 1.875.32 1.843.737 3.15 1.532 4.446 1.515 13.796-.178 27.589-.664 41.384-.713 21.138-.074 42.277.128 63.43.607-2.575 12.89-5.117 25.396-7.762 37.88-5.747 27.118-11.546 54.225-17.698 81.47-5.294.461-8.636 2.227-7.795 8.03.11.755-.402 1.592-.587 2.4-1.648 7.212-3.287 14.425-4.993 21.922 2.238.258 4.177.48 6.07 1.125a36392.833 36392.833 0 0 1-14.179 67.508c-2.871 13.623-5.748 27.245-8.765 41.004-.256.376-.376.611-.966.844-16.62-.269-32.778-.578-48.937-.723-1.169-.01-2.348 1.18-3.523 1.811m71.008-147.341 5.068-19.615H88.134c-2.06 9.561-3.74 19.047-6.238 28.312-1.427 5.29-3.327 10.924-6.687 15.037-1.845 2.26-7.193 2.24-10.888 2.02-.996-.06-2.628-4.701-2.397-7.088.599-6.21 1.882-12.378 3.244-18.484 1.46-6.542 3.323-12.995 5.16-20.062-5.113 0-9.612-.351-13.994.207-1.378.176-2.616 2.693-3.585 4.336-.524.887-.26 2.208-.497 3.301-2.394 11.019-4.913 22.012-7.199 33.053-1.303 6.297.34 10.967 6.508 12.694 6.482 1.816 13.655 2.044 20.447 1.64 7.84-.465 14.612-4.441 17.68-11.93 2.988-7.293 4.644-15.131 7.32-23.421z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#36807A",
                d: "M223.115 264.026c48.638.004 97.276-.007 145.913.065 1.86.002 3.72.792 5.775 1.562-50.157.347-100.511.347-151.364.049-.521-.497-.545-.695-.511-1.09.057-.196.187-.586.187-.586z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M401 23.531c-.833.089-2.174-.087-2.422-.702-3.796-9.433-10.288-15.989-19.958-19.35-.414-.143-.537-1.124-.708-2.097C385.593 1 393.186 1 401 1v22.531zM23.531 1c-1.845 1.808-4.015 3.85-6.5 5.38C9 11.32 3.558 17.913 2.565 27.61c-.013.132-.554.21-1.207.35C1 19.08 1 10.16 1 1h22.531zM1 239.469c.587-.269 1.669-.113 1.69.137 1.148 12.877 9.616 19.594 20.371 24.441.551.248.942.852 1.173 1.622C16.401 266 8.802 266 1 266v-26.531zM378.469 266c.631-.958 1.593-2.19 2.855-2.83 7.893-4.003 13.741-9.867 17.16-18.101.349-.843 1.186-1.482 2.157-2.142.359 7.666.359 15.259.359 23.073h-22.531z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#36807A",
                d: "M370.531 1c-1.364.65-3.195 1.861-5.03 1.869-28.486.12-56.971.084-85.99-.128-.534-.213-.668-.658-.438-.796A8.63 8.63 0 0 0 280 1h90.531z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#4F5E7E",
                d: "M222.87 264.809c.024.198.048.396.1.893-47.658.298-95.345.298-143.487.023-.49-.454-.524-.634-.56-.814.127-.232.247-.467.931-.7 2.037.233 3.502.662 4.967.662 46.017.005 92.033-.033 138.05-.064z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#4F5F7E",
                d: "M279.531 1c.236.269.004.537-.91.951-47.98.131-95.279.117-142.621-.16-.03-.438-.015-.615 0-.791h143.531z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#E35756",
                d: "M135.531 1c.454.176.44.353.233.845-.192.315-.643.49-.643.49-21.139-.085-42.278-.287-63.416-.213-13.795.049-27.588.535-41.384.713-1.296.017-2.603-.778-4.113-1.516C62.354 1 98.708 1 135.531 1zM78.46 264.912c.499.179.534.359.554.813C61.646 266 44.292 266 26.47 266c.706-.632 1.885-1.822 3.054-1.811 16.16.145 32.317.454 48.937.723z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#17325F",
                d: "M135.135 2.73c-.014-.395.437-.57.673-.623 47.534-.04 94.833-.025 142.583-.017.452-.007.586.438.659.66-1.445 6.808-3.037 13.38-4.463 19.987a8700.498 8700.498 0 0 0-10 46.999c-1.933 9.2-3.758 18.424-6.069 28.223-2.757.626-5.119.966-7.385.64-3.884-.558-5.197 1.421-5.972 4.753-2.801 12.045-5.774 24.05-8.642 36.08-1.168 4.897-2.234 9.818-3.426 15.078l12.07.701c-1.839 9.872-3.637 19.751-5.532 29.612-1.276 6.632-2.69 13.237-4.041 19.854-3.567 17.475-7.114 34.954-10.723 52.42-.429 2.076-1.188 4.083-1.773 6.525.021.404-.109.794-.166.99-46.074.228-92.09.266-138.107.261-1.465 0-2.93-.429-4.824-.8 2.446-13.764 5.323-27.386 8.194-41.01 4.713-22.361 9.422-44.724 14.55-67.635 5.54.042 7.854-2.094 8.279-7.384.368-4.582 1.536-9.176 2.995-13.55.484-1.449 2.972-2.23 4.544-3.317.43 1.539 1.433 3.175 1.19 4.6-1.054 6.213-2.47 12.366-3.823 18.871 4.09 0 7.385.133 10.656-.086.906-.06 2.343-1.03 2.518-1.812 1.768-7.874 3.685-15.745 4.808-23.723.706-5.014-2.092-7.915-7.036-7.029-5.726 1.027-11.222.423-16.823-.052 5.778-27.112 11.577-54.219 17.324-81.337 2.645-12.484 5.187-24.99 7.762-37.88m18.693 126.42-2.155-1.484c1.303-1.241 3.067-2.165 3.44-3.482.414-1.461-.413-4.719-.75-4.725-3.482-.072-7.214-.306-10.393.842-2.856 1.032-4.722 3.69-1.423 6.924.55.54-.136 2.343-.943 3.456-.86 2.343-1.92 4.634-2.537 7.04-1.418 5.521-2.62 11.098-3.984 16.977 3.85 0 7.335.253 10.75-.132 1.25-.14 3.075-1.61 3.364-2.786 1.768-7.209 3.17-14.508 4.63-22.63m3.908 20.252c2.986 6.342 12.544 6.866 19.693 5.035 9.819-2.516 13.358-10.06 14.795-19.32.85-5.467-1.042-10.022-5.971-12.17-6.995-3.047-18.147-.935-23.01 4.918-2.459 2.96-3.968 6.708-6.703 10.311-2.487 3.934-2.23 8.253 1.196 11.226m48.477 2.58c1.254-5.486 2.72-10.936 3.685-16.473.64-3.667 2.472-4.633 6.92-3.784l-4.14 22.947c3.519 0 6.693.317 9.747-.15 1.291-.197 3.022-1.86 3.37-3.17 1.736-6.56 3.093-13.222 4.557-19.854 1.444-6.541-1.353-10.027-8.025-9.616-2.917.18-6.634 2.477-8.526 1.353-5.307-3.154-9.66.526-14.217.045-1.23 5.702-2.29 10.832-3.452 15.94-1.14 5.012-2.384 10.001-3.692 15.462 3.712 0 6.518.21 9.27-.084 1.496-.16 2.901-1.174 4.503-2.615z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F6F8F8",
                d: "M245.474 155.024c-4.067-.031-7.824-.25-12.38-.514 1.19-5.26 2.257-10.181 3.425-15.078 2.868-12.03 5.84-24.035 8.642-36.08.775-3.332 2.088-5.311 5.972-4.753 2.266.326 4.628-.014 7.371-.215 5.218-.027 10.017.006 14.804.256 13.997.731 17.023 8.383 12.35 20.644-4.371 11.467-14.245 15.14-25.371 15.38-5.875.126-9.765.72-10.044 7.71-.129 3.228-1.4 6.44-2.382 9.587-.333 1.07-1.364 1.924-2.387 3.063m9.521-33.245c-.99 3.057.183 4.64 3.304 4.07 2.875-.526 5.819-1.257 8.43-2.522 4.383-2.123 5.905-6.358 5.294-10.773-.702-5.064-5.052-5.428-9.21-5.43h-4.287c-.6 2.606-1.083 4.849-1.64 7.073-.562 2.248-1.197 4.478-1.89 7.582z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F4F8F8",
                d: "M313.137 174.162c2.405-2.297 4.447-4.543 6.455-6.819 7.386-8.368 7.758-18.052 5.568-28.363-1.054-4.96-1.497-10.05-2.255-15.344l13.261-1.981 1.49 13.817c4.16-8.36 8.644-15.475 20.083-12.93-6.734 11.46-13.408 22.82-20.085 34.18-2.93 4.983-6.18 9.809-8.725 14.981-3.895 7.914-9.62 11.542-19.56 8.914 1.153-2.183 2.271-4.3 3.768-6.455z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F4F7F7",
                d: "M278.173 144.043c1.325-11.384 6.963-19.037 15.45-21.297 1.267-.338 2.971-1.026 3.853-.504 6.494 3.847 12.95.11 20.184.141-.72 3.812-1.321 7.461-2.108 11.07-1.336 6.131-2.617 12.285-4.324 18.315-.387 1.37-2.352 3.137-3.71 3.245-6.031.484-12.107.565-18.166.537-7.122-.033-10.793-3.8-11.179-11.507m15.325 4.027c5.34-.772 8.272-5.28 8.011-13.136-.053-1.593-1.649-3.135-2.534-4.701-1.682 1.011-4.033 1.634-4.895 3.121-1.442 2.489-2.336 5.479-2.688 8.352-.242 1.98.822 4.119 2.106 6.364z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#FDF6F5",
                d: "M96.79 119.005c-2.458 7.944-4.114 15.782-7.102 23.074-3.068 7.49-9.84 11.466-17.68 11.932-6.792.403-13.965.175-20.447-1.64-6.167-1.728-7.811-6.398-6.508-12.695 2.286-11.041 4.805-22.034 7.199-33.053.237-1.093-.027-2.414.497-3.301.97-1.643 2.207-4.16 3.585-4.336 4.382-.558 8.88-.207 13.994-.207-1.837 7.067-3.7 13.52-5.16 20.062-1.362 6.106-2.645 12.274-3.244 18.484-.23 2.387 1.4 7.028 2.397 7.088 3.695.22 9.043.24 10.888-2.02 3.36-4.113 5.26-9.746 6.687-15.037 2.498-9.265 4.179-18.75 6.238-28.312h13.942c-1.731 6.7-3.4 13.157-5.285 19.96z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F6F4F5",
                d: "M109.675 122.079c5.975.342 11.47.946 17.197-.08 4.944-.887 7.742 2.014 7.036 7.028-1.123 7.978-3.04 15.849-4.808 23.723-.175.782-1.612 1.751-2.518 1.812-3.271.219-6.566.086-10.656.086 1.353-6.505 2.77-12.658 3.824-18.872.242-1.424-.761-3.06-1.191-4.599-1.572 1.087-4.06 1.868-4.544 3.318-1.459 4.373-2.627 8.967-2.995 13.549-.425 5.29-2.739 7.426-8.232 6.963-2.311-.095-4.25-.318-6.488-.576 1.706-7.497 3.345-14.71 4.993-21.921.185-.809.696-1.646.587-2.402-.841-5.802 2.5-7.568 7.795-8.03z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F3F4F6",
                d: "M206.134 152.388c-1.524 1.035-2.929 2.05-4.425 2.209-2.752.294-5.558.084-9.27.084 1.308-5.46 2.552-10.45 3.692-15.462 1.162-5.108 2.222-10.238 3.452-15.94 4.557.481 8.91-3.199 14.217-.045 1.892 1.124 5.609-1.173 8.526-1.353 6.672-.411 9.469 3.075 8.025 9.616-1.464 6.632-2.821 13.293-4.558 19.854-.347 1.31-2.078 2.973-3.37 3.17-3.053.467-6.227.15-9.746.15l4.14-22.947c-4.448-.849-6.28.117-6.92 3.784-.965 5.537-2.431 10.987-3.763 16.88z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F6F7F8",
                d: "M157.335 137.964c1.939-3.392 3.448-7.14 5.907-10.1 4.863-5.853 16.015-7.965 23.01-4.917 4.929 2.147 6.82 6.702 5.971 12.17-1.437 9.259-4.976 16.803-14.795 19.319-7.15 1.831-16.707 1.307-19.982-5.686-.23-4.03-.17-7.408-.11-10.786m12.659 4.085c.267.583.605 1.145.785 1.754.384 1.302.685 2.628 1.02 3.944 1.474-.825 3.766-1.314 4.27-2.538 1.61-3.916 2.748-8.063 3.626-12.214.225-1.067-1.047-3.402-1.869-3.521-1.304-.19-3.565.618-4.086 1.668-1.588 3.199-2.537 6.715-3.746 10.907z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#EFF0F3",
                d: "M153.892 130.002c-1.525 7.27-2.927 14.568-4.695 21.777-.289 1.176-2.115 2.645-3.365 2.786-3.414.385-6.9.132-10.75.132 1.365-5.879 2.567-11.456 3.985-16.978.617-2.405 1.678-4.696 3.345-6.93 4.365-.19 7.922-.488 11.48-.787z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#EBEDF1",
                d: "M153.86 129.576c-3.526.725-7.083 1.023-11.102 1.265-.347-1.274.34-3.077-.211-3.617-3.299-3.235-1.433-5.892 1.423-6.924 3.18-1.148 6.91-.914 10.392-.842.338.006 1.165 3.264.75 4.725-.372 1.317-2.136 2.24-3.439 3.482.864.595 1.51 1.04 2.187 1.91z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#092457",
                d: "M156.937 138.07c.339 3.272.279 6.65.234 10.49-2.862-2.132-3.12-6.45-.234-10.49z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#106E68",
                d: "M255.04 121.346c.65-2.671 1.284-4.9 1.847-7.149.556-2.224 1.039-4.467 1.64-7.073h4.286c4.158.002 8.508.366 9.21 5.43.61 4.415-.911 8.65-5.294 10.773-2.611 1.265-5.555 1.996-8.43 2.522-3.121.57-4.293-1.013-3.258-4.503z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#17716B",
                d: "M293.096 147.981c-.882-2.156-1.946-4.295-1.704-6.275.352-2.873 1.246-5.863 2.688-8.352.862-1.487 3.213-2.11 4.895-3.121.885 1.566 2.481 3.108 2.534 4.701.261 7.856-2.67 12.364-8.413 13.047z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#29426C",
                d: "M170 141.65c1.204-3.793 2.153-7.309 3.741-10.508.52-1.05 2.782-1.858 4.086-1.668.822.12 2.094 2.454 1.869 3.521-.878 4.151-2.017 8.298-3.627 12.214-.503 1.224-2.795 1.713-4.269 2.538-.335-1.316-.636-2.642-1.02-3.944-.18-.61-.518-1.171-.78-2.154z"
            })
        ]
    });
var $8f1297b4a8343d37$export$2e2bcd8739ae039 = $8f1297b4a8343d37$var$SvgUnionPay;

});

parcelRegister("dpTj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac9b1f7eb7a3fba9$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $ac9b1f7eb7a3fba9$var$SvgVisa = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 400 265",
        xmlSpace: "preserve",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#0C1727",
                d: "M1 244c0-73.354 0-146.708.32-220.641C6.498 13.898 12.726 6.407 22.307 2.272c.35-.15.468-.836.694-1.272 118.354 0 236.708 0 355.641.32 6.672 4.493 13.563 7.679 17.524 14.446 1.463 2.499 3.215 4.828 4.835 7.234 0 73.354 0 146.708-.32 220.641-5.176 9.462-11.404 16.953-20.986 21.087-.349.151-.468.836-.694 1.272-118.354 0-236.708 0-355.641-.32-6.67-4.493-13.564-7.675-17.519-14.45-1.46-2.5-3.218-4.825-4.84-7.23m361.564-84.103c-5.376-23.508-10.846-46.996-16.034-70.545-.87-3.95-2.222-5.724-6.512-5.38-4.962.397-9.984.227-14.972.061-7.771-.259-12.763 3.16-15.882 10.333-12.136 27.912-24.508 55.721-36.765 83.58-.615 1.398-.97 2.91-1.65 4.994 5.373 0 9.914-.484 14.314.099 9.605 1.271 16.498-.901 18.032-11.787.4-2.84 2.494-3.415 5.16-3.358 6.821.145 13.648.046 20.473.046 10.094 0 10.035.015 12.53 9.628.417 1.603 1.55 4.263 2.448 4.303 7.689.344 15.4.197 23.78.197-1.715-7.784-3.212-14.574-4.922-22.171m-161.29 21.4c10.89 3.144 22.03 3.6 33.191 2.494 9.559-.948 18.51-3.87 26.331-9.839 12.15-9.272 18.164-31.935-.5-44.25-3.877-2.557-8.067-4.638-12.117-6.932-3.471-1.967-7.175-3.614-10.372-5.954-5.287-3.867-4.915-8.976 1.12-11.565 3.842-1.647 8.394-2.675 12.52-2.394 6.81.466 13.533 2.215 20.512 3.463.856-4.466 1.657-9.561 2.846-14.564.954-4.014-.62-5.757-4.381-6.673-12.706-3.093-25.518-3.739-38 .18-6.2 1.946-12.455 5.091-17.468 9.184-13.477 11.003-12.842 28.94 1.051 39.368 4.616 3.464 10.007 5.9 15.053 8.788 2.886 1.651 6.003 2.983 8.644 4.957 5.262 3.931 4.702 10.3-1.171 13.33-2.305 1.189-5 1.953-7.586 2.203-8.903.863-17.624-.026-25.936-3.648-1.927-.84-3.922-1.525-6.466-2.504-.998 5.792-1.5 11.1-2.902 16.16-1.344 4.846-.1 7.34 5.631 8.196m-76.139-90.675-23.384 59.805c-6.572-22.687-21.825-36.612-39.467-49.8 0 1.87-.187 2.714.027 3.44 7.341 24.897 14.753 49.773 22.05 74.683.809 2.761 2.31 3.613 5.038 3.556 6.493-.137 13.004-.297 19.48.052 4.177.225 6.145-1.358 7.75-5.139 12.427-29.255 25.075-58.415 37.637-87.612.697-1.619 1.237-3.304 2.189-5.874-7.952 0-15.082.344-22.16-.116-5.065-.329-7.886 1.387-9.16 7.005m30.73 62.657-4.996 28.988c7.34 0 13.837-.418 20.253.128 5.472.466 7.018-1.81 7.824-6.765 3.77-23.17 7.91-46.28 11.883-69.416 1.23-7.165 2.348-14.35 3.673-22.478-7.924 0-15.033.168-22.128-.07-3.624-.12-4.87 1.33-5.438 4.751-3.542 21.353-7.278 42.673-11.071 64.862M77.12 83.066h-42.37l-.481 1.852c26.525 6.879 48.39 19.989 61.574 44.967.166-1.522.182-2.957-.105-4.328a6203.654 6203.654 0 0 0-6.846-32.19c-1.55-7.214-3.447-8.98-11.772-10.3z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M22.531 1c.243.436.124 1.121-.225 1.272C12.726 6.407 6.496 13.898 1.32 22.89 1 15.74 1 8.48 1 1h21.531zM379.469 266c-.243-.436-.124-1.121.225-1.272 9.582-4.134 15.81-11.625 20.985-20.618.321 7.15.321 14.41.321 21.89h-21.531zM401 22.531c-1.62-1.937-3.372-4.266-4.835-6.765C392.204 9 385.313 5.813 379.11 1.321 386.26 1 393.52 1 401 1v21.531zM1 244.469c1.622 1.936 3.38 4.262 4.84 6.761 3.955 6.775 10.848 9.957 17.05 14.45C15.74 266 8.48 266 1 266v-21.531z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3361AA",
                d: "M362.671 160.3c1.603 7.194 3.1 13.984 4.815 21.768-8.38 0-16.091.147-23.78-.197-.897-.04-2.03-2.7-2.447-4.303-2.496-9.613-2.437-9.629-12.531-9.628-6.825 0-13.652.1-20.474-.046-2.665-.057-4.76.517-5.16 3.358-1.533 10.886-8.426 13.058-18.031 11.787-4.4-.583-8.94-.1-14.315-.1.68-2.083 1.036-3.595 1.651-4.992 12.257-27.86 24.629-55.669 36.765-83.58 3.12-7.174 8.11-10.593 15.882-10.334 4.988.166 10.01.336 14.972-.062 4.29-.343 5.642 1.432 6.512 5.38 5.188 23.55 10.658 47.038 16.141 70.95m-28.74-13.822-7.081-33.502-1.329.12-13.578 35.225c7.925-.365 14.826-.684 21.987-1.843z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3361A9",
                d: "M200.88 181.194c-5.337-.753-6.581-3.247-5.237-8.093 1.402-5.06 1.904-10.368 2.902-16.16 2.544.98 4.539 1.664 6.466 2.504 8.312 3.622 17.033 4.51 25.936 3.648 2.586-.25 5.281-1.014 7.586-2.203 5.873-3.03 6.433-9.399 1.171-13.33-2.64-1.974-5.758-3.306-8.644-4.957-5.046-2.888-10.437-5.324-15.053-8.788-13.893-10.428-14.528-28.365-1.05-39.368 5.012-4.093 11.266-7.238 17.467-9.184 12.482-3.919 25.294-3.273 38-.18 3.762.916 5.335 2.66 4.381 6.673-1.19 5.003-1.99 10.097-2.846 14.564-6.98-1.248-13.702-2.997-20.513-3.463-4.125-.281-8.677.747-12.518 2.394-6.036 2.59-6.408 7.698-1.121 11.565 3.197 2.34 6.9 3.987 10.372 5.954 4.05 2.294 8.24 4.375 12.117 6.933 18.664 12.314 12.65 34.977.5 44.25-7.82 5.967-16.772 8.89-26.331 9.838-11.16 1.106-22.302.65-33.584-2.597z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#3361AA",
                d: "M125.285 90.26c1.124-5.256 3.945-6.972 9.01-6.643 7.078.46 14.208.116 22.16.116-.952 2.57-1.492 4.255-2.189 5.874-12.562 29.197-25.21 58.357-37.636 87.612-1.606 3.78-3.574 5.364-7.75 5.14-6.477-.35-12.988-.19-19.481-.053-2.729.057-4.23-.795-5.038-3.556-7.297-24.91-14.709-49.786-22.05-74.684-.214-.725-.027-1.57-.027-3.44 17.642 13.189 32.895 27.114 39.467 49.8 8.076-20.653 15.73-40.229 23.534-60.167zM155.926 152.85c3.732-21.76 7.468-43.08 11.01-64.433.567-3.42 1.814-4.872 5.438-4.75 7.095.237 14.204.07 22.128.07-1.325 8.128-2.443 15.312-3.673 22.477-3.973 23.137-8.113 46.246-11.883 69.416-.806 4.954-2.352 7.23-7.824 6.765-6.416-.546-12.913-.128-20.253-.128 1.748-10.14 3.372-19.564 5.057-29.417z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#F4B10C",
                d: "M77.57 83.088c7.876 1.299 9.773 3.065 11.323 10.279a6203.654 6203.654 0 0 1 6.846 32.19c.287 1.371.271 2.806.105 4.328-13.184-24.978-35.05-38.088-61.574-44.967l.48-1.852c14.124 0 28.248 0 42.82.022z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fill: "#0D192A",
                d: "M333.8 146.9c-7.031.738-13.932 1.057-21.857 1.422l13.578-35.225 1.329-.12c2.36 11.167 4.72 22.334 6.95 33.922z"
            })
        ]
    });
var $ac9b1f7eb7a3fba9$export$2e2bcd8739ae039 = $ac9b1f7eb7a3fba9$var$SvgVisa;

});


parcelRegister("bq9l8", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $2e4ddfe3a9f11e71$export$df03f54e09e486fa; });

var $3PrO9 = parcelRequire("3PrO9");

var $iCcjI = parcelRequire("iCcjI");

var $4TTVA = parcelRequire("4TTVA");

var $6BZyr = parcelRequire("6BZyr");

var $Rk3re = parcelRequire("Rk3re");

var $1fFrD = parcelRequire("1fFrD");

var $4dCmv = parcelRequire("4dCmv");

var $j8RqC = parcelRequire("j8RqC");

var $yWbk2 = parcelRequire("yWbk2");

var $jDgOF = parcelRequire("jDgOF");

var $iCHRO = parcelRequire("iCHRO");

var $1L90Z = parcelRequire("1L90Z");

var $4uBwa = parcelRequire("4uBwa");

var $cPakL = parcelRequire("cPakL");

var $ooW3c = parcelRequire("ooW3c");

var $b96Pr = parcelRequire("b96Pr");

var $1Ds7m = parcelRequire("1Ds7m");

var $5VFWk = parcelRequire("5VFWk");

var $43nLX = parcelRequire("43nLX");

var $10vCk = parcelRequire("10vCk");

var $eMJeB = parcelRequire("eMJeB");

var $fooj8 = parcelRequire("fooj8");

var $9B70c = parcelRequire("9B70c");

var $gp9tD = parcelRequire("gp9tD");

var $h6pqZ = parcelRequire("h6pqZ");

var $bmbTy = parcelRequire("bmbTy");

var $kdAJC = parcelRequire("kdAJC");

var $4YkDi = parcelRequire("4YkDi");

var $fTB8i = parcelRequire("fTB8i");

var $7Tn5F = parcelRequire("7Tn5F");

var $j8nHW = parcelRequire("j8nHW");

var $aZkxO = parcelRequire("aZkxO");

var $d3vqP = parcelRequire("d3vqP");

var $eDp6w = parcelRequire("eDp6w");

var $2LjGN = parcelRequire("2LjGN");

var $l2cGb = parcelRequire("l2cGb");

var $gQ6Mk = parcelRequire("gQ6Mk");

var $jJUNu = parcelRequire("jJUNu");

var $2Eu1v = parcelRequire("2Eu1v");

var $7Sjgb = parcelRequire("7Sjgb");

var $c2kXV = parcelRequire("c2kXV");

var $cCMt8 = parcelRequire("cCMt8");

var $7cioZ = parcelRequire("7cioZ");

var $aeup7 = parcelRequire("aeup7");

var $4U3S7 = parcelRequire("4U3S7");

var $fTup9 = parcelRequire("fTup9");

var $2H1Ik = parcelRequire("2H1Ik");

var $iahXp = parcelRequire("iahXp");
const $2e4ddfe3a9f11e71$export$df03f54e09e486fa = {
    AlertTriangle: $3PrO9.default,
    ArrowLeft: $iCcjI.default,
    ArrowRight: $4TTVA.default,
    Bell: $6BZyr.default,
    CaretDown: $Rk3re.default,
    CheckCircle: $1fFrD.default,
    CheckSquare: $4dCmv.default,
    Check: $j8RqC.default,
    Clock: $yWbk2.default,
    CommentFilled: $jDgOF.default,
    Comment: $iCHRO.default,
    CreditCardIncome: $1L90Z.default,
    CreditCardOutgoing: $4uBwa.default,
    CreditCard: $cPakL.default,
    CrossCircle: $ooW3c.default,
    CrossSquare: $b96Pr.default,
    Crown: $1Ds7m.default,
    DollarCircle: $5VFWk.default,
    Download: $43nLX.default,
    Edit: $10vCk.default,
    Fire: $eMJeB.default,
    HeartBroken: $fooj8.default,
    HeartFilled: $9B70c.default,
    Heart: $gp9tD.default,
    ImageDownload: $h6pqZ.default,
    Lock: $bmbTy.default,
    MenuDots: $fTB8i.default,
    MenuLines: $7Tn5F.default,
    MusicNote: $kdAJC.default,
    MusicNotes: $4YkDi.default,
    Pause: $j8nHW.default,
    PlayCircle: $aZkxO.default,
    Play: $eDp6w.default,
    PlayCircleBold: $d3vqP.default,
    PlusCircle: $2LjGN.default,
    Posts: $l2cGb.default,
    Ryddm: $gQ6Mk.default,
    Scope: $jJUNu.default,
    Search: $2Eu1v.default,
    SignOut: $7Sjgb.default,
    Speaker: $c2kXV.default,
    Time: $cCMt8.default,
    Trash: $7cioZ.default,
    Unlock: $aeup7.default,
    Upload: $4U3S7.default,
    UserCircle: $fTup9.default,
    UserPlus: $2H1Ik.default,
    User: $iahXp.default
};

});
parcelRegister("3PrO9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aadc1995924f4ac3$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $aadc1995924f4ac3$var$SvgAlertTriangle = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        viewBox: "0 0 511.999 463.377",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M289.639 9.137c12.411 7.25 23.763 18.883 33.037 34.913l.97 1.813 1.118 1.941 174.174 302.48c33.712 56.407-1.203 113.774-66.174 112.973v.12H73.485c-.895 0-1.78-.04-2.657-.112-59.104-.799-86.277-54.995-61.909-106.852.842-1.805 1.816-3.475 2.816-5.201L189.482 43.959l-.053-.032c9.22-15.786 20.717-27.457 33.411-34.805C243.788-3 268.711-3.086 289.639 9.137zM255.7 339.203c13.04 0 23.612 10.571 23.612 23.612 0 13.041-10.572 23.613-23.612 23.613-13.041 0-23.613-10.572-23.613-23.613s10.572-23.612 23.613-23.612zm17.639-35.379c-.794 19.906-34.506 19.931-35.278-.006-3.41-34.108-12.129-111.541-11.853-143.591.284-9.874 8.469-15.724 18.939-17.955 3.231-.686 6.781-1.024 10.357-1.019 3.595.008 7.153.362 10.387 1.051 10.818 2.303 19.309 8.392 19.309 18.446l-.043 1.005-11.818 142.069zM37.596 369.821 216.864 59.942c21.738-37.211 56.225-38.289 78.376 0l176.298 306.166c17.177 28.285 10.04 66.236-38.774 65.488H73.485c-33.017.756-52.841-25.695-35.889-61.775z",
            fill: "#FFF"
        })
    });
var $aadc1995924f4ac3$export$2e2bcd8739ae039 = $aadc1995924f4ac3$var$SvgAlertTriangle;

});

parcelRegister("iCcjI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9db1479e1c9bf47$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $a9db1479e1c9bf47$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "arrow_left_svg__feather arrow_left_svg__feather-arrow-left",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M19 12H5M12 19l-7-7 7-7"
        })
    });
var $a9db1479e1c9bf47$export$2e2bcd8739ae039 = $a9db1479e1c9bf47$var$SvgArrowLeft;

});

parcelRegister("4TTVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9deef3fdf40d92bc$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $9deef3fdf40d92bc$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "arrow_right_svg__feather arrow_right_svg__feather-arrow-right",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M5 12h14M12 5l7 7-7 7"
        })
    });
var $9deef3fdf40d92bc$export$2e2bcd8739ae039 = $9deef3fdf40d92bc$var$SvgArrowRight;

});

parcelRegister("6BZyr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f890ba6a3002cdde$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $f890ba6a3002cdde$var$SvgBell = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 28 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.001.667C8.294.667 3.668 5.293 3.668 11v.94c0 .928-.275 1.837-.79 2.61l-1.532 2.297c-1.777 2.666-.42 6.29 2.671 7.133 1.007.275 2.023.508 3.045.698l.003.007C8.09 27.42 10.83 29.334 14 29.334s5.911-1.914 6.937-4.65l.002-.006a37.949 37.949 0 0 0 3.046-.698c3.091-.843 4.448-4.467 2.67-7.133l-1.53-2.297a4.706 4.706 0 0 1-.791-2.61V11C24.335 5.293 19.708.667 14 .667Zm4.502 24.383a37.95 37.95 0 0 1-9.004 0c.948 1.362 2.597 2.284 4.502 2.284 1.905 0 3.554-.922 4.502-2.284ZM5.668 11a8.333 8.333 0 0 1 16.667 0v.94c0 1.323.392 2.618 1.126 3.72l1.532 2.297a2.695 2.695 0 0 1-1.534 4.094 35.947 35.947 0 0 1-18.916 0 2.695 2.695 0 0 1-1.533-4.094l1.532-2.298a6.707 6.707 0 0 0 1.126-3.72V11Z",
            fill: "#FFF"
        })
    });
var $f890ba6a3002cdde$export$2e2bcd8739ae039 = $f890ba6a3002cdde$var$SvgBell;

});

parcelRegister("Rk3re", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02df70a985cc5a9f$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $02df70a985cc5a9f$var$SvgCaretDown = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 320 512",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "m310.6 246.6-127.1 128c-7.1 6.3-15.3 9.4-23.5 9.4s-16.38-3.125-22.63-9.375l-127.1-128C.224 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75s3.12 25.75-6.08 34.85z",
            fill: "#FFF"
        })
    });
var $02df70a985cc5a9f$export$2e2bcd8739ae039 = $02df70a985cc5a9f$var$SvgCaretDown;

});

parcelRegister("1fFrD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d3899512bbfbce0$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $5d3899512bbfbce0$var$SvgCheckCircle = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 22 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M15.03 9.53a.75.75 0 0 0-1.06-1.06L9.5 12.94l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l5-5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 .75C5.063.75.25 5.563.25 11.5S5.063 22.25 11 22.25s10.75-4.813 10.75-10.75S16.937.75 11 .75ZM1.75 11.5a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0Z",
                fill: "#FFF"
            })
        ]
    });
var $5d3899512bbfbce0$export$2e2bcd8739ae039 = $5d3899512bbfbce0$var$SvgCheckCircle;

});

parcelRegister("4dCmv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df7d2bb88ac91b53$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $df7d2bb88ac91b53$var$SvgCheckSquare = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M15.03 9.03a.75.75 0 0 0-1.06-1.06L9.5 12.44l-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l5-5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.057.25h-.114c-2.309 0-4.118 0-5.53.19-1.444.194-2.584.6-3.479 1.494C1.04 2.83.634 3.97.44 5.414.25 6.825.25 8.634.25 10.943v.114c0 2.309 0 4.118.19 5.53.194 1.444.6 2.584 1.494 3.479.895.895 2.035 1.3 3.48 1.494 1.411.19 3.22.19 5.529.19h.114c2.309 0 4.118 0 5.53-.19 1.444-.194 2.584-.6 3.479-1.494.895-.895 1.3-2.035 1.494-3.48.19-1.411.19-3.22.19-5.529v-.114c0-2.309 0-4.118-.19-5.53-.194-1.444-.6-2.584-1.494-3.479-.895-.895-2.035-1.3-3.48-1.494-1.411-.19-3.22-.19-5.529-.19ZM2.995 2.995c.57-.57 1.34-.897 2.619-1.069 1.3-.174 3.008-.176 5.386-.176s4.086.002 5.386.176c1.279.172 2.05.5 2.62 1.069.569.57.896 1.34 1.068 2.619.174 1.3.176 3.008.176 5.386s-.002 4.086-.176 5.386c-.172 1.279-.5 2.05-1.069 2.62-.57.569-1.34.896-2.619 1.068-1.3.174-3.008.176-5.386.176s-4.086-.002-5.386-.176c-1.279-.172-2.05-.5-2.62-1.069-.569-.57-.896-1.34-1.068-2.619-.174-1.3-.176-3.008-.176-5.386s.002-4.086.176-5.386c.172-1.279.5-2.05 1.069-2.62Z",
                fill: "#FFF"
            })
        ]
    });
var $df7d2bb88ac91b53$export$2e2bcd8739ae039 = $df7d2bb88ac91b53$var$SvgCheckSquare;

});

parcelRegister("j8RqC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e26ca52a43d3a8bd$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $e26ca52a43d3a8bd$var$SvgCheck = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 50 50",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M41.938 8.625a2 2 0 0 0-1.626.938L21.5 38.343 9.312 27.814a1.992 1.992 0 0 0-2.03-.52 1.998 1.998 0 0 0-.595 3.52l13.938 12.062a2.005 2.005 0 0 0 1.582.453 2.01 2.01 0 0 0 1.387-.89L43.687 11.75a1.997 1.997 0 0 0-1.75-3.125Z",
            fill: "#FFF"
        })
    });
var $e26ca52a43d3a8bd$export$2e2bcd8739ae039 = $e26ca52a43d3a8bd$var$SvgCheck;

});

parcelRegister("yWbk2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59734df628a0b379$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $59734df628a0b379$var$SvgClock = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "clock_svg__feather clock_svg__feather-clock",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 10
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M12 6v6l4 2"
            })
        ]
    });
var $59734df628a0b379$export$2e2bcd8739ae039 = $59734df628a0b379$var$SvgClock;

});

parcelRegister("jDgOF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02c70968128da109$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $02c70968128da109$var$SvgCommentFilled = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M21.5 11C21.5 5.063 16.687.25 10.75.25S0 5.063 0 11c0 1.718.404 3.345 1.122 4.787.107.215.13.435.08.62l-.595 2.226c-.408 1.524.986 2.918 2.51 2.51l2.226-.596a.885.885 0 0 1 .62.08 10.709 10.709 0 0 0 4.787 1.123c5.937 0 10.75-4.813 10.75-10.75Z",
            fill: "#FFF"
        })
    });
var $02c70968128da109$export$2e2bcd8739ae039 = $02c70968128da109$var$SvgCommentFilled;

});

parcelRegister("iCHRO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c46fb8ed3209b4d$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $5c46fb8ed3209b4d$var$SvgComment = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.75 11C21.75 5.063 16.937.25 11 .25S.25 5.063.25 11c0 1.718.404 3.345 1.122 4.787.107.215.13.435.08.62l-.595 2.226c-.408 1.524.986 2.918 2.51 2.51l2.226-.596a.885.885 0 0 1 .62.08A10.709 10.709 0 0 0 11 21.75c5.937 0 10.75-4.813 10.75-10.75ZM11 1.75a9.25 9.25 0 0 1 0 18.5 9.208 9.208 0 0 1-4.118-.965 2.383 2.383 0 0 0-1.676-.187l-2.227.596a.55.55 0 0 1-.673-.674l.596-2.226a2.383 2.383 0 0 0-.187-1.676A9.209 9.209 0 0 1 1.75 11 9.25 9.25 0 0 1 11 1.75Z",
            fill: "#FFF"
        })
    });
var $5c46fb8ed3209b4d$export$2e2bcd8739ae039 = $5c46fb8ed3209b4d$var$SvgComment;

});

parcelRegister("1L90Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd9e4c99b6273850$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $fd9e4c99b6273850$var$SvgCreditCardIncome = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 29 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.777.167h5.484c2.45 0 4.391 0 5.91.204 1.563.21 2.828.653 3.826 1.65.998.998 1.44 2.264 1.651 3.827.12.897.17 1.941.19 3.15a1.007 1.007 0 0 1 .005.307c.01.754.01 1.57.01 2.453v.075a1 1 0 1 1-2 0c0-.594 0-1.149-.003-1.667H2.188c-.002.518-.002 1.073-.002 1.667 0 2.543.002 4.349.186 5.719.18 1.341.518 2.114 1.083 2.679.564.564 1.337.902 2.678 1.082 1.37.185 3.177.187 5.72.187h5.333a1 1 0 0 1 0 2h-5.409c-2.45 0-4.391 0-5.91-.204-1.563-.21-2.829-.653-3.826-1.651C1.043 20.647.6 19.382.39 17.819c-.204-1.52-.204-3.46-.204-5.91v-.151c0-.882 0-1.699.01-2.453A1.009 1.009 0 0 1 .2 8.999c.02-1.21.07-2.254.19-3.151.21-1.563.653-2.829 1.65-3.826C3.039 1.024 4.305.58 5.868.37c1.519-.205 3.46-.205 5.91-.204Zm-9.557 8h24.597a20.824 20.824 0 0 0-.151-2.053c-.18-1.341-.519-2.114-1.083-2.678-.564-.565-1.337-.903-2.679-1.083-1.37-.184-3.176-.187-5.718-.187h-5.334c-2.542 0-4.348.003-5.719.187-1.341.18-2.114.518-2.678 1.083C2.89 4 2.552 4.773 2.372 6.114c-.08.594-.126 1.27-.152 2.053ZM23.852 23.5a1 1 0 0 1-1-1v-5.586l-.96.96a1 1 0 0 1-1.414-1.415l2.667-2.666a1 1 0 0 1 1.414 0l2.667 2.666a1 1 0 0 1-1.414 1.415l-.96-.96V22.5a1 1 0 0 1-1 1ZM5.52 17.166a1 1 0 0 1 1-1h5.333a1 1 0 1 1 0 2H6.52a1 1 0 0 1-1-1Zm8.666 0a1 1 0 0 1 1-1h.667a1 1 0 1 1 0 2h-.667a1 1 0 0 1-1-1Z",
            fill: "#FFF"
        })
    });
var $fd9e4c99b6273850$export$2e2bcd8739ae039 = $fd9e4c99b6273850$var$SvgCreditCardIncome;

});

parcelRegister("4uBwa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde8cc1ff139fe68$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $fde8cc1ff139fe68$var$SvgCreditCardOutgoing = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 29 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.591 0h5.484c2.45 0 4.391 0 5.91.204 1.564.21 2.829.653 3.827 1.651.997.998 1.44 2.263 1.65 3.826.121.897.17 1.942.19 3.151a1.007 1.007 0 0 1 .005.307c.01.754.01 1.57.01 2.453v.075a1 1 0 1 1-2 0c0-.595 0-1.15-.003-1.667H2.003C2 10.518 2 11.072 2 11.667c0 2.542.002 4.348.186 5.719.18 1.341.519 2.114 1.083 2.678.564.564 1.337.903 2.679 1.083 1.37.184 3.176.186 5.719.186H17a1 1 0 0 1 0 2h-5.409c-2.45 0-4.39 0-5.91-.204-1.563-.21-2.828-.653-3.826-1.65-.998-.998-1.44-2.264-1.65-3.827C0 16.133 0 14.192 0 11.742v-.15c0-.883 0-1.7.01-2.453a1.009 1.009 0 0 1 .004-.307c.02-1.21.07-2.254.19-3.15.21-1.564.653-2.83 1.651-3.827C2.853.857 4.118.415 5.681.205 7.201 0 9.141 0 11.591 0ZM2.035 8h24.597a20.822 20.822 0 0 0-.152-2.052c-.18-1.342-.518-2.115-1.082-2.679-.565-.564-1.338-.902-2.68-1.083C21.349 2.002 19.543 2 17 2h-5.333c-2.543 0-4.349.002-5.72.186-1.34.18-2.114.519-2.678 1.083-.564.564-.902 1.337-1.083 2.679-.08.594-.125 1.27-.151 2.052Zm21.632 5.333a1 1 0 0 1 1 1v5.586l.96-.96a1 1 0 1 1 1.413 1.415l-2.666 2.666a1 1 0 0 1-1.414 0l-2.667-2.666a1 1 0 0 1 1.414-1.414l.96.96v-5.587a1 1 0 0 1 1-1ZM5.333 17a1 1 0 0 1 1-1h5.334a1 1 0 1 1 0 2H6.333a1 1 0 0 1-1-1ZM14 17a1 1 0 0 1 1-1h.667a1 1 0 1 1 0 2H15a1 1 0 0 1-1-1Z",
            fill: "#FFF"
        })
    });
var $fde8cc1ff139fe68$export$2e2bcd8739ae039 = $fde8cc1ff139fe68$var$SvgCreditCardOutgoing;

});

parcelRegister("cPakL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc1267dd864ccca0$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $dc1267dd864ccca0$var$SvgCreditCard = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        fill: "#FFF",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 456.548 456.548",
        xmlSpace: "preserve",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M433.467 81.51H23.081C10.334 81.51 0 91.844 0 104.591v26.274h456.548v-26.274c0-12.747-10.334-23.081-23.081-23.081zM0 351.957c0 12.747 10.334 23.081 23.081 23.081h410.385c12.747 0 23.081-10.334 23.081-23.081V198.355H0v153.602zm196.171-28.447h-29c-8.284 0-15-6.716-15-15s6.716-15 15-15h29c8.284 0 15 6.716 15 15s-6.716 15-15 15zm152.296-30h47c8.284 0 15 6.716 15 15s-6.716 15-15 15h-47c-8.284 0-15-6.716-15-15s6.716-15 15-15zm-45.296 15c0 8.284-6.716 15-15 15h-29c-8.284 0-15-6.716-15-15s6.716-15 15-15h29c8.284 0 15 6.716 15 15zm-244.297-72h224c8.284 0 15 6.716 15 15s-6.716 15-15 15h-224c-8.284 0-15-6.716-15-15s6.716-15 15-15zm0 57h47c8.284 0 15 6.716 15 15s-6.715 15-15 15h-47c-8.284 0-15-6.716-15-15s6.716-15 15-15z"
        })
    });
var $dc1267dd864ccca0$export$2e2bcd8739ae039 = $dc1267dd864ccca0$var$SvgCreditCard;

});

parcelRegister("ooW3c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4493c980a7920d1$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $a4493c980a7920d1$var$SvgCrossCircle = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 44 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M18.06 15.94a1.5 1.5 0 1 0-2.12 2.12L19.878 22l-3.94 3.94a1.5 1.5 0 1 0 2.122 2.12L22 24.122l3.94 3.94a1.5 1.5 0 0 0 2.12-2.122L24.122 22l3.94-3.94a1.5 1.5 0 1 0-2.122-2.12L22 19.878l-3.94-3.94Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22 .5C10.126.5.5 10.126.5 22S10.126 43.5 22 43.5 43.5 33.874 43.5 22 33.874.5 22 .5ZM3.5 22C3.5 11.783 11.783 3.5 22 3.5S40.5 11.783 40.5 22 32.217 40.5 22 40.5 3.5 32.217 3.5 22Z",
                fill: "#FFF"
            })
        ]
    });
var $a4493c980a7920d1$export$2e2bcd8739ae039 = $a4493c980a7920d1$var$SvgCrossCircle;

});

parcelRegister("b96Pr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a839927c80f9007$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $7a839927c80f9007$var$SvgCrossSquare = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M9.03 7.97a.75.75 0 0 0-1.06 1.06L9.94 11l-1.97 1.97a.75.75 0 1 0 1.06 1.06L11 12.06l1.97 1.97a.75.75 0 0 0 1.06-1.06L12.06 11l1.97-1.97a.75.75 0 1 0-1.06-1.06L11 9.94 9.03 7.97Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.057.25h-.114c-2.309 0-4.118 0-5.53.19-1.444.194-2.584.6-3.479 1.494C1.04 2.83.634 3.97.44 5.414.25 6.825.25 8.634.25 10.943v.114c0 2.309 0 4.118.19 5.53.194 1.444.6 2.584 1.494 3.479.895.895 2.035 1.3 3.48 1.494 1.411.19 3.22.19 5.529.19h.114c2.309 0 4.118 0 5.53-.19 1.444-.194 2.584-.6 3.479-1.494.895-.895 1.3-2.035 1.494-3.48.19-1.411.19-3.22.19-5.529v-.114c0-2.309 0-4.118-.19-5.53-.194-1.444-.6-2.584-1.494-3.479-.895-.895-2.035-1.3-3.48-1.494-1.411-.19-3.22-.19-5.529-.19ZM2.995 2.995c.57-.57 1.34-.897 2.619-1.069 1.3-.174 3.008-.176 5.386-.176s4.086.002 5.386.176c1.279.172 2.05.5 2.62 1.069.569.57.896 1.34 1.068 2.619.174 1.3.176 3.008.176 5.386s-.002 4.086-.176 5.386c-.172 1.279-.5 2.05-1.069 2.62-.57.569-1.34.896-2.619 1.068-1.3.174-3.008.176-5.386.176s-4.086-.002-5.386-.176c-1.279-.172-2.05-.5-2.62-1.069-.569-.57-.896-1.34-1.068-2.619-.174-1.3-.176-3.008-.176-5.386s.002-4.086.176-5.386c.172-1.279.5-2.05 1.069-2.62Z",
                fill: "#FFF"
            })
        ]
    });
var $7a839927c80f9007$export$2e2bcd8739ae039 = $7a839927c80f9007$var$SvgCrossSquare;

});

parcelRegister("1Ds7m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3b2a39062fad349$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $d3b2a39062fad349$var$SvgCrown = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.828 1.828c-.192.286-.411.732-.74 1.407L6.284 6.928c-.159.325-.297.608-.429.823-.135.22-.314.455-.592.595-.25.127-.533.173-.812.129-.315-.05-.554-.229-.74-.402-.182-.167-.385-.398-.615-.66l-.02-.023c-.487-.554-.822-.935-1.082-1.177a1.515 1.515 0 0 0-.265-.211.22.22 0 0 0-.09.065c.003 0-.044.096-.041.468.003.39.053.933.126 1.71l.184 1.948c.152 1.62.262 2.783.448 3.665.183.872.424 1.388.783 1.755.35.358.8.563 1.549.672.774.113 1.785.115 3.222.115h2.175c1.437 0 2.448-.002 3.222-.115.75-.11 1.2-.314 1.55-.672.358-.367.6-.883.782-1.755.185-.882.296-2.046.448-3.665l.184-1.948c.073-.777.123-1.32.126-1.71.003-.372-.044-.467-.042-.468l.005.005a.223.223 0 0 0-.094-.07c-.052.029-.137.09-.265.21-.26.243-.595.624-1.082 1.178l-.02.023a9.46 9.46 0 0 1-.614.66c-.187.173-.426.352-.74.402a1.339 1.339 0 0 1-.813-.129c-.278-.14-.457-.374-.592-.595a10.39 10.39 0 0 1-.43-.823L9.91 3.235c-.33-.675-.55-1.121-.741-1.407a1.14 1.14 0 0 0-.17-.21 1.14 1.14 0 0 0-.17.21Zm.206-.235-.008.003c.005-.003.008-.004.008-.003Zm-.063.003-.008-.003s.003 0 .008.003Zm-1.138-.438C8.074.799 8.433.4 8.998.4c.566 0 .924.4 1.166.758.245.363.5.887.803 1.508l1.81 3.71c.176.359.289.588.386.747a.71.71 0 0 0 .114.154.14.14 0 0 0 .07.014.712.712 0 0 0 .124-.099c.13-.12.291-.302.547-.594l.023-.026c.459-.522.833-.948 1.141-1.236.158-.148.324-.284.499-.381.177-.1.4-.18.655-.157.378.033.714.225.95.509.284.343.316.823.312 1.238-.003.448-.06 1.042-.129 1.781l-.19 2.018c-.148 1.572-.264 2.804-.464 3.76-.205.976-.512 1.747-1.1 2.348-.596.61-1.328.888-2.233 1.02-.87.128-1.97.128-3.348.128H7.863c-1.378 0-2.477 0-3.348-.127-.905-.133-1.637-.412-2.234-1.021-.587-.601-.894-1.373-1.099-2.347-.2-.957-.316-2.189-.464-3.761l-.19-2.018c-.07-.739-.126-1.333-.13-1.781-.003-.415.03-.895.313-1.238.236-.284.572-.476.95-.51.255-.021.477.058.655.158.175.097.34.233.499.381.308.288.682.714 1.14 1.236l.024.026c.256.292.417.474.547.594.071.066.11.091.124.099a.14.14 0 0 0 .07-.014.703.703 0 0 0 .114-.154c.097-.159.21-.388.385-.747l1.81-3.71c.304-.62.56-1.145.804-1.508Z",
            fill: "#FFF"
        })
    });
var $d3b2a39062fad349$export$2e2bcd8739ae039 = $d3b2a39062fad349$var$SvgCrown;

});

parcelRegister("5VFWk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e8ce17eea8c5ab4$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $9e8ce17eea8c5ab4$var$SvgDollarCircle = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11 1.75a9.25 9.25 0 1 0 0 18.5 9.25 9.25 0 0 0 0-18.5ZM.25 11C.25 5.063 5.063.25 11 .25S21.75 5.063 21.75 11 16.937 21.75 11 21.75.25 16.937.25 11ZM11 4.25a.75.75 0 0 1 .75.75v.317c1.63.292 3 1.517 3 3.183a.75.75 0 0 1-1.5 0c0-.844-.873-1.75-2.25-1.75-1.376 0-2.25.906-2.25 1.75s.874 1.75 2.25 1.75c1.937 0 3.75 1.333 3.75 3.25 0 1.666-1.37 2.891-3 3.183V17a.75.75 0 0 1-1.5 0v-.317c-1.63-.292-3-1.517-3-3.183a.75.75 0 0 1 1.5 0c0 .844.874 1.75 2.25 1.75 1.377 0 2.25-.906 2.25-1.75s-.873-1.75-2.25-1.75c-1.937 0-3.75-1.333-3.75-3.25 0-1.666 1.37-2.891 3-3.183V5a.75.75 0 0 1 .75-.75Z",
            fill: "#FFF"
        })
    });
var $9e8ce17eea8c5ab4$export$2e2bcd8739ae039 = $9e8ce17eea8c5ab4$var$SvgDollarCircle;

});

parcelRegister("43nLX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd60910183cbe666$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $bd60910183cbe666$var$SvgDownload = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "download_svg__feather download_svg__feather-download",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3"
        })
    });
var $bd60910183cbe666$export$2e2bcd8739ae039 = $bd60910183cbe666$var$SvgDownload;

});

parcelRegister("10vCk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c4127f420263c13$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $8c4127f420263c13$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.1 1.391a3.896 3.896 0 0 1 5.509 5.51l-7.594 7.594c-.428.428-.69.69-.98.917a5.996 5.996 0 0 1-1.108.684c-.334.159-.685.276-1.259.467l-2.672.891-.642.214a1.598 1.598 0 0 1-2.022-2.022l1.105-3.314c.191-.574.308-.925.467-1.259a5.99 5.99 0 0 1 .685-1.107c.227-.292.488-.553.916-.98L11.1 1.39ZM2.96 15.884l-.844-.845.728-2.185c.212-.636.3-.895.414-1.135.14-.295.313-.573.513-.83.164-.21.356-.404.83-.879l5.891-5.89a6.05 6.05 0 0 0 1.349 2.04 6.05 6.05 0 0 0 2.04 1.348l-5.891 5.89c-.474.475-.668.667-.878.83-.258.201-.536.373-.83.514-.24.114-.5.202-1.136.414l-2.185.728Zm12.116-9.572a4.025 4.025 0 0 1-.455-.129 4.536 4.536 0 0 1-1.72-1.084c-.599-.6-.916-1.236-1.084-1.72a4.028 4.028 0 0 1-.13-.455l.473-.472a2.396 2.396 0 0 1 3.388 3.388l-.472.472ZM.25 21a.75.75 0 0 1 .75-.75h16v1.5H1A.75.75 0 0 1 .25 21Z",
            fill: "#FFF"
        })
    });
var $8c4127f420263c13$export$2e2bcd8739ae039 = $8c4127f420263c13$var$SvgEdit;

});

parcelRegister("eMJeB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdad8d7b92e20647$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $cdad8d7b92e20647$var$SvgFire = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 15 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.383.608a1.827 1.827 0 0 1 2.05.104c2.128 1.54 4.566 4.284 4.566 8.177 0 3.045-1.308 5.003-2.974 6.179-1.023.722-2.167 1.14-3.2 1.352a3.303 3.303 0 0 1-1.301.17c-.131.006-.257.01-.378.01-1.169 0-2.896-.388-4.344-1.556C1.33 13.856.2 11.901.2 8.89c0-2.462 1.3-4.117 2.524-5.05a1.45 1.45 0 0 1 1.603-.132c.468.255.795.747.854 1.324l.069.67a.85.85 0 0 0 .296.576.295.295 0 0 0 .152.067c.029.002.075-.002.143-.046.522-.34.919-.95 1.186-1.669a5.998 5.998 0 0 0 .373-1.963v-.258c0-.779.396-1.446.984-1.8Zm.121 14.653c-.34.066-.665.107-.963.126a2.835 2.835 0 0 1-1.282-.45c-.468-.322-.86-.852-.86-1.782 0-1.121.694-1.973 1.432-2.52a.126.126 0 0 1 .004.031v.01c0 .181 0 .457.034.744.034.285.107.636.288.944.126.215.32.397.583.474a.977.977 0 0 0 .697-.062c.364-.173.625-.533.735-.912.33.268.627.688.627 1.291 0 .963-.358 1.496-.75 1.804-.172.134-.36.233-.545.302Zm2.31-.843c.176-.101.35-.211.52-.33 1.356-.958 2.465-2.555 2.465-5.2 0-3.35-2.098-5.778-4.07-7.204-.26-.188-.52-.172-.727-.047-.22.132-.403.405-.403.77v.26a7.19 7.19 0 0 1-.448 2.38c-.313.841-.832 1.721-1.657 2.257-.588.382-1.221.272-1.673-.07-.427-.322-.709-.851-.766-1.41l-.069-.67a.498.498 0 0 0-.235-.394c-.089-.049-.187-.054-.3.032C2.437 5.566 1.4 6.9 1.4 8.89c0 2.676.986 4.277 2.157 5.222.318.256.654.467.993.64-.219-.44-.35-.969-.35-1.596 0-1.682 1.056-2.858 1.959-3.514.41-.298.903-.289 1.28-.06.363.22.597.626.597 1.085 0 .188 0 .4.025.611l.014.1c.128-.295.364-.524.643-.645.334-.145.76-.142 1.115.125.56.421 1.167 1.177 1.167 2.298 0 .475-.067.895-.186 1.263Z",
            fill: "#FFF"
        })
    });
var $cdad8d7b92e20647$export$2e2bcd8739ae039 = $cdad8d7b92e20647$var$SvgFire;

});

parcelRegister("fooj8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f0cf097646b102$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $b2f0cf097646b102$var$SvgHeartBroken = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 122 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.296 10.575C16.006 14.822 9.2 24.923 9.2 36.968c0 12.305 5.035 21.79 12.254 29.918 5.95 6.7 13.152 12.252 20.176 17.668 1.668 1.286 3.327 2.564 4.956 3.848 2.945 2.323 5.573 4.36 8.106 5.84 1.158.678 2.213 1.186 3.183 1.54l4.074-16.294-9.519-9.518a4.2 4.2 0 0 1-.22-5.704L66.026 48.15 50.159 36.818a4.2 4.2 0 0 1-1.316-5.297l7.032-14.06c-10.883-10.032-22.1-10.762-30.579-6.886Zm39.168 8.491-6.502 13.002L74.64 43.982a4.2 4.2 0 0 1 .748 6.151L61.119 66.78l8.45 8.45a4.2 4.2 0 0 1 1.105 3.989l-3.82 15.284c.149-.084.3-.17.454-.26 2.532-1.48 5.16-3.518 8.106-5.84 1.629-1.285 3.287-2.563 4.956-3.85 7.023-5.415 14.226-10.967 20.175-17.666 7.219-8.13 12.255-17.614 12.255-29.92 0-12.044-6.806-22.145-16.097-26.392-8.91-4.073-20.846-3.06-32.239 8.491ZM61 10.77C48.052-.815 33.554-2.435 21.804 2.936 9.394 8.608.8 21.78.8 36.968c0 14.926 6.219 26.314 14.373 35.496 6.53 7.354 14.524 13.508 21.583 18.944 1.6 1.232 3.153 2.427 4.63 3.591 2.868 2.261 5.947 4.673 9.068 6.496 3.12 1.823 6.68 3.305 10.546 3.305 3.866 0 7.426-1.482 10.546-3.305 3.12-1.823 6.2-4.235 9.068-6.496 1.477-1.164 3.029-2.359 4.63-3.591 7.059-5.436 15.052-11.59 21.582-18.944 8.155-9.182 14.374-20.57 14.374-35.496 0-15.188-8.595-28.36-21.004-34.032C88.446-2.435 73.947-.814 61 10.769Z",
            fill: "#FFF"
        })
    });
var $b2f0cf097646b102$export$2e2bcd8739ae039 = $b2f0cf097646b102$var$SvgHeartBroken;

});

parcelRegister("9B70c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a13967e11df33637$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $a13967e11df33637$var$SvgHeartFilled = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M.333 4.091c0 3.242 2.68 4.97 4.641 6.516.693.546 1.36 1.06 2.026 1.06.667 0 1.333-.514 2.025-1.06 1.962-1.546 4.642-3.274 4.642-6.516S10-1.449 7 1.667C4-1.45.333.85.333 4.091Z",
            fill: "#FFF"
        })
    });
var $a13967e11df33637$export$2e2bcd8739ae039 = $a13967e11df33637$var$SvgHeartFilled;

});

parcelRegister("gp9tD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $968c42013724fde1$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $968c42013724fde1$var$SvgHeart = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 19 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.316 1.94c-1.34.606-2.32 2.05-2.32 3.77 0 1.758.725 3.113 1.766 4.274.857.957 1.895 1.75 2.908 2.524.24.184.479.366.714.55.424.332.803.623 1.168.834.365.212.66.308.91.308.249 0 .543-.096.908-.308.365-.211.744-.502 1.168-.834.235-.184.474-.366.715-.55 1.012-.774 2.05-1.567 2.907-2.524 1.04-1.161 1.766-2.516 1.766-4.274 0-1.72-.98-3.164-2.32-3.77-1.3-.59-3.048-.434-4.709 1.277a.608.608 0 0 1-.872 0C7.364 1.507 5.616 1.35 4.315 1.94Zm5.145.027C7.595.313 5.506.081 3.812.848 2.024 1.658.785 3.54.785 5.71c0 2.132.896 3.76 2.072 5.071.94 1.05 2.093 1.93 3.11 2.706.23.176.455.347.667.513.414.323.857.668 1.307.928.45.26.963.472 1.52.472s1.07-.211 1.52-.472c.45-.26.893-.605 1.307-.928.213-.166.436-.337.667-.513 1.017-.776 2.17-1.655 3.11-2.706 1.176-1.312 2.072-2.939 2.072-5.071 0-2.17-1.239-4.051-3.027-4.862-1.694-.767-3.783-.535-5.649 1.12Z",
            fill: "#FFF"
        })
    });
var $968c42013724fde1$export$2e2bcd8739ae039 = $968c42013724fde1$var$SvgHeart;

});

parcelRegister("h6pqZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b63a2aab6d9f1d1d$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $b63a2aab6d9f1d1d$var$SvgImageDownload = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.666 6.167a1 1 0 0 1 1 1v9.585l2.293-2.292a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 0 1 1.414-1.414l2.293 2.292V7.167a1 1 0 0 1 1-1Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 6.167h-.077c-3.078 0-5.49 0-7.372.253-1.926.259-3.446.8-4.64 1.992-1.193 1.193-1.733 2.713-1.992 4.64-.253 1.882-.253 4.294-.253 7.372v.152c0 3.078 0 5.49.253 7.372.259 1.927.8 3.447 1.993 4.64 1.193 1.193 2.713 1.733 4.639 1.992 1.882.253 4.294.253 7.372.253h.153c3.078 0 5.49 0 7.372-.253 1.926-.259 3.446-.8 4.64-1.992 1.192-1.193 1.733-2.713 1.992-4.64.253-1.882.253-4.294.253-7.372V20.5a1 1 0 1 0-2 0c0 3.171-.002 5.449-.236 7.182l-.028.202-3.699-3.329a5 5 0 0 0-6.22-.374l-.397.28a1.667 1.667 0 0 1-2.137-.186l-5.72-5.72a4.067 4.067 0 0 0-5.553-.185l-.676.592c.006-2.39.04-4.205.234-5.644.23-1.704.665-2.732 1.425-3.492.76-.76 1.787-1.195 3.492-1.424 1.733-.233 4.01-.235 7.181-.235a1 1 0 1 0 0-2ZM7.9 27.682c.23 1.704.665 2.732 1.425 3.492.76.76 1.787 1.195 3.492 1.424 1.733.233 4.01.235 7.181.235 3.171 0 5.449-.002 7.182-.235 1.705-.229 2.732-.665 3.492-1.424.325-.325.59-.699.806-1.154a1.006 1.006 0 0 1-.149-.11l-4.298-3.868a3 3 0 0 0-3.732-.225l-.397.28a3.667 3.667 0 0 1-4.701-.408l-5.72-5.72a2.067 2.067 0 0 0-2.822-.093L7.667 21.62c.003 2.598.03 4.54.234 6.062Z",
                fill: "#FFF"
            })
        ]
    });
var $b63a2aab6d9f1d1d$export$2e2bcd8739ae039 = $b63a2aab6d9f1d1d$var$SvgImageDownload;

});

parcelRegister("bmbTy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cf5a1a0c7de6973$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $7cf5a1a0c7de6973$var$SvgLock = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.667 5.369V4.5a4.5 4.5 0 0 1 9 0v.869c.15.01.293.024.428.042.6.08 1.105.253 1.506.655.401.4.574.906.655 1.506.077.578.077 1.313.077 2.225v.073c0 .912 0 1.647-.077 2.225-.081.6-.254 1.105-.655 1.506s-.906.574-1.507.655c-.577.077-1.312.077-2.224.077H4.463c-.911 0-1.646 0-2.224-.077-.6-.081-1.105-.254-1.507-.655-.401-.401-.574-.906-.654-1.507C0 11.518 0 10.783 0 9.87v-.073c0-.912 0-1.647.078-2.225.08-.6.253-1.105.654-1.506.402-.402.907-.574 1.507-.655.134-.018.276-.032.428-.042Zm1-.869a3.5 3.5 0 1 1 7 0v.836c-.25-.003-.515-.003-.797-.003H4.463c-.282 0-.547 0-.796.003V4.5ZM1.439 6.773c.185-.185.444-.305.933-.37.504-.069 1.171-.07 2.128-.07h5.333c.957 0 1.625.001 2.128.07.49.065.748.185.933.37.184.184.305.443.37.932.068.504.07 1.171.07 2.128 0 .957-.002 1.625-.07 2.128-.065.49-.185.748-.37.933-.184.184-.444.305-.933.37-.503.068-1.17.07-2.128.07H4.5c-.957 0-1.624-.002-2.128-.07-.49-.065-.748-.185-.933-.37-.184-.184-.304-.444-.37-.933C1 11.458 1 10.791 1 9.833c0-.957.001-1.624.069-2.128.066-.489.186-.748.37-.932Z",
            fill: "#FFF"
        })
    });
var $7cf5a1a0c7de6973$export$2e2bcd8739ae039 = $7cf5a1a0c7de6973$var$SvgLock;

});

parcelRegister("kdAJC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49fed78dea413eba$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $49fed78dea413eba$var$SvgMusicNote = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "music_note_svg__feather music_note_svg__feather-music",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M9 18V5l12-2v13"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("circle", {
                cx: 6,
                cy: 18,
                r: 3
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("circle", {
                cx: 18,
                cy: 16,
                r: 3
            })
        ]
    });
var $49fed78dea413eba$export$2e2bcd8739ae039 = $49fed78dea413eba$var$SvgMusicNote;

});

parcelRegister("4YkDi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9eef8bc2eb624fd7$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $9eef8bc2eb624fd7$var$SvgMusicNotes = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 121 117",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M40.965 9.51c2.546 2.104 5.79 3.09 8.335 3.09a4.2 4.2 0 1 1 0 8.4c-4.035 0-8.688-1.349-12.6-4.175V50.4c0 .893-.28 1.721-.755 2.402C33.708 60.32 26.745 65.8 18.5 65.8 8.448 65.8.3 57.652.3 47.6s8.148-18.2 18.2-18.2c3.608 0 6.971 1.05 9.8 2.861V0h8.4c0 4.468 1.839 7.507 4.265 9.51ZM28.3 47.6c0-5.412-4.388-9.8-9.8-9.8-5.413 0-9.8 4.388-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8Zm74.607-36.73c-3.762.959-8.687 3.008-15.834 6l-11.2 4.687c-3.417 1.43-5.67 2.38-7.325 3.294-1.566.864-2.244 1.515-2.676 2.163-.431.648-.77 1.525-.962 3.303-.204 1.88-.21 4.325-.21 8.029v11.45l47.598-19.039c-.01-6.208-.083-10.68-.577-14.021-.556-3.759-1.509-5.046-2.543-5.734-1.034-.689-2.589-1.07-6.271-.132ZM120.7 33.502v-.196c0-7.31 0-13.271-.67-17.8-.692-4.682-2.238-8.861-6.198-11.497-3.961-2.636-8.413-2.448-12.999-1.279-4.436 1.13-9.935 3.432-16.679 6.255l-11.726 4.908c-3.161 1.323-5.84 2.444-7.941 3.605-2.237 1.235-4.163 2.691-5.608 4.862-1.444 2.17-2.044 4.51-2.32 7.05-.26 2.387-.26 5.29-.26 8.717v17.778a4.148 4.148 0 0 0 0 .193V82.66a18.115 18.115 0 0 0-9.8-2.861c-10.05 0-18.2 8.148-18.2 18.2s8.15 18.2 18.2 18.2c10.052 0 18.2-8.148 18.2-18.2 0-.952-.072-1.887-.213-2.8h.214V58.843l47.6-19.04v31.658a18.116 18.116 0 0 0-9.8-2.861c-10.052 0-18.2 8.148-18.2 18.2s8.148 18.2 18.2 18.2c10.051 0 18.2-8.148 18.2-18.2 0-.655-.035-1.301-.102-1.938h.102V33.695a6.221 6.221 0 0 0 0-.193ZM102.5 77c-5.413 0-9.8 4.388-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8 0-5.412-4.388-9.8-9.8-9.8Zm-56 11.2c-5.413 0-9.8 4.388-9.8 9.8 0 5.412 4.387 9.8 9.8 9.8 5.412 0 9.8-4.388 9.8-9.8 0-5.412-4.388-9.8-9.8-9.8Z",
            fill: "#FFF"
        })
    });
var $9eef8bc2eb624fd7$export$2e2bcd8739ae039 = $9eef8bc2eb624fd7$var$SvgMusicNotes;

});

parcelRegister("fTB8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ad6f2eec633e835$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $5ad6f2eec633e835$var$SvgMenuDots = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 20 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M.25 3a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM3 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM7.25 3a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0ZM10 1.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM17 .25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM15.75 3a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
            fill: "#FFF"
        })
    });
var $5ad6f2eec633e835$export$2e2bcd8739ae039 = $5ad6f2eec633e835$var$SvgMenuDots;

});

parcelRegister("7Tn5F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a22438a46883b40$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $2a22438a46883b40$var$SvgMenuLines = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "menu_lines_svg__feather menu_lines_svg__feather-menu",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M3 12h18M3 6h18M3 18h18"
        })
    });
var $2a22438a46883b40$export$2e2bcd8739ae039 = $2a22438a46883b40$var$SvgMenuLines;

});

parcelRegister("j8nHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2548166153dfc4f$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $a2548166153dfc4f$var$SvgPause = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M0 4C0 2.114 0 1.172.586.586 1.172 0 2.114 0 4 0c1.886 0 2.828 0 3.414.586C8 1.172 8 2.114 8 4v12c0 1.886 0 2.828-.586 3.414C6.828 20 5.886 20 4 20c-1.886 0-2.828 0-3.414-.586C0 18.828 0 17.886 0 16V4ZM12 4c0-1.886 0-2.828.586-3.414C13.172 0 14.114 0 16 0c1.886 0 2.828 0 3.414.586C20 1.172 20 2.114 20 4v12c0 1.886 0 2.828-.586 3.414C18.828 20 17.886 20 16 20c-1.886 0-2.828 0-3.414-.586C12 18.828 12 17.886 12 16V4Z",
            fill: "#FFF"
        })
    });
var $a2548166153dfc4f$export$2e2bcd8739ae039 = $a2548166153dfc4f$var$SvgPause;

});

parcelRegister("aZkxO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1904dae1dc7af2b4$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $1904dae1dc7af2b4$var$SvgPlayCircle = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 11.7,
                stroke: "#FFF",
                strokeWidth: 0.6
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M8.875 6.375 17.625 12l-8.75 5.625V6.375Z",
                fill: "#FFF",
                stroke: "#FFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1904dae1dc7af2b4$export$2e2bcd8739ae039 = $1904dae1dc7af2b4$var$SvgPlayCircle;

});

parcelRegister("d3vqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad8b4c1b689b13f7$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $ad8b4c1b689b13f7$var$SvgPlayCircleBold = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#FFF",
        className: "play_circle_bold_svg__bi play_circle_bold_svg__bi-play-circle",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"
            })
        ]
    });
var $ad8b4c1b689b13f7$export$2e2bcd8739ae039 = $ad8b4c1b689b13f7$var$SvgPlayCircleBold;

});

parcelRegister("eDp6w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9feaa77397f2e253$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $9feaa77397f2e253$var$SvgPlay = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M13.163 4.837C16.388 7.03 18 8.125 18 10c0 1.875-1.612 2.97-4.837 5.163a46.431 46.431 0 0 1-2.585 1.65c-.711.416-1.518.847-2.352 1.27-3.217 1.63-4.826 2.446-6.269 1.543-1.442-.902-1.574-2.792-1.836-6.57A45.156 45.156 0 0 1 0 10c0-.94.047-1.987.121-3.055.262-3.779.394-5.668 1.836-6.57C3.4-.529 5.01.286 8.226 1.916c.834.423 1.64.854 2.352 1.27a46.385 46.385 0 0 1 2.585 1.65Z",
            fill: "#FFF"
        })
    });
var $9feaa77397f2e253$export$2e2bcd8739ae039 = $9feaa77397f2e253$var$SvgPlay;

});

parcelRegister("2LjGN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4159bf62035bac77$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $4159bf62035bac77$var$SvgPlusCircle = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M11.75 8a.75.75 0 0 0-1.5 0v2.25H8a.75.75 0 0 0 0 1.5h2.25V14a.75.75 0 0 0 1.5 0v-2.25H14a.75.75 0 0 0 0-1.5h-2.25V8Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 .25C5.063.25.25 5.063.25 11S5.063 21.75 11 21.75 21.75 16.937 21.75 11 16.937.25 11 .25ZM1.75 11a9.25 9.25 0 1 1 18.5 0 9.25 9.25 0 0 1-18.5 0Z",
                fill: "#FFF"
            })
        ]
    });
var $4159bf62035bac77$export$2e2bcd8739ae039 = $4159bf62035bac77$var$SvgPlusCircle;

});

parcelRegister("l2cGb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc455e80c7c46062$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $fc455e80c7c46062$var$SvgPosts = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 122 122",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M55.093.8h11.814c7.659 0 13.832 0 18.687.652 5.04.678 9.284 2.128 12.655 5.499 2.241 2.24 3.633 4.868 4.514 7.859 1.184.018 2.173.07 3.084.214a18.2 18.2 0 0 1 15.129 15.129c.225 1.422.225 3.035.224 5.284v51.125c.001 2.25.001 3.863-.224 5.285a18.201 18.201 0 0 1-15.129 15.129c-.911.144-1.9.196-3.084.214-.881 2.991-2.273 5.618-4.514 7.859-3.37 3.371-7.615 4.821-12.655 5.498-4.855.653-11.028.653-18.687.653H55.093c-7.659 0-13.832 0-18.687-.653-5.04-.677-9.285-2.127-12.655-5.498-2.241-2.241-3.633-4.868-4.514-7.859-1.184-.018-2.174-.07-3.084-.214a18.2 18.2 0 0 1-15.129-15.13C.799 90.427.799 88.813.8 86.563V35.437c0-2.25-.001-3.862.224-5.284a18.2 18.2 0 0 1 15.129-15.13c.91-.143 1.9-.195 3.084-.213.88-2.991 2.273-5.618 4.514-7.86 3.37-3.37 7.614-4.82 12.655-5.498C41.261.8 47.434.8 55.093.8ZM17.89 23.269a6.292 6.292 0 0 0-.424.052 9.8 9.8 0 0 0-8.146 8.146c-.108.68-.121 1.571-.121 4.333v50.4c0 2.761.013 3.653.12 4.333a9.8 9.8 0 0 0 8.147 8.146c.13.02.267.038.424.052-.291-4.191-.291-9.174-.291-15.024V38.292c0-5.85 0-10.832.29-15.023ZM26 78.477V83.4c0 8.038.009 13.644.578 17.874.552 4.109 1.563 6.285 3.112 7.835 1.55 1.55 3.726 2.561 7.835 3.113 4.23.569 9.837.578 17.875.578h11.2c8.038 0 13.645-.009 17.875-.578 4.109-.552 6.285-1.563 7.835-3.113.85-.851 1.54-1.891 2.078-3.336L83.85 94.651c-2.819-2.974-6.713-3.178-9.68-.734l-1.23 1.014c-5.13 4.228-12.193 3.397-16.447-1.59l-17.7-20.756c-1.961-2.299-4.757-2.353-6.758-.3L26 78.477Zm69.883 16.661-5.936-6.264c-5.76-6.08-14.641-6.777-21.118-1.44l-1.23 1.014c-1.432 1.18-3.297 1.104-4.715-.558l-17.7-20.756c-5.106-5.987-13.645-6.375-19.164-.712l-.02.02V38.6c0-8.039.009-13.645.578-17.875.552-4.109 1.563-6.285 3.112-7.835 1.55-1.55 3.726-2.56 7.835-3.113C41.755 9.21 47.362 9.2 55.4 9.2h11.2c8.038 0 13.645.009 17.875.577 4.109.553 6.285 1.563 7.835 3.113 1.55 1.55 2.56 3.726 3.112 7.835.569 4.23.578 9.836.578 17.875v44.8c0 4.662-.003 8.506-.117 11.738Zm8.226 3.593c.157-.014.294-.031.424-.052a9.8 9.8 0 0 0 8.146-8.146c.108-.68.121-1.572.121-4.333V35.8c0-2.762-.013-3.654-.121-4.333a9.8 9.8 0 0 0-8.146-8.146 6.303 6.303 0 0 0-.424-.052c.291 4.19.291 9.174.291 15.023v45.415c0 5.85 0 10.833-.291 15.024ZM74.999 26a4.2 4.2 0 1 0 0 8.4 4.2 4.2 0 0 0 0-8.4Zm-12.6 4.2c0-6.959 5.642-12.6 12.6-12.6 6.96 0 12.6 5.641 12.6 12.6S81.96 42.8 75 42.8c-6.958 0-12.6-5.641-12.6-12.6Z",
            fill: "#FFF"
        })
    });
var $fc455e80c7c46062$export$2e2bcd8739ae039 = $fc455e80c7c46062$var$SvgPosts;

});

parcelRegister("gQ6Mk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02cc232a041f5c32$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $02cc232a041f5c32$var$SvgRyddm = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 30 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M1.648 38.636h22.49",
                stroke: "#FFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M9.866 18.771V38.51M5.308 22.253l-1.64 1.24a2.874 2.874 0 0 0-.753 3.733l1.656 2.856 1.738 2.606a2.873 2.873 0 0 1-.692 3.912L3.01 38.51",
                stroke: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("ellipse", {
                cx: 9.464,
                cy: 9.255,
                rx: 9.464,
                ry: 9.255,
                transform: "matrix(.99516 -.09827 .10281 .9947 9.261 2.497)",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "m16.088 16.468-3.267-4.132-9.223 9.24c-.824.944.222 2.335 1.358 1.805l.237-.111 10.895-6.802Z",
                fill: "#FFF",
                stroke: "#FFF",
                strokeWidth: 0.431
            })
        ]
    });
var $02cc232a041f5c32$export$2e2bcd8739ae039 = $02cc232a041f5c32$var$SvgRyddm;

});

parcelRegister("jJUNu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0903d7c16369ed7b$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $0903d7c16369ed7b$var$SvgScope = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.8 2.297c.447-.253.718-.405.927-.49a.791.791 0 0 1 .183-.055.079.079 0 0 1 .033 0c.004 0 .01.002.027.015a.764.764 0 0 1 .127.135c.137.175.294.438.552.877l1.049 1.786c.258.44.411.704.496.908.04.093.051.146.055.171l.001.017v.002l-.001.002-.011.016a.76.76 0 0 1-.137.125c-.18.135-.448.29-.895.543l-3.735 2.12c-.423.24-.675.381-.87.46a.704.704 0 0 1-.16.05h-.015l-.003-.001a.708.708 0 0 1-.124-.13c-.129-.165-.277-.414-.523-.833l-1.12-1.907c-.253-.43-.402-.689-.486-.888a.706.706 0 0 1-.054-.176v-.003l.002-.002.002-.003.004-.006a.708.708 0 0 1 .128-.117c.172-.13.43-.279.865-.525l3.684-2.09ZM18.326.301c-.428-.113-.816-.023-1.16.116-.313.126-.671.33-1.066.553l-3.762 2.136c-.381.216-.731.414-.993.614-.287.218-.56.504-.675.927l-3.48 1.975-.04.022c-.38.217-.73.415-.993.615-.287.218-.56.504-.675.928l-3.427 1.945-.04.022c-.394.224-.752.428-1.02.631-.295.223-.573.513-.69.944-.118.432-.024.822.118 1.163.13.309.337.662.564 1.05l.046.078c.228.387.435.74.643 1.005.228.29.522.56.951.674.428.113.817.023 1.16-.115.314-.127.672-.33 1.066-.554l3.455-1.96.019.004c.417.112.795.025 1.124-.108.048-.019.096-.04.145-.063L6.31 20.71a.75.75 0 1 0 1.382.582l3.31-7.858 3.308 7.858a.75.75 0 1 0 1.382-.582l-3.818-9.069 2.145-1.217.02.005c.417.112.795.025 1.124-.108.299-.12.64-.314 1.01-.525l3.814-2.164c.394-.223.753-.427 1.021-.63.294-.223.572-.513.69-.944.118-.432.024-.823-.119-1.163-.13-.31-.337-.663-.564-1.05L19.942 2.02l-.023-.04c-.227-.387-.434-.74-.642-1.004-.229-.292-.522-.562-.952-.675ZM2.794 11.437 5.79 9.735c.106.199.23.41.361.632l.023.04.618 1.052c.116.196.226.384.334.555l-2.976 1.69c-.446.252-.717.404-.927.489a.79.79 0 0 1-.182.056c-.023.002-.03 0-.033 0h-.001c-.004-.002-.01-.003-.027-.016a.757.757 0 0 1-.126-.135c-.138-.175-.294-.438-.552-.877-.258-.44-.412-.704-.497-.908a.73.73 0 0 1-.055-.171V12.12l.011-.016a.767.767 0 0 1 .138-.125c.179-.136.447-.29.894-.543Zm8.185-5.241-3.05 1.73c-.434.247-.692.396-.864.526a.71.71 0 0 0-.135.126l-.001.002V8.594a.71.71 0 0 0 .054.165c.083.2.233.457.486.888l.595 1.014c.246.42.395.668.524.833a.7.7 0 0 0 .124.13l.002.001h.003a.702.702 0 0 0 .172-.05c.195-.079.447-.22.87-.46l.774-.44.754-.427 1.551-.88c-.107-.171-.218-.359-.333-.555L11.34 6.829c-.131-.223-.255-.435-.361-.633Z",
            fill: "#FFF"
        })
    });
var $0903d7c16369ed7b$export$2e2bcd8739ae039 = $0903d7c16369ed7b$var$SvgScope;

});

parcelRegister("2Eu1v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d94dbd2a5e8227ae$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $d94dbd2a5e8227ae$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.5 5.75a8.75 8.75 0 1 0 0 17.5 8.75 8.75 0 0 0 0-17.5ZM4.25 14.5c0-5.66 4.59-10.25 10.25-10.25S24.75 8.84 24.75 14.5c0 2.56-.939 4.902-2.491 6.698l3.271 3.272a.75.75 0 1 1-1.06 1.06l-3.272-3.271A10.21 10.21 0 0 1 14.5 24.75c-5.66 0-10.25-4.59-10.25-10.25Z",
            fill: "#FFF"
        })
    });
var $d94dbd2a5e8227ae$export$2e2bcd8739ae039 = $d94dbd2a5e8227ae$var$SvgSearch;

});

parcelRegister("7Sjgb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87356cb195d4ba76$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $87356cb195d4ba76$var$SvgSignOut = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "sign_out_svg__feather sign_out_svg__feather-log-out",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
        })
    });
var $87356cb195d4ba76$export$2e2bcd8739ae039 = $87356cb195d4ba76$var$SvgSignOut;

});

parcelRegister("c2kXV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0707019c1f1d503b$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $0707019c1f1d503b$var$SvgSpeaker = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M.003 7.715C.04 5.873.059 4.952.671 4.164c.112-.144.275-.315.413-.431.752-.636 1.746-.636 3.733-.636.71 0 1.065 0 1.403-.092.07-.02.14-.042.209-.067.33-.121.627-.33 1.22-.746C9.987.547 11.156-.275 12.138.082c.188.069.37.168.533.29.848.635.913 2.115 1.042 5.073A71.13 71.13 0 0 1 13.793 8c0 .522-.032 1.46-.08 2.555-.13 2.958-.194 4.438-1.042 5.073-.163.122-.345.221-.533.29-.982.357-2.15-.465-4.49-2.11-.592-.416-.889-.625-1.22-.746a2.61 2.61 0 0 0-.208-.066c-.338-.093-.693-.093-1.403-.093-1.987 0-2.98 0-3.733-.636a3.145 3.145 0 0 1-.413-.43c-.612-.79-.63-1.71-.668-3.552a14.06 14.06 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.49 1.552a.66.66 0 0 1 .97.094l-.529.471.53-.47.002.002.003.004.007.009a2.572 2.572 0 0 1 .079.112c.047.071.111.173.186.305.149.264.339.652.526 1.171C19.64 4.291 20 5.851 20 8c0 2.15-.36 3.71-.736 4.75-.187.52-.377.907-.526 1.172a4.655 4.655 0 0 1-.265.417l-.007.009-.003.003-.001.002s-.001.001-.531-.47l.53.471a.66.66 0 0 1-.971.094.77.77 0 0 1-.09-1.035l.03-.041c.026-.04.07-.11.125-.207a6.28 6.28 0 0 0 .422-.943c.314-.871.644-2.252.644-4.222 0-1.97-.33-3.35-.644-4.222a6.28 6.28 0 0 0-.422-.942 3.152 3.152 0 0 0-.157-.253M15.757 4.416c.333-.197.753-.07.938.286l-.603.357.603-.357v.001l.001.001.002.003.003.007.01.018.024.053c.018.042.042.099.07.17.053.145.12.35.185.62.13.54.252 1.337.252 2.425 0 1.089-.122 1.886-.252 2.426-.065.27-.132.475-.186.619a3.04 3.04 0 0 1-.094.223l-.009.018-.003.007-.002.003v.002s-.001.001-.604-.356l.603.357c-.185.355-.605.483-.938.286-.33-.196-.45-.638-.272-.991l.004-.01.035-.085c.032-.086.08-.23.13-.438.1-.416.208-1.09.208-2.06 0-.971-.108-1.645-.208-2.06a3.757 3.757 0 0 0-.165-.524l-.004-.01c-.179-.354-.058-.795.272-.991Z",
                fill: "#FFF"
            })
        ]
    });
var $0707019c1f1d503b$export$2e2bcd8739ae039 = $0707019c1f1d503b$var$SvgSpeaker;

});

parcelRegister("cCMt8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f694dda9de6584b9$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $f694dda9de6584b9$var$SvgTime = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.998 1.6a7.4 7.4 0 1 0 0 14.8 7.4 7.4 0 0 0 0-14.8ZM.398 9a8.6 8.6 0 1 1 17.2 0 8.6 8.6 0 0 1-17.2 0Zm8.6-3.8a.6.6 0 0 1 .6.6V8.75l1.825 1.825a.6.6 0 0 1-.849.848l-2-2A.6.6 0 0 1 8.398 9V5.8a.6.6 0 0 1 .6-.6Z",
            fill: "#FFF"
        })
    });
var $f694dda9de6584b9$export$2e2bcd8739ae039 = $f694dda9de6584b9$var$SvgTime;

});

parcelRegister("7cioZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9375b39d384ba404$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $9375b39d384ba404$var$SvgTrash = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M7.878 3.25a2.251 2.251 0 0 1 4.244 0 .75.75 0 1 0 1.415-.5 3.751 3.751 0 0 0-7.073 0 .75.75 0 1 0 1.414.5ZM.75 5a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5h-17A.75.75 0 0 1 .75 5ZM3.117 6.752a.75.75 0 0 1 .798.698l.46 6.9c.09 1.347.154 2.285.294 2.99.137.685.327 1.047.6 1.303.274.256.648.422 1.34.512.714.093 1.654.095 3.004.095h.774c1.35 0 2.29-.002 3.004-.095.692-.09 1.066-.256 1.34-.512.273-.256.463-.618.6-1.303.14-.705.204-1.643.294-2.99l.46-6.9a.75.75 0 1 1 1.497.1l-.464 6.952c-.085 1.282-.154 2.318-.316 3.132-.169.845-.455 1.551-1.047 2.104-.591.554-1.315.793-2.17.904-.822.108-1.86.108-3.146.108h-.878c-1.286 0-2.324 0-3.146-.108-.855-.111-1.579-.35-2.17-.904-.592-.553-.878-1.26-1.047-2.104-.162-.814-.23-1.85-.316-3.132L2.418 7.55a.75.75 0 0 1 .699-.798Z",
            fill: "#FFF"
        })
    });
var $9375b39d384ba404$export$2e2bcd8739ae039 = $9375b39d384ba404$var$SvgTrash;

});

parcelRegister("aeup7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a284be70ad904c5$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $3a284be70ad904c5$var$SvgUnlock = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.167 1a3.5 3.5 0 0 0-3.5 3.5v.836c.249-.003.514-.003.796-.003H9.87l2.225.078c.6.08 1.105.253 1.506.655.401.4.574.906.655 1.506.077.578.077 1.313.077 2.225v.073c0 .912 0 1.647-.077 2.225-.081.6-.254 1.105-.655 1.506s-.906.574-1.507.655c-.577.077-1.312.077-2.224.077H4.463c-.911 0-1.646 0-2.224-.077-.6-.081-1.105-.254-1.507-.655-.401-.401-.574-.906-.654-1.507C0 11.518 0 10.783 0 9.87v-.073c0-.912 0-1.647.078-2.225.08-.6.253-1.105.654-1.506.402-.402.907-.574 1.507-.655a6.8 6.8 0 0 1 .428-.042V4.5a4.5 4.5 0 0 1 8.888-1h-1.033A3.501 3.501 0 0 0 7.167 1ZM1.439 6.773c.185-.185.444-.305.933-.37.504-.069 1.171-.07 2.128-.07h5.333c.957 0 1.625.001 2.128.07.49.065.748.185.933.37.184.184.305.443.37.932.068.504.07 1.171.07 2.128 0 .957-.002 1.625-.07 2.128-.065.49-.185.748-.37.933-.184.184-.444.305-.933.37-.503.068-1.17.07-2.128.07H4.5c-.957 0-1.624-.002-2.128-.07-.49-.065-.748-.185-.933-.37-.184-.184-.304-.444-.37-.933C1 11.458 1 10.791 1 9.833c0-.957.001-1.624.069-2.128.066-.489.186-.748.37-.932Z",
            fill: "#FFF"
        })
    });
var $3a284be70ad904c5$export$2e2bcd8739ae039 = $3a284be70ad904c5$var$SvgUnlock;

});

parcelRegister("4U3S7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08ccf000ecd79a6$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $b08ccf000ecd79a6$var$SvgUpload = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "upload_svg__feather upload_svg__feather-upload",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12"
        })
    });
var $b08ccf000ecd79a6$export$2e2bcd8739ae039 = $b08ccf000ecd79a6$var$SvgUpload;

});

parcelRegister("fTup9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96195501dff2ad9b$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $96195501dff2ad9b$var$SvgUserCircle = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.25 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM11 5.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.25 11C.25 5.063 5.063.25 11 .25S21.75 5.063 21.75 11 16.937 21.75 11 21.75.25 16.937.25 11ZM11 1.75a9.25 9.25 0 0 0-6.558 15.773c.18-.973.535-1.89 1.246-2.628C6.753 13.791 8.454 13.25 11 13.25c2.546 0 4.247.541 5.311 1.645.712.738 1.066 1.655 1.247 2.629A9.25 9.25 0 0 0 11 1.75Zm5.194 16.905c-.102-1.212-.365-2.1-.962-2.719-.65-.673-1.853-1.186-4.232-1.186-2.379 0-3.582.513-4.232 1.186-.597.62-.86 1.507-.962 2.72A9.207 9.207 0 0 0 11 20.25a9.208 9.208 0 0 0 5.194-1.595Z",
                fill: "#FFF"
            })
        ]
    });
var $96195501dff2ad9b$export$2e2bcd8739ae039 = $96195501dff2ad9b$var$SvgUserCircle;

});

parcelRegister("2H1Ik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d7398eca4e135c3$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $7d7398eca4e135c3$var$SvgUserPlus = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.25 4.78C4.25 2.277 6.377.25 9 .25s4.75 2.028 4.75 4.53c0 2.5-2.127 4.528-4.75 4.528S4.25 7.28 4.25 4.78ZM9 1.68c-1.795 0-3.25 1.388-3.25 3.1 0 1.71 1.455 3.098 3.25 3.098s3.25-1.387 3.25-3.099c0-1.711-1.455-3.099-3.25-3.099ZM2.976 12.087c1.58-.847 3.71-1.349 6.024-1.349s4.445.502 6.025 1.349c1.556.834 2.725 2.1 2.725 3.657v.097c.001 1.108.003 2.499-1.276 3.492-.63.488-1.51.836-2.7 1.066-1.193.23-2.748.351-4.774.351s-3.58-.121-4.774-.351c-1.19-.23-2.07-.578-2.7-1.066C.249 18.34.25 16.949.25 15.84v-.097c0-1.558 1.17-2.823 2.726-3.657Zm.735 1.247c-1.34.718-1.96 1.598-1.96 2.41 0 1.247.04 1.95.723 2.48.37.287.99.568 2.05.773 1.057.204 2.502.323 4.476.323 1.974 0 3.42-.12 4.476-.323 1.06-.205 1.68-.486 2.05-.773.684-.53.724-1.233.724-2.48 0-.812-.621-1.692-1.96-2.41-1.317-.706-3.185-1.165-5.29-1.165s-3.973.459-5.289 1.165Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M18.75 6.686c0-.395-.336-.715-.75-.715s-.75.32-.75.715v1.192H16c-.414 0-.75.32-.75.715 0 .395.336.715.75.715h1.25V10.5c0 .395.336.715.75.715s.75-.32.75-.715V9.308H20c.414 0 .75-.32.75-.715 0-.395-.336-.715-.75-.715h-1.25V6.686Z",
                fill: "#FFF"
            })
        ]
    });
var $7d7398eca4e135c3$export$2e2bcd8739ae039 = $7d7398eca4e135c3$var$SvgUserPlus;

});

parcelRegister("iahXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00ff4b560fc5a535$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $00ff4b560fc5a535$var$SvgUser = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 36 44",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18 .5a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19ZM11.5 10a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM18 22.5c-4.627 0-8.89 1.052-12.049 2.829C2.84 27.079.501 29.732.501 33v.204c-.003 2.324-.006 5.24 2.552 7.323 1.259 1.025 3.02 1.754 5.4 2.236 2.386.483 5.496.737 9.547.737 4.052 0 7.162-.254 9.548-.737 2.38-.482 4.14-1.21 5.4-2.236 2.557-2.083 2.555-5 2.552-7.323V33c0-3.268-2.339-5.92-5.45-7.671C26.89 23.552 22.626 22.5 18 22.5ZM3.5 33c0-1.703 1.243-3.55 3.922-5.057C10.054 26.463 13.79 25.5 18 25.5c4.21 0 7.947.963 10.579 2.443C31.257 29.45 32.5 31.297 32.5 33c0 2.616-.08 4.088-1.447 5.2-.741.604-1.98 1.193-4.1 1.622-2.114.428-5.004.678-8.953.678-3.948 0-6.838-.25-8.952-.678-2.12-.429-3.36-1.018-4.1-1.621C3.58 37.088 3.5 35.616 3.5 33Z",
            fill: "#FFF"
        })
    });
var $00ff4b560fc5a535$export$2e2bcd8739ae039 = $00ff4b560fc5a535$var$SvgUser;

});


parcelRegister("9uBbu", function(module, exports) {

$parcel$export(module.exports, "logos", function () { return $044ec33878cc77c5$export$ad200f2ca1a7d990; });

var $fnJ0k = parcelRequire("fnJ0k");
const $044ec33878cc77c5$export$ad200f2ca1a7d990 = {
    RyddmLogo: $fnJ0k.default
};

});
parcelRegister("fnJ0k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58200824be42692e$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $58200824be42692e$var$SvgRyddmLogo = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 142 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M74.317.558h-5.383a.537.537 0 0 0-.537.537v9.951c0 .558.744.746 1.009.256l5.383-9.951a.537.537 0 0 0-.472-.793Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M78.563.686a.524.524 0 0 0-.622.258l-9.481 17.81a.537.537 0 0 0-.063.252v4.457c0 .296.24.537.537.537h8.495c3.584 0 9.32-4.395 10.037-8.79 1.38-8.462-3.991-12.936-8.903-14.524Zm-7.049 21.116a.537.537 0 0 1-.537-.537v-2.253c0-.092.024-.182.069-.262l8.281-14.81a.512.512 0 0 1 .706-.202c4.007 2.364 6.09 7.94 4.708 11.471-1.992 5.09-5.113 5.85-7.963 6.577a.535.535 0 0 1-.133.016h-5.13Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M99.552.558h-5.384a.537.537 0 0 0-.537.537v9.951c0 .558.745.746 1.01.256l5.383-9.951a.537.537 0 0 0-.472-.793Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M103.798.686a.523.523 0 0 0-.622.258l-9.482 17.81a.538.538 0 0 0-.063.252v4.457c0 .296.24.537.537.537h8.496c3.584 0 9.32-4.395 10.037-8.79 1.38-8.462-3.991-12.936-8.903-14.524Zm-7.049 21.116a.537.537 0 0 1-.537-.537v-2.253c0-.092.024-.182.068-.262l8.282-14.81a.513.513 0 0 1 .706-.202c4.007 2.364 6.091 7.94 4.708 11.471-1.992 5.09-5.113 5.85-7.963 6.577a.54.54 0 0 1-.133.016h-5.13ZM42.524 1.394a.537.537 0 0 1 .447-.836h19.998c.424 0 .68.47.452.827l-9.06 14.148a.537.537 0 0 0-.084.29v7.64c0 .296-.24.537-.537.537h-1.125a.537.537 0 0 1-.537-.537v-7.635a.537.537 0 0 0-.09-.299L42.523 1.394Zm15.913 1.362c.422 0 .679.464.455.822l-5.48 8.75a.537.537 0 0 1-.91 0l-5.479-8.75a.537.537 0 0 1 .455-.822h10.959ZM26.562.558a.537.537 0 0 0-.537.537v22.368c0 .296.24.537.537.537h1.23c.297 0 .538-.24.538-.537v-8.044c0-.297.24-.537.537-.537h4.11c.159 0 .31.07.411.192l7.317 8.734a.537.537 0 0 0 .411.192h2.156c.464 0 .71-.547.402-.893l-7.825-8.821c-.233-.263-.153-.677.132-.883 2.414-1.74 3.16-5.79 2.288-8.45-.72-2.197-3.601-4.395-5.762-4.395h-5.945Zm6.75 11.713a.5.5 0 0 1-.173.03h-4.272a.537.537 0 0 1-.537-.538V3.88c0-.297.24-.537.537-.537h4.36c1.44.146 3.025 2.05 3.025 3.81 0 1.734-.842 4.347-2.94 5.119Z",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M.96 22.995h13.1",
                stroke: "#F2C94C",
                strokeWidth: 1.868,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M5.747 10.974v11.945",
                stroke: "#F2C94C",
                strokeWidth: 1.868
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "m2.695 13.03-.29.192A2.873 2.873 0 0 0 1.6 17.19l.561.855.505.669a2.873 2.873 0 0 1-.732 4.144l-.904.585",
                stroke: "#F2C94C",
                strokeWidth: 0.431
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("ellipse", {
                cx: 5.515,
                cy: 5.598,
                rx: 5.515,
                ry: 5.598,
                transform: "rotate(-5.857 13.697 -52.159) skewX(-.176)",
                fill: "#F2C94C"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "m9.371 9.58-1.903-2.5-5.372 5.591c-.48.572.163 1.397.834 1.07l.095-.045L9.37 9.58Z",
                fill: "#F2C94C",
                stroke: "#F2C94C",
                strokeWidth: 0.431
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M116.889 23.329a.537.537 0 0 0 .52.671h1.636a.536.536 0 0 0 .521-.407l3.707-14.804a.537.537 0 0 1 .981-.147l4.644 7.709a.537.537 0 0 0 .92 0l4.644-7.709a.537.537 0 0 1 .981.147l3.707 14.804c.06.24.275.407.521.407h1.636a.537.537 0 0 0 .52-.671l-5.538-21.472a.537.537 0 0 0-.989-.128l-5.473 9.801a.537.537 0 0 1-.938 0l-5.473-9.8a.537.537 0 0 0-.989.127l-5.538 21.472Z",
                fill: "#F2C94C"
            })
        ]
    });
var $58200824be42692e$export$2e2bcd8739ae039 = $58200824be42692e$var$SvgRyddmLogo;

});



parcelRegister("c2KsG", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $034f637c69b56f26$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $034f637c69b56f26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $034f637c69b56f26$var$_ref = {
    name: "1i4zziy",
    styles: "display:flex;align-items:center;margin-left:10px"
};
var $034f637c69b56f26$var$_ref2 = {
    name: "zdrr8d",
    styles: "align-self:center;margin-right:auto"
};
const $034f637c69b56f26$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: {
                shared: /*#__PURE__*/ (0, $7hler.css)("display:flex;padding:10px 22px;animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.down(50), ";", ""),
                info: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.positive.normal, ";color:", theme.colors.primary.normal, ";", ""),
                warn: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";", ""),
                error: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.negative.normal, ";color:", theme.colors.primary.normal, ";", "")
            },
            content: {
                main: $034f637c69b56f26$var$_ref2,
                message: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", "")), ";", "")
            },
            close: {
                main: $034f637c69b56f26$var$_ref,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;cursor:pointer;", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:30px;height:30px;&>path{fill:", theme.colors.primary.normal, ";}", "")
            }
        }
    });

});
parcelRegister("7hler", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $54ca97295c8c5003$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $54ca97295c8c5003$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $54ca97295c8c5003$export$d25ddfdf17c3ad3e; });

var $iwq56 = parcelRequire("iwq56");

var $bh6RR = parcelRequire("bh6RR");

var $cdpIC = parcelRequire("cdpIC");

var $fPHYJ = parcelRequire("fPHYJ");

var $9v6T8 = parcelRequire("9v6T8");
parcelRequire("gbgGf");
parcelRequire("3Tqyg");
parcelRequire("ieFqf");

parcelRequire("adG4d");
var $54ca97295c8c5003$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $iwq56.h).call(props, "css")) return $bh6RR.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $iwq56.E);
    createElementArgArray[1] = (0, $iwq56.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $bh6RR.createElement.apply(null, createElementArgArray);
};
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $54ca97295c8c5003$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $iwq56.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $9v6T8.serializeStyles)([
        styles
    ], undefined, $bh6RR.useContext((0, $iwq56.T)));
    if (!(0, $iwq56.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $bh6RR.useRef();
    (0, $fPHYJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fPHYJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $cdpIC.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
/* import type { Interpolation, SerializedStyles } from '@emotion/utils' */ function $54ca97295c8c5003$export$dbf350e5966cf602() /*: SerializedStyles */ {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $9v6T8.serializeStyles)(args);
}
/*
type Keyframes = {|
  name: string,
  styles: string,
  anim: 1,
  toString: () => string
|} & string
*/ var $54ca97295c8c5003$export$d25ddfdf17c3ad3e = function /*: Keyframes */ keyframes() {
    var insertable = $54ca97295c8c5003$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
/*
type ClassNameArg =
  | string
  | boolean
  | { [key: string]: boolean }
  | Array<ClassNameArg>
  | null
  | void
*/ var $54ca97295c8c5003$var$classnames = function /*: string */ classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $54ca97295c8c5003$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $cdpIC.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $54ca97295c8c5003$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $fPHYJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = "";
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $cdpIC.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $iwq56.i) && res !== undefined) rules += res;
        }
        if (!(0, $iwq56.i)) return rules;
    });
    if (!(0, $iwq56.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $bh6RR.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(" "), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
/*
type Props = {
  children: ({
    css: (...args: any) => string,
    cx: (...args: Array<ClassNameArg>) => string,
    theme: Object
  }) => React.Node
} */ var $54ca97295c8c5003$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $iwq56.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $iwq56.a)) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $9v6T8.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $cdpIC.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $iwq56.a)) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $54ca97295c8c5003$var$merge(cache.registered, css, $54ca97295c8c5003$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $bh6RR.useContext((0, $iwq56.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($54ca97295c8c5003$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});

parcelRegister("lWWT4", function(module, exports) {

$parcel$export(module.exports, "constants", function () { return (parcelRequire("gln0L")).constants; });
$parcel$export(module.exports, "helpers", function () { return (parcelRequire("gln0L")).helpers; });
$parcel$export(module.exports, "fonts", function () { return (parcelRequire("gln0L")).fonts; });
$parcel$export(module.exports, "typography", function () { return (parcelRequire("gln0L")).typography; });
$parcel$export(module.exports, "mq", function () { return (parcelRequire("gln0L")).mq; });
$parcel$export(module.exports, "kf", function () { return (parcelRequire("gln0L")).kf; });
$parcel$export(module.exports, "z", function () { return (parcelRequire("gln0L")).z; });
$parcel$export(module.exports, "getTheme", function () { return (parcelRequire("gln0L")).getTheme; });
$parcel$export(module.exports, "getGlobal", function () { return (parcelRequire("gln0L")).getGlobal; });
$parcel$export(module.exports, "ThemeName", function () { return (parcelRequire("gln0L")).ThemeName; });
$parcel$export(module.exports, "contentLayout", function () { return (parcelRequire("3sxbD")).contentLayout; });
$parcel$export(module.exports, "contentContainer", function () { return (parcelRequire("kTvpt")).contentContainer; });
$parcel$export(module.exports, "stripeAppearance", function () { return (parcelRequire("55stI")).stripeAppearance; });

var $gln0L = parcelRequire("gln0L");

var $3sxbD = parcelRequire("3sxbD");

var $kTvpt = parcelRequire("kTvpt");

var $55stI = parcelRequire("55stI");

});
parcelRegister("gln0L", function(module, exports) {

$parcel$export(module.exports, "ThemeName", function () { return $a8640f2f3ac91664$export$14cdbe8c6bcbc8a; });
$parcel$export(module.exports, "constants", function () { return $a8640f2f3ac91664$export$1a988e7317c65621; });
$parcel$export(module.exports, "mq", function () { return $a8640f2f3ac91664$export$38e816254073c913; });
$parcel$export(module.exports, "helpers", function () { return $a8640f2f3ac91664$export$cbfd4c4104bf5a27; });
$parcel$export(module.exports, "fonts", function () { return $a8640f2f3ac91664$export$f45fbea8fe20ca8a; });
$parcel$export(module.exports, "typography", function () { return $a8640f2f3ac91664$export$d846a084e680d8e; });
$parcel$export(module.exports, "kf", function () { return $a8640f2f3ac91664$export$2b8c26fdf7ddc4b8; });
$parcel$export(module.exports, "z", function () { return $a8640f2f3ac91664$export$df995fae86a55f06; });
$parcel$export(module.exports, "getTheme", function () { return $a8640f2f3ac91664$export$89cbf1a0881c8b9c; });
$parcel$export(module.exports, "getGlobal", function () { return $a8640f2f3ac91664$export$a4e55266d2135a7f; });

var $7hler = parcelRequire("7hler");
function $a8640f2f3ac91664$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a8640f2f3ac91664$export$14cdbe8c6bcbc8a;
(function(ThemeName) {
    ThemeName["Dark"] = "Dark";
    ThemeName["Light"] = "Light";
})($a8640f2f3ac91664$export$14cdbe8c6bcbc8a || ($a8640f2f3ac91664$export$14cdbe8c6bcbc8a = {}));
const $a8640f2f3ac91664$export$1a988e7317c65621 = {
    app: {
        container: {
            small: "1140px",
            large: "1440px"
        },
        header: {
            desktop: {
                height: "120px"
            },
            mobile: {
                height: "80px"
            }
        },
        player: {
            desktop: {
                height: "100px"
            },
            mobile: {
                height: "80px"
            }
        },
        navigation: {
            desktop: {
                width: "280px",
                height: "100vh"
            }
        },
        content: {
            desktop: {
                padding: "42px"
            },
            mobile: {
                padding: "22px"
            }
        }
    },
    library: {
        navigation: {
            desktop: {
                height: "64px",
                margin: {
                    bottom: "30px"
                }
            },
            mobile: {
                height: "64px",
                margin: {
                    bottom: "30px"
                }
            }
        }
    }
};
const $a8640f2f3ac91664$export$38e816254073c913 = {
    mobile: (style)=>/*#__PURE__*/ (0, $7hler.css)("@media only screen and (max-width: 26.563em){", style, ";}", ""),
    tablet: (style)=>/*#__PURE__*/ (0, $7hler.css)("@media only screen and (max-width: 48em){", style, ";}", ""),
    laptop: (style)=>/*#__PURE__*/ (0, $7hler.css)("@media only screen and (max-width: 64em){", style, ";}", ""),
    desktop: (style)=>/*#__PURE__*/ (0, $7hler.css)("@media only screen and (max-width: 90em){", style, ";}", "")
};
const $a8640f2f3ac91664$export$cbfd4c4104bf5a27 = {
    resetDefaults: {
        name: "5y8btj",
        styles: "border:none;outline:none;background-image:none;background-color:transparent;-webkit-box-shadow:none;-moz-box-shadow:none;box-shadow:none"
    },
    image: {
        name: "vep67q",
        styles: "display:block;width:100%;height:100%;object-fit:cover"
    },
    // requires fixed width { width: 170px; } | or parent with { display: flex; min-width: 0; }
    textOverflowEllipsis: {
        name: "1a4h0r7",
        styles: "display:inline-block;overflow:hidden;white-space:nowrap;text-overflow:ellipsis"
    },
    hideScrollbar: {
        name: "1o67s0f",
        styles: "scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{width:0;height:0;}"
    },
    app: {
        header: {
            width: /*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.navigation.desktop.width, ");", $a8640f2f3ac91664$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $7hler.css)("height:", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.desktop.height, ";", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("height:", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.mobile.height, ";", "")), ";", "")
        },
        player: {
            width: /*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.navigation.desktop.width, ");", $a8640f2f3ac91664$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $7hler.css)("height:", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.desktop.height, ";", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("height:", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.mobile.height, ";", "")), ";", "")
        },
        playlist: {
            width: /*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.navigation.desktop.width, ");", $a8640f2f3ac91664$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $7hler.css)("height:calc(\n          100vh -\n            (\n              ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.desktop.height, " +\n                ", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.desktop.height, "\n            )\n        );", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("height:calc(\n            100vh -\n              (\n                ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.mobile.height, " +\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.mobile.height, "\n              )\n          );", "")), ";", "")
        },
        screen: {
            width: {
                full: /*#__PURE__*/ (0, $7hler.css)("width:calc(\n            100vw - (", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.desktop.padding, "*2) -\n              (", $a8640f2f3ac91664$export$1a988e7317c65621.app.navigation.desktop.width, ")\n          );", $a8640f2f3ac91664$export$38e816254073c913.tablet(/*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - (", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.desktop.padding, "*2));", "")), " ", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - (", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.mobile.padding, "*2));", "")), ";", ""),
                content: /*#__PURE__*/ (0, $7hler.css)("width:calc(\n            100vw -\n              (\n                ", $a8640f2f3ac91664$export$1a988e7317c65621.app.navigation.desktop.width, " +\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.desktop.padding, "\n              )\n          );", $a8640f2f3ac91664$export$38e816254073c913.tablet(/*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.desktop.padding, ");", "")), " ", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.mobile.padding, ");", "")), ";", "")
            },
            height: {
                full: /*#__PURE__*/ (0, $7hler.css)("height:calc(\n            100vh -\n              (\n                ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.desktop.height, " +\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.desktop.height, "\n              )\n          );", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("height:calc(\n              100vh -\n                (\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.mobile.height, " +\n                    ", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.mobile.height, "\n                )\n            );", "")), ";", ""),
                home: /*#__PURE__*/ (0, $7hler.css)("height:calc(100vh - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.desktop.height, ");", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("height:calc(100vh - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.mobile.height, ");", "")), ";", ""),
                library: /*#__PURE__*/ (0, $7hler.css)("height:calc(\n            100vh -\n              (\n                ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.desktop.height, " +\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.desktop.height, " +\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.desktop.height, " +\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.desktop.margin.bottom, "\n              )\n          );", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("height:calc(\n              100vh -\n                (\n                  ", $a8640f2f3ac91664$export$1a988e7317c65621.app.header.mobile.height, " +\n                    ", $a8640f2f3ac91664$export$1a988e7317c65621.app.player.mobile.height, " +\n                    ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.mobile.height, "+\n                    ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.mobile.margin.bottom, "\n                )\n            );", "")), ";", "")
            }
        },
        padding: {
            full: /*#__PURE__*/ (0, $7hler.css)("padding:", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.desktop.padding, ";", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("padding:", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.mobile.padding, ";", "")), ";", ""),
            sides: /*#__PURE__*/ (0, $7hler.css)("padding:0px ", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.desktop.padding, ";", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("padding:0px ", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.mobile.padding, ";", "")), ";", ""),
            content: /*#__PURE__*/ (0, $7hler.css)("padding-left:", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.desktop.padding, ";", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("padding-left:", $a8640f2f3ac91664$export$1a988e7317c65621.app.content.mobile.padding, ";", "")), ";", "")
        }
    },
    library: {
        header: {
            width: /*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - ", $a8640f2f3ac91664$export$1a988e7317c65621.app.navigation.desktop.width, ");", $a8640f2f3ac91664$export$38e816254073c913.tablet({
                name: "lcsd53",
                styles: "width:100vw"
            }), ";", ""),
            height: /*#__PURE__*/ (0, $7hler.css)("height:calc(\n          ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.desktop.height, " +\n            ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.desktop.margin.bottom, "\n        );", $a8640f2f3ac91664$export$38e816254073c913.mobile(/*#__PURE__*/ (0, $7hler.css)("height:calc(\n            ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.mobile.height, " +\n              ", $a8640f2f3ac91664$export$1a988e7317c65621.library.navigation.mobile.margin.bottom, "\n          );", "")), ";", "")
        }
    }
};
const $a8640f2f3ac91664$export$f45fbea8fe20ca8a = {
    primary: "Cera Pro"
};
const $a8640f2f3ac91664$export$d846a084e680d8e = {
    h1: "6.1rem",
    h2: "4.9rem",
    h3: "3.9rem",
    h4: "3.1rem",
    h5: "2.5rem",
    h6: "2.0rem",
    p: "1.6rem",
    sp: "1.3rem",
    c: "1rem"
};
const $a8640f2f3ac91664$export$2b8c26fdf7ddc4b8 = {
    slideIn: {
        up: (px)=>(0, $7hler.keyframes)`
      from {
        transform: translateY(${px}px);
        opacity: 0;
      }
      to {
        transform: transformY(0px);
        opacity: 1;
      }
    `,
        down: (px)=>(0, $7hler.keyframes)`
      from {
        transform: translateY(-${px}px);
        opacity: 0;
      }
      to {
        transform: transformY(0px);
        opacity: 1;
      }
    `,
        left: (px)=>(0, $7hler.keyframes)`
      from {
        transform: translateX(${px}px);
        opacity: 0;
      }
      to {
        transform: transformX(0px);
        opacity: 1;
      }
    `,
        right: (px)=>(0, $7hler.keyframes)`
      from {
        transform: translateX(-${px}px);
        opacity: 0;
      }
      to {
        transform: transformX(0px);
        opacity: 1;
      }
    `
    },
    load: {
        // width 85 height 50
        bars: (width, height)=>{
            const baseWidth = width / 8;
            const minHeight = 3;
            const quarterHight = height / 4;
            const halfHeight = height / 2;
            return (0, $7hler.keyframes)`
        0% {
          background-size: ${baseWidth}px ${minHeight}px;
        }
        16% {
          background-size: ${baseWidth}px ${height}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px;
        }
        33% {
          background-size: ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px;
        }
        50% {
          background-size: ${baseWidth}px ${quarterHight}px,
            ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px;
        }
        66% {
          background-size: ${baseWidth}px ${minHeight}px, ${baseWidth}px ${quarterHight}px,
            ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px;
        }
        83% {
          background-size: ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${quarterHight}px, ${baseWidth}px ${halfHeight}px,
            ${baseWidth}px ${height}px, ${baseWidth}px ${minHeight}px;
        }
        100% {
          background-size: ${baseWidth}px ${minHeight}px, ${baseWidth}px ${minHeight}px,
            ${baseWidth}px ${minHeight}px, ${baseWidth}px ${quarterHight}px,
            ${baseWidth}px ${halfHeight}px, ${baseWidth}px ${height}px;
        }
      `;
        },
        shine: (left, top)=>(0, $7hler.keyframes)`
        to {
          background-position: right ${left}px top ${top}px;
        }
    `
    }
};
const $a8640f2f3ac91664$export$df995fae86a55f06 = {
    app: {
        navigation: {
            mobile: "999"
        },
        header: {
            menu: "50"
        },
        modal: "777"
    },
    alert: {
        modal: "888"
    },
    onboarding: {
        backward: "10",
        stepper: {
            progress: "2",
            circle: "4"
        },
        followArtists: {
            overlay: "2"
        }
    },
    library: {
        navigation: {
            arrows: "5"
        }
    },
    components: {
        elements: {
            inputLine: {
                icon: "1"
            }
        }
    },
    features: {
        track: {
            card: {
                overlay: "2",
                menu: "3"
            },
            tile: {
                overlay: "2",
                menu: "3"
            }
        },
        post: {
            card: {
                header: "1",
                footer: "1",
                overlay: "2"
            }
        },
        user: {
            card: {
                selectedGenre: {
                    close: "1"
                }
            }
        },
        audio: {
            player: "20",
            playlist: "15"
        }
    }
};
const $a8640f2f3ac91664$export$89cbf1a0881c8b9c = (name)=>name === "Dark" ? {
        colors: {
            primary: {
                light: "#e7e7e7",
                // rgb(231, 231, 231)
                lightHover: "#dbdbdb",
                // rgb(219, 219, 219)
                lightActive: "#b5b5b5",
                // rgb(181, 181, 181)
                normal: "#0f0f0f",
                // rgb(15, 15, 15)
                normalHover: "#0e0e0e",
                // rgb(14, 14, 14)
                normalActive: "#0c0c0c",
                // rgb(12, 12, 12)
                dark: "#0b0b0b",
                // rgb(11, 11, 11)
                darkHover: "#090909",
                // rgb(9, 9, 9)
                darkActive: "#070707",
                // rgb(7, 7, 7)
                darker: "#050505" // rgb(5, 5, 5)
            },
            secondary: {
                light: "#fefefe",
                // rgb(254, 254, 254)
                lightHover: "#fdfdfd",
                // rgb(253, 253, 253)
                lightActive: "#fbfbfb",
                // rgb(251, 251, 251)
                normal: "#f2f2f2",
                // rgb(242, 242, 242)
                normalHover: "#dadada",
                // rgb(218, 218, 218)
                normalActive: "#c2c2c2",
                // rgb(194, 194, 194)
                dark: "#b6b6b6",
                // rgb(182, 182, 182)
                darkHover: "#919191",
                // rgb(145, 145, 145)
                darkActive: "#6d6d6d",
                // rgb(109, 109, 109)
                darker: "#555555" // rgb(85, 85, 85)
            },
            accent: {
                light: "#fefaed",
                // rgb(254, 250, 237)
                lightHover: "#fdf7e4",
                // rgb(253, 247, 228)
                lightActive: "#fbeec8",
                // rgb(251, 238, 200)
                normal: "#f2c94c",
                // rgb(242, 201, 76)
                normalHover: "#dab544",
                // rgb(218, 181, 68)
                normalActive: "#c2a13d",
                // rgb(194, 161, 61)
                dark: "#b69739",
                // rgb(182, 151, 57)+
                darkHover: "#91792e",
                // rgb(145, 121, 46)
                darkActive: "#6d5a22",
                // rgb(109, 90, 34)
                darker: "#55461b" // rgb(85, 70, 27)
            },
            positive: {
                light: "#e6f4ee",
                // rgb(230, 244, 238)
                lightHover: "#d9efe5",
                // rgb(217, 239, 229)
                lightActive: "#b0dec9",
                // rgb(176, 222, 201)
                normal: "#009452",
                // rgb(0, 148, 82)
                normalHover: "#00854a",
                // rgb(0, 133, 74)
                normalActive: "#007642",
                // rgb(0, 118, 66)
                dark: "#006f3e",
                // rgb(0, 111, 62)
                darkHover: "#005931",
                // rgb(0, 89, 49)
                darkActive: "#004325",
                // rgb(0, 67, 37)
                darker: "#00341d" // rgb(0, 52, 29)
            },
            negative: {
                light: "#ffebe8",
                // rgb(255, 235, 232)
                lightHover: "#ffe2dd",
                // rgb(255, 226, 221)
                lightActive: "#fec2b8",
                // rgb(254, 194, 184)
                normal: "#fc3b1b",
                // rgb(252, 59, 27)
                normalHover: "#e33518",
                // rgb(227, 53, 24)
                normalActive: "#ca2f16",
                // rgb(202, 47, 22)
                dark: "#bd2c14",
                // rgb(189, 44, 20)
                darkHover: "#972310",
                // rgb(151, 35, 16)
                darkActive: "#711b0c",
                // rgb(113, 27, 12)
                darker: "#581509" // rgb(88, 21, 9)
            }
        }
    } : {
        colors: {
            primary: {
                light: "#fefefe",
                // rgb(254, 254, 254)
                lightHover: "#fdfdfd",
                // rgb(253, 253, 253)
                lightActive: "#fbfbfb",
                // rgb(251, 251, 251)
                normal: "#f2f2f2",
                // rgb(242, 242, 242)
                normalHover: "#dadada",
                // rgb(218, 218, 218)
                normalActive: "#c2c2c2",
                // rgb(194, 194, 194)
                dark: "#b6b6b6",
                // rgb(182, 182, 182)
                darkHover: "#919191",
                // rgb(145, 145, 145)
                darkActive: "#6d6d6d",
                // rgb(109, 109, 109)
                darker: "#555555" // rgb(85, 85, 85)
            },
            secondary: {
                light: "#e7e7e7",
                // rgb(231, 231, 231)
                lightHover: "#dbdbdb",
                // rgb(219, 219, 219)
                lightActive: "#b5b5b5",
                // rgb(181, 181, 181)
                normal: "#0f0f0f",
                // rgb(15, 15, 15)
                normalHover: "#0e0e0e",
                // rgb(14, 14, 14)
                normalActive: "#0c0c0c",
                // rgb(12, 12, 12)
                dark: "#0b0b0b",
                // rgb(11, 11, 11)
                darkHover: "#090909",
                // rgb(9, 9, 9)
                darkActive: "#070707",
                // rgb(7, 7, 7)
                darker: "#050505" // rgb(5, 5, 5)
            },
            accent: {
                light: "#f3edfc",
                // rgb(243, 237, 252)
                lightHover: "#ede4fb",
                // rgb(237, 228, 251)
                lightActive: "#d9c7f7",
                // rgb(217, 199, 247)
                normal: "#864be5",
                // rgb(134, 75, 229)
                normalHover: "#7944ce",
                // rgb(121, 68, 206)
                normalActive: "#6b3cb7",
                // rgb(107, 60, 183)
                dark: "#6538ac",
                // rgb(101, 56, 172)
                darkHover: "#502d89",
                // rgb(80, 45, 137)
                darkActive: "#3c2267",
                // rgb(60, 34, 103)
                darker: "#2f1a50" // rgb(47, 26, 80)
            },
            positive: {
                light: "#e6f1e6",
                // rgb(230, 241, 230)
                lightHover: "#daead9",
                // rgb(218, 234, 217)
                lightActive: "#b2d4b1",
                // rgb(178, 212, 177)
                normal: "#077502",
                // rgb(7, 117, 2)
                normalHover: "#066902",
                // rgb(6, 105, 2)
                normalActive: "#065e02",
                // rgb(6, 94, 2)
                dark: "#055802",
                // rgb(5, 88, 2)
                darkHover: "#044601",
                // rgb(4, 70, 1)
                darkActive: "#033501",
                // rgb(3, 53, 1)
                darker: "#022901" // rgb(2, 41, 1)
            },
            negative: {
                light: "#f9e9e6",
                // rgb(249, 233, 230)
                lightHover: "#f6ddd9",
                // rgb(246, 221, 217)
                lightActive: "#ebb9b1",
                // rgb(235, 185, 177)
                normal: "#c01e04",
                // rgb(192, 30, 4)
                normalHover: "#ad1b04",
                // rgb(173, 27, 4)
                normalActive: "#9a1803",
                // rgb(154, 24, 3)
                dark: "#901703",
                // rgb(144, 23, 3)
                darkHover: "#731202",
                // rgb(115, 18, 2)
                darkActive: "#560d02",
                // rgb(86, 13, 2)
                darker: "#430b01" // rgb(67, 11, 1)
            }
        }
    };
const $a8640f2f3ac91664$export$a4e55266d2135a7f = (name)=>/*#__PURE__*/ (0, $7hler.css)("*,*::before,*::after{box-sizing:inherit;margin:0;padding:0;}html{box-sizing:border-box;font-size:62.5%;background-color:", $a8640f2f3ac91664$export$89cbf1a0881c8b9c(name).colors.primary.normal, ";overflow:hidden;@media only screen and (max-width: 48em){font-size:56.25%;}@media only screen and (max-width: 26.563em){font-size:50%;}}body{font-family:", $a8640f2f3ac91664$export$f45fbea8fe20ca8a.primary, ",sans-serif,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-size:", $a8640f2f3ac91664$export$d846a084e680d8e.p, ";font-weight:400;line-height:1.4;color:", $a8640f2f3ac91664$export$89cbf1a0881c8b9c(name).colors.secondary.normal, ";}#app{position:relative;}::selection{background:", $a8640f2f3ac91664$export$89cbf1a0881c8b9c(name).colors.accent.normal, ";color:", $a8640f2f3ac91664$export$89cbf1a0881c8b9c(name).colors.primary.normal, ";}input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active,textarea:-webkit-autofill,textarea:-webkit-autofill:hover,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:active,select:-webkit-autofill,select:-webkit-autofill:hover,select:-webkit-autofill:focus,select:-webkit-autofill:active{-webkit-transition-delay:9999s;transition-delay:9999s;}", "");

});

parcelRegister("3sxbD", function(module, exports) {

$parcel$export(module.exports, "contentLayout", function () { return $a6a44c8265e99cc0$export$f923184c0f9fe848; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $a6a44c8265e99cc0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a6a44c8265e99cc0$export$f923184c0f9fe848 = {
    home: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)("padding-right:", (0, $gln0L.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    },
    feed: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)("padding-right:", (0, $gln0L.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    },
    library: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)("padding-right:", (0, $gln0L.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    },
    charts: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)("padding-right:", (0, $gln0L.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    },
    studio: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)("padding-right:", (0, $gln0L.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    },
    user: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)("padding-right:", (0, $gln0L.constants).app.content.desktop.padding, ";", ""),
            title: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.content, ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    },
    post: {
        current: {
            main: /*#__PURE__*/ (0, $7hler.css)("overflow:hidden;padding:0px;margin:0px;", (0, $gln0L.mq).mobile({
                name: "1pgg23o",
                styles: "padding:0px;margin:0px"
            }), ";", ""),
            header: {
                main: {
                    name: "1adafot",
                    styles: "padding-right:0px;max-width:800px"
                },
                title: {
                    main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("", "")
                }
            },
            navigation: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                button: /*#__PURE__*/ (0, $7hler.css)("", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";", "")
            },
            container: {
                main: {
                    name: "ddxhyk",
                    styles: "max-width:800px"
                }
            }
        },
        create: {
            main: /*#__PURE__*/ (0, $7hler.css)("overflow:hidden;padding:0px;margin-bottom:8px;", (0, $gln0L.mq).mobile({
                name: "4e837x",
                styles: "padding:0px;margin-bottom:0px"
            }), ";", ""),
            header: {
                main: {
                    name: "v4gdnl",
                    styles: "padding-right:0px"
                },
                title: {
                    main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("", "")
                }
            },
            navigation: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                button: /*#__PURE__*/ (0, $7hler.css)("", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("overflow:hidden;width:400px;", (0, $gln0L.mq).tablet(/*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - (", (0, $gln0L.constants).app.content.desktop.padding, "*2));", "")), " ", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - (", (0, $gln0L.constants).app.content.mobile.padding, "*2));", "")), ";", "")
            },
            container: {
                main: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    },
    onboarding: {
        main: /*#__PURE__*/ (0, $7hler.css)("overflow:hidden;padding:0px;", (0, $gln0L.mq).mobile({
            name: "3tvnwt",
            styles: "margin-bottom:0px;padding:0px"
        }), ";", ""),
        header: {
            main: {
                name: "v4gdnl",
                styles: "padding-right:0px"
            },
            title: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        },
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        },
        content: {
            main: /*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - ", (0, $gln0L.constants).app.content.desktop.padding, ");overflow:hidden;", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("width:calc(100vw - (", (0, $gln0L.constants).app.content.mobile.padding, "*2));", "")), ";", "")
        },
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    }
};

});

parcelRegister("kTvpt", function(module, exports) {

$parcel$export(module.exports, "contentContainer", function () { return $c20b5c8a77024828$export$8f981dffec84ba52; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $c20b5c8a77024828$export$8f981dffec84ba52 = {
    charts: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", "")
    },
    feed: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", "")
    },
    home: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.home, ";", "")
    },
    library: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.library, ";", "")
    },
    notifications: {
        notifications: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        },
        notification: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        }
    },
    post: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
    },
    profile: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
    },
    reports: {
        reports: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        },
        report: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        },
        complaint: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        }
    },
    studio: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", ""),
        createPost: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        },
        createTrack: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        },
        editPost: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        },
        editTrack: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", (0, $gln0L.helpers).app.padding.sides, ";", "")
        }
    },
    user: {
        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.height.full, ";", "")
    }
};

});

parcelRegister("55stI", function(module, exports) {

$parcel$export(module.exports, "stripeAppearance", function () { return $1c851691db6e4580$export$f6c7b8928647b07; });
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $1c851691db6e4580$export$f6c7b8928647b07 = (theme)=>({
        theme: "night",
        // 'stripe' | 'flat'
        labels: "above",
        // 'floating'
        disableAnimations: false,
        variables: {
            // General font styles
            fontFamily: (0, $gln0L.fonts).primary,
            // fontSmooth?: string;
            // fontVariantLigatures?: string;
            // fontVariationSettings?: string;
            // fontLineHeight?: string;
            // Font sizes
            fontSizeBase: (0, $gln0L.typography).sp,
            // fontSizeSm?: string;
            // fontSizeXs?: string;
            // fontSize2Xs?: string;
            // fontSize3Xs?: string;
            // fontSizeLg?: string;
            // fontSizeXl?: string;
            // Font weights
            // fontWeightLight?: string;
            // fontWeightNormal?: string;
            // fontWeightMedium?: string;
            // fontWeightBold?: string;
            // Spacing
            // spacingUnit?: string;
            // spacingGridRow?: string;
            // spacingGridColumn?: string;
            // spacingTab?: string;
            // spacingAccordionItem?: string;
            // Colors
            colorPrimary: theme.colors.accent.normal,
            // colorPrimaryText?: string;
            colorBackground: theme.colors.primary.normal,
            // colorBackgroundText?: string;
            colorText: theme.colors.secondary.normal,
            // colorSuccess?: string;
            // colorSuccessText?: string;
            colorDanger: theme.colors.negative.normal,
            colorDangerText: theme.colors.negative.normal,
            // colorWarning?: string;
            // colorWarningText?: string;
            // Text variations
            // colorTextSecondary?: string;
            colorTextPlaceholder: theme.colors.secondary.dark,
            // Icons
            colorIcon: theme.colors.accent.normal,
            // colorIconHover?: string;
            // colorIconCardError?: string;
            // colorIconCardCvc?: string;
            // colorIconCardCvcError?: string;
            // colorIconCheckmark?: string;
            // colorIconChevronDown?: string;
            // colorIconChevronDownHover?: string;
            // colorIconRedirect?: string;
            // colorIconTab?: string;
            // colorIconTabHover?: string;
            // colorIconTabSelected?: string;
            // colorIconTabMore?: string;
            // colorIconTabMoreHover?: string;
            // Logos
            // colorLogo?: string;
            // colorLogoTab?: string;
            // colorLogoTabSelected?: string;
            // colorLogoBlock?: string;
            // Focus
            focusBoxShadow: "none",
            // focusOutline?: string,
            // Radius
            borderRadius: "14px"
        }
    });

});




parcelRegister("hn85R", function(module, exports) {

$parcel$export(module.exports, "AlertModal", function () { return $e6b728220a4f560c$export$fdc96b94563d4a64; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $brwRj = parcelRequire("brwRj");
var $6tPng = parcelRequire("6tPng");

var $kf12V = parcelRequire("kf12V");
const $e6b728220a4f560c$export$fdc96b94563d4a64 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const messages = (0, $gNvvs.useAppSelector)((0, $6tPng.alertSelectMessages));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kf12V.styles)().modal.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $kf12V.styles)().modal.content.main,
            children: messages.map((message)=>{
                const { id: messageId } = message;
                return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kf12V.styles)().modal.content.message,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $brwRj.AlertCard), {
                        alertMessage: message,
                        onTimeout: ()=>dispatch((0, $6tPng.alertRemoveMessage)({
                                messageId: messageId
                            })),
                        onCloseClick: ()=>dispatch((0, $6tPng.alertRemoveMessage)({
                                messageId: messageId
                            }))
                    })
                }, `alert-message-${messageId}`);
            })
        })
    });
};
$e6b728220a4f560c$export$fdc96b94563d4a64.propTypes = {};

});
parcelRegister("gWg0P", function(module, exports) {
$parcel$export(module.exports, "useComment", function () { return (parcelRequire("K9dw6")).useComment; });
$parcel$export(module.exports, "useConnectPayout", function () { return (parcelRequire("1MzSD")).useConnectPayout; });
$parcel$export(module.exports, "useConnectReady", function () { return (parcelRequire("iLKNg")).useConnectReady; });
$parcel$export(module.exports, "usePost", function () { return (parcelRequire("jMNnt")).usePost; });
$parcel$export(module.exports, "useSubscription", function () { return (parcelRequire("lbAL5")).useSubscription; });
$parcel$export(module.exports, "useSubscriptionPrice", function () { return (parcelRequire("lqGW0")).useSubscriptionPrice; });
$parcel$export(module.exports, "useTip", function () { return (parcelRequire("bRg8c")).useTip; });
$parcel$export(module.exports, "useTrack", function () { return (parcelRequire("i9vCv")).useTrack; });
$parcel$export(module.exports, "useTracks", function () { return (parcelRequire("6uGoQ")).useTracks; });
$parcel$export(module.exports, "useTracksPublic", function () { return (parcelRequire("ceCYx")).useTracksPublic; });
$parcel$export(module.exports, "useUnlock", function () { return (parcelRequire("5LPLy")).useUnlock; });
$parcel$export(module.exports, "useUser", function () { return (parcelRequire("gLN5L")).useUser; });
$parcel$export(module.exports, "useUserPublic", function () { return (parcelRequire("aCYwi")).useUserPublic; });
$parcel$export(module.exports, "useUsers", function () { return (parcelRequire("gBCSe")).useUsers; });
$parcel$export(module.exports, "useUserStats", function () { return (parcelRequire("lXxtV")).useUserStats; });

$parcel$export(module.exports, "useAppSelector", function () { return (parcelRequire("gNvvs")).useAppSelector; });
$parcel$export(module.exports, "useAppDispatch", function () { return (parcelRequire("2bja3")).useAppDispatch; });
$parcel$export(module.exports, "useFile", function () { return (parcelRequire("jpNoL")).useFile; });
$parcel$export(module.exports, "useInterval", function () { return (parcelRequire("7J4Vi")).useInterval; });

var $gNvvs = parcelRequire("gNvvs");

var $2bja3 = parcelRequire("2bja3");

var $jpNoL = parcelRequire("jpNoL");

var $7J4Vi = parcelRequire("7J4Vi");

var $9rd5i = parcelRequire("9rd5i");
parcelRequire("1sxw1");

});
parcelRegister("gNvvs", function(module, exports) {

$parcel$export(module.exports, "useAppSelector", function () { return $6edd57f9da44a7f7$export$a7347740d65f620b; });

var $I3ixn = parcelRequire("I3ixn");
const $6edd57f9da44a7f7$export$a7347740d65f620b = (0, $I3ixn.useSelector);

});
parcelRegister("I3ixn", function(module, exports) {

$parcel$export(module.exports, "useSelector", function () { return $0846ab1663ddc3f8$export$2105062e25df4afe; });
$parcel$export(module.exports, "Provider", function () { return $0846ab1663ddc3f8$export$2881499e37b75b9a; });
$parcel$export(module.exports, "useDispatch", function () { return $0846ab1663ddc3f8$export$8ad76b76a4c905f8; });

var $bh6RR = parcelRequire("bh6RR");

var $81Vzg = parcelRequire("81Vzg");
var $0846ab1663ddc3f8$var$__defProp = Object.defineProperty;
var $0846ab1663ddc3f8$var$__defProps = Object.defineProperties;
var $0846ab1663ddc3f8$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0846ab1663ddc3f8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0846ab1663ddc3f8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0846ab1663ddc3f8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0846ab1663ddc3f8$var$__defNormalProp = (obj, key, value)=>key in obj ? $0846ab1663ddc3f8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0846ab1663ddc3f8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0846ab1663ddc3f8$var$__hasOwnProp.call(b, prop)) $0846ab1663ddc3f8$var$__defNormalProp(a, prop, b[prop]);
    if ($0846ab1663ddc3f8$var$__getOwnPropSymbols) {
        for (var prop of $0846ab1663ddc3f8$var$__getOwnPropSymbols(b))if ($0846ab1663ddc3f8$var$__propIsEnum.call(b, prop)) $0846ab1663ddc3f8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0846ab1663ddc3f8$var$__spreadProps = (a, b)=>$0846ab1663ddc3f8$var$__defProps(a, $0846ab1663ddc3f8$var$__getOwnPropDescs(b));
var $0846ab1663ddc3f8$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($0846ab1663ddc3f8$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $0846ab1663ddc3f8$var$__getOwnPropSymbols) {
        for (var prop of $0846ab1663ddc3f8$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $0846ab1663ddc3f8$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $0846ab1663ddc3f8$var$React = // prettier-ignore
// @ts-ignore
"default" in $bh6RR ? $bh6RR["default"] : $bh6RR;
// src/components/Context.ts
var $0846ab1663ddc3f8$var$ContextKey = Symbol.for(`react-redux-context`);
var $0846ab1663ddc3f8$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $0846ab1663ddc3f8$var$getContext() {
    var _a;
    if (!$0846ab1663ddc3f8$var$React.createContext) return {};
    const contextMap = (_a = $0846ab1663ddc3f8$var$gT[$0846ab1663ddc3f8$var$ContextKey]) != null ? _a : $0846ab1663ddc3f8$var$gT[$0846ab1663ddc3f8$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($0846ab1663ddc3f8$var$React.createContext);
    if (!realContext) {
        realContext = $0846ab1663ddc3f8$var$React.createContext(null);
        contextMap.set($0846ab1663ddc3f8$var$React.createContext, realContext);
    }
    return realContext;
}
var $0846ab1663ddc3f8$export$cc80c08dc91f1c00 = /* @__PURE__ */ $0846ab1663ddc3f8$var$getContext();
// src/utils/useSyncExternalStore.ts
var $0846ab1663ddc3f8$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $0846ab1663ddc3f8$var$createReduxContextHook(context = $0846ab1663ddc3f8$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $0846ab1663ddc3f8$var$React.useContext(context);
        return contextValue;
    };
}
var $0846ab1663ddc3f8$var$useReduxContext = /* @__PURE__ */ $0846ab1663ddc3f8$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $0846ab1663ddc3f8$var$useSyncExternalStoreWithSelector = $0846ab1663ddc3f8$var$notInitialized;
var $0846ab1663ddc3f8$var$initializeUseSelector = (fn)=>{
    $0846ab1663ddc3f8$var$useSyncExternalStoreWithSelector = fn;
};
var $0846ab1663ddc3f8$var$refEquality = (a, b)=>a === b;
function $0846ab1663ddc3f8$export$2b53f90d2bd1cbfb(context = $0846ab1663ddc3f8$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $0846ab1663ddc3f8$export$cc80c08dc91f1c00 ? $0846ab1663ddc3f8$var$useReduxContext : $0846ab1663ddc3f8$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $0846ab1663ddc3f8$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $0846ab1663ddc3f8$var$React.useRef(true);
        const wrappedSelector = $0846ab1663ddc3f8$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $0846ab1663ddc3f8$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $0846ab1663ddc3f8$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $0846ab1663ddc3f8$export$2105062e25df4afe = /* @__PURE__ */ $0846ab1663ddc3f8$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $0846ab1663ddc3f8$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $0846ab1663ddc3f8$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $0846ab1663ddc3f8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $0846ab1663ddc3f8$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $0846ab1663ddc3f8$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $0846ab1663ddc3f8$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $0846ab1663ddc3f8$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $0846ab1663ddc3f8$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $0846ab1663ddc3f8$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $0846ab1663ddc3f8$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $0846ab1663ddc3f8$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $0846ab1663ddc3f8$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $0846ab1663ddc3f8$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $0846ab1663ddc3f8$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $0846ab1663ddc3f8$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $0846ab1663ddc3f8$var$ForwardRef = $0846ab1663ddc3f8$var$REACT_FORWARD_REF_TYPE;
var $0846ab1663ddc3f8$var$Memo = $0846ab1663ddc3f8$var$REACT_MEMO_TYPE;
function $0846ab1663ddc3f8$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $0846ab1663ddc3f8$var$REACT_FRAGMENT_TYPE || type === $0846ab1663ddc3f8$var$REACT_PROFILER_TYPE || type === $0846ab1663ddc3f8$var$REACT_STRICT_MODE_TYPE || type === $0846ab1663ddc3f8$var$REACT_SUSPENSE_TYPE || type === $0846ab1663ddc3f8$var$REACT_SUSPENSE_LIST_TYPE || type === $0846ab1663ddc3f8$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $0846ab1663ddc3f8$var$REACT_LAZY_TYPE || type.$$typeof === $0846ab1663ddc3f8$var$REACT_MEMO_TYPE || type.$$typeof === $0846ab1663ddc3f8$var$REACT_PROVIDER_TYPE || type.$$typeof === $0846ab1663ddc3f8$var$REACT_CONTEXT_TYPE || type.$$typeof === $0846ab1663ddc3f8$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $0846ab1663ddc3f8$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $0846ab1663ddc3f8$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $0846ab1663ddc3f8$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $0846ab1663ddc3f8$var$REACT_FRAGMENT_TYPE:
                        case $0846ab1663ddc3f8$var$REACT_PROFILER_TYPE:
                        case $0846ab1663ddc3f8$var$REACT_STRICT_MODE_TYPE:
                        case $0846ab1663ddc3f8$var$REACT_SUSPENSE_TYPE:
                        case $0846ab1663ddc3f8$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $0846ab1663ddc3f8$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $0846ab1663ddc3f8$var$REACT_CONTEXT_TYPE:
                                    case $0846ab1663ddc3f8$var$REACT_FORWARD_REF_TYPE:
                                    case $0846ab1663ddc3f8$var$REACT_LAZY_TYPE:
                                    case $0846ab1663ddc3f8$var$REACT_MEMO_TYPE:
                                    case $0846ab1663ddc3f8$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $0846ab1663ddc3f8$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $0846ab1663ddc3f8$var$isContextConsumer(object) {
    return $0846ab1663ddc3f8$var$typeOf(object) === $0846ab1663ddc3f8$var$REACT_CONTEXT_TYPE;
}
function $0846ab1663ddc3f8$var$isMemo(object) {
    return $0846ab1663ddc3f8$var$typeOf(object) === $0846ab1663ddc3f8$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $0846ab1663ddc3f8$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $0846ab1663ddc3f8$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $0846ab1663ddc3f8$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $0846ab1663ddc3f8$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $0846ab1663ddc3f8$var$verify(mapStateToProps, "mapStateToProps");
    $0846ab1663ddc3f8$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $0846ab1663ddc3f8$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $0846ab1663ddc3f8$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $0846ab1663ddc3f8$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $0846ab1663ddc3f8$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $0846ab1663ddc3f8$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $0846ab1663ddc3f8$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $0846ab1663ddc3f8$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $0846ab1663ddc3f8$var$verifyPlainObject(value, displayName, methodName) {
    if (!$0846ab1663ddc3f8$var$isPlainObject(value)) $0846ab1663ddc3f8$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $0846ab1663ddc3f8$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $0846ab1663ddc3f8$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $0846ab1663ddc3f8$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $0846ab1663ddc3f8$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $0846ab1663ddc3f8$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $0846ab1663ddc3f8$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $0846ab1663ddc3f8$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $0846ab1663ddc3f8$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $0846ab1663ddc3f8$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $0846ab1663ddc3f8$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $0846ab1663ddc3f8$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $0846ab1663ddc3f8$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $0846ab1663ddc3f8$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $0846ab1663ddc3f8$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $0846ab1663ddc3f8$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $0846ab1663ddc3f8$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $0846ab1663ddc3f8$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $0846ab1663ddc3f8$var$__spreadValues($0846ab1663ddc3f8$var$__spreadValues($0846ab1663ddc3f8$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $0846ab1663ddc3f8$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $0846ab1663ddc3f8$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$0846ab1663ddc3f8$var$defaultMergeProps : typeof mergeProps === "function" ? $0846ab1663ddc3f8$var$wrapMergePropsFunc(mergeProps) : $0846ab1663ddc3f8$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $0846ab1663ddc3f8$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $0846ab1663ddc3f8$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $0846ab1663ddc3f8$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $0846ab1663ddc3f8$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $0846ab1663ddc3f8$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $0846ab1663ddc3f8$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0846ab1663ddc3f8$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $0846ab1663ddc3f8$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $0846ab1663ddc3f8$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $0846ab1663ddc3f8$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $0846ab1663ddc3f8$var$useIsomorphicLayoutEffect = $0846ab1663ddc3f8$var$canUseDOM || $0846ab1663ddc3f8$var$isReactNative ? $0846ab1663ddc3f8$var$React.useLayoutEffect : $0846ab1663ddc3f8$var$React.useEffect;
// src/utils/shallowEqual.ts
function $0846ab1663ddc3f8$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $0846ab1663ddc3f8$export$d36bdfa510afb180(objA, objB) {
    if ($0846ab1663ddc3f8$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$0846ab1663ddc3f8$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $0846ab1663ddc3f8$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $0846ab1663ddc3f8$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $0846ab1663ddc3f8$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $0846ab1663ddc3f8$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $0846ab1663ddc3f8$var$TYPE_STATICS = {
    [$0846ab1663ddc3f8$var$ForwardRef]: $0846ab1663ddc3f8$var$FORWARD_REF_STATICS,
    [$0846ab1663ddc3f8$var$Memo]: $0846ab1663ddc3f8$var$MEMO_STATICS
};
function $0846ab1663ddc3f8$var$getStatics(component) {
    if ($0846ab1663ddc3f8$var$isMemo(component)) return $0846ab1663ddc3f8$var$MEMO_STATICS;
    return $0846ab1663ddc3f8$var$TYPE_STATICS[component["$$typeof"]] || $0846ab1663ddc3f8$var$REACT_STATICS;
}
var $0846ab1663ddc3f8$var$defineProperty = Object.defineProperty;
var $0846ab1663ddc3f8$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $0846ab1663ddc3f8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0846ab1663ddc3f8$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0846ab1663ddc3f8$var$getPrototypeOf = Object.getPrototypeOf;
var $0846ab1663ddc3f8$var$objectPrototype = Object.prototype;
function $0846ab1663ddc3f8$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($0846ab1663ddc3f8$var$objectPrototype) {
            const inheritedComponent = $0846ab1663ddc3f8$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $0846ab1663ddc3f8$var$objectPrototype) $0846ab1663ddc3f8$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $0846ab1663ddc3f8$var$getOwnPropertyNames(sourceComponent);
        if ($0846ab1663ddc3f8$var$getOwnPropertySymbols) keys = keys.concat($0846ab1663ddc3f8$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $0846ab1663ddc3f8$var$getStatics(targetComponent);
        const sourceStatics = $0846ab1663ddc3f8$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$0846ab1663ddc3f8$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $0846ab1663ddc3f8$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $0846ab1663ddc3f8$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $0846ab1663ddc3f8$var$useSyncExternalStore = $0846ab1663ddc3f8$var$notInitialized;
var $0846ab1663ddc3f8$var$initializeConnect = (fn)=>{
    $0846ab1663ddc3f8$var$useSyncExternalStore = fn;
};
var $0846ab1663ddc3f8$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $0846ab1663ddc3f8$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $0846ab1663ddc3f8$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $0846ab1663ddc3f8$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $0846ab1663ddc3f8$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $0846ab1663ddc3f8$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $0846ab1663ddc3f8$var$strictEqual(a, b) {
    return a === b;
}
var $0846ab1663ddc3f8$var$hasWarnedAboutDeprecatedPureOption = false;
function $0846ab1663ddc3f8$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $0846ab1663ddc3f8$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $0846ab1663ddc3f8$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $0846ab1663ddc3f8$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $0846ab1663ddc3f8$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $0846ab1663ddc3f8$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $0846ab1663ddc3f8$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $0846ab1663ddc3f8$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $0846ab1663ddc3f8$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $0846ab1663ddc3f8$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $0846ab1663ddc3f8$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                return $0846ab1663ddc3f8$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $0846ab1663ddc3f8$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $0846ab1663ddc3f8$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $0846ab1663ddc3f8$var$__spreadProps($0846ab1663ddc3f8$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $0846ab1663ddc3f8$var$React.useRef(void 0);
            const lastWrapperProps = $0846ab1663ddc3f8$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $0846ab1663ddc3f8$var$React.useRef(void 0);
            const renderIsScheduled = $0846ab1663ddc3f8$var$React.useRef(false);
            const isMounted = $0846ab1663ddc3f8$var$React.useRef(false);
            const latestSubscriptionCallbackError = $0846ab1663ddc3f8$var$React.useRef(void 0);
            $0846ab1663ddc3f8$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $0846ab1663ddc3f8$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $0846ab1663ddc3f8$var$useIsomorphicLayoutEffectWithArgs($0846ab1663ddc3f8$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $0846ab1663ddc3f8$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $0846ab1663ddc3f8$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $0846ab1663ddc3f8$var$React.createElement(WrappedComponent, $0846ab1663ddc3f8$var$__spreadProps($0846ab1663ddc3f8$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $0846ab1663ddc3f8$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $0846ab1663ddc3f8$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $0846ab1663ddc3f8$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $0846ab1663ddc3f8$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $0846ab1663ddc3f8$var$React.createElement(Connect, $0846ab1663ddc3f8$var$__spreadProps($0846ab1663ddc3f8$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $0846ab1663ddc3f8$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $0846ab1663ddc3f8$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $0846ab1663ddc3f8$export$64605811ab45167f = $0846ab1663ddc3f8$var$connect;
// src/components/Provider.tsx
function $0846ab1663ddc3f8$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $0846ab1663ddc3f8$var$React.useMemo(()=>{
        const subscription = $0846ab1663ddc3f8$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $0846ab1663ddc3f8$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $0846ab1663ddc3f8$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $0846ab1663ddc3f8$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $0846ab1663ddc3f8$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $0846ab1663ddc3f8$export$2881499e37b75b9a = $0846ab1663ddc3f8$var$Provider;
// src/hooks/useStore.ts
function $0846ab1663ddc3f8$export$671dba69185d0304(context = $0846ab1663ddc3f8$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $0846ab1663ddc3f8$export$cc80c08dc91f1c00 ? $0846ab1663ddc3f8$var$useReduxContext : // @ts-ignore
    $0846ab1663ddc3f8$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $0846ab1663ddc3f8$export$6ccbb43953eebf8 = /* @__PURE__ */ $0846ab1663ddc3f8$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $0846ab1663ddc3f8$export$bc9b55530897c558(context = $0846ab1663ddc3f8$export$cc80c08dc91f1c00) {
    const useStore2 = context === $0846ab1663ddc3f8$export$cc80c08dc91f1c00 ? $0846ab1663ddc3f8$export$6ccbb43953eebf8 : $0846ab1663ddc3f8$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $0846ab1663ddc3f8$export$8ad76b76a4c905f8 = /* @__PURE__ */ $0846ab1663ddc3f8$export$bc9b55530897c558();
// src/exports.ts
var $0846ab1663ddc3f8$export$712ea50be43a7858 = $0846ab1663ddc3f8$var$defaultNoopBatch;
// src/index.ts
$0846ab1663ddc3f8$var$initializeUseSelector((0, $81Vzg.useSyncExternalStoreWithSelector));
$0846ab1663ddc3f8$var$initializeConnect($bh6RR.useSyncExternalStore);

});
parcelRegister("81Vzg", function(module, exports) {
"use strict";

module.exports = (parcelRequire("87sJk"));

});



parcelRegister("2bja3", function(module, exports) {

$parcel$export(module.exports, "useAppDispatch", function () { return $1d9ca7ef0382fdf7$export$f51d452c10d5b956; });

var $I3ixn = parcelRequire("I3ixn");
const $1d9ca7ef0382fdf7$export$f51d452c10d5b956 = (0, $I3ixn.useDispatch);

});

parcelRegister("jpNoL", function(module, exports) {

$parcel$export(module.exports, "useFile", function () { return $95dff7a06db647b2$export$1ad42cf9b00bda68; });
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
const $95dff7a06db647b2$export$1ad42cf9b00bda68 = (fileId, userId)=>{
    const { basePath: basePath } = (0, $dOAPA.apiGetService)();
    // if user id provided
    if (userId) return `${basePath}/file/public/file/url?fileId=${fileId}&userId=${userId}`;
    return `${basePath}/file/public/file/url?fileId=${fileId}`;
};

});
parcelRegister("fWtjF", function(module, exports) {

$parcel$export(module.exports, "apiGetService", function () { return (parcelRequire("dOAPA")).apiGetService; });
$parcel$export(module.exports, "apiHandleError", function () { return (parcelRequire("dOAPA")).apiHandleError; });
$parcel$export(module.exports, "dateGetDifferenceSec", function () { return (parcelRequire("fIhuQ")).dateGetDifferenceSec; });
$parcel$export(module.exports, "firebaseSignupWithEmailAndPassword", function () { return (parcelRequire("2VHep")).firebaseSignupWithEmailAndPassword; });
$parcel$export(module.exports, "firebaseLoginWithEmailAndPassword", function () { return (parcelRequire("2VHep")).firebaseLoginWithEmailAndPassword; });
$parcel$export(module.exports, "firebaseLoginWithGoogle", function () { return (parcelRequire("2VHep")).firebaseLoginWithGoogle; });
$parcel$export(module.exports, "firebaseLoginWithFacebook", function () { return (parcelRequire("2VHep")).firebaseLoginWithFacebook; });
$parcel$export(module.exports, "firebaseSendPasswordResetEmail", function () { return (parcelRequire("2VHep")).firebaseSendPasswordResetEmail; });
$parcel$export(module.exports, "firebaseSendVerificationEmail", function () { return (parcelRequire("2VHep")).firebaseSendVerificationEmail; });
$parcel$export(module.exports, "firebaseGetEmailVerified", function () { return (parcelRequire("2VHep")).firebaseGetEmailVerified; });
$parcel$export(module.exports, "firebaseSignout", function () { return (parcelRequire("2VHep")).firebaseSignout; });
$parcel$export(module.exports, "jwtDecode", function () { return (parcelRequire("1zjiQ")).jwtDecode; });
$parcel$export(module.exports, "jwtGetExpiresInDays", function () { return (parcelRequire("1zjiQ")).jwtGetExpiresInDays; });
$parcel$export(module.exports, "storageGetAuthToken", function () { return (parcelRequire("29At8")).storageGetAuthToken; });
$parcel$export(module.exports, "storageSetAuthToken", function () { return (parcelRequire("29At8")).storageSetAuthToken; });
$parcel$export(module.exports, "storageGetSentPasswordResetEmailDate", function () { return (parcelRequire("29At8")).storageGetSentPasswordResetEmailDate; });
$parcel$export(module.exports, "storageSetSentPasswordResetEmailDate", function () { return (parcelRequire("29At8")).storageSetSentPasswordResetEmailDate; });
$parcel$export(module.exports, "storageGetSentVerificationEmailDate", function () { return (parcelRequire("29At8")).storageGetSentVerificationEmailDate; });
$parcel$export(module.exports, "storageSetSentVerificationEmailDate", function () { return (parcelRequire("29At8")).storageSetSentVerificationEmailDate; });

var $dOAPA = parcelRequire("dOAPA");

var $fIhuQ = parcelRequire("fIhuQ");

var $2VHep = parcelRequire("2VHep");

var $1zjiQ = parcelRequire("1zjiQ");

var $29At8 = parcelRequire("29At8");

});
parcelRegister("dOAPA", function(module, exports) {

$parcel$export(module.exports, "apiGetService", function () { return $c5c9afd7c1be3c5b$export$c8e00e6ceb81bfe0; });
$parcel$export(module.exports, "apiHandleError", function () { return $c5c9afd7c1be3c5b$export$e060db9f039c9353; });
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
var $7ppL5 = parcelRequire("7ppL5");
parcelRequire("krTeD");
var $dDlhU = parcelRequire("dDlhU");
var $2zawF = parcelRequire("2zawF");
parcelRequire("fWtjF");
var $29At8 = parcelRequire("29At8");
/**
 * Creates new instance of api client.
 *
 * Takes api base path and jwt token, returns api service.
 *
 * @param {string} basePath - API base path.
 * @param {number} apiKey - API authentication token (JWT).
 * @returns {number} The sum of the two input numbers.
 *
 * @example
 * // Returns api service.
 * const apiService = createApiService('https://api.example.com/api/v1', 'eyJhbGciOiJI...');
 */ const $c5c9afd7c1be3c5b$var$apiCreateService = (basePath, apiKey)=>({
        basePath: basePath,
        authApi: new (0, $2gpGl.AuthApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        commentApi: new (0, $2gpGl.CommentApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        connectApi: new (0, $2gpGl.ConnectApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        customerApi: new (0, $2gpGl.CustomerApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        fileApi: new (0, $2gpGl.FileApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        likeApi: new (0, $2gpGl.LikeApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        notificationApi: new (0, $2gpGl.NotificationApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        postApi: new (0, $2gpGl.PostApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        reportApi: new (0, $2gpGl.ReportApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        streamApi: new (0, $2gpGl.StreamApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        subscriptionApi: new (0, $2gpGl.SubscriptionApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        tipApi: new (0, $2gpGl.TipApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        trackApi: new (0, $2gpGl.TrackApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        transactionApi: new (0, $2gpGl.TransactionApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        unlockApi: new (0, $2gpGl.UnlockApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        })),
        userApi: new (0, $2gpGl.UserApi)(new (0, $7ppL5.Configuration)({
            apiKey: apiKey,
            basePath: basePath
        }))
    });
// cachedApiService - represents cached api service.
let $c5c9afd7c1be3c5b$var$cachedApiService;
const $c5c9afd7c1be3c5b$export$c8e00e6ceb81bfe0 = ()=>{
    // get api url based on environment
    const basePath = "staging" === (0, $2zawF.Environment).Production ? (0, $dDlhU.API).ProductionURL : (0, $dDlhU.API).StagingURL;
    // if no api service in cache
    if (!$c5c9afd7c1be3c5b$var$cachedApiService) {
        const apiKey = (0, $29At8.storageGetAuthToken)();
        // create api service and cache it
        $c5c9afd7c1be3c5b$var$cachedApiService = $c5c9afd7c1be3c5b$var$apiCreateService(basePath, apiKey ? `Bearer ${apiKey}` : "");
    }
    // updateApiKey - recreates api service with new authentication token and updates cache.
    const updateApiKey = (apiKey)=>{
        $c5c9afd7c1be3c5b$var$cachedApiService = $c5c9afd7c1be3c5b$var$apiCreateService(basePath, `Bearer ${apiKey}`);
        // return api service and update function.
        return {
            ...$c5c9afd7c1be3c5b$var$cachedApiService,
            updateApiKey: updateApiKey
        };
    };
    // return api service and update function.
    return {
        ...$c5c9afd7c1be3c5b$var$cachedApiService,
        updateApiKey: updateApiKey
    };
};
const $c5c9afd7c1be3c5b$export$e060db9f039c9353 = async (err, context)=>{
    // if error of type response
    if (err instanceof Response) {
        // parse error
        const data = await err.json();
        const errorCode = err.status;
        const errorMessage = context ? `${context}: ${data.error}` : data.error;
        // if error severity is high
        if (errorCode >= 500) console.error(err); // eslint-disable-line no-console
        console.debug(err); // eslint-disable-line no-console
        return {
            code: errorCode,
            message: errorMessage
        };
    }
    // if error is unknown
    const errorMessage = context ? `${context}: ${err.message}` : err.message;
    console.error(err); // eslint-disable-line no-console
    return {
        code: 0,
        message: errorMessage
    };
};

});
parcelRegister("krTeD", function(module, exports) {

$parcel$export(module.exports, "API", function () { return (parcelRequire("dDlhU")).API; });
$parcel$export(module.exports, "Environment", function () { return (parcelRequire("2zawF")).Environment; });
$parcel$export(module.exports, "ExternalLinks", function () { return (parcelRequire("dkzpd")).ExternalLinks; });
$parcel$export(module.exports, "Path", function () { return (parcelRequire("b7fnN")).Path; });
$parcel$export(module.exports, "Params", function () { return (parcelRequire("b7fnN")).Params; });
$parcel$export(module.exports, "Platform", function () { return (parcelRequire("itzfe")).Platform; });
$parcel$export(module.exports, "StorageKeys", function () { return (parcelRequire("y15Yn")).StorageKeys; });
$parcel$export(module.exports, "minCommentMessageLength", function () { return (parcelRequire("auEWN")).minCommentMessageLength; });
$parcel$export(module.exports, "maxCommentMessageLength", function () { return (parcelRequire("auEWN")).maxCommentMessageLength; });
$parcel$export(module.exports, "minTipAmount", function () { return (parcelRequire("lygIl")).minTipAmount; });
$parcel$export(module.exports, "maxTipAmount", function () { return (parcelRequire("lygIl")).maxTipAmount; });
$parcel$export(module.exports, "minTipMessageLength", function () { return (parcelRequire("lygIl")).minTipMessageLength; });
$parcel$export(module.exports, "maxTipMessageLength", function () { return (parcelRequire("lygIl")).maxTipMessageLength; });
$parcel$export(module.exports, "minReportComplaintLength", function () { return (parcelRequire("512kQ")).minReportComplaintLength; });
$parcel$export(module.exports, "maxReportComplaintLength", function () { return (parcelRequire("512kQ")).maxReportComplaintLength; });
$parcel$export(module.exports, "complaintTypeSelectOptions", function () { return (parcelRequire("512kQ")).complaintTypeSelectOptions; });
$parcel$export(module.exports, "minPostMessageLength", function () { return (parcelRequire("i0PvU")).minPostMessageLength; });
$parcel$export(module.exports, "maxPostMessageLength", function () { return (parcelRequire("i0PvU")).maxPostMessageLength; });
$parcel$export(module.exports, "minPostUnlockPrice", function () { return (parcelRequire("i0PvU")).minPostUnlockPrice; });
$parcel$export(module.exports, "maxPostUnlockPrice", function () { return (parcelRequire("i0PvU")).maxPostUnlockPrice; });
$parcel$export(module.exports, "maxPostTracksCount", function () { return (parcelRequire("i0PvU")).maxPostTracksCount; });
$parcel$export(module.exports, "maxPostMediaFileSize", function () { return (parcelRequire("i0PvU")).maxPostMediaFileSize; });
$parcel$export(module.exports, "minTrackNameLength", function () { return (parcelRequire("9srzl")).minTrackNameLength; });
$parcel$export(module.exports, "maxTrackNameLength", function () { return (parcelRequire("9srzl")).maxTrackNameLength; });
$parcel$export(module.exports, "minTrackUnlockPrice", function () { return (parcelRequire("9srzl")).minTrackUnlockPrice; });
$parcel$export(module.exports, "maxTrackUnlockPrice", function () { return (parcelRequire("9srzl")).maxTrackUnlockPrice; });
$parcel$export(module.exports, "maxTrackCoverFileSize", function () { return (parcelRequire("9srzl")).maxTrackCoverFileSize; });
$parcel$export(module.exports, "maxTrackFileSize", function () { return (parcelRequire("9srzl")).maxTrackFileSize; });
$parcel$export(module.exports, "minUserNameLength", function () { return (parcelRequire("620EQ")).minUserNameLength; });
$parcel$export(module.exports, "maxUserNameLength", function () { return (parcelRequire("620EQ")).maxUserNameLength; });
$parcel$export(module.exports, "minUserUsernameLength", function () { return (parcelRequire("620EQ")).minUserUsernameLength; });
$parcel$export(module.exports, "maxUserUsernameLength", function () { return (parcelRequire("620EQ")).maxUserUsernameLength; });
$parcel$export(module.exports, "minUserPasswordLength", function () { return (parcelRequire("620EQ")).minUserPasswordLength; });
$parcel$export(module.exports, "maxUserAvatarFileSize", function () { return (parcelRequire("620EQ")).maxUserAvatarFileSize; });
$parcel$export(module.exports, "firebaseConfigProd", function () { return (parcelRequire("6xz2K")).firebaseConfigProd; });
$parcel$export(module.exports, "firebaseConfigStag", function () { return (parcelRequire("6xz2K")).firebaseConfigStag; });
$parcel$export(module.exports, "musicGenres", function () { return (parcelRequire("cGp48")).musicGenres; });
$parcel$export(module.exports, "maxTrackGenresCount", function () { return (parcelRequire("cGp48")).maxTrackGenresCount; });
$parcel$export(module.exports, "maxUserPreferredGenresCount", function () { return (parcelRequire("cGp48")).maxUserPreferredGenresCount; });
$parcel$export(module.exports, "stripePublishableKeyProd", function () { return (parcelRequire("dypeb")).stripePublishableKeyProd; });
$parcel$export(module.exports, "stripePublishableKeyStag", function () { return (parcelRequire("dypeb")).stripePublishableKeyStag; });

var $dDlhU = parcelRequire("dDlhU");

var $2zawF = parcelRequire("2zawF");

var $dkzpd = parcelRequire("dkzpd");

var $b7fnN = parcelRequire("b7fnN");

var $itzfe = parcelRequire("itzfe");

var $y15Yn = parcelRequire("y15Yn");

var $auEWN = parcelRequire("auEWN");

var $lygIl = parcelRequire("lygIl");

var $512kQ = parcelRequire("512kQ");

var $i0PvU = parcelRequire("i0PvU");

var $9srzl = parcelRequire("9srzl");

var $620EQ = parcelRequire("620EQ");

var $6xz2K = parcelRequire("6xz2K");

var $cGp48 = parcelRequire("cGp48");

var $dypeb = parcelRequire("dypeb");

});
parcelRegister("dDlhU", function(module, exports) {

$parcel$export(module.exports, "API", function () { return $048b519f87098b51$export$2c4e825dc9120f87; });
var $048b519f87098b51$export$2c4e825dc9120f87;
(function(API) {
    API["LocalURL"] = "http://127.0.0.1/api/v1";
    API["StagingURL"] = "https://stag.api.ryddm.com/api/v1";
    API["ProductionURL"] = "https://api.ryddm.com/api/v1";
})($048b519f87098b51$export$2c4e825dc9120f87 || ($048b519f87098b51$export$2c4e825dc9120f87 = {}));

});

parcelRegister("2zawF", function(module, exports) {

$parcel$export(module.exports, "Environment", function () { return $d0b1297b73a835a3$export$7dc6752a22ab011a; });
var $d0b1297b73a835a3$export$7dc6752a22ab011a;
(function(Environment) {
    Environment["Production"] = "production";
    Environment["Staging"] = "staging";
})($d0b1297b73a835a3$export$7dc6752a22ab011a || ($d0b1297b73a835a3$export$7dc6752a22ab011a = {}));

});

parcelRegister("dkzpd", function(module, exports) {

$parcel$export(module.exports, "ExternalLinks", function () { return $4cfb5c08ba8b290e$export$7c6fdaf98295312b; });
var $4cfb5c08ba8b290e$export$7c6fdaf98295312b;
(function(ExternalLinks) {
    ExternalLinks["TermsOfUse"] = "https://ryddm.com/terms";
    ExternalLinks["PrivacyPolicy"] = "https://ryddm.com/privacy-policy";
    ExternalLinks["FAQ"] = "https://support.ryddm.com/support/home";
    ExternalLinks["Support"] = "https://support.ryddm.com/support/home";
    ExternalLinks["Contacts"] = "https://support.ryddm.com/support/home";
})($4cfb5c08ba8b290e$export$7c6fdaf98295312b || ($4cfb5c08ba8b290e$export$7c6fdaf98295312b = {}));

});

parcelRegister("b7fnN", function(module, exports) {

$parcel$export(module.exports, "Path", function () { return $ca5609bd62c96a71$export$4b2950bdac9b6ee9; });
$parcel$export(module.exports, "Params", function () { return $ca5609bd62c96a71$export$e34ec06faf1ca435; });
var $ca5609bd62c96a71$export$4b2950bdac9b6ee9;
(function(Path) {
    Path["Home"] = "/";
    Path["Feed"] = "/";
    Path["Library"] = "/library";
    Path["Charts"] = "/charts";
    Path["Studio"] = "/studio";
    Path["Reports"] = "/reports";
    Path["Profile"] = "/profile";
    Path["Notifications"] = "/notifications";
    Path["User"] = "/user";
    Path["Post"] = "/post";
    Path["Track"] = "/track";
    Path["Report"] = "/report";
    Path["Complaint"] = "/complaint";
    Path["Notification"] = "/notification";
})($ca5609bd62c96a71$export$4b2950bdac9b6ee9 || ($ca5609bd62c96a71$export$4b2950bdac9b6ee9 = {}));
var $ca5609bd62c96a71$export$e34ec06faf1ca435;
(function(Params) {
    Params["UserID"] = ":userId";
    Params["PostID"] = ":postId";
    Params["TrackID"] = ":trackId";
    Params["ReportID"] = ":reportId";
    Params["ReportComplaintID"] = ":reportComplaintId";
    Params["NotificationID"] = ":notificationId";
})($ca5609bd62c96a71$export$e34ec06faf1ca435 || ($ca5609bd62c96a71$export$e34ec06faf1ca435 = {}));

});

parcelRegister("itzfe", function(module, exports) {

$parcel$export(module.exports, "Platform", function () { return $bcbd777974760c81$export$2dffd0b5373a4389; });
var $bcbd777974760c81$export$2dffd0b5373a4389;
(function(Platform) {
    Platform["LocalURL"] = "http://127.0.0.1:1234";
    Platform["StagingURL"] = "https://stag.platform.ryddm.com/";
    Platform["ProductionURL"] = "https://platform.ryddm.com/";
})($bcbd777974760c81$export$2dffd0b5373a4389 || ($bcbd777974760c81$export$2dffd0b5373a4389 = {}));

});

parcelRegister("y15Yn", function(module, exports) {

$parcel$export(module.exports, "StorageKeys", function () { return $2f853f2e20aed726$export$25c0d5b425a20ec; });
var $2f853f2e20aed726$export$25c0d5b425a20ec;
(function(StorageKeys) {
    StorageKeys["AuthToken"] = "@ryddm/authToken";
    StorageKeys["SentPasswordResetEmailDate"] = "@ryddm/sentPasswordResetDate";
    StorageKeys["SentVerificationEmailDate"] = "@ryddm/sentVerificationEmailDate";
})($2f853f2e20aed726$export$25c0d5b425a20ec || ($2f853f2e20aed726$export$25c0d5b425a20ec = {}));

});

parcelRegister("auEWN", function(module, exports) {

$parcel$export(module.exports, "minCommentMessageLength", function () { return $1de5a2235a85bf42$export$6bdaa109ce5cf1a0; });
$parcel$export(module.exports, "maxCommentMessageLength", function () { return $1de5a2235a85bf42$export$4d7981eb409a1905; });
// updating this values will also require to update regex
// in @/utils/validateCommentMessage
const $1de5a2235a85bf42$export$6bdaa109ce5cf1a0 = 1;
const $1de5a2235a85bf42$export$4d7981eb409a1905 = 1000;

});

parcelRegister("lygIl", function(module, exports) {

$parcel$export(module.exports, "minTipAmount", function () { return $44fd65b787a9e8d6$export$e4f0b0abb9ecb430; });
$parcel$export(module.exports, "maxTipAmount", function () { return $44fd65b787a9e8d6$export$8f6d62c74ec1e8f5; });
$parcel$export(module.exports, "minTipMessageLength", function () { return $44fd65b787a9e8d6$export$65c0e97e026435f; });
$parcel$export(module.exports, "maxTipMessageLength", function () { return $44fd65b787a9e8d6$export$32070f15de013c49; });
const $44fd65b787a9e8d6$export$e4f0b0abb9ecb430 = 1;
const $44fd65b787a9e8d6$export$8f6d62c74ec1e8f5 = 9;
const $44fd65b787a9e8d6$export$65c0e97e026435f = 1;
const $44fd65b787a9e8d6$export$32070f15de013c49 = 256;

});

parcelRegister("512kQ", function(module, exports) {

$parcel$export(module.exports, "minReportComplaintLength", function () { return $b67dba8a6613c5d7$export$603a6ab7cb18c160; });
$parcel$export(module.exports, "maxReportComplaintLength", function () { return $b67dba8a6613c5d7$export$afd48bc32b8d2ec7; });
$parcel$export(module.exports, "complaintTypeSelectOptions", function () { return $b67dba8a6613c5d7$export$17e62d63f017d71; });
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
const $b67dba8a6613c5d7$export$603a6ab7cb18c160 = 1;
const $b67dba8a6613c5d7$export$afd48bc32b8d2ec7 = 256;
const $b67dba8a6613c5d7$export$17e62d63f017d71 = [
    {
        id: "complaint-type-select-option-child-abuse",
        label: "Child Abuse",
        value: (0, $2gpGl.EntityReportComplaintType).ChildAbuse.toString()
    },
    {
        id: "complaint-type-select-option-copyright",
        label: "Copyright",
        value: (0, $2gpGl.EntityReportComplaintType).Copyright.toString()
    },
    {
        id: "complaint-type-select-option-fake",
        label: "Fake",
        value: (0, $2gpGl.EntityReportComplaintType).Fake.toString()
    },
    {
        id: "complaint-type-select-option-pornography",
        label: "Pornography",
        value: (0, $2gpGl.EntityReportComplaintType).Pornography.toString()
    },
    {
        id: "complaint-type-select-option-spam",
        label: "Spam",
        value: (0, $2gpGl.EntityReportComplaintType).Spam.toString()
    },
    {
        id: "complaint-type-select-option-violence",
        label: "Violence",
        value: (0, $2gpGl.EntityReportComplaintType).Violence.toString()
    }
];

});

parcelRegister("i0PvU", function(module, exports) {

$parcel$export(module.exports, "minPostMessageLength", function () { return $f8e0c0ed12dd4574$export$cd306cf9192f67d1; });
$parcel$export(module.exports, "maxPostMessageLength", function () { return $f8e0c0ed12dd4574$export$7054c88eaa8ac11a; });
$parcel$export(module.exports, "minPostUnlockPrice", function () { return $f8e0c0ed12dd4574$export$8fcba1b80435648c; });
$parcel$export(module.exports, "maxPostUnlockPrice", function () { return $f8e0c0ed12dd4574$export$3c2ad8f014095a5f; });
$parcel$export(module.exports, "maxPostTracksCount", function () { return $f8e0c0ed12dd4574$export$7e624277da3962ed; });
$parcel$export(module.exports, "maxPostMediaFileSize", function () { return $f8e0c0ed12dd4574$export$15d917db408e8a19; });
// updating this values will also require to update regex
// in @/utils/validatePostMessage
const $f8e0c0ed12dd4574$export$cd306cf9192f67d1 = 3;
const $f8e0c0ed12dd4574$export$7054c88eaa8ac11a = 1000;
const $f8e0c0ed12dd4574$export$8fcba1b80435648c = 1;
const $f8e0c0ed12dd4574$export$3c2ad8f014095a5f = 9;
const $f8e0c0ed12dd4574$export$7e624277da3962ed = 8;
const $f8e0c0ed12dd4574$export$15d917db408e8a19 = 33554432;

});

parcelRegister("9srzl", function(module, exports) {

$parcel$export(module.exports, "minTrackNameLength", function () { return $bbfabd05c30ed2e4$export$e0f090e5dcb713a; });
$parcel$export(module.exports, "maxTrackNameLength", function () { return $bbfabd05c30ed2e4$export$fd6b151279299f8a; });
$parcel$export(module.exports, "minTrackUnlockPrice", function () { return $bbfabd05c30ed2e4$export$da4ccd4f42c5c84c; });
$parcel$export(module.exports, "maxTrackUnlockPrice", function () { return $bbfabd05c30ed2e4$export$d8ccefa8e242ed5f; });
$parcel$export(module.exports, "maxTrackCoverFileSize", function () { return $bbfabd05c30ed2e4$export$9b69e6ad1faf4fca; });
$parcel$export(module.exports, "maxTrackFileSize", function () { return $bbfabd05c30ed2e4$export$8dc9f88d282540cc; });
// updating this values will also require to update regex
// in @/utils/validateTrackName
const $bbfabd05c30ed2e4$export$e0f090e5dcb713a = 3;
const $bbfabd05c30ed2e4$export$fd6b151279299f8a = 100;
const $bbfabd05c30ed2e4$export$da4ccd4f42c5c84c = 1;
const $bbfabd05c30ed2e4$export$d8ccefa8e242ed5f = 9;
const $bbfabd05c30ed2e4$export$9b69e6ad1faf4fca = 8388608;
const $bbfabd05c30ed2e4$export$8dc9f88d282540cc = 25165824;

});

parcelRegister("620EQ", function(module, exports) {

$parcel$export(module.exports, "minUserUsernameLength", function () { return $6d4b1bc31335dc08$export$e49088c05a658209; });
$parcel$export(module.exports, "maxUserUsernameLength", function () { return $6d4b1bc31335dc08$export$9455dadea84e3fa6; });
$parcel$export(module.exports, "minUserNameLength", function () { return $6d4b1bc31335dc08$export$8bf390e4fd663ba; });
$parcel$export(module.exports, "maxUserNameLength", function () { return $6d4b1bc31335dc08$export$b4608afd32bdba85; });
$parcel$export(module.exports, "minUserPasswordLength", function () { return $6d4b1bc31335dc08$export$6c613d41c23a148a; });
$parcel$export(module.exports, "maxUserAvatarFileSize", function () { return $6d4b1bc31335dc08$export$a09ffeb911428ff; });
// updating this values will also require to update regex
// in @/utils/validateUsername
const $6d4b1bc31335dc08$export$e49088c05a658209 = 3;
const $6d4b1bc31335dc08$export$9455dadea84e3fa6 = 16;
const $6d4b1bc31335dc08$export$8bf390e4fd663ba = 3;
const $6d4b1bc31335dc08$export$b4608afd32bdba85 = 100;
const $6d4b1bc31335dc08$export$6c613d41c23a148a = 8;
const $6d4b1bc31335dc08$export$a09ffeb911428ff = 33554432;

});

parcelRegister("6xz2K", function(module, exports) {

$parcel$export(module.exports, "firebaseConfigProd", function () { return $8fbc0296f6fd3b07$export$3c07b9a4ab489d13; });
$parcel$export(module.exports, "firebaseConfigStag", function () { return $8fbc0296f6fd3b07$export$260f1a7b6f980f91; });
const $8fbc0296f6fd3b07$export$3c07b9a4ab489d13 = {
    apiKey: "AIzaSyDuYj58qK8qf4Dz_5nDRjLTE5v_HZyKv5k",
    authDomain: "ryddm-286615.firebaseapp.com",
    databaseURL: "https://ryddm-286615.firebaseio.com",
    projectId: "ryddm-286615",
    storageBucket: "ryddm-286615.appspot.com",
    messagingSenderId: "864316200417",
    appId: "1:864316200417:web:ffe830cc68e0b3f34aeea0",
    measurementId: "G-MBKVM74PPX"
};
const $8fbc0296f6fd3b07$export$260f1a7b6f980f91 = {
    apiKey: "AIzaSyA_2ysu-qullegzw23n7MuVmGKlSO_t4kk",
    authDomain: "ryddmstaging.firebaseapp.com",
    projectId: "ryddmstaging",
    storageBucket: "ryddmstaging.appspot.com",
    messagingSenderId: "1057102064949",
    appId: "1:1057102064949:web:ff160f543d306fbd23707c",
    measurementId: "G-FRSWWVMQJH"
};

});

parcelRegister("cGp48", function(module, exports) {

$parcel$export(module.exports, "musicGenres", function () { return $547cdda0f165a7c6$export$a2ded38cb48fcc09; });
$parcel$export(module.exports, "maxTrackGenresCount", function () { return $547cdda0f165a7c6$export$529919e62a58ddc5; });
$parcel$export(module.exports, "maxUserPreferredGenresCount", function () { return $547cdda0f165a7c6$export$c7dbd472abd43187; });
const $547cdda0f165a7c6$export$a2ded38cb48fcc09 = [
    "Rock",
    "Metal",
    "Alternative",
    "Hip-Hop",
    "Rap",
    "Dance",
    "EDM",
    "Classical",
    "Country",
    "Folk",
    "Jazz",
    "Indie",
    "Industrial",
    "Instrumental",
    "World",
    "Trap",
    "R&B",
    "New Age",
    "Christian",
    "Synthwave",
    "Children Music",
    "Acoustic",
    "Bass",
    "Blues",
    "Electronic",
    "Future Bass",
    "Holiday",
    "House",
    "Latin",
    "Pop",
    "Reggae",
    "Rockabilly"
];
const $547cdda0f165a7c6$export$529919e62a58ddc5 = 2;
const $547cdda0f165a7c6$export$c7dbd472abd43187 = 3;

});

parcelRegister("dypeb", function(module, exports) {

$parcel$export(module.exports, "stripePublishableKeyProd", function () { return $e1c562b61279f027$export$95c96e49940ef90d; });
$parcel$export(module.exports, "stripePublishableKeyStag", function () { return $e1c562b61279f027$export$5f8822679672cb43; });
const $e1c562b61279f027$export$95c96e49940ef90d = "pk_live_51HzOCtAnIc3UbsjuaGNKzCiEDhWXoErBBMML7aJMaZFdwO4Vx5XTxjWHRwmfCYaxq4BaePaV9YxWu1nF5eDUdsPz00w9uJzooQ";
const $e1c562b61279f027$export$5f8822679672cb43 = "pk_test_51HzOCtAnIc3Ubsju2mZYS2u0aMAiNzqHVCcpYeYlu0G3dJUrJYTEtMXtEKt7kL3uxpBcq8Tldfhnh2Jy1ZrHUdim00bpU8xFY7";

});



parcelRegister("fIhuQ", function(module, exports) {

$parcel$export(module.exports, "dateGetDifferenceSec", function () { return $85ce4b4628c05f64$export$fae9e2fd8565e6a9; });
/**
 * Calculates difference in seconds between provided dates.
 *
 * Takes past and current data as params, returns difference in seconds.
 *
 * @param {number} pastDate - Date in milliseconds elapsed since the epoch.
 * @param {number} currentDate - Date in milliseconds elapsed since the epoch (default is current date).
 * @returns {number} - Difference between dates in seconds.
 *
 * @example
 * // Returns difference between two dates in seconds.
 * const lastPasswordResetSec = dateGetDifferenceSec(lastIssuedDate);
 */ const $85ce4b4628c05f64$export$fae9e2fd8565e6a9 = (pastDate, currentDate = Date.now())=>Math.floor((currentDate - pastDate) / 1000);

});

parcelRegister("2VHep", function(module, exports) {

$parcel$export(module.exports, "firebaseSignupWithEmailAndPassword", function () { return $4b2ff82a5e5884ae$export$1ed15408b0c36796; });
$parcel$export(module.exports, "firebaseLoginWithEmailAndPassword", function () { return $4b2ff82a5e5884ae$export$7ea3f81a63d06d2d; });
$parcel$export(module.exports, "firebaseLoginWithGoogle", function () { return $4b2ff82a5e5884ae$export$596dddd43d76a76c; });
$parcel$export(module.exports, "firebaseLoginWithFacebook", function () { return $4b2ff82a5e5884ae$export$27ab9db94af63bd7; });
$parcel$export(module.exports, "firebaseSendPasswordResetEmail", function () { return $4b2ff82a5e5884ae$export$bc2f170a1316cdef; });
$parcel$export(module.exports, "firebaseSendVerificationEmail", function () { return $4b2ff82a5e5884ae$export$676c02462de282f; });
$parcel$export(module.exports, "firebaseSignout", function () { return $4b2ff82a5e5884ae$export$ce2b67b6cbba1984; });
$parcel$export(module.exports, "firebaseGetEmailVerified", function () { return $4b2ff82a5e5884ae$export$2571cb1371ffdb4a; });
// Import the functions you need from the SDKs you need
parcelRequire("gKkQl");
var $ix4Jr = parcelRequire("ix4Jr");
parcelRequire("eyjy7");
var $gOZuL = parcelRequire("gOZuL");
parcelRequire("krTeD");
var $2zawF = parcelRequire("2zawF");
var $6xz2K = parcelRequire("6xz2K");

var $hpy7I = parcelRequire("hpy7I");
// initialize firebase app
const $4b2ff82a5e5884ae$var$app = (0, $ix4Jr.initializeApp)("staging" === (0, $2zawF.Environment).Production ? (0, $6xz2K.firebaseConfigProd) : (0, $6xz2K.firebaseConfigStag));
// initialize firebase analytics
// export const firebaseAnalytics = getAnalytics(app)
// initialize firebase authentication
const $4b2ff82a5e5884ae$var$firebaseAuth = (0, $gOZuL.o)($4b2ff82a5e5884ae$var$app);
$4b2ff82a5e5884ae$var$firebaseAuth.useDeviceLanguage();
// firebaseHandleError - handles firebase errors.
const $4b2ff82a5e5884ae$var$firebaseHandleError = (err)=>{
    // retrieve firebase error message
    const errorCode = err?.code;
    const errorMessage = (0, $hpy7I.firebaseAuthErrors)[errorCode];
    return errorMessage || "Authentication error occurred.";
};
const $4b2ff82a5e5884ae$export$1ed15408b0c36796 = async (email, password)=>{
    try {
        // create user with email and password
        const res = await (0, $gOZuL.aa)($4b2ff82a5e5884ae$var$firebaseAuth, email, password);
        // send email verification
        await (0, $gOZuL.ag)(res.user);
        // get user id token
        const idToken = await $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $4b2ff82a5e5884ae$export$7ea3f81a63d06d2d = async (email, password)=>{
    try {
        // sign in with email and password
        await (0, $gOZuL.ab)($4b2ff82a5e5884ae$var$firebaseAuth, email, password);
        // get user id token
        const idToken = await $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $4b2ff82a5e5884ae$export$596dddd43d76a76c = async ()=>{
    // initialize google provider
    const googleProvider = new (0, $gOZuL.X)();
    googleProvider.setCustomParameters({
        prompt: "select_account"
    });
    // add required scopes
    googleProvider.addScope("https://www.googleapis.com/auth/userinfo.profile");
    googleProvider.addScope("https://www.googleapis.com/auth/userinfo.email");
    // googleProvider.addScope('https://www.googleapis.com/auth/contacts.readonly')
    try {
        // sign in with popup
        await (0, $gOZuL.c)($4b2ff82a5e5884ae$var$firebaseAuth, googleProvider);
        // get google credentials
        // const creds = GoogleAuthProvider.credentialFromResult(res)
        // get user id token
        const idToken = await $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $4b2ff82a5e5884ae$export$27ab9db94af63bd7 = async ()=>{
    // initialize facebook provider
    const facebookProvider = new (0, $gOZuL.W)();
    facebookProvider.setCustomParameters({
        prompt: "select_account",
        display: "popup"
    });
    // add required scopes
    facebookProvider.addScope("public_profile");
    facebookProvider.addScope("email");
    try {
        // sign in with popup
        await (0, $gOZuL.c)($4b2ff82a5e5884ae$var$firebaseAuth, facebookProvider);
        // get facebook credentials
        // const creds = FacebookAuthProvider.credentialFromResult(res)
        // get user id token
        const idToken = await $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.getIdToken();
        const emailVerified = $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.emailVerified;
        return {
            idToken: idToken || "",
            emailVerified: emailVerified || false,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            idToken: "",
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};
const $4b2ff82a5e5884ae$export$bc2f170a1316cdef = async (email)=>{
    try {
        // send email
        await (0, $gOZuL.a5)($4b2ff82a5e5884ae$var$firebaseAuth, email);
        return {
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            errorMessage: errorMessage
        };
    }
};
const $4b2ff82a5e5884ae$export$676c02462de282f = async ()=>{
    try {
        // get current user
        const user = $4b2ff82a5e5884ae$var$firebaseAuth.currentUser;
        // send email verification
        await (0, $gOZuL.ag)(user);
        return {
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            errorMessage: errorMessage
        };
    }
};
const $4b2ff82a5e5884ae$export$ce2b67b6cbba1984 = async ()=>{
    try {
        // sign user out from firebase
        await (0, $gOZuL.C)($4b2ff82a5e5884ae$var$firebaseAuth);
        return {
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            errorMessage: errorMessage
        };
    }
};
// firebaseGetCurrentUserState - wraps observer to get current user state status.
const $4b2ff82a5e5884ae$var$firebaseGetCurrentUserState = ()=>new Promise((res)=>{
        const unsubscribe = (0, $gOZuL.y)($4b2ff82a5e5884ae$var$firebaseAuth, (authUser)=>{
            res(authUser);
            unsubscribe();
        });
    });
const $4b2ff82a5e5884ae$export$2571cb1371ffdb4a = async ()=>{
    try {
        // get current user
        const user = await $4b2ff82a5e5884ae$var$firebaseGetCurrentUserState();
        // reload user data
        await user?.reload();
        // check email verification status
        const emailVerified = $4b2ff82a5e5884ae$var$firebaseAuth.currentUser?.emailVerified;
        return {
            emailVerified: emailVerified,
            errorMessage: ""
        };
    } catch (err) {
        // handle firebase error
        const errorMessage = $4b2ff82a5e5884ae$var$firebaseHandleError(err);
        return {
            emailVerified: false,
            errorMessage: errorMessage
        };
    }
};

});
parcelRegister("gKkQl", function(module, exports) {
$parcel$export(module.exports, "initializeApp", function () { return (parcelRequire("ix4Jr")).initializeApp; });
$parcel$export(module.exports, "registerVersion", function () { return (parcelRequire("ix4Jr")).registerVersion; });

var $ix4Jr = parcelRequire("ix4Jr");
var $c3111c3e3c6a9bdc$var$name = "firebase";
var $c3111c3e3c6a9bdc$var$version = "10.13.1";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $ix4Jr.registerVersion)($c3111c3e3c6a9bdc$var$name, $c3111c3e3c6a9bdc$var$version, "app");

});
parcelRegister("ix4Jr", function(module, exports) {

$parcel$export(module.exports, "_registerComponent", function () { return $d7defabc17f02990$export$c930050e7bb63965; });
$parcel$export(module.exports, "_getProvider", function () { return $d7defabc17f02990$export$fa0d6da0f5838f50; });
$parcel$export(module.exports, "_isFirebaseServerApp", function () { return $d7defabc17f02990$export$643c8bc6c389f34e; });
$parcel$export(module.exports, "registerVersion", function () { return $d7defabc17f02990$export$d29d5299a7137abc; });
$parcel$export(module.exports, "SDK_VERSION", function () { return $d7defabc17f02990$export$31499a9cd224b78c; });
$parcel$export(module.exports, "initializeApp", function () { return $d7defabc17f02990$export$c55cfd413944906d; });
$parcel$export(module.exports, "getApp", function () { return $d7defabc17f02990$export$f9962582c9e66d99; });

var $4a6xH = parcelRequire("4a6xH");

var $7vF8m = parcelRequire("7vF8m");

var $ffjl9 = parcelRequire("ffjl9");

var $cCiiD = parcelRequire("cCiiD");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d7defabc17f02990$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($d7defabc17f02990$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $d7defabc17f02990$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $d7defabc17f02990$var$name$p = "@firebase/app";
const $d7defabc17f02990$var$version$1 = "0.10.10";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d7defabc17f02990$var$logger = new (0, $7vF8m.Logger)("@firebase/app");
const $d7defabc17f02990$var$name$o = "@firebase/app-compat";
const $d7defabc17f02990$var$name$n = "@firebase/analytics-compat";
const $d7defabc17f02990$var$name$m = "@firebase/analytics";
const $d7defabc17f02990$var$name$l = "@firebase/app-check-compat";
const $d7defabc17f02990$var$name$k = "@firebase/app-check";
const $d7defabc17f02990$var$name$j = "@firebase/auth";
const $d7defabc17f02990$var$name$i = "@firebase/auth-compat";
const $d7defabc17f02990$var$name$h = "@firebase/database";
const $d7defabc17f02990$var$name$g = "@firebase/database-compat";
const $d7defabc17f02990$var$name$f = "@firebase/functions";
const $d7defabc17f02990$var$name$e = "@firebase/functions-compat";
const $d7defabc17f02990$var$name$d = "@firebase/installations";
const $d7defabc17f02990$var$name$c = "@firebase/installations-compat";
const $d7defabc17f02990$var$name$b = "@firebase/messaging";
const $d7defabc17f02990$var$name$a = "@firebase/messaging-compat";
const $d7defabc17f02990$var$name$9 = "@firebase/performance";
const $d7defabc17f02990$var$name$8 = "@firebase/performance-compat";
const $d7defabc17f02990$var$name$7 = "@firebase/remote-config";
const $d7defabc17f02990$var$name$6 = "@firebase/remote-config-compat";
const $d7defabc17f02990$var$name$5 = "@firebase/storage";
const $d7defabc17f02990$var$name$4 = "@firebase/storage-compat";
const $d7defabc17f02990$var$name$3 = "@firebase/firestore";
const $d7defabc17f02990$var$name$2 = "@firebase/vertexai-preview";
const $d7defabc17f02990$var$name$1 = "@firebase/firestore-compat";
const $d7defabc17f02990$var$name = "firebase";
const $d7defabc17f02990$var$version = "10.13.1";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $d7defabc17f02990$export$9f30fa0c10967f7f = "[DEFAULT]";
const $d7defabc17f02990$var$PLATFORM_LOG_STRING = {
    [$d7defabc17f02990$var$name$p]: "fire-core",
    [$d7defabc17f02990$var$name$o]: "fire-core-compat",
    [$d7defabc17f02990$var$name$m]: "fire-analytics",
    [$d7defabc17f02990$var$name$n]: "fire-analytics-compat",
    [$d7defabc17f02990$var$name$k]: "fire-app-check",
    [$d7defabc17f02990$var$name$l]: "fire-app-check-compat",
    [$d7defabc17f02990$var$name$j]: "fire-auth",
    [$d7defabc17f02990$var$name$i]: "fire-auth-compat",
    [$d7defabc17f02990$var$name$h]: "fire-rtdb",
    [$d7defabc17f02990$var$name$g]: "fire-rtdb-compat",
    [$d7defabc17f02990$var$name$f]: "fire-fn",
    [$d7defabc17f02990$var$name$e]: "fire-fn-compat",
    [$d7defabc17f02990$var$name$d]: "fire-iid",
    [$d7defabc17f02990$var$name$c]: "fire-iid-compat",
    [$d7defabc17f02990$var$name$b]: "fire-fcm",
    [$d7defabc17f02990$var$name$a]: "fire-fcm-compat",
    [$d7defabc17f02990$var$name$9]: "fire-perf",
    [$d7defabc17f02990$var$name$8]: "fire-perf-compat",
    [$d7defabc17f02990$var$name$7]: "fire-rc",
    [$d7defabc17f02990$var$name$6]: "fire-rc-compat",
    [$d7defabc17f02990$var$name$5]: "fire-gcs",
    [$d7defabc17f02990$var$name$4]: "fire-gcs-compat",
    [$d7defabc17f02990$var$name$3]: "fire-fst",
    [$d7defabc17f02990$var$name$1]: "fire-fst-compat",
    [$d7defabc17f02990$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$d7defabc17f02990$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $d7defabc17f02990$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $d7defabc17f02990$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d7defabc17f02990$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $d7defabc17f02990$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $d7defabc17f02990$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $d7defabc17f02990$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $d7defabc17f02990$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($d7defabc17f02990$export$9566bce3835c0f28.has(componentName)) {
        $d7defabc17f02990$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $d7defabc17f02990$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $d7defabc17f02990$export$b4e3c36c855b14b5.values())$d7defabc17f02990$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $d7defabc17f02990$export$fb03ad8d3d5c5f76.values())$d7defabc17f02990$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $d7defabc17f02990$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $d7defabc17f02990$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $d7defabc17f02990$export$9f30fa0c10967f7f) {
    $d7defabc17f02990$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $d7defabc17f02990$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $d7defabc17f02990$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $d7defabc17f02990$export$3685d89b9c3cdfaf() {
    $d7defabc17f02990$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d7defabc17f02990$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $d7defabc17f02990$var$ERROR_FACTORY = new (0, $ffjl9.ErrorFactory)("app", "Firebase", $d7defabc17f02990$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d7defabc17f02990$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $4a6xH.Component)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $d7defabc17f02990$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $d7defabc17f02990$var$FirebaseServerAppImpl extends $d7defabc17f02990$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $d7defabc17f02990$export$d29d5299a7137abc($d7defabc17f02990$var$name$p, $d7defabc17f02990$var$version$1, "serverapp");
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $d7defabc17f02990$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $d7defabc17f02990$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $d7defabc17f02990$export$31499a9cd224b78c = $d7defabc17f02990$var$version;
function $d7defabc17f02990$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $d7defabc17f02990$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $d7defabc17f02990$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $ffjl9.getDefaultAppConfig)());
    if (!options) throw $d7defabc17f02990$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $d7defabc17f02990$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $ffjl9.deepEqual)(options, existingApp.options) && (0, $ffjl9.deepEqual)(config, existingApp.config)) return existingApp;
        else throw $d7defabc17f02990$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $4a6xH.ComponentContainer)(name);
    for (const component of $d7defabc17f02990$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $d7defabc17f02990$var$FirebaseAppImpl(options, config, container);
    $d7defabc17f02990$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $d7defabc17f02990$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $ffjl9.isBrowser)() && !(0, $ffjl9.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $d7defabc17f02990$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($d7defabc17f02990$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $d7defabc17f02990$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $d7defabc17f02990$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $4a6xH.ComponentContainer)(nameString);
    for (const component of $d7defabc17f02990$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $d7defabc17f02990$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $d7defabc17f02990$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $d7defabc17f02990$export$f9962582c9e66d99(name = $d7defabc17f02990$export$9f30fa0c10967f7f) {
    const app = $d7defabc17f02990$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $d7defabc17f02990$export$9f30fa0c10967f7f && (0, $ffjl9.getDefaultAppConfig)()) return $d7defabc17f02990$export$c55cfd413944906d();
    if (!app) throw $d7defabc17f02990$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $d7defabc17f02990$export$68ddedf7d44b3bdf() {
    return Array.from($d7defabc17f02990$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $d7defabc17f02990$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($d7defabc17f02990$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $d7defabc17f02990$export$b4e3c36c855b14b5.delete(name);
    } else if ($d7defabc17f02990$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $d7defabc17f02990$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $d7defabc17f02990$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $d7defabc17f02990$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $d7defabc17f02990$var$logger.warn(warning.join(" "));
        return;
    }
    $d7defabc17f02990$export$c930050e7bb63965(new (0, $4a6xH.Component)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $d7defabc17f02990$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $d7defabc17f02990$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $7vF8m.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $d7defabc17f02990$export$c622e99c0ce7b1c9(logLevel) {
    (0, $7vF8m.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d7defabc17f02990$var$DB_NAME = "firebase-heartbeat-database";
const $d7defabc17f02990$var$DB_VERSION = 1;
const $d7defabc17f02990$var$STORE_NAME = "firebase-heartbeat-store";
let $d7defabc17f02990$var$dbPromise = null;
function $d7defabc17f02990$var$getDbPromise() {
    if (!$d7defabc17f02990$var$dbPromise) $d7defabc17f02990$var$dbPromise = (0, $cCiiD.openDB)($d7defabc17f02990$var$DB_NAME, $d7defabc17f02990$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($d7defabc17f02990$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $d7defabc17f02990$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $d7defabc17f02990$var$dbPromise;
}
async function $d7defabc17f02990$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $d7defabc17f02990$var$getDbPromise();
        const tx = db.transaction($d7defabc17f02990$var$STORE_NAME);
        const result = await tx.objectStore($d7defabc17f02990$var$STORE_NAME).get($d7defabc17f02990$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $ffjl9.FirebaseError)) $d7defabc17f02990$var$logger.warn(e.message);
        else {
            const idbGetError = $d7defabc17f02990$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $d7defabc17f02990$var$logger.warn(idbGetError.message);
        }
    }
}
async function $d7defabc17f02990$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $d7defabc17f02990$var$getDbPromise();
        const tx = db.transaction($d7defabc17f02990$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($d7defabc17f02990$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $d7defabc17f02990$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $ffjl9.FirebaseError)) $d7defabc17f02990$var$logger.warn(e.message);
        else {
            const idbGetError = $d7defabc17f02990$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $d7defabc17f02990$var$logger.warn(idbGetError.message);
        }
    }
}
function $d7defabc17f02990$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d7defabc17f02990$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $d7defabc17f02990$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $d7defabc17f02990$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $d7defabc17f02990$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b;
        try {
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $d7defabc17f02990$var$getUTCDateString();
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $d7defabc17f02990$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $d7defabc17f02990$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $d7defabc17f02990$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $d7defabc17f02990$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $ffjl9.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $d7defabc17f02990$var$logger.warn(e);
            return "";
        }
    }
}
function $d7defabc17f02990$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $d7defabc17f02990$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $d7defabc17f02990$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($d7defabc17f02990$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($d7defabc17f02990$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $d7defabc17f02990$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $ffjl9.isIndexedDBAvailable)()) return false;
        else return (0, $ffjl9.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $d7defabc17f02990$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $d7defabc17f02990$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $d7defabc17f02990$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $d7defabc17f02990$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $ffjl9.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $d7defabc17f02990$var$registerCoreComponents(variant) {
    $d7defabc17f02990$export$c930050e7bb63965(new (0, $4a6xH.Component)("platform-logger", (container)=>new $d7defabc17f02990$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $d7defabc17f02990$export$c930050e7bb63965(new (0, $4a6xH.Component)("heartbeat", (container)=>new $d7defabc17f02990$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $d7defabc17f02990$export$d29d5299a7137abc($d7defabc17f02990$var$name$p, $d7defabc17f02990$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $d7defabc17f02990$export$d29d5299a7137abc($d7defabc17f02990$var$name$p, $d7defabc17f02990$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $d7defabc17f02990$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $d7defabc17f02990$var$registerCoreComponents("");

});
parcelRegister("4a6xH", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $307d2bd0b522285b$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "ComponentContainer", function () { return $307d2bd0b522285b$export$436a80eea5d5c0c5; });

var $ffjl9 = parcelRequire("ffjl9");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $307d2bd0b522285b$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $307d2bd0b522285b$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $ffjl9.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($307d2bd0b522285b$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $307d2bd0b522285b$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $307d2bd0b522285b$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $307d2bd0b522285b$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $307d2bd0b522285b$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $307d2bd0b522285b$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $307d2bd0b522285b$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

});
parcelRegister("ffjl9", function(module, exports) {

$parcel$export(module.exports, "base64urlEncodeWithoutPadding", function () { return $b197424204fd80b4$export$4b5284a3025a455; });
$parcel$export(module.exports, "base64Decode", function () { return $b197424204fd80b4$export$c62426fdd000a97e; });
$parcel$export(module.exports, "getDefaultEmulatorHost", function () { return $b197424204fd80b4$export$9c11895284c8adad; });
$parcel$export(module.exports, "getDefaultAppConfig", function () { return $b197424204fd80b4$export$3dfb6827a9f89756; });
$parcel$export(module.exports, "getExperimentalSetting", function () { return $b197424204fd80b4$export$5539a1a3afe87d6; });
$parcel$export(module.exports, "Deferred", function () { return $b197424204fd80b4$export$85f6557964517f1a; });
$parcel$export(module.exports, "getUA", function () { return $b197424204fd80b4$export$c36915b22ce77c19; });
$parcel$export(module.exports, "isMobileCordova", function () { return $b197424204fd80b4$export$872f8323f01d7ae0; });
$parcel$export(module.exports, "isBrowser", function () { return $b197424204fd80b4$export$4e09c449d6c407f7; });
$parcel$export(module.exports, "isWebWorker", function () { return $b197424204fd80b4$export$97b87b8868ff7a3c; });
$parcel$export(module.exports, "isBrowserExtension", function () { return $b197424204fd80b4$export$caa8774a9107a58e; });
$parcel$export(module.exports, "isReactNative", function () { return $b197424204fd80b4$export$f7a1e23e542d38e3; });
$parcel$export(module.exports, "isIE", function () { return $b197424204fd80b4$export$7e7b1a9668aaed8; });
$parcel$export(module.exports, "isIndexedDBAvailable", function () { return $b197424204fd80b4$export$3865db50535c2055; });
$parcel$export(module.exports, "validateIndexedDBOpenable", function () { return $b197424204fd80b4$export$a8a3018f3d187a4d; });
$parcel$export(module.exports, "FirebaseError", function () { return $b197424204fd80b4$export$dd24e9cd51226c56; });
$parcel$export(module.exports, "ErrorFactory", function () { return $b197424204fd80b4$export$3fa6e1b18a3b2d40; });
$parcel$export(module.exports, "isEmpty", function () { return $b197424204fd80b4$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "deepEqual", function () { return $b197424204fd80b4$export$9cb4719e2e525b7a; });
$parcel$export(module.exports, "querystring", function () { return $b197424204fd80b4$export$ac4103b836844853; });
$parcel$export(module.exports, "querystringDecode", function () { return $b197424204fd80b4$export$c1271ca4c8a70741; });
$parcel$export(module.exports, "extractQuerystring", function () { return $b197424204fd80b4$export$1a8408415472d8ed; });
$parcel$export(module.exports, "createSubscribe", function () { return $b197424204fd80b4$export$364097d812234b3f; });
$parcel$export(module.exports, "getModularInstance", function () { return $b197424204fd80b4$export$4befe9b5fa509a1b; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ 
var $4TNnu = parcelRequire("4TNnu");
const $b197424204fd80b4$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $b197424204fd80b4$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $b197424204fd80b4$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $b197424204fd80b4$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $b197424204fd80b4$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b197424204fd80b4$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $b197424204fd80b4$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $b197424204fd80b4$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($b197424204fd80b4$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $b197424204fd80b4$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $b197424204fd80b4$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $b197424204fd80b4$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $b197424204fd80b4$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $b197424204fd80b4$var$stringToByteArray$1(str);
    return $b197424204fd80b4$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $b197424204fd80b4$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $b197424204fd80b4$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $b197424204fd80b4$export$c62426fdd000a97e = function(str) {
    try {
        return $b197424204fd80b4$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $b197424204fd80b4$export$6c40052bed430212(value) {
    return $b197424204fd80b4$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $b197424204fd80b4$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$b197424204fd80b4$var$isValidKey(prop)) continue;
        target[prop] = $b197424204fd80b4$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $b197424204fd80b4$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $b197424204fd80b4$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b197424204fd80b4$var$getDefaultsFromGlobal = ()=>$b197424204fd80b4$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $b197424204fd80b4$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $4TNnu === "undefined" || typeof $4TNnu.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $b197424204fd80b4$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $b197424204fd80b4$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $b197424204fd80b4$export$212bb2fc580a90a8 = ()=>{
    try {
        return $b197424204fd80b4$var$getDefaultsFromGlobal() || $b197424204fd80b4$var$getDefaultsFromEnvVariable() || $b197424204fd80b4$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $b197424204fd80b4$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $b197424204fd80b4$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $b197424204fd80b4$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $b197424204fd80b4$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $b197424204fd80b4$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $b197424204fd80b4$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $b197424204fd80b4$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $b197424204fd80b4$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b197424204fd80b4$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b197424204fd80b4$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $b197424204fd80b4$export$4b5284a3025a455(JSON.stringify(header)),
        $b197424204fd80b4$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $b197424204fd80b4$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $b197424204fd80b4$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($b197424204fd80b4$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $b197424204fd80b4$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $b197424204fd80b4$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $b197424204fd80b4$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $b197424204fd80b4$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context
 */ function $b197424204fd80b4$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
function $b197424204fd80b4$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $b197424204fd80b4$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $b197424204fd80b4$export$f2f6a8999f8ebd30() {
    return $b197424204fd80b4$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $b197424204fd80b4$export$7e7b1a9668aaed8() {
    const ua = $b197424204fd80b4$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $b197424204fd80b4$export$202944b2d2824246() {
    return $b197424204fd80b4$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $b197424204fd80b4$export$5d1d834fbbf8bab7() {
    return $b197424204fd80b4$export$588c7fdda06fbb0a.NODE_CLIENT === true || $b197424204fd80b4$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $b197424204fd80b4$export$95df08bae54cb4df() {
    return !$b197424204fd80b4$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $b197424204fd80b4$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $b197424204fd80b4$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $b197424204fd80b4$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $b197424204fd80b4$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $b197424204fd80b4$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $b197424204fd80b4$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b197424204fd80b4$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $b197424204fd80b4$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $b197424204fd80b4$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $b197424204fd80b4$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $b197424204fd80b4$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $b197424204fd80b4$var$replaceTemplate(template, data) {
    return template.replace($b197424204fd80b4$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $b197424204fd80b4$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $b197424204fd80b4$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $b197424204fd80b4$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b197424204fd80b4$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $b197424204fd80b4$export$c5a53ce6a17cf18d($b197424204fd80b4$export$c62426fdd000a97e(parts[0]) || "");
        claims = $b197424204fd80b4$export$c5a53ce6a17cf18d($b197424204fd80b4$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b197424204fd80b4$export$5f870fcca7ae6a88 = function(token) {
    const claims = $b197424204fd80b4$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b197424204fd80b4$export$701c661ec91095f2 = function(token) {
    const claims = $b197424204fd80b4$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b197424204fd80b4$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $b197424204fd80b4$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $b197424204fd80b4$export$fc970ed23da99565 = function(token) {
    const claims = $b197424204fd80b4$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b197424204fd80b4$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $b197424204fd80b4$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $b197424204fd80b4$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $b197424204fd80b4$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $b197424204fd80b4$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($b197424204fd80b4$var$isObject(aProp) && $b197424204fd80b4$var$isObject(bProp)) {
            if (!$b197424204fd80b4$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $b197424204fd80b4$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $b197424204fd80b4$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $b197424204fd80b4$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $b197424204fd80b4$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $b197424204fd80b4$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $b197424204fd80b4$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $b197424204fd80b4$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $b197424204fd80b4$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $b197424204fd80b4$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $b197424204fd80b4$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($b197424204fd80b4$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $b197424204fd80b4$var$noop;
        if (observer.error === undefined) observer.error = $b197424204fd80b4$var$noop;
        if (observer.complete === undefined) observer.complete = $b197424204fd80b4$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b197424204fd80b4$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $b197424204fd80b4$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $b197424204fd80b4$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $b197424204fd80b4$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $b197424204fd80b4$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $b197424204fd80b4$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($b197424204fd80b4$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $b197424204fd80b4$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($b197424204fd80b4$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $b197424204fd80b4$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($b197424204fd80b4$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $b197424204fd80b4$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $b197424204fd80b4$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $b197424204fd80b4$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $b197424204fd80b4$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $b197424204fd80b4$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $b197424204fd80b4$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $b197424204fd80b4$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $b197424204fd80b4$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $b197424204fd80b4$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $b197424204fd80b4$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $b197424204fd80b4$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $b197424204fd80b4$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($b197424204fd80b4$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $b197424204fd80b4$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $b197424204fd80b4$var$indicator(i);
}
function $b197424204fd80b4$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b197424204fd80b4$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});



parcelRegister("7vF8m", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $577b55f579ec2041$export$243e62d78d3b544d; });
$parcel$export(module.exports, "Logger", function () { return $577b55f579ec2041$export$efa9a398d6368992; });
$parcel$export(module.exports, "setLogLevel", function () { return $577b55f579ec2041$export$c622e99c0ce7b1c9; });
$parcel$export(module.exports, "setUserLogHandler", function () { return $577b55f579ec2041$export$29577d29c84db5f6; });
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $577b55f579ec2041$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $577b55f579ec2041$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($577b55f579ec2041$export$243e62d78d3b544d || ($577b55f579ec2041$export$243e62d78d3b544d = {}));
const $577b55f579ec2041$var$levelStringToEnum = {
    "debug": $577b55f579ec2041$export$243e62d78d3b544d.DEBUG,
    "verbose": $577b55f579ec2041$export$243e62d78d3b544d.VERBOSE,
    "info": $577b55f579ec2041$export$243e62d78d3b544d.INFO,
    "warn": $577b55f579ec2041$export$243e62d78d3b544d.WARN,
    "error": $577b55f579ec2041$export$243e62d78d3b544d.ERROR,
    "silent": $577b55f579ec2041$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $577b55f579ec2041$var$defaultLogLevel = $577b55f579ec2041$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $577b55f579ec2041$var$ConsoleMethod = {
    [$577b55f579ec2041$export$243e62d78d3b544d.DEBUG]: "log",
    [$577b55f579ec2041$export$243e62d78d3b544d.VERBOSE]: "log",
    [$577b55f579ec2041$export$243e62d78d3b544d.INFO]: "info",
    [$577b55f579ec2041$export$243e62d78d3b544d.WARN]: "warn",
    [$577b55f579ec2041$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $577b55f579ec2041$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $577b55f579ec2041$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $577b55f579ec2041$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $577b55f579ec2041$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $577b55f579ec2041$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $577b55f579ec2041$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $577b55f579ec2041$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $577b55f579ec2041$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $577b55f579ec2041$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $577b55f579ec2041$export$c622e99c0ce7b1c9(level) {
    $577b55f579ec2041$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $577b55f579ec2041$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $577b55f579ec2041$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $577b55f579ec2041$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $577b55f579ec2041$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}

});

parcelRegister("cCiiD", function(module, exports) {

$parcel$export(module.exports, "openDB", function () { return $92f73a92431170de$export$ca0ed41b1a2af7e; });

var $ekHjI = parcelRequire("ekHjI");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $92f73a92431170de$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $ekHjI.w)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $ekHjI.w)(request.result), event.oldVersion, event.newVersion, (0, $ekHjI.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $92f73a92431170de$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $ekHjI.w)(request).then(()=>undefined);
}
const $92f73a92431170de$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $92f73a92431170de$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $92f73a92431170de$var$cachedMethods = new Map();
function $92f73a92431170de$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($92f73a92431170de$var$cachedMethods.get(prop)) return $92f73a92431170de$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $92f73a92431170de$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $92f73a92431170de$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $92f73a92431170de$var$cachedMethods.set(prop, method);
    return method;
}
(0, $ekHjI.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$92f73a92431170de$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$92f73a92431170de$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));

});
parcelRegister("ekHjI", function(module, exports) {

$parcel$export(module.exports, "w", function () { return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "r", function () { return $a6f488ce4cf7dbe7$export$43caf9889c228507; });
const $a6f488ce4cf7dbe7$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $a6f488ce4cf7dbe7$var$idbProxyableTypes;
let $a6f488ce4cf7dbe7$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $a6f488ce4cf7dbe7$var$getIdbProxyableTypes() {
    return $a6f488ce4cf7dbe7$var$idbProxyableTypes || ($a6f488ce4cf7dbe7$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $a6f488ce4cf7dbe7$var$getCursorAdvanceMethods() {
    return $a6f488ce4cf7dbe7$var$cursorAdvanceMethods || ($a6f488ce4cf7dbe7$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $a6f488ce4cf7dbe7$var$cursorRequestMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transactionDoneMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transactionStoreNamesMap = new WeakMap();
const $a6f488ce4cf7dbe7$var$transformCache = new WeakMap();
const $a6f488ce4cf7dbe7$export$407448d2b89b1813 = new WeakMap();
function $a6f488ce4cf7dbe7$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $a6f488ce4cf7dbe7$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $a6f488ce4cf7dbe7$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $a6f488ce4cf7dbe7$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($a6f488ce4cf7dbe7$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $a6f488ce4cf7dbe7$var$transactionDoneMap.set(tx, done);
}
let $a6f488ce4cf7dbe7$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $a6f488ce4cf7dbe7$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $a6f488ce4cf7dbe7$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $a6f488ce4cf7dbe7$export$43caf9889c228507(callback) {
    $a6f488ce4cf7dbe7$var$idbProxyTraps = callback($a6f488ce4cf7dbe7$var$idbProxyTraps);
}
function $a6f488ce4cf7dbe7$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), storeNames, ...args);
        $a6f488ce4cf7dbe7$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($a6f488ce4cf7dbe7$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), args);
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b($a6f488ce4cf7dbe7$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(func.apply($a6f488ce4cf7dbe7$export$3b14a55fb2447963(this), args));
    };
}
function $a6f488ce4cf7dbe7$var$transformCachableValue(value) {
    if (typeof value === "function") return $a6f488ce4cf7dbe7$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $a6f488ce4cf7dbe7$var$cacheDonePromiseForTransaction(value);
    if ($a6f488ce4cf7dbe7$export$23f2a1d2818174ef(value, $a6f488ce4cf7dbe7$var$getIdbProxyableTypes())) return new Proxy(value, $a6f488ce4cf7dbe7$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $a6f488ce4cf7dbe7$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $a6f488ce4cf7dbe7$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($a6f488ce4cf7dbe7$var$transformCache.has(value)) return $a6f488ce4cf7dbe7$var$transformCache.get(value);
    const newValue = $a6f488ce4cf7dbe7$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $a6f488ce4cf7dbe7$var$transformCache.set(value, newValue);
        $a6f488ce4cf7dbe7$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $a6f488ce4cf7dbe7$export$3b14a55fb2447963 = (value)=>$a6f488ce4cf7dbe7$export$407448d2b89b1813.get(value);

});




parcelRegister("eyjy7", function(module, exports) {
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("gOZuL")).aa; });
$parcel$export(module.exports, "FacebookAuthProvider", function () { return (parcelRequire("gOZuL")).W; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("gOZuL")).o; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("gOZuL")).X; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("gOZuL")).y; });
$parcel$export(module.exports, "sendEmailVerification", function () { return (parcelRequire("gOZuL")).ag; });
$parcel$export(module.exports, "sendPasswordResetEmail", function () { return (parcelRequire("gOZuL")).a5; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("gOZuL")).ab; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("gOZuL")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("gOZuL")).C; });
parcelRequire("1iO0g");

});
parcelRegister("1iO0g", function(module, exports) {

$parcel$export(module.exports, "FacebookAuthProvider", function () { return (parcelRequire("gOZuL")).W; });
$parcel$export(module.exports, "GoogleAuthProvider", function () { return (parcelRequire("gOZuL")).X; });
$parcel$export(module.exports, "createUserWithEmailAndPassword", function () { return (parcelRequire("gOZuL")).aa; });
$parcel$export(module.exports, "getAuth", function () { return (parcelRequire("gOZuL")).o; });
$parcel$export(module.exports, "onAuthStateChanged", function () { return (parcelRequire("gOZuL")).y; });
$parcel$export(module.exports, "sendEmailVerification", function () { return (parcelRequire("gOZuL")).ag; });
$parcel$export(module.exports, "sendPasswordResetEmail", function () { return (parcelRequire("gOZuL")).a5; });
$parcel$export(module.exports, "signInWithEmailAndPassword", function () { return (parcelRequire("gOZuL")).ab; });
$parcel$export(module.exports, "signInWithPopup", function () { return (parcelRequire("gOZuL")).c; });
$parcel$export(module.exports, "signOut", function () { return (parcelRequire("gOZuL")).C; });

var $gOZuL = parcelRequire("gOZuL");
parcelRequire("ix4Jr");
parcelRequire("ffjl9");
parcelRequire("7vF8m");

parcelRequire("4a6xH");

});
parcelRegister("gOZuL", function(module, exports) {

$parcel$export(module.exports, "W", function () { return $c3f10480260b82e8$export$71cec2538cb2c617; });
$parcel$export(module.exports, "X", function () { return $c3f10480260b82e8$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "a5", function () { return $c3f10480260b82e8$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "aa", function () { return $c3f10480260b82e8$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "ab", function () { return $c3f10480260b82e8$export$555508cbc6add439; });
$parcel$export(module.exports, "ag", function () { return $c3f10480260b82e8$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "y", function () { return $c3f10480260b82e8$export$4a5767248b18ef41; });
$parcel$export(module.exports, "C", function () { return $c3f10480260b82e8$export$e7094788287c5e9b; });
$parcel$export(module.exports, "c", function () { return $c3f10480260b82e8$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $c3f10480260b82e8$export$ae1af26003f05816; });

var $ix4Jr = parcelRequire("ix4Jr");

var $ffjl9 = parcelRequire("ffjl9");

var $7vF8m = parcelRequire("7vF8m");

var $l73V3 = parcelRequire("l73V3");

var $4a6xH = parcelRequire("4a6xH");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $c3f10480260b82e8$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: "phone",
    TOTP: "totp"
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $c3f10480260b82e8$export$ffb5f4729a158638 = {
    /** Facebook provider ID */ FACEBOOK: "facebook.com",
    /** GitHub provider ID */ GITHUB: "github.com",
    /** Google provider ID */ GOOGLE: "google.com",
    /** Password provider */ PASSWORD: "password",
    /** Phone provider */ PHONE: "phone",
    /** Twitter provider ID */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $c3f10480260b82e8$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: "emailLink",
    /** Email/password sign in method */ EMAIL_PASSWORD: "password",
    /** Facebook sign in method */ FACEBOOK: "facebook.com",
    /** GitHub sign in method */ GITHUB: "github.com",
    /** Google sign in method */ GOOGLE: "google.com",
    /** Phone sign in method */ PHONE: "phone",
    /** Twitter sign in method */ TWITTER: "twitter.com"
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $c3f10480260b82e8$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: "link",
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: "reauthenticate",
    /** Operation involving signing in a user. */ SIGN_IN: "signIn"
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $c3f10480260b82e8$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: "EMAIL_SIGNIN",
    /** The password reset action. */ PASSWORD_RESET: "PASSWORD_RESET",
    /** The email revocation action. */ RECOVER_EMAIL: "RECOVER_EMAIL",
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: "REVERT_SECOND_FACTOR_ADDITION",
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: "VERIFY_AND_CHANGE_EMAIL",
    /** The email verification action. */ VERIFY_EMAIL: "VERIFY_EMAIL"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: "This operation is restricted to administrators only.",
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: "",
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: "Cordova framework is not ready.",
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: "This browser is not supported.",
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: "This credential is already associated with a different user account.",
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: "The custom token corresponds to a different audience.",
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: "Multi-factor users must always have a verified email.",
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: "The email address is already in use by another account.",
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: "The action code has expired.",
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: "This operation has been cancelled due to another conflicting popup being opened.",
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: "An internal AuthError has occurred.",
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: "The mobile app identifier is not registered for the current project.",
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: "The continue URL provided in the request is invalid.",
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: "The custom token format is incorrect. Please check the documentation.",
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: "The provided dynamic link domain is not configured or authorized for the current project.",
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: "The email address is badly formatted.",
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: "Emulator URL must start with a valid scheme (http:// or https://).",
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: "Your API key is invalid, please check you have copied it correctly.",
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: "The SHA-1 certificate hash provided is invalid.",
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: "The supplied auth credential is incorrect, malformed or has expired.",
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: "The request does not contain a valid proof of first factor successful sign-in.",
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: "The password is invalid or the user does not have a password.",
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: "The specified persistence type is invalid. It can only be local, session or none.",
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: "The specified provider ID is invalid.",
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: "The verification ID used to create the phone auth credential is invalid.",
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: "Login blocked by user-provided method: {$originalMessage}",
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: "An Android Package Name must be provided if the Android App is required to be installed.",
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: "The phone auth credential was created with an empty SMS verification code.",
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: "A continue URL must be provided in the request.",
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: "An internal AuthError has occurred.",
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: "An iOS Bundle ID must be provided if an App Store ID is provided.",
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: "A non-empty password must be provided",
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: "No second factor identifier is provided.",
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: "The request is missing proof of first factor successful sign-in.",
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: "To send verification codes, provide a phone number for the recipient.",
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: "The phone auth credential was created with an empty verification ID.",
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: "This instance of FirebaseApp has been deleted.",
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: "The user does not have a second factor matching the identifier provided.",
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: "Proof of ownership of a second factor is required to complete sign-in.",
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: "A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.",
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: "An internal AuthError has occurred.",
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: "User was not linked to an account with the given provider.",
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: "Unable to establish a connection with the popup. It may have been blocked by the browser.",
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: "The popup has been closed by the user before finalizing the operation.",
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: "User can only be linked to one identity for the given provider.",
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: "The redirect operation has been cancelled by the user before finalizing.",
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: "A redirect sign-in operation is already pending.",
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: "The request contains malformed or mismatching credentials.",
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: "The second factor is already enrolled on this account.",
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "The maximum allowed number of second factors on a user has been exceeded.",
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: "The operation has timed out.",
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: "The current environment does not support the specified persistence type.",
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: "This operation is not supported in a multi-tenant context.",
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: "The operation requires a verified email.",
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: "The user did not grant your application the permissions it requested.",
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: "The user account has been disabled by an administrator.",
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: "The supplied credentials do not correspond to the previously signed in user.",
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: "",
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: "The password must be 6 characters long or more.",
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: "This browser is not supported or 3rd party cookies and data may be disabled.",
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is missing when sending request to the backend.",
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: "The reCAPTCHA token is invalid when sending request to the backend.",
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: "The reCAPTCHA action is invalid when sending request to the backend.",
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: "reCAPTCHA Enterprise integration is not enabled for this project.",
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: "The reCAPTCHA client type is missing when sending request to the backend.",
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is missing when sending request to the backend.",
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: "Invalid request parameters.",
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: "The reCAPTCHA version is invalid when sending request to the backend.",
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: "The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.",
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "The password does not meet the requirements."
    };
}
function $c3f10480260b82e8$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $c3f10480260b82e8$export$2329c99376c9d0a4 = $c3f10480260b82e8$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $c3f10480260b82e8$export$7f8ddf7c7c20b3cd = $c3f10480260b82e8$var$_prodErrorMap;
const $c3f10480260b82e8$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $ffjl9.ErrorFactory)("auth", "Firebase", $c3f10480260b82e8$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $c3f10480260b82e8$export$9bb611d729802a56 = {
    ADMIN_ONLY_OPERATION: "auth/admin-restricted-operation",
    ARGUMENT_ERROR: "auth/argument-error",
    APP_NOT_AUTHORIZED: "auth/app-not-authorized",
    APP_NOT_INSTALLED: "auth/app-not-installed",
    CAPTCHA_CHECK_FAILED: "auth/captcha-check-failed",
    CODE_EXPIRED: "auth/code-expired",
    CORDOVA_NOT_READY: "auth/cordova-not-ready",
    CORS_UNSUPPORTED: "auth/cors-unsupported",
    CREDENTIAL_ALREADY_IN_USE: "auth/credential-already-in-use",
    CREDENTIAL_MISMATCH: "auth/custom-token-mismatch",
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: "auth/requires-recent-login",
    DEPENDENT_SDK_INIT_BEFORE_AUTH: "auth/dependent-sdk-initialized-before-auth",
    DYNAMIC_LINK_NOT_ACTIVATED: "auth/dynamic-link-not-activated",
    EMAIL_CHANGE_NEEDS_VERIFICATION: "auth/email-change-needs-verification",
    EMAIL_EXISTS: "auth/email-already-in-use",
    EMULATOR_CONFIG_FAILED: "auth/emulator-config-failed",
    EXPIRED_OOB_CODE: "auth/expired-action-code",
    EXPIRED_POPUP_REQUEST: "auth/cancelled-popup-request",
    INTERNAL_ERROR: "auth/internal-error",
    INVALID_API_KEY: "auth/invalid-api-key",
    INVALID_APP_CREDENTIAL: "auth/invalid-app-credential",
    INVALID_APP_ID: "auth/invalid-app-id",
    INVALID_AUTH: "auth/invalid-user-token",
    INVALID_AUTH_EVENT: "auth/invalid-auth-event",
    INVALID_CERT_HASH: "auth/invalid-cert-hash",
    INVALID_CODE: "auth/invalid-verification-code",
    INVALID_CONTINUE_URI: "auth/invalid-continue-uri",
    INVALID_CORDOVA_CONFIGURATION: "auth/invalid-cordova-configuration",
    INVALID_CUSTOM_TOKEN: "auth/invalid-custom-token",
    INVALID_DYNAMIC_LINK_DOMAIN: "auth/invalid-dynamic-link-domain",
    INVALID_EMAIL: "auth/invalid-email",
    INVALID_EMULATOR_SCHEME: "auth/invalid-emulator-scheme",
    INVALID_IDP_RESPONSE: "auth/invalid-credential",
    INVALID_LOGIN_CREDENTIALS: "auth/invalid-credential",
    INVALID_MESSAGE_PAYLOAD: "auth/invalid-message-payload",
    INVALID_MFA_SESSION: "auth/invalid-multi-factor-session",
    INVALID_OAUTH_CLIENT_ID: "auth/invalid-oauth-client-id",
    INVALID_OAUTH_PROVIDER: "auth/invalid-oauth-provider",
    INVALID_OOB_CODE: "auth/invalid-action-code",
    INVALID_ORIGIN: "auth/unauthorized-domain",
    INVALID_PASSWORD: "auth/wrong-password",
    INVALID_PERSISTENCE: "auth/invalid-persistence-type",
    INVALID_PHONE_NUMBER: "auth/invalid-phone-number",
    INVALID_PROVIDER_ID: "auth/invalid-provider-id",
    INVALID_RECIPIENT_EMAIL: "auth/invalid-recipient-email",
    INVALID_SENDER: "auth/invalid-sender",
    INVALID_SESSION_INFO: "auth/invalid-verification-id",
    INVALID_TENANT_ID: "auth/invalid-tenant-id",
    MFA_INFO_NOT_FOUND: "auth/multi-factor-info-not-found",
    MFA_REQUIRED: "auth/multi-factor-auth-required",
    MISSING_ANDROID_PACKAGE_NAME: "auth/missing-android-pkg-name",
    MISSING_APP_CREDENTIAL: "auth/missing-app-credential",
    MISSING_AUTH_DOMAIN: "auth/auth-domain-config-required",
    MISSING_CODE: "auth/missing-verification-code",
    MISSING_CONTINUE_URI: "auth/missing-continue-uri",
    MISSING_IFRAME_START: "auth/missing-iframe-start",
    MISSING_IOS_BUNDLE_ID: "auth/missing-ios-bundle-id",
    MISSING_OR_INVALID_NONCE: "auth/missing-or-invalid-nonce",
    MISSING_MFA_INFO: "auth/missing-multi-factor-info",
    MISSING_MFA_SESSION: "auth/missing-multi-factor-session",
    MISSING_PHONE_NUMBER: "auth/missing-phone-number",
    MISSING_SESSION_INFO: "auth/missing-verification-id",
    MODULE_DESTROYED: "auth/app-deleted",
    NEED_CONFIRMATION: "auth/account-exists-with-different-credential",
    NETWORK_REQUEST_FAILED: "auth/network-request-failed",
    NULL_USER: "auth/null-user",
    NO_AUTH_EVENT: "auth/no-auth-event",
    NO_SUCH_PROVIDER: "auth/no-such-provider",
    OPERATION_NOT_ALLOWED: "auth/operation-not-allowed",
    OPERATION_NOT_SUPPORTED: "auth/operation-not-supported-in-this-environment",
    POPUP_BLOCKED: "auth/popup-blocked",
    POPUP_CLOSED_BY_USER: "auth/popup-closed-by-user",
    PROVIDER_ALREADY_LINKED: "auth/provider-already-linked",
    QUOTA_EXCEEDED: "auth/quota-exceeded",
    REDIRECT_CANCELLED_BY_USER: "auth/redirect-cancelled-by-user",
    REDIRECT_OPERATION_PENDING: "auth/redirect-operation-pending",
    REJECTED_CREDENTIAL: "auth/rejected-credential",
    SECOND_FACTOR_ALREADY_ENROLLED: "auth/second-factor-already-in-use",
    SECOND_FACTOR_LIMIT_EXCEEDED: "auth/maximum-second-factor-count-exceeded",
    TENANT_ID_MISMATCH: "auth/tenant-id-mismatch",
    TIMEOUT: "auth/timeout",
    TOKEN_EXPIRED: "auth/user-token-expired",
    TOO_MANY_ATTEMPTS_TRY_LATER: "auth/too-many-requests",
    UNAUTHORIZED_DOMAIN: "auth/unauthorized-continue-uri",
    UNSUPPORTED_FIRST_FACTOR: "auth/unsupported-first-factor",
    UNSUPPORTED_PERSISTENCE: "auth/unsupported-persistence-type",
    UNSUPPORTED_TENANT_OPERATION: "auth/unsupported-tenant-operation",
    UNVERIFIED_EMAIL: "auth/unverified-email",
    USER_CANCELLED: "auth/user-cancelled",
    USER_DELETED: "auth/user-not-found",
    USER_DISABLED: "auth/user-disabled",
    USER_MISMATCH: "auth/user-mismatch",
    USER_SIGNED_OUT: "auth/user-signed-out",
    WEAK_PASSWORD: "auth/weak-password",
    WEB_STORAGE_UNSUPPORTED: "auth/web-storage-unsupported",
    ALREADY_INITIALIZED: "auth/already-initialized",
    RECAPTCHA_NOT_ENABLED: "auth/recaptcha-not-enabled",
    MISSING_RECAPTCHA_TOKEN: "auth/missing-recaptcha-token",
    INVALID_RECAPTCHA_TOKEN: "auth/invalid-recaptcha-token",
    INVALID_RECAPTCHA_ACTION: "auth/invalid-recaptcha-action",
    MISSING_CLIENT_TYPE: "auth/missing-client-type",
    MISSING_RECAPTCHA_VERSION: "auth/missing-recaptcha-version",
    INVALID_RECAPTCHA_VERSION: "auth/invalid-recaptcha-version",
    INVALID_REQ_TYPE: "auth/invalid-req-type"
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$logClient = new (0, $7vF8m.Logger)("@firebase/auth");
function $c3f10480260b82e8$var$_logWarn(msg, ...args) {
    if ($c3f10480260b82e8$var$logClient.logLevel <= (0, $7vF8m.LogLevel).WARN) $c3f10480260b82e8$var$logClient.warn(`Auth (${(0, $ix4Jr.SDK_VERSION)}): ${msg}`, ...args);
}
function $c3f10480260b82e8$var$_logError(msg, ...args) {
    if ($c3f10480260b82e8$var$logClient.logLevel <= (0, $7vF8m.LogLevel).ERROR) $c3f10480260b82e8$var$logClient.error(`Auth (${(0, $ix4Jr.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$export$9fa96a7d116ea3ce(authOrCode, ...rest) {
    throw $c3f10480260b82e8$var$createErrorInternal(authOrCode, ...rest);
}
function $c3f10480260b82e8$export$9d398bebfec1c039(authOrCode, ...rest) {
    return $c3f10480260b82e8$var$createErrorInternal(authOrCode, ...rest);
}
function $c3f10480260b82e8$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = Object.assign(Object.assign({}, $c3f10480260b82e8$export$7f8ddf7c7c20b3cd()), {
        [code]: message
    });
    const factory = new (0, $ffjl9.ErrorFactory)("auth", "Firebase", errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $c3f10480260b82e8$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , "Operations that alter the current user are not supported in conjunction with FirebaseServerApp");
}
function $c3f10480260b82e8$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $c3f10480260b82e8$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $c3f10480260b82e8$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== "string") {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $c3f10480260b82e8$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $c3f10480260b82e8$export$890c4ad488842ce7(assertion, authOrCode, ...rest) {
    if (!assertion) throw $c3f10480260b82e8$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $c3f10480260b82e8$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $c3f10480260b82e8$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $c3f10480260b82e8$export$1fbe638ecf81657e(assertion, message) {
    if (!assertion) $c3f10480260b82e8$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$_getCurrentUrl() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.href) || "";
}
function $c3f10480260b82e8$var$_isHttpOrHttps() {
    return $c3f10480260b82e8$var$_getCurrentScheme() === "http:" || $c3f10480260b82e8$var$_getCurrentScheme() === "https:";
}
function $c3f10480260b82e8$var$_getCurrentScheme() {
    var _a;
    return typeof self !== "undefined" && ((_a = self.location) === null || _a === void 0 ? void 0 : _a.protocol) || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $c3f10480260b82e8$var$_isOnline() {
    if (typeof navigator !== "undefined" && navigator && "onLine" in navigator && typeof navigator.onLine === "boolean" && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($c3f10480260b82e8$var$_isHttpOrHttps() || (0, $ffjl9.isBrowserExtension)() || "connection" in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $c3f10480260b82e8$var$_getUserLanguage() {
    if (typeof navigator === "undefined") return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $c3f10480260b82e8$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $c3f10480260b82e8$export$1fbe638ecf81657e(longDelay > shortDelay, "Short delay should be less than long delay!");
        this.isMobile = (0, $ffjl9.isMobileCordova)() || (0, $ffjl9.isReactNative)();
    }
    get() {
        if (!$c3f10480260b82e8$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$_emulatorUrl(config, path) {
    $c3f10480260b82e8$export$1fbe638ecf81657e(config.emulator, "Emulator should always be set here");
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith("/") ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$export$2ed0fc6709e59212 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== "undefined" && "fetch" in self) return self.fetch;
        if (typeof globalThis !== "undefined" && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== "undefined") return fetch;
        $c3f10480260b82e8$var$debugFail("Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== "undefined" && "Headers" in self) return self.Headers;
        if (typeof globalThis !== "undefined" && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== "undefined") return Headers;
        $c3f10480260b82e8$var$debugFail("Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== "undefined" && "Response" in self) return self.Response;
        if (typeof globalThis !== "undefined" && globalThis.Response) return globalThis.Response;
        if (typeof Response !== "undefined") return Response;
        $c3f10480260b82e8$var$debugFail("Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $c3f10480260b82e8$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$DEFAULT_API_TIMEOUT_MS = new $c3f10480260b82e8$var$Delay(30000, 60000);
function $c3f10480260b82e8$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return Object.assign(Object.assign({}, request), {
        tenantId: auth.tenantId
    });
    return request;
}
async function $c3f10480260b82e8$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $c3f10480260b82e8$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $ffjl9.querystring)(Object.assign({
            key: auth.config.apiKey
        }, params)).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/json";
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        return $c3f10480260b82e8$export$2ed0fc6709e59212.fetch()($c3f10480260b82e8$var$_getFinalTarget(auth, auth.config.apiHost, path, query), Object.assign({
            method: method,
            headers: headers,
            referrerPolicy: "no-referrer"
        }, body));
    });
}
async function $c3f10480260b82e8$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = Object.assign(Object.assign({}, $c3f10480260b82e8$var$SERVER_ERROR_MAP), customErrorMap);
    try {
        const networkTimeout = new $c3f10480260b82e8$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ("needConfirmation" in json) throw $c3f10480260b82e8$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !("errorMessage" in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(" : ");
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $c3f10480260b82e8$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $c3f10480260b82e8$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $c3f10480260b82e8$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, "-");
            if (serverErrorMessage) throw $c3f10480260b82e8$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $ffjl9.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            "message": String(e)
        });
    }
}
async function $c3f10480260b82e8$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $c3f10480260b82e8$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ("mfaPendingCredential" in serverResponse) $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
function $c3f10480260b82e8$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    if (!auth.config.emulator) return `${auth.config.apiScheme}://${base}`;
    return $c3f10480260b82e8$var$_emulatorUrl(auth.config, base);
}
function $c3f10480260b82e8$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case "ENFORCE":
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case "AUDIT":
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case "OFF":
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $c3f10480260b82e8$var$NetworkTimeout {
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($c3f10480260b82e8$export$9d398bebfec1c039(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $c3f10480260b82e8$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
}
function $c3f10480260b82e8$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $c3f10480260b82e8$export$9d398bebfec1c039(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $c3f10480260b82e8$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $c3f10480260b82e8$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = "";
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error("recaptchaKey undefined");
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split("/")[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $c3f10480260b82e8$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$getRecaptchaParams(auth) {
    return (await $c3f10480260b82e8$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || "";
}
async function $c3f10480260b82e8$var$getRecaptchaConfig(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$deleteAccount(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $c3f10480260b82e8$var$deleteLinkedAccounts(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $c3f10480260b82e8$var$getAccountInfo(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $c3f10480260b82e8$export$306ddfe3a8403e2(user, forceRefresh = false) {
    return (0, $ffjl9.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $c3f10480260b82e8$export$7a38258bbe170828(user, forceRefresh = false) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $c3f10480260b82e8$var$_parseToken(token);
    $c3f10480260b82e8$export$890c4ad488842ce7(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === "object" ? claims.firebase : undefined;
    const signInProvider = firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_provider"];
    return {
        claims: claims,
        token: token,
        authTime: $c3f10480260b82e8$var$utcTimestampToDateString($c3f10480260b82e8$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $c3f10480260b82e8$var$utcTimestampToDateString($c3f10480260b82e8$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $c3f10480260b82e8$var$utcTimestampToDateString($c3f10480260b82e8$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: (firebase === null || firebase === void 0 ? void 0 : firebase["sign_in_second_factor"]) || null
    };
}
function $c3f10480260b82e8$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $c3f10480260b82e8$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split(".");
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $c3f10480260b82e8$var$_logError("JWT malformed, contained fewer than 3 sections");
        return null;
    }
    try {
        const decoded = (0, $ffjl9.base64Decode)(payload);
        if (!decoded) {
            $c3f10480260b82e8$var$_logError("Failed to decode base64 JWT payload");
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $c3f10480260b82e8$var$_logError("Caught error parsing JWT payload as JSON", e === null || e === void 0 ? void 0 : e.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $c3f10480260b82e8$var$_tokenExpiresIn(token) {
    const parsedToken = $c3f10480260b82e8$var$_parseToken(token);
    $c3f10480260b82e8$export$890c4ad488842ce7(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $c3f10480260b82e8$export$890c4ad488842ce7(typeof parsedToken.exp !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $c3f10480260b82e8$export$890c4ad488842ce7(typeof parsedToken.iat !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $ffjl9.FirebaseError) && $c3f10480260b82e8$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $c3f10480260b82e8$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        var _a;
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = (_a = this.user.stsTokenManager.expirationTime) !== null && _a !== void 0 ? _a : 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $c3f10480260b82e8$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $c3f10480260b82e8$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$_reloadWithoutSaving(user) {
    var _a;
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $c3f10480260b82e8$var$_logoutIfInvalidated(user, $c3f10480260b82e8$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $c3f10480260b82e8$export$890c4ad488842ce7(response === null || response === void 0 ? void 0 : response.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = ((_a = coreAccount.providerUserInfo) === null || _a === void 0 ? void 0 : _a.length) ? $c3f10480260b82e8$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $c3f10480260b82e8$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $c3f10480260b82e8$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $c3f10480260b82e8$export$d24c54395ce0c509(user) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    await $c3f10480260b82e8$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $c3f10480260b82e8$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $c3f10480260b82e8$var$extractProviderData(providers) {
    return providers.map((_a)=>{
        var { providerId: providerId } = _a, provider = (0, $l73V3.__rest)(_a, [
            "providerId"
        ]);
        return {
            providerId: providerId,
            uid: provider.rawId || "",
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$requestStsToken(auth, refreshToken) {
    const response = await $c3f10480260b82e8$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $ffjl9.querystring)({
            "grant_type": "refresh_token",
            "refresh_token": refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = $c3f10480260b82e8$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = "application/x-www-form-urlencoded";
        return $c3f10480260b82e8$export$2ed0fc6709e59212.fetch()(url, {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        });
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $c3f10480260b82e8$var$revokeToken(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $c3f10480260b82e8$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $c3f10480260b82e8$export$890c4ad488842ce7(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof response.idToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof response.refreshToken !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = "expiresIn" in response && typeof response.expiresIn !== "undefined" ? Number(response.expiresIn) : $c3f10480260b82e8$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $c3f10480260b82e8$export$890c4ad488842ce7(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $c3f10480260b82e8$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $c3f10480260b82e8$export$890c4ad488842ce7(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $c3f10480260b82e8$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $c3f10480260b82e8$var$StsTokenManager();
        if (refreshToken) {
            $c3f10480260b82e8$export$890c4ad488842ce7(typeof refreshToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $c3f10480260b82e8$export$890c4ad488842ce7(typeof accessToken === "string", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $c3f10480260b82e8$export$890c4ad488842ce7(typeof expirationTime === "number", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $c3f10480260b82e8$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $c3f10480260b82e8$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$assertStringOrUndefined(assertion, appName) {
    $c3f10480260b82e8$export$890c4ad488842ce7(typeof assertion === "string" || typeof assertion === "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $c3f10480260b82e8$export$23ebac1979863676 {
    constructor(_a){
        var { uid: uid, auth: auth, stsTokenManager: stsTokenManager } = _a, opt = (0, $l73V3.__rest)(_a, [
            "uid",
            "auth",
            "stsTokenManager"
        ]);
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $c3f10480260b82e8$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $c3f10480260b82e8$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $c3f10480260b82e8$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $c3f10480260b82e8$export$890c4ad488842ce7(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $c3f10480260b82e8$export$7a38258bbe170828(this, forceRefresh);
    }
    reload() {
        return $c3f10480260b82e8$export$d24c54395ce0c509(this);
    }
    _assign(user) {
        if (this === user) return;
        $c3f10480260b82e8$export$890c4ad488842ce7(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>Object.assign({}, userInfo));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $c3f10480260b82e8$export$23ebac1979863676(Object.assign(Object.assign({}, this), {
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        }));
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $c3f10480260b82e8$export$890c4ad488842ce7(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $c3f10480260b82e8$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $ix4Jr._isFirebaseServerApp)(this.auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $c3f10480260b82e8$var$_logoutIfInvalidated(this, $c3f10480260b82e8$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return Object.assign(Object.assign({
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>Object.assign({}, userInfo)),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId
        }, this.metadata.toJSON()), {
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        });
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || "";
    }
    static _fromJSON(auth, object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const displayName = (_a = object.displayName) !== null && _a !== void 0 ? _a : undefined;
        const email = (_b = object.email) !== null && _b !== void 0 ? _b : undefined;
        const phoneNumber = (_c = object.phoneNumber) !== null && _c !== void 0 ? _c : undefined;
        const photoURL = (_d = object.photoURL) !== null && _d !== void 0 ? _d : undefined;
        const tenantId = (_e = object.tenantId) !== null && _e !== void 0 ? _e : undefined;
        const _redirectEventId = (_f = object._redirectEventId) !== null && _f !== void 0 ? _f : undefined;
        const createdAt = (_g = object.createdAt) !== null && _g !== void 0 ? _g : undefined;
        const lastLoginAt = (_h = object.lastLoginAt) !== null && _h !== void 0 ? _h : undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $c3f10480260b82e8$export$890c4ad488842ce7(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $c3f10480260b82e8$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof uid === "string", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c3f10480260b82e8$var$assertStringOrUndefined(displayName, auth.name);
        $c3f10480260b82e8$var$assertStringOrUndefined(email, auth.name);
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof emailVerified === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof isAnonymous === "boolean", auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c3f10480260b82e8$var$assertStringOrUndefined(phoneNumber, auth.name);
        $c3f10480260b82e8$var$assertStringOrUndefined(photoURL, auth.name);
        $c3f10480260b82e8$var$assertStringOrUndefined(tenantId, auth.name);
        $c3f10480260b82e8$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $c3f10480260b82e8$var$assertStringOrUndefined(createdAt, auth.name);
        $c3f10480260b82e8$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $c3f10480260b82e8$export$23ebac1979863676({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>Object.assign({}, userInfo));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $c3f10480260b82e8$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $c3f10480260b82e8$export$23ebac1979863676({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $c3f10480260b82e8$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $c3f10480260b82e8$export$890c4ad488842ce7(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $c3f10480260b82e8$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length);
        const stsTokenManager = new $c3f10480260b82e8$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $c3f10480260b82e8$export$23ebac1979863676({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $c3f10480260b82e8$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !(providerData === null || providerData === void 0 ? void 0 : providerData.length)
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$instanceCache = new Map();
function $c3f10480260b82e8$export$158acd800e1ef08b(cls) {
    $c3f10480260b82e8$export$1fbe638ecf81657e(cls instanceof Function, "Expected a class definition");
    let instance = $c3f10480260b82e8$var$instanceCache.get(cls);
    if (instance) {
        $c3f10480260b82e8$export$1fbe638ecf81657e(instance instanceof cls, "Instance stored in cache mismatched with class");
        return instance;
    }
    instance = new cls();
    $c3f10480260b82e8$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$c3f10480260b82e8$var$InMemoryPersistence.type = "NONE";
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $c3f10480260b82e8$export$3a6d5c9ae78a2c08 = $c3f10480260b82e8$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$export$cf2f7c5792f80b46(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $c3f10480260b82e8$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $c3f10480260b82e8$export$cf2f7c5792f80b46(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $c3f10480260b82e8$export$cf2f7c5792f80b46("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        return blob ? $c3f10480260b82e8$export$23ebac1979863676._fromJSON(this.auth, blob) : null;
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $c3f10480260b82e8$var$PersistenceUserManager($c3f10480260b82e8$export$158acd800e1ef08b($c3f10480260b82e8$export$3a6d5c9ae78a2c08), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $c3f10480260b82e8$export$158acd800e1ef08b($c3f10480260b82e8$export$3a6d5c9ae78a2c08);
        const key = $c3f10480260b82e8$export$cf2f7c5792f80b46(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                const user = $c3f10480260b82e8$export$23ebac1979863676._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch (_a) {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $c3f10480260b82e8$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch (_a) {}
        }));
        return new $c3f10480260b82e8$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $c3f10480260b82e8$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes("opera/") || ua.includes("opr/") || ua.includes("opios/")) return "Opera" /* BrowserName.OPERA */ ;
    else if ($c3f10480260b82e8$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes("msie") || ua.includes("trident/")) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes("edge/")) return "Edge" /* BrowserName.EDGE */ ;
    else if ($c3f10480260b82e8$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes("silk/")) return "Silk" /* BrowserName.SILK */ ;
    else if ($c3f10480260b82e8$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($c3f10480260b82e8$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($c3f10480260b82e8$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes("chrome/") || $c3f10480260b82e8$var$_isChromeIOS(ua)) && !ua.includes("edge/")) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($c3f10480260b82e8$export$92108d983e8ee699(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if ((matches === null || matches === void 0 ? void 0 : matches.length) === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $c3f10480260b82e8$var$_isFirefox(ua = (0, $ffjl9.getUA)()) {
    return /firefox\//i.test(ua);
}
function $c3f10480260b82e8$var$_isSafari(userAgent = (0, $ffjl9.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes("safari/") && !ua.includes("chrome/") && !ua.includes("crios/") && !ua.includes("android");
}
function $c3f10480260b82e8$var$_isChromeIOS(ua = (0, $ffjl9.getUA)()) {
    return /crios\//i.test(ua);
}
function $c3f10480260b82e8$var$_isIEMobile(ua = (0, $ffjl9.getUA)()) {
    return /iemobile/i.test(ua);
}
function $c3f10480260b82e8$export$92108d983e8ee699(ua = (0, $ffjl9.getUA)()) {
    return /android/i.test(ua);
}
function $c3f10480260b82e8$var$_isBlackBerry(ua = (0, $ffjl9.getUA)()) {
    return /blackberry/i.test(ua);
}
function $c3f10480260b82e8$var$_isWebOS(ua = (0, $ffjl9.getUA)()) {
    return /webos/i.test(ua);
}
function $c3f10480260b82e8$export$d66dc83d8cfc8dd(ua = (0, $ffjl9.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $c3f10480260b82e8$export$91c6e00c14e7e6fd(ua = (0, $ffjl9.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $c3f10480260b82e8$var$_isIOSStandalone(ua = (0, $ffjl9.getUA)()) {
    var _a;
    return $c3f10480260b82e8$export$d66dc83d8cfc8dd(ua) && !!((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.standalone);
}
function $c3f10480260b82e8$var$_isIE10() {
    return (0, $ffjl9.isIE)() && document.documentMode === 10;
}
function $c3f10480260b82e8$var$_isMobileBrowser(ua = (0, $ffjl9.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $c3f10480260b82e8$export$d66dc83d8cfc8dd(ua) || $c3f10480260b82e8$export$92108d983e8ee699(ua) || $c3f10480260b82e8$var$_isWebOS(ua) || $c3f10480260b82e8$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $c3f10480260b82e8$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $c3f10480260b82e8$export$9f4f30ee63539e24(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $c3f10480260b82e8$var$_getBrowserName((0, $ffjl9.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$c3f10480260b82e8$var$_getBrowserName((0, $ffjl9.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(",") : "FirebaseCore-web"; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $ix4Jr.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e === null || e === void 0 ? void 0 : e.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $c3f10480260b82e8$var$_getPasswordPolicy(auth, request = {}) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $c3f10480260b82e8$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $c3f10480260b82e8$var$PasswordPolicyImpl {
    constructor(response){
        var _a, _b, _c, _d;
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = (_a = responseOptions.minPasswordLength) !== null && _a !== void 0 ? _a : $c3f10480260b82e8$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === "ENFORCEMENT_STATE_UNSPECIFIED") this.enforcementState = "OFF";
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = (_c = (_b = response.allowedNonAlphanumericCharacters) === null || _b === void 0 ? void 0 : _b.join("")) !== null && _c !== void 0 ? _c : "";
        this.forceUpgradeOnSignin = (_d = response.forceUpgradeOnSignin) !== null && _d !== void 0 ? _d : false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        var _a, _b, _c, _d, _e, _f;
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = (_a = status.meetsMinPasswordLength) !== null && _a !== void 0 ? _a : true);
        status.isValid && (status.isValid = (_b = status.meetsMaxPasswordLength) !== null && _b !== void 0 ? _b : true);
        status.isValid && (status.isValid = (_c = status.containsLowercaseLetter) !== null && _c !== void 0 ? _c : true);
        status.isValid && (status.isValid = (_d = status.containsUppercaseLetter) !== null && _d !== void 0 ? _d : true);
        status.isValid && (status.isValid = (_e = status.containsNumericCharacter) !== null && _e !== void 0 ? _e : true);
        status.isValid && (status.isValid = (_f = status.containsNonAlphanumericCharacter) !== null && _f !== void 0 ? _f : true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= "a" && passwordChar <= "z", /* containsUppercaseCharacter= */ passwordChar >= "A" && passwordChar <= "Z", /* containsNumericCharacter= */ passwordChar >= "0" && passwordChar <= "9", /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$export$91477dc880baac21 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $c3f10480260b82e8$var$Subscription(this);
        this.idTokenSubscription = new $c3f10480260b82e8$var$Subscription(this);
        this.beforeStateQueue = new $c3f10480260b82e8$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $c3f10480260b82e8$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $c3f10480260b82e8$export$158acd800e1ef08b(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            var _a, _b;
            if (this._deleted) return;
            this.persistenceManager = await $c3f10480260b82e8$var$PersistenceUserManager.create(this, persistenceHierarchy);
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if ((_a = this._popupRedirectResolver) === null || _a === void 0 ? void 0 : _a._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.uid) || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $c3f10480260b82e8$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $c3f10480260b82e8$export$23ebac1979863676._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn("FirebaseServerApp could not login user with provided authIdToken: ", err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        var _a;
        if ((0, $ix4Jr._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = (_a = this.redirectUser) === null || _a === void 0 ? void 0 : _a._redirectEventId;
            const storedUserEventId = futureCurrentUser === null || futureCurrentUser === void 0 ? void 0 : futureCurrentUser._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && (result === null || result === void 0 ? void 0 : result.user)) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $c3f10480260b82e8$export$890c4ad488842ce7(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $c3f10480260b82e8$var$_reloadWithoutSaving(user);
        } catch (e) {
            if ((e === null || e === void 0 ? void 0 : e.code) !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $c3f10480260b82e8$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $ix4Jr._isFirebaseServerApp)(this.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $ffjl9.getModularInstance)(userExtern) : null;
        if (user) $c3f10480260b82e8$export$890c4ad488842ce7(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $c3f10480260b82e8$export$890c4ad488842ce7(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $ix4Jr._isFirebaseServerApp)(this.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $ix4Jr._isFirebaseServerApp)(this.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($c3f10480260b82e8$export$158acd800e1ef08b(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $c3f10480260b82e8$var$_getPasswordPolicy(this);
        const passwordPolicy = new $c3f10480260b82e8$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence.type;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $ffjl9.ErrorFactory)("auth", "Firebase", errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: "apple.com",
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $c3f10480260b82e8$var$revokeToken(this, request);
        }
    }
    toJSON() {
        var _a;
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: (_a = this._currentUser) === null || _a === void 0 ? void 0 : _a.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $c3f10480260b82e8$export$158acd800e1ef08b(popupRedirectResolver) || this._popupRedirectResolver;
            $c3f10480260b82e8$export$890c4ad488842ce7(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $c3f10480260b82e8$var$PersistenceUserManager.create(this, [
                $c3f10480260b82e8$export$158acd800e1ef08b(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        var _a, _b;
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (((_a = this._currentUser) === null || _a === void 0 ? void 0 : _a._redirectEventId) === id) return this._currentUser;
        if (((_b = this.redirectUser) === null || _b === void 0 ? void 0 : _b._redirectEventId) === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        var _a, _b;
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = (_b = (_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.uid) !== null && _b !== void 0 ? _b : null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === "function" ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $c3f10480260b82e8$export$890c4ad488842ce7(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === "function") {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $c3f10480260b82e8$export$890c4ad488842ce7(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $c3f10480260b82e8$export$9f4f30ee63539e24(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        var _a;
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await ((_a = this.heartbeatServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getHeartbeatsHeader());
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        var _a;
        const appCheckTokenResult = await ((_a = this.appCheckServiceProvider.getImmediate({
            optional: true
        })) === null || _a === void 0 ? void 0 : _a.getToken());
        if (appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $c3f10480260b82e8$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult === null || appCheckTokenResult === void 0 ? void 0 : appCheckTokenResult.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $c3f10480260b82e8$export$a05254e7c3aeba6e(auth) {
    return (0, $ffjl9.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class $c3f10480260b82e8$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $ffjl9.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        $c3f10480260b82e8$export$890c4ad488842ce7(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $c3f10480260b82e8$var$externalJSProvider = {
    async loadJS () {
        throw new Error("Unable to load external scripts");
    },
    recaptchaV2Script: "",
    recaptchaEnterpriseScript: "",
    gapiScript: ""
};
function $c3f10480260b82e8$var$_setExternalJSProvider(p) {
    $c3f10480260b82e8$var$externalJSProvider = p;
}
function $c3f10480260b82e8$var$_loadJS(url) {
    return $c3f10480260b82e8$var$externalJSProvider.loadJS(url);
}
function $c3f10480260b82e8$var$_recaptchaV2ScriptUrl() {
    return $c3f10480260b82e8$var$externalJSProvider.recaptchaV2Script;
}
function $c3f10480260b82e8$var$_recaptchaEnterpriseScriptUrl() {
    return $c3f10480260b82e8$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $c3f10480260b82e8$var$_gapiScriptUrl() {
    return $c3f10480260b82e8$var$externalJSProvider.gapiScript;
}
function $c3f10480260b82e8$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $c3f10480260b82e8$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = "recaptcha-enterprise";
const $c3f10480260b82e8$var$FAKE_TOKEN = "NO_RECAPTCHA";
class $c3f10480260b82e8$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $c3f10480260b82e8$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $c3f10480260b82e8$export$a05254e7c3aeba6e(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = "verify", forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $c3f10480260b82e8$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error("recaptcha Enterprise site key undefined"));
                    else {
                        const config = new $c3f10480260b82e8$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($c3f10480260b82e8$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($c3f10480260b82e8$var$FAKE_TOKEN);
                });
            });
            else reject(Error("No reCAPTCHA enterprise script loaded."));
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then((siteKey)=>{
                if (!forceRefresh && $c3f10480260b82e8$var$isEnterprise(window.grecaptcha)) retrieveRecaptchaToken(siteKey, resolve, reject);
                else {
                    if (typeof window === "undefined") {
                        reject(new Error("RecaptchaVerifier is only supported in browser"));
                        return;
                    }
                    let url = $c3f10480260b82e8$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey;
                    $c3f10480260b82e8$var$_loadJS(url).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
async function $c3f10480260b82e8$var$injectRecaptchaFields(auth, request, action, captchaResp = false) {
    const verifier = new $c3f10480260b82e8$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = Object.assign({}, request);
    if (!captchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        "captchaResp": captchaResponse
    });
    Object.assign(newRequest, {
        "clientType": "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        "recaptchaVersion": "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $c3f10480260b82e8$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod) {
    var _a;
    if ((_a = authInstance._getRecaptchaConfig()) === null || _a === void 0 ? void 0 : _a.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const requestWithRecaptcha = await $c3f10480260b82e8$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
        return actionMethod(authInstance, requestWithRecaptcha);
    } else return actionMethod(authInstance, request).catch(async (error)=>{
        if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
            console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
            const requestWithRecaptcha = await $c3f10480260b82e8$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return Promise.reject(error);
    });
}
async function $c3f10480260b82e8$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    const response = await $c3f10480260b82e8$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $c3f10480260b82e8$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaProvider.EMAIL_PASSWORD_PROVIDER */ )) {
        const verifier = new $c3f10480260b82e8$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $c3f10480260b82e8$export$b4171a6734a65d42(app, deps) {
    const provider = (0, $ix4Jr._getProvider)(app, "auth");
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $ffjl9.deepEqual)(initialOptions, deps !== null && deps !== void 0 ? deps : {})) return auth;
        else $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $c3f10480260b82e8$var$_initializeAuthInstance(auth, deps) {
    const persistence = (deps === null || deps === void 0 ? void 0 : deps.persistence) || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($c3f10480260b82e8$export$158acd800e1ef08b);
    if (deps === null || deps === void 0 ? void 0 : deps.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps === null || deps === void 0 ? void 0 : deps.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $c3f10480260b82e8$export$3466f893ebf79586(auth, url, options) {
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    $c3f10480260b82e8$export$890c4ad488842ce7(authInternal._canInitEmulator, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
    $c3f10480260b82e8$export$890c4ad488842ce7(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!(options === null || options === void 0 ? void 0 : options.disableWarnings);
    const protocol = $c3f10480260b82e8$var$extractProtocol(url);
    const { host: host, port: port } = $c3f10480260b82e8$var$extractHostAndPort(url);
    const portStr = port === null ? "" : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    authInternal.config.emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    authInternal.settings.appVerificationDisabledForTesting = true;
    authInternal.emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(":", ""),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    if (!disableWarnings) $c3f10480260b82e8$var$emitEmulatorWarning();
}
function $c3f10480260b82e8$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(":");
    return protocolEnd < 0 ? "" : url.substr(0, protocolEnd + 1);
}
function $c3f10480260b82e8$var$extractHostAndPort(url) {
    const protocol = $c3f10480260b82e8$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: "",
        port: null
    };
    const hostAndPort = authority[2].split("@").pop() || ""; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $c3f10480260b82e8$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(":");
        return {
            host: host,
            port: $c3f10480260b82e8$var$parsePort(port)
        };
    }
}
function $c3f10480260b82e8$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $c3f10480260b82e8$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement("p");
        const sty = el.style;
        el.innerText = "Running in emulator mode. Do not use with production credentials.";
        sty.position = "fixed";
        sty.width = "100%";
        sty.backgroundColor = "#ffffff";
        sty.border = ".1em solid #000000";
        sty.color = "#b50000";
        sty.bottom = "0px";
        sty.left = "0px";
        sty.margin = "0px";
        sty.zIndex = "10000";
        sty.textAlign = "center";
        el.classList.add("firebase-emulator-warning");
        document.body.appendChild(el);
    }
    if (typeof console !== "undefined" && typeof console.info === "function") console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== "undefined" && typeof document !== "undefined") {
        if (document.readyState === "loading") window.addEventListener("DOMContentLoaded", attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $c3f10480260b82e8$export$61196ced6d74a310 {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $c3f10480260b82e8$var$debugFail("not implemented");
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $c3f10480260b82e8$var$debugFail("not implemented");
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $c3f10480260b82e8$var$debugFail("not implemented");
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $c3f10480260b82e8$var$debugFail("not implemented");
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$resetPassword(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
async function $c3f10480260b82e8$var$updateEmailPassword(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $c3f10480260b82e8$var$linkEmailPassword(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $c3f10480260b82e8$var$applyActionCode$1(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$signInWithPassword(auth, request) {
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
async function $c3f10480260b82e8$var$sendOobCode(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
async function $c3f10480260b82e8$var$sendEmailVerification$1(auth, request) {
    return $c3f10480260b82e8$var$sendOobCode(auth, request);
}
async function $c3f10480260b82e8$var$sendPasswordResetEmail$1(auth, request) {
    return $c3f10480260b82e8$var$sendOobCode(auth, request);
}
async function $c3f10480260b82e8$var$sendSignInLinkToEmail$1(auth, request) {
    return $c3f10480260b82e8$var$sendOobCode(auth, request);
}
async function $c3f10480260b82e8$var$verifyAndChangeEmail(auth, request) {
    return $c3f10480260b82e8$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$signInWithEmailLink$1(auth, request) {
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
async function $c3f10480260b82e8$var$signInWithEmailLinkForLinking(auth, request) {
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $c3f10480260b82e8$export$3a1a48c8f6ef640e extends $c3f10480260b82e8$export$61196ced6d74a310 {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $c3f10480260b82e8$export$3a1a48c8f6ef640e(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $c3f10480260b82e8$export$3a1a48c8f6ef640e(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        if ((obj === null || obj === void 0 ? void 0 : obj.email) && (obj === null || obj === void 0 ? void 0 : obj.password)) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $c3f10480260b82e8$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $c3f10480260b82e8$var$signInWithPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $c3f10480260b82e8$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $c3f10480260b82e8$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $c3f10480260b82e8$var$linkEmailPassword);
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $c3f10480260b82e8$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$signInWithIdp(auth, request) {
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$IDP_REQUEST_URI$1 = "http://localhost";
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $c3f10480260b82e8$export$a07804094c3ecf2d extends $c3f10480260b82e8$export$61196ced6d74a310 {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $c3f10480260b82e8$export$a07804094c3ecf2d(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $c3f10480260b82e8$export$9fa96a7d116ea3ce("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod } = obj, rest = (0, $l73V3.__rest)(obj, [
            "providerId",
            "signInMethod"
        ]);
        if (!providerId || !signInMethod) return null;
        const cred = new $c3f10480260b82e8$export$a07804094c3ecf2d(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $c3f10480260b82e8$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $c3f10480260b82e8$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $c3f10480260b82e8$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $c3f10480260b82e8$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody["id_token"] = this.idToken;
            if (this.accessToken) postBody["access_token"] = this.accessToken;
            if (this.secret) postBody["oauth_token_secret"] = this.secret;
            postBody["providerId"] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody["nonce"] = this.nonce;
            request.postBody = (0, $ffjl9.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$sendPhoneVerificationCode(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
async function $c3f10480260b82e8$var$signInWithPhoneNumber$1(auth, request) {
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
async function $c3f10480260b82e8$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $c3f10480260b82e8$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $c3f10480260b82e8$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $c3f10480260b82e8$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = Object.assign(Object.assign({}, request), {
        operation: "REAUTH"
    });
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, apiRequest), $c3f10480260b82e8$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $c3f10480260b82e8$export$3722cfe417b6ed86 extends $c3f10480260b82e8$export$61196ced6d74a310 {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $c3f10480260b82e8$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $c3f10480260b82e8$export$3722cfe417b6ed86({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $c3f10480260b82e8$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $c3f10480260b82e8$var$linkWithPhoneNumber$1(auth, Object.assign({
            idToken: idToken
        }, this._makeVerificationRequest()));
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $c3f10480260b82e8$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === "string") json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $c3f10480260b82e8$export$3722cfe417b6ed86({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $c3f10480260b82e8$var$parseMode(mode) {
    switch(mode){
        case "recoverEmail":
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case "resetPassword":
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case "signIn":
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case "verifyEmail":
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case "verifyAndChangeEmail":
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case "revertSecondFactorAddition":
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $c3f10480260b82e8$var$parseDeepLink(url) {
    const link = (0, $ffjl9.querystringDecode)((0, $ffjl9.extractQuerystring)(url))["link"];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $ffjl9.querystringDecode)((0, $ffjl9.extractQuerystring)(link))["deep_link_id"] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $ffjl9.querystringDecode)((0, $ffjl9.extractQuerystring)(url))["deep_link_id"];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $ffjl9.querystringDecode)((0, $ffjl9.extractQuerystring)(iOSDeepLink))["link"] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $c3f10480260b82e8$export$f38c853ae54ed474 {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        var _a, _b, _c, _d, _e, _f;
        const searchParams = (0, $ffjl9.querystringDecode)((0, $ffjl9.extractQuerystring)(actionLink));
        const apiKey = (_a = searchParams["apiKey" /* QueryField.API_KEY */ ]) !== null && _a !== void 0 ? _a : null;
        const code = (_b = searchParams["oobCode" /* QueryField.CODE */ ]) !== null && _b !== void 0 ? _b : null;
        const operation = $c3f10480260b82e8$var$parseMode((_c = searchParams["mode" /* QueryField.MODE */ ]) !== null && _c !== void 0 ? _c : null);
        // Validate API key, code and mode.
        $c3f10480260b82e8$export$890c4ad488842ce7(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = (_d = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ]) !== null && _d !== void 0 ? _d : null;
        this.languageCode = (_e = searchParams["languageCode" /* QueryField.LANGUAGE_CODE */ ]) !== null && _e !== void 0 ? _e : null;
        this.tenantId = (_f = searchParams["tenantId" /* QueryField.TENANT_ID */ ]) !== null && _f !== void 0 ? _f : null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $c3f10480260b82e8$var$parseDeepLink(link);
        try {
            return new $c3f10480260b82e8$export$f38c853ae54ed474(actionLink);
        } catch (_a) {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $c3f10480260b82e8$export$3b513254972cfc9c(link) {
    return $c3f10480260b82e8$export$f38c853ae54ed474.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $c3f10480260b82e8$export$e7c866399fa523f5 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $c3f10480260b82e8$export$e7c866399fa523f5.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $c3f10480260b82e8$export$3a1a48c8f6ef640e._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $c3f10480260b82e8$export$f38c853ae54ed474.parseLink(emailLink);
        $c3f10480260b82e8$export$890c4ad488842ce7(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c3f10480260b82e8$export$3a1a48c8f6ef640e._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $c3f10480260b82e8$export$e7c866399fa523f5.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $c3f10480260b82e8$export$e7c866399fa523f5.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $c3f10480260b82e8$export$e7c866399fa523f5.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $c3f10480260b82e8$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $c3f10480260b82e8$var$BaseOAuthProvider extends $c3f10480260b82e8$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $c3f10480260b82e8$export$dc98b0b04f4c7758 extends $c3f10480260b82e8$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        $c3f10480260b82e8$export$890c4ad488842ce7("providerId" in obj && "signInMethod" in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c3f10480260b82e8$export$a07804094c3ecf2d._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential(Object.assign(Object.assign({}, params), {
            nonce: params.rawNonce
        }));
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $c3f10480260b82e8$export$890c4ad488842ce7(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $c3f10480260b82e8$export$a07804094c3ecf2d._fromParams(Object.assign(Object.assign({}, params), {
            providerId: this.providerId,
            signInMethod: this.providerId
        }));
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c3f10480260b82e8$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c3f10480260b82e8$export$dc98b0b04f4c7758.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $c3f10480260b82e8$export$dc98b0b04f4c7758(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $c3f10480260b82e8$export$71cec2538cb2c617 extends $c3f10480260b82e8$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $c3f10480260b82e8$export$a07804094c3ecf2d._fromParams({
            providerId: $c3f10480260b82e8$export$71cec2538cb2c617.PROVIDER_ID,
            signInMethod: $c3f10480260b82e8$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c3f10480260b82e8$export$71cec2538cb2c617.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c3f10480260b82e8$export$71cec2538cb2c617.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $c3f10480260b82e8$export$71cec2538cb2c617.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $c3f10480260b82e8$export$71cec2538cb2c617.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $c3f10480260b82e8$export$71cec2538cb2c617.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $c3f10480260b82e8$export$78acf4525d8a74c4 extends $c3f10480260b82e8$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope("profile");
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $c3f10480260b82e8$export$a07804094c3ecf2d._fromParams({
            providerId: $c3f10480260b82e8$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $c3f10480260b82e8$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c3f10480260b82e8$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c3f10480260b82e8$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $c3f10480260b82e8$export$78acf4525d8a74c4.credential(oauthIdToken, oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $c3f10480260b82e8$export$78acf4525d8a74c4.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $c3f10480260b82e8$export$78acf4525d8a74c4.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $c3f10480260b82e8$export$8743009a87fcb00f extends $c3f10480260b82e8$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $c3f10480260b82e8$export$a07804094c3ecf2d._fromParams({
            providerId: $c3f10480260b82e8$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $c3f10480260b82e8$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c3f10480260b82e8$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c3f10480260b82e8$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !("oauthAccessToken" in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $c3f10480260b82e8$export$8743009a87fcb00f.credential(tokenResponse.oauthAccessToken);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $c3f10480260b82e8$export$8743009a87fcb00f.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $c3f10480260b82e8$export$8743009a87fcb00f.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$IDP_REQUEST_URI = "http://localhost";
/**
 * @public
 */ class $c3f10480260b82e8$export$f96d196f7728bb5 extends $c3f10480260b82e8$export$61196ced6d74a310 {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $c3f10480260b82e8$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $c3f10480260b82e8$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $c3f10480260b82e8$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === "string" ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $c3f10480260b82e8$export$f96d196f7728bb5(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $c3f10480260b82e8$export$f96d196f7728bb5(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $c3f10480260b82e8$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$SAML_PROVIDER_PREFIX = "saml.";
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $c3f10480260b82e8$export$71511d61b312f219 extends $c3f10480260b82e8$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $c3f10480260b82e8$export$890c4ad488842ce7(providerId.startsWith($c3f10480260b82e8$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c3f10480260b82e8$export$71511d61b312f219.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c3f10480260b82e8$export$71511d61b312f219.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $c3f10480260b82e8$export$f96d196f7728bb5.fromJSON(json);
        $c3f10480260b82e8$export$890c4ad488842ce7(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $c3f10480260b82e8$export$f96d196f7728bb5._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $c3f10480260b82e8$export$3d8c2f653ac9d0b9 extends $c3f10480260b82e8$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $c3f10480260b82e8$export$a07804094c3ecf2d._fromParams({
            providerId: $c3f10480260b82e8$export$3d8c2f653ac9d0b9.PROVIDER_ID,
            signInMethod: $c3f10480260b82e8$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c3f10480260b82e8$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c3f10480260b82e8$export$3d8c2f653ac9d0b9.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $c3f10480260b82e8$export$3d8c2f653ac9d0b9.credential(oauthAccessToken, oauthTokenSecret);
        } catch (_a) {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $c3f10480260b82e8$export$3d8c2f653ac9d0b9.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $c3f10480260b82e8$export$3d8c2f653ac9d0b9.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$signUp(auth, request) {
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $c3f10480260b82e8$export$23ebac1979863676._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $c3f10480260b82e8$var$providerIdForResponse(idTokenResponse);
        const userCred = new $c3f10480260b82e8$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $c3f10480260b82e8$var$providerIdForResponse(response);
        return new $c3f10480260b82e8$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $c3f10480260b82e8$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ("phoneNumber" in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $c3f10480260b82e8$export$34aec0b863436764(auth) {
    var _a;
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    await authInternal._initializationPromise;
    if ((_a = authInternal.currentUser) === null || _a === void 0 ? void 0 : _a.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $c3f10480260b82e8$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $c3f10480260b82e8$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $c3f10480260b82e8$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$MultiFactorError extends (0, $ffjl9.FirebaseError) {
    constructor(auth, error, operationType, user){
        var _a;
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c3f10480260b82e8$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: (_a = auth.tenantId) !== null && _a !== void 0 ? _a : undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $c3f10480260b82e8$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $c3f10480260b82e8$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $c3f10480260b82e8$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $c3f10480260b82e8$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $c3f10480260b82e8$export$2f6ca3d3b1f80bf5(user, providerId) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    await $c3f10480260b82e8$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $c3f10480260b82e8$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $c3f10480260b82e8$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $c3f10480260b82e8$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $c3f10480260b82e8$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $c3f10480260b82e8$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $c3f10480260b82e8$var$_assertLinkedStatus(expected, user, provider) {
    await $c3f10480260b82e8$var$_reloadWithoutSaving(user);
    const providerIds = $c3f10480260b82e8$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $c3f10480260b82e8$export$890c4ad488842ce7(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $c3f10480260b82e8$var$_logoutIfInvalidated(user, $c3f10480260b82e8$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $c3f10480260b82e8$export$890c4ad488842ce7(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $c3f10480260b82e8$var$_parseToken(response.idToken);
        $c3f10480260b82e8$export$890c4ad488842ce7(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $c3f10480260b82e8$export$890c4ad488842ce7(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $c3f10480260b82e8$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if ((e === null || e === void 0 ? void 0 : e.code) === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $c3f10480260b82e8$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $c3f10480260b82e8$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c3f10480260b82e8$export$3c2fa207a37baaea(auth, credential) {
    return $c3f10480260b82e8$var$_signInWithCredential($c3f10480260b82e8$export$a05254e7c3aeba6e(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c3f10480260b82e8$export$ce26c07117d59d6a(user, credential) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    await $c3f10480260b82e8$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $c3f10480260b82e8$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c3f10480260b82e8$export$6559d589eb85fbb6(user, credential) {
    return $c3f10480260b82e8$var$_reauthenticate((0, $ffjl9.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$signInWithCustomToken$1(auth, request) {
    return $c3f10480260b82e8$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $c3f10480260b82e8$export$efca4cbe5dd06740(auth, customToken) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    const response = await $c3f10480260b82e8$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $c3f10480260b82e8$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ("phoneInfo" in enrollment) return $c3f10480260b82e8$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ("totpInfo" in enrollment) return $c3f10480260b82e8$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $c3f10480260b82e8$var$PhoneMultiFactorInfoImpl extends $c3f10480260b82e8$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $c3f10480260b82e8$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $c3f10480260b82e8$var$TotpMultiFactorInfoImpl extends $c3f10480260b82e8$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $c3f10480260b82e8$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    var _a;
    $c3f10480260b82e8$export$890c4ad488842ce7(((_a = actionCodeSettings.url) === null || _a === void 0 ? void 0 : _a.length) > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $c3f10480260b82e8$export$890c4ad488842ce7(typeof actionCodeSettings.dynamicLinkDomain === "undefined" || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $c3f10480260b82e8$export$890c4ad488842ce7(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $c3f10480260b82e8$export$890c4ad488842ce7(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $c3f10480260b82e8$var$recachePasswordPolicy(auth) {
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$a8550f7dbe79f93a(auth, email, actionCodeSettings) {
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $c3f10480260b82e8$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $c3f10480260b82e8$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $c3f10480260b82e8$var$sendPasswordResetEmail$1);
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $c3f10480260b82e8$export$2e2af4578d910ddf(auth, oobCode, newPassword) {
    await $c3f10480260b82e8$var$resetPassword((0, $ffjl9.getModularInstance)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $c3f10480260b82e8$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $c3f10480260b82e8$export$a93c5207d687da10(auth, oobCode) {
    await $c3f10480260b82e8$var$applyActionCode$1((0, $ffjl9.getModularInstance)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $c3f10480260b82e8$export$c3950d9923825c02(auth, oobCode) {
    const authModular = (0, $ffjl9.getModularInstance)(auth);
    const response = await $c3f10480260b82e8$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $c3f10480260b82e8$export$890c4ad488842ce7(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $c3f10480260b82e8$export$890c4ad488842ce7(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $c3f10480260b82e8$export$890c4ad488842ce7(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $c3f10480260b82e8$export$890c4ad488842ce7(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $c3f10480260b82e8$var$MultiFactorInfoImpl._fromServerResponse($c3f10480260b82e8$export$a05254e7c3aeba6e(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $c3f10480260b82e8$export$a9c996f45e5784d0(auth, code) {
    const { data: data } = await $c3f10480260b82e8$export$c3950d9923825c02((0, $ffjl9.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $c3f10480260b82e8$export$7910e0436ed8d1de(auth, email, password) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $c3f10480260b82e8$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $c3f10480260b82e8$var$signUp);
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $c3f10480260b82e8$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $c3f10480260b82e8$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $c3f10480260b82e8$export$555508cbc6add439(auth, email, password) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $c3f10480260b82e8$export$3c2fa207a37baaea((0, $ffjl9.getModularInstance)(auth), $c3f10480260b82e8$export$e7c866399fa523f5.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $c3f10480260b82e8$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$2219238a014317b0(auth, email, actionCodeSettings) {
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $c3f10480260b82e8$export$890c4ad488842ce7(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $c3f10480260b82e8$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $c3f10480260b82e8$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $c3f10480260b82e8$var$sendSignInLinkToEmail$1);
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $c3f10480260b82e8$export$4c3d22f3d993c33f(auth, emailLink) {
    const actionCodeUrl = $c3f10480260b82e8$export$f38c853ae54ed474.parseLink(emailLink);
    return (actionCodeUrl === null || actionCodeUrl === void 0 ? void 0 : actionCodeUrl.operation) === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $c3f10480260b82e8$export$f787f51d84a910ad(auth, email, emailLink) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $ffjl9.getModularInstance)(auth);
    const credential = $c3f10480260b82e8$export$e7c866399fa523f5.credentialWithLink(email, emailLink || $c3f10480260b82e8$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $c3f10480260b82e8$export$890c4ad488842ce7(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $c3f10480260b82e8$export$3c2fa207a37baaea(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$createAuthUri(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $c3f10480260b82e8$export$c9170ad7d4cd7e57(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $c3f10480260b82e8$var$_isHttpOrHttps() ? $c3f10480260b82e8$var$_getCurrentUrl() : "http://localhost";
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $c3f10480260b82e8$var$createAuthUri((0, $ffjl9.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$ee7c8ad385a60b7b(user, actionCodeSettings) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $c3f10480260b82e8$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $c3f10480260b82e8$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$995eb9fca571757(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $c3f10480260b82e8$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $c3f10480260b82e8$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$var$updateProfile$1(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $c3f10480260b82e8$export$21579262ef46735b(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $c3f10480260b82e8$var$_logoutIfInvalidated(userInternal, $c3f10480260b82e8$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $c3f10480260b82e8$export$ab83b03e4111b1d0(user, newEmail) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    if ((0, $ix4Jr._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $c3f10480260b82e8$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $c3f10480260b82e8$export$1a82df3d29112e01(user, newPassword) {
    return $c3f10480260b82e8$var$updateEmailOrPassword((0, $ffjl9.getModularInstance)(user), null, newPassword);
}
async function $c3f10480260b82e8$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $c3f10480260b82e8$var$_logoutIfInvalidated(user, $c3f10480260b82e8$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $c3f10480260b82e8$var$_fromIdTokenResponse(idTokenResponse) {
    var _a, _b;
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && (idTokenResponse === null || idTokenResponse === void 0 ? void 0 : idTokenResponse.idToken)) {
        const signInProvider = (_b = (_a = $c3f10480260b82e8$var$_parseToken(idTokenResponse.idToken)) === null || _a === void 0 ? void 0 : _a.firebase) === null || _b === void 0 ? void 0 : _b["sign_in_provider"];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $c3f10480260b82e8$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $c3f10480260b82e8$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $c3f10480260b82e8$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $c3f10480260b82e8$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $c3f10480260b82e8$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $c3f10480260b82e8$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $c3f10480260b82e8$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $c3f10480260b82e8$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $c3f10480260b82e8$var$FederatedAdditionalUserInfoWithUsername extends $c3f10480260b82e8$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $c3f10480260b82e8$var$FacebookAdditionalUserInfo extends $c3f10480260b82e8$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $c3f10480260b82e8$var$GithubAdditionalUserInfo extends $c3f10480260b82e8$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof (profile === null || profile === void 0 ? void 0 : profile.login) === "string" ? profile === null || profile === void 0 ? void 0 : profile.login : null);
    }
}
class $c3f10480260b82e8$var$GoogleAdditionalUserInfo extends $c3f10480260b82e8$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $c3f10480260b82e8$var$TwitterAdditionalUserInfo extends $c3f10480260b82e8$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $c3f10480260b82e8$export$8a5498727ef6be21(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $c3f10480260b82e8$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $c3f10480260b82e8$export$9e5f44173e64f162(auth, persistence) {
    return (0, $ffjl9.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c3f10480260b82e8$export$625550452a3fa3ec(auth) {
    return $c3f10480260b82e8$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $c3f10480260b82e8$export$90a7f3efeed30595(auth, password) {
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $c3f10480260b82e8$export$efccba1c4a2ef57b(auth, nextOrObserver, error, completed) {
    return (0, $ffjl9.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $c3f10480260b82e8$export$d141bba7fdc215a3(auth, callback, onAbort) {
    return (0, $ffjl9.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $c3f10480260b82e8$export$4a5767248b18ef41(auth, nextOrObserver, error, completed) {
    return (0, $ffjl9.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c3f10480260b82e8$export$df995fae86a55f06(auth) {
    (0, $ffjl9.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $c3f10480260b82e8$export$ef35774e6d314e91(auth, user) {
    return (0, $ffjl9.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c3f10480260b82e8$export$e7094788287c5e9b(auth) {
    return (0, $ffjl9.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $c3f10480260b82e8$export$96f57966bedc81b4(auth, token) {
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $c3f10480260b82e8$export$a9c23c6ac3fc3eca(user) {
    return (0, $ffjl9.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $c3f10480260b82e8$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $c3f10480260b82e8$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? "idToken" : "pendingCredential";
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        var _a, _b;
        if (obj === null || obj === void 0 ? void 0 : obj.multiFactorSession) {
            if ((_a = obj.multiFactorSession) === null || _a === void 0 ? void 0 : _a.pendingCredential) return $c3f10480260b82e8$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if ((_b = obj.multiFactorSession) === null || _b === void 0 ? void 0 : _b.idToken) return $c3f10480260b82e8$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $c3f10480260b82e8$export$a05254e7c3aeba6e(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$c3f10480260b82e8$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $c3f10480260b82e8$export$890c4ad488842ce7(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $c3f10480260b82e8$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $c3f10480260b82e8$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = Object.assign(Object.assign({}, serverResponse), {
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            });
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $c3f10480260b82e8$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $c3f10480260b82e8$export$890c4ad488842ce7(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $c3f10480260b82e8$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $c3f10480260b82e8$export$6554612db691658e(auth, error) {
    var _a;
    const authModular = (0, $ffjl9.getModularInstance)(auth);
    const errorInternal = error;
    $c3f10480260b82e8$export$890c4ad488842ce7(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $c3f10480260b82e8$export$890c4ad488842ce7((_a = errorInternal.customData._serverResponse) === null || _a === void 0 ? void 0 : _a.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $c3f10480260b82e8$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$startEnrollPhoneMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
function $c3f10480260b82e8$var$finalizeEnrollPhoneMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
function $c3f10480260b82e8$var$startEnrollTotpMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
function $c3f10480260b82e8$var$finalizeEnrollTotpMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
function $c3f10480260b82e8$var$withdrawMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
class $c3f10480260b82e8$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$c3f10480260b82e8$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $c3f10480260b82e8$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $c3f10480260b82e8$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $c3f10480260b82e8$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === "string" ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $c3f10480260b82e8$var$_logoutIfInvalidated(this.user, $c3f10480260b82e8$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $c3f10480260b82e8$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $c3f10480260b82e8$export$493d36ec626b6698(user) {
    const userModular = (0, $ffjl9.getModularInstance)(user);
    if (!$c3f10480260b82e8$var$multiFactorUserCache.has(userModular)) $c3f10480260b82e8$var$multiFactorUserCache.set(userModular, $c3f10480260b82e8$var$MultiFactorUserImpl._fromUser(userModular));
    return $c3f10480260b82e8$var$multiFactorUserCache.get(userModular);
}
const $c3f10480260b82e8$var$STORAGE_AVAILABLE_KEY = "__sak";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $c3f10480260b82e8$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($c3f10480260b82e8$var$STORAGE_AVAILABLE_KEY, "1");
            this.storage.removeItem($c3f10480260b82e8$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch (_a) {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $c3f10480260b82e8$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $c3f10480260b82e8$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $c3f10480260b82e8$var$BrowserLocalPersistence extends $c3f10480260b82e8$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $c3f10480260b82e8$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($c3f10480260b82e8$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $c3f10480260b82e8$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent("storage", {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $c3f10480260b82e8$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener("storage", this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener("storage", this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$c3f10480260b82e8$var$BrowserLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $c3f10480260b82e8$export$8b22cf2602fb60ce = $c3f10480260b82e8$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$BrowserSessionPersistence extends $c3f10480260b82e8$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$c3f10480260b82e8$var$BrowserSessionPersistence.type = "SESSION";
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $c3f10480260b82e8$export$407448d2b89b1813 = $c3f10480260b82e8$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $c3f10480260b82e8$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $c3f10480260b82e8$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $c3f10480260b82e8$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!(handlers === null || handlers === void 0 ? void 0 : handlers.size)) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $c3f10480260b82e8$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener("message", this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener("message", this.boundEventHandler);
    }
}
$c3f10480260b82e8$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$export$faec65b429be379(prefix = "", digits = 10) {
    let random = "";
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $c3f10480260b82e8$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener("message", handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== "undefined" ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $c3f10480260b82e8$export$faec65b429be379("", 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener("message", handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $c3f10480260b82e8$var$_window() {
    return window;
}
function $c3f10480260b82e8$var$_setWindowLocation(url) {
    $c3f10480260b82e8$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$_isWorker() {
    return typeof $c3f10480260b82e8$var$_window()["WorkerGlobalScope"] !== "undefined" && typeof $c3f10480260b82e8$var$_window()["importScripts"] === "function";
}
async function $c3f10480260b82e8$var$_getActiveServiceWorker() {
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker)) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch (_a) {
        return null;
    }
}
function $c3f10480260b82e8$var$_getServiceWorkerController() {
    var _a;
    return ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.serviceWorker) === null || _a === void 0 ? void 0 : _a.controller) || null;
}
function $c3f10480260b82e8$var$_getWorkerGlobalScope() {
    return $c3f10480260b82e8$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$DB_NAME = "firebaseLocalStorageDb";
const $c3f10480260b82e8$var$DB_VERSION = 1;
const $c3f10480260b82e8$var$DB_OBJECTSTORE_NAME = "firebaseLocalStorage";
const $c3f10480260b82e8$var$DB_DATA_KEYPATH = "fbase_key";
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $c3f10480260b82e8$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener("success", ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener("error", ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $c3f10480260b82e8$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $c3f10480260b82e8$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? "readwrite" : "readonly").objectStore($c3f10480260b82e8$var$DB_OBJECTSTORE_NAME);
}
function $c3f10480260b82e8$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($c3f10480260b82e8$var$DB_NAME);
    return new $c3f10480260b82e8$var$DBPromise(request).toPromise();
}
function $c3f10480260b82e8$var$_openDatabase() {
    const request = indexedDB.open($c3f10480260b82e8$var$DB_NAME, $c3f10480260b82e8$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener("error", ()=>{
            reject(request.error);
        });
        request.addEventListener("upgradeneeded", ()=>{
            const db = request.result;
            try {
                db.createObjectStore($c3f10480260b82e8$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $c3f10480260b82e8$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener("success", async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($c3f10480260b82e8$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $c3f10480260b82e8$var$_deleteDatabase();
                resolve(await $c3f10480260b82e8$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $c3f10480260b82e8$var$_putObject(db, key, value) {
    const request = $c3f10480260b82e8$var$getObjectStore(db, true).put({
        [$c3f10480260b82e8$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $c3f10480260b82e8$var$DBPromise(request).toPromise();
}
async function $c3f10480260b82e8$var$getObject(db, key) {
    const request = $c3f10480260b82e8$var$getObjectStore(db, false).get(key);
    const data = await new $c3f10480260b82e8$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $c3f10480260b82e8$var$_deleteObject(db, key) {
    const request = $c3f10480260b82e8$var$getObjectStore(db, true).delete(key);
    return new $c3f10480260b82e8$var$DBPromise(request).toPromise();
}
const $c3f10480260b82e8$var$_POLLING_INTERVAL_MS = 800;
const $c3f10480260b82e8$var$_TRANSACTION_RETRY_COUNT = 3;
class $c3f10480260b82e8$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.db) return this.db;
        this.db = await $c3f10480260b82e8$var$_openDatabase();
        return this.db;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $c3f10480260b82e8$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.db) {
                this.db.close();
                this.db = undefined;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $c3f10480260b82e8$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $c3f10480260b82e8$var$Receiver._getInstance($c3f10480260b82e8$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        var _a, _b;
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $c3f10480260b82e8$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $c3f10480260b82e8$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (((_a = results[0]) === null || _a === void 0 ? void 0 : _a.fulfilled) && ((_b = results[0]) === null || _b === void 0 ? void 0 : _b.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ ))) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $c3f10480260b82e8$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch (_a) {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            const db = await $c3f10480260b82e8$var$_openDatabase();
            await $c3f10480260b82e8$var$_putObject(db, $c3f10480260b82e8$var$STORAGE_AVAILABLE_KEY, "1");
            await $c3f10480260b82e8$var$_deleteObject(db, $c3f10480260b82e8$var$STORAGE_AVAILABLE_KEY);
            return true;
        } catch (_a) {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$c3f10480260b82e8$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$c3f10480260b82e8$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$c3f10480260b82e8$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $c3f10480260b82e8$var$getObjectStore(db, false).getAll();
            return new $c3f10480260b82e8$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $c3f10480260b82e8$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$c3f10480260b82e8$var$IndexedDBLocalPersistence.type = "LOCAL";
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $c3f10480260b82e8$export$23f2a1d2818174ef = $c3f10480260b82e8$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$startSignInPhoneMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
function $c3f10480260b82e8$var$finalizeSignInPhoneMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
function $c3f10480260b82e8$var$finalizeSignInTotpMfa(auth, request) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $c3f10480260b82e8$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$_SOLVE_TIME_MS = 500;
const $c3f10480260b82e8$var$_EXPIRATION_TIME_MS = 60000;
const $c3f10480260b82e8$var$_WIDGET_ID_START = 1000000000000;
class $c3f10480260b82e8$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $c3f10480260b82e8$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $c3f10480260b82e8$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        var _a;
        const id = optWidgetId || $c3f10480260b82e8$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        var _a;
        const id = optWidgetId || $c3f10480260b82e8$var$_WIDGET_ID_START;
        return ((_a = this._widgets.get(id)) === null || _a === void 0 ? void 0 : _a.getResponse()) || "";
    }
    async execute(optWidgetId) {
        var _a;
        const id = optWidgetId || $c3f10480260b82e8$var$_WIDGET_ID_START;
        (_a = this._widgets.get(id)) === null || _a === void 0 || _a.execute();
        return "";
    }
}
class $c3f10480260b82e8$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $c3f10480260b82e8$export$890c4ad488842ce7(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== "invisible";
        if (this.isVisible) this.execute();
        else this.container.addEventListener("click", this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener("click", this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $c3f10480260b82e8$var$generateRandomAlphaNumericString(50);
            const { callback: callback, "expired-callback": expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $c3f10480260b82e8$var$_EXPIRATION_TIME_MS);
        }, $c3f10480260b82e8$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error("reCAPTCHA mock was already deleted!");
    }
}
function $c3f10480260b82e8$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = "1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join("");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $c3f10480260b82e8$var$_JSLOAD_CALLBACK = $c3f10480260b82e8$var$_generateCallbackName("rcb");
const $c3f10480260b82e8$var$NETWORK_TIMEOUT_DELAY = new $c3f10480260b82e8$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $c3f10480260b82e8$var$ReCaptchaLoaderImpl {
    constructor(){
        var _a;
        this.hostLanguage = "";
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!((_a = $c3f10480260b82e8$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render);
    }
    load(auth, hl = "") {
        $c3f10480260b82e8$export$890c4ad488842ce7($c3f10480260b82e8$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $c3f10480260b82e8$var$isV2($c3f10480260b82e8$var$_window().grecaptcha)) return Promise.resolve($c3f10480260b82e8$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $c3f10480260b82e8$var$_window().setTimeout(()=>{
                reject($c3f10480260b82e8$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $c3f10480260b82e8$var$NETWORK_TIMEOUT_DELAY.get());
            $c3f10480260b82e8$var$_window()[$c3f10480260b82e8$var$_JSLOAD_CALLBACK] = ()=>{
                $c3f10480260b82e8$var$_window().clearTimeout(networkTimeout);
                delete $c3f10480260b82e8$var$_window()[$c3f10480260b82e8$var$_JSLOAD_CALLBACK];
                const recaptcha = $c3f10480260b82e8$var$_window().grecaptcha;
                if (!recaptcha || !$c3f10480260b82e8$var$isV2(recaptcha)) {
                    reject($c3f10480260b82e8$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$c3f10480260b82e8$var$_recaptchaV2ScriptUrl()}?${(0, $ffjl9.querystring)({
                onload: $c3f10480260b82e8$var$_JSLOAD_CALLBACK,
                render: "explicit",
                hl: hl
            })}`;
            $c3f10480260b82e8$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($c3f10480260b82e8$export$9d398bebfec1c039(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        var _a;
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!((_a = $c3f10480260b82e8$var$_window().grecaptcha) === null || _a === void 0 ? void 0 : _a.render) && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $c3f10480260b82e8$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $c3f10480260b82e8$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $c3f10480260b82e8$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$RECAPTCHA_VERIFIER_TYPE = "recaptcha";
const $c3f10480260b82e8$var$DEFAULT_PARAMS = {
    theme: "light",
    type: "image"
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $c3f10480260b82e8$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = Object.assign({}, $c3f10480260b82e8$var$DEFAULT_PARAMS)){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $c3f10480260b82e8$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $c3f10480260b82e8$export$a05254e7c3aeba6e(authExtern);
        this.isInvisible = this.parameters.size === "invisible";
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === "string" ? document.getElementById(containerOrId) : containerOrId;
        $c3f10480260b82e8$export$890c4ad488842ce7(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $c3f10480260b82e8$var$MockReCaptchaLoaderImpl() : new $c3f10480260b82e8$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $c3f10480260b82e8$export$890c4ad488842ce7(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c3f10480260b82e8$export$890c4ad488842ce7(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof document !== "undefined", this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === "function") existing(token);
            else if (typeof existing === "string") {
                const globalFunc = $c3f10480260b82e8$var$_window()[existing];
                if (typeof globalFunc === "function") globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $c3f10480260b82e8$export$890c4ad488842ce7(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement("div");
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $c3f10480260b82e8$export$890c4ad488842ce7($c3f10480260b82e8$var$_isHttpOrHttps() && !$c3f10480260b82e8$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $c3f10480260b82e8$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $c3f10480260b82e8$var$getRecaptchaParams(this.auth);
        $c3f10480260b82e8$export$890c4ad488842ce7(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $c3f10480260b82e8$export$890c4ad488842ce7(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $c3f10480260b82e8$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === "complete") {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener("load", resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener("load", resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $c3f10480260b82e8$export$3722cfe417b6ed86._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method also requires a {@link ApplicationVerifier}.
 * This SDK includes a reCAPTCHA-based implementation, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    const verificationId = await $c3f10480260b82e8$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $ffjl9.getModularInstance)(appVerifier));
    return new $c3f10480260b82e8$var$ConfirmationResultImpl(verificationId, (cred)=>$c3f10480260b82e8$export$3c2fa207a37baaea(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    await $c3f10480260b82e8$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $c3f10480260b82e8$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $ffjl9.getModularInstance)(appVerifier));
    return new $c3f10480260b82e8$var$ConfirmationResultImpl(verificationId, (cred)=>$c3f10480260b82e8$export$ce26c07117d59d6a(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    if ((0, $ix4Jr._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $c3f10480260b82e8$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $ffjl9.getModularInstance)(appVerifier));
    return new $c3f10480260b82e8$var$ConfirmationResultImpl(verificationId, (cred)=>$c3f10480260b82e8$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $c3f10480260b82e8$var$_verifyPhoneNumber(auth, options, verifier) {
    var _a;
    const recaptchaToken = await verifier.verify();
    try {
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof recaptchaToken === "string", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c3f10480260b82e8$export$890c4ad488842ce7(verifier.type === $c3f10480260b82e8$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        let phoneInfoOptions;
        if (typeof options === "string") phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ("session" in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ("phoneNumber" in phoneInfoOptions) {
                $c3f10480260b82e8$export$890c4ad488842ce7(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const response = await $c3f10480260b82e8$var$startEnrollPhoneMfa(auth, {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $c3f10480260b82e8$export$890c4ad488842ce7(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = ((_a = phoneInfoOptions.multiFactorHint) === null || _a === void 0 ? void 0 : _a.uid) || phoneInfoOptions.multiFactorUid;
                $c3f10480260b82e8$export$890c4ad488842ce7(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const response = await $c3f10480260b82e8$var$startSignInPhoneMfa(auth, {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        recaptchaToken: recaptchaToken
                    }
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const { sessionInfo: sessionInfo } = await $c3f10480260b82e8$var$sendPhoneVerificationCode(auth, {
                phoneNumber: phoneInfoOptions.phoneNumber,
                recaptchaToken: recaptchaToken
            });
            return sessionInfo;
        }
    } finally{
        verifier._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $c3f10480260b82e8$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    if ((0, $ix4Jr._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $c3f10480260b82e8$var$_link$1(userInternal, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $c3f10480260b82e8$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $c3f10480260b82e8$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - For abuse prevention, this method also requires a
     * {@link ApplicationVerifier}. This SDK includes a reCAPTCHA-based implementation,
     * {@link RecaptchaVerifier}.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow..
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $c3f10480260b82e8$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $ffjl9.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $c3f10480260b82e8$export$3722cfe417b6ed86._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $c3f10480260b82e8$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $c3f10480260b82e8$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $c3f10480260b82e8$export$3722cfe417b6ed86._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $c3f10480260b82e8$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $c3f10480260b82e8$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $c3f10480260b82e8$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $c3f10480260b82e8$export$158acd800e1ef08b(resolverOverride);
    $c3f10480260b82e8$export$890c4ad488842ce7(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$IdpCredential extends $c3f10480260b82e8$export$61196ced6d74a310 {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $c3f10480260b82e8$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $c3f10480260b82e8$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $c3f10480260b82e8$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $c3f10480260b82e8$var$_signIn(params) {
    return $c3f10480260b82e8$var$_signInWithCredential(params.auth, new $c3f10480260b82e8$var$IdpCredential(params), params.bypassAuthState);
}
function $c3f10480260b82e8$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $c3f10480260b82e8$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $c3f10480260b82e8$var$_reauthenticate(user, new $c3f10480260b82e8$var$IdpCredential(params), params.bypassAuthState);
}
async function $c3f10480260b82e8$var$_link(params) {
    const { auth: auth, user: user } = params;
    $c3f10480260b82e8$export$890c4ad488842ce7(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $c3f10480260b82e8$var$_link$1(user, new $c3f10480260b82e8$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $c3f10480260b82e8$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $c3f10480260b82e8$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $c3f10480260b82e8$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $c3f10480260b82e8$var$_reauth;
            default:
                $c3f10480260b82e8$export$9fa96a7d116ea3ce(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $c3f10480260b82e8$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $c3f10480260b82e8$export$1fbe638ecf81657e(this.pendingPromise, "Pending promise was never set");
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $c3f10480260b82e8$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$db3b6bfb95261072(auth, provider, resolver) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$export$9d398bebfec1c039(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    $c3f10480260b82e8$var$_assertInstanceOf(auth, provider, $c3f10480260b82e8$var$FederatedAuthProvider);
    const resolverInternal = $c3f10480260b82e8$var$_withDefaultResolver(authInternal, resolver);
    const action = new $c3f10480260b82e8$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    if ((0, $ix4Jr._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($c3f10480260b82e8$export$9d398bebfec1c039(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $c3f10480260b82e8$var$_assertInstanceOf(userInternal.auth, provider, $c3f10480260b82e8$var$FederatedAuthProvider);
    const resolverInternal = $c3f10480260b82e8$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $c3f10480260b82e8$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$4368d992c4eafac0(user, provider, resolver) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    $c3f10480260b82e8$var$_assertInstanceOf(userInternal.auth, provider, $c3f10480260b82e8$var$FederatedAuthProvider);
    const resolverInternal = $c3f10480260b82e8$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $c3f10480260b82e8$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $c3f10480260b82e8$var$PopupOperation extends $c3f10480260b82e8$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($c3f10480260b82e8$var$PopupOperation.currentPopupAction) $c3f10480260b82e8$var$PopupOperation.currentPopupAction.cancel();
        $c3f10480260b82e8$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $c3f10480260b82e8$export$890c4ad488842ce7(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $c3f10480260b82e8$export$1fbe638ecf81657e(this.filter.length === 1, "Popup operations only handle one event");
        const eventId = $c3f10480260b82e8$export$faec65b429be379();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($c3f10480260b82e8$export$9d398bebfec1c039(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        var _a;
        return ((_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.associatedEvent) || null;
    }
    cancel() {
        this.reject($c3f10480260b82e8$export$9d398bebfec1c039(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $c3f10480260b82e8$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            var _a, _b;
            if ((_b = (_a = this.authWindow) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($c3f10480260b82e8$export$9d398bebfec1c039(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $c3f10480260b82e8$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$c3f10480260b82e8$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$PENDING_REDIRECT_KEY = "pendingRedirect";
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $c3f10480260b82e8$var$redirectOutcomeMap = new Map();
class $c3f10480260b82e8$var$RedirectAction extends $c3f10480260b82e8$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $c3f10480260b82e8$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $c3f10480260b82e8$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $c3f10480260b82e8$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $c3f10480260b82e8$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $c3f10480260b82e8$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $c3f10480260b82e8$var$pendingRedirectKey(auth);
    const persistence = $c3f10480260b82e8$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === "true";
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $c3f10480260b82e8$var$_setPendingRedirectStatus(resolver, auth) {
    return $c3f10480260b82e8$var$resolverPersistence(resolver)._set($c3f10480260b82e8$var$pendingRedirectKey(auth), "true");
}
function $c3f10480260b82e8$export$b9a6b53f9be3734() {
    $c3f10480260b82e8$var$redirectOutcomeMap.clear();
}
function $c3f10480260b82e8$export$a33b77bbdbb8366c(auth, result) {
    $c3f10480260b82e8$var$redirectOutcomeMap.set(auth._key(), result);
}
function $c3f10480260b82e8$var$resolverPersistence(resolver) {
    return $c3f10480260b82e8$export$158acd800e1ef08b(resolver._redirectPersistence);
}
function $c3f10480260b82e8$var$pendingRedirectKey(auth) {
    return $c3f10480260b82e8$export$cf2f7c5792f80b46($c3f10480260b82e8$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c3f10480260b82e8$export$2d1720544b23b823(auth, provider, resolver) {
    return $c3f10480260b82e8$var$_signInWithRedirect(auth, provider, resolver);
}
async function $c3f10480260b82e8$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    $c3f10480260b82e8$var$_assertInstanceOf(auth, provider, $c3f10480260b82e8$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $c3f10480260b82e8$var$_withDefaultResolver(authInternal, resolver);
    await $c3f10480260b82e8$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c3f10480260b82e8$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $c3f10480260b82e8$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $c3f10480260b82e8$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    $c3f10480260b82e8$var$_assertInstanceOf(userInternal.auth, provider, $c3f10480260b82e8$var$FederatedAuthProvider);
    if ((0, $ix4Jr._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $c3f10480260b82e8$var$_withDefaultResolver(userInternal.auth, resolver);
    await $c3f10480260b82e8$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $c3f10480260b82e8$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c3f10480260b82e8$export$39b482c5e57630a8(user, provider, resolver) {
    return $c3f10480260b82e8$var$_linkWithRedirect(user, provider, resolver);
}
async function $c3f10480260b82e8$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $ffjl9.getModularInstance)(user);
    $c3f10480260b82e8$var$_assertInstanceOf(userInternal.auth, provider, $c3f10480260b82e8$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $c3f10480260b82e8$var$_withDefaultResolver(userInternal.auth, resolver);
    await $c3f10480260b82e8$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $c3f10480260b82e8$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $c3f10480260b82e8$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c3f10480260b82e8$export$35e795649ee09318(auth, resolver) {
    await $c3f10480260b82e8$export$a05254e7c3aeba6e(auth)._initializationPromise;
    return $c3f10480260b82e8$export$53a70dd1ebbae346(auth, resolver, false);
}
async function $c3f10480260b82e8$export$53a70dd1ebbae346(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $ix4Jr._isFirebaseServerApp)(auth.app)) return Promise.reject($c3f10480260b82e8$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c3f10480260b82e8$export$a05254e7c3aeba6e(auth);
    const resolver = $c3f10480260b82e8$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $c3f10480260b82e8$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $c3f10480260b82e8$var$prepareUserForRedirect(user) {
    const eventId = $c3f10480260b82e8$export$faec65b429be379(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $c3f10480260b82e8$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $c3f10480260b82e8$export$24baa2b76016ce0e {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$c3f10480260b82e8$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        var _a;
        if (event.error && !$c3f10480260b82e8$var$isNullRedirectEvent(event)) {
            const code = ((_a = event.error.code) === null || _a === void 0 ? void 0 : _a.split("auth/")[1]) || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($c3f10480260b82e8$export$9d398bebfec1c039(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $c3f10480260b82e8$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($c3f10480260b82e8$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($c3f10480260b82e8$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $c3f10480260b82e8$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join("-");
}
function $c3f10480260b82e8$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && (error === null || error === void 0 ? void 0 : error.code) === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $c3f10480260b82e8$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $c3f10480260b82e8$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c3f10480260b82e8$export$3d12bd131bb975d1(auth, request = {}) {
    return $c3f10480260b82e8$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $c3f10480260b82e8$var$HTTP_REGEX = /^https?/;
async function $c3f10480260b82e8$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $c3f10480260b82e8$export$3d12bd131bb975d1(auth);
    for (const domain of authorizedDomains)try {
        if ($c3f10480260b82e8$var$matchDomain(domain)) return;
    } catch (_a) {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $c3f10480260b82e8$var$matchDomain(expected) {
    const currentUrl = $c3f10480260b82e8$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith("chrome-extension://")) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === "" && hostname === "") // For some reason we're not parsing chrome URLs properly
        return protocol === "chrome-extension:" && expected.replace("chrome-extension://", "") === currentUrl.replace("chrome-extension://", "");
        return protocol === "chrome-extension:" && ceUrl.hostname === hostname;
    }
    if (!$c3f10480260b82e8$var$HTTP_REGEX.test(protocol)) return false;
    if ($c3f10480260b82e8$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, "\\.");
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp("^(.+\\." + escapedDomainPattern + "|" + escapedDomainPattern + ")$", "i");
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$NETWORK_TIMEOUT = new $c3f10480260b82e8$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $c3f10480260b82e8$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $c3f10480260b82e8$var$_window().___jsl;
    // Get current hint.
    if (beacon === null || beacon === void 0 ? void 0 : beacon.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $c3f10480260b82e8$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        var _a, _b, _c;
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $c3f10480260b82e8$var$resetUnloadedGapiModules();
            gapi.load("gapi.iframes", {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $c3f10480260b82e8$var$resetUnloadedGapiModules();
                    reject($c3f10480260b82e8$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $c3f10480260b82e8$var$NETWORK_TIMEOUT.get()
            });
        }
        if ((_b = (_a = $c3f10480260b82e8$var$_window().gapi) === null || _a === void 0 ? void 0 : _a.iframes) === null || _b === void 0 ? void 0 : _b.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!((_c = $c3f10480260b82e8$var$_window().gapi) === null || _c === void 0 ? void 0 : _c.load)) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $c3f10480260b82e8$var$_generateCallbackName("iframefcb");
            // GApi loader not available, dynamically load platform.js.
            $c3f10480260b82e8$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($c3f10480260b82e8$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $c3f10480260b82e8$var$_loadJS(`${$c3f10480260b82e8$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $c3f10480260b82e8$var$cachedGApiLoader = null;
        throw error;
    });
}
let $c3f10480260b82e8$var$cachedGApiLoader = null;
function $c3f10480260b82e8$var$_loadGapi(auth) {
    $c3f10480260b82e8$var$cachedGApiLoader = $c3f10480260b82e8$var$cachedGApiLoader || $c3f10480260b82e8$var$loadGapi(auth);
    return $c3f10480260b82e8$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$PING_TIMEOUT = new $c3f10480260b82e8$var$Delay(5000, 15000);
const $c3f10480260b82e8$var$IFRAME_PATH = "__/auth/iframe";
const $c3f10480260b82e8$var$EMULATED_IFRAME_PATH = "emulator/auth/iframe";
const $c3f10480260b82e8$var$IFRAME_ATTRIBUTES = {
    style: {
        position: "absolute",
        top: "-100px",
        width: "1px",
        height: "1px"
    },
    "aria-hidden": "true",
    tabindex: "-1"
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $c3f10480260b82e8$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        "p"
    ],
    [
        "staging-identitytoolkit.sandbox.googleapis.com",
        "s"
    ],
    [
        "test-identitytoolkit.sandbox.googleapis.com",
        "t"
    ] // test
]);
function $c3f10480260b82e8$var$getIframeUrl(auth) {
    const config = auth.config;
    $c3f10480260b82e8$export$890c4ad488842ce7(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $c3f10480260b82e8$var$_emulatorUrl(config, $c3f10480260b82e8$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$c3f10480260b82e8$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $ix4Jr.SDK_VERSION)
    };
    const eid = $c3f10480260b82e8$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(",");
    return `${url}?${(0, $ffjl9.querystring)(params).slice(1)}`;
}
async function $c3f10480260b82e8$var$_openIframe(auth) {
    const context = await $c3f10480260b82e8$var$_loadGapi(auth);
    const gapi1 = $c3f10480260b82e8$var$_window().gapi;
    $c3f10480260b82e8$export$890c4ad488842ce7(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $c3f10480260b82e8$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $c3f10480260b82e8$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $c3f10480260b82e8$export$9d398bebfec1c039(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $c3f10480260b82e8$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $c3f10480260b82e8$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $c3f10480260b82e8$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$BASE_POPUP_OPTIONS = {
    location: "yes",
    resizable: "yes",
    statusbar: "yes",
    toolbar: "no"
};
const $c3f10480260b82e8$var$DEFAULT_WIDTH = 500;
const $c3f10480260b82e8$var$DEFAULT_HEIGHT = 600;
const $c3f10480260b82e8$var$TARGET_BLANK = "_blank";
const $c3f10480260b82e8$var$FIREFOX_EMPTY_URL = "http://localhost";
class $c3f10480260b82e8$export$c03999cb2f36933f {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $c3f10480260b82e8$var$_open(auth, url, name, width = $c3f10480260b82e8$var$DEFAULT_WIDTH, height = $c3f10480260b82e8$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = "";
    const options = Object.assign(Object.assign({}, $c3f10480260b82e8$var$BASE_POPUP_OPTIONS), {
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    });
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $ffjl9.getUA)().toLowerCase();
    if (name) target = $c3f10480260b82e8$var$_isChromeIOS(ua) ? $c3f10480260b82e8$var$TARGET_BLANK : name;
    if ($c3f10480260b82e8$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $c3f10480260b82e8$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = "yes";
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, "");
    if ($c3f10480260b82e8$var$_isIOSStandalone(ua) && target !== "_self") {
        $c3f10480260b82e8$var$openAsNewWindowIOS(url || "", target);
        return new $c3f10480260b82e8$export$c03999cb2f36933f(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || "", target, optionsString);
    $c3f10480260b82e8$export$890c4ad488842ce7(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $c3f10480260b82e8$export$c03999cb2f36933f(newWin);
}
function $c3f10480260b82e8$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement("a");
    el.href = url;
    el.target = target;
    const click = document.createEvent("MouseEvent");
    click.initMouseEvent("click", true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $c3f10480260b82e8$var$WIDGET_PATH = "__/auth/handler";
/**
 * URL for emulated environment
 *
 * @internal
 */ const $c3f10480260b82e8$var$EMULATOR_WIDGET_PATH = "emulator/auth/handler";
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $c3f10480260b82e8$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent("fac");
async function $c3f10480260b82e8$export$28f7fcd39efa255(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $c3f10480260b82e8$export$890c4ad488842ce7(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $c3f10480260b82e8$export$890c4ad488842ce7(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $ix4Jr.SDK_VERSION),
        eventId: eventId
    };
    if (provider instanceof $c3f10480260b82e8$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || "";
        if (!(0, $ffjl9.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $c3f10480260b82e8$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== "");
        if (scopes.length > 0) params.scopes = scopes.join(",");
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$c3f10480260b82e8$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : "";
    // Start at index 1 to skip the leading '&' in the query string
    return `${$c3f10480260b82e8$var$getHandlerBase(auth)}?${(0, $ffjl9.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $c3f10480260b82e8$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$c3f10480260b82e8$var$WIDGET_PATH}`;
    return $c3f10480260b82e8$var$_emulatorUrl(config, $c3f10480260b82e8$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $c3f10480260b82e8$var$WEB_STORAGE_SUPPORT_KEY = "webStorageSupport";
class $c3f10480260b82e8$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $c3f10480260b82e8$export$407448d2b89b1813;
        this._completeRedirectFn = $c3f10480260b82e8$export$53a70dd1ebbae346;
        this._overrideRedirectResult = $c3f10480260b82e8$export$a33b77bbdbb8366c;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        var _a;
        $c3f10480260b82e8$export$1fbe638ecf81657e((_a = this.eventManagers[auth._key()]) === null || _a === void 0 ? void 0 : _a.manager, "_initialize() not called before _openPopup()");
        const url = await $c3f10480260b82e8$export$28f7fcd39efa255(auth, provider, authType, $c3f10480260b82e8$var$_getCurrentUrl(), eventId);
        return $c3f10480260b82e8$var$_open(auth, url, $c3f10480260b82e8$export$faec65b429be379());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $c3f10480260b82e8$export$28f7fcd39efa255(auth, provider, authType, $c3f10480260b82e8$var$_getCurrentUrl(), eventId);
        $c3f10480260b82e8$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $c3f10480260b82e8$export$1fbe638ecf81657e(promise, "If manager is not set, promise should be");
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $c3f10480260b82e8$var$_openIframe(auth);
        const manager = new $c3f10480260b82e8$export$24baa2b76016ce0e(auth);
        iframe.register("authEvent", (iframeEvent)=>{
            $c3f10480260b82e8$export$890c4ad488842ce7(iframeEvent === null || iframeEvent === void 0 ? void 0 : iframeEvent.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($c3f10480260b82e8$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $c3f10480260b82e8$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            var _a;
            const isSupported = (_a = result === null || result === void 0 ? void 0 : result[0]) === null || _a === void 0 ? void 0 : _a[$c3f10480260b82e8$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $c3f10480260b82e8$export$9fa96a7d116ea3ce(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $c3f10480260b82e8$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $c3f10480260b82e8$var$_isMobileBrowser() || $c3f10480260b82e8$var$_isSafari() || $c3f10480260b82e8$export$d66dc83d8cfc8dd();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $c3f10480260b82e8$export$342063e11d6c3cad = $c3f10480260b82e8$var$BrowserPopupRedirectResolver;
class $c3f10480260b82e8$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $c3f10480260b82e8$var$debugFail("unexpected MultiFactorSessionType");
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $c3f10480260b82e8$var$PhoneMultiFactorAssertionImpl extends $c3f10480260b82e8$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $c3f10480260b82e8$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $c3f10480260b82e8$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $c3f10480260b82e8$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $c3f10480260b82e8$export$953cecd6e717a553 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $c3f10480260b82e8$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $c3f10480260b82e8$export$953cecd6e717a553.FACTOR_ID = "phone";
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $c3f10480260b82e8$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $c3f10480260b82e8$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $c3f10480260b82e8$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        var _a;
        const mfaSession = session;
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof ((_a = mfaSession.user) === null || _a === void 0 ? void 0 : _a.auth) !== "undefined", "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $c3f10480260b82e8$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $c3f10480260b82e8$export$7ccc53e8f1e7dfc5._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $c3f10480260b82e8$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $c3f10480260b82e8$var$TotpMultiFactorAssertionImpl extends $c3f10480260b82e8$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $c3f10480260b82e8$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $c3f10480260b82e8$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $c3f10480260b82e8$export$890c4ad488842ce7(typeof this.secret !== "undefined", auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c3f10480260b82e8$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $c3f10480260b82e8$export$890c4ad488842ce7(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $c3f10480260b82e8$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $c3f10480260b82e8$export$7ccc53e8f1e7dfc5 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $c3f10480260b82e8$export$7ccc53e8f1e7dfc5(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        var _a;
        let useDefaults = false;
        if ($c3f10480260b82e8$var$_isEmptyString(accountName) || $c3f10480260b82e8$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($c3f10480260b82e8$var$_isEmptyString(accountName)) accountName = ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.email) || "unknownuser";
            if ($c3f10480260b82e8$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $c3f10480260b82e8$var$_isEmptyString(input) {
    return typeof input === "undefined" || (input === null || input === void 0 ? void 0 : input.length) === 0;
}
var $c3f10480260b82e8$var$name = "@firebase/auth";
var $c3f10480260b82e8$var$version = "1.7.8";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c3f10480260b82e8$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        var _a;
        this.assertAuthConfigured();
        return ((_a = this.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener((user === null || user === void 0 ? void 0 : user.stsTokenManager.accessToken) || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $c3f10480260b82e8$export$890c4ad488842ce7(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c3f10480260b82e8$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return "node";
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return "rn";
        case "Worker" /* ClientPlatform.WORKER */ :
            return "webworker";
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return "cordova";
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return "web-extension";
        default:
            return undefined;
    }
}
/** @internal */ function $c3f10480260b82e8$var$registerAuth(clientPlatform) {
    (0, $ix4Jr._registerComponent)(new (0, $4a6xH.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider("app").getImmediate();
        const heartbeatServiceProvider = container.getProvider("heartbeat");
        const appCheckServiceProvider = container.getProvider("app-check-internal");
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $c3f10480260b82e8$export$890c4ad488842ce7(apiKey && !apiKey.includes(":"), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $c3f10480260b82e8$export$9f4f30ee63539e24(clientPlatform)
        };
        const authInstance = new $c3f10480260b82e8$export$91477dc880baac21(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $c3f10480260b82e8$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $ix4Jr._registerComponent)(new (0, $4a6xH.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $c3f10480260b82e8$export$a05254e7c3aeba6e(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $c3f10480260b82e8$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $ix4Jr.registerVersion)($c3f10480260b82e8$var$name, $c3f10480260b82e8$var$version, $c3f10480260b82e8$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $ix4Jr.registerVersion)($c3f10480260b82e8$var$name, $c3f10480260b82e8$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c3f10480260b82e8$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $c3f10480260b82e8$var$authIdTokenMaxAge = (0, $ffjl9.getExperimentalSetting)("authIdTokenMaxAge") || $c3f10480260b82e8$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $c3f10480260b82e8$var$lastPostedIdToken = null;
const $c3f10480260b82e8$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $c3f10480260b82e8$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult === null || idTokenResult === void 0 ? void 0 : idTokenResult.token;
        if ($c3f10480260b82e8$var$lastPostedIdToken === idToken) return;
        $c3f10480260b82e8$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? "POST" : "DELETE",
            headers: idToken ? {
                "Authorization": `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $c3f10480260b82e8$export$ae1af26003f05816(app = (0, $ix4Jr.getApp)()) {
    const provider = (0, $ix4Jr._getProvider)(app, "auth");
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $c3f10480260b82e8$export$b4171a6734a65d42(app, {
        popupRedirectResolver: $c3f10480260b82e8$export$342063e11d6c3cad,
        persistence: [
            $c3f10480260b82e8$export$23f2a1d2818174ef,
            $c3f10480260b82e8$export$8b22cf2602fb60ce,
            $c3f10480260b82e8$export$407448d2b89b1813
        ]
    });
    const authTokenSyncPath = (0, $ffjl9.getExperimentalSetting)("authTokenSyncURL");
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === "boolean" && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $c3f10480260b82e8$var$mintCookieFactory(authTokenSyncUrl.toString());
            $c3f10480260b82e8$export$d141bba7fdc215a3(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $c3f10480260b82e8$export$efccba1c4a2ef57b(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $ffjl9.getDefaultEmulatorHost)("auth");
    if (authEmulatorHost) $c3f10480260b82e8$export$3466f893ebf79586(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $c3f10480260b82e8$var$getScriptParentElement() {
    var _a, _b;
    return (_b = (_a = document.getElementsByTagName("head")) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : document;
}
$c3f10480260b82e8$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement("script");
            el.setAttribute("src", url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $c3f10480260b82e8$export$9d398bebfec1c039("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = "text/javascript";
            el.charset = "UTF-8";
            $c3f10480260b82e8$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: "https://apis.google.com/js/api.js",
    recaptchaV2Script: "https://www.google.com/recaptcha/api.js",
    recaptchaEnterpriseScript: "https://www.google.com/recaptcha/enterprise.js?render="
});
$c3f10480260b82e8$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );

});
parcelRegister("l73V3", function(module, exports) {

$parcel$export(module.exports, "__rest", function () { return $f5ed4ab2a4d1861b$export$3c9a16f847548506; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};

});




parcelRegister("hpy7I", function(module, exports) {

$parcel$export(module.exports, "firebaseAuthErrors", function () { return $f6f6903c4d4c6ea7$export$224e941aa7cf4287; });
const $f6f6903c4d4c6ea7$export$224e941aa7cf4287 = {
    "auth/admin-restricted-operation": "This operation is restricted to administrators only.",
    "auth/argument-error": "",
    "auth/app-not-authorized": "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
    "auth/app-not-installed": "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
    "auth/captcha-check-failed": "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
    "auth/code-expired": "The SMS code has expired. Please re-send the verification code to try again.",
    "auth/cordova-not-ready": "Cordova framework is not ready.",
    "auth/cors-unsupported": "This browser is not supported.",
    "auth/credential-already-in-use": "This credential is already associated with a different user account.",
    "auth/custom-token-mismatch": "The custom token corresponds to a different audience.",
    "auth/requires-recent-login": "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
    "auth/dynamic-link-not-activated": "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
    "auth/email-change-needs-verification": "Multi-factor users must always have a verified email.",
    "auth/email-already-in-use": "The email address is already in use by another account.",
    "auth/expired-action-code": "The action code has expired. ",
    "auth/cancelled-popup-request": "This operation has been cancelled due to another conflicting popup being opened.",
    "auth/internal-error": "An internal error has occurred.",
    "auth/invalid-app-credential": "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
    "auth/invalid-app-id": "The mobile app identifier is not registed for the current project.",
    "auth/invalid-user-token": "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
    "auth/invalid-auth-event": "An internal error has occurred.",
    "auth/invalid-verification-code": "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.",
    "auth/invalid-continue-uri": "The continue URL provided in the request is invalid.",
    "auth/invalid-cordova-configuration": "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
    "auth/invalid-custom-token": "The custom token format is incorrect. Please check the documentation.",
    "auth/invalid-dynamic-link-domain": "The provided dynamic link domain is not configured or authorized for the current project.",
    "auth/invalid-email": "The email address is badly formatted.",
    "auth/invalid-api-key": "Your API key is invalid, please check you have copied it correctly.",
    "auth/invalid-cert-hash": "The SHA-1 certificate hash provided is invalid.",
    "auth/invalid-credential": "The supplied auth credential is malformed or has expired.",
    "auth/invalid-message-payload": "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
    "auth/invalid-multi-factor-session": "The request does not contain a valid proof of first factor successful sign-in.",
    "auth/invalid-oauth-provider": "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
    "auth/invalid-oauth-client-id": "The OAuth client ID provided is either invalid or does not match the specified API key.",
    "auth/unauthorized-domain": "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
    "auth/invalid-action-code": "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
    "auth/wrong-password": "The password is invalid or the user does not have a password.",
    "auth/invalid-persistence-type": "The specified persistence type is invalid. It can only be local, session or none.",
    "auth/invalid-phone-number": "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
    "auth/invalid-provider-id": "The specified provider ID is invalid.",
    "auth/invalid-recipient-email": "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
    "auth/invalid-sender": "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
    "auth/invalid-verification-id": "The verification ID used to create the phone auth credential is invalid.",
    "auth/invalid-tenant-id": "The Auth instance's tenant ID is invalid.",
    "auth/multi-factor-info-not-found": "The user does not have a second factor matching the identifier provided.",
    "auth/multi-factor-auth-required": "Proof of ownership of a second factor is required to complete sign-in.",
    "auth/missing-android-pkg-name": "An Android Package Name must be provided if the Android App is required to be installed.",
    "auth/auth-domain-config-required": "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
    "auth/missing-app-credential": "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
    "auth/missing-verification-code": "The phone auth credential was created with an empty SMS verification code.",
    "auth/missing-continue-uri": "A continue URL must be provided in the request.",
    "auth/missing-iframe-start": "An internal error has occurred.",
    "auth/missing-ios-bundle-id": "An iOS Bundle ID must be provided if an App Store ID is provided.",
    "auth/missing-multi-factor-info": "No second factor identifier is provided.",
    "auth/missing-multi-factor-session": "The request is missing proof of first factor successful sign-in.",
    "auth/missing-or-invalid-nonce": "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
    "auth/missing-phone-number": "To send verification codes, provide a phone number for the recipient.",
    "auth/missing-verification-id": "The phone auth credential was created with an empty verification ID.",
    "auth/app-deleted": "This instance of FirebaseApp has been deleted.",
    "auth/account-exists-with-different-credential": "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
    "auth/network-request-failed": "A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
    "auth/no-auth-event": "An internal error has occurred.",
    "auth/no-such-provider": "User was not linked to an account with the given provider.",
    "auth/null-user": "A null user object was provided as the argument for an operation which requires a non-null user object.",
    "auth/operation-not-allowed": "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
    "auth/operation-not-supported-in-this-environment": 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
    "auth/popup-blocked": "Unable to establish a connection with the popup. It may have been blocked by the browser.",
    "auth/popup-closed-by-user": "The popup has been closed by the user before finalizing the operation.",
    "auth/provider-already-linked": "User can only be linked to one identity for the given provider.",
    "auth/quota-exceeded": "The project's quota for this operation has been exceeded.",
    "auth/redirect-cancelled-by-user": "The redirect operation has been cancelled by the user before finalizing.",
    "auth/redirect-operation-pending": "A redirect sign-in operation is already pending.",
    "auth/rejected-credential": "The request contains malformed or mismatching credentials.",
    "auth/second-factor-already-in-use": "The second factor is already enrolled on this account.",
    "auth/maximum-second-factor-count-exceeded": "The maximum allowed number of second factors on a user has been exceeded.",
    "auth/tenant-id-mismatch": "The provided tenant ID does not match the Auth instance's tenant ID",
    "auth/timeout": "The operation has timed out.",
    "auth/user-token-expired": "The user's credential is no longer valid. The user must sign in again.",
    "auth/too-many-requests": "We have blocked all requests from this device due to unusual activity. Try again later.",
    "auth/unauthorized-continue-uri": "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
    "auth/unsupported-first-factor": "Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.",
    "auth/unsupported-persistence-type": "The current environment does not support the specified persistence type.",
    "auth/unsupported-tenant-operation": "This operation is not supported in a multi-tenant context.",
    "auth/unverified-email": "The operation requires a verified email.",
    "auth/user-cancelled": "The user did not grant your application the permissions it requested.",
    "auth/user-not-found": "There is no user record corresponding to this identifier. The user may have been deleted.",
    "auth/user-disabled": "The user account has been disabled by an administrator.",
    "auth/user-mismatch": "The supplied credentials do not correspond to the previously signed in user.",
    "auth/user-signed-out": "The user is signed out.",
    "auth/weak-password": "The password must be 6 characters long or more.",
    "auth/web-storage-unsupported": "This browser is not supported or 3rd party cookies and data may be disabled."
};

});


parcelRegister("1zjiQ", function(module, exports) {

$parcel$export(module.exports, "jwtGetExpiresInDays", function () { return $6501a0dfc3540eba$export$1d2314b1895438e2; });
$parcel$export(module.exports, "jwtDecode", function () { return $6501a0dfc3540eba$export$fa1e2fb699b7861e; });
/**
 * Represents decoded API authentication token.
 * @type {JWT}
 */ const $6501a0dfc3540eba$export$1d2314b1895438e2 = (token)=>{
    const day = 86400;
    const currentDate = Math.floor(Date.now() / 1000);
    const expiredInDays = Math.floor((token.exp - currentDate) / day);
    return expiredInDays;
};
const $6501a0dfc3540eba$export$fa1e2fb699b7861e = (token)=>{
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(window.atob(base64).split("").map((c)=>`%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
    return JSON.parse(jsonPayload);
};

});

parcelRegister("29At8", function(module, exports) {

$parcel$export(module.exports, "storageGetAuthToken", function () { return $5df50486665b02df$export$7ad25702bbbc2644; });
$parcel$export(module.exports, "storageSetAuthToken", function () { return $5df50486665b02df$export$1c68b820a330d0f9; });
$parcel$export(module.exports, "storageGetSentPasswordResetEmailDate", function () { return $5df50486665b02df$export$78e40faf782fa2d3; });
$parcel$export(module.exports, "storageSetSentPasswordResetEmailDate", function () { return $5df50486665b02df$export$95eca3f72d73e283; });
$parcel$export(module.exports, "storageGetSentVerificationEmailDate", function () { return $5df50486665b02df$export$114974c8222fd3b8; });
$parcel$export(module.exports, "storageSetSentVerificationEmailDate", function () { return $5df50486665b02df$export$4246dbd4eb03f04e; });
// config
parcelRequire("krTeD");
var $y15Yn = parcelRequire("y15Yn");
const $5df50486665b02df$export$7ad25702bbbc2644 = ()=>localStorage.getItem((0, $y15Yn.StorageKeys).AuthToken) || "";
const $5df50486665b02df$export$1c68b820a330d0f9 = (authToken)=>localStorage.setItem((0, $y15Yn.StorageKeys).AuthToken, authToken);
const $5df50486665b02df$export$78e40faf782fa2d3 = ()=>localStorage.getItem((0, $y15Yn.StorageKeys).SentPasswordResetEmailDate) || "";
const $5df50486665b02df$export$95eca3f72d73e283 = (date)=>localStorage.setItem((0, $y15Yn.StorageKeys).SentPasswordResetEmailDate, date);
const $5df50486665b02df$export$114974c8222fd3b8 = ()=>localStorage.getItem((0, $y15Yn.StorageKeys).SentVerificationEmailDate) || "";
const $5df50486665b02df$export$4246dbd4eb03f04e = (date)=>localStorage.setItem((0, $y15Yn.StorageKeys).SentVerificationEmailDate, date);

});



parcelRegister("7J4Vi", function(module, exports) {

$parcel$export(module.exports, "useInterval", function () { return $e0db6c9bbe4fa885$export$f4b266cd2aae9cb1; });

var $bh6RR = parcelRequire("bh6RR");
const $e0db6c9bbe4fa885$export$f4b266cd2aae9cb1 = (callback, delay)=>{
    const savedCallback = (0, $bh6RR.useRef)();
    // remember the latest callback
    (0, $bh6RR.useEffect)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // set up the interval
    (0, $bh6RR.useEffect)(()=>{
        const intervalId = setInterval(()=>{
            savedCallback.current?.();
        }, delay);
        return ()=>clearInterval(intervalId);
    }, [
        delay
    ]);
};

});

parcelRegister("9rd5i", function(module, exports) {

var $bh6RR = parcelRequire("bh6RR");
const $b1cf2ed8f34ad818$export$e8b771555dc4a003 = (ref)=>{
    const [width, setWidth] = (0, $bh6RR.useState)(0);
    const [height, setHeight] = (0, $bh6RR.useState)(0);
    const handleResize = (0, $bh6RR.useCallback)(()=>{
        if (ref) {
            setWidth(ref.current?.offsetWidth || 0);
            setHeight(ref.current?.offsetHeight || 0);
        }
    }, [
        ref
    ]);
    (0, $bh6RR.useEffect)(()=>{
        window.addEventListener("load", handleResize);
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("load", handleResize);
            window.removeEventListener("resize", handleResize);
        };
    }, [
        ref,
        handleResize
    ]);
    return {
        width: width,
        height: height
    };
};

});

parcelRegister("1sxw1", function(module, exports) {

$parcel$export(module.exports, "useComment", function () { return (parcelRequire("K9dw6")).useComment; });
$parcel$export(module.exports, "useConnectPayout", function () { return (parcelRequire("1MzSD")).useConnectPayout; });
$parcel$export(module.exports, "useConnectReady", function () { return (parcelRequire("iLKNg")).useConnectReady; });
$parcel$export(module.exports, "usePost", function () { return (parcelRequire("jMNnt")).usePost; });
$parcel$export(module.exports, "useSubscription", function () { return (parcelRequire("lbAL5")).useSubscription; });
$parcel$export(module.exports, "useSubscriptionPrice", function () { return (parcelRequire("lqGW0")).useSubscriptionPrice; });
$parcel$export(module.exports, "useTip", function () { return (parcelRequire("bRg8c")).useTip; });
$parcel$export(module.exports, "useTrack", function () { return (parcelRequire("i9vCv")).useTrack; });
$parcel$export(module.exports, "useTracks", function () { return (parcelRequire("6uGoQ")).useTracks; });
$parcel$export(module.exports, "useTracksPublic", function () { return (parcelRequire("ceCYx")).useTracksPublic; });
$parcel$export(module.exports, "useUnlock", function () { return (parcelRequire("5LPLy")).useUnlock; });
$parcel$export(module.exports, "useUser", function () { return (parcelRequire("gLN5L")).useUser; });
$parcel$export(module.exports, "useUserPublic", function () { return (parcelRequire("aCYwi")).useUserPublic; });
$parcel$export(module.exports, "useUsers", function () { return (parcelRequire("gBCSe")).useUsers; });
$parcel$export(module.exports, "useUserStats", function () { return (parcelRequire("lXxtV")).useUserStats; });

var $K9dw6 = parcelRequire("K9dw6");

var $1MzSD = parcelRequire("1MzSD");

var $iLKNg = parcelRequire("iLKNg");

var $jMNnt = parcelRequire("jMNnt");

var $lbAL5 = parcelRequire("lbAL5");

var $lqGW0 = parcelRequire("lqGW0");

var $bRg8c = parcelRequire("bRg8c");

var $i9vCv = parcelRequire("i9vCv");

var $6uGoQ = parcelRequire("6uGoQ");

var $ceCYx = parcelRequire("ceCYx");

var $5LPLy = parcelRequire("5LPLy");

var $gLN5L = parcelRequire("gLN5L");

var $aCYwi = parcelRequire("aCYwi");

var $gBCSe = parcelRequire("gBCSe");

var $lXxtV = parcelRequire("lXxtV");

});
parcelRegister("K9dw6", function(module, exports) {

$parcel$export(module.exports, "useComment", function () { return $6a7e8fc17fb58b03$export$4c1f83d02cdf94f9; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $6a7e8fc17fb58b03$var$getComment = async ({ data: { commentId: commentId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve comment
        const { comment: comment } = await api.commentApi.getComment(commentId);
        // return payload
        return {
            comment: comment,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            comment: undefined,
            error: message
        };
    }
};
const $6a7e8fc17fb58b03$var$fetcher = (args)=>$6a7e8fc17fb58b03$var$getComment(args);
const $6a7e8fc17fb58b03$export$4c1f83d02cdf94f9 = (commentId)=>{
    const shouldFetch = !!commentId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseComment,
        data: {
            commentId: commentId
        }
    } : null, $6a7e8fc17fb58b03$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        comment: data?.comment,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});
parcelRegister("fTjtL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b91b1a392eefbbec$export$2e2bcd8739ae039; });
parcelRequire("cenzc");

var $bh6RR = parcelRequire("bh6RR");

var $hVYK3 = parcelRequire("hVYK3");

var $9kc2k = parcelRequire("9kc2k");
const $b91b1a392eefbbec$export$dbab534a48e651ef = (key)=>(0, $9kc2k.serialize)(key)[0];
/// <reference types="react/experimental" />
const $b91b1a392eefbbec$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $b91b1a392eefbbec$var$WITH_DEDUPE = {
    dedupe: true
};
const $b91b1a392eefbbec$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $9kc2k.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $9kc2k.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $bh6RR.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $bh6RR.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $bh6RR.useRef)(key);
    const fetcherRef = (0, $bh6RR.useRef)(fetcher);
    const configRef = (0, $bh6RR.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $9kc2k.createCacheHelper)(cache, key);
    const stateDependencies = (0, $bh6RR.useRef)({}).current;
    const fallback = (0, $9kc2k.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $9kc2k.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $bh6RR.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $9kc2k.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $9kc2k.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $9kc2k.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $hVYK3.useSyncExternalStore)((0, $bh6RR.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $9kc2k.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $bh6RR.useRef)(data);
    const returnedData = keepPreviousData ? (0, $9kc2k.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $9kc2k.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $9kc2k.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $9kc2k.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $9kc2k.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $9kc2k.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $9kc2k.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $bh6RR.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $9kc2k.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $9kc2k.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $9kc2k.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $9kc2k.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $9kc2k.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $9kc2k.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $9kc2k.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $9kc2k.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $bh6RR.useCallback)((...args)=>{
        return (0, $9kc2k.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $9kc2k.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $9kc2k.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $9kc2k.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $9kc2k.UNDEFINED), $b91b1a392eefbbec$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $9kc2k.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $9kc2k.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $9kc2k.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $9kc2k.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $9kc2k.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $9kc2k.isUndefined)(data) || (0, $9kc2k.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $9kc2k.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $9kc2k.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $9kc2k.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($b91b1a392eefbbec$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $bh6RR.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $9kc2k.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $9kc2k.IS_REACT_LEGACY) && (0, $9kc2k.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $9kc2k.isUndefined)(req)) {
            const promise = boundMutate(req);
            $b91b1a392eefbbec$var$use(promise);
        }
        if ((0, $9kc2k.isUndefined)(error)) {
            const promise = revalidate($b91b1a392eefbbec$var$WITH_DEDUPE);
            if (!(0, $9kc2k.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $b91b1a392eefbbec$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $b91b1a392eefbbec$export$4c7bbecdacc3ca2c = (0, $9kc2k.OBJECT).defineProperty((0, $9kc2k.SWRConfig), "defaultValue", {
    value: (0, $9kc2k.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $b91b1a392eefbbec$export$2e2bcd8739ae039 = (0, $9kc2k.withArgs)($b91b1a392eefbbec$var$useSWRHandler);

});
parcelRegister("cenzc", function(module, exports) {

});

parcelRegister("hVYK3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gdZJN"));

});
parcelRegister("gdZJN", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $bcfdc00ed56980e9$export$306c0aa65ff9ec16; }, function (v) { return $bcfdc00ed56980e9$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcfdc00ed56980e9$export$306c0aa65ff9ec16;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $bcfdc00ed56980e9$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $bcfdc00ed56980e9$var$k = "function" === typeof Object.is ? Object.is : $bcfdc00ed56980e9$var$h, $bcfdc00ed56980e9$var$l = $bh6RR.useState, $bcfdc00ed56980e9$var$m = $bh6RR.useEffect, $bcfdc00ed56980e9$var$n = $bh6RR.useLayoutEffect, $bcfdc00ed56980e9$var$p = $bh6RR.useDebugValue;
function $bcfdc00ed56980e9$var$q(a, b) {
    var d = b(), f = $bcfdc00ed56980e9$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $bcfdc00ed56980e9$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $bcfdc00ed56980e9$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $bcfdc00ed56980e9$var$m(function() {
        $bcfdc00ed56980e9$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $bcfdc00ed56980e9$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $bcfdc00ed56980e9$var$p(d);
    return d;
}
function $bcfdc00ed56980e9$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$bcfdc00ed56980e9$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $bcfdc00ed56980e9$var$t(a, b) {
    return b();
}
var $bcfdc00ed56980e9$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $bcfdc00ed56980e9$var$t : $bcfdc00ed56980e9$var$q;
$bcfdc00ed56980e9$export$306c0aa65ff9ec16 = void 0 !== $bh6RR.useSyncExternalStore ? $bh6RR.useSyncExternalStore : $bcfdc00ed56980e9$var$u;

});


parcelRegister("9kc2k", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", function () { return $6c9f5184448c0c82$export$6db089fe7b26f5b6; });
$parcel$export(module.exports, "OBJECT", function () { return $6c9f5184448c0c82$export$8b8a958a7f6f130c; });
$parcel$export(module.exports, "isUndefined", function () { return $6c9f5184448c0c82$export$fce6876652108ab; });
$parcel$export(module.exports, "isFunction", function () { return $6c9f5184448c0c82$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "mergeObjects", function () { return $6c9f5184448c0c82$export$2321aea138b44780; });
$parcel$export(module.exports, "SWRGlobalState", function () { return $6c9f5184448c0c82$export$b94ca9901c60634; });
$parcel$export(module.exports, "createCacheHelper", function () { return $6c9f5184448c0c82$export$1251d51d9c571b45; });
$parcel$export(module.exports, "IS_REACT_LEGACY", function () { return $6c9f5184448c0c82$export$ddb64fe6466374f7; });
$parcel$export(module.exports, "IS_SERVER", function () { return $6c9f5184448c0c82$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "rAF", function () { return $6c9f5184448c0c82$export$eba6076d3d7d0c06; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $6c9f5184448c0c82$export$700979bc83e7db82; });
$parcel$export(module.exports, "serialize", function () { return $6c9f5184448c0c82$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "getTimestamp", function () { return $6c9f5184448c0c82$export$3c95c4c8b671ef0; });
$parcel$export(module.exports, "revalidateEvents", function () { return $6c9f5184448c0c82$export$10213d6aa5ce32e6; });
$parcel$export(module.exports, "internalMutate", function () { return $6c9f5184448c0c82$export$c9d44e5bea4509be; });
$parcel$export(module.exports, "defaultConfig", function () { return $6c9f5184448c0c82$export$f84bd70098573c5c; });
$parcel$export(module.exports, "SWRConfig", function () { return $6c9f5184448c0c82$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "withArgs", function () { return $6c9f5184448c0c82$export$84d44e54e14b0133; });
$parcel$export(module.exports, "subscribeCallback", function () { return $6c9f5184448c0c82$export$e005210ed621746; });

var $bh6RR = parcelRequire("bh6RR");
// Shared state between server components and client components
const $6c9f5184448c0c82$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $6c9f5184448c0c82$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $6c9f5184448c0c82$export$8793edee2d425525();
const $6c9f5184448c0c82$export$8b8a958a7f6f130c = Object;
const $6c9f5184448c0c82$export$fce6876652108ab = (v)=>v === $6c9f5184448c0c82$export$6db089fe7b26f5b6;
const $6c9f5184448c0c82$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $6c9f5184448c0c82$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $6c9f5184448c0c82$export$ae936b9d47e5870e = (x)=>$6c9f5184448c0c82$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $6c9f5184448c0c82$var$table = new WeakMap();
// counter of the key
let $6c9f5184448c0c82$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $6c9f5184448c0c82$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($6c9f5184448c0c82$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $6c9f5184448c0c82$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$6c9f5184448c0c82$var$counter + "~";
        $6c9f5184448c0c82$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $6c9f5184448c0c82$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $6c9f5184448c0c82$var$table.set(arg, result);
        }
        if (constructor == $6c9f5184448c0c82$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $6c9f5184448c0c82$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$6c9f5184448c0c82$export$fce6876652108ab(index = keys.pop()))if (!$6c9f5184448c0c82$export$fce6876652108ab(arg[index])) result += index + ":" + $6c9f5184448c0c82$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $6c9f5184448c0c82$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $6c9f5184448c0c82$export$b94ca9901c60634 = new WeakMap();
const $6c9f5184448c0c82$var$EMPTY_CACHE = {};
const $6c9f5184448c0c82$var$INITIAL_CACHE = {};
const $6c9f5184448c0c82$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $6c9f5184448c0c82$export$6e85fd745dc51282 = typeof window != $6c9f5184448c0c82$var$STR_UNDEFINED;
const $6c9f5184448c0c82$export$842dfe7a9f24298 = typeof document != $6c9f5184448c0c82$var$STR_UNDEFINED;
const $6c9f5184448c0c82$export$a9116928c9d15917 = ()=>$6c9f5184448c0c82$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $6c9f5184448c0c82$var$STR_UNDEFINED;
const $6c9f5184448c0c82$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $6c9f5184448c0c82$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$6c9f5184448c0c82$export$fce6876652108ab(key) && cache.get(key) || $6c9f5184448c0c82$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$6c9f5184448c0c82$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $6c9f5184448c0c82$var$INITIAL_CACHE)) $6c9f5184448c0c82$var$INITIAL_CACHE[key] = prev;
                state[5](key, $6c9f5184448c0c82$export$2321aea138b44780(prev, info), prev || $6c9f5184448c0c82$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$6c9f5184448c0c82$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $6c9f5184448c0c82$var$INITIAL_CACHE) return $6c9f5184448c0c82$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$6c9f5184448c0c82$export$fce6876652108ab(key) && cache.get(key) || $6c9f5184448c0c82$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $6c9f5184448c0c82$var$online = true;
const $6c9f5184448c0c82$var$isOnline = ()=>$6c9f5184448c0c82$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$6c9f5184448c0c82$var$onWindowEvent, $6c9f5184448c0c82$var$offWindowEvent] = $6c9f5184448c0c82$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $6c9f5184448c0c82$export$8793edee2d425525,
    $6c9f5184448c0c82$export$8793edee2d425525
];
const $6c9f5184448c0c82$var$isVisible = ()=>{
    const visibilityState = $6c9f5184448c0c82$export$842dfe7a9f24298 && document.visibilityState;
    return $6c9f5184448c0c82$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $6c9f5184448c0c82$var$initFocus = (callback)=>{
    // focus revalidate
    if ($6c9f5184448c0c82$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $6c9f5184448c0c82$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($6c9f5184448c0c82$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $6c9f5184448c0c82$var$offWindowEvent("focus", callback);
    };
};
const $6c9f5184448c0c82$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $6c9f5184448c0c82$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $6c9f5184448c0c82$var$online = false;
    };
    $6c9f5184448c0c82$var$onWindowEvent("online", onOnline);
    $6c9f5184448c0c82$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $6c9f5184448c0c82$var$offWindowEvent("online", onOnline);
        $6c9f5184448c0c82$var$offWindowEvent("offline", onOffline);
    };
};
const $6c9f5184448c0c82$export$f5ab8217e0edff04 = {
    isOnline: $6c9f5184448c0c82$var$isOnline,
    isVisible: $6c9f5184448c0c82$var$isVisible
};
const $6c9f5184448c0c82$export$b1857f3440a65373 = {
    initFocus: $6c9f5184448c0c82$var$initFocus,
    initReconnect: $6c9f5184448c0c82$var$initReconnect
};
const $6c9f5184448c0c82$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useId;
const $6c9f5184448c0c82$export$d2f4d8e74279c212 = !$6c9f5184448c0c82$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $6c9f5184448c0c82$export$eba6076d3d7d0c06 = (f)=>$6c9f5184448c0c82$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $6c9f5184448c0c82$export$700979bc83e7db82 = $6c9f5184448c0c82$export$d2f4d8e74279c212 ? (0, $bh6RR.useEffect) : (0, $bh6RR.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $6c9f5184448c0c82$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $6c9f5184448c0c82$export$3723beb60427dc52 = !$6c9f5184448c0c82$export$d2f4d8e74279c212 && $6c9f5184448c0c82$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($6c9f5184448c0c82$var$navigatorConnection.effectiveType) || $6c9f5184448c0c82$var$navigatorConnection.saveData);
const $6c9f5184448c0c82$export$dfdc1655ccc5b9cb = (key)=>{
    if ($6c9f5184448c0c82$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $6c9f5184448c0c82$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $6c9f5184448c0c82$var$__timestamp = 0;
const $6c9f5184448c0c82$export$3c95c4c8b671ef0 = ()=>++$6c9f5184448c0c82$var$__timestamp;
const $6c9f5184448c0c82$var$FOCUS_EVENT = 0;
const $6c9f5184448c0c82$var$RECONNECT_EVENT = 1;
const $6c9f5184448c0c82$var$MUTATE_EVENT = 2;
const $6c9f5184448c0c82$var$ERROR_REVALIDATE_EVENT = 3;
var $6c9f5184448c0c82$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $6c9f5184448c0c82$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $6c9f5184448c0c82$var$FOCUS_EVENT,
    MUTATE_EVENT: $6c9f5184448c0c82$var$MUTATE_EVENT,
    RECONNECT_EVENT: $6c9f5184448c0c82$var$RECONNECT_EVENT
};
async function $6c9f5184448c0c82$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $6c9f5184448c0c82$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($6c9f5184448c0c82$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $6c9f5184448c0c82$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $6c9f5184448c0c82$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $6c9f5184448c0c82$export$b94ca9901c60634.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $6c9f5184448c0c82$export$f6e2535fb5126e54(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($6c9f5184448c0c82$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $6c9f5184448c0c82$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$6c9f5184448c0c82$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $6c9f5184448c0c82$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $6c9f5184448c0c82$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($6c9f5184448c0c82$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $6c9f5184448c0c82$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $6c9f5184448c0c82$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($6c9f5184448c0c82$export$f6e2535fb5126e54(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $6c9f5184448c0c82$export$6db089fe7b26f5b6,
                        _c: $6c9f5184448c0c82$export$6db089fe7b26f5b6
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $6c9f5184448c0c82$export$6db089fe7b26f5b6,
                    _c: $6c9f5184448c0c82$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $6c9f5184448c0c82$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $6c9f5184448c0c82$export$6db089fe7b26f5b6
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $6c9f5184448c0c82$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $6c9f5184448c0c82$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$6c9f5184448c0c82$export$b94ca9901c60634.has(provider)) {
        const opts = $6c9f5184448c0c82$export$2321aea138b44780($6c9f5184448c0c82$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $6c9f5184448c0c82$export$c9d44e5bea4509be.bind($6c9f5184448c0c82$export$6db089fe7b26f5b6, provider);
        let unmount = $6c9f5184448c0c82$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$6c9f5184448c0c82$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $6c9f5184448c0c82$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$6c9f5184448c0c82$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($6c9f5184448c0c82$export$6db089fe7b26f5b6, $6c9f5184448c0c82$var$revalidateAllKeys.bind($6c9f5184448c0c82$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $6c9f5184448c0c82$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($6c9f5184448c0c82$export$6db089fe7b26f5b6, $6c9f5184448c0c82$var$revalidateAllKeys.bind($6c9f5184448c0c82$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $6c9f5184448c0c82$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $6c9f5184448c0c82$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $6c9f5184448c0c82$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $6c9f5184448c0c82$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$6c9f5184448c0c82$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $6c9f5184448c0c82$export$398604a469f7de9a = (currentData, newData)=>$6c9f5184448c0c82$export$e9a4e06c7dfb0bd4(currentData) == $6c9f5184448c0c82$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$6c9f5184448c0c82$export$69a3209f1a06c04d, $6c9f5184448c0c82$export$57e795267c26e600] = $6c9f5184448c0c82$export$4008f5b66f9e0b3c(new Map());
// Default config
const $6c9f5184448c0c82$export$f84bd70098573c5c = $6c9f5184448c0c82$export$2321aea138b44780({
    // events
    onLoadingSlow: $6c9f5184448c0c82$export$8793edee2d425525,
    onSuccess: $6c9f5184448c0c82$export$8793edee2d425525,
    onError: $6c9f5184448c0c82$export$8793edee2d425525,
    onErrorRetry: $6c9f5184448c0c82$var$onErrorRetry,
    onDiscarded: $6c9f5184448c0c82$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $6c9f5184448c0c82$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $6c9f5184448c0c82$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $6c9f5184448c0c82$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $6c9f5184448c0c82$export$69a3209f1a06c04d,
    mutate: $6c9f5184448c0c82$export$57e795267c26e600,
    fallback: {}
}, $6c9f5184448c0c82$export$f5ab8217e0edff04);
const $6c9f5184448c0c82$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $6c9f5184448c0c82$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $6c9f5184448c0c82$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $6c9f5184448c0c82$var$SWRConfigContext = (0, $bh6RR.createContext)({});
const $6c9f5184448c0c82$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $bh6RR.useContext)($6c9f5184448c0c82$var$SWRConfigContext);
    const isFunctionalConfig = $6c9f5184448c0c82$export$f6e2535fb5126e54(value);
    const config = (0, $bh6RR.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $bh6RR.useMemo)(()=>isFunctionalConfig ? config : $6c9f5184448c0c82$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $bh6RR.useRef)($6c9f5184448c0c82$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $6c9f5184448c0c82$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $6c9f5184448c0c82$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $6c9f5184448c0c82$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $bh6RR.createElement)($6c9f5184448c0c82$var$SWRConfigContext.Provider, $6c9f5184448c0c82$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
const $6c9f5184448c0c82$export$8667f065faedc62c = "$inf$";
// @ts-expect-error
const $6c9f5184448c0c82$var$enableDevtools = $6c9f5184448c0c82$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $6c9f5184448c0c82$var$use = $6c9f5184448c0c82$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $6c9f5184448c0c82$var$setupDevTools = ()=>{
    if ($6c9f5184448c0c82$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR)));
};
const $6c9f5184448c0c82$export$a3295358bff77e = (args)=>{
    return $6c9f5184448c0c82$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $6c9f5184448c0c82$export$f1dc0e282d4c1c0 = ()=>{
    return $6c9f5184448c0c82$export$2321aea138b44780($6c9f5184448c0c82$export$f84bd70098573c5c, (0, $bh6RR.useContext)($6c9f5184448c0c82$var$SWRConfigContext));
};
const $6c9f5184448c0c82$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $6c9f5184448c0c82$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $6c9f5184448c0c82$export$b94ca9901c60634.get($6c9f5184448c0c82$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $6c9f5184448c0c82$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $6c9f5184448c0c82$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $6c9f5184448c0c82$export$b94ca9901c60634.get($6c9f5184448c0c82$export$69a3209f1a06c04d);
            if (key.startsWith($6c9f5184448c0c82$export$8667f065faedc62c)) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ($6c9f5184448c0c82$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $6c9f5184448c0c82$var$BUILT_IN_MIDDLEWARE = $6c9f5184448c0c82$var$use.concat($6c9f5184448c0c82$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $6c9f5184448c0c82$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $6c9f5184448c0c82$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $6c9f5184448c0c82$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $6c9f5184448c0c82$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($6c9f5184448c0c82$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $6c9f5184448c0c82$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $6c9f5184448c0c82$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $6c9f5184448c0c82$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$6c9f5184448c0c82$var$setupDevTools();

});


parcelRegister("f2lkA", function(module, exports) {

$parcel$export(module.exports, "SWRKeys", function () { return $e4a235670aad577c$export$7360c809f66e820e; });
// SWRKeys - represents unique keys for swr hooks.
var $e4a235670aad577c$export$7360c809f66e820e;
(function(SWRKeys) {
    SWRKeys["UseComment"] = "USE_COMMENT";
    SWRKeys["UseConnectPayout"] = "USE_CONNECT_PAYOUT";
    SWRKeys["UseConnectReady"] = "USE_CONNECT_READY";
    SWRKeys["UsePost"] = "USE_POST";
    SWRKeys["UseSubscription"] = "USE_SUBSCRIPTION";
    SWRKeys["UseSubscriptionPrice"] = "USE_SUBSCRIPTION_PRICE";
    SWRKeys["UseTip"] = "USE_TIP";
    SWRKeys["UseTrack"] = "USE_TRACK";
    SWRKeys["UseTracks"] = "USE_TRACKS";
    SWRKeys["UseTracksPublic"] = "USE_TRACKS_PUBLIC";
    SWRKeys["UseUnlock"] = "USE_UNLOCK";
    SWRKeys["UseUser"] = "USE_USER";
    SWRKeys["UseUsers"] = "USE_USERS";
    SWRKeys["UseUserPublic"] = "USE_USER_PUBLIC";
    SWRKeys["UseUserStats"] = "USE_USER_STATS";
})($e4a235670aad577c$export$7360c809f66e820e || ($e4a235670aad577c$export$7360c809f66e820e = {}));

});


parcelRegister("1MzSD", function(module, exports) {

$parcel$export(module.exports, "useConnectPayout", function () { return $fb230b6d00610490$export$c427682aaf595823; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $fb230b6d00610490$var$getConnectPayout = async ({ data: { connectPayoutId: connectPayoutId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve connect payout
        const { connectPayout: connectPayout } = await api.connectApi.getConnectPayout(connectPayoutId);
        // return payload
        return {
            connectPayout: connectPayout,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            connectPayout: undefined,
            error: message
        };
    }
};
const $fb230b6d00610490$var$fetcher = (args)=>$fb230b6d00610490$var$getConnectPayout(args);
const $fb230b6d00610490$export$c427682aaf595823 = (connectPayoutId)=>{
    const shouldFetch = !!connectPayoutId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseConnectPayout,
        data: {
            connectPayoutId: connectPayoutId
        }
    } : null, $fb230b6d00610490$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        connectPayout: data?.connectPayout,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("iLKNg", function(module, exports) {

$parcel$export(module.exports, "useConnectReady", function () { return $2541c8daa75bd705$export$d925aee74f737a7c; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $2541c8daa75bd705$var$getConnectReadiness = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get connect readiness
        const { ready: ready } = await api.connectApi.getConnectReadiness(userId);
        // return payload
        return {
            ready: ready,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            ready: false,
            error: message
        };
    }
};
const $2541c8daa75bd705$var$fetcher = (args)=>$2541c8daa75bd705$var$getConnectReadiness(args);
const $2541c8daa75bd705$export$d925aee74f737a7c = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseConnectReady,
        data: {
            userId: userId
        }
    } : null, $2541c8daa75bd705$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        ready: data?.ready,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("jMNnt", function(module, exports) {

$parcel$export(module.exports, "usePost", function () { return $d3401ba308907146$export$9158e33c8d0ca687; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $d3401ba308907146$var$getPost = async ({ data: { postId: postId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve post
        const { post: post } = await api.postApi.getPost(postId);
        // return payload
        return {
            post: post,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            post: undefined,
            error: message
        };
    }
};
const $d3401ba308907146$var$fetcher = (args)=>$d3401ba308907146$var$getPost(args);
const $d3401ba308907146$export$9158e33c8d0ca687 = (postId)=>{
    const shouldFetch = !!postId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UsePost,
        data: {
            postId: postId
        }
    } : null, $d3401ba308907146$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        post: data?.post,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("lbAL5", function(module, exports) {

$parcel$export(module.exports, "useSubscription", function () { return $ba955862f900ad4a$export$368b4214baeb914c; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $ba955862f900ad4a$var$getSubscription = async ({ data: { subscriptionId: subscriptionId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve subscription
        const { subscription: subscription } = await api.subscriptionApi.getSubscription(subscriptionId);
        // return payload
        return {
            subscription: subscription,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            subscription: undefined,
            error: message
        };
    }
};
const $ba955862f900ad4a$var$fetcher = (args)=>$ba955862f900ad4a$var$getSubscription(args);
const $ba955862f900ad4a$export$368b4214baeb914c = (subscriptionId)=>{
    const shouldFetch = !!subscriptionId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseSubscription,
        data: {
            subscriptionId: subscriptionId
        }
    } : null, $ba955862f900ad4a$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        subscription: data?.subscription,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("lqGW0", function(module, exports) {

$parcel$export(module.exports, "useSubscriptionPrice", function () { return $6bd64ac8ecc2db3f$export$833b744e66986faf; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $6bd64ac8ecc2db3f$var$getSubscriptionPrice = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve subscription price
        const { subscriptionPrice: subscriptionPrice } = await api.subscriptionApi.getUserSubscriptionPrice(userId);
        // return payload
        return {
            subscriptionPrice: subscriptionPrice,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            subscriptionPrice: undefined,
            error: message
        };
    }
};
const $6bd64ac8ecc2db3f$var$fetcher = (args)=>$6bd64ac8ecc2db3f$var$getSubscriptionPrice(args);
const $6bd64ac8ecc2db3f$export$833b744e66986faf = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseSubscriptionPrice,
        data: {
            userId: userId
        }
    } : null, $6bd64ac8ecc2db3f$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        subscriptionPrice: data?.subscriptionPrice,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("bRg8c", function(module, exports) {

$parcel$export(module.exports, "useTip", function () { return $9a8b2f067ab5dd6a$export$3e8bc5425d7d6093; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $9a8b2f067ab5dd6a$var$getTip = async ({ data: { tipId: tipId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tip
        const { tip: tip } = await api.tipApi.getTip(tipId);
        // return payload
        return {
            tip: tip,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            tip: undefined,
            error: message
        };
    }
};
const $9a8b2f067ab5dd6a$var$fetcher = (args)=>$9a8b2f067ab5dd6a$var$getTip(args);
const $9a8b2f067ab5dd6a$export$3e8bc5425d7d6093 = (tipId)=>{
    const shouldFetch = !!tipId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseTip,
        data: {
            tipId: tipId
        }
    } : null, $9a8b2f067ab5dd6a$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        tip: data?.tip,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("i9vCv", function(module, exports) {

$parcel$export(module.exports, "useTrack", function () { return $fb95bf8bd4efe03c$export$60a459a981d7d2d9; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $fb95bf8bd4efe03c$var$getTrack = async ({ data: { trackId: trackId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve track
        const { track: track } = await api.trackApi.getTrack(trackId);
        // return payload
        return {
            track: track,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            track: undefined,
            error: message
        };
    }
};
const $fb95bf8bd4efe03c$var$fetcher = (args)=>$fb95bf8bd4efe03c$var$getTrack(args);
const $fb95bf8bd4efe03c$export$60a459a981d7d2d9 = (trackId)=>{
    const shouldFetch = !!trackId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseTrack,
        data: {
            trackId: trackId
        }
    } : null, $fb95bf8bd4efe03c$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        track: data?.track,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("6uGoQ", function(module, exports) {

$parcel$export(module.exports, "useTracks", function () { return $101ae5aa2340f44c$export$ac24e1f911a9f36c; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $101ae5aa2340f44c$var$getTracksByIds = async ({ data: { trackIds: trackIds } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // if no track ids provided
    if (trackIds.length === 0) // return empty payload
    return {
        tracks: [],
        count: 0,
        error: ""
    };
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getTracksByIds(trackIds.join(","));
        // return payload
        return {
            tracks: tracks,
            count: count,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error
        return {
            tracks: [],
            count: 0,
            error: message
        };
    }
};
const $101ae5aa2340f44c$var$fetcher = (args)=>$101ae5aa2340f44c$var$getTracksByIds(args);
const $101ae5aa2340f44c$export$ac24e1f911a9f36c = (trackIds)=>{
    const { data: data, isLoading: isLoading } = (0, $fTjtL.default)({
        key: (0, $f2lkA.SWRKeys).UseTracks,
        data: {
            trackIds: trackIds
        }
    }, $101ae5aa2340f44c$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        tracks: data?.tracks,
        count: data?.count,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("ceCYx", function(module, exports) {

$parcel$export(module.exports, "useTracksPublic", function () { return $d2b7c31bdd44564e$export$f5bc4564080a741a; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $d2b7c31bdd44564e$var$getPublicTracksByIds = async ({ data: { trackIds: trackIds } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // if no track ids provided
    if (trackIds.length === 0) // return empty payload
    return {
        tracks: [],
        count: 0,
        error: ""
    };
    try {
        // retrieve public tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPublicTracksByIds(trackIds.join(","));
        // return payload
        return {
            tracks: tracks,
            count: count,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error
        return {
            tracks: [],
            count: 0,
            error: message
        };
    }
};
const $d2b7c31bdd44564e$var$fetcher = (args)=>$d2b7c31bdd44564e$var$getPublicTracksByIds(args);
const $d2b7c31bdd44564e$export$f5bc4564080a741a = (trackIds)=>{
    const { data: data, isLoading: isLoading } = (0, $fTjtL.default)({
        key: (0, $f2lkA.SWRKeys).UseTracksPublic,
        data: {
            trackIds: trackIds
        }
    }, $d2b7c31bdd44564e$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        tracks: data?.tracks,
        count: data?.count,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("5LPLy", function(module, exports) {

$parcel$export(module.exports, "useUnlock", function () { return $bb30c9307b95d48a$export$ac82547f128fc31b; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $bb30c9307b95d48a$var$getUnlock = async ({ data: { unlockId: unlockId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve unlock
        const { unlock: unlock } = await api.unlockApi.getUnlock(unlockId);
        // return payload
        return {
            unlock: unlock,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            unlock: undefined,
            error: message
        };
    }
};
const $bb30c9307b95d48a$var$fetcher = (args)=>$bb30c9307b95d48a$var$getUnlock(args);
const $bb30c9307b95d48a$export$ac82547f128fc31b = (unlockId)=>{
    const shouldFetch = !!unlockId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseUnlock,
        data: {
            unlockId: unlockId
        }
    } : null, $bb30c9307b95d48a$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        unlock: data?.unlock,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("gLN5L", function(module, exports) {

$parcel$export(module.exports, "useUser", function () { return $922cb7654860c433$export$23bbbc4533528f03; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $922cb7654860c433$var$getUser = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve user
        const { user: user } = await api.userApi.getUser(userId);
        // return payload
        return {
            user: user,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            user: undefined,
            error: message
        };
    }
};
const $922cb7654860c433$var$fetcher = (args)=>$922cb7654860c433$var$getUser(args);
const $922cb7654860c433$export$23bbbc4533528f03 = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseUser,
        data: {
            userId: userId
        }
    } : null, $922cb7654860c433$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        user: data?.user,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("aCYwi", function(module, exports) {

$parcel$export(module.exports, "useUserPublic", function () { return $441eb77ec4dab5f0$export$2a67f4ed498d5944; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $441eb77ec4dab5f0$var$getPublicUser = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve public user
        const { user: user } = await api.userApi.getPublicUser(userId);
        // return payload
        return {
            user: user,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            user: undefined,
            error: message
        };
    }
};
const $441eb77ec4dab5f0$var$fetcher = (args)=>$441eb77ec4dab5f0$var$getPublicUser(args);
const $441eb77ec4dab5f0$export$2a67f4ed498d5944 = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading, mutate: mutate } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseUserPublic,
        data: {
            userId: userId
        }
    } : null, $441eb77ec4dab5f0$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        user: data?.user,
        isLoading: isLoading,
        isError: data?.error,
        mutate: mutate
    };
};

});

parcelRegister("gBCSe", function(module, exports) {

$parcel$export(module.exports, "useUsers", function () { return $ca258e43aaddab03$export$90f4370c54dd43c9; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $ca258e43aaddab03$var$getUsersByIds = async ({ data: { userIds: userIds } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // if no user ids provided
    if (userIds.length === 0) // return empty payload
    return {
        users: [],
        count: 0,
        error: ""
    };
    try {
        // retrieve users
        const { users: users, count: count } = await api.userApi.getUsersByIds(userIds.join(","));
        // return payload
        return {
            users: users,
            count: count,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error
        return {
            users: [],
            count: 0,
            error: message
        };
    }
};
const $ca258e43aaddab03$var$fetcher = (args)=>$ca258e43aaddab03$var$getUsersByIds(args);
const $ca258e43aaddab03$export$90f4370c54dd43c9 = (userIds)=>{
    const { data: data, isLoading: isLoading } = (0, $fTjtL.default)({
        key: (0, $f2lkA.SWRKeys).UseUsers,
        data: {
            userIds: userIds
        }
    }, $ca258e43aaddab03$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        users: data?.users,
        count: data?.count,
        isLoading: isLoading,
        isError: data?.error
    };
};

});

parcelRegister("lXxtV", function(module, exports) {

$parcel$export(module.exports, "useUserStats", function () { return $1ec2c840a9e0a353$export$1adece3fb6ad67ff; });

var $fTjtL = parcelRequire("fTjtL");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");

var $f2lkA = parcelRequire("f2lkA");
const $1ec2c840a9e0a353$var$getUserStats = async ({ data: { userId: userId } })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve posts count
        const { count: postsCount } = await api.postApi.getUserPostsCount(userId);
        // retrieve tracks count
        const { count: tracksCount } = await api.trackApi.getUserTracksCount(userId);
        // return payload
        return {
            postsCount: postsCount,
            tracksCount: tracksCount,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return payload
        return {
            postsCount: 0,
            tracksCount: 0,
            error: message
        };
    }
};
const $1ec2c840a9e0a353$var$fetcher = (args)=>$1ec2c840a9e0a353$var$getUserStats(args);
const $1ec2c840a9e0a353$export$1adece3fb6ad67ff = (userId)=>{
    const shouldFetch = !!userId;
    const { data: data, isLoading: isLoading } = (0, $fTjtL.default)(shouldFetch ? {
        key: (0, $f2lkA.SWRKeys).UseUserStats,
        data: {
            userId: userId
        }
    } : null, $1ec2c840a9e0a353$var$fetcher, {
        revalidateOnFocus: false
    });
    return {
        postsCount: data?.postsCount,
        tracksCount: data?.tracksCount,
        isLoading: isLoading,
        isError: data?.error
    };
};

});



parcelRegister("kf12V", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $94eec17af0be4739$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $94eec17af0be4739$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).alert.modal, ";position:fixed;top:0;left:0;width:100%;", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                message: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("h7gla", function(module, exports) {

$parcel$export(module.exports, "AlertMessageType", function () { return $f51c4cb4829ed83b$export$ce4c141af0ec0b42; });
var $f51c4cb4829ed83b$export$ce4c141af0ec0b42;
(function(AlertMessageType) {
    AlertMessageType["Info"] = "info";
    AlertMessageType["Warn"] = "warn";
    AlertMessageType["Error"] = "error";
})($f51c4cb4829ed83b$export$ce4c141af0ec0b42 || ($f51c4cb4829ed83b$export$ce4c141af0ec0b42 = {}));

});

parcelRegister("6tPng", function(module, exports) {

$parcel$export(module.exports, "alertSlice", function () { return $53525e8e8f63e6b9$export$347ed57d7b031934; });
$parcel$export(module.exports, "alertAddMessage", function () { return $53525e8e8f63e6b9$export$539a1eed9a97cb62; });
$parcel$export(module.exports, "alertRemoveMessage", function () { return $53525e8e8f63e6b9$export$c1a8b8fb2cbef9fe; });
$parcel$export(module.exports, "alertSelectMessages", function () { return $53525e8e8f63e6b9$export$1a389607ab64f99; });
$parcel$export(module.exports, "alertReducer", function () { return $53525e8e8f63e6b9$export$5edbb3adab4c0050; });

var $kvj5V = parcelRequire("kvj5V");
const $53525e8e8f63e6b9$var$initialState = {
    messages: []
};
const $53525e8e8f63e6b9$export$347ed57d7b031934 = (0, $kvj5V.createSlice)({
    name: "alert",
    initialState: $53525e8e8f63e6b9$var$initialState,
    reducers: {
        // reset state
        alertResetState: ()=>({
                messages: []
            }),
        // add message
        alertAddMessage: (state, action)=>{
            const { message: message } = action.payload;
            // mutate state
            state.messages.push(message);
        },
        // remove message
        alertRemoveMessage: (state, action)=>{
            const { messageId: messageId } = action.payload;
            // mutate state
            state.messages = state.messages.filter((el)=>el.id !== messageId);
        }
    }
});
const { alertAddMessage: $53525e8e8f63e6b9$export$539a1eed9a97cb62, alertRemoveMessage: $53525e8e8f63e6b9$export$c1a8b8fb2cbef9fe } = $53525e8e8f63e6b9$export$347ed57d7b031934.actions;
const $53525e8e8f63e6b9$export$1a389607ab64f99 = (state)=>state.alert.messages;
const $53525e8e8f63e6b9$export$5edbb3adab4c0050 = $53525e8e8f63e6b9$export$347ed57d7b031934.reducer; // export default alertReducer.reducer

});
parcelRegister("kvj5V", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $eed583b23d3647ed$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createAsyncThunk", function () { return $eed583b23d3647ed$export$6abd22dc03e5063f; });
$parcel$export(module.exports, "createSlice", function () { return $eed583b23d3647ed$export$4d8d9bd83c24ae8b; });

var $eOM9F = parcelRequire("eOM9F");

var $2VCAa = parcelRequire("2VCAa");

var $rsltX = parcelRequire("rsltX");

var $hULef = parcelRequire("hULef");

var $4TNnu = parcelRequire("4TNnu");
var $eed583b23d3647ed$var$__defProp = Object.defineProperty;
var $eed583b23d3647ed$var$__defProps = Object.defineProperties;
var $eed583b23d3647ed$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $eed583b23d3647ed$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $eed583b23d3647ed$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $eed583b23d3647ed$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $eed583b23d3647ed$var$__defNormalProp = (obj, key, value)=>key in obj ? $eed583b23d3647ed$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $eed583b23d3647ed$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($eed583b23d3647ed$var$__hasOwnProp.call(b, prop)) $eed583b23d3647ed$var$__defNormalProp(a, prop, b[prop]);
    if ($eed583b23d3647ed$var$__getOwnPropSymbols) {
        for (var prop of $eed583b23d3647ed$var$__getOwnPropSymbols(b))if ($eed583b23d3647ed$var$__propIsEnum.call(b, prop)) $eed583b23d3647ed$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $eed583b23d3647ed$var$__spreadProps = (a, b)=>$eed583b23d3647ed$var$__defProps(a, $eed583b23d3647ed$var$__getOwnPropDescs(b));
var $eed583b23d3647ed$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($eed583b23d3647ed$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $eed583b23d3647ed$var$__getOwnPropSymbols) {
        for (var prop of $eed583b23d3647ed$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $eed583b23d3647ed$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $eed583b23d3647ed$var$__publicField = (obj, key, value)=>$eed583b23d3647ed$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $eed583b23d3647ed$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $rsltX.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $2VCAa.isDraft)(value) ? (0, $2VCAa.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $eed583b23d3647ed$export$a5d3c27355e35910 = /* @__PURE__ */ $eed583b23d3647ed$export$aab6de9e3dbb1473((0, $rsltX.weakMapMemoize));
var $eed583b23d3647ed$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $eOM9F.compose;
    return (0, $eOM9F.compose).apply(null, arguments);
};
var $eed583b23d3647ed$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $eed583b23d3647ed$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $eed583b23d3647ed$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(0));
            return $eed583b23d3647ed$var$__spreadValues($eed583b23d3647ed$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $eOM9F.isAction)(action) && action.type === type;
    return actionCreator;
}
function $eed583b23d3647ed$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $eed583b23d3647ed$var$hasMatchFunction(action);
}
function $eed583b23d3647ed$export$ebd532f9034651f3(action) {
    return (0, $eOM9F.isAction)(action) && Object.keys(action).every($eed583b23d3647ed$var$isValidKey);
}
function $eed583b23d3647ed$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $eed583b23d3647ed$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $eed583b23d3647ed$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $eed583b23d3647ed$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $eed583b23d3647ed$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $eed583b23d3647ed$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $eed583b23d3647ed$var$freezeDraftable(val) {
    return (0, $2VCAa.isDraftable)(val) ? (0, $2VCAa.produce)(val, ()=>{}) : val;
}
function $eed583b23d3647ed$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $eed583b23d3647ed$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $eed583b23d3647ed$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $eed583b23d3647ed$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $eed583b23d3647ed$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $eed583b23d3647ed$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $eed583b23d3647ed$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $eed583b23d3647ed$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $eed583b23d3647ed$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $eed583b23d3647ed$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $eed583b23d3647ed$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $eOM9F.isPlainObject)(val);
}
function $eed583b23d3647ed$export$ada5dca0b571bc7(value, path = "", isSerializable = $eed583b23d3647ed$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $eed583b23d3647ed$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $eed583b23d3647ed$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $eed583b23d3647ed$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$eed583b23d3647ed$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $eed583b23d3647ed$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $eed583b23d3647ed$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $eed583b23d3647ed$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $eed583b23d3647ed$export$1908877435b1d5e9();
        if (thunk) {
            if ($eed583b23d3647ed$var$isBoolean(thunk)) middlewareArray.push((0, $hULef.thunk));
            else middlewareArray.push((0, $hULef.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $eed583b23d3647ed$export$8fb31c0f05df007b = "RTK_autoBatch";
var $eed583b23d3647ed$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$eed583b23d3647ed$export$8fb31c0f05df007b]: true
            }
        });
var $eed583b23d3647ed$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $eed583b23d3647ed$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $eed583b23d3647ed$var$createQueueWithTimer(10);
var $eed583b23d3647ed$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $eed583b23d3647ed$var$rAF : options.type === "callback" ? options.queueNotification : $eed583b23d3647ed$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$eed583b23d3647ed$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $eed583b23d3647ed$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $eed583b23d3647ed$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($eed583b23d3647ed$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $eed583b23d3647ed$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $eed583b23d3647ed$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $eOM9F.isPlainObject)(reducer)) rootReducer = (0, $eOM9F.combineReducers)(reducer);
    else throw new Error($eed583b23d3647ed$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $eOM9F.compose);
    if (devTools) finalCompose = $eed583b23d3647ed$var$composeWithDevTools($eed583b23d3647ed$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $eOM9F.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $eed583b23d3647ed$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $eOM9F.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $eed583b23d3647ed$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $eed583b23d3647ed$var$isStateFunction(x) {
    return typeof x === "function";
}
function $eed583b23d3647ed$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $eed583b23d3647ed$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($eed583b23d3647ed$var$isStateFunction(initialState)) getInitialState = ()=>$eed583b23d3647ed$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $eed583b23d3647ed$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $2VCAa.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $2VCAa.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($eed583b23d3647ed$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $2VCAa.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $eed583b23d3647ed$var$matches = (matcher, action)=>{
    if ($eed583b23d3647ed$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $eed583b23d3647ed$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$eed583b23d3647ed$var$matches(matcher, action));
    };
}
function $eed583b23d3647ed$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$eed583b23d3647ed$var$matches(matcher, action));
    };
}
function $eed583b23d3647ed$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $eed583b23d3647ed$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $eed583b23d3647ed$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$eed583b23d3647ed$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$eed583b23d3647ed$var$isAsyncThunkArray(asyncThunks)) return $eed583b23d3647ed$export$872dec21e9a69476()(asyncThunks[0]);
    return $eed583b23d3647ed$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $eed583b23d3647ed$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$eed583b23d3647ed$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$eed583b23d3647ed$var$isAsyncThunkArray(asyncThunks)) return $eed583b23d3647ed$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $eed583b23d3647ed$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $eed583b23d3647ed$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $eed583b23d3647ed$export$9dd1fb32974da385($eed583b23d3647ed$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$eed583b23d3647ed$var$isAsyncThunkArray(asyncThunks)) return $eed583b23d3647ed$export$fcc3388fb56de601()(asyncThunks[0]);
    return $eed583b23d3647ed$export$9dd1fb32974da385($eed583b23d3647ed$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $eed583b23d3647ed$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$eed583b23d3647ed$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$eed583b23d3647ed$var$isAsyncThunkArray(asyncThunks)) return $eed583b23d3647ed$export$1da80a6ef1307441()(asyncThunks[0]);
    return $eed583b23d3647ed$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $eed583b23d3647ed$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$eed583b23d3647ed$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$eed583b23d3647ed$var$isAsyncThunkArray(asyncThunks)) return $eed583b23d3647ed$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $eed583b23d3647ed$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $eed583b23d3647ed$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $eed583b23d3647ed$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $eed583b23d3647ed$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $eed583b23d3647ed$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $eed583b23d3647ed$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $eed583b23d3647ed$var$__publicField(this, "_type");
    }
};
var $eed583b23d3647ed$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $eed583b23d3647ed$var$__publicField(this, "_type");
    }
};
var $eed583b23d3647ed$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $eed583b23d3647ed$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $eed583b23d3647ed$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $eed583b23d3647ed$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $eed583b23d3647ed$var$__spreadProps($eed583b23d3647ed$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $eed583b23d3647ed$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $eed583b23d3647ed$var$__spreadProps($eed583b23d3647ed$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $eed583b23d3647ed$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $eed583b23d3647ed$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $eed583b23d3647ed$var$__spreadProps($eed583b23d3647ed$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $eed583b23d3647ed$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($eed583b23d3647ed$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $eed583b23d3647ed$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $eed583b23d3647ed$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $eed583b23d3647ed$var$RejectWithValue) throw result;
                                if (result instanceof $eed583b23d3647ed$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $eed583b23d3647ed$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($eed583b23d3647ed$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $eed583b23d3647ed$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $eed583b23d3647ed$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $eed583b23d3647ed$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $eed583b23d3647ed$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $eed583b23d3647ed$export$343355ed40c51c46 = {
    [$eed583b23d3647ed$var$asyncThunkSymbol]: $eed583b23d3647ed$export$6abd22dc03e5063f
};
var $eed583b23d3647ed$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($eed583b23d3647ed$export$23a094319a4b586 || {});
function $eed583b23d3647ed$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $eed583b23d3647ed$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$eed583b23d3647ed$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(11));
        typeof $4TNnu;
        const reducers = (typeof options.reducers === "function" ? options.reducers($eed583b23d3647ed$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $eed583b23d3647ed$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($eed583b23d3647ed$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $eed583b23d3647ed$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $eed583b23d3647ed$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $eed583b23d3647ed$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $eed583b23d3647ed$var$__spreadValues($eed583b23d3647ed$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $eed583b23d3647ed$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $eed583b23d3647ed$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $eed583b23d3647ed$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $eed583b23d3647ed$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $eed583b23d3647ed$var$__spreadProps($eed583b23d3647ed$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $eed583b23d3647ed$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $eed583b23d3647ed$var$__spreadValues($eed583b23d3647ed$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $eed583b23d3647ed$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $eed583b23d3647ed$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $eed583b23d3647ed$export$affdea4146de9cf5();
function $eed583b23d3647ed$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $eed583b23d3647ed$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $eed583b23d3647ed$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$eed583b23d3647ed$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $eed583b23d3647ed$export$309c7a02b0b0bc62(type, prepareCallback) : $eed583b23d3647ed$export$309c7a02b0b0bc62(type));
}
function $eed583b23d3647ed$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $eed583b23d3647ed$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $eed583b23d3647ed$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $eed583b23d3647ed$var$noop,
        pending: pending || $eed583b23d3647ed$var$noop,
        rejected: rejected || $eed583b23d3647ed$var$noop,
        settled: settled || $eed583b23d3647ed$var$noop
    });
}
function $eed583b23d3647ed$var$noop() {}
// src/entities/entity_state.ts
function $eed583b23d3647ed$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $eed583b23d3647ed$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($eed583b23d3647ed$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $eed583b23d3647ed$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $eed583b23d3647ed$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $eed583b23d3647ed$var$isDraftTyped = (0, $2VCAa.isDraft);
function $eed583b23d3647ed$var$createSingleArgumentStateOperator(mutator) {
    const operator = $eed583b23d3647ed$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $eed583b23d3647ed$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $eed583b23d3647ed$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($eed583b23d3647ed$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $2VCAa.produce)(state, runMutator);
    };
}
function $eed583b23d3647ed$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $eed583b23d3647ed$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $eed583b23d3647ed$var$getCurrent(value) {
    return (0, $2VCAa.isDraft)(value) ? (0, $2VCAa.current)(value) : value;
}
function $eed583b23d3647ed$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $eed583b23d3647ed$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $eed583b23d3647ed$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $eed583b23d3647ed$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $eed583b23d3647ed$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $eed583b23d3647ed$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $eed583b23d3647ed$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $eed583b23d3647ed$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $eed583b23d3647ed$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $eed583b23d3647ed$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $eed583b23d3647ed$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $eed583b23d3647ed$var$__spreadValues($eed583b23d3647ed$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$eed583b23d3647ed$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $eed583b23d3647ed$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $eed583b23d3647ed$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $eed583b23d3647ed$var$createStateOperator(addOneMutably),
        addMany: $eed583b23d3647ed$var$createStateOperator(addManyMutably),
        setOne: $eed583b23d3647ed$var$createStateOperator(setOneMutably),
        setMany: $eed583b23d3647ed$var$createStateOperator(setManyMutably),
        setAll: $eed583b23d3647ed$var$createStateOperator(setAllMutably),
        updateOne: $eed583b23d3647ed$var$createStateOperator(updateOneMutably),
        updateMany: $eed583b23d3647ed$var$createStateOperator(updateManyMutably),
        upsertOne: $eed583b23d3647ed$var$createStateOperator(upsertOneMutably),
        upsertMany: $eed583b23d3647ed$var$createStateOperator(upsertManyMutably),
        removeOne: $eed583b23d3647ed$var$createStateOperator(removeOneMutably),
        removeMany: $eed583b23d3647ed$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $eed583b23d3647ed$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $eed583b23d3647ed$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $eed583b23d3647ed$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $eed583b23d3647ed$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $eed583b23d3647ed$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $eed583b23d3647ed$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $eed583b23d3647ed$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($eed583b23d3647ed$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $eed583b23d3647ed$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $eed583b23d3647ed$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $eed583b23d3647ed$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $eed583b23d3647ed$var$getCurrent(state.entities);
        const currentIds = $eed583b23d3647ed$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $eed583b23d3647ed$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $eed583b23d3647ed$var$createStateOperator(addOneMutably),
        updateOne: $eed583b23d3647ed$var$createStateOperator(updateOneMutably),
        upsertOne: $eed583b23d3647ed$var$createStateOperator(upsertOneMutably),
        setOne: $eed583b23d3647ed$var$createStateOperator(setOneMutably),
        setMany: $eed583b23d3647ed$var$createStateOperator(setManyMutably),
        setAll: $eed583b23d3647ed$var$createStateOperator(setAllMutably),
        addMany: $eed583b23d3647ed$var$createStateOperator(addManyMutably),
        updateMany: $eed583b23d3647ed$var$createStateOperator(updateManyMutably),
        upsertMany: $eed583b23d3647ed$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $eed583b23d3647ed$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $eed583b23d3647ed$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $eed583b23d3647ed$var$createSortedStateAdapter(selectId, sortComparer) : $eed583b23d3647ed$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $eed583b23d3647ed$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $eed583b23d3647ed$var$createSelectorsFactory();
    return $eed583b23d3647ed$var$__spreadValues($eed583b23d3647ed$var$__spreadValues($eed583b23d3647ed$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $eed583b23d3647ed$var$task = "task";
var $eed583b23d3647ed$var$listener = "listener";
var $eed583b23d3647ed$var$completed = "completed";
var $eed583b23d3647ed$var$cancelled = "cancelled";
var $eed583b23d3647ed$var$taskCancelled = `task-${$eed583b23d3647ed$var$cancelled}`;
var $eed583b23d3647ed$var$taskCompleted = `task-${$eed583b23d3647ed$var$completed}`;
var $eed583b23d3647ed$var$listenerCancelled = `${$eed583b23d3647ed$var$listener}-${$eed583b23d3647ed$var$cancelled}`;
var $eed583b23d3647ed$var$listenerCompleted = `${$eed583b23d3647ed$var$listener}-${$eed583b23d3647ed$var$completed}`;
var $eed583b23d3647ed$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $eed583b23d3647ed$var$__publicField(this, "name", "TaskAbortError");
        $eed583b23d3647ed$var$__publicField(this, "message");
        this.message = `${$eed583b23d3647ed$var$task} ${$eed583b23d3647ed$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $eed583b23d3647ed$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($eed583b23d3647ed$export$378fa86b259c0280(32));
};
var $eed583b23d3647ed$var$noop2 = ()=>{};
var $eed583b23d3647ed$var$catchRejection = (promise, onError = $eed583b23d3647ed$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $eed583b23d3647ed$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $eed583b23d3647ed$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $eed583b23d3647ed$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $eed583b23d3647ed$export$cb1bdac908fed7f(reason);
    }
};
function $eed583b23d3647ed$var$raceWithSignal(signal, promise) {
    let cleanup = $eed583b23d3647ed$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $eed583b23d3647ed$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $eed583b23d3647ed$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $eed583b23d3647ed$var$noop2;
    });
}
var $eed583b23d3647ed$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $eed583b23d3647ed$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $eed583b23d3647ed$var$createPause = (signal)=>{
    return (promise)=>{
        return $eed583b23d3647ed$var$catchRejection($eed583b23d3647ed$var$raceWithSignal(signal, promise).then((output)=>{
            $eed583b23d3647ed$var$validateActive(signal);
            return output;
        }));
    };
};
var $eed583b23d3647ed$var$createDelay = (signal)=>{
    const pause = $eed583b23d3647ed$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $eed583b23d3647ed$var$assign } = Object;
var $eed583b23d3647ed$var$INTERNAL_NIL_TOKEN = {};
var $eed583b23d3647ed$var$alm = "listenerMiddleware";
var $eed583b23d3647ed$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$eed583b23d3647ed$var$addAbortSignalListener(parentAbortSignal, ()=>$eed583b23d3647ed$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $eed583b23d3647ed$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $eed583b23d3647ed$var$runTask(async ()=>{
            $eed583b23d3647ed$var$validateActive(parentAbortSignal);
            $eed583b23d3647ed$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $eed583b23d3647ed$var$createPause(childAbortController.signal),
                delay: $eed583b23d3647ed$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $eed583b23d3647ed$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$eed583b23d3647ed$var$abortControllerWithReason(childAbortController, $eed583b23d3647ed$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($eed583b23d3647ed$var$noop2));
        return {
            result: $eed583b23d3647ed$var$createPause(parentAbortSignal)(result),
            cancel () {
                $eed583b23d3647ed$var$abortControllerWithReason(childAbortController, $eed583b23d3647ed$var$taskCancelled);
            }
        };
    };
};
var $eed583b23d3647ed$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $eed583b23d3647ed$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $eed583b23d3647ed$var$raceWithSignal(signal, Promise.race(promises));
            $eed583b23d3647ed$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$eed583b23d3647ed$var$catchRejection(take(predicate, timeout));
};
var $eed583b23d3647ed$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $eed583b23d3647ed$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($eed583b23d3647ed$export$378fa86b259c0280(21));
    $eed583b23d3647ed$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $eed583b23d3647ed$var$createListenerEntry = /* @__PURE__ */ $eed583b23d3647ed$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $eed583b23d3647ed$var$getListenerEntryPropsFrom(options);
    const id = $eed583b23d3647ed$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($eed583b23d3647ed$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$eed583b23d3647ed$var$createListenerEntry
});
var $eed583b23d3647ed$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $eed583b23d3647ed$var$abortControllerWithReason(controller, $eed583b23d3647ed$var$listenerCancelled);
    });
};
var $eed583b23d3647ed$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($eed583b23d3647ed$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $eed583b23d3647ed$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $eed583b23d3647ed$export$f03a6b845d3fb58b = /* @__PURE__ */ $eed583b23d3647ed$var$assign(/* @__PURE__ */ $eed583b23d3647ed$export$309c7a02b0b0bc62(`${$eed583b23d3647ed$var$alm}/add`), {
    withTypes: ()=>$eed583b23d3647ed$export$f03a6b845d3fb58b
});
var $eed583b23d3647ed$export$b1b8022855fb2b71 = /* @__PURE__ */ $eed583b23d3647ed$export$309c7a02b0b0bc62(`${$eed583b23d3647ed$var$alm}/removeAll`);
var $eed583b23d3647ed$export$b03e9483f936dccb = /* @__PURE__ */ $eed583b23d3647ed$var$assign(/* @__PURE__ */ $eed583b23d3647ed$export$309c7a02b0b0bc62(`${$eed583b23d3647ed$var$alm}/remove`), {
    withTypes: ()=>$eed583b23d3647ed$export$b03e9483f936dccb
});
var $eed583b23d3647ed$var$defaultErrorHandler = (...args)=>{
    console.error(`${$eed583b23d3647ed$var$alm}/error`, ...args);
};
var $eed583b23d3647ed$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $eed583b23d3647ed$var$defaultErrorHandler } = middlewareOptions;
    $eed583b23d3647ed$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $eed583b23d3647ed$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $eed583b23d3647ed$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $eed583b23d3647ed$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $eed583b23d3647ed$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $eed583b23d3647ed$var$getListenerEntryPropsFrom(options);
        const entry = $eed583b23d3647ed$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $eed583b23d3647ed$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $eed583b23d3647ed$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $eed583b23d3647ed$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $eed583b23d3647ed$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $eed583b23d3647ed$var$createDelay(internalTaskController.signal),
                pause: $eed583b23d3647ed$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $eed583b23d3647ed$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $eed583b23d3647ed$var$abortControllerWithReason(controller, $eed583b23d3647ed$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $eed583b23d3647ed$var$abortControllerWithReason(internalTaskController, $eed583b23d3647ed$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $eed583b23d3647ed$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $eed583b23d3647ed$export$cb1bdac908fed7f)) $eed583b23d3647ed$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $eed583b23d3647ed$var$abortControllerWithReason(internalTaskController, $eed583b23d3647ed$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $eed583b23d3647ed$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $eOM9F.isAction)(action)) return next(action);
                if ($eed583b23d3647ed$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($eed583b23d3647ed$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($eed583b23d3647ed$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $eed583b23d3647ed$var$INTERNAL_NIL_TOKEN) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $eed583b23d3647ed$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $eed583b23d3647ed$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $eed583b23d3647ed$var$createMiddlewareEntry = (middleware)=>({
        id: $eed583b23d3647ed$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $eed583b23d3647ed$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $eed583b23d3647ed$export$4bb1606a79445586 = ()=>{
    const instanceId = $eed583b23d3647ed$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($eed583b23d3647ed$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $eed583b23d3647ed$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $eed583b23d3647ed$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$eed583b23d3647ed$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $eOM9F.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $eed583b23d3647ed$export$9dd1fb32974da385(withMiddleware, $eed583b23d3647ed$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $eed583b23d3647ed$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $eed583b23d3647ed$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$eed583b23d3647ed$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $eed583b23d3647ed$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $eed583b23d3647ed$var$isStateProxy = (value)=>!!value && !!value[$eed583b23d3647ed$var$ORIGINAL_STATE];
var $eed583b23d3647ed$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $eed583b23d3647ed$var$createStateProxy = (state, reducerMap)=>$eed583b23d3647ed$var$emplace($eed583b23d3647ed$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $eed583b23d3647ed$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $eed583b23d3647ed$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($eed583b23d3647ed$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $eed583b23d3647ed$var$original = (state)=>{
    if (!$eed583b23d3647ed$var$isStateProxy(state)) throw new Error($eed583b23d3647ed$export$378fa86b259c0280(25));
    return state[$eed583b23d3647ed$var$ORIGINAL_STATE];
};
var $eed583b23d3647ed$var$noopReducer = (state = {})=>state;
function $eed583b23d3647ed$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($eed583b23d3647ed$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $eOM9F.combineReducers)(reducerMap) : $eed583b23d3647ed$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $4TNnu;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($eed583b23d3647ed$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $eed583b23d3647ed$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $eed583b23d3647ed$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("eOM9F", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $ac9b16ca22581446$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "createStore", function () { return $ac9b16ca22581446$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $ac9b16ca22581446$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $ac9b16ca22581446$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $ac9b16ca22581446$export$9ff26e0402cc7b7; });
$parcel$export(module.exports, "isAction", function () { return $ac9b16ca22581446$export$b956e38827fca970; });
// src/utils/formatProdErrorMessage.ts
function $ac9b16ca22581446$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $ac9b16ca22581446$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $ac9b16ca22581446$var$symbol_observable_default = $ac9b16ca22581446$var$$$observable;
// src/utils/actionTypes.ts
var $ac9b16ca22581446$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $ac9b16ca22581446$var$ActionTypes = {
    INIT: `@@redux/INIT${$ac9b16ca22581446$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$ac9b16ca22581446$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$ac9b16ca22581446$var$randomString()}`
};
var $ac9b16ca22581446$export$4219e499db7ca678 = $ac9b16ca22581446$var$ActionTypes;
// src/utils/isPlainObject.ts
function $ac9b16ca22581446$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $ac9b16ca22581446$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ac9b16ca22581446$var$isDate(val)) return "date";
    if ($ac9b16ca22581446$var$isError(val)) return "error";
    const constructorName = $ac9b16ca22581446$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ac9b16ca22581446$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ac9b16ca22581446$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ac9b16ca22581446$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ac9b16ca22581446$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $ac9b16ca22581446$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(1));
        return enhancer($ac9b16ca22581446$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$ac9b16ca22581446$export$53b83ca8eaab0383(action)) throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $ac9b16ca22581446$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$ac9b16ca22581446$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $ac9b16ca22581446$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$ac9b16ca22581446$var$symbol_observable_default]: observable
    };
    return store;
}
function $ac9b16ca22581446$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $ac9b16ca22581446$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $ac9b16ca22581446$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $ac9b16ca22581446$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $ac9b16ca22581446$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ac9b16ca22581446$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$ac9b16ca22581446$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ac9b16ca22581446$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $ac9b16ca22581446$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $ac9b16ca22581446$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $ac9b16ca22581446$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(13));
    });
}
function $ac9b16ca22581446$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $ac9b16ca22581446$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $ac9b16ca22581446$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $ac9b16ca22581446$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ac9b16ca22581446$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ac9b16ca22581446$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $ac9b16ca22581446$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $ac9b16ca22581446$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($ac9b16ca22581446$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $ac9b16ca22581446$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $ac9b16ca22581446$export$b956e38827fca970(action) {
    return $ac9b16ca22581446$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("2VCAa", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return $221ed54ac1c24a81$export$541ac630993a4c84; });
$parcel$export(module.exports, "isDraftable", function () { return $221ed54ac1c24a81$export$16e3aed3edb85946; });
$parcel$export(module.exports, "current", function () { return $221ed54ac1c24a81$export$97aac956da55dae9; });
$parcel$export(module.exports, "produce", function () { return $221ed54ac1c24a81$export$b46cabe22e78bc00; });
var $221ed54ac1c24a81$var$__defProp = Object.defineProperty;
var $221ed54ac1c24a81$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $221ed54ac1c24a81$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $221ed54ac1c24a81$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $221ed54ac1c24a81$var$__defNormalProp = (obj, key, value)=>key in obj ? $221ed54ac1c24a81$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $221ed54ac1c24a81$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($221ed54ac1c24a81$var$__hasOwnProp.call(b, prop)) $221ed54ac1c24a81$var$__defNormalProp(a, prop, b[prop]);
    if ($221ed54ac1c24a81$var$__getOwnPropSymbols) {
        for (var prop of $221ed54ac1c24a81$var$__getOwnPropSymbols(b))if ($221ed54ac1c24a81$var$__propIsEnum.call(b, prop)) $221ed54ac1c24a81$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $221ed54ac1c24a81$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $221ed54ac1c24a81$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $221ed54ac1c24a81$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $221ed54ac1c24a81$var$errors = [];
function $221ed54ac1c24a81$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $221ed54ac1c24a81$var$getPrototypeOf = Object.getPrototypeOf;
function $221ed54ac1c24a81$export$541ac630993a4c84(value) {
    return !!value && !!value[$221ed54ac1c24a81$var$DRAFT_STATE];
}
function $221ed54ac1c24a81$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $221ed54ac1c24a81$var$isPlainObject(value) || Array.isArray(value) || !!value[$221ed54ac1c24a81$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$221ed54ac1c24a81$export$6ee2082928bcb0ee]) || $221ed54ac1c24a81$var$isMap(value) || $221ed54ac1c24a81$var$isSet(value);
}
var $221ed54ac1c24a81$var$objectCtorString = Object.prototype.constructor.toString();
function $221ed54ac1c24a81$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $221ed54ac1c24a81$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $221ed54ac1c24a81$var$objectCtorString;
}
function $221ed54ac1c24a81$export$22e8af3f75a010e3(value) {
    if (!$221ed54ac1c24a81$export$541ac630993a4c84(value)) $221ed54ac1c24a81$var$die(15, value);
    return value[$221ed54ac1c24a81$var$DRAFT_STATE].base_;
}
function $221ed54ac1c24a81$var$each(obj, iter) {
    if ($221ed54ac1c24a81$var$getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $221ed54ac1c24a81$var$getArchtype(thing) {
    const state = thing[$221ed54ac1c24a81$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $221ed54ac1c24a81$var$isMap(thing) ? 2 /* Map */  : $221ed54ac1c24a81$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $221ed54ac1c24a81$var$has(thing, prop) {
    return $221ed54ac1c24a81$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $221ed54ac1c24a81$var$get(thing, prop) {
    return $221ed54ac1c24a81$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $221ed54ac1c24a81$var$set(thing, propOrOldValue, value) {
    const t = $221ed54ac1c24a81$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $221ed54ac1c24a81$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $221ed54ac1c24a81$var$isMap(target) {
    return target instanceof Map;
}
function $221ed54ac1c24a81$var$isSet(target) {
    return target instanceof Set;
}
function $221ed54ac1c24a81$var$latest(state) {
    return state.copy_ || state.base_;
}
function $221ed54ac1c24a81$var$shallowCopy(base, strict) {
    if ($221ed54ac1c24a81$var$isMap(base)) return new Map(base);
    if ($221ed54ac1c24a81$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = $221ed54ac1c24a81$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[$221ed54ac1c24a81$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create($221ed54ac1c24a81$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $221ed54ac1c24a81$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return $221ed54ac1c24a81$var$__spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function $221ed54ac1c24a81$export$792f3d81ea979f55(obj, deep = false) {
    if ($221ed54ac1c24a81$var$isFrozen(obj) || $221ed54ac1c24a81$export$541ac630993a4c84(obj) || !$221ed54ac1c24a81$export$16e3aed3edb85946(obj)) return obj;
    if ($221ed54ac1c24a81$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $221ed54ac1c24a81$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>$221ed54ac1c24a81$export$792f3d81ea979f55(value, true));
    return obj;
}
function $221ed54ac1c24a81$var$dontMutateFrozenCollections() {
    $221ed54ac1c24a81$var$die(2);
}
function $221ed54ac1c24a81$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $221ed54ac1c24a81$var$plugins = {};
function $221ed54ac1c24a81$var$getPlugin(pluginKey) {
    const plugin = $221ed54ac1c24a81$var$plugins[pluginKey];
    if (!plugin) $221ed54ac1c24a81$var$die(0, pluginKey);
    return plugin;
}
function $221ed54ac1c24a81$var$loadPlugin(pluginKey, implementation) {
    if (!$221ed54ac1c24a81$var$plugins[pluginKey]) $221ed54ac1c24a81$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $221ed54ac1c24a81$var$currentScope;
function $221ed54ac1c24a81$var$getCurrentScope() {
    return $221ed54ac1c24a81$var$currentScope;
}
function $221ed54ac1c24a81$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $221ed54ac1c24a81$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $221ed54ac1c24a81$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $221ed54ac1c24a81$var$revokeScope(scope) {
    $221ed54ac1c24a81$var$leaveScope(scope);
    scope.drafts_.forEach($221ed54ac1c24a81$var$revokeDraft);
    scope.drafts_ = null;
}
function $221ed54ac1c24a81$var$leaveScope(scope) {
    if (scope === $221ed54ac1c24a81$var$currentScope) $221ed54ac1c24a81$var$currentScope = scope.parent_;
}
function $221ed54ac1c24a81$var$enterScope(immer2) {
    return $221ed54ac1c24a81$var$currentScope = $221ed54ac1c24a81$var$createScope($221ed54ac1c24a81$var$currentScope, immer2);
}
function $221ed54ac1c24a81$var$revokeDraft(draft) {
    const state = draft[$221ed54ac1c24a81$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $221ed54ac1c24a81$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$221ed54ac1c24a81$var$DRAFT_STATE].modified_) {
            $221ed54ac1c24a81$var$revokeScope(scope);
            $221ed54ac1c24a81$var$die(4);
        }
        if ($221ed54ac1c24a81$export$16e3aed3edb85946(result)) {
            result = $221ed54ac1c24a81$var$finalize(scope, result);
            if (!scope.parent_) $221ed54ac1c24a81$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $221ed54ac1c24a81$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$221ed54ac1c24a81$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $221ed54ac1c24a81$var$finalize(scope, baseDraft, []);
    $221ed54ac1c24a81$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $221ed54ac1c24a81$export$45b790e32b2810ee ? result : void 0;
}
function $221ed54ac1c24a81$var$finalize(rootScope, value, path) {
    if ($221ed54ac1c24a81$var$isFrozen(value)) return value;
    const state = value[$221ed54ac1c24a81$var$DRAFT_STATE];
    if (!state) {
        $221ed54ac1c24a81$var$each(value, (key, childValue)=>$221ed54ac1c24a81$var$finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $221ed54ac1c24a81$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $221ed54ac1c24a81$var$each(resultEach, (key, childValue)=>$221ed54ac1c24a81$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $221ed54ac1c24a81$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $221ed54ac1c24a81$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $221ed54ac1c24a81$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($221ed54ac1c24a81$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$221ed54ac1c24a81$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $221ed54ac1c24a81$var$finalize(rootScope, childValue, path);
        $221ed54ac1c24a81$var$set(targetObject, prop, res);
        if ($221ed54ac1c24a81$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($221ed54ac1c24a81$export$16e3aed3edb85946(childValue) && !$221ed54ac1c24a81$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $221ed54ac1c24a81$var$finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) $221ed54ac1c24a81$var$maybeFreeze(rootScope, childValue);
    }
}
function $221ed54ac1c24a81$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $221ed54ac1c24a81$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $221ed54ac1c24a81$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $221ed54ac1c24a81$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $221ed54ac1c24a81$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $221ed54ac1c24a81$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $221ed54ac1c24a81$var$objectTraps = {
    get (state, prop) {
        if (prop === $221ed54ac1c24a81$var$DRAFT_STATE) return state;
        const source = $221ed54ac1c24a81$var$latest(state);
        if (!$221ed54ac1c24a81$var$has(source, prop)) return $221ed54ac1c24a81$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$221ed54ac1c24a81$export$16e3aed3edb85946(value)) return value;
        if (value === $221ed54ac1c24a81$var$peek(state.base_, prop)) {
            $221ed54ac1c24a81$var$prepareCopy(state);
            return state.copy_[prop] = $221ed54ac1c24a81$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $221ed54ac1c24a81$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($221ed54ac1c24a81$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $221ed54ac1c24a81$var$getDescriptorFromProto($221ed54ac1c24a81$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $221ed54ac1c24a81$var$peek($221ed54ac1c24a81$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$221ed54ac1c24a81$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($221ed54ac1c24a81$var$is(value, current2) && (value !== void 0 || $221ed54ac1c24a81$var$has(state.base_, prop))) return true;
            $221ed54ac1c24a81$var$prepareCopy(state);
            $221ed54ac1c24a81$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($221ed54ac1c24a81$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $221ed54ac1c24a81$var$prepareCopy(state);
            $221ed54ac1c24a81$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $221ed54ac1c24a81$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $221ed54ac1c24a81$var$die(11);
    },
    getPrototypeOf (state) {
        return $221ed54ac1c24a81$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $221ed54ac1c24a81$var$die(12);
    }
};
var $221ed54ac1c24a81$var$arrayTraps = {};
$221ed54ac1c24a81$var$each($221ed54ac1c24a81$var$objectTraps, (key, fn)=>{
    $221ed54ac1c24a81$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$221ed54ac1c24a81$var$arrayTraps.deleteProperty = function(state, prop) {
    return $221ed54ac1c24a81$var$arrayTraps.set.call(this, state, prop, void 0);
};
$221ed54ac1c24a81$var$arrayTraps.set = function(state, prop, value) {
    return $221ed54ac1c24a81$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $221ed54ac1c24a81$var$peek(draft, prop) {
    const state = draft[$221ed54ac1c24a81$var$DRAFT_STATE];
    const source = state ? $221ed54ac1c24a81$var$latest(state) : draft;
    return source[prop];
}
function $221ed54ac1c24a81$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $221ed54ac1c24a81$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $221ed54ac1c24a81$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $221ed54ac1c24a81$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $221ed54ac1c24a81$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $221ed54ac1c24a81$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $221ed54ac1c24a81$var$markChanged(state.parent_);
    }
}
function $221ed54ac1c24a81$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $221ed54ac1c24a81$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $221ed54ac1c24a81$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $221ed54ac1c24a81$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $221ed54ac1c24a81$var$die(7);
            let result;
            if ($221ed54ac1c24a81$export$16e3aed3edb85946(base)) {
                const scope = $221ed54ac1c24a81$var$enterScope(this);
                const proxy = $221ed54ac1c24a81$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $221ed54ac1c24a81$var$revokeScope(scope);
                    else $221ed54ac1c24a81$var$leaveScope(scope);
                }
                $221ed54ac1c24a81$var$usePatchesInScope(scope, patchListener);
                return $221ed54ac1c24a81$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $221ed54ac1c24a81$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $221ed54ac1c24a81$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $221ed54ac1c24a81$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $221ed54ac1c24a81$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$221ed54ac1c24a81$export$16e3aed3edb85946(base)) $221ed54ac1c24a81$var$die(8);
        if ($221ed54ac1c24a81$export$541ac630993a4c84(base)) base = $221ed54ac1c24a81$export$97aac956da55dae9(base);
        const scope = $221ed54ac1c24a81$var$enterScope(this);
        const proxy = $221ed54ac1c24a81$var$createProxy(base, void 0);
        proxy[$221ed54ac1c24a81$var$DRAFT_STATE].isManual_ = true;
        $221ed54ac1c24a81$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$221ed54ac1c24a81$var$DRAFT_STATE];
        if (!state || !state.isManual_) $221ed54ac1c24a81$var$die(9);
        const { scope_: scope } = state;
        $221ed54ac1c24a81$var$usePatchesInScope(scope, patchListener);
        return $221ed54ac1c24a81$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $221ed54ac1c24a81$var$getPlugin("Patches").applyPatches_;
        if ($221ed54ac1c24a81$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $221ed54ac1c24a81$var$createProxy(value, parent) {
    const draft = $221ed54ac1c24a81$var$isMap(value) ? $221ed54ac1c24a81$var$getPlugin("MapSet").proxyMap_(value, parent) : $221ed54ac1c24a81$var$isSet(value) ? $221ed54ac1c24a81$var$getPlugin("MapSet").proxySet_(value, parent) : $221ed54ac1c24a81$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $221ed54ac1c24a81$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $221ed54ac1c24a81$export$97aac956da55dae9(value) {
    if (!$221ed54ac1c24a81$export$541ac630993a4c84(value)) $221ed54ac1c24a81$var$die(10, value);
    return $221ed54ac1c24a81$var$currentImpl(value);
}
function $221ed54ac1c24a81$var$currentImpl(value) {
    if (!$221ed54ac1c24a81$export$16e3aed3edb85946(value) || $221ed54ac1c24a81$var$isFrozen(value)) return value;
    const state = value[$221ed54ac1c24a81$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $221ed54ac1c24a81$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $221ed54ac1c24a81$var$shallowCopy(value, true);
    $221ed54ac1c24a81$var$each(copy, (key, childValue)=>{
        $221ed54ac1c24a81$var$set(copy, key, $221ed54ac1c24a81$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $221ed54ac1c24a81$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $221ed54ac1c24a81$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $221ed54ac1c24a81$var$get(base_, key);
            const value = $221ed54ac1c24a81$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $221ed54ac1c24a81$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $221ed54ac1c24a81$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $221ed54ac1c24a81$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $221ed54ac1c24a81$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $221ed54ac1c24a81$var$die(errorOffset + 3);
                base = $221ed54ac1c24a81$var$get(base, p);
                if (typeof base !== "object") $221ed54ac1c24a81$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $221ed54ac1c24a81$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $221ed54ac1c24a81$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $221ed54ac1c24a81$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$221ed54ac1c24a81$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($221ed54ac1c24a81$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($221ed54ac1c24a81$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($221ed54ac1c24a81$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($221ed54ac1c24a81$var$has(obj, $221ed54ac1c24a81$export$6ee2082928bcb0ee)) cloned[$221ed54ac1c24a81$export$6ee2082928bcb0ee] = obj[$221ed54ac1c24a81$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($221ed54ac1c24a81$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $221ed54ac1c24a81$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $221ed54ac1c24a81$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$221ed54ac1c24a81$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $221ed54ac1c24a81$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $221ed54ac1c24a81$var$latest(this[$221ed54ac1c24a81$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $221ed54ac1c24a81$var$latest(this[$221ed54ac1c24a81$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$221ed54ac1c24a81$var$latest(state).has(key) || $221ed54ac1c24a81$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $221ed54ac1c24a81$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $221ed54ac1c24a81$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($221ed54ac1c24a81$var$latest(state).size) {
                prepareMapCopy(state);
                $221ed54ac1c24a81$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $221ed54ac1c24a81$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            $221ed54ac1c24a81$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $221ed54ac1c24a81$var$latest(state).get(key);
            if (state.finalized_ || !$221ed54ac1c24a81$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $221ed54ac1c24a81$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $221ed54ac1c24a81$var$latest(this[$221ed54ac1c24a81$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($221ed54ac1c24a81$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$221ed54ac1c24a81$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $221ed54ac1c24a81$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $221ed54ac1c24a81$var$latest(this[$221ed54ac1c24a81$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $221ed54ac1c24a81$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $221ed54ac1c24a81$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($221ed54ac1c24a81$var$latest(state).size) {
                prepareSetCopy(state);
                $221ed54ac1c24a81$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$221ed54ac1c24a81$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($221ed54ac1c24a81$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($221ed54ac1c24a81$export$16e3aed3edb85946(value)) {
                    const draft = $221ed54ac1c24a81$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $221ed54ac1c24a81$var$die(3, JSON.stringify($221ed54ac1c24a81$var$latest(state)));
    }
    $221ed54ac1c24a81$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $221ed54ac1c24a81$var$immer = new $221ed54ac1c24a81$export$aaadc6ff0f822719();
var $221ed54ac1c24a81$export$b46cabe22e78bc00 = $221ed54ac1c24a81$var$immer.produce;
var $221ed54ac1c24a81$export$4da66d41c9492c78 = $221ed54ac1c24a81$var$immer.produceWithPatches.bind($221ed54ac1c24a81$var$immer);
var $221ed54ac1c24a81$export$573f26f60825c493 = $221ed54ac1c24a81$var$immer.setAutoFreeze.bind($221ed54ac1c24a81$var$immer);
var $221ed54ac1c24a81$export$333ce65961cbe047 = $221ed54ac1c24a81$var$immer.setUseStrictShallowCopy.bind($221ed54ac1c24a81$var$immer);
var $221ed54ac1c24a81$export$a8b8e03e6bbe5473 = $221ed54ac1c24a81$var$immer.applyPatches.bind($221ed54ac1c24a81$var$immer);
var $221ed54ac1c24a81$export$3c3214997190395f = $221ed54ac1c24a81$var$immer.createDraft.bind($221ed54ac1c24a81$var$immer);
var $221ed54ac1c24a81$export$c60f5e69c521b528 = $221ed54ac1c24a81$var$immer.finishDraft.bind($221ed54ac1c24a81$var$immer);
function $221ed54ac1c24a81$export$c05b21e3257751e5(value) {
    return value;
}
function $221ed54ac1c24a81$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("rsltX", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", function () { return $0528828dfd93e500$export$8402dc26d96f6902; });
$parcel$export(module.exports, "createSelectorCreator", function () { return $0528828dfd93e500$export$5943f4447f6ef248; });
var $0528828dfd93e500$var$__defProp = Object.defineProperty;
var $0528828dfd93e500$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0528828dfd93e500$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0528828dfd93e500$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0528828dfd93e500$var$__defNormalProp = (obj, key, value)=>key in obj ? $0528828dfd93e500$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0528828dfd93e500$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0528828dfd93e500$var$__hasOwnProp.call(b, prop)) $0528828dfd93e500$var$__defNormalProp(a, prop, b[prop]);
    if ($0528828dfd93e500$var$__getOwnPropSymbols) {
        for (var prop of $0528828dfd93e500$var$__getOwnPropSymbols(b))if ($0528828dfd93e500$var$__propIsEnum.call(b, prop)) $0528828dfd93e500$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0528828dfd93e500$var$__publicField = (obj, key, value)=>{
    $0528828dfd93e500$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $0528828dfd93e500$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $0528828dfd93e500$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $0528828dfd93e500$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $0528828dfd93e500$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($0528828dfd93e500$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $0528828dfd93e500$var$NOT_FOUND = "NOT_FOUND";
function $0528828dfd93e500$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $0528828dfd93e500$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $0528828dfd93e500$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $0528828dfd93e500$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $0528828dfd93e500$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $0528828dfd93e500$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $0528828dfd93e500$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $0528828dfd93e500$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $0528828dfd93e500$var$__spreadValues($0528828dfd93e500$var$__spreadValues({}, $0528828dfd93e500$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $0528828dfd93e500$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $0528828dfd93e500$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $0528828dfd93e500$var$$REVISION = 0;
var $0528828dfd93e500$var$CURRENT_TRACKER = null;
var $0528828dfd93e500$var$Cell = class {
    constructor(initialValue, isEqual = $0528828dfd93e500$var$tripleEq){
        $0528828dfd93e500$var$__publicField(this, "revision", $0528828dfd93e500$var$$REVISION);
        $0528828dfd93e500$var$__publicField(this, "_value");
        $0528828dfd93e500$var$__publicField(this, "_lastValue");
        $0528828dfd93e500$var$__publicField(this, "_isEqual", $0528828dfd93e500$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $0528828dfd93e500$var$CURRENT_TRACKER == null || $0528828dfd93e500$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$0528828dfd93e500$var$$REVISION;
    }
};
function $0528828dfd93e500$var$tripleEq(a, b) {
    return a === b;
}
var $0528828dfd93e500$var$TrackingCache = class {
    constructor(fn){
        $0528828dfd93e500$var$__publicField(this, "_cachedValue");
        $0528828dfd93e500$var$__publicField(this, "_cachedRevision", -1);
        $0528828dfd93e500$var$__publicField(this, "_deps", []);
        $0528828dfd93e500$var$__publicField(this, "hits", 0);
        $0528828dfd93e500$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $0528828dfd93e500$var$CURRENT_TRACKER;
            $0528828dfd93e500$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $0528828dfd93e500$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $0528828dfd93e500$var$CURRENT_TRACKER == null || $0528828dfd93e500$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $0528828dfd93e500$var$getValue(cell) {
    if (!(cell instanceof $0528828dfd93e500$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $0528828dfd93e500$var$setValue(storage, value) {
    if (!(storage instanceof $0528828dfd93e500$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $0528828dfd93e500$var$createCell(initialValue, isEqual = $0528828dfd93e500$var$tripleEq) {
    return new $0528828dfd93e500$var$Cell(initialValue, isEqual);
}
function $0528828dfd93e500$var$createCache(fn) {
    $0528828dfd93e500$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $0528828dfd93e500$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $0528828dfd93e500$var$neverEq = (a, b)=>false;
function $0528828dfd93e500$var$createTag() {
    return $0528828dfd93e500$var$createCell(null, $0528828dfd93e500$var$neverEq);
}
function $0528828dfd93e500$var$dirtyTag(tag, value) {
    $0528828dfd93e500$var$setValue(tag, value);
}
var $0528828dfd93e500$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $0528828dfd93e500$var$createTag();
    $0528828dfd93e500$var$getValue(tag);
};
var $0528828dfd93e500$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $0528828dfd93e500$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $0528828dfd93e500$var$REDUX_PROXY_LABEL = Symbol();
var $0528828dfd93e500$var$nextId = 0;
var $0528828dfd93e500$var$proto = Object.getPrototypeOf({});
var $0528828dfd93e500$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $0528828dfd93e500$var$__publicField(this, "proxy", new Proxy(this, $0528828dfd93e500$var$objectProxyHandler));
        $0528828dfd93e500$var$__publicField(this, "tag", $0528828dfd93e500$var$createTag());
        $0528828dfd93e500$var$__publicField(this, "tags", {});
        $0528828dfd93e500$var$__publicField(this, "children", {});
        $0528828dfd93e500$var$__publicField(this, "collectionTag", null);
        $0528828dfd93e500$var$__publicField(this, "id", $0528828dfd93e500$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $0528828dfd93e500$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $0528828dfd93e500$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $0528828dfd93e500$var$createNode(childValue);
                if (childNode.tag) $0528828dfd93e500$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $0528828dfd93e500$var$createTag();
                    tag.value = childValue;
                }
                $0528828dfd93e500$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $0528828dfd93e500$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $0528828dfd93e500$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $0528828dfd93e500$var$__publicField(this, "proxy", new Proxy([
            this
        ], $0528828dfd93e500$var$arrayProxyHandler));
        $0528828dfd93e500$var$__publicField(this, "tag", $0528828dfd93e500$var$createTag());
        $0528828dfd93e500$var$__publicField(this, "tags", {});
        $0528828dfd93e500$var$__publicField(this, "children", {});
        $0528828dfd93e500$var$__publicField(this, "collectionTag", null);
        $0528828dfd93e500$var$__publicField(this, "id", $0528828dfd93e500$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $0528828dfd93e500$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $0528828dfd93e500$var$consumeCollection(node);
        return $0528828dfd93e500$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $0528828dfd93e500$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $0528828dfd93e500$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $0528828dfd93e500$var$objectProxyHandler.has(node, prop);
    }
};
function $0528828dfd93e500$var$createNode(value) {
    if (Array.isArray(value)) return new $0528828dfd93e500$var$ArrayTreeNode(value);
    return new $0528828dfd93e500$var$ObjectTreeNode(value);
}
function $0528828dfd93e500$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $0528828dfd93e500$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $0528828dfd93e500$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $0528828dfd93e500$var$dirtyCollection(node);
            $0528828dfd93e500$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $0528828dfd93e500$var$updateNode(childNode, newChildValue);
        else {
            $0528828dfd93e500$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $0528828dfd93e500$var$deleteNode(node) {
    if (node.tag) $0528828dfd93e500$var$dirtyTag(node.tag, null);
    $0528828dfd93e500$var$dirtyCollection(node);
    for(const key in node.tags)$0528828dfd93e500$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$0528828dfd93e500$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $0528828dfd93e500$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $0528828dfd93e500$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $0528828dfd93e500$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $0528828dfd93e500$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $0528828dfd93e500$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $0528828dfd93e500$export$3f025202a230c6dd = (a, b)=>a === b;
function $0528828dfd93e500$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $0528828dfd93e500$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $0528828dfd93e500$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $0528828dfd93e500$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $0528828dfd93e500$var$createSingletonCache(comparator) : $0528828dfd93e500$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $0528828dfd93e500$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $0528828dfd93e500$export$c8f9cf88d9fdee55(func) {
    const node = $0528828dfd93e500$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $0528828dfd93e500$var$createCacheKeyComparator($0528828dfd93e500$export$3f025202a230c6dd);
    const cache = $0528828dfd93e500$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $0528828dfd93e500$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $0528828dfd93e500$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $0528828dfd93e500$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $0528828dfd93e500$var$StrongRef;
var $0528828dfd93e500$var$UNTERMINATED = 0;
var $0528828dfd93e500$var$TERMINATED = 1;
function $0528828dfd93e500$var$createCacheNode() {
    return {
        s: $0528828dfd93e500$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $0528828dfd93e500$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $0528828dfd93e500$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $0528828dfd93e500$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $0528828dfd93e500$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $0528828dfd93e500$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $0528828dfd93e500$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $0528828dfd93e500$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $0528828dfd93e500$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $0528828dfd93e500$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $0528828dfd93e500$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $0528828dfd93e500$var$__spreadValues($0528828dfd93e500$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $0528828dfd93e500$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $0528828dfd93e500$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $0528828dfd93e500$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $0528828dfd93e500$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $0528828dfd93e500$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $0528828dfd93e500$export$595d22ed68ca2841 = /* @__PURE__ */ $0528828dfd93e500$export$5943f4447f6ef248($0528828dfd93e500$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $0528828dfd93e500$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $0528828dfd93e500$export$595d22ed68ca2841)=>{
    $0528828dfd93e500$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$0528828dfd93e500$export$75979cfcd91bf38f
});

});

parcelRegister("hULef", function(module, exports) {

$parcel$export(module.exports, "thunk", function () { return $d0ac4d430f624e37$export$dd164f5517779f15; });
$parcel$export(module.exports, "withExtraArgument", function () { return $d0ac4d430f624e37$export$16d06542a1949d9e; });
// src/index.ts
function $d0ac4d430f624e37$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $d0ac4d430f624e37$export$dd164f5517779f15 = $d0ac4d430f624e37$var$createThunkMiddleware();
var $d0ac4d430f624e37$export$16d06542a1949d9e = $d0ac4d430f624e37$var$createThunkMiddleware;

});




parcelRegister("bHI1v", function(module, exports) {

$parcel$export(module.exports, "AuthJoinModal", function () { return (parcelRequire("jD4eB")).AuthJoinModal; });
$parcel$export(module.exports, "AuthLoginModal", function () { return (parcelRequire("29ZPY")).AuthLoginModal; });
$parcel$export(module.exports, "AuthResetModal", function () { return (parcelRequire("2hGWo")).AuthResetModal; });
$parcel$export(module.exports, "AuthSignupModal", function () { return (parcelRequire("3Veob")).AuthSignupModal; });
$parcel$export(module.exports, "AuthVerificationModal", function () { return (parcelRequire("dl1JL")).AuthVerificationModal; });
parcelRequire("aJwJX");
var $jD4eB = parcelRequire("jD4eB");
var $29ZPY = parcelRequire("29ZPY");
var $2hGWo = parcelRequire("2hGWo");
var $3Veob = parcelRequire("3Veob");
var $dl1JL = parcelRequire("dl1JL");

var $9HBOX = parcelRequire("9HBOX");

var $gHHUR = parcelRequire("gHHUR");
$parcel$exportWildcard(module.exports, $9HBOX);
$parcel$exportWildcard(module.exports, $gHHUR);

});
parcelRegister("aJwJX", function(module, exports) {

$parcel$export(module.exports, "AuthJoinModal", function () { return (parcelRequire("jD4eB")).AuthJoinModal; });
$parcel$export(module.exports, "AuthLoginModal", function () { return (parcelRequire("29ZPY")).AuthLoginModal; });
$parcel$export(module.exports, "AuthResetModal", function () { return (parcelRequire("2hGWo")).AuthResetModal; });
$parcel$export(module.exports, "AuthSignupModal", function () { return (parcelRequire("3Veob")).AuthSignupModal; });
$parcel$export(module.exports, "AuthVerificationModal", function () { return (parcelRequire("dl1JL")).AuthVerificationModal; });

var $jD4eB = parcelRequire("jD4eB");
parcelRequire("11p3j");
var $29ZPY = parcelRequire("29ZPY");
var $2hGWo = parcelRequire("2hGWo");
var $3Veob = parcelRequire("3Veob");
var $dl1JL = parcelRequire("dl1JL");

});
parcelRegister("jD4eB", function(module, exports) {

$parcel$export(module.exports, "AuthJoinModal", function () { return $caea9faf6f1bde2b$export$8661dd77ba90024c; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("3dg1C");
var $dge5L = parcelRequire("dge5L");
var $iEiFm = parcelRequire("iEiFm");

var $7nicT = parcelRequire("7nicT");
const $caea9faf6f1bde2b$export$8661dd77ba90024c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const joinModalOpen = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectJoinModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $7nicT.styles)().modal.main,
        children: joinModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $9HBOX.authCloseJoinModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $7nicT.styles)().modal.content,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $dge5L.ModalCard), {
                        onCloseClick: ()=>dispatch((0, $9HBOX.authCloseJoinModal)()),
                        onSignupClick: ()=>{
                            dispatch((0, $9HBOX.authCloseJoinModal)());
                            dispatch((0, $9HBOX.authOpenSignupModal)());
                        },
                        onLoginClick: ()=>{
                            dispatch((0, $9HBOX.authCloseJoinModal)());
                            dispatch((0, $9HBOX.authOpenLoginModal)());
                        }
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $iEiFm.ModalFooterDesktop), {
                        onCloseClick: ()=>dispatch((0, $9HBOX.authCloseJoinModal)())
                    })
                ]
            })
        })
    });
};
$caea9faf6f1bde2b$export$8661dd77ba90024c.propTypes = {};

});
parcelRegister("1TdPt", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return (parcelRequire("7y6mB")).Badge; });
$parcel$export(module.exports, "BadgeSelected", function () { return (parcelRequire("9HR7l")).BadgeSelected; });
$parcel$export(module.exports, "ButtonLarge", function () { return (parcelRequire("dB5kz")).ButtonLarge; });
$parcel$export(module.exports, "ButtonMedium", function () { return (parcelRequire("iGKn1")).ButtonMedium; });
$parcel$export(module.exports, "ButtonRound", function () { return (parcelRequire("lIoWX")).ButtonRound; });
$parcel$export(module.exports, "ButtonSmall", function () { return (parcelRequire("l7e6s")).ButtonSmall; });
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("eJNPy")).Checkbox; });
$parcel$export(module.exports, "CheckboxOption", function () { return (parcelRequire("95KdT")).CheckboxOption; });
$parcel$export(module.exports, "ContentHeader", function () { return (parcelRequire("9tYNN")).ContentHeader; });
$parcel$export(module.exports, "ContentPlaceholder", function () { return (parcelRequire("4sGtG")).ContentPlaceholder; });
$parcel$export(module.exports, "Divider", function () { return (parcelRequire("kXKXY")).Divider; });
$parcel$export(module.exports, "Error", function () { return (parcelRequire("ly71s")).Error; });
$parcel$export(module.exports, "InputAmount", function () { return (parcelRequire("9jZXY")).InputAmount; });
$parcel$export(module.exports, "InputArea", function () { return (parcelRequire("eOdZ3")).InputArea; });
$parcel$export(module.exports, "InputBar", function () { return (parcelRequire("gW5Rq")).InputBar; });
$parcel$export(module.exports, "InputDescription", function () { return (parcelRequire("7NUoN")).InputDescription; });
$parcel$export(module.exports, "InputLabel", function () { return (parcelRequire("13cuy")).InputLabel; });
$parcel$export(module.exports, "InputLine", function () { return (parcelRequire("6F2CE")).InputLine; });
$parcel$export(module.exports, "InputSelect", function () { return (parcelRequire("k1nII")).InputSelect; });
$parcel$export(module.exports, "Loader", function () { return (parcelRequire("f6nZ0")).Loader; });
$parcel$export(module.exports, "MediaFilePreview", function () { return (parcelRequire("81gWx")).MediaFilePreview; });
$parcel$export(module.exports, "ModalCardSubtitle", function () { return (parcelRequire("57kXZ")).ModalCardSubtitle; });
$parcel$export(module.exports, "ModalCardTitle", function () { return (parcelRequire("6GhGJ")).ModalCardTitle; });
$parcel$export(module.exports, "NavigationScrollable", function () { return (parcelRequire("curqj")).NavigationScrollable; });
$parcel$export(module.exports, "SkeletonHorizontal", function () { return (parcelRequire("42mKz")).SkeletonHorizontal; });
$parcel$export(module.exports, "SkeletonVertical", function () { return (parcelRequire("r5GD9")).SkeletonVertical; });
$parcel$export(module.exports, "Stepper", function () { return (parcelRequire("bl2nZ")).Stepper; });
$parcel$export(module.exports, "Subtitle", function () { return (parcelRequire("2oiNd")).Subtitle; });
$parcel$export(module.exports, "ErrorFallback", function () { return (parcelRequire("2uUr9")).ErrorFallback; });
$parcel$export(module.exports, "SuspenseContentFallback", function () { return (parcelRequire("6aEHC")).SuspenseContentFallback; });
$parcel$export(module.exports, "SuspenseMainFallback", function () { return (parcelRequire("kb0tL")).SuspenseMainFallback; });
$parcel$export(module.exports, "AppLayout", function () { return (parcelRequire("3YnFc")).AppLayout; });
$parcel$export(module.exports, "ContentContainer", function () { return (parcelRequire("gnTra")).ContentContainer; });
$parcel$export(module.exports, "ContentLayoutVirtualized", function () { return (parcelRequire("2xDls")).ContentLayoutVirtualized; });
$parcel$export(module.exports, "MainLayout", function () { return (parcelRequire("8BwiX")).MainLayout; });
$parcel$export(module.exports, "ModalLayout", function () { return (parcelRequire("e1re8")).ModalLayout; });
$parcel$export(module.exports, "SectionsLayout", function () { return (parcelRequire("d6xWB")).SectionsLayout; });
$parcel$export(module.exports, "AppHeader", function () { return (parcelRequire("dqVAo")).AppHeader; });
$parcel$export(module.exports, "CardHeaderMobile", function () { return (parcelRequire("1NE1d")).CardHeaderMobile; });
$parcel$export(module.exports, "ImageComposition", function () { return (parcelRequire("fTvbo")).ImageComposition; });
parcelRequire("6zyzi");
var $7y6mB = parcelRequire("7y6mB");
var $9HR7l = parcelRequire("9HR7l");
var $dB5kz = parcelRequire("dB5kz");
var $iGKn1 = parcelRequire("iGKn1");
var $lIoWX = parcelRequire("lIoWX");
var $l7e6s = parcelRequire("l7e6s");
var $eJNPy = parcelRequire("eJNPy");
var $95KdT = parcelRequire("95KdT");
var $9tYNN = parcelRequire("9tYNN");
var $4sGtG = parcelRequire("4sGtG");
var $kXKXY = parcelRequire("kXKXY");
var $ly71s = parcelRequire("ly71s");
var $9jZXY = parcelRequire("9jZXY");
var $eOdZ3 = parcelRequire("eOdZ3");
var $gW5Rq = parcelRequire("gW5Rq");
var $7NUoN = parcelRequire("7NUoN");
var $13cuy = parcelRequire("13cuy");
var $6F2CE = parcelRequire("6F2CE");
var $k1nII = parcelRequire("k1nII");
var $f6nZ0 = parcelRequire("f6nZ0");
var $81gWx = parcelRequire("81gWx");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
var $curqj = parcelRequire("curqj");
var $42mKz = parcelRequire("42mKz");
var $r5GD9 = parcelRequire("r5GD9");
var $bl2nZ = parcelRequire("bl2nZ");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("jvUFX");
var $2uUr9 = parcelRequire("2uUr9");
var $6aEHC = parcelRequire("6aEHC");
var $kb0tL = parcelRequire("kb0tL");
parcelRequire("9TlX5");
var $3YnFc = parcelRequire("3YnFc");
var $gnTra = parcelRequire("gnTra");
var $2xDls = parcelRequire("2xDls");
var $8BwiX = parcelRequire("8BwiX");
var $e1re8 = parcelRequire("e1re8");
var $d6xWB = parcelRequire("d6xWB");
parcelRequire("6waMo");
var $dqVAo = parcelRequire("dqVAo");
var $1NE1d = parcelRequire("1NE1d");
var $fTvbo = parcelRequire("fTvbo");

});
parcelRegister("6zyzi", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return (parcelRequire("7y6mB")).Badge; });
$parcel$export(module.exports, "BadgeSelected", function () { return (parcelRequire("9HR7l")).BadgeSelected; });
$parcel$export(module.exports, "ButtonLarge", function () { return (parcelRequire("dB5kz")).ButtonLarge; });
$parcel$export(module.exports, "ButtonMedium", function () { return (parcelRequire("iGKn1")).ButtonMedium; });
$parcel$export(module.exports, "ButtonRound", function () { return (parcelRequire("lIoWX")).ButtonRound; });
$parcel$export(module.exports, "ButtonSmall", function () { return (parcelRequire("l7e6s")).ButtonSmall; });
$parcel$export(module.exports, "Checkbox", function () { return (parcelRequire("eJNPy")).Checkbox; });
$parcel$export(module.exports, "CheckboxOption", function () { return (parcelRequire("95KdT")).CheckboxOption; });
$parcel$export(module.exports, "ContentHeader", function () { return (parcelRequire("9tYNN")).ContentHeader; });
$parcel$export(module.exports, "ContentPlaceholder", function () { return (parcelRequire("4sGtG")).ContentPlaceholder; });
$parcel$export(module.exports, "Divider", function () { return (parcelRequire("kXKXY")).Divider; });
$parcel$export(module.exports, "Error", function () { return (parcelRequire("ly71s")).Error; });
$parcel$export(module.exports, "InputAmount", function () { return (parcelRequire("9jZXY")).InputAmount; });
$parcel$export(module.exports, "InputArea", function () { return (parcelRequire("eOdZ3")).InputArea; });
$parcel$export(module.exports, "InputBar", function () { return (parcelRequire("gW5Rq")).InputBar; });
$parcel$export(module.exports, "InputDescription", function () { return (parcelRequire("7NUoN")).InputDescription; });
$parcel$export(module.exports, "InputLabel", function () { return (parcelRequire("13cuy")).InputLabel; });
$parcel$export(module.exports, "InputLine", function () { return (parcelRequire("6F2CE")).InputLine; });
$parcel$export(module.exports, "InputSelect", function () { return (parcelRequire("k1nII")).InputSelect; });
$parcel$export(module.exports, "Loader", function () { return (parcelRequire("f6nZ0")).Loader; });
$parcel$export(module.exports, "MediaFilePreview", function () { return (parcelRequire("81gWx")).MediaFilePreview; });
$parcel$export(module.exports, "ModalCardSubtitle", function () { return (parcelRequire("57kXZ")).ModalCardSubtitle; });
$parcel$export(module.exports, "ModalCardTitle", function () { return (parcelRequire("6GhGJ")).ModalCardTitle; });
$parcel$export(module.exports, "NavigationScrollable", function () { return (parcelRequire("curqj")).NavigationScrollable; });
$parcel$export(module.exports, "Stepper", function () { return (parcelRequire("bl2nZ")).Stepper; });
$parcel$export(module.exports, "SkeletonHorizontal", function () { return (parcelRequire("42mKz")).SkeletonHorizontal; });
$parcel$export(module.exports, "SkeletonVertical", function () { return (parcelRequire("r5GD9")).SkeletonVertical; });
$parcel$export(module.exports, "Subtitle", function () { return (parcelRequire("2oiNd")).Subtitle; });

var $7y6mB = parcelRequire("7y6mB");

var $9HR7l = parcelRequire("9HR7l");

var $dB5kz = parcelRequire("dB5kz");

var $iGKn1 = parcelRequire("iGKn1");

var $lIoWX = parcelRequire("lIoWX");

var $l7e6s = parcelRequire("l7e6s");

var $eJNPy = parcelRequire("eJNPy");

var $95KdT = parcelRequire("95KdT");

var $9tYNN = parcelRequire("9tYNN");

var $4sGtG = parcelRequire("4sGtG");

var $kXKXY = parcelRequire("kXKXY");

var $ly71s = parcelRequire("ly71s");

var $9jZXY = parcelRequire("9jZXY");

var $eOdZ3 = parcelRequire("eOdZ3");

var $gW5Rq = parcelRequire("gW5Rq");

var $7NUoN = parcelRequire("7NUoN");

var $13cuy = parcelRequire("13cuy");

var $6F2CE = parcelRequire("6F2CE");

var $k1nII = parcelRequire("k1nII");

var $f6nZ0 = parcelRequire("f6nZ0");

var $81gWx = parcelRequire("81gWx");

var $57kXZ = parcelRequire("57kXZ");

var $6GhGJ = parcelRequire("6GhGJ");

var $curqj = parcelRequire("curqj");

var $bl2nZ = parcelRequire("bl2nZ");

var $42mKz = parcelRequire("42mKz");

var $r5GD9 = parcelRequire("r5GD9");

var $2oiNd = parcelRequire("2oiNd");

});
parcelRegister("7y6mB", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return $3dff0a4ac86faa33$export$37acb3580601e69a; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $5hwTf = parcelRequire("5hwTf");
const $3dff0a4ac86faa33$export$37acb3580601e69a = ({ name: name, disabled: disabled, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5hwTf.styles)(theme).badge.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
            css: [
                (0, $5hwTf.styles)(theme).badge.button.shared,
                disabled ? (0, $5hwTf.styles)(theme).badge.button.disabled : (0, $5hwTf.styles)(theme).badge.button.enabled,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            disabled: disabled,
            type: "button",
            "aria-label": "log out",
            children: name
        })
    });
};
$3dff0a4ac86faa33$export$37acb3580601e69a.propTypes = {};

});
parcelRegister("5hwTf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2b1b3f327d1f8431$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $2b1b3f327d1f8431$export$9dd6ff9ea0189349 = (theme)=>({
        badge: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;height:24px;background-color:", theme.colors.primary.normal, ";", ""),
            button: {
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-size:", (0, $gln0L.typography).p, ";transition:color 0.2s;", ""),
                enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;color:", theme.colors.secondary.dark, ";&:hover{color:", theme.colors.secondary.dark, ";}", "")
            }
        }
    });

});


parcelRegister("9HR7l", function(module, exports) {

$parcel$export(module.exports, "BadgeSelected", function () { return $26238752fad6fd23$export$f260e5b9211df663; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $efW5I = parcelRequire("efW5I");
const $26238752fad6fd23$export$f260e5b9211df663 = ({ name: name, onRemoveClick: onRemoveClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $efW5I.styles)(theme).badge.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $efW5I.styles)(theme).badge.close.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $efW5I.styles)(theme).badge.close.button,
                    onClick: (e)=>onRemoveClick(e),
                    type: "button",
                    "aria-label": "log out",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CrossCircle, {
                        css: (0, $efW5I.styles)(theme).badge.close.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $efW5I.styles)(theme).badge.name,
                children: name
            })
        ]
    });
};
$26238752fad6fd23$export$f260e5b9211df663.propTypes = {};

});
parcelRegister("efW5I", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $64f8474581d076b3$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $64f8474581d076b3$export$9dd6ff9ea0189349 = (theme)=>({
        badge: {
            main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;height:32px;border-radius:20px;padding:0px 32px;background-color:", theme.colors.accent.normal, ";", ""),
            close: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.user.card.selectedGenre.close, ";position:absolute;right:0;top:-30%;display:flex;width:24px;height:24px;background-color:", theme.colors.primary.normal, ";border-radius:50%;", ""),
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:24px;height:24px;cursor:pointer;", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:18px;height:18px;&>path{fill:", theme.colors.accent.normal, ";}", "")
            },
            name: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";font-weight:bold;color:", theme.colors.primary.normal, ";", "")
        }
    });

});


parcelRegister("dB5kz", function(module, exports) {

$parcel$export(module.exports, "ButtonLarge", function () { return $b2ac6881a1737b02$export$1bd2585f926208da; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $4yyDR = parcelRequire("4yyDR");
const $b2ac6881a1737b02$export$1bd2585f926208da = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("button", {
        css: [
            (0, $4yyDR.styles)(theme).button.main,
            appearance === "primary" && (0, $4yyDR.styles)(theme).button.primary,
            appearance === "secondary" && (0, $4yyDR.styles)(theme).button.secondary,
            attributes.disabled && (0, $4yyDR.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $4yyDR.styles)(theme).button.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $4yyDR.styles)(theme).button.content.children,
                children: children
            })
        })
    });
};
$b2ac6881a1737b02$export$1bd2585f926208da.propTypes = {};

});
parcelRegister("4yyDR", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $05929b68efcc9cbb$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $05929b68efcc9cbb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $05929b68efcc9cbb$var$_ref = {
    name: "16lvhbt",
    styles: "display:flex;justify-content:center;width:100%;min-width:0"
};
var $05929b68efcc9cbb$var$_ref2 = {
    name: "rg7b1m",
    styles: "padding:8px 26px;height:46px"
};
var $05929b68efcc9cbb$var$_ref3 = {
    name: "452cf2",
    styles: "height:52px"
};
const $05929b68efcc9cbb$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;white-space:nowrap;border-radius:20px;padding:14px 32px;height:56px;width:100%;overflow:hidden;transition:color 0.2s,background-color 0.2s;min-width:0;", (0, $gln0L.mq).tablet($05929b68efcc9cbb$var$_ref3), " ", (0, $gln0L.mq).mobile($05929b68efcc9cbb$var$_ref2), ";", ""),
            primary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{background-color:", theme.colors.accent.normalHover, ";}", ""),
            secondary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";background-color:", theme.colors.primary.normal, ";&:hover{background-color:", theme.colors.primary.normalHover, ";}", ""),
            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;color:", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.dark, ";&:hover{background-color:", theme.colors.secondary.dark, ";}", ""),
            content: {
                main: $05929b68efcc9cbb$var$_ref,
                children: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});


parcelRegister("iGKn1", function(module, exports) {

$parcel$export(module.exports, "ButtonMedium", function () { return $52a52958ded04a80$export$32edac2c0f3b2a9a; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $azpCr = parcelRequire("azpCr");
const $52a52958ded04a80$export$32edac2c0f3b2a9a = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("button", {
        css: [
            (0, $azpCr.styles)(theme).button.main,
            appearance === "primary" && (0, $azpCr.styles)(theme).button.primary,
            appearance === "secondary" && (0, $azpCr.styles)(theme).button.secondary,
            attributes.disabled && (0, $azpCr.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $azpCr.styles)(theme).button.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $azpCr.styles)(theme).button.content.children,
                children: children
            })
        })
    });
};
$52a52958ded04a80$export$32edac2c0f3b2a9a.propTypes = {};

});
parcelRegister("azpCr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3d173464458c4c9b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $3d173464458c4c9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3d173464458c4c9b$var$_ref = {
    name: "16lvhbt",
    styles: "display:flex;justify-content:center;width:100%;min-width:0"
};
const $3d173464458c4c9b$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;padding:12px 36px;height:44px;width:100%;overflow:hidden;transition:color 0.2s,background-color 0.2s,border 0.2s;min-width:0;& svg>path{transition:fill 0.2s,color 0.2s;}", ""),
            primary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";& svg>path{fill:", theme.colors.primary.normal, ";}&:hover{color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normalHover, ";& svg>path{fill:", theme.colors.primary.normal, ";}}", ""),
            secondary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.secondary.normal, ";& svg>path{fill:", theme.colors.secondary.normal, ";}&:hover{color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";& svg>path{fill:", theme.colors.accent.normal, ";}}", ""),
            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;color:", theme.colors.secondary.dark, ";background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.secondary.dark, ";& svg>path{fill:", theme.colors.secondary.dark, ";}&:hover{color:", theme.colors.secondary.dark, ";border:1px solid ", theme.colors.secondary.dark, ";background-color:", theme.colors.primary.normal, ";& svg>path{fill:", theme.colors.secondary.dark, ";}}", ""),
            content: {
                main: $3d173464458c4c9b$var$_ref,
                children: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});


parcelRegister("lIoWX", function(module, exports) {

$parcel$export(module.exports, "ButtonRound", function () { return $9e696167a2e6dd25$export$6c486db588432ce2; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $bvXtU = parcelRequire("bvXtU");
const $9e696167a2e6dd25$export$6c486db588432ce2 = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("button", {
        css: [
            (0, $bvXtU.styles)(theme).button.main,
            appearance === "primary" && (0, $bvXtU.styles)(theme).button.primary,
            appearance === "secondary" && (0, $bvXtU.styles)(theme).button.secondary,
            attributes.disabled && (0, $bvXtU.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $bvXtU.styles)(theme).button.content,
            children: children
        })
    });
};
$9e696167a2e6dd25$export$6c486db588432ce2.propTypes = {};

});
parcelRegister("bvXtU", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8fe93688d86ffef1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $8fe93688d86ffef1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8fe93688d86ffef1$var$_ref = {
    name: "1wnowod",
    styles: "display:flex;align-items:center;justify-content:center"
};
var $8fe93688d86ffef1$var$_ref2 = {
    name: "ypnlzr",
    styles: "width:50px;height:50px"
};
const $8fe93688d86ffef1$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;white-space:nowrap;border-radius:50%;overflow:hidden;width:60px;height:60px;transition:color 0.2s,background-color 0.2s;", (0, $gln0L.mq).mobile($8fe93688d86ffef1$var$_ref2), ";", ""),
            primary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{background-color:", theme.colors.accent.normalHover, ";}", ""),
            secondary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";background-color:", theme.colors.primary.normal, ";&:hover{background-color:", theme.colors.primary.normalHover, ";}", ""),
            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;color:", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.dark, ";&:hover{background-color:", theme.colors.secondary.dark, ";}", ""),
            content: $8fe93688d86ffef1$var$_ref
        }
    });

});


parcelRegister("l7e6s", function(module, exports) {

$parcel$export(module.exports, "ButtonSmall", function () { return $74b41514a449892c$export$80dfd3a1a7d0749e; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $Hg6ih = parcelRequire("Hg6ih");
const $74b41514a449892c$export$80dfd3a1a7d0749e = ({ appearance: appearance = "primary", children: children, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("button", {
        css: [
            (0, $Hg6ih.styles)(theme).button.shared,
            appearance === "primary" && (0, $Hg6ih.styles)(theme).button.primary,
            appearance === "secondary" && (0, $Hg6ih.styles)(theme).button.secondary,
            attributes.disabled && (0, $Hg6ih.styles)(theme).button.disabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: children
    });
};

});
parcelRegister("Hg6ih", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2ea27b06b80b0d73$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $2ea27b06b80b0d73$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:8px 26px;width:100%;transition:border 0.2s,color 0.2s,background-color 0.2s;", ""),
            primary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.accent.normal, ";}", ""),
            secondary: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.secondary.light, ";background-color:", theme.colors.primary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;color:", theme.colors.secondary.darkHover, ";background-color:", theme.colors.secondary.darker, ";&:hover{border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.darker, ";color:", theme.colors.secondary.darkHover, ";}", "")
        }
    });

});


parcelRegister("eJNPy", function(module, exports) {

$parcel$export(module.exports, "Checkbox", function () { return $9f17275ae9406a89$export$48513f6b9f8ce62d; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $2iPvn = parcelRequire("2iPvn");
const $9f17275ae9406a89$export$48513f6b9f8ce62d = ({ name: name, label: label, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $2iPvn.styles)(theme).checkbox.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
            css: (0, $2iPvn.styles)(theme).checkbox.label.main,
            htmlFor: name,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                    css: (0, $2iPvn.styles)(theme).checkbox.input,
                    id: name,
                    ...attributes,
                    type: "checkbox"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: [
                        (0, $2iPvn.styles)(theme).checkbox.label.mark.shared,
                        attributes.checked ? (0, $2iPvn.styles)(theme).checkbox.label.mark.checked : (0, $2iPvn.styles)(theme).checkbox.label.mark.unchecked,
                        "",
                        ""
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: (0, $2iPvn.styles)(theme).checkbox.label.text,
                    children: label
                })
            ]
        })
    });
};
$9f17275ae9406a89$export$48513f6b9f8ce62d.propTypes = {};

});
parcelRegister("2iPvn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ddca343975aa23ed$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $ddca343975aa23ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ddca343975aa23ed$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $ddca343975aa23ed$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
var $ddca343975aa23ed$var$_ref3 = {
    name: "10556yz",
    styles: "display:inline-block;position:relative;width:30px;height:30px;border-radius:8px;cursor:pointer"
};
var $ddca343975aa23ed$var$_ref4 = {
    name: "1h11b77",
    styles: "display:flex;width:30px;height:30px"
};
const $ddca343975aa23ed$export$9dd6ff9ea0189349 = (theme)=>({
        checkbox: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            label: {
                main: $ddca343975aa23ed$var$_ref4,
                mark: {
                    shared: $ddca343975aa23ed$var$_ref3,
                    checked: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";&::after{content:'';position:absolute;left:50%;top:50%;width:8px;height:14px;border:solid ", theme.colors.primary.normal, ";border-width:0 3px 3px 0;transform:translate(-50%,-58%) rotate(45deg);}", ""),
                    unchecked: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.secondary.darkHover, ";", "")
                },
                text: $ddca343975aa23ed$var$_ref2
            },
            input: $ddca343975aa23ed$var$_ref
        }
    });

});


parcelRegister("95KdT", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", function () { return $087bf982788ca108$export$d40cc97ecda916f9; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("1TdPt");
var $eJNPy = parcelRequire("eJNPy");

var $f3bXr = parcelRequire("f3bXr");
const $087bf982788ca108$export$d40cc97ecda916f9 = ({ name: name, description: description, icon: Icon, checked: checked, onCheckboxClick: onCheckboxClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $f3bXr.styles)(theme).option.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $f3bXr.styles)(theme).option.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $f3bXr.styles)(theme).option.data.title.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $f3bXr.styles)(theme).option.data.title.icon,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $f3bXr.styles)(theme).option.data.title.name,
                                children: name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $f3bXr.styles)(theme).option.data.description,
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $f3bXr.styles)(theme).option.checkbox,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eJNPy.Checkbox), {
                    name: name,
                    label: name,
                    checked: checked,
                    onChange: (e)=>onCheckboxClick(e)
                })
            })
        ]
    });
};
$087bf982788ca108$export$d40cc97ecda916f9.propTypes = {};

});
parcelRegister("f3bXr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4f19db883a15d6dc$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4f19db883a15d6dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4f19db883a15d6dc$var$_ref = {
    name: "1rit7pc",
    styles: "margin-right:8px;&>svg{width:26px;height:26px;}"
};
var $4f19db883a15d6dc$var$_ref2 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $4f19db883a15d6dc$var$_ref3 = {
    name: "3ik5jl",
    styles: "display:flex;flex-direction:column;margin-right:auto"
};
var $4f19db883a15d6dc$var$_ref4 = {
    name: "zjik7",
    styles: "display:flex"
};
const $4f19db883a15d6dc$export$9dd6ff9ea0189349 = (theme)=>({
        option: {
            main: $4f19db883a15d6dc$var$_ref4,
            data: {
                main: $4f19db883a15d6dc$var$_ref3,
                title: {
                    main: $4f19db883a15d6dc$var$_ref2,
                    icon: $4f19db883a15d6dc$var$_ref,
                    name: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";font-weight:bold;margin-right:auto;", "")
                },
                description: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
            },
            checkbox: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("9tYNN", function(module, exports) {

$parcel$export(module.exports, "ContentHeader", function () { return $e964ce4d42d23c92$export$b52a1b6380889dfe; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $1APlR = parcelRequire("1APlR");
const $e964ce4d42d23c92$export$b52a1b6380889dfe = ({ text: text, placement: placement = "default" })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("h2", {
        css: [
            (0, $1APlR.styles)(theme).title.text,
            placement === "default" && (0, $1APlR.styles)(theme).title.placement.default,
            placement === "content" && (0, $1APlR.styles)(theme).title.placement.content,
            "",
            ""
        ],
        children: text
    });
};
$e964ce4d42d23c92$export$b52a1b6380889dfe.propTypes = {};

});
parcelRegister("1APlR", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $03118162de26b1f2$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $03118162de26b1f2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $03118162de26b1f2$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $03118162de26b1f2$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";font-weight:bold;color:", theme.colors.secondary.light, ";margin-bottom:0px;", ""),
            placement: {
                default: $03118162de26b1f2$var$_ref,
                content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.content, ";margin-bottom:24px;", "")
            }
        }
    });

});


parcelRegister("4sGtG", function(module, exports) {

$parcel$export(module.exports, "ContentPlaceholder", function () { return $d06a243ca455ed40$export$ae725288d93437df; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $eWTIm = parcelRequire("eWTIm");
const $d06a243ca455ed40$export$ae725288d93437df = ({ title: title, height: height, icon: Icon })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $eWTIm.styles)(theme).placeholder.main(height),
        children: [
            Icon && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eWTIm.styles)(theme).placeholder.icon,
                children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eWTIm.styles)(theme).placeholder.title,
                children: title
            })
        ]
    });
};
$d06a243ca455ed40$export$ae725288d93437df.propTypes = {};

});
parcelRegister("eWTIm", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $41942a60c7dd83ea$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $41942a60c7dd83ea$export$9dd6ff9ea0189349 = (theme)=>({
        placeholder: {
            main: (height)=>/*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:", height, ";", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("margin-bottom:10px;&>svg{width:40px;height:40px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
            title: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";text-align:center;color:", theme.colors.secondary.light, ";", "")
        }
    });

});


parcelRegister("kXKXY", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $b49434f6df3111ae$export$2e0a83ec2e27ecbb; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $5q7KH = parcelRequire("5q7KH");
const $b49434f6df3111ae$export$2e0a83ec2e27ecbb = ({ maxWidth: maxWidth = "", horizontalMargin: horizontalMargin, verticalMargin: verticalMargin })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: [
            (0, $5q7KH.styles)(theme).divider.main,
            maxWidth && (0, $5q7KH.styles)(theme).divider.maxWidth(maxWidth),
            horizontalMargin && (0, $5q7KH.styles)(theme).divider.horizontalMargin(horizontalMargin),
            verticalMargin && (0, $5q7KH.styles)(theme).divider.verticalMargin(verticalMargin),
            "",
            ""
        ]
    });
};
$b49434f6df3111ae$export$2e0a83ec2e27ecbb.propTypes = {};

});
parcelRegister("5q7KH", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ac08ebd8a777de58$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $ac08ebd8a777de58$export$9dd6ff9ea0189349 = (theme)=>({
        divider: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;height:2px;background-color:", theme.colors.secondary.dark, ";", ""),
            maxWidth: (maxWidth)=>/*#__PURE__*/ (0, $7hler.css)("max-width:", maxWidth, ";", ""),
            horizontalMargin: (horizontalMargin)=>/*#__PURE__*/ (0, $7hler.css)("margin-left:", horizontalMargin.left, ";margin-right:", horizontalMargin.right, ";", ""),
            verticalMargin: (verticalMargin)=>/*#__PURE__*/ (0, $7hler.css)("margin-top:", verticalMargin.top, ";margin-bottom:", verticalMargin.bottom, ";", "")
        }
    });

});


parcelRegister("ly71s", function(module, exports) {

$parcel$export(module.exports, "Error", function () { return $d58f2e39e879c3fd$export$edf27be85e5f6da0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $cfdzt = parcelRequire("cfdzt");
const $d58f2e39e879c3fd$export$edf27be85e5f6da0 = ({ error: error })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: [
            (0, $cfdzt.styles)(theme).error.shared,
            error ? (0, $cfdzt.styles)(theme).error.visible : (0, $cfdzt.styles)(theme).error.hidden,
            "",
            ""
        ],
        children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
            css: [
                (0, $cfdzt.styles)(theme).error.text.shared,
                error ? (0, $cfdzt.styles)(theme).error.text.visible : (0, $cfdzt.styles)(theme).error.text.hidden,
                "",
                ""
            ],
            children: error
        })
    });
};
$d58f2e39e879c3fd$export$edf27be85e5f6da0.propTypes = {};

});
parcelRegister("cfdzt", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0bdb46cf28391918$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $0bdb46cf28391918$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0bdb46cf28391918$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $0bdb46cf28391918$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $0bdb46cf28391918$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $0bdb46cf28391918$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $0bdb46cf28391918$var$_ref5 = {
    name: "7wk0r4",
    styles: "display:flex;justify-content:center;min-width:0;transition:height 0.2s"
};
const $0bdb46cf28391918$export$9dd6ff9ea0189349 = (theme)=>({
        error: {
            shared: $0bdb46cf28391918$var$_ref5,
            visible: $0bdb46cf28391918$var$_ref4,
            hidden: $0bdb46cf28391918$var$_ref3,
            text: {
                shared: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.negative.normal, ";text-align:center;transition:opacity 0.4s;", ""),
                visible: $0bdb46cf28391918$var$_ref2,
                hidden: $0bdb46cf28391918$var$_ref
            }
        }
    });

});


parcelRegister("9jZXY", function(module, exports) {

$parcel$export(module.exports, "InputAmount", function () { return $1076cbc2cf1a582a$export$35d22d5200306724; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $lncJN = parcelRequire("lncJN");
const $1076cbc2cf1a582a$export$35d22d5200306724 = ({ name: name, label: label, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $lncJN.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $lncJN.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $lncJN.styles)(theme).input.range.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: attributes.value === attributes.min ? (0, $lncJN.styles)(theme).input.range.min.active : (0, $lncJN.styles)(theme).input.range.min.inactive,
                        children: [
                            "$",
                            attributes.min
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: attributes.value === attributes.max ? (0, $lncJN.styles)(theme).input.range.min.active : (0, $lncJN.styles)(theme).input.range.min.inactive,
                        children: [
                            "$",
                            attributes.max
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lncJN.styles)(theme).input.data.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                    css: (0, $lncJN.styles)(theme).input.data.input,
                    id: name,
                    ...attributes
                })
            })
        ]
    });
};
$1076cbc2cf1a582a$export$35d22d5200306724.propTypes = {};

});
parcelRegister("lncJN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b2297382568b46a8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $b2297382568b46a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b2297382568b46a8$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $b2297382568b46a8$var$_ref2 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $b2297382568b46a8$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $b2297382568b46a8$var$_ref2,
            label: $b2297382568b46a8$var$_ref,
            range: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:space-between;font-size:", (0, $gln0L.typography).h6, ";", ""),
                min: {
                    inactive: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.dark, ";", ""),
                    active: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";font-weight:bold;", "")
                },
                max: {
                    inactive: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.dark, ";", ""),
                    active: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";font-weight:bold;", "")
                }
            },
            data: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                input: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:28px;appearance:none;-webkit-appearance:none;background:transparent;cursor:pointer;&::-webkit-slider-runnable-track{background:", theme.colors.accent.normal, ";height:4px;}&::-moz-range-track{background:", theme.colors.accent.normal, ";height:4px;}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;margin-top:-6px;height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}&::-moz-range-thumb{height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}", "")
            }
        }
    });

});


parcelRegister("eOdZ3", function(module, exports) {

$parcel$export(module.exports, "InputArea", function () { return $45537fb1ed62dc5e$export$2b0b81e3a67b07d2; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $6gUBA = parcelRequire("6gUBA");
const $45537fb1ed62dc5e$export$2b0b81e3a67b07d2 = ({ name: name, label: label, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $6gUBA.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $6gUBA.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $6gUBA.styles)(theme).input.data.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("textarea", {
                    css: [
                        (0, $6gUBA.styles)(theme).input.data.shared,
                        attributes.value ? (0, $6gUBA.styles)(theme).input.data.filled : (0, $6gUBA.styles)(theme).input.data.empty,
                        attributes.disabled && (0, $6gUBA.styles)(theme).input.data.disabled,
                        error && (0, $6gUBA.styles)(theme).input.data.errored,
                        "",
                        ""
                    ],
                    id: name,
                    ...attributes
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $6gUBA.styles)(theme).input.error.shared,
                    errorMessage ? (0, $6gUBA.styles)(theme).input.error.visible : (0, $6gUBA.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: [
                        (0, $6gUBA.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $6gUBA.styles)(theme).input.error.text.visible : (0, $6gUBA.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$45537fb1ed62dc5e$export$2b0b81e3a67b07d2.propTypes = {};

});
parcelRegister("6gUBA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f3e71e70977308c2$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $f3e71e70977308c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f3e71e70977308c2$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $f3e71e70977308c2$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $f3e71e70977308c2$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $f3e71e70977308c2$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $f3e71e70977308c2$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $f3e71e70977308c2$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $f3e71e70977308c2$var$_ref7 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $f3e71e70977308c2$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $f3e71e70977308c2$var$_ref7,
            label: $f3e71e70977308c2$var$_ref6,
            data: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;resize:none;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;transition:border 0.2s;&:focus{border-bottom:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", ""),
                empty: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                filled: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.dark, ";", ""),
                errored: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.negative.normal, ";color:", theme.colors.secondary.normal, ";", "")
            },
            error: {
                shared: $f3e71e70977308c2$var$_ref5,
                visible: $f3e71e70977308c2$var$_ref4,
                hidden: $f3e71e70977308c2$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $f3e71e70977308c2$var$_ref2,
                    hidden: $f3e71e70977308c2$var$_ref
                }
            }
        }
    });

});


parcelRegister("gW5Rq", function(module, exports) {

$parcel$export(module.exports, "InputBar", function () { return $787ae5d1a9d11cf6$export$e1ae4a06dabc4e34; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $1xJI4 = parcelRequire("1xJI4");
const $787ae5d1a9d11cf6$export$e1ae4a06dabc4e34 = ({ name: name, label: label, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $1xJI4.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $1xJI4.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1xJI4.styles)(theme).input.data.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                    css: [
                        (0, $1xJI4.styles)(theme).input.data.shared,
                        attributes.value ? (0, $1xJI4.styles)(theme).input.data.filled : (0, $1xJI4.styles)(theme).input.data.empty,
                        error && (0, $1xJI4.styles)(theme).input.data.errored,
                        "",
                        ""
                    ],
                    id: name,
                    ...attributes
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $1xJI4.styles)(theme).input.error.shared,
                    errorMessage ? (0, $1xJI4.styles)(theme).input.error.visible : (0, $1xJI4.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: [
                        (0, $1xJI4.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $1xJI4.styles)(theme).input.error.text.visible : (0, $1xJI4.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$787ae5d1a9d11cf6$export$e1ae4a06dabc4e34.propTypes = {};

});
parcelRegister("1xJI4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $79aee9b2621a3d3f$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $79aee9b2621a3d3f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $79aee9b2621a3d3f$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $79aee9b2621a3d3f$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $79aee9b2621a3d3f$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $79aee9b2621a3d3f$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $79aee9b2621a3d3f$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $79aee9b2621a3d3f$var$_ref6 = {
    name: "1dvgrzx",
    styles: "height:50px;padding:12px 26px"
};
var $79aee9b2621a3d3f$var$_ref7 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $79aee9b2621a3d3f$var$_ref8 = {
    name: "eivff4",
    styles: "display:none"
};
var $79aee9b2621a3d3f$var$_ref9 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $79aee9b2621a3d3f$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $79aee9b2621a3d3f$var$_ref9,
            label: $79aee9b2621a3d3f$var$_ref8,
            data: {
                main: $79aee9b2621a3d3f$var$_ref7,
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:56px;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h6, ";color:", theme.colors.secondary.normal, ";border-radius:20px;padding:14px 32px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", (0, $gln0L.mq).mobile($79aee9b2621a3d3f$var$_ref6), ";", ""),
                empty: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.darkHover, ";", ""),
                filled: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.normal, ";", ""),
                errored: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.negative.normal, ";", "")
            },
            error: {
                shared: $79aee9b2621a3d3f$var$_ref5,
                visible: $79aee9b2621a3d3f$var$_ref4,
                hidden: $79aee9b2621a3d3f$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $79aee9b2621a3d3f$var$_ref2,
                    hidden: $79aee9b2621a3d3f$var$_ref
                }
            }
        }
    });

});


parcelRegister("7NUoN", function(module, exports) {

$parcel$export(module.exports, "InputDescription", function () { return $87af7d30395da4a2$export$416ae9045a33afd; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $bUFcG = parcelRequire("bUFcG");
const $87af7d30395da4a2$export$416ae9045a33afd = ({ description: description })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $bUFcG.styles)(theme).option.main,
        children: description
    });
};
$87af7d30395da4a2$export$416ae9045a33afd.propTypes = {};

});
parcelRegister("bUFcG", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $76a8332301e0d4b0$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $76a8332301e0d4b0$export$9dd6ff9ea0189349 = (theme)=>({
        option: {
            main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("13cuy", function(module, exports) {

$parcel$export(module.exports, "InputLabel", function () { return $d107ae37c7968a5a$export$76d3231fec538b73; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $iqgqe = parcelRequire("iqgqe");
const $d107ae37c7968a5a$export$76d3231fec538b73 = ({ text: text })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $iqgqe.styles)(theme).label.main,
        children: text
    });
};
$d107ae37c7968a5a$export$76d3231fec538b73.propTypes = {};

});
parcelRegister("iqgqe", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $041b5b1a9f080625$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $041b5b1a9f080625$export$9dd6ff9ea0189349 = (theme)=>({
        label: {
            main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});


parcelRegister("6F2CE", function(module, exports) {

$parcel$export(module.exports, "InputLine", function () { return $66453ff5c1d57482$export$5214e7c10cea1350; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $1gfbO = parcelRequire("1gfbO");
const $66453ff5c1d57482$export$5214e7c10cea1350 = ({ name: name, label: label, icon: Icon, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $1gfbO.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $1gfbO.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $1gfbO.styles)(theme).input.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                        css: [
                            (0, $1gfbO.styles)(theme).input.data.shared,
                            attributes.value ? (0, $1gfbO.styles)(theme).input.data.filled : (0, $1gfbO.styles)(theme).input.data.empty,
                            attributes.disabled && (0, $1gfbO.styles)(theme).input.data.disabled,
                            error && (0, $1gfbO.styles)(theme).input.data.errored,
                            "",
                            ""
                        ],
                        id: name,
                        ...attributes
                    }),
                    Icon && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: [
                            (0, $1gfbO.styles)(theme).input.data.icon.shared,
                            attributes.value ? (0, $1gfbO.styles)(theme).input.data.icon.filled : (0, $1gfbO.styles)(theme).input.data.icon.empty,
                            attributes.disabled && (0, $1gfbO.styles)(theme).input.data.icon.disabled,
                            error && (0, $1gfbO.styles)(theme).input.data.icon.errored,
                            "",
                            ""
                        ],
                        children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $1gfbO.styles)(theme).input.error.shared,
                    errorMessage ? (0, $1gfbO.styles)(theme).input.error.visible : (0, $1gfbO.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: [
                        (0, $1gfbO.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $1gfbO.styles)(theme).input.error.text.visible : (0, $1gfbO.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$66453ff5c1d57482$export$5214e7c10cea1350.propTypes = {};

});
parcelRegister("1gfbO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $80b810f2ffacf8c0$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $80b810f2ffacf8c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $80b810f2ffacf8c0$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $80b810f2ffacf8c0$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $80b810f2ffacf8c0$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $80b810f2ffacf8c0$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $80b810f2ffacf8c0$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $80b810f2ffacf8c0$var$_ref6 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $80b810f2ffacf8c0$var$_ref7 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $80b810f2ffacf8c0$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $80b810f2ffacf8c0$var$_ref7,
            label: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";margin-bottom:10px;", ""),
            data: {
                main: $80b810f2ffacf8c0$var$_ref6,
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:28px;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;padding-bottom:2px;padding-right:28px;transition:border 0.2s;&:focus{border-bottom:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", ""),
                empty: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                filled: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.dark, ";", ""),
                errored: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.negative.normal, ";color:", theme.colors.secondary.normal, ";", ""),
                icon: {
                    shared: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).components.elements.inputLine.icon, ";position:absolute;right:0;top:0;display:flex;align-items:center;justify-content:center;width:28px;height:28px;&>svg{width:14px;height:14px;&>path{transition:fill 0.2s;}}", ""),
                    empty: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                    filled: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                    disabled: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.secondary.dark, ";}", ""),
                    errored: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.negative.normal, ";}", "")
                }
            },
            error: {
                shared: $80b810f2ffacf8c0$var$_ref5,
                visible: $80b810f2ffacf8c0$var$_ref4,
                hidden: $80b810f2ffacf8c0$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $80b810f2ffacf8c0$var$_ref2,
                    hidden: $80b810f2ffacf8c0$var$_ref
                }
            }
        }
    });

});


parcelRegister("k1nII", function(module, exports) {

$parcel$export(module.exports, "InputSelect", function () { return $ac36b53df66976c7$export$3fdb416c71effd9; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $dxcji = parcelRequire("dxcji");
const $ac36b53df66976c7$export$3fdb416c71effd9 = ({ placeholder: placeholder, options: options, setValue: setValue })=>{
    const theme = (0, $iwq56.u)();
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const [selectedOption, setSelectedOption] = (0, $bh6RR.useState)(placeholder);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dxcji.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: [
                    (0, $dxcji.styles)(theme).input.header.main.shared,
                    isOpen && (0, $dxcji.styles)(theme).input.header.main.open,
                    "",
                    ""
                ],
                onClick: ()=>setIsOpen((state)=>!state),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dxcji.styles)(theme).input.header.option,
                        "aria-label": selectedOption.label,
                        children: selectedOption.label
                    }, `${selectedOption.id}-selected`),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: [
                            (0, $dxcji.styles)(theme).input.header.icon.shared,
                            isOpen && (0, $dxcji.styles)(theme).input.header.icon.open,
                            "",
                            ""
                        ],
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CaretDown, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $dxcji.styles)(theme).input.options.main.shared,
                    isOpen && (0, $dxcji.styles)(theme).input.options.main.open,
                    "",
                    ""
                ],
                children: options.map((option)=>{
                    const { id: id, label: label, value: value } = option;
                    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: [
                            (0, $dxcji.styles)(theme).input.options.option.shared,
                            selectedOption.id === id && (0, $dxcji.styles)(theme).input.options.option.selected,
                            "",
                            ""
                        ],
                        "aria-label": label,
                        onClick: ()=>{
                            setSelectedOption(option);
                            setIsOpen(false);
                            setValue(value);
                        },
                        "aria-hidden": "true",
                        children: label
                    }, id);
                })
            })
        ]
    });
};
$ac36b53df66976c7$export$3fdb416c71effd9.propTypes = {};

});
parcelRegister("dxcji", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0a285f9d888b65ee$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $0a285f9d888b65ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0a285f9d888b65ee$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $0a285f9d888b65ee$var$_ref2 = {
    name: "16hjiy4",
    styles: "position:relative;display:flex;flex-direction:column"
};
const $0a285f9d888b65ee$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $0a285f9d888b65ee$var$_ref2,
            header: {
                main: {
                    shared: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;width:100%;height:28px;border-bottom:1px solid ", theme.colors.secondary.normal, ";transition:border 0.2s;", ""),
                    open: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.accent.normal, ";", "")
                },
                option: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;user-select:none;margin-right:28px;cursor:pointer;", ""),
                icon: {
                    shared: /*#__PURE__*/ (0, $7hler.css)("position:absolute;right:0;top:0;display:flex;align-items:center;justify-content:center;width:28px;height:28px;transform:rotate(180deg);transition:transform 0.2s;&>svg{width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                    open: /*#__PURE__*/ (0, $7hler.css)("transform:rotate(0deg);&>svg{&>path{fill:", theme.colors.accent.normal, ";}}", "")
                }
            },
            options: {
                main: {
                    shared: /*#__PURE__*/ (0, $7hler.css)("position:absolute;left:0;top:36px;display:none;width:100%;background-color:", theme.colors.primary.normal, ";padding:6px 0px;animation:0.2s ease 0s backwards ", (0, $gln0L.kf).slideIn.down(10), ";&>div:not(:last-of-type){margin-bottom:8px;}", ""),
                    open: $0a285f9d888b65ee$var$_ref
                },
                option: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";width:100%;height:28px;font-size:", (0, $gln0L.typography).p, ";font-weight:bold;user-select:none;cursor:pointer;", ""),
                    selected: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";", "")
                }
            }
        }
    });

});


parcelRegister("f6nZ0", function(module, exports) {

$parcel$export(module.exports, "Loader", function () { return $6925962562af78fa$export$3b0d6d7590275603; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $hrsAm = parcelRequire("hrsAm");
const $6925962562af78fa$export$3b0d6d7590275603 = ({ width: width, height: height, appearance: appearance = "primary" })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $hrsAm.styles)(theme).loader.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: [
                (0, $hrsAm.styles)(theme).loader.bars.shared(width, height),
                appearance === "primary" && (0, $hrsAm.styles)(theme).loader.bars.primary(width, height),
                appearance === "secondary" && (0, $hrsAm.styles)(theme).loader.bars.secondary(width, height),
                appearance === "accent" && (0, $hrsAm.styles)(theme).loader.bars.accent(width, height),
                "",
                ""
            ]
        })
    });
};
$6925962562af78fa$export$3b0d6d7590275603.propTypes = {};

});
parcelRegister("hrsAm", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $17457eb5f6bcc40c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $17457eb5f6bcc40c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $17457eb5f6bcc40c$var$_ref = {
    name: "1wnowod",
    styles: "display:flex;align-items:center;justify-content:center"
};
const $17457eb5f6bcc40c$export$9dd6ff9ea0189349 = (theme)=>({
        loader: {
            main: $17457eb5f6bcc40c$var$_ref,
            bars: {
                shared: (width, height)=>{
                    const baseWidth = width / 7;
                    return /*#__PURE__*/ (0, $7hler.css)("position:relative;width:", width, "px;height:", height, "px;animation:1s linear infinite alternate ", (0, $gln0L.kf).load.bars(width, height), ";background-repeat:no-repeat;background-position:0px center,", baseWidth * 1, "px center,", baseWidth * 2, "px center,", baseWidth * 3, "px center,", baseWidth * 4, "px center,", baseWidth * 5, "px center,", baseWidth * 6, "px center;", "");
                },
                primary: (width, height)=>/*#__PURE__*/ (0, $7hler.css)("background-image:linear-gradient(\n            ", theme.colors.primary.normal, " ", height, "px,\n            transparent 0\n          ),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.primary.normal, " ", height, "px, transparent 0);", ""),
                secondary: (width, height)=>/*#__PURE__*/ (0, $7hler.css)("background-image:linear-gradient(\n            ", theme.colors.secondary.normal, " ", height, "px,\n            transparent 0\n          ),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.secondary.normal, " ", height, "px, transparent 0);", ""),
                accent: (width, height)=>/*#__PURE__*/ (0, $7hler.css)("background-image:linear-gradient(\n            ", theme.colors.accent.normal, " ", height, "px,\n            transparent 0\n          ),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0),linear-gradient(", theme.colors.accent.normal, " ", height, "px, transparent 0);", "")
            }
        }
    });

});


parcelRegister("81gWx", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreview", function () { return $2e2e38c1b86eae64$export$b563e8c407c1ac47; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $dZ6Dk = parcelRequire("dZ6Dk");
const $2e2e38c1b86eae64$export$b563e8c407c1ac47 = ({ source: source, width: width, height: height, type: type, formats: formats, maxFileSize: maxFileSize, alt: alt = "", onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    const renderPreview = ()=>{
        // if source provided and media type is image
        if (source && type === "image") return /*#__PURE__*/ (0, $9awXB.jsx)("img", {
            css: (0, $dZ6Dk.styles)(theme).preview.image.overlay.content,
            loading: "lazy",
            src: source,
            alt: alt,
            width: width,
            height: height
        });
        // if source provided and media type is video
        if (source && type === "video") return /*#__PURE__*/ (0, $9awXB.jsxs)("video", {
            css: (0, $dZ6Dk.styles)(theme).preview.image.overlay.content,
            width: width,
            height: height,
            src: source,
            muted: true,
            preload: "metadata",
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("source", {
                    src: source,
                    type: "video/mp4"
                }),
                "Your browser does not support the video tag."
            ]
        });
        // placeholder
        return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $dZ6Dk.styles)(theme).preview.image.overlay.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ImageDownload, {
                    css: (0, $dZ6Dk.styles)(theme).preview.image.overlay.icon
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $dZ6Dk.styles)(theme).preview.image.overlay.text.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dZ6Dk.styles)(theme).preview.image.overlay.text.formats,
                            children: formats && formats.join(", ")
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dZ6Dk.styles)(theme).preview.image.overlay.text.size,
                            children: maxFileSize && `up to ${maxFileSize / 1024 / 1024}MiB`
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $dZ6Dk.styles)(theme).preview.main(width, height),
        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
            css: (0, $dZ6Dk.styles)(theme).preview.button,
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "change file",
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dZ6Dk.styles)(theme).preview.image.main(width, height),
                children: renderPreview()
            })
        })
    });
};
$2e2e38c1b86eae64$export$b563e8c407c1ac47.propTypes = {};

});
parcelRegister("dZ6Dk", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fca30a4fbfe03f8e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $fca30a4fbfe03f8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fca30a4fbfe03f8e$var$_ref = {
    name: "18wgrk7",
    styles: "border-radius:50%"
};
var $fca30a4fbfe03f8e$var$_ref2 = {
    name: "bpd7z7",
    styles: "margin-bottom:2px"
};
const $fca30a4fbfe03f8e$export$9dd6ff9ea0189349 = (theme)=>({
        preview: {
            main: (width, height)=>/*#__PURE__*/ (0, $7hler.css)("position:relative;width:", width, ";height:", height, ";border-radius:4px;overflow:hidden;", ""),
            button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:100%;cursor:pointer;", ""),
            image: {
                main: (width, height)=>/*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:", width, ";height:", height, ";background-color:", theme.colors.secondary.darker, ";overflow:hidden;", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px;", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("width:40px;height:40px;margin-bottom:4px;&>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    text: {
                        main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";", ""),
                        formats: $fca30a4fbfe03f8e$var$_ref2,
                        size: /*#__PURE__*/ (0, $7hler.css)("", "")
                    }
                }
            },
            helpers: {
                round: $fca30a4fbfe03f8e$var$_ref
            }
        }
    });

});


parcelRegister("57kXZ", function(module, exports) {

$parcel$export(module.exports, "ModalCardSubtitle", function () { return $07d9f904d80bc8bf$export$5c08126300965871; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $fmtl0 = parcelRequire("fmtl0");
const $07d9f904d80bc8bf$export$5c08126300965871 = ({ text: text, accent: accent })=>{
    const theme = (0, $iwq56.u)();
    // if accent provided
    if (accent) {
        const { accentStart: accentStart, accentEnd: accentEnd, onClick: onClick } = accent;
        const isLongUsername = accentEnd - accentStart > 31;
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fmtl0.styles)(theme).title.main,
            children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $fmtl0.styles)(theme).title.text,
                children: [
                    text.slice(0, accentStart),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $fmtl0.styles)(theme).title.button,
                        onClick: (e)=>onClick(e),
                        type: "button",
                        "aria-label": "navigate to artist profile",
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                            css: [
                                (0, $fmtl0.styles)(theme).title.accent.main,
                                isLongUsername && (0, $fmtl0.styles)(theme).title.accent.long,
                                "",
                                ""
                            ],
                            children: text.slice(accentStart, accentEnd)
                        })
                    }),
                    text.slice(accentEnd, text.length)
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fmtl0.styles)(theme).title.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fmtl0.styles)(theme).title.text,
            children: text
        })
    });
};
$07d9f904d80bc8bf$export$5c08126300965871.propTypes = {};

});
parcelRegister("fmtl0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $cb832dc4d3224143$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $cb832dc4d3224143$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cb832dc4d3224143$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $cb832dc4d3224143$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: $cb832dc4d3224143$var$_ref,
            text: /*#__PURE__*/ (0, $7hler.css)("max-width:0;font-size:", (0, $gln0L.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";max-width:500px;", ""),
            button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-weight:bold;text-align:start;white-space:nowrap;cursor:pointer;", ""),
            accent: {
                main: /*#__PURE__*/ (0, $7hler.css)("font-weight:bold;font-size:", (0, $gln0L.typography).h6, ";text-align:center;color:", theme.colors.accent.normal, ";", ""),
                long: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});


parcelRegister("6GhGJ", function(module, exports) {

$parcel$export(module.exports, "ModalCardTitle", function () { return $97fe6ef7d77a1c0c$export$1f5c1177562f0093; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $gnD0s = parcelRequire("gnD0s");
const $97fe6ef7d77a1c0c$export$1f5c1177562f0093 = ({ text: text, icon: Icon })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $gnD0s.styles)(theme).title.main,
        children: [
            Icon && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gnD0s.styles)(theme).title.icon,
                children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gnD0s.styles)(theme).title.text,
                children: text
            })
        ]
    });
};
$97fe6ef7d77a1c0c$export$1f5c1177562f0093.propTypes = {};

});
parcelRegister("gnD0s", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e9fbb9fea2a97059$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $e9fbb9fea2a97059$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e9fbb9fea2a97059$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $e9fbb9fea2a97059$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: $e9fbb9fea2a97059$var$_ref,
            icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-right:10px;&>svg{width:28px;height:28px;& path{fill:", theme.colors.accent.normal, ";}}", ""),
            text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h5, ";color:", theme.colors.secondary.normal, ";", "")
        }
    });

});


parcelRegister("curqj", function(module, exports) {

$parcel$export(module.exports, "NavigationScrollable", function () { return $60396f27d2e8e2f8$export$476009c3d58af41b; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $5h51K = parcelRequire("5h51K");
const $60396f27d2e8e2f8$export$476009c3d58af41b = ({ options: options })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5h51K.styles)(theme).nav.main,
        children: options.map(({ id: id, label: label, enabled: enabled, onClick: onClick })=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $5h51K.styles)(theme).nav.option.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: [
                        (0, $5h51K.styles)(theme).nav.option.button.shared,
                        enabled ? (0, $5h51K.styles)(theme).nav.option.button.enabled : (0, $5h51K.styles)(theme).nav.option.button.disabled,
                        "",
                        ""
                    ],
                    type: "button",
                    onClick: (e)=>onClick(e),
                    children: label
                })
            }, `navigation-scrollable-${id}`))
    });
};

});
parcelRegister("5h51K", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0d33efe9ca869f77$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $0d33efe9ca869f77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0d33efe9ca869f77$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $0d33efe9ca869f77$export$9dd6ff9ea0189349 = (theme)=>({
        nav: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";display:flex;align-items:center;width:100%;height:54px;scroll-behavior:smooth;overflow-x:scroll;overflow-y:hidden;&>div:not(:last-of-type){margin-right:20px;}", ""),
            option: {
                main: $0d33efe9ca869f77$var$_ref,
                button: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:4px 26px;width:100%;height:32px;transition:border 0.2s,color 0.2s,background-color 0.2s;", ""),
                    enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";border:1px solid ", theme.colors.accent.normal, ";", ""),
                    disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.secondary.light, ";background-color:", theme.colors.primary.normal, ";border:1px solid ", theme.colors.accent.normal, ";", "")
                }
            }
        }
    });

});


parcelRegister("bl2nZ", function(module, exports) {

$parcel$export(module.exports, "Stepper", function () { return $13d71351017021a9$export$ed8ca599049e8881; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $8GvWP = parcelRequire("8GvWP");
const $13d71351017021a9$export$ed8ca599049e8881 = ({ steps: steps, currentStep: currentStep })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $8GvWP.styles)(theme).stepper.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8GvWP.styles)(theme).stepper.progress
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8GvWP.styles)(theme).stepper.steps.main,
                children: steps.map(({ id: id, description: description }, i)=>{
                    const checked = currentStep - 1 > i;
                    const current = currentStep - 1 === i;
                    const following = !checked && !current;
                    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $8GvWP.styles)(theme).stepper.steps.step.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                css: (0, $8GvWP.styles)(theme).stepper.steps.step.icon.main,
                                children: [
                                    checked && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: [
                                            (0, $8GvWP.styles)(theme).stepper.steps.step.icon.circle.shared,
                                            (0, $8GvWP.styles)(theme).stepper.steps.step.icon.circle.checked,
                                            "",
                                            ""
                                        ],
                                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Check, {
                                            css: (0, $8GvWP.styles)(theme).stepper.steps.step.icon.check
                                        })
                                    }),
                                    current && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: [
                                            (0, $8GvWP.styles)(theme).stepper.steps.step.icon.circle.shared,
                                            (0, $8GvWP.styles)(theme).stepper.steps.step.icon.circle.current,
                                            "",
                                            ""
                                        ]
                                    }),
                                    following && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: [
                                            (0, $8GvWP.styles)(theme).stepper.steps.step.icon.circle.shared,
                                            (0, $8GvWP.styles)(theme).stepper.steps.step.icon.circle.following,
                                            "",
                                            ""
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $8GvWP.styles)(theme).stepper.steps.step.description,
                                children: description
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
};
$13d71351017021a9$export$ed8ca599049e8881.propTypes = {};

});
parcelRegister("8GvWP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $32e1f0a51382a285$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $32e1f0a51382a285$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $32e1f0a51382a285$var$_ref = {
    name: "u43u09",
    styles: "max-width:78px"
};
var $32e1f0a51382a285$var$_ref2 = {
    name: "1ntjm1r",
    styles: "max-width:88px"
};
var $32e1f0a51382a285$var$_ref3 = {
    name: "68x97p",
    styles: "width:32px;height:32px"
};
var $32e1f0a51382a285$var$_ref4 = {
    name: "bgbjt4",
    styles: "width:36px;height:36px"
};
var $32e1f0a51382a285$var$_ref5 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $32e1f0a51382a285$var$_ref6 = {
    name: "h9ib7p",
    styles: "flex:1;display:flex;flex-direction:column;align-items:center"
};
var $32e1f0a51382a285$var$_ref7 = {
    name: "106ba0x",
    styles: "height:2px;top:15px"
};
var $32e1f0a51382a285$var$_ref8 = {
    name: "1i8qned",
    styles: "top:14px"
};
var $32e1f0a51382a285$var$_ref9 = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $32e1f0a51382a285$export$9dd6ff9ea0189349 = (theme)=>({
        stepper: {
            main: $32e1f0a51382a285$var$_ref9,
            progress: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.stepper.progress, ";position:absolute;top:18px;left:12%;width:76%;height:4px;background-color:", theme.colors.accent.normal, ";", (0, $gln0L.mq).tablet($32e1f0a51382a285$var$_ref8), " ", (0, $gln0L.mq).mobile($32e1f0a51382a285$var$_ref7), ";", ""),
            steps: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.stepper.circle, ";display:flex;position:relative;", ""),
                step: {
                    main: $32e1f0a51382a285$var$_ref6,
                    icon: {
                        main: $32e1f0a51382a285$var$_ref5,
                        circle: {
                            shared: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;border:4px solid transparent;", (0, $gln0L.mq).tablet($32e1f0a51382a285$var$_ref4), " ", (0, $gln0L.mq).mobile($32e1f0a51382a285$var$_ref3), ";", ""),
                            checked: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.accent.normal, ";border:4px solid ", theme.colors.primary.normal, ";", ""),
                            current: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.accent.normal, ";border:6px solid ", theme.colors.primary.normal, ";", ""),
                            following: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.primary.normal, ";border:2px solid ", theme.colors.accent.normal, ";", "")
                        },
                        check: /*#__PURE__*/ (0, $7hler.css)("width:24px;height:24px;&>path{fill:", theme.colors.primary.normal, ";}", "")
                    },
                    description: /*#__PURE__*/ (0, $7hler.css)("text-align:center;word-break:break-word;max-width:98px;", (0, $gln0L.mq).tablet($32e1f0a51382a285$var$_ref2), " ", (0, $gln0L.mq).mobile($32e1f0a51382a285$var$_ref), ";", "")
                }
            }
        }
    });

});


parcelRegister("42mKz", function(module, exports) {

$parcel$export(module.exports, "SkeletonHorizontal", function () { return $7e5351b0c27f5e75$export$f782bd160760d52d; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $cQciq = parcelRequire("cQciq");
const $7e5351b0c27f5e75$export$f782bd160760d52d = ({ sections: sections })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $cQciq.styles)(theme).skeleton.main,
        children: sections.map(({ name: name, width: width, height: height, isStatic: isStatic, isDivider: isDivider }, i)=>{
            const isOnlySection = sections.length === 1;
            const isFirstSection = i === 0 && !isOnlySection;
            const isLastSection = i === sections.length - 1 && !isOnlySection;
            const isCenterSection = !isFirstSection && !isLastSection && !isDivider;
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    isDivider && (0, $cQciq.styles)(theme).skeleton.divider(width, height, isStatic),
                    isOnlySection && (0, $cQciq.styles)(theme).skeleton.section.full(width, height, isStatic),
                    isFirstSection && (0, $cQciq.styles)(theme).skeleton.section.start(width, height, isStatic),
                    isLastSection && (0, $cQciq.styles)(theme).skeleton.section.end(width, height, isStatic),
                    isCenterSection && (0, $cQciq.styles)(theme).skeleton.section.center(width, height, isStatic),
                    "",
                    ""
                ]
            }, name);
        })
    });
};
$7e5351b0c27f5e75$export$f782bd160760d52d.propTypes = {};

});
parcelRegister("cQciq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $04b9e5a0e8c34df1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $04b9e5a0e8c34df1$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;width:100%;border-radius:4px;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $gln0L.kf).load.shine(-60, 0), ";", ""),
            section: {
                full: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                start: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-top-left-radius:4px;border-bottom-left-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                center: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;background-color:", theme.colors.primary.darker, ";", ""),
                end: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-top-right-radius:4px;border-bottom-right-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
            },
            divider: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";background-color:", theme.colors.primary.normal, ";", "")
        }
    });

});


parcelRegister("r5GD9", function(module, exports) {

$parcel$export(module.exports, "SkeletonVertical", function () { return $fc40fbdc16afd3aa$export$50a8a0b1864d274b; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $hxggl = parcelRequire("hxggl");
const $fc40fbdc16afd3aa$export$50a8a0b1864d274b = ({ containerWidth: containerWidth, sections: sections })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $hxggl.styles)(theme).skeleton.main(containerWidth),
        children: sections.map(({ name: name, width: width, height: height, isStatic: isStatic, isDivider: isDivider }, i)=>{
            const isOnlySection = sections.length === 1;
            const isFirstSection = i === 0 && !isOnlySection;
            const isLastSection = i === sections.length - 1 && !isOnlySection;
            const isCenterSection = !isFirstSection && !isLastSection && !isDivider;
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    isDivider && (0, $hxggl.styles)(theme).skeleton.divider(width, height, isStatic),
                    isOnlySection && (0, $hxggl.styles)(theme).skeleton.section.full(width, height, isStatic),
                    isFirstSection && (0, $hxggl.styles)(theme).skeleton.section.start(width, height, isStatic),
                    isLastSection && (0, $hxggl.styles)(theme).skeleton.section.end(width, height, isStatic),
                    isCenterSection && (0, $hxggl.styles)(theme).skeleton.section.center(width, height, isStatic),
                    "",
                    ""
                ]
            }, name);
        })
    });
};
$fc40fbdc16afd3aa$export$50a8a0b1864d274b.propTypes = {};

});
parcelRegister("hxggl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d6497de5b909c4bd$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $d6497de5b909c4bd$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: (width)=>/*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;align-items:center;width:", width, ";border-radius:4px;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $gln0L.kf).load.shine(-60, 0), ";", ""),
            section: {
                full: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                start: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-top-left-radius:4px;border-top-right-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
                center: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;background-color:", theme.colors.primary.darker, ";", ""),
                end: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";opacity:0.4;border-bottom-left-radius:4px;border-bottom-right-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
            },
            divider: (width, height, isStatic)=>/*#__PURE__*/ (0, $7hler.css)(isStatic && `flex-shrink: 0;`, " width:", width, ";height:", height, ";background-color:", theme.colors.primary.normal, ";", "")
        }
    });

});


parcelRegister("2oiNd", function(module, exports) {

$parcel$export(module.exports, "Subtitle", function () { return $3e87262568cdbede$export$cf345ef34cd72655; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $kIiNB = parcelRequire("kIiNB");
const $3e87262568cdbede$export$cf345ef34cd72655 = ({ text: text, accent: accent, link: link })=>{
    const theme = (0, $iwq56.u)();
    const renderTitle = ()=>{
        if (accent) {
            const { accentStart: accentStart, accentEnd: accentEnd } = accent;
            return /*#__PURE__*/ (0, $9awXB.jsxs)("h2", {
                css: (0, $kIiNB.styles)(theme).title.text,
                children: [
                    text.slice(0, accentStart),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $kIiNB.styles)(theme).title.accent,
                        children: text.slice(accentStart, accentEnd)
                    }),
                    text.slice(accentEnd, text.length)
                ]
            });
        }
        if (link) {
            const { linkStart: linkStart, linkEnd: linkEnd, href: href } = link;
            return /*#__PURE__*/ (0, $9awXB.jsxs)("h2", {
                css: (0, $kIiNB.styles)(theme).title.text,
                children: [
                    text.slice(0, linkStart),
                    /*#__PURE__*/ (0, $9awXB.jsx)("a", {
                        css: (0, $kIiNB.styles)(theme).title.link,
                        href: href,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: text.slice(linkStart, linkEnd)
                    }),
                    text.slice(linkEnd, text.length)
                ]
            });
        }
        return /*#__PURE__*/ (0, $9awXB.jsx)("h2", {
            css: (0, $kIiNB.styles)(theme).title.text,
            children: text
        });
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kIiNB.styles)(theme).title.main,
        children: renderTitle()
    });
};
$3e87262568cdbede$export$cf345ef34cd72655.propTypes = {};

});
parcelRegister("kIiNB", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ceee69f02c634413$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ceee69f02c634413$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ceee69f02c634413$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
const $ceee69f02c634413$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: $ceee69f02c634413$var$_ref,
            text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.normal, ";", ""),
            accent: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";", ""),
            link: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";text-decoration:none;transition:color 0.2s;&:hover,&:active{color:", theme.colors.accent.normalHover, ";}&:link,&:visited{}", "")
        }
    });

});



parcelRegister("jvUFX", function(module, exports) {

$parcel$export(module.exports, "ErrorFallback", function () { return (parcelRequire("2uUr9")).ErrorFallback; });
$parcel$export(module.exports, "SuspenseContentFallback", function () { return (parcelRequire("6aEHC")).SuspenseContentFallback; });
$parcel$export(module.exports, "SuspenseMainFallback", function () { return (parcelRequire("kb0tL")).SuspenseMainFallback; });

var $2uUr9 = parcelRequire("2uUr9");

var $6aEHC = parcelRequire("6aEHC");

var $kb0tL = parcelRequire("kb0tL");

});
parcelRegister("2uUr9", function(module, exports) {

$parcel$export(module.exports, "ErrorFallback", function () { return $34ddc2b7a720cbbe$export$8a7ad05c3ee0c78a; });

var $9awXB = parcelRequire("9awXB");

var $gYuRo = parcelRequire("gYuRo");
const $34ddc2b7a720cbbe$export$8a7ad05c3ee0c78a = ()=>/*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $gYuRo.styles)().fallback.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gYuRo.styles)().fallback.title.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("h2", {
                    css: (0, $gYuRo.styles)().fallback.title.text,
                    children: "Ooops, something went wrong!"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gYuRo.styles)().fallback.buttons.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $gYuRo.styles)().fallback.buttons.button,
                    onClick: ()=>window.location.assign(window.location.origin),
                    type: "button",
                    "aria-label": "refresh page",
                    children: "Refresh"
                })
            })
        ]
    });
$34ddc2b7a720cbbe$export$8a7ad05c3ee0c78a.propTypes = {};

});
parcelRegister("gYuRo", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9e15c59e425e53fb$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $9e15c59e425e53fb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9e15c59e425e53fb$var$_ref = {
    name: "7whenc",
    styles: "display:flex;width:100%"
};
var $9e15c59e425e53fb$var$_ref2 = {
    name: "14y2j0t",
    styles: "margin-bottom:46px"
};
const $9e15c59e425e53fb$export$9dd6ff9ea0189349 = ()=>{
    const theme = (0, $gln0L.getTheme)((0, $gln0L.ThemeName).Dark);
    return {
        fallback: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:100vw;min-height:100vh;background-color:", theme.colors.primary.normal, ";", ""),
            title: {
                main: $9e15c59e425e53fb$var$_ref2,
                text: /*#__PURE__*/ (0, $7hler.css)("font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h5, ";color:", theme.colors.secondary.normal, ";text-align:center;", "")
            },
            buttons: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($9e15c59e425e53fb$var$_ref), ";", ""),
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:8px 26px;cursor:pointer;width:100%;transition:border 0.2s,color 0.2s,background-color 0.2s;color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";&:hover{border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.accent.normal, ";}", "")
            }
        }
    };
};

});


parcelRegister("6aEHC", function(module, exports) {

$parcel$export(module.exports, "SuspenseContentFallback", function () { return $3daeb1ced516d950$export$b2db1ccc4d1fb3bd; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("1TdPt");
var $f6nZ0 = parcelRequire("f6nZ0");

var $kxbXC = parcelRequire("kxbXC");
const $3daeb1ced516d950$export$b2db1ccc4d1fb3bd = ({ position: position = "full" })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: [
            (0, $kxbXC.styles)(theme).fallback.shared,
            position === "fit" && (0, $kxbXC.styles)(theme).fallback.fit,
            position === "full" && (0, $kxbXC.styles)(theme).fallback.full,
            "",
            ""
        ],
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
            width: 80,
            height: 40,
            appearance: "accent"
        })
    });
};
$3daeb1ced516d950$export$b2db1ccc4d1fb3bd.propTypes = {};

});
parcelRegister("kxbXC", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ed4ca62ee6deff74$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ed4ca62ee6deff74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ed4ca62ee6deff74$var$_ref = {
    name: "5nlari",
    styles: "min-width:100vw;min-height:100vh"
};
var $ed4ca62ee6deff74$var$_ref2 = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $ed4ca62ee6deff74$export$9dd6ff9ea0189349 = (theme)=>({
        fallback: {
            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:", theme.colors.primary.normal, ";", ""),
            fit: $ed4ca62ee6deff74$var$_ref2,
            full: $ed4ca62ee6deff74$var$_ref
        }
    });

});


parcelRegister("kb0tL", function(module, exports) {

$parcel$export(module.exports, "SuspenseMainFallback", function () { return $bff7535d8497dcba$export$fd75980ff6fb550b; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("1TdPt");
var $f6nZ0 = parcelRequire("f6nZ0");

var $9hoXe = parcelRequire("9hoXe");
const $bff7535d8497dcba$export$fd75980ff6fb550b = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9hoXe.styles)().fallback.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
            width: 80,
            height: 40,
            appearance: "accent"
        })
    });
$bff7535d8497dcba$export$fd75980ff6fb550b.propTypes = {};

});
parcelRegister("9hoXe", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ae1594f16cfd3ee0$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $ae1594f16cfd3ee0$export$9dd6ff9ea0189349 = ()=>{
    const theme = (0, $gln0L.getTheme)((0, $gln0L.ThemeName).Dark);
    return {
        fallback: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:100vw;min-height:100vh;background-color:", theme.colors.primary.normal, ";", "")
        }
    };
};

});



parcelRegister("9TlX5", function(module, exports) {

$parcel$export(module.exports, "AppLayout", function () { return (parcelRequire("3YnFc")).AppLayout; });
$parcel$export(module.exports, "ContentContainer", function () { return (parcelRequire("gnTra")).ContentContainer; });
$parcel$export(module.exports, "ContentLayoutVirtualized", function () { return (parcelRequire("2xDls")).ContentLayoutVirtualized; });
$parcel$export(module.exports, "MainLayout", function () { return (parcelRequire("8BwiX")).MainLayout; });
$parcel$export(module.exports, "ModalLayout", function () { return (parcelRequire("e1re8")).ModalLayout; });
$parcel$export(module.exports, "SectionsLayout", function () { return (parcelRequire("d6xWB")).SectionsLayout; });

var $3YnFc = parcelRequire("3YnFc");

var $gnTra = parcelRequire("gnTra");

var $2xDls = parcelRequire("2xDls");

var $8BwiX = parcelRequire("8BwiX");

var $e1re8 = parcelRequire("e1re8");

var $d6xWB = parcelRequire("d6xWB");

});
parcelRegister("3YnFc", function(module, exports) {

$parcel$export(module.exports, "AppLayout", function () { return $68b59f13ad4289e3$export$e034111dc0cfe9e7; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $hnklx = parcelRequire("hnklx");
var $3uBAm = parcelRequire("3uBAm");
var $3kLT7 = parcelRequire("3kLT7");
var $44h64 = parcelRequire("44h64");
var $7Iuuy = parcelRequire("7Iuuy");
parcelRequire("1TdPt");
var $dqVAo = parcelRequire("dqVAo");

var $d8X6F = parcelRequire("d8X6F");
const $68b59f13ad4289e3$export$e034111dc0cfe9e7 = ({ children: children })=>{
    const { pathname: pathname } = (0, $99w1R.useLocation)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const isLibraryPage = pathname === (0, $b7fnN.Path).Library;
    const isUserLoggedIn = !!profile;
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $d8X6F.styles)().layout.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $d8X6F.styles)().layout.navigation,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $hnklx.NavigationApp), {}),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $3uBAm.NavigationAppMobile), {})
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $d8X6F.styles)().layout.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $d8X6F.styles)().layout.content.header.app,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dqVAo.AppHeader), {})
                    }),
                    isLibraryPage && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $d8X6F.styles)().layout.content.header.library,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $3kLT7.NavigationLibrary), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $d8X6F.styles)().layout.content.panel.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("main", {
                            css: (0, $d8X6F.styles)().layout.content.panel.view,
                            children: children
                        })
                    }),
                    isUserLoggedIn && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $d8X6F.styles)().layout.content.player,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $44h64.PlayerAudio), {})
                    }),
                    isUserLoggedIn && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $d8X6F.styles)().layout.content.playlist,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7Iuuy.PlayerAudioPlaylist), {})
                    })
                ]
            })
        ]
    });
};
$68b59f13ad4289e3$export$e034111dc0cfe9e7.propTypes = {};

});
parcelRegister("10WBQ", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", function () { return $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $0bd3411f2ec14e23$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("99w1R")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("99w1R")).useNavigate; });
/**
 * React Router DOM v6.26.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $fSADM = parcelRequire("fSADM");
var $99w1R = parcelRequire("99w1R");

var $fSADM = parcelRequire("fSADM");
function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $fSADM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $0bd3411f2ec14e23$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $fSADM.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $fSADM.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $99w1R.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnNavigation: opts == null ? void 0 : opts.unstable_patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $fSADM.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $0bd3411f2ec14e23$export$7ad602f0e94e62d1 = /*#__PURE__*/ $bh6RR.createContext({
    isTransitioning: false
});
const $0bd3411f2ec14e23$export$148fd98d095596d4 = /*#__PURE__*/ $bh6RR.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
const $0bd3411f2ec14e23$var$FLUSH_SYNC = "flushSync";
const $0bd3411f2ec14e23$var$flushSyncImpl = $6afFj[$0bd3411f2ec14e23$var$FLUSH_SYNC];
const $0bd3411f2ec14e23$var$USE_ID = "useId";
const $0bd3411f2ec14e23$var$useIdImpl = $bh6RR[$0bd3411f2ec14e23$var$USE_ID];
function $0bd3411f2ec14e23$var$startTransitionSafe(cb) {
    if ($0bd3411f2ec14e23$var$startTransitionImpl) $0bd3411f2ec14e23$var$startTransitionImpl(cb);
    else cb();
}
function $0bd3411f2ec14e23$var$flushSyncSafe(cb) {
    if ($0bd3411f2ec14e23$var$flushSyncImpl) $0bd3411f2ec14e23$var$flushSyncImpl(cb);
    else cb();
}
class $0bd3411f2ec14e23$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $0bd3411f2ec14e23$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let [pendingState, setPendingState] = $bh6RR.useState();
    let [vtContext, setVtContext] = $bh6RR.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $bh6RR.useState();
    let [transition, setTransition] = $bh6RR.useState();
    let [interruption, setInterruption] = $bh6RR.useState();
    let fetcherData = $bh6RR.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $bh6RR.useCallback((cb)=>{
        if (v7_startTransition) $0bd3411f2ec14e23$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $bh6RR.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $0bd3411f2ec14e23$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $0bd3411f2ec14e23$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $bh6RR.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $0bd3411f2ec14e23$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $bh6RR.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $bh6RR.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $bh6RR.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $bh6RR.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $0bd3411f2ec14e23$var$MemoizedDataRoutes = /*#__PURE__*/ $bh6RR.memo($0bd3411f2ec14e23$var$DataRoutes);
function $0bd3411f2ec14e23$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $99w1R.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $fSADM.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $99w1R.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref7, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $fSADM.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $99w1R.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref8, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $99w1R.useLocation)();
    let routerState = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $0bd3411f2ec14e23$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $fSADM.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref9, $0bd3411f2ec14e23$var$_excluded3);
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
// Internal hooks
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterContext));
    !ctx && (0, $fSADM.UNSAFE_invariant)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $99w1R.UNSAFE_DataRouterStateContext));
    !state && (0, $fSADM.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $99w1R.useNavigate)();
    let location = (0, $99w1R.useLocation)();
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $fSADM.createPath)(location) === (0, $fSADM.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $99w1R.useLocation)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $99w1R.useNavigate)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
let $0bd3411f2ec14e23$var$getUniqueFetcherId = ()=>"__" + String(++$0bd3411f2ec14e23$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let currentRouteId = (0, $99w1R.UNSAFE_useRouteId)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $0bd3411f2ec14e23$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let routeContext = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    !routeContext && (0, $fSADM.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $99w1R.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $99w1R.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $fSADM.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $fSADM.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $bh6RR.useContext($0bd3411f2ec14e23$export$148fd98d095596d4);
    let route = $bh6RR.useContext((0, $99w1R.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $fSADM.UNSAFE_invariant)(false);
    !route && (0, $fSADM.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $fSADM.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $0bd3411f2ec14e23$var$useIdImpl ? $0bd3411f2ec14e23$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $bh6RR.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($0bd3411f2ec14e23$var$getUniqueFetcherId());
    // Registration/cleanup
    $bh6RR.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $bh6RR.useCallback((href, opts)=>{
        !routeId && (0, $fSADM.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    let submit = $bh6RR.useCallback((target, opts)=>{
        submitImpl(target, $0bd3411f2ec14e23$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $bh6RR.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a7fed597f4b8afd8, $0bd3411f2ec14e23$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $fSADM.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $0bd3411f2ec14e23$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $99w1R.UNSAFE_NavigationContext));
    let location = (0, $99w1R.useLocation)();
    let matches = (0, $99w1R.useMatches)();
    let navigation = (0, $99w1R.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $fSADM.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $99w1R.useBlocker)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $0bd3411f2ec14e23$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $bh6RR.useContext($0bd3411f2ec14e23$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $fSADM.UNSAFE_invariant)(false);
    let { basename: basename } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.useViewTransitionState);
    let path = (0, $99w1R.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $fSADM.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $fSADM.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $fSADM.matchPath)(path.pathname, nextPath) != null || (0, $fSADM.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("6afFj", function(module, exports) {
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("foRq4"));

});


parcelRegister("d8X6F", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ea5102685c0473e4$export$9dd6ff9ea0189349; });
function $ea5102685c0473e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ea5102685c0473e4$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ea5102685c0473e4$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ea5102685c0473e4$var$_ref3 = {
    name: "36bnqj",
    styles: "display:flex;flex:1"
};
var $ea5102685c0473e4$var$_ref4 = {
    name: "i02vwc",
    styles: "display:flex;flex:1;width:100%"
};
var $ea5102685c0473e4$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ea5102685c0473e4$var$_ref6 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ea5102685c0473e4$var$_ref7 = {
    name: "170x82z",
    styles: "display:flex;flex-direction:column;flex:1;width:100%"
};
var $ea5102685c0473e4$var$_ref8 = {
    name: "zjik7",
    styles: "display:flex"
};
var $ea5102685c0473e4$var$_ref9 = {
    name: "nizj86",
    styles: "display:flex;min-height:100vh"
};
const $ea5102685c0473e4$export$9dd6ff9ea0189349 = ()=>({
        layout: {
            main: $ea5102685c0473e4$var$_ref9,
            navigation: $ea5102685c0473e4$var$_ref8,
            content: {
                main: $ea5102685c0473e4$var$_ref7,
                header: {
                    app: $ea5102685c0473e4$var$_ref6,
                    library: $ea5102685c0473e4$var$_ref5
                },
                panel: {
                    main: $ea5102685c0473e4$var$_ref4,
                    view: $ea5102685c0473e4$var$_ref3
                },
                player: $ea5102685c0473e4$var$_ref2,
                playlist: $ea5102685c0473e4$var$_ref
            }
        }
    });

});


parcelRegister("gnTra", function(module, exports) {

$parcel$export(module.exports, "ContentContainer", function () { return $3323c751f4894bf8$export$9d2b4227a95687cc; });

var $9awXB = parcelRequire("9awXB");

var $7hler = parcelRequire("7hler");

var $i9unM = parcelRequire("i9unM");
const $3323c751f4894bf8$export$9d2b4227a95687cc = ({ children: children, overrideCss: overrideCss = {
    main: /*#__PURE__*/ (0, $7hler.css)("", "")
} })=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: [
            (0, $i9unM.styles)().container.main,
            overrideCss?.main,
            "",
            ""
        ],
        children: children
    });
$3323c751f4894bf8$export$9d2b4227a95687cc.propTypes = {};

});
parcelRegister("i9unM", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f070f5cddc5bb547$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $f070f5cddc5bb547$export$9dd6ff9ea0189349 = ()=>({
        container: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";width:100%;overflow-y:scroll;", "")
        }
    });

});


parcelRegister("2xDls", function(module, exports) {

$parcel$export(module.exports, "ContentLayoutVirtualized", function () { return $75782a686457aed3$export$8d3fc14510f0efc9; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $7hler = parcelRequire("7hler");
var $iwq56 = parcelRequire("iwq56");

var $eCfBx = parcelRequire("eCfBx");
parcelRequire("3QbGE");
var $SYApi = parcelRequire("SYApi");

var $5IqEP = parcelRequire("5IqEP");

var $hDyx2 = parcelRequire("hDyx2");
const $75782a686457aed3$export$8d3fc14510f0efc9 = ({ title: title, icon: Icon, children: children, itemWidth: itemWidth, itemsCount: itemsCount, overrideCss: overrideCss = {
    main: /*#__PURE__*/ (0, $7hler.css)("", ""),
    header: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        title: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            text: /*#__PURE__*/ (0, $7hler.css)("", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    },
    navigation: {
        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
        button: /*#__PURE__*/ (0, $7hler.css)("", ""),
        icon: /*#__PURE__*/ (0, $7hler.css)("", "")
    },
    content: {
        main: /*#__PURE__*/ (0, $7hler.css)("", "")
    },
    container: {
        main: /*#__PURE__*/ (0, $7hler.css)("", "")
    }
} })=>{
    const theme = (0, $iwq56.u)();
    // content navigation
    const [backwardDisabled, setBackwardDisabled] = (0, $bh6RR.useState)(true);
    const [forwardDisabled, setForwardDisabled] = (0, $bh6RR.useState)(true);
    const containerRef = (0, $bh6RR.useRef)(null);
    // configure initial navigation state
    (0, $bh6RR.useEffect)(()=>{
        // if items count is 0
        if (itemsCount === 0) {
            // disable backward and forward scrolls
            setBackwardDisabled(true);
            setForwardDisabled(true);
            return;
        }
        // if list node found
        if (containerRef.current?.children.length) {
            // get list node
            const listNode = containerRef.current.children[0];
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = listNode;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (scrollLeft <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (scrollLeft >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    }, [
        itemsCount
    ]);
    // handleBackwardClick - handles content navigation backward click
    const handleBackwardClick = ()=>{
        // if list node found
        if (containerRef.current?.children.length) {
            // get list node
            const listNode = containerRef.current.children[0];
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = listNode;
            // calculate next scroll offset
            const offset = Math.floor(clientWidth / itemWidth) * itemWidth;
            // scroll for exactly n visible items
            listNode.scrollBy(-offset, 0);
            const nextScrollPosition = scrollLeft - offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    // handleForwardClick - handles content navigation forward click
    const handleForwardClick = ()=>{
        // if list node found
        if (containerRef.current?.children.length) {
            // get list node
            const listNode = containerRef.current.children[0];
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = listNode;
            // calculate next scroll offset
            const offset = Math.floor(clientWidth / itemWidth) * itemWidth;
            // scroll for exactly n visible items
            listNode.scrollBy(offset, 0);
            const nextScrollPosition = scrollLeft + offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: [
            (0, $hDyx2.styles)(theme).layout.main,
            overrideCss?.main,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: [
                    (0, $hDyx2.styles)(theme).layout.header.main,
                    overrideCss?.header.main,
                    "",
                    ""
                ],
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: [
                            [
                                (0, $hDyx2.styles)(theme).layout.header.title.main,
                                overrideCss?.header.title.main
                            ],
                            "",
                            ""
                        ],
                        children: [
                            Icon && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: [
                                    (0, $hDyx2.styles)(theme).layout.header.title.icon,
                                    overrideCss?.header.title.icon,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: [
                                    (0, $hDyx2.styles)(theme).layout.header.title.text,
                                    overrideCss?.header.title.text,
                                    "",
                                    ""
                                ],
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: [
                            (0, $hDyx2.styles)(theme).layout.header.navigation.main,
                            overrideCss?.navigation.main,
                            "",
                            ""
                        ],
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $SYApi.NavigationButton), {
                                css: [
                                    (0, $hDyx2.styles)(theme).layout.header.navigation.button,
                                    overrideCss?.navigation.button,
                                    "",
                                    ""
                                ],
                                onClick: ()=>handleBackwardClick(),
                                disabled: backwardDisabled,
                                "aria-label": "navigate backward",
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $5IqEP.icons).ArrowLeft, {
                                    css: [
                                        (0, $hDyx2.styles)(theme).layout.header.navigation.icon,
                                        overrideCss?.navigation.icon,
                                        "",
                                        ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $SYApi.NavigationButton), {
                                css: [
                                    (0, $hDyx2.styles)(theme).layout.header.navigation.button,
                                    overrideCss?.navigation.button,
                                    "",
                                    ""
                                ],
                                onClick: ()=>handleForwardClick(),
                                disabled: forwardDisabled,
                                "aria-label": "navigate forward",
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $5IqEP.icons).ArrowRight, {
                                    css: [
                                        (0, $hDyx2.styles)(theme).layout.header.navigation.icon,
                                        overrideCss?.navigation.icon,
                                        "",
                                        ""
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $hDyx2.styles)(theme).layout.content.main,
                    overrideCss?.content.main,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: [
                        (0, $hDyx2.styles)(theme).layout.content.container.main,
                        overrideCss?.container.main,
                        "",
                        ""
                    ],
                    ref: containerRef,
                    children: children
                })
            })
        ]
    });
};
$75782a686457aed3$export$8d3fc14510f0efc9.propTypes = {
    title: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string.isRequired
};

});
parcelRegister("eCfBx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("2tbKl"))();

});
parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8c849a51633fc8b0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});



parcelRegister("3QbGE", function(module, exports) {

$parcel$export(module.exports, "NavigationButton", function () { return (parcelRequire("SYApi")).NavigationButton; });

var $SYApi = parcelRequire("SYApi");

});
parcelRegister("SYApi", function(module, exports) {

$parcel$export(module.exports, "NavigationButton", function () { return $0e4ca97570dd37c2$export$e2d1bd910e689283; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $eyLWn = parcelRequire("eyLWn");
const $0e4ca97570dd37c2$export$e2d1bd910e689283 = ({ children: children, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("button", {
        css: [
            (0, $eyLWn.styles)(theme).button.shared,
            attributes.disabled ? (0, $eyLWn.styles)(theme).button.disabled : (0, $eyLWn.styles)(theme).button.enabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: children
    });
};

});
parcelRegister("eyLWn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $aa5d889f3b2bd1dc$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $aa5d889f3b2bd1dc$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;&>svg>path{transition:fill 0.2s;}", ""),
            enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;&:hover>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}", "")
        }
    });

});



parcelRegister("5IqEP", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $741056d672bde16f$export$df03f54e09e486fa; });

var $95n6k = parcelRequire("95n6k");

var $6OZOc = parcelRequire("6OZOc");
const $741056d672bde16f$export$df03f54e09e486fa = {
    ArrowLeft: $95n6k.default,
    ArrowRight: $6OZOc.default
};

});
parcelRegister("95n6k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b2ea73422617b51$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $4b2ea73422617b51$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2.133c-5.45 0-9.867 4.418-9.867 9.867 0 5.45 4.418 9.867 9.867 9.867 5.45 0 9.867-4.418 9.867-9.867 0-5.45-4.418-9.867-9.867-9.867ZM.533 12C.533 5.667 5.667.533 12 .533S23.467 5.667 23.467 12 18.333 23.467 12 23.467.533 18.333.533 12Zm13.633-3.766a.8.8 0 0 1 0 1.132L11.53 12l2.635 2.634a.8.8 0 0 1-1.132 1.132l-3.2-3.2a.8.8 0 0 1 0-1.132l3.2-3.2a.8.8 0 0 1 1.132 0Z",
            fill: "#FFF"
        })
    });
var $4b2ea73422617b51$export$2e2bcd8739ae039 = $4b2ea73422617b51$var$SvgArrowLeft;

});

parcelRegister("6OZOc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20ddeaac79776722$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $20ddeaac79776722$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 2.133c-5.45 0-9.867 4.418-9.867 9.867 0 5.45 4.418 9.867 9.867 9.867 5.45 0 9.867-4.418 9.867-9.867 0-5.45-4.418-9.867-9.867-9.867ZM.533 12C.533 5.667 5.667.533 12 .533S23.467 5.667 23.467 12 18.333 23.467 12 23.467.533 18.333.533 12Zm9.301-3.766a.8.8 0 0 1 1.132 0l3.2 3.2a.8.8 0 0 1 0 1.132l-3.2 3.2a.8.8 0 0 1-1.132-1.132L12.47 12 9.834 9.366a.8.8 0 0 1 0-1.132Z",
            fill: "#FFF"
        })
    });
var $20ddeaac79776722$export$2e2bcd8739ae039 = $20ddeaac79776722$var$SvgArrowRight;

});


parcelRegister("hDyx2", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $87d21b31a80ec0b1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $87d21b31a80ec0b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $87d21b31a80ec0b1$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $87d21b31a80ec0b1$var$_ref2 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $87d21b31a80ec0b1$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $87d21b31a80ec0b1$var$_ref4 = {
    name: "1exrrsa",
    styles: "display:flex;margin-right:8px;&>svg{width:18px;height:18px;}"
};
var $87d21b31a80ec0b1$var$_ref5 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $87d21b31a80ec0b1$var$_ref6 = {
    name: "v4gdnl",
    styles: "padding-right:0px"
};
var $87d21b31a80ec0b1$var$_ref7 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
const $87d21b31a80ec0b1$export$9dd6ff9ea0189349 = (theme)=>({
        layout: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.content, ";margin-bottom:60px;", (0, $gln0L.mq).mobile($87d21b31a80ec0b1$var$_ref7), ";", ""),
            header: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:space-between;margin-bottom:24px;", (0, $gln0L.mq).mobile($87d21b31a80ec0b1$var$_ref6), ";", ""),
                title: {
                    main: $87d21b31a80ec0b1$var$_ref5,
                    text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";font-weight:bold;color:", theme.colors.secondary.light, ";", ""),
                    icon: $87d21b31a80ec0b1$var$_ref4
                },
                navigation: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>button:nth-of-type(1){margin-right:28px;}", (0, $gln0L.mq).mobile($87d21b31a80ec0b1$var$_ref3), ";", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    icon: $87d21b31a80ec0b1$var$_ref2
                }
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.content, ";", ""),
                container: {
                    main: $87d21b31a80ec0b1$var$_ref
                }
            }
        }
    });

});


parcelRegister("8BwiX", function(module, exports) {

$parcel$export(module.exports, "MainLayout", function () { return $e3c8f4ade21c7beb$export$93af822566053b3e; });

var $9awXB = parcelRequire("9awXB");

var $5wDoS = parcelRequire("5wDoS");
const $e3c8f4ade21c7beb$export$93af822566053b3e = ({ children: children })=>/*#__PURE__*/ (0, $9awXB.jsx)("main", {
        css: (0, $5wDoS.styles)().layout.main,
        children: children
    });
$e3c8f4ade21c7beb$export$93af822566053b3e.propTypes = {};

});
parcelRegister("5wDoS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0e90cc07b497e155$export$9dd6ff9ea0189349; });
function $0e90cc07b497e155$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0e90cc07b497e155$var$_ref = {
    name: "nizj86",
    styles: "display:flex;min-height:100vh"
};
const $0e90cc07b497e155$export$9dd6ff9ea0189349 = ()=>({
        layout: {
            main: $0e90cc07b497e155$var$_ref
        }
    });

});


parcelRegister("e1re8", function(module, exports) {

$parcel$export(module.exports, "ModalLayout", function () { return $062e9eb2541362fd$export$84cbdf36c27e9fa7; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $h1Mg1 = parcelRequire("h1Mg1");
const $062e9eb2541362fd$export$84cbdf36c27e9fa7 = ({ background: background = "solid", children: children, onOutsideClick: onOutsideClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: [
            (0, $h1Mg1.styles)(theme).modal.main,
            background === "solid" && (0, $h1Mg1.styles)(theme).modal.solid,
            background === "opaque" && (0, $h1Mg1.styles)(theme).modal.opaque,
            "",
            ""
        ],
        onClick: (e)=>onOutsideClick(e),
        "aria-hidden": "true",
        children: children
    });
};
$062e9eb2541362fd$export$84cbdf36c27e9fa7.propTypes = {};

});
parcelRegister("h1Mg1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $503e7978b827b209$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $503e7978b827b209$export$9dd6ff9ea0189349 = (theme)=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";z-index:", (0, $gln0L.z).app.modal, ";display:flex;flex-direction:column;overflow:hidden;overflow-y:scroll;display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;", ""),
            solid: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.primary.normal, ";", ""),
            opaque: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.primary.normal, "E4;", "")
        }
    });

});


parcelRegister("d6xWB", function(module, exports) {

$parcel$export(module.exports, "SectionsLayout", function () { return $e6f8a1928dda7407$export$33795262da82cdf8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("l59j7");
var $dRxFj = parcelRequire("dRxFj");

var $eD6oW = parcelRequire("eD6oW");
const $e6f8a1928dda7407$export$33795262da82cdf8 = ({ sections: sections })=>{
    const [currentSectionIndex, setCurrentSectionIndex] = (0, $bh6RR.useState)(0);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $eD6oW.styles)().sections.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eD6oW.styles)().sections.nav.main,
                children: sections.map(({ id: id, name: name }, idx)=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eD6oW.styles)().sections.nav.item,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dRxFj.Button), {
                            type: "button",
                            "aria-label": `select ${name}`,
                            active: currentSectionIndex === idx,
                            onClick: ()=>setCurrentSectionIndex(idx),
                            children: name
                        })
                    }, `section-layout-item-${id}`))
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eD6oW.styles)().sections.content,
                children: sections[currentSectionIndex].section
            })
        ]
    });
};
$e6f8a1928dda7407$export$33795262da82cdf8.propTypes = {};

});
parcelRegister("l59j7", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return (parcelRequire("dRxFj")).Button; });

var $dRxFj = parcelRequire("dRxFj");

});
parcelRegister("dRxFj", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $a344e78fde595e12$export$353f5b6fc5456de1; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $bfe3h = parcelRequire("bfe3h");
const $a344e78fde595e12$export$353f5b6fc5456de1 = ({ children: children, active: active, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("button", {
        css: [
            (0, $bfe3h.styles)(theme).button.main,
            active ? (0, $bfe3h.styles)(theme).button.active : (0, $bfe3h.styles)(theme).button.inactive,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $bfe3h.styles)(theme).button.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bfe3h.styles)(theme).button.content.children,
                children: children
            })
        })
    });
};
$a344e78fde595e12$export$353f5b6fc5456de1.propTypes = {};

});
parcelRegister("bfe3h", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d2e48c5c6997b2fd$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $d2e48c5c6997b2fd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d2e48c5c6997b2fd$var$_ref = {
    name: "16lvhbt",
    styles: "display:flex;justify-content:center;width:100%;min-width:0"
};
const $d2e48c5c6997b2fd$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;white-space:nowrap;cursor:pointer;overflow:hidden;transition:color 0.2s;min-width:0;height:44px;width:100%;", ""),
            active: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";border-bottom:2px solid ", theme.colors.accent.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
            inactive: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.dark, ";border-bottom:2px solid transparent;&:hover{color:", theme.colors.accent.normal, ";}", ""),
            content: {
                main: $d2e48c5c6997b2fd$var$_ref,
                children: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")
            }
        }
    });

});



parcelRegister("eD6oW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b2260d7dc56ddf13$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $b2260d7dc56ddf13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b2260d7dc56ddf13$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $b2260d7dc56ddf13$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $b2260d7dc56ddf13$var$_ref3 = {
    name: "7a6dt5",
    styles: "margin:50px 0px"
};
const $b2260d7dc56ddf13$export$9dd6ff9ea0189349 = ()=>({
        sections: {
            main: $b2260d7dc56ddf13$var$_ref3,
            nav: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-bottom:50px;&>div{", (0, $gln0L.mq).mobile($b2260d7dc56ddf13$var$_ref2), ";}&>div:not(:last-of-type){margin-right:32px;}", ""),
                item: /*#__PURE__*/ (0, $7hler.css)("", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:400px;", (0, $gln0L.mq).tablet($b2260d7dc56ddf13$var$_ref), ";", "")
            }
        }
    });

});



parcelRegister("6waMo", function(module, exports) {

$parcel$export(module.exports, "AppHeader", function () { return (parcelRequire("dqVAo")).AppHeader; });
$parcel$export(module.exports, "CardHeaderMobile", function () { return (parcelRequire("1NE1d")).CardHeaderMobile; });
$parcel$export(module.exports, "ImageComposition", function () { return (parcelRequire("fTvbo")).ImageComposition; });

var $dqVAo = parcelRequire("dqVAo");

var $1NE1d = parcelRequire("1NE1d");

var $fTvbo = parcelRequire("fTvbo");

});
parcelRegister("dqVAo", function(module, exports) {

$parcel$export(module.exports, "AppHeader", function () { return $94af3662fef0ef9d$export$9bd256435c34a030; });
// import { FC, useState } from 'react'

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $6Gpkq = parcelRequire("6Gpkq");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
var $9uBbu = parcelRequire("9uBbu");
parcelRequire("1TdPt");
var $l7e6s = parcelRequire("l7e6s");
parcelRequire("hbyxQ");
var $6Bdlp = parcelRequire("6Bdlp");
var $dyCiT = parcelRequire("dyCiT");

var $lWxYN = parcelRequire("lWxYN");
const $94af3662fef0ef9d$export$9bd256435c34a030 = ()=>{
    const theme = (0, $iwq56.u)();
    const { pathname: pathname } = (0, $99w1R.useLocation)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const isNavigationOpen = (0, $gNvvs.useAppSelector)((0, $6Gpkq.navigationSelectAppNavigationOpen));
    // TODO: consider to make search global or local
    // const searchTerm = useAppSelector(searchSelectTerm)
    // const [searchTerm, setSearchTerm] = useState('')
    return /*#__PURE__*/ (0, $9awXB.jsxs)("header", {
        css: (0, $lWxYN.styles)(theme).header.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lWxYN.styles)(theme).header.logo,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9uBbu.logos).RyddmLogo, {})
            }),
            pathname === (0, $b7fnN.Path).Library || pathname === (0, $b7fnN.Path).Charts ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lWxYN.styles)(theme).header.search
            }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {}),
            profile ? /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $lWxYN.styles)(theme).header.actions.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lWxYN.styles)(theme).header.actions.notifications,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6Bdlp.Notifications), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lWxYN.styles)(theme).header.actions.avatar,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dyCiT.UserMenu), {})
                    })
                ]
            }) : /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $lWxYN.styles)(theme).header.buttons,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                            "aria-label": "sign up",
                            appearance: "secondary",
                            onClick: ()=>dispatch((0, $9HBOX.authOpenSignupModal)()),
                            children: "Sign up"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                            "aria-label": "log in",
                            appearance: "primary",
                            onClick: ()=>dispatch((0, $9HBOX.authOpenLoginModal)()),
                            children: "Log in"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $lWxYN.styles)(theme).header.menu.main,
                children: [
                    profile && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lWxYN.styles)(theme).header.menu.notifications,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6Bdlp.Notifications), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lWxYN.styles)(theme).header.menu.actions.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $lWxYN.styles)(theme).header.menu.actions.button,
                            onClick: ()=>dispatch((0, $6Gpkq.navigationAppNavigationToggle)()),
                            type: "button",
                            "aria-label": "toggle navigation menu",
                            children: isNavigationOpen ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CrossCircle, {
                                css: [
                                    (0, $lWxYN.styles)(theme).header.menu.actions.icon.shared,
                                    (0, $lWxYN.styles)(theme).header.menu.actions.icon.close,
                                    "",
                                    ""
                                ]
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MenuLines, {
                                css: [
                                    (0, $lWxYN.styles)(theme).header.menu.actions.icon.shared,
                                    (0, $lWxYN.styles)(theme).header.menu.actions.icon.open,
                                    "",
                                    ""
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$94af3662fef0ef9d$export$9bd256435c34a030.propTypes = {};

});
parcelRegister("hbyxQ", function(module, exports) {

$parcel$export(module.exports, "Notifications", function () { return (parcelRequire("6Bdlp")).Notifications; });
$parcel$export(module.exports, "UserMenu", function () { return (parcelRequire("dyCiT")).UserMenu; });

var $6Bdlp = parcelRequire("6Bdlp");

var $dOj7J = parcelRequire("dOj7J");

var $dyCiT = parcelRequire("dyCiT");

});
parcelRegister("6Bdlp", function(module, exports) {

$parcel$export(module.exports, "Notifications", function () { return $831e782d6ab23aa5$export$36ba2f559d49a8f6; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $7J4Vi = parcelRequire("7J4Vi");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
parcelRequire("cJvLm");
var $day58 = parcelRequire("day58");
var $89C5W = parcelRequire("89C5W");

var $f9suj = parcelRequire("f9suj");
const $831e782d6ab23aa5$export$36ba2f559d49a8f6 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const { pathname: pathname } = (0, $99w1R.useLocation)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const notificationsUnreadCount = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationsUnreadCount));
    (0, $7J4Vi.useInterval)(()=>{
        // refetch unread notifications count every 10 seconds
        dispatch((0, $day58.notificationGetNotificationsUnreadCount)());
    }, 10000);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $f9suj.styles)(theme).notifications.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $f9suj.styles)(theme).notifications.button,
                onClick: ()=>navigate((0, $b7fnN.Path).Notifications),
                type: "button",
                "aria-label": "navigate to notifications page",
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Bell, {
                    css: [
                        (0, $f9suj.styles)(theme).notifications.icon.shared,
                        pathname.includes((0, $b7fnN.Path).Notifications) ? (0, $f9suj.styles)(theme).notifications.icon.active : (0, $f9suj.styles)(theme).notifications.icon.inactive,
                        "",
                        ""
                    ]
                })
            }),
            notificationsUnreadCount > 0 && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $f9suj.styles)(theme).notifications.count.shared,
                    notificationsUnreadCount < 100 ? (0, $f9suj.styles)(theme).notifications.count.circle : (0, $f9suj.styles)(theme).notifications.count.badge,
                    "",
                    ""
                ],
                children: (0, $1Fj5G.numbersFormatter)(notificationsUnreadCount)
            })
        ]
    });
};

});
parcelRegister("1O2TI", function(module, exports) {

$parcel$export(module.exports, "mergeArraysAtIndex", function () { return (parcelRequire("6Rkyy")).mergeArraysAtIndex; });
$parcel$export(module.exports, "importsLazy", function () { return (parcelRequire("5qa04")).importsLazy; });
$parcel$export(module.exports, "numbersFormatter", function () { return (parcelRequire("1Fj5G")).numbersFormatter; });
$parcel$export(module.exports, "audioDurationFormatter", function () { return (parcelRequire("1Fj5G")).audioDurationFormatter; });
$parcel$export(module.exports, "stringsCutter", function () { return (parcelRequire("4t4rd")).stringsCutter; });
$parcel$export(module.exports, "uuid", function () { return (parcelRequire("itWch")).uuid; });
$parcel$export(module.exports, "validateAvatarFile", function () { return (parcelRequire("lRNbG")).validateAvatarFile; });
$parcel$export(module.exports, "validateCoverFile", function () { return (parcelRequire("lRNbG")).validateCoverFile; });
$parcel$export(module.exports, "validateTrackFile", function () { return (parcelRequire("lRNbG")).validateTrackFile; });
$parcel$export(module.exports, "validatePostMediaFile", function () { return (parcelRequire("lRNbG")).validatePostMediaFile; });
$parcel$export(module.exports, "validateUsername", function () { return (parcelRequire("lRNbG")).validateUsername; });
$parcel$export(module.exports, "validateName", function () { return (parcelRequire("lRNbG")).validateName; });
$parcel$export(module.exports, "validateTrackName", function () { return (parcelRequire("lRNbG")).validateTrackName; });
$parcel$export(module.exports, "validateEmail", function () { return (parcelRequire("lRNbG")).validateEmail; });
$parcel$export(module.exports, "validatePassword", function () { return (parcelRequire("lRNbG")).validatePassword; });
$parcel$export(module.exports, "validateRepeatPassword", function () { return (parcelRequire("lRNbG")).validateRepeatPassword; });
$parcel$export(module.exports, "validatePostMessage", function () { return (parcelRequire("lRNbG")).validatePostMessage; });
$parcel$export(module.exports, "validateCommentMessage", function () { return (parcelRequire("lRNbG")).validateCommentMessage; });
$parcel$export(module.exports, "validateTipMessage", function () { return (parcelRequire("lRNbG")).validateTipMessage; });
$parcel$export(module.exports, "validateReportComplaint", function () { return (parcelRequire("lRNbG")).validateReportComplaint; });

var $6Rkyy = parcelRequire("6Rkyy");

var $5qa04 = parcelRequire("5qa04");

var $1Fj5G = parcelRequire("1Fj5G");

var $4t4rd = parcelRequire("4t4rd");

var $itWch = parcelRequire("itWch");

var $lRNbG = parcelRequire("lRNbG");

});
parcelRegister("6Rkyy", function(module, exports) {

$parcel$export(module.exports, "mergeArraysAtIndex", function () { return $3e24b7be2b92e0f1$export$fb8c283b853546f6; });
/**
 * Merges two arrays at specified index.
 *
 * Takes two arrays of any type and start index, returns merged array.
 *
 *
 * @param {any[]} arr1 - array of any type.
 * @param {any[]} arr2 - array of any type.
 * @param {number} startIndex - index to start merge from.
 * @returns {any[]} - result of merge of arr1 with arr2 at start index.
 *
 * @example
 * // Returns [1,2,3,undefined,undefined,6,7,8].
 * const cutString = mergeArraysAtIndex([1,2,3], [6,7,8], 4)
 */ const $3e24b7be2b92e0f1$export$fb8c283b853546f6 = (arr1, arr2, startIndex)=>{
    // append first array to result
    const result = [
        ...arr1
    ];
    // iterate over array to be merged to
    for(let i = 0; i < arr2.length; i += 1)result[startIndex + i] = arr2[i];
    return result;
};

});

parcelRegister("5qa04", function(module, exports) {

$parcel$export(module.exports, "importsLazy", function () { return $6755e46642d0a901$export$7e090d1bf5cee0b1; });

var $bh6RR = parcelRequire("bh6RR");
function $6755e46642d0a901$export$7e090d1bf5cee0b1(factory, name) {
    return Object.create({
        [name]: (0, $bh6RR.lazy)(()=>factory().then((module)=>({
                    default: module[name]
                })))
    });
}

});

parcelRegister("1Fj5G", function(module, exports) {

$parcel$export(module.exports, "numbersFormatter", function () { return $5f65eae5911309d5$export$873aaf10871ec6f; });
$parcel$export(module.exports, "audioDurationFormatter", function () { return $5f65eae5911309d5$export$81713a7a4f77c43b; });
/**
 * Converts a number into a string representation with appropriate characters.
 *
 * Takes number to convert and number of digits to return.
 *
 * @param number - number to convert.
 * @param digits - digits to add to the return (defaults to 1).
 * @returns converted string representation.
 *
 * @example
 * // Returns formatted number (1k).
 * const formattedNum = numbersFormatter(1000);
 */ const $5f65eae5911309d5$export$873aaf10871ec6f = (num, digits = 1)=>{
    const lookup = [
        {
            value: 1,
            symbol: ""
        },
        {
            value: 1e3,
            symbol: "k"
        },
        {
            value: 1e6,
            symbol: "M"
        },
        {
            value: 1e9,
            symbol: "G"
        },
        {
            value: 1e12,
            symbol: "T"
        },
        {
            value: 1e15,
            symbol: "P"
        },
        {
            value: 1e18,
            symbol: "E"
        }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const lookupItem = lookup.slice().reverse().find((item)=>num >= item.value);
    return lookupItem ? (num / lookupItem.value).toFixed(digits).replace(rx, "$1") + lookupItem.symbol : "0";
};
const $5f65eae5911309d5$export$81713a7a4f77c43b = (durationTime)=>{
    const min = Math.floor(durationTime / 60);
    const sec = Math.floor(durationTime - min * 60);
    // format - mm:ss
    const formatted = [
        min,
        sec
    ].map((n)=>n < 10 ? `0${n}` : n).join(":");
    return formatted;
};

});

parcelRegister("4t4rd", function(module, exports) {

$parcel$export(module.exports, "stringsCutter", function () { return $68ca6dd3cff8ced7$export$b6589b543c0953e5; });
/**
 * Cuts a string to the specified maximum length, adds three dots at the end.
 *
 * Takes max length and string to cut, returns cut string with three dots.
 *
 *
 * @param maxLength - maximum length of the resulting string (excluding the dots).
 * @param str - input string to be cut.
 * @returns cut string with three dots added at the end.
 *
 * @example
 * // Returns cut string (st...).
 * const cutString = stringsCutter("string", 5)
 */ const $68ca6dd3cff8ced7$export$b6589b543c0953e5 = (maxLength, str)=>{
    // Check if the input string is already shorter than or equal to the maximum length
    if (str.length <= maxLength) return str;
    // Cut the string to the specified maximum length and add three dots at the end
    const cutString = `${str.slice(0, maxLength - 3)}...`;
    return cutString;
};

});

parcelRegister("itWch", function(module, exports) {

$parcel$export(module.exports, "uuid", function () { return $c0534ec143272e0f$export$31b40729666a4ae0; });
/**
 * Generates RFC4122-compliant uuid v4.
 *
 * Generates uuid version 4 and returns it.
 *
 * @returns uuid version 4.
 *
 * @example
 * // Returns uuid version 4.
 * const uuid = uuid();
 */ const $c0534ec143272e0f$export$31b40729666a4ae0 = ()=>// @ts-ignore: Operator '+' cannot be applied to types 'number[]' and 'number'
    "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16) // eslint-disable-line no-bitwise
    );

});

parcelRegister("lRNbG", function(module, exports) {

$parcel$export(module.exports, "validateAvatarFile", function () { return $75383ef98c1e2db5$export$6893dbd105eee7e0; });
$parcel$export(module.exports, "validateCoverFile", function () { return $75383ef98c1e2db5$export$18ece6d9894880d1; });
$parcel$export(module.exports, "validateTrackFile", function () { return $75383ef98c1e2db5$export$4b3b1c63eea947e8; });
$parcel$export(module.exports, "validatePostMediaFile", function () { return $75383ef98c1e2db5$export$b89238738738a984; });
$parcel$export(module.exports, "validateUsername", function () { return $75383ef98c1e2db5$export$729c1ad6a2d5e1a2; });
$parcel$export(module.exports, "validateName", function () { return $75383ef98c1e2db5$export$b135c3f9b9f02308; });
$parcel$export(module.exports, "validateTrackName", function () { return $75383ef98c1e2db5$export$98b6632e76a5c811; });
$parcel$export(module.exports, "validateEmail", function () { return $75383ef98c1e2db5$export$18148d12c805c5b0; });
$parcel$export(module.exports, "validatePassword", function () { return $75383ef98c1e2db5$export$4d2a7159fda5dc93; });
$parcel$export(module.exports, "validateRepeatPassword", function () { return $75383ef98c1e2db5$export$d85688bc3c102ae0; });
$parcel$export(module.exports, "validatePostMessage", function () { return $75383ef98c1e2db5$export$c5370cfcf90498c0; });
$parcel$export(module.exports, "validateCommentMessage", function () { return $75383ef98c1e2db5$export$7ebc7aa6cf84a4e2; });
$parcel$export(module.exports, "validateTipMessage", function () { return $75383ef98c1e2db5$export$f624e131c2bec5cb; });
$parcel$export(module.exports, "validateReportComplaint", function () { return $75383ef98c1e2db5$export$49ad54cc2eedbc83; });
parcelRequire("krTeD");
var $auEWN = parcelRequire("auEWN");
var $i0PvU = parcelRequire("i0PvU");
var $512kQ = parcelRequire("512kQ");
var $lygIl = parcelRequire("lygIl");
var $9srzl = parcelRequire("9srzl");
var $620EQ = parcelRequire("620EQ");
const $75383ef98c1e2db5$export$6893dbd105eee7e0 = (file)=>{
    // validate file type
    if (!file.type.startsWith("image/")) return "File should be in a valid image format.";
    // validate file size
    const maxFileSize = (0, $620EQ.maxUserAvatarFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $75383ef98c1e2db5$export$18ece6d9894880d1 = (file)=>{
    // validate file type
    if (!file.type.startsWith("image/")) return "File should be in a valid image format.";
    // validate file size
    const maxFileSize = (0, $9srzl.maxTrackCoverFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $75383ef98c1e2db5$export$4b3b1c63eea947e8 = (file)=>{
    // validate file type
    if (!file.type.startsWith("audio/mpeg")) return "File should be in a valid MP3 format.";
    // validate file size
    const maxFileSize = (0, $9srzl.maxTrackFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $75383ef98c1e2db5$export$b89238738738a984 = (file)=>{
    // validate file type
    if (!file.type.startsWith("image/") && !file.type.startsWith("video/")) return "File should be in a valid image or video format.";
    // validate file size
    const maxFileSize = (0, $i0PvU.maxPostMediaFileSize);
    if (file.size >= maxFileSize) return `File size exceeded. (max: ${maxFileSize / 1024 / 1024}MiB)`;
    return "";
};
const $75383ef98c1e2db5$export$729c1ad6a2d5e1a2 = (username)=>{
    // validate min length
    const minUsernameLength = (0, $620EQ.minUserUsernameLength);
    if (username.length < minUsernameLength) return `Username must be ${minUsernameLength} characters or longer.`;
    // validate max length
    const maxUsernameLength = (0, $620EQ.maxUserUsernameLength);
    if (username.length > maxUsernameLength) return `Username must be up to ${maxUsernameLength} characters.`;
    // username examples
    // const usernameExamples = [
    //   'user_name',
    //   'user_1234',
    //   'user1234',
    //   '__username',
    //   'username__',
    //   '0_username_1',
    // ]
    // const randomIndex = Math.floor(Math.random() * usernameExamples.length)
    // const exampleName = usernameExamples[randomIndex]
    // validate username
    const reName = /^[a-z0-9_]{3,16}$/;
    const res = String(username).match(reName);
    if (!res) return `Given username contains unacceptable characters or case.`;
    return "";
};
const $75383ef98c1e2db5$export$b135c3f9b9f02308 = (name)=>{
    // validate min length
    const minNameLength = (0, $620EQ.minUserNameLength);
    if (name.length < minNameLength) return `Name must be ${minNameLength} characters or longer.`;
    // validate max length
    const masNameLength = (0, $620EQ.maxUserNameLength);
    if (name.length > masNameLength) return `Name must be up to ${masNameLength} characters.`;
    // name examples
    // const nameExamples = [
    //   'James Smith',
    //   'James-Smith',
    //   'James_Smith',
    //   'James Smith 1',
    //   'James-Smith-1',
    //   'James_Smith_1',
    //   'J.Smith',
    //   'James, Smith',
    // ]
    // const randomIndex = Math.floor(Math.random() * nameExamples.length)
    // const exampleName = `${nameExamples[randomIndex]}`
    // validate name
    const reName = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19_,.'()\- ]{3,100}$/;
    const res = String(name).match(reName);
    if (!res) return `Given name contains unacceptable characters.`;
    return "";
};
const $75383ef98c1e2db5$export$98b6632e76a5c811 = (name)=>{
    // validate min length
    const minNameLength = (0, $9srzl.minTrackNameLength);
    if (name.length < minNameLength) return `Track name must be ${minNameLength} characters or longer.`;
    // validate max length
    const masNameLength = (0, $9srzl.maxTrackNameLength);
    if (name.length > masNameLength) return `Track name must be up to ${masNameLength} characters.`;
    // validate name
    const reName = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19_,.'()\- ]{3,100}$/;
    const res = String(name).match(reName);
    if (!res) return `Given name contains unaccepted characters.`;
    return "";
};
const $75383ef98c1e2db5$export$18148d12c805c5b0 = (email)=>{
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return !String(email).toLowerCase().match(re) ? "Invalid email address." : "";
};
const $75383ef98c1e2db5$export$4d2a7159fda5dc93 = (password)=>{
    // at least one upper case letter /(?=.*?[A-Z])/
    // at least one lower case letter /(?=.*?[a-z])/
    // at least one digit /(?=.*?[0-9])/
    // at least one special character, /(?=.*?[#?!@$%^&*-])/
    // all together /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
    // minimum eight characters
    const minPasswordLength = (0, $620EQ.minUserPasswordLength);
    if (password.length < minPasswordLength) return `Password must be ${minPasswordLength} characters or longer.`;
    // at least one number character
    const reNums = /(?=.*?[0-9])/;
    if (!password.match(reNums)) return "Password must contain a number.";
    // at least one special character
    const reSpecial = /(?=.*?[#~?!@$%^&*-])/;
    if (!password.match(reSpecial)) return "Password must contain a symbol (@$!%*#?&).";
    return "";
};
const $75383ef98c1e2db5$export$d85688bc3c102ae0 = (password, repeat)=>password === repeat ? "" : "Passwords don't match.";
const $75383ef98c1e2db5$export$c5370cfcf90498c0 = (message)=>{
    // validate min length
    const minMessageLength = (0, $i0PvU.minPostMessageLength);
    if (message.length < minMessageLength) return `Post message must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $i0PvU.maxPostMessageLength);
    if (message.length > maxMessageLength) return `Post message must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{3,1000}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Post message contains unaccepted characters.`;
    return "";
};
const $75383ef98c1e2db5$export$7ebc7aa6cf84a4e2 = (message)=>{
    // validate min length
    const minMessageLength = (0, $auEWN.minCommentMessageLength);
    if (message.length < minMessageLength) return `Comment message must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $auEWN.maxCommentMessageLength);
    if (message.length > maxMessageLength) return `Comment message must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{1,1000}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Comment message contains unaccepted characters.`;
    return "";
};
const $75383ef98c1e2db5$export$f624e131c2bec5cb = (message)=>{
    // validate min length
    const minMessageLength = (0, $lygIl.minTipMessageLength);
    if (message.length < minMessageLength) return `Tip message must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $lygIl.maxTipMessageLength);
    if (message.length > maxMessageLength) return `Tip message must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{1,256}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Tip message contains unaccepted characters.`;
    return "";
};
const $75383ef98c1e2db5$export$49ad54cc2eedbc83 = (message)=>{
    // validate min length
    const minMessageLength = (0, $512kQ.minReportComplaintLength);
    if (message.length < minMessageLength) return `Complaint must be ${minMessageLength} characters or longer.`;
    // validate max length
    const maxMessageLength = (0, $512kQ.maxReportComplaintLength);
    if (message.length > maxMessageLength) return `Complaint must be up to ${maxMessageLength} characters.`;
    // validate message
    const reMessage = /^[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19!-#%-\x2A,-/:;\x3F@\x5B-\x5D_\x7B}\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65$^+~<>| ]{1,256}$/;
    const res = String(message).match(reMessage);
    if (!res) return `Complaint contains unaccepted characters.`;
    return "";
};

});


parcelRegister("f9suj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $72c029d743c4e9d4$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $72c029d743c4e9d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $72c029d743c4e9d4$var$_ref = {
    name: "1iefybh",
    styles: "padding:0px 2px;border-radius:20px"
};
var $72c029d743c4e9d4$var$_ref2 = {
    name: "1cuh9u4",
    styles: "width:20px;border-radius:50%"
};
var $72c029d743c4e9d4$var$_ref3 = {
    name: "1sdieky",
    styles: "width:24px;height:24px;&>path{transition:fill 0.2s;}"
};
var $72c029d743c4e9d4$var$_ref4 = {
    name: "e14s2a",
    styles: "position:relative;display:flex;align-items:center;justify-content:center;width:40px;height:40px"
};
const $72c029d743c4e9d4$export$9dd6ff9ea0189349 = (theme)=>({
        notifications: {
            main: $72c029d743c4e9d4$var$_ref4,
            button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:40px;height:40px;cursor:pointer;&:hover>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            icon: {
                shared: $72c029d743c4e9d4$var$_ref3,
                active: /*#__PURE__*/ (0, $7hler.css)("&>path{fill:", theme.colors.accent.normal, ";}", ""),
                inactive: /*#__PURE__*/ (0, $7hler.css)("&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            count: {
                shared: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:-2px;right:2px;display:flex;align-items:center;justify-content:center;height:20px;color:", theme.colors.positive.darker, ";font-weight:bold;background-color:", theme.colors.accent.normal, ";", ""),
                circle: $72c029d743c4e9d4$var$_ref2,
                badge: $72c029d743c4e9d4$var$_ref
            }
        }
    });

});


parcelRegister("dOj7J", function(module, exports) {

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $cMkE4 = parcelRequire("cMkE4");
const $05176a44a381af33$export$55d7609a8f1eccd2 = ({ name: name, label: label, icon: Icon, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $cMkE4.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $cMkE4.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                css: (0, $cMkE4.styles)(theme).input.data,
                id: name,
                ...attributes
            }),
            Icon && /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {
                css: (0, $cMkE4.styles)(theme).input.icon
            })
        ]
    });
};

});
parcelRegister("cMkE4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $890b0b6035b4735d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $890b0b6035b4735d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $890b0b6035b4735d$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $890b0b6035b4735d$var$_ref2 = {
    name: "5ob2ly",
    styles: "display:flex;position:relative"
};
const $890b0b6035b4735d$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $890b0b6035b4735d$var$_ref2,
            label: $890b0b6035b4735d$var$_ref,
            data: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h6, ";color:", theme.colors.secondary.normal, ";border:1px solid ", theme.colors.secondary.darkHover, ";border-radius:10px;padding:8px 8px 8px 44px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";&~svg>path{fill:", theme.colors.accent.normal, ";}}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:6px;left:10px;width:30px;height:30px;&>path{transition:fill 0.2s;fill:", theme.colors.secondary.darkHover, ";}", "")
        }
    });

});


parcelRegister("dyCiT", function(module, exports) {

$parcel$export(module.exports, "UserMenu", function () { return $f0fe0d5211841533$export$72d0b49a56703654; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $gHHUR = parcelRequire("gHHUR");
parcelRequire("k9iZ0");
var $eBU64 = parcelRequire("eBU64");

var $8aBPR = parcelRequire("8aBPR");
const $f0fe0d5211841533$export$72d0b49a56703654 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $8aBPR.styles)(theme).menu.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8aBPR.styles)(theme).menu.avatar,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eBU64.Avatar), {})
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $8aBPR.styles)(theme).menu.options.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8aBPR.styles)(theme).menu.options.divider
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8aBPR.styles)(theme).menu.options.list.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsxs)("ul", {
                            css: (0, $8aBPR.styles)(theme).menu.options.list.ul,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("li", {
                                    css: (0, $8aBPR.styles)(theme).menu.options.list.li,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                        css: [
                                            (0, $8aBPR.styles)(theme).menu.options.list.button.shared,
                                            (0, $8aBPR.styles)(theme).menu.options.list.button.profile,
                                            "",
                                            ""
                                        ],
                                        onClick: ()=>navigate((0, $b7fnN.Path).Profile),
                                        type: "button",
                                        "aria-label": "navigate to profile page",
                                        children: "Profile"
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("li", {
                                    css: (0, $8aBPR.styles)(theme).menu.options.list.li,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                        css: [
                                            (0, $8aBPR.styles)(theme).menu.options.list.button.shared,
                                            (0, $8aBPR.styles)(theme).menu.options.list.button.logout,
                                            "",
                                            ""
                                        ],
                                        onClick: ()=>dispatch((0, $gHHUR.authSignout)()),
                                        type: "button",
                                        "aria-label": "log out",
                                        children: "Log out"
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("k9iZ0", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("eBU64")).Avatar; });

var $eBU64 = parcelRequire("eBU64");

});
parcelRegister("eBU64", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $ce8e70960f7e88a0$export$e2255cf6045e8d47; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");

var $77UJA = parcelRequire("77UJA");
const $ce8e70960f7e88a0$export$e2255cf6045e8d47 = ()=>{
    const theme = (0, $iwq56.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $bh6RR.useState)(false);
    const profileAvatar = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfileAvatar));
    const source = (0, $jpNoL.useFile)(profileAvatar || "");
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $77UJA.styles)(theme).avatar.main,
        children: profileAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
            css: (0, $77UJA.styles)(theme).avatar.content,
            onError: ()=>setAvatarLoadError(true),
            loading: "lazy",
            width: "40px",
            height: "40px",
            src: source,
            alt: "user avatar"
        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
            css: (0, $77UJA.styles)(theme).avatar.icon
        })
    });
};

});
parcelRegister("77UJA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $189aeacd5f16abb9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $189aeacd5f16abb9$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:50%;background-color:", theme.colors.primary.darker, ";overflow:hidden;", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("width:20px;height:20px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
        }
    });

});



parcelRegister("8aBPR", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $098573bc7a241778$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $098573bc7a241778$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $098573bc7a241778$var$_ref = {
    name: "qr8q5p",
    styles: "list-style:none"
};
var $098573bc7a241778$var$_ref2 = {
    name: "1kw2gd3",
    styles: "height:10px;width:100%;background-color:transparent"
};
var $098573bc7a241778$var$_ref3 = {
    name: "2vqn85",
    styles: "position:relative;&:hover div:nth-of-type(2){visibility:visible;opacity:1;}"
};
const $098573bc7a241778$export$9dd6ff9ea0189349 = (theme)=>({
        menu: {
            main: $098573bc7a241778$var$_ref3,
            avatar: /*#__PURE__*/ (0, $7hler.css)("", ""),
            options: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).app.header.menu, ";position:absolute;top:100%;right:50%;transform:translate(50%, 0%);visibility:hidden;opacity:0;transition:opacity 0.2s;", ""),
                divider: $098573bc7a241778$var$_ref2,
                list: {
                    main: /*#__PURE__*/ (0, $7hler.css)("width:100px;padding:2px 10px;border-radius:4px;border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.primary.darker, ";", ""),
                    ul: $098573bc7a241778$var$_ref,
                    li: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    button: {
                        shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:24px;cursor:pointer;font-weight:bold;white-space:nowrap;text-align:start;transition:color 0.2s;", ""),
                        profile: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        logout: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.negative.normal, ";&:hover{color:", theme.colors.negative.normalHover, ";}", "")
                    }
                }
            }
        }
    });

});



parcelRegister("lWxYN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fda37efb146b2aaa$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $fda37efb146b2aaa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fda37efb146b2aaa$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $fda37efb146b2aaa$var$_ref2 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $fda37efb146b2aaa$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $fda37efb146b2aaa$var$_ref4 = {
    name: "nkt64x",
    styles: "margin-right:10px"
};
var $fda37efb146b2aaa$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
var $fda37efb146b2aaa$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $fda37efb146b2aaa$var$_ref7 = {
    name: "r5hahk",
    styles: "margin-right:20px"
};
var $fda37efb146b2aaa$var$_ref8 = {
    name: "eivff4",
    styles: "display:none"
};
var $fda37efb146b2aaa$var$_ref9 = {
    name: "eivff4",
    styles: "display:none"
};
var $fda37efb146b2aaa$var$_ref10 = {
    name: "15o2f02",
    styles: "&>svg{width:120px;height:20px;}"
};
var $fda37efb146b2aaa$var$_ref11 = {
    name: "dzjsdb",
    styles: "display:inline-block;&>svg{width:140px;height:24px;}"
};
const $fda37efb146b2aaa$export$9dd6ff9ea0189349 = (theme)=>({
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.sides, ";", (0, $gln0L.helpers).app.header.height, ";", (0, $gln0L.helpers).app.header.width, ";display:flex;align-items:center;justify-content:space-between;background-color:", theme.colors.primary.normal, ";", ""),
            logo: /*#__PURE__*/ (0, $7hler.css)("display:none;margin-right:10px;", (0, $gln0L.mq).tablet($fda37efb146b2aaa$var$_ref11), " ", (0, $gln0L.mq).mobile($fda37efb146b2aaa$var$_ref10), ";", ""),
            search: /*#__PURE__*/ (0, $7hler.css)("margin-right:10px;max-width:236px;", (0, $gln0L.mq).tablet($fda37efb146b2aaa$var$_ref9), ";", ""),
            actions: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).tablet($fda37efb146b2aaa$var$_ref8), ";", ""),
                notifications: $fda37efb146b2aaa$var$_ref7,
                avatar: /*#__PURE__*/ (0, $7hler.css)("", "")
            },
            buttons: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>div:nth-of-type(1){margin-right:10px;}", (0, $gln0L.mq).tablet($fda37efb146b2aaa$var$_ref6), ";", ""),
            menu: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($fda37efb146b2aaa$var$_ref5), ";", ""),
                notifications: $fda37efb146b2aaa$var$_ref4,
                actions: {
                    main: $fda37efb146b2aaa$var$_ref3,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:40px;height:40px;cursor:pointer;&:hover>svg>path{color:", theme.colors.accent.normal, ";}", ""),
                    icon: {
                        shared: /*#__PURE__*/ (0, $7hler.css)("&>path{transition:color 0.2s;color:", theme.colors.secondary.normal, ";}", ""),
                        close: $fda37efb146b2aaa$var$_ref2,
                        open: $fda37efb146b2aaa$var$_ref
                    }
                }
            }
        }
    });

});


parcelRegister("1NE1d", function(module, exports) {

$parcel$export(module.exports, "CardHeaderMobile", function () { return $90346fd5c11deb6d$export$a3109477fc4ac830; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $9T1e6 = parcelRequire("9T1e6");
const $90346fd5c11deb6d$export$a3109477fc4ac830 = ({ onCloseClick: onCloseClick, hideClose: hideClose = false })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $9T1e6.styles)(theme).header.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {}),
            !hideClose && /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $9T1e6.styles)(theme).header.menu,
                onClick: (e)=>onCloseClick(e),
                type: "button",
                "aria-label": "close modal",
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CrossCircle, {})
            })
        ]
    });
};
$90346fd5c11deb6d$export$a3109477fc4ac830.propTypes = {};

});
parcelRegister("9T1e6", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $59aeb16e9ca6387e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $59aeb16e9ca6387e$export$9dd6ff9ea0189349 = (theme)=>({
        header: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:none;flex-shrink:0;display:flex;align-items:center;justify-content:space-between;height:", (0, $gln0L.constants).app.header.desktop.height, ";", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("height:", (0, $gln0L.constants).app.header.mobile.height, ";", "")), ";", ""),
            menu: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;cursor:pointer;width:40px;height:40px;&>svg{width:30px;height:30px;}&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.light, ";}&:hover{&>svg>path{transition:fill 0.2s;fill:", theme.colors.accent.normal, ";}}", "")
        }
    });

});


parcelRegister("fTvbo", function(module, exports) {

$parcel$export(module.exports, "ImageComposition", function () { return $37fd7659eca52fed$export$1e8c2afbe31cec0; });

var $9awXB = parcelRequire("9awXB");

var $7hfc2 = parcelRequire("7hfc2");

var $4v0JQ = parcelRequire("4v0JQ");
const $37fd7659eca52fed$export$1e8c2afbe31cec0 = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $4v0JQ.styles)().composition.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $4v0JQ.styles)().composition.grid.main,
            children: (0, $7hfc2.images).map((image, i)=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $4v0JQ.styles)().composition.grid.item(i),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                        css: (0, $4v0JQ.styles)().composition.grid.image,
                        src: image.image,
                        alt: "track album cover"
                    })
                }, image.id))
        })
    });
$37fd7659eca52fed$export$1e8c2afbe31cec0.propTypes = {};

});
parcelRegister("7hfc2", function(module, exports) {

$parcel$export(module.exports, "images", function () { return $28b6206e2622560b$export$6c746a5570b8b35c; });

var $g1Uup = parcelRequire("g1Uup");

var $kaDmN = parcelRequire("kaDmN");

var $itui7 = parcelRequire("itui7");

var $ia5hL = parcelRequire("ia5hL");

var $dUrJX = parcelRequire("dUrJX");

var $gzFVS = parcelRequire("gzFVS");

var $45hLb = parcelRequire("45hLb");

var $4XW9x = parcelRequire("4XW9x");

var $d1wmy = parcelRequire("d1wmy");
const $28b6206e2622560b$export$6c746a5570b8b35c = [
    {
        id: "7a134bb7-3842-4eec-bad2-8b2ad32e4038",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($g1Uup)))
    },
    {
        id: "08d0a206-dc40-4a1a-abe7-f9f5e0386625",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($kaDmN)))
    },
    {
        id: "0c956389-91b3-47bb-95be-654c668904c5",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($itui7)))
    },
    {
        id: "85a10454-08c5-4a96-b377-1030d09f0456",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($ia5hL)))
    },
    {
        id: "f252a756-7dae-4c3c-8669-88b685eec0d8",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($dUrJX)))
    },
    {
        id: "9a12ab6a-74e9-4c81-96c4-fc65f3e7b488",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($gzFVS)))
    },
    {
        id: "5a8118f3-c30b-4db4-9ba4-82d2c424cf7f",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($45hLb)))
    },
    {
        id: "97164e2f-73cc-498b-9beb-2b2b6bf0c553",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($4XW9x)))
    },
    {
        id: "a4ca7805-4676-4449-abb6-5eeeb9ef005b",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($d1wmy)))
    }
];

});
parcelRegister("g1Uup", function(module, exports) {
module.exports = new URL("cover_01.e2d3afdf.webp", import.meta.url).toString();

});

parcelRegister("kaDmN", function(module, exports) {
module.exports = new URL("cover_02.b2e18193.webp", import.meta.url).toString();

});

parcelRegister("itui7", function(module, exports) {
module.exports = new URL("cover_03.bee7b8fe.webp", import.meta.url).toString();

});

parcelRegister("ia5hL", function(module, exports) {
module.exports = new URL("cover_04.7bafb92c.webp", import.meta.url).toString();

});

parcelRegister("dUrJX", function(module, exports) {
module.exports = new URL("cover_05.7203e2c5.webp", import.meta.url).toString();

});

parcelRegister("gzFVS", function(module, exports) {
module.exports = new URL("cover_06.68f2c7fa.webp", import.meta.url).toString();

});

parcelRegister("45hLb", function(module, exports) {
module.exports = new URL("cover_07.778f41a6.webp", import.meta.url).toString();

});

parcelRegister("4XW9x", function(module, exports) {
module.exports = new URL("cover_08.99d7fee0.webp", import.meta.url).toString();

});

parcelRegister("d1wmy", function(module, exports) {
module.exports = new URL("cover_09.1d3a64cb.webp", import.meta.url).toString();

});


parcelRegister("4v0JQ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $80e877109f48c68c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $80e877109f48c68c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $80e877109f48c68c$var$_ref = {
    name: "czcgto",
    styles: "grid-row:1/span 2;grid-column:3/span 2"
};
var $80e877109f48c68c$var$_ref2 = {
    name: "olau56",
    styles: "display:grid;grid-template-rows:repeat(2, 145px);grid-template-columns:repeat(6, 145px);grid-gap:10px"
};
var $80e877109f48c68c$var$_ref3 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $80e877109f48c68c$export$9dd6ff9ea0189349 = ()=>({
        composition: {
            main: $80e877109f48c68c$var$_ref3,
            grid: {
                main: $80e877109f48c68c$var$_ref2,
                item: (index)=>{
                    switch(index){
                        case 4:
                            return $80e877109f48c68c$var$_ref;
                        default:
                            return /*#__PURE__*/ (0, $7hler.css)("", "");
                    }
                },
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px;", "")
            }
        }
    });

});




parcelRegister("3dg1C", function(module, exports) {

$parcel$export(module.exports, "ModalCard", function () { return (parcelRequire("dge5L")).ModalCard; });
$parcel$export(module.exports, "ModalFooterDesktop", function () { return (parcelRequire("iEiFm")).ModalFooterDesktop; });

var $dge5L = parcelRequire("dge5L");

var $iEiFm = parcelRequire("iEiFm");

});
parcelRegister("dge5L", function(module, exports) {

$parcel$export(module.exports, "ModalCard", function () { return $a8ee47d43c10890b$export$265e2dc45c2d5635; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $fTvbo = parcelRequire("fTvbo");
parcelRequire("h7Kwa");
var $5tuL0 = parcelRequire("5tuL0");
var $iTcv2 = parcelRequire("iTcv2");
var $hJV6r = parcelRequire("hJV6r");

var $cHptu = parcelRequire("cHptu");
const $a8ee47d43c10890b$export$265e2dc45c2d5635 = ({ onCloseClick: onCloseClick, onSignupClick: onSignupClick, onLoginClick: onLoginClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $cHptu.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cHptu.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: (e)=>onCloseClick(e)
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cHptu.styles)(theme).card.composition,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTvbo.ImageComposition), {})
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cHptu.styles)(theme).card.description,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $5tuL0.CardDescription), {
                    title: "Unlock the world of music",
                    subtitle: "Create your free RYDDM account",
                    accentStart: 17,
                    accentEnd: 22
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $cHptu.styles)(theme).card.buttons,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $hJV6r.CardSignup), {
                        onSignupClick: (e)=>onSignupClick(e)
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $iTcv2.CardLogin), {
                        description: "Already have account?",
                        onLoginClick: (e)=>onLoginClick(e)
                    })
                ]
            })
        ]
    });
};
$a8ee47d43c10890b$export$265e2dc45c2d5635.propTypes = {};

});
parcelRegister("h7Kwa", function(module, exports) {

$parcel$export(module.exports, "CardDescription", function () { return (parcelRequire("5tuL0")).CardDescription; });
$parcel$export(module.exports, "CardLogin", function () { return (parcelRequire("iTcv2")).CardLogin; });
$parcel$export(module.exports, "CardSignup", function () { return (parcelRequire("hJV6r")).CardSignup; });

var $5tuL0 = parcelRequire("5tuL0");

var $iTcv2 = parcelRequire("iTcv2");

var $hJV6r = parcelRequire("hJV6r");

});
parcelRegister("5tuL0", function(module, exports) {

$parcel$export(module.exports, "CardDescription", function () { return $301da625d9685b2b$export$16e0ed4cb97c00d4; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $f25Pz = parcelRequire("f25Pz");
const $301da625d9685b2b$export$16e0ed4cb97c00d4 = ({ title: title, subtitle: subtitle, accentStart: accentStart, accentEnd: accentEnd })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $f25Pz.styles)(theme).description.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $f25Pz.styles)(theme).description.title,
                children: title
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $f25Pz.styles)(theme).description.subtitle,
                children: [
                    subtitle.slice(0, accentStart),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $f25Pz.styles)(theme).description.accent,
                        children: subtitle.slice(accentStart, accentEnd)
                    }),
                    subtitle.slice(accentEnd, subtitle.length)
                ]
            })
        ]
    });
};
$301da625d9685b2b$export$16e0ed4cb97c00d4.propTypes = {};

});
parcelRegister("f25Pz", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4b263a37542b6d85$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4b263a37542b6d85$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b263a37542b6d85$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
const $4b263a37542b6d85$export$9dd6ff9ea0189349 = (theme)=>({
        description: {
            main: $4b263a37542b6d85$var$_ref,
            title: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";font-weight:bold;margin-bottom:8px;", ""),
            subtitle: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;", ""),
            accent: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";", "")
        }
    });

});


parcelRegister("iTcv2", function(module, exports) {

$parcel$export(module.exports, "CardLogin", function () { return $aa42fc2622719353$export$418447c82f083ecd; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $2n4Xr = parcelRequire("2n4Xr");
const $aa42fc2622719353$export$418447c82f083ecd = ({ description: description, onLoginClick: onLoginClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $2n4Xr.styles)(theme).login.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                css: (0, $2n4Xr.styles)(theme).login.text,
                children: description
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $2n4Xr.styles)(theme).login.button,
                onClick: (e)=>onLoginClick(e),
                type: "button",
                "aria-label": "log in",
                children: "Log in"
            })
        ]
    });
};
$aa42fc2622719353$export$418447c82f083ecd.propTypes = {};

});
parcelRegister("2n4Xr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $937fa3ca36fa2511$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $937fa3ca36fa2511$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $937fa3ca36fa2511$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
const $937fa3ca36fa2511$export$9dd6ff9ea0189349 = (theme)=>({
        login: {
            main: $937fa3ca36fa2511$var$_ref,
            text: /*#__PURE__*/ (0, $7hler.css)("", ""),
            button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-weight:bold;color:", theme.colors.secondary.normal, ";padding:10px 12px;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
        }
    });

});


parcelRegister("hJV6r", function(module, exports) {

$parcel$export(module.exports, "CardSignup", function () { return $f297ee65ef6dd3d2$export$e9db94a7d0e08e46; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("1TdPt");
var $l7e6s = parcelRequire("l7e6s");

var $c6OkO = parcelRequire("c6OkO");
const $f297ee65ef6dd3d2$export$e9db94a7d0e08e46 = ({ onSignupClick: onSignupClick })=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $c6OkO.styles)().signup.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $c6OkO.styles)().signup.button,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                "aria-label": "sign up",
                appearance: "primary",
                onClick: (e)=>onSignupClick(e),
                children: "Sign up"
            })
        })
    });
$f297ee65ef6dd3d2$export$e9db94a7d0e08e46.propTypes = {};

});
parcelRegister("c6OkO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c94d0ece8c185bb0$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c94d0ece8c185bb0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c94d0ece8c185bb0$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $c94d0ece8c185bb0$var$_ref2 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $c94d0ece8c185bb0$export$9dd6ff9ea0189349 = ()=>({
        signup: {
            main: $c94d0ece8c185bb0$var$_ref2,
            button: /*#__PURE__*/ (0, $7hler.css)("width:180px;flex-shrink:0;", (0, $gln0L.mq).mobile($c94d0ece8c185bb0$var$_ref), ";", "")
        }
    });

});



parcelRegister("cHptu", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c12b5fd13533e55d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c12b5fd13533e55d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c12b5fd13533e55d$var$_ref = {
    name: "1mqj4ex",
    styles: "margin-top:22px;&>div:nth-of-type(1){margin-bottom:24px;}"
};
var $c12b5fd13533e55d$var$_ref2 = {
    name: "12l3ktq",
    styles: "margin-bottom:auto"
};
var $c12b5fd13533e55d$var$_ref3 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c12b5fd13533e55d$var$_ref4 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $c12b5fd13533e55d$var$_ref5 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $c12b5fd13533e55d$var$_ref6 = {
    name: "1jxdg1d",
    styles: "width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $c12b5fd13533e55d$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background:linear-gradient(\n        180deg,\n        ", theme.colors.accent.darkHover, " 0%,\n        ", theme.colors.primary.normal, " 100%\n      );animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($c12b5fd13533e55d$var$_ref6), " ", (0, $gln0L.mq).mobile($c12b5fd13533e55d$var$_ref5), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($c12b5fd13533e55d$var$_ref4), ";", ""),
            composition: $c12b5fd13533e55d$var$_ref3,
            description: /*#__PURE__*/ (0, $7hler.css)("margin-bottom:42px;", (0, $gln0L.mq).tablet($c12b5fd13533e55d$var$_ref2), ";", ""),
            buttons: $c12b5fd13533e55d$var$_ref
        }
    });

});


parcelRegister("iEiFm", function(module, exports) {

$parcel$export(module.exports, "ModalFooterDesktop", function () { return $be225882002e391b$export$6afe37ac7af699df; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $13yFv = parcelRequire("13yFv");
const $be225882002e391b$export$6afe37ac7af699df = ({ onCloseClick: onCloseClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $13yFv.styles)(theme).footer.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
            css: (0, $13yFv.styles)(theme).footer.button,
            onClick: (e)=>onCloseClick(e),
            type: "button",
            "aria-label": "close modal",
            children: "Close"
        })
    });
};
$be225882002e391b$export$6afe37ac7af699df.propTypes = {};

});
parcelRegister("13yFv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $04246340303edf88$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $04246340303edf88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $04246340303edf88$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
const $04246340303edf88$export$9dd6ff9ea0189349 = (theme)=>({
        footer: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:center;animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($04246340303edf88$var$_ref), ";", ""),
            button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-size:", (0, $gln0L.typography).h6, ";color:", theme.colors.secondary.dark, ";transition:color 0.2s;padding:10px 12px;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
        }
    });

});



parcelRegister("7nicT", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $99b353f6a402c3ff$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $99b353f6a402c3ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $99b353f6a402c3ff$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $99b353f6a402c3ff$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($99b353f6a402c3ff$var$_ref), ";", "")
        }
    });

});


parcelRegister("11p3j", function(module, exports) {

$parcel$export(module.exports, "AuthLoginModal", function () { return (parcelRequire("29ZPY")).AuthLoginModal; });
$parcel$export(module.exports, "AuthResetModal", function () { return (parcelRequire("2hGWo")).AuthResetModal; });
$parcel$export(module.exports, "AuthSignupModal", function () { return (parcelRequire("3Veob")).AuthSignupModal; });
$parcel$export(module.exports, "AuthVerificationModal", function () { return (parcelRequire("dl1JL")).AuthVerificationModal; });

var $29ZPY = parcelRequire("29ZPY");

var $2hGWo = parcelRequire("2hGWo");

var $3Veob = parcelRequire("3Veob");

var $dl1JL = parcelRequire("dl1JL");

});
parcelRegister("29ZPY", function(module, exports) {

$parcel$export(module.exports, "AuthLoginModal", function () { return $d417d08cc124afbc$export$e9b16d2f6ca1e4ad; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("3OHDf");
var $gjhv2 = parcelRequire("gjhv2");

var $k9jgE = parcelRequire("k9jgE");
const $d417d08cc124afbc$export$e9b16d2f6ca1e4ad = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const loginModalOpen = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectLoginModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $k9jgE.styles)().modal.main,
        children: loginModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>dispatch((0, $9HBOX.authCloseLoginModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gjhv2.LoginCard), {})
        })
    });
};
$d417d08cc124afbc$export$e9b16d2f6ca1e4ad.propTypes = {};

});
parcelRegister("3OHDf", function(module, exports) {

$parcel$export(module.exports, "LoginCard", function () { return (parcelRequire("gjhv2")).LoginCard; });
$parcel$export(module.exports, "ResetCard", function () { return (parcelRequire("3uwER")).ResetCard; });
$parcel$export(module.exports, "SignupCard", function () { return (parcelRequire("1eVWm")).SignupCard; });
$parcel$export(module.exports, "VerificationCard", function () { return (parcelRequire("6qTKT")).VerificationCard; });
parcelRequire("jueLi");
var $gjhv2 = parcelRequire("gjhv2");
var $3uwER = parcelRequire("3uwER");
var $1eVWm = parcelRequire("1eVWm");
var $6qTKT = parcelRequire("6qTKT");

});
parcelRegister("jueLi", function(module, exports) {

$parcel$export(module.exports, "LoginCard", function () { return (parcelRequire("gjhv2")).LoginCard; });
$parcel$export(module.exports, "ResetCard", function () { return (parcelRequire("3uwER")).ResetCard; });
$parcel$export(module.exports, "SignupCard", function () { return (parcelRequire("1eVWm")).SignupCard; });
$parcel$export(module.exports, "VerificationCard", function () { return (parcelRequire("6qTKT")).VerificationCard; });

var $gjhv2 = parcelRequire("gjhv2");

var $3uwER = parcelRequire("3uwER");

var $1eVWm = parcelRequire("1eVWm");

var $6qTKT = parcelRequire("6qTKT");

});
parcelRegister("gjhv2", function(module, exports) {

$parcel$export(module.exports, "LoginCard", function () { return $a324def15550a099$export$25233b7fe55e5696; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $gHHUR = parcelRequire("gHHUR");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
parcelRequire("li8Yh");
var $fSr60 = parcelRequire("fSr60");
var $ahPK0 = parcelRequire("ahPK0");
var $l6su9 = parcelRequire("l6su9");
var $8td5r = parcelRequire("8td5r");

var $XBAFc = parcelRequire("XBAFc");
const $a324def15550a099$export$25233b7fe55e5696 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authLoading = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectLoading));
    const authError = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $XBAFc.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $XBAFc.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $9HBOX.authCloseLoginModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $XBAFc.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l6su9.CardTitle), {
                    title: "Log in to RYDDM",
                    accentStart: 10,
                    accentEnd: 15
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $XBAFc.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $XBAFc.styles)(theme).card.content.login,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $fSr60.CardButton), {
                                onClick: ()=>dispatch((0, $gHHUR.authLoginWithGoogle)()),
                                disabled: authLoading,
                                idp: "google",
                                text: "Continue with Google",
                                "aria-label": "login with google"
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $fSr60.CardButton), {
                                onClick: ()=>dispatch((0, $gHHUR.authLoginWithFacebook)()),
                                disabled: authLoading,
                                idp: "facebook",
                                text: "Continue with Facebook",
                                "aria-label": "login with facebook"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $XBAFc.styles)(theme).card.content.divider.top,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ahPK0.CardDivider), {
                            text: "or"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $XBAFc.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $8td5r.LoginForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $XBAFc.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $XBAFc.styles)(theme).card.content.reset.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $XBAFc.styles)(theme).card.content.reset.button,
                            onClick: ()=>{
                                dispatch((0, $9HBOX.authCloseLoginModal)());
                                dispatch((0, $9HBOX.authOpenResetModal)());
                            },
                            type: "button",
                            "aria-label": "reset password",
                            children: "Forgot your password"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $XBAFc.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ahPK0.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $XBAFc.styles)(theme).card.content.signup.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                css: (0, $XBAFc.styles)(theme).card.content.signup.title,
                                children: "Dont have an account?"
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                css: (0, $XBAFc.styles)(theme).card.content.signup.button,
                                onClick: ()=>{
                                    dispatch((0, $9HBOX.authCloseLoginModal)());
                                    dispatch((0, $9HBOX.authOpenSignupModal)());
                                },
                                type: "button",
                                "aria-label": "sign up",
                                children: "Sign up to RYDDM"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$a324def15550a099$export$25233b7fe55e5696.propTypes = {};

});
parcelRegister("li8Yh", function(module, exports) {

$parcel$export(module.exports, "CardButton", function () { return (parcelRequire("fSr60")).CardButton; });
$parcel$export(module.exports, "CardDivider", function () { return (parcelRequire("ahPK0")).CardDivider; });
$parcel$export(module.exports, "CardTitle", function () { return (parcelRequire("l6su9")).CardTitle; });
$parcel$export(module.exports, "LoginForm", function () { return (parcelRequire("8td5r")).LoginForm; });
$parcel$export(module.exports, "ResetForm", function () { return (parcelRequire("iYwW4")).ResetForm; });
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("kPwcM")).SignupForm; });
$parcel$export(module.exports, "VerificationForm", function () { return (parcelRequire("2MuOj")).VerificationForm; });

var $fSr60 = parcelRequire("fSr60");

var $ahPK0 = parcelRequire("ahPK0");

var $l6su9 = parcelRequire("l6su9");
parcelRequire("jDJSG");
var $8td5r = parcelRequire("8td5r");
var $iYwW4 = parcelRequire("iYwW4");
var $kPwcM = parcelRequire("kPwcM");
var $2MuOj = parcelRequire("2MuOj");

});
parcelRegister("fSr60", function(module, exports) {

$parcel$export(module.exports, "CardButton", function () { return $1aa143262d68f693$export$d4b8376576f53ef0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $s2jMX = parcelRequire("s2jMX");

var $hNhXr = parcelRequire("hNhXr");
const $1aa143262d68f693$export$d4b8376576f53ef0 = ({ idp: idp, text: text, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
        css: [
            (0, $hNhXr.styles)(theme).button.main,
            attributes.disabled ? (0, $hNhXr.styles)(theme).button.disabled : (0, $hNhXr.styles)(theme).button.enabled,
            "",
            ""
        ],
        type: "button",
        ...attributes,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $hNhXr.styles)(theme).button.content.icon,
                children: [
                    idp === "google" && /*#__PURE__*/ (0, $9awXB.jsx)((0, $s2jMX.icons).GoogleLogo, {}),
                    idp === "facebook" && /*#__PURE__*/ (0, $9awXB.jsx)((0, $s2jMX.icons).FacebookLogo, {})
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $hNhXr.styles)(theme).button.content.text.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $hNhXr.styles)(theme).button.content.text.text,
                    children: text
                })
            })
        ]
    });
};
$1aa143262d68f693$export$d4b8376576f53ef0.propTypes = {};

});
parcelRegister("s2jMX", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $4300f8ef2e4debab$export$df03f54e09e486fa; });

var $jXbRo = parcelRequire("jXbRo");

var $anBa0 = parcelRequire("anBa0");
const $4300f8ef2e4debab$export$df03f54e09e486fa = {
    FacebookLogo: $jXbRo.default,
    GoogleLogo: $anBa0.default
};

});
parcelRegister("jXbRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92210306e1c5b1d7$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $92210306e1c5b1d7$var$SvgFacebookLogo = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("circle", {
                cx: 16,
                cy: 16,
                r: 16,
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M14.097 20.223c-.082-1.066-.082-2.132-.163-3.28 0-.574-.246-.983-.902-.983-.41 0-.82.081-.902-.492-.082-.738-.246-1.558 0-2.296 0-.082.328-.246.492-.246 1.23.246 1.475-.41 1.475-1.393 0-2.624 2.214-4.017 5.083-3.853.82.082.82.737.82 1.311-.082.574.246 1.394-.82 1.394-.902-.082-1.557.246-1.557 1.312 0 .737.082 1.311.983 1.393 1.312.082 1.066.984 1.066 1.886.082.984-.41 1.312-1.312 1.312-.901 0-1.065.491-1.065 1.311 0 1.804 0 3.525-.082 5.329-.082 1.148-.328 1.23-1.886 1.148-1.066 0-1.23-.492-1.148-1.394-.164-.738-.164-1.558-.082-2.46Z",
                fill: "#0F0F0F"
            })
        ]
    });
var $92210306e1c5b1d7$export$2e2bcd8739ae039 = $92210306e1c5b1d7$var$SvgFacebookLogo;

});

parcelRegister("anBa0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c19848b3ba078c9$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $4c19848b3ba078c9$var$SvgGoogleLogo = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("g", {
            clipPath: "url('f1c49d078daedfe5')",
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("circle", {
                    cx: 16,
                    cy: 16,
                    r: 16,
                    fill: "#FFF"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                    d: "M21.248 10.838c-.433.516-.865.826-1.19 1.24-.54.722-.973.825-1.839.31-2.055-1.137-3.786-.62-5.516 1.238-1.298 1.343-1.406 3.409-.433 5.06 1.406 2.273 6.166 2.376 7.68.207.433-.62.216-1.136-.649-1.239-.54-.103-1.19.103-1.839 0-1.081-.103-1.514-.62-1.406-1.652 0-1.033.757-1.136 1.623-1.136 1.514 0 2.92 0 4.434.103 1.623.103 1.731.31 1.407 1.859 0 .207-.217.516-.217.723-.54 2.685-1.514 4.957-4.543 5.783-3.245.826-6.165.104-8.545-2.065-2.596-2.376-2.488-7.643.216-10.121 3.245-3.202 7.68-3.305 10.817-.31Z",
                    fill: "#0F0F0F"
                })
            ]
        })
    });
var $4c19848b3ba078c9$export$2e2bcd8739ae039 = $4c19848b3ba078c9$var$SvgGoogleLogo;

});


parcelRegister("hNhXr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $78b26049c2449639$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $78b26049c2449639$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $78b26049c2449639$var$_ref = {
    name: "62qxo5",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0"
};
var $78b26049c2449639$var$_ref2 = {
    name: "1c7wyvx",
    styles: "margin-right:26px"
};
var $78b26049c2449639$var$_ref3 = {
    name: "457mpb",
    styles: "padding:8px 26px"
};
var $78b26049c2449639$var$_ref4 = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
const $78b26049c2449639$export$9dd6ff9ea0189349 = (theme)=>({
        button: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;padding:12px 32px;cursor:pointer;width:100%;overflow:hidden;transition:border 0.2s,color 0.2s,background-color 0.2s;", (0, $gln0L.mq).tablet($78b26049c2449639$var$_ref4), " ", (0, $gln0L.mq).mobile($78b26049c2449639$var$_ref3), ";", ""),
            enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;color:", theme.colors.secondary.normal, ";border:1px solid ", theme.colors.secondary.normal, ";&:hover{border:1px solid ", theme.colors.accent.normal, ";}&>div:nth-of-type(1)>svg>g>circle{fill:", theme.colors.secondary.normal, ";}&>div:nth-of-type(1)>svg>circle{fill:", theme.colors.secondary.normal, ";}", ""),
            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;color:", theme.colors.secondary.darker, ";border:1px solid ", theme.colors.secondary.darker, ";&>div:nth-of-type(1)>svg>g>circle{fill:", theme.colors.secondary.darker, ";}&>div:nth-of-type(1)>svg>circle{fill:", theme.colors.secondary.darker, ";}", ""),
            content: {
                icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-right:32px;&>svg{width:32px;height:32px;}", (0, $gln0L.mq).mobile($78b26049c2449639$var$_ref2), ";", ""),
                text: {
                    main: $78b26049c2449639$var$_ref,
                    text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")
                }
            }
        }
    });

});


parcelRegister("ahPK0", function(module, exports) {

$parcel$export(module.exports, "CardDivider", function () { return $e1b692d26b30d178$export$ca04f93e3f5a6e48; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $bGohz = parcelRequire("bGohz");
const $e1b692d26b30d178$export$ca04f93e3f5a6e48 = ({ text: text = "" })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $bGohz.styles)(theme).divider.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bGohz.styles)(theme).divider.bar
            }),
            text && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bGohz.styles)(theme).divider.text.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: (0, $bGohz.styles)(theme).divider.text.text,
                    children: text
                })
            })
        ]
    });
};
$e1b692d26b30d178$export$ca04f93e3f5a6e48.propTypes = {};

});
parcelRegister("bGohz", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9c35a602e55f8862$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $9c35a602e55f8862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9c35a602e55f8862$var$_ref = {
    name: "5ob2ly",
    styles: "display:flex;position:relative"
};
const $9c35a602e55f8862$export$9dd6ff9ea0189349 = (theme)=>({
        divider: {
            main: $9c35a602e55f8862$var$_ref,
            bar: /*#__PURE__*/ (0, $7hler.css)("height:2px;width:100%;background-color:", theme.colors.secondary.darker, ";", ""),
            text: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);background-color:", theme.colors.primary.normal, ";", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";font-weight:bold;padding:4px 16px;", "")
            }
        }
    });

});


parcelRegister("l6su9", function(module, exports) {

$parcel$export(module.exports, "CardTitle", function () { return $27a6f6835ef8a0b6$export$474db65c3c394e1c; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $2Koef = parcelRequire("2Koef");
const $27a6f6835ef8a0b6$export$474db65c3c394e1c = ({ title: title, accentStart: accentStart = 0, accentEnd: accentEnd = 0 })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $2Koef.styles)(theme).title.main,
        children: [
            title.slice(0, accentStart),
            /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                css: (0, $2Koef.styles)(theme).title.accent,
                children: title.slice(accentStart, accentEnd)
            }),
            title.slice(accentEnd, title.length)
        ]
    });
};
$27a6f6835ef8a0b6$export$474db65c3c394e1c.propTypes = {};

});
parcelRegister("2Koef", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e82a38c7aba354e9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $e82a38c7aba354e9$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $7hler.css)("text-align:center;font-size:", (0, $gln0L.typography).h4, ";font-weight:bold;", ""),
            accent: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";", "")
        }
    });

});


parcelRegister("jDJSG", function(module, exports) {

$parcel$export(module.exports, "LoginForm", function () { return (parcelRequire("8td5r")).LoginForm; });
$parcel$export(module.exports, "ResetForm", function () { return (parcelRequire("iYwW4")).ResetForm; });
$parcel$export(module.exports, "SignupForm", function () { return (parcelRequire("kPwcM")).SignupForm; });
$parcel$export(module.exports, "VerificationForm", function () { return (parcelRequire("2MuOj")).VerificationForm; });

var $8td5r = parcelRequire("8td5r");

var $iYwW4 = parcelRequire("iYwW4");

var $kPwcM = parcelRequire("kPwcM");

var $2MuOj = parcelRequire("2MuOj");

});
parcelRegister("8td5r", function(module, exports) {

$parcel$export(module.exports, "LoginForm", function () { return $cf03035782c9634d$export$1f58f750f20f344b; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gHHUR = parcelRequire("gHHUR");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("ickpN");
var $6nxXb = parcelRequire("6nxXb");

var $fcss8 = parcelRequire("fcss8");
const $cf03035782c9634d$export$1f58f750f20f344b = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authLoading = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectLoading));
    const [email, setEmail] = (0, $bh6RR.useState)("");
    const [emailError, setEmailError] = (0, $bh6RR.useState)("");
    const [password, setPassword] = (0, $bh6RR.useState)("");
    const submitDisabled = password.length < 6 || email.length < 4 || emailError !== "" || authLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fcss8.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $fcss8.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $gHHUR.authLoginWithEmailAndPassword)({
                    email: email,
                    password: password
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fcss8.styles)().form.content.email,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6nxXb.FormInput), {
                        name: "email",
                        label: "email",
                        type: "email",
                        placeholder: "Enter your email",
                        value: email,
                        error: emailError.length > 0,
                        errorMessage: emailError,
                        onChange: (e)=>{
                            setEmail(e.target.value);
                        },
                        onBlur: ()=>setEmailError((0, $lRNbG.validateEmail)(email)),
                        onFocus: ()=>setEmailError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fcss8.styles)().form.content.password,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6nxXb.FormInput), {
                        name: "password",
                        label: "password",
                        type: "password",
                        placeholder: "Enter your password",
                        value: password,
                        onChange: (e)=>{
                            setPassword(e.target.value);
                        }
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fcss8.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "log in",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: authLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Log in"
                    })
                })
            ]
        })
    });
};
$cf03035782c9634d$export$1f58f750f20f344b.propTypes = {};

});
parcelRegister("ickpN", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return (parcelRequire("6nxXb")).FormInput; });

var $6nxXb = parcelRequire("6nxXb");

});
parcelRegister("6nxXb", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return $19dcfd6b3fe73f58$export$fd970bbd10854e43; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");

var $kFERM = parcelRequire("kFERM");

var $6rZKo = parcelRequire("6rZKo");
var $19dcfd6b3fe73f58$var$InputType;
(function(InputType) {
    InputType["Text"] = "text";
    InputType["Password"] = "password";
})($19dcfd6b3fe73f58$var$InputType || ($19dcfd6b3fe73f58$var$InputType = {}));
const $19dcfd6b3fe73f58$export$fd970bbd10854e43 = ({ name: name, label: label, error: error = false, errorMessage: errorMessage = "", ...attributes })=>{
    const theme = (0, $iwq56.u)();
    const [inputType, setInputType] = (0, $bh6RR.useState)(attributes.type);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $6rZKo.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $6rZKo.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $6rZKo.styles)(theme).input.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                        css: [
                            (0, $6rZKo.styles)(theme).input.data.shared,
                            attributes.value ? (0, $6rZKo.styles)(theme).input.data.filled : (0, $6rZKo.styles)(theme).input.data.empty,
                            error && (0, $6rZKo.styles)(theme).input.data.errored,
                            (inputType === "password" || inputType === "text") && (0, $6rZKo.styles)(theme).input.data.withIcon,
                            inputType === "password" && attributes.value && (0, $6rZKo.styles)(theme).input.data.password,
                            "",
                            ""
                        ],
                        id: name,
                        ...attributes,
                        type: inputType
                    }),
                    inputType === "password" && /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $6rZKo.styles)(theme).input.button.main,
                        onClick: ()=>setInputType("text"),
                        type: "button",
                        "aria-label": "open password",
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kFERM.icons).EyeClosed, {
                            css: (0, $6rZKo.styles)(theme).input.button.icon
                        })
                    }),
                    inputType === "text" && /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $6rZKo.styles)(theme).input.button.main,
                        onClick: ()=>setInputType("password"),
                        type: "button",
                        "aria-label": "hide password",
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kFERM.icons).EyeOpen, {
                            css: (0, $6rZKo.styles)(theme).input.button.icon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $6rZKo.styles)(theme).input.error.shared,
                    errorMessage ? (0, $6rZKo.styles)(theme).input.error.visible : (0, $6rZKo.styles)(theme).input.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: [
                        (0, $6rZKo.styles)(theme).input.error.text.shared,
                        errorMessage ? (0, $6rZKo.styles)(theme).input.error.text.visible : (0, $6rZKo.styles)(theme).input.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$19dcfd6b3fe73f58$export$fd970bbd10854e43.propTypes = {};

});
parcelRegister("kFERM", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $3b57d9ad63f50f4a$export$df03f54e09e486fa; });

var $7oln8 = parcelRequire("7oln8");

var $7qLmS = parcelRequire("7qLmS");
const $3b57d9ad63f50f4a$export$df03f54e09e486fa = {
    EyeOpen: $7oln8.default,
    EyeClosed: $7qLmS.default
};

});
parcelRegister("7oln8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66faac0cd510a4c6$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $66faac0cd510a4c6$var$SvgEyeOpen = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 11.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5ZM12.75 15a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 6.25c-4.514 0-7.555 2.704-9.32 4.997l-.031.041c-.4.518-.767.996-1.016 1.56-.267.605-.383 1.264-.383 2.152 0 .888.116 1.547.383 2.152.25.564.617 1.041 1.016 1.56l.032.041C7.445 21.046 10.486 23.75 15 23.75c4.514 0 7.555-2.704 9.32-4.997l.031-.041c.4-.518.767-.996 1.016-1.56.267-.605.383-1.264.383-2.152 0-.888-.116-1.547-.383-2.152-.25-.564-.617-1.042-1.016-1.56l-.032-.041C22.555 8.954 19.514 6.25 15 6.25Zm-8.13 5.912C8.498 10.045 11.15 7.75 15 7.75c3.85 0 6.501 2.295 8.13 4.412.44.57.696.91.865 1.292.158.358.255.795.255 1.546s-.097 1.188-.255 1.546c-.169.382-.426.722-.864 1.292C21.5 19.955 18.85 22.25 15 22.25c-3.85 0-6.501-2.295-8.13-4.412-.44-.57-.696-.91-.865-1.293-.158-.357-.255-.794-.255-1.545 0-.751.097-1.188.255-1.546.169-.382.426-.722.864-1.292Z",
                fill: "#FFF"
            })
        ]
    });
var $66faac0cd510a4c6$export$2e2bcd8739ae039 = $66faac0cd510a4c6$var$SvgEyeOpen;

});

parcelRegister("7qLmS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22b858697440b27d$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $22b858697440b27d$var$SvgEyeClosed = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M25.295 9.31a.75.75 0 0 1 .394.985L25 10l.69.295v.002l-.002.003-.003.007-.01.024-.039.084a13.871 13.871 0 0 1-.727 1.321 15.05 15.05 0 0 1-1.846 2.394l.968.968a.75.75 0 0 1-1.06 1.061l-1.001-1a11.548 11.548 0 0 1-2.274 1.497l.934 1.435a.75.75 0 1 1-1.258.818l-1.089-1.674c-.78.255-1.623.428-2.532.49V19.5a.75.75 0 0 1-1.5 0v-1.775c-.881-.06-1.7-.225-2.46-.467l-1.074 1.651a.75.75 0 0 1-1.258-.818l.913-1.402a11.502 11.502 0 0 1-2.293-1.49l-.96.96a.75.75 0 0 1-1.061-1.06l.924-.924a15.03 15.03 0 0 1-2.467-3.455 9.464 9.464 0 0 1-.188-.389l-.01-.024-.004-.007v-.003H4.31c0-.001 0-.002.689-.297l-.69.296a.75.75 0 0 1 1.379-.592v.002l.007.014.029.062a12.388 12.388 0 0 0 .65 1.177c.475.761 1.197 1.748 2.18 2.663.867.804 1.928 1.546 3.197 2.034A8.97 8.97 0 0 0 15 16.25a8.963 8.963 0 0 0 3.312-.62c1.262-.496 2.316-1.242 3.175-2.048a13.3 13.3 0 0 0 2.789-3.8l.028-.063.006-.013v-.001m.985-.394a.75.75 0 0 0-.984.394l.984-.394ZM5.69 9.704Z",
            fill: "#FFF"
        })
    });
var $22b858697440b27d$export$2e2bcd8739ae039 = $22b858697440b27d$var$SvgEyeClosed;

});


parcelRegister("6rZKo", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b23f156c6512cfae$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $b23f156c6512cfae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b23f156c6512cfae$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $b23f156c6512cfae$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $b23f156c6512cfae$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $b23f156c6512cfae$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $b23f156c6512cfae$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $b23f156c6512cfae$var$_ref6 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $b23f156c6512cfae$var$_ref7 = {
    name: "abijo8",
    styles: "right:26px"
};
var $b23f156c6512cfae$var$_ref8 = {
    name: "laomuu",
    styles: "padding-right:60px"
};
var $b23f156c6512cfae$var$_ref9 = {
    name: "1dvgrzx",
    styles: "height:50px;padding:12px 26px"
};
var $b23f156c6512cfae$var$_ref10 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $b23f156c6512cfae$var$_ref11 = {
    name: "eivff4",
    styles: "display:none"
};
var $b23f156c6512cfae$var$_ref12 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $b23f156c6512cfae$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $b23f156c6512cfae$var$_ref12,
            label: $b23f156c6512cfae$var$_ref11,
            data: {
                main: $b23f156c6512cfae$var$_ref10,
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:56px;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h6, ";color:", theme.colors.secondary.normal, ";border-radius:20px;padding:14px 32px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", (0, $gln0L.mq).mobile($b23f156c6512cfae$var$_ref9), ";", ""),
                empty: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.darkHover, ";&~button>svg>path{fill:", theme.colors.secondary.darkHover, ";}", ""),
                filled: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.normal, ";&~button>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                errored: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.negative.normal, ";", ""),
                withIcon: /*#__PURE__*/ (0, $7hler.css)("padding-right:70px;", (0, $gln0L.mq).mobile($b23f156c6512cfae$var$_ref8), ";", ""),
                password: /*#__PURE__*/ (0, $7hler.css)("letter-spacing:8px;font-size:", (0, $gln0L.typography).h4, ";", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("letter-spacing:6px;font-size:", (0, $gln0L.typography).h5, ";", "")), ";", "")
            },
            button: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;position:absolute;right:32px;top:50%;transform:translate(0%, -50%);&>path{transition:fill 0.2s;fill:", theme.colors.secondary.darkHover, ";}", (0, $gln0L.mq).mobile($b23f156c6512cfae$var$_ref7), ";", ""),
                icon: $b23f156c6512cfae$var$_ref6
            },
            error: {
                shared: $b23f156c6512cfae$var$_ref5,
                visible: $b23f156c6512cfae$var$_ref4,
                hidden: $b23f156c6512cfae$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $b23f156c6512cfae$var$_ref2,
                    hidden: $b23f156c6512cfae$var$_ref
                }
            }
        }
    });

});



parcelRegister("fcss8", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1d0a28b4542704bf$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $1d0a28b4542704bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1d0a28b4542704bf$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $1d0a28b4542704bf$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $1d0a28b4542704bf$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                email: $1d0a28b4542704bf$var$_ref2,
                password: $1d0a28b4542704bf$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("iYwW4", function(module, exports) {

$parcel$export(module.exports, "ResetForm", function () { return $d4acaaf6764d26b3$export$f4a155c4515f44cf; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $7J4Vi = parcelRequire("7J4Vi");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $gHHUR = parcelRequire("gHHUR");
parcelRequire("fWtjF");
var $fIhuQ = parcelRequire("fIhuQ");
var $29At8 = parcelRequire("29At8");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("ickpN");
var $6nxXb = parcelRequire("6nxXb");

var $fcjpk = parcelRequire("fcjpk");
const $d4acaaf6764d26b3$export$f4a155c4515f44cf = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authLoading = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectLoading));
    const [email, setEmail] = (0, $bh6RR.useState)("");
    const [emailError, setEmailError] = (0, $bh6RR.useState)("");
    const lastResetSec = (0, $fIhuQ.dateGetDifferenceSec)(parseInt((0, $29At8.storageGetSentPasswordResetEmailDate)() || "0", 10));
    const delaySec = 30;
    const initialSendDelay = lastResetSec > delaySec ? 0 : delaySec - lastResetSec;
    const [sendDelay, setSendDelay] = (0, $bh6RR.useState)(initialSendDelay);
    (0, $7J4Vi.useInterval)(()=>{
        if (sendDelay > 0) setSendDelay(sendDelay - 1);
    }, 1000);
    const submitDisabled = email.length < 4 || emailError !== "" || sendDelay > 0 || authLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fcjpk.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $fcjpk.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                setSendDelay(delaySec);
                dispatch((0, $gHHUR.authSendPasswordResetEmail)({
                    email: email
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fcjpk.styles)().form.content.email,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6nxXb.FormInput), {
                        name: "email",
                        label: "email",
                        type: "email",
                        placeholder: "Enter your email",
                        value: email,
                        error: emailError.length > 0,
                        errorMessage: emailError,
                        onChange: (e)=>{
                            setEmail(e.target.value);
                        },
                        onBlur: ()=>setEmailError((0, $lRNbG.validateEmail)(email)),
                        onFocus: ()=>setEmailError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fcjpk.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "Send password reset",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: ((loading, delay)=>{
                            // if loading render the loader
                            if (loading) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                width: 50,
                                height: 20,
                                appearance: "primary"
                            });
                            // if send delayed render the delay count
                            if (delay > 0) return `${delay}`;
                            return `Send`;
                        })(authLoading, sendDelay)
                    })
                })
            ]
        })
    });
};
$d4acaaf6764d26b3$export$f4a155c4515f44cf.propTypes = {};

});
parcelRegister("fcjpk", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $76ef6d91ea1111df$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $76ef6d91ea1111df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $76ef6d91ea1111df$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $76ef6d91ea1111df$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                email: $76ef6d91ea1111df$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("kPwcM", function(module, exports) {

$parcel$export(module.exports, "SignupForm", function () { return $8c27296b0e104a2e$export$cc15cfe224a6a69b; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $gHHUR = parcelRequire("gHHUR");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("ickpN");
var $6nxXb = parcelRequire("6nxXb");

var $lfzsY = parcelRequire("lfzsY");
const $8c27296b0e104a2e$export$cc15cfe224a6a69b = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authLoading = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectLoading));
    const [email, setEmail] = (0, $bh6RR.useState)("");
    const [emailError, setEmailError] = (0, $bh6RR.useState)("");
    const [password, setPassword] = (0, $bh6RR.useState)("");
    const [passwordError, setPasswordError] = (0, $bh6RR.useState)("");
    const [repeatPassword, setRepeatPassword] = (0, $bh6RR.useState)("");
    const [repeatPasswordError, setRepeatPasswordError] = (0, $bh6RR.useState)("");
    const submitDisabled = email.length < 4 || password.length < 6 || repeatPassword.length < 6 || emailError !== "" || passwordError !== "" || repeatPasswordError !== "" || authLoading;
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $lfzsY.styles)().form.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lfzsY.styles)().form.title.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lfzsY.styles)().form.title.text,
                    children: "Sign up with email and password"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
                css: (0, $lfzsY.styles)().form.content.main,
                onSubmit: (e)=>{
                    e.preventDefault();
                    dispatch((0, $gHHUR.authSignupWithEmailAndPassword)({
                        email: email,
                        password: password
                    }));
                },
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lfzsY.styles)().form.content.email,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6nxXb.FormInput), {
                            name: "email",
                            label: "email",
                            type: "email",
                            placeholder: "Enter your email",
                            value: email,
                            error: emailError.length > 0,
                            errorMessage: emailError,
                            onChange: (e)=>{
                                setEmail(e.target.value);
                            },
                            onBlur: ()=>setEmailError((0, $lRNbG.validateEmail)(email)),
                            onFocus: ()=>setEmailError("")
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lfzsY.styles)().form.content.password,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6nxXb.FormInput), {
                            name: "password",
                            label: "password",
                            type: "password",
                            placeholder: "Create a password",
                            value: password,
                            error: passwordError.length > 0,
                            errorMessage: passwordError,
                            onChange: (e)=>{
                                setPassword(e.target.value);
                            },
                            onBlur: ()=>setPasswordError((0, $lRNbG.validatePassword)(password)),
                            onFocus: ()=>setPasswordError("")
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lfzsY.styles)().form.content.repeat,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6nxXb.FormInput), {
                            name: "repeat password",
                            label: "repeat password",
                            type: "password",
                            placeholder: "Repeat password",
                            value: repeatPassword,
                            error: repeatPasswordError.length > 0,
                            errorMessage: repeatPasswordError,
                            onChange: (e)=>{
                                setRepeatPassword(e.target.value);
                            },
                            onBlur: ()=>setRepeatPasswordError((0, $lRNbG.validateRepeatPassword)(password, repeatPassword)),
                            onFocus: ()=>setRepeatPasswordError("")
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lfzsY.styles)().form.content.submit,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                            type: "submit",
                            "aria-label": "sign up",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: authLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                width: 50,
                                height: 20,
                                appearance: "primary"
                            }) : "Sign up"
                        })
                    })
                ]
            })
        ]
    });
};
$8c27296b0e104a2e$export$cc15cfe224a6a69b.propTypes = {};

});
parcelRegister("lfzsY", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bacdea90e68b4f84$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $bacdea90e68b4f84$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bacdea90e68b4f84$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $bacdea90e68b4f84$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $bacdea90e68b4f84$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $bacdea90e68b4f84$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $bacdea90e68b4f84$var$_ref5 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $bacdea90e68b4f84$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            title: {
                main: $bacdea90e68b4f84$var$_ref5,
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;text-align:center;", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                email: $bacdea90e68b4f84$var$_ref4,
                password: $bacdea90e68b4f84$var$_ref3,
                repeat: $bacdea90e68b4f84$var$_ref2,
                terms: $bacdea90e68b4f84$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("2MuOj", function(module, exports) {

$parcel$export(module.exports, "VerificationForm", function () { return $31922bf2ef815e40$export$12e8c6671acf18af; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $7J4Vi = parcelRequire("7J4Vi");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $gHHUR = parcelRequire("gHHUR");
parcelRequire("fWtjF");
var $fIhuQ = parcelRequire("fIhuQ");
var $29At8 = parcelRequire("29At8");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $4XQy1 = parcelRequire("4XQy1");
const $31922bf2ef815e40$export$12e8c6671acf18af = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authLoading = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectLoading));
    const lastResetSec = (0, $fIhuQ.dateGetDifferenceSec)(parseInt((0, $29At8.storageGetSentVerificationEmailDate)() || "0", 10));
    const delaySec = 30;
    const initialSendDelay = lastResetSec > delaySec ? 0 : delaySec - lastResetSec;
    const [sendDelay, setSendDelay] = (0, $bh6RR.useState)(initialSendDelay);
    (0, $7J4Vi.useInterval)(()=>{
        if (sendDelay > 0) setSendDelay(sendDelay - 1);
    }, 1000);
    const submitDisabled = sendDelay > 0 || authLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $4XQy1.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("form", {
            css: (0, $4XQy1.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                setSendDelay(delaySec);
                dispatch((0, $gHHUR.authSendVerificationEmail)());
            },
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $4XQy1.styles)().form.content.submit,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                    type: "submit",
                    "aria-label": "Send password reset",
                    disabled: submitDisabled,
                    appearance: "primary",
                    children: ((loading, delay)=>{
                        // if loading render the loader
                        if (loading) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        });
                        // if send delayed render the delay count
                        if (delay > 0) return `${delay}`;
                        return `Resend`;
                    })(authLoading, sendDelay)
                })
            })
        })
    });
};
$31922bf2ef815e40$export$12e8c6671acf18af.propTypes = {};

});
parcelRegister("4XQy1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $437e82f46b3d37e1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $437e82f46b3d37e1$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});




parcelRegister("XBAFc", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c7731465af9f1cfd$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c7731465af9f1cfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c7731465af9f1cfd$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $c7731465af9f1cfd$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $c7731465af9f1cfd$var$_ref3 = {
    name: "17vc17s",
    styles: "text-align:center;margin:0"
};
var $c7731465af9f1cfd$var$_ref4 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $c7731465af9f1cfd$var$_ref5 = {
    name: "1hvob47",
    styles: "display:flex;justify-content:center;margin-bottom:32px"
};
var $c7731465af9f1cfd$var$_ref6 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $c7731465af9f1cfd$var$_ref7 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $c7731465af9f1cfd$var$_ref8 = {
    name: "18vsq6y",
    styles: "margin-bottom:50px;&>button:nth-of-type(1){margin-bottom:16px;}"
};
var $c7731465af9f1cfd$var$_ref9 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $c7731465af9f1cfd$var$_ref10 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $c7731465af9f1cfd$var$_ref11 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $c7731465af9f1cfd$var$_ref12 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $c7731465af9f1cfd$var$_ref13 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $c7731465af9f1cfd$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($c7731465af9f1cfd$var$_ref13), " ", (0, $gln0L.mq).mobile($c7731465af9f1cfd$var$_ref12), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($c7731465af9f1cfd$var$_ref11), ";", ""),
            title: $c7731465af9f1cfd$var$_ref10,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($c7731465af9f1cfd$var$_ref9), ";", ""),
                login: $c7731465af9f1cfd$var$_ref8,
                form: $c7731465af9f1cfd$var$_ref7,
                error: $c7731465af9f1cfd$var$_ref6,
                reset: {
                    main: $c7731465af9f1cfd$var$_ref5,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                signup: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:center;", (0, $gln0L.mq).mobile($c7731465af9f1cfd$var$_ref4), ";", ""),
                    title: /*#__PURE__*/ (0, $7hler.css)("margin-right:8px;", (0, $gln0L.mq).mobile($c7731465af9f1cfd$var$_ref3), ";", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    top: $c7731465af9f1cfd$var$_ref2,
                    bottom: $c7731465af9f1cfd$var$_ref
                }
            }
        }
    });

});


parcelRegister("3uwER", function(module, exports) {

$parcel$export(module.exports, "ResetCard", function () { return $a3bddf4b36dad3e3$export$82ff2ce32135a9e4; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
parcelRequire("li8Yh");
var $ahPK0 = parcelRequire("ahPK0");
var $l6su9 = parcelRequire("l6su9");
var $iYwW4 = parcelRequire("iYwW4");

var $g3Cge = parcelRequire("g3Cge");
const $a3bddf4b36dad3e3$export$82ff2ce32135a9e4 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authError = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $g3Cge.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $g3Cge.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $9HBOX.authCloseResetModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $g3Cge.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l6su9.CardTitle), {
                    title: "Reset password"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $g3Cge.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $g3Cge.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iYwW4.ResetForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $g3Cge.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $g3Cge.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ahPK0.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $g3Cge.styles)(theme).card.content.login.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $g3Cge.styles)(theme).card.content.login.button,
                            onClick: ()=>{
                                dispatch((0, $9HBOX.authCloseResetModal)());
                                dispatch((0, $9HBOX.authOpenLoginModal)());
                            },
                            type: "button",
                            "aria-label": "log in",
                            children: "Log in to RYDDM"
                        })
                    })
                ]
            })
        ]
    });
};
$a3bddf4b36dad3e3$export$82ff2ce32135a9e4.propTypes = {};

});
parcelRegister("g3Cge", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4bf34ee0e43411e7$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4bf34ee0e43411e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4bf34ee0e43411e7$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $4bf34ee0e43411e7$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $4bf34ee0e43411e7$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $4bf34ee0e43411e7$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $4bf34ee0e43411e7$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4bf34ee0e43411e7$var$_ref6 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $4bf34ee0e43411e7$var$_ref7 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $4bf34ee0e43411e7$var$_ref8 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $4bf34ee0e43411e7$var$_ref9 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $4bf34ee0e43411e7$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($4bf34ee0e43411e7$var$_ref9), " ", (0, $gln0L.mq).mobile($4bf34ee0e43411e7$var$_ref8), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($4bf34ee0e43411e7$var$_ref7), ";", ""),
            title: $4bf34ee0e43411e7$var$_ref6,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($4bf34ee0e43411e7$var$_ref5), ";", ""),
                form: $4bf34ee0e43411e7$var$_ref4,
                error: $4bf34ee0e43411e7$var$_ref3,
                login: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:center;", (0, $gln0L.mq).mobile($4bf34ee0e43411e7$var$_ref2), ";", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    bottom: $4bf34ee0e43411e7$var$_ref
                }
            }
        }
    });

});


parcelRegister("1eVWm", function(module, exports) {

$parcel$export(module.exports, "SignupCard", function () { return $c4d831a27200b0ed$export$8581c745ab20309b; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $gHHUR = parcelRequire("gHHUR");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
parcelRequire("li8Yh");
var $fSr60 = parcelRequire("fSr60");
var $ahPK0 = parcelRequire("ahPK0");
var $l6su9 = parcelRequire("l6su9");
var $kPwcM = parcelRequire("kPwcM");

var $cdQ1P = parcelRequire("cdQ1P");
const $c4d831a27200b0ed$export$8581c745ab20309b = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authLoading = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectLoading));
    const authError = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $cdQ1P.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cdQ1P.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $9HBOX.authCloseSignupModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cdQ1P.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l6su9.CardTitle), {
                    title: "Sign up to RYDDM for free",
                    accentStart: 11,
                    accentEnd: 16
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $cdQ1P.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $cdQ1P.styles)(theme).card.content.signup,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $fSr60.CardButton), {
                                onClick: ()=>dispatch((0, $gHHUR.authLoginWithGoogle)()),
                                disabled: authLoading,
                                idp: "google",
                                text: "Continue with Google",
                                "aria-label": "login with google"
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $fSr60.CardButton), {
                                onClick: ()=>dispatch((0, $gHHUR.authLoginWithFacebook)()),
                                disabled: authLoading,
                                idp: "facebook",
                                text: "Continue with Facebook",
                                "aria-label": "login with facebook"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $cdQ1P.styles)(theme).card.content.divider.top,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ahPK0.CardDivider), {
                            text: "or"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $cdQ1P.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kPwcM.SignupForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $cdQ1P.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $cdQ1P.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ahPK0.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $cdQ1P.styles)(theme).card.content.login.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                css: (0, $cdQ1P.styles)(theme).card.content.login.title,
                                children: "Already have account?"
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                css: (0, $cdQ1P.styles)(theme).card.content.login.button,
                                onClick: ()=>{
                                    dispatch((0, $9HBOX.authCloseSignupModal)());
                                    dispatch((0, $9HBOX.authOpenLoginModal)());
                                },
                                type: "button",
                                "aria-label": "sign up",
                                children: "Log in to RYDDM"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$c4d831a27200b0ed$export$8581c745ab20309b.propTypes = {};

});
parcelRegister("cdQ1P", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d9ea905874ed1d7e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $d9ea905874ed1d7e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d9ea905874ed1d7e$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d9ea905874ed1d7e$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $d9ea905874ed1d7e$var$_ref3 = {
    name: "17vc17s",
    styles: "text-align:center;margin:0"
};
var $d9ea905874ed1d7e$var$_ref4 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $d9ea905874ed1d7e$var$_ref5 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d9ea905874ed1d7e$var$_ref6 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $d9ea905874ed1d7e$var$_ref7 = {
    name: "18vsq6y",
    styles: "margin-bottom:50px;&>button:nth-of-type(1){margin-bottom:16px;}"
};
var $d9ea905874ed1d7e$var$_ref8 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d9ea905874ed1d7e$var$_ref9 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $d9ea905874ed1d7e$var$_ref10 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $d9ea905874ed1d7e$var$_ref11 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $d9ea905874ed1d7e$var$_ref12 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $d9ea905874ed1d7e$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($d9ea905874ed1d7e$var$_ref12), " ", (0, $gln0L.mq).mobile($d9ea905874ed1d7e$var$_ref11), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($d9ea905874ed1d7e$var$_ref10), ";", ""),
            title: $d9ea905874ed1d7e$var$_ref9,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($d9ea905874ed1d7e$var$_ref8), ";", ""),
                signup: $d9ea905874ed1d7e$var$_ref7,
                form: $d9ea905874ed1d7e$var$_ref6,
                error: $d9ea905874ed1d7e$var$_ref5,
                login: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:center;", (0, $gln0L.mq).mobile($d9ea905874ed1d7e$var$_ref4), ";", ""),
                    title: /*#__PURE__*/ (0, $7hler.css)("margin-right:8px;", (0, $gln0L.mq).mobile($d9ea905874ed1d7e$var$_ref3), ";", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    top: $d9ea905874ed1d7e$var$_ref2,
                    bottom: $d9ea905874ed1d7e$var$_ref
                }
            }
        }
    });

});


parcelRegister("6qTKT", function(module, exports) {

$parcel$export(module.exports, "VerificationCard", function () { return $d876a9778cba91a3$export$4fab1ccea936c245; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $gHHUR = parcelRequire("gHHUR");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
parcelRequire("li8Yh");
var $ahPK0 = parcelRequire("ahPK0");
var $l6su9 = parcelRequire("l6su9");
var $2MuOj = parcelRequire("2MuOj");

var $3doCr = parcelRequire("3doCr");
const $d876a9778cba91a3$export$4fab1ccea936c245 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const authError = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectError));
    const authProfile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $3doCr.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3doCr.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>{},
                    hideClose: true
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3doCr.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l6su9.CardTitle), {
                    title: "Please check your email"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $3doCr.styles)(theme).card.subtitle.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $3doCr.styles)(theme).card.subtitle.text,
                        children: `We've sent a confirmation link to your email:`
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $3doCr.styles)(theme).card.subtitle.email,
                        children: authProfile?.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $3doCr.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3doCr.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2MuOj.VerificationForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3doCr.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: authError
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3doCr.styles)(theme).card.content.divider.bottom,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ahPK0.CardDivider), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3doCr.styles)(theme).card.content.login.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $3doCr.styles)(theme).card.content.login.button,
                            onClick: ()=>dispatch((0, $gHHUR.authSignout)()),
                            type: "button",
                            "aria-label": "log out",
                            children: "Log out"
                        })
                    })
                ]
            })
        ]
    });
};
$d876a9778cba91a3$export$4fab1ccea936c245.propTypes = {};

});
parcelRegister("3doCr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fcc22dc60e35f9d4$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $fcc22dc60e35f9d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fcc22dc60e35f9d4$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $fcc22dc60e35f9d4$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $fcc22dc60e35f9d4$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $fcc22dc60e35f9d4$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $fcc22dc60e35f9d4$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $fcc22dc60e35f9d4$var$_ref6 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $fcc22dc60e35f9d4$var$_ref7 = {
    name: "vhzsvc",
    styles: "display:flex;flex-direction:column;text-align:center;margin-bottom:32px"
};
var $fcc22dc60e35f9d4$var$_ref8 = {
    name: "j9ove5",
    styles: "margin-bottom:22px"
};
var $fcc22dc60e35f9d4$var$_ref9 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $fcc22dc60e35f9d4$var$_ref10 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $fcc22dc60e35f9d4$var$_ref11 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $fcc22dc60e35f9d4$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($fcc22dc60e35f9d4$var$_ref11), " ", (0, $gln0L.mq).mobile($fcc22dc60e35f9d4$var$_ref10), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($fcc22dc60e35f9d4$var$_ref9), ";", ""),
            title: $fcc22dc60e35f9d4$var$_ref8,
            subtitle: {
                main: $fcc22dc60e35f9d4$var$_ref7,
                text: $fcc22dc60e35f9d4$var$_ref6,
                email: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";color:", theme.colors.accent.normal, ";", "")
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($fcc22dc60e35f9d4$var$_ref5), ";", ""),
                form: $fcc22dc60e35f9d4$var$_ref4,
                error: $fcc22dc60e35f9d4$var$_ref3,
                login: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:center;", (0, $gln0L.mq).mobile($fcc22dc60e35f9d4$var$_ref2), ";", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;cursor:pointer;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                divider: {
                    bottom: $fcc22dc60e35f9d4$var$_ref
                }
            }
        }
    });

});




parcelRegister("k9jgE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d573636bb630c5ad$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $d573636bb630c5ad$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("2hGWo", function(module, exports) {

$parcel$export(module.exports, "AuthResetModal", function () { return $8a40b79d858aaa44$export$29305173138505c3; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("3OHDf");
var $3uwER = parcelRequire("3uwER");

var $25iPy = parcelRequire("25iPy");
const $8a40b79d858aaa44$export$29305173138505c3 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const resetModalOpen = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectResetModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $25iPy.styles)().modal.main,
        children: resetModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>dispatch((0, $9HBOX.authCloseResetModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $3uwER.ResetCard), {})
        })
    });
};
$8a40b79d858aaa44$export$29305173138505c3.propTypes = {};

});
parcelRegister("25iPy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4c4b6bbec567a587$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $4c4b6bbec567a587$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("3Veob", function(module, exports) {

$parcel$export(module.exports, "AuthSignupModal", function () { return $00e0ec8ee75c1728$export$2cdb240c8b859012; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("3OHDf");
var $1eVWm = parcelRequire("1eVWm");

var $dZhTL = parcelRequire("dZhTL");
const $00e0ec8ee75c1728$export$2cdb240c8b859012 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const signupModalOpen = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectSignupModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $dZhTL.styles)().modal.main,
        children: signupModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>dispatch((0, $9HBOX.authCloseSignupModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1eVWm.SignupCard), {})
        })
    });
};
$00e0ec8ee75c1728$export$2cdb240c8b859012.propTypes = {};

});
parcelRegister("dZhTL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $58670172b56ffd19$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $58670172b56ffd19$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("dl1JL", function(module, exports) {

$parcel$export(module.exports, "AuthVerificationModal", function () { return $f6989384b637b0ba$export$2793b46f9b27a7cb; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $7J4Vi = parcelRequire("7J4Vi");
parcelRequire("cJvLm");
var $gHHUR = parcelRequire("gHHUR");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("3OHDf");
var $6qTKT = parcelRequire("6qTKT");

var $cXFvP = parcelRequire("cXFvP");
const $f6989384b637b0ba$export$2793b46f9b27a7cb = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const emailVerified = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectEmailVerified));
    (0, $7J4Vi.useInterval)(()=>{
        if (!emailVerified) dispatch((0, $gHHUR.authCheckVerificationStatus)());
    }, 4000);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $cXFvP.styles)().modal.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "solid",
            onOutsideClick: ()=>{},
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6qTKT.VerificationCard), {})
        })
    });
};
$f6989384b637b0ba$export$2793b46f9b27a7cb.propTypes = {};

});
parcelRegister("cXFvP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4c6c0a757f170ea8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $4c6c0a757f170ea8$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});




parcelRegister("9HBOX", function(module, exports) {

$parcel$export(module.exports, "authSlice", function () { return $62c393eca862ddb2$export$a4617a4027bb509b; });
$parcel$export(module.exports, "authUpdateProfile", function () { return $62c393eca862ddb2$export$2193180e69fc5c9b; });
$parcel$export(module.exports, "authOpenJoinModal", function () { return $62c393eca862ddb2$export$a44d995955acf6fe; });
$parcel$export(module.exports, "authCloseJoinModal", function () { return $62c393eca862ddb2$export$af6daf84c0435a87; });
$parcel$export(module.exports, "authOpenLoginModal", function () { return $62c393eca862ddb2$export$2f3d09f176ff02e3; });
$parcel$export(module.exports, "authCloseLoginModal", function () { return $62c393eca862ddb2$export$d5a50ff831f0adc5; });
$parcel$export(module.exports, "authOpenResetModal", function () { return $62c393eca862ddb2$export$9e56764caac8044c; });
$parcel$export(module.exports, "authCloseResetModal", function () { return $62c393eca862ddb2$export$90bd896eca8cebff; });
$parcel$export(module.exports, "authOpenSignupModal", function () { return $62c393eca862ddb2$export$d53f523c53c6f9b2; });
$parcel$export(module.exports, "authCloseSignupModal", function () { return $62c393eca862ddb2$export$2ab011e3e0b7ad7f; });
$parcel$export(module.exports, "authSetPlatformUnlocked", function () { return $62c393eca862ddb2$export$5f89e63975dcdea6; });
$parcel$export(module.exports, "authSelectProfile", function () { return $62c393eca862ddb2$export$3bb8b93c38c5261d; });
$parcel$export(module.exports, "authSelectProfileAvatar", function () { return $62c393eca862ddb2$export$3ced2c24a889e1ae; });
$parcel$export(module.exports, "authSelectEmailVerified", function () { return $62c393eca862ddb2$export$81be7dfdceb313f9; });
$parcel$export(module.exports, "authSelectRefreshing", function () { return $62c393eca862ddb2$export$9ec47880503f4133; });
$parcel$export(module.exports, "authSelectPlatformLocked", function () { return $62c393eca862ddb2$export$22fef9034c0b6f2d; });
$parcel$export(module.exports, "authSelectJoinModalOpen", function () { return $62c393eca862ddb2$export$e635316c57f599f7; });
$parcel$export(module.exports, "authSelectLoginModalOpen", function () { return $62c393eca862ddb2$export$cc86fb31ea9f1a0c; });
$parcel$export(module.exports, "authSelectResetModalOpen", function () { return $62c393eca862ddb2$export$17b9074ad23d9db3; });
$parcel$export(module.exports, "authSelectSignupModalOpen", function () { return $62c393eca862ddb2$export$a0ab782f787ce114; });
$parcel$export(module.exports, "authSelectLoading", function () { return $62c393eca862ddb2$export$c8a5cb343ec50b5d; });
$parcel$export(module.exports, "authSelectError", function () { return $62c393eca862ddb2$export$46dda0454b918137; });
$parcel$export(module.exports, "authReducer", function () { return $62c393eca862ddb2$export$b3aa4dbb59e7857d; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $gHHUR = parcelRequire("gHHUR");
const $62c393eca862ddb2$var$initialState = {
    profile: null,
    emailVerified: false,
    refreshing: true,
    joinModal: {
        open: false
    },
    loginModal: {
        open: false
    },
    resetModal: {
        open: false
    },
    signupModal: {
        open: false
    },
    platformLocked: true,
    error: "",
    loading: false
};
const $62c393eca862ddb2$export$a4617a4027bb509b = (0, $kvj5V.createSlice)({
    name: "auth",
    initialState: $62c393eca862ddb2$var$initialState,
    reducers: {
        // update profile
        authUpdateProfile: (state, action)=>({
                ...state,
                profile: action.payload
            }),
        // open join modal
        authOpenJoinModal: (state)=>({
                ...state,
                joinModal: {
                    open: true
                }
            }),
        // close join modal
        authCloseJoinModal: (state)=>({
                ...state,
                joinModal: {
                    open: false
                }
            }),
        // open login modal
        authOpenLoginModal: (state)=>({
                ...state,
                error: "",
                loginModal: {
                    open: true
                }
            }),
        // close login modal
        authCloseLoginModal: (state)=>({
                ...state,
                loginModal: {
                    open: false
                }
            }),
        // open reset modal
        authOpenResetModal: (state)=>({
                ...state,
                error: "",
                resetModal: {
                    open: true
                }
            }),
        // close reset modal
        authCloseResetModal: (state)=>({
                ...state,
                resetModal: {
                    open: false
                }
            }),
        // open signup modal
        authOpenSignupModal: (state)=>({
                ...state,
                error: "",
                signupModal: {
                    open: true
                }
            }),
        // close signup modal
        authCloseSignupModal: (state)=>({
                ...state,
                signupModal: {
                    open: false
                }
            }),
        // unlock platform
        authSetPlatformUnlocked: (state)=>({
                ...state,
                platformLocked: false
            })
    },
    extraReducers: (builder)=>{
        // authenticate user
        builder.addCase((0, $gHHUR.authAuthenticateUser).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authAuthenticateUser).fulfilled, (state, { payload: payload })=>({
                ...state,
                profile: payload.profile,
                emailVerified: payload.emailVerified,
                error: payload.error,
                loading: false
            }));
        // refresh
        builder.addCase((0, $gHHUR.authRefresh).pending, (state)=>({
                ...state,
                loading: true,
                refreshing: true
            })).addCase((0, $gHHUR.authRefresh).fulfilled, (state, { payload: payload })=>({
                ...state,
                profile: payload.profile,
                emailVerified: payload.emailVerified,
                error: payload.error,
                loading: false,
                refreshing: false
            }));
        // sign up with email and password
        builder.addCase((0, $gHHUR.authSignupWithEmailAndPassword).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authSignupWithEmailAndPassword).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // log in with email and password
        builder.addCase((0, $gHHUR.authLoginWithEmailAndPassword).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authLoginWithEmailAndPassword).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // log in with google
        builder.addCase((0, $gHHUR.authLoginWithGoogle).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authLoginWithGoogle).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // log in with facebook
        builder.addCase((0, $gHHUR.authLoginWithFacebook).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authLoginWithFacebook).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // reset password
        builder.addCase((0, $gHHUR.authSendPasswordResetEmail).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authSendPasswordResetEmail).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // verify email
        builder.addCase((0, $gHHUR.authSendVerificationEmail).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authSendVerificationEmail).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // sign out
        builder.addCase((0, $gHHUR.authSignout).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authSignout).fulfilled, (state)=>({
                ...state,
                ...$62c393eca862ddb2$var$initialState,
                loading: false,
                refreshing: false
            }));
        // check email verification
        builder.addCase((0, $gHHUR.authCheckVerificationStatus).pending, (state)=>({
                ...state
            })).addCase((0, $gHHUR.authCheckVerificationStatus).fulfilled, (state, { payload: payload })=>({
                ...state,
                emailVerified: payload.emailVerified
            }));
        // unlock platform
        builder.addCase((0, $gHHUR.authUnlockPlatform).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $gHHUR.authUnlockPlatform).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
    }
});
const { authUpdateProfile: $62c393eca862ddb2$export$2193180e69fc5c9b, authOpenJoinModal: $62c393eca862ddb2$export$a44d995955acf6fe, authCloseJoinModal: $62c393eca862ddb2$export$af6daf84c0435a87, authOpenLoginModal: $62c393eca862ddb2$export$2f3d09f176ff02e3, authCloseLoginModal: $62c393eca862ddb2$export$d5a50ff831f0adc5, authOpenResetModal: $62c393eca862ddb2$export$9e56764caac8044c, authCloseResetModal: $62c393eca862ddb2$export$90bd896eca8cebff, authOpenSignupModal: $62c393eca862ddb2$export$d53f523c53c6f9b2, authCloseSignupModal: $62c393eca862ddb2$export$2ab011e3e0b7ad7f, authSetPlatformUnlocked: $62c393eca862ddb2$export$5f89e63975dcdea6 } = $62c393eca862ddb2$export$a4617a4027bb509b.actions;
const $62c393eca862ddb2$export$3bb8b93c38c5261d = (state)=>state.auth.profile;
const $62c393eca862ddb2$export$3ced2c24a889e1ae = (state)=>state.auth.profile?.avatarId;
const $62c393eca862ddb2$export$81be7dfdceb313f9 = (state)=>state.auth.emailVerified;
const $62c393eca862ddb2$export$9ec47880503f4133 = (state)=>state.auth.refreshing;
const $62c393eca862ddb2$export$22fef9034c0b6f2d = (state)=>state.auth.platformLocked;
const $62c393eca862ddb2$export$e635316c57f599f7 = (state)=>state.auth.joinModal.open;
const $62c393eca862ddb2$export$cc86fb31ea9f1a0c = (state)=>state.auth.loginModal.open;
const $62c393eca862ddb2$export$17b9074ad23d9db3 = (state)=>state.auth.resetModal.open;
const $62c393eca862ddb2$export$a0ab782f787ce114 = (state)=>state.auth.signupModal.open;
const $62c393eca862ddb2$export$c8a5cb343ec50b5d = (state)=>state.auth.loading;
const $62c393eca862ddb2$export$46dda0454b918137 = (state)=>state.auth.error;
const $62c393eca862ddb2$export$b3aa4dbb59e7857d = $62c393eca862ddb2$export$a4617a4027bb509b.reducer; // export default authSlice.reducer

});

parcelRegister("gHHUR", function(module, exports) {

$parcel$export(module.exports, "authAuthenticateUser", function () { return $08d6d171093e5655$export$3914058f8bb10993; });
$parcel$export(module.exports, "authRefresh", function () { return $08d6d171093e5655$export$f7c93eeb6ca3335b; });
$parcel$export(module.exports, "authSignupWithEmailAndPassword", function () { return $08d6d171093e5655$export$ecb9a44d05b171e6; });
$parcel$export(module.exports, "authLoginWithEmailAndPassword", function () { return $08d6d171093e5655$export$bb3e78703faa1054; });
$parcel$export(module.exports, "authLoginWithGoogle", function () { return $08d6d171093e5655$export$78ad7a7adb7c19fe; });
$parcel$export(module.exports, "authLoginWithFacebook", function () { return $08d6d171093e5655$export$7d108d78f207b530; });
$parcel$export(module.exports, "authSendPasswordResetEmail", function () { return $08d6d171093e5655$export$14c18d9c8a72a983; });
$parcel$export(module.exports, "authSendVerificationEmail", function () { return $08d6d171093e5655$export$6d4db7f58939d274; });
$parcel$export(module.exports, "authSignout", function () { return $08d6d171093e5655$export$609a29e630c259c9; });
$parcel$export(module.exports, "authCheckVerificationStatus", function () { return $08d6d171093e5655$export$78b89752e463380f; });
$parcel$export(module.exports, "authUnlockPlatform", function () { return $08d6d171093e5655$export$d058694af390bb5a; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $day58 = parcelRequire("day58");
var $7676a = parcelRequire("7676a");
var $aC3hJ = parcelRequire("aC3hJ");
var $8EUP6 = parcelRequire("8EUP6");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
var $2VHep = parcelRequire("2VHep");
var $1zjiQ = parcelRequire("1zjiQ");
var $29At8 = parcelRequire("29At8");
const $08d6d171093e5655$export$3914058f8bb10993 = (0, $kvj5V.createAsyncThunk)("auth/authAuthenticateUser", async (inp, { dispatch: dispatch })=>{
    // get api service
    let api = (0, $dOAPA.apiGetService)();
    try {
        // exchange auth token
        const { token: token } = await api.authApi.exchangeToken({
            authToken: inp.idToken
        });
        // save token to local storage
        (0, $29At8.storageSetAuthToken)(token);
        // update api service with auth token
        api = api.updateApiKey(token);
        // get subscribed user ids
        dispatch((0, $aC3hJ.subscriptionGetSubscribedUserIds)());
        dispatch((0, $aC3hJ.subscriptionGetSubscribedAtPeriodEndUserIds)());
        // get unlocked entity ids
        dispatch((0, $8EUP6.unlockGetUnlockedPostIds)());
        dispatch((0, $8EUP6.unlockGetUnlockedTrackIds)());
        // get liked entity ids
        dispatch((0, $4cq7L.likeGetFollowedUserIds)());
        dispatch((0, $4cq7L.likeGetLikedPostIds)());
        dispatch((0, $4cq7L.likeGetLikedTrackIds)());
        dispatch((0, $4cq7L.likeGetLikedCommentIds)());
        // get notification unread count
        dispatch((0, $day58.notificationGetNotificationsUnreadCount)());
        // fetch user profile
        const { user: user } = await api.userApi.getUserProfile();
        // if onboarding is not finished
        if (user?.onboardingStage !== (0, $2gpGl.EntityOnboardingStage).Finished) {
            const userRole = user?.role;
            const currentOnboardingStage = user?.onboardingStage;
            // set appropriate onboarding step for stepper
            dispatch((0, $7676a.onboardingSetCurrentStep)({
                userRole: userRole,
                currentOnboardingStage: currentOnboardingStage
            }));
        }
        // return profile and token in payload
        return {
            profile: user || {},
            emailVerified: inp.emailVerified,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            profile: null,
            emailVerified: false,
            error: message
        };
    }
});
const $08d6d171093e5655$export$f7c93eeb6ca3335b = (0, $kvj5V.createAsyncThunk)("auth/authRefresh", async (_, { dispatch: dispatch })=>{
    // get auth token from storage
    const tokenFromStorage = (0, $29At8.storageGetAuthToken)();
    // if no token in local storage
    if (!tokenFromStorage) // return empty payload (sign user out)
    return {
        profile: null,
        emailVerified: false,
        error: ""
    };
    // decode token
    const decodedToken = (0, $1zjiQ.jwtDecode)(tokenFromStorage);
    // calculate token expiration
    const expiresInDays = (0, $1zjiQ.jwtGetExpiresInDays)(decodedToken);
    const tokenExpired = expiresInDays <= 0;
    const tokenExpiresSoon = expiresInDays > 0 && expiresInDays <= 7;
    // check if email is verified
    const { emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $2VHep.firebaseGetEmailVerified)();
    // if error occurred
    if (errorMessage) // return empty payload (sign user out)
    return {
        profile: null,
        emailVerified: false,
        error: errorMessage
    };
    // get api service
    let api = (0, $dOAPA.apiGetService)();
    // if token is expired
    if (tokenExpired) {
        // clean local storage
        (0, $29At8.storageSetAuthToken)("");
        // return empty payload (sign user out)
        return {
            profile: null,
            emailVerified: false,
            error: ""
        };
    }
    try {
        // if token expires soon (in 7 days or less)
        if (tokenExpiresSoon) {
            // refresh token
            const { token: freshToken } = await api.authApi.refreshToken();
            // update token in local storage
            (0, $29At8.storageSetAuthToken)(freshToken);
            // update token in api service
            api = api.updateApiKey(freshToken);
        }
        // get subscribed user ids
        dispatch((0, $aC3hJ.subscriptionGetSubscribedUserIds)());
        dispatch((0, $aC3hJ.subscriptionGetSubscribedAtPeriodEndUserIds)());
        // get unlocked entity ids
        dispatch((0, $8EUP6.unlockGetUnlockedPostIds)());
        dispatch((0, $8EUP6.unlockGetUnlockedTrackIds)());
        // get liked entity ids
        dispatch((0, $4cq7L.likeGetFollowedUserIds)());
        dispatch((0, $4cq7L.likeGetLikedPostIds)());
        dispatch((0, $4cq7L.likeGetLikedTrackIds)());
        dispatch((0, $4cq7L.likeGetLikedCommentIds)());
        // get notification unread count
        dispatch((0, $day58.notificationGetNotificationsUnreadCount)());
        // fetch profile
        const { user: user } = await api.userApi.getUserProfile();
        // if onboarding is not finished
        if (user?.onboardingStage !== (0, $2gpGl.EntityOnboardingStage).Finished) {
            const userRole = user?.role;
            const currentOnboardingStage = user?.onboardingStage;
            // set appropriate onboarding step for stepper
            dispatch((0, $7676a.onboardingSetCurrentStep)({
                userRole: userRole,
                currentOnboardingStage: currentOnboardingStage
            }));
        }
        // return profile and token in payload
        return {
            profile: user || {},
            emailVerified: emailVerified,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            profile: null,
            emailVerified: false,
            error: message
        };
    }
});
const $08d6d171093e5655$export$ecb9a44d05b171e6 = (0, $kvj5V.createAsyncThunk)("auth/authSignupWithEmailAndPassword", async (inp, { dispatch: dispatch })=>{
    // firebase sign up with email and password
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $2VHep.firebaseSignupWithEmailAndPassword)(inp.email, inp.password);
    // update trigger date
    (0, $29At8.storageSetSentVerificationEmailDate)(Date.now().toString());
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($08d6d171093e5655$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $08d6d171093e5655$export$bb3e78703faa1054 = (0, $kvj5V.createAsyncThunk)("auth/authLoginWithEmailAndPassword", async (inp, { dispatch: dispatch })=>{
    // firebase login with email and password
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $2VHep.firebaseLoginWithEmailAndPassword)(inp.email, inp.password);
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($08d6d171093e5655$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $08d6d171093e5655$export$78ad7a7adb7c19fe = (0, $kvj5V.createAsyncThunk)("auth/authLoginWithGoogle", async (_, { dispatch: dispatch })=>{
    // firebase login with google
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $2VHep.firebaseLoginWithGoogle)();
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($08d6d171093e5655$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $08d6d171093e5655$export$7d108d78f207b530 = (0, $kvj5V.createAsyncThunk)("auth/authLoginWithFacebook", async (_, { dispatch: dispatch })=>{
    // firebase login with facebook
    const { idToken: idToken, emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $2VHep.firebaseLoginWithFacebook)();
    // if error occurred during authentication
    if (errorMessage) // return error message in payload
    return {
        error: errorMessage
    };
    // authenticate user
    dispatch($08d6d171093e5655$export$3914058f8bb10993({
        idToken: idToken,
        emailVerified: emailVerified
    }));
    return {
        error: ""
    };
});
const $08d6d171093e5655$export$14c18d9c8a72a983 = (0, $kvj5V.createAsyncThunk)("auth/authSendPasswordResetEmail", async (inp)=>{
    // firebase send password reset email
    const { errorMessage: errorMessage } = await (0, $2VHep.firebaseSendPasswordResetEmail)(inp.email);
    // update trigger date
    (0, $29At8.storageSetSentPasswordResetEmailDate)(Date.now().toString());
    return {
        error: errorMessage
    };
});
const $08d6d171093e5655$export$6d4db7f58939d274 = (0, $kvj5V.createAsyncThunk)("auth/authSendVerificationEmail", async ()=>{
    // firebase send verification email
    const { errorMessage: errorMessage } = await (0, $2VHep.firebaseSendVerificationEmail)();
    // update trigger date
    (0, $29At8.storageSetSentVerificationEmailDate)(Date.now().toString());
    return {
        error: errorMessage
    };
});
const $08d6d171093e5655$export$609a29e630c259c9 = (0, $kvj5V.createAsyncThunk)("auth/authSignout", async ()=>{
    // firebase sign out
    const { errorMessage: errorMessage } = await (0, $2VHep.firebaseSignout)();
    // clean up token from local storage
    (0, $29At8.storageSetAuthToken)("");
    // state is reset in authSignout.fulfilled
    // return error message in payload
    return {
        error: errorMessage
    };
});
const $08d6d171093e5655$export$78b89752e463380f = (0, $kvj5V.createAsyncThunk)("auth/authCheckVerificationStatus", async ()=>{
    // check email verification status
    const { emailVerified: emailVerified, errorMessage: errorMessage } = await (0, $2VHep.firebaseGetEmailVerified)();
    return {
        emailVerified: emailVerified,
        error: errorMessage
    };
});
const $08d6d171093e5655$export$d058694af390bb5a = (0, $kvj5V.createAsyncThunk)("auth/authUnlockPlatform", async (inp, { dispatch: dispatch })=>{
    // assert passphrase
    const passphrase = "ryddm2024";
    if (inp.passphrase === passphrase) {
        dispatch((0, $9HBOX.authSetPlatformUnlocked)());
        return {
            error: ""
        };
    }
    return {
        error: "Invalid passphrase"
    };
});

});


parcelRegister("hgzUM", function(module, exports) {

$parcel$export(module.exports, "CommentBlockModal", function () { return (parcelRequire("2Isj9")).CommentBlockModal; });
$parcel$export(module.exports, "CommentCard", function () { return (parcelRequire("f2RiN")).CommentCard; });
$parcel$export(module.exports, "CommentDeleteModal", function () { return (parcelRequire("6bwn8")).CommentDeleteModal; });
$parcel$export(module.exports, "CommentListPost", function () { return (parcelRequire("7eK4u")).CommentListPost; });
parcelRequire("byoM8");
var $2Isj9 = parcelRequire("2Isj9");
var $f2RiN = parcelRequire("f2RiN");
var $6bwn8 = parcelRequire("6bwn8");
var $7eK4u = parcelRequire("7eK4u");

var $e9SYA = parcelRequire("e9SYA");

var $klaOF = parcelRequire("klaOF");
$parcel$exportWildcard(module.exports, $e9SYA);
$parcel$exportWildcard(module.exports, $klaOF);

});
parcelRegister("byoM8", function(module, exports) {

$parcel$export(module.exports, "CommentBlockModal", function () { return (parcelRequire("2Isj9")).CommentBlockModal; });
$parcel$export(module.exports, "CommentCard", function () { return (parcelRequire("f2RiN")).CommentCard; });
$parcel$export(module.exports, "CommentDeleteModal", function () { return (parcelRequire("6bwn8")).CommentDeleteModal; });
$parcel$export(module.exports, "CommentListPost", function () { return (parcelRequire("7eK4u")).CommentListPost; });

var $2Isj9 = parcelRequire("2Isj9");

var $f2RiN = parcelRequire("f2RiN");

var $6bwn8 = parcelRequire("6bwn8");

var $7eK4u = parcelRequire("7eK4u");

});
parcelRegister("2Isj9", function(module, exports) {

$parcel$export(module.exports, "CommentBlockModal", function () { return $44cab80f2d6b9ba7$export$ad2878f8a39f20db; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $e9SYA = parcelRequire("e9SYA");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("bctMz");
var $6y3G9 = parcelRequire("6y3G9");

var $bdCgM = parcelRequire("bdCgM");
const $44cab80f2d6b9ba7$export$ad2878f8a39f20db = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const blockCommentModalOpen = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentBlockModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $bdCgM.styles)().modal.main,
        children: blockCommentModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $e9SYA.commentCloseCommentBlockModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bdCgM.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6y3G9.CommentBlockCard), {})
            })
        })
    });
};
$44cab80f2d6b9ba7$export$ad2878f8a39f20db.propTypes = {};

});
parcelRegister("bctMz", function(module, exports) {

$parcel$export(module.exports, "CommentBlockCard", function () { return (parcelRequire("6y3G9")).CommentBlockCard; });

var $6y3G9 = parcelRequire("6y3G9");

});
parcelRegister("6y3G9", function(module, exports) {

$parcel$export(module.exports, "CommentBlockCard", function () { return $99df876a5607c374$export$ac6e9c123167ba02; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $e9SYA = parcelRequire("e9SYA");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("iK6hi");
var $6e4IZ = parcelRequire("6e4IZ");

var $75thZ = parcelRequire("75thZ");
const $99df876a5607c374$export$ac6e9c123167ba02 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const commentBlockError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $75thZ.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $75thZ.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $e9SYA.commentCloseCommentBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $75thZ.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Block Comment",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $75thZ.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Are you sure you want to block this comment?"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $75thZ.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $75thZ.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6e4IZ.CommentBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $75thZ.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: commentBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$99df876a5607c374$export$ac6e9c123167ba02.propTypes = {};

});
parcelRegister("iK6hi", function(module, exports) {

$parcel$export(module.exports, "CommentBlockForm", function () { return (parcelRequire("6e4IZ")).CommentBlockForm; });

var $6e4IZ = parcelRequire("6e4IZ");

});
parcelRegister("6e4IZ", function(module, exports) {

$parcel$export(module.exports, "CommentBlockForm", function () { return $e132707004ed7c7f$export$fd64a2f495d11aa8; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("1O2TI");
var $4t4rd = parcelRequire("4t4rd");
parcelRequire("cJvLm");
var $klaOF = parcelRequire("klaOF");
var $e9SYA = parcelRequire("e9SYA");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $5LVTI = parcelRequire("5LVTI");
const $e132707004ed7c7f$export$fd64a2f495d11aa8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const commentBlockLoading = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentBlockLoading));
    const comment = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentBlockModalComment));
    const { message: message } = comment ?? {};
    const maxCommentMessageDisplayLength = 88;
    const submitDisabled = commentBlockLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5LVTI.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $5LVTI.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $klaOF.commentBlock)({
                    id: comment?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $5LVTI.styles)().form.content.message,
                    children: (0, $4t4rd.stringsCutter)(maxCommentMessageDisplayLength, message || "")
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $5LVTI.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block comment",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: commentBlockLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$e132707004ed7c7f$export$fd64a2f495d11aa8.propTypes = {};

});
parcelRegister("5LVTI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $83da187cace7a796$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $83da187cace7a796$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $83da187cace7a796$var$_ref = {
    name: "q0fhfi",
    styles: "text-align:center;word-wrap:break-word;overflow:hidden;margin-bottom:24px"
};
const $83da187cace7a796$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                message: $83da187cace7a796$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("75thZ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5b0293e3b8262949$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $5b0293e3b8262949$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5b0293e3b8262949$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $5b0293e3b8262949$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $5b0293e3b8262949$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $5b0293e3b8262949$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5b0293e3b8262949$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $5b0293e3b8262949$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $5b0293e3b8262949$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $5b0293e3b8262949$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $5b0293e3b8262949$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($5b0293e3b8262949$var$_ref8), " ", (0, $gln0L.mq).mobile($5b0293e3b8262949$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($5b0293e3b8262949$var$_ref6), ";", ""),
            title: $5b0293e3b8262949$var$_ref5,
            subtitle: $5b0293e3b8262949$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($5b0293e3b8262949$var$_ref3), ";", ""),
                form: $5b0293e3b8262949$var$_ref2,
                error: $5b0293e3b8262949$var$_ref
            }
        }
    });

});



parcelRegister("bdCgM", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0b7effbfcef90f30$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $0b7effbfcef90f30$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0b7effbfcef90f30$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $0b7effbfcef90f30$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($0b7effbfcef90f30$var$_ref), ";", "")
        }
    });

});


parcelRegister("f2RiN", function(module, exports) {

$parcel$export(module.exports, "CommentCard", function () { return $bb63d65b2d919451$export$bc479ee64936fcb7; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $dJd5m = parcelRequire("dJd5m");
const $bb63d65b2d919451$export$bc479ee64936fcb7 = ({ comment: comment, reply: reply = false, isCurrentUserCommentAuthor: isCurrentUserCommentAuthor, isCurrentUserAdmin: isCurrentUserAdmin, isLiked: isLiked, onUserNameClick: onUserNameClick, onLikeClick: onLikeClick, onDislikeClick: onDislikeClick, onReplyClick: onReplyClick, onBlockClick: onBlockClick, onDeleteClick: onDeleteClick, onReportClick: onReportClick })=>{
    const theme = (0, $iwq56.u)();
    const { userId: commentAuthorUserId, message: message } = comment;
    // comment author
    const { user: commentAuthor, isLoading: isCommentAuthorLoading } = (0, $aCYwi.useUserPublic)(commentAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = commentAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $jpNoL.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $bh6RR.useState)(false);
    const renderLikeButtons = ()=>{
        // if comment liked
        if (isLiked) // return dislike button
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $dJd5m.styles)(theme).card.actions.heart.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: [
                    (0, $dJd5m.styles)(theme).card.actions.heart.button.shared,
                    (0, $dJd5m.styles)(theme).card.actions.heart.button.dislike,
                    "",
                    ""
                ],
                onClick: (e)=>onDislikeClick(e),
                type: "button",
                "aria-label": "dislike comment",
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).HeartFilled, {})
            })
        });
        // else return like button
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $dJd5m.styles)(theme).card.actions.heart.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: [
                    (0, $dJd5m.styles)(theme).card.actions.heart.button.shared,
                    (0, $dJd5m.styles)(theme).card.actions.heart.button.like,
                    "",
                    ""
                ],
                onClick: (e)=>onLikeClick(e),
                type: "button",
                "aria-label": "like comment",
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Heart, {})
            })
        });
    };
    const renderActionButtons = ()=>{
        // if current user is comment author
        if (isCurrentUserCommentAuthor) // return delete button
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $dJd5m.styles)(theme).card.actions.delete.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $dJd5m.styles)(theme).card.actions.delete.button,
                onClick: (e)=>onDeleteClick(e),
                type: "button",
                "aria-label": "delete comment",
                children: "Delete"
            })
        });
        // if current user is admin
        if (isCurrentUserAdmin) // return block button
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $dJd5m.styles)(theme).card.actions.block.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $dJd5m.styles)(theme).card.actions.block.button,
                onClick: (e)=>onBlockClick(e),
                type: "button",
                "aria-label": "block comment",
                children: "Block"
            })
        });
        // else return report button
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $dJd5m.styles)(theme).card.actions.report.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $dJd5m.styles)(theme).card.actions.report.button,
                onClick: (e)=>onReportClick(e),
                type: "button",
                "aria-label": "report comment",
                children: "Report"
            })
        });
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dJd5m.styles)(theme).card.main(reply || false),
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $dJd5m.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dJd5m.styles)(theme).card.data.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $dJd5m.styles)(theme).card.data.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                            css: (0, $dJd5m.styles)(theme).card.data.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $dJd5m.styles)(theme).card.data.content.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $dJd5m.styles)(theme).card.data.content.name,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: (0, $dJd5m.styles)(theme).card.data.content.name,
                                    onClick: (e)=>onUserNameClick(e),
                                    type: "button",
                                    "aria-label": "explore author profile",
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                        children: isCommentAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $dJd5m.styles)(theme).card.data.content.message,
                                children: message
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $dJd5m.styles)(theme).card.actions.main,
                children: [
                    renderLikeButtons(),
                    ` \u{2014} `,
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dJd5m.styles)(theme).card.actions.reply.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $dJd5m.styles)(theme).card.actions.reply.button,
                            onClick: (e)=>onReplyClick(e),
                            type: "button",
                            "aria-label": "reply to comment",
                            children: "Reply"
                        })
                    }),
                    ` \u{2014} `,
                    renderActionButtons()
                ]
            })
        ]
    });
};
$bb63d65b2d919451$export$bc479ee64936fcb7.propTypes = {};

});
parcelRegister("dJd5m", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bbdb1ef64c4ae14a$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $bbdb1ef64c4ae14a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bbdb1ef64c4ae14a$var$_ref = {
    name: "124yqkc",
    styles: "display:flex;margin-left:8px"
};
var $bbdb1ef64c4ae14a$var$_ref2 = {
    name: "124yqkc",
    styles: "display:flex;margin-left:8px"
};
var $bbdb1ef64c4ae14a$var$_ref3 = {
    name: "124yqkc",
    styles: "display:flex;margin-left:8px"
};
var $bbdb1ef64c4ae14a$var$_ref4 = {
    name: "13y0mlm",
    styles: "display:flex;margin:0px 8px"
};
var $bbdb1ef64c4ae14a$var$_ref5 = {
    name: "13y0mlm",
    styles: "display:flex;margin:0px 8px"
};
var $bbdb1ef64c4ae14a$var$_ref6 = {
    name: "zjik7",
    styles: "display:flex"
};
var $bbdb1ef64c4ae14a$var$_ref7 = {
    name: "j523fz",
    styles: "display:flex;align-items:center;margin-left:34px"
};
var $bbdb1ef64c4ae14a$var$_ref8 = {
    name: "62qxo5",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0"
};
var $bbdb1ef64c4ae14a$var$_ref9 = {
    name: "zjik7",
    styles: "display:flex"
};
const $bbdb1ef64c4ae14a$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: (reply)=>/*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:space-between;height:70px;margin-left:", reply ? `40px` : `0px`, ";", ""),
            data: {
                main: $bbdb1ef64c4ae14a$var$_ref9,
                avatar: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                    image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                content: {
                    main: $bbdb1ef64c4ae14a$var$_ref8,
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                    message: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
                }
            },
            actions: {
                main: $bbdb1ef64c4ae14a$var$_ref7,
                heart: {
                    main: $bbdb1ef64c4ae14a$var$_ref6,
                    button: {
                        shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;display:flex;align-items:center;justify-content:center;width:30px;height:30px;&>svg{width:14px;height:14px;}", ""),
                        dislike: /*#__PURE__*/ (0, $7hler.css)("& svg{&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                        like: /*#__PURE__*/ (0, $7hler.css)("& svg{&>path{fill:", theme.colors.secondary.normal, ";}}", "")
                    }
                },
                reply: {
                    main: $bbdb1ef64c4ae14a$var$_ref5,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $gln0L.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                read: {
                    main: $bbdb1ef64c4ae14a$var$_ref4,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $gln0L.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                },
                delete: {
                    main: $bbdb1ef64c4ae14a$var$_ref3,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $gln0L.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.negative.normal, ";}", "")
                },
                block: {
                    main: $bbdb1ef64c4ae14a$var$_ref2,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $gln0L.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.negative.normal, ";}", "")
                },
                report: {
                    main: $bbdb1ef64c4ae14a$var$_ref,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;color:", theme.colors.secondary.dark, ";font-size:", (0, $gln0L.typography).c, ";font-weight:bold;height:30px;transition:color 0.2s;&:hover{color:", theme.colors.negative.normal, ";}", "")
                }
            }
        }
    });

});


parcelRegister("6bwn8", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteModal", function () { return $33a4c37f33f95497$export$8eb8df218902568a; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $e9SYA = parcelRequire("e9SYA");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("fTXlp");
var $dPOse = parcelRequire("dPOse");

var $laihz = parcelRequire("laihz");
const $33a4c37f33f95497$export$8eb8df218902568a = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const deleteCommentModalOpen = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentDeleteModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $laihz.styles)().modal.main,
        children: deleteCommentModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $e9SYA.commentCloseCommentDeleteModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $laihz.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dPOse.CommentDeleteCard), {})
            })
        })
    });
};
$33a4c37f33f95497$export$8eb8df218902568a.propTypes = {};

});
parcelRegister("fTXlp", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteCard", function () { return (parcelRequire("dPOse")).CommentDeleteCard; });

var $dPOse = parcelRequire("dPOse");

});
parcelRegister("dPOse", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteCard", function () { return $3e618337039b3d12$export$48b3e8bde388a977; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $e9SYA = parcelRequire("e9SYA");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("bCkWK");
var $85GdO = parcelRequire("85GdO");

var $c2N6b = parcelRequire("c2N6b");
const $3e618337039b3d12$export$48b3e8bde388a977 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const commentDeleteError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $c2N6b.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $c2N6b.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $e9SYA.commentCloseCommentDeleteModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $c2N6b.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Delete Comment",
                    icon: (0, $bq9l8.icons).Trash
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $c2N6b.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Are you sure you want to delete your comment?"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $c2N6b.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $c2N6b.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $85GdO.CommentDeleteForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $c2N6b.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: commentDeleteError
                        })
                    })
                ]
            })
        ]
    });
};
$3e618337039b3d12$export$48b3e8bde388a977.propTypes = {};

});
parcelRegister("bCkWK", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteForm", function () { return (parcelRequire("85GdO")).CommentDeleteForm; });

var $85GdO = parcelRequire("85GdO");

});
parcelRegister("85GdO", function(module, exports) {

$parcel$export(module.exports, "CommentDeleteForm", function () { return $feb8b2f4129aad9f$export$628243470a18449b; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("1O2TI");
var $4t4rd = parcelRequire("4t4rd");
parcelRequire("cJvLm");
var $klaOF = parcelRequire("klaOF");
var $e9SYA = parcelRequire("e9SYA");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $03hv4 = parcelRequire("03hv4");
const $feb8b2f4129aad9f$export$628243470a18449b = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const commentDeleteLoading = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentDeleteLoading));
    const comment = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentDeleteModalComment));
    const { message: message } = comment ?? {};
    const maxCommentMessageDisplayLength = 88;
    const submitDisabled = commentDeleteLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $03hv4.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $03hv4.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $klaOF.commentDelete)({
                    id: comment?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $03hv4.styles)().form.content.message,
                    children: (0, $4t4rd.stringsCutter)(maxCommentMessageDisplayLength, message || "")
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $03hv4.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "delete comment",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: commentDeleteLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Delete"
                    })
                })
            ]
        })
    });
};
$feb8b2f4129aad9f$export$628243470a18449b.propTypes = {};

});
parcelRegister("03hv4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2f17e83f70b6d2b5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $2f17e83f70b6d2b5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2f17e83f70b6d2b5$var$_ref = {
    name: "q0fhfi",
    styles: "text-align:center;word-wrap:break-word;overflow:hidden;margin-bottom:24px"
};
const $2f17e83f70b6d2b5$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                message: $2f17e83f70b6d2b5$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("c2N6b", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a167726b086d193c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $a167726b086d193c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a167726b086d193c$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $a167726b086d193c$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $a167726b086d193c$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $a167726b086d193c$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $a167726b086d193c$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $a167726b086d193c$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $a167726b086d193c$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $a167726b086d193c$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $a167726b086d193c$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($a167726b086d193c$var$_ref8), " ", (0, $gln0L.mq).mobile($a167726b086d193c$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($a167726b086d193c$var$_ref6), ";", ""),
            title: $a167726b086d193c$var$_ref5,
            subtitle: $a167726b086d193c$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($a167726b086d193c$var$_ref3), ";", ""),
                form: $a167726b086d193c$var$_ref2,
                error: $a167726b086d193c$var$_ref
            }
        }
    });

});



parcelRegister("laihz", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $423421f4c157375f$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $423421f4c157375f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $423421f4c157375f$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $423421f4c157375f$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($423421f4c157375f$var$_ref), ";", "")
        }
    });

});


parcelRegister("7eK4u", function(module, exports) {

$parcel$export(module.exports, "CommentListPost", function () { return $78062911bf1d2942$export$b2d989c1a4cff6a; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $e9SYA = parcelRequire("e9SYA");
var $f2RiN = parcelRequire("f2RiN");
var $klaOF = parcelRequire("klaOF");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $a0vy2 = parcelRequire("a0vy2");
var $10e6J = parcelRequire("10e6J");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("824L0");
var $1OBYe = parcelRequire("1OBYe");
var $47EQY = parcelRequire("47EQY");
var $isbXS = parcelRequire("isbXS");

var $kbU46 = parcelRequire("kbU46");
const $78062911bf1d2942$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const commentLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectCommentLikes));
    const comments = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectComments));
    const comment = comments[index];
    // if comment not fetched
    if (!comment) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "comment-list-post",
                    width: "100%",
                    height: "70px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: currentUserId, role: currentUserRole } = profile ?? {};
    const { id: commentId, userId: commentAuthorUserId, commentId: depth } = comment;
    const isCommentLiked = commentLikes[commentId || ""];
    const isCurrentUserCommentAuthor = currentUserId === commentAuthorUserId;
    const isCurrentUserAdmin = currentUserRole === (0, $2gpGl.EntityUserRole).Admin;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kbU46.styles)().comments.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f2RiN.CommentCard), {
            comment: comment,
            reply: !!depth,
            isCurrentUserCommentAuthor: isCurrentUserCommentAuthor,
            isCurrentUserAdmin: isCurrentUserAdmin,
            isLiked: isCommentLiked,
            onUserNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${commentAuthorUserId}`),
            onLikeClick: ()=>dispatch((0, $4cq7L.likeCreateCommentLike)({
                    comment: comment
                })),
            onDislikeClick: ()=>dispatch((0, $4cq7L.likeDeleteCommentLike)({
                    comment: comment
                })),
            onReplyClick: ()=>dispatch((0, $e9SYA.commentAddDepth)({
                    comment: comment
                })),
            onBlockClick: ()=>dispatch((0, $e9SYA.commentOpenCommentBlockModal)({
                    comment: comment
                })),
            onDeleteClick: ()=>dispatch((0, $e9SYA.commentOpenCommentDeleteModal)({
                    comment: comment
                })),
            onReportClick: ()=>dispatch((0, $10e6J.reportOpenReportCommentModal)({
                    comment: comment
                }))
        })
    });
});
const $78062911bf1d2942$export$b2d989c1a4cff6a = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const post = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPost));
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post ?? {};
    const { id: profileUserId } = profile ?? {};
    const commentGetCommentsLoading = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentGetCommentsLoading));
    const comments = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectComments));
    const commentsCount = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentsCount));
    const commentsLength = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentsLength));
    const commentsFetched = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentsFetched));
    const commentsDepth = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentsDepth));
    const commentDepthCurrent = commentsDepth[0] || undefined;
    const { id: currentDepthId } = commentDepthCurrent ?? {};
    const commentCardHeight = 70;
    const commentCardMarginBottom = 10;
    const itemHeight = commentCardHeight + commentCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 400;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    // if post is not fetched
    if (!post) // return card post skeleton
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kbU46.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $isbXS.Title), {
                    text: "Comments"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
                    sections: [
                        {
                            name: "comment-list-post-card",
                            width: "100%",
                            height: "400px",
                            isStatic: false,
                            isDivider: false
                        }
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1OBYe.Form), {})
            })
        ]
    });
    const isItemLoaded = (index)=>!!comments[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $klaOF.commentGetComments)({
            postId: postId || "",
            commentId: currentDepthId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = profileUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if post is locked
    if (renderLocked) // return placeholder
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kbU46.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $isbXS.Title), {
                    text: "Comments"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
                    icon: (0, $bq9l8.icons).Lock,
                    height: "400px",
                    title: "Content is locked"
                })
            })
        ]
    });
    // if comments are fetched but length is 0
    if (!commentGetCommentsLoading && commentsFetched && commentsLength === 0) // return placeholder
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kbU46.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $isbXS.Title), {
                    text: "Comments"
                })
            }),
            commentDepthCurrent && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.comment,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $47EQY.ParentComment), {
                    comment: commentDepthCurrent,
                    onUserNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${commentDepthCurrent.userId}`),
                    onBackwardClick: ()=>dispatch((0, $e9SYA.commentRemoveDepth)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
                    icon: (0, $bq9l8.icons).Comment,
                    height: "400px",
                    title: commentDepthCurrent ? "Could not find any replies" : "Could not find any comments"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.form,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1OBYe.Form), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kbU46.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $isbXS.Title), {
                    text: "Comments"
                })
            }),
            commentDepthCurrent && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.comment,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $47EQY.ParentComment), {
                    comment: commentDepthCurrent,
                    onUserNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${commentDepthCurrent.userId}`),
                    onBackwardClick: ()=>dispatch((0, $e9SYA.commentRemoveDepth)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: commentsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: commentsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $78062911bf1d2942$var$Row
                        })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kbU46.styles)().list.form,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1OBYe.Form), {})
            })
        ]
    });
};
$78062911bf1d2942$export$b2d989c1a4cff6a.propTypes = {};

});
parcelRegister("5dy7p", function(module, exports) {

$parcel$export(module.exports, "FixedSizeList", function () { return $3cc8a1e45b82291d$export$ae9e55e1d8a2f4b7; });

var $4WYaH = parcelRequire("4WYaH");

var $hqR4t = parcelRequire("hqR4t");

var $gMqD6 = parcelRequire("gMqD6");

var $1XykX = parcelRequire("1XykX");

var $bh6RR = parcelRequire("bh6RR");

var $hCIyK = parcelRequire("hCIyK");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $3cc8a1e45b82291d$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $3cc8a1e45b82291d$var$now = $3cc8a1e45b82291d$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $3cc8a1e45b82291d$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $3cc8a1e45b82291d$var$requestTimeout(callback, delay) {
    var start = $3cc8a1e45b82291d$var$now();
    function tick() {
        if ($3cc8a1e45b82291d$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $3cc8a1e45b82291d$var$size = -1; // This utility copied from "dom-helpers" package.
function $3cc8a1e45b82291d$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3cc8a1e45b82291d$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $3cc8a1e45b82291d$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $3cc8a1e45b82291d$var$size;
}
var $3cc8a1e45b82291d$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $3cc8a1e45b82291d$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3cc8a1e45b82291d$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $3cc8a1e45b82291d$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $3cc8a1e45b82291d$var$cachedRTLResult = "negative";
            else $3cc8a1e45b82291d$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $3cc8a1e45b82291d$var$cachedRTLResult;
    }
    return $3cc8a1e45b82291d$var$cachedRTLResult;
}
var $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $3cc8a1e45b82291d$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3cc8a1e45b82291d$var$devWarningsOverscanCount = null;
var $3cc8a1e45b82291d$var$devWarningsOverscanRowsColumnsCount = null;
var $3cc8a1e45b82291d$var$devWarningsTagName = null;
function $3cc8a1e45b82291d$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $gMqD6.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $hqR4t.default)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $hqR4t.default)(_this),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $1XykX.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $1XykX.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $1XykX.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3cc8a1e45b82291d$var$requestTimeout(_this._resetIsScrolling, $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3cc8a1e45b82291d$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $3cc8a1e45b82291d$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $3cc8a1e45b82291d$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $bh6RR.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $bh6RR.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $4WYaH.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $bh6RR.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $bh6RR.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $3cc8a1e45b82291d$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $3cc8a1e45b82291d$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $3cc8a1e45b82291d$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3cc8a1e45b82291d$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3cc8a1e45b82291d$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3cc8a1e45b82291d$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $3cc8a1e45b82291d$var$getEstimatedTotalWidth(props, instanceProps) : $3cc8a1e45b82291d$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $3cc8a1e45b82291d$export$32c206c84102e73c = /*#__PURE__*/ $3cc8a1e45b82291d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $3cc8a1e45b82291d$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $3cc8a1e45b82291d$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $3cc8a1e45b82291d$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3cc8a1e45b82291d$var$devWarningsDirection = null;
var $3cc8a1e45b82291d$var$devWarningsTagName$1 = null;
function $3cc8a1e45b82291d$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $gMqD6.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $hqR4t.default)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $hqR4t.default)(_this),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $1XykX.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $1XykX.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $1XykX.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3cc8a1e45b82291d$var$requestTimeout(_this._resetIsScrolling, $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3cc8a1e45b82291d$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === "vertical") scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $3cc8a1e45b82291d$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $3cc8a1e45b82291d$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $3cc8a1e45b82291d$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $bh6RR.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $bh6RR.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $4WYaH.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $bh6RR.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $bh6RR.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $3cc8a1e45b82291d$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $3cc8a1e45b82291d$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $3cc8a1e45b82291d$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3cc8a1e45b82291d$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3cc8a1e45b82291d$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3cc8a1e45b82291d$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3cc8a1e45b82291d$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$export$d8ac3b6b20be856e = /*#__PURE__*/ $3cc8a1e45b82291d$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $3cc8a1e45b82291d$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $3cc8a1e45b82291d$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $3cc8a1e45b82291d$export$f331158cccad7361 = /*#__PURE__*/ $3cc8a1e45b82291d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $3cc8a1e45b82291d$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $3cc8a1e45b82291d$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $3cc8a1e45b82291d$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $3cc8a1e45b82291d$var$_excluded = [
    "style"
], $3cc8a1e45b82291d$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $3cc8a1e45b82291d$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $hCIyK.default)(prevProps, $3cc8a1e45b82291d$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $hCIyK.default)(nextProps, $3cc8a1e45b82291d$var$_excluded2);
    return !$3cc8a1e45b82291d$var$shallowDiffers(prevStyle, nextStyle) && !$3cc8a1e45b82291d$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $3cc8a1e45b82291d$export$aa365c903ed149ff(nextProps, nextState) {
    return !$3cc8a1e45b82291d$export$b141efd0b0fb9174(this.props, nextProps) || $3cc8a1e45b82291d$var$shallowDiffers(this.state, nextState);
}

});
parcelRegister("hqR4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0e0834598ff6d6$export$2e2bcd8739ae039; });
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("gMqD6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c375c92967c25393$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $c375c92967c25393$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hloi6.default)(subClass, superClass);
}

});
parcelRegister("hloi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca073d81f2a471af$export$2e2bcd8739ae039; });
function $ca073d81f2a471af$export$2e2bcd8739ae039(o, p) {
    $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ca073d81f2a471af$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("1XykX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16d5efbf3de5c533$export$2e2bcd8739ae039; });
var $16d5efbf3de5c533$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $16d5efbf3de5c533$var$isEqual(first, second) {
    if (first === second) return true;
    if ($16d5efbf3de5c533$var$safeIsNaN(first) && $16d5efbf3de5c533$var$safeIsNaN(second)) return true;
    return false;
}
function $16d5efbf3de5c533$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$16d5efbf3de5c533$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $16d5efbf3de5c533$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $16d5efbf3de5c533$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $16d5efbf3de5c533$export$2e2bcd8739ae039 = $16d5efbf3de5c533$var$memoizeOne;

});

parcelRegister("hCIyK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd488cd9c287f883$export$2e2bcd8739ae039; });
function $cd488cd9c287f883$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) {
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("7VQuT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c6694274ebe20d5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");
function $5c6694274ebe20d5$var$isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $5c6694274ebe20d5$var$isRangeVisible(_ref) {
    var lastRenderedStartIndex = _ref.lastRenderedStartIndex, lastRenderedStopIndex = _ref.lastRenderedStopIndex, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function $5c6694274ebe20d5$var$scanForUnloadedRanges(_ref) {
    var isItemLoaded = _ref.isItemLoaded, itemCount = _ref.itemCount, minimumBatchSize = _ref.minimumBatchSize, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    var unloadedRanges = [];
    var rangeStartIndex = null;
    var rangeStopIndex = null;
    for(var _index = startIndex; _index <= stopIndex; _index++){
        var loaded = isItemLoaded(_index);
        if (!loaded) {
            rangeStopIndex = _index;
            if (rangeStartIndex === null) rangeStartIndex = _index;
        } else if (rangeStopIndex !== null) {
            unloadedRanges.push(rangeStartIndex, rangeStopIndex);
            rangeStartIndex = rangeStopIndex = null;
        }
    }
    // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
    // Scan forward to try filling our :minimumBatchSize.
    if (rangeStopIndex !== null) {
        var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), itemCount - 1);
        for(var _index2 = rangeStopIndex + 1; _index2 <= potentialStopIndex; _index2++){
            if (!isItemLoaded(_index2)) rangeStopIndex = _index2;
            else break;
        }
        unloadedRanges.push(rangeStartIndex, rangeStopIndex);
    }
    // Check to see if our first range ended prematurely.
    // In this case we should scan backwards to try filling our :minimumBatchSize.
    if (unloadedRanges.length) while(unloadedRanges[1] - unloadedRanges[0] + 1 < minimumBatchSize && unloadedRanges[0] > 0){
        var _index3 = unloadedRanges[0] - 1;
        if (!isItemLoaded(_index3)) unloadedRanges[0] = _index3;
        else break;
    }
    return unloadedRanges;
}
var $5c6694274ebe20d5$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $5c6694274ebe20d5$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $5c6694274ebe20d5$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $5c6694274ebe20d5$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $5c6694274ebe20d5$var$InfiniteLoader = function(_PureComponent) {
    $5c6694274ebe20d5$var$inherits(InfiniteLoader, _PureComponent);
    function InfiniteLoader() {
        var _ref;
        var _temp, _this, _ret;
        $5c6694274ebe20d5$var$classCallCheck(this, InfiniteLoader);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5c6694274ebe20d5$var$possibleConstructorReturn(this, (_ref = InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._lastRenderedStartIndex = -1, _this._lastRenderedStopIndex = -1, _this._memoizedUnloadedRanges = [], _this._onItemsRendered = function(_ref2) {
            var visibleStartIndex = _ref2.visibleStartIndex, visibleStopIndex = _ref2.visibleStopIndex;
            _this._lastRenderedStartIndex = visibleStartIndex;
            _this._lastRenderedStopIndex = visibleStopIndex;
            _this._ensureRowsLoaded(visibleStartIndex, visibleStopIndex);
        }, _this._setRef = function(listRef) {
            _this._listRef = listRef;
        }, _temp), $5c6694274ebe20d5$var$possibleConstructorReturn(_this, _ret);
    }
    $5c6694274ebe20d5$var$createClass(InfiniteLoader, [
        {
            key: "resetloadMoreItemsCache",
            value: function resetloadMoreItemsCache() {
                var autoReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this._memoizedUnloadedRanges = [];
                if (autoReload) this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {}
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    onItemsRendered: this._onItemsRendered,
                    ref: this._setRef
                });
            }
        },
        {
            key: "_ensureRowsLoaded",
            value: function _ensureRowsLoaded(startIndex, stopIndex) {
                var _props = this.props, isItemLoaded = _props.isItemLoaded, itemCount = _props.itemCount, _props$minimumBatchSi = _props.minimumBatchSize, minimumBatchSize = _props$minimumBatchSi === undefined ? 10 : _props$minimumBatchSi, _props$threshold = _props.threshold, threshold = _props$threshold === undefined ? 15 : _props$threshold;
                var unloadedRanges = $5c6694274ebe20d5$var$scanForUnloadedRanges({
                    isItemLoaded: isItemLoaded,
                    itemCount: itemCount,
                    minimumBatchSize: minimumBatchSize,
                    startIndex: Math.max(0, startIndex - threshold),
                    stopIndex: Math.min(itemCount - 1, stopIndex + threshold)
                });
                // Avoid calling load-rows unless range has changed.
                // This shouldn't be strictly necessary, but is maybe nice to do.
                if (this._memoizedUnloadedRanges.length !== unloadedRanges.length || this._memoizedUnloadedRanges.some(function(startOrStop, index) {
                    return unloadedRanges[index] !== startOrStop;
                })) {
                    this._memoizedUnloadedRanges = unloadedRanges;
                    this._loadUnloadedRanges(unloadedRanges);
                }
            }
        },
        {
            key: "_loadUnloadedRanges",
            value: function _loadUnloadedRanges(unloadedRanges) {
                var _this2 = this;
                // loadMoreRows was renamed to loadMoreItems in v1.0.3; will be removed in v2.0
                var loadMoreItems = this.props.loadMoreItems || this.props.loadMoreRows;
                var _loop = function _loop(i) {
                    var startIndex = unloadedRanges[i];
                    var stopIndex = unloadedRanges[i + 1];
                    var promise = loadMoreItems(startIndex, stopIndex);
                    if (promise != null) promise.then(function() {
                        // Refresh the visible rows if any of them have just been loaded.
                        // Otherwise they will remain in their unloaded visual state.
                        if ($5c6694274ebe20d5$var$isRangeVisible({
                            lastRenderedStartIndex: _this2._lastRenderedStartIndex,
                            lastRenderedStopIndex: _this2._lastRenderedStopIndex,
                            startIndex: startIndex,
                            stopIndex: stopIndex
                        })) {
                            // Handle an unmount while promises are still in flight.
                            if (_this2._listRef == null) return;
                            // Resize cached row sizes for VariableSizeList,
                            // otherwise just re-render the list.
                            if (typeof _this2._listRef.resetAfterIndex === "function") _this2._listRef.resetAfterIndex(startIndex, true);
                            else {
                                // HACK reset temporarily cached item styles to force PureComponent to re-render.
                                // This is pretty gross, but I'm okay with it for now.
                                // Don't judge me.
                                if (typeof _this2._listRef._getItemStyleCache === "function") _this2._listRef._getItemStyleCache(-1);
                                _this2._listRef.forceUpdate();
                            }
                        }
                    });
                };
                for(var i = 0; i < unloadedRanges.length; i += 2)_loop(i);
            }
        }
    ]);
    return InfiniteLoader;
}((0, $bh6RR.PureComponent));
var $5c6694274ebe20d5$export$2e2bcd8739ae039 = $5c6694274ebe20d5$var$InfiniteLoader;

});

parcelRegister("824L0", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("1OBYe")).Form; });
$parcel$export(module.exports, "ParentComment", function () { return (parcelRequire("47EQY")).ParentComment; });
$parcel$export(module.exports, "Title", function () { return (parcelRequire("isbXS")).Title; });

var $1OBYe = parcelRequire("1OBYe");

var $47EQY = parcelRequire("47EQY");

var $isbXS = parcelRequire("isbXS");

});
parcelRegister("1OBYe", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $5fd5e39982bff35a$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $auEWN = parcelRequire("auEWN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $klaOF = parcelRequire("klaOF");
var $e9SYA = parcelRequire("e9SYA");
var $a0vy2 = parcelRequire("a0vy2");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("h3nGC");
var $gqova = parcelRequire("gqova");

var $71eyo = parcelRequire("71eyo");
const $5fd5e39982bff35a$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const commentsDepth = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentsDepth));
    const commentDepthCurrent = commentsDepth[0] || undefined;
    const { id: commentId } = commentDepthCurrent ?? {};
    const post = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPost));
    const { id: postId } = post ?? {};
    const [message, setMessage] = (0, $bh6RR.useState)("");
    const [messageError, setMessageError] = (0, $bh6RR.useState)("");
    const commentCreateLoading = (0, $gNvvs.useAppSelector)((0, $e9SYA.commentSelectCommentCreateLoading));
    const submitDisabled = message.length < (0, $auEWN.minCommentMessageLength) || messageError !== "" || commentCreateLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $71eyo.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("form", {
            css: (0, $71eyo.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $klaOF.commentCreate)({
                    postId: postId || "",
                    message: message,
                    commentId: commentId
                }));
                setMessage("");
                setMessageError("");
            },
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $71eyo.styles)().form.content.message,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gqova.FormInput), {
                    name: "comment",
                    label: "comment",
                    type: "text",
                    placeholder: "Enter your comment",
                    maxLength: (0, $auEWN.maxCommentMessageLength),
                    value: message,
                    error: messageError.length > 0,
                    // errorMessage={messageError}
                    sendDisabled: submitDisabled,
                    onChange: (e)=>{
                        setMessage(e.target.value);
                    },
                    onBlur: ()=>{
                        if (message !== "") setMessageError((0, $lRNbG.validateCommentMessage)(message));
                    },
                    onFocus: ()=>setMessageError("")
                })
            })
        })
    });
};
$5fd5e39982bff35a$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("h3nGC", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return (parcelRequire("gqova")).FormInput; });

var $gqova = parcelRequire("gqova");

});
parcelRegister("gqova", function(module, exports) {

$parcel$export(module.exports, "FormInput", function () { return $e0b1cda0f10d3dbd$export$fd970bbd10854e43; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $3dIqa = parcelRequire("3dIqa");
const $e0b1cda0f10d3dbd$export$fd970bbd10854e43 = ({ name: name, label: label, error: error = false, sendDisabled: // errorMessage = '',
sendDisabled = false, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $3dIqa.styles)(theme).input.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $3dIqa.styles)(theme).input.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $3dIqa.styles)(theme).input.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                        css: [
                            (0, $3dIqa.styles)(theme).input.data.shared,
                            attributes.value ? (0, $3dIqa.styles)(theme).input.data.filled : (0, $3dIqa.styles)(theme).input.data.empty,
                            error && (0, $3dIqa.styles)(theme).input.data.errored,
                            (0, $3dIqa.styles)(theme).input.data.withIcon,
                            "",
                            ""
                        ],
                        id: name,
                        ...attributes
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: [
                            (0, $3dIqa.styles)(theme).input.button.shared,
                            sendDisabled ? (0, $3dIqa.styles)(theme).input.button.disabled : (0, $3dIqa.styles)(theme).input.button.enabled,
                            "",
                            ""
                        ],
                        disabled: sendDisabled,
                        type: "submit",
                        "aria-label": "send comment",
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                            css: (0, $3dIqa.styles)(theme).input.button.text,
                            children: "Send"
                        })
                    })
                ]
            })
        ]
    });
};
$e0b1cda0f10d3dbd$export$fd970bbd10854e43.propTypes = {};

});
parcelRegister("3dIqa", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3a803707e71fa7fb$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $3a803707e71fa7fb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3a803707e71fa7fb$var$_ref = {
    name: "abijo8",
    styles: "right:26px"
};
var $3a803707e71fa7fb$var$_ref2 = {
    name: "1dcvvov",
    styles: "padding-right:64px"
};
var $3a803707e71fa7fb$var$_ref3 = {
    name: "f3hzix",
    styles: "height:36px;padding:12px 26px"
};
var $3a803707e71fa7fb$var$_ref4 = {
    name: "bjn8wh",
    styles: "position:relative"
};
var $3a803707e71fa7fb$var$_ref5 = {
    name: "eivff4",
    styles: "display:none"
};
var $3a803707e71fa7fb$var$_ref6 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $3a803707e71fa7fb$export$9dd6ff9ea0189349 = (theme)=>({
        input: {
            main: $3a803707e71fa7fb$var$_ref6,
            label: $3a803707e71fa7fb$var$_ref5,
            data: {
                main: $3a803707e71fa7fb$var$_ref4,
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:40px;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.secondary.normal, ";border-radius:6px;padding:8px 32px;transition:border 0.2s;&:focus{border:1px solid ", theme.colors.accent.normal, ";}&::placeholder{color:", theme.colors.secondary.darkHover, ";}&::-webkit-search-cancel-button{}", (0, $gln0L.mq).mobile($3a803707e71fa7fb$var$_ref3), ";", ""),
                empty: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.darkHover, ";&~button>svg>path{fill:", theme.colors.secondary.darkHover, ";}", ""),
                filled: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.normal, ";&~button>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                errored: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.negative.normal, ";", ""),
                withIcon: /*#__PURE__*/ (0, $7hler.css)("padding-right:80px;", (0, $gln0L.mq).mobile($3a803707e71fa7fb$var$_ref2), ";", "")
            },
            button: {
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;position:absolute;right:32px;top:50%;transform:translate(0%, -50%);height:30px;", (0, $gln0L.mq).mobile($3a803707e71fa7fb$var$_ref), ";", ""),
                enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;&>span{color:", theme.colors.secondary.normal, ";}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&>span{color:", theme.colors.secondary.darkHover, ";}&:hover{&>span{color:", theme.colors.secondary.darkHover, ";}}", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";transition:color 0.2s;", "")
            }
        }
    });

});



parcelRegister("71eyo", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $53289ce8bfc04a70$export$9dd6ff9ea0189349; });
function $53289ce8bfc04a70$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $53289ce8bfc04a70$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $53289ce8bfc04a70$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $53289ce8bfc04a70$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $53289ce8bfc04a70$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $53289ce8bfc04a70$var$_ref3,
            content: {
                main: $53289ce8bfc04a70$var$_ref2,
                message: $53289ce8bfc04a70$var$_ref
            }
        }
    });

});


parcelRegister("47EQY", function(module, exports) {

$parcel$export(module.exports, "ParentComment", function () { return $c0f0d14e934e3623$export$2025b53f620908f1; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $8ivYg = parcelRequire("8ivYg");
const $c0f0d14e934e3623$export$2025b53f620908f1 = ({ comment: comment, onUserNameClick: onUserNameClick, onBackwardClick: onBackwardClick })=>{
    const theme = (0, $iwq56.u)();
    const { message: message, userId: commentAuthorUserId } = comment;
    // comment author
    const { user: commentAuthor, isLoading: isCommentAuthorLoading } = (0, $aCYwi.useUserPublic)(commentAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = commentAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $jpNoL.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $bh6RR.useState)(false);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $8ivYg.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $8ivYg.styles)(theme).card.left.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8ivYg.styles)(theme).card.left.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $8ivYg.styles)(theme).card.left.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                            css: (0, $8ivYg.styles)(theme).card.left.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8ivYg.styles)(theme).card.left.nav.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $8ivYg.styles)(theme).card.left.nav.button,
                            onClick: (e)=>onBackwardClick(e),
                            type: "button",
                            "aria-label": "navigate to previous comment",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $8ivYg.styles)(theme).card.right.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8ivYg.styles)(theme).card.right.name,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $8ivYg.styles)(theme).card.right.name,
                            onClick: (e)=>onUserNameClick(e),
                            type: "button",
                            "aria-label": "explore author profile",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                children: isCommentAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8ivYg.styles)(theme).card.right.message,
                        children: message
                    })
                ]
            })
        ]
    });
};
$c0f0d14e934e3623$export$2025b53f620908f1.propTypes = {};

});
parcelRegister("8ivYg", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $50418cf32f492748$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $50418cf32f492748$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $50418cf32f492748$var$_ref = {
    name: "1ojnsow",
    styles: "display:flex;flex-direction:column;min-width:0"
};
var $50418cf32f492748$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
var $50418cf32f492748$var$_ref3 = {
    name: "18tn8dg",
    styles: "display:flex;flex-direction:column;margin-right:12px"
};
var $50418cf32f492748$var$_ref4 = {
    name: "zjik7",
    styles: "display:flex"
};
const $50418cf32f492748$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $50418cf32f492748$var$_ref4,
            left: {
                main: $50418cf32f492748$var$_ref3,
                avatar: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:12px;", ""),
                    image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                nav: {
                    main: $50418cf32f492748$var$_ref2,
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;display:flex;align-items:center;justify-content:center;width:30px;height:30px;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}}", "")
                }
            },
            right: {
                main: $50418cf32f492748$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                message: /*#__PURE__*/ (0, $7hler.css)("word-wrap:break-word;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});


parcelRegister("isbXS", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $771c217320dc3e6d$export$f99233281efd08a0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $jWJDP = parcelRequire("jWJDP");
const $771c217320dc3e6d$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $jWJDP.styles)(theme).label.main,
        children: text
    });
};
$771c217320dc3e6d$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("jWJDP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c91e46aaa95fe833$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $c91e46aaa95fe833$export$9dd6ff9ea0189349 = (theme)=>({
        label: {
            main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("kbU46", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6e59c7afd7b62fa8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6e59c7afd7b62fa8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6e59c7afd7b62fa8$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6e59c7afd7b62fa8$var$_ref2 = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $6e59c7afd7b62fa8$var$_ref3 = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $6e59c7afd7b62fa8$var$_ref4 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
const $6e59c7afd7b62fa8$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";display:flex;flex-direction:column;overflow:hidden;max-width:800px;margin-bottom:50px;", ""),
            title: $6e59c7afd7b62fa8$var$_ref4,
            comment: $6e59c7afd7b62fa8$var$_ref3,
            content: $6e59c7afd7b62fa8$var$_ref2,
            form: $6e59c7afd7b62fa8$var$_ref
        },
        comments: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});



parcelRegister("e9SYA", function(module, exports) {

$parcel$export(module.exports, "commentSlice", function () { return $b0fd0d0f24ed0c3d$export$6f10542002196596; });
$parcel$export(module.exports, "commentResetState", function () { return $b0fd0d0f24ed0c3d$export$bf76718181990b6e; });
$parcel$export(module.exports, "commentSetComments", function () { return $b0fd0d0f24ed0c3d$export$85292e9081798741; });
$parcel$export(module.exports, "commentResetComments", function () { return $b0fd0d0f24ed0c3d$export$c309ca146d80ecec; });
$parcel$export(module.exports, "commentFilterComment", function () { return $b0fd0d0f24ed0c3d$export$f6003723296faa6f; });
$parcel$export(module.exports, "commentFilterUserComments", function () { return $b0fd0d0f24ed0c3d$export$7c60efed55d280ea; });
$parcel$export(module.exports, "commentAddComment", function () { return $b0fd0d0f24ed0c3d$export$50bedd2684311fb4; });
$parcel$export(module.exports, "commentUpdateComment", function () { return $b0fd0d0f24ed0c3d$export$632c88bd775bcae9; });
$parcel$export(module.exports, "commentOpenCommentBlockModal", function () { return $b0fd0d0f24ed0c3d$export$d9f1b5989bbb1f59; });
$parcel$export(module.exports, "commentCloseCommentBlockModal", function () { return $b0fd0d0f24ed0c3d$export$4481126479d8d975; });
$parcel$export(module.exports, "commentOpenCommentDeleteModal", function () { return $b0fd0d0f24ed0c3d$export$f5b455630aac12a6; });
$parcel$export(module.exports, "commentCloseCommentDeleteModal", function () { return $b0fd0d0f24ed0c3d$export$980fbe285aaf28af; });
$parcel$export(module.exports, "commentAddDepth", function () { return $b0fd0d0f24ed0c3d$export$53b5f7a5216d6b03; });
$parcel$export(module.exports, "commentRemoveDepth", function () { return $b0fd0d0f24ed0c3d$export$c0b46e92200ba298; });
$parcel$export(module.exports, "commentSelectComments", function () { return $b0fd0d0f24ed0c3d$export$9391eb82973eda85; });
$parcel$export(module.exports, "commentSelectCommentsLength", function () { return $b0fd0d0f24ed0c3d$export$32efe9d5e932cf81; });
$parcel$export(module.exports, "commentSelectCommentsCount", function () { return $b0fd0d0f24ed0c3d$export$e65b8eaba6d91637; });
$parcel$export(module.exports, "commentSelectCommentsFetched", function () { return $b0fd0d0f24ed0c3d$export$31ae2fc3ac8394fb; });
$parcel$export(module.exports, "commentSelectCommentBlockModalOpen", function () { return $b0fd0d0f24ed0c3d$export$892bf2334087f1ea; });
$parcel$export(module.exports, "commentSelectCommentBlockModalComment", function () { return $b0fd0d0f24ed0c3d$export$e9d740ddaf26d801; });
$parcel$export(module.exports, "commentSelectCommentDeleteModalOpen", function () { return $b0fd0d0f24ed0c3d$export$576690c145ccb8eb; });
$parcel$export(module.exports, "commentSelectCommentDeleteModalComment", function () { return $b0fd0d0f24ed0c3d$export$ea9afaaaafe09ae5; });
$parcel$export(module.exports, "commentSelectCommentsDepth", function () { return $b0fd0d0f24ed0c3d$export$4d1c2c156616749c; });
$parcel$export(module.exports, "commentSelectCommentsDepthLength", function () { return $b0fd0d0f24ed0c3d$export$e8eee21aefba81a2; });
$parcel$export(module.exports, "commentSelectCommentGetCommentsLoading", function () { return $b0fd0d0f24ed0c3d$export$fbc11414a54c1d5b; });
$parcel$export(module.exports, "commentSelectCommentCreateLoading", function () { return $b0fd0d0f24ed0c3d$export$905470f2c19d133e; });
$parcel$export(module.exports, "commentSelectCommentUpdateLoading", function () { return $b0fd0d0f24ed0c3d$export$f651d62a59500408; });
$parcel$export(module.exports, "commentSelectCommentBlockLoading", function () { return $b0fd0d0f24ed0c3d$export$2496612e297163c8; });
$parcel$export(module.exports, "commentSelectCommentDeleteLoading", function () { return $b0fd0d0f24ed0c3d$export$3b3a1599d46c45b1; });
$parcel$export(module.exports, "commentReducer", function () { return $b0fd0d0f24ed0c3d$export$5ff8fec368de6099; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $klaOF = parcelRequire("klaOF");
const $b0fd0d0f24ed0c3d$var$initialState = {
    comments: [],
    commentsCount: 0,
    commentsFetched: false,
    commentsDepth: [],
    commentBlockModal: {
        comment: undefined,
        open: false
    },
    commentDeleteModal: {
        comment: undefined,
        open: false
    },
    commentGetCommentsLoading: false,
    commentCreateLoading: false,
    commentUpdateLoading: false,
    commentBlockLoading: false,
    commentDeleteLoading: false
};
const $b0fd0d0f24ed0c3d$export$6f10542002196596 = (0, $kvj5V.createSlice)({
    name: "comment",
    initialState: $b0fd0d0f24ed0c3d$var$initialState,
    reducers: {
        // reset state
        commentResetState: ()=>({
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: [],
                commentBlockModal: {
                    comment: undefined,
                    open: false
                },
                commentDeleteModal: {
                    comment: undefined,
                    open: false
                },
                commentGetCommentsLoading: false,
                commentCreateLoading: false,
                commentUpdateLoading: false,
                commentBlockLoading: false,
                commentDeleteLoading: false
            }),
        // set comments
        commentSetComments: (state, action)=>{
            const { comments: comments, count: count, offset: offset } = action.payload;
            // mutate count
            state.commentsCount = count;
            // mutate comments array
            state.comments = (0, $6Rkyy.mergeArraysAtIndex)(state.comments, comments, offset);
        },
        // reset comments
        commentResetComments: (state)=>({
                ...state,
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: []
            }),
        // add comment
        commentAddComment: (state, action)=>{
            const { comment: comment } = action.payload;
            // add comment
            state.comments = [
                comment,
                ...state.comments
            ];
            state.commentsCount += 1;
        },
        // update comment
        commentUpdateComment: (state, action)=>{
            const { updatedComment: updatedComment } = action.payload;
            // update comment in comments
            const idx = state.comments.findIndex((c)=>c.id === updatedComment.id);
            if (idx !== -1) {
                const currentComment = state.comments[idx];
                state.comments[idx] = {
                    ...currentComment,
                    ...updatedComment
                };
            }
        },
        // filter comment
        commentFilterComment: (state, action)=>{
            const { id: id } = action.payload;
            // check if comment exists in state
            const cIndex = state.comments.findIndex((c)=>c.id === id);
            if (cIndex !== -1) {
                // filter comment
                state.comments = state.comments.filter((c)=>c.id !== id);
                state.commentsCount -= 1;
            }
            // check if comment exists in state
            const dIndex = state.commentsDepth.findIndex((c)=>c.id === id);
            if (dIndex !== -1) // filter comment
            state.commentsDepth = state.commentsDepth.filter((c)=>c.id !== id);
        },
        // filter user comments
        commentFilterUserComments: (state, action)=>{
            const { userId: userId } = action.payload;
            // filter user comments from comments
            const filteredComments = state.comments.filter((c)=>c.userId !== userId);
            const filteredCommentsCount = state.comments.length - filteredComments.length;
            // if filtered comments
            if (filteredCommentsCount > 0) {
                // update comments
                state.comments = filteredComments;
                state.commentsCount -= filteredCommentsCount;
            }
            // filter user comments from comments depth
            const filteredCommentsDepth = state.commentsDepth.filter((c)=>c.userId !== userId);
            const filteredCommentsDepthCount = state.commentsDepth.length - filteredCommentsDepth.length;
            // if filtered comments
            if (filteredCommentsDepthCount > 0) // update comments
            state.commentsDepth = filteredCommentsDepth;
        },
        // open comment block modal
        commentOpenCommentBlockModal: (state, action)=>({
                ...state,
                commentBlockModal: {
                    comment: action.payload.comment,
                    open: true
                }
            }),
        // close comment block modal
        commentCloseCommentBlockModal: (state)=>({
                ...state,
                commentBlockModal: {
                    comment: undefined,
                    open: false
                }
            }),
        // open comment delete modal
        commentOpenCommentDeleteModal: (state, action)=>({
                ...state,
                commentDeleteModal: {
                    comment: action.payload.comment,
                    open: true
                }
            }),
        // close comment delete modal
        commentCloseCommentDeleteModal: (state)=>({
                ...state,
                commentDeleteModal: {
                    comment: undefined,
                    open: false
                }
            }),
        // add depth
        commentAddDepth: (state, action)=>({
                ...state,
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: [
                    action.payload.comment,
                    ...state.commentsDepth
                ]
            }),
        // remove depth
        commentRemoveDepth: (state)=>({
                ...state,
                comments: [],
                commentsCount: 0,
                commentsFetched: false,
                commentsDepth: [
                    ...state.commentsDepth.slice(1)
                ]
            })
    },
    extraReducers: (builder)=>{
        // get comments
        builder.addCase((0, $klaOF.commentGetComments).pending, (state)=>({
                ...state,
                commentGetCommentsLoading: true
            })).addCase((0, $klaOF.commentGetComments).fulfilled, (state)=>({
                ...state,
                commentsFetched: true,
                commentGetCommentsLoading: false
            }));
        // create comment
        builder.addCase((0, $klaOF.commentCreate).pending, (state)=>({
                ...state,
                commentCreateLoading: true
            })).addCase((0, $klaOF.commentCreate).fulfilled, (state)=>({
                ...state,
                commentCreateLoading: false
            }));
        // update comment
        builder.addCase((0, $klaOF.commentUpdate).pending, (state)=>({
                ...state,
                commentUpdateLoading: true
            })).addCase((0, $klaOF.commentUpdate).fulfilled, (state)=>({
                ...state,
                commentUpdateLoading: false
            }));
        // block comment
        builder.addCase((0, $klaOF.commentBlock).pending, (state)=>({
                ...state,
                commentBlockLoading: true
            })).addCase((0, $klaOF.commentBlock).fulfilled, (state)=>({
                ...state,
                commentBlockLoading: false
            }));
        // delete comment
        builder.addCase((0, $klaOF.commentDelete).pending, (state)=>({
                ...state,
                commentDeleteLoading: true
            })).addCase((0, $klaOF.commentDelete).fulfilled, (state)=>({
                ...state,
                commentDeleteLoading: false
            }));
    }
});
const { commentResetState: $b0fd0d0f24ed0c3d$export$bf76718181990b6e, commentSetComments: $b0fd0d0f24ed0c3d$export$85292e9081798741, commentResetComments: $b0fd0d0f24ed0c3d$export$c309ca146d80ecec, commentFilterComment: $b0fd0d0f24ed0c3d$export$f6003723296faa6f, commentFilterUserComments: $b0fd0d0f24ed0c3d$export$7c60efed55d280ea, commentAddComment: $b0fd0d0f24ed0c3d$export$50bedd2684311fb4, commentUpdateComment: $b0fd0d0f24ed0c3d$export$632c88bd775bcae9, commentOpenCommentBlockModal: $b0fd0d0f24ed0c3d$export$d9f1b5989bbb1f59, commentCloseCommentBlockModal: $b0fd0d0f24ed0c3d$export$4481126479d8d975, commentOpenCommentDeleteModal: $b0fd0d0f24ed0c3d$export$f5b455630aac12a6, commentCloseCommentDeleteModal: $b0fd0d0f24ed0c3d$export$980fbe285aaf28af, commentAddDepth: $b0fd0d0f24ed0c3d$export$53b5f7a5216d6b03, commentRemoveDepth: $b0fd0d0f24ed0c3d$export$c0b46e92200ba298 } = $b0fd0d0f24ed0c3d$export$6f10542002196596.actions;
const $b0fd0d0f24ed0c3d$export$9391eb82973eda85 = (state)=>state.comment.comments;
const $b0fd0d0f24ed0c3d$export$32efe9d5e932cf81 = (state)=>state.comment.comments.length;
const $b0fd0d0f24ed0c3d$export$e65b8eaba6d91637 = (state)=>state.comment.commentsCount;
const $b0fd0d0f24ed0c3d$export$31ae2fc3ac8394fb = (state)=>state.comment.commentsFetched;
const $b0fd0d0f24ed0c3d$export$892bf2334087f1ea = (state)=>state.comment.commentBlockModal.open;
const $b0fd0d0f24ed0c3d$export$e9d740ddaf26d801 = (state)=>state.comment.commentBlockModal.comment;
const $b0fd0d0f24ed0c3d$export$576690c145ccb8eb = (state)=>state.comment.commentDeleteModal.open;
const $b0fd0d0f24ed0c3d$export$ea9afaaaafe09ae5 = (state)=>state.comment.commentDeleteModal.comment;
const $b0fd0d0f24ed0c3d$export$4d1c2c156616749c = (state)=>state.comment.commentsDepth;
const $b0fd0d0f24ed0c3d$export$e8eee21aefba81a2 = (state)=>state.comment.commentsDepth.length;
const $b0fd0d0f24ed0c3d$export$fbc11414a54c1d5b = (state)=>state.comment.commentGetCommentsLoading;
const $b0fd0d0f24ed0c3d$export$905470f2c19d133e = (state)=>state.comment.commentCreateLoading;
const $b0fd0d0f24ed0c3d$export$f651d62a59500408 = (state)=>state.comment.commentUpdateLoading;
const $b0fd0d0f24ed0c3d$export$2496612e297163c8 = (state)=>state.comment.commentBlockLoading;
const $b0fd0d0f24ed0c3d$export$3b3a1599d46c45b1 = (state)=>state.comment.commentDeleteLoading;
const $b0fd0d0f24ed0c3d$export$5ff8fec368de6099 = $b0fd0d0f24ed0c3d$export$6f10542002196596.reducer; // export default commentSlice.reducer

});

parcelRegister("klaOF", function(module, exports) {

$parcel$export(module.exports, "commentGetComments", function () { return $c9f7bb1b4e89675e$export$b1c2e2a7ed12f293; });
$parcel$export(module.exports, "commentCreate", function () { return $c9f7bb1b4e89675e$export$18cd8f3c0240b0a7; });
$parcel$export(module.exports, "commentUpdate", function () { return $c9f7bb1b4e89675e$export$8bc6276e5d81ca08; });
$parcel$export(module.exports, "commentBlock", function () { return $c9f7bb1b4e89675e$export$c4b788daf331c00; });
$parcel$export(module.exports, "commentDelete", function () { return $c9f7bb1b4e89675e$export$e5a979b36f99b7ac; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $e9SYA = parcelRequire("e9SYA");
var $10e6J = parcelRequire("10e6J");
const $c9f7bb1b4e89675e$export$b1c2e2a7ed12f293 = (0, $kvj5V.createAsyncThunk)("comment/commentGetComments", async ({ postId: postId, commentId: commentId, limit: limit, offset: offset, search: search }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // if depth exists
        if (commentId) {
            // retrieve replies
            const { comments: comments, count: count } = await api.commentApi.getReplies(commentId, postId, limit, offset, search);
            // set replies
            dispatch((0, $e9SYA.commentSetComments)({
                comments: comments || [],
                count: count || 0,
                offset: offset || 0
            }));
            // return empty payload
            return {
                error: ""
            };
        }
        // retrieve comments
        const { comments: comments, count: count } = await api.commentApi.getComments(postId, limit, offset, search);
        // set comments
        dispatch((0, $e9SYA.commentSetComments)({
            comments: comments || [],
            count: count || 0,
            offset: offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c9f7bb1b4e89675e$export$18cd8f3c0240b0a7 = (0, $kvj5V.createAsyncThunk)("comment/commentCreate", async ({ message: message, postId: postId, commentId: commentId }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create comment
        const { comment: comment } = await api.commentApi.createComment({
            message: message,
            postId: postId,
            commentId: commentId
        });
        // add comment to state
        dispatch((0, $e9SYA.commentAddComment)({
            comment: comment || {}
        }));
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully created comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create comment: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $c9f7bb1b4e89675e$export$8bc6276e5d81ca08 = (0, $kvj5V.createAsyncThunk)("comment/commentUpdate", async ({ comment: comment, message: message }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // update comment
        const { comment: updatedComment } = await api.commentApi.updateComment({
            commentId: comment.id || "",
            message: message
        });
        // update comment in state
        dispatch((0, $e9SYA.commentUpdateComment)({
            updatedComment: {
                ...comment,
                message: updatedComment?.message
            }
        }));
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully updated comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to update comment: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $c9f7bb1b4e89675e$export$c4b788daf331c00 = (0, $kvj5V.createAsyncThunk)("comment/commentBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // block comment
        await api.commentApi.blockComment({
            commentId: id
        });
        // filter blocked comment
        dispatch((0, $e9SYA.commentFilterComment)({
            id: id
        }));
        // set comment as blocked in the report state
        dispatch((0, $10e6J.reportSetReportEntityBlocked)());
        // close comment block modal
        dispatch((0, $e9SYA.commentCloseCommentBlockModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully blocked comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to block comment: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c9f7bb1b4e89675e$export$e5a979b36f99b7ac = (0, $kvj5V.createAsyncThunk)("comment/commentDelete", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete comment
        await api.commentApi.deleteComment(id);
        // filter deleted comment
        dispatch((0, $e9SYA.commentFilterComment)({
            id: id
        }));
        // close comment delete modal
        dispatch((0, $e9SYA.commentCloseCommentDeleteModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully deleted comment!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to delete comment: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("2UEyU", function(module, exports) {

$parcel$export(module.exports, "ConnectViewProfile", function () { return (parcelRequire("aBHNa")).ConnectViewProfile; });
parcelRequire("1bTmR");
var $aBHNa = parcelRequire("aBHNa");

var $7u2wt = parcelRequire("7u2wt");

var $8bw42 = parcelRequire("8bw42");
$parcel$exportWildcard(module.exports, $7u2wt);
$parcel$exportWildcard(module.exports, $8bw42);

});
parcelRegister("1bTmR", function(module, exports) {

$parcel$export(module.exports, "ConnectViewProfile", function () { return (parcelRequire("aBHNa")).ConnectViewProfile; });

var $aBHNa = parcelRequire("aBHNa");

});
parcelRegister("aBHNa", function(module, exports) {

$parcel$export(module.exports, "ConnectViewProfile", function () { return $1e62299b77d423f8$export$f6b69a8282d35c1d; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $8bw42 = parcelRequire("8bw42");
var $7u2wt = parcelRequire("7u2wt");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("hmv01");
var $gidaM = parcelRequire("gidaM");
var $9Iifi = parcelRequire("9Iifi");
var $Z5Efb = parcelRequire("Z5Efb");
var $lJVkg = parcelRequire("lJVkg");

var $6NkdB = parcelRequire("6NkdB");
const $1e62299b77d423f8$export$f6b69a8282d35c1d = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const connectStatus = (0, $gNvvs.useAppSelector)((0, $7u2wt.connectSelectConnectStatus));
    const { available: availableBalance, pending: pendingBalance } = (0, $gNvvs.useAppSelector)((0, $7u2wt.connectSelectConnectBalance));
    const connectOnboardingLink = (0, $gNvvs.useAppSelector)((0, $7u2wt.connectSelectConnectOnboardingLink));
    const connectGetConnectOnboardingLinkLoading = (0, $gNvvs.useAppSelector)((0, $7u2wt.connectSelectConnectGetConnectOnboardingLinkLoading));
    const connectCreatePayoutLoading = (0, $gNvvs.useAppSelector)((0, $7u2wt.connectSelectConnectCreatePayoutLoading));
    const minPayoutAvailableBalance = 5000;
    const hasEnoughBalance = availableBalance >= minPayoutAvailableBalance;
    const isConnectReady = connectStatus === (0, $2gpGl.EntityConnectStatus).Complete || connectStatus === (0, $2gpGl.EntityConnectStatus).Enabled;
    const canPayout = hasEnoughBalance && isConnectReady;
    const updateConnectDisabled = connectGetConnectOnboardingLinkLoading;
    const createPayoutDisabled = !canPayout || connectCreatePayoutLoading;
    (0, $bh6RR.useEffect)(()=>{
        // get connect status
        dispatch((0, $8bw42.connectGetConnectStatus)());
        // get connect balance
        dispatch((0, $8bw42.connectGetConnectBalance)());
        // get connect onboarding link
        dispatch((0, $8bw42.connectGetConnectOnboardingLink)());
    }, [
        dispatch
    ]);
    const getBusinessAccountMessage = (status)=>{
        switch(status){
            case (0, $2gpGl.EntityConnectStatus).Pending:
                return "Set up your business account to unlock full potential.";
            case (0, $2gpGl.EntityConnectStatus).Restricted:
                return "We need a bit more info to complete your business account setup.";
            case (0, $2gpGl.EntityConnectStatus).Enabled:
                return "Your business account is almost ready, but we need some extra details from you.";
            case (0, $2gpGl.EntityConnectStatus).Complete:
                return "Your business account setup is complete.";
            default:
                return "";
        }
    };
    const getUpdateButtonText = (status)=>{
        switch(status){
            case (0, $2gpGl.EntityConnectStatus).Complete:
                return "Update";
            default:
                return "Set up";
        }
    };
    const getPayoutButtonText = (payoutAvailable)=>payoutAvailable ? "Create payout" : "Create payout (min $50)";
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $6NkdB.styles)().card.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $6NkdB.styles)().card.content.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $6NkdB.styles)().card.content.account.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $6NkdB.styles)().card.content.account.status.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $6NkdB.styles)().card.content.account.status.title,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lJVkg.Title), {
                                        text: "Stripe business account"
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $6NkdB.styles)().card.content.account.status.name,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9Iifi.Status), {
                                        status: connectStatus
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $6NkdB.styles)().card.content.account.status.subtitle,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $Z5Efb.Subtitle), {
                                text: getBusinessAccountMessage(connectStatus)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $6NkdB.styles)().card.content.balance.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $6NkdB.styles)().card.content.balance.title,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lJVkg.Title), {
                                text: "Balance overview"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $6NkdB.styles)().card.content.balance.pending,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gidaM.Balance), {
                                amount: pendingBalance,
                                subtitle: "Pending Balance"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $6NkdB.styles)().card.content.balance.available,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gidaM.Balance), {
                                amount: availableBalance,
                                subtitle: "Available Balance"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $6NkdB.styles)().card.content.buttons.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $6NkdB.styles)().card.content.buttons.update,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "update connect account",
                                disabled: updateConnectDisabled,
                                appearance: "secondary",
                                onClick: ()=>{
                                    window.location.assign(connectOnboardingLink);
                                },
                                children: connectGetConnectOnboardingLinkLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : getUpdateButtonText(connectStatus)
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $6NkdB.styles)().card.content.buttons.payout,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "create payout",
                                disabled: createPayoutDisabled,
                                appearance: "primary",
                                onClick: ()=>{
                                    dispatch((0, $8bw42.connectCreatePayout)());
                                },
                                children: connectCreatePayoutLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : getPayoutButtonText(canPayout)
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$1e62299b77d423f8$export$f6b69a8282d35c1d.propTypes = {};

});
parcelRegister("hmv01", function(module, exports) {

$parcel$export(module.exports, "Balance", function () { return (parcelRequire("gidaM")).Balance; });
$parcel$export(module.exports, "Status", function () { return (parcelRequire("9Iifi")).Status; });
$parcel$export(module.exports, "Subtitle", function () { return (parcelRequire("Z5Efb")).Subtitle; });
$parcel$export(module.exports, "Title", function () { return (parcelRequire("lJVkg")).Title; });

var $gidaM = parcelRequire("gidaM");

var $9Iifi = parcelRequire("9Iifi");

var $Z5Efb = parcelRequire("Z5Efb");

var $lJVkg = parcelRequire("lJVkg");

});
parcelRegister("gidaM", function(module, exports) {

$parcel$export(module.exports, "Balance", function () { return $0454c2044e249272$export$276e99f8b64146b2; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $cLaKp = parcelRequire("cLaKp");
const $0454c2044e249272$export$276e99f8b64146b2 = ({ amount: amount, subtitle: subtitle })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $cLaKp.styles)(theme).balance.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $cLaKp.styles)(theme).balance.amount,
                children: [
                    "$",
                    amount / 100
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cLaKp.styles)(theme).balance.subtitle,
                children: subtitle
            })
        ]
    });
};
$0454c2044e249272$export$276e99f8b64146b2.propTypes = {};

});
parcelRegister("cLaKp", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $02a036581cb10c89$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $02a036581cb10c89$export$9dd6ff9ea0189349 = (theme)=>({
        balance: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            amount: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h3, ";color:", theme.colors.secondary.light, ";", ""),
            subtitle: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("9Iifi", function(module, exports) {

$parcel$export(module.exports, "Status", function () { return $5e7c20e90b134c57$export$96e9906d6d93a972; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");

var $69TdO = parcelRequire("69TdO");
const $5e7c20e90b134c57$export$96e9906d6d93a972 = ({ status: status })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $69TdO.styles)(theme).status.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: [
                (0, $69TdO.styles)(theme).status.name.shared,
                status === (0, $2gpGl.EntityConnectStatus).Pending && (0, $69TdO.styles)(theme).status.name.pending,
                status === (0, $2gpGl.EntityConnectStatus).Restricted && (0, $69TdO.styles)(theme).status.name.restricted,
                status === (0, $2gpGl.EntityConnectStatus).Enabled && (0, $69TdO.styles)(theme).status.name.enabled,
                status === (0, $2gpGl.EntityConnectStatus).Complete && (0, $69TdO.styles)(theme).status.name.complete,
                "",
                ""
            ],
            children: status || `---`
        })
    });
};
$5e7c20e90b134c57$export$96e9906d6d93a972.propTypes = {};

});
parcelRegister("69TdO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fda3be2477665294$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $fda3be2477665294$export$9dd6ff9ea0189349 = (theme)=>({
        status: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            name: {
                shared: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;height:30px;border-radius:20px;padding:0px 26px;font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                pending: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.primary.normal, ";background-color:", theme.colors.accent.normal, ";", ""),
                restricted: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";background-color:", theme.colors.negative.normal, ";", ""),
                enabled: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.primary.normal, ";background-color:", theme.colors.positive.light, ";", ""),
                complete: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.primary.normal, ";background-color:", theme.colors.positive.normal, ";", "")
            }
        }
    });

});


parcelRegister("Z5Efb", function(module, exports) {

$parcel$export(module.exports, "Subtitle", function () { return $186a1b96a83b6468$export$cf345ef34cd72655; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $HRT12 = parcelRequire("HRT12");
const $186a1b96a83b6468$export$cf345ef34cd72655 = ({ text: text })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $HRT12.styles)(theme).subtitle.main,
        children: text
    });
};
$186a1b96a83b6468$export$cf345ef34cd72655.propTypes = {};

});
parcelRegister("HRT12", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8fafa266d5fc0fb7$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $8fafa266d5fc0fb7$export$9dd6ff9ea0189349 = (theme)=>({
        subtitle: {
            main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("lJVkg", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $3112956e0087fe4a$export$f99233281efd08a0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $heh78 = parcelRequire("heh78");
const $3112956e0087fe4a$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $heh78.styles)(theme).title.main,
        children: text
    });
};
$3112956e0087fe4a$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("heh78", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bd6fa6e260d7716c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $bd6fa6e260d7716c$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("6NkdB", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6b5aca944072bdc5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6b5aca944072bdc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6b5aca944072bdc5$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6b5aca944072bdc5$var$_ref2 = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $6b5aca944072bdc5$var$_ref3 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $6b5aca944072bdc5$var$_ref4 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $6b5aca944072bdc5$var$_ref5 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $6b5aca944072bdc5$var$_ref6 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $6b5aca944072bdc5$var$_ref7 = {
    name: "r5hahk",
    styles: "margin-right:20px"
};
var $6b5aca944072bdc5$var$_ref8 = {
    name: "1gty26n",
    styles: "display:flex;margin-bottom:10px;align-items:center"
};
var $6b5aca944072bdc5$var$_ref9 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $6b5aca944072bdc5$var$_ref10 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6b5aca944072bdc5$var$_ref11 = {
    name: "7a6dt5",
    styles: "margin:50px 0px"
};
const $6b5aca944072bdc5$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $6b5aca944072bdc5$var$_ref11,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:400px;", (0, $gln0L.mq).tablet($6b5aca944072bdc5$var$_ref10), ";", ""),
                account: {
                    main: $6b5aca944072bdc5$var$_ref9,
                    status: {
                        main: $6b5aca944072bdc5$var$_ref8,
                        title: $6b5aca944072bdc5$var$_ref7,
                        name: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        subtitle: /*#__PURE__*/ (0, $7hler.css)("", "")
                    }
                },
                balance: {
                    main: $6b5aca944072bdc5$var$_ref6,
                    title: $6b5aca944072bdc5$var$_ref5,
                    pending: $6b5aca944072bdc5$var$_ref4,
                    available: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-bottom:32px;", (0, $gln0L.mq).tablet($6b5aca944072bdc5$var$_ref3), ";", ""),
                    update: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:130px;}", (0, $gln0L.mq).tablet($6b5aca944072bdc5$var$_ref2), ";", ""),
                    payout: $6b5aca944072bdc5$var$_ref
                }
            }
        }
    });

});



parcelRegister("7u2wt", function(module, exports) {

$parcel$export(module.exports, "connectSlice", function () { return $d84484287be5685d$export$af9a9e979a6f0d83; });
$parcel$export(module.exports, "connectResetState", function () { return $d84484287be5685d$export$16a4a5a1b28ce32e; });
$parcel$export(module.exports, "connectSelectConnectBalance", function () { return $d84484287be5685d$export$f26688763a5ab8a2; });
$parcel$export(module.exports, "connectSelectConnectStatus", function () { return $d84484287be5685d$export$733e31380b7ddf97; });
$parcel$export(module.exports, "connectSelectConnectOnboardingLink", function () { return $d84484287be5685d$export$40352c03dcaa7a5a; });
$parcel$export(module.exports, "connectSelectConnectLoginLink", function () { return $d84484287be5685d$export$2c45777af9ccd7b7; });
$parcel$export(module.exports, "connectSelectConnectGetConnectStatusLoading", function () { return $d84484287be5685d$export$27f61009dfbdab82; });
$parcel$export(module.exports, "connectSelectConnectGetConnectBalanceLoading", function () { return $d84484287be5685d$export$f5d3129eed042924; });
$parcel$export(module.exports, "connectSelectConnectGetConnectOnboardingLinkLoading", function () { return $d84484287be5685d$export$91e3d75843a0851b; });
$parcel$export(module.exports, "connectSelectConnectGetConnectLoginLinkLoading", function () { return $d84484287be5685d$export$4c7d7d7a3b8795aa; });
$parcel$export(module.exports, "connectSelectConnectCreatePayoutLoading", function () { return $d84484287be5685d$export$126a16eeb4842bd2; });
$parcel$export(module.exports, "connectReducer", function () { return $d84484287be5685d$export$b3d13d625aab94b1; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $8bw42 = parcelRequire("8bw42");
const $d84484287be5685d$var$initialState = {
    connectStatus: undefined,
    connectBalance: {
        available: 0,
        pending: 0
    },
    connectOnboardingLink: "",
    connectLoginLink: "",
    connectGetConnectStatusLoading: false,
    connectGetConnectBalanceLoading: false,
    connectGetConnectOnboardingLinkLoading: false,
    connectGetConnectLoginLinkLoading: false,
    connectCreatePayoutLoading: false
};
const $d84484287be5685d$export$af9a9e979a6f0d83 = (0, $kvj5V.createSlice)({
    name: "connect",
    initialState: $d84484287be5685d$var$initialState,
    reducers: {
        // reset state
        connectResetState: ()=>({
                connectStatus: undefined,
                connectBalance: {
                    available: 0,
                    pending: 0
                },
                connectOnboardingLink: "",
                connectLoginLink: "",
                connectGetConnectStatusLoading: false,
                connectGetConnectBalanceLoading: false,
                connectGetConnectOnboardingLinkLoading: false,
                connectGetConnectLoginLinkLoading: false,
                connectCreatePayoutLoading: false
            })
    },
    extraReducers: (builder)=>{
        // get connect status
        builder.addCase((0, $8bw42.connectGetConnectStatus).pending, (state)=>({
                ...state,
                connectGetConnectStatusLoading: true
            })).addCase((0, $8bw42.connectGetConnectStatus).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectStatus: payload.status,
                connectGetConnectStatusLoading: false
            }));
        // get connect balance
        builder.addCase((0, $8bw42.connectGetConnectBalance).pending, (state)=>({
                ...state,
                connectGetConnectBalanceLoading: true
            })).addCase((0, $8bw42.connectGetConnectBalance).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectBalance: payload.balance,
                connectGetConnectBalanceLoading: false
            }));
        // get connect onboarding link
        builder.addCase((0, $8bw42.connectGetConnectOnboardingLink).pending, (state)=>({
                ...state,
                connectGetConnectOnboardingLinkLoading: true
            })).addCase((0, $8bw42.connectGetConnectOnboardingLink).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectOnboardingLink: payload.onboardingLink,
                connectGetConnectOnboardingLinkLoading: false
            }));
        // get connect login link
        builder.addCase((0, $8bw42.connectGetConnectLoginLink).pending, (state)=>({
                ...state,
                connectGetConnectLoginLinkLoading: true
            })).addCase((0, $8bw42.connectGetConnectLoginLink).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectLoginLink: payload.loginLink,
                connectGetConnectLoginLinkLoading: false
            }));
        // create payout
        builder.addCase((0, $8bw42.connectCreatePayout).pending, (state)=>({
                ...state,
                connectCreatePayoutLoading: true
            })).addCase((0, $8bw42.connectCreatePayout).fulfilled, (state)=>({
                ...state,
                connectCreatePayoutLoading: false
            }));
    }
});
const { connectResetState: $d84484287be5685d$export$16a4a5a1b28ce32e } = $d84484287be5685d$export$af9a9e979a6f0d83.actions;
const $d84484287be5685d$export$f26688763a5ab8a2 = (state)=>state.connect.connectBalance;
const $d84484287be5685d$export$733e31380b7ddf97 = (state)=>state.connect.connectStatus;
const $d84484287be5685d$export$40352c03dcaa7a5a = (state)=>state.connect.connectOnboardingLink;
const $d84484287be5685d$export$2c45777af9ccd7b7 = (state)=>state.connect.connectLoginLink;
const $d84484287be5685d$export$27f61009dfbdab82 = (state)=>state.connect.connectGetConnectStatusLoading;
const $d84484287be5685d$export$f5d3129eed042924 = (state)=>state.connect.connectGetConnectBalanceLoading;
const $d84484287be5685d$export$91e3d75843a0851b = (state)=>state.connect.connectGetConnectOnboardingLinkLoading;
const $d84484287be5685d$export$4c7d7d7a3b8795aa = (state)=>state.connect.connectGetConnectLoginLinkLoading;
const $d84484287be5685d$export$126a16eeb4842bd2 = (state)=>state.connect.connectCreatePayoutLoading;
const $d84484287be5685d$export$b3d13d625aab94b1 = $d84484287be5685d$export$af9a9e979a6f0d83.reducer; // export default connectSlice.reducer

});

parcelRegister("8bw42", function(module, exports) {

$parcel$export(module.exports, "connectGetConnectStatus", function () { return $9b7154a0d63dad9d$export$2c07193a2dabf237; });
$parcel$export(module.exports, "connectGetConnectBalance", function () { return $9b7154a0d63dad9d$export$e401564139153401; });
$parcel$export(module.exports, "connectGetConnectOnboardingLink", function () { return $9b7154a0d63dad9d$export$749ddfa1ff9ad91f; });
$parcel$export(module.exports, "connectGetConnectLoginLink", function () { return $9b7154a0d63dad9d$export$9f2d17ed815e9de3; });
$parcel$export(module.exports, "connectCreatePayout", function () { return $9b7154a0d63dad9d$export$1c82019f420b4ac9; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $2O1h5 = parcelRequire("2O1h5");

var $gb3Hs = parcelRequire("gb3Hs");
const $9b7154a0d63dad9d$export$2c07193a2dabf237 = (0, $kvj5V.createAsyncThunk)("connect/connectGetConnectStatus", async ()=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get connect status
        const { status: status } = await api.connectApi.getConnectStatus();
        // return payload
        return {
            status: status,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            status: undefined,
            error: message
        };
    }
});
const $9b7154a0d63dad9d$export$e401564139153401 = (0, $kvj5V.createAsyncThunk)("connect/connectGetConnectBalance", async ()=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get connect balance
        const { availableBalance: availableBalance, pendingBalance: pendingBalance } = await api.connectApi.getConnectBalance();
        // return payload
        return {
            balance: {
                available: availableBalance || 0,
                pending: pendingBalance || 0
            },
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            balance: {
                available: 0,
                pending: 0
            },
            error: message
        };
    }
});
const $9b7154a0d63dad9d$export$749ddfa1ff9ad91f = (0, $kvj5V.createAsyncThunk)("connect/connectGetConnectOnboardingLink", async ()=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get connect onboarding link
        const { link: link } = await api.connectApi.getConnectLink((0, $gb3Hs.ConnectLinkType).Onboarding);
        // return balance payload
        return {
            onboardingLink: link || "",
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            onboardingLink: "",
            error: message
        };
    }
});
const $9b7154a0d63dad9d$export$9f2d17ed815e9de3 = (0, $kvj5V.createAsyncThunk)("connect/connectGetConnectLoginLink", async ()=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get connect update link
        const { link: link } = await api.connectApi.getConnectLoginLink();
        // return payload
        return {
            loginLink: link || "",
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            loginLink: "",
            error: message
        };
    }
});
const $9b7154a0d63dad9d$export$1c82019f420b4ac9 = (0, $kvj5V.createAsyncThunk)("connect/connectCreatePayout", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create payout
        await api.connectApi.createConnectPayout();
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully created payout!"
            }
        }));
        // fetch outgoing transactions
        dispatch((0, $2O1h5.transactionGetOutgoingTransactions)({
            limit: 30,
            offset: 0
        }));
        // fetch balance
        dispatch($9b7154a0d63dad9d$export$e401564139153401());
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create payout: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});
parcelRegister("gb3Hs", function(module, exports) {

$parcel$export(module.exports, "ConnectLinkType", function () { return $28b056a128f8bd2d$export$372751fe44bf95e8; });
var $28b056a128f8bd2d$export$372751fe44bf95e8;
(function(ConnectLinkType) {
    ConnectLinkType["Onboarding"] = "account_onboarding";
    ConnectLinkType["Update"] = "account_update";
})($28b056a128f8bd2d$export$372751fe44bf95e8 || ($28b056a128f8bd2d$export$372751fe44bf95e8 = {}));

});



parcelRegister("gfEo4", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethod", function () { return (parcelRequire("2sP2B")).CustomerPaymentMethod; });
$parcel$export(module.exports, "CustomerPaymentMethodCreateModal", function () { return (parcelRequire("lP9fU")).CustomerPaymentMethodCreateModal; });
$parcel$export(module.exports, "CustomerPaymentMethodDefault", function () { return (parcelRequire("jOj42")).CustomerPaymentMethodDefault; });
$parcel$export(module.exports, "CustomerPaymentMethodListProfile", function () { return (parcelRequire("9rYLD")).CustomerPaymentMethodListProfile; });
$parcel$export(module.exports, "CustomerViewProfile", function () { return (parcelRequire("lle1j")).CustomerViewProfile; });
parcelRequire("40Qmm");
var $2sP2B = parcelRequire("2sP2B");
var $lP9fU = parcelRequire("lP9fU");
var $jOj42 = parcelRequire("jOj42");
var $9rYLD = parcelRequire("9rYLD");
var $lle1j = parcelRequire("lle1j");

var $2KqxL = parcelRequire("2KqxL");

var $9rGZZ = parcelRequire("9rGZZ");
$parcel$exportWildcard(module.exports, $2KqxL);
$parcel$exportWildcard(module.exports, $9rGZZ);

});
parcelRegister("40Qmm", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethod", function () { return (parcelRequire("2sP2B")).CustomerPaymentMethod; });
$parcel$export(module.exports, "CustomerPaymentMethodCreateModal", function () { return (parcelRequire("lP9fU")).CustomerPaymentMethodCreateModal; });
$parcel$export(module.exports, "CustomerPaymentMethodDefault", function () { return (parcelRequire("jOj42")).CustomerPaymentMethodDefault; });
$parcel$export(module.exports, "CustomerPaymentMethodListProfile", function () { return (parcelRequire("9rYLD")).CustomerPaymentMethodListProfile; });
$parcel$export(module.exports, "CustomerViewProfile", function () { return (parcelRequire("lle1j")).CustomerViewProfile; });

var $2sP2B = parcelRequire("2sP2B");

var $lP9fU = parcelRequire("lP9fU");

var $jOj42 = parcelRequire("jOj42");

var $9rYLD = parcelRequire("9rYLD");

var $lle1j = parcelRequire("lle1j");

});
parcelRegister("2sP2B", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethod", function () { return $91e5a3da94998a56$export$5c351e716103ae5c; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $jwfyL = parcelRequire("jwfyL");
var $bq9l8 = parcelRequire("bq9l8");

var $3FbDi = parcelRequire("3FbDi");
const $91e5a3da94998a56$export$5c351e716103ae5c = ({ customerPaymentMethod: customerPaymentMethod, selected: selected, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    const { brand: brand, last4: last4, isDefault: isDefault } = customerPaymentMethod;
    const getPaymentMethodIcon = (cardBrand)=>{
        switch(cardBrand){
            case "amex":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Amex, {});
            case "diners":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Diners, {});
            case "discover":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Discover, {});
            case "eftpos_au":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Eft, {});
            case "jcb":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Jcb, {});
            case "mastercard":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Mastercard, {});
            case "unionpay":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).UnionPay, {});
            case "visa":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Visa, {});
            default:
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Card, {});
        }
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $3FbDi.styles)(theme).method.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3FbDi.styles)(theme).method.type,
                children: getPaymentMethodIcon(brand || "")
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: [
                    (0, $3FbDi.styles)(theme).method.data.main.shared,
                    selected && (0, $3FbDi.styles)(theme).method.data.main.selected,
                    "",
                    ""
                ],
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3FbDi.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3FbDi.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3FbDi.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    last4 ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3FbDi.styles)(theme).method.data.digits,
                        children: last4
                    }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3FbDi.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3FbDi.styles)(theme).method.default,
                children: isDefault && /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CheckCircle, {})
            })
        ]
    });
};
$91e5a3da94998a56$export$5c351e716103ae5c.propTypes = {};

});
parcelRegister("3FbDi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8f8f30b218510316$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $8f8f30b218510316$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8f8f30b218510316$var$_ref = {
    name: "1efi8gv",
    styles: "font-weight:bold"
};
var $8f8f30b218510316$var$_ref2 = {
    name: "nkt64x",
    styles: "margin-right:10px"
};
var $8f8f30b218510316$var$_ref3 = {
    name: "5trhql",
    styles: "margin-right:14px"
};
var $8f8f30b218510316$var$_ref4 = {
    name: "5trhql",
    styles: "margin-right:14px"
};
var $8f8f30b218510316$var$_ref5 = {
    name: "tov9r9",
    styles: "display:flex;align-items:center;height:30px"
};
const $8f8f30b218510316$export$9dd6ff9ea0189349 = (theme)=>({
        method: {
            main: $8f8f30b218510316$var$_ref5,
            type: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;width:46px;margin-right:32px;", (0, $gln0L.mq).mobile($8f8f30b218510316$var$_ref4), " &>svg{height:30px;}", ""),
            data: {
                main: {
                    shared: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;cursor:pointer;transition:color 0.2s;margin-right:32px;", (0, $gln0L.mq).mobile($8f8f30b218510316$var$_ref3), " color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}&>div:not(:last-of-type){margin-right:16px;", (0, $gln0L.mq).mobile($8f8f30b218510316$var$_ref2), ";}", ""),
                    selected: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.accent.normal, ";", "")
                },
                circles: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";", ""),
                digits: $8f8f30b218510316$var$_ref
            },
            default: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;width:20px;height:20px;&>svg{width:20px;height:20px;&>path{fill:", theme.colors.positive.normal, ";}}", "")
        }
    });

});


parcelRegister("lP9fU", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateModal", function () { return $6720e0cd0e81440d$export$9ff1c52ff7c37b3f; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $2KqxL = parcelRequire("2KqxL");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("c0z2Z");
var $kCOHC = parcelRequire("kCOHC");

var $136iR = parcelRequire("136iR");
const $6720e0cd0e81440d$export$9ff1c52ff7c37b3f = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const customerPaymentMethodCreateModalOpen = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethodCreateModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $136iR.styles)().modal.main,
        children: customerPaymentMethodCreateModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $2KqxL.customerCloseCustomerPaymentMethodCreateModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $136iR.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kCOHC.CustomerPaymentMethodCreateCard), {})
            })
        })
    });
};
$6720e0cd0e81440d$export$9ff1c52ff7c37b3f.propTypes = {};

});
parcelRegister("c0z2Z", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateCard", function () { return (parcelRequire("kCOHC")).CustomerPaymentMethodCreateCard; });

var $kCOHC = parcelRequire("kCOHC");

});
parcelRegister("kCOHC", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateCard", function () { return $1190294663b0f1ba$export$a2fba47527901994; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $an00m = parcelRequire("an00m");
parcelRequire("7GBhj");
var $4d4hE = parcelRequire("4d4hE");
parcelRequire("krTeD");
var $2zawF = parcelRequire("2zawF");
var $dypeb = parcelRequire("dypeb");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $2KqxL = parcelRequire("2KqxL");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
parcelRequire("lWWT4");
var $55stI = parcelRequire("55stI");
parcelRequire("6wf6n");
var $lAYVl = parcelRequire("lAYVl");

var $plHDv = parcelRequire("plHDv");
const $1190294663b0f1ba$var$stripePromise = (0, $4d4hE.loadStripe)("staging" === (0, $2zawF.Environment).Production ? (0, $dypeb.stripePublishableKeyProd) : (0, $dypeb.stripePublishableKeyStag));
const $1190294663b0f1ba$export$a2fba47527901994 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const clientSecret = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethodCreateModalClientSecret));
    const customerPaymentMethodCreateError = "";
    const options = {
        clientSecret: clientSecret,
        appearance: (0, $55stI.stripeAppearance)(theme)
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $plHDv.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $plHDv.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $2KqxL.customerCloseCustomerPaymentMethodCreateModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $plHDv.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $plHDv.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $an00m.Elements), {
                            stripe: $1190294663b0f1ba$var$stripePromise,
                            options: options,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lAYVl.CustomerPaymentMethodCreateForm), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $plHDv.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: customerPaymentMethodCreateError
                        })
                    })
                ]
            })
        ]
    });
};
$1190294663b0f1ba$export$a2fba47527901994.propTypes = {};

});
parcelRegister("an00m", function(module, exports) {

(function(global, factory) {
    factory(module.exports, (parcelRequire("bh6RR")));
})(module.exports, function(exports1, React) {
    "use strict";
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
        if (_i == null) return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _s, _e;
        try {
            for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = "Invariant Violation";
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb); // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) cbRef.current.apply(cbRef, arguments);
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === "object";
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === "function";
    }; // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === "function" && typeof raw.createToken === "function" && typeof raw.createPaymentMethod === "function" && typeof raw.confirmCardPayment === "function";
    };
    var PLAIN_OBJECT_STR = "[object Object]";
    var isEqual = function isEqual(left, right) {
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false; // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$2 = "Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details."; // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$2;
        if (isPromise(raw)) return {
            tag: "async",
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: "empty"
        };
        return {
            tag: "sync",
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: "react-stripe-js",
            version: "2.7.3"
        });
        stripe.registerAppInfo({
            name: "react-stripe-js",
            version: "2.7.3",
            url: "https://stripe.com/docs/stripe-js/react"
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = "ElementsContext";
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://stripe.com/docs/stripe-js/react#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]); // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                elements: parsed.tag === "sync" ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            }; // For an async stripePromise, store it in context once resolved
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === "sync" && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                "clientSecret",
                "fonts"
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase("calls useElements()"), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase("mounts <ElementsConsumer>"); // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var _excluded = [
        "on",
        "session"
    ];
    var CustomCheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutSdkContext.displayName = "CustomCheckoutSdkContext";
    var parseCustomCheckoutSdkContext = function parseCustomCheckoutSdkContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find CustomCheckoutProvider context; You need to wrap the part of your app that ".concat(useCase, " in an <CustomCheckoutProvider> provider."));
        return ctx;
    };
    var CustomCheckoutContext = /*#__PURE__*/ React.createContext(null);
    CustomCheckoutContext.displayName = "CustomCheckoutContext";
    var extractCustomCheckoutContextValue = function extractCustomCheckoutContextValue(customCheckoutSdk, sessionState) {
        if (!customCheckoutSdk) return null;
        customCheckoutSdk.on;
        customCheckoutSdk.session;
        var actions = _objectWithoutProperties(customCheckoutSdk, _excluded);
        if (!sessionState) return _objectSpread2(_objectSpread2({}, actions), customCheckoutSdk.session());
        return _objectSpread2(_objectSpread2({}, actions), sessionState);
    };
    var INVALID_STRIPE_ERROR$1 = "Invalid prop `stripe` supplied to `CustomCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.";
    var CustomCheckoutProvider = function CustomCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR$1);
        }, [
            rawStripeProp
        ]); // State used to trigger a re-render when sdk.session is updated
        var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), session = _React$useState2[0], setSession = _React$useState2[1];
        var _React$useState3 = React.useState(function() {
            return {
                stripe: parsed.tag === "sync" ? parsed.stripe : null,
                customCheckoutSdk: null
            };
        }), _React$useState4 = _slicedToArray(_React$useState3, 2), ctx = _React$useState4[0], setContext = _React$useState4[1];
        var safeSetContext = function safeSetContext(stripe, customCheckoutSdk) {
            setContext(function(ctx) {
                if (ctx.stripe && ctx.customCheckoutSdk) return ctx;
                return {
                    stripe: stripe,
                    customCheckoutSdk: customCheckoutSdk
                };
            });
        }; // Ref used to avoid calling initCustomCheckout multiple times when options changes
        var initCustomCheckoutCalledRef = React.useRef(false);
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === "async" && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted && !initCustomCheckoutCalledRef.current) {
                    // Only update context if the component is still mounted
                    // and stripe is not null. We allow stripe to be null to make
                    // handling SSR easier.
                    initCustomCheckoutCalledRef.current = true;
                    stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                        if (customCheckoutSdk) {
                            safeSetContext(stripe, customCheckoutSdk);
                            customCheckoutSdk.on("change", setSession);
                        }
                    });
                }
            });
            else if (parsed.tag === "sync" && parsed.stripe && !initCustomCheckoutCalledRef.current) {
                initCustomCheckoutCalledRef.current = true;
                parsed.stripe.initCustomCheckout(options).then(function(customCheckoutSdk) {
                    if (customCheckoutSdk) {
                        safeSetContext(parsed.stripe, customCheckoutSdk);
                        customCheckoutSdk.on("change", setSession);
                    }
                });
            }
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options,
            setSession
        ]); // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on CustomCheckoutProvider: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            var _prevOptions$elements, _options$elementsOpti;
            if (!ctx.customCheckoutSdk) return;
            if (options.clientSecret && !isUnknownObject(prevOptions) && !isEqual(options.clientSecret, prevOptions.clientSecret)) console.warn("Unsupported prop change: options.client_secret is not a mutable property.");
            var previousAppearance = prevOptions === null || prevOptions === void 0 ? void 0 : (_prevOptions$elements = prevOptions.elementsOptions) === null || _prevOptions$elements === void 0 ? void 0 : _prevOptions$elements.appearance;
            var currentAppearance = options === null || options === void 0 ? void 0 : (_options$elementsOpti = options.elementsOptions) === null || _options$elementsOpti === void 0 ? void 0 : _options$elementsOpti.appearance;
            if (currentAppearance && !isEqual(currentAppearance, previousAppearance)) ctx.customCheckoutSdk.changeAppearance(currentAppearance);
        }, [
            options,
            prevOptions,
            ctx.customCheckoutSdk
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        var customCheckoutContextValue = React.useMemo(function() {
            return extractCustomCheckoutContextValue(ctx.customCheckoutSdk, session);
        }, [
            ctx.customCheckoutSdk,
            session
        ]);
        if (!ctx.customCheckoutSdk) return null;
        return /*#__PURE__*/ React.createElement(CustomCheckoutSdkContext.Provider, {
            value: ctx
        }, /*#__PURE__*/ React.createElement(CustomCheckoutContext.Provider, {
            value: customCheckoutContextValue
        }, children));
    };
    CustomCheckoutProvider.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.shape({
            clientSecret: PropTypes.string.isRequired,
            elementsOptions: PropTypes.object
        }).isRequired
    };
    var useCustomCheckoutSdkContextWithUseCase = function useCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var ctx = React.useContext(CustomCheckoutSdkContext);
        return parseCustomCheckoutSdkContext(ctx, useCaseString);
    };
    var useElementsOrCustomCheckoutSdkContextWithUseCase = function useElementsOrCustomCheckoutSdkContextWithUseCase(useCaseString) {
        var customCheckoutSdkContext = React.useContext(CustomCheckoutSdkContext);
        var elementsContext = React.useContext(ElementsContext);
        if (customCheckoutSdkContext && elementsContext) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both <CustomCheckoutProvider> and <Elements> providers."));
        if (customCheckoutSdkContext) return parseCustomCheckoutSdkContext(customCheckoutSdkContext, useCaseString);
        return parseElementsContext(elementsContext, useCaseString);
    };
    var useCustomCheckout = function useCustomCheckout() {
        // ensure it's in CustomCheckoutProvider
        useCustomCheckoutSdkContextWithUseCase("calls useCustomCheckout()");
        var ctx = React.useContext(CustomCheckoutContext);
        if (!ctx) throw new Error("Could not find CustomCheckout Context; You need to wrap the part of your app that calls useCustomCheckout() in an <CustomCheckoutProvider> provider.");
        return ctx;
    };
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange;
            var ctx = useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = "elements" in ctx ? ctx.elements : null;
            var customCheckoutSdk = "customCheckoutSdk" in ctx ? ctx.customCheckoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null); // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, "blur", onBlur);
            useAttachEvent(element, "focus", onFocus);
            useAttachEvent(element, "escape", onEscape);
            useAttachEvent(element, "click", onClick);
            useAttachEvent(element, "loaderror", onLoadError);
            useAttachEvent(element, "loaderstart", onLoaderStart);
            useAttachEvent(element, "networkschange", onNetworksChange);
            useAttachEvent(element, "confirm", onConfirm);
            useAttachEvent(element, "cancel", onCancel);
            useAttachEvent(element, "shippingaddresschange", onShippingAddressChange);
            useAttachEvent(element, "shippingratechange", onShippingRateChange);
            useAttachEvent(element, "change", onChange);
            var readyCallback;
            if (onReady) {
                if (type === "expressCheckout") // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, "ready", readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || customCheckoutSdk)) {
                    var newElement = null;
                    if (customCheckoutSdk) newElement = customCheckoutSdk.createElement(type, options);
                    else if (elements) newElement = elements.create(type, options);
                     // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement; // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                customCheckoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    "paymentRequest"
                ]);
                if (updates) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === "function") try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {}
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        }; // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCustomCheckoutSdkContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === "undefined";
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = "EmbeddedCheckoutProviderContext";
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error("<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>");
        return ctx;
    };
    var INVALID_STRIPE_ERROR = "Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.";
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.initEmbeddedCheckout(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            }; // For an async stripePromise, store it once resolved
            if (parsed.tag === "async" && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === "sync" && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]); // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]); // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.");
        }, [
            prevStripe,
            rawStripeProp
        ]); // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.");
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn("Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.");
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.");
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.");
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.");
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn("Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.");
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            } // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    }; // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCustomC = useElementsOrCustomCheckoutSdkContextWithUseCase("calls useStripe()"), stripe = _useElementsOrCustomC.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent("auBankAccount", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent("card", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent("cardNumber", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent("cardExpiry", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent("cardCvc", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var FpxBankElement = createElementComponent("fpxBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent("iban", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IdealBankElement = createElementComponent("idealBank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var P24BankElement = createElementComponent("p24Bank", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var EpsBankElement = createElementComponent("epsBank", isServer);
    var PaymentElement = createElementComponent("payment", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent("expressCheckout", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent("paymentRequestButton", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent("linkAuthentication", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent("address", isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent("shippingAddress", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent("paymentMethodMessaging", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AffirmMessageElement = createElementComponent("affirmMessage", isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AfterpayClearpayMessageElement = createElementComponent("afterpayClearpayMessage", isServer);
    exports1.AddressElement = AddressElement;
    exports1.AffirmMessageElement = AffirmMessageElement;
    exports1.AfterpayClearpayMessageElement = AfterpayClearpayMessageElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.CustomCheckoutProvider = CustomCheckoutProvider;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.EpsBankElement = EpsBankElement;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FpxBankElement = FpxBankElement;
    exports1.IbanElement = IbanElement;
    exports1.IdealBankElement = IdealBankElement;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.P24BankElement = P24BankElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.useCustomCheckout = useCustomCheckout;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});

});

parcelRegister("7GBhj", function(module, exports) {
$parcel$export(module.exports, "loadStripe", function () { return (parcelRequire("4d4hE")).loadStripe; });
parcelRequire("4d4hE");

});
parcelRegister("4d4hE", function(module, exports) {

$parcel$export(module.exports, "loadStripe", function () { return $293cdbce9e9eb723$export$de80f7562c3fd6b1; });
var $293cdbce9e9eb723$var$V3_URL = "https://js.stripe.com/v3";
var $293cdbce9e9eb723$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $293cdbce9e9eb723$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $293cdbce9e9eb723$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($293cdbce9e9eb723$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$293cdbce9e9eb723$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $293cdbce9e9eb723$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($293cdbce9e9eb723$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $293cdbce9e9eb723$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "3.4.1",
        startTime: startTime
    });
};
var $293cdbce9e9eb723$var$stripePromise = null;
var $293cdbce9e9eb723$var$onErrorListener = null;
var $293cdbce9e9eb723$var$onLoadListener = null;
var $293cdbce9e9eb723$var$onError = function onError(reject) {
    return function() {
        reject(new Error("Failed to load Stripe.js"));
    };
};
var $293cdbce9e9eb723$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error("Stripe.js not available"));
    };
};
var $293cdbce9e9eb723$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($293cdbce9e9eb723$var$stripePromise !== null) return $293cdbce9e9eb723$var$stripePromise;
    $293cdbce9e9eb723$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($293cdbce9e9eb723$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $293cdbce9e9eb723$var$findScript();
            if (script && params) console.warn($293cdbce9e9eb723$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $293cdbce9e9eb723$var$injectScript(params);
            else if (script && $293cdbce9e9eb723$var$onLoadListener !== null && $293cdbce9e9eb723$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener("load", $293cdbce9e9eb723$var$onLoadListener);
                script.removeEventListener("error", $293cdbce9e9eb723$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $293cdbce9e9eb723$var$injectScript(params);
            }
            $293cdbce9e9eb723$var$onLoadListener = $293cdbce9e9eb723$var$onLoad(resolve, reject);
            $293cdbce9e9eb723$var$onErrorListener = $293cdbce9e9eb723$var$onError(reject);
            script.addEventListener("load", $293cdbce9e9eb723$var$onLoadListener);
            script.addEventListener("error", $293cdbce9e9eb723$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $293cdbce9e9eb723$var$stripePromise["catch"](function(error) {
        $293cdbce9e9eb723$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $293cdbce9e9eb723$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $293cdbce9e9eb723$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $293cdbce9e9eb723$var$stripePromise$1;
var $293cdbce9e9eb723$var$loadCalled = false;
var $293cdbce9e9eb723$var$getStripePromise = function getStripePromise() {
    if ($293cdbce9e9eb723$var$stripePromise$1) return $293cdbce9e9eb723$var$stripePromise$1;
    $293cdbce9e9eb723$var$stripePromise$1 = $293cdbce9e9eb723$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $293cdbce9e9eb723$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
    return $293cdbce9e9eb723$var$stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $293cdbce9e9eb723$var$getStripePromise();
})["catch"](function(error) {
    if (!$293cdbce9e9eb723$var$loadCalled) console.warn(error);
});
var $293cdbce9e9eb723$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $293cdbce9e9eb723$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $293cdbce9e9eb723$var$getStripePromise().then(function(maybeStripe) {
        return $293cdbce9e9eb723$var$initStripe(maybeStripe, args, startTime);
    });
};

});


parcelRegister("6wf6n", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateForm", function () { return (parcelRequire("lAYVl")).CustomerPaymentMethodCreateForm; });

var $lAYVl = parcelRequire("lAYVl");

});
parcelRegister("lAYVl", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodCreateForm", function () { return $3d3c94a4082dac3c$export$d3b1916139689608; });

var $9awXB = parcelRequire("9awXB");

var $an00m = parcelRequire("an00m");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9rGZZ = parcelRequire("9rGZZ");
var $2KqxL = parcelRequire("2KqxL");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $5Nqi0 = parcelRequire("5Nqi0");
const $3d3c94a4082dac3c$export$d3b1916139689608 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const customerCreateCustomerPaymentMethodLoading = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerCreateCustomerPaymentMethodLoading));
    const stripe = (0, $an00m.useStripe)();
    const elements = (0, $an00m.useElements)();
    const submitDisabled = customerCreateCustomerPaymentMethodLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5Nqi0.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $5Nqi0.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                // create customer payment method with payment element
                dispatch((0, $9rGZZ.customerCreateCustomerPaymentMethod)({
                    stripe: stripe,
                    elements: elements
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $5Nqi0.styles)().form.content.card,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $an00m.PaymentElement), {})
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $5Nqi0.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "checkout",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: customerCreateCustomerPaymentMethodLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Create`
                    })
                })
            ]
        })
    });
};
$3d3c94a4082dac3c$export$d3b1916139689608.propTypes = {};

});
parcelRegister("5Nqi0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $20fc1d73189d0cd9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $20fc1d73189d0cd9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $20fc1d73189d0cd9$var$_ref = {
    name: "18wktwv",
    styles: "display:flex;align-items:center;justify-content:left;margin-bottom:32px"
};
var $20fc1d73189d0cd9$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $20fc1d73189d0cd9$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                card: $20fc1d73189d0cd9$var$_ref2,
                checkbox: {
                    main: $20fc1d73189d0cd9$var$_ref,
                    label: /*#__PURE__*/ (0, $7hler.css)("display:flex;font-size:", (0, $gln0L.typography).h6, ";user-select:none;margin-left:16px;", "")
                },
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("plHDv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $306fb5264bd42af0$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $306fb5264bd42af0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $306fb5264bd42af0$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $306fb5264bd42af0$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $306fb5264bd42af0$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $306fb5264bd42af0$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $306fb5264bd42af0$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $306fb5264bd42af0$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $306fb5264bd42af0$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $306fb5264bd42af0$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $306fb5264bd42af0$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($306fb5264bd42af0$var$_ref8), " ", (0, $gln0L.mq).mobile($306fb5264bd42af0$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($306fb5264bd42af0$var$_ref6), ";", ""),
            title: $306fb5264bd42af0$var$_ref5,
            subtitle: $306fb5264bd42af0$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($306fb5264bd42af0$var$_ref3), ";", ""),
                form: $306fb5264bd42af0$var$_ref2,
                error: $306fb5264bd42af0$var$_ref
            }
        }
    });

});



parcelRegister("136iR", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4e2f430c3c287f4e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4e2f430c3c287f4e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4e2f430c3c287f4e$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $4e2f430c3c287f4e$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($4e2f430c3c287f4e$var$_ref), ";", "")
        }
    });

});


parcelRegister("jOj42", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodDefault", function () { return $c2f97a9a13fc97f7$export$903d5dcea0359875; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $jwfyL = parcelRequire("jwfyL");

var $dw4bV = parcelRequire("dw4bV");
const $c2f97a9a13fc97f7$export$903d5dcea0359875 = ({ brand: brand = "", last4: last4 = "" })=>{
    const theme = (0, $iwq56.u)();
    const getPaymentMethodIcon = (cardBrand)=>{
        switch(cardBrand){
            case "amex":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Amex, {});
            case "diners":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Diners, {});
            case "discover":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Discover, {});
            case "eftpos_au":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Eft, {});
            case "jcb":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Jcb, {});
            case "mastercard":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Mastercard, {});
            case "unionpay":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).UnionPay, {});
            case "visa":
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Visa, {});
            default:
                return /*#__PURE__*/ (0, $9awXB.jsx)((0, $jwfyL.cards).Card, {});
        }
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dw4bV.styles)(theme).method.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dw4bV.styles)(theme).method.type,
                children: getPaymentMethodIcon(brand || "")
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $dw4bV.styles)(theme).method.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dw4bV.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dw4bV.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dw4bV.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    }),
                    last4 ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dw4bV.styles)(theme).method.data.digits,
                        children: last4
                    }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dw4bV.styles)(theme).method.data.circles,
                        children: "\u25CF\u25CF\u25CF\u25CF"
                    })
                ]
            })
        ]
    });
};
$c2f97a9a13fc97f7$export$903d5dcea0359875.propTypes = {};

});
parcelRegister("dw4bV", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a7562a7e7cd26e45$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $a7562a7e7cd26e45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a7562a7e7cd26e45$var$_ref = {
    name: "1efi8gv",
    styles: "font-weight:bold"
};
var $a7562a7e7cd26e45$var$_ref2 = {
    name: "nkt64x",
    styles: "margin-right:10px"
};
var $a7562a7e7cd26e45$var$_ref3 = {
    name: "1nwiza9",
    styles: "display:flex;align-items:center;margin-bottom:16px;&>svg{height:40px;}"
};
var $a7562a7e7cd26e45$var$_ref4 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
const $a7562a7e7cd26e45$export$9dd6ff9ea0189349 = (theme)=>({
        method: {
            main: $a7562a7e7cd26e45$var$_ref4,
            type: $a7562a7e7cd26e45$var$_ref3,
            data: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;cursor:pointer;transition:color 0.2s;color:", theme.colors.secondary.normal, ";&>div:not(:last-of-type){margin-right:16px;", (0, $gln0L.mq).mobile($a7562a7e7cd26e45$var$_ref2), ";}", ""),
                circles: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";", ""),
                digits: $a7562a7e7cd26e45$var$_ref
            }
        }
    });

});


parcelRegister("9rYLD", function(module, exports) {

$parcel$export(module.exports, "CustomerPaymentMethodListProfile", function () { return $e49bcc5d2a8dc55f$export$c35dd062ff2cce62; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9rGZZ = parcelRequire("9rGZZ");
var $2sP2B = parcelRequire("2sP2B");
var $2KqxL = parcelRequire("2KqxL");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $14I9U = parcelRequire("14I9U");
const $e49bcc5d2a8dc55f$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const customerPaymentMethodSelected = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethodSelected));
    const customerPaymentMethods = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethods));
    const customerPaymentMethod = customerPaymentMethods[index];
    // if payment method not fetched
    if (!customerPaymentMethod) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "customer-payment-method-list-payment-method",
                    width: "100%",
                    height: "30px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $14I9U.styles)().pms.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2sP2B.CustomerPaymentMethod), {
            customerPaymentMethod: customerPaymentMethod,
            selected: customerPaymentMethodSelected?.id === customerPaymentMethod?.id,
            onClick: ()=>dispatch((0, $2KqxL.customerSelectCustomerPaymentMethod)({
                    customerPaymentMethod: customerPaymentMethod
                }))
        })
    });
});
const $e49bcc5d2a8dc55f$export$c35dd062ff2cce62 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const customerPaymentMethods = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethods));
    const customerPaymentMethodsCount = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethodsCount));
    const customerPaymentMethodsLength = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethodsLength));
    const customerPaymentMethodsFetched = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethodsFetched));
    const paymentMethodCardHeight = 30;
    const paymentMethodCardMarginBottom = 10;
    const itemHeight = paymentMethodCardHeight + paymentMethodCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 160;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!customerPaymentMethods[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $9rGZZ.customerGetCustomerPaymentMethods)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if payment methods are fetched but length is 0
    if (customerPaymentMethodsFetched && customerPaymentMethodsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $14I9U.styles)().list.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).CreditCard,
            height: "160px",
            title: "You don't have any payment methods yet"
        })
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $14I9U.styles)().list.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $14I9U.styles)().list.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
                isItemLoaded: isItemLoaded,
                loadMoreItems: loadMoreItems,
                itemCount: customerPaymentMethodsCount || defaultContentCount,
                minimumBatchSize: itemsToFetch,
                threshold: itemThreshold,
                children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                        className: "virtualized-list",
                        height: defaultListHeight,
                        itemSize: itemHeight,
                        itemCount: customerPaymentMethodsCount || defaultContentCount,
                        onItemsRendered: onItemsRendered,
                        ref: ref,
                        width: defaultListWidth,
                        layout: "vertical",
                        children: $e49bcc5d2a8dc55f$var$Row
                    })
            })
        })
    }));
};
$e49bcc5d2a8dc55f$export$c35dd062ff2cce62.propTypes = {};

});
parcelRegister("14I9U", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $dbeea5b6b9219b72$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $dbeea5b6b9219b72$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $dbeea5b6b9219b72$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
const $dbeea5b6b9219b72$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: $dbeea5b6b9219b72$var$_ref
            }
        },
        pms: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("lle1j", function(module, exports) {

$parcel$export(module.exports, "CustomerViewProfile", function () { return $e27e441fa7cb766c$export$1493c81b20626531; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9rGZZ = parcelRequire("9rGZZ");
var $9rYLD = parcelRequire("9rYLD");
var $2KqxL = parcelRequire("2KqxL");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("8ZAYY");
var $api6Q = parcelRequire("api6Q");

var $fBioF = parcelRequire("fBioF");
const $e27e441fa7cb766c$export$1493c81b20626531 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const customerPaymentMethodSelected = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerPaymentMethodSelected));
    const customerDeleteCustomerPaymentMethodLoading = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerDeleteCustomerPaymentMethodLoading));
    const customerCreateCustomerPaymentMethodSetupLoading = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerCreateCustomerPaymentMethodSetupLoading));
    const customerSetCustomerPaymentMethodDefaultLoading = (0, $gNvvs.useAppSelector)((0, $2KqxL.customerSelectCustomerSetCustomerPaymentMethodDefaultLoading));
    const isPaymentMethodSelected = customerPaymentMethodSelected !== undefined;
    const isSelectedPaymentMethodDefault = customerPaymentMethodSelected?.isDefault === true;
    const deletePaymentMethodDisabled = !isPaymentMethodSelected || customerDeleteCustomerPaymentMethodLoading;
    const createPaymentMethodDisabled = customerCreateCustomerPaymentMethodSetupLoading;
    const setDefaultPaymentMethodDisabled = !isPaymentMethodSelected || isSelectedPaymentMethodDefault || customerSetCustomerPaymentMethodDefaultLoading;
    (0, $bh6RR.useEffect)(()=>{
        // get payment methods
        dispatch((0, $9rGZZ.customerGetCustomerPaymentMethods)({
            offset: 0,
            limit: 30
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fBioF.styles)().card.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $fBioF.styles)().card.content.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fBioF.styles)().card.content.title,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $api6Q.Title), {
                        text: "Payment methods"
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fBioF.styles)().card.content.methods.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9rYLD.CustomerPaymentMethodListProfile), {})
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fBioF.styles)().card.content.buttons.main,
                    children: [
                        isPaymentMethodSelected ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fBioF.styles)().card.content.buttons.delete,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "delete payment method",
                                disabled: deletePaymentMethodDisabled,
                                appearance: "secondary",
                                onClick: ()=>{
                                    dispatch((0, $9rGZZ.customerDeleteCustomerPaymentMethod)({
                                        customerPaymentMethod: customerPaymentMethodSelected || {}
                                    }));
                                },
                                children: customerDeleteCustomerPaymentMethodLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Delete"
                            })
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fBioF.styles)().card.content.buttons.create,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "create payment method",
                                disabled: createPaymentMethodDisabled,
                                appearance: "primary",
                                onClick: ()=>dispatch((0, $9rGZZ.customerCreateCustomerPaymentMethodSetup)()),
                                children: customerCreateCustomerPaymentMethodSetupLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Create"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fBioF.styles)().card.content.buttons.set,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "set payment method as default",
                                disabled: setDefaultPaymentMethodDisabled,
                                appearance: "primary",
                                onClick: ()=>{
                                    dispatch((0, $9rGZZ.customerSetCustomerPaymentMethodDefault)({
                                        customerPaymentMethod: customerPaymentMethodSelected || {}
                                    }));
                                },
                                children: customerSetCustomerPaymentMethodDefaultLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Set as Default"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$e27e441fa7cb766c$export$1493c81b20626531.propTypes = {};

});
parcelRegister("8ZAYY", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return (parcelRequire("api6Q")).Title; });

var $api6Q = parcelRequire("api6Q");

});
parcelRegister("api6Q", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $9ed4fac19768ee90$export$f99233281efd08a0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $6pDbE = parcelRequire("6pDbE");
const $9ed4fac19768ee90$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $6pDbE.styles)(theme).title.main,
        children: text
    });
};
$9ed4fac19768ee90$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("6pDbE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7825070528de52aa$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $7825070528de52aa$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("fBioF", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $185079719ad56121$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $185079719ad56121$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $185079719ad56121$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $185079719ad56121$var$_ref2 = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $185079719ad56121$var$_ref3 = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $185079719ad56121$var$_ref4 = {
    name: "17y49kf",
    styles: "flex-direction:column;width:100%"
};
var $185079719ad56121$var$_ref5 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $185079719ad56121$var$_ref6 = {
    name: "j9ove5",
    styles: "margin-bottom:22px"
};
var $185079719ad56121$var$_ref7 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $185079719ad56121$var$_ref8 = {
    name: "7a6dt5",
    styles: "margin:50px 0px"
};
const $185079719ad56121$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $185079719ad56121$var$_ref8,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("max-width:800px;", (0, $gln0L.mq).tablet($185079719ad56121$var$_ref7), ";", ""),
                title: $185079719ad56121$var$_ref6,
                methods: {
                    main: $185079719ad56121$var$_ref5
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-bottom:32px;width:400px;", (0, $gln0L.mq).tablet($185079719ad56121$var$_ref4), ";", ""),
                    delete: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:130px;}", (0, $gln0L.mq).tablet($185079719ad56121$var$_ref3), ";", ""),
                    create: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:130px;}", (0, $gln0L.mq).tablet($185079719ad56121$var$_ref2), ";", ""),
                    set: $185079719ad56121$var$_ref
                }
            }
        }
    });

});



parcelRegister("2KqxL", function(module, exports) {

$parcel$export(module.exports, "customerSlice", function () { return $d1c1e84036a8ad72$export$2ae3d640159c6d99; });
$parcel$export(module.exports, "customerResetState", function () { return $d1c1e84036a8ad72$export$e8611f1371357562; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethod", function () { return $d1c1e84036a8ad72$export$36631dd251fe5c6c; });
$parcel$export(module.exports, "customerSetCustomerPaymentMethods", function () { return $d1c1e84036a8ad72$export$d3675be8a985ff73; });
$parcel$export(module.exports, "customerOpenCustomerPaymentMethodCreateModal", function () { return $d1c1e84036a8ad72$export$73439e5c1c8cb7c3; });
$parcel$export(module.exports, "customerCloseCustomerPaymentMethodCreateModal", function () { return $d1c1e84036a8ad72$export$6ebf30059d388a82; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethods", function () { return $d1c1e84036a8ad72$export$1c810647799c8d17; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodsLength", function () { return $d1c1e84036a8ad72$export$79b2f162e22bae6e; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodsCount", function () { return $d1c1e84036a8ad72$export$f293b366466a19aa; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodsFetched", function () { return $d1c1e84036a8ad72$export$4a36ad94fa280cd7; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodSelected", function () { return $d1c1e84036a8ad72$export$e1cdac964ce638d8; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodCreateModalOpen", function () { return $d1c1e84036a8ad72$export$5f41e97201b93f24; });
$parcel$export(module.exports, "customerSelectCustomerPaymentMethodCreateModalClientSecret", function () { return $d1c1e84036a8ad72$export$af4ca5677d61a6b6; });
$parcel$export(module.exports, "customerSelectCustomerGetCustomerPaymentMethodsLoading", function () { return $d1c1e84036a8ad72$export$ee06c98f7e90ab8e; });
$parcel$export(module.exports, "customerSelectCustomerCreateCustomerPaymentMethodSetupLoading", function () { return $d1c1e84036a8ad72$export$16c18301d24bcd0d; });
$parcel$export(module.exports, "customerSelectCustomerCreateCustomerPaymentMethodLoading", function () { return $d1c1e84036a8ad72$export$6e19e431c89cee0d; });
$parcel$export(module.exports, "customerSelectCustomerDeleteCustomerPaymentMethodLoading", function () { return $d1c1e84036a8ad72$export$7ff1e0cdf406ce47; });
$parcel$export(module.exports, "customerSelectCustomerSetCustomerPaymentMethodDefaultLoading", function () { return $d1c1e84036a8ad72$export$3756350e3b4b2e28; });
$parcel$export(module.exports, "customerReducer", function () { return $d1c1e84036a8ad72$export$949d24f84332859b; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $9rGZZ = parcelRequire("9rGZZ");
const $d1c1e84036a8ad72$var$initialState = {
    customerPaymentMethods: [],
    customerPaymentMethodsCount: 0,
    customerPaymentMethodsFetched: false,
    customerPaymentMethodSelected: undefined,
    customerPaymentMethodCreateModal: {
        clientSecret: "",
        open: false
    },
    customerGetCustomerPaymentMethodsLoading: false,
    customerCreateCustomerPaymentMethodSetupLoading: false,
    customerCreateCustomerPaymentMethodLoading: false,
    customerDeleteCustomerPaymentMethodLoading: false,
    customerSetCustomerPaymentMethodDefaultLoading: false
};
const $d1c1e84036a8ad72$export$2ae3d640159c6d99 = (0, $kvj5V.createSlice)({
    name: "customer",
    initialState: $d1c1e84036a8ad72$var$initialState,
    reducers: {
        // reset state
        customerResetState: ()=>({
                customerPaymentMethods: [],
                customerPaymentMethodsCount: 0,
                customerPaymentMethodsFetched: false,
                customerPaymentMethodSelected: undefined,
                customerPaymentMethodCreateModal: {
                    clientSecret: "",
                    open: false
                },
                customerGetCustomerPaymentMethodsLoading: false,
                customerCreateCustomerPaymentMethodSetupLoading: false,
                customerCreateCustomerPaymentMethodLoading: false,
                customerDeleteCustomerPaymentMethodLoading: false,
                customerSetCustomerPaymentMethodDefaultLoading: false
            }),
        // select customer payment method
        customerSelectCustomerPaymentMethod: (state, action)=>{
            const { customerPaymentMethod: customerPaymentMethod } = action.payload;
            // mutate selected customer payment method
            // if provided payment method already selected - unselect it
            // else select provided payment method
            state.customerPaymentMethodSelected = state.customerPaymentMethodSelected?.id === customerPaymentMethod?.id ? undefined : customerPaymentMethod;
        },
        // set customer payment methods
        customerSetCustomerPaymentMethods: (state, action)=>{
            const { customerPaymentMethods: customerPaymentMethods, count: count, offset: offset } = action.payload;
            // mutate count
            state.customerPaymentMethodsCount = count;
            // mutate payment methods array
            state.customerPaymentMethods = (0, $6Rkyy.mergeArraysAtIndex)(state.customerPaymentMethods, customerPaymentMethods, offset);
        },
        // open customer payment method create modal
        customerOpenCustomerPaymentMethodCreateModal: (state, action)=>({
                ...state,
                customerPaymentMethodCreateModal: {
                    clientSecret: action.payload.clientSecret,
                    open: true
                }
            }),
        // close customer payment method create modal
        customerCloseCustomerPaymentMethodCreateModal: (state)=>({
                ...state,
                customerPaymentMethodCreateModal: {
                    clientSecret: "",
                    open: false
                }
            })
    },
    extraReducers: (builder)=>{
        // get customer payment methods
        builder.addCase((0, $9rGZZ.customerGetCustomerPaymentMethods).pending, (state)=>({
                ...state,
                customerGetCustomerPaymentMethodsLoading: true
            })).addCase((0, $9rGZZ.customerGetCustomerPaymentMethods).fulfilled, (state)=>({
                ...state,
                customerPaymentMethodsFetched: true,
                customerGetCustomerPaymentMethodsLoading: false
            }));
        // create customer payment method setup
        builder.addCase((0, $9rGZZ.customerCreateCustomerPaymentMethodSetup).pending, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodSetupLoading: true
            })).addCase((0, $9rGZZ.customerCreateCustomerPaymentMethodSetup).fulfilled, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodSetupLoading: false
            }));
        // create customer payment method
        builder.addCase((0, $9rGZZ.customerCreateCustomerPaymentMethod).pending, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodLoading: true
            })).addCase((0, $9rGZZ.customerCreateCustomerPaymentMethod).fulfilled, (state)=>({
                ...state,
                customerCreateCustomerPaymentMethodLoading: false
            }));
        // delete customer payment method
        builder.addCase((0, $9rGZZ.customerDeleteCustomerPaymentMethod).pending, (state)=>({
                ...state,
                customerDeleteCustomerPaymentMethodLoading: true
            })).addCase((0, $9rGZZ.customerDeleteCustomerPaymentMethod).fulfilled, (state)=>({
                ...state,
                customerDeleteCustomerPaymentMethodLoading: false
            }));
        // set customer payment method default
        builder.addCase((0, $9rGZZ.customerSetCustomerPaymentMethodDefault).pending, (state)=>({
                ...state,
                customerSetCustomerPaymentMethodDefaultLoading: true
            })).addCase((0, $9rGZZ.customerSetCustomerPaymentMethodDefault).fulfilled, (state, { payload: payload })=>({
                ...state,
                customerSetCustomerPaymentMethodDefaultLoading: false,
                error: payload.error
            }));
    }
});
const { customerResetState: $d1c1e84036a8ad72$export$e8611f1371357562, customerSelectCustomerPaymentMethod: $d1c1e84036a8ad72$export$36631dd251fe5c6c, customerSetCustomerPaymentMethods: $d1c1e84036a8ad72$export$d3675be8a985ff73, customerOpenCustomerPaymentMethodCreateModal: $d1c1e84036a8ad72$export$73439e5c1c8cb7c3, customerCloseCustomerPaymentMethodCreateModal: $d1c1e84036a8ad72$export$6ebf30059d388a82 } = $d1c1e84036a8ad72$export$2ae3d640159c6d99.actions;
const $d1c1e84036a8ad72$export$1c810647799c8d17 = (state)=>state.customer.customerPaymentMethods;
const $d1c1e84036a8ad72$export$79b2f162e22bae6e = (state)=>state.customer.customerPaymentMethods.length;
const $d1c1e84036a8ad72$export$f293b366466a19aa = (state)=>state.customer.customerPaymentMethodsCount;
const $d1c1e84036a8ad72$export$4a36ad94fa280cd7 = (state)=>state.customer.customerPaymentMethodsFetched;
const $d1c1e84036a8ad72$export$e1cdac964ce638d8 = (state)=>state.customer.customerPaymentMethodSelected;
const $d1c1e84036a8ad72$export$5f41e97201b93f24 = (state)=>state.customer.customerPaymentMethodCreateModal.open;
const $d1c1e84036a8ad72$export$af4ca5677d61a6b6 = (state)=>state.customer.customerPaymentMethodCreateModal.clientSecret;
const $d1c1e84036a8ad72$export$ee06c98f7e90ab8e = (state)=>state.customer.customerGetCustomerPaymentMethodsLoading;
const $d1c1e84036a8ad72$export$16c18301d24bcd0d = (state)=>state.customer.customerCreateCustomerPaymentMethodSetupLoading;
const $d1c1e84036a8ad72$export$6e19e431c89cee0d = (state)=>state.customer.customerCreateCustomerPaymentMethodLoading;
const $d1c1e84036a8ad72$export$7ff1e0cdf406ce47 = (state)=>state.customer.customerDeleteCustomerPaymentMethodLoading;
const $d1c1e84036a8ad72$export$3756350e3b4b2e28 = (state)=>state.customer.customerSetCustomerPaymentMethodDefaultLoading;
const $d1c1e84036a8ad72$export$949d24f84332859b = $d1c1e84036a8ad72$export$2ae3d640159c6d99.reducer; // export default customerSlice.reducer

});

parcelRegister("9rGZZ", function(module, exports) {

$parcel$export(module.exports, "customerGetCustomerPaymentMethods", function () { return $c325c1c1f3ce606e$export$aae3832a27512d82; });
$parcel$export(module.exports, "customerCreateCustomerPaymentMethodSetup", function () { return $c325c1c1f3ce606e$export$ac39972811fd4372; });
$parcel$export(module.exports, "customerCreateCustomerPaymentMethod", function () { return $c325c1c1f3ce606e$export$a511c4c6d7bd397d; });
$parcel$export(module.exports, "customerDeleteCustomerPaymentMethod", function () { return $c325c1c1f3ce606e$export$8e61ca7747be6855; });
$parcel$export(module.exports, "customerSetCustomerPaymentMethodDefault", function () { return $c325c1c1f3ce606e$export$61f68d108929c87; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("krTeD");
var $2zawF = parcelRequire("2zawF");
var $itzfe = parcelRequire("itzfe");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $2KqxL = parcelRequire("2KqxL");
const $c325c1c1f3ce606e$export$aae3832a27512d82 = (0, $kvj5V.createAsyncThunk)("customer/customerGetCustomerPaymentMethods", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get payment methods
        const { customerPaymentMethods: customerPaymentMethods, count: count } = await api.customerApi.getCustomerPaymentMethods(inp.limit, inp.offset);
        // set payment methods
        dispatch((0, $2KqxL.customerSetCustomerPaymentMethods)({
            customerPaymentMethods: customerPaymentMethods || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c325c1c1f3ce606e$export$ac39972811fd4372 = (0, $kvj5V.createAsyncThunk)("customer/customerCreateCustomerPaymentMethodSetup", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create customer payment method setup
        const { clientSecret: clientSecret } = await api.customerApi.createCustomerPaymentMethodSetup();
        // open customer payment method create modal
        dispatch((0, $2KqxL.customerOpenCustomerPaymentMethodCreateModal)({
            clientSecret: clientSecret || ""
        }));
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to setup customer payment method creation: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c325c1c1f3ce606e$export$a511c4c6d7bd397d = (0, $kvj5V.createAsyncThunk)("customer/customerCreateCustomerPaymentMethod", async (inp, { dispatch: dispatch })=>{
    // if stripe is not loaded
    if (!inp.stripe || !inp.elements) // return error message in payload
    return {
        error: "Stripe is failed to load"
    };
    // define redirect url
    const redirectUrl = "staging" === (0, $2zawF.Environment).Production ? (0, $itzfe.Platform).ProductionURL : (0, $itzfe.Platform).StagingURL;
    try {
        // confirm stripe setup
        const { error: error } = await inp.stripe.confirmSetup({
            elements: inp.elements,
            redirect: "if_required",
            confirmParams: {
                return_url: redirectUrl
            }
        });
        // if error returned
        if (error) {
            // launch error alert
            dispatch((0, $6tPng.alertAddMessage)({
                message: {
                    id: (0, $itWch.uuid)(),
                    type: (0, $h7gla.AlertMessageType).Error,
                    message: `Payment method creation failed: ${error.message}`
                }
            }));
            // return error message in payload
            return {
                error: error.message || ""
            };
        }
        // launch success alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: `Payment method creation succeeded!`
            }
        }));
        // close customer payment method create modal
        dispatch((0, $2KqxL.customerCloseCustomerPaymentMethodCreateModal)());
        const resetAfterMs = 3000;
        setTimeout(()=>{
            // reset customer state
            dispatch((0, $2KqxL.customerResetState)());
        }, resetAfterMs);
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Payment method creation failed: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c325c1c1f3ce606e$export$8e61ca7747be6855 = (0, $kvj5V.createAsyncThunk)("customer/customerDeleteCustomerPaymentMethod", async ({ customerPaymentMethod: customerPaymentMethod }, { dispatch: dispatch })=>{
    const { id: customerPaymentMethodId } = customerPaymentMethod;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete payment method
        await api.customerApi.deleteCustomerPaymentMethod(customerPaymentMethodId || "");
        // reset customer state
        dispatch((0, $2KqxL.customerResetState)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: `Successfully deleted payment method!`
            }
        }));
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to delete payment method: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c325c1c1f3ce606e$export$61f68d108929c87 = (0, $kvj5V.createAsyncThunk)("customer/customerSetCustomerPaymentMethodDefault", async ({ customerPaymentMethod: customerPaymentMethod }, { dispatch: dispatch })=>{
    const { id: customerPaymentMethodId } = customerPaymentMethod;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // set payment method as default
        await api.customerApi.setCustomerPaymentMethodDefault({
            customerPaymentMethodId: customerPaymentMethodId || ""
        });
        // reset customer state
        dispatch((0, $2KqxL.customerResetState)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: `Successfully updated default payment method!`
            }
        }));
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to update default payment method: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("6UAL8", function(module, exports) {
// export {} from './components'

var $7oPCi = parcelRequire("7oPCi");

var $4cq7L = parcelRequire("4cq7L");
$parcel$exportWildcard(module.exports, $7oPCi);
$parcel$exportWildcard(module.exports, $4cq7L);

});
parcelRegister("7oPCi", function(module, exports) {

$parcel$export(module.exports, "likeSlice", function () { return $be601d0c656bf26d$export$13fa8af9cb8f6311; });
$parcel$export(module.exports, "likeResetState", function () { return $be601d0c656bf26d$export$6271733e0f9f33c5; });
$parcel$export(module.exports, "likeSetUserFollows", function () { return $be601d0c656bf26d$export$877182111b837392; });
$parcel$export(module.exports, "likeAddUserFollow", function () { return $be601d0c656bf26d$export$424f7d1030c3fdbe; });
$parcel$export(module.exports, "likeRemoveUserFollow", function () { return $be601d0c656bf26d$export$a87fb37e450feb31; });
$parcel$export(module.exports, "likeSetPostLikes", function () { return $be601d0c656bf26d$export$5fa4205fa6c9ecea; });
$parcel$export(module.exports, "likeAddPostLike", function () { return $be601d0c656bf26d$export$a09892d23cff9d4e; });
$parcel$export(module.exports, "likeRemovePostLike", function () { return $be601d0c656bf26d$export$493af460e6693ad8; });
$parcel$export(module.exports, "likeSetTrackLikes", function () { return $be601d0c656bf26d$export$38c392102127a134; });
$parcel$export(module.exports, "likeAddTrackLike", function () { return $be601d0c656bf26d$export$32742a415871bb6f; });
$parcel$export(module.exports, "likeRemoveTrackLike", function () { return $be601d0c656bf26d$export$5704115526859999; });
$parcel$export(module.exports, "likeSetCommentLikes", function () { return $be601d0c656bf26d$export$a91b348ca84c5784; });
$parcel$export(module.exports, "likeAddCommentLike", function () { return $be601d0c656bf26d$export$5ae5e0cbc7535348; });
$parcel$export(module.exports, "likeRemoveCommentLike", function () { return $be601d0c656bf26d$export$ecf26279cd48d6c9; });
$parcel$export(module.exports, "likeSelectUserFollows", function () { return $be601d0c656bf26d$export$547fac48fda98a21; });
$parcel$export(module.exports, "likeSelectPostLikes", function () { return $be601d0c656bf26d$export$3c54bf73a85e6628; });
$parcel$export(module.exports, "likeSelectTrackLikes", function () { return $be601d0c656bf26d$export$ac21df2c015e092e; });
$parcel$export(module.exports, "likeSelectCommentLikes", function () { return $be601d0c656bf26d$export$d447f3e45611dbfc; });
$parcel$export(module.exports, "likeSelectLikeGetFollowedUserIdsLoading", function () { return $be601d0c656bf26d$export$2eee4f66368f7600; });
$parcel$export(module.exports, "likeSelectLikeGetLikedPostIdsLoading", function () { return $be601d0c656bf26d$export$e81e1f6ecbfcd908; });
$parcel$export(module.exports, "likeSelectLikeGetLikedTrackIdsLoading", function () { return $be601d0c656bf26d$export$f79bd85604abc97a; });
$parcel$export(module.exports, "likeSelectLikeGetLikedCommentIdsLoading", function () { return $be601d0c656bf26d$export$42a0f2775253af0c; });
$parcel$export(module.exports, "likeReducer", function () { return $be601d0c656bf26d$export$fe1f313dc70c6a75; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $4cq7L = parcelRequire("4cq7L");
const $be601d0c656bf26d$var$initialState = {
    userFollows: {},
    trackLikes: {},
    postLikes: {},
    commentLikes: {},
    likeGetFollowedUserIdsLoading: false,
    likeGetLikedPostIdsLoading: false,
    likeGetLikedTrackIdsLoading: false,
    likeGetLikedCommentIdsLoading: false
};
const $be601d0c656bf26d$export$13fa8af9cb8f6311 = (0, $kvj5V.createSlice)({
    name: "like",
    initialState: $be601d0c656bf26d$var$initialState,
    reducers: {
        // reset state
        likeResetState: ()=>({
                userFollows: {},
                trackLikes: {},
                postLikes: {},
                commentLikes: {},
                likeGetFollowedUserIdsLoading: false,
                likeGetLikedPostIdsLoading: false,
                likeGetLikedTrackIdsLoading: false,
                likeGetLikedCommentIdsLoading: false
            }),
        // set user follows
        likeSetUserFollows: (state, action)=>{
            const { followedUserIds: followedUserIds } = action.payload;
            // define user follows map
            const userFollows = {};
            // iterate over each followed user id
            followedUserIds.forEach((id)=>{
                // add id to the map
                userFollows[id] = true;
            });
            // update state
            state.userFollows = userFollows;
        },
        // add user follow
        likeAddUserFollow: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userFollows[userId] = true;
        },
        // remove user follow
        likeRemoveUserFollow: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userFollows[userId] = false;
        },
        // set post likes
        likeSetPostLikes: (state, action)=>{
            const { likedPostIds: likedPostIds } = action.payload;
            // define post likes map
            const postLikes = {};
            // iterate over each liked post id
            likedPostIds.forEach((id)=>{
                // add id to the map
                postLikes[id] = true;
            });
            // update state
            state.postLikes = postLikes;
        },
        // add post like
        likeAddPostLike: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postLikes[postId] = true;
        },
        // remove post like
        likeRemovePostLike: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postLikes[postId] = false;
        },
        // set track likes
        likeSetTrackLikes: (state, action)=>{
            const { likedTrackIds: likedTrackIds } = action.payload;
            // define track likes map
            const trackLikes = {};
            // iterate over each liked track id
            likedTrackIds.forEach((id)=>{
                // add id to the map
                trackLikes[id] = true;
            });
            // update state
            state.trackLikes = trackLikes;
        },
        // add track like
        likeAddTrackLike: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackLikes[trackId] = true;
        },
        // remove track like
        likeRemoveTrackLike: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackLikes[trackId] = false;
        },
        // set comment likes
        likeSetCommentLikes: (state, action)=>{
            const { likedCommentIds: likedCommentIds } = action.payload;
            // define comment likes map
            const commentLikes = {};
            // iterate over each liked comment id
            likedCommentIds.forEach((id)=>{
                // add id to the map
                commentLikes[id] = true;
            });
            // update state
            state.commentLikes = commentLikes;
        },
        // add comment like
        likeAddCommentLike: (state, action)=>{
            const { commentId: commentId } = action.payload;
            // update state
            state.commentLikes[commentId] = true;
        },
        // remove liked comment
        likeRemoveCommentLike: (state, action)=>{
            const { commentId: commentId } = action.payload;
            // update state
            state.commentLikes[commentId] = false;
        }
    },
    extraReducers: (builder)=>{
        // get followed user ids
        builder.addCase((0, $4cq7L.likeGetFollowedUserIds).pending, (state)=>({
                ...state,
                likeGetFollowedUserIdsLoading: true
            })).addCase((0, $4cq7L.likeGetFollowedUserIds).fulfilled, (state)=>({
                ...state,
                likeGetFollowedUserIdsLoading: false
            }));
        // get liked post ids
        builder.addCase((0, $4cq7L.likeGetLikedPostIds).pending, (state)=>({
                ...state,
                likeGetLikedPostIdsLoading: true
            })).addCase((0, $4cq7L.likeGetLikedPostIds).fulfilled, (state)=>({
                ...state,
                likeGetLikedPostIdsLoading: false
            }));
        // get liked track ids
        builder.addCase((0, $4cq7L.likeGetLikedTrackIds).pending, (state)=>({
                ...state,
                likeGetLikedTrackIdsLoading: true
            })).addCase((0, $4cq7L.likeGetLikedTrackIds).fulfilled, (state)=>({
                ...state,
                likeGetLikedTrackIdsLoading: false
            }));
        // get liked comment ids
        builder.addCase((0, $4cq7L.likeGetLikedCommentIds).pending, (state)=>({
                ...state,
                likeGetLikedCommentIdsLoading: true
            })).addCase((0, $4cq7L.likeGetLikedCommentIds).fulfilled, (state)=>({
                ...state,
                likeGetLikedCommentIdsLoading: false
            }));
    }
});
const { likeResetState: $be601d0c656bf26d$export$6271733e0f9f33c5, likeSetUserFollows: $be601d0c656bf26d$export$877182111b837392, likeAddUserFollow: $be601d0c656bf26d$export$424f7d1030c3fdbe, likeRemoveUserFollow: $be601d0c656bf26d$export$a87fb37e450feb31, likeSetPostLikes: $be601d0c656bf26d$export$5fa4205fa6c9ecea, likeAddPostLike: $be601d0c656bf26d$export$a09892d23cff9d4e, likeRemovePostLike: $be601d0c656bf26d$export$493af460e6693ad8, likeSetTrackLikes: $be601d0c656bf26d$export$38c392102127a134, likeAddTrackLike: $be601d0c656bf26d$export$32742a415871bb6f, likeRemoveTrackLike: $be601d0c656bf26d$export$5704115526859999, likeSetCommentLikes: $be601d0c656bf26d$export$a91b348ca84c5784, likeAddCommentLike: $be601d0c656bf26d$export$5ae5e0cbc7535348, likeRemoveCommentLike: $be601d0c656bf26d$export$ecf26279cd48d6c9 } = $be601d0c656bf26d$export$13fa8af9cb8f6311.actions;
const $be601d0c656bf26d$export$547fac48fda98a21 = (state)=>state.like.userFollows;
const $be601d0c656bf26d$export$3c54bf73a85e6628 = (state)=>state.like.postLikes;
const $be601d0c656bf26d$export$ac21df2c015e092e = (state)=>state.like.trackLikes;
const $be601d0c656bf26d$export$d447f3e45611dbfc = (state)=>state.like.commentLikes;
const $be601d0c656bf26d$export$2eee4f66368f7600 = (state)=>state.like.likeGetFollowedUserIdsLoading;
const $be601d0c656bf26d$export$e81e1f6ecbfcd908 = (state)=>state.like.likeGetLikedPostIdsLoading;
const $be601d0c656bf26d$export$f79bd85604abc97a = (state)=>state.like.likeGetLikedTrackIdsLoading;
const $be601d0c656bf26d$export$42a0f2775253af0c = (state)=>state.like.likeGetLikedCommentIdsLoading;
const $be601d0c656bf26d$export$fe1f313dc70c6a75 = $be601d0c656bf26d$export$13fa8af9cb8f6311.reducer; // export default likeSlice.reducer

});

parcelRegister("4cq7L", function(module, exports) {

$parcel$export(module.exports, "likeGetFollowedUserIds", function () { return $981dcff1c018a9dd$export$289794adea63932b; });
$parcel$export(module.exports, "likeCreateUserFollow", function () { return $981dcff1c018a9dd$export$199321f08b9f1617; });
$parcel$export(module.exports, "likeDeleteUserFollow", function () { return $981dcff1c018a9dd$export$6ca782b6e3563c9e; });
$parcel$export(module.exports, "likeGetLikedPostIds", function () { return $981dcff1c018a9dd$export$c30c4c16f8f42888; });
$parcel$export(module.exports, "likeCreatePostLike", function () { return $981dcff1c018a9dd$export$65ab8fbbffe02866; });
$parcel$export(module.exports, "likeDeletePostLike", function () { return $981dcff1c018a9dd$export$d5e7d1f5ec64e1a8; });
$parcel$export(module.exports, "likeGetLikedTrackIds", function () { return $981dcff1c018a9dd$export$bc2a263fe8589666; });
$parcel$export(module.exports, "likeCreateTrackLike", function () { return $981dcff1c018a9dd$export$c6d6a0e482d9499f; });
$parcel$export(module.exports, "likeDeleteTrackLike", function () { return $981dcff1c018a9dd$export$9f5046deb7b0a112; });
$parcel$export(module.exports, "likeGetLikedCommentIds", function () { return $981dcff1c018a9dd$export$89f3d6e510de3e93; });
$parcel$export(module.exports, "likeCreateCommentLike", function () { return $981dcff1c018a9dd$export$f9856df8a32b83e4; });
$parcel$export(module.exports, "likeDeleteCommentLike", function () { return $981dcff1c018a9dd$export$1ccf5b66fb2f62cd; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("cJvLm");
var $7oPCi = parcelRequire("7oPCi");
var $a0vy2 = parcelRequire("a0vy2");
var $2Vh5B = parcelRequire("2Vh5B");
var $iw5tW = parcelRequire("iw5tW");
const $981dcff1c018a9dd$export$289794adea63932b = (0, $kvj5V.createAsyncThunk)("like/likeGetFollowedUserIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve followed user ids
        const { followedUserIds: followedUserIds } = await api.likeApi.getFollowedUserIds();
        // set user follows
        dispatch((0, $7oPCi.likeSetUserFollows)({
            followedUserIds: followedUserIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$199321f08b9f1617 = (0, $kvj5V.createAsyncThunk)("like/likeCreateUserFollow", async ({ user: user }, { dispatch: dispatch })=>{
    const { id: userId } = user;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create user follow
        await api.likeApi.createUserFollow({
            userId: userId || ""
        });
        // add user follow
        dispatch((0, $7oPCi.likeAddUserFollow)({
            userId: userId || ""
        }));
        // append user to followed artists
        dispatch((0, $iw5tW.userAppendFollowedArtist)({
            artist: user
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$6ca782b6e3563c9e = (0, $kvj5V.createAsyncThunk)("like/likeDeleteUserFollow", async ({ user: user }, { dispatch: dispatch })=>{
    const { id: userId } = user;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete user follow
        await api.likeApi.deleteUserFollow(userId || "");
        // remove user follow
        dispatch((0, $7oPCi.likeRemoveUserFollow)({
            userId: userId || ""
        }));
        // filter user from followed artists
        dispatch((0, $iw5tW.userFilterFollowedArtist)({
            artist: user
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$c30c4c16f8f42888 = (0, $kvj5V.createAsyncThunk)("like/likeGetLikedPostIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve liked post ids
        const { likedPostIds: likedPostIds } = await api.likeApi.getLikedPostIds();
        // set post likes
        dispatch((0, $7oPCi.likeSetPostLikes)({
            likedPostIds: likedPostIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$65ab8fbbffe02866 = (0, $kvj5V.createAsyncThunk)("like/likeCreatePostLike", async ({ post: post }, { dispatch: dispatch })=>{
    const { id: postId } = post;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create post like
        await api.likeApi.createPostLike({
            postId: postId || ""
        });
        // add post like
        dispatch((0, $7oPCi.likeAddPostLike)({
            postId: postId || ""
        }));
        // append post to liked posts
        dispatch((0, $a0vy2.postAppendLikedPost)({
            post: post
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$d5e7d1f5ec64e1a8 = (0, $kvj5V.createAsyncThunk)("like/likeDeletePostLike", async ({ post: post }, { dispatch: dispatch })=>{
    const { id: postId } = post;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete post like
        await api.likeApi.deletePostLike(postId || "");
        // remove post like
        dispatch((0, $7oPCi.likeRemovePostLike)({
            postId: postId || ""
        }));
        // filter post from liked posts
        dispatch((0, $a0vy2.postFilterLikedPost)({
            post: post
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$bc2a263fe8589666 = (0, $kvj5V.createAsyncThunk)("like/likeGetLikedTrackIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve liked track ids
        const { likedTrackIds: likedTrackIds } = await api.likeApi.getLikedTrackIds();
        // set track likes
        dispatch((0, $7oPCi.likeSetTrackLikes)({
            likedTrackIds: likedTrackIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$c6d6a0e482d9499f = (0, $kvj5V.createAsyncThunk)("like/likeCreateTrackLike", async ({ track: track }, { dispatch: dispatch })=>{
    const { id: trackId } = track;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create track like
        await api.likeApi.createTrackLike({
            trackId: trackId || ""
        });
        // add track like
        dispatch((0, $7oPCi.likeAddTrackLike)({
            trackId: trackId || ""
        }));
        // append track to liked tracks
        dispatch((0, $2Vh5B.trackAppendLikedTrack)({
            track: track
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$9f5046deb7b0a112 = (0, $kvj5V.createAsyncThunk)("like/likeDeleteTrackLike", async ({ track: track }, { dispatch: dispatch })=>{
    const { id: trackId } = track;
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete track like
        await api.likeApi.deleteTrackLike(trackId || "");
        // remove track like
        dispatch((0, $7oPCi.likeRemoveTrackLike)({
            trackId: trackId || ""
        }));
        // filter track from liked tracks
        dispatch((0, $2Vh5B.trackFilterLikedTrack)({
            track: track
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$89f3d6e510de3e93 = (0, $kvj5V.createAsyncThunk)("like/likeGetLikedCommentIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve liked comment ids
        const { likedCommentIds: likedCommentIds } = await api.likeApi.getLikedCommentIds();
        // set comment likes
        dispatch((0, $7oPCi.likeSetCommentLikes)({
            likedCommentIds: likedCommentIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$f9856df8a32b83e4 = (0, $kvj5V.createAsyncThunk)("like/likeCreateCommentLike", async ({ comment: comment }, { dispatch: dispatch })=>{
    const { id: commentId, postId: postId } = comment;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create comment like
        await api.likeApi.createCommentLike({
            commentId: commentId || "",
            postId: postId || ""
        });
        // add comment like
        dispatch((0, $7oPCi.likeAddCommentLike)({
            commentId: commentId || ""
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $981dcff1c018a9dd$export$1ccf5b66fb2f62cd = (0, $kvj5V.createAsyncThunk)("like/likeDeleteCommentLike", async ({ comment: comment }, { dispatch: dispatch })=>{
    const { id: commentId } = comment;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete comment like
        await api.likeApi.deleteCommentLike(commentId || "");
        // remove comment like
        dispatch((0, $7oPCi.likeRemoveCommentLike)({
            commentId: commentId || ""
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("fvgno", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return (parcelRequire("hnklx")).NavigationApp; });
$parcel$export(module.exports, "NavigationAppMobile", function () { return (parcelRequire("3uBAm")).NavigationAppMobile; });
$parcel$export(module.exports, "NavigationLibrary", function () { return (parcelRequire("3kLT7")).NavigationLibrary; });
parcelRequire("9YWed");
var $hnklx = parcelRequire("hnklx");
var $3uBAm = parcelRequire("3uBAm");
var $3kLT7 = parcelRequire("3kLT7");

var $6Gpkq = parcelRequire("6Gpkq");
$parcel$exportWildcard(module.exports, $6Gpkq);

});
parcelRegister("9YWed", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return (parcelRequire("hnklx")).NavigationApp; });
$parcel$export(module.exports, "NavigationAppMobile", function () { return (parcelRequire("3uBAm")).NavigationAppMobile; });
$parcel$export(module.exports, "NavigationLibrary", function () { return (parcelRequire("3kLT7")).NavigationLibrary; });
parcelRequire("1ot18");
var $hnklx = parcelRequire("hnklx");
var $3uBAm = parcelRequire("3uBAm");

var $3kLT7 = parcelRequire("3kLT7");

});
parcelRegister("1ot18", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return (parcelRequire("hnklx")).NavigationApp; });
$parcel$export(module.exports, "NavigationAppMobile", function () { return (parcelRequire("3uBAm")).NavigationAppMobile; });

var $hnklx = parcelRequire("hnklx");

var $3uBAm = parcelRequire("3uBAm");

});
parcelRegister("hnklx", function(module, exports) {

$parcel$export(module.exports, "NavigationApp", function () { return $b67317cb3b48a395$export$42d4318a67277c83; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
parcelRequire("j8bpm");
var $9uBbu = parcelRequire("9uBbu");
parcelRequire("lDQHC");
var $bsX4s = parcelRequire("bsX4s");
parcelRequire("28NJg");
var $4p9Xe = parcelRequire("4p9Xe");
var $01tQ5 = parcelRequire("01tQ5");

var $gKTL7 = parcelRequire("gKTL7");
const $b67317cb3b48a395$export$42d4318a67277c83 = ()=>{
    const theme = (0, $iwq56.u)();
    const { pathname: pathname } = (0, $99w1R.useLocation)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const navLinks = (0, $bsX4s.getNavLinks)(profile);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $gKTL7.styles)(theme).navigation.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gKTL7.styles)(theme).navigation.logo,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9uBbu.logos).RyddmLogo, {})
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("nav", {
                css: (0, $gKTL7.styles)(theme).navigation.links,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("ul", {
                    children: navLinks.map(({ name: name, path: path, icon: icon })=>/*#__PURE__*/ (0, $9awXB.jsx)("li", {
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $01tQ5.NavLink), {
                                to: path,
                                name: name,
                                icon: icon,
                                onClick: ()=>dispatch((0, $jAL4t.playerAudioSetClosed)()),
                                active: pathname === path
                            })
                        }, `${name}-${path}`))
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gKTL7.styles)(theme).navigation.footer,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4p9Xe.NavFooter), {})
            })
        ]
    });
};
$b67317cb3b48a395$export$42d4318a67277c83.propTypes = {};

});
parcelRegister("lDQHC", function(module, exports) {

$parcel$export(module.exports, "getNavLinks", function () { return (parcelRequire("bsX4s")).getNavLinks; });

var $bsX4s = parcelRequire("bsX4s");

});
parcelRegister("bsX4s", function(module, exports) {

$parcel$export(module.exports, "getNavLinks", function () { return $4b7a20439a022f7d$export$f9d18ce6e26966fa; });
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");

var $4rOX2 = parcelRequire("4rOX2");
const $4b7a20439a022f7d$var$publicNavLinks = [
    {
        name: "Home",
        path: (0, $b7fnN.Path).Home,
        icon: (0, $4rOX2.icons).HomeIcon
    }
];
const $4b7a20439a022f7d$var$fanNavLinks = [
    {
        name: "Home",
        path: (0, $b7fnN.Path).Feed,
        icon: (0, $4rOX2.icons).HomeIcon
    },
    {
        name: "Library",
        path: (0, $b7fnN.Path).Library,
        icon: (0, $4rOX2.icons).LibraryIcon
    },
    {
        name: "Charts",
        path: (0, $b7fnN.Path).Charts,
        icon: (0, $4rOX2.icons).ChartsIcon
    },
    {
        name: "Profile",
        path: (0, $b7fnN.Path).Profile,
        icon: (0, $4rOX2.icons).ProfileIcon
    }
];
const $4b7a20439a022f7d$var$artistNavLinks = [
    {
        name: "Home",
        path: (0, $b7fnN.Path).Feed,
        icon: (0, $4rOX2.icons).HomeIcon
    },
    {
        name: "Library",
        path: (0, $b7fnN.Path).Library,
        icon: (0, $4rOX2.icons).LibraryIcon
    },
    {
        name: "Charts",
        path: (0, $b7fnN.Path).Charts,
        icon: (0, $4rOX2.icons).ChartsIcon
    },
    {
        name: "Studio",
        path: (0, $b7fnN.Path).Studio,
        icon: (0, $4rOX2.icons).StudioIcon
    },
    {
        name: "Profile",
        path: (0, $b7fnN.Path).Profile,
        icon: (0, $4rOX2.icons).ProfileIcon
    }
];
const $4b7a20439a022f7d$var$adminNavLinks = [
    {
        name: "Home",
        path: (0, $b7fnN.Path).Feed,
        icon: (0, $4rOX2.icons).HomeIcon
    },
    {
        name: "Library",
        path: (0, $b7fnN.Path).Library,
        icon: (0, $4rOX2.icons).LibraryIcon
    },
    {
        name: "Charts",
        path: (0, $b7fnN.Path).Charts,
        icon: (0, $4rOX2.icons).ChartsIcon
    },
    {
        name: "Reports",
        path: (0, $b7fnN.Path).Reports,
        icon: (0, $4rOX2.icons).ReportsIcon
    },
    {
        name: "Profile",
        path: (0, $b7fnN.Path).Profile,
        icon: (0, $4rOX2.icons).ProfileIcon
    }
];
const $4b7a20439a022f7d$export$f9d18ce6e26966fa = (user)=>{
    // if fan
    if (user && user.role === (0, $2gpGl.EntityUserRole).Fan && user.onboardingStage === (0, $2gpGl.EntityOnboardingStage).Finished) return $4b7a20439a022f7d$var$fanNavLinks;
    // if artist
    if (user && user.role === (0, $2gpGl.EntityUserRole).Artist && user.onboardingStage === (0, $2gpGl.EntityOnboardingStage).Finished) return $4b7a20439a022f7d$var$artistNavLinks;
    // if admin
    if (user && user.role === (0, $2gpGl.EntityUserRole).Admin && user.onboardingStage === (0, $2gpGl.EntityOnboardingStage).Finished) return $4b7a20439a022f7d$var$adminNavLinks;
    return $4b7a20439a022f7d$var$publicNavLinks;
};

});
parcelRegister("4rOX2", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $59d8671924cc0922$export$df03f54e09e486fa; });

var $19x24 = parcelRequire("19x24");

var $48Qt0 = parcelRequire("48Qt0");

var $7jqjY = parcelRequire("7jqjY");

var $l4Bea = parcelRequire("l4Bea");

var $b3oiI = parcelRequire("b3oiI");

var $irkOr = parcelRequire("irkOr");
const $59d8671924cc0922$export$df03f54e09e486fa = {
    HomeIcon: $19x24.default,
    LibraryIcon: $48Qt0.default,
    ChartsIcon: $7jqjY.default,
    ProfileIcon: $l4Bea.default,
    StudioIcon: $b3oiI.default,
    ReportsIcon: $irkOr.default
};

});
parcelRegister("19x24", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11ce136a9976e552$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $11ce136a9976e552$var$SvgHome = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M8 16.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H8Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11 .25c-.708 0-1.351.203-2.05.542-.674.328-1.454.812-2.427 1.416L4.456 3.491c-.92.572-1.659 1.03-2.227 1.465-.589.45-1.041.91-1.368 1.507C.535 7.058.39 7.692.318 8.44.25 9.167.25 10.054.25 11.167v1.613c0 1.904 0 3.407.153 4.582.156 1.205.486 2.178 1.23 2.947.747.773 1.697 1.119 2.875 1.282 1.14.159 2.598.159 4.434.159h4.116c1.836 0 3.294 0 4.434-.159 1.177-.163 2.128-.509 2.876-1.282.743-.769 1.073-1.742 1.23-2.947.152-1.175.152-2.678.152-4.582v-1.613c0-1.113 0-2-.068-2.726-.07-.75-.217-1.383-.543-1.978-.327-.597-.78-1.056-1.368-1.507-.568-.436-1.306-.893-2.227-1.465l-2.067-1.283c-.973-.604-1.753-1.088-2.428-1.416C12.352.452 11.71.25 11 .25ZM7.28 3.504c1.015-.63 1.73-1.072 2.327-1.363.581-.283.993-.391 1.393-.391s.812.108 1.393.391c.598.29 1.312.733 2.327 1.363l2 1.241c.961.597 1.636 1.016 2.14 1.402.489.375.77.684.963 1.036.193.353.306.766.365 1.398.061.648.062 1.465.062 2.623v1.521c0 1.97-.002 3.376-.14 4.443-.136 1.048-.393 1.656-.82 2.099-.425.439-1.003.7-2.004.839-1.026.142-2.379.144-4.286.144H9c-1.908 0-3.26-.002-4.286-.144-1.001-.14-1.579-.4-2.003-.84-.428-.442-.685-1.05-.82-2.098-.14-1.067-.141-2.472-.141-4.443v-1.521c0-1.158 0-1.975.062-2.623.059-.632.172-1.045.365-1.398.193-.352.474-.661.964-1.036.503-.386 1.178-.805 2.139-1.402l2-1.24Z",
                fill: "#FFF"
            })
        ]
    });
var $11ce136a9976e552$export$2e2bcd8739ae039 = $11ce136a9976e552$var$SvgHome;

});

parcelRegister("48Qt0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8d852c959fd837c$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $c8d852c959fd837c$var$SvgLibrary = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.611.584a2.75 2.75 0 0 1 3.139 2.722v1.377a3.75 3.75 0 0 1 2 3.317v10A3.75 3.75 0 0 1 14 21.75H4A3.75 3.75 0 0 1 .25 18V3.929c0-.906.666-1.675 1.564-1.803L12.61.584ZM1.75 5.75V18A2.25 2.25 0 0 0 4 20.25h10A2.25 2.25 0 0 0 16.25 18V8A2.25 2.25 0 0 0 14 5.75H1.75Zm.321-1.5H14.25v-.944a1.25 1.25 0 0 0-1.427-1.237L2.026 3.61a.321.321 0 0 0 .045.639ZM4.25 11a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Zm0 3.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z",
            fill: "#FFF"
        })
    });
var $c8d852c959fd837c$export$2e2bcd8739ae039 = $c8d852c959fd837c$var$SvgLibrary;

});

parcelRegister("7jqjY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $327f4f935e0fc97a$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $327f4f935e0fc97a$var$SvgCharts = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M10.25 1A.75.75 0 0 1 11 .25C16.937.25 21.75 5.063 21.75 11S16.937 21.75 11 21.75.25 16.937.25 11a10.72 10.72 0 0 1 3.225-7.677.75.75 0 1 1 1.05 1.071A9.22 9.22 0 0 0 1.75 11 9.25 9.25 0 1 0 11 1.75a.75.75 0 0 1-.75-.75Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M10.25 4a.75.75 0 0 1 .75-.75A7.75 7.75 0 1 1 3.25 11a.75.75 0 0 1 1.5 0A6.25 6.25 0 1 0 11 4.75a.75.75 0 0 1-.75-.75Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M11 6.25a.75.75 0 0 0 0 1.5 3.25 3.25 0 0 1 0 6.5.75.75 0 0 0 0 1.5 4.75 4.75 0 1 0 0-9.5Z",
                fill: "#FFF"
            })
        ]
    });
var $327f4f935e0fc97a$export$2e2bcd8739ae039 = $327f4f935e0fc97a$var$SvgCharts;

});

parcelRegister("l4Bea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b00227f1898c2940$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $b00227f1898c2940$var$SvgProfile = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 .25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM5.75 5a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0ZM9 11.25c-2.314 0-4.445.526-6.025 1.414C1.42 13.54.25 14.866.25 16.5v.102c-.001 1.162-.003 2.62 1.276 3.662.63.512 1.51.877 2.7 1.117 1.193.242 2.748.369 4.774.369s3.58-.127 4.774-.369c1.19-.24 2.07-.605 2.7-1.117 1.279-1.042 1.277-2.5 1.276-3.662V16.5c0-1.634-1.17-2.96-2.726-3.836-1.579-.888-3.71-1.414-6.024-1.414ZM1.75 16.5c0-.851.621-1.775 1.96-2.528 1.317-.74 3.185-1.222 5.29-1.222s3.973.482 5.289 1.222c1.34.753 1.96 1.677 1.96 2.528 0 1.308-.04 2.044-.723 2.6-.37.302-.99.597-2.05.811-1.057.214-2.502.339-4.476.339-1.974 0-3.42-.125-4.476-.339-1.06-.214-1.68-.509-2.05-.81-.684-.557-.724-1.293-.724-2.601Z",
            fill: "#FFF"
        })
    });
var $b00227f1898c2940$export$2e2bcd8739ae039 = $b00227f1898c2940$var$SvgProfile;

});

parcelRegister("b3oiI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae1740c943922b4c$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $ae1740c943922b4c$var$SvgStudio = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.943.25h.114c2.309 0 4.118 0 5.53.19 1.444.194 2.584.6 3.479 1.494.895.895 1.3 2.035 1.494 3.48.19 1.411.19 3.22.19 5.529v.114c0 2.309 0 4.118-.19 5.53-.194 1.444-.6 2.584-1.494 3.479-.895.895-2.035 1.3-3.48 1.494-1.411.19-3.22.19-5.529.19h-.114c-2.309 0-4.118 0-5.53-.19-1.444-.194-2.584-.6-3.479-1.494-.895-.895-1.3-2.035-1.494-3.48-.19-1.411-.19-3.22-.19-5.529v-.114c0-2.309 0-4.118.19-5.53.194-1.444.6-2.584 1.494-3.479C2.83 1.04 3.97.634 5.414.44 6.825.25 8.634.25 10.943.25Zm-5.33 1.676c-1.278.172-2.049.5-2.618 1.069-.57.57-.897 1.34-1.069 2.619-.174 1.3-.176 3.008-.176 5.386s.002 4.086.176 5.386c.172 1.279.5 2.05 1.069 2.62.57.569 1.34.896 2.619 1.068 1.3.174 3.008.176 5.386.176s4.086-.002 5.386-.176c1.279-.172 2.05-.5 2.62-1.069.569-.57.896-1.34 1.068-2.619.174-1.3.176-3.008.176-5.386s-.002-4.086-.176-5.386c-.172-1.279-.5-2.05-1.069-2.62-.57-.569-1.34-.896-2.619-1.068-1.3-.174-3.008-.176-5.386-.176s-4.086.002-5.386.176ZM11 5.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Zm-5 2a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 6 7.25Zm10 1a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Z",
            fill: "#FFF"
        })
    });
var $ae1740c943922b4c$export$2e2bcd8739ae039 = $ae1740c943922b4c$var$SvgStudio;

});

parcelRegister("irkOr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6e7571a806e6f78$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $f6e7571a806e6f78$var$SvgReports = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        shapeRendering: "geometricPrecision",
        textRendering: "geometricPrecision",
        imageRendering: "optimizeQuality",
        fillRule: "evenodd",
        clipRule: "evenodd",
        viewBox: "0 0 511.999 463.377",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M289.639 9.137c12.411 7.25 23.763 18.883 33.037 34.913l.97 1.813 1.118 1.941 174.174 302.48c33.712 56.407-1.203 113.774-66.174 112.973v.12H73.485c-.895 0-1.78-.04-2.657-.112-59.104-.799-86.277-54.995-61.909-106.852.842-1.805 1.816-3.475 2.816-5.201L189.482 43.959l-.053-.032c9.22-15.786 20.717-27.457 33.411-34.805C243.788-3 268.711-3.086 289.639 9.137zM255.7 339.203c13.04 0 23.612 10.571 23.612 23.612 0 13.041-10.572 23.613-23.612 23.613-13.041 0-23.613-10.572-23.613-23.613s10.572-23.612 23.613-23.612zm17.639-35.379c-.794 19.906-34.506 19.931-35.278-.006-3.41-34.108-12.129-111.541-11.853-143.591.284-9.874 8.469-15.724 18.939-17.955 3.231-.686 6.781-1.024 10.357-1.019 3.595.008 7.153.362 10.387 1.051 10.818 2.303 19.309 8.392 19.309 18.446l-.043 1.005-11.818 142.069zM37.596 369.821 216.864 59.942c21.738-37.211 56.225-38.289 78.376 0l176.298 306.166c17.177 28.285 10.04 66.236-38.774 65.488H73.485c-33.017.756-52.841-25.695-35.889-61.775z",
            fill: "#FFF"
        })
    });
var $f6e7571a806e6f78$export$2e2bcd8739ae039 = $f6e7571a806e6f78$var$SvgReports;

});




parcelRegister("28NJg", function(module, exports) {

$parcel$export(module.exports, "NavFooter", function () { return (parcelRequire("4p9Xe")).NavFooter; });
$parcel$export(module.exports, "NavLink", function () { return (parcelRequire("01tQ5")).NavLink; });

var $4p9Xe = parcelRequire("4p9Xe");

var $01tQ5 = parcelRequire("01tQ5");

});
parcelRegister("4p9Xe", function(module, exports) {

$parcel$export(module.exports, "NavFooter", function () { return $6c2c1575851aa42f$export$43e7f44f055ed22f; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $dkzpd = parcelRequire("dkzpd");
parcelRequire("6C8CX");
var $7KpEH = parcelRequire("7KpEH");

var $kB8Rm = parcelRequire("kB8Rm");
const $6c2c1575851aa42f$export$43e7f44f055ed22f = ()=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("footer", {
        css: (0, $kB8Rm.styles)(theme).footer.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $kB8Rm.styles)(theme).footer.terms,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $7KpEH.Link), {
                        name: "Terms of use",
                        href: (0, $dkzpd.ExternalLinks).TermsOfUse
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $kB8Rm.styles)(theme).footer.divider,
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $7KpEH.Link), {
                        name: "Privacy Policy",
                        href: (0, $dkzpd.ExternalLinks).PrivacyPolicy
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $kB8Rm.styles)(theme).footer.contacts,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $7KpEH.Link), {
                        name: "FAQs",
                        href: (0, $dkzpd.ExternalLinks).FAQ
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $kB8Rm.styles)(theme).footer.divider,
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $7KpEH.Link), {
                        name: "Support",
                        href: (0, $dkzpd.ExternalLinks).Support
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $kB8Rm.styles)(theme).footer.divider,
                        children: "|"
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $7KpEH.Link), {
                        name: "Contact us",
                        href: (0, $dkzpd.ExternalLinks).Contacts
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $kB8Rm.styles)(theme).footer.copyright,
                children: [
                    "\xa9 2021-",
                    new Date().getFullYear(),
                    " Ryddm Inc. All Rights Reserved"
                ]
            })
        ]
    });
};
$6c2c1575851aa42f$export$43e7f44f055ed22f.propTypes = {};

});
parcelRegister("6C8CX", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return (parcelRequire("7KpEH")).Link; });

var $7KpEH = parcelRequire("7KpEH");

});
parcelRegister("7KpEH", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $5cdcd10695fdadef$export$a6c7ac8248d6e38a; });

var $9awXB = parcelRequire("9awXB");

var $eCfBx = parcelRequire("eCfBx");

var $iwq56 = parcelRequire("iwq56");

var $fJEK2 = parcelRequire("fJEK2");
const $5cdcd10695fdadef$export$a6c7ac8248d6e38a = ({ name: name, href: href })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("a", {
        css: (0, $fJEK2.styles)(theme).link,
        href: href,
        rel: "noopener noreferrer",
        target: "_blank",
        children: name
    });
};
$5cdcd10695fdadef$export$a6c7ac8248d6e38a.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string.isRequired
};

});
parcelRegister("fJEK2", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $921e5d2fcad8df23$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $921e5d2fcad8df23$export$9dd6ff9ea0189349 = (theme)=>({
        link: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.dark, ";transition:color 0.2s;text-decoration:none;cursor:pointer;&:link,&:visited{}&:hover,&:active{color:", theme.colors.secondary.darkHover, ";}", "")
    });

});



parcelRegister("kB8Rm", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $60265516b2a9813e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $60265516b2a9813e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $60265516b2a9813e$var$_ref = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $60265516b2a9813e$var$_ref2 = {
    name: "bpd7z7",
    styles: "margin-bottom:2px"
};
const $60265516b2a9813e$export$9dd6ff9ea0189349 = (theme)=>({
        footer: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            terms: $60265516b2a9813e$var$_ref2,
            contacts: $60265516b2a9813e$var$_ref,
            copyright: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.light, ";", ""),
            divider: /*#__PURE__*/ (0, $7hler.css)("margin:0px 4px;color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("01tQ5", function(module, exports) {

$parcel$export(module.exports, "NavLink", function () { return $aa9a1016f451ce91$export$b0d92dbee9b5b60d; });

var $9awXB = parcelRequire("9awXB");

var $eCfBx = parcelRequire("eCfBx");

var $iwq56 = parcelRequire("iwq56");

var $10WBQ = parcelRequire("10WBQ");

var $lV5j3 = parcelRequire("lV5j3");
const $aa9a1016f451ce91$export$b0d92dbee9b5b60d = ({ to: to, name: name, active: active, onClick: onClick, icon: Icon })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $10WBQ.Link), {
        css: [
            (0, $lV5j3.styles)(theme).link.main,
            active && (0, $lV5j3.styles)(theme).link.active,
            "",
            ""
        ],
        to: to,
        onClick: (e)=>onClick(e),
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $lV5j3.styles)(theme).link.body,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lV5j3.styles)(theme).link.icon,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lV5j3.styles)(theme).link.text,
                    children: name
                })
            ]
        })
    });
};
$aa9a1016f451ce91$export$b0d92dbee9b5b60d.propTypes = {
    to: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).string.isRequired,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($eCfBx))).bool.isRequired
};

});
parcelRegister("lV5j3", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $eb15ccdd7b4dd6d3$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $eb15ccdd7b4dd6d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $eb15ccdd7b4dd6d3$var$_ref = {
    name: "s079uh",
    styles: "margin-top:2px"
};
var $eb15ccdd7b4dd6d3$var$_ref2 = {
    name: "18zs2kf",
    styles: "display:flex;width:22px;align-items:center;justify-content:center;margin-right:12px;&>svg{width:22px;height:22px;}&>svg>path{transition:fill 0.2s;}"
};
var $eb15ccdd7b4dd6d3$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
const $eb15ccdd7b4dd6d3$export$9dd6ff9ea0189349 = (theme)=>({
        link: {
            main: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.light, ";font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;cursor:pointer;text-decoration:none;transition:color 0.2s;display:inline-block;&:link,&:visited{}&:hover,&:active{color:", theme.colors.accent.normal, ";&>div>div>svg>path{fill:", theme.colors.accent.normal, ";}}", ""),
            active: /*#__PURE__*/ (0, $7hler.css)("&:link,&:visited{color:", theme.colors.accent.normal, ";}&>div>div>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            body: $eb15ccdd7b4dd6d3$var$_ref3,
            icon: $eb15ccdd7b4dd6d3$var$_ref2,
            text: $eb15ccdd7b4dd6d3$var$_ref
        }
    });

});



parcelRegister("gKTL7", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $cfa00d40279d5c81$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $cfa00d40279d5c81$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $cfa00d40279d5c81$var$_ref = {
    name: "1sfqy6m",
    styles: "flex:1;margin-bottom:auto;padding:20px 20px;&>ul{list-style-type:none;&>li:not(:last-of-type){margin-bottom:6px;}}"
};
var $cfa00d40279d5c81$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
const $cfa00d40279d5c81$export$9dd6ff9ea0189349 = (theme)=>({
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;flex:1;width:", (0, $gln0L.constants).app.navigation.desktop.width, ";height:", (0, $gln0L.constants).app.navigation.desktop.height, ";background-color:", theme.colors.primary.darker, ";", (0, $gln0L.mq).tablet($cfa00d40279d5c81$var$_ref2), ";", ""),
            logo: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;height:", (0, $gln0L.constants).app.header.desktop.height, ";padding:20px 20px;&>svg{width:140px;height:24px;}", ""),
            links: $cfa00d40279d5c81$var$_ref,
            footer: /*#__PURE__*/ (0, $7hler.css)("padding:20px 20px 40px 20px;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("3uBAm", function(module, exports) {

$parcel$export(module.exports, "NavigationAppMobile", function () { return $e76f7c57a9f25d04$export$bd6a2b6da3ead20e; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $gHHUR = parcelRequire("gHHUR");
var $6Gpkq = parcelRequire("6Gpkq");
var $jAL4t = parcelRequire("jAL4t");
parcelRequire("1TdPt");
var $l7e6s = parcelRequire("l7e6s");
var $1NE1d = parcelRequire("1NE1d");
parcelRequire("lDQHC");
var $bsX4s = parcelRequire("bsX4s");
parcelRequire("28NJg");
var $4p9Xe = parcelRequire("4p9Xe");
var $01tQ5 = parcelRequire("01tQ5");

var $iXXgk = parcelRequire("iXXgk");
const $e76f7c57a9f25d04$export$bd6a2b6da3ead20e = ()=>{
    const theme = (0, $iwq56.u)();
    const { pathname: pathname } = (0, $99w1R.useLocation)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const isNavigationOpen = (0, $gNvvs.useAppSelector)((0, $6Gpkq.navigationSelectAppNavigationOpen));
    const navLinks = (0, $bsX4s.getNavLinks)(profile);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: [
            (0, $iXXgk.styles)(theme).navigation.main.shared,
            isNavigationOpen ? (0, $iXXgk.styles)(theme).navigation.main.open : (0, $iXXgk.styles)(theme).navigation.main.closed,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                onCloseClick: ()=>dispatch((0, $6Gpkq.navigationAppNavigationClose)())
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("nav", {
                css: (0, $iXXgk.styles)(theme).navigation.links,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("ul", {
                    children: navLinks.map(({ name: name, path: path, icon: icon })=>/*#__PURE__*/ (0, $9awXB.jsx)("li", {
                            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                css: (0, $iXXgk.styles)(theme).navigation.menu,
                                onClick: ()=>dispatch((0, $6Gpkq.navigationAppNavigationClose)()),
                                type: "button",
                                "aria-label": `navigate to ${name}`,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $01tQ5.NavLink), {
                                    to: path,
                                    name: name,
                                    icon: icon,
                                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetClosed)()),
                                    active: pathname === path
                                })
                            })
                        }, `${name}-${path}`))
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $iXXgk.styles)(theme).navigation.auth,
                children: profile ? // if authenticated
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                    "aria-label": "log out",
                    appearance: "secondary",
                    onClick: ()=>{
                        dispatch((0, $gHHUR.authSignout)());
                        dispatch((0, $6Gpkq.navigationAppNavigationClose)());
                    },
                    children: "Log out"
                }) : // if unauthenticated
                /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                            "aria-label": "log in",
                            appearance: "secondary",
                            onClick: ()=>{
                                dispatch((0, $9HBOX.authOpenLoginModal)());
                                dispatch((0, $6Gpkq.navigationAppNavigationClose)());
                            },
                            children: "Log in"
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                            "aria-label": "sign up",
                            appearance: "primary",
                            onClick: ()=>{
                                dispatch((0, $9HBOX.authOpenSignupModal)());
                                dispatch((0, $6Gpkq.navigationAppNavigationClose)());
                            },
                            children: "Sign up"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $iXXgk.styles)(theme).navigation.footer,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4p9Xe.NavFooter), {})
            })
        ]
    });
};
$e76f7c57a9f25d04$export$bd6a2b6da3ead20e.propTypes = {};

});
parcelRegister("iXXgk", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $255e9ae8c9ebda50$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $255e9ae8c9ebda50$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $255e9ae8c9ebda50$var$_ref = {
    name: "1fuw0zz",
    styles: "display:flex;justify-content:center;padding:0px 10px;&>footer{text-align:center;}"
};
var $255e9ae8c9ebda50$var$_ref2 = {
    name: "1jex98y",
    styles: "display:flex;flex-direction:column;align-items:center;padding:0px 10px;margin-bottom:40px;&>button{max-width:300px;}&>button:nth-of-type(1){margin-bottom:20px;}"
};
var $255e9ae8c9ebda50$var$_ref3 = {
    name: "kx0plp",
    styles: "left:100vw;top:0;opacity:0"
};
var $255e9ae8c9ebda50$var$_ref4 = {
    name: "196alpc",
    styles: "left:0;top:0;opacity:1"
};
var $255e9ae8c9ebda50$var$_ref5 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $255e9ae8c9ebda50$var$_ref6 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $255e9ae8c9ebda50$export$9dd6ff9ea0189349 = (theme)=>({
        navigation: {
            main: {
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";z-index:", (0, $gln0L.z).app.navigation.mobile, ";display:none;position:fixed;padding-top:0px;width:100%;height:100%;background-color:", theme.colors.primary.darker, ";overflow:hidden;overflow-y:scroll;transition:left 0.2s,opacity 0.4s;", (0, $gln0L.mq).tablet($255e9ae8c9ebda50$var$_ref6), " ", (0, $gln0L.mq).mobile($255e9ae8c9ebda50$var$_ref5), ";", ""),
                open: $255e9ae8c9ebda50$var$_ref4,
                closed: $255e9ae8c9ebda50$var$_ref3
            },
            menu: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;cursor:pointer;&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.light, ";}&:hover{&>svg>path{transition:fill 0.2s;fill:", theme.colors.accent.normal, ";}}", ""),
            links: /*#__PURE__*/ (0, $7hler.css)("flex:1;display:flex;justify-content:center;background-color:", theme.colors.primary.darker, ";margin-bottom:40px;&>ul{list-style-type:none;&>li:not(:last-of-type){margin-bottom:24px;}}", ""),
            auth: $255e9ae8c9ebda50$var$_ref2,
            footer: $255e9ae8c9ebda50$var$_ref
        }
    });

});



parcelRegister("3kLT7", function(module, exports) {

$parcel$export(module.exports, "NavigationLibrary", function () { return $649f0f18b25a1cc0$export$7656d61f506178a4; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $6Gpkq = parcelRequire("6Gpkq");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("kgr2A");
var $1YPJb = parcelRequire("1YPJb");

var $2FrOD = parcelRequire("2FrOD");
const $649f0f18b25a1cc0$export$7656d61f506178a4 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const { likedTracks: likedTracks, likedPosts: likedPosts, followedArtists: followedArtists, unlockedTracks: unlockedTracks, unlockedPosts: unlockedPosts, subscribedArtists: subscribedArtists } = (0, $gNvvs.useAppSelector)((0, $6Gpkq.navigationSelectLibraryCategories));
    // content navigation desktop
    const [backwardDisabled, setBackwardDisabled] = (0, $bh6RR.useState)(true);
    const [forwardDisabled, setForwardDisabled] = (0, $bh6RR.useState)(false);
    const contentRef = (0, $bh6RR.useRef)(null);
    const categories = [
        {
            id: "2cc48f49-5bf6-40ab-9522-32bb5c0408bd",
            name: "Liked Tracks",
            label: "select liked tracks",
            selected: likedTracks,
            onClick: ()=>dispatch((0, $6Gpkq.navigationLibraryCategoriesToggleLikedTracks)())
        },
        {
            id: "074437af-af73-4f93-b69b-34e25b7195bd",
            name: "Liked Posts",
            label: "select liked posts",
            selected: likedPosts,
            onClick: ()=>dispatch((0, $6Gpkq.navigationLibraryCategoriesToggleLikedPosts)())
        },
        {
            id: "dfe24625-0bba-4085-8933-51e6139761a2",
            name: "Followed Artists",
            label: "select followed artists",
            selected: followedArtists,
            onClick: ()=>dispatch((0, $6Gpkq.navigationLibraryCategoriesToggleFollowedArtists)())
        },
        {
            id: "705b9609-f357-46ee-b6f9-9e4fe26200e0",
            name: "Unlocked Tracks",
            label: "select unlocked tracks",
            selected: unlockedTracks,
            onClick: ()=>dispatch((0, $6Gpkq.navigationLibraryCategoriesToggleUnlockedTracks)())
        },
        {
            id: "9aebdb24-2da7-40a1-8d2c-062d4d2a847a",
            name: "Unlocked Posts",
            label: "select unlocked posts",
            selected: unlockedPosts,
            onClick: ()=>dispatch((0, $6Gpkq.navigationLibraryCategoriesToggleUnlockedPosts)())
        },
        {
            id: "9129888d-fd0a-47c3-a7e3-0d21634dda10",
            name: "Subscribed Artists",
            label: "select subscribed artists",
            selected: subscribedArtists,
            onClick: ()=>dispatch((0, $6Gpkq.navigationLibraryCategoriesToggleSubscribedArtists)())
        }
    ];
    // configure initial navigation state
    (0, $bh6RR.useEffect)(()=>{
        // if node exists
        if (contentRef.current) {
            // get current node
            const { current: current } = contentRef;
            // get list node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = current;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (scrollLeft <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (scrollLeft >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    }, []);
    // handleBackwardClick - handles categories navigation backward click
    const handleBackwardClick = ()=>{
        // if node exists
        if (contentRef.current) {
            // get current node
            const { current: current } = contentRef;
            // get node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = current;
            // calculate next scroll offset
            const navigationButtonWidth = 60;
            const offset = clientWidth - navigationButtonWidth * 2;
            // scroll for exactly n visible items
            current.scrollBy(-offset, 0);
            const nextScrollPosition = scrollLeft - offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    // handleForwardClick - handles categories navigation forward click
    const handleForwardClick = ()=>{
        // if node exists
        if (contentRef.current) {
            // get current node
            const { current: current } = contentRef;
            // get node client width, scroll width, and scroll offset
            // clientWidth - currently visible content
            // scrollWidth - total width of the element
            // scrollLeft  - number of pixels scrolled
            const { clientWidth: clientWidth, scrollWidth: scrollWidth, scrollLeft: scrollLeft } = current;
            // calculate next scroll offset
            const navigationButtonWidth = 60;
            const offset = clientWidth - navigationButtonWidth * 2;
            // scroll for exactly n visible items
            current.scrollBy(offset, 0);
            const nextScrollPosition = scrollLeft + offset;
            const lastScrollPosition = scrollWidth - clientWidth;
            if (nextScrollPosition <= 0) setBackwardDisabled(true);
            else setBackwardDisabled(false);
            if (nextScrollPosition >= lastScrollPosition) setForwardDisabled(true);
            else setForwardDisabled(false);
        }
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $2FrOD.styles)(theme).navigation.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $2FrOD.styles)(theme).navigation.overlay.shared,
                    (0, $2FrOD.styles)(theme).navigation.overlay.backward,
                    backwardDisabled && (0, $2FrOD.styles)(theme).navigation.overlay.disabled,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $2FrOD.styles)(theme).navigation.overlay.button,
                    type: "button",
                    "aria-label": "scroll backward",
                    disabled: backwardDisabled,
                    onClick: ()=>handleBackwardClick(),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {
                        css: (0, $2FrOD.styles)(theme).navigation.overlay.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2FrOD.styles)(theme).navigation.content,
                ref: contentRef,
                children: categories.map(({ id: id, name: name, label: label, selected: selected, onClick: onClick })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $1YPJb.Category), {
                        name: name,
                        label: label,
                        selected: selected,
                        onClick: ()=>onClick()
                    }, id))
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $2FrOD.styles)(theme).navigation.overlay.shared,
                    (0, $2FrOD.styles)(theme).navigation.overlay.forward,
                    forwardDisabled && (0, $2FrOD.styles)(theme).navigation.overlay.disabled,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $2FrOD.styles)(theme).navigation.overlay.button,
                    type: "button",
                    "aria-label": "scroll backward",
                    disabled: forwardDisabled,
                    onClick: ()=>handleForwardClick(),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowRight, {
                        css: (0, $2FrOD.styles)(theme).navigation.overlay.icon
                    })
                })
            })
        ]
    });
};
$649f0f18b25a1cc0$export$7656d61f506178a4.propTypes = {};

});
parcelRegister("kgr2A", function(module, exports) {

$parcel$export(module.exports, "Category", function () { return (parcelRequire("1YPJb")).Category; });

var $1YPJb = parcelRequire("1YPJb");

});
parcelRegister("1YPJb", function(module, exports) {

$parcel$export(module.exports, "Category", function () { return $b7f6d65a152b17e6$export$3a8840c5b2ecf003; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $9mJX0 = parcelRequire("9mJX0");
const $b7f6d65a152b17e6$export$3a8840c5b2ecf003 = ({ name: name, label: label, selected: selected = false, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9mJX0.styles)(theme).category.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
            css: [
                (0, $9mJX0.styles)(theme).category.button.shared,
                selected ? (0, $9mJX0.styles)(theme).category.button.selected : (0, $9mJX0.styles)(theme).category.button.unselected,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": label,
            children: name
        })
    });
};
$b7f6d65a152b17e6$export$3a8840c5b2ecf003.propTypes = {};

});
parcelRegister("9mJX0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4d17748cbf6d0a92$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4d17748cbf6d0a92$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4d17748cbf6d0a92$var$_ref = {
    name: "1u4hpl4",
    styles: "display:inline"
};
const $4d17748cbf6d0a92$export$9dd6ff9ea0189349 = (theme)=>({
        category: {
            main: $4d17748cbf6d0a92$var$_ref,
            button: {
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";height:40px;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;white-space:nowrap;line-height:1;border-radius:20px;border:1px solid transparent;padding:8px 26px;cursor:pointer;transition:color 0.2s,background-color 0.2s,border 0.2s;", ""),
                selected: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";", ""),
                unselected: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});



parcelRegister("2FrOD", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a9203e0916f236a4$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $a9203e0916f236a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a9203e0916f236a4$var$_ref = {
    name: "lcsd53",
    styles: "width:100vw"
};
var $a9203e0916f236a4$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
var $a9203e0916f236a4$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
const $a9203e0916f236a4$export$9dd6ff9ea0189349 = (theme)=>({
        navigation: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).library.header.height, ";", (0, $gln0L.helpers).library.header.width, ";position:relative;", ""),
            overlay: {
                shared: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).library.navigation.arrows, ";position:absolute;display:flex;align-items:center;justify-content:center;width:60px;height:64px;", (0, $gln0L.mq).mobile($a9203e0916f236a4$var$_ref3), ";", ""),
                backward: /*#__PURE__*/ (0, $7hler.css)("top:0;left:0;background:linear-gradient(\n          90deg,\n          ", theme.colors.primary.normal, " 50%,\n          ", theme.colors.primary.normal, "00 100%\n        );", ""),
                forward: /*#__PURE__*/ (0, $7hler.css)("top:0;right:0;background:linear-gradient(\n          270deg,\n          ", theme.colors.primary.normal, " 50%,\n          ", theme.colors.primary.normal, "00 100%\n        );", ""),
                disabled: $a9203e0916f236a4$var$_ref2,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:40px;height:40px;cursor:pointer;&:hover>svg{color:", theme.colors.accent.normal, ";}", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:20px;height:20px;transition:color 0.2s;color:", theme.colors.secondary.normal, ";", "")
            },
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.sides, ";display:flex;align-items:center;width:100%;height:64px;scroll-behavior:smooth;overflow-x:scroll;overflow-y:hidden;&>div:not(:last-of-type){margin-right:18px;}", (0, $gln0L.mq).tablet($a9203e0916f236a4$var$_ref), ";", "")
        }
    });

});



parcelRegister("6Gpkq", function(module, exports) {

$parcel$export(module.exports, "navigationSlice", function () { return $3821be31a0e9e087$export$de790b4dea75d828; });
$parcel$export(module.exports, "navigationAppNavigationToggle", function () { return $3821be31a0e9e087$export$af9b100e53a4319a; });
$parcel$export(module.exports, "navigationAppNavigationClose", function () { return $3821be31a0e9e087$export$9533b90f4dbbbe61; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleLikedTracks", function () { return $3821be31a0e9e087$export$f336f935c1afd49; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleLikedPosts", function () { return $3821be31a0e9e087$export$3c4c9d7436519edc; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleUnlockedTracks", function () { return $3821be31a0e9e087$export$b9439e277be4ef7c; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleUnlockedPosts", function () { return $3821be31a0e9e087$export$853b5990905e4b4a; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleFollowedArtists", function () { return $3821be31a0e9e087$export$3ab5ea438c43ace8; });
$parcel$export(module.exports, "navigationLibraryCategoriesToggleSubscribedArtists", function () { return $3821be31a0e9e087$export$671962ec6c02e8d7; });
$parcel$export(module.exports, "navigationSelectAppNavigationOpen", function () { return $3821be31a0e9e087$export$1e1838785d7d9c6; });
$parcel$export(module.exports, "navigationSelectLibraryCategories", function () { return $3821be31a0e9e087$export$1183892afe6282; });
$parcel$export(module.exports, "navigationReducer", function () { return $3821be31a0e9e087$export$dcbfb7a8294dae22; });

var $kvj5V = parcelRequire("kvj5V");
const $3821be31a0e9e087$var$initialState = {
    app: {
        navigation: {
            open: false
        }
    },
    library: {
        categories: {
            likedTracks: true,
            likedPosts: false,
            unlockedTracks: false,
            unlockedPosts: false,
            followedArtists: false,
            subscribedArtists: false
        }
    }
};
const $3821be31a0e9e087$export$de790b4dea75d828 = (0, $kvj5V.createSlice)({
    name: "navigation",
    initialState: $3821be31a0e9e087$var$initialState,
    reducers: {
        // app navigation
        navigationAppNavigationToggle: (state)=>({
                ...state,
                app: {
                    navigation: {
                        open: !state.app.navigation.open
                    }
                }
            }),
        navigationAppNavigationClose: (state)=>({
                ...state,
                app: {
                    navigation: {
                        open: false
                    }
                }
            }),
        // library navigation
        navigationLibraryCategoriesToggleLikedTracks: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        likedTracks: !state.library.categories.likedTracks
                    }
                }
            }),
        navigationLibraryCategoriesToggleLikedPosts: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        likedPosts: !state.library.categories.likedPosts
                    }
                }
            }),
        navigationLibraryCategoriesToggleUnlockedTracks: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        unlockedTracks: !state.library.categories.unlockedTracks
                    }
                }
            }),
        navigationLibraryCategoriesToggleUnlockedPosts: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        unlockedPosts: !state.library.categories.unlockedPosts
                    }
                }
            }),
        navigationLibraryCategoriesToggleFollowedArtists: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        followedArtists: !state.library.categories.followedArtists
                    }
                }
            }),
        navigationLibraryCategoriesToggleSubscribedArtists: (state)=>({
                ...state,
                library: {
                    categories: {
                        ...state.library.categories,
                        subscribedArtists: !state.library.categories.subscribedArtists
                    }
                }
            })
    }
});
const { navigationAppNavigationToggle: $3821be31a0e9e087$export$af9b100e53a4319a, navigationAppNavigationClose: $3821be31a0e9e087$export$9533b90f4dbbbe61, navigationLibraryCategoriesToggleLikedTracks: $3821be31a0e9e087$export$f336f935c1afd49, navigationLibraryCategoriesToggleLikedPosts: $3821be31a0e9e087$export$3c4c9d7436519edc, navigationLibraryCategoriesToggleUnlockedTracks: $3821be31a0e9e087$export$b9439e277be4ef7c, navigationLibraryCategoriesToggleUnlockedPosts: $3821be31a0e9e087$export$853b5990905e4b4a, navigationLibraryCategoriesToggleFollowedArtists: $3821be31a0e9e087$export$3ab5ea438c43ace8, navigationLibraryCategoriesToggleSubscribedArtists: $3821be31a0e9e087$export$671962ec6c02e8d7 } = $3821be31a0e9e087$export$de790b4dea75d828.actions;
const $3821be31a0e9e087$export$1e1838785d7d9c6 = (state)=>state.navigation.app.navigation.open;
const $3821be31a0e9e087$export$1183892afe6282 = (state)=>state.navigation.library.categories;
const $3821be31a0e9e087$export$dcbfb7a8294dae22 = $3821be31a0e9e087$export$de790b4dea75d828.reducer; // export default navigationSlice.reducer

});


parcelRegister("Nc6lr", function(module, exports) {

$parcel$export(module.exports, "NotificationCard", function () { return (parcelRequire("2J8rw")).NotificationCard; });
$parcel$export(module.exports, "NotificationListNotifications", function () { return (parcelRequire("hcjtt")).NotificationListNotifications; });
$parcel$export(module.exports, "NotificationViewNotification", function () { return (parcelRequire("59Rw5")).NotificationViewNotification; });
parcelRequire("5bMn8");
var $2J8rw = parcelRequire("2J8rw");
var $hcjtt = parcelRequire("hcjtt");
var $59Rw5 = parcelRequire("59Rw5");

var $89C5W = parcelRequire("89C5W");

var $day58 = parcelRequire("day58");
$parcel$exportWildcard(module.exports, $89C5W);
$parcel$exportWildcard(module.exports, $day58);

});
parcelRegister("5bMn8", function(module, exports) {

$parcel$export(module.exports, "NotificationCard", function () { return (parcelRequire("2J8rw")).NotificationCard; });
$parcel$export(module.exports, "NotificationListNotifications", function () { return (parcelRequire("hcjtt")).NotificationListNotifications; });
$parcel$export(module.exports, "NotificationViewNotification", function () { return (parcelRequire("59Rw5")).NotificationViewNotification; });

var $2J8rw = parcelRequire("2J8rw");

var $hcjtt = parcelRequire("hcjtt");

var $59Rw5 = parcelRequire("59Rw5");

});
parcelRegister("2J8rw", function(module, exports) {

$parcel$export(module.exports, "NotificationCard", function () { return $2835bf2f1170e55a$export$c86fc4367bcc624a; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gBCSe = parcelRequire("gBCSe");
parcelRequire("cJvLm");
var $day58 = parcelRequire("day58");

var $4BZgi = parcelRequire("4BZgi");
parcelRequire("dzXbo");
var $8Vi4P = parcelRequire("8Vi4P");

var $aigv4 = parcelRequire("aigv4");
const $2835bf2f1170e55a$export$c86fc4367bcc624a = ({ notification: notification, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const { id: notificationId, sourceUserIds: sourceUserIds, sourceUserIdsCount: sourceUserIdsCount, event: event, read: read } = notification;
    const isSourcesPresent = !!(sourceUserIds && sourceUserIds.length > 0);
    const isSingleSource = !!(sourceUserIds && sourceUserIds.length === 1);
    const isDoubleSource = !!(sourceUserIds && sourceUserIds.length === 2);
    const isTripleSource = !!(sourceUserIds && sourceUserIds.length === 3);
    // source users
    const { users: sourceUsers, isLoading: isSourceUsersLoading } = (0, $gBCSe.useUsers)(sourceUserIds || []);
    const userLoadingPlaceholder = "Loading...";
    (0, $bh6RR.useEffect)(()=>{
        // if notification is not read
        if (!read) // flag notification as read
        dispatch((0, $day58.notificationReadNotification)({
            notificationId: notificationId || ""
        }));
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $aigv4.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $aigv4.styles)(theme).card.data.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $aigv4.styles)(theme).card.data.source.main,
                    children: isSourcesPresent ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: [
                            (0, $aigv4.styles)(theme).card.data.source.avatars.shared,
                            isSingleSource && (0, $aigv4.styles)(theme).card.data.source.avatars.single,
                            isDoubleSource && (0, $aigv4.styles)(theme).card.data.source.avatars.double,
                            isTripleSource && (0, $aigv4.styles)(theme).card.data.source.avatars.triple,
                            "",
                            ""
                        ],
                        children: sourceUsers && sourceUsers.map(({ id: id, avatarId: avatarId })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $8Vi4P.Avatar), {
                                avatarId: avatarId
                            }, `notification-avatar-${id}`))
                    }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $aigv4.styles)(theme).card.data.source.icon,
                        children: event && /*#__PURE__*/ (0, $bh6RR.createElement)((0, $4BZgi.getNotificationIcon)(event))
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $aigv4.styles)(theme).card.data.info.main,
                    children: [
                        isSourcesPresent && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $aigv4.styles)(theme).card.data.info.sources,
                            children: isSourceUsersLoading ? userLoadingPlaceholder : (0, $4BZgi.formantNotificationSources)(sourceUsers || [])
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $aigv4.styles)(theme).card.data.info.titles,
                            children: [
                                (0, $4BZgi.getNotificationOthers)(sourceUserIds || [], sourceUserIdsCount || 0),
                                " ",
                                event && (0, $4BZgi.getNotificationTitle)(event)
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$2835bf2f1170e55a$export$c86fc4367bcc624a.propTypes = {};

});
parcelRegister("4BZgi", function(module, exports) {

$parcel$export(module.exports, "getNotificationTitle", function () { return $4b1754d1ac828e9e$export$58a9eeee76364ebb; });
$parcel$export(module.exports, "getNotificationOthers", function () { return $4b1754d1ac828e9e$export$2537101bd1e6339; });
$parcel$export(module.exports, "formantNotificationSources", function () { return $4b1754d1ac828e9e$export$b6cfc697d69eb4d8; });
$parcel$export(module.exports, "getNotificationIcon", function () { return $4b1754d1ac828e9e$export$2c1c27587878a0c4; });
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
const $4b1754d1ac828e9e$export$58a9eeee76364ebb = (event)=>{
    // USER
    if (event === (0, $2gpGl.EntityNotificationEvent).AppUserFollowCreated) return "started following you";
    // TRACK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackCreated) return "released new track";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackBlocked) return "Your track is blocked";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackLikeCreated) return "liked your track";
    // POST
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostCreated) return "shared new post";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostBlocked) return "Your post is blocked";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostLikeCreated) return "liked your post";
    // COMMENT
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentCreated) return "commented on your post";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentReplyCreated) return "replied to your comment";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentBlocked) return "Your comment is blocked";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentLikeCreated) return "liked your comment";
    // TIP
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentSucceeded) return "Tip payment succeeded";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentFailed) return "Tip payment failed";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipCreated) return "has sent you a tip";
    // TRACK UNLOCK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return "Unlock payment succeeded";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentFailed) return "Unlock payment failed";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockCreated) return "unlocked your track";
    // POST UNLOCK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return "Unlock payment succeeded";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentFailed) return "Unlock payment failed";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockCreated) return "unlocked your post";
    // SUBSCRIPTION
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return "Subscription payment succeeded";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentFailed) return "Subscription payment failed";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionCreated) return "subscribed to you";
    // PAYOUT
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPayoutPaid) return "Payout payment succeeded";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPayoutFailed) return "Payout payment failed";
    return "";
};
const $4b1754d1ac828e9e$export$2537101bd1e6339 = (sourceUserIds, sourceUserIdsCount)=>{
    if (sourceUserIds.length >= 3 && sourceUserIdsCount > 3) return `and ${(0, $1Fj5G.numbersFormatter)(sourceUserIdsCount - sourceUserIds.length)} other(s)`;
    return "";
};
const $4b1754d1ac828e9e$export$b6cfc697d69eb4d8 = (sourceUsers)=>sourceUsers.reduce((prev, { username: username })=>prev === "" ? `@${username}` : `${prev}, @${username}`, "");
const $4b1754d1ac828e9e$export$2c1c27587878a0c4 = (event)=>{
    // TRACK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackBlocked) return (0, $bq9l8.icons).AlertTriangle;
    // POST
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostBlocked) return (0, $bq9l8.icons).AlertTriangle;
    // COMMENT
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentBlocked) return (0, $bq9l8.icons).AlertTriangle;
    // TIP
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentSucceeded) return (0, $bq9l8.icons).DollarCircle;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentFailed) return (0, $bq9l8.icons).AlertTriangle;
    // UNLOCK TRACK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return (0, $bq9l8.icons).Unlock;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentFailed) return (0, $bq9l8.icons).AlertTriangle;
    // UNLOCK POST
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return (0, $bq9l8.icons).Unlock;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentFailed) return (0, $bq9l8.icons).AlertTriangle;
    // SUBSCRIPTION
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return (0, $bq9l8.icons).Unlock;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentFailed) return (0, $bq9l8.icons).AlertTriangle;
    // PAYOUT
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPayoutPaid) return (0, $bq9l8.icons).DollarCircle;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPayoutFailed) return (0, $bq9l8.icons).AlertTriangle;
    return (0, $bq9l8.icons).CheckCircle;
};

});

parcelRegister("dzXbo", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("8Vi4P")).Avatar; });

var $8Vi4P = parcelRequire("8Vi4P");

});
parcelRegister("8Vi4P", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $bb22f0c26138ac24$export$e2255cf6045e8d47; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");

var $1JSSV = parcelRequire("1JSSV");
const $bb22f0c26138ac24$export$e2255cf6045e8d47 = ({ avatarId: avatarId = "" })=>{
    const theme = (0, $iwq56.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $bh6RR.useState)(false);
    const hasAvatar = !!avatarId;
    const source = (0, $jpNoL.useFile)(avatarId || "");
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1JSSV.styles)(theme).avatar.main,
        children: hasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
            css: (0, $1JSSV.styles)(theme).avatar.content,
            onError: ()=>setAvatarLoadError(true),
            loading: "lazy",
            width: "60px",
            height: "60px",
            src: source,
            alt: "source user avatar"
        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
            css: (0, $1JSSV.styles)(theme).avatar.icon
        })
    });
};

});
parcelRegister("1JSSV", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bf1a5ddf09cd252b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $bf1a5ddf09cd252b$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:60px;height:60px;border-radius:50%;background-color:", theme.colors.primary.darker, ";overflow:hidden;", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("width:30px;height:30px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
        }
    });

});



parcelRegister("aigv4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b04ca8f0468d715e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $b04ca8f0468d715e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b04ca8f0468d715e$var$_ref = {
    name: "79ibxp",
    styles: "display:flex;flex-direction:column;width:100%;min-width:0"
};
var $b04ca8f0468d715e$var$_ref2 = {
    name: "bxnacs",
    styles: "position:relative;display:flex;align-items:center;&>div{position:absolute;width:30px;height:30px;}&>div:nth-of-type(1){z-index:3;left:0px;}&>div:nth-of-type(2){z-index:2;left:15px;}&>div:nth-of-type(3){z-index:1;right:0px;}"
};
var $b04ca8f0468d715e$var$_ref3 = {
    name: "18az8xz",
    styles: "position:relative;display:flex;align-items:center;&>div{position:absolute;width:40px;height:40px;}&>div:nth-of-type(1){z-index:2;left:0px;}&>div:nth-of-type(2){z-index:1;right:0px;}"
};
var $b04ca8f0468d715e$var$_ref4 = {
    name: "pn23tk",
    styles: "width:60px;height:60px"
};
var $b04ca8f0468d715e$var$_ref5 = {
    name: "18dc9ig",
    styles: "display:flex;flex:0 0 60px;margin-right:20px"
};
var $b04ca8f0468d715e$var$_ref6 = {
    name: "12t4mdo",
    styles: "display:flex;align-items:center;height:60px"
};
var $b04ca8f0468d715e$var$_ref7 = {
    name: "1y1se14",
    styles: "display:flex;flex-direction:column;justify-content:space-between;height:60px;cursor:pointer"
};
const $b04ca8f0468d715e$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $b04ca8f0468d715e$var$_ref7,
            data: {
                main: $b04ca8f0468d715e$var$_ref6,
                source: {
                    main: $b04ca8f0468d715e$var$_ref5,
                    avatars: {
                        shared: $b04ca8f0468d715e$var$_ref4,
                        single: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        double: $b04ca8f0468d715e$var$_ref3,
                        triple: $b04ca8f0468d715e$var$_ref2
                    },
                    icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:60px;height:60px;&>svg{width:32px;height:32px;&>path{fill:", theme.colors.secondary.normal, ";}}", "")
                },
                info: {
                    main: $b04ca8f0468d715e$var$_ref,
                    sources: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", ""),
                    titles: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")
                }
            }
        }
    });

});


parcelRegister("hcjtt", function(module, exports) {

$parcel$export(module.exports, "NotificationListNotifications", function () { return $13b51d5e6106a24b$export$9f7bd6309114da4c; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $2J8rw = parcelRequire("2J8rw");
var $day58 = parcelRequire("day58");
var $89C5W = parcelRequire("89C5W");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
var $4sGtG = parcelRequire("4sGtG");
var $f6nZ0 = parcelRequire("f6nZ0");
var $curqj = parcelRequire("curqj");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $66ECO = parcelRequire("66ECO");
const $13b51d5e6106a24b$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const notifications = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotifications));
    const notification = notifications[index];
    // if notification not fetched
    if (!notification) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "notification-list-notifications-notification",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: notificationId } = notification;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $66ECO.styles)().notification.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2J8rw.NotificationCard), {
            notification: notification,
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Notifications}${(0, $b7fnN.Path).Notification}/${notificationId}`)
        })
    });
});
const $13b51d5e6106a24b$export$9f7bd6309114da4c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const notificationGetNotificationsLoading = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationGetNotificationsLoading));
    const notifications = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotifications));
    const notificationsCount = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationsCount));
    const notificationsLength = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationsLength));
    const notificationsFetched = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationsFetched));
    const notificationsFilter = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationsFilter));
    const notificationReadNotificationsLoading = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationReadNotificationsLoading));
    const notificationCardHeight = 60;
    const notificationCardMarginBottom = 20;
    const itemHeight = notificationCardHeight + notificationCardMarginBottom;
    const itemsToFit = 6;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = itemsToFit * itemHeight;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!notifications[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $day58.notificationGetNotifications)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders notification list navigation
    const renderNotificationListNavigation = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $66ECO.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $curqj.NavigationScrollable), {
                options: [
                    {
                        id: "ebb827c4-2091-4dc2-8f5d-621ce926677d",
                        label: "User",
                        enabled: notificationsFilter === (0, $2gpGl.EntityNotificationEntityType).User,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $89C5W.notificationSetNotificationsFilter)({
                                filter: (0, $2gpGl.EntityNotificationEntityType).User
                            }));
                            // refetch notifications
                            dispatch((0, $day58.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "8dceb189-e6e8-4f1c-85a0-31fcde6fe99d",
                        label: "Track",
                        enabled: notificationsFilter === (0, $2gpGl.EntityNotificationEntityType).Track,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $89C5W.notificationSetNotificationsFilter)({
                                filter: (0, $2gpGl.EntityNotificationEntityType).Track
                            }));
                            // refetch notifications
                            dispatch((0, $day58.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "37740ab4-aea0-4c54-8448-400a1fab5096",
                        label: "Post",
                        enabled: notificationsFilter === (0, $2gpGl.EntityNotificationEntityType).Post,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $89C5W.notificationSetNotificationsFilter)({
                                filter: (0, $2gpGl.EntityNotificationEntityType).Post
                            }));
                            // refetch notifications
                            dispatch((0, $day58.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "b5200260-910e-43f5-aa44-8c7883dee6ae",
                        label: "Comment",
                        enabled: notificationsFilter === (0, $2gpGl.EntityNotificationEntityType).Comment,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $89C5W.notificationSetNotificationsFilter)({
                                filter: (0, $2gpGl.EntityNotificationEntityType).Comment
                            }));
                            // refetch notifications
                            dispatch((0, $day58.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "cb4d6974-7986-4054-b7b4-ba644cd2d0f6",
                        label: "Tip",
                        enabled: notificationsFilter === (0, $2gpGl.EntityNotificationEntityType).Tip,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $89C5W.notificationSetNotificationsFilter)({
                                filter: (0, $2gpGl.EntityNotificationEntityType).Tip
                            }));
                            // refetch notifications
                            dispatch((0, $day58.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "e26df361-c035-42c7-82d9-18ceab7d9d56",
                        label: "Unlock",
                        enabled: notificationsFilter === (0, $2gpGl.EntityNotificationEntityType).Unlock,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $89C5W.notificationSetNotificationsFilter)({
                                filter: (0, $2gpGl.EntityNotificationEntityType).Unlock
                            }));
                            // refetch notifications
                            dispatch((0, $day58.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "1a2c0ce2-edff-4878-a25d-8bca6509d185",
                        label: "Sub",
                        enabled: notificationsFilter === (0, $2gpGl.EntityNotificationEntityType).Subscription,
                        onClick: ()=>{
                            // set notifications filter
                            dispatch((0, $89C5W.notificationSetNotificationsFilter)({
                                filter: (0, $2gpGl.EntityNotificationEntityType).Subscription
                            }));
                            // refetch notifications
                            dispatch((0, $day58.notificationGetNotifications)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    }
                ]
            })
        });
    // if notifications are fetched but length is 0
    if (!notificationGetNotificationsLoading && notificationsFetched && notificationsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $66ECO.styles)().list.main,
        children: [
            renderNotificationListNavigation(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $66ECO.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
                    icon: (0, $bq9l8.icons).Bell,
                    height: `${defaultListHeight}px`,
                    title: "There are no notifications"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $66ECO.styles)().list.main,
        children: [
            renderNotificationListNavigation(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $66ECO.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: notificationsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: notificationsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $13b51d5e6106a24b$var$Row
                        })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $66ECO.styles)().list.actions.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                    type: "button",
                    "aria-label": "read all notifications",
                    disabled: notificationReadNotificationsLoading,
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $day58.notificationReadNotifications)()),
                    children: notificationReadNotificationsLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                        width: 56,
                        height: 16,
                        appearance: "secondary"
                    }) : `Read all`
                })
            })
        ]
    }));
};
$13b51d5e6106a24b$export$9f7bd6309114da4c.propTypes = {};

});
parcelRegister("66ECO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $23e4e944eadb2d91$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $23e4e944eadb2d91$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $23e4e944eadb2d91$var$_ref = {
    name: "vziczn",
    styles: "justify-content:flex-start;&>button{width:100%;}"
};
var $23e4e944eadb2d91$var$_ref2 = {
    name: "1f5vy9b",
    styles: "max-width:800px;margin-bottom:24px"
};
const $23e4e944eadb2d91$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            content: {
                main: $23e4e944eadb2d91$var$_ref2
            },
            actions: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:flex-end;max-width:800px;&>button{width:140px;height:32px;}", (0, $gln0L.mq).mobile($23e4e944eadb2d91$var$_ref), ";", "")
            }
        },
        notification: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("59Rw5", function(module, exports) {

$parcel$export(module.exports, "NotificationViewNotification", function () { return $b9911b6bad4d30d8$export$73f3139b9805d66d; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
var $1MzSD = parcelRequire("1MzSD");
var $lbAL5 = parcelRequire("lbAL5");
var $bRg8c = parcelRequire("bRg8c");
var $5LPLy = parcelRequire("5LPLy");
var $gBCSe = parcelRequire("gBCSe");
parcelRequire("cJvLm");
var $89C5W = parcelRequire("89C5W");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $dptzH = parcelRequire("dptzH");
parcelRequire("iGHLc");
var $PW76r = parcelRequire("PW76r");
var $1rOB9 = parcelRequire("1rOB9");
var $1bYaB = parcelRequire("1bYaB");
var $jjj7B = parcelRequire("jjj7B");
var $913AC = parcelRequire("913AC");
var $2aKGP = parcelRequire("2aKGP");
var $9beEk = parcelRequire("9beEk");

var $5XCLp = parcelRequire("5XCLp");
const $b9911b6bad4d30d8$export$73f3139b9805d66d = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const notification = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotification));
    const notificationFetched = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationFetched));
    const { sourceUserIds: sourceUserIds, sourceUserIdsCount: sourceUserIdsCount, entityType: entityType, entityId: entityId, parentEntityId: parentEntityId, event: event } = notification ?? {};
    // source users
    const { users: sourceUsers, isLoading: isSourceUsersLoading } = (0, $gBCSe.useUsers)(sourceUserIds || []);
    const userLoadingPlaceholder = "Loading...";
    // notification types
    const isTrackNotification = entityType === (0, $2gpGl.EntityNotificationEntityType).Track;
    const isPostNotification = entityType === (0, $2gpGl.EntityNotificationEntityType).Post;
    const isCommentNotification = entityType === (0, $2gpGl.EntityNotificationEntityType).Comment;
    const isTipNotification = entityType === (0, $2gpGl.EntityNotificationEntityType).Tip;
    const isUnlockNotification = entityType === (0, $2gpGl.EntityNotificationEntityType).Unlock;
    const isSubscriptionNotification = entityType === (0, $2gpGl.EntityNotificationEntityType).Subscription;
    const isConnectPayoutNotification = entityType === (0, $2gpGl.EntityNotificationEntityType).ConnectPayout;
    // notification tip
    const { tip: notificationTip, isLoading: isNotificationTipLoading } = (0, $bRg8c.useTip)(isTipNotification ? entityId || "" : "");
    // notification unlock
    const { unlock: notificationUnlock, isLoading: isNotificationUnlockLoading } = (0, $5LPLy.useUnlock)(isUnlockNotification ? entityId || "" : "");
    // notification subscription
    const { subscription: notificationSubscription, isLoading: isNotificationSubscriptionLoading } = (0, $lbAL5.useSubscription)(isSubscriptionNotification ? entityId || "" : "");
    // notification connect payout
    const { connectPayout: notificationConnectPayout, isLoading: isNotificationConnectPayoutLoading } = (0, $1MzSD.useConnectPayout)(isConnectPayoutNotification ? entityId || "" : "");
    const isTipControlsDisabled = isNotificationTipLoading || !notificationTip;
    const isUnlockControlsDisabled = isNotificationUnlockLoading || !notificationUnlock;
    const isSubscriptionControlsDisabled = isNotificationSubscriptionLoading || !notificationSubscription;
    // if notification not found
    if (notificationFetched && !notification) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5XCLp.styles)().view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).AlertTriangle,
            height: "80px",
            title: "Could not find notification"
        })
    });
    const renderNotificationSourceUsers = ()=>{
        // if source users loading
        if (isSourceUsersLoading) // return placeholder
        return /*#__PURE__*/ (0, $9awXB.jsxs)("span", {
            children: [
                userLoadingPlaceholder,
                " "
            ]
        });
        // if source users loaded
        if (sourceUsers) // render source users
        return sourceUsers.map(({ id: userId, username: username }, idx)=>{
            const isLastSource = sourceUsers.length - 1 === idx;
            return /*#__PURE__*/ (0, $9awXB.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $1bYaB.SourceUser), {
                        label: "source user",
                        username: username || "unknown",
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${userId}`)
                    }),
                    isLastSource ? " " : ", "
                ]
            }, `notification-view-notification-source-${userId}`);
        });
        return /*#__PURE__*/ (0, $9awXB.jsx)("span", {});
    };
    // if notification found
    if (notificationFetched && notification) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5XCLp.styles)().view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $5XCLp.styles)().view.content.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $5XCLp.styles)().view.content.identifier,
                    children: [
                        renderNotificationSourceUsers(),
                        (0, $dptzH.getNotificationOthers)(sourceUserIds || [], sourceUserIdsCount || 0),
                        " ",
                        event && (0, $dptzH.getNotificationTitle)(event, {
                            tip: notificationTip,
                            isTipLoading: isNotificationTipLoading,
                            unlock: notificationUnlock,
                            isUnlockLoading: isNotificationUnlockLoading,
                            subscription: notificationSubscription,
                            isSubscriptionLoading: isNotificationSubscriptionLoading,
                            connectPayout: notificationConnectPayout,
                            isConnectPayoutLoading: isNotificationConnectPayoutLoading
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $5XCLp.styles)().view.content.navigation,
                    children: [
                        isTrackNotification && /*#__PURE__*/ (0, $9awXB.jsx)((0, $2aKGP.TrackControls), {
                            trackId: entityId || ""
                        }),
                        isPostNotification && /*#__PURE__*/ (0, $9awXB.jsx)((0, $1rOB9.PostControls), {
                            postId: entityId || ""
                        }),
                        isCommentNotification && /*#__PURE__*/ (0, $9awXB.jsx)((0, $PW76r.CommentControls), {
                            commentId: entityId || "",
                            parentCommentId: parentEntityId || ""
                        }),
                        isTipNotification && /*#__PURE__*/ (0, $9awXB.jsx)((0, $913AC.TipControls), {
                            event: notification.event,
                            tip: notificationTip,
                            isDisabled: isTipControlsDisabled
                        }),
                        isUnlockNotification && /*#__PURE__*/ (0, $9awXB.jsx)((0, $9beEk.UnlockControls), {
                            event: notification.event,
                            unlock: notificationUnlock,
                            isDisabled: isUnlockControlsDisabled
                        }),
                        isSubscriptionNotification && /*#__PURE__*/ (0, $9awXB.jsx)((0, $jjj7B.SubscriptionControls), {
                            event: notification.event,
                            subscription: notificationSubscription,
                            isDisabled: isSubscriptionControlsDisabled
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5XCLp.styles)().view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "notification-view-notifications-notification",
                    width: "100%",
                    height: "80px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$b9911b6bad4d30d8$export$73f3139b9805d66d.propTypes = {};

});
parcelRegister("dptzH", function(module, exports) {

$parcel$export(module.exports, "getNotificationTitle", function () { return $b42f86d1a02e15e4$export$58a9eeee76364ebb; });
$parcel$export(module.exports, "getNotificationOthers", function () { return $b42f86d1a02e15e4$export$2537101bd1e6339; });
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
const $b42f86d1a02e15e4$export$58a9eeee76364ebb = (event, { tip: tip, isTipLoading: isTipLoading, unlock: unlock, isUnlockLoading: isUnlockLoading, subscription: subscription, isSubscriptionLoading: isSubscriptionLoading, connectPayout: connectPayout, isConnectPayoutLoading: isConnectPayoutLoading })=>{
    // USER
    if (event === (0, $2gpGl.EntityNotificationEvent).AppUserFollowCreated) return "started following you";
    // TRACK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackCreated) return "released new track";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackBlocked) return "Your track is blocked";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackLikeCreated) return "liked your track";
    // POST
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostCreated) return "shared new post";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostBlocked) return "Your post is blocked";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostLikeCreated) return "liked your post";
    // COMMENT
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentCreated) return "commented on your post";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentReplyCreated) return "replied to your comment";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentBlocked) return "Your comment is blocked";
    if (event === (0, $2gpGl.EntityNotificationEvent).AppCommentLikeCreated) return "liked your comment";
    // TIP
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentSucceeded) return `Your $${isTipLoading ? "..." : (tip?.amount || 0) / 100} tip payment has succeeded`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentFailed) return `Your $${isTipLoading ? "..." : (tip?.amount || 0) / 100} tip payment has failed`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipCreated) return ` has sent you $${isTipLoading ? "..." : (tip?.amount || 0) / 100} tip`;
    // TRACK UNLOCK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100} track unlock payment has succeeded`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentFailed) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100}  track unlock payment has failed`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockCreated) return ` has unlocked your track for $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100} `;
    // POST UNLOCK
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100}  post unlock payment has succeeded`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentFailed) return `Your $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100}  post unlock payment has failed`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockCreated) return ` has unlocked your post for $${isUnlockLoading ? "..." : (unlock?.unlockPrice || 0) / 100} `;
    // SUBSCRIPTION
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return `Your $${isSubscriptionLoading ? "..." : (subscription?.subscriptionPrice || 0) / 100} subscription payment has succeeded`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentFailed) return `Your $${isSubscriptionLoading ? "..." : (subscription?.subscriptionPrice || 0) / 100} subscription payment has failed`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionCreated) return ` has subscribed to you for $${isSubscriptionLoading ? "..." : (subscription?.subscriptionPrice || 0) / 100}`;
    // PAYOUT
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPayoutPaid) return `Your $${isConnectPayoutLoading ? "..." : (connectPayout?.amount || 0) / 100} payout has succeeded`;
    if (event === (0, $2gpGl.EntityNotificationEvent).AppPayoutFailed) return `Your $${isConnectPayoutLoading ? "..." : (connectPayout?.amount || 0) / 100} payout has succeeded`;
    return "";
};
const $b42f86d1a02e15e4$export$2537101bd1e6339 = (sourceUserIds, sourceUserIdsCount)=>{
    if (sourceUserIds.length >= 3 && sourceUserIdsCount > 3) return `and ${(0, $1Fj5G.numbersFormatter)(sourceUserIdsCount - sourceUserIds.length)} other(s)`;
    return "";
};

});

parcelRegister("iGHLc", function(module, exports) {

$parcel$export(module.exports, "CommentControls", function () { return (parcelRequire("PW76r")).CommentControls; });
$parcel$export(module.exports, "PostControls", function () { return (parcelRequire("1rOB9")).PostControls; });
$parcel$export(module.exports, "SubscriptionControls", function () { return (parcelRequire("jjj7B")).SubscriptionControls; });
$parcel$export(module.exports, "TipControls", function () { return (parcelRequire("913AC")).TipControls; });
$parcel$export(module.exports, "TrackControls", function () { return (parcelRequire("2aKGP")).TrackControls; });
$parcel$export(module.exports, "UnlockControls", function () { return (parcelRequire("9beEk")).UnlockControls; });
$parcel$export(module.exports, "SourceUser", function () { return (parcelRequire("1bYaB")).SourceUser; });
parcelRequire("gF79V");
var $PW76r = parcelRequire("PW76r");
var $1rOB9 = parcelRequire("1rOB9");
var $jjj7B = parcelRequire("jjj7B");
var $913AC = parcelRequire("913AC");
var $2aKGP = parcelRequire("2aKGP");
var $9beEk = parcelRequire("9beEk");

var $1bYaB = parcelRequire("1bYaB");

});
parcelRegister("gF79V", function(module, exports) {

$parcel$export(module.exports, "CommentControls", function () { return (parcelRequire("PW76r")).CommentControls; });
$parcel$export(module.exports, "PostControls", function () { return (parcelRequire("1rOB9")).PostControls; });
$parcel$export(module.exports, "SubscriptionControls", function () { return (parcelRequire("jjj7B")).SubscriptionControls; });
$parcel$export(module.exports, "TipControls", function () { return (parcelRequire("913AC")).TipControls; });
$parcel$export(module.exports, "TrackControls", function () { return (parcelRequire("2aKGP")).TrackControls; });
$parcel$export(module.exports, "UnlockControls", function () { return (parcelRequire("9beEk")).UnlockControls; });

var $PW76r = parcelRequire("PW76r");

var $1rOB9 = parcelRequire("1rOB9");

var $jjj7B = parcelRequire("jjj7B");

var $913AC = parcelRequire("913AC");

var $2aKGP = parcelRequire("2aKGP");

var $9beEk = parcelRequire("9beEk");

});
parcelRegister("PW76r", function(module, exports) {

$parcel$export(module.exports, "CommentControls", function () { return $bde274f2165a8dad$export$5106dd4e859a791e; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $K9dw6 = parcelRequire("K9dw6");
parcelRequire("cJvLm");
var $e9SYA = parcelRequire("e9SYA");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("82IkN");
var $907Jv = parcelRequire("907Jv");
const $bde274f2165a8dad$export$5106dd4e859a791e = ({ commentId: commentId, parentCommentId: parentCommentId })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    // comment
    const { comment: comment, isLoading: isLoading } = (0, $K9dw6.useComment)(commentId);
    // parent comment
    const { comment: parentComment, isLoading: parentCommentLoading } = (0, $K9dw6.useComment)(parentCommentId);
    const isReply = !!parentCommentId;
    const isDisabled = isLoading || !comment;
    const isParentDisabled = isDisabled || parentCommentLoading || !parentComment;
    // if reply
    if (isReply) // return comment and reply controls
    return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                appearance: "neutral",
                label: "navigate to comment",
                icon: (0, $bq9l8.icons).Scope,
                text: "View comment",
                disabled: isParentDisabled,
                onClick: ()=>{
                    // add parent comment to comment depth
                    dispatch((0, $e9SYA.commentAddDepth)({
                        comment: parentComment
                    }));
                    // navigate to post page
                    navigate(`${(0, $b7fnN.Path).Post}/${parentComment?.postId}`);
                }
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                appearance: "neutral",
                label: "navigate to reply",
                icon: (0, $bq9l8.icons).Scope,
                text: "View reply",
                disabled: isDisabled,
                onClick: ()=>{
                    // add parent comment to comment depth
                    dispatch((0, $e9SYA.commentAddDepth)({
                        comment: parentComment
                    }));
                    // add reply comment to comment depth
                    dispatch((0, $e9SYA.commentAddDepth)({
                        comment: comment
                    }));
                    // navigate to post page
                    navigate(`${(0, $b7fnN.Path).Post}/${comment?.postId}`);
                }
            })
        ]
    });
    // return comment controls
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
        appearance: "neutral",
        label: "navigate to comment page",
        icon: (0, $bq9l8.icons).Scope,
        text: "View comment",
        disabled: isDisabled,
        onClick: ()=>{
            // add comment to comment depth
            dispatch((0, $e9SYA.commentAddDepth)({
                comment: comment
            }));
            // navigate to post page
            navigate(`${(0, $b7fnN.Path).Post}/${comment?.postId}`);
        }
    });
};
$bde274f2165a8dad$export$5106dd4e859a791e.propTypes = {};

});
parcelRegister("82IkN", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return (parcelRequire("907Jv")).Control; });
$parcel$export(module.exports, "TipMessage", function () { return (parcelRequire("9rsSS")).TipMessage; });

var $907Jv = parcelRequire("907Jv");

var $9rsSS = parcelRequire("9rsSS");

});
parcelRegister("907Jv", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return $108d3c3ddfde784d$export$7a7fa4424cb20976; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $7RexL = parcelRequire("7RexL");
const $108d3c3ddfde784d$export$7a7fa4424cb20976 = ({ appearance: appearance = "neutral", label: label, icon: Icon, text: text, disabled: disabled, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $7RexL.styles)(theme).control.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
            css: [
                (0, $7RexL.styles)(theme).control.content.main,
                appearance === "positive" && (0, $7RexL.styles)(theme).control.content.positive,
                appearance === "negative" && (0, $7RexL.styles)(theme).control.content.negative,
                appearance === "neutral" && (0, $7RexL.styles)(theme).control.content.neutral,
                disabled && (0, $7RexL.styles)(theme).control.content.disabled,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": label,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: [
                        (0, $7RexL.styles)(theme).control.content.icon.main,
                        appearance === "positive" && (0, $7RexL.styles)(theme).control.content.icon.positive,
                        appearance === "negative" && (0, $7RexL.styles)(theme).control.content.icon.negative,
                        appearance === "neutral" && (0, $7RexL.styles)(theme).control.content.icon.neutral,
                        disabled && (0, $7RexL.styles)(theme).control.content.icon.disabled,
                        "",
                        ""
                    ],
                    children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: [
                        (0, $7RexL.styles)(theme).control.content.text.main,
                        appearance === "positive" && (0, $7RexL.styles)(theme).control.content.text.positive,
                        appearance === "negative" && (0, $7RexL.styles)(theme).control.content.text.negative,
                        appearance === "neutral" && (0, $7RexL.styles)(theme).control.content.text.neutral,
                        disabled && (0, $7RexL.styles)(theme).control.content.text.disabled,
                        "",
                        ""
                    ],
                    children: text
                })
            ]
        })
    });
};
$108d3c3ddfde784d$export$7a7fa4424cb20976.propTypes = {};

});
parcelRegister("7RexL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3cec53ffd90b2a30$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $3cec53ffd90b2a30$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3cec53ffd90b2a30$var$_ref = {
    name: "a8rt8v",
    styles: "display:flex;margin-right:10px;&>svg{width:22px;height:22px;}&>svg>path{transition:fill 0.2s;}"
};
var $3cec53ffd90b2a30$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
const $3cec53ffd90b2a30$export$9dd6ff9ea0189349 = (theme)=>({
        control: {
            main: $3cec53ffd90b2a30$var$_ref2,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;cursor:pointer;min-width:130px;", ""),
                positive: /*#__PURE__*/ (0, $7hler.css)("&:hover{&>div>svg>path{fill:", theme.colors.positive.dark, ";}&>div{color:", theme.colors.positive.dark, ";}}", ""),
                negative: /*#__PURE__*/ (0, $7hler.css)("&:hover{&>div>svg>path{fill:", theme.colors.negative.dark, ";}&>div{color:", theme.colors.negative.dark, ";}}", ""),
                neutral: /*#__PURE__*/ (0, $7hler.css)("&:hover{&>div>svg>path{fill:", theme.colors.accent.normal, ";}&>div{color:", theme.colors.accent.normal, ";}}", ""),
                disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&:hover{&>div>svg>path{fill:", theme.colors.secondary.dark, ";}&>div{color:", theme.colors.secondary.dark, ";}}", ""),
                icon: {
                    main: $3cec53ffd90b2a30$var$_ref,
                    positive: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.positive.normal, ";}", ""),
                    negative: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.negative.normal, ";}", ""),
                    neutral: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    disabled: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.secondary.dark, ";}", "")
                },
                text: {
                    main: /*#__PURE__*/ (0, $7hler.css)("white-space:nowrap;font-size:", (0, $gln0L.typography).p, ";text-decoration:underline;transition:color 0.2s;", ""),
                    positive: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.positive.normal, ";", ""),
                    negative: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.negative.normal, ";", ""),
                    neutral: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";", ""),
                    disabled: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.dark, ";", "")
                }
            }
        }
    });

});


parcelRegister("9rsSS", function(module, exports) {

$parcel$export(module.exports, "TipMessage", function () { return $34f62da1ecbda55f$export$7b0b0f20c484716f; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $5CFz1 = parcelRequire("5CFz1");
const $34f62da1ecbda55f$export$7b0b0f20c484716f = ({ message: message })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("p", {
        css: (0, $5CFz1.styles)(theme).message.main,
        children: [
            '"',
            message,
            '"'
        ]
    });
};
$34f62da1ecbda55f$export$7b0b0f20c484716f.propTypes = {};

});
parcelRegister("5CFz1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $690cceda0a2ea820$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $690cceda0a2ea820$export$9dd6ff9ea0189349 = (theme)=>({
        message: {
            main: /*#__PURE__*/ (0, $7hler.css)("word-break:break-all;color:", theme.colors.secondary.normal, ";font-size:", (0, $gln0L.typography).h6, ";", "")
        }
    });

});




parcelRegister("1rOB9", function(module, exports) {

$parcel$export(module.exports, "PostControls", function () { return $4d545058efa0e710$export$8580fa483187194a; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $jMNnt = parcelRequire("jMNnt");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("82IkN");
var $907Jv = parcelRequire("907Jv");
const $4d545058efa0e710$export$8580fa483187194a = ({ postId: postId })=>{
    const navigate = (0, $99w1R.useNavigate)();
    // post
    const { post: post, isLoading: isLoading } = (0, $jMNnt.usePost)(postId);
    const isDisabled = isLoading || !post;
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
        appearance: "neutral",
        label: "navigate to post page",
        icon: (0, $bq9l8.icons).Scope,
        text: "View post",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`)
    });
};
$4d545058efa0e710$export$8580fa483187194a.propTypes = {};

});

parcelRegister("jjj7B", function(module, exports) {

$parcel$export(module.exports, "SubscriptionControls", function () { return $20930cbf9ba4905d$export$850f1baa8903d334; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("82IkN");
var $907Jv = parcelRequire("907Jv");
const $20930cbf9ba4905d$export$850f1baa8903d334 = ({ event: event, subscription: subscription, isDisabled: isDisabled })=>{
    const navigate = (0, $99w1R.useNavigate)();
    // if notification event is subscription created
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionCreated) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {});
    // if notification event is subscription payment failed
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentFailed) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
        appearance: "neutral",
        label: "navigate to target user page",
        icon: (0, $bq9l8.icons).UserCircle,
        text: "View user",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${subscription?.targetUserId}`)
    });
    // if notification event is subscription payment succeeded
    if (event === (0, $2gpGl.EntityNotificationEvent).AppSubscriptionPaymentSucceeded) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
        appearance: "neutral",
        label: "navigate to target user page",
        icon: (0, $bq9l8.icons).UserCircle,
        text: "View user",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${subscription?.targetUserId}`)
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {});
};
$20930cbf9ba4905d$export$850f1baa8903d334.propTypes = {};

});

parcelRegister("913AC", function(module, exports) {

$parcel$export(module.exports, "TipControls", function () { return $80bec0a69e68bd45$export$6a429fa6ff25b3d0; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $89C5W = parcelRequire("89C5W");
var $44jep = parcelRequire("44jep");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("82IkN");
var $907Jv = parcelRequire("907Jv");
var $9rsSS = parcelRequire("9rsSS");
const $80bec0a69e68bd45$export$6a429fa6ff25b3d0 = ({ event: event, tip: tip, isDisabled: isDisabled })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const notificationTipRetried = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationTipRetried));
    // if notification event is tip created
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipCreated) {
        // if tip message present
        if (tip?.message) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $9rsSS.TipMessage), {
            message: tip?.message
        });
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {});
    }
    // if notification event is tip payment failed
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentFailed) {
        const isTipRetryDisabled = isDisabled || tip?.status !== (0, $2gpGl.EntityTipStatus).Failed || notificationTipRetried;
        return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                    appearance: "neutral",
                    label: "navigate to target user page",
                    icon: (0, $bq9l8.icons).UserCircle,
                    text: "View user",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${tip?.targetUserId}`)
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                    appearance: "neutral",
                    label: "retry tip",
                    icon: (0, $bq9l8.icons).DollarCircle,
                    text: "Retry",
                    disabled: isTipRetryDisabled,
                    onClick: ()=>{
                        dispatch((0, $44jep.tipCreateTip)({
                            amount: (tip?.amount || 0) / 100,
                            message: tip?.message,
                            artistId: tip?.targetUserId || ""
                        }));
                    }
                })
            ]
        });
    }
    // if notification event is tip payment succeeded
    if (event === (0, $2gpGl.EntityNotificationEvent).AppTipPaymentSucceeded) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
        appearance: "neutral",
        label: "navigate to target user page",
        icon: (0, $bq9l8.icons).UserCircle,
        text: "View user",
        disabled: isDisabled,
        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${tip?.targetUserId}`)
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {});
};
$80bec0a69e68bd45$export$6a429fa6ff25b3d0.propTypes = {};

});

parcelRegister("2aKGP", function(module, exports) {

$parcel$export(module.exports, "TrackControls", function () { return $77bf568d47c233cd$export$3e7fab28a8882038; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $i9vCv = parcelRequire("i9vCv");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("82IkN");
var $907Jv = parcelRequire("907Jv");
const $77bf568d47c233cd$export$3e7fab28a8882038 = ({ trackId: trackId })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    // track
    const { track: track, isLoading: isLoading } = (0, $i9vCv.useTrack)(trackId);
    const isDisabled = isLoading || !track;
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
        appearance: "neutral",
        label: "play track",
        icon: (0, $bq9l8.icons).PlayCircleBold,
        text: "Play track",
        disabled: isDisabled,
        onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                track: track
            }))
    });
};
$77bf568d47c233cd$export$3e7fab28a8882038.propTypes = {};

});

parcelRegister("9beEk", function(module, exports) {

$parcel$export(module.exports, "UnlockControls", function () { return $fe6c282331864d8b$export$2f91fb6583916e4f; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $jMNnt = parcelRequire("jMNnt");
var $i9vCv = parcelRequire("i9vCv");
parcelRequire("cJvLm");
var $89C5W = parcelRequire("89C5W");
var $jAL4t = parcelRequire("jAL4t");
var $8aXib = parcelRequire("8aXib");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("82IkN");
var $907Jv = parcelRequire("907Jv");
const $fe6c282331864d8b$export$2f91fb6583916e4f = ({ event: event, unlock: unlock, isDisabled: isDisabled })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const notificationUnlockRetried = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationUnlockRetried));
    const isTrackUnlock = unlock?.entityType === (0, $2gpGl.EntityUnlockEntityType).Track;
    const isPostUnlock = unlock?.entityType === (0, $2gpGl.EntityUnlockEntityType).Post;
    // unlock track
    const { track: track, isLoading: isTrackLoading } = (0, $i9vCv.useTrack)(isTrackUnlock ? unlock.entityId || "" : "");
    const isTrackControlDisabled = isTrackLoading || !track;
    // unlock post
    const { post: post, isLoading: isPostLoading } = (0, $jMNnt.usePost)(isPostUnlock ? unlock.entityId || "" : "");
    const isPostControlDisabled = isPostLoading || !post;
    // if unlock type is track
    if (unlock?.entityType === (0, $2gpGl.EntityUnlockEntityType).Track) {
        // if notification event is track unlock created
        if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockCreated) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
            appearance: "neutral",
            label: "play track",
            icon: (0, $bq9l8.icons).PlayCircleBold,
            text: "Play track",
            disabled: isTrackControlDisabled,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                }))
        });
        // if notification event is track unlock payment failed
        if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentFailed) {
            const isUnlockRetryDisabled = isDisabled || isTrackControlDisabled || unlock?.status !== (0, $2gpGl.EntityUnlockStatus).Failed || notificationUnlockRetried;
            return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                        appearance: "neutral",
                        label: "navigate to target user page",
                        icon: (0, $bq9l8.icons).UserCircle,
                        text: "View user",
                        disabled: isDisabled,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${unlock?.targetUserId}`)
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                        appearance: "neutral",
                        label: "retry track unlock",
                        icon: (0, $bq9l8.icons).DollarCircle,
                        text: "Retry",
                        disabled: isUnlockRetryDisabled,
                        onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                                track: track
                            }))
                    })
                ]
            });
        }
        // if notification event is track unlock payment succeeded
        if (event === (0, $2gpGl.EntityNotificationEvent).AppTrackUnlockPaymentSucceeded) return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                    appearance: "neutral",
                    label: "navigate to target user page",
                    icon: (0, $bq9l8.icons).UserCircle,
                    text: "View user",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${unlock?.targetUserId}`)
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                    appearance: "neutral",
                    label: "play track",
                    icon: (0, $bq9l8.icons).PlayCircleBold,
                    text: "Play track",
                    disabled: isTrackControlDisabled,
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                            track: track
                        }))
                })
            ]
        });
    }
    // if post unlock
    if (unlock?.entityType === (0, $2gpGl.EntityUnlockEntityType).Post) {
        // if notification event is post unlock created
        if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockCreated) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
            appearance: "neutral",
            label: "navigate to post page",
            icon: (0, $bq9l8.icons).Scope,
            text: "View post",
            disabled: isDisabled,
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${unlock?.entityId}`)
        });
        // if notification event is post unlock payment failed
        if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentFailed) {
            const isUnlockRetryDisabled = isDisabled || isPostControlDisabled || unlock?.status !== (0, $2gpGl.EntityUnlockStatus).Failed || notificationUnlockRetried;
            return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                        appearance: "neutral",
                        label: "navigate to target user page",
                        icon: (0, $bq9l8.icons).UserCircle,
                        text: "View user",
                        disabled: isDisabled,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${unlock?.targetUserId}`)
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                        appearance: "neutral",
                        label: "retry post unlock",
                        icon: (0, $bq9l8.icons).DollarCircle,
                        text: "Retry",
                        disabled: isUnlockRetryDisabled,
                        onClick: ()=>{
                            dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                                post: post
                            }));
                        }
                    })
                ]
            });
        }
        // if notification event is post unlock payment succeeded
        if (event === (0, $2gpGl.EntityNotificationEvent).AppPostUnlockPaymentSucceeded) return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                    appearance: "neutral",
                    label: "navigate to target user page",
                    icon: (0, $bq9l8.icons).UserCircle,
                    text: "View user",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${unlock?.targetUserId}`)
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $907Jv.Control), {
                    appearance: "neutral",
                    label: "navigate to post page",
                    icon: (0, $bq9l8.icons).Scope,
                    text: "View post",
                    disabled: isDisabled,
                    onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${unlock?.entityId}`)
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {});
};
$fe6c282331864d8b$export$2f91fb6583916e4f.propTypes = {};

});


parcelRegister("1bYaB", function(module, exports) {

$parcel$export(module.exports, "SourceUser", function () { return $eb001d9c647cc938$export$fffa57a226281f84; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $k0mES = parcelRequire("k0mES");
const $eb001d9c647cc938$export$fffa57a226281f84 = ({ label: label, username: username, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
        css: (0, $k0mES.styles)(theme).source.main,
        onClick: (e)=>onClick(e),
        type: "button",
        "aria-label": label,
        children: [
            "@",
            username
        ]
    });
};
$eb001d9c647cc938$export$fffa57a226281f84.propTypes = {};

});
parcelRegister("k0mES", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $692e8c42be542ff9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $692e8c42be542ff9$export$9dd6ff9ea0189349 = (theme)=>({
        source: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;word-break:break-all;color:", theme.colors.secondary.normal, ";font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
        }
    });

});



parcelRegister("5XCLp", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $57fefdc11322c7a5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $57fefdc11322c7a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $57fefdc11322c7a5$var$_ref = {
    name: "1ufrsmv",
    styles: "display:flex;flex-wrap:wrap;min-height:22px;&>div:not(:last-of-type){margin-right:16px;}"
};
var $57fefdc11322c7a5$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $57fefdc11322c7a5$var$_ref3 = {
    name: "1pbcbhk",
    styles: "max-width:800px;min-height:80px"
};
const $57fefdc11322c7a5$export$9dd6ff9ea0189349 = ()=>({
        view: {
            main: $57fefdc11322c7a5$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("&:not(:last-of-type){margin-bottom:10px;}", (0, $gln0L.mq).tablet($57fefdc11322c7a5$var$_ref2), ";", ""),
                identifier: /*#__PURE__*/ (0, $7hler.css)("margin-bottom:16px;font-size:", (0, $gln0L.typography).h6, ";", ""),
                navigation: $57fefdc11322c7a5$var$_ref
            }
        }
    });

});



parcelRegister("89C5W", function(module, exports) {

$parcel$export(module.exports, "notificationSlice", function () { return $0fa9a1b08adc480b$export$572e8dc57d3bd5f2; });
$parcel$export(module.exports, "notificationResetState", function () { return $0fa9a1b08adc480b$export$1f6a9f51115409e6; });
$parcel$export(module.exports, "notificationSetNotifications", function () { return $0fa9a1b08adc480b$export$14e5b8d882d13664; });
$parcel$export(module.exports, "notificationResetNotifications", function () { return $0fa9a1b08adc480b$export$53de810204552d28; });
$parcel$export(module.exports, "notificationSetNotificationsUnreadCount", function () { return $0fa9a1b08adc480b$export$a66b58f06a9e5432; });
$parcel$export(module.exports, "notificationSetNotification", function () { return $0fa9a1b08adc480b$export$5b89393bb7418c25; });
$parcel$export(module.exports, "notificationSetNotificationTipRetried", function () { return $0fa9a1b08adc480b$export$582446818c78df42; });
$parcel$export(module.exports, "notificationSetNotificationUnlockRetried", function () { return $0fa9a1b08adc480b$export$2c939389ab046c9; });
$parcel$export(module.exports, "notificationResetNotification", function () { return $0fa9a1b08adc480b$export$8981b508292c55ed; });
$parcel$export(module.exports, "notificationSetNotificationConfig", function () { return $0fa9a1b08adc480b$export$5bc685f8ce3e7467; });
$parcel$export(module.exports, "notificationSetNotificationsFilter", function () { return $0fa9a1b08adc480b$export$497199f322817fab; });
$parcel$export(module.exports, "notificationSelectNotifications", function () { return $0fa9a1b08adc480b$export$aadcc86a5d49f95c; });
$parcel$export(module.exports, "notificationSelectNotificationsLength", function () { return $0fa9a1b08adc480b$export$bac113b2128234e1; });
$parcel$export(module.exports, "notificationSelectNotificationsCount", function () { return $0fa9a1b08adc480b$export$21a43f80b2d9ea6f; });
$parcel$export(module.exports, "notificationSelectNotificationsFetched", function () { return $0fa9a1b08adc480b$export$3892c4159a4a8532; });
$parcel$export(module.exports, "notificationSelectNotificationsUnreadCount", function () { return $0fa9a1b08adc480b$export$ea4ea155cf365968; });
$parcel$export(module.exports, "notificationSelectNotification", function () { return $0fa9a1b08adc480b$export$3904e7f0a18f08e1; });
$parcel$export(module.exports, "notificationSelectNotificationFetched", function () { return $0fa9a1b08adc480b$export$4b12dc030489735d; });
$parcel$export(module.exports, "notificationSelectNotificationTipRetried", function () { return $0fa9a1b08adc480b$export$6d40f962e1e8580a; });
$parcel$export(module.exports, "notificationSelectNotificationUnlockRetried", function () { return $0fa9a1b08adc480b$export$654cd803729c5d0f; });
$parcel$export(module.exports, "notificationSelectNotificationConfig", function () { return $0fa9a1b08adc480b$export$2b747478b432f84b; });
$parcel$export(module.exports, "notificationSelectNotificationConfigFetched", function () { return $0fa9a1b08adc480b$export$947e5de144145b21; });
$parcel$export(module.exports, "notificationSelectNotificationsFilter", function () { return $0fa9a1b08adc480b$export$96b9b2fc6d95cee4; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationsLoading", function () { return $0fa9a1b08adc480b$export$104a48df097aa8d2; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationsUnreadCountLoading", function () { return $0fa9a1b08adc480b$export$2bbc3810a61d96d7; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationLoading", function () { return $0fa9a1b08adc480b$export$f73a84e5b85dacd3; });
$parcel$export(module.exports, "notificationSelectNotificationGetNotificationConfigLoading", function () { return $0fa9a1b08adc480b$export$1f984d75920c93b7; });
$parcel$export(module.exports, "notificationSelectNotificationUpdateNotificationConfigLoading", function () { return $0fa9a1b08adc480b$export$a6f86ccd3f47ba2d; });
$parcel$export(module.exports, "notificationSelectNotificationReadNotificationsLoading", function () { return $0fa9a1b08adc480b$export$e4a345ae4781fb54; });
$parcel$export(module.exports, "notificationReducer", function () { return $0fa9a1b08adc480b$export$1e8c7d75bf62e791; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $day58 = parcelRequire("day58");
const $0fa9a1b08adc480b$var$initialState = {
    notifications: [],
    notificationsCount: 0,
    notificationsFetched: false,
    notificationsUnreadCount: 0,
    notification: undefined,
    notificationFetched: false,
    notificationTipRetried: false,
    notificationUnlockRetried: false,
    notificationConfig: undefined,
    notificationConfigFetched: false,
    notificationsFilter: undefined,
    notificationGetNotificationsLoading: false,
    notificationGetNotificationsUnreadCountLoading: false,
    notificationGetNotificationLoading: false,
    notificationGetNotificationConfigLoading: false,
    notificationUpdateNotificationConfigLoading: false,
    notificationReadNotificationsLoading: false
};
const $0fa9a1b08adc480b$export$572e8dc57d3bd5f2 = (0, $kvj5V.createSlice)({
    name: "notification",
    initialState: $0fa9a1b08adc480b$var$initialState,
    reducers: {
        // reset state
        notificationResetState: ()=>({
                notifications: [],
                notificationsCount: 0,
                notificationsFetched: false,
                notificationsUnreadCount: 0,
                notification: undefined,
                notificationFetched: false,
                notificationTipRetried: false,
                notificationUnlockRetried: false,
                notificationConfig: undefined,
                notificationConfigFetched: false,
                notificationsFilter: undefined,
                notificationGetNotificationsLoading: false,
                notificationGetNotificationsUnreadCountLoading: false,
                notificationGetNotificationLoading: false,
                notificationGetNotificationConfigLoading: false,
                notificationUpdateNotificationConfigLoading: false,
                notificationReadNotificationsLoading: false
            }),
        // set notifications
        notificationSetNotifications: (state, action)=>{
            const { notifications: notifications, count: count, offset: offset } = action.payload;
            // mutate count
            state.notificationsCount = count;
            // mutate notifications array
            state.notifications = (0, $6Rkyy.mergeArraysAtIndex)(state.notifications, notifications, offset);
        },
        // reset notifications
        notificationResetNotifications: (state)=>({
                ...state,
                notifications: [],
                notificationsCount: 0,
                notificationsFetched: false
            }),
        // set notifications unread count
        notificationSetNotificationsUnreadCount: (state, action)=>{
            const { count: count } = action.payload;
            // update notifications unread count state
            state.notificationsUnreadCount = count;
        },
        // set notification
        notificationSetNotification: (state, action)=>{
            const { notification: notification } = action.payload;
            // update notification state
            state.notification = notification;
        },
        // set notification tip retried
        notificationSetNotificationTipRetried: (state)=>({
                ...state,
                notificationTipRetried: true
            }),
        // set notification unlock retried
        notificationSetNotificationUnlockRetried: (state)=>({
                ...state,
                notificationUnlockRetried: true
            }),
        // reset notification
        notificationResetNotification: (state)=>({
                ...state,
                notification: undefined,
                notificationFetched: false,
                notificationTipRetried: false,
                notificationUnlockRetried: false
            }),
        // set notification config
        notificationSetNotificationConfig: (state, action)=>{
            const { notificationConfig: notificationConfig } = action.payload;
            // update notification config state
            state.notificationConfig = notificationConfig;
        },
        // set notifications filter
        notificationSetNotificationsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup notifications
            state.notifications = [];
            state.notificationsCount = 0;
            // mutate notifications filter
            state.notificationsFilter = state.notificationsFilter === filter ? undefined : filter;
        }
    },
    extraReducers: (builder)=>{
        // get notifications
        builder.addCase((0, $day58.notificationGetNotifications).pending, (state)=>({
                ...state,
                notificationGetNotificationsLoading: true
            })).addCase((0, $day58.notificationGetNotifications).fulfilled, (state)=>({
                ...state,
                notificationsFetched: true,
                notificationGetNotificationsLoading: false
            }));
        // get notifications unread count
        builder.addCase((0, $day58.notificationGetNotificationsUnreadCount).pending, (state)=>({
                ...state,
                notificationGetNotificationsUnreadCountLoading: true
            })).addCase((0, $day58.notificationGetNotificationsUnreadCount).fulfilled, (state)=>({
                ...state,
                notificationGetNotificationsUnreadCountLoading: false
            }));
        // get notification
        builder.addCase((0, $day58.notificationGetNotification).pending, (state)=>({
                ...state,
                notificationGetNotificationLoading: true
            })).addCase((0, $day58.notificationGetNotification).fulfilled, (state)=>({
                ...state,
                notificationFetched: true,
                notificationGetNotificationLoading: false
            }));
        // get notifications config
        builder.addCase((0, $day58.notificationGetNotificationConfig).pending, (state)=>({
                ...state,
                notificationGetNotificationConfigLoading: true
            })).addCase((0, $day58.notificationGetNotificationConfig).fulfilled, (state)=>({
                ...state,
                notificationGetNotificationConfigLoading: false
            }));
        // update notifications config
        builder.addCase((0, $day58.notificationUpdateNotificationConfig).pending, (state)=>({
                ...state,
                notificationUpdateNotificationConfigLoading: true
            })).addCase((0, $day58.notificationUpdateNotificationConfig).fulfilled, (state)=>({
                ...state,
                notificationUpdateNotificationConfigLoading: false
            }));
        // read notifications
        builder.addCase((0, $day58.notificationReadNotifications).pending, (state)=>({
                ...state,
                notificationReadNotificationsLoading: true
            })).addCase((0, $day58.notificationReadNotifications).fulfilled, (state)=>({
                ...state,
                notificationReadNotificationsLoading: false
            }));
    }
});
const { notificationResetState: $0fa9a1b08adc480b$export$1f6a9f51115409e6, notificationSetNotifications: $0fa9a1b08adc480b$export$14e5b8d882d13664, notificationResetNotifications: $0fa9a1b08adc480b$export$53de810204552d28, notificationSetNotificationsUnreadCount: $0fa9a1b08adc480b$export$a66b58f06a9e5432, notificationSetNotification: $0fa9a1b08adc480b$export$5b89393bb7418c25, notificationSetNotificationTipRetried: $0fa9a1b08adc480b$export$582446818c78df42, notificationSetNotificationUnlockRetried: $0fa9a1b08adc480b$export$2c939389ab046c9, notificationResetNotification: $0fa9a1b08adc480b$export$8981b508292c55ed, notificationSetNotificationConfig: $0fa9a1b08adc480b$export$5bc685f8ce3e7467, notificationSetNotificationsFilter: $0fa9a1b08adc480b$export$497199f322817fab } = $0fa9a1b08adc480b$export$572e8dc57d3bd5f2.actions;
const $0fa9a1b08adc480b$export$aadcc86a5d49f95c = (state)=>state.notification.notifications;
const $0fa9a1b08adc480b$export$bac113b2128234e1 = (state)=>state.notification.notifications.length;
const $0fa9a1b08adc480b$export$21a43f80b2d9ea6f = (state)=>state.notification.notificationsCount;
const $0fa9a1b08adc480b$export$3892c4159a4a8532 = (state)=>state.notification.notificationsFetched;
const $0fa9a1b08adc480b$export$ea4ea155cf365968 = (state)=>state.notification.notificationsUnreadCount;
const $0fa9a1b08adc480b$export$3904e7f0a18f08e1 = (state)=>state.notification.notification;
const $0fa9a1b08adc480b$export$4b12dc030489735d = (state)=>state.notification.notificationFetched;
const $0fa9a1b08adc480b$export$6d40f962e1e8580a = (state)=>state.notification.notificationTipRetried;
const $0fa9a1b08adc480b$export$654cd803729c5d0f = (state)=>state.notification.notificationUnlockRetried;
const $0fa9a1b08adc480b$export$2b747478b432f84b = (state)=>state.notification.notificationConfig;
const $0fa9a1b08adc480b$export$947e5de144145b21 = (state)=>state.notification.notificationConfigFetched;
const $0fa9a1b08adc480b$export$96b9b2fc6d95cee4 = (state)=>state.notification.notificationsFilter;
const $0fa9a1b08adc480b$export$104a48df097aa8d2 = (state)=>state.notification.notificationGetNotificationsLoading;
const $0fa9a1b08adc480b$export$2bbc3810a61d96d7 = (state)=>state.notification.notificationGetNotificationsUnreadCountLoading;
const $0fa9a1b08adc480b$export$f73a84e5b85dacd3 = (state)=>state.notification.notificationGetNotificationLoading;
const $0fa9a1b08adc480b$export$1f984d75920c93b7 = (state)=>state.notification.notificationGetNotificationConfigLoading;
const $0fa9a1b08adc480b$export$a6f86ccd3f47ba2d = (state)=>state.notification.notificationUpdateNotificationConfigLoading;
const $0fa9a1b08adc480b$export$e4a345ae4781fb54 = (state)=>state.notification.notificationReadNotificationsLoading;
const $0fa9a1b08adc480b$export$1e8c7d75bf62e791 = $0fa9a1b08adc480b$export$572e8dc57d3bd5f2.reducer; // export default notificationSlice.reducer

});

parcelRegister("day58", function(module, exports) {

$parcel$export(module.exports, "notificationGetNotifications", function () { return $092574b7f8287338$export$2198b65d0697d0b9; });
$parcel$export(module.exports, "notificationGetNotificationsUnreadCount", function () { return $092574b7f8287338$export$9f63eafc05b4f789; });
$parcel$export(module.exports, "notificationGetNotification", function () { return $092574b7f8287338$export$a2ff9aa993fbdd42; });
$parcel$export(module.exports, "notificationGetNotificationConfig", function () { return $092574b7f8287338$export$fe8949cf20419680; });
$parcel$export(module.exports, "notificationUpdateNotificationConfig", function () { return $092574b7f8287338$export$cb7731663c4ace95; });
$parcel$export(module.exports, "notificationReadNotification", function () { return $092574b7f8287338$export$b23ffc7af13cdd30; });
$parcel$export(module.exports, "notificationReadNotifications", function () { return $092574b7f8287338$export$7b28611e0695d6eb; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("cJvLm");
var $89C5W = parcelRequire("89C5W");
const $092574b7f8287338$export$2198b65d0697d0b9 = (0, $kvj5V.createAsyncThunk)("notification/notificationGetNotifications", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get notifications filter
    const filter = getState().notification.notificationsFilter;
    // define entity type
    let entityType;
    // assert entity type
    switch(filter){
        case (0, $2gpGl.EntityNotificationEntityType).User:
            entityType = "user";
            break;
        case (0, $2gpGl.EntityNotificationEntityType).Track:
            entityType = "track";
            break;
        case (0, $2gpGl.EntityNotificationEntityType).Post:
            entityType = "post";
            break;
        case (0, $2gpGl.EntityNotificationEntityType).Comment:
            entityType = "comment";
            break;
        case (0, $2gpGl.EntityNotificationEntityType).Tip:
            entityType = "tip";
            break;
        case (0, $2gpGl.EntityNotificationEntityType).Unlock:
            entityType = "unlock";
            break;
        case (0, $2gpGl.EntityNotificationEntityType).Subscription:
            entityType = "subscription";
            break;
        default:
            entityType = undefined;
    }
    try {
        // retrieve notifications
        const { notifications: notifications, count: count } = await api.notificationApi.getAppNotifications(entityType, inp.limit, inp.offset);
        // set notifications
        dispatch((0, $89C5W.notificationSetNotifications)({
            notifications: notifications || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $092574b7f8287338$export$9f63eafc05b4f789 = (0, $kvj5V.createAsyncThunk)("notification/notificationGetNotificationsUnreadCount", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve notifications unread count
        const { count: count } = await api.notificationApi.getAppNotificationsUnreadCount();
        // set notifications unread count
        dispatch((0, $89C5W.notificationSetNotificationsUnreadCount)({
            count: count || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $092574b7f8287338$export$a2ff9aa993fbdd42 = (0, $kvj5V.createAsyncThunk)("notification/notificationGetNotification", async ({ notificationId: notificationId }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve notification
        const { notification: notification } = await api.notificationApi.getAppNotification(notificationId);
        // set notification
        dispatch((0, $89C5W.notificationSetNotification)({
            notification: notification || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $092574b7f8287338$export$fe8949cf20419680 = (0, $kvj5V.createAsyncThunk)("notification/notificationGetNotificationConfig", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get notification config
        const { notificationConfig: notificationConfig } = await api.notificationApi.getNotificationConfig();
        // set notification config
        dispatch((0, $89C5W.notificationSetNotificationConfig)({
            notificationConfig: notificationConfig || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $092574b7f8287338$export$cb7731663c4ace95 = (0, $kvj5V.createAsyncThunk)("notification/notificationUpdateNotificationConfig", async ({ scope: scope }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // update notifications configuration
        const { notificationConfig: notificationConfig } = await api.notificationApi.updateNotificationConfig({
            scope: scope
        });
        // set notification config
        dispatch((0, $89C5W.notificationSetNotificationConfig)({
            notificationConfig: notificationConfig || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $092574b7f8287338$export$b23ffc7af13cdd30 = (0, $kvj5V.createAsyncThunk)("notification/notificationReadNotification", async ({ notificationId: notificationId })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve notification
        await api.notificationApi.readAppNotification({
            notificationId: notificationId
        });
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $092574b7f8287338$export$7b28611e0695d6eb = (0, $kvj5V.createAsyncThunk)("notification/notificationReadNotifications", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve notification
        await api.notificationApi.readAppNotifications();
        // update notifications unread count
        dispatch($092574b7f8287338$export$9f63eafc05b4f789());
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("bhkER", function(module, exports) {

$parcel$export(module.exports, "Onboarding", function () { return (parcelRequire("bTbtR")).Onboarding; });
parcelRequire("ghoUv");
var $bTbtR = parcelRequire("bTbtR");

var $3EkqN = parcelRequire("3EkqN");

var $7676a = parcelRequire("7676a");
$parcel$exportWildcard(module.exports, $3EkqN);
$parcel$exportWildcard(module.exports, $7676a);

});
parcelRegister("ghoUv", function(module, exports) {

$parcel$export(module.exports, "Onboarding", function () { return (parcelRequire("bTbtR")).Onboarding; });

var $bTbtR = parcelRequire("bTbtR");

});
parcelRegister("bTbtR", function(module, exports) {

$parcel$export(module.exports, "Onboarding", function () { return $b5108a0df9b8cdab$export$70238cd3868b67c9; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $hn85R = parcelRequire("hn85R");
var $9HBOX = parcelRequire("9HBOX");
var $3EkqN = parcelRequire("3EkqN");
parcelRequire("1TdPt");
var $2uUr9 = parcelRequire("2uUr9");
var $bl2nZ = parcelRequire("bl2nZ");
parcelRequire("4oMJ8");
var $6W3ju = parcelRequire("6W3ju");
var $2aMiv = parcelRequire("2aMiv");
var $iqvYO = parcelRequire("iqvYO");
var $2b1ki = parcelRequire("2b1ki");
var $4GJ4g = parcelRequire("4GJ4g");
var $clVvs = parcelRequire("clVvs");
var $VDfei = parcelRequire("VDfei");
var $iToJs = parcelRequire("iToJs");

var $bbijD = parcelRequire("bbijD");

var $14bds = parcelRequire("14bds");
const $b5108a0df9b8cdab$export$70238cd3868b67c9 = ()=>{
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const step = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectStep));
    const isProfileRoleSelected = !!profile?.role;
    const profileRole = profile?.role || "";
    const profileOnboardingStage = profile?.onboardingStage || "";
    const getCurrentStage = ()=>{
        const fanOnboardingStages = {
            [(0, $2gpGl.EntityOnboardingStage).CreateProfile]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iqvYO.CreateProfile), {}),
            [(0, $2gpGl.EntityOnboardingStage).SelectGenres]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $clVvs.SelectGenres), {}),
            [(0, $2gpGl.EntityOnboardingStage).FollowArtists]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4GJ4g.FollowArtists), {}),
            [(0, $2gpGl.EntityOnboardingStage).ConfigureNotifications]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2aMiv.ConfigureNotifications), {}),
            [(0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6W3ju.AcceptTermsAndConditions), {})
        };
        const artistOnboardingStages = {
            [(0, $2gpGl.EntityOnboardingStage).CreateProfile]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iqvYO.CreateProfile), {}),
            [(0, $2gpGl.EntityOnboardingStage).UploadTracks]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iToJs.UploadTracks), {}),
            [(0, $2gpGl.EntityOnboardingStage).EnableMonetization]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2b1ki.EnableMonetization), {}),
            [(0, $2gpGl.EntityOnboardingStage).ConfigureNotifications]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2aMiv.ConfigureNotifications), {}),
            [(0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions]: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6W3ju.AcceptTermsAndConditions), {})
        };
        // if role is fan
        if (profileRole && profileRole === (0, $2gpGl.EntityUserRole).Fan && profileOnboardingStage) // return appropriate stage for fan
        return fanOnboardingStages[profileOnboardingStage];
        // if role is artist
        if (profileRole && profileRole === (0, $2gpGl.EntityUserRole).Artist && profileOnboardingStage) // return appropriate stage for artist
        return artistOnboardingStages[profileOnboardingStage];
        return null;
    };
    const renderOnboarding = ()=>{
        // get current onboarding stage
        const currentStage = getCurrentStage();
        // if role is not selected
        if (!isProfileRoleSelected) // return select role stage
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $14bds.styles)().onboarding.role,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $VDfei.SelectRole), {})
        });
        // if role is selected and role is 'fan'
        if (isProfileRoleSelected && profileRole === (0, $2gpGl.EntityUserRole).Fan && currentStage !== null) // return fan stage
        return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $14bds.styles)().onboarding.stage,
            children: [
                currentStage,
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $bl2nZ.Stepper), {
                    steps: (0, $bbijD.fanOnboardingSteps),
                    currentStep: step
                })
            ]
        });
        // if role is selected and role is 'artist'
        if (isProfileRoleSelected && profileRole === (0, $2gpGl.EntityUserRole).Artist && currentStage !== null) // return artist stage
        return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $14bds.styles)().onboarding.stage,
            children: [
                currentStage,
                /*#__PURE__*/ (0, $9awXB.jsx)((0, $bl2nZ.Stepper), {
                    steps: (0, $bbijD.artistOnboardingSteps),
                    currentStep: step
                })
            ]
        });
        return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2uUr9.ErrorFallback), {});
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $14bds.styles)().onboarding.main,
        children: [
            renderOnboarding(),
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $hn85R.AlertModal), {})
        ]
    });
};
$b5108a0df9b8cdab$export$70238cd3868b67c9.propTypes = {};

});
parcelRegister("4oMJ8", function(module, exports) {

$parcel$export(module.exports, "AcceptTermsAndConditions", function () { return (parcelRequire("6W3ju")).AcceptTermsAndConditions; });
$parcel$export(module.exports, "ConfigureNotifications", function () { return (parcelRequire("2aMiv")).ConfigureNotifications; });
$parcel$export(module.exports, "CreateProfile", function () { return (parcelRequire("iqvYO")).CreateProfile; });
$parcel$export(module.exports, "EnableMonetization", function () { return (parcelRequire("2b1ki")).EnableMonetization; });
$parcel$export(module.exports, "FollowArtists", function () { return (parcelRequire("4GJ4g")).FollowArtists; });
$parcel$export(module.exports, "SelectGenres", function () { return (parcelRequire("clVvs")).SelectGenres; });
$parcel$export(module.exports, "SelectRole", function () { return (parcelRequire("VDfei")).SelectRole; });
$parcel$export(module.exports, "UploadTracks", function () { return (parcelRequire("iToJs")).UploadTracks; });

var $6W3ju = parcelRequire("6W3ju");

var $2aMiv = parcelRequire("2aMiv");

var $iqvYO = parcelRequire("iqvYO");

var $2b1ki = parcelRequire("2b1ki");

var $4GJ4g = parcelRequire("4GJ4g");

var $clVvs = parcelRequire("clVvs");

var $VDfei = parcelRequire("VDfei");

var $iToJs = parcelRequire("iToJs");

});
parcelRegister("6W3ju", function(module, exports) {

$parcel$export(module.exports, "AcceptTermsAndConditions", function () { return $220e20ef92c1459a$export$54b64605ce78aed1; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("krTeD");
var $dkzpd = parcelRequire("dkzpd");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");
var $ly71s = parcelRequire("ly71s");
var $fTvbo = parcelRequire("fTvbo");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("3hbJ6");
var $3qlnE = parcelRequire("3qlnE");

var $fPQQK = parcelRequire("fPQQK");
const $220e20ef92c1459a$export$54b64605ce78aed1 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingError = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $fPQQK.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fPQQK.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $7676a.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {
                        css: (0, $fPQQK.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $fPQQK.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $fPQQK.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2oiNd.Subtitle), {
                            text: "By continuing you agree to RYDDM terms and conditions",
                            link: {
                                linkStart: 33,
                                linkEnd: 53,
                                href: (0, $dkzpd.ExternalLinks).TermsOfUse
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $fPQQK.styles)().stage.content.composition,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTvbo.ImageComposition), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $fPQQK.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $3qlnE.Form), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $fPQQK.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$220e20ef92c1459a$export$54b64605ce78aed1.propTypes = {};

});
parcelRegister("3hbJ6", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("3qlnE")).Form; });

var $3qlnE = parcelRequire("3qlnE");

});
parcelRegister("3qlnE", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $66affa5d86febcee$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $cX7Gq = parcelRequire("cX7Gq");
const $66affa5d86febcee$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    const submitDisabled = onboardingLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $cX7Gq.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("form", {
            css: (0, $cX7Gq.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $7676a.onboardingSetNextStage)());
            },
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cX7Gq.styles)().form.content.submit,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                    type: "submit",
                    "aria-label": "accept terms of use",
                    disabled: submitDisabled,
                    appearance: "primary",
                    children: onboardingLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                        width: 50,
                        height: 20,
                        appearance: "primary"
                    }) : "Continue"
                })
            })
        })
    });
};
$66affa5d86febcee$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("cX7Gq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2a122c7406814201$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2a122c7406814201$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2a122c7406814201$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2a122c7406814201$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2a122c7406814201$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2a122c7406814201$var$_ref4 = {
    name: "1u8bg7q",
    styles: "width:380px"
};
var $2a122c7406814201$var$_ref5 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $2a122c7406814201$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $2a122c7406814201$var$_ref5,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:510px;", (0, $gln0L.mq).tablet($2a122c7406814201$var$_ref4), " ", (0, $gln0L.mq).mobile($2a122c7406814201$var$_ref3), ";", ""),
                submit: /*#__PURE__*/ (0, $7hler.css)("align-self:center;", (0, $gln0L.mq).mobile($2a122c7406814201$var$_ref2), " &>button{width:380px;", (0, $gln0L.mq).mobile($2a122c7406814201$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("fPQQK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bf73f4f8c7a1901f$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $bf73f4f8c7a1901f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bf73f4f8c7a1901f$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $bf73f4f8c7a1901f$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $bf73f4f8c7a1901f$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $bf73f4f8c7a1901f$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $bf73f4f8c7a1901f$var$_ref5 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $bf73f4f8c7a1901f$var$_ref6 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $bf73f4f8c7a1901f$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $bf73f4f8c7a1901f$var$_ref6,
            backward: {
                button: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $bf73f4f8c7a1901f$var$_ref5
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:760px;", (0, $gln0L.mq).mobile($bf73f4f8c7a1901f$var$_ref4), ";", ""),
                title: $bf73f4f8c7a1901f$var$_ref3,
                composition: $bf73f4f8c7a1901f$var$_ref2,
                form: $bf73f4f8c7a1901f$var$_ref,
                error: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("2aMiv", function(module, exports) {

$parcel$export(module.exports, "ConfigureNotifications", function () { return $cd4b2f3e8c1c3cf5$export$491071bcdb2df82c; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");
var $ly71s = parcelRequire("ly71s");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("1fEGO");
var $kDYhJ = parcelRequire("kDYhJ");

var $kSXLq = parcelRequire("kSXLq");
const $cd4b2f3e8c1c3cf5$export$491071bcdb2df82c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingError = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kSXLq.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kSXLq.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    onClick: ()=>dispatch((0, $7676a.onboardingSetPrevStage)()),
                    appearance: "secondary",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {
                        css: (0, $kSXLq.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $kSXLq.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $kSXLq.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2oiNd.Subtitle), {
                            text: "Customize notifications settings to match your preferences!"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $kSXLq.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kDYhJ.Form), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $kSXLq.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$cd4b2f3e8c1c3cf5$export$491071bcdb2df82c.propTypes = {};

});
parcelRegister("1fEGO", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("kDYhJ")).Form; });

var $kDYhJ = parcelRequire("kDYhJ");

});
parcelRegister("kDYhJ", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $0a5870bcc50dbae5$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $day58 = parcelRequire("day58");
var $89C5W = parcelRequire("89C5W");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $eJNPy = parcelRequire("eJNPy");
var $f6nZ0 = parcelRequire("f6nZ0");

var $8wQ2C = parcelRequire("8wQ2C");
const $0a5870bcc50dbae5$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    const notificationConfig = (0, $gNvvs.useAppSelector)((0, $89C5W.notificationSelectNotificationConfig));
    const initialScope = notificationConfig?.scope;
    const [notificationConfigScope, setNotificationConfigScope] = (0, $bh6RR.useState)((0, $2gpGl.EntityNotificationConfigScope).Enabled);
    (0, $bh6RR.useEffect)(()=>{
        // get notifications config
        dispatch((0, $day58.notificationGetNotificationConfig)());
        // update local state with initial scope
        if (initialScope) setNotificationConfigScope(initialScope);
    }, [
        dispatch,
        initialScope
    ]);
    const submitDisabled = onboardingLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $8wQ2C.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $8wQ2C.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $7676a.onboardingSetNextStage)());
                dispatch((0, $day58.notificationUpdateNotificationConfig)({
                    scope: notificationConfigScope
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8wQ2C.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $eJNPy.Checkbox), {
                            name: "notifications-enabled",
                            label: "enable all notifications",
                            checked: notificationConfigScope === (0, $2gpGl.EntityNotificationConfigScope).Enabled,
                            onChange: ()=>{
                                setNotificationConfigScope((0, $2gpGl.EntityNotificationConfigScope).Enabled);
                            }
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8wQ2C.styles)().form.content.checkbox.label,
                            children: `I'd like to receive all notifications.`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8wQ2C.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $eJNPy.Checkbox), {
                            name: "notifications-custom",
                            label: "receive only important notifications",
                            checked: notificationConfigScope === (0, $2gpGl.EntityNotificationConfigScope).Custom,
                            onChange: ()=>{
                                setNotificationConfigScope((0, $2gpGl.EntityNotificationConfigScope).Custom);
                            }
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8wQ2C.styles)().form.content.checkbox.label,
                            children: "I prefer to receive only important notifications."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8wQ2C.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $eJNPy.Checkbox), {
                            name: "notifications-disabled",
                            label: "do not receive any notifications",
                            checked: notificationConfigScope === (0, $2gpGl.EntityNotificationConfigScope).Disabled,
                            onChange: ()=>{
                                setNotificationConfigScope((0, $2gpGl.EntityNotificationConfigScope).Disabled);
                            }
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8wQ2C.styles)().form.content.checkbox.label,
                            children: `I'd rather not receive notifications at the moment.`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $8wQ2C.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "configure notifications",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Next"
                    })
                })
            ]
        })
    });
};
$0a5870bcc50dbae5$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("8wQ2C", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $583d7c2178a7aacc$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $583d7c2178a7aacc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $583d7c2178a7aacc$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $583d7c2178a7aacc$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $583d7c2178a7aacc$var$_ref3 = {
    name: "pgjgom",
    styles: "display:flex;align-items:center;justify-content:left;margin-bottom:24px"
};
var $583d7c2178a7aacc$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $583d7c2178a7aacc$var$_ref5 = {
    name: "1u8bg7q",
    styles: "width:380px"
};
var $583d7c2178a7aacc$var$_ref6 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $583d7c2178a7aacc$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $583d7c2178a7aacc$var$_ref6,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:510px;", (0, $gln0L.mq).tablet($583d7c2178a7aacc$var$_ref5), " ", (0, $gln0L.mq).mobile($583d7c2178a7aacc$var$_ref4), ";", ""),
                checkbox: {
                    main: $583d7c2178a7aacc$var$_ref3,
                    label: /*#__PURE__*/ (0, $7hler.css)("display:flex;font-size:", (0, $gln0L.typography).h6, ";margin-left:16px;", "")
                },
                submit: /*#__PURE__*/ (0, $7hler.css)("align-self:center;margin-top:36px;", (0, $gln0L.mq).mobile($583d7c2178a7aacc$var$_ref2), " &>button{width:380px;", (0, $gln0L.mq).mobile($583d7c2178a7aacc$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("kSXLq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0b1aaece5340b07c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $0b1aaece5340b07c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0b1aaece5340b07c$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $0b1aaece5340b07c$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $0b1aaece5340b07c$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $0b1aaece5340b07c$var$_ref4 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $0b1aaece5340b07c$var$_ref5 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $0b1aaece5340b07c$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $0b1aaece5340b07c$var$_ref5,
            backward: {
                button: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $0b1aaece5340b07c$var$_ref4
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:760px;", (0, $gln0L.mq).mobile($0b1aaece5340b07c$var$_ref3), ";", ""),
                title: $0b1aaece5340b07c$var$_ref2,
                form: $0b1aaece5340b07c$var$_ref,
                error: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("iqvYO", function(module, exports) {

$parcel$export(module.exports, "CreateProfile", function () { return $7331143254d41cc8$export$50f914132f8ce5ba; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gHHUR = parcelRequire("gHHUR");
var $3EkqN = parcelRequire("3EkqN");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");
var $ly71s = parcelRequire("ly71s");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("bGUw9");
var $9atI7 = parcelRequire("9atI7");

var $4nvWO = parcelRequire("4nvWO");
const $7331143254d41cc8$export$50f914132f8ce5ba = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingError = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $4nvWO.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $4nvWO.styles)().stage.backward.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    css: (0, $4nvWO.styles)().stage.backward.button,
                    "aria-label": "sign out",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $gHHUR.authSignout)()),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).SignOut, {
                        css: (0, $4nvWO.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $4nvWO.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $4nvWO.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2oiNd.Subtitle), {
                            text: "Personalize your profile to make it uniquely yours!"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $4nvWO.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9atI7.Form), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $4nvWO.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$7331143254d41cc8$export$50f914132f8ce5ba.propTypes = {};

});
parcelRegister("bGUw9", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("9atI7")).Form; });

var $9atI7 = parcelRequire("9atI7");

});
parcelRegister("9atI7", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $f1240e8db0c23f72$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $620EQ = parcelRequire("620EQ");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $gW5Rq = parcelRequire("gW5Rq");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("9RW9l");
var $2P09L = parcelRequire("2P09L");

var $fGS6i = parcelRequire("fGS6i");
const $f1240e8db0c23f72$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const onboardingError = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectError));
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    // avatar state
    const userHasAvatar = !!profile?.avatarId;
    const profileAvatar = (0, $jpNoL.useFile)(profile?.avatarId || "");
    const [avatar, setAvatar] = (0, $bh6RR.useState)(null);
    const [avatarPreview, setAvatarPreview] = (0, $bh6RR.useState)(userHasAvatar ? profileAvatar : "");
    const fileInputRef = (0, $bh6RR.useRef)(null);
    // name state
    const [name, setName] = (0, $bh6RR.useState)(profile?.name || "");
    const [nameError, setNameError] = (0, $bh6RR.useState)("");
    // username state
    const [username, setUsername] = (0, $bh6RR.useState)(profile?.username || "");
    const [usernameError, setUsernameError] = (0, $bh6RR.useState)("");
    const submitDisabled = name.length < (0, $620EQ.minUserNameLength) || username.length < (0, $620EQ.minUserUsernameLength) || nameError !== "" || usernameError !== "" || onboardingError !== "" || onboardingLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const onEditClick = ()=>{
        fileInputRef.current?.click();
        dispatch((0, $3EkqN.onboardingSetError)(""));
    };
    const onFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validateAvatarFile)(file);
            if (error) {
                dispatch((0, $3EkqN.onboardingSetError)(error));
                return;
            }
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
            // set file as a preview
            setAvatarPreview(URL.createObjectURL(file));
            // store file in state
            setAvatar(file);
        }
    };
    (0, $bh6RR.useEffect)(()=>()=>{
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
        });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fGS6i.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $fGS6i.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $7676a.onboardingUpdateProfile)({
                    name: name,
                    username: username,
                    avatar: avatar
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fGS6i.styles)().form.content.avatar.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                            css: (0, $fGS6i.styles)().form.content.avatar.label,
                            htmlFor: "avatar",
                            children: [
                                "avatar",
                                /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                    css: (0, $fGS6i.styles)().form.content.avatar.input,
                                    name: "avatar",
                                    type: "file",
                                    id: "avatar",
                                    ref: fileInputRef,
                                    accept: "image/jpeg,image/webp,image/png",
                                    onChange: (e)=>onFileChange(e)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $2P09L.Avatar), {
                            onEditClick: ()=>onEditClick(),
                            source: avatarPreview
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fGS6i.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gW5Rq.InputBar), {
                        name: "name",
                        label: "name",
                        type: "text",
                        placeholder: "Enter your name",
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $620EQ.minUserNameLength),
                        max: (0, $620EQ.maxUserNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $lRNbG.validateName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                !profile?.username && // render username input if user has no username
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fGS6i.styles)().form.content.username,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gW5Rq.InputBar), {
                        name: "username",
                        label: "username",
                        type: "text",
                        placeholder: "Enter your username",
                        value: username,
                        error: usernameError.length > 0,
                        errorMessage: usernameError,
                        min: (0, $620EQ.minUserUsernameLength),
                        max: (0, $620EQ.maxUserUsernameLength),
                        onChange: (e)=>{
                            setUsername(e.target.value);
                        },
                        onBlur: ()=>setUsernameError((0, $lRNbG.validateUsername)(username)),
                        onFocus: ()=>{
                            setUsernameError("");
                            dispatch((0, $3EkqN.onboardingSetError)(""));
                        }
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $fGS6i.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create profile",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Create"
                    })
                })
            ]
        })
    });
};
$f1240e8db0c23f72$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("9RW9l", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("2P09L")).Avatar; });

var $2P09L = parcelRequire("2P09L");

});
parcelRegister("2P09L", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $30f7b508e5ff309d$export$e2255cf6045e8d47; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $2Wh4g = parcelRequire("2Wh4g");
const $30f7b508e5ff309d$export$e2255cf6045e8d47 = ({ source: source, onEditClick: onEditClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $2Wh4g.styles)(theme).avatar.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2Wh4g.styles)(theme).avatar.image.main,
                children: source ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $2Wh4g.styles)(theme).avatar.image.content,
                    loading: "lazy",
                    width: "120px",
                    height: "120px",
                    src: source,
                    alt: "user avatar"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                    css: (0, $2Wh4g.styles)(theme).avatar.image.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2Wh4g.styles)(theme).avatar.edit.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $2Wh4g.styles)(theme).avatar.edit.button,
                    onClick: (e)=>onEditClick(e),
                    type: "button",
                    "aria-label": "change user avatar",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Edit, {
                        css: (0, $2Wh4g.styles)(theme).avatar.edit.icon
                    })
                })
            })
        ]
    });
};
$30f7b508e5ff309d$export$e2255cf6045e8d47.propTypes = {};

});
parcelRegister("2Wh4g", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $46f8820943334545$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $46f8820943334545$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $46f8820943334545$var$_ref = {
    name: "eveydc",
    styles: "position:relative;width:120px;height:120px"
};
const $46f8820943334545$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: $46f8820943334545$var$_ref,
            image: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:120px;height:120px;background-color:", theme.colors.secondary.darker, ";border-radius:50%;overflow:hidden;", ""),
                content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            edit: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:absolute;bottom:4px;right:2px;width:36px;height:36px;border-radius:50%;overflow:hidden;transition:background-color 0.2s;background-color:", theme.colors.secondary.dark, ";&:hover{background-color:", theme.colors.secondary.darkHover, ";}", ""),
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:100%;cursor:pointer;", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:18px;height:18px;&>path{fill:", theme.colors.primary.normal, ";}", "")
            }
        }
    });

});



parcelRegister("fGS6i", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fc3de4bdd79a211b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $fc3de4bdd79a211b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fc3de4bdd79a211b$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $fc3de4bdd79a211b$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $fc3de4bdd79a211b$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $fc3de4bdd79a211b$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $fc3de4bdd79a211b$var$_ref5 = {
    name: "9tjjy6",
    styles: "display:flex;align-items:center;justify-content:center;margin-bottom:32px"
};
const $fc3de4bdd79a211b$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                avatar: {
                    main: $fc3de4bdd79a211b$var$_ref5,
                    label: $fc3de4bdd79a211b$var$_ref4,
                    input: $fc3de4bdd79a211b$var$_ref3
                },
                name: $fc3de4bdd79a211b$var$_ref2,
                username: $fc3de4bdd79a211b$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("4nvWO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4fb6a6e5b6465a94$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4fb6a6e5b6465a94$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4fb6a6e5b6465a94$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4fb6a6e5b6465a94$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $4fb6a6e5b6465a94$var$_ref3 = {
    name: "i38kcj",
    styles: "display:flex;align-items:center;flex-direction:column"
};
var $4fb6a6e5b6465a94$var$_ref4 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $4fb6a6e5b6465a94$var$_ref5 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $4fb6a6e5b6465a94$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $4fb6a6e5b6465a94$var$_ref5,
            backward: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                button: /*#__PURE__*/ (0, $7hler.css)("", ""),
                icon: $4fb6a6e5b6465a94$var$_ref4
            },
            content: {
                main: $4fb6a6e5b6465a94$var$_ref3,
                title: $4fb6a6e5b6465a94$var$_ref2,
                form: /*#__PURE__*/ (0, $7hler.css)("margin-bottom:32px;width:380px;", (0, $gln0L.mq).mobile($4fb6a6e5b6465a94$var$_ref), ";", ""),
                error: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("2b1ki", function(module, exports) {

$parcel$export(module.exports, "EnableMonetization", function () { return $10024d178be750fc$export$6e396ef3fbeea87f; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");
var $ly71s = parcelRequire("ly71s");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("9W279");
var $fb2yv = parcelRequire("fb2yv");
var $iSMNz = parcelRequire("iSMNz");

var $eW5Q2 = parcelRequire("eW5Q2");
const $10024d178be750fc$export$6e396ef3fbeea87f = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingError = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $eW5Q2.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eW5Q2.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $7676a.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {
                        css: (0, $eW5Q2.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $eW5Q2.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eW5Q2.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2oiNd.Subtitle), {
                            text: "Enable payouts by configuring your business account!"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eW5Q2.styles)().stage.content.features,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fb2yv.Features), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eW5Q2.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iSMNz.Form), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eW5Q2.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$10024d178be750fc$export$6e396ef3fbeea87f.propTypes = {};

});
parcelRegister("9W279", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return (parcelRequire("fb2yv")).Features; });
$parcel$export(module.exports, "Form", function () { return (parcelRequire("iSMNz")).Form; });

var $fb2yv = parcelRequire("fb2yv");

var $iSMNz = parcelRequire("iSMNz");

});
parcelRegister("fb2yv", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return $6cb8c8f69a28ac84$export$617d79dae526d2cf; });

var $9awXB = parcelRequire("9awXB");

var $8y7dF = parcelRequire("8y7dF");
parcelRequire("k4J4B");
var $aVbu8 = parcelRequire("aVbu8");

var $aWTkf = parcelRequire("aWTkf");
const $6cb8c8f69a28ac84$export$617d79dae526d2cf = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $aWTkf.styles)().features.main,
        children: (0, $8y7dF.monetizationFeatures).map((feature)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $aVbu8.Feature), {
                ...feature
            }, feature.id))
    });
$6cb8c8f69a28ac84$export$617d79dae526d2cf.propTypes = {};

});
parcelRegister("8y7dF", function(module, exports) {

$parcel$export(module.exports, "monetizationFeatures", function () { return $56149c39c2dcbcad$export$bed2e1e36bed53e1; });

var $62Hgc = parcelRequire("62Hgc");
const $56149c39c2dcbcad$export$bed2e1e36bed53e1 = [
    {
        id: "218f6074-bcad-4c04-ad8c-cb0d25d612db",
        icon: (0, $62Hgc.icons).Dollar,
        title: "Unlock Earnings",
        description: "Enable payouts by configuring your business account"
    },
    {
        id: "faaa776c-fb02-464f-b1dd-ba63b08fd5d4",
        icon: (0, $62Hgc.icons).Stars,
        title: "Build Your Brand",
        description: "Unlock advanced profile controls and promote your brand"
    },
    {
        id: "69203fe8-5a0a-4a41-b2a7-8310701726ab",
        icon: (0, $62Hgc.icons).Rocket,
        title: "Maximize Your Potential",
        description: "Fans are eagerly anticipating your incredible content"
    }
];

});
parcelRegister("62Hgc", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $cc5cdb2f442df5c7$export$df03f54e09e486fa; });

var $272DZ = parcelRequire("272DZ");

var $euHFP = parcelRequire("euHFP");

var $5ReC8 = parcelRequire("5ReC8");
const $cc5cdb2f442df5c7$export$df03f54e09e486fa = {
    Dollar: $272DZ.default,
    Rocket: $euHFP.default,
    Stars: $5ReC8.default
};

});
parcelRegister("272DZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b55c10972728341$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $4b55c10972728341$var$SvgDollar = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20 7.667C13.187 7.667 7.665 13.188 7.665 20c0 6.811 5.522 12.333 12.333 12.333 6.812 0 12.334-5.521 12.334-12.333S26.81 7.667 19.999 7.667ZM5.665 20c0-7.916 6.417-14.333 14.333-14.333S34.333 12.084 34.333 20s-6.418 14.333-14.334 14.333c-7.916 0-14.333-6.417-14.333-14.333Zm14.333-9a1 1 0 0 1 1 1v.422c2.174.39 4 2.023 4 4.245a1 1 0 1 1-2 0c0-1.126-1.164-2.334-3-2.334-1.835 0-3 1.208-3 2.334C17 17.792 18.164 19 20 19c2.583 0 5 1.777 5 4.333 0 2.222-1.826 3.855-4 4.245V28a1 1 0 0 1-2 0v-.422c-2.174-.39-4-2.023-4-4.245a1 1 0 0 1 2 0c0 1.126 1.165 2.334 3 2.334 1.836 0 3-1.208 3-2.334C23 22.208 21.835 21 20 21c-2.583 0-5-1.777-5-4.333 0-2.222 1.826-3.856 4-4.245V12a1 1 0 0 1 1-1Z",
            fill: "#FFF"
        })
    });
var $4b55c10972728341$export$2e2bcd8739ae039 = $4b55c10972728341$var$SvgDollar;

});

parcelRegister("euHFP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3986e237e605834$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $f3986e237e605834$var$SvgRocket = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M8.003 20.475a1 1 0 0 1 0 1.415l-.206.204a.447.447 0 0 0 0 .633.451.451 0 0 0 .638 0l2.255-2.253a1 1 0 0 1 1.414 1.416l-2.256 2.252a2.451 2.451 0 0 1-3.464 0 2.447 2.447 0 0 1 0-3.463l.205-.204a1 1 0 0 1 1.414 0ZM14.475 21.804a1 1 0 0 1 0 1.414l-2.822 2.822a1 1 0 1 1-1.414-1.414l2.822-2.822a1 1 0 0 1 1.414 0ZM18.176 25.5a1 1 0 0 1 0 1.414l-2.803 2.804a1 1 0 0 1-1.414-1.415l2.803-2.803a1 1 0 0 1 1.414 0ZM13.962 26.028a1 1 0 0 1-.015 1.414l-2.28 2.23a1 1 0 0 1-1.398-1.43l2.28-2.23a1 1 0 0 1 1.413.016ZM19.474 27.901a1 1 0 0 1 0 1.415l-2.256 2.253a.447.447 0 0 0 0 .633.451.451 0 0 0 .637 0l.205-.205a1 1 0 1 1 1.414 1.415l-.206.205a2.451 2.451 0 0 1-3.463 0 2.447 2.447 0 0 1 0-3.463L18.06 27.9a1 1 0 0 1 1.415 0Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.989 5.667h.905c1.005 0 1.857 0 2.538.09.723.098 1.4.314 1.946.858.548.545.766 1.22.863 1.943.092.678.092 1.528.092 2.528v.903c0 1.201.001 2.081-.334 2.887s-.96 1.427-1.814 2.276l-.126.126-3.022 3.009.053.08c.454.702.826 1.276 1.096 1.773.28.517.485 1.01.567 1.56.13.874.012 1.773-.333 2.597-.131.314-.355.638-.578.924-.234.302-.52.63-.825.962a66.971 66.971 0 0 1-1.977 2.025l-.01.01-.097.096c-.9.896-2.459.608-2.94-.598-.265-.664-.369-.92-.498-1.154a4.607 4.607 0 0 0-.414-.627c-.163-.207-.354-.4-.845-.89l-.564-.493a2.68 2.68 0 0 1-.287.015c-.772 0-1.404-.323-1.985-.765-.546-.414-1.15-1.015-1.86-1.723l-1.688-1.68c-.71-.708-1.313-1.309-1.73-1.852-.444-.58-.77-1.21-.77-1.983 0-.116.008-.23.022-.343l-.916-.913c-.057-.056-.078-.078-.1-.098a4.634 4.634 0 0 0-1.462-.958l-.13-.052-.44-.174a1.885 1.885 0 0 1-.638-3.09l.01-.009c.643-.64 1.37-1.365 2.034-1.97.333-.303.662-.587.965-.82.288-.222.612-.445.927-.575a4.925 4.925 0 0 1 2.602-.33c.55.08 1.044.283 1.563.563.499.268 1.075.639 1.78 1.091l.087.057 3.026-3.014.126-.125c.853-.851 1.477-1.472 2.285-1.806.807-.333 1.688-.332 2.896-.331Zm-.4 16.062c.375.58.644 1.005.84 1.365.22.407.31.669.345.9a2.878 2.878 0 0 1-.2 1.532c-.024.06-.113.212-.312.469-.186.24-.43.522-.717.834-.54.588-1.19 1.239-1.81 1.856-.184-.459-.319-.78-.487-1.086a6.608 6.608 0 0 0-.593-.898c-.25-.319-.537-.604-.986-1.05l-.048-.05c.045-.037.09-.074.135-.113.439-.38.931-.87 1.497-1.433l2.336-2.326Zm.578-14.062c-1.463 0-1.917.017-2.312.18-.395.163-.727.47-1.762 1.5L17.311 16.1c-.58.577-1.014 1.01-1.34 1.383-.33.374-.487.62-.561.804a.716.716 0 0 0-.058.277c0 .157.05.365.357.766.326.424.831.93 1.602 1.699l.09.09 1.685-1.677a1 1 0 1 1 1.411 1.417L18.82 22.53l.085.085c.771.768 1.28 1.271 1.706 1.595.403.306.613.357.775.357a.718.718 0 0 0 .256-.048c.182-.067.427-.217.808-.545.38-.327.822-.767 1.416-1.36l6.782-6.753c1.035-1.03 1.342-1.361 1.505-1.753.163-.39.18-.84.18-2.297v-.657c0-1.086-.002-1.8-.073-2.328-.067-.5-.18-.682-.292-.794-.113-.112-.297-.225-.8-.292-.533-.071-1.25-.073-2.34-.073h-.66Zm.295 3.843a3.26 3.26 0 0 0-4.597 0 3.237 3.237 0 0 0 0 4.59 3.26 3.26 0 0 0 4.598 0 3.237 3.237 0 0 0 0-4.59Zm-3.186 1.418a1.26 1.26 0 0 1 1.775 0c.488.485.488 1.27 0 1.755a1.26 1.26 0 0 1-1.775 0 1.237 1.237 0 0 1 0-1.755Zm-7.071-.54a22.291 22.291 0 0 0-1.364-.832c-.41-.22-.673-.311-.907-.346a2.925 2.925 0 0 0-1.545.2c-.061.025-.215.113-.472.311-.242.186-.525.43-.838.715a61.152 61.152 0 0 0-1.855 1.794l.278.11.007.003.149.06c.778.32 1.488.785 2.092 1.37l.114.114.454.45.149-.173c.376-.429.858-.909 1.411-1.46l2.327-2.316Z",
                fill: "#FFF"
            })
        ]
    });
var $f3986e237e605834$export$2e2bcd8739ae039 = $f3986e237e605834$var$SvgRocket;

});

parcelRegister("5ReC8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94f511a6f62354cf$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $94f511a6f62354cf$var$SvgStars = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.307 6.537a.667.667 0 0 0-1.309.005v.002l-.003.013a4.904 4.904 0 0 1-.06.269 9.152 9.152 0 0 1-.204.708c-.193.58-.456 1.147-.758 1.45-.301.304-.867.571-1.445.768a9.141 9.141 0 0 1-.976.271l-.012.003h-.003a.667.667 0 0 0 .005 1.309h.002l.013.003a4.518 4.518 0 0 1 .269.06c.182.045.434.113.708.204.58.194 1.147.456 1.45.758.304.302.571.868.768 1.445a9.146 9.146 0 0 1 .271.976l.003.013v.002a.667.667 0 0 0 1.309-.004v-.003l.003-.012.012-.056a9.131 9.131 0 0 1 .253-.922c.193-.579.455-1.147.757-1.45.302-.304.868-.57 1.445-.768a9.118 9.118 0 0 1 .976-.27l.013-.003h.002a.667.667 0 0 0-.004-1.31h-.003l-.012-.003a9.141 9.141 0 0 1-.978-.265c-.579-.192-1.147-.455-1.45-.757-.304-.301-.57-.867-.768-1.445a9.113 9.113 0 0 1-.27-.976l-.003-.012v-.003Zm1.221 4.123c-.404-.19-.81-.433-1.119-.74-.31-.309-.556-.712-.749-1.115-.19.404-.433.81-.74 1.12-.309.31-.712.556-1.115.748.404.19.81.433 1.12.741.31.308.556.712.748 1.114.19-.404.433-.81.741-1.119.308-.31.712-.556 1.114-.749ZM29.333 8.333a1 1 0 0 1 1 1v.334h.334a1 1 0 0 1 0 2h-.334V12a1 1 0 1 1-2 0v-.333H28a1 1 0 1 1 0-2h.333v-.334a1 1 0 0 1 1-1Zm-9.35 3.907c-.438.572-.935 1.46-1.67 2.776l-.37.667-.072.128c-.335.603-.638 1.148-1.127 1.52-.496.377-1.1.512-1.752.658l-.139.031-.72.164c-1.429.323-2.383.541-3.032.797-.631.25-.716.434-.748.537-.035.113-.064.335.314.936.386.613 1.039 1.38 2.01 2.517l.492.575.092.106c.45.524.85.992 1.035 1.584.183.589.122 1.206.053 1.906l-.014.142-.074.767c-.147 1.515-.244 2.542-.211 3.277.032.735.186.883.257.937.055.042.202.15.858-.039.67-.192 1.566-.6 2.902-1.216l.676-.311.132-.061c.607-.281 1.173-.543 1.792-.543s1.184.262 1.791.543l.133.06.675.312c1.337.615 2.232 1.024 2.902 1.216.657.188.803.08.858.04.071-.055.225-.203.258-.938.033-.735-.065-1.762-.211-3.277l-.075-.767-.014-.142c-.069-.7-.13-1.317.054-1.905.184-.593.585-1.06 1.035-1.585l.091-.106.492-.575c.972-1.137 1.625-1.904 2.01-2.517.379-.6.35-.823.314-.936-.032-.103-.117-.288-.747-.537-.65-.256-1.604-.474-3.032-.797l-.721-.164a78.83 78.83 0 0 0-.139-.03c-.653-.147-1.256-.282-1.751-.659-.49-.372-.793-.917-1.128-1.52l-.071-.128-.371-.667c-.734-1.316-1.232-2.204-1.67-2.776-.438-.57-.626-.573-.683-.573-.057 0-.246.002-.684.573Zm-1.588-1.216c.549-.716 1.256-1.357 2.272-1.357 1.016 0 1.722.641 2.27 1.357.538.702 1.106 1.72 1.79 2.946l.41.739c.452.81.55.944.662 1.03.106.08.244.132 1.122.33l.804.183c1.323.299 2.43.55 3.241.869.846.333 1.624.84 1.924 1.803.296.953-.043 1.82-.531 2.596-.473.751-1.225 1.63-2.13 2.689l-.545.636c-.594.695-.69.837-.736.985-.048.153-.049.336.041 1.261l.082.847c.137 1.415.25 2.585.21 3.48-.04.913-.248 1.835-1.046 2.44-.813.618-1.753.539-2.618.29-.835-.238-1.871-.716-3.11-1.286l-.753-.347c-.826-.38-.965-.42-1.087-.42-.123 0-.262.04-1.088.42l-.753.347c-1.239.57-2.274 1.048-3.11 1.287-.865.248-1.805.327-2.618-.29-.797-.606-1.006-1.528-1.046-2.442-.04-.894.073-2.064.21-3.479l.082-.847c.09-.925.09-1.108.042-1.26-.046-.15-.143-.29-.737-.986l-.544-.636c-.906-1.059-1.658-1.938-2.13-2.69-.49-.776-.828-1.642-.531-2.595.3-.964 1.077-1.47 1.923-1.803.81-.32 1.918-.57 3.241-.87l.804-.181c.878-.199 1.017-.252 1.122-.332.112-.085.21-.22.661-1.03l.412-.738c.684-1.226 1.25-2.244 1.788-2.946Z",
            fill: "#FFF"
        })
    });
var $94f511a6f62354cf$export$2e2bcd8739ae039 = $94f511a6f62354cf$var$SvgStars;

});



parcelRegister("k4J4B", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return (parcelRequire("aVbu8")).Feature; });

var $aVbu8 = parcelRequire("aVbu8");

});
parcelRegister("aVbu8", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $2d006ff6912b180e$export$6e91cf7616333d5; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $dqxLU = parcelRequire("dqxLU");
const $2d006ff6912b180e$export$6e91cf7616333d5 = ({ icon: Icon, title: title, description: description })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dqxLU.styles)(theme).feature.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dqxLU.styles)(theme).feature.icon,
                children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dqxLU.styles)(theme).feature.title,
                children: title
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dqxLU.styles)(theme).feature.description,
                children: description
            })
        ]
    });
};
$2d006ff6912b180e$export$6e91cf7616333d5.propTypes = {};

});
parcelRegister("dqxLU", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1a01ed50aa8783f0$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $1a01ed50aa8783f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1a01ed50aa8783f0$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $1a01ed50aa8783f0$export$9dd6ff9ea0189349 = (theme)=>({
        feature: {
            main: /*#__PURE__*/ (0, $7hler.css)("text-align:center;width:228px;padding:0px 1px;", (0, $gln0L.mq).mobile($1a01ed50aa8783f0$var$_ref), ";", ""),
            icon: /*#__PURE__*/ (0, $7hler.css)("&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
            title: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;margin-bottom:8px;", ""),
            description: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";", "")
        }
    });

});



parcelRegister("aWTkf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a42a918687867c72$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $a42a918687867c72$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a42a918687867c72$var$_ref = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
const $a42a918687867c72$export$9dd6ff9ea0189349 = ()=>({
        features: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:space-between;flex-wrap:wrap;&>div:not(:last-of-type){margin-bottom:32px;}", (0, $gln0L.mq).tablet($a42a918687867c72$var$_ref), ";", "")
        }
    });

});


parcelRegister("iSMNz", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $e6e0cec85ef9bfaa$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $7676a = parcelRequire("7676a");
var $3EkqN = parcelRequire("3EkqN");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $kV92E = parcelRequire("kV92E");
const $e6e0cec85ef9bfaa$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    const onboardingConnectLink = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectConnectLink));
    const submitDisabled = onboardingLoading;
    (0, $bh6RR.useEffect)(()=>{
        dispatch((0, $7676a.onboardingGetConnectLink)());
    }, [
        dispatch
    ]);
    const onEnableClick = ()=>{
        const newWindow = window.open(onboardingConnectLink, "_self", // '_blank'
        "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kV92E.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $kV92E.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $7676a.onboardingSetNextStage)());
            },
            children: [
                onboardingConnectLink && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kV92E.styles)().form.content.enable,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "button",
                        onClick: ()=>onEnableClick(),
                        "aria-label": "enable monetization",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: "Enable"
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kV92E.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "proceed to next onboarding stage",
                        disabled: submitDisabled,
                        appearance: "secondary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Next"
                    })
                })
            ]
        })
    });
};
$e6e0cec85ef9bfaa$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("kV92E", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7906eea1281d93c2$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $7906eea1281d93c2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7906eea1281d93c2$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7906eea1281d93c2$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7906eea1281d93c2$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7906eea1281d93c2$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7906eea1281d93c2$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7906eea1281d93c2$var$_ref6 = {
    name: "1u8bg7q",
    styles: "width:380px"
};
var $7906eea1281d93c2$var$_ref7 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $7906eea1281d93c2$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $7906eea1281d93c2$var$_ref7,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:510px;", (0, $gln0L.mq).tablet($7906eea1281d93c2$var$_ref6), " ", (0, $gln0L.mq).mobile($7906eea1281d93c2$var$_ref5), ";", ""),
                enable: /*#__PURE__*/ (0, $7hler.css)("align-self:center;margin-bottom:20px;", (0, $gln0L.mq).mobile($7906eea1281d93c2$var$_ref4), " &>button{width:380px;", (0, $gln0L.mq).mobile($7906eea1281d93c2$var$_ref3), ";}", ""),
                submit: /*#__PURE__*/ (0, $7hler.css)("align-self:center;", (0, $gln0L.mq).mobile($7906eea1281d93c2$var$_ref2), " &>button{width:380px;", (0, $gln0L.mq).mobile($7906eea1281d93c2$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("eW5Q2", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $48aa111233346daf$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $48aa111233346daf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $48aa111233346daf$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $48aa111233346daf$var$_ref2 = {
    name: "qu9742",
    styles: "margin-bottom:100px"
};
var $48aa111233346daf$var$_ref3 = {
    name: "qu9742",
    styles: "margin-bottom:100px"
};
var $48aa111233346daf$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $48aa111233346daf$var$_ref5 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $48aa111233346daf$var$_ref6 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $48aa111233346daf$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $48aa111233346daf$var$_ref6,
            backward: {
                button: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $48aa111233346daf$var$_ref5
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:760px;", (0, $gln0L.mq).mobile($48aa111233346daf$var$_ref4), ";", ""),
                title: $48aa111233346daf$var$_ref3,
                features: $48aa111233346daf$var$_ref2,
                form: $48aa111233346daf$var$_ref,
                error: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("4GJ4g", function(module, exports) {

$parcel$export(module.exports, "FollowArtists", function () { return $ae21eb43ec3154bf$export$c75212fe28cc57d5; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gzBMX = parcelRequire("gzBMX");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");
var $ly71s = parcelRequire("ly71s");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("lXv3V");
var $fnyqW = parcelRequire("fnyqW");

var $4LSQA = parcelRequire("4LSQA");
const $ae21eb43ec3154bf$export$c75212fe28cc57d5 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingError = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $4LSQA.styles)(theme).stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $4LSQA.styles)(theme).stage.backward.button,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $7676a.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {
                        css: (0, $4LSQA.styles)(theme).stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $4LSQA.styles)(theme).stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $4LSQA.styles)(theme).stage.content.title,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2oiNd.Subtitle), {
                            text: "Go ahead and follow the artists we think you'll like!"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $4LSQA.styles)(theme).stage.content.artists.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $4LSQA.styles)(theme).stage.content.artists.overlay.top
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $gzBMX.ArtistListOnboardingRecommended), {}),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $4LSQA.styles)(theme).stage.content.artists.overlay.bot
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $4LSQA.styles)(theme).stage.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fnyqW.Form), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $4LSQA.styles)(theme).stage.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$ae21eb43ec3154bf$export$c75212fe28cc57d5.propTypes = {};

});
parcelRegister("lXv3V", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("fnyqW")).Form; });

var $fnyqW = parcelRequire("fnyqW");

});
parcelRegister("fnyqW", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $e5f3b0619cf5764c$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $di6di = parcelRequire("di6di");
const $e5f3b0619cf5764c$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    const submitDisabled = onboardingLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $di6di.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("form", {
            css: (0, $di6di.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $7676a.onboardingSetNextStage)());
            },
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $di6di.styles)().form.content.submit,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                    type: "submit",
                    "aria-label": "follow artists",
                    disabled: submitDisabled,
                    appearance: "primary",
                    children: onboardingLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                        width: 50,
                        height: 20,
                        appearance: "primary"
                    }) : "Next"
                })
            })
        })
    });
};
$e5f3b0619cf5764c$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("di6di", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4fbeb3cc160e3313$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4fbeb3cc160e3313$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4fbeb3cc160e3313$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4fbeb3cc160e3313$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4fbeb3cc160e3313$var$_ref3 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $4fbeb3cc160e3313$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: $4fbeb3cc160e3313$var$_ref3,
                submit: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($4fbeb3cc160e3313$var$_ref2), " &>button{width:380px;", (0, $gln0L.mq).mobile($4fbeb3cc160e3313$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("4LSQA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7118a080b890c6e9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $7118a080b890c6e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7118a080b890c6e9$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $7118a080b890c6e9$var$_ref2 = {
    name: "fbo2gl",
    styles: "display:flex;flex-direction:column;align-items:center;position:relative;margin-bottom:50px"
};
var $7118a080b890c6e9$var$_ref3 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $7118a080b890c6e9$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7118a080b890c6e9$var$_ref5 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $7118a080b890c6e9$var$_ref6 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $7118a080b890c6e9$export$9dd6ff9ea0189349 = (theme)=>({
        stage: {
            main: $7118a080b890c6e9$var$_ref6,
            backward: {
                button: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $7118a080b890c6e9$var$_ref5
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:760px;", (0, $gln0L.mq).mobile($7118a080b890c6e9$var$_ref4), ";", ""),
                title: $7118a080b890c6e9$var$_ref3,
                artists: {
                    main: $7118a080b890c6e9$var$_ref2,
                    overlay: {
                        top: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.followArtists.overlay, ";position:absolute;left:0;top:0;width:100%;height:60px;background:linear-gradient(\n              180deg,\n              ", theme.colors.primary.normal, " 0%,\n              ", theme.colors.primary.normal, "00 75.79%\n            );", ""),
                        bot: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.followArtists.overlay, ";position:absolute;left:0;bottom:0;width:100%;height:60px;background:linear-gradient(\n              180deg,\n              ", theme.colors.primary.normal, "00 25.21%,\n              ", theme.colors.primary.normal, " 100%\n            );", "")
                    }
                },
                form: $7118a080b890c6e9$var$_ref,
                error: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("clVvs", function(module, exports) {

$parcel$export(module.exports, "SelectGenres", function () { return $b67333e78e7a72e9$export$9620f4783b9264db; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");
var $ly71s = parcelRequire("ly71s");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("eMIpY");
var $k9MwR = parcelRequire("k9MwR");

var $aLofh = parcelRequire("aLofh");
const $b67333e78e7a72e9$export$9620f4783b9264db = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingError = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectError));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $aLofh.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $aLofh.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $7676a.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {
                        css: (0, $aLofh.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $aLofh.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $aLofh.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2oiNd.Subtitle), {
                            text: "Pick the top three music genres you enjoy the most!"
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $aLofh.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $k9MwR.Form), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $aLofh.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: onboardingError
                        })
                    })
                ]
            })
        ]
    });
};
$b67333e78e7a72e9$export$9620f4783b9264db.propTypes = {};

});
parcelRegister("eMIpY", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("k9MwR")).Form; });

var $k9MwR = parcelRequire("k9MwR");

});
parcelRegister("k9MwR", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $191d60a1437ad9f4$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $cGp48 = parcelRequire("cGp48");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("ixiyV");
var $8Yo7m = parcelRequire("8Yo7m");

var $6Jdym = parcelRequire("6Jdym");
const $191d60a1437ad9f4$export$a7fed597f4b8afd8 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const [selectedGenres, setSelectedGenres] = (0, $bh6RR.useState)(profile?.preferredGenres || []);
    const submitDisabled = selectedGenres.length <= 0 || selectedGenres.length > (0, $cGp48.maxUserPreferredGenresCount) || onboardingLoading;
    const onGenreClick = (selected, genre)=>{
        if (selected) setSelectedGenres((state)=>[
                ...state.filter((el)=>el !== genre)
            ]);
        if (!selected && selectedGenres.length < (0, $cGp48.maxUserPreferredGenresCount)) setSelectedGenres((state)=>[
                ...state,
                genre
            ]);
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $6Jdym.styles)(theme).form.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $6Jdym.styles)(theme).form.genres.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $6Jdym.styles)(theme).form.genres.rows.main,
                        children: (0, $cGp48.musicGenres).map((genre)=>{
                            const selected = selectedGenres.includes(genre);
                            return /*#__PURE__*/ (0, $9awXB.jsx)((0, $8Yo7m.Genre), {
                                genre: genre,
                                onClick: ()=>onGenreClick(selected, genre),
                                selected: selected
                            }, `onboarding-genres-${genre}`);
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $6Jdym.styles)(theme).form.genres.selected.main,
                        children: [
                            "Selected",
                            " ",
                            /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                css: (0, $6Jdym.styles)(theme).form.genres.selected.num,
                                children: selectedGenres.length
                            }),
                            " ",
                            "out of",
                            " ",
                            /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                css: (0, $6Jdym.styles)(theme).form.genres.selected.num,
                                children: (0, $cGp48.maxUserPreferredGenresCount)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("form", {
                css: (0, $6Jdym.styles)(theme).form.content.main,
                onSubmit: (e)=>{
                    e.preventDefault();
                    dispatch((0, $7676a.onboardingUpdateGenres)({
                        preferredGenres: selectedGenres
                    }));
                },
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $6Jdym.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "select genres",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Select"
                    })
                })
            })
        ]
    });
};
$191d60a1437ad9f4$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("ixiyV", function(module, exports) {

$parcel$export(module.exports, "Genre", function () { return (parcelRequire("8Yo7m")).Genre; });

var $8Yo7m = parcelRequire("8Yo7m");

});
parcelRegister("8Yo7m", function(module, exports) {

$parcel$export(module.exports, "Genre", function () { return $a906e50241419f2a$export$8676b75cc81ea732; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $chBG6 = parcelRequire("chBG6");
const $a906e50241419f2a$export$8676b75cc81ea732 = ({ genre: genre, selected: selected = false, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $chBG6.styles)(theme).genre.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
            css: [
                (0, $chBG6.styles)(theme).genre.button.shared,
                selected ? (0, $chBG6.styles)(theme).genre.button.selected : (0, $chBG6.styles)(theme).genre.button.unselected,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "select genre",
            children: genre
        })
    });
};
$a906e50241419f2a$export$8676b75cc81ea732.propTypes = {};

});
parcelRegister("chBG6", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b2887a8cd4442695$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $b2887a8cd4442695$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b2887a8cd4442695$var$_ref = {
    name: "1u4hpl4",
    styles: "display:inline"
};
const $b2887a8cd4442695$export$9dd6ff9ea0189349 = (theme)=>({
        genre: {
            main: $b2887a8cd4442695$var$_ref,
            button: {
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:8px 26px;cursor:pointer;transition:color 0.2s,background-color 0.2s,border 0.2s;", ""),
                selected: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";", ""),
                unselected: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.primary.normal, ";color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});



parcelRegister("6Jdym", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $058eab0ae7f34b18$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $058eab0ae7f34b18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $058eab0ae7f34b18$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $058eab0ae7f34b18$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $058eab0ae7f34b18$var$_ref3 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
var $058eab0ae7f34b18$var$_ref4 = {
    name: "1efi8gv",
    styles: "font-weight:bold"
};
var $058eab0ae7f34b18$var$_ref5 = {
    name: "1jivb86",
    styles: "display:flex;justify-content:center;flex-wrap:wrap;margin-bottom:32px;max-width:572px;&>div{margin-left:8px;margin-right:8px;margin-bottom:16px;}"
};
var $058eab0ae7f34b18$var$_ref6 = {
    name: "1ohaauq",
    styles: "display:flex;flex-direction:column;align-items:center;margin-bottom:50px"
};
const $058eab0ae7f34b18$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            genres: {
                main: $058eab0ae7f34b18$var$_ref6,
                rows: {
                    main: $058eab0ae7f34b18$var$_ref5
                },
                selected: {
                    main: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";text-align:center;", ""),
                    num: $058eab0ae7f34b18$var$_ref4
                }
            },
            content: {
                main: $058eab0ae7f34b18$var$_ref3,
                submit: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($058eab0ae7f34b18$var$_ref2), " &>button{width:380px;", (0, $gln0L.mq).mobile($058eab0ae7f34b18$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("aLofh", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4b272dd7a1402499$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4b272dd7a1402499$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b272dd7a1402499$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $4b272dd7a1402499$var$_ref2 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $4b272dd7a1402499$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4b272dd7a1402499$var$_ref4 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $4b272dd7a1402499$var$_ref5 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $4b272dd7a1402499$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $4b272dd7a1402499$var$_ref5,
            backward: {
                button: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $4b272dd7a1402499$var$_ref4
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:760px;", (0, $gln0L.mq).mobile($4b272dd7a1402499$var$_ref3), ";", ""),
                title: $4b272dd7a1402499$var$_ref2,
                form: $4b272dd7a1402499$var$_ref,
                error: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("VDfei", function(module, exports) {

$parcel$export(module.exports, "SelectRole", function () { return $2d87669414171f5b$export$63dfc77bab1afa54; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gHHUR = parcelRequire("gHHUR");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");

var $cd93O = parcelRequire("cd93O");
parcelRequire("34kwD");
var $efeB2 = parcelRequire("efeB2");

var $hjTVU = parcelRequire("hjTVU");
const $2d87669414171f5b$export$63dfc77bab1afa54 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    const [fanRoleHover, setFanRoleHover] = (0, $bh6RR.useState)(true);
    const [artistRoleHover, setArtistRoleHover] = (0, $bh6RR.useState)(false);
    const onFanRoleMouseEnter = ()=>{
        setFanRoleHover(true);
        setArtistRoleHover(false);
    };
    const onFanRoleMouseLeave = ()=>{
        setFanRoleHover(true);
        setArtistRoleHover(false);
    };
    const onArtistRoleMouseEnter = ()=>{
        setArtistRoleHover(true);
        setFanRoleHover(false);
    };
    const onArtistRoleMouseLeave = ()=>{
        setArtistRoleHover(true);
        setFanRoleHover(false);
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $hjTVU.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $hjTVU.styles)().stage.backward.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    css: (0, $hjTVU.styles)().stage.backward.button,
                    "aria-label": "sign out",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $gHHUR.authSignout)()),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).SignOut, {
                        css: (0, $hjTVU.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $hjTVU.styles)().stage.role.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $hjTVU.styles)().stage.role.fan,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $efeB2.Role), {
                            name: "Fan",
                            appearance: "primary",
                            features: (0, $cd93O.fanRoleFeatures),
                            visible: fanRoleHover,
                            loading: onboardingLoading,
                            onRoleMouseEnter: ()=>onFanRoleMouseEnter(),
                            onRoleMouseLeave: ()=>onFanRoleMouseLeave(),
                            onNextClick: ()=>{
                                dispatch((0, $7676a.onboardingUpdateRole)({
                                    role: (0, $2gpGl.EntityUserRole).Fan
                                }));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $hjTVU.styles)().stage.role.artist,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $efeB2.Role), {
                            name: "Artist",
                            appearance: "secondary",
                            features: (0, $cd93O.artistRoleFeatures),
                            visible: artistRoleHover,
                            loading: onboardingLoading,
                            onRoleMouseEnter: ()=>onArtistRoleMouseEnter(),
                            onRoleMouseLeave: ()=>onArtistRoleMouseLeave(),
                            onNextClick: ()=>{
                                dispatch((0, $7676a.onboardingUpdateRole)({
                                    role: (0, $2gpGl.EntityUserRole).Artist
                                }));
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$2d87669414171f5b$export$63dfc77bab1afa54.propTypes = {};

});
parcelRegister("cd93O", function(module, exports) {

$parcel$export(module.exports, "fanRoleFeatures", function () { return $af35c188c0ccb05c$export$dcb16797db17b4cd; });
$parcel$export(module.exports, "artistRoleFeatures", function () { return $af35c188c0ccb05c$export$9fef70fa27af7bc2; });
// icons

var $jFMqv = parcelRequire("jFMqv");
const $af35c188c0ccb05c$export$dcb16797db17b4cd = [
    {
        id: "8fbadf0c-f417-4331-8180-326ccc489975",
        title: "DISPERSE IN EXCLUSIVE CONTENT",
        description: "Immerse yourself in a rich variety of exclusive audio tracks and media posts, carefully crafted by top creators from around the world.",
        icon: (0, $jFMqv.icons).FireIcon
    },
    {
        id: "9e1c9469-7619-4e03-bb07-728ae9dcc3b4",
        title: "SUPPORT YOUR CREATORS",
        description: "Show your appreciation by becoming a valued patron, unlocking exclusive content, enjoying subscription perks, and offering tips to support the artists you admire.",
        icon: (0, $jFMqv.icons).GrowIcon
    },
    {
        id: "737469ca-8263-49a5-9752-3d3d9a99ce11",
        title: "NEVER MISS A BEAT",
        description: "Stay updated and never miss out!! Stay in the loop with instant notifications whenever your favourite artists drop new tracks or media posts.",
        icon: (0, $jFMqv.icons).NotificationIcon
    }
];
const $af35c188c0ccb05c$export$9fef70fa27af7bc2 = [
    {
        id: "c9fee612-e208-4360-8a9e-bf34a97c7b9c",
        title: "SHARE CONTENT AND EARN",
        description: "Earn more money than ever before by sharing exclusive music, video clips, photo, or text. Just share content with your fans and get paid directly.",
        icon: (0, $jFMqv.icons).FireIcon
    },
    {
        id: "9f765252-cf75-4667-8089-c567a956e0de",
        title: "GROW FROM THE VERY BEGINNING",
        description: "Our algorithms are concentrated for artist growth and help promote new music to listeners with similar taste!",
        icon: (0, $jFMqv.icons).GrowIcon
    },
    {
        id: "9e45d811-42eb-4b14-bbc1-4e67987531ad",
        title: "RETAIN ENGAGEMENT",
        description: "Fans will be notified with every release and post that you publish! Show demos and snippets to subscribers far ahead of the release to be closer to them.",
        icon: (0, $jFMqv.icons).NotificationIcon
    }
];

});
parcelRegister("jFMqv", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $1e242ecfdbb0bc48$export$df03f54e09e486fa; });

var $34hHQ = parcelRequire("34hHQ");

var $4sxBY = parcelRequire("4sxBY");

var $3Buir = parcelRequire("3Buir");
const $1e242ecfdbb0bc48$export$df03f54e09e486fa = {
    FireIcon: $34hHQ.default,
    GrowIcon: $4sxBY.default,
    NotificationIcon: $3Buir.default
};

});
parcelRegister("34hHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74ce4b70e28c0312$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $74ce4b70e28c0312$var$SvgFire = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 48 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.693 3.763C17.77 1.067 21.32-.6 24.073 1.498c4.586 3.494 10.34 8.63 14.967 14.505 4.586 5.822 8.294 12.656 8.294 19.497 0 6.115-1.894 10.66-4.636 13.915-2.715 3.223-6.166 5.07-9.147 5.997-1.53.477-2.93-.225-3.61-1.367a3.375 3.375 0 0 1 .156-3.657c2.286-3.285 4.703-8.01 4.703-12.221 0-2.09-.9-4.563-2.355-7.101-1.094-1.909-2.434-3.74-3.74-5.309-.27 3.741-1.084 8.442-3.606 12.329-1.146 1.766-3.694 1.963-5.05.248a41.279 41.279 0 0 1-1.294-1.76c-.21-.293-.408-.572-.601-.834-1.829 1.821-3.531 4-3.531 6.427 0 2.143 1.07 5.073 2.335 7.555a3.46 3.46 0 0 1-.426 3.806c-.876 1.037-2.47 1.57-3.983.694C7.365 51.22.667 44.81.667 35.5c0-2.525.856-5.137 2.054-7.689 1.206-2.568 2.841-5.244 4.559-7.918.595-.926 1.199-1.852 1.802-2.775 2.945-4.514 5.866-8.99 7.61-13.355Zm4.37.85a1.116 1.116 0 0 0-.656.634c-1.907 4.773-5.1 9.659-8.046 14.167-.586.897-1.162 1.778-1.716 2.64-1.704 2.655-3.217 5.144-4.303 7.457-1.095 2.331-1.675 4.319-1.675 5.989 0 6.119 3.75 10.87 7.688 13.809-.946-2.243-1.732-4.83-1.732-7.142 0-4.615 3.465-8.1 5.401-9.933 1.254-1.188 3.42-1.294 4.682.263.457.564.903 1.189 1.309 1.76l.048.067c.114.16.224.316.333.467 1.783-3.398 2.283-7.543 2.407-10.954a3.324 3.324 0 0 1 2.063-2.979 3.2 3.2 0 0 1 3.61.837l-1.483 1.341 1.483-1.34c1.777 1.965 3.825 4.563 5.44 7.38 1.593 2.78 2.884 5.978 2.884 9.09 0 4.514-2.047 9.094-4.116 12.503 1.738-.851 3.492-2.095 4.955-3.831 2.098-2.491 3.695-6.108 3.695-11.338 0-5.485-3.034-11.432-7.437-17.022C31.536 12.941 26.052 8.034 21.65 4.68c-.146-.111-.334-.154-.587-.067Z",
            fill: "#FFF"
        })
    });
var $74ce4b70e28c0312$export$2e2bcd8739ae039 = $74ce4b70e28c0312$var$SvgFire;

});

parcelRegister("4sxBY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9286ee6bcd10b2d2$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $9286ee6bcd10b2d2$var$SvgGrow = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 58 58",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29.131.333h-.263c-1.773 0-3.3 0-4.524.165-1.31.176-2.568.573-3.587 1.593-1.02 1.02-1.417 2.276-1.593 3.587C18.999 6.9 19 8.428 19 10.202v6.473a5.99 5.99 0 0 0-2-.342H9a6 6 0 0 0-6 6v31.334h-.667a2 2 0 1 0 0 4h53.333a2 2 0 1 0 0-4H55v-18a6 6 0 0 0-6-6h-8a5.99 5.99 0 0 0-2 .341V10.202c0-1.773 0-3.3-.165-4.524-.176-1.311-.573-2.568-1.593-3.587C36.223 1.07 34.966.674 33.655.498c-1.223-.165-2.75-.165-4.524-.165ZM51 53.667v-18a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v18h12Zm-16 0V10.333c0-1.942-.005-3.197-.129-4.122-.117-.868-.305-1.14-.457-1.292-.152-.152-.424-.34-1.292-.457-.925-.124-2.18-.129-4.122-.129-1.942 0-3.198.005-4.123.129-.867.117-1.14.305-1.291.457-.153.152-.341.424-.458 1.292-.124.925-.128 2.18-.128 4.122v43.334h12Zm-16 0V22.333a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v31.334h12Z",
            fill: "#FFF"
        })
    });
var $9286ee6bcd10b2d2$export$2e2bcd8739ae039 = $9286ee6bcd10b2d2$var$SvgGrow;

});

parcelRegister("3Buir", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5722471bb544dac$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $e5722471bb544dac$var$SvgNotification = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 54 59",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M29 13.5a2 2 0 0 0-4 0v10.667a2 2 0 1 0 4 0V13.5Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.333 21.5C6.333 10.086 15.586.833 27 .833c11.414 0 20.666 9.253 20.666 20.667v1.878c0 1.858.55 3.675 1.581 5.221l3.063 4.595c3.555 5.332.841 12.58-5.342 14.266a75.9 75.9 0 0 1-6.09 1.395l-.006.014c-2.05 5.471-7.531 9.298-13.872 9.298-6.342 0-11.822-3.827-13.873-9.298l-.005-.014A75.888 75.888 0 0 1 7.03 47.46c-6.183-1.686-8.897-8.934-5.342-14.266l3.063-4.595a9.413 9.413 0 0 0 1.581-5.221V21.5Zm11.663 28.099a75.901 75.901 0 0 0 18.008 0c-1.896 2.724-5.194 4.568-9.004 4.568-3.811 0-7.108-1.844-9.004-4.568ZM27 4.833c-9.205 0-16.667 7.462-16.667 16.667v1.878c0 2.648-.784 5.237-2.253 7.44l-3.063 4.595c-2.04 3.06-.482 7.22 3.067 8.188a71.891 71.891 0 0 0 37.832 0c3.549-.968 5.107-5.128 3.066-8.188l-3.063-4.595a13.414 13.414 0 0 1-2.253-7.44V21.5c0-9.205-7.461-16.667-16.666-16.667Z",
                fill: "#FFF"
            })
        ]
    });
var $e5722471bb544dac$export$2e2bcd8739ae039 = $e5722471bb544dac$var$SvgNotification;

});



parcelRegister("34kwD", function(module, exports) {

$parcel$export(module.exports, "Role", function () { return (parcelRequire("efeB2")).Role; });

var $efeB2 = parcelRequire("efeB2");

});
parcelRegister("efeB2", function(module, exports) {

$parcel$export(module.exports, "Role", function () { return $7d0ae12186bb5efc$export$46919bad18fb2f76; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("7nPw2");
var $5azXF = parcelRequire("5azXF");
var $8qZ6N = parcelRequire("8qZ6N");

var $jLSos = parcelRequire("jLSos");
const $7d0ae12186bb5efc$export$46919bad18fb2f76 = ({ name: name, features: features, visible: visible, loading: loading, onRoleMouseEnter: onRoleMouseEnter, onRoleMouseLeave: onRoleMouseLeave, onNextClick: onNextClick, appearance: appearance = "primary" })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: [
            (0, $jLSos.styles)(theme).role.main.shared(visible),
            appearance === "primary" && (0, $jLSos.styles)(theme).role.main.primary,
            appearance === "secondary" && (0, $jLSos.styles)(theme).role.main.secondary,
            "",
            ""
        ],
        onMouseEnter: (e)=>onRoleMouseEnter(e),
        onMouseLeave: (e)=>onRoleMouseLeave(e),
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $jLSos.styles)(theme).role.content.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $jLSos.styles)(theme).role.content.title,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $8qZ6N.Title), {
                        text: name,
                        appearance: appearance
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $jLSos.styles)(theme).role.content.features,
                    children: features.map((feature)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5azXF.Feature), {
                            ...feature,
                            appearance: appearance
                        }, feature.id))
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $jLSos.styles)(theme).role.content.next,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        onClick: (e)=>onNextClick(e),
                        "aria-label": `select role ${name}`,
                        disabled: loading,
                        appearance: appearance === "primary" ? "secondary" : "primary",
                        children: loading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Become a ${name}`
                    })
                })
            ]
        })
    });
};
$7d0ae12186bb5efc$export$46919bad18fb2f76.propTypes = {};

});
parcelRegister("7nPw2", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return (parcelRequire("5azXF")).Feature; });
$parcel$export(module.exports, "Title", function () { return (parcelRequire("8qZ6N")).Title; });

var $5azXF = parcelRequire("5azXF");

var $8qZ6N = parcelRequire("8qZ6N");

});
parcelRegister("5azXF", function(module, exports) {

$parcel$export(module.exports, "Feature", function () { return $6cf22aba720dbf60$export$6e91cf7616333d5; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $eVTt2 = parcelRequire("eVTt2");
const $6cf22aba720dbf60$export$6e91cf7616333d5 = ({ title: title, description: description, icon: Icon, appearance: appearance = "primary" })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $eVTt2.styles)(theme).feature.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eVTt2.styles)(theme).feature.icon.main,
                children: Icon && /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {
                    css: [
                        (0, $eVTt2.styles)(theme).feature.icon.content.shared,
                        appearance === "primary" && (0, $eVTt2.styles)(theme).feature.icon.content.primary,
                        appearance === "secondary" && (0, $eVTt2.styles)(theme).feature.icon.content.secondary,
                        "",
                        ""
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: [
                    (0, $eVTt2.styles)(theme).feature.content.main.shared,
                    appearance === "primary" && (0, $eVTt2.styles)(theme).feature.content.main.primary,
                    appearance === "secondary" && (0, $eVTt2.styles)(theme).feature.content.main.secondary,
                    "",
                    ""
                ],
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eVTt2.styles)(theme).feature.content.title,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eVTt2.styles)(theme).feature.content.description,
                        children: description
                    })
                ]
            })
        ]
    });
};
$6cf22aba720dbf60$export$6e91cf7616333d5.propTypes = {};

});
parcelRegister("eVTt2", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $be079c2bb414b7ea$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $be079c2bb414b7ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $be079c2bb414b7ea$var$_ref = {
    name: "1azakc",
    styles: "text-align:center"
};
var $be079c2bb414b7ea$var$_ref2 = {
    name: "xjpx28",
    styles: "width:58px;height:58px"
};
var $be079c2bb414b7ea$var$_ref3 = {
    name: "1o8qm9w",
    styles: "align-self:center;margin-right:0px;margin-bottom:20px"
};
var $be079c2bb414b7ea$var$_ref4 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $be079c2bb414b7ea$export$9dd6ff9ea0189349 = (theme)=>({
        feature: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).mobile($be079c2bb414b7ea$var$_ref4), ";", ""),
            icon: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:80px;height:80px;margin-right:24px;", (0, $gln0L.mq).mobile($be079c2bb414b7ea$var$_ref3), ";", ""),
                content: {
                    shared: $be079c2bb414b7ea$var$_ref2,
                    primary: /*#__PURE__*/ (0, $7hler.css)("&>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    secondary: /*#__PURE__*/ (0, $7hler.css)("&>path{fill:", theme.colors.accent.normal, ";}", "")
                }
            },
            content: {
                main: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($be079c2bb414b7ea$var$_ref), ";", ""),
                    primary: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.primary.normal, ";", ""),
                    secondary: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";", "")
                },
                title: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;text-transform:uppercase;", ""),
                description: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("8qZ6N", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $de897e7bf2584ec2$export$f99233281efd08a0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $fusZh = parcelRequire("fusZh");
const $de897e7bf2584ec2$export$f99233281efd08a0 = ({ text: text, appearance: appearance = "primary" })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fusZh.styles)(theme).title.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("h1", {
            css: [
                (0, $fusZh.styles)(theme).title.text.shared,
                appearance === "primary" && (0, $fusZh.styles)(theme).title.text.primary,
                appearance === "secondary" && (0, $fusZh.styles)(theme).title.text.secondary,
                "",
                ""
            ],
            children: text
        })
    });
};
$de897e7bf2584ec2$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("fusZh", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d103a2d4c2f4b32d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $d103a2d4c2f4b32d$export$9dd6ff9ea0189349 = (theme)=>({
        title: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            text: {
                shared: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h3, ";font-weight:bold;text-align:center;", ""),
                primary: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.primary.normal, ";", ""),
                secondary: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";", "")
            }
        }
    });

});



parcelRegister("jLSos", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $00548a37473ce454$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $00548a37473ce454$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $00548a37473ce454$var$_ref = {
    name: "1azpx8r",
    styles: "margin-bottom:20px"
};
var $00548a37473ce454$var$_ref2 = {
    name: "1omtx6o",
    styles: "&>div:not(:last-of-type){margin-bottom:20px;}"
};
var $00548a37473ce454$var$_ref3 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $00548a37473ce454$var$_ref4 = {
    name: "1k0e75g",
    styles: "display:flex;flex-direction:column;max-width:740px;width:100%"
};
var $00548a37473ce454$var$_ref5 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $00548a37473ce454$var$_ref6 = {
    name: "1hy92ex",
    styles: "opacity:0.1"
};
const $00548a37473ce454$export$9dd6ff9ea0189349 = (theme)=>({
        role: {
            main: {
                shared: (hover)=>/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.full, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;transition:opacity 0.4s;", !hover && $00548a37473ce454$var$_ref6, " ", (0, $gln0L.mq).tablet($00548a37473ce454$var$_ref5), ";", ""),
                primary: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.accent.normal, ";", ""),
                secondary: /*#__PURE__*/ (0, $7hler.css)("background-color:", theme.colors.primary.darker, ";", "")
            },
            content: {
                main: $00548a37473ce454$var$_ref4,
                title: /*#__PURE__*/ (0, $7hler.css)("margin-bottom:60px;", (0, $gln0L.mq).mobile($00548a37473ce454$var$_ref3), ";", ""),
                features: /*#__PURE__*/ (0, $7hler.css)("margin-bottom:60px;&>div:not(:last-of-type){margin-bottom:50px;}", (0, $gln0L.mq).mobile($00548a37473ce454$var$_ref2), ";", ""),
                next: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:center;&>button{max-width:380px;}", (0, $gln0L.mq).mobile($00548a37473ce454$var$_ref), ";", "")
            }
        }
    });

});



parcelRegister("hjTVU", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2a47921d96a5fadc$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2a47921d96a5fadc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2a47921d96a5fadc$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $2a47921d96a5fadc$var$_ref2 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
const $2a47921d96a5fadc$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";width:100%;height:100%;overflow:hidden;overflow-y:scroll;", ""),
            backward: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                button: /*#__PURE__*/ (0, $7hler.css)("", ""),
                icon: $2a47921d96a5fadc$var$_ref2
            },
            role: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:grid;grid-template-rows:repeat(1, 1fr);grid-template-columns:repeat(2, 1fr);width:100%;height:100%;", (0, $gln0L.mq).tablet($2a47921d96a5fadc$var$_ref), ";", ""),
                fan: /*#__PURE__*/ (0, $7hler.css)("", ""),
                artist: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});


parcelRegister("iToJs", function(module, exports) {

$parcel$export(module.exports, "UploadTracks", function () { return $67bb3325d8b941c7$export$ead49df769534942; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $7676a = parcelRequire("7676a");
var $kwNyE = parcelRequire("kwNyE");
var $gRqmZ = parcelRequire("gRqmZ");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $lIoWX = parcelRequire("lIoWX");
var $ly71s = parcelRequire("ly71s");
var $2oiNd = parcelRequire("2oiNd");
parcelRequire("iI2SL");
var $fiOLd = parcelRequire("fiOLd");
var $idO8L = parcelRequire("idO8L");

var $dsoZE = parcelRequire("dsoZE");
const $67bb3325d8b941c7$export$ead49df769534942 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackCreateLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackCreateLoading));
    const uploadedTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksLength));
    const onboardingError = "";
    const trackCreateError = "";
    (0, $bh6RR.useEffect)(()=>{
        // fetch profile tracks
        dispatch((0, $kwNyE.trackGetUploadedTracks)({}));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dsoZE.styles)().stage.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dsoZE.styles)().stage.backward.button,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lIoWX.ButtonRound), {
                    "aria-label": "set previous onboarding stage",
                    appearance: "secondary",
                    onClick: ()=>dispatch((0, $7676a.onboardingSetPrevStage)()),
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ArrowLeft, {
                        css: (0, $dsoZE.styles)().stage.backward.icon
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $dsoZE.styles)().stage.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dsoZE.styles)().stage.content.title,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2oiNd.Subtitle), {
                            text: "Upload your first track to RYDDM!"
                        })
                    }),
                    !trackCreateLoading && uploadedTracksLength > 0 && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $dsoZE.styles)().stage.content.tracks,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $gRqmZ.TrackListOnboardingUploaded), {}),
                            /*#__PURE__*/ (0, $9awXB.jsx)((0, $fiOLd.Divider), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dsoZE.styles)().stage.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $idO8L.Form), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dsoZE.styles)().stage.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: onboardingError || trackCreateError
                        })
                    })
                ]
            })
        ]
    });
};
$67bb3325d8b941c7$export$ead49df769534942.propTypes = {};

});
parcelRegister("iI2SL", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return (parcelRequire("fiOLd")).Divider; });
$parcel$export(module.exports, "Form", function () { return (parcelRequire("idO8L")).Form; });

var $fiOLd = parcelRequire("fiOLd");

var $idO8L = parcelRequire("idO8L");

});
parcelRegister("fiOLd", function(module, exports) {

$parcel$export(module.exports, "Divider", function () { return $9cfa162ee1cead16$export$2e0a83ec2e27ecbb; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $9lazF = parcelRequire("9lazF");
const $9cfa162ee1cead16$export$2e0a83ec2e27ecbb = ()=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9lazF.styles)(theme).divider.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $9lazF.styles)(theme).divider.bar
        })
    });
};
$9cfa162ee1cead16$export$2e0a83ec2e27ecbb.propTypes = {};

});
parcelRegister("9lazF", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $872bd1a8aff7b49d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $872bd1a8aff7b49d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $872bd1a8aff7b49d$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $872bd1a8aff7b49d$export$9dd6ff9ea0189349 = (theme)=>({
        divider: {
            main: $872bd1a8aff7b49d$var$_ref,
            bar: /*#__PURE__*/ (0, $7hler.css)("height:1px;width:100%;background-color:", theme.colors.secondary.darkHover, ";", "")
        }
    });

});


parcelRegister("idO8L", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $9aca11a221a78ddf$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $9srzl = parcelRequire("9srzl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $3EkqN = parcelRequire("3EkqN");
var $7676a = parcelRequire("7676a");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $l7e6s = parcelRequire("l7e6s");
var $ly71s = parcelRequire("ly71s");
var $gW5Rq = parcelRequire("gW5Rq");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("4eCXo");
var $6CiLf = parcelRequire("6CiLf");
var $15iSu = parcelRequire("15iSu");

var $coG6S = parcelRequire("coG6S");
const $9aca11a221a78ddf$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const onboardingLoading = (0, $gNvvs.useAppSelector)((0, $3EkqN.onboardingSelectLoading));
    const uploadedTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksLength));
    const trackCreateLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackCreateLoading));
    // cover state
    const [cover, setCover] = (0, $bh6RR.useState)(undefined);
    const [coverPreview, setCoverPreview] = (0, $bh6RR.useState)("");
    const coverFileInputRef = (0, $bh6RR.useRef)(null);
    const [coverError, setCoverError] = (0, $bh6RR.useState)("");
    // track state
    const [track, setTrack] = (0, $bh6RR.useState)(undefined);
    const [trackFileName, setTrackFileName] = (0, $bh6RR.useState)("");
    const trackFileInputRef = (0, $bh6RR.useRef)(null);
    const [trackError, setTrackError] = (0, $bh6RR.useState)("");
    // name state
    const [name, setName] = (0, $bh6RR.useState)("");
    const [nameError, setNameError] = (0, $bh6RR.useState)("");
    const submitDisabled = onboardingLoading || trackCreateLoading;
    const uploadDisabled = name.length < (0, $9srzl.minTrackNameLength) || name.length > (0, $9srzl.maxTrackNameLength) || track === undefined || coverError !== "" || trackError !== "" || nameError !== "" || trackCreateLoading || onboardingLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setCover(undefined);
        setTrack(undefined);
        setName("");
        setTrackFileName("");
        // if cover preview was set
        if (coverPreview) {
            // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            setCoverPreview("");
        }
    };
    const onCoverClick = ()=>{
        coverFileInputRef.current?.click();
        setCoverError("");
    };
    const onTrackClick = ()=>{
        trackFileInputRef.current?.click();
        setTrackError("");
    };
    const onCoverFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validateCoverFile)(file);
            if (error) {
                setCoverError(error);
                return;
            }
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            // set file as a preview
            setCoverPreview(URL.createObjectURL(file));
            // store file in state
            setCover(file);
        }
    };
    const onTrackFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validateTrackFile)(file);
            if (error) {
                setTrackError(error);
                return;
            }
            // store file name in state
            setTrackFileName(file.name);
            // store file in state
            setTrack(file);
        }
    };
    (0, $bh6RR.useEffect)(()=>()=>{
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
        });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $coG6S.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $coG6S.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $7676a.onboardingSetNextStage)());
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $coG6S.styles)().form.content.inputs.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $coG6S.styles)().form.content.inputs.cover.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                                    css: (0, $coG6S.styles)().form.content.inputs.cover.label,
                                    htmlFor: "cover",
                                    children: [
                                        "cover",
                                        /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                            css: (0, $coG6S.styles)().form.content.inputs.cover.input,
                                            name: "cover",
                                            type: "file",
                                            id: "cover",
                                            ref: coverFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png",
                                            onChange: (e)=>onCoverFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)((0, $6CiLf.Cover), {
                                    onClick: ()=>onCoverClick(),
                                    source: coverPreview
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $coG6S.styles)().form.content.inputs.track.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $coG6S.styles)().form.content.inputs.track.name.main,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gW5Rq.InputBar), {
                                        name: "name",
                                        label: "name",
                                        type: "text",
                                        placeholder: "Enter track name",
                                        value: name,
                                        error: nameError.length > 0,
                                        errorMessage: nameError,
                                        min: (0, $9srzl.minTrackNameLength),
                                        max: (0, $9srzl.maxTrackNameLength),
                                        onChange: (e)=>{
                                            setName(e.target.value);
                                        },
                                        onBlur: ()=>setNameError((0, $lRNbG.validateTrackName)(name)),
                                        onFocus: ()=>setNameError("")
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $coG6S.styles)().form.content.inputs.track.file.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                                            css: (0, $coG6S.styles)().form.content.inputs.track.file.label,
                                            htmlFor: "track",
                                            children: [
                                                "track",
                                                /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                                    css: (0, $coG6S.styles)().form.content.inputs.track.file.input,
                                                    name: "track",
                                                    type: "file",
                                                    id: "track",
                                                    ref: trackFileInputRef,
                                                    accept: ".mp3",
                                                    onChange: (e)=>onTrackFileChange(e)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $15iSu.Track), {
                                            onClick: ()=>onTrackClick(),
                                            fileName: trackFileName
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $coG6S.styles)().form.content.inputs.upload,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                                type: "button",
                                "aria-label": "upload track",
                                appearance: "primary",
                                disabled: uploadDisabled,
                                onClick: ()=>{
                                    dispatch((0, $kwNyE.trackCreate)({
                                        name: name,
                                        genres: [],
                                        track: track,
                                        cover: cover
                                    }));
                                    cleanupState();
                                },
                                children: trackCreateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                    width: 40,
                                    height: 20,
                                    appearance: "primary"
                                }) : "Upload"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $coG6S.styles)().form.content.error,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                        error: coverError || trackError
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $coG6S.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "proceed to next onboarding stage",
                        disabled: submitDisabled,
                        appearance: uploadedTracksLength > 0 ? "primary" : "secondary",
                        children: onboardingLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Next"
                    })
                })
            ]
        })
    });
};
$9aca11a221a78ddf$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("4eCXo", function(module, exports) {

$parcel$export(module.exports, "Cover", function () { return (parcelRequire("6CiLf")).Cover; });
$parcel$export(module.exports, "Track", function () { return (parcelRequire("15iSu")).Track; });

var $6CiLf = parcelRequire("6CiLf");

var $15iSu = parcelRequire("15iSu");

});
parcelRegister("6CiLf", function(module, exports) {

$parcel$export(module.exports, "Cover", function () { return $5c3a3bad68827810$export$64da1bd56a7c875f; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $8QEgE = parcelRequire("8QEgE");
const $5c3a3bad68827810$export$64da1bd56a7c875f = ({ source: source, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $8QEgE.styles)(theme).cover.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
            css: (0, $8QEgE.styles)(theme).cover.button,
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "change track cover",
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8QEgE.styles)(theme).cover.image.main,
                children: source ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $8QEgE.styles)(theme).cover.image.content,
                    loading: "lazy",
                    width: "136px",
                    height: "136px",
                    src: source,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).ImageDownload, {
                    css: (0, $8QEgE.styles)(theme).cover.image.icon
                })
            })
        })
    });
};
$5c3a3bad68827810$export$64da1bd56a7c875f.propTypes = {};

});
parcelRegister("8QEgE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $304d799f97ae78a5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $304d799f97ae78a5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $304d799f97ae78a5$var$_ref = {
    name: "ic1kkf",
    styles: "position:relative;width:136px;height:136px;border-radius:4px;overflow:hidden"
};
const $304d799f97ae78a5$export$9dd6ff9ea0189349 = (theme)=>({
        cover: {
            main: $304d799f97ae78a5$var$_ref,
            button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:100%;cursor:pointer;", ""),
            image: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:136px;height:136px;background-color:", theme.colors.secondary.darker, ";overflow:hidden;", ""),
                content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px;", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:40px;height:40px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            }
        }
    });

});


parcelRegister("15iSu", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $b37a18122b5f45de$export$13921ac0cc260818; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $avqgo = parcelRequire("avqgo");
const $b37a18122b5f45de$export$13921ac0cc260818 = ({ fileName: fileName, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $avqgo.styles)(theme).track.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
            css: [
                (0, $avqgo.styles)(theme).track.button.shared,
                fileName ? (0, $avqgo.styles)(theme).track.button.filled : (0, $avqgo.styles)(theme).track.button.empty,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": "change track file",
            children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $avqgo.styles)(theme).track.button.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $avqgo.styles)(theme).track.button.content.name,
                        children: fileName || `Select track (.mp3)`
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $avqgo.styles)(theme).track.button.content.icon,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Upload, {})
                    })
                ]
            })
        })
    });
};
$b37a18122b5f45de$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("avqgo", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $40daec2cfb7d3153$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $40daec2cfb7d3153$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $40daec2cfb7d3153$var$_ref = {
    name: "gjwf77",
    styles: "display:flex;align-items:center;margin-left:6px;&>svg{width:24px;height:24px;}"
};
var $40daec2cfb7d3153$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
var $40daec2cfb7d3153$var$_ref3 = {
    name: "1dvgrzx",
    styles: "height:50px;padding:12px 26px"
};
var $40daec2cfb7d3153$var$_ref4 = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $40daec2cfb7d3153$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $40daec2cfb7d3153$var$_ref4,
            button: {
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:56px;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).h6, ";border-radius:20px;padding:14px 32px;transition:border 0.2s,color 0.2s;cursor:pointer;", (0, $gln0L.mq).mobile($40daec2cfb7d3153$var$_ref3), ";", ""),
                empty: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.darkHover, ";color:", theme.colors.secondary.darkHover, ";", ""),
                filled: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.normal, ";color:", theme.colors.secondary.normal, ";", ""),
                content: {
                    main: $40daec2cfb7d3153$var$_ref2,
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";margin-right:auto;", ""),
                    icon: $40daec2cfb7d3153$var$_ref
                }
            }
        }
    });

});



parcelRegister("coG6S", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d9291bea4b569385$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $d9291bea4b569385$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d9291bea4b569385$var$_ref = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d9291bea4b569385$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d9291bea4b569385$var$_ref3 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $d9291bea4b569385$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d9291bea4b569385$var$_ref5 = {
    name: "eivff4",
    styles: "display:none"
};
var $d9291bea4b569385$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $d9291bea4b569385$var$_ref7 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $d9291bea4b569385$var$_ref8 = {
    name: "zs54pd",
    styles: "margin-right:0px;margin-bottom:24px"
};
var $d9291bea4b569385$var$_ref9 = {
    name: "eivff4",
    styles: "display:none"
};
var $d9291bea4b569385$var$_ref10 = {
    name: "eivff4",
    styles: "display:none"
};
var $d9291bea4b569385$var$_ref11 = {
    name: "zs54pd",
    styles: "margin-right:0px;margin-bottom:24px"
};
var $d9291bea4b569385$var$_ref12 = {
    name: "1f9uc99",
    styles: "flex-direction:column;align-items:center"
};
var $d9291bea4b569385$var$_ref13 = {
    name: "b6wrti",
    styles: "display:flex;flex-direction:column;width:100%"
};
var $d9291bea4b569385$var$_ref14 = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $d9291bea4b569385$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: $d9291bea4b569385$var$_ref14,
            content: {
                main: $d9291bea4b569385$var$_ref13,
                inputs: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-bottom:16px;justify-content:center;", (0, $gln0L.mq).tablet($d9291bea4b569385$var$_ref12), ";", ""),
                    cover: {
                        main: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;margin-right:24px;", (0, $gln0L.mq).tablet($d9291bea4b569385$var$_ref11), ";", ""),
                        label: $d9291bea4b569385$var$_ref10,
                        input: $d9291bea4b569385$var$_ref9
                    },
                    track: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:100%;max-width:380px;margin-right:24px;", (0, $gln0L.mq).tablet($d9291bea4b569385$var$_ref8), ";", ""),
                        name: {
                            main: $d9291bea4b569385$var$_ref7
                        },
                        file: {
                            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                            label: $d9291bea4b569385$var$_ref6,
                            input: $d9291bea4b569385$var$_ref5
                        }
                    },
                    upload: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:136px;", (0, $gln0L.mq).mobile($d9291bea4b569385$var$_ref4), ";", "")
                },
                error: $d9291bea4b569385$var$_ref3,
                submit: /*#__PURE__*/ (0, $7hler.css)("align-self:center;", (0, $gln0L.mq).mobile($d9291bea4b569385$var$_ref2), " &>button{width:380px;", (0, $gln0L.mq).mobile($d9291bea4b569385$var$_ref), ";}", "")
            }
        }
    });

});



parcelRegister("dsoZE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fb917e24909e57e2$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $fb917e24909e57e2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fb917e24909e57e2$var$_ref = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $fb917e24909e57e2$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $fb917e24909e57e2$var$_ref3 = {
    name: "52b1oc",
    styles: "padding:0px"
};
var $fb917e24909e57e2$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $fb917e24909e57e2$var$_ref5 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $fb917e24909e57e2$var$_ref6 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $fb917e24909e57e2$var$_ref7 = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
var $fb917e24909e57e2$var$_ref8 = {
    name: "1odw3ck",
    styles: "flex:1;display:flex;align-items:center;justify-content:center;width:100%"
};
const $fb917e24909e57e2$export$9dd6ff9ea0189349 = ()=>({
        stage: {
            main: $fb917e24909e57e2$var$_ref8,
            backward: {
                button: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).onboarding.backward, ";position:fixed;top:20px;left:20px;", ""),
                icon: $fb917e24909e57e2$var$_ref7
            },
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:760px;", (0, $gln0L.mq).mobile($fb917e24909e57e2$var$_ref6), ";", ""),
                title: $fb917e24909e57e2$var$_ref5,
                tracks: /*#__PURE__*/ (0, $7hler.css)("padding:0px 30px;&>div:nth-of-type(1){margin-bottom:32px;}&>div:nth-of-type(2){margin-bottom:32px;", (0, $gln0L.mq).mobile($fb917e24909e57e2$var$_ref4), ";}", (0, $gln0L.mq).tablet($fb917e24909e57e2$var$_ref3), " ", (0, $gln0L.mq).mobile($fb917e24909e57e2$var$_ref2), ";", ""),
                form: $fb917e24909e57e2$var$_ref,
                error: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("bbijD", function(module, exports) {

$parcel$export(module.exports, "fanOnboardingSteps", function () { return $0ce9a35f966382f8$export$5c1b8a6a4ebd5db; });
$parcel$export(module.exports, "artistOnboardingSteps", function () { return $0ce9a35f966382f8$export$8b34b26852c483c1; });
const $0ce9a35f966382f8$export$5c1b8a6a4ebd5db = [
    {
        id: "eb52306b-ff26-4f4a-8c00-77818ba31f33",
        description: "Create Profile"
    },
    {
        id: "19841cbf-0af9-494a-8e0a-68e9a967330a",
        description: "Select Genres"
    },
    {
        id: "4698fbb5-95bf-4f17-ad6e-d5a787acdc50",
        description: "Follow Artists"
    },
    {
        id: "f066d4bf-7db4-4407-a191-f07f5b0bbee8",
        description: "Configure Notifications"
    }
];
const $0ce9a35f966382f8$export$8b34b26852c483c1 = [
    {
        id: "2aa1e99c-af39-4c77-8707-3eef32015eb7",
        description: "Create Profile"
    },
    {
        id: "a28a9eca-23a5-40c5-ad18-02ab40821bb1",
        description: "Upload Tracks"
    },
    {
        id: "525901d6-6cef-452c-9ce7-675c06e4c72f",
        description: "Enable Monetization"
    },
    {
        id: "14ec6508-41d9-4641-8e64-3560e462da70",
        description: "Configure Notifications"
    }
];

});

parcelRegister("14bds", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $578e9a3d310d9481$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $578e9a3d310d9481$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $578e9a3d310d9481$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
var $578e9a3d310d9481$var$_ref2 = {
    name: "9w34mz",
    styles: "display:flex;width:100%;height:100%;position:fixed;left:0;right:0"
};
const $578e9a3d310d9481$export$9dd6ff9ea0189349 = ()=>({
        onboarding: {
            main: $578e9a3d310d9481$var$_ref2,
            stage: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;width:100%;height:100%;overflow:hidden;overflow-y:scroll;&>div:nth-of-type(2){width:100%;max-width:760px;margin:0 auto;}", ""),
            role: $578e9a3d310d9481$var$_ref
        }
    });

});



parcelRegister("3EkqN", function(module, exports) {

$parcel$export(module.exports, "onboardingSlice", function () { return $81d885621bcbb657$export$b6177dfe2a583549; });
$parcel$export(module.exports, "onboardingSetError", function () { return $81d885621bcbb657$export$42ed5835b75dfec2; });
$parcel$export(module.exports, "onboardingSelectStep", function () { return $81d885621bcbb657$export$bd1d5b2cdc081f94; });
$parcel$export(module.exports, "onboardingSelectConnectLink", function () { return $81d885621bcbb657$export$7fd9a685a7b05236; });
$parcel$export(module.exports, "onboardingSelectError", function () { return $81d885621bcbb657$export$6cdeab2c12935ae9; });
$parcel$export(module.exports, "onboardingSelectLoading", function () { return $81d885621bcbb657$export$879fd1bbe61011a4; });
$parcel$export(module.exports, "onboardingReducer", function () { return $81d885621bcbb657$export$4b19e5acc18169e1; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $7676a = parcelRequire("7676a");
const $81d885621bcbb657$var$initialState = {
    step: 0,
    connectLink: "",
    error: "",
    loading: false
};
const $81d885621bcbb657$export$b6177dfe2a583549 = (0, $kvj5V.createSlice)({
    name: "onboarding",
    initialState: $81d885621bcbb657$var$initialState,
    reducers: {
        // set error
        onboardingSetError: (state, action)=>({
                ...state,
                error: action.payload
            })
    },
    extraReducers: (builder)=>{
        // set current onboarding step (on refresh)
        builder.addCase((0, $7676a.onboardingSetCurrentStep).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $7676a.onboardingSetCurrentStep).fulfilled, (state, { payload: payload })=>({
                ...state,
                step: payload.step,
                error: payload.error,
                loading: false
            }));
        // set next onboarding stage
        builder.addCase((0, $7676a.onboardingSetNextStage).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $7676a.onboardingSetNextStage).fulfilled, (state, { payload: payload })=>({
                ...state,
                step: payload.step,
                error: payload.error,
                loading: false
            }));
        // set prev onboarding stage
        builder.addCase((0, $7676a.onboardingSetPrevStage).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $7676a.onboardingSetPrevStage).fulfilled, (state, { payload: payload })=>({
                ...state,
                step: payload.step,
                error: payload.error,
                loading: false
            }));
        // select user role
        builder.addCase((0, $7676a.onboardingUpdateRole).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $7676a.onboardingUpdateRole).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // create profile
        builder.addCase((0, $7676a.onboardingUpdateProfile).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $7676a.onboardingUpdateProfile).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // select genres
        builder.addCase((0, $7676a.onboardingUpdateGenres).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $7676a.onboardingUpdateGenres).fulfilled, (state, { payload: payload })=>({
                ...state,
                error: payload.error,
                loading: false
            }));
        // get connect link
        builder.addCase((0, $7676a.onboardingGetConnectLink).pending, (state)=>({
                ...state,
                loading: true
            })).addCase((0, $7676a.onboardingGetConnectLink).fulfilled, (state, { payload: payload })=>({
                ...state,
                connectLink: payload.connectLink,
                error: payload.error,
                loading: false
            }));
    }
});
const { onboardingSetError: $81d885621bcbb657$export$42ed5835b75dfec2 } = $81d885621bcbb657$export$b6177dfe2a583549.actions;
const $81d885621bcbb657$export$bd1d5b2cdc081f94 = (state)=>state.onboarding.step;
const $81d885621bcbb657$export$7fd9a685a7b05236 = (state)=>state.onboarding.connectLink;
const $81d885621bcbb657$export$6cdeab2c12935ae9 = (state)=>state.onboarding.error;
const $81d885621bcbb657$export$879fd1bbe61011a4 = (state)=>state.onboarding.loading;
const $81d885621bcbb657$export$4b19e5acc18169e1 = $81d885621bcbb657$export$b6177dfe2a583549.reducer; // export default onboardingSlice.reducer

});

parcelRegister("7676a", function(module, exports) {

$parcel$export(module.exports, "onboardingSetCurrentStep", function () { return $518499de7dc341b3$export$802df2ef8e11c200; });
$parcel$export(module.exports, "onboardingSetNextStage", function () { return $518499de7dc341b3$export$c28b048557b38e68; });
$parcel$export(module.exports, "onboardingSetPrevStage", function () { return $518499de7dc341b3$export$6bc8ff36d21b8859; });
$parcel$export(module.exports, "onboardingUpdateRole", function () { return $518499de7dc341b3$export$3e34293436e76993; });
$parcel$export(module.exports, "onboardingUpdateProfile", function () { return $518499de7dc341b3$export$87335f1395fc90b2; });
$parcel$export(module.exports, "onboardingUpdateGenres", function () { return $518499de7dc341b3$export$f002bc156cbabc67; });
$parcel$export(module.exports, "onboardingGetConnectLink", function () { return $518499de7dc341b3$export$51345a47a25d6a2; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
var $29At8 = parcelRequire("29At8");

var $dBgRA = parcelRequire("dBgRA");

var $hTRMQ = parcelRequire("hTRMQ");
const $518499de7dc341b3$export$802df2ef8e11c200 = (0, $kvj5V.createAsyncThunk)("onboarding/onboardingSetCurrentStep", async (inp)=>{
    // get current onboarding step utilizing provided user role and onboarding stage
    const { currentOnboardingStep: currentOnboardingStep } = (0, $hTRMQ.onboardingGetCurrentStep)(inp.userRole, inp.currentOnboardingStage);
    return {
        step: currentOnboardingStep,
        error: ""
    };
});
const $518499de7dc341b3$export$c28b048557b38e68 = (0, $kvj5V.createAsyncThunk)("onboarding/onboardingSetNextStage", async (_, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get current user
    const { profile: profile } = getState().auth;
    // get current step
    const currentOnboardingStep = getState().onboarding.step;
    const userRole = profile?.role;
    const currentOnboardingStage = profile?.onboardingStage;
    const { nextOnboardingStage: nextOnboardingStage, nextOnboardingStep: nextOnboardingStep } = (0, $hTRMQ.onboardingGetNextStage)(userRole, currentOnboardingStage, currentOnboardingStep);
    try {
        // update onboarding stage
        const { user: user } = await api.userApi.updateUserProfileOnboardingStage({
            onboardingStage: nextOnboardingStage
        });
        // update profile
        dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        // return payload
        return {
            step: nextOnboardingStep,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            step: currentOnboardingStep,
            error: message
        };
    }
});
const $518499de7dc341b3$export$6bc8ff36d21b8859 = (0, $kvj5V.createAsyncThunk)("onboarding/onboardingSetPrevStage", async (_, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get current user
    const { profile: profile } = getState().auth;
    // get current step
    const currentOnboardingStep = getState().onboarding.step;
    const userRole = profile?.role;
    const currentOnboardingStage = profile?.onboardingStage;
    const { prevOnboardingStage: prevOnboardingStage, prevOnboardingStep: prevOnboardingStep } = (0, $hTRMQ.onboardingGetPrevStage)(userRole, currentOnboardingStage, currentOnboardingStep);
    try {
        // update onboarding stage
        const { user: user } = await api.userApi.updateUserProfileOnboardingStage({
            onboardingStage: prevOnboardingStage
        });
        // update profile
        dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        // return payload
        return {
            step: prevOnboardingStep,
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            step: currentOnboardingStep,
            error: message
        };
    }
});
const $518499de7dc341b3$export$3e34293436e76993 = (0, $kvj5V.createAsyncThunk)("onboarding/onboardingUpdateRole", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // update user role
        const { user: user } = await api.userApi.updateUserProfileRole({
            role: inp.role
        });
        // refresh token
        const { token: freshToken } = await api.authApi.refreshToken();
        // update token in local storage
        (0, $29At8.storageSetAuthToken)(freshToken);
        // update token in api service
        api.updateApiKey(freshToken);
        // update profile
        dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        // update onboarding stage
        dispatch($518499de7dc341b3$export$c28b048557b38e68());
        // return payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $518499de7dc341b3$export$87335f1395fc90b2 = (0, $kvj5V.createAsyncThunk)("onboarding/onboardingUpdateProfile", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // if avatar provided
        if (inp.avatar) {
            // create form data
            const formData = new FormData();
            // append avatar
            formData.append("file", inp.avatar);
            // update user avatar
            const { user: user } = await api.userApi.updateUserProfileAvatar({
                body: formData
            });
            // update profile
            dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        }
        // if name provided
        if (inp.name) {
            // update user name
            const { user: user } = await api.userApi.updateUserProfile({
                name: inp.name
            });
            // update profile
            dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        }
        // get current profile
        const { profile: profile } = getState().auth;
        // if user not have username and provided username
        if (inp.username && !profile?.username) {
            // check username availability
            const unRes = await api.userApi.getUserProfileUsernameAvailable(inp.username);
            // if username is not available
            if (!unRes.usernameAvailable) return {
                error: "this username is not available"
            };
            // update user username
            const { user: user } = await api.userApi.updateUserProfileUsername({
                username: inp.username
            });
            // update profile
            dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        }
        // update onboarding stage
        dispatch($518499de7dc341b3$export$c28b048557b38e68());
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $518499de7dc341b3$export$f002bc156cbabc67 = (0, $kvj5V.createAsyncThunk)("onboarding/onboardingUpdateGenres", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // update user preferred genres
        const { user: user } = await api.userApi.updateUserProfile({
            preferredGenres: inp.preferredGenres
        });
        // update profile
        dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        // update onboarding stage
        dispatch($518499de7dc341b3$export$c28b048557b38e68());
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $518499de7dc341b3$export$51345a47a25d6a2 = (0, $kvj5V.createAsyncThunk)("onboarding/onboardingGetConnectLink", async ()=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // get connect link
        const res = await api.connectApi.getConnectLink((0, $dBgRA.ConnectLinkType).Onboarding);
        // return empty payload
        return {
            connectLink: res.link || "",
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            connectLink: "",
            error: message
        };
    }
});

});
parcelRegister("dBgRA", function(module, exports) {

$parcel$export(module.exports, "OnboardingStep", function () { return $6c6489f062b51a43$export$4aeefa8fda57befc; });
$parcel$export(module.exports, "ConnectLinkType", function () { return $6c6489f062b51a43$export$372751fe44bf95e8; });
var $6c6489f062b51a43$export$4aeefa8fda57befc;
(function(OnboardingStep) {
    OnboardingStep[OnboardingStep["Initial"] = 0] = "Initial";
    OnboardingStep[OnboardingStep["First"] = 1] = "First";
    OnboardingStep[OnboardingStep["Second"] = 2] = "Second";
    OnboardingStep[OnboardingStep["Third"] = 3] = "Third";
    OnboardingStep[OnboardingStep["Fourth"] = 4] = "Fourth";
    OnboardingStep[OnboardingStep["Fifth"] = 5] = "Fifth";
    OnboardingStep[OnboardingStep["Sixth"] = 6] = "Sixth";
})($6c6489f062b51a43$export$4aeefa8fda57befc || ($6c6489f062b51a43$export$4aeefa8fda57befc = {}));
var $6c6489f062b51a43$export$372751fe44bf95e8;
(function(ConnectLinkType) {
    ConnectLinkType["Onboarding"] = "account_onboarding";
    ConnectLinkType["Update"] = "account_update";
})($6c6489f062b51a43$export$372751fe44bf95e8 || ($6c6489f062b51a43$export$372751fe44bf95e8 = {}));

});

parcelRegister("hTRMQ", function(module, exports) {

$parcel$export(module.exports, "onboardingGetCurrentStep", function () { return $ad9852027138d46c$export$8f53d0172002b66d; });
$parcel$export(module.exports, "onboardingGetNextStage", function () { return $ad9852027138d46c$export$ba0b7075632a985a; });
$parcel$export(module.exports, "onboardingGetPrevStage", function () { return $ad9852027138d46c$export$2438ce0289ef0330; });
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");

var $dBgRA = parcelRequire("dBgRA");
const $ad9852027138d46c$export$8f53d0172002b66d = (userRole, currentOnboardingStage)=>{
    let currentOnboardingStep;
    // based on user role and current onboarding stage
    // assert current onboarding step
    switch(userRole){
        case (0, $2gpGl.EntityUserRole).Fan:
            switch(currentOnboardingStage){
                case (0, $2gpGl.EntityOnboardingStage).SelectRole:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Initial;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).CreateProfile:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).First;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).SelectGenres:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Second;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).FollowArtists:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Third;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Fourth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Fifth;
                    break;
                default:
                    return {
                        currentOnboardingStep: (0, $dBgRA.OnboardingStep).Initial
                    };
            }
            break;
        case (0, $2gpGl.EntityUserRole).Artist:
            switch(currentOnboardingStage){
                case (0, $2gpGl.EntityOnboardingStage).SelectRole:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Initial;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).CreateProfile:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).First;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).UploadTracks:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Second;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).EnableMonetization:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Third;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Fourth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions:
                    currentOnboardingStep = (0, $dBgRA.OnboardingStep).Fifth;
                    break;
                default:
                    return {
                        currentOnboardingStep: (0, $dBgRA.OnboardingStep).Initial
                    };
            }
            break;
        default:
            return {
                currentOnboardingStep: (0, $dBgRA.OnboardingStep).Initial
            };
    }
    return {
        currentOnboardingStep: currentOnboardingStep
    };
};
const $ad9852027138d46c$export$ba0b7075632a985a = (userRole, currentOnboardingStage, currentOnboardingStep)=>{
    let nextOnboardingStage;
    let nextOnboardingStep;
    // based on user role and current onboarding stage
    // assert next onboarding stage and onboarding step
    switch(userRole){
        case (0, $2gpGl.EntityUserRole).Fan:
            switch(currentOnboardingStage){
                case (0, $2gpGl.EntityOnboardingStage).SelectRole:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).CreateProfile;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).First;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).CreateProfile:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).SelectGenres;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Second;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).SelectGenres:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).FollowArtists;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Third;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).FollowArtists:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Fourth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Fifth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).Finished;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Sixth;
                    break;
                default:
                    return {
                        nextOnboardingStage: currentOnboardingStage,
                        nextOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        case (0, $2gpGl.EntityUserRole).Artist:
            switch(currentOnboardingStage){
                case (0, $2gpGl.EntityOnboardingStage).SelectRole:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).CreateProfile;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).First;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).CreateProfile:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).UploadTracks;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Second;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).UploadTracks:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).EnableMonetization;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Third;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).EnableMonetization:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Fourth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Fifth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions:
                    nextOnboardingStage = (0, $2gpGl.EntityOnboardingStage).Finished;
                    nextOnboardingStep = (0, $dBgRA.OnboardingStep).Sixth;
                    break;
                default:
                    return {
                        nextOnboardingStage: currentOnboardingStage,
                        nextOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        default:
            return {
                nextOnboardingStage: currentOnboardingStage,
                nextOnboardingStep: currentOnboardingStep
            };
    }
    return {
        nextOnboardingStage: nextOnboardingStage,
        nextOnboardingStep: nextOnboardingStep
    };
};
const $ad9852027138d46c$export$2438ce0289ef0330 = (userRole, currentOnboardingStage, currentOnboardingStep)=>{
    let prevOnboardingStage;
    let prevOnboardingStep;
    // based on user role and current onboarding stage
    // assert prev onboarding stage and onboarding step
    switch(userRole){
        case (0, $2gpGl.EntityUserRole).Fan:
            switch(currentOnboardingStage){
                case (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).Fourth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).FollowArtists;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).Third;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).FollowArtists:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).SelectGenres;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).Second;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).SelectGenres:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).CreateProfile;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).First;
                    break;
                default:
                    return {
                        prevOnboardingStage: currentOnboardingStage,
                        prevOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        case (0, $2gpGl.EntityUserRole).Artist:
            switch(currentOnboardingStage){
                case (0, $2gpGl.EntityOnboardingStage).AcceptTermsAndConditions:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).Fourth;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).ConfigureNotifications:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).EnableMonetization;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).Third;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).EnableMonetization:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).UploadTracks;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).Second;
                    break;
                case (0, $2gpGl.EntityOnboardingStage).UploadTracks:
                    prevOnboardingStage = (0, $2gpGl.EntityOnboardingStage).CreateProfile;
                    prevOnboardingStep = (0, $dBgRA.OnboardingStep).First;
                    break;
                default:
                    return {
                        prevOnboardingStage: currentOnboardingStage,
                        prevOnboardingStep: currentOnboardingStep
                    };
            }
            break;
        default:
            return {
                prevOnboardingStage: currentOnboardingStage,
                prevOnboardingStep: currentOnboardingStep
            };
    }
    return {
        prevOnboardingStage: prevOnboardingStage,
        prevOnboardingStep: prevOnboardingStep
    };
};

});



parcelRegister("whwjs", function(module, exports) {

$parcel$export(module.exports, "PaymentModal", function () { return (parcelRequire("15XxZ")).PaymentModal; });
parcelRequire("ruhRw");
var $15XxZ = parcelRequire("15XxZ");

var $hxwj5 = parcelRequire("hxwj5");

var $6Qgqx = parcelRequire("6Qgqx");

var $9NSza = parcelRequire("9NSza");
$parcel$exportWildcard(module.exports, $hxwj5);
$parcel$exportWildcard(module.exports, $6Qgqx);
$parcel$exportWildcard(module.exports, $9NSza);

});
parcelRegister("ruhRw", function(module, exports) {

$parcel$export(module.exports, "PaymentModal", function () { return (parcelRequire("15XxZ")).PaymentModal; });

var $15XxZ = parcelRequire("15XxZ");

});
parcelRegister("15XxZ", function(module, exports) {

$parcel$export(module.exports, "PaymentModal", function () { return $8fa9b0be4f47fa37$export$3ff09aa788237818; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $6Qgqx = parcelRequire("6Qgqx");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("gd5pt");
var $lTRLd = parcelRequire("lTRLd");

var $gDSex = parcelRequire("gDSex");
const $8fa9b0be4f47fa37$export$3ff09aa788237818 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const paymentModalOpen = (0, $gNvvs.useAppSelector)((0, $6Qgqx.paymentSelectPaymentModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gDSex.styles)().modal.main,
        children: paymentModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $6Qgqx.paymentClosePaymentModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gDSex.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lTRLd.PaymentCard), {})
            })
        })
    });
};
$8fa9b0be4f47fa37$export$3ff09aa788237818.propTypes = {};

});
parcelRegister("gd5pt", function(module, exports) {

$parcel$export(module.exports, "PaymentCard", function () { return (parcelRequire("lTRLd")).PaymentCard; });

var $lTRLd = parcelRequire("lTRLd");

});
parcelRegister("lTRLd", function(module, exports) {

$parcel$export(module.exports, "PaymentCard", function () { return $5c26c6c5b8013be6$export$5af683685858e056; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $an00m = parcelRequire("an00m");
parcelRequire("7GBhj");
var $4d4hE = parcelRequire("4d4hE");
parcelRequire("krTeD");
var $2zawF = parcelRequire("2zawF");
var $dypeb = parcelRequire("dypeb");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $6Qgqx = parcelRequire("6Qgqx");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
parcelRequire("lWWT4");
var $55stI = parcelRequire("55stI");
parcelRequire("l9K4J");
var $kQtGG = parcelRequire("kQtGG");

var $1JVT4 = parcelRequire("1JVT4");
const $5c26c6c5b8013be6$var$stripePromise = (0, $4d4hE.loadStripe)("staging" === (0, $2zawF.Environment).Production ? (0, $dypeb.stripePublishableKeyProd) : (0, $dypeb.stripePublishableKeyStag));
const $5c26c6c5b8013be6$export$5af683685858e056 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const clientSecret = (0, $gNvvs.useAppSelector)((0, $6Qgqx.paymentSelectPaymentModalClientSecret));
    const paymentCreatePaymentError = "";
    const options = {
        clientSecret: clientSecret,
        appearance: (0, $55stI.stripeAppearance)(theme)
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $1JVT4.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1JVT4.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $6Qgqx.paymentClosePaymentModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $1JVT4.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1JVT4.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $an00m.Elements), {
                            stripe: $5c26c6c5b8013be6$var$stripePromise,
                            options: options,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kQtGG.PaymentForm), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1JVT4.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: paymentCreatePaymentError
                        })
                    })
                ]
            })
        ]
    });
};
$5c26c6c5b8013be6$export$5af683685858e056.propTypes = {};

});
parcelRegister("l9K4J", function(module, exports) {

$parcel$export(module.exports, "PaymentForm", function () { return (parcelRequire("kQtGG")).PaymentForm; });

var $kQtGG = parcelRequire("kQtGG");

});
parcelRegister("kQtGG", function(module, exports) {

$parcel$export(module.exports, "PaymentForm", function () { return $72cfd593dbb1d118$export$b6ded7c5f3fd9245; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $an00m = parcelRequire("an00m");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $jOj42 = parcelRequire("jOj42");
var $9NSza = parcelRequire("9NSza");
var $6Qgqx = parcelRequire("6Qgqx");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $eJNPy = parcelRequire("eJNPy");
var $f6nZ0 = parcelRequire("f6nZ0");

var $4M4w5 = parcelRequire("4M4w5");
const $72cfd593dbb1d118$export$b6ded7c5f3fd9245 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const paymentCreatePaymentLoading = (0, $gNvvs.useAppSelector)((0, $6Qgqx.paymentSelectPaymentCreatePaymentLoading));
    const paymentCreateDefaultPaymentLoading = (0, $gNvvs.useAppSelector)((0, $6Qgqx.paymentSelectPaymentCreateDefaultPaymentLoading));
    const defaultPaymentMethod = (0, $gNvvs.useAppSelector)((0, $6Qgqx.paymentSelectPaymentModalDefaultCustomerPaymentMethod));
    const { brand: brand, last4: last4 } = defaultPaymentMethod ?? {};
    const [useDefaultPaymentMethod, setUseDefaultPaymentMethod] = (0, $bh6RR.useState)(!!defaultPaymentMethod);
    const stripe = (0, $an00m.useStripe)();
    const elements = (0, $an00m.useElements)();
    const paymentLoading = paymentCreatePaymentLoading || paymentCreateDefaultPaymentLoading;
    const submitDisabled = paymentLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $4M4w5.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $4M4w5.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                // if user has default payment method and wants to use it for payment
                if (defaultPaymentMethod && useDefaultPaymentMethod) // create default payment
                dispatch((0, $9NSza.paymentCreateDefaultPayment)({
                    stripe: stripe
                }));
                else // create payment with payment element
                dispatch((0, $9NSza.paymentCreatePayment)({
                    stripe: stripe,
                    elements: elements
                }));
            },
            children: [
                useDefaultPaymentMethod ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $4M4w5.styles)().form.content.card,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $jOj42.CustomerPaymentMethodDefault), {
                        brand: brand,
                        last4: last4
                    })
                }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $4M4w5.styles)().form.content.card,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $an00m.PaymentElement), {})
                }),
                defaultPaymentMethod && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $4M4w5.styles)().form.content.checkbox.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $eJNPy.Checkbox), {
                            name: "use-default-payment-method",
                            label: "Use default payment method",
                            checked: useDefaultPaymentMethod,
                            disabled: paymentLoading,
                            onChange: (e)=>setUseDefaultPaymentMethod(e.target.checked)
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $4M4w5.styles)().form.content.checkbox.label,
                            onClick: paymentLoading ? ()=>{} : ()=>setUseDefaultPaymentMethod((state)=>!state),
                            "aria-hidden": "true",
                            children: "Use default payment method"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $4M4w5.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "checkout",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: paymentLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Checkout`
                    })
                })
            ]
        })
    });
};
$72cfd593dbb1d118$export$b6ded7c5f3fd9245.propTypes = {};

});
parcelRegister("4M4w5", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0438cddac06477d5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $0438cddac06477d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0438cddac06477d5$var$_ref = {
    name: "18wktwv",
    styles: "display:flex;align-items:center;justify-content:left;margin-bottom:32px"
};
var $0438cddac06477d5$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
const $0438cddac06477d5$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                card: $0438cddac06477d5$var$_ref2,
                checkbox: {
                    main: $0438cddac06477d5$var$_ref,
                    label: /*#__PURE__*/ (0, $7hler.css)("display:flex;font-size:", (0, $gln0L.typography).h6, ";user-select:none;margin-left:16px;", "")
                },
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("1JVT4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $be172987208fc564$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $be172987208fc564$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $be172987208fc564$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $be172987208fc564$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $be172987208fc564$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $be172987208fc564$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $be172987208fc564$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $be172987208fc564$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $be172987208fc564$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $be172987208fc564$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $be172987208fc564$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($be172987208fc564$var$_ref8), " ", (0, $gln0L.mq).mobile($be172987208fc564$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($be172987208fc564$var$_ref6), ";", ""),
            title: $be172987208fc564$var$_ref5,
            subtitle: $be172987208fc564$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($be172987208fc564$var$_ref3), ";", ""),
                form: $be172987208fc564$var$_ref2,
                error: $be172987208fc564$var$_ref
            }
        }
    });

});



parcelRegister("gDSex", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c32a6fd1ea3cf557$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c32a6fd1ea3cf557$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c32a6fd1ea3cf557$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $c32a6fd1ea3cf557$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($c32a6fd1ea3cf557$var$_ref), ";", "")
        }
    });

});



parcelRegister("hxwj5", function(module, exports) {

$parcel$export(module.exports, "PaymentOperationType", function () { return $f36957bc84737902$export$a9d3ed3ed13e41a3; });
var $f36957bc84737902$export$a9d3ed3ed13e41a3;
(function(PaymentOperationType) {
    PaymentOperationType["Tip"] = "tip";
    PaymentOperationType["Subscription"] = "subscription";
    PaymentOperationType["PostUnlock"] = "post_unlock";
    PaymentOperationType["TrackUnlock"] = "track_unlock";
})($f36957bc84737902$export$a9d3ed3ed13e41a3 || ($f36957bc84737902$export$a9d3ed3ed13e41a3 = {}));

});

parcelRegister("6Qgqx", function(module, exports) {

$parcel$export(module.exports, "paymentSlice", function () { return $69636cf8ac6f544c$export$c99e1c5455ba6a3f; });
$parcel$export(module.exports, "paymentResetState", function () { return $69636cf8ac6f544c$export$86d8df7797d1b519; });
$parcel$export(module.exports, "paymentOpenPaymentModal", function () { return $69636cf8ac6f544c$export$78be0d48ae3cf851; });
$parcel$export(module.exports, "paymentClosePaymentModal", function () { return $69636cf8ac6f544c$export$8d1e5b89d114f684; });
$parcel$export(module.exports, "paymentSelectPaymentModalOpen", function () { return $69636cf8ac6f544c$export$31099d7429224230; });
$parcel$export(module.exports, "paymentSelectPaymentModalClientSecret", function () { return $69636cf8ac6f544c$export$69491cbfbe624e40; });
$parcel$export(module.exports, "paymentSelectPaymentModalDefaultCustomerPaymentMethod", function () { return $69636cf8ac6f544c$export$d9b5a57eab6c8137; });
$parcel$export(module.exports, "paymentSelectPaymentCreatePaymentLoading", function () { return $69636cf8ac6f544c$export$78afbc418af41ea6; });
$parcel$export(module.exports, "paymentSelectPaymentCreateDefaultPaymentLoading", function () { return $69636cf8ac6f544c$export$a12ef377435f930c; });
$parcel$export(module.exports, "paymentReducer", function () { return $69636cf8ac6f544c$export$51709e6bb40a75d3; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $9NSza = parcelRequire("9NSza");
const $69636cf8ac6f544c$var$initialState = {
    paymentModal: {
        clientSecret: "",
        defaultCustomerPaymentMethod: undefined,
        operationType: undefined,
        operationSubject: undefined,
        open: false
    },
    paymentCreatePaymentLoading: false,
    paymentCreateDefaultPaymentLoading: false
};
const $69636cf8ac6f544c$export$c99e1c5455ba6a3f = (0, $kvj5V.createSlice)({
    name: "payment",
    initialState: $69636cf8ac6f544c$var$initialState,
    reducers: {
        // reset state
        paymentResetState: ()=>({
                paymentModal: {
                    clientSecret: "",
                    defaultCustomerPaymentMethod: undefined,
                    operationType: undefined,
                    operationSubject: undefined,
                    open: false
                },
                paymentCreatePaymentLoading: false,
                paymentCreateDefaultPaymentLoading: false
            }),
        // open payment modal
        paymentOpenPaymentModal: (state, action)=>({
                ...state,
                paymentModal: {
                    clientSecret: action.payload.clientSecret,
                    defaultCustomerPaymentMethod: action.payload.defaultCustomerPaymentMethod,
                    operationType: action.payload.operationType,
                    operationSubject: action.payload.operationSubject,
                    open: true
                }
            }),
        // close payment modal
        paymentClosePaymentModal: (state)=>({
                ...state,
                paymentModal: {
                    clientSecret: "",
                    defaultCustomerPaymentMethod: undefined,
                    operationType: undefined,
                    operationSubject: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // create payment
        builder.addCase((0, $9NSza.paymentCreatePayment).pending, (state)=>({
                ...state,
                paymentCreatePaymentLoading: true
            })).addCase((0, $9NSza.paymentCreatePayment).fulfilled, (state)=>({
                ...state,
                paymentCreatePaymentLoading: false
            }));
        // create default payment (payment utilizing default payment method)
        builder.addCase((0, $9NSza.paymentCreateDefaultPayment).pending, (state)=>({
                ...state,
                paymentCreateDefaultPaymentLoading: true
            })).addCase((0, $9NSza.paymentCreateDefaultPayment).fulfilled, (state)=>({
                ...state,
                paymentCreateDefaultPaymentLoading: false
            }));
    }
});
const { paymentResetState: $69636cf8ac6f544c$export$86d8df7797d1b519, paymentOpenPaymentModal: $69636cf8ac6f544c$export$78be0d48ae3cf851, paymentClosePaymentModal: $69636cf8ac6f544c$export$8d1e5b89d114f684 } = $69636cf8ac6f544c$export$c99e1c5455ba6a3f.actions;
const $69636cf8ac6f544c$export$31099d7429224230 = (state)=>state.payment.paymentModal.open;
const $69636cf8ac6f544c$export$69491cbfbe624e40 = (state)=>state.payment.paymentModal.clientSecret;
const $69636cf8ac6f544c$export$d9b5a57eab6c8137 = (state)=>state.payment.paymentModal.defaultCustomerPaymentMethod;
const $69636cf8ac6f544c$export$78afbc418af41ea6 = (state)=>state.payment.paymentCreatePaymentLoading;
const $69636cf8ac6f544c$export$a12ef377435f930c = (state)=>state.payment.paymentCreateDefaultPaymentLoading;
const $69636cf8ac6f544c$export$51709e6bb40a75d3 = $69636cf8ac6f544c$export$c99e1c5455ba6a3f.reducer; // export default paymentSlice.reducer

});

parcelRegister("9NSza", function(module, exports) {

$parcel$export(module.exports, "paymentCreatePayment", function () { return $421525ee7dbe7c9a$export$d96f3783041f7c6e; });
$parcel$export(module.exports, "paymentCreateDefaultPayment", function () { return $421525ee7dbe7c9a$export$16d6e099535c8a19; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("krTeD");
var $2zawF = parcelRequire("2zawF");
var $itzfe = parcelRequire("itzfe");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $89C5W = parcelRequire("89C5W");
var $6Qgqx = parcelRequire("6Qgqx");
var $hxwj5 = parcelRequire("hxwj5");
var $jAL4t = parcelRequire("jAL4t");
var $a0vy2 = parcelRequire("a0vy2");
var $l5cm3 = parcelRequire("l5cm3");
var $2Vh5B = parcelRequire("2Vh5B");
var $ht2ql = parcelRequire("ht2ql");
var $8aXib = parcelRequire("8aXib");
var $iw5tW = parcelRequire("iw5tW");
const $421525ee7dbe7c9a$export$d96f3783041f7c6e = (0, $kvj5V.createAsyncThunk)("payment/paymentCreatePayment", async (inp, { dispatch: dispatch, getState: getState })=>{
    // if stripe is not loaded
    if (!inp.stripe || !inp.elements) // return error message in payload
    return {
        error: "Stripe is failed to load"
    };
    // get client secret, operation type and operation subject
    const { operationType: operationType, operationSubject: operationSubject } = getState().payment.paymentModal;
    // define redirect url
    const redirectUrl = "staging" === (0, $2zawF.Environment).Production ? (0, $itzfe.Platform).ProductionURL : (0, $itzfe.Platform).StagingURL;
    try {
        // confirm stripe payment
        const { error: error } = await inp.stripe.confirmPayment({
            elements: inp.elements,
            redirect: "if_required",
            confirmParams: {
                return_url: redirectUrl
            }
        });
        // if error returned
        if (error) {
            // launch error alert
            dispatch((0, $6tPng.alertAddMessage)({
                message: {
                    id: (0, $itWch.uuid)(),
                    type: (0, $h7gla.AlertMessageType).Error,
                    message: `Payment failed: ${error.message}`
                }
            }));
            // return error message in payload
            return {
                error: error.message || ""
            };
        }
        // launch success alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: `Payment succeeded!`
            }
        }));
        // close payment modal
        dispatch((0, $6Qgqx.paymentClosePaymentModal)());
        // reset transaction state
        dispatch((0, $ht2ql.transactionResetState)());
        // get notification state
        const { notification: notification } = getState().notification;
        // update application state based on operation type
        switch(operationType){
            // on tip operation type
            case (0, $hxwj5.PaymentOperationType).Tip:
                // if notification exists - then tip payment was retried from notification view
                if (notification) dispatch((0, $89C5W.notificationSetNotificationTipRetried)());
                break;
            // on subscription operation type
            case (0, $hxwj5.PaymentOperationType).Subscription:
                // add subscription to user subscriptions
                dispatch((0, $l5cm3.subscriptionAddUserSubscription)({
                    userId: operationSubject?.id || ""
                }));
                // append user to subscribed artists list
                dispatch((0, $iw5tW.userAppendSubscribedArtist)({
                    artist: operationSubject
                }));
                break;
            // on post unlock operation type
            case (0, $hxwj5.PaymentOperationType).PostUnlock:
                // add unlock to post unlocks
                dispatch((0, $8aXib.unlockAddPostUnlock)({
                    postId: operationSubject?.id || ""
                }));
                // append post to unlocked posts list
                dispatch((0, $a0vy2.postAppendUnlockedPost)({
                    post: operationSubject
                }));
                // TODO:
                // - implement open unlocked post
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $89C5W.notificationSetNotificationUnlockRetried)());
                break;
            // on track unlock operation type
            case (0, $hxwj5.PaymentOperationType).TrackUnlock:
                // add unlock to track unlocks
                dispatch((0, $8aXib.unlockAddTrackUnlock)({
                    trackId: operationSubject?.id || ""
                }));
                // append track to unlocked tracks list
                dispatch((0, $2Vh5B.trackAppendUnlockedTrack)({
                    track: operationSubject
                }));
                // play unlocked track
                dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: operationSubject
                }));
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $89C5W.notificationSetNotificationUnlockRetried)());
                break;
            default:
        }
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        // return error message in payload
        return {
            error: err.message || ""
        };
    }
});
const $421525ee7dbe7c9a$export$16d6e099535c8a19 = (0, $kvj5V.createAsyncThunk)("payment/paymentCreateDefaultPayment", async (inp, { dispatch: dispatch, getState: getState })=>{
    // if stripe is not loaded
    if (!inp.stripe) // return error message in payload
    return {
        error: "Stripe is failed to load"
    };
    // get client secret, operation type, and operation subject
    const { clientSecret: clientSecret, defaultCustomerPaymentMethod: defaultCustomerPaymentMethod, operationType: operationType, operationSubject: operationSubject } = getState().payment.paymentModal;
    try {
        // confirm stripe payment
        const { error: error } = await inp.stripe.confirmCardPayment(clientSecret, {
            payment_method: defaultCustomerPaymentMethod?.paymentMethodId
        });
        // if error returned
        if (error) {
            // launch error alert
            dispatch((0, $6tPng.alertAddMessage)({
                message: {
                    id: (0, $itWch.uuid)(),
                    type: (0, $h7gla.AlertMessageType).Error,
                    message: `Payment failed: ${error.message}`
                }
            }));
            // return error message in payload
            return {
                error: error.message || ""
            };
        }
        // launch success alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: `Payment succeeded!`
            }
        }));
        // close payment modal
        dispatch((0, $6Qgqx.paymentClosePaymentModal)());
        // reset transaction state
        dispatch((0, $ht2ql.transactionResetState)());
        // get notification state
        const { notification: notification } = getState().notification;
        // update application state based on operation type
        switch(operationType){
            // on tip operation type
            case (0, $hxwj5.PaymentOperationType).Tip:
                // if notification exists - then tip payment was retried from notification view
                if (notification) dispatch((0, $89C5W.notificationSetNotificationTipRetried)());
                break;
            // on subscription operation type
            case (0, $hxwj5.PaymentOperationType).Subscription:
                // add subscription to user subscriptions
                dispatch((0, $l5cm3.subscriptionAddUserSubscription)({
                    userId: operationSubject?.id || ""
                }));
                // append user to subscribed artists list
                dispatch((0, $iw5tW.userAppendSubscribedArtist)({
                    artist: operationSubject
                }));
                break;
            // on post unlock operation type
            case (0, $hxwj5.PaymentOperationType).PostUnlock:
                // add unlock to post unlocks
                dispatch((0, $8aXib.unlockAddPostUnlock)({
                    postId: operationSubject?.id || ""
                }));
                // append post to unlocked posts list
                dispatch((0, $a0vy2.postAppendUnlockedPost)({
                    post: operationSubject
                }));
                // TODO:
                // - implement open unlocked post
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $89C5W.notificationSetNotificationUnlockRetried)());
                break;
            // on track unlock operation type
            case (0, $hxwj5.PaymentOperationType).TrackUnlock:
                // add unlock to track unlocks
                dispatch((0, $8aXib.unlockAddTrackUnlock)({
                    trackId: operationSubject?.id || ""
                }));
                // append track to unlocked tracks list
                dispatch((0, $2Vh5B.trackAppendUnlockedTrack)({
                    track: operationSubject
                }));
                // play unlocked track
                dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: operationSubject
                }));
                // if notification exists - then unlock payment was retried from notification view
                if (notification) dispatch((0, $89C5W.notificationSetNotificationUnlockRetried)());
                break;
            default:
        }
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        // return error message in payload
        return {
            error: err.message || ""
        };
    }
});

});


parcelRegister("8daht", function(module, exports) {

$parcel$export(module.exports, "PlayerAudio", function () { return (parcelRequire("44h64")).PlayerAudio; });
$parcel$export(module.exports, "PlayerAudioPlaylist", function () { return (parcelRequire("7Iuuy")).PlayerAudioPlaylist; });
parcelRequire("grzWe");
var $44h64 = parcelRequire("44h64");
var $7Iuuy = parcelRequire("7Iuuy");

var $jAL4t = parcelRequire("jAL4t");
$parcel$exportWildcard(module.exports, $jAL4t);

});
parcelRegister("grzWe", function(module, exports) {

$parcel$export(module.exports, "PlayerAudio", function () { return (parcelRequire("44h64")).PlayerAudio; });
$parcel$export(module.exports, "PlayerAudioPlaylist", function () { return (parcelRequire("7Iuuy")).PlayerAudioPlaylist; });

var $44h64 = parcelRequire("44h64");

var $7Iuuy = parcelRequire("7Iuuy");

});
parcelRegister("44h64", function(module, exports) {

$parcel$export(module.exports, "PlayerAudio", function () { return $8ab5fc5b179cc18b$export$778cf6b6a2da7a23; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");
var $8NOJ0 = parcelRequire("8NOJ0");
parcelRequire("5ORUQ");
var $95D60 = parcelRequire("95D60");
var $kiQFh = parcelRequire("kiQFh");
var $6BxhZ = parcelRequire("6BxhZ");
var $cLMvT = parcelRequire("cLMvT");

var $angAi = parcelRequire("angAi");
const $8ab5fc5b179cc18b$export$778cf6b6a2da7a23 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const isAudioRepeatActive = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectRepeat));
    const isAudioRandomActive = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectRandom));
    const playlistLength = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectPlaylistLength));
    const currentTrack = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrack));
    const currentTrackAction = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrackAction));
    // track
    const { id: currentTrackId, name: trackName, coverId: coverId, trackId: trackId, userId: trackAuthorUserId } = currentTrack ?? {};
    const trackHasCover = !!coverId;
    const coverSrc = (0, $jpNoL.useFile)(coverId || "");
    const audioSrc = (0, $jpNoL.useFile)(trackId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(trackAuthorUserId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const trackAuthorName = isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder;
    // refs
    const audioRef = (0, $bh6RR.useRef)(null);
    // audio states
    const [audioDuration, setAudioDuration] = (0, $bh6RR.useState)(0);
    const [audioProgress, setAudioProgress] = (0, $bh6RR.useState)(0);
    const [audioBuffered, setAudioBuffered] = (0, $bh6RR.useState)(0);
    // control states
    const [audioVolume, setAudioVolume] = (0, $bh6RR.useState)(1);
    // on player touch states
    const [touchStartPosition, setTouchStartPosition] = (0, $bh6RR.useState)({
        x: 0,
        y: 0
    });
    (0, $bh6RR.useEffect)(()=>{
        // if media session present
        if ("mediaSession" in navigator) {
            // create media session metadata
            navigator.mediaSession.metadata = new MediaMetadata({
                title: trackName,
                artist: trackAuthorName,
                album: "-",
                artwork: trackHasCover ? [
                    {
                        src: coverSrc,
                        sizes: "96x96",
                        type: "image/webp"
                    }
                ] : undefined
            });
            navigator.mediaSession.setActionHandler("play", ()=>{
                // play functionality
                if (audioRef.current) audioRef.current.play();
            });
            navigator.mediaSession.setActionHandler("pause", ()=>{
                // pause functionality
                if (audioRef.current) audioRef.current.pause();
            });
            navigator.mediaSession.setActionHandler("previoustrack", ()=>{
                // prev functionality
                dispatch((0, $jAL4t.playerAudioSetPrevTrack)());
            });
            navigator.mediaSession.setActionHandler("nexttrack", ()=>{
                // next functionality
                dispatch((0, $jAL4t.playerAudioSetNextTrack)());
            });
        }
        return ()=>{
        // cleanup
        };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        currentTrack
    ]);
    const handleBufferProgress = (currentTime, duration, buffered)=>{
        // if duration is greater than 0
        if (duration > 0) {
            // iterate from 0 to buffered length
            for(let i = 0; i < buffered.length; i += 1)// if start time of the buffered range at the current index
            // is less than the current playback time
            if (buffered.start(buffered.length - 1 - i) < currentTime) {
                // calculate the end time of buffered range
                const bufferedLength = buffered.end(buffered.length - 1 - i);
                setAudioBuffered(bufferedLength);
                break;
            }
        }
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $angAi.styles)(theme).player.main,
        onTouchStart: (e)=>{
            const { clientX: clientX, clientY: clientY } = e.changedTouches[0];
            setTouchStartPosition({
                x: clientX,
                y: clientY
            });
        },
        onTouchEnd: (e)=>{
            const { clientY: clientY } = e.changedTouches[0];
            // calculate touch distance
            const touchDistance = touchStartPosition.y - clientY;
            // set min touch threshold
            const minTouchThreshold = 100;
            // if touch distance is greater or equal min threshold
            if (touchDistance >= minTouchThreshold) dispatch((0, $jAL4t.playerAudioSetOpen)());
        },
        children: [
            currentTrack && /* eslint-disable-next-line jsx-a11y/media-has-caption */ /*#__PURE__*/ (0, $9awXB.jsx)("audio", {
                ref: audioRef,
                preload: "metadata",
                // controls
                autoPlay: true,
                onDurationChange: (e)=>setAudioDuration(e.currentTarget.duration),
                onCanPlay: (e)=>{
                    dispatch((0, $jAL4t.playerAudioSetCurrentTrackReady)({
                        state: true
                    }));
                    e.currentTarget.volume = audioVolume;
                },
                onPlaying: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrackPlaying)({
                        state: true
                    })),
                onPause: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrackPlaying)({
                        state: false
                    })),
                onEnded: ()=>{
                    // create track stream
                    dispatch((0, $8NOJ0.streamCreateTrackStream)({
                        track: currentTrack
                    }));
                    // if repeat active
                    if (isAudioRepeatActive) {
                        // repeat current song
                        dispatch((0, $jAL4t.playerAudioSetRepeatTrack)());
                        return;
                    }
                    // if random active
                    if (isAudioRandomActive) {
                        // play random song
                        dispatch((0, $jAL4t.playerAudioSetRandomTrack)());
                        return;
                    }
                    // if playlist length is greater than 1
                    if (playlistLength > 1) // play next track
                    dispatch((0, $jAL4t.playerAudioSetNextTrack)());
                },
                onTimeUpdate: (e)=>{
                    const { currentTime: currentTime, duration: duration, buffered: buffered } = e.currentTarget;
                    setAudioProgress(currentTime);
                    handleBufferProgress(currentTime, duration, buffered);
                },
                onProgress: (e)=>{
                    const { currentTime: currentTime, duration: duration, buffered: buffered } = e.currentTarget;
                    handleBufferProgress(currentTime, duration, buffered);
                },
                children: /*#__PURE__*/ (0, $9awXB.jsx)("source", {
                    type: "audio/mpeg",
                    src: audioSrc
                })
            }, `${currentTrackId}-${currentTrackAction}`),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $angAi.styles)(theme).player.progress.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $cLMvT.Progress), {
                    duration: audioDuration,
                    progress: audioProgress,
                    buffered: audioBuffered,
                    onChange: (e)=>{
                        // get current progress value
                        const progressValue = e.currentTarget.valueAsNumber;
                        // if audio ref
                        if (audioRef.current) // update progress value on audio ref
                        audioRef.current.currentTime = progressValue;
                        // update progress value state
                        setAudioProgress(progressValue);
                    }
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $angAi.styles)(theme).player.panel.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $angAi.styles)(theme).player.panel.audio.main,
                        children: currentTrack && /*#__PURE__*/ (0, $9awXB.jsx)((0, $kiQFh.CurrentTrack), {
                            track: currentTrack,
                            trackAuthorName: trackAuthorName,
                            progress: audioProgress,
                            duration: audioDuration,
                            onAuthorNameClick: ()=>{
                                navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`);
                                dispatch((0, $jAL4t.playerAudioSetClosed)());
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $angAi.styles)(theme).player.panel.controls.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $95D60.Controls), {
                            onPauseClick: ()=>{
                                // if audio ref
                                if (audioRef.current) // pause audio
                                audioRef.current.pause();
                            },
                            onPlayClick: ()=>{
                                // if audio ref
                                if (audioRef.current) // play audio
                                audioRef.current.play();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $angAi.styles)(theme).player.panel.nav.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6BxhZ.Navigation), {
                            volume: audioVolume,
                            onVolumeChange: (e)=>{
                                // get current volume value
                                const volumeValue = e.currentTarget.valueAsNumber;
                                // if audio ref
                                if (audioRef.current) // update volume value on audio ref
                                audioRef.current.volume = volumeValue;
                                // update volume value state
                                setAudioVolume(volumeValue);
                            }
                        })
                    })
                ]
            })
        ]
    });
};
$8ab5fc5b179cc18b$export$778cf6b6a2da7a23.propTypes = {}; // media loading process
 // loadstart - media loading has started and the browser is connecting to the media
 // durationchange - fires when the duration of the media is already available
 // loadedmetadata - fires when all media metadata has been loaded
 // loadeddata - this event is fired when the first bit of media arrives
 // progress - the event indicating that media downloading is still in progress
 // canplay - fires when the media is ready to be played
 // canplaythrough - this event lets us know that the media can be played all the way through

});
parcelRegister("5ORUQ", function(module, exports) {

$parcel$export(module.exports, "Controls", function () { return (parcelRequire("95D60")).Controls; });
$parcel$export(module.exports, "CurrentTrack", function () { return (parcelRequire("kiQFh")).CurrentTrack; });
$parcel$export(module.exports, "Navigation", function () { return (parcelRequire("6BxhZ")).Navigation; });
$parcel$export(module.exports, "Progress", function () { return (parcelRequire("cLMvT")).Progress; });

var $95D60 = parcelRequire("95D60");

var $kiQFh = parcelRequire("kiQFh");

var $6BxhZ = parcelRequire("6BxhZ");

var $cLMvT = parcelRequire("cLMvT");

});
parcelRegister("95D60", function(module, exports) {

$parcel$export(module.exports, "Controls", function () { return $9b7a1faa305b2d17$export$c7c44baae9d9f25f; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");
parcelRequire("1TdPt");
var $f6nZ0 = parcelRequire("f6nZ0");

var $eshXV = parcelRequire("eshXV");

var $gg1sn = parcelRequire("gg1sn");
const $9b7a1faa305b2d17$export$c7c44baae9d9f25f = ({ onPauseClick: onPauseClick, onPlayClick: onPlayClick })=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const isAudioRepeatActive = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectRepeat));
    const isAudioRandomActive = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectRandom));
    const currentTrack = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrack));
    const currentTrackReady = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrackReady));
    const currentTrackPlaying = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrackPlaying));
    const renderPlayPauseControls = ()=>{
        // if track is set but is not loaded
        if (currentTrack && !currentTrackReady) // render loader
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $gg1sn.styles)(theme).controls.play.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                width: 30,
                height: 30,
                appearance: "secondary"
            })
        });
        // if track is playing - render pause button
        if (currentTrack && currentTrackPlaying) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $gg1sn.styles)(theme).controls.pause.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $gg1sn.styles)(theme).controls.pause.button,
                onClick: (e)=>onPauseClick(e),
                disabled: !currentTrackReady,
                type: "button",
                "aria-label": "pause audio",
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eshXV.icons).AudioPause, {})
            })
        });
        // else render play button
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $gg1sn.styles)(theme).controls.play.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: (0, $gg1sn.styles)(theme).controls.play.button,
                onClick: (e)=>onPlayClick(e),
                disabled: !currentTrackReady,
                type: "button",
                "aria-label": "play audio",
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eshXV.icons).AudioPlay, {})
            })
        });
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $gg1sn.styles)(theme).controls.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gg1sn.styles)(theme).controls.repeat.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: [
                        (0, $gg1sn.styles)(theme).controls.repeat.button.shared,
                        isAudioRepeatActive ? (0, $gg1sn.styles)(theme).controls.repeat.button.active : (0, $gg1sn.styles)(theme).controls.repeat.button.inactive,
                        "",
                        ""
                    ],
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioToggleRepeat)()),
                    type: "button",
                    "aria-label": "activate repeat audio",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eshXV.icons).AudioRepeat, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gg1sn.styles)(theme).controls.prev.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $gg1sn.styles)(theme).controls.prev.button,
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetPrevTrack)()),
                    type: "button",
                    "aria-label": "set previous audio",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eshXV.icons).AudioPrev, {})
                })
            }),
            renderPlayPauseControls(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gg1sn.styles)(theme).controls.next.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $gg1sn.styles)(theme).controls.next.button,
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetNextTrack)()),
                    type: "button",
                    "aria-label": "set next audio",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eshXV.icons).AudioNext, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gg1sn.styles)(theme).controls.random.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: [
                        (0, $gg1sn.styles)(theme).controls.random.button.shared,
                        isAudioRandomActive ? (0, $gg1sn.styles)(theme).controls.random.button.active : (0, $gg1sn.styles)(theme).controls.random.button.inactive,
                        "",
                        ""
                    ],
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioToggleRandom)()),
                    type: "button",
                    "aria-label": "activate random audio",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eshXV.icons).AudioRandom, {})
                })
            })
        ]
    });
};
$9b7a1faa305b2d17$export$c7c44baae9d9f25f.propTypes = {};

});
parcelRegister("eshXV", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $7df72b0dcbf3976d$export$df03f54e09e486fa; });

var $hiTQY = parcelRequire("hiTQY");

var $7aCwn = parcelRequire("7aCwn");

var $2OrpZ = parcelRequire("2OrpZ");

var $5eWkP = parcelRequire("5eWkP");

var $4Lbqr = parcelRequire("4Lbqr");

var $ldQbV = parcelRequire("ldQbV");
const $7df72b0dcbf3976d$export$df03f54e09e486fa = {
    AudioNext: $hiTQY.default,
    AudioPause: $7aCwn.default,
    AudioPlay: $2OrpZ.default,
    AudioPrev: $5eWkP.default,
    AudioRandom: $4Lbqr.default,
    AudioRepeat: $ldQbV.default
};

});
parcelRegister("hiTQY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e66ea845bdd24805$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $e66ea845bdd24805$var$SvgAudioNext = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M11.7 4.837C14.567 7.029 16 8.125 16 10c0 1.875-1.433 2.97-4.3 5.163a40.949 40.949 0 0 1-2.297 1.65c-.633.416-1.35.847-2.091 1.27-2.86 1.63-4.29 2.446-5.572 1.543-1.283-.902-1.4-2.792-1.632-6.57A50.77 50.77 0 0 1 0 10c0-.94.042-1.987.108-3.055C.34 3.165.458 1.277 1.74.374 3.022-.529 4.452.287 7.312 1.917a38.95 38.95 0 0 1 2.091 1.27 40.96 40.96 0 0 1 2.297 1.65Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 2.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z",
                fill: "#FFF"
            })
        ]
    });
var $e66ea845bdd24805$export$2e2bcd8739ae039 = $e66ea845bdd24805$var$SvgAudioNext;

});

parcelRegister("7aCwn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $848a6497e9c5c8ef$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $848a6497e9c5c8ef$var$SvgAudioPause = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M0 4C0 2.114 0 1.172.586.586 1.172 0 2.114 0 4 0c1.886 0 2.828 0 3.414.586C8 1.172 8 2.114 8 4v12c0 1.886 0 2.828-.586 3.414C6.828 20 5.886 20 4 20c-1.886 0-2.828 0-3.414-.586C0 18.828 0 17.886 0 16V4ZM12 4c0-1.886 0-2.828.586-3.414C13.172 0 14.114 0 16 0c1.886 0 2.828 0 3.414.586C20 1.172 20 2.114 20 4v12c0 1.886 0 2.828-.586 3.414C18.828 20 17.886 20 16 20c-1.886 0-2.828 0-3.414-.586C12 18.828 12 17.886 12 16V4Z",
            fill: "#FFF"
        })
    });
var $848a6497e9c5c8ef$export$2e2bcd8739ae039 = $848a6497e9c5c8ef$var$SvgAudioPause;

});

parcelRegister("2OrpZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42a7aee0b0b989be$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $42a7aee0b0b989be$var$SvgAudioPlay = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            d: "M13.163 4.837C16.388 7.03 18 8.125 18 10c0 1.875-1.612 2.97-4.837 5.163a46.431 46.431 0 0 1-2.585 1.65c-.711.416-1.518.847-2.352 1.27-3.217 1.63-4.826 2.446-6.269 1.543-1.442-.902-1.574-2.792-1.836-6.57A45.156 45.156 0 0 1 0 10c0-.94.047-1.987.121-3.055.262-3.779.394-5.668 1.836-6.57C3.4-.529 5.01.286 8.226 1.916c.834.423 1.64.854 2.352 1.27a46.385 46.385 0 0 1 2.585 1.65Z",
            fill: "#FFF"
        })
    });
var $42a7aee0b0b989be$export$2e2bcd8739ae039 = $42a7aee0b0b989be$var$SvgAudioPlay;

});

parcelRegister("5eWkP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $455f3630d9f31ead$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $455f3630d9f31ead$var$SvgAudioPrev = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M9.3 4.837C6.433 7.029 5 8.125 5 10c0 1.875 1.433 2.97 4.3 5.163a40.96 40.96 0 0 0 2.297 1.65c.633.416 1.35.847 2.091 1.27 2.86 1.63 4.29 2.446 5.572 1.543 1.283-.902 1.4-2.792 1.632-6.57.066-1.07.108-2.117.108-3.056 0-.94-.042-1.987-.108-3.055-.233-3.78-.35-5.668-1.632-6.571-1.282-.903-2.712-.087-5.572 1.543a38.94 38.94 0 0 0-2.091 1.27A40.97 40.97 0 0 0 9.3 4.837Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1 2.25A.75.75 0 0 0 .25 3v15a.75.75 0 0 0 1.5 0V3A.75.75 0 0 0 1 2.25Z",
                fill: "#FEFEFE"
            })
        ]
    });
var $455f3630d9f31ead$export$2e2bcd8739ae039 = $455f3630d9f31ead$var$SvgAudioPrev;

});

parcelRegister("4Lbqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c4a40f8138c2c4$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $c9c4a40f8138c2c4$var$SvgAudioRandom = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.974.976a.6.6 0 0 1 .849 0l1.6 1.6a.6.6 0 0 1 0 .848l-1.6 1.6a.6.6 0 1 1-.849-.848l.576-.576h-1.434c-.675 0-1.139 0-1.504.036-.352.034-.565.097-.742.197-.176.1-.34.25-.55.535-.219.294-.458.692-.805 1.27L8.496 9.004c-.329.548-.597.996-.854 1.343-.269.363-.55.653-.924.864-.374.212-.768.304-1.217.348-.43.042-.952.042-1.591.042H.998a.6.6 0 1 1 0-1.2h2.883c.675 0 1.139 0 1.504-.036.352-.035.565-.098.741-.198.177-.1.34-.25.551-.534.219-.295.458-.692.805-1.271l2.019-3.365c.328-.547.597-.995.854-1.342.269-.363.55-.653.924-.865.374-.211.768-.304 1.217-.347.43-.042.952-.042 1.591-.042h1.463l-.576-.576a.6.6 0 0 1 0-.848Zm-9.39 2.657c-.157-.03-.335-.033-.851-.033H.998a.6.6 0 1 1 0-1.2H4.791c.436 0 .737 0 1.022.055a3 3 0 0 1 1.657.938c.194.216.349.474.573.848l.03.05a.6.6 0 1 1-1.03.617c-.265-.442-.358-.593-.465-.712a1.8 1.8 0 0 0-.995-.563Zm4.546 5.252a.6.6 0 0 1 .823.206c.266.443.36.594.466.713.262.29.61.488.994.563.157.03.335.033.851.033h2.286l-.576-.576a.6.6 0 0 1 .849-.848l1.6 1.6a.6.6 0 0 1 0 .848l-1.6 1.6a.6.6 0 1 1-.849-.848l.576-.576h-2.344c-.436 0-.737 0-1.022-.056a3 3 0 0 1-1.657-.938c-.194-.215-.349-.473-.573-.848l-.03-.05a.6.6 0 0 1 .206-.823Z",
            fill: "#FFF"
        })
    });
var $c9c4a40f8138c2c4$export$2e2bcd8739ae039 = $c9c4a40f8138c2c4$var$SvgAudioRandom;

});

parcelRegister("ldQbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ba958e8d426333e$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $8ba958e8d426333e$var$SvgAudioRepeat = (props)=>/*#__PURE__*/ (0, $9awXB.jsx)("svg", {
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.174.376a.6.6 0 0 1 .849 0l1.6 1.6A.6.6 0 0 1 8.198 3h-1.6a5 5 0 1 0 0 10h.4a.6.6 0 1 1 0 1.2h-.4a6.2 6.2 0 0 1 0-12.4h.152l-.576-.576a.6.6 0 0 1 0-.848ZM10.398 2.4a.6.6 0 0 1 .6-.6h.4a6.2 6.2 0 1 1 0 12.4h-.151l.576.576a.6.6 0 0 1-.849.848l-1.6-1.6A.6.6 0 0 1 9.798 13h1.6a5 5 0 1 0 0-10h-.4a.6.6 0 0 1-.6-.6Z",
            fill: "#FEFEFE"
        })
    });
var $8ba958e8d426333e$export$2e2bcd8739ae039 = $8ba958e8d426333e$var$SvgAudioRepeat;

});


parcelRegister("gg1sn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $428cb09ff0e03c7b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $428cb09ff0e03c7b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $428cb09ff0e03c7b$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $428cb09ff0e03c7b$var$_ref2 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $428cb09ff0e03c7b$var$_ref3 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $428cb09ff0e03c7b$var$_ref4 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $428cb09ff0e03c7b$var$_ref5 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $428cb09ff0e03c7b$var$_ref6 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $428cb09ff0e03c7b$var$_ref7 = {
    name: "1k0ud4i",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;&>div:not(:last-of-type){margin-right:24px;}"
};
const $428cb09ff0e03c7b$export$9dd6ff9ea0189349 = (theme)=>({
        controls: {
            main: $428cb09ff0e03c7b$var$_ref7,
            repeat: {
                main: $428cb09ff0e03c7b$var$_ref6,
                button: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    active: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    inactive: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                }
            },
            prev: {
                main: $428cb09ff0e03c7b$var$_ref5,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            play: {
                main: $428cb09ff0e03c7b$var$_ref4,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            pause: {
                main: $428cb09ff0e03c7b$var$_ref3,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            next: {
                main: $428cb09ff0e03c7b$var$_ref2,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;& path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}}&:hover{&>svg{& path{fill:", theme.colors.secondary.dark, ";}}}", "")
            },
            random: {
                main: $428cb09ff0e03c7b$var$_ref,
                button: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    active: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    inactive: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                }
            }
        }
    });

});


parcelRegister("kiQFh", function(module, exports) {

$parcel$export(module.exports, "CurrentTrack", function () { return $5c477e0191c16eaf$export$f01c3456559809ce; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $iVvpl = parcelRequire("iVvpl");
const $5c477e0191c16eaf$export$f01c3456559809ce = ({ track: track, trackAuthorName: trackAuthorName, progress: progress, duration: duration, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    // track
    const { coverId: coverId, name: trackName } = track ?? {};
    const trackHasCover = !!coverId;
    const coverSrc = (0, $jpNoL.useFile)(coverId || "");
    const elapsedTime = (0, $1Fj5G.audioDurationFormatter)(progress);
    const durationTime = (0, $1Fj5G.audioDurationFormatter)(duration);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $iVvpl.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $iVvpl.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $iVvpl.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "56px",
                    height: "56px",
                    src: coverSrc,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $iVvpl.styles)(theme).track.cover.placeholder,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $iVvpl.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $iVvpl.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $iVvpl.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: trackAuthorName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $iVvpl.styles)(theme).track.description.duration,
                        children: [
                            elapsedTime,
                            " / ",
                            durationTime
                        ]
                    })
                ]
            })
        ]
    });
};
$5c477e0191c16eaf$export$f01c3456559809ce.propTypes = {};

});
parcelRegister("iVvpl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fab2663b74d1811b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $fab2663b74d1811b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fab2663b74d1811b$var$_ref = {
    name: "1ojnsow",
    styles: "display:flex;flex-direction:column;min-width:0"
};
var $fab2663b74d1811b$var$_ref2 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $fab2663b74d1811b$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $fab2663b74d1811b$var$_ref2,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:56px;height:56px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $fab2663b74d1811b$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                duration: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.dark, ";", "")
            }
        }
    });

});


parcelRegister("6BxhZ", function(module, exports) {

$parcel$export(module.exports, "Navigation", function () { return $6db02af8a1eb3e17$export$b8a61e5c71402559; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");

var $2j6h5 = parcelRequire("2j6h5");

var $8brSN = parcelRequire("8brSN");
const $6db02af8a1eb3e17$export$b8a61e5c71402559 = ({ volume: volume, onVolumeChange: onVolumeChange })=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const isAudioPlayerOpen = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectOpen));
    const [isVolumeOpen, setIsVolumeOpen] = (0, $bh6RR.useState)(false);
    const label = "Audio Player Volume";
    const name = "audio-player-progress";
    const renderVolumeIcon = ()=>{
        // if volume is muted
        if (volume === 0) // render muted icon
        return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2j6h5.icons).AudioVolumeMute, {});
        // if volume is low
        if (volume <= 0.5) // render min icon
        return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2j6h5.icons).AudioVolumeMin, {});
        // else render max icon
        return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2j6h5.icons).AudioVolumeMax, {});
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $8brSN.styles)(theme).nav.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $8brSN.styles)(theme).nav.volume.main,
                onMouseLeave: ()=>setIsVolumeOpen(false),
                children: [
                    isVolumeOpen && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $8brSN.styles)(theme).nav.volume.control.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                                css: (0, $8brSN.styles)(theme).nav.volume.control.label,
                                htmlFor: name,
                                children: label
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                css: (0, $8brSN.styles)(theme).nav.volume.control.input(volume * 100),
                                "aria-label": "audio player volume",
                                id: name,
                                name: name,
                                type: "range",
                                min: 0,
                                step: 0.05,
                                max: 1,
                                value: volume,
                                onChange: (e)=>onVolumeChange(e)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: [
                            (0, $8brSN.styles)(theme).nav.volume.button.shared,
                            isVolumeOpen ? (0, $8brSN.styles)(theme).nav.volume.button.open : (0, $8brSN.styles)(theme).nav.volume.button.closed,
                            "",
                            ""
                        ],
                        onClick: ()=>setIsVolumeOpen((state)=>!state),
                        type: "button",
                        "aria-label": "open audio volume control",
                        children: renderVolumeIcon()
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8brSN.styles)(theme).nav.open.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: [
                        (0, $8brSN.styles)(theme).nav.open.button.shared,
                        isAudioPlayerOpen ? (0, $8brSN.styles)(theme).nav.open.button.open : (0, $8brSN.styles)(theme).nav.open.button.closed,
                        "",
                        ""
                    ],
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioToggleOpen)()),
                    type: "button",
                    "aria-label": "open audio player",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2j6h5.icons).AudioNav, {})
                })
            })
        ]
    });
};
$6db02af8a1eb3e17$export$b8a61e5c71402559.propTypes = {};

});
parcelRegister("2j6h5", function(module, exports) {

$parcel$export(module.exports, "icons", function () { return $8f43349a0456fbc8$export$df03f54e09e486fa; });

var $gK7by = parcelRequire("gK7by");

var $8xWIU = parcelRequire("8xWIU");

var $gMGtD = parcelRequire("gMGtD");

var $LirFn = parcelRequire("LirFn");
const $8f43349a0456fbc8$export$df03f54e09e486fa = {
    AudioNav: $gK7by.default,
    AudioVolumeMax: $8xWIU.default,
    AudioVolumeMin: $gMGtD.default,
    AudioVolumeMute: $LirFn.default
};

});
parcelRegister("gK7by", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9019e8dd60260e5d$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $9019e8dd60260e5d$var$SvgAudioNav = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M.25 1A.75.75 0 0 1 1 .25h18a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 1Zm0 4A.75.75 0 0 1 1 4.25h18a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 5Zm0 4A.75.75 0 0 1 1 8.25h8a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 9Zm0 4a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 13Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M16.875 9.118c1.654.955 2.48 1.433 2.602 2.121a1.5 1.5 0 0 1 0 .521c-.121.69-.948 1.167-2.602 2.122-1.654.954-2.48 1.432-3.138 1.193a1.499 1.499 0 0 1-.451-.26c-.536-.45-.536-1.405-.536-3.315s0-2.865.536-3.314a1.5 1.5 0 0 1 .451-.26c.657-.24 1.484.238 3.138 1.192Z",
                fill: "#FFF"
            })
        ]
    });
var $9019e8dd60260e5d$export$2e2bcd8739ae039 = $9019e8dd60260e5d$var$SvgAudioNav;

});

parcelRegister("8xWIU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd8bfe3b98ddf118$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $bd8bfe3b98ddf118$var$SvgAudioVolumeMax = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M.003 7.715C.04 5.873.059 4.952.671 4.164c.112-.144.275-.315.413-.431.752-.636 1.746-.636 3.733-.636.71 0 1.065 0 1.403-.092.07-.02.14-.042.209-.067.33-.121.627-.33 1.22-.746C9.987.547 11.156-.275 12.138.082c.188.069.37.168.533.29.848.635.913 2.115 1.042 5.073A71.13 71.13 0 0 1 13.793 8c0 .522-.032 1.46-.08 2.555-.13 2.958-.194 4.438-1.042 5.073-.163.122-.345.221-.533.29-.982.357-2.15-.465-4.49-2.11-.592-.416-.889-.625-1.22-.746a2.61 2.61 0 0 0-.208-.066c-.338-.093-.693-.093-1.403-.093-1.987 0-2.98 0-3.733-.636a3.145 3.145 0 0 1-.413-.43c-.612-.79-.63-1.71-.668-3.552a14.06 14.06 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.49 1.552a.66.66 0 0 1 .97.094l-.529.471.53-.47.002.002.003.004.007.009a2.572 2.572 0 0 1 .079.112c.047.071.111.173.186.305.149.264.339.652.526 1.171C19.64 4.291 20 5.851 20 8c0 2.15-.36 3.71-.736 4.75-.187.52-.377.907-.526 1.172a4.655 4.655 0 0 1-.265.417l-.007.009-.003.003-.001.002s-.001.001-.531-.47l.53.471a.66.66 0 0 1-.971.094.77.77 0 0 1-.09-1.035l.03-.041c.026-.04.07-.11.125-.207a6.28 6.28 0 0 0 .422-.943c.314-.871.644-2.252.644-4.222 0-1.97-.33-3.35-.644-4.222a6.28 6.28 0 0 0-.422-.942 3.152 3.152 0 0 0-.157-.253M15.757 4.416c.333-.197.753-.07.938.286l-.603.357.603-.357v.001l.001.001.002.003.003.007.01.018.024.053c.018.042.042.099.07.17.053.145.12.35.185.62.13.54.252 1.337.252 2.425 0 1.089-.122 1.886-.252 2.426-.065.27-.132.475-.186.619a3.04 3.04 0 0 1-.094.223l-.009.018-.003.007-.002.003v.002s-.001.001-.604-.356l.603.357c-.185.355-.605.483-.938.286-.33-.196-.45-.638-.272-.991l.004-.01.035-.085c.032-.086.08-.23.13-.438.1-.416.208-1.09.208-2.06 0-.971-.108-1.645-.208-2.06a3.757 3.757 0 0 0-.165-.524l-.004-.01c-.179-.354-.058-.795.272-.991Z",
                fill: "#FFF"
            })
        ]
    });
var $bd8bfe3b98ddf118$export$2e2bcd8739ae039 = $bd8bfe3b98ddf118$var$SvgAudioVolumeMax;

});

parcelRegister("gMGtD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca6aa26dfdccaacf$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $ca6aa26dfdccaacf$var$SvgAudioVolumeMin = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M.003 7.715C.043 5.873.062 4.952.7 4.164c.117-.144.288-.315.432-.431.785-.636 1.822-.636 3.897-.636.741 0 1.112 0 1.465-.092.073-.02.146-.042.218-.067.345-.121.654-.33 1.273-.746C10.427.547 11.647-.275 12.672.082c.196.069.387.168.556.29.886.635.954 2.115 1.088 5.073.05 1.096.084 2.033.084 2.555 0 .522-.034 1.46-.084 2.555-.135 2.958-.202 4.438-1.088 5.073-.17.122-.36.221-.556.29-1.025.357-2.245-.465-4.687-2.11-.619-.416-.928-.625-1.273-.746a2.815 2.815 0 0 0-.218-.066c-.353-.093-.724-.093-1.465-.093-2.075 0-3.112 0-3.897-.636a3.21 3.21 0 0 1-.432-.43c-.638-.79-.658-1.71-.697-3.552a13.468 13.468 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.45 4.416a.712.712 0 0 1 .98.286l-.63.357.63-.357v.002l.002.003.004.007.01.018a1.975 1.975 0 0 1 .098.224c.056.144.126.349.193.619.136.54.263 1.337.263 2.425 0 1.089-.127 1.886-.263 2.426-.067.27-.137.475-.193.619a2.921 2.921 0 0 1-.099.223l-.009.018-.004.007-.001.003v.002s-.002.001-.631-.356l.63.357a.712.712 0 0 1-.98.286.744.744 0 0 1-.284-.991l.005-.01c.006-.014.019-.043.035-.085.034-.086.084-.23.137-.438.104-.416.217-1.09.217-2.06 0-.971-.113-1.645-.217-2.06a3.657 3.657 0 0 0-.172-.524l-.005-.01a.744.744 0 0 1 .284-.991Z",
                fill: "#FFF"
            })
        ]
    });
var $ca6aa26dfdccaacf$export$2e2bcd8739ae039 = $ca6aa26dfdccaacf$var$SvgAudioVolumeMin;

});

parcelRegister("LirFn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db2e4a3c9eb2c5c$export$2e2bcd8739ae039; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("bh6RR");
const $5db2e4a3c9eb2c5c$var$SvgAudioVolumeMute = (props)=>/*#__PURE__*/ (0, $9awXB.jsxs)("svg", {
        viewBox: "0 0 21 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                d: "M.003 7.715c.04-1.842.06-2.763.718-3.551.12-.144.296-.315.444-.431.809-.636 1.876-.636 4.012-.636.763 0 1.144 0 1.508-.092.076-.02.15-.042.224-.067.355-.121.674-.33 1.31-.746C10.734.547 11.99-.275 13.046.082c.202.069.398.168.573.29.911.635.98 2.115 1.12 5.073.05 1.096.085 2.033.085 2.555a66.3 66.3 0 0 1-.086 2.555c-.138 2.958-.208 4.438-1.12 5.073-.174.122-.37.221-.572.29-1.055.357-2.312-.465-4.825-2.11-.637-.416-.956-.625-1.31-.746a2.962 2.962 0 0 0-.225-.066c-.364-.093-.745-.093-1.508-.093-2.136 0-3.203 0-4.012-.636a3.259 3.259 0 0 1-.444-.43c-.658-.79-.678-1.71-.718-3.552a13.084 13.084 0 0 1 0-.57Z",
                fill: "#FFF"
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.782 5.52a.745.745 0 0 1 1.048 0l1.452 1.44 1.453-1.44a.745.745 0 0 1 1.048 0c.29.286.29.752 0 1.04L19.33 8l1.453 1.441c.29.287.29.753 0 1.04a.745.745 0 0 1-1.048 0l-1.453-1.44-1.452 1.44a.745.745 0 0 1-1.048 0 .731.731 0 0 1 0-1.04l1.452-1.44-1.452-1.442a.731.731 0 0 1 0-1.04Z",
                fill: "#FFF"
            })
        ]
    });
var $5db2e4a3c9eb2c5c$export$2e2bcd8739ae039 = $5db2e4a3c9eb2c5c$var$SvgAudioVolumeMute;

});


parcelRegister("8brSN", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e020ddbb8c91329d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $e020ddbb8c91329d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e020ddbb8c91329d$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $e020ddbb8c91329d$var$_ref2 = {
    name: "eivff4",
    styles: "display:none"
};
var $e020ddbb8c91329d$var$_ref3 = {
    name: "1xuln4b",
    styles: "position:relative;width:30px;height:30px"
};
var $e020ddbb8c91329d$var$_ref4 = {
    name: "1sgy8tm",
    styles: "display:flex;align-items:center;justify-content:flex-end;height:100%;&>div:not(:last-of-type){margin-right:24px;}"
};
const $e020ddbb8c91329d$export$9dd6ff9ea0189349 = (theme)=>({
        nav: {
            main: $e020ddbb8c91329d$var$_ref4,
            volume: {
                main: $e020ddbb8c91329d$var$_ref3,
                button: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    open: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    closed: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                },
                control: {
                    main: /*#__PURE__*/ (0, $7hler.css)("position:absolute;right:-220%;top:-328%;background-color:", theme.colors.primary.darker, ";padding:8px 12px;border-radius:4px;width:160px;height:36px;transform:rotate(-90deg);", ""),
                    label: $e020ddbb8c91329d$var$_ref2,
                    input: (volumeWidthPercent)=>/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:20px;appearance:none;-webkit-appearance:none;background:transparent;cursor:pointer;&::-webkit-slider-runnable-track{background:linear-gradient(\n              to right,\n              ", theme.colors.accent.normal, " 0% ", volumeWidthPercent, "%,\n              ", theme.colors.secondary.normal, " ", volumeWidthPercent, "%\n                ", 100 - volumeWidthPercent, "%\n            );height:4px;}&::-moz-range-track{background:linear-gradient(\n              to right,\n              ", theme.colors.accent.normal, " 0% ", volumeWidthPercent, "%,\n              ", theme.colors.secondary.normal, " ", volumeWidthPercent, "%\n                ", 100 - volumeWidthPercent, "%\n            );height:4px;}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;margin-top:-6px;height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}&::-moz-range-thumb{height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}", "")
                }
            },
            open: {
                main: $e020ddbb8c91329d$var$_ref,
                button: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                    open: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", ""),
                    closed: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", "")
                }
            }
        }
    });

});


parcelRegister("cLMvT", function(module, exports) {

$parcel$export(module.exports, "Progress", function () { return $73b057f8036f0f79$export$b25a304ec7d746bb; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $eDLPI = parcelRequire("eDLPI");
const $73b057f8036f0f79$export$b25a304ec7d746bb = ({ duration: duration, progress: progress, buffered: buffered, ...attributes })=>{
    const theme = (0, $iwq56.u)();
    const progressWidth = Number.isNaN(progress / duration) ? 0 : progress / duration;
    const progressWidthPercent = (progressWidth + 0.0018) * 100;
    // const progressWidthPercent = Math.round(progressWidth * 100)
    // const bufferedWidth = Number.isNaN(buffered / duration) ? 0 : buffered / duration
    // const bufferedWidthPercent = Math.round(bufferedWidth * 100)
    const label = "Audio Player Progress";
    const name = "audio-player-progress";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $eDLPI.styles)(theme).progress.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("label", {
                css: (0, $eDLPI.styles)(theme).progress.label,
                htmlFor: name,
                children: label
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                css: (0, $eDLPI.styles)(theme).progress.input(progressWidthPercent),
                id: name,
                name: name,
                type: "range",
                min: 0,
                max: duration,
                value: progress,
                ...attributes
            })
        ]
    });
};
$73b057f8036f0f79$export$b25a304ec7d746bb.propTypes = {};

});
parcelRegister("eDLPI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2eea47f83f915da3$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2eea47f83f915da3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2eea47f83f915da3$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $2eea47f83f915da3$var$_ref2 = {
    name: "xb48oe",
    styles: "position:relative;height:100%;top:-6px"
};
const $2eea47f83f915da3$export$9dd6ff9ea0189349 = (theme)=>({
        progress: {
            main: $2eea47f83f915da3$var$_ref2,
            label: $2eea47f83f915da3$var$_ref,
            input: (progressWidthPercent)=>/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100.2%;height:16px;appearance:none;-webkit-appearance:none;background:transparent;cursor:pointer;&::-webkit-slider-runnable-track{background:linear-gradient(\n          to right,\n          ", theme.colors.accent.normal, " 0% ", progressWidthPercent, "%,\n          ", theme.colors.secondary.normal, " ", progressWidthPercent, "%\n            ", 100 - progressWidthPercent, "%\n        );height:4px;}&::-moz-range-track{background:linear-gradient(\n          to right,\n          ", theme.colors.accent.normal, " 0% ", progressWidthPercent, "%,\n          ", theme.colors.secondary.normal, " ", progressWidthPercent, "%\n            ", 100 - progressWidthPercent, "%\n        );height:4px;}&::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;margin-top:-8px;height:20px;width:20px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}&::-moz-range-thumb{height:16px;width:16px;border-radius:50%;background-color:", theme.colors.accent.normal, ";border:2px solid ", theme.colors.primary.normal, ";}", "")
        }
    }); /*

(scale: number) => css`
      position: absolute;
      left: 0;
      top: 6px;

      background-color: red;

      height: 100%;
      width: 100%;

      transform: scaleX(${scale});
      transform-origin: left;
    `,

*/ 

});



parcelRegister("angAi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $acdb6f219c7b8dcb$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $acdb6f219c7b8dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $acdb6f219c7b8dcb$var$_ref = {
    name: "eivff4",
    styles: "display:none"
};
var $acdb6f219c7b8dcb$var$_ref2 = {
    name: "2et80v",
    styles: "margin-left:30px"
};
var $acdb6f219c7b8dcb$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $acdb6f219c7b8dcb$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $acdb6f219c7b8dcb$var$_ref5 = {
    name: "1yrybnr",
    styles: "&>div{display:none;}"
};
var $acdb6f219c7b8dcb$var$_ref6 = {
    name: "9b9j84",
    styles: "height:4%"
};
const $acdb6f219c7b8dcb$export$9dd6ff9ea0189349 = (theme)=>({
        player: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.player.height, ";", (0, $gln0L.helpers).app.player.width, ";position:relative;z-index:", (0, $gln0L.z).features.audio.player, ";display:flex;flex-direction:column;background-color:", theme.colors.primary.darker, ";", ""),
            progress: {
                main: $acdb6f219c7b8dcb$var$_ref6
            },
            panel: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.sides, ";display:flex;display:flex;height:94%;", ""),
                audio: {
                    main: /*#__PURE__*/ (0, $7hler.css)("width:33.333%;display:flex;align-items:center;justify-content:flex-start;", (0, $gln0L.mq).tablet($acdb6f219c7b8dcb$var$_ref5), " ", (0, $gln0L.mq).mobile($acdb6f219c7b8dcb$var$_ref4), ";", "")
                },
                controls: {
                    main: /*#__PURE__*/ (0, $7hler.css)("width:246px;margin:0 auto;", (0, $gln0L.mq).mobile($acdb6f219c7b8dcb$var$_ref3), ";", "")
                },
                nav: {
                    main: /*#__PURE__*/ (0, $7hler.css)("width:33.333%;margin-left:10px;", (0, $gln0L.mq).tablet($acdb6f219c7b8dcb$var$_ref2), " ", (0, $gln0L.mq).mobile($acdb6f219c7b8dcb$var$_ref), ";", "")
                }
            }
        }
    });

});


parcelRegister("7Iuuy", function(module, exports) {

$parcel$export(module.exports, "PlayerAudioPlaylist", function () { return $3e890fbdfd105e1d$export$5402ad09f300f963; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");
var $emkZ3 = parcelRequire("emkZ3");
var $1yt5C = parcelRequire("1yt5C");

var $liaZs = parcelRequire("liaZs");
const $3e890fbdfd105e1d$export$5402ad09f300f963 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const isAudioPlayerOpen = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectOpen));
    const currentTrack = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrack));
    // on playlist touch states
    const [touchStartPosition, setTouchStartPosition] = (0, $bh6RR.useState)({
        x: 0,
        y: 0
    });
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: [
            (0, $liaZs.styles)(theme).playlist.main,
            isAudioPlayerOpen ? (0, $liaZs.styles)(theme).playlist.open : (0, $liaZs.styles)(theme).playlist.closed,
            "",
            ""
        ],
        onTouchStart: (e)=>{
            const { clientX: clientX, clientY: clientY } = e.changedTouches[0];
            setTouchStartPosition({
                x: clientX,
                y: clientY
            });
        },
        onTouchEnd: (e)=>{
            const { clientY: clientY } = e.changedTouches[0];
            // calculate touch distance
            const touchDistance = clientY - touchStartPosition.y;
            // set min touch threshold
            const minTouchThreshold = 200;
            // if touch distance is greater or equal min threshold
            if (touchDistance >= minTouchThreshold) dispatch((0, $jAL4t.playerAudioSetClosed)());
        },
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $liaZs.styles)(theme).playlist.current,
                children: currentTrack && /*#__PURE__*/ (0, $9awXB.jsx)((0, $1yt5C.TrackViewAudioPlaylist), {})
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $liaZs.styles)(theme).playlist.tracks,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $emkZ3.TrackListAudioPlaylist), {})
            })
        ]
    });
};
$3e890fbdfd105e1d$export$5402ad09f300f963.propTypes = {};

});
parcelRegister("liaZs", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f239573d4e61ff5e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $f239573d4e61ff5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f239573d4e61ff5e$var$_ref = {
    name: "13udsys",
    styles: "height:100%"
};
var $f239573d4e61ff5e$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f239573d4e61ff5e$var$_ref3 = {
    name: "evk0yx",
    styles: "top:100vh;opacity:0"
};
const $f239573d4e61ff5e$export$9dd6ff9ea0189349 = (theme)=>({
        playlist: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.sides, ";", (0, $gln0L.helpers).app.playlist.height, ";", (0, $gln0L.helpers).app.playlist.width, ";z-index:", (0, $gln0L.z).features.audio.playlist, ";display:flex;flex-direction:column;position:fixed;overflow:hidden;overflow-y:scroll;transition:top 0.2s,opacity 0.4s;background-color:", theme.colors.primary.normal, ";", ""),
            open: /*#__PURE__*/ (0, $7hler.css)("top:", (0, $gln0L.constants).app.header.desktop.height, ";", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("top:", (0, $gln0L.constants).app.header.mobile.height, ";", "")), " opacity:1;", ""),
            closed: $f239573d4e61ff5e$var$_ref3,
            current: /*#__PURE__*/ (0, $7hler.css)("&>div{margin-bottom:50px;", (0, $gln0L.mq).mobile($f239573d4e61ff5e$var$_ref2), ";}", ""),
            tracks: $f239573d4e61ff5e$var$_ref
        }
    });

});



parcelRegister("jAL4t", function(module, exports) {

$parcel$export(module.exports, "playerSlice", function () { return $e1c3eafd78572f6c$export$6e3f0fced909207; });
$parcel$export(module.exports, "playerAudioSetCurrentTrack", function () { return $e1c3eafd78572f6c$export$c7935c9a76cf15f1; });
$parcel$export(module.exports, "playerAudioSetCurrentTrackReady", function () { return $e1c3eafd78572f6c$export$c76f55635b37d0a0; });
$parcel$export(module.exports, "playerAudioSetCurrentTrackPlaying", function () { return $e1c3eafd78572f6c$export$4435ec57ae5f3ab9; });
$parcel$export(module.exports, "playerAudioSetNextTrack", function () { return $e1c3eafd78572f6c$export$773b2114c78c003e; });
$parcel$export(module.exports, "playerAudioSetPrevTrack", function () { return $e1c3eafd78572f6c$export$aa19b6c6d1d860c3; });
$parcel$export(module.exports, "playerAudioSetRepeatTrack", function () { return $e1c3eafd78572f6c$export$11bf1292d535949e; });
$parcel$export(module.exports, "playerAudioSetRandomTrack", function () { return $e1c3eafd78572f6c$export$d2acfe9cc261e87a; });
$parcel$export(module.exports, "playerAudioToggleRepeat", function () { return $e1c3eafd78572f6c$export$f47fed164c8dcf6f; });
$parcel$export(module.exports, "playerAudioToggleRandom", function () { return $e1c3eafd78572f6c$export$1616f3dcb976fd63; });
$parcel$export(module.exports, "playerAudioToggleOpen", function () { return $e1c3eafd78572f6c$export$51610af521ec7afd; });
$parcel$export(module.exports, "playerAudioSetOpen", function () { return $e1c3eafd78572f6c$export$4d2aedf91566643; });
$parcel$export(module.exports, "playerAudioSetClosed", function () { return $e1c3eafd78572f6c$export$a1edf3642649277f; });
$parcel$export(module.exports, "playerAudioFilterPlaylistTrack", function () { return $e1c3eafd78572f6c$export$75030b4f0ff63aaf; });
$parcel$export(module.exports, "playerAudioFilterPlaylistUserTracks", function () { return $e1c3eafd78572f6c$export$3dc5256278aacd89; });
$parcel$export(module.exports, "playerAudioUpdatePlaylistTrack", function () { return $e1c3eafd78572f6c$export$56a02b674638e7d4; });
$parcel$export(module.exports, "playerAudioSelectPlaylist", function () { return $e1c3eafd78572f6c$export$47d928be6f4dcc98; });
$parcel$export(module.exports, "playerAudioSelectPlaylistLength", function () { return $e1c3eafd78572f6c$export$6a9b1fbd3c83f3fe; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrack", function () { return $e1c3eafd78572f6c$export$57968c275f4eaaf5; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrackAction", function () { return $e1c3eafd78572f6c$export$89a2733de17cebde; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrackReady", function () { return $e1c3eafd78572f6c$export$14cc090a206fb988; });
$parcel$export(module.exports, "playerAudioSelectCurrentTrackPlaying", function () { return $e1c3eafd78572f6c$export$af20843d4124aca4; });
$parcel$export(module.exports, "playerAudioSelectRepeat", function () { return $e1c3eafd78572f6c$export$aab427a8ffd01b7d; });
$parcel$export(module.exports, "playerAudioSelectRandom", function () { return $e1c3eafd78572f6c$export$b40204deaea2321b; });
$parcel$export(module.exports, "playerAudioSelectOpen", function () { return $e1c3eafd78572f6c$export$109045197ee506ec; });
$parcel$export(module.exports, "playerReducer", function () { return $e1c3eafd78572f6c$export$e21df831734792fb; });

var $kvj5V = parcelRequire("kvj5V");
const $e1c3eafd78572f6c$var$initialState = {
    audio: {
        playlist: [],
        current: {
            action: 0,
            ready: false,
            playing: false,
            index: -1
        },
        repeat: false,
        random: false,
        open: false
    },
    video: {}
};
const $e1c3eafd78572f6c$export$6e3f0fced909207 = (0, $kvj5V.createSlice)({
    name: "player",
    initialState: $e1c3eafd78572f6c$var$initialState,
    reducers: {
        // set audio player current track
        playerAudioSetCurrentTrack: (state, action)=>{
            const { track: track } = action.payload;
            // check if track exists in playlist
            const idx = state.audio.playlist.findIndex((t)=>t.id === track.id);
            // if track is already in playlist
            if (idx !== -1) {
                // reset ready state
                state.audio.current.ready = false;
                // increment current action
                state.audio.current.action += 1;
                // set current index as index of track in the playlist
                state.audio.current.index = idx;
            }
            // if track is not in playlist
            if (idx === -1) {
                // add track to playlist
                state.audio.playlist.push(track);
                // reset ready state
                state.audio.current.ready = false;
                // increment current action
                state.audio.current.action += 1;
                // set current index as last playlist index
                state.audio.current.index = state.audio.playlist.length - 1;
            }
        },
        // set audio player current track ready
        playerAudioSetCurrentTrackReady: (state, action)=>{
            // set ready state
            state.audio.current.ready = action.payload.state;
        },
        // set audio player current track playing
        playerAudioSetCurrentTrackPlaying: (state, action)=>{
            // set playing state
            state.audio.current.playing = action.payload.state;
        },
        // set audio player next track
        playerAudioSetNextTrack: (state)=>{
            // get current track index
            const { index: currentTrackIndex } = state.audio.current;
            // get last playlist index
            const lastPlaylistIndex = state.audio.playlist.length - 1;
            // get first playlist index
            const firstPlaylistIndex = 0;
            // if current track has index and playlist last index is >= 0
            if (currentTrackIndex !== undefined && lastPlaylistIndex >= 0) {
                // get next playlist index
                const nextPlaylistIndex = currentTrackIndex + 1;
                switch(true){
                    case lastPlaylistIndex === firstPlaylistIndex:
                        // if last playlist index equals first playlist index
                        // there is just one track in playlist
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as last playlist index
                        state.audio.current.index = lastPlaylistIndex;
                        break;
                    case currentTrackIndex >= lastPlaylistIndex:
                        // if current track index is greater or equal to last playlist index
                        // playlist is over, start from the first index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as first playlist index
                        state.audio.current.index = firstPlaylistIndex;
                        break;
                    default:
                        // else just set next playlist index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as next playlist index
                        state.audio.current.index = nextPlaylistIndex;
                        break;
                }
            }
        },
        // set audio player prev track
        playerAudioSetPrevTrack: (state)=>{
            // get current track index
            const { index: currentTrackIndex } = state.audio.current;
            // get last playlist index
            const lastPlaylistIndex = state.audio.playlist.length - 1;
            // get first playlist index
            const firstPlaylistIndex = 0;
            // if current track has index and playlist last index is >= 0
            if (currentTrackIndex !== undefined && lastPlaylistIndex >= 0) {
                // get prev playlist index
                const prevPlaylistIndex = currentTrackIndex - 1;
                switch(true){
                    case lastPlaylistIndex === firstPlaylistIndex:
                        // if last playlist index equals first playlist index
                        // there is just one track in playlist
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as last playlist index
                        state.audio.current.index = lastPlaylistIndex;
                        break;
                    case currentTrackIndex <= firstPlaylistIndex:
                        // if current track index is less or equal to first playlist index
                        // playlist is over, start from the last index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as last playlist index
                        state.audio.current.index = lastPlaylistIndex;
                        break;
                    default:
                        // else just set prev playlist index
                        // reset ready state
                        state.audio.current.ready = false;
                        // increment current action
                        state.audio.current.action += 1;
                        // set current index as prev playlist index
                        state.audio.current.index = prevPlaylistIndex;
                        break;
                }
            }
        },
        // set audio player repeat track
        playerAudioSetRepeatTrack: (state)=>{
            const currentPlaylistIndex = state.audio.current.index;
            // increment current action
            state.audio.current.action += 1;
            // set current index as current index
            state.audio.current.index = currentPlaylistIndex;
        },
        // set audio player random track
        playerAudioSetRandomTrack: (state)=>{
            // get playlist length
            const playlistLength = state.audio.playlist.length;
            // get random index
            const randomPlaylistIndex = Math.floor(Math.random() * playlistLength);
            // if random playlist index is defined (0 - n)
            if (randomPlaylistIndex !== undefined) {
                // reset ready state
                state.audio.current.ready = false;
                // increment current action
                state.audio.current.action += 1;
                // set current index as random playlist index
                state.audio.current.index = randomPlaylistIndex;
            }
        },
        // toggle audio player repeat
        playerAudioToggleRepeat: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    repeat: !state.audio.repeat
                }
            }),
        // toggle audio player random
        playerAudioToggleRandom: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    random: !state.audio.random
                }
            }),
        // toggle audio player open
        playerAudioToggleOpen: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    open: !state.audio.open
                }
            }),
        // set audio player open
        playerAudioSetOpen: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    open: true
                }
            }),
        // set audio player closed
        playerAudioSetClosed: (state)=>({
                ...state,
                audio: {
                    ...state.audio,
                    open: false
                }
            }),
        // filter track
        playerAudioFilterPlaylistTrack: (state, action)=>{
            const { id: id } = action.payload;
            // check if track exists in playlist
            const idx = state.audio.playlist.findIndex((t)=>t.id === id);
            if (idx !== -1) {
                // if track currently playing
                if (idx === state.audio.current.index) // reset current track state
                state.audio.current = {
                    ...state.audio.current,
                    ready: false,
                    playing: false,
                    index: -1
                };
                // filter track from playlist
                state.audio.playlist = state.audio.playlist.filter((t)=>t.id !== id);
            }
        },
        // filter user tracks
        playerAudioFilterPlaylistUserTracks: (state, action)=>{
            const { userId: userId } = action.payload;
            // define user tracks map
            const userTracksMap = {};
            // iterate over each track in playlist
            state.audio.playlist.forEach((t, idx)=>{
                // if track belongs to user
                if (t.userId === userId) // add track to map
                userTracksMap[idx] = true;
            });
            // if user track currently playing
            if (userTracksMap[state.audio.current.index]) // reset current track state
            state.audio.current = {
                ...state.audio.current,
                ready: false,
                playing: false,
                index: -1
            };
            // filter user track from playlist
            state.audio.playlist = state.audio.playlist.filter((t)=>t.userId !== userId);
        },
        // update track in audio player playlist
        playerAudioUpdatePlaylistTrack: (state, action)=>{
            const { updatedTrack: updatedTrack } = action.payload;
            // update track in playlist
            const idx = state.audio.playlist.findIndex((t)=>t.id === updatedTrack.id);
            if (idx !== -1) {
                const currentTrack = state.audio.playlist[idx];
                state.audio.playlist[idx] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
        }
    }
});
const { playerAudioSetCurrentTrack: $e1c3eafd78572f6c$export$c7935c9a76cf15f1, playerAudioSetCurrentTrackReady: $e1c3eafd78572f6c$export$c76f55635b37d0a0, playerAudioSetCurrentTrackPlaying: $e1c3eafd78572f6c$export$4435ec57ae5f3ab9, playerAudioSetNextTrack: $e1c3eafd78572f6c$export$773b2114c78c003e, playerAudioSetPrevTrack: $e1c3eafd78572f6c$export$aa19b6c6d1d860c3, playerAudioSetRepeatTrack: $e1c3eafd78572f6c$export$11bf1292d535949e, playerAudioSetRandomTrack: $e1c3eafd78572f6c$export$d2acfe9cc261e87a, playerAudioToggleRepeat: $e1c3eafd78572f6c$export$f47fed164c8dcf6f, playerAudioToggleRandom: $e1c3eafd78572f6c$export$1616f3dcb976fd63, playerAudioToggleOpen: $e1c3eafd78572f6c$export$51610af521ec7afd, playerAudioSetOpen: $e1c3eafd78572f6c$export$4d2aedf91566643, playerAudioSetClosed: $e1c3eafd78572f6c$export$a1edf3642649277f, playerAudioFilterPlaylistTrack: $e1c3eafd78572f6c$export$75030b4f0ff63aaf, playerAudioFilterPlaylistUserTracks: $e1c3eafd78572f6c$export$3dc5256278aacd89, playerAudioUpdatePlaylistTrack: $e1c3eafd78572f6c$export$56a02b674638e7d4 } = $e1c3eafd78572f6c$export$6e3f0fced909207.actions;
const $e1c3eafd78572f6c$export$47d928be6f4dcc98 = (state)=>state.player.audio.playlist;
const $e1c3eafd78572f6c$export$6a9b1fbd3c83f3fe = (state)=>state.player.audio.playlist.length;
const $e1c3eafd78572f6c$export$57968c275f4eaaf5 = (state)=>state.player.audio.playlist[state.player.audio.current.index];
const $e1c3eafd78572f6c$export$89a2733de17cebde = (state)=>state.player.audio.current.action;
const $e1c3eafd78572f6c$export$14cc090a206fb988 = (state)=>state.player.audio.current.ready;
const $e1c3eafd78572f6c$export$af20843d4124aca4 = (state)=>state.player.audio.current.playing;
const $e1c3eafd78572f6c$export$aab427a8ffd01b7d = (state)=>state.player.audio.repeat;
const $e1c3eafd78572f6c$export$b40204deaea2321b = (state)=>state.player.audio.random;
const $e1c3eafd78572f6c$export$109045197ee506ec = (state)=>state.player.audio.open;
const $e1c3eafd78572f6c$export$e21df831734792fb = $e1c3eafd78572f6c$export$6e3f0fced909207.reducer; // export default playerSlice.reducer

});


parcelRegister("I1WkL", function(module, exports) {

$parcel$export(module.exports, "PostBlockModal", function () { return (parcelRequire("8helY")).PostBlockModal; });
$parcel$export(module.exports, "PostCard", function () { return (parcelRequire("b0AUL")).PostCard; });
$parcel$export(module.exports, "PostCardLocked", function () { return (parcelRequire("aC4ny")).PostCardLocked; });
$parcel$export(module.exports, "PostCardProduct", function () { return (parcelRequire("9q2KH")).PostCardProduct; });
$parcel$export(module.exports, "PostCardPublic", function () { return (parcelRequire("8NDJc")).PostCardPublic; });
$parcel$export(module.exports, "PostCardUploaded", function () { return (parcelRequire("kcTuq")).PostCardUploaded; });
$parcel$export(module.exports, "PostDeleteModal", function () { return (parcelRequire("dYv6s")).PostDeleteModal; });
$parcel$export(module.exports, "PostListFeedPopular", function () { return (parcelRequire("bPfKx")).PostListFeedPopular; });
$parcel$export(module.exports, "PostListFeedRecommended", function () { return (parcelRequire("cClrD")).PostListFeedRecommended; });
$parcel$export(module.exports, "PostListHomePublic", function () { return (parcelRequire("cAzL1")).PostListHomePublic; });
$parcel$export(module.exports, "PostListLibraryLiked", function () { return (parcelRequire("fiP8m")).PostListLibraryLiked; });
$parcel$export(module.exports, "PostListLibraryUnlocked", function () { return (parcelRequire("6KU1f")).PostListLibraryUnlocked; });
$parcel$export(module.exports, "PostListStudioUploaded", function () { return (parcelRequire("6aNk3")).PostListStudioUploaded; });
$parcel$export(module.exports, "PostListUserExclusive", function () { return (parcelRequire("aZNXK")).PostListUserExclusive; });
$parcel$export(module.exports, "PostListUserLatest", function () { return (parcelRequire("fMB6j")).PostListUserLatest; });
$parcel$export(module.exports, "PostListUserPopular", function () { return (parcelRequire("jQg9F")).PostListUserPopular; });
$parcel$export(module.exports, "PostViewCreateStudio", function () { return (parcelRequire("hX44K")).PostViewCreateStudio; });
$parcel$export(module.exports, "PostViewEditStudio", function () { return (parcelRequire("8YBfu")).PostViewEditStudio; });
$parcel$export(module.exports, "PostViewMediaPost", function () { return (parcelRequire("4EDE8")).PostViewMediaPost; });
$parcel$export(module.exports, "postUtilGetPostCardSkeletonSections", function () { return (parcelRequire("cMDgV")).postUtilGetPostCardSkeletonSections; });
parcelRequire("9YYIx");
var $8helY = parcelRequire("8helY");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $9q2KH = parcelRequire("9q2KH");
var $8NDJc = parcelRequire("8NDJc");
var $kcTuq = parcelRequire("kcTuq");
var $dYv6s = parcelRequire("dYv6s");
var $bPfKx = parcelRequire("bPfKx");
var $cClrD = parcelRequire("cClrD");
var $cAzL1 = parcelRequire("cAzL1");
var $fiP8m = parcelRequire("fiP8m");
var $6KU1f = parcelRequire("6KU1f");
var $6aNk3 = parcelRequire("6aNk3");
var $aZNXK = parcelRequire("aZNXK");
var $fMB6j = parcelRequire("fMB6j");
var $jQg9F = parcelRequire("jQg9F");
var $hX44K = parcelRequire("hX44K");
var $8YBfu = parcelRequire("8YBfu");
var $4EDE8 = parcelRequire("4EDE8");

var $cMDgV = parcelRequire("cMDgV");

var $a0vy2 = parcelRequire("a0vy2");

var $dt591 = parcelRequire("dt591");
$parcel$exportWildcard(module.exports, $a0vy2);
$parcel$exportWildcard(module.exports, $dt591);

});
parcelRegister("9YYIx", function(module, exports) {

$parcel$export(module.exports, "PostBlockModal", function () { return (parcelRequire("8helY")).PostBlockModal; });
$parcel$export(module.exports, "PostCard", function () { return (parcelRequire("b0AUL")).PostCard; });
$parcel$export(module.exports, "PostCardLocked", function () { return (parcelRequire("aC4ny")).PostCardLocked; });
$parcel$export(module.exports, "PostCardProduct", function () { return (parcelRequire("9q2KH")).PostCardProduct; });
$parcel$export(module.exports, "PostCardPublic", function () { return (parcelRequire("8NDJc")).PostCardPublic; });
$parcel$export(module.exports, "PostCardUploaded", function () { return (parcelRequire("kcTuq")).PostCardUploaded; });
$parcel$export(module.exports, "PostDeleteModal", function () { return (parcelRequire("dYv6s")).PostDeleteModal; });
$parcel$export(module.exports, "PostListFeedPopular", function () { return (parcelRequire("bPfKx")).PostListFeedPopular; });
$parcel$export(module.exports, "PostListFeedRecommended", function () { return (parcelRequire("cClrD")).PostListFeedRecommended; });
$parcel$export(module.exports, "PostListHomePublic", function () { return (parcelRequire("cAzL1")).PostListHomePublic; });
$parcel$export(module.exports, "PostListLibraryLiked", function () { return (parcelRequire("fiP8m")).PostListLibraryLiked; });
$parcel$export(module.exports, "PostListLibraryUnlocked", function () { return (parcelRequire("6KU1f")).PostListLibraryUnlocked; });
$parcel$export(module.exports, "PostListStudioUploaded", function () { return (parcelRequire("6aNk3")).PostListStudioUploaded; });
$parcel$export(module.exports, "PostListUserExclusive", function () { return (parcelRequire("aZNXK")).PostListUserExclusive; });
$parcel$export(module.exports, "PostListUserLatest", function () { return (parcelRequire("fMB6j")).PostListUserLatest; });
$parcel$export(module.exports, "PostListUserPopular", function () { return (parcelRequire("jQg9F")).PostListUserPopular; });
$parcel$export(module.exports, "PostViewCreateStudio", function () { return (parcelRequire("hX44K")).PostViewCreateStudio; });
$parcel$export(module.exports, "PostViewEditStudio", function () { return (parcelRequire("8YBfu")).PostViewEditStudio; });
$parcel$export(module.exports, "PostViewMediaPost", function () { return (parcelRequire("4EDE8")).PostViewMediaPost; });

var $8helY = parcelRequire("8helY");

var $b0AUL = parcelRequire("b0AUL");

var $aC4ny = parcelRequire("aC4ny");

var $9q2KH = parcelRequire("9q2KH");

var $8NDJc = parcelRequire("8NDJc");

var $kcTuq = parcelRequire("kcTuq");

var $dYv6s = parcelRequire("dYv6s");

var $bPfKx = parcelRequire("bPfKx");

var $cClrD = parcelRequire("cClrD");

var $cAzL1 = parcelRequire("cAzL1");

var $fiP8m = parcelRequire("fiP8m");

var $6KU1f = parcelRequire("6KU1f");

var $6aNk3 = parcelRequire("6aNk3");

var $aZNXK = parcelRequire("aZNXK");

var $fMB6j = parcelRequire("fMB6j");

var $jQg9F = parcelRequire("jQg9F");

var $hX44K = parcelRequire("hX44K");

var $8YBfu = parcelRequire("8YBfu");

var $4EDE8 = parcelRequire("4EDE8");

});
parcelRegister("8helY", function(module, exports) {

$parcel$export(module.exports, "PostBlockModal", function () { return $8253e4f6aca6f419$export$8cf4e90fd23f7e6; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $a0vy2 = parcelRequire("a0vy2");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("feH5h");
var $8aQq4 = parcelRequire("8aQq4");

var $bzDDi = parcelRequire("bzDDi");
const $8253e4f6aca6f419$export$8cf4e90fd23f7e6 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const postBlockModalOpen = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostBlockModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $bzDDi.styles)().modal.main,
        children: postBlockModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $a0vy2.postClosePostBlockModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bzDDi.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $8aQq4.PostBlockCard), {})
            })
        })
    });
};
$8253e4f6aca6f419$export$8cf4e90fd23f7e6.propTypes = {};

});
parcelRegister("feH5h", function(module, exports) {

$parcel$export(module.exports, "PostBlockCard", function () { return (parcelRequire("8aQq4")).PostBlockCard; });

var $8aQq4 = parcelRequire("8aQq4");

});
parcelRegister("8aQq4", function(module, exports) {

$parcel$export(module.exports, "PostBlockCard", function () { return $dfb08788a0c4fae7$export$d0aa73622ca1e1d5; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $a0vy2 = parcelRequire("a0vy2");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("bkH7z");
var $dnMTp = parcelRequire("dnMTp");

var $2kzat = parcelRequire("2kzat");
const $dfb08788a0c4fae7$export$d0aa73622ca1e1d5 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const postBlockError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $2kzat.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2kzat.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $a0vy2.postClosePostBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2kzat.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Block Post",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2kzat.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Are you sure you want to block this post?"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $2kzat.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $2kzat.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dnMTp.PostBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $2kzat.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: postBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$dfb08788a0c4fae7$export$d0aa73622ca1e1d5.propTypes = {};

});
parcelRegister("bkH7z", function(module, exports) {

$parcel$export(module.exports, "PostBlockForm", function () { return (parcelRequire("dnMTp")).PostBlockForm; });

var $dnMTp = parcelRequire("dnMTp");

});
parcelRegister("dnMTp", function(module, exports) {

$parcel$export(module.exports, "PostBlockForm", function () { return $4b815d6c004dfe70$export$d796800ab322d21c; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $dt591 = parcelRequire("dt591");
var $b0AUL = parcelRequire("b0AUL");
var $a0vy2 = parcelRequire("a0vy2");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $2aAIa = parcelRequire("2aAIa");
const $4b815d6c004dfe70$export$d796800ab322d21c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const postBlockLoading = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostBlockLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const post = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostBlockModalPost));
    const submitDisabled = postBlockLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $2aAIa.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $2aAIa.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $dt591.postBlock)({
                    id: post?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $2aAIa.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
                        post: post || {},
                        currentUserId: profile?.id || "",
                        onClick: ()=>()=>{},
                        onAuthorNameClick: ()=>()=>{},
                        onAuthorUsernameClick: ()=>()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $2aAIa.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block post",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: postBlockLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$4b815d6c004dfe70$export$d796800ab322d21c.propTypes = {};

});
parcelRegister("2aAIa", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $09c29fd01c0ddecc$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $09c29fd01c0ddecc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $09c29fd01c0ddecc$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $09c29fd01c0ddecc$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                track: $09c29fd01c0ddecc$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("2kzat", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $37d012df7c47389b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $37d012df7c47389b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $37d012df7c47389b$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $37d012df7c47389b$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $37d012df7c47389b$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $37d012df7c47389b$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $37d012df7c47389b$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $37d012df7c47389b$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $37d012df7c47389b$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $37d012df7c47389b$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $37d012df7c47389b$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($37d012df7c47389b$var$_ref8), " ", (0, $gln0L.mq).mobile($37d012df7c47389b$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($37d012df7c47389b$var$_ref6), ";", ""),
            title: $37d012df7c47389b$var$_ref5,
            subtitle: $37d012df7c47389b$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($37d012df7c47389b$var$_ref3), ";", ""),
                form: $37d012df7c47389b$var$_ref2,
                error: $37d012df7c47389b$var$_ref
            }
        }
    });

});



parcelRegister("bzDDi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ed94b942584aeb69$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ed94b942584aeb69$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ed94b942584aeb69$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $ed94b942584aeb69$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($ed94b942584aeb69$var$_ref), ";", "")
        }
    });

});


parcelRegister("b0AUL", function(module, exports) {

$parcel$export(module.exports, "PostCard", function () { return $166c5ec1834ec4e2$export$56c928be863719c7; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
var $6uGoQ = parcelRequire("6uGoQ");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("cJvLm");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
var $4t4rd = parcelRequire("4t4rd");
parcelRequire("i4hFZ");
var $b1YFw = parcelRequire("b1YFw");
var $8CyWe = parcelRequire("8CyWe");

var $eroh6 = parcelRequire("eroh6");
const $166c5ec1834ec4e2$export$56c928be863719c7 = ({ post: post, currentUserId: currentUserId, onClick: onClick, onAuthorNameClick: onAuthorNameClick, onAuthorUsernameClick: onAuthorUsernameClick })=>{
    const theme = (0, $iwq56.u)();
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const [mediaLoadError, setMediaLoadError] = (0, $bh6RR.useState)(false);
    const [headerAvatarError, setHeaderAvatarError] = (0, $bh6RR.useState)(false);
    const { id: postId, userId: userId, trackIds: trackIds, message: message, mediaType: mediaType, mediaId: mediaId, likesCount: likesCount } = post;
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $6uGoQ.useTracks)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const authorHasAvatar = !!authorAvatarId;
    const avatarSource = (0, $jpNoL.useFile)(authorAvatarId || "");
    const postHasMedia = !!mediaId;
    const postMedia = (0, $jpNoL.useFile)(mediaId || "");
    const maxPostDescriptionLength = 84;
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $eroh6.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eroh6.styles)(theme).card.header.main,
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $eroh6.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $eroh6.styles)(theme).card.header.content.avatar.main,
                            children: authorHasAvatar && !headerAvatarError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                                css: (0, $eroh6.styles)(theme).card.header.content.avatar.image,
                                onError: ()=>setHeaderAvatarError(true),
                                loading: "lazy",
                                width: "30px",
                                height: "30px",
                                src: avatarSource,
                                alt: "post author avatar"
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                                css: (0, $eroh6.styles)(theme).card.header.content.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $eroh6.styles)(theme).card.header.content.author.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: (0, $eroh6.styles)(theme).card.header.content.author.name,
                                    onClick: (e)=>onAuthorNameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: (0, $eroh6.styles)(theme).card.header.content.author.username,
                                    onClick: (e)=>onAuthorUsernameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $eroh6.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $eroh6.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).HeartFilled, {})
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $eroh6.styles)(theme).card.header.content.likes.likes,
                                    children: (0, $1Fj5G.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eroh6.styles)(theme).card.media.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: postHasMedia && !mediaLoadError ? /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                    children: [
                        mediaType && mediaType === (0, $2gpGl.EntityPostMediaType).Image && /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $eroh6.styles)(theme).card.media.image,
                            onError: ()=>setMediaLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "150px",
                            src: postMedia,
                            alt: "post media"
                        }),
                        mediaType && mediaType === (0, $2gpGl.EntityPostMediaType).Video && /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("video", {
                                    css: (0, $eroh6.styles)(theme).card.media.video.main,
                                    onError: ()=>setMediaLoadError(true),
                                    width: "180",
                                    muted: true,
                                    preload: "metadata",
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("source", {
                                            src: postMedia,
                                            type: "video/mp4"
                                        }),
                                        "Your browser does not support the video tag."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $eroh6.styles)(theme).card.media.video.play,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $eroh6.styles)(theme).card.media.placeholder,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Ryddm, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $eroh6.styles)(theme).card.content.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eroh6.styles)(theme).card.content.description,
                        children: (0, $4t4rd.stringsCutter)(maxPostDescriptionLength, message || "")
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $eroh6.styles)(theme).card.content.tracks,
                        children: isPostTracksLoading ? tracksLoadingPlaceholder : postTracks && postTracks.map((track)=>{
                            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
                            const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
                            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
                            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
                            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
                            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
                            if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $8CyWe.TrackLocked), {
                                track: track
                            }, `post-${postId}-track-${track.id}`);
                            return /*#__PURE__*/ (0, $9awXB.jsx)((0, $b1YFw.Track), {
                                track: track
                            }, `post-${postId}-track-${track.id}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eroh6.styles)(theme).card.footer,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true"
            })
        ]
    });
};
$166c5ec1834ec4e2$export$56c928be863719c7.propTypes = {};

});
parcelRegister("i4hFZ", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return (parcelRequire("b1YFw")).Track; });
$parcel$export(module.exports, "TrackLocked", function () { return (parcelRequire("8CyWe")).TrackLocked; });

var $b1YFw = parcelRequire("b1YFw");

var $8CyWe = parcelRequire("8CyWe");

});
parcelRegister("b1YFw", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $dbff5d82147bfb71$export$13921ac0cc260818; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $6TBPd = parcelRequire("6TBPd");
const $dbff5d82147bfb71$export$13921ac0cc260818 = ({ track: track })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    const trackHasCover = !!coverId;
    const coverSource = (0, $jpNoL.useFile)(coverId || "");
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $6TBPd.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $6TBPd.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $6TBPd.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "30px",
                    height: "30px",
                    src: coverSource,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {
                    css: (0, $6TBPd.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $6TBPd.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $6TBPd.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $6TBPd.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $6TBPd.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
            })
        ]
    });
};
$dbff5d82147bfb71$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("6TBPd", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fb2d826d2cc919be$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $fb2d826d2cc919be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fb2d826d2cc919be$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $fb2d826d2cc919be$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $fb2d826d2cc919be$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});


parcelRegister("8CyWe", function(module, exports) {

$parcel$export(module.exports, "TrackLocked", function () { return $ab0bbb15524c95f9$export$95154993d63756c1; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $gYaJK = parcelRequire("gYaJK");
const $ab0bbb15524c95f9$export$95154993d63756c1 = ({ track: track })=>{
    const theme = (0, $iwq56.u)();
    const { userId: userId, name: name } = track;
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $gYaJK.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gYaJK.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {
                    css: (0, $gYaJK.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $gYaJK.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $gYaJK.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $gYaJK.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gYaJK.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
            })
        ]
    });
};
$ab0bbb15524c95f9$export$95154993d63756c1.propTypes = {};

});
parcelRegister("gYaJK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9a3ed808915720ae$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $9a3ed808915720ae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9a3ed808915720ae$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $9a3ed808915720ae$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $9a3ed808915720ae$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});



parcelRegister("eroh6", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $36ba68f4fd621ac3$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $36ba68f4fd621ac3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $36ba68f4fd621ac3$var$_ref = {
    name: "1h4mco6",
    styles: "&>div:not(:last-of-type){margin-bottom:8px;}"
};
var $36ba68f4fd621ac3$var$_ref2 = {
    name: "k231at",
    styles: "position:relative;height:150px;border-radius:4px"
};
var $36ba68f4fd621ac3$var$_ref3 = {
    name: "1kui3n4",
    styles: "display:flex;align-items:center;margin-left:8px"
};
var $36ba68f4fd621ac3$var$_ref4 = {
    name: "1kt1pq0",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto"
};
var $36ba68f4fd621ac3$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
var $36ba68f4fd621ac3$var$_ref6 = {
    name: "2d7q80",
    styles: "flex-grow:0;flex-shrink:0;position:relative;width:180px;height:282px;cursor:pointer;overflow:hidden"
};
const $36ba68f4fd621ac3$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $36ba68f4fd621ac3$var$_ref6,
            // header
            header: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $36ba68f4fd621ac3$var$_ref5,
                    avatar: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;height:30px;width:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                        image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    author: {
                        main: $36ba68f4fd621ac3$var$_ref4,
                        name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).c, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).c, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    },
                    likes: {
                        main: $36ba68f4fd621ac3$var$_ref3,
                        icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-right:4px;&>svg{width:14px;height:14px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                        likes: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";", "")
                    }
                }
            },
            // media
            media: {
                main: $36ba68f4fd621ac3$var$_ref2,
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                video: {
                    main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                    play: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:60%;left:50%;transform:translate(-50%, -60%);&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.secondary.normal, ";}&>svg>circle{stroke:", theme.colors.secondary.normal, ";}", "")
                },
                placeholder: /*#__PURE__*/ (0, $7hler.css)("height:100%;background-color:", theme.colors.primary.darker, ";&>svg{position:absolute;top:60%;left:50%;width:30px;height:40px;transform:translate(-50%, -60%);}&>svg>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            // content
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("height:130px;overflow:hidden;padding:8px 8px 0px 8px;border-radius:0px 0px 4px 4px;background-color:", theme.colors.primary.darker, ";", ""),
                description: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";line-height:120%;word-break:break-word;height:62px;overflow:hidden;margin-bottom:8px;", ""),
                tracks: $36ba68f4fd621ac3$var$_ref
            },
            // footer
            footer: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.footer, ";position:absolute;bottom:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n        180deg,\n        ", theme.colors.primary.normal, "00 25.21%,\n        ", theme.colors.primary.normal, " 100%\n      );", "")
        }
    });

});


parcelRegister("aC4ny", function(module, exports) {

$parcel$export(module.exports, "PostCardLocked", function () { return $226f48dd58932fbb$export$a7b4b10f2847bb72; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");

var $bOYjk = parcelRequire("bOYjk");
const $226f48dd58932fbb$export$a7b4b10f2847bb72 = ({ post: post, onClick: onClick, onAuthorNameClick: onAuthorNameClick, onAuthorUsernameClick: onAuthorUsernameClick })=>{
    const theme = (0, $iwq56.u)();
    const [headerAvatarError, setHeaderAvatarError] = (0, $bh6RR.useState)(false);
    const { userId: userId, likesCount: likesCount } = post;
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    const authorHasAvatar = !!authorAvatarId;
    const avatarSource = (0, $jpNoL.useFile)(authorAvatarId || "");
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $bOYjk.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bOYjk.styles)(theme).card.lock.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {
                    css: (0, $bOYjk.styles)(theme).card.lock.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bOYjk.styles)(theme).card.overlay.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: (0, $bOYjk.styles)(theme).card.overlay.button,
                    onClick: (e)=>onClick(e),
                    type: "button",
                    "aria-label": "unlock track",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Unlock, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bOYjk.styles)(theme).card.header.main,
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $bOYjk.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $bOYjk.styles)(theme).card.header.content.avatar.main,
                            children: authorHasAvatar && !headerAvatarError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                                css: (0, $bOYjk.styles)(theme).card.header.content.avatar.image,
                                onError: ()=>setHeaderAvatarError(true),
                                loading: "lazy",
                                width: "30px",
                                height: "30px",
                                src: avatarSource,
                                alt: "post author avatar"
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                                css: (0, $bOYjk.styles)(theme).card.header.content.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $bOYjk.styles)(theme).card.header.content.author.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: (0, $bOYjk.styles)(theme).card.header.content.author.name,
                                    onClick: (e)=>onAuthorNameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: (0, $bOYjk.styles)(theme).card.header.content.author.username,
                                    onClick: (e)=>onAuthorUsernameClick(e),
                                    type: "button",
                                    "aria-label": "explore track author",
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $bOYjk.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $bOYjk.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).HeartFilled, {})
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $bOYjk.styles)(theme).card.header.content.likes.likes,
                                    children: (0, $1Fj5G.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bOYjk.styles)(theme).card.footer,
                "aria-hidden": "true"
            })
        ]
    });
};
$226f48dd58932fbb$export$a7b4b10f2847bb72.propTypes = {};

});
parcelRegister("bOYjk", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b95824869e23b409$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $b95824869e23b409$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b95824869e23b409$var$_ref = {
    name: "1kui3n4",
    styles: "display:flex;align-items:center;margin-left:8px"
};
var $b95824869e23b409$var$_ref2 = {
    name: "1kt1pq0",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto"
};
var $b95824869e23b409$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $b95824869e23b409$var$_ref4 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $b95824869e23b409$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
const $b95824869e23b409$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;position:relative;width:180px;height:282px;background-color:", theme.colors.primary.darker, ";cursor:pointer;overflow:hidden;transition:border 0.2s;&:hover>div{opacity:1;}", ""),
            lock: {
                main: $b95824869e23b409$var$_ref5,
                icon: $b95824869e23b409$var$_ref4
            },
            // overlay
            overlay: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.overlay, ";display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:4px;background-color:", theme.colors.primary.normal, "E4;transition:opacity 0.2s,border 0.2s;opacity:0;", ""),
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:30px;height:30px;& path{fill:", theme.colors.accent.normal, ";}}", "")
            },
            // header
            header: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $b95824869e23b409$var$_ref3,
                    avatar: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;height:30px;width:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                        image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    author: {
                        main: $b95824869e23b409$var$_ref2,
                        name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).c, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).c, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    },
                    likes: {
                        main: $b95824869e23b409$var$_ref,
                        icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-right:4px;&>svg{width:14px;height:14px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                        likes: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";", "")
                    }
                }
            },
            // footer
            footer: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.footer, ";position:absolute;bottom:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n        180deg,\n        ", theme.colors.primary.normal, "00 25.21%,\n        ", theme.colors.primary.normal, " 100%\n      );", "")
        }
    });

});


parcelRegister("9q2KH", function(module, exports) {

$parcel$export(module.exports, "PostCardProduct", function () { return $fde076654c3db560$export$3d9c62c05422580c; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $kCXf9 = parcelRequire("kCXf9");
const $fde076654c3db560$export$3d9c62c05422580c = ()=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kCXf9.styles)(theme).card.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $kCXf9.styles)(theme).card.lock.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {
                css: (0, $kCXf9.styles)(theme).card.lock.icon
            })
        })
    });
};
$fde076654c3db560$export$3d9c62c05422580c.propTypes = {};

});
parcelRegister("kCXf9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2a32967a3a22b75c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $2a32967a3a22b75c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2a32967a3a22b75c$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $2a32967a3a22b75c$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
const $2a32967a3a22b75c$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;position:relative;width:180px;height:282px;background-color:", theme.colors.primary.normal, ";overflow:hidden;transition:border 0.2s;&:hover>div{opacity:1;}", ""),
            lock: {
                main: $2a32967a3a22b75c$var$_ref2,
                icon: $2a32967a3a22b75c$var$_ref
            },
            description: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("8NDJc", function(module, exports) {

$parcel$export(module.exports, "PostCardPublic", function () { return $83ab043c912ff229$export$b659014c52e02228; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $ceCYx = parcelRequire("ceCYx");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
var $4t4rd = parcelRequire("4t4rd");
parcelRequire("1TdPt");
var $l7e6s = parcelRequire("l7e6s");
parcelRequire("1ixsm");
var $l8Iim = parcelRequire("l8Iim");
var $dr3Z2 = parcelRequire("dr3Z2");

var $5avHq = parcelRequire("5avHq");
const $83ab043c912ff229$export$b659014c52e02228 = ({ post: post, overlayAction: overlayAction })=>{
    const theme = (0, $iwq56.u)();
    const [mediaLoadError, setMediaLoadError] = (0, $bh6RR.useState)(false);
    const [overlayAvatarError, setOverlayAvatarError] = (0, $bh6RR.useState)(false);
    const [headerAvatarError, setHeaderAvatarError] = (0, $bh6RR.useState)(false);
    const [hover, setHover] = (0, $bh6RR.useState)(false);
    const { id: postId, userId: userId, trackIds: trackIds, message: message, mediaType: mediaType, mediaId: mediaId, likesCount: likesCount } = post;
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $ceCYx.useTracksPublic)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const authorHasAvatar = !!authorAvatarId;
    const avatarSource = (0, $jpNoL.useFile)(authorAvatarId || "");
    const postHasMedia = !!mediaId;
    const postMedia = (0, $jpNoL.useFile)(mediaId || "");
    const maxPostDescriptionLength = 84;
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $5avHq.styles)(theme).card.main,
        onMouseEnter: ()=>setHover(true),
        onMouseLeave: ()=>setHover(false),
        children: [
            overlayAction && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $5avHq.styles)(theme).card.overlay.main(hover),
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $5avHq.styles)(theme).card.overlay.avatar.main,
                        children: authorHasAvatar && !overlayAvatarError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $5avHq.styles)(theme).card.overlay.avatar.image,
                            onError: ()=>setOverlayAvatarError(true),
                            loading: "lazy",
                            width: "80px",
                            height: "80px",
                            src: avatarSource,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                            css: (0, $5avHq.styles)(theme).card.overlay.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $5avHq.styles)(theme).card.overlay.author.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $5avHq.styles)(theme).card.overlay.author.name,
                                children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $5avHq.styles)(theme).card.overlay.author.username,
                                children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $5avHq.styles)(theme).card.overlay.follow,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
                            "aria-label": overlayAction.label,
                            appearance: "primary",
                            onClick: (e)=>overlayAction.onClick(e),
                            children: overlayAction.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $5avHq.styles)(theme).card.header.main,
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $5avHq.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $5avHq.styles)(theme).card.header.content.avatar.main,
                            children: authorHasAvatar && !headerAvatarError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                                css: (0, $5avHq.styles)(theme).card.header.content.avatar.image,
                                onError: ()=>setHeaderAvatarError(true),
                                loading: "lazy",
                                width: "30px",
                                height: "30px",
                                src: avatarSource,
                                alt: "post author avatar"
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                                css: (0, $5avHq.styles)(theme).card.header.content.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $5avHq.styles)(theme).card.header.content.author.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $5avHq.styles)(theme).card.header.content.author.name,
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $5avHq.styles)(theme).card.header.content.author.username,
                                    children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $5avHq.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $5avHq.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).HeartFilled, {})
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $5avHq.styles)(theme).card.header.content.likes.likes,
                                    children: (0, $1Fj5G.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $5avHq.styles)(theme).card.media.main,
                children: postHasMedia && !mediaLoadError ? /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                    children: [
                        mediaType && mediaType === (0, $2gpGl.EntityPostMediaType).Image && /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $5avHq.styles)(theme).card.media.image,
                            onError: ()=>setMediaLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "150px",
                            src: postMedia,
                            alt: "post media"
                        }),
                        mediaType && mediaType === (0, $2gpGl.EntityPostMediaType).Video && /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("video", {
                                    css: (0, $5avHq.styles)(theme).card.media.video.main,
                                    onError: ()=>setMediaLoadError(true),
                                    width: "180",
                                    muted: true,
                                    preload: "metadata",
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("source", {
                                            src: postMedia,
                                            type: "video/mp4"
                                        }),
                                        "Your browser does not support the video tag."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $5avHq.styles)(theme).card.media.video.play,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $5avHq.styles)(theme).card.media.placeholder,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Ryddm, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $5avHq.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $5avHq.styles)(theme).card.content.description,
                        children: (0, $4t4rd.stringsCutter)(maxPostDescriptionLength, message || "")
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $5avHq.styles)(theme).card.content.tracks,
                        children: isPostTracksLoading ? tracksLoadingPlaceholder : postTracks && postTracks.map((track)=>{
                            const { visibility: visibility } = track;
                            const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
                            const renderLocked = isContentLocked;
                            if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $dr3Z2.TrackLocked), {
                                track: track
                            }, `public-post-${postId}-track-${track.id}`);
                            return /*#__PURE__*/ (0, $9awXB.jsx)((0, $l8Iim.Track), {
                                track: track
                            }, `public-post-${postId}-track-${track.id}`);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $5avHq.styles)(theme).card.footer
            })
        ]
    });
};
$83ab043c912ff229$export$b659014c52e02228.propTypes = {};

});
parcelRegister("1ixsm", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return (parcelRequire("l8Iim")).Track; });
$parcel$export(module.exports, "TrackLocked", function () { return (parcelRequire("dr3Z2")).TrackLocked; });

var $l8Iim = parcelRequire("l8Iim");

var $dr3Z2 = parcelRequire("dr3Z2");

});
parcelRegister("l8Iim", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $c0453249cd0cd160$export$13921ac0cc260818; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $1keUX = parcelRequire("1keUX");
const $c0453249cd0cd160$export$13921ac0cc260818 = ({ track: track })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    const trackHasCover = !!coverId;
    const coverSource = (0, $jpNoL.useFile)(coverId || "");
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $1keUX.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1keUX.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $1keUX.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "30px",
                    height: "30px",
                    src: coverSource,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {
                    css: (0, $1keUX.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $1keUX.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $1keUX.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $1keUX.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1keUX.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
            })
        ]
    });
};
$c0453249cd0cd160$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("1keUX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $08f9412d87ea54be$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $08f9412d87ea54be$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $08f9412d87ea54be$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $08f9412d87ea54be$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $08f9412d87ea54be$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});


parcelRegister("dr3Z2", function(module, exports) {

$parcel$export(module.exports, "TrackLocked", function () { return $6c4514a5a85cbd93$export$95154993d63756c1; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $4YLjS = parcelRequire("4YLjS");
const $6c4514a5a85cbd93$export$95154993d63756c1 = ({ track: track })=>{
    const theme = (0, $iwq56.u)();
    const { userId: userId, name: name } = track;
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $4YLjS.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $4YLjS.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {
                    css: (0, $4YLjS.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $4YLjS.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $4YLjS.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $4YLjS.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $4YLjS.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
            })
        ]
    });
};
$6c4514a5a85cbd93$export$95154993d63756c1.propTypes = {};

});
parcelRegister("4YLjS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c40f272f959466c7$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c40f272f959466c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c40f272f959466c7$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $c40f272f959466c7$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $c40f272f959466c7$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});



parcelRegister("5avHq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e191a95742a4a7d3$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $e191a95742a4a7d3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e191a95742a4a7d3$var$_ref = {
    name: "1h4mco6",
    styles: "&>div:not(:last-of-type){margin-bottom:8px;}"
};
var $e191a95742a4a7d3$var$_ref2 = {
    name: "k231at",
    styles: "position:relative;height:150px;border-radius:4px"
};
var $e191a95742a4a7d3$var$_ref3 = {
    name: "1kui3n4",
    styles: "display:flex;align-items:center;margin-left:8px"
};
var $e191a95742a4a7d3$var$_ref4 = {
    name: "1kt1pq0",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto"
};
var $e191a95742a4a7d3$var$_ref5 = {
    name: "zjik7",
    styles: "display:flex"
};
var $e191a95742a4a7d3$var$_ref6 = {
    name: "1nvqbcw",
    styles: "display:flex;flex-direction:column;margin-bottom:24px;text-align:center"
};
var $e191a95742a4a7d3$var$_ref7 = {
    name: "2d7q80",
    styles: "flex-grow:0;flex-shrink:0;position:relative;width:180px;height:282px;cursor:pointer;overflow:hidden"
};
const $e191a95742a4a7d3$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $e191a95742a4a7d3$var$_ref7,
            // overlay
            overlay: {
                main: (hover)=>/*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.overlay, ";display:flex;flex-direction:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;border-radius:4px;border:1px solid ", theme.colors.accent.normal, ";transition:opacity 0.2s,border 0.2s;opacity:", hover ? "1" : "0", ";background-color:", theme.colors.primary.normal, "E4;", ""),
                avatar: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:80px;height:80px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:8px;", ""),
                    image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("width:30px;height:30px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                author: {
                    main: $e191a95742a4a7d3$var$_ref6,
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";width:120px;font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;", ""),
                    username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";width:120px;font-size:", (0, $gln0L.typography).sp, ";", "")
                },
                follow: /*#__PURE__*/ (0, $7hler.css)("&>button{font-size:", (0, $gln0L.typography).sp, ";}", "")
            },
            // header
            header: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $e191a95742a4a7d3$var$_ref5,
                    avatar: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;height:30px;width:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                        image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    author: {
                        main: $e191a95742a4a7d3$var$_ref4,
                        name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).c, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).c, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    },
                    likes: {
                        main: $e191a95742a4a7d3$var$_ref3,
                        icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-right:4px;&>svg{width:14px;height:14px;}&>svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                        likes: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";", "")
                    }
                }
            },
            // media
            media: {
                main: $e191a95742a4a7d3$var$_ref2,
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                video: {
                    main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                    play: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:60%;left:50%;transform:translate(-50%, -60%);&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.secondary.normal, ";}&>svg>circle{stroke:", theme.colors.secondary.normal, ";}", "")
                },
                placeholder: /*#__PURE__*/ (0, $7hler.css)("height:100%;background-color:", theme.colors.primary.darker, ";&>svg{position:absolute;top:60%;left:50%;width:30px;height:40px;transform:translate(-50%, -60%);}&>svg>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            // content
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("height:130px;overflow:hidden;padding:8px 8px 0px 8px;border-radius:0px 0px 4px 4px;background-color:", theme.colors.primary.darker, ";", ""),
                description: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";line-height:120%;word-break:break-word;height:62px;overflow:hidden;margin-bottom:8px;", ""),
                tracks: $e191a95742a4a7d3$var$_ref
            },
            // footer
            footer: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.footer, ";position:absolute;bottom:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n        180deg,\n        ", theme.colors.primary.normal, "00 25.21%,\n        ", theme.colors.primary.normal, " 100%\n      );", "")
        }
    });

});


parcelRegister("kcTuq", function(module, exports) {

$parcel$export(module.exports, "PostCardUploaded", function () { return $7cd0bab27b15a151$export$6cc25747a9e57d38; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $6uGoQ = parcelRequire("6uGoQ");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
var $4t4rd = parcelRequire("4t4rd");
parcelRequire("9wR7s");
var $5lY9q = parcelRequire("5lY9q");

var $krHoi = parcelRequire("krHoi");
const $7cd0bab27b15a151$export$6cc25747a9e57d38 = ({ post: post, editDisabled: editDisabled = false, deleteDisabled: deleteDisabled = false, onClick: onClick, onEditClick: onEditClick, onDeleteClick: onDeleteClick })=>{
    const theme = (0, $iwq56.u)();
    const [mediaLoadError, setMediaLoadError] = (0, $bh6RR.useState)(false);
    const { id: postId, trackIds: trackIds, message: message, mediaType: mediaType, mediaId: mediaId, visibility: visibility, likesCount: likesCount, unlocksCount: unlocksCount, commentsCount: commentsCount } = post;
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $6uGoQ.useTracks)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const postHasMedia = !!mediaId;
    const postMedia = (0, $jpNoL.useFile)(mediaId || "");
    const maxPostDescriptionLength = 84;
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $krHoi.styles)(theme).card.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $krHoi.styles)(theme).card.header.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $krHoi.styles)(theme).card.header.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $krHoi.styles)(theme).card.header.content.likes.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $krHoi.styles)(theme).card.header.content.likes.icon,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Heart, {})
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $krHoi.styles)(theme).card.header.content.likes.count,
                                    children: (0, $1Fj5G.numbersFormatter)(likesCount || 0)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $krHoi.styles)(theme).card.header.content.comments.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $krHoi.styles)(theme).card.header.content.comments.icon,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Comment, {})
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $krHoi.styles)(theme).card.header.content.comments.count,
                                    children: (0, $1Fj5G.numbersFormatter)(commentsCount || 0)
                                })
                            ]
                        }),
                        visibility === (0, $2gpGl.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $krHoi.styles)(theme).card.header.content.unlocks.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $krHoi.styles)(theme).card.header.content.unlocks.icon,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $krHoi.styles)(theme).card.header.content.unlocks.count,
                                    children: (0, $1Fj5G.numbersFormatter)(unlocksCount || 0)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $krHoi.styles)(theme).card.media.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: postHasMedia && !mediaLoadError ? /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                    children: [
                        mediaType && mediaType === (0, $2gpGl.EntityPostMediaType).Image && /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $krHoi.styles)(theme).card.media.image,
                            onError: ()=>setMediaLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "150px",
                            src: postMedia,
                            alt: "post media"
                        }),
                        mediaType && mediaType === (0, $2gpGl.EntityPostMediaType).Video && /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("video", {
                                    css: (0, $krHoi.styles)(theme).card.media.video.main,
                                    onError: ()=>setMediaLoadError(true),
                                    width: "180",
                                    muted: true,
                                    preload: "metadata",
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("source", {
                                            src: postMedia,
                                            type: "video/mp4"
                                        }),
                                        "Your browser does not support the video tag."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $krHoi.styles)(theme).card.media.video.play,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $krHoi.styles)(theme).card.media.placeholder,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Ryddm, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $krHoi.styles)(theme).card.content.main,
                onClick: (e)=>onClick(e),
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $krHoi.styles)(theme).card.content.description,
                        children: (0, $4t4rd.stringsCutter)(maxPostDescriptionLength, message || "")
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $krHoi.styles)(theme).card.content.tracks,
                        children: isPostTracksLoading ? tracksLoadingPlaceholder : postTracks && postTracks.map((track)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5lY9q.Track), {
                                track: track
                            }, `uploaded-post-${postId}-track-${track.id}`))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $krHoi.styles)(theme).card.footer.main,
                onClick: (e)=>e.stopPropagation(),
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $krHoi.styles)(theme).card.footer.buttons.main,
                    children: [
                        onEditClick && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $krHoi.styles)(theme).card.footer.buttons.edit.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                css: [
                                    (0, $krHoi.styles)(theme).card.footer.buttons.edit.button.shared,
                                    editDisabled ? (0, $krHoi.styles)(theme).card.footer.buttons.edit.button.disabled : (0, $krHoi.styles)(theme).card.footer.buttons.edit.button.enabled,
                                    "",
                                    ""
                                ],
                                onClick: (e)=>onEditClick(e),
                                disabled: editDisabled,
                                type: "button",
                                "aria-label": "edit post",
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Edit, {
                                    css: (0, $krHoi.styles)(theme).card.footer.buttons.edit.icon
                                })
                            })
                        }),
                        onDeleteClick && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $krHoi.styles)(theme).card.footer.buttons.delete.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                css: [
                                    (0, $krHoi.styles)(theme).card.footer.buttons.delete.button.shared,
                                    deleteDisabled ? (0, $krHoi.styles)(theme).card.footer.buttons.delete.button.disabled : (0, $krHoi.styles)(theme).card.footer.buttons.delete.button.enabled,
                                    "",
                                    ""
                                ],
                                onClick: (e)=>onDeleteClick(e),
                                disabled: deleteDisabled,
                                type: "button",
                                "aria-label": "delete post",
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Trash, {
                                    css: (0, $krHoi.styles)(theme).card.footer.buttons.delete.icon
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$7cd0bab27b15a151$export$6cc25747a9e57d38.propTypes = {};

});
parcelRegister("9wR7s", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return (parcelRequire("5lY9q")).Track; });

var $5lY9q = parcelRequire("5lY9q");

});
parcelRegister("5lY9q", function(module, exports) {

$parcel$export(module.exports, "Track", function () { return $5fa7be99c3f653da$export$13921ac0cc260818; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $dX5l9 = parcelRequire("dX5l9");
const $5fa7be99c3f653da$export$13921ac0cc260818 = ({ track: track })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    const trackHasCover = !!coverId;
    const coverSource = (0, $jpNoL.useFile)(coverId || "");
    // track author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dX5l9.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dX5l9.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $dX5l9.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "30px",
                    height: "30px",
                    src: coverSource,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {
                    css: (0, $dX5l9.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $dX5l9.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $dX5l9.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $dX5l9.styles)(theme).track.description.authorName,
                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dX5l9.styles)(theme).track.play,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlayCircle, {})
            })
        ]
    });
};
$5fa7be99c3f653da$export$13921ac0cc260818.propTypes = {};

});
parcelRegister("dX5l9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ce91b12f6650532c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ce91b12f6650532c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ce91b12f6650532c$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $ce91b12f6650532c$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $ce91b12f6650532c$var$_ref,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:16px;height:16px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;margin-right:auto;color:", theme.colors.secondary.normal, ";", ""),
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;line-height:12px;", ""),
                authorName: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).c, ";", "")
            },
            play: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-left:8px;&>svg{width:24px;height:24px;}&>svg>path{fill:", theme.colors.secondary.dark, ";stroke:", theme.colors.secondary.dark, ";}&>svg>circle{stroke:", theme.colors.secondary.dark, ";}", "")
        }
    });

});



parcelRegister("krHoi", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e88497565fea0393$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $e88497565fea0393$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e88497565fea0393$var$_ref = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $e88497565fea0393$var$_ref2 = {
    name: "e3viwr",
    styles: "display:flex;justify-content:center;width:100%"
};
var $e88497565fea0393$var$_ref3 = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $e88497565fea0393$var$_ref4 = {
    name: "e3viwr",
    styles: "display:flex;justify-content:center;width:100%"
};
var $e88497565fea0393$var$_ref5 = {
    name: "1h4mco6",
    styles: "&>div:not(:last-of-type){margin-bottom:8px;}"
};
var $e88497565fea0393$var$_ref6 = {
    name: "k231at",
    styles: "position:relative;height:150px;border-radius:4px"
};
var $e88497565fea0393$var$_ref7 = {
    name: "1swhn0m",
    styles: "display:flex;margin-right:4px;&>svg{width:14px;height:14px;}"
};
var $e88497565fea0393$var$_ref8 = {
    name: "p2fe58",
    styles: "display:flex;align-items:center;min-width:0"
};
var $e88497565fea0393$var$_ref9 = {
    name: "1prft12",
    styles: "display:flex;margin-right:4px;&>svg{width:12px;height:12px;}"
};
var $e88497565fea0393$var$_ref10 = {
    name: "jj94x",
    styles: "display:flex;align-items:center;margin-right:8px;min-width:0"
};
var $e88497565fea0393$var$_ref11 = {
    name: "1swhn0m",
    styles: "display:flex;margin-right:4px;&>svg{width:14px;height:14px;}"
};
var $e88497565fea0393$var$_ref12 = {
    name: "jj94x",
    styles: "display:flex;align-items:center;margin-right:8px;min-width:0"
};
var $e88497565fea0393$var$_ref13 = {
    name: "zjik7",
    styles: "display:flex"
};
var $e88497565fea0393$var$_ref14 = {
    name: "2d7q80",
    styles: "flex-grow:0;flex-shrink:0;position:relative;width:180px;height:282px;cursor:pointer;overflow:hidden"
};
const $e88497565fea0393$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $e88497565fea0393$var$_ref14,
            // header
            header: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.header, ";position:absolute;top:0;left:0;width:100%;height:60px;padding:8px 8px 18px 8px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, " 0%,\n          ", theme.colors.primary.normal, "00 75.79%\n        );", ""),
                content: {
                    main: $e88497565fea0393$var$_ref13,
                    likes: {
                        main: $e88497565fea0393$var$_ref12,
                        icon: $e88497565fea0393$var$_ref11,
                        count: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";", "")
                    },
                    comments: {
                        main: $e88497565fea0393$var$_ref10,
                        icon: $e88497565fea0393$var$_ref9,
                        count: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";", "")
                    },
                    unlocks: {
                        main: $e88497565fea0393$var$_ref8,
                        icon: $e88497565fea0393$var$_ref7,
                        count: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";", "")
                    }
                }
            },
            // media
            media: {
                main: $e88497565fea0393$var$_ref6,
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                video: {
                    main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px 4px 0px 0px;", ""),
                    play: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:60%;left:50%;transform:translate(-50%, -60%);&>svg{width:40px;height:40px;}&>svg>path{fill:", theme.colors.secondary.normal, ";}&>svg>circle{stroke:", theme.colors.secondary.normal, ";}", "")
                },
                placeholder: /*#__PURE__*/ (0, $7hler.css)("height:100%;background-color:", theme.colors.primary.darker, ";&>svg{position:absolute;top:60%;left:50%;width:30px;height:40px;transform:translate(-50%, -60%);}&>svg>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            // content
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("height:130px;overflow:hidden;padding:8px 8px 0px 8px;border-radius:0px 0px 4px 4px;background-color:", theme.colors.primary.darker, ";", ""),
                description: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";line-height:120%;word-break:break-word;height:62px;overflow:hidden;margin-bottom:8px;", ""),
                tracks: $e88497565fea0393$var$_ref5
            },
            // footer
            footer: {
                main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.post.card.footer, ";display:flex;align-items:flex-end;position:absolute;bottom:0;left:0;width:100%;height:60px;background:linear-gradient(\n          180deg,\n          ", theme.colors.primary.normal, "00 25.21%,\n          ", theme.colors.primary.normal, " 100%\n        );", ""),
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;background-color:", theme.colors.primary.darker, "aa;border-radius:0px 0px 4px 4px;height:40px;width:100%;", ""),
                    edit: {
                        main: $e88497565fea0393$var$_ref4,
                        button: {
                            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;", ""),
                            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                            enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                        },
                        icon: $e88497565fea0393$var$_ref3
                    },
                    delete: {
                        main: $e88497565fea0393$var$_ref2,
                        button: {
                            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;", ""),
                            disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                            enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                        },
                        icon: $e88497565fea0393$var$_ref
                    }
                }
            }
        }
    });

});


parcelRegister("dYv6s", function(module, exports) {

$parcel$export(module.exports, "PostDeleteModal", function () { return $1d5c8bb52bf318f1$export$396fe6d9b11c10c; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $a0vy2 = parcelRequire("a0vy2");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("emq7t");
var $67lo3 = parcelRequire("67lo3");

var $cakEf = parcelRequire("cakEf");
const $1d5c8bb52bf318f1$export$396fe6d9b11c10c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const deletePostModalOpen = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostDeleteModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $cakEf.styles)().modal.main,
        children: deletePostModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $a0vy2.postClosePostDeleteModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cakEf.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $67lo3.PostDeleteCard), {})
            })
        })
    });
};
$1d5c8bb52bf318f1$export$396fe6d9b11c10c.propTypes = {};

});
parcelRegister("emq7t", function(module, exports) {

$parcel$export(module.exports, "PostDeleteCard", function () { return (parcelRequire("67lo3")).PostDeleteCard; });

var $67lo3 = parcelRequire("67lo3");

});
parcelRegister("67lo3", function(module, exports) {

$parcel$export(module.exports, "PostDeleteCard", function () { return $0fa33fdf69d76940$export$c143e8fdf6e0e6ca; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $a0vy2 = parcelRequire("a0vy2");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("8kNrW");
var $5PHhV = parcelRequire("5PHhV");

var $b2mpK = parcelRequire("b2mpK");
const $0fa33fdf69d76940$export$c143e8fdf6e0e6ca = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const postDeleteError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $b2mpK.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $b2mpK.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $a0vy2.postClosePostDeleteModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $b2mpK.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Delete Post",
                    icon: (0, $bq9l8.icons).Trash
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $b2mpK.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Are you sure you want to delete your post?"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $b2mpK.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b2mpK.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $5PHhV.PostDeleteForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b2mpK.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: postDeleteError
                        })
                    })
                ]
            })
        ]
    });
};
$0fa33fdf69d76940$export$c143e8fdf6e0e6ca.propTypes = {};

});
parcelRegister("8kNrW", function(module, exports) {

$parcel$export(module.exports, "PostDeleteForm", function () { return (parcelRequire("5PHhV")).PostDeleteForm; });

var $5PHhV = parcelRequire("5PHhV");

});
parcelRegister("5PHhV", function(module, exports) {

$parcel$export(module.exports, "PostDeleteForm", function () { return $9d7c35b264303a02$export$2c7e35ae2bc3f407; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $5CTEA = parcelRequire("5CTEA");
const $9d7c35b264303a02$export$2c7e35ae2bc3f407 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const postDeleteLoading = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostDeleteLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const post = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostDeleteModalPost));
    const submitDisabled = postDeleteLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5CTEA.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $5CTEA.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $dt591.postDelete)({
                    id: post?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $5CTEA.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
                        post: post || {},
                        currentUserId: profile?.id || "",
                        onClick: ()=>()=>{},
                        onAuthorNameClick: ()=>()=>{},
                        onAuthorUsernameClick: ()=>()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $5CTEA.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "delete post",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: postDeleteLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Delete"
                    })
                })
            ]
        })
    });
};
$9d7c35b264303a02$export$2c7e35ae2bc3f407.propTypes = {};

});
parcelRegister("5CTEA", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $115d925c4ea68287$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $115d925c4ea68287$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $115d925c4ea68287$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $115d925c4ea68287$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                track: $115d925c4ea68287$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("b2mpK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d2f262e4c2d989a8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $d2f262e4c2d989a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d2f262e4c2d989a8$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d2f262e4c2d989a8$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d2f262e4c2d989a8$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d2f262e4c2d989a8$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $d2f262e4c2d989a8$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $d2f262e4c2d989a8$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $d2f262e4c2d989a8$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $d2f262e4c2d989a8$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $d2f262e4c2d989a8$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($d2f262e4c2d989a8$var$_ref8), " ", (0, $gln0L.mq).mobile($d2f262e4c2d989a8$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($d2f262e4c2d989a8$var$_ref6), ";", ""),
            title: $d2f262e4c2d989a8$var$_ref5,
            subtitle: $d2f262e4c2d989a8$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($d2f262e4c2d989a8$var$_ref3), ";", ""),
                form: $d2f262e4c2d989a8$var$_ref2,
                error: $d2f262e4c2d989a8$var$_ref
            }
        }
    });

});



parcelRegister("cakEf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1ec2544faaa2458c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $1ec2544faaa2458c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1ec2544faaa2458c$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $1ec2544faaa2458c$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($1ec2544faaa2458c$var$_ref), ";", "")
        }
    });

});


parcelRegister("bPfKx", function(module, exports) {

$parcel$export(module.exports, "PostListFeedPopular", function () { return $1f4af2793e8bde54$export$e936cae6b713be21; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $6Llp0 = parcelRequire("6Llp0");
const $1f4af2793e8bde54$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPopularPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-feed-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $6Llp0.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $6Llp0.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $1f4af2793e8bde54$export$e936cae6b713be21 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const popularPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPopularPosts));
    const popularPostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPopularPostsCount));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!popularPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetPopularPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $3sxbD.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: popularPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: popularPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: popularPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $1f4af2793e8bde54$var$Row
                })
        })
    });
};
$1f4af2793e8bde54$export$e936cae6b713be21.propTypes = {};

});
parcelRegister("6Llp0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ae9da508329a7a09$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $ae9da508329a7a09$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("cClrD", function(module, exports) {

$parcel$export(module.exports, "PostListFeedRecommended", function () { return $a041f7137ec2ac86$export$43345a646054aff1; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $SO4ug = parcelRequire("SO4ug");
const $a041f7137ec2ac86$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectRecommendedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-feed-recommended")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $SO4ug.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $SO4ug.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $a041f7137ec2ac86$export$43345a646054aff1 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const recommendedPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectRecommendedPosts));
    const recommendedPostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectRecommendedPostsCount));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!recommendedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetRecommendedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $3sxbD.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: recommendedPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: recommendedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: recommendedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $a041f7137ec2ac86$var$Row
                })
        })
    });
};
$a041f7137ec2ac86$export$43345a646054aff1.propTypes = {};

});
parcelRegister("SO4ug", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c4b3faf66663a152$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $c4b3faf66663a152$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("cAzL1", function(module, exports) {

$parcel$export(module.exports, "PostListHomePublic", function () { return $47907c43e7263cdc$export$250dcb62c2923f35; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $aC4ny = parcelRequire("aC4ny");
var $8NDJc = parcelRequire("8NDJc");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $1Jx5e = parcelRequire("1Jx5e");
const $47907c43e7263cdc$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPublicPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-home-public")
        })
    });
    const { visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const renderLocked = isContentLocked;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1Jx5e.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)()),
            onAuthorNameClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)()),
            onAuthorUsernameClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)())
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1Jx5e.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $8NDJc.PostCardPublic), {
            post: post,
            overlayAction: {
                name: "Follow",
                label: "follow artist",
                onClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)())
            }
        })
    });
});
const $47907c43e7263cdc$export$250dcb62c2923f35 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const publicPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPublicPosts));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    // TODO: uncomment once 60 posts created
    // const defaultContentCount = 60
    const defaultContentCount = 12;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!publicPosts[index];
    const loadMoreItems = ()=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetPublicPosts)());
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular Posts",
        overrideCss: (0, $3sxbD.contentLayout).home,
        itemWidth: itemWidth,
        itemsCount: defaultContentCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $47907c43e7263cdc$var$Row
                })
        })
    });
};
$47907c43e7263cdc$export$250dcb62c2923f35.propTypes = {};

});
parcelRegister("1Jx5e", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f1b83bca8d2ea46d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $f1b83bca8d2ea46d$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("fiP8m", function(module, exports) {

$parcel$export(module.exports, "PostListLibraryLiked", function () { return $f1ae5697d0261ef3$export$244b1302f656142c; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $ix44C = parcelRequire("ix44C");
const $f1ae5697d0261ef3$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectLikedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-library-liked")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $ix44C.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $ix44C.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $f1ae5697d0261ef3$export$244b1302f656142c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const likedPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectLikedPosts));
    const likedPostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectLikedPostsCount));
    const likedPostsLength = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectLikedPostsLength));
    const likedPostsFetched = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectLikedPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!likedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetLikedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if liked posts are fetched but length is 0
    if (likedPostsFetched && likedPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Liked Posts",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Posts,
            height: "294px",
            title: "You haven't liked any post yet"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Liked Posts",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: likedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: likedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $f1ae5697d0261ef3$var$Row
                })
        })
    });
};
$f1ae5697d0261ef3$export$244b1302f656142c.propTypes = {};

});
parcelRegister("ix44C", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6ed91d17ea65935e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $6ed91d17ea65935e$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("6KU1f", function(module, exports) {

$parcel$export(module.exports, "PostListLibraryUnlocked", function () { return $3a3e5ff53a4bc372$export$797b6c01a2d4a375; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $dUans = parcelRequire("dUans");
const $3a3e5ff53a4bc372$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUnlockedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-library-unlocked")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $dUans.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $dUans.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $3a3e5ff53a4bc372$export$797b6c01a2d4a375 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const unlockedPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUnlockedPosts));
    const unlockedPostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUnlockedPostsCount));
    const unlockedPostsLength = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUnlockedPostsLength));
    const unlockedPostsFetched = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUnlockedPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!unlockedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetUnlockedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if unlocked posts are fetched but length is 0
    if (unlockedPostsFetched && unlockedPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Unlocked Posts",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Posts,
            height: "294px",
            title: "You haven't unlocked any post yet"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Unlocked Posts",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: unlockedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: unlockedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $3a3e5ff53a4bc372$var$Row
                })
        })
    });
};
$3a3e5ff53a4bc372$export$797b6c01a2d4a375.propTypes = {};

});
parcelRegister("dUans", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7c69a735a89a7a7c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $7c69a735a89a7a7c$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("6aNk3", function(module, exports) {

$parcel$export(module.exports, "PostListStudioUploaded", function () { return $b350dd2d91f89ddc$export$776358b8f2e0c990; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $kcTuq = parcelRequire("kcTuq");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $1Op4J = parcelRequire("1Op4J");
const $b350dd2d91f89ddc$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const postDeleteLoading = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostDeleteLoading));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUploadedPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-studio-uploaded")
        })
    });
    const { id: postId, visibility: visibility } = post;
    // if post is locked or loading - artist should not be able to delete it
    const deleteDisabled = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers || postDeleteLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1Op4J.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kcTuq.PostCardUploaded), {
            post: post,
            deleteDisabled: deleteDisabled,
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onEditClick: ()=>navigate(`${(0, $b7fnN.Path).Studio}${(0, $b7fnN.Path).Post}/${postId}`),
            onDeleteClick: ()=>dispatch((0, $a0vy2.postOpenPostDeleteModal)({
                    post: post
                }))
        })
    }, `uploaded-post-${postId}`);
});
const $b350dd2d91f89ddc$export$776358b8f2e0c990 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const uploadedPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUploadedPosts));
    const uploadedPostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUploadedPostsCount));
    const uploadedPostsLength = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUploadedPostsLength));
    const uploadedPostsFetched = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUploadedPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!uploadedPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetUploadedPosts)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if uploaded posts are fetched but length is 0
    if (uploadedPostsFetched && uploadedPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $3sxbD.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: uploadedPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Posts,
            height: "294px",
            title: "Couldn't find any uploaded posts"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Posts",
        overrideCss: (0, $3sxbD.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: uploadedPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: uploadedPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: uploadedPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $b350dd2d91f89ddc$var$Row
                })
        })
    });
};
$b350dd2d91f89ddc$export$776358b8f2e0c990.propTypes = {};

});
parcelRegister("1Op4J", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $af0a3495c4328e68$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $af0a3495c4328e68$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("aZNXK", function(module, exports) {

$parcel$export(module.exports, "PostListUserExclusive", function () { return $c0348ab039a0371d$export$ef6ea7411239cae5; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $1fA6a = parcelRequire("1fA6a");
const $c0348ab039a0371d$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistExclusivePosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-user-exclusive")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1fA6a.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1fA6a.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $c0348ab039a0371d$export$ef6ea7411239cae5 = ()=>{
    const { userId: userId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const artistExclusivePosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistExclusivePosts));
    const artistExclusivePostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistExclusivePostsCount));
    const artistExclusivePostsLength = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistExclusivePostsLength));
    const artistExclusivePostsFetched = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistExclusivePostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistExclusivePosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetArtistExclusivePosts)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if exclusive posts are fetched but length is 0
    if (artistExclusivePostsFetched && artistExclusivePostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $bq9l8.icons).Lock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusivePostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Posts,
            height: "294px",
            title: "Couldn't find any exclusive posts"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $bq9l8.icons).Lock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusivePostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistExclusivePostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistExclusivePostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $c0348ab039a0371d$var$Row
                })
        })
    });
};
$c0348ab039a0371d$export$ef6ea7411239cae5.propTypes = {};

});
parcelRegister("1fA6a", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $06e2465105d7e065$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $06e2465105d7e065$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("fMB6j", function(module, exports) {

$parcel$export(module.exports, "PostListUserLatest", function () { return $1148b2ace96e2a6f$export$c4d71d3afc3cb114; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $7K4oH = parcelRequire("7K4oH");
const $1148b2ace96e2a6f$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistLatestPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-user-latest")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $7K4oH.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $7K4oH.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $1148b2ace96e2a6f$export$c4d71d3afc3cb114 = ()=>{
    const { userId: userId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const artistLatestPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistLatestPosts));
    const artistLatestPostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistLatestPostsCount));
    const artistLatestPostsLength = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistLatestPostsLength));
    const artistLatestPostsFetched = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistLatestPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistLatestPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetArtistLatestPosts)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if latest posts are fetched but length is 0
    if (artistLatestPostsFetched && artistLatestPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $bq9l8.icons).Clock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Posts,
            height: "294px",
            title: "Couldn't find any latest posts"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $bq9l8.icons).Clock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistLatestPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistLatestPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $1148b2ace96e2a6f$var$Row
                })
        })
    });
};
$1148b2ace96e2a6f$export$c4d71d3afc3cb114.propTypes = {};

});
parcelRegister("7K4oH", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7291723bda3e6fa1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $7291723bda3e6fa1$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("jQg9F", function(module, exports) {

$parcel$export(module.exports, "PostListUserPopular", function () { return $719cff26f1688cc3$export$1d57ee2778df2641; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $b0AUL = parcelRequire("b0AUL");
var $aC4ny = parcelRequire("aC4ny");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $cMDgV = parcelRequire("cMDgV");
var $l5cm3 = parcelRequire("l5cm3");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $4y8v5 = parcelRequire("4y8v5");
const $719cff26f1688cc3$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const posts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistPopularPosts));
    const post = posts[index];
    // if post not fetched
    if (!post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $cMDgV.postUtilGetPostCardSkeletonSections)("post-list-user-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $4y8v5.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $aC4ny.PostCardLocked), {
            post: post,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockPostModal)({
                    post: post
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $4y8v5.styles)().posts.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b0AUL.PostCard), {
            post: post,
            currentUserId: currentUserId || "",
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${postId}`),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
            onAuthorUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`)
        })
    });
});
const $719cff26f1688cc3$export$1d57ee2778df2641 = ()=>{
    const { userId: userId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const artistPopularPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistPopularPosts));
    const artistPopularPostsCount = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistPopularPostsCount));
    const artistPopularPostsLength = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistPopularPostsLength));
    const artistPopularPostsFetched = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectArtistPopularPostsFetched));
    const postCardWidth = 180;
    const postCardMarginRight = 20;
    const itemWidth = postCardWidth + postCardMarginRight;
    const postCardHeight = 294;
    const postCardMarginBottom = 0;
    const itemHeight = postCardHeight + postCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistPopularPosts[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $dt591.postGetArtistPopularPosts)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if popular posts are fetched but length is 0
    if (artistPopularPostsFetched && artistPopularPostsLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $bq9l8.icons).Crown,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Posts,
            height: "294px",
            title: "Couldn't find any popular posts"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $bq9l8.icons).Crown,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularPostsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistPopularPostsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistPopularPostsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $719cff26f1688cc3$var$Row
                })
        })
    });
};
$719cff26f1688cc3$export$1d57ee2778df2641.propTypes = {};

});
parcelRegister("4y8v5", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f29d25538264b9a1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $f29d25538264b9a1$export$9dd6ff9ea0189349 = ()=>({
        posts: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("hX44K", function(module, exports) {

$parcel$export(module.exports, "PostViewCreateStudio", function () { return $ee0857ce41fc2d7b$export$596463192fa063d9; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("f46j0");
var $g7hX6 = parcelRequire("g7hX6");

var $iU1SX = parcelRequire("iU1SX");
const $ee0857ce41fc2d7b$export$596463192fa063d9 = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $iU1SX.styles)().card.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $iU1SX.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $iU1SX.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $g7hX6.Form), {})
            })
        })
    });
$ee0857ce41fc2d7b$export$596463192fa063d9.propTypes = {};

});
parcelRegister("f46j0", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("g7hX6")).Form; });

var $g7hX6 = parcelRequire("g7hX6");

});
parcelRegister("g7hX6", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $e7def0d4fd26fd3e$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $i0PvU = parcelRequire("i0PvU");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $iLKNg = parcelRequire("iLKNg");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $dt591 = parcelRequire("dt591");
var $a0vy2 = parcelRequire("a0vy2");
var $awTAN = parcelRequire("awTAN");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
var $95KdT = parcelRequire("95KdT");
var $ly71s = parcelRequire("ly71s");
var $9jZXY = parcelRequire("9jZXY");
var $eOdZ3 = parcelRequire("eOdZ3");
var $7NUoN = parcelRequire("7NUoN");
var $13cuy = parcelRequire("13cuy");
var $f6nZ0 = parcelRequire("f6nZ0");
var $81gWx = parcelRequire("81gWx");

var $8mNwL = parcelRequire("8mNwL");
const $e7def0d4fd26fd3e$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postCreateLoading = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostCreateLoading));
    // connect ready
    const { ready: connectReady } = (0, $iLKNg.useConnectReady)(profile?.id || "");
    // media state
    const [media, setMedia] = (0, $bh6RR.useState)(undefined);
    const [mediaPreview, setMediaPreview] = (0, $bh6RR.useState)("");
    const [mediaPreviewType, setMediaPreviewType] = (0, $bh6RR.useState)("");
    const mediaFileInputRef = (0, $bh6RR.useRef)(null);
    const [mediaError, setMediaError] = (0, $bh6RR.useState)("");
    // message state
    const [message, setMessage] = (0, $bh6RR.useState)("");
    const [messageError, setMessageError] = (0, $bh6RR.useState)("");
    // tracks state
    const [tracks, setTracks] = (0, $bh6RR.useState)([]);
    // visibility state
    const [visibility, setVisibility] = (0, $bh6RR.useState)((0, $2gpGl.EntityPostVisibility).Public);
    // unlock price state
    const defaultUnlockPrice = Math.ceil((0, $i0PvU.maxPostUnlockPrice) / 2);
    const [unlockPrice, setUnlockPrice] = (0, $bh6RR.useState)(defaultUnlockPrice);
    const submitDisabled = message.length < (0, $i0PvU.minPostMessageLength) || message.length > (0, $i0PvU.maxPostMessageLength) || unlockPrice < (0, $i0PvU.minPostUnlockPrice) || unlockPrice > (0, $i0PvU.maxPostUnlockPrice) || mediaError !== "" || messageError !== "" || postCreateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setMedia(undefined);
        setMessage("");
        setTracks([]);
        setVisibility((0, $2gpGl.EntityPostVisibility).Public);
        setUnlockPrice(defaultUnlockPrice);
        // if media preview was set
        if (mediaPreview) {
            // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
            setMediaPreview("");
        }
    };
    const onMediaClick = ()=>{
        mediaFileInputRef.current?.click();
        setMediaError("");
    };
    const onMediaFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validatePostMediaFile)(file);
            if (error) {
                setMediaError(error);
                return;
            }
            // if file of image type
            if (file.type.startsWith("image/")) setMediaPreviewType("image");
            // if file of video type
            if (file.type.startsWith("video/")) setMediaPreviewType("video");
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
            // set file as a preview
            setMediaPreview(URL.createObjectURL(file));
            // store file in state
            setMedia(file);
        }
    };
    (0, $bh6RR.useEffect)(()=>()=>{
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
        });
    (0, $bh6RR.useEffect)(()=>{
        if (!postCreateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        postCreateLoading
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $8mNwL.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $8mNwL.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $dt591.postCreate)({
                    message: message,
                    media: media,
                    tracks: tracks,
                    visibility: visibility,
                    unlockPrice: unlockPrice
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8mNwL.styles)().form.content.media.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.media.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Media"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $8mNwL.styles)().form.content.media.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                                    css: (0, $8mNwL.styles)().form.content.media.preview.label,
                                    htmlFor: "media",
                                    children: [
                                        "media",
                                        /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                            name: "media",
                                            type: "file",
                                            id: "media",
                                            ref: mediaFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png,video/quicktime,video/mp4,video/webm",
                                            onChange: (e)=>onMediaFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $8mNwL.styles)().form.content.media.preview.image,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $81gWx.MediaFilePreview), {
                                        source: mediaPreview,
                                        type: mediaPreviewType,
                                        width: "100%",
                                        height: "200px",
                                        alt: "post media",
                                        onClick: ()=>onMediaClick(),
                                        formats: [
                                            "JPG",
                                            "JPEG",
                                            "PNG",
                                            "WEBP",
                                            "MOV",
                                            "MP4",
                                            "WEBM"
                                        ],
                                        maxFileSize: (0, $i0PvU.maxPostMediaFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.media.error,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                                error: mediaError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8mNwL.styles)().form.content.message.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.message.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Message"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.message.input,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eOdZ3.InputArea), {
                                name: "message",
                                label: "message",
                                id: "tip-message",
                                placeholder: "Share your experience with your followers",
                                value: message,
                                maxLength: (0, $i0PvU.maxPostMessageLength),
                                error: messageError.length > 0,
                                errorMessage: messageError,
                                rows: 6,
                                onChange: (e)=>setMessage(e.target.value),
                                onBlur: ()=>setMessageError((0, $lRNbG.validatePostMessage)(message)),
                                onFocus: ()=>setMessageError("")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8mNwL.styles)().form.content.tracks.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.tracks.list,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $awTAN.TrackListStudioPostUploaded), {
                                postTracks: tracks,
                                addPostTrack: (track)=>tracks.length < (0, $i0PvU.maxPostTracksCount) ? setTracks((state)=>[
                                            ...state,
                                            track
                                        ]) : ()=>{},
                                removePostTrack: (trackId)=>setTracks((state)=>state.filter((t)=>t.id !== trackId))
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.tracks.description,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7NUoN.InputDescription), {
                                description: `Feel free to include a maximum of ${(0, $i0PvU.maxPostTracksCount)} tracks in your post.`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8mNwL.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $8mNwL.styles)().form.content.visibility.inputs,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the post is made publicly accessible to everyone on the platform.",
                                    icon: (0, $bq9l8.icons).Unlock,
                                    checked: visibility === (0, $2gpGl.EntityPostVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityPostVisibility).Public)
                                }),
                                connectReady && /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the post is exclusively accessible to subscribers or individuals who unlock it directly, unlocking the post grants the user access to all the locked tracks it contains.",
                                    icon: (0, $bq9l8.icons).Lock,
                                    checked: visibility === (0, $2gpGl.EntityPostVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityPostVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $2gpGl.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8mNwL.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $8mNwL.styles)().form.content.price.amount,
                            children: [
                                "$",
                                unlockPrice
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8mNwL.styles)().form.content.price.input,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9jZXY.InputAmount), {
                                name: "unlock-price",
                                label: "unlock price",
                                type: "range",
                                id: "unlock-price",
                                value: unlockPrice,
                                min: (0, $i0PvU.minPostUnlockPrice),
                                max: (0, $i0PvU.maxPostUnlockPrice),
                                onChange: (e)=>setUnlockPrice(parseInt(e.target.value, 10))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $8mNwL.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8mNwL.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                            type: "submit",
                            "aria-label": "create post",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: postCreateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Create"
                        })
                    })
                })
            ]
        })
    });
};
$e7def0d4fd26fd3e$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("8mNwL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f4fb9ae412290e5e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $f4fb9ae412290e5e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f4fb9ae412290e5e$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $f4fb9ae412290e5e$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $f4fb9ae412290e5e$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $f4fb9ae412290e5e$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f4fb9ae412290e5e$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $f4fb9ae412290e5e$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $f4fb9ae412290e5e$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $f4fb9ae412290e5e$var$_ref8 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $f4fb9ae412290e5e$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $f4fb9ae412290e5e$var$_ref10 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $f4fb9ae412290e5e$var$_ref11 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $f4fb9ae412290e5e$var$_ref12 = {
    name: "eivff4",
    styles: "display:none"
};
var $f4fb9ae412290e5e$var$_ref13 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $f4fb9ae412290e5e$var$_ref14 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $f4fb9ae412290e5e$var$_ref15 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $f4fb9ae412290e5e$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                media: {
                    main: $f4fb9ae412290e5e$var$_ref15,
                    label: $f4fb9ae412290e5e$var$_ref14,
                    preview: {
                        main: $f4fb9ae412290e5e$var$_ref13,
                        label: $f4fb9ae412290e5e$var$_ref12,
                        image: /*#__PURE__*/ (0, $7hler.css)("", "")
                    },
                    error: $f4fb9ae412290e5e$var$_ref11
                },
                message: {
                    main: $f4fb9ae412290e5e$var$_ref10,
                    label: $f4fb9ae412290e5e$var$_ref9,
                    input: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                tracks: {
                    main: $f4fb9ae412290e5e$var$_ref8,
                    list: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    description: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                visibility: {
                    main: $f4fb9ae412290e5e$var$_ref7,
                    label: $f4fb9ae412290e5e$var$_ref6,
                    inputs: $f4fb9ae412290e5e$var$_ref5
                },
                price: {
                    main: $f4fb9ae412290e5e$var$_ref4,
                    label: $f4fb9ae412290e5e$var$_ref3,
                    amount: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";line-height:24px;margin-bottom:10px;", ""),
                    input: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).tablet($f4fb9ae412290e5e$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:220px;}", (0, $gln0L.mq).tablet($f4fb9ae412290e5e$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("iU1SX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6b938370225cb195$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6b938370225cb195$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6b938370225cb195$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $6b938370225cb195$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $6b938370225cb195$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $6b938370225cb195$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $6b938370225cb195$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:400px;", (0, $gln0L.mq).tablet($6b938370225cb195$var$_ref2), ";", ""),
                form: $6b938370225cb195$var$_ref
            }
        }
    });

});


parcelRegister("8YBfu", function(module, exports) {

$parcel$export(module.exports, "PostViewEditStudio", function () { return $6db2badddcd16417$export$5287db19b393e810; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("iHDLD");
var $lPRQ6 = parcelRequire("lPRQ6");

var $8ET0F = parcelRequire("8ET0F");
const $6db2badddcd16417$export$5287db19b393e810 = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $8ET0F.styles)().card.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $8ET0F.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8ET0F.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lPRQ6.Form), {})
            })
        })
    });
$6db2badddcd16417$export$5287db19b393e810.propTypes = {};

});
parcelRegister("iHDLD", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("lPRQ6")).Form; });

var $lPRQ6 = parcelRequire("lPRQ6");

});
parcelRegister("lPRQ6", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $7e9e6fb19f545aa7$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $i0PvU = parcelRequire("i0PvU");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
var $6uGoQ = parcelRequire("6uGoQ");
parcelRequire("cJvLm");
var $a0vy2 = parcelRequire("a0vy2");
var $dt591 = parcelRequire("dt591");
var $awTAN = parcelRequire("awTAN");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
var $95KdT = parcelRequire("95KdT");
var $ly71s = parcelRequire("ly71s");
var $eOdZ3 = parcelRequire("eOdZ3");
var $7NUoN = parcelRequire("7NUoN");
var $13cuy = parcelRequire("13cuy");
var $f6nZ0 = parcelRequire("f6nZ0");
var $81gWx = parcelRequire("81gWx");

var $dNMK0 = parcelRequire("dNMK0");
const $7e9e6fb19f545aa7$export$a7fed597f4b8afd8 = ()=>{
    const { postId: postId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const postUpdateLoading = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostUpdateLoading));
    const uploadedPosts = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectUploadedPosts));
    const post = uploadedPosts.find((p)=>p.id === postId);
    const { mediaId: mediaId, mediaType: mediaType, trackIds: trackIds, message: currentMessage, visibility: currentVisibility, unlockPrice: currentUnlockPrice } = post ?? {};
    const getMediaPreviewType = ()=>{
        if (mediaType === (0, $2gpGl.EntityPostMediaType).Image) return "image";
        if (mediaType === (0, $2gpGl.EntityPostMediaType).Video) return "video";
        return "";
    };
    // post tracks
    const { tracks: postTracks } = (0, $6uGoQ.useTracks)(trackIds || []);
    // media state
    const postHasMedia = !!mediaId;
    const postMedia = (0, $jpNoL.useFile)(mediaId || "");
    const [media, setMedia] = (0, $bh6RR.useState)(undefined);
    const [mediaPreview, setMediaPreview] = (0, $bh6RR.useState)(postHasMedia ? postMedia : "");
    const [mediaPreviewType, setMediaPreviewType] = (0, $bh6RR.useState)(getMediaPreviewType());
    const mediaFileInputRef = (0, $bh6RR.useRef)(null);
    const [mediaError, setMediaError] = (0, $bh6RR.useState)("");
    // message state
    const [message, setMessage] = (0, $bh6RR.useState)(currentMessage || "");
    const [messageError, setMessageError] = (0, $bh6RR.useState)("");
    // tracks state
    const [tracks, setTracks] = (0, $bh6RR.useState)(postTracks || []);
    // visibility state
    const [visibility, setVisibility] = (0, $bh6RR.useState)(currentVisibility || (0, $2gpGl.EntityPostVisibility).Public);
    const messageUnchanged = message === currentMessage;
    const tracksUnchanged = tracks.map((t)=>t.id).join("") === postTracks?.map((t)=>t.id).join("");
    const mediaNotSelected = media === undefined;
    const postDefaultsUnchanged = messageUnchanged && tracksUnchanged && mediaNotSelected;
    const submitDisabled = postDefaultsUnchanged || message.length < (0, $i0PvU.minPostMessageLength) || message.length > (0, $i0PvU.maxPostMessageLength) || mediaError !== "" || messageError !== "" || postUpdateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setMedia(undefined);
        setMessage(currentMessage || "");
        setTracks(postTracks || []);
        setVisibility(currentVisibility || (0, $2gpGl.EntityPostVisibility).Public);
    };
    const onMediaClick = ()=>{
        mediaFileInputRef.current?.click();
        setMediaError("");
    };
    const onMediaFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validatePostMediaFile)(file);
            if (error) {
                setMediaError(error);
                return;
            }
            // if file of image type
            if (file.type.startsWith("image/")) setMediaPreviewType("image");
            // if file of video type
            if (file.type.startsWith("video/")) setMediaPreviewType("video");
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
            // set file as a preview
            setMediaPreview(URL.createObjectURL(file));
            // store file in state
            setMedia(file);
        }
    };
    (0, $bh6RR.useEffect)(()=>()=>{
            // if media preview was set
            if (mediaPreview) // clean up to avoid memory leaks
            revokePreviewURL(mediaPreview);
        });
    (0, $bh6RR.useEffect)(()=>{
        if (!postUpdateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        postUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $dNMK0.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $dNMK0.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $dt591.postUpdate)({
                    post: post || {},
                    message: message,
                    media: media,
                    tracks: tracks
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $dNMK0.styles)().form.content.media.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.media.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Media"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $dNMK0.styles)().form.content.media.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                                    css: (0, $dNMK0.styles)().form.content.media.preview.label,
                                    htmlFor: "media",
                                    children: [
                                        "media",
                                        /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                            name: "media",
                                            type: "file",
                                            id: "media",
                                            ref: mediaFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png,video/quicktime,video/mp4,video/webm",
                                            onChange: (e)=>onMediaFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $dNMK0.styles)().form.content.media.preview.image,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $81gWx.MediaFilePreview), {
                                        source: mediaPreview,
                                        type: mediaPreviewType,
                                        width: "100%",
                                        height: "200px",
                                        alt: "post media",
                                        onClick: ()=>onMediaClick(),
                                        formats: [
                                            "JPG",
                                            "JPEG",
                                            "PNG",
                                            "WEBP",
                                            "MOV",
                                            "MP4",
                                            "WEBM"
                                        ],
                                        maxFileSize: (0, $i0PvU.maxPostMediaFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.media.error,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                                error: mediaError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $dNMK0.styles)().form.content.message.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.message.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Message"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.message.input,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eOdZ3.InputArea), {
                                name: "message",
                                label: "message",
                                id: "tip-message",
                                placeholder: "Share your experience with your followers",
                                value: message,
                                maxLength: (0, $i0PvU.maxPostMessageLength),
                                error: messageError.length > 0,
                                errorMessage: messageError,
                                rows: 6,
                                onChange: (e)=>setMessage(e.target.value),
                                onBlur: ()=>setMessageError((0, $lRNbG.validatePostMessage)(message)),
                                onFocus: ()=>setMessageError("")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $dNMK0.styles)().form.content.tracks.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.tracks.list,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $awTAN.TrackListStudioPostUploaded), {
                                postTracks: tracks,
                                addPostTrack: (track)=>tracks.length < (0, $i0PvU.maxPostTracksCount) ? setTracks((state)=>[
                                            ...state,
                                            track
                                        ]) : ()=>{},
                                removePostTrack: (trackId)=>setTracks((state)=>state.filter((t)=>t.id !== trackId))
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.tracks.description,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7NUoN.InputDescription), {
                                description: `Feel free to include a maximum of ${(0, $i0PvU.maxPostTracksCount)} tracks in your post.`
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $dNMK0.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $dNMK0.styles)().form.content.visibility.inputs,
                            children: [
                                visibility === (0, $2gpGl.EntityPostVisibility).Public && /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the post is made publicly accessible to everyone on the platform.",
                                    icon: (0, $bq9l8.icons).Unlock,
                                    checked: visibility === (0, $2gpGl.EntityPostVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityPostVisibility).Public)
                                }),
                                visibility === (0, $2gpGl.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the post is exclusively accessible to subscribers or individuals who unlock it directly, unlocking the post grants the user access to all the locked tracks it contains.",
                                    icon: (0, $bq9l8.icons).Lock,
                                    checked: visibility === (0, $2gpGl.EntityPostVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityPostVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $2gpGl.EntityPostVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $dNMK0.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $dNMK0.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $dNMK0.styles)().form.content.price.amount,
                            children: [
                                " ",
                                "$",
                                (currentUnlockPrice || 0) / 100
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $dNMK0.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dNMK0.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                            type: "submit",
                            "aria-label": "create post",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: postUpdateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Update"
                        })
                    })
                })
            ]
        })
    });
};
$7e9e6fb19f545aa7$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("dNMK0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $843b9fb06cac0026$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $843b9fb06cac0026$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $843b9fb06cac0026$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $843b9fb06cac0026$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $843b9fb06cac0026$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $843b9fb06cac0026$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $843b9fb06cac0026$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $843b9fb06cac0026$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $843b9fb06cac0026$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $843b9fb06cac0026$var$_ref8 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $843b9fb06cac0026$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $843b9fb06cac0026$var$_ref10 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $843b9fb06cac0026$var$_ref11 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $843b9fb06cac0026$var$_ref12 = {
    name: "eivff4",
    styles: "display:none"
};
var $843b9fb06cac0026$var$_ref13 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $843b9fb06cac0026$var$_ref14 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $843b9fb06cac0026$var$_ref15 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $843b9fb06cac0026$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                media: {
                    main: $843b9fb06cac0026$var$_ref15,
                    label: $843b9fb06cac0026$var$_ref14,
                    preview: {
                        main: $843b9fb06cac0026$var$_ref13,
                        label: $843b9fb06cac0026$var$_ref12,
                        image: /*#__PURE__*/ (0, $7hler.css)("", "")
                    },
                    error: $843b9fb06cac0026$var$_ref11
                },
                message: {
                    main: $843b9fb06cac0026$var$_ref10,
                    label: $843b9fb06cac0026$var$_ref9,
                    input: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                tracks: {
                    main: $843b9fb06cac0026$var$_ref8,
                    list: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    description: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                visibility: {
                    main: $843b9fb06cac0026$var$_ref7,
                    label: $843b9fb06cac0026$var$_ref6,
                    inputs: $843b9fb06cac0026$var$_ref5
                },
                price: {
                    main: $843b9fb06cac0026$var$_ref4,
                    label: $843b9fb06cac0026$var$_ref3,
                    amount: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";line-height:24px;margin-bottom:10px;", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).tablet($843b9fb06cac0026$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:220px;}", (0, $gln0L.mq).tablet($843b9fb06cac0026$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("8ET0F", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ab82f77d7cf94963$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ab82f77d7cf94963$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ab82f77d7cf94963$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $ab82f77d7cf94963$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ab82f77d7cf94963$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $ab82f77d7cf94963$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $ab82f77d7cf94963$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:400px;", (0, $gln0L.mq).tablet($ab82f77d7cf94963$var$_ref2), ";", ""),
                form: $ab82f77d7cf94963$var$_ref
            }
        }
    });

});


parcelRegister("4EDE8", function(module, exports) {

$parcel$export(module.exports, "PostViewMediaPost", function () { return $7cdf2c6e352deaf9$export$ef8a9e19b0660e0f; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $iLKNg = parcelRequire("iLKNg");
var $jpNoL = parcelRequire("jpNoL");
var $gLN5L = parcelRequire("gLN5L");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $a0vy2 = parcelRequire("a0vy2");
var $10e6J = parcelRequire("10e6J");
var $8NOJ0 = parcelRequire("8NOJ0");
var $l5cm3 = parcelRequire("l5cm3");
var $a0GHC = parcelRequire("a0GHC");
var $8aXib = parcelRequire("8aXib");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $eTdS3 = parcelRequire("eTdS3");
const $7cdf2c6e352deaf9$export$ef8a9e19b0660e0f = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const postLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectPostLikes));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const post = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPost));
    const postFetched = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPostFetched));
    const { id: profileUserId, role: profileUserRole } = profile ?? {};
    const { // id
    id: postId, // author
    userId: postAuthorUserId, mediaId: // content
    mediaId, mediaType: mediaType, message: message, commentsCount: // data
    commentsCount, likesCount: likesCount, visibility: // visibility
    visibility } = post ?? {};
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $gLN5L.useUser)(postAuthorUserId || "");
    const { name: authorName, username: authorUsername, avatarId: authorAvatarId } = postAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const userUsernamePlaceholder = "unknown";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $jpNoL.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $bh6RR.useState)(false);
    const postHasMedia = !!mediaId;
    const postMedia = (0, $jpNoL.useFile)(mediaId || "");
    const [postMediaLoadError, setPostMediaLoadError] = (0, $bh6RR.useState)(false);
    // connect ready
    const { ready: isAuthorCanReceivePayments } = (0, $iLKNg.useConnectReady)(postAuthorUserId || "");
    const followDisabled = false;
    const unfollowDisabled = false;
    const subscribeDisabled = false;
    const unsubscribeDisabled = false;
    const tipDisabled = false;
    const blockDisabled = false;
    const reportDisabled = false;
    const isCurrentUserAdmin = profileUserRole === (0, $2gpGl.EntityUserRole).Admin;
    const isPostAuthorFollowed = userFollows[postAuthorUserId || ""];
    const isPostLiked = postLikes[postId || ""];
    const isPostCommented = false;
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = profileUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const isCurrentUserSubscribedToContentAuthorAtPeriodEnd = userSubscriptionsAtPeriodEnd[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // on post view
    (0, $bh6RR.useEffect)(()=>{
        const tenSeconds = 10000;
        const id = setTimeout(()=>{
            // if post exists and is not locked
            if (post && !renderLocked) // after n seconds create post stream
            dispatch((0, $8NOJ0.streamCreatePostStream)({
                post: post
            }));
        }, tenSeconds);
        return ()=>clearInterval(id);
    }, [
        post,
        renderLocked,
        dispatch
    ]);
    // if post is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $eTdS3.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Lock,
            height: "504px",
            title: "Content is locked"
        })
    });
    // if post not found
    if (postFetched && !post) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $eTdS3.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Posts,
            height: "504px",
            title: "Could not find post"
        })
    });
    const renderPostMedia = ()=>{
        // if post media type is image
        if (mediaType === (0, $2gpGl.EntityPostMediaType).Image && postHasMedia && !postMediaLoadError) // render image
        return /*#__PURE__*/ (0, $9awXB.jsx)("img", {
            css: (0, $eTdS3.styles)(theme).view.media.image,
            onError: ()=>setPostMediaLoadError(true),
            loading: "lazy",
            src: postMedia,
            alt: "post media content"
        });
        // if post media type is video
        if (mediaType === (0, $2gpGl.EntityPostMediaType).Video && postHasMedia && !postMediaLoadError) // render video
        return /*#__PURE__*/ (0, $9awXB.jsxs)("video", {
            css: (0, $eTdS3.styles)(theme).view.media.video,
            onError: ()=>setPostMediaLoadError(true),
            src: postMedia,
            controls: true,
            preload: "metadata",
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("source", {
                    src: postMedia,
                    type: "video/mp4"
                }),
                "Your browser does not support the video tag."
            ]
        });
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $eTdS3.styles)(theme).view.media.placeholder,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Ryddm, {})
        });
    };
    const renderArtistActionsInput = {
        isCurrentUserFollowingArtist: isPostAuthorFollowed,
        isCurrentUserSubscribedToArtist: isCurrentUserSubscribedToContentAuthor,
        isCurrentUserSubscribedToArtistAtPeriodEnd: isCurrentUserSubscribedToContentAuthorAtPeriodEnd,
        isArtistCanReceivePayments: !!isAuthorCanReceivePayments,
        createUserFollowNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $eTdS3.styles)(theme).view.footer.buttons.follow,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "follow author",
                disabled: followDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
                        user: {
                            ...postAuthor
                        }
                    })),
                children: "Follow"
            })
        }),
        deleteUserFollowNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $eTdS3.styles)(theme).view.footer.buttons.unfollow,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "unfollow author",
                disabled: unfollowDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
                        user: {
                            ...postAuthor
                        }
                    })),
                children: "Unfollow"
            })
        }),
        createSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $eTdS3.styles)(theme).view.footer.buttons.subscribe,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe on author",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCreateModal)({
                        artist: {
                            ...postAuthor
                        }
                    })),
                children: "Subscribe"
            })
        }),
        renewSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $eTdS3.styles)(theme).view.footer.buttons.subscribe,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe on author",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionRenewModal)({
                        artist: {
                            ...postAuthor
                        }
                    })),
                children: "Subscribe"
            })
        }),
        cancelSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $eTdS3.styles)(theme).view.footer.buttons.unsubscribe,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "unsubscribe from author",
                disabled: unsubscribeDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCancelModal)({
                        artist: {
                            ...postAuthor
                        }
                    })),
                children: "Unsubscribe"
            })
        }),
        defaultNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {})
    };
    // if post found
    if (postFetched && post) return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $eTdS3.styles)(theme).view.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eTdS3.styles)(theme).view.media.main,
                children: renderPostMedia()
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eTdS3.styles)(theme).view.message.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: (0, $eTdS3.styles)(theme).view.message.text,
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $eTdS3.styles)(theme).view.footer.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $eTdS3.styles)(theme).view.footer.author.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $eTdS3.styles)(theme).view.footer.author.avatar.main,
                                children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                                    css: (0, $eTdS3.styles)(theme).view.footer.author.avatar.image,
                                    onError: ()=>setAuthorAvatarLoadError(true),
                                    loading: "lazy",
                                    width: "30px",
                                    height: "30px",
                                    src: authorAvatar,
                                    alt: "post author avatar"
                                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                                    css: (0, $eTdS3.styles)(theme).view.footer.author.avatar.icon
                                })
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                css: (0, $eTdS3.styles)(theme).view.footer.author.info.main,
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                        css: (0, $eTdS3.styles)(theme).view.footer.author.info.name,
                                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
                                        type: "button",
                                        "aria-label": "explore author profile",
                                        children: isPostAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                        css: (0, $eTdS3.styles)(theme).view.footer.author.info.username,
                                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${postAuthorUserId}`),
                                        type: "button",
                                        "aria-label": "explore author profile",
                                        children: isPostAuthorLoading ? userLoadingPlaceholder : `@${authorUsername || userUsernamePlaceholder}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $eTdS3.styles)(theme).view.footer.buttons.main,
                        children: [
                            !isCurrentUserContentAuthor && (0, $aM7LJ.userUtilRenderArtistActions)(renderArtistActionsInput),
                            !isCurrentUserContentAuthor && isAuthorCanReceivePayments && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $eTdS3.styles)(theme).view.footer.buttons.tip,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                    type: "button",
                                    "aria-label": "send tip to author",
                                    disabled: tipDisabled,
                                    appearance: "primary",
                                    onClick: ()=>dispatch((0, $a0GHC.tipOpenTipModal)({
                                            artist: {
                                                ...postAuthor
                                            }
                                        })),
                                    children: "Tip"
                                })
                            }),
                            !isCurrentUserContentAuthor && (isCurrentUserAdmin ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $eTdS3.styles)(theme).view.footer.buttons.block,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                    type: "button",
                                    "aria-label": "block post",
                                    disabled: blockDisabled,
                                    appearance: "secondary",
                                    onClick: ()=>dispatch((0, $a0vy2.postOpenPostBlockModal)({
                                            post: post
                                        })),
                                    children: "Block"
                                })
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $eTdS3.styles)(theme).view.footer.buttons.report,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                    type: "button",
                                    "aria-label": "report post",
                                    disabled: reportDisabled,
                                    appearance: "secondary",
                                    onClick: ()=>dispatch((0, $10e6J.reportOpenReportPostModal)({
                                            post: post
                                        })),
                                    children: "Report"
                                })
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $eTdS3.styles)(theme).view.footer.info.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                css: (0, $eTdS3.styles)(theme).view.footer.info.comments.main,
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $eTdS3.styles)(theme).view.footer.info.comments.buttons,
                                        children: isPostCommented ? /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                            css: [
                                                (0, $eTdS3.styles)(theme).view.footer.info.comments.button.shared,
                                                (0, $eTdS3.styles)(theme).view.footer.info.comments.button.commented,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>{},
                                            type: "button",
                                            "aria-label": "comment on post",
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CommentFilled, {})
                                        }) : /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                            css: [
                                                (0, $eTdS3.styles)(theme).view.footer.info.comments.button.shared,
                                                (0, $eTdS3.styles)(theme).view.footer.info.comments.button.uncommented,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>{},
                                            type: "button",
                                            "aria-label": "comment on post",
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Comment, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $eTdS3.styles)(theme).view.footer.info.comments.count,
                                        children: (0, $1Fj5G.numbersFormatter)(commentsCount || 0)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                css: (0, $eTdS3.styles)(theme).view.footer.info.likes.main,
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $eTdS3.styles)(theme).view.footer.info.likes.buttons,
                                        children: isPostLiked ? /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                            css: [
                                                (0, $eTdS3.styles)(theme).view.footer.info.likes.button.shared,
                                                (0, $eTdS3.styles)(theme).view.footer.info.likes.button.dislike,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>dispatch((0, $4cq7L.likeDeletePostLike)({
                                                    post: post
                                                })),
                                            type: "button",
                                            "aria-label": "dislike post",
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).HeartFilled, {})
                                        }) : /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                            css: [
                                                (0, $eTdS3.styles)(theme).view.footer.info.likes.button.shared,
                                                (0, $eTdS3.styles)(theme).view.footer.info.likes.button.like,
                                                "",
                                                ""
                                            ],
                                            onClick: ()=>dispatch((0, $4cq7L.likeCreatePostLike)({
                                                    post: post
                                                })),
                                            type: "button",
                                            "aria-label": "like post",
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Heart, {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $eTdS3.styles)(theme).view.footer.info.likes.count,
                                        children: (0, $1Fj5G.numbersFormatter)(likesCount || 0)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    // else render skeleton
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $eTdS3.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "100%",
            sections: [
                {
                    name: `post-media-view-post-media`,
                    width: "100%",
                    height: "400px",
                    isStatic: true,
                    isDivider: false
                },
                {
                    name: `post-media-view-post-divider`,
                    width: "100%",
                    height: "16px",
                    isStatic: true,
                    isDivider: true
                },
                {
                    name: `post-media-view-post-description`,
                    width: "100%",
                    height: "88.4px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$7cdf2c6e352deaf9$export$ef8a9e19b0660e0f.propTypes = {};

});
parcelRegister("eTdS3", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9b131bb5cd6e1569$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $9b131bb5cd6e1569$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9b131bb5cd6e1569$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $9b131bb5cd6e1569$var$_ref2 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $9b131bb5cd6e1569$var$_ref3 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $9b131bb5cd6e1569$var$_ref4 = {
    name: "1tx1l5v",
    styles: "margin-right:auto"
};
var $9b131bb5cd6e1569$var$_ref5 = {
    name: "6og82r",
    styles: "margin-left:0px"
};
var $9b131bb5cd6e1569$var$_ref6 = {
    name: "1calkkd",
    styles: "&>div:not(:last-of-type){margin-right:0px;margin-bottom:12px;}&>div{width:100%;}flex-direction:column"
};
var $9b131bb5cd6e1569$var$_ref7 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $9b131bb5cd6e1569$var$_ref8 = {
    name: "62qxo5",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0"
};
var $9b131bb5cd6e1569$var$_ref9 = {
    name: "bbnk5u",
    styles: "max-width:100%;margin-right:0px;margin-bottom:16px"
};
var $9b131bb5cd6e1569$var$_ref10 = {
    name: "ieoj9s",
    styles: "flex-direction:column;align-items:stretch;flex-wrap:nowrap"
};
var $9b131bb5cd6e1569$var$_ref11 = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $9b131bb5cd6e1569$var$_ref12 = {
    name: "4t7tsq",
    styles: "height:400px;width:100%;margin-bottom:16px"
};
const $9b131bb5cd6e1569$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";overflow:hidden;max-width:800px;", ""),
            media: {
                main: $9b131bb5cd6e1569$var$_ref12,
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px;", ""),
                video: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";border-radius:4px;", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;height:100%;background-color:", theme.colors.primary.darker, ";border-radius:4px;&>svg{width:80px;height:80px;}", "")
            },
            message: {
                main: $9b131bb5cd6e1569$var$_ref11,
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).p, ";font-weight:bold;word-wrap:break-word;", "")
            },
            footer: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;flex-wrap:wrap;width:100%;", (0, $gln0L.mq).tablet($9b131bb5cd6e1569$var$_ref10), ";", ""),
                author: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;min-width:0;max-width:240px;margin-right:12px;", (0, $gln0L.mq).tablet($9b131bb5cd6e1569$var$_ref9), ";", ""),
                    avatar: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:50px;height:50px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                        image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $7hler.css)("width:20px;height:20px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    info: {
                        main: $9b131bb5cd6e1569$var$_ref8,
                        name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).p, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                        username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:left;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-right:12px;&>div:not(:last-of-type){margin-right:12px;}&>div>button{height:34px;}", (0, $gln0L.mq).tablet($9b131bb5cd6e1569$var$_ref7), " ", (0, $gln0L.mq).mobile($9b131bb5cd6e1569$var$_ref6), ";", ""),
                    follow: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    unfollow: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    subscribe: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    unsubscribe: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    tip: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    block: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    report: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                info: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-left:auto;", (0, $gln0L.mq).tablet($9b131bb5cd6e1569$var$_ref5), ";", ""),
                    comments: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;margin-right:8px;", (0, $gln0L.mq).tablet($9b131bb5cd6e1569$var$_ref4), ";", ""),
                        buttons: $9b131bb5cd6e1569$var$_ref3,
                        button: {
                            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;", ""),
                            commented: /*#__PURE__*/ (0, $7hler.css)("&>svg{width:20px;height:17px;&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            uncommented: /*#__PURE__*/ (0, $7hler.css)("&>svg{width:20px;height:17px;&>path{fill:", theme.colors.secondary.normal, ";}}", "")
                        },
                        count: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";", "")
                    },
                    likes: {
                        main: $9b131bb5cd6e1569$var$_ref2,
                        buttons: $9b131bb5cd6e1569$var$_ref,
                        button: {
                            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";cursor:pointer;display:flex;align-items:center;justify-content:center;width:30px;height:30px;&>svg{width:20px;height:18px;}", ""),
                            like: /*#__PURE__*/ (0, $7hler.css)("&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            dislike: /*#__PURE__*/ (0, $7hler.css)("&>svg{&>path{fill:", theme.colors.accent.normal, ";}}", "")
                        },
                        count: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";", "")
                    }
                }
            }
        }
    });

});



parcelRegister("cMDgV", function(module, exports) {

$parcel$export(module.exports, "postUtilGetPostCardSkeletonSections", function () { return $5f11e317de3fed20$export$d657ebf86e206be3; });
const $5f11e317de3fed20$export$d657ebf86e206be3 = (sectionName)=>[
        {
            name: `${sectionName}-media`,
            width: "180px",
            height: "146px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider`,
            width: "180px",
            height: "8px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-description`,
            width: "180px",
            height: "128px",
            isStatic: true,
            isDivider: false
        }
    ];

});

parcelRegister("a0vy2", function(module, exports) {

$parcel$export(module.exports, "postSlice", function () { return $fceac3d22563c8c8$export$84b5fd1687923cdd; });
$parcel$export(module.exports, "postResetState", function () { return $fceac3d22563c8c8$export$9dd424aad11dd66c; });
$parcel$export(module.exports, "postSetPublicPosts", function () { return $fceac3d22563c8c8$export$ce5a046a1fbe931d; });
$parcel$export(module.exports, "postSetPopularPosts", function () { return $fceac3d22563c8c8$export$2a0820930dbb6cfd; });
$parcel$export(module.exports, "postSetRecommendedPosts", function () { return $fceac3d22563c8c8$export$f048c5af1e054de2; });
$parcel$export(module.exports, "postSetLikedPosts", function () { return $fceac3d22563c8c8$export$8bf7790d2c52e250; });
$parcel$export(module.exports, "postSetUnlockedPosts", function () { return $fceac3d22563c8c8$export$df4ed605a0c4aa35; });
$parcel$export(module.exports, "postSetUploadedPosts", function () { return $fceac3d22563c8c8$export$4379cd31786d3494; });
$parcel$export(module.exports, "postSetArtistPopularPosts", function () { return $fceac3d22563c8c8$export$ae5c03bbd62019ff; });
$parcel$export(module.exports, "postSetArtistExclusivePosts", function () { return $fceac3d22563c8c8$export$dd9dfdbe68071b4a; });
$parcel$export(module.exports, "postSetArtistLatestPosts", function () { return $fceac3d22563c8c8$export$7e2514e9868c1835; });
$parcel$export(module.exports, "postResetArtistPosts", function () { return $fceac3d22563c8c8$export$32ce3be0d1041cd2; });
$parcel$export(module.exports, "postSetPost", function () { return $fceac3d22563c8c8$export$d7e1ac0660aef3e; });
$parcel$export(module.exports, "postResetPost", function () { return $fceac3d22563c8c8$export$9cdd001f16a9a95e; });
$parcel$export(module.exports, "postAppendLikedPost", function () { return $fceac3d22563c8c8$export$dbd95498e0105519; });
$parcel$export(module.exports, "postFilterLikedPost", function () { return $fceac3d22563c8c8$export$cad450d0eee98236; });
$parcel$export(module.exports, "postAppendUnlockedPost", function () { return $fceac3d22563c8c8$export$d6a4dbcd8796e529; });
$parcel$export(module.exports, "postFilterUnlockedPost", function () { return $fceac3d22563c8c8$export$3bd892409aa76046; });
$parcel$export(module.exports, "postFilterPost", function () { return $fceac3d22563c8c8$export$c28d13e5e641a413; });
$parcel$export(module.exports, "postFilterUserPosts", function () { return $fceac3d22563c8c8$export$a7e1aa97f9558dbc; });
$parcel$export(module.exports, "postUpdatePost", function () { return $fceac3d22563c8c8$export$5a655b43053213db; });
$parcel$export(module.exports, "postOpenPostBlockModal", function () { return $fceac3d22563c8c8$export$93499fe2b661300d; });
$parcel$export(module.exports, "postClosePostBlockModal", function () { return $fceac3d22563c8c8$export$3cab156dba2d530; });
$parcel$export(module.exports, "postOpenPostDeleteModal", function () { return $fceac3d22563c8c8$export$416f813d58a14263; });
$parcel$export(module.exports, "postClosePostDeleteModal", function () { return $fceac3d22563c8c8$export$a455e59882114226; });
$parcel$export(module.exports, "postSelectPublicPosts", function () { return $fceac3d22563c8c8$export$fb241e6d2021ff71; });
$parcel$export(module.exports, "postSelectPublicPostsLength", function () { return $fceac3d22563c8c8$export$3a701e16151ab41; });
$parcel$export(module.exports, "postSelectPublicPostsCount", function () { return $fceac3d22563c8c8$export$38c02c2bc52c8194; });
$parcel$export(module.exports, "postSelectPublicPostsFetched", function () { return $fceac3d22563c8c8$export$39d1973247427310; });
$parcel$export(module.exports, "postSelectPopularPosts", function () { return $fceac3d22563c8c8$export$afd27ee2e6d98764; });
$parcel$export(module.exports, "postSelectPopularPostsLength", function () { return $fceac3d22563c8c8$export$2a0d9bc00fa25195; });
$parcel$export(module.exports, "postSelectPopularPostsCount", function () { return $fceac3d22563c8c8$export$793061c15ff8847d; });
$parcel$export(module.exports, "postSelectPopularPostsFetched", function () { return $fceac3d22563c8c8$export$785438d13e726074; });
$parcel$export(module.exports, "postSelectRecommendedPosts", function () { return $fceac3d22563c8c8$export$e620b65a5b60eafa; });
$parcel$export(module.exports, "postSelectRecommendedPostsLength", function () { return $fceac3d22563c8c8$export$15de216159a2b089; });
$parcel$export(module.exports, "postSelectRecommendedPostsCount", function () { return $fceac3d22563c8c8$export$ce62f4ef910910ca; });
$parcel$export(module.exports, "postSelectRecommendedPostsFetched", function () { return $fceac3d22563c8c8$export$f1c376010aab834c; });
$parcel$export(module.exports, "postSelectLikedPosts", function () { return $fceac3d22563c8c8$export$54dfeb421271f9ac; });
$parcel$export(module.exports, "postSelectLikedPostsLength", function () { return $fceac3d22563c8c8$export$edfbf0548d8188d9; });
$parcel$export(module.exports, "postSelectLikedPostsCount", function () { return $fceac3d22563c8c8$export$695d287082716fff; });
$parcel$export(module.exports, "postSelectLikedPostsFetched", function () { return $fceac3d22563c8c8$export$563f7b0826706eaf; });
$parcel$export(module.exports, "postSelectUnlockedPosts", function () { return $fceac3d22563c8c8$export$540148e7f3d53bc4; });
$parcel$export(module.exports, "postSelectUnlockedPostsLength", function () { return $fceac3d22563c8c8$export$7716ea1b0396d86a; });
$parcel$export(module.exports, "postSelectUnlockedPostsCount", function () { return $fceac3d22563c8c8$export$8c849c4e19d24711; });
$parcel$export(module.exports, "postSelectUnlockedPostsFetched", function () { return $fceac3d22563c8c8$export$8d77a678a152519c; });
$parcel$export(module.exports, "postSelectUploadedPosts", function () { return $fceac3d22563c8c8$export$3634f989eea4feba; });
$parcel$export(module.exports, "postSelectUploadedPostsLength", function () { return $fceac3d22563c8c8$export$9e4dd71b085997ff; });
$parcel$export(module.exports, "postSelectUploadedPostsCount", function () { return $fceac3d22563c8c8$export$4c358e30e4e77ccd; });
$parcel$export(module.exports, "postSelectUploadedPostsFetched", function () { return $fceac3d22563c8c8$export$9fbf9933174ed152; });
$parcel$export(module.exports, "postSelectArtistPopularPosts", function () { return $fceac3d22563c8c8$export$cd1063db3626a4f0; });
$parcel$export(module.exports, "postSelectArtistPopularPostsLength", function () { return $fceac3d22563c8c8$export$af731748b0e19bb4; });
$parcel$export(module.exports, "postSelectArtistPopularPostsCount", function () { return $fceac3d22563c8c8$export$f0402047b032ff58; });
$parcel$export(module.exports, "postSelectArtistPopularPostsFetched", function () { return $fceac3d22563c8c8$export$e1ec845822c2862c; });
$parcel$export(module.exports, "postSelectArtistExclusivePosts", function () { return $fceac3d22563c8c8$export$18564db38bd46f7a; });
$parcel$export(module.exports, "postSelectArtistExclusivePostsLength", function () { return $fceac3d22563c8c8$export$1be46c4dd465af22; });
$parcel$export(module.exports, "postSelectArtistExclusivePostsCount", function () { return $fceac3d22563c8c8$export$adfaba7489ca0479; });
$parcel$export(module.exports, "postSelectArtistExclusivePostsFetched", function () { return $fceac3d22563c8c8$export$bf021a3494f0a907; });
$parcel$export(module.exports, "postSelectArtistLatestPosts", function () { return $fceac3d22563c8c8$export$53e191b8cbd5a45; });
$parcel$export(module.exports, "postSelectArtistLatestPostsLength", function () { return $fceac3d22563c8c8$export$3ba948bda75df569; });
$parcel$export(module.exports, "postSelectArtistLatestPostsCount", function () { return $fceac3d22563c8c8$export$445ee8b7072a8cd1; });
$parcel$export(module.exports, "postSelectArtistLatestPostsFetched", function () { return $fceac3d22563c8c8$export$8b247801ccd46b70; });
$parcel$export(module.exports, "postSelectPost", function () { return $fceac3d22563c8c8$export$3c11521f7f3f87ff; });
$parcel$export(module.exports, "postSelectPostFetched", function () { return $fceac3d22563c8c8$export$1b02d1fdc8545643; });
$parcel$export(module.exports, "postSelectPostBlockModalOpen", function () { return $fceac3d22563c8c8$export$7cfe34405cb09bd; });
$parcel$export(module.exports, "postSelectPostBlockModalPost", function () { return $fceac3d22563c8c8$export$f6706f92b506f19d; });
$parcel$export(module.exports, "postSelectPostDeleteModalOpen", function () { return $fceac3d22563c8c8$export$d4841c78d863ce4d; });
$parcel$export(module.exports, "postSelectPostDeleteModalPost", function () { return $fceac3d22563c8c8$export$2a92f752ec3a8a3b; });
$parcel$export(module.exports, "postSelectPostGetPublicPostsLoading", function () { return $fceac3d22563c8c8$export$a1bff146f511503e; });
$parcel$export(module.exports, "postSelectPostGetPopularPostsLoading", function () { return $fceac3d22563c8c8$export$85248f85935c038d; });
$parcel$export(module.exports, "postSelectPostGetRecommendedPostsLoading", function () { return $fceac3d22563c8c8$export$34ed93d124c6b30d; });
$parcel$export(module.exports, "postSelectPostGetLikedPostsLoading", function () { return $fceac3d22563c8c8$export$8724e993d50686d8; });
$parcel$export(module.exports, "postSelectPostGetUnlockedPostsLoading", function () { return $fceac3d22563c8c8$export$1ae2c3d187ce2732; });
$parcel$export(module.exports, "postSelectPostGetUploadedPostsLoading", function () { return $fceac3d22563c8c8$export$55a7c4e7c5c0e2a8; });
$parcel$export(module.exports, "postSelectPostGetArtistPopularPostsLoading", function () { return $fceac3d22563c8c8$export$c1b04ba9ccb2667c; });
$parcel$export(module.exports, "postSelectPostGetArtistExclusivePostsLoading", function () { return $fceac3d22563c8c8$export$c312341e7fc27bac; });
$parcel$export(module.exports, "postSelectPostGetArtistLatestPostsLoading", function () { return $fceac3d22563c8c8$export$2ad5ed8ad1be53f8; });
$parcel$export(module.exports, "postSelectPostGetPostLoading", function () { return $fceac3d22563c8c8$export$df7914468ca0aeb3; });
$parcel$export(module.exports, "postSelectPostCreateLoading", function () { return $fceac3d22563c8c8$export$d1a3f987c5fbe290; });
$parcel$export(module.exports, "postSelectPostUpdateLoading", function () { return $fceac3d22563c8c8$export$6e9d5b4362dbc0d8; });
$parcel$export(module.exports, "postSelectPostBlockLoading", function () { return $fceac3d22563c8c8$export$207e13237327f2c; });
$parcel$export(module.exports, "postSelectPostDeleteLoading", function () { return $fceac3d22563c8c8$export$b7fe3c79adb92dd2; });
$parcel$export(module.exports, "postReducer", function () { return $fceac3d22563c8c8$export$1ea4d99c3899e898; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $dt591 = parcelRequire("dt591");
const $fceac3d22563c8c8$var$initialState = {
    publicPosts: [],
    publicPostsCount: 0,
    publicPostsFetched: false,
    popularPosts: [],
    popularPostsCount: 0,
    popularPostsFetched: false,
    recommendedPosts: [],
    recommendedPostsCount: 0,
    recommendedPostsFetched: false,
    likedPosts: [],
    likedPostsCount: 0,
    likedPostsFetched: false,
    unlockedPosts: [],
    unlockedPostsCount: 0,
    unlockedPostsFetched: false,
    uploadedPosts: [],
    uploadedPostsCount: 0,
    uploadedPostsFetched: false,
    artistPopularPosts: [],
    artistPopularPostsCount: 0,
    artistPopularPostsFetched: false,
    artistExclusivePosts: [],
    artistExclusivePostsCount: 0,
    artistExclusivePostsFetched: false,
    artistLatestPosts: [],
    artistLatestPostsCount: 0,
    artistLatestPostsFetched: false,
    post: undefined,
    postFetched: false,
    postBlockModal: {
        post: undefined,
        open: false
    },
    postDeleteModal: {
        post: undefined,
        open: false
    },
    postGetPublicPostsLoading: false,
    postGetPopularPostsLoading: false,
    postGetRecommendedPostsLoading: false,
    postGetLikedPostsLoading: false,
    postGetUnlockedPostsLoading: false,
    postGetUploadedPostsLoading: false,
    postGetArtistPopularPostsLoading: false,
    postGetArtistExclusivePostsLoading: false,
    postGetArtistLatestPostsLoading: false,
    postGetPostLoading: false,
    postCreateLoading: false,
    postUpdateLoading: false,
    postBlockLoading: false,
    postDeleteLoading: false
};
const $fceac3d22563c8c8$export$84b5fd1687923cdd = (0, $kvj5V.createSlice)({
    name: "post",
    initialState: $fceac3d22563c8c8$var$initialState,
    reducers: {
        // reset state
        postResetState: ()=>({
                publicPosts: [],
                publicPostsCount: 0,
                publicPostsFetched: false,
                popularPosts: [],
                popularPostsCount: 0,
                popularPostsFetched: false,
                recommendedPosts: [],
                recommendedPostsCount: 0,
                recommendedPostsFetched: false,
                likedPosts: [],
                likedPostsCount: 0,
                likedPostsFetched: false,
                unlockedPosts: [],
                unlockedPostsCount: 0,
                unlockedPostsFetched: false,
                profilePosts: [],
                profilePostsCount: 0,
                profilePostsFetched: false,
                uploadedPosts: [],
                uploadedPostsCount: 0,
                uploadedPostsFetched: false,
                artistPopularPosts: [],
                artistPopularPostsCount: 0,
                artistPopularPostsFetched: false,
                artistExclusivePosts: [],
                artistExclusivePostsCount: 0,
                artistExclusivePostsFetched: false,
                artistLatestPosts: [],
                artistLatestPostsCount: 0,
                artistLatestPostsFetched: false,
                post: undefined,
                postFetched: false,
                postBlockModal: {
                    post: undefined,
                    open: false
                },
                postDeleteModal: {
                    post: undefined,
                    open: false
                },
                postGetPublicPostsLoading: false,
                postGetPopularPostsLoading: false,
                postGetRecommendedPostsLoading: false,
                postGetLikedPostsLoading: false,
                postGetUnlockedPostsLoading: false,
                postGetUploadedPostsLoading: false,
                postGetArtistPopularPostsLoading: false,
                postGetArtistExclusivePostsLoading: false,
                postGetArtistLatestPostsLoading: false,
                postGetPostLoading: false,
                postCreateLoading: false,
                postUpdateLoading: false,
                postBlockLoading: false,
                postDeleteLoading: false
            }),
        // set public posts
        postSetPublicPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.publicPostsCount = count;
                // mutate public posts array
                state.publicPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.publicPosts, posts, offset);
            }
        },
        // set popular posts
        postSetPopularPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.popularPostsCount = count;
                // mutate popular posts array
                state.popularPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.popularPosts, posts, offset);
            }
        },
        // set recommended posts
        postSetRecommendedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.recommendedPostsCount = count;
                // mutate recommended posts array
                state.recommendedPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.recommendedPosts, posts, offset);
            }
        },
        // set liked posts
        postSetLikedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.likedPostsCount = count;
                // mutate profile posts array
                state.likedPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.likedPosts, posts, offset);
            }
        },
        // set unlocked posts
        postSetUnlockedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.unlockedPostsCount = count;
                // mutate profile posts array
                state.unlockedPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.unlockedPosts, posts, offset);
            }
        },
        // set uploaded posts
        postSetUploadedPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.uploadedPostsCount = count;
                // mutate uploaded posts array
                state.uploadedPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.uploadedPosts, posts, offset);
            }
        },
        // set artist popular posts
        postSetArtistPopularPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistPopularPostsCount = count;
            // mutate artist popular posts array
            state.artistPopularPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.artistPopularPosts, posts, offset);
        },
        // set artist exclusive posts
        postSetArtistExclusivePosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistExclusivePostsCount = count;
            // mutate artist exclusive posts array
            state.artistExclusivePosts = (0, $6Rkyy.mergeArraysAtIndex)(state.artistExclusivePosts, posts, offset);
        },
        // set artist latest posts
        postSetArtistLatestPosts: (state, action)=>{
            const { posts: posts, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistLatestPostsCount = count;
            // mutate artist latest posts array
            state.artistLatestPosts = (0, $6Rkyy.mergeArraysAtIndex)(state.artistLatestPosts, posts, offset);
        },
        // reset artist posts
        postResetArtistPosts: (state)=>({
                ...state,
                artistPopularPosts: [],
                artistPopularPostsCount: 0,
                artistPopularPostsFetched: false,
                artistExclusivePosts: [],
                artistExclusivePostsCount: 0,
                artistExclusivePostsFetched: false,
                artistLatestPosts: [],
                artistLatestPostsCount: 0,
                artistLatestPostsFetched: false
            }),
        // set post
        postSetPost: (state, action)=>{
            const { post: post } = action.payload;
            // update post state
            state.post = post;
        },
        // reset post
        postResetPost: (state)=>({
                ...state,
                post: undefined,
                postFetched: false
            }),
        // append liked post
        postAppendLikedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if liked posts are fetched
            if (state.likedPostsFetched) {
                // append post to liked posts
                state.likedPosts.unshift(post);
                state.likedPostsCount += 1;
            }
        },
        // filter liked posts
        postFilterLikedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if liked posts are fetched
            if (state.likedPostsFetched) {
                // filter post from liked posts
                state.likedPosts = state.likedPosts.filter((p)=>p.id !== post.id);
                state.likedPostsCount -= 1;
            }
        },
        // append unlocked post
        postAppendUnlockedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if unlocked posts are fetched
            if (state.unlockedPostsFetched) {
                // append post to unlocked posts
                state.unlockedPosts.unshift(post);
                state.unlockedPostsCount += 1;
            }
        },
        // filter unlocked post
        postFilterUnlockedPost: (state, action)=>{
            const { post: post } = action.payload;
            // if unlocked posts are fetched
            if (state.unlockedPostsFetched) {
                // filter post from unlocked posts
                state.unlockedPosts = state.unlockedPosts.filter((p)=>p.id !== post.id);
                state.unlockedPostsCount -= 1;
            }
        },
        // filter post
        postFilterPost: (state, action)=>{
            const { id: id } = action.payload;
            // check if post exists in public posts
            const pubIndex = state.publicPosts.findIndex((p)=>p.id === id);
            if (pubIndex !== -1) {
                // filter post
                state.publicPosts = state.publicPosts.filter((p)=>p.id !== id);
                state.publicPostsCount -= 1;
            }
            // check if post exists in popular posts
            const popIndex = state.popularPosts.findIndex((p)=>p.id === id);
            if (popIndex !== -1) {
                // filter post
                state.popularPosts = state.popularPosts.filter((p)=>p.id !== id);
                state.popularPostsCount -= 1;
            }
            // check if post exists in recommended posts
            const recIndex = state.recommendedPosts.findIndex((p)=>p.id === id);
            if (recIndex !== -1) {
                // filter post
                state.recommendedPosts = state.recommendedPosts.filter((p)=>p.id !== id);
                state.recommendedPostsCount -= 1;
            }
            // check if post exists in liked posts
            const lkIndex = state.likedPosts.findIndex((p)=>p.id === id);
            if (lkIndex !== -1) {
                // filter post
                state.likedPosts = state.likedPosts.filter((p)=>p.id !== id);
                state.likedPostsCount -= 1;
            }
            // check if post exists in unlocked posts
            const unlIndex = state.unlockedPosts.findIndex((p)=>p.id === id);
            if (unlIndex !== -1) {
                // filter post
                state.unlockedPosts = state.unlockedPosts.filter((p)=>p.id !== id);
                state.unlockedPostsCount -= 1;
            }
            // check if post exists in uploaded posts
            const uplIndex = state.uploadedPosts.findIndex((p)=>p.id === id);
            if (uplIndex !== -1) {
                // filter post
                state.uploadedPosts = state.uploadedPosts.filter((p)=>p.id !== id);
                state.uploadedPostsCount -= 1;
            }
            // check if post exists in artist popular posts
            const aPopIndex = state.artistPopularPosts.findIndex((p)=>p.id === id);
            if (aPopIndex !== -1) {
                // filter post
                state.artistPopularPosts = state.artistPopularPosts.filter((p)=>p.id !== id);
                state.artistPopularPostsCount -= 1;
            }
            // check if post exists in artist exclusive posts
            const aExIndex = state.artistExclusivePosts.findIndex((p)=>p.id === id);
            if (aExIndex !== -1) {
                // filter post
                state.artistExclusivePosts = state.artistExclusivePosts.filter((p)=>p.id !== id);
                state.artistExclusivePostsCount -= 1;
            }
            // check if post exists in artist latest posts
            const aLatIndex = state.artistLatestPosts.findIndex((p)=>p.id === id);
            if (aLatIndex !== -1) {
                // filter post
                state.artistLatestPosts = state.artistLatestPosts.filter((p)=>p.id !== id);
                state.artistLatestPostsCount -= 1;
            }
        },
        // filter user posts
        postFilterUserPosts: (state, action)=>{
            const { userId: userId } = action.payload;
            // filter user posts from public posts
            const filteredPublicPosts = state.publicPosts.filter((p)=>p.userId !== userId);
            const filteredPublicPostsCount = state.publicPosts.length - filteredPublicPosts.length;
            // if filtered posts
            if (filteredPublicPostsCount > 0) {
                // update posts
                state.publicPosts = filteredPublicPosts;
                state.publicPostsCount -= filteredPublicPostsCount;
            }
            // filter user posts from popular posts
            const filteredPopularPosts = state.popularPosts.filter((p)=>p.userId !== userId);
            const filteredPopularPostsCount = state.popularPosts.length - filteredPopularPosts.length;
            // if filtered posts
            if (filteredPopularPostsCount > 0) {
                // update posts
                state.popularPosts = filteredPopularPosts;
                state.popularPostsCount -= filteredPopularPostsCount;
            }
            // filter user posts from recommended posts
            const filteredRecommendedPosts = state.recommendedPosts.filter((p)=>p.userId !== userId);
            const filteredRecommendedPostsCount = state.recommendedPosts.length - filteredRecommendedPosts.length;
            // if filtered posts
            if (filteredRecommendedPostsCount > 0) {
                // update posts
                state.recommendedPosts = filteredRecommendedPosts;
                state.recommendedPostsCount -= filteredRecommendedPostsCount;
            }
            // filter user posts from liked posts
            const filteredLikedPosts = state.likedPosts.filter((p)=>p.userId !== userId);
            const filteredLikedPostsCount = state.likedPosts.length - filteredLikedPosts.length;
            // if filtered posts
            if (filteredLikedPostsCount > 0) {
                // update posts
                state.likedPosts = filteredLikedPosts;
                state.likedPostsCount -= filteredLikedPostsCount;
            }
            // filter user posts from unlocked posts
            const filteredUnlockedPosts = state.unlockedPosts.filter((p)=>p.userId !== userId);
            const filteredUnlockedPostsCount = state.unlockedPosts.length - filteredUnlockedPosts.length;
            // if filtered posts
            if (filteredUnlockedPostsCount > 0) {
                // update posts
                state.unlockedPosts = filteredUnlockedPosts;
                state.unlockedPostsCount -= filteredUnlockedPostsCount;
            }
            // filter user posts from uploaded posts
            const filteredUploadedPosts = state.uploadedPosts.filter((p)=>p.userId !== userId);
            const filteredUploadedPostsCount = state.uploadedPosts.length - filteredUploadedPosts.length;
            // if filtered posts
            if (filteredUploadedPostsCount > 0) {
                // update posts
                state.uploadedPosts = filteredUploadedPosts;
                state.uploadedPostsCount -= filteredUploadedPostsCount;
            }
            // filter user posts from artist popular posts
            const filteredArtistPopularPosts = state.artistPopularPosts.filter((p)=>p.userId !== userId);
            const filteredArtistPopularPostsCount = state.artistPopularPosts.length - filteredArtistPopularPosts.length;
            // if filtered posts
            if (filteredArtistPopularPostsCount > 0) {
                // update posts
                state.artistPopularPosts = filteredArtistPopularPosts;
                state.artistPopularPostsCount -= filteredArtistPopularPostsCount;
            }
            // filter user posts from artist exclusive posts
            const filteredArtistExclusivePosts = state.artistExclusivePosts.filter((p)=>p.userId !== userId);
            const filteredArtistExclusivePostsCount = state.artistExclusivePosts.length - filteredArtistExclusivePosts.length;
            // if filtered posts
            if (filteredArtistExclusivePostsCount > 0) {
                // update posts
                state.artistExclusivePosts = filteredArtistExclusivePosts;
                state.artistExclusivePostsCount -= filteredArtistExclusivePostsCount;
            }
            // filter user posts from artist latest posts
            const filteredArtistLatestPosts = state.artistLatestPosts.filter((p)=>p.userId !== userId);
            const filteredArtistLatestPostsCount = state.artistLatestPosts.length - filteredArtistLatestPosts.length;
            // if filtered posts
            if (filteredArtistLatestPostsCount > 0) {
                // update posts
                state.artistLatestPosts = filteredArtistLatestPosts;
                state.artistLatestPostsCount -= filteredArtistLatestPostsCount;
            }
        },
        // update post
        postUpdatePost: (state, action)=>{
            const { updatedPost: updatedPost } = action.payload;
            // update post in public posts
            const pubIndex = state.publicPosts.findIndex((p)=>p.id === updatedPost.id);
            if (pubIndex !== -1) {
                const currentPost = state.publicPosts[pubIndex];
                state.publicPosts[pubIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in popular posts
            const popIndex = state.popularPosts.findIndex((p)=>p.id === updatedPost.id);
            if (popIndex !== -1) {
                const currentPost = state.popularPosts[popIndex];
                state.popularPosts[popIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in recommended posts
            const recIndex = state.recommendedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (recIndex !== -1) {
                const currentPost = state.recommendedPosts[recIndex];
                state.recommendedPosts[recIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in liked posts
            const lkIndex = state.likedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (lkIndex !== -1) {
                const currentPost = state.likedPosts[lkIndex];
                state.likedPosts[lkIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in unlocked posts
            const unlIndex = state.unlockedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (unlIndex !== -1) {
                const currentPost = state.unlockedPosts[unlIndex];
                state.unlockedPosts[unlIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in uploaded posts
            const uplIndex = state.uploadedPosts.findIndex((p)=>p.id === updatedPost.id);
            if (uplIndex !== -1) {
                const currentPost = state.uploadedPosts[uplIndex];
                state.uploadedPosts[uplIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in artist popular posts
            const aPopIndex = state.artistPopularPosts.findIndex((p)=>p.id === updatedPost.id);
            if (aPopIndex !== -1) {
                const currentPost = state.artistPopularPosts[aPopIndex];
                state.artistPopularPosts[aPopIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in artist exclusive posts
            const aExIndex = state.artistExclusivePosts.findIndex((p)=>p.id === updatedPost.id);
            if (aExIndex !== -1) {
                const currentPost = state.artistExclusivePosts[aExIndex];
                state.artistExclusivePosts[aExIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // update post in artist latest posts
            const aLatIndex = state.artistLatestPosts.findIndex((p)=>p.id === updatedPost.id);
            if (aLatIndex !== -1) {
                const currentPost = state.artistLatestPosts[aLatIndex];
                state.artistLatestPosts[aLatIndex] = {
                    ...currentPost,
                    ...updatedPost
                };
            }
            // if post fetched and exists
            if (state.postFetched && state.post) // if post id equal to updated user id
            {
                if (state.post.id === updatedPost.id) // update post
                state.post = updatedPost;
            }
        },
        // open post block modal
        postOpenPostBlockModal: (state, action)=>({
                ...state,
                postBlockModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close post block modal
        postClosePostBlockModal: (state)=>({
                ...state,
                postBlockModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            }),
        // open post delete modal
        postOpenPostDeleteModal: (state, action)=>({
                ...state,
                postDeleteModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close post delete modal
        postClosePostDeleteModal: (state)=>({
                ...state,
                postDeleteModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get public posts
        builder.addCase((0, $dt591.postGetPublicPosts).pending, (state)=>({
                ...state,
                postGetPublicPostsLoading: true
            })).addCase((0, $dt591.postGetPublicPosts).fulfilled, (state)=>({
                ...state,
                publicPostsFetched: true,
                postGetPublicPostsLoading: false
            }));
        // get popular posts
        builder.addCase((0, $dt591.postGetPopularPosts).pending, (state)=>({
                ...state,
                postGetPopularPostsLoading: true
            })).addCase((0, $dt591.postGetPopularPosts).fulfilled, (state)=>({
                ...state,
                popularPostsFetched: true,
                postGetPopularPostsLoading: false
            }));
        // get recommended posts
        builder.addCase((0, $dt591.postGetRecommendedPosts).pending, (state)=>({
                ...state,
                postGetRecommendedPostsLoading: true
            })).addCase((0, $dt591.postGetRecommendedPosts).fulfilled, (state)=>({
                ...state,
                recommendedPostsFetched: true,
                postGetRecommendedPostsLoading: false
            }));
        // get liked posts
        builder.addCase((0, $dt591.postGetLikedPosts).pending, (state)=>({
                ...state,
                postGetLikedPostsLoading: true
            })).addCase((0, $dt591.postGetLikedPosts).fulfilled, (state)=>({
                ...state,
                likedPostsFetched: true,
                postGetLikedPostsLoading: false
            }));
        // get unlocked posts
        builder.addCase((0, $dt591.postGetUnlockedPosts).pending, (state)=>({
                ...state,
                postGetUnlockedPostsLoading: true
            })).addCase((0, $dt591.postGetUnlockedPosts).fulfilled, (state)=>({
                ...state,
                unlockedPostsFetched: true,
                postGetUnlockedPostsLoading: false
            }));
        // get uploaded posts
        builder.addCase((0, $dt591.postGetUploadedPosts).pending, (state)=>({
                ...state,
                postGetUploadedPostsLoading: true
            })).addCase((0, $dt591.postGetUploadedPosts).fulfilled, (state)=>({
                ...state,
                uploadedPostsFetched: true,
                postGetUploadedPostsLoading: false
            }));
        // get artist popular posts
        builder.addCase((0, $dt591.postGetArtistPopularPosts).pending, (state)=>({
                ...state,
                postGetArtistPopularPostsLoading: true
            })).addCase((0, $dt591.postGetArtistPopularPosts).fulfilled, (state)=>({
                ...state,
                artistPopularPostsFetched: true,
                postGetArtistPopularPostsLoading: false
            }));
        // get artist exclusive posts
        builder.addCase((0, $dt591.postGetArtistExclusivePosts).pending, (state)=>({
                ...state,
                postGetArtistExclusivePostsLoading: true
            })).addCase((0, $dt591.postGetArtistExclusivePosts).fulfilled, (state)=>({
                ...state,
                artistExclusivePostsFetched: true,
                postGetArtistExclusivePostsLoading: false
            }));
        // get artist latest posts
        builder.addCase((0, $dt591.postGetArtistLatestPosts).pending, (state)=>({
                ...state,
                postGetArtistLatestPostsLoading: true
            })).addCase((0, $dt591.postGetArtistLatestPosts).fulfilled, (state)=>({
                ...state,
                artistLatestPostsFetched: true,
                postGetArtistLatestPostsLoading: false
            }));
        // get post
        builder.addCase((0, $dt591.postGetPost).pending, (state)=>({
                ...state,
                postGetPostLoading: true
            })).addCase((0, $dt591.postGetPost).fulfilled, (state)=>({
                ...state,
                postFetched: true,
                postGetPostLoading: false
            }));
        // create post
        builder.addCase((0, $dt591.postCreate).pending, (state)=>({
                ...state,
                postCreateLoading: true
            })).addCase((0, $dt591.postCreate).fulfilled, (state)=>({
                ...state,
                postCreateLoading: false
            }));
        // update post
        builder.addCase((0, $dt591.postUpdate).pending, (state)=>({
                ...state,
                postUpdateLoading: true
            })).addCase((0, $dt591.postUpdate).fulfilled, (state)=>({
                ...state,
                postUpdateLoading: false
            }));
        // block post
        builder.addCase((0, $dt591.postBlock).pending, (state)=>({
                ...state,
                postBlockLoading: true
            })).addCase((0, $dt591.postBlock).fulfilled, (state)=>({
                ...state,
                postBlockLoading: false
            }));
        // delete post
        builder.addCase((0, $dt591.postDelete).pending, (state)=>({
                ...state,
                postDeleteLoading: true
            })).addCase((0, $dt591.postDelete).fulfilled, (state)=>({
                ...state,
                postDeleteLoading: false
            }));
    }
});
const { postResetState: $fceac3d22563c8c8$export$9dd424aad11dd66c, postSetPublicPosts: $fceac3d22563c8c8$export$ce5a046a1fbe931d, postSetPopularPosts: $fceac3d22563c8c8$export$2a0820930dbb6cfd, postSetRecommendedPosts: $fceac3d22563c8c8$export$f048c5af1e054de2, postSetLikedPosts: $fceac3d22563c8c8$export$8bf7790d2c52e250, postSetUnlockedPosts: $fceac3d22563c8c8$export$df4ed605a0c4aa35, postSetUploadedPosts: $fceac3d22563c8c8$export$4379cd31786d3494, postSetArtistPopularPosts: $fceac3d22563c8c8$export$ae5c03bbd62019ff, postSetArtistExclusivePosts: $fceac3d22563c8c8$export$dd9dfdbe68071b4a, postSetArtistLatestPosts: $fceac3d22563c8c8$export$7e2514e9868c1835, postResetArtistPosts: $fceac3d22563c8c8$export$32ce3be0d1041cd2, postSetPost: $fceac3d22563c8c8$export$d7e1ac0660aef3e, postResetPost: $fceac3d22563c8c8$export$9cdd001f16a9a95e, postAppendLikedPost: $fceac3d22563c8c8$export$dbd95498e0105519, postFilterLikedPost: $fceac3d22563c8c8$export$cad450d0eee98236, postAppendUnlockedPost: $fceac3d22563c8c8$export$d6a4dbcd8796e529, postFilterUnlockedPost: $fceac3d22563c8c8$export$3bd892409aa76046, postFilterPost: $fceac3d22563c8c8$export$c28d13e5e641a413, postFilterUserPosts: $fceac3d22563c8c8$export$a7e1aa97f9558dbc, postUpdatePost: $fceac3d22563c8c8$export$5a655b43053213db, postOpenPostBlockModal: $fceac3d22563c8c8$export$93499fe2b661300d, postClosePostBlockModal: $fceac3d22563c8c8$export$3cab156dba2d530, postOpenPostDeleteModal: $fceac3d22563c8c8$export$416f813d58a14263, postClosePostDeleteModal: $fceac3d22563c8c8$export$a455e59882114226 } = $fceac3d22563c8c8$export$84b5fd1687923cdd.actions;
const $fceac3d22563c8c8$export$fb241e6d2021ff71 = (state)=>state.post.publicPosts;
const $fceac3d22563c8c8$export$3a701e16151ab41 = (state)=>state.post.publicPosts.length;
const $fceac3d22563c8c8$export$38c02c2bc52c8194 = (state)=>state.post.publicPostsCount;
const $fceac3d22563c8c8$export$39d1973247427310 = (state)=>state.post.publicPostsFetched;
const $fceac3d22563c8c8$export$afd27ee2e6d98764 = (state)=>state.post.popularPosts;
const $fceac3d22563c8c8$export$2a0d9bc00fa25195 = (state)=>state.post.popularPosts.length;
const $fceac3d22563c8c8$export$793061c15ff8847d = (state)=>state.post.popularPostsCount;
const $fceac3d22563c8c8$export$785438d13e726074 = (state)=>state.post.popularPostsFetched;
const $fceac3d22563c8c8$export$e620b65a5b60eafa = (state)=>state.post.recommendedPosts;
const $fceac3d22563c8c8$export$15de216159a2b089 = (state)=>state.post.recommendedPosts.length;
const $fceac3d22563c8c8$export$ce62f4ef910910ca = (state)=>state.post.recommendedPostsCount;
const $fceac3d22563c8c8$export$f1c376010aab834c = (state)=>state.post.recommendedPostsFetched;
const $fceac3d22563c8c8$export$54dfeb421271f9ac = (state)=>state.post.likedPosts;
const $fceac3d22563c8c8$export$edfbf0548d8188d9 = (state)=>state.post.likedPosts.length;
const $fceac3d22563c8c8$export$695d287082716fff = (state)=>state.post.likedPostsCount;
const $fceac3d22563c8c8$export$563f7b0826706eaf = (state)=>state.post.likedPostsFetched;
const $fceac3d22563c8c8$export$540148e7f3d53bc4 = (state)=>state.post.unlockedPosts;
const $fceac3d22563c8c8$export$7716ea1b0396d86a = (state)=>state.post.unlockedPosts.length;
const $fceac3d22563c8c8$export$8c849c4e19d24711 = (state)=>state.post.unlockedPostsCount;
const $fceac3d22563c8c8$export$8d77a678a152519c = (state)=>state.post.unlockedPostsFetched;
const $fceac3d22563c8c8$export$3634f989eea4feba = (state)=>state.post.uploadedPosts;
const $fceac3d22563c8c8$export$9e4dd71b085997ff = (state)=>state.post.uploadedPosts.length;
const $fceac3d22563c8c8$export$4c358e30e4e77ccd = (state)=>state.post.uploadedPostsCount;
const $fceac3d22563c8c8$export$9fbf9933174ed152 = (state)=>state.post.uploadedPostsFetched;
const $fceac3d22563c8c8$export$cd1063db3626a4f0 = (state)=>state.post.artistPopularPosts;
const $fceac3d22563c8c8$export$af731748b0e19bb4 = (state)=>state.post.artistPopularPosts.length;
const $fceac3d22563c8c8$export$f0402047b032ff58 = (state)=>state.post.artistPopularPostsCount;
const $fceac3d22563c8c8$export$e1ec845822c2862c = (state)=>state.post.artistPopularPostsFetched;
const $fceac3d22563c8c8$export$18564db38bd46f7a = (state)=>state.post.artistExclusivePosts;
const $fceac3d22563c8c8$export$1be46c4dd465af22 = (state)=>state.post.artistExclusivePosts.length;
const $fceac3d22563c8c8$export$adfaba7489ca0479 = (state)=>state.post.artistExclusivePostsCount;
const $fceac3d22563c8c8$export$bf021a3494f0a907 = (state)=>state.post.artistExclusivePostsFetched;
const $fceac3d22563c8c8$export$53e191b8cbd5a45 = (state)=>state.post.artistLatestPosts;
const $fceac3d22563c8c8$export$3ba948bda75df569 = (state)=>state.post.artistLatestPosts.length;
const $fceac3d22563c8c8$export$445ee8b7072a8cd1 = (state)=>state.post.artistLatestPostsCount;
const $fceac3d22563c8c8$export$8b247801ccd46b70 = (state)=>state.post.artistLatestPostsFetched;
const $fceac3d22563c8c8$export$3c11521f7f3f87ff = (state)=>state.post.post;
const $fceac3d22563c8c8$export$1b02d1fdc8545643 = (state)=>state.post.postFetched;
const $fceac3d22563c8c8$export$7cfe34405cb09bd = (state)=>state.post.postBlockModal.open;
const $fceac3d22563c8c8$export$f6706f92b506f19d = (state)=>state.post.postBlockModal.post;
const $fceac3d22563c8c8$export$d4841c78d863ce4d = (state)=>state.post.postDeleteModal.open;
const $fceac3d22563c8c8$export$2a92f752ec3a8a3b = (state)=>state.post.postDeleteModal.post;
const $fceac3d22563c8c8$export$a1bff146f511503e = (state)=>state.post.postGetPublicPostsLoading;
const $fceac3d22563c8c8$export$85248f85935c038d = (state)=>state.post.postGetPopularPostsLoading;
const $fceac3d22563c8c8$export$34ed93d124c6b30d = (state)=>state.post.postGetRecommendedPostsLoading;
const $fceac3d22563c8c8$export$8724e993d50686d8 = (state)=>state.post.postGetLikedPostsLoading;
const $fceac3d22563c8c8$export$1ae2c3d187ce2732 = (state)=>state.post.postGetUnlockedPostsLoading;
const $fceac3d22563c8c8$export$55a7c4e7c5c0e2a8 = (state)=>state.post.postGetUploadedPostsLoading;
const $fceac3d22563c8c8$export$c1b04ba9ccb2667c = (state)=>state.post.postGetArtistPopularPostsLoading;
const $fceac3d22563c8c8$export$c312341e7fc27bac = (state)=>state.post.postGetArtistExclusivePostsLoading;
const $fceac3d22563c8c8$export$2ad5ed8ad1be53f8 = (state)=>state.post.postGetArtistLatestPostsLoading;
const $fceac3d22563c8c8$export$df7914468ca0aeb3 = (state)=>state.post.postGetPostLoading;
const $fceac3d22563c8c8$export$d1a3f987c5fbe290 = (state)=>state.post.postCreateLoading;
const $fceac3d22563c8c8$export$6e9d5b4362dbc0d8 = (state)=>state.post.postUpdateLoading;
const $fceac3d22563c8c8$export$207e13237327f2c = (state)=>state.post.postBlockLoading;
const $fceac3d22563c8c8$export$b7fe3c79adb92dd2 = (state)=>state.post.postDeleteLoading;
const $fceac3d22563c8c8$export$1ea4d99c3899e898 = $fceac3d22563c8c8$export$84b5fd1687923cdd.reducer; // export default postSlice.reducer

});

parcelRegister("dt591", function(module, exports) {

$parcel$export(module.exports, "postGetPublicPosts", function () { return $e927c7dc5773749b$export$addafaf8bec90092; });
$parcel$export(module.exports, "postGetPopularPosts", function () { return $e927c7dc5773749b$export$466fe1d7e3b62322; });
$parcel$export(module.exports, "postGetRecommendedPosts", function () { return $e927c7dc5773749b$export$6690bc2052db8b1e; });
$parcel$export(module.exports, "postGetLikedPosts", function () { return $e927c7dc5773749b$export$7fc0c1ca72ba4d7d; });
$parcel$export(module.exports, "postGetUnlockedPosts", function () { return $e927c7dc5773749b$export$e0b9d84bf1697f29; });
$parcel$export(module.exports, "postGetUploadedPosts", function () { return $e927c7dc5773749b$export$9ec7a0da93a2e6f3; });
$parcel$export(module.exports, "postGetArtistPopularPosts", function () { return $e927c7dc5773749b$export$549ce51589e9fea8; });
$parcel$export(module.exports, "postGetArtistExclusivePosts", function () { return $e927c7dc5773749b$export$78711610cc3df796; });
$parcel$export(module.exports, "postGetArtistLatestPosts", function () { return $e927c7dc5773749b$export$c860eac3c8791ff4; });
$parcel$export(module.exports, "postGetPost", function () { return $e927c7dc5773749b$export$cf246b2f471283c8; });
$parcel$export(module.exports, "postCreate", function () { return $e927c7dc5773749b$export$1c653e50934cd597; });
$parcel$export(module.exports, "postUpdate", function () { return $e927c7dc5773749b$export$a787fd5d078d5cef; });
$parcel$export(module.exports, "postBlock", function () { return $e927c7dc5773749b$export$788e41b05acb4a0; });
$parcel$export(module.exports, "postDelete", function () { return $e927c7dc5773749b$export$37646f6edbc68fd3; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $e9SYA = parcelRequire("e9SYA");
var $a0vy2 = parcelRequire("a0vy2");
var $10e6J = parcelRequire("10e6J");
var $kwNyE = parcelRequire("kwNyE");
const $e927c7dc5773749b$export$addafaf8bec90092 = (0, $kvj5V.createAsyncThunk)("post/postGetPublicPosts", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve public posts
        const { posts: posts, count: count } = await api.postApi.getPublicPosts();
        // set public posts
        dispatch((0, $a0vy2.postSetPublicPosts)({
            posts: posts || [],
            count: count || 0,
            offset: 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$466fe1d7e3b62322 = (0, $kvj5V.createAsyncThunk)("post/postGetPopularPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve popular posts
        const { posts: posts, count: count } = await api.postApi.getPopularPosts(undefined, inp.limit, inp.offset, inp.search);
        // set popular posts
        dispatch((0, $a0vy2.postSetPopularPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$6690bc2052db8b1e = (0, $kvj5V.createAsyncThunk)("post/postGetRecommendedPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve recommended posts
        const { posts: posts, count: count } = await api.postApi.getRecommendedPosts(inp.limit, inp.offset, inp.search);
        // set recommended posts
        dispatch((0, $a0vy2.postSetRecommendedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$7fc0c1ca72ba4d7d = (0, $kvj5V.createAsyncThunk)("post/postGetLikedPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve liked posts
        const { posts: posts, count: count } = await api.postApi.getLikedPosts(inp.limit, inp.offset, inp.search);
        // set liked posts
        dispatch((0, $a0vy2.postSetLikedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$e0b9d84bf1697f29 = (0, $kvj5V.createAsyncThunk)("post/postGetUnlockedPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve unlocked posts
        const { posts: posts, count: count } = await api.postApi.getUnlockedPosts(inp.limit, inp.offset, inp.search);
        // set unlocked posts
        dispatch((0, $a0vy2.postSetUnlockedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$9ec7a0da93a2e6f3 = (0, $kvj5V.createAsyncThunk)("post/postGetUploadedPosts", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get currently logged in user id
    const { profile: profile } = getState().auth;
    const userId = profile?.id || "";
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getArtistPosts(userId, inp.limit, inp.offset, inp.search);
        // set uploaded posts
        dispatch((0, $a0vy2.postSetUploadedPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$549ce51589e9fea8 = (0, $kvj5V.createAsyncThunk)("post/postGetArtistPopularPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getPopularPosts(inp.artistId, inp.limit, inp.offset, inp.search);
        // set posts
        dispatch((0, $a0vy2.postSetArtistPopularPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$78711610cc3df796 = (0, $kvj5V.createAsyncThunk)("post/postGetArtistExclusivePosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getExclusivePosts(inp.artistId, inp.limit, inp.offset, inp.search);
        // set posts
        dispatch((0, $a0vy2.postSetArtistExclusivePosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$c860eac3c8791ff4 = (0, $kvj5V.createAsyncThunk)("post/postGetArtistLatestPosts", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve posts
        const { posts: posts, count: count } = await api.postApi.getLatestPosts(inp.artistId, inp.limit, inp.offset, inp.search);
        // set posts
        dispatch((0, $a0vy2.postSetArtistLatestPosts)({
            posts: posts || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$cf246b2f471283c8 = (0, $kvj5V.createAsyncThunk)("post/postGetPost", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve post
        const { post: post } = await api.postApi.getPost(inp.postId);
        // set post
        dispatch((0, $a0vy2.postSetPost)({
            post: post || {}
        }));
        // get post tracks
        dispatch((0, $kwNyE.trackGetPostTracks)({
            trackIds: post?.trackIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$1c653e50934cd597 = (0, $kvj5V.createAsyncThunk)("post/postCreate", async ({ message: message, media: media, tracks: tracks, visibility: visibility, unlockPrice: unlockPrice }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append message
        formData.append("message", message);
        // if media provided
        if (media) // append media
        formData.append("media", media);
        // if tracks provided
        if (tracks && tracks.length > 0) // append track ids
        formData.append("trackIds", tracks.map((track)=>track.id).join(","));
        // if visibility provided
        if (visibility) // append visibility
        formData.append("visibility", visibility.toString());
        // if visibility is subscribers
        // and unlock price provided
        if (visibility === (0, $2gpGl.EntityPostVisibility).Subscribers && unlockPrice) // append unlock price in cents
        // if unlockPrice = 1 (one dollar)
        // 1 * 100 = 100 (hundred cents)
        formData.append("unlockPrice", (unlockPrice * 100).toString());
        // create post
        await api.postApi.createPost({
            body: formData
        });
        // refetch uploaded posts
        dispatch($e927c7dc5773749b$export$9ec7a0da93a2e6f3({
            limit: 30,
            offset: 0
        }));
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully created post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create post: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $e927c7dc5773749b$export$a787fd5d078d5cef = (0, $kvj5V.createAsyncThunk)("post/postUpdate", async ({ post: post, message: message, media: media, tracks: tracks }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append post id
        formData.append("postId", post.id || "");
        // if message provided
        if (message) // append name
        formData.append("message", message);
        // if media provided
        if (media) // append media
        formData.append("media", media);
        // if tracks provided
        if (tracks && tracks.length > 0) // append track ids
        formData.append("trackIds", tracks.map((track)=>track.id).join(","));
        // update post
        const { post: updatedPost } = await api.postApi.updatePost({
            body: formData
        });
        // update post in post state
        dispatch((0, $a0vy2.postUpdatePost)({
            updatedPost: updatedPost || {}
        }));
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully updated post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: errMessage } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to update post: ${errMessage}`
            }
        }));
        // return error message in payload
        return {
            error: errMessage
        };
    }
});
const $e927c7dc5773749b$export$788e41b05acb4a0 = (0, $kvj5V.createAsyncThunk)("post/postBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // block post
        await api.postApi.blockPost({
            postId: id
        });
        // reset post page state
        dispatch((0, $a0vy2.postResetPost)());
        // reset comments state
        dispatch((0, $e9SYA.commentResetComments)());
        // filter blocked post from posts
        dispatch((0, $a0vy2.postFilterPost)({
            id: id
        }));
        // set post as blocked in the report state
        dispatch((0, $10e6J.reportSetReportEntityBlocked)());
        // close block post modal
        dispatch((0, $a0vy2.postClosePostBlockModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully blocked post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to block post: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $e927c7dc5773749b$export$37646f6edbc68fd3 = (0, $kvj5V.createAsyncThunk)("post/postDelete", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete post
        await api.postApi.deletePost(id);
        // filter deleted post
        dispatch((0, $a0vy2.postFilterPost)({
            id: id
        }));
        // refetch uploaded posts
        dispatch($e927c7dc5773749b$export$9ec7a0da93a2e6f3({
            limit: 30,
            offset: 0
        }));
        // close delete post modal
        dispatch((0, $a0vy2.postClosePostDeleteModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully deleted post!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to delete post: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("iXWCl", function(module, exports) {

$parcel$export(module.exports, "ReportCard", function () { return (parcelRequire("6Gsv5")).ReportCard; });
$parcel$export(module.exports, "ReportCommentModal", function () { return (parcelRequire("9Du3z")).ReportCommentModal; });
$parcel$export(module.exports, "ReportComplaintCard", function () { return (parcelRequire("iDOhc")).ReportComplaintCard; });
$parcel$export(module.exports, "ReportComplaintListReport", function () { return (parcelRequire("hStsc")).ReportComplaintListReport; });
$parcel$export(module.exports, "ReportComplaintViewReportComplaint", function () { return (parcelRequire("gwO3g")).ReportComplaintViewReportComplaint; });
$parcel$export(module.exports, "ReportListReports", function () { return (parcelRequire("iAJfp")).ReportListReports; });
$parcel$export(module.exports, "ReportPostModal", function () { return (parcelRequire("8XLYp")).ReportPostModal; });
$parcel$export(module.exports, "ReportResolveModal", function () { return (parcelRequire("4gtff")).ReportResolveModal; });
$parcel$export(module.exports, "ReportTrackModal", function () { return (parcelRequire("2ngpN")).ReportTrackModal; });
$parcel$export(module.exports, "ReportUserModal", function () { return (parcelRequire("8ofjB")).ReportUserModal; });
$parcel$export(module.exports, "ReportViewReport", function () { return (parcelRequire("96net")).ReportViewReport; });
parcelRequire("3B5Vv");
var $6Gsv5 = parcelRequire("6Gsv5");
var $9Du3z = parcelRequire("9Du3z");
var $iDOhc = parcelRequire("iDOhc");
var $hStsc = parcelRequire("hStsc");
var $gwO3g = parcelRequire("gwO3g");
var $iAJfp = parcelRequire("iAJfp");
var $8XLYp = parcelRequire("8XLYp");
var $4gtff = parcelRequire("4gtff");
var $2ngpN = parcelRequire("2ngpN");
var $8ofjB = parcelRequire("8ofjB");
var $96net = parcelRequire("96net");

var $10e6J = parcelRequire("10e6J");

var $lxN7y = parcelRequire("lxN7y");
$parcel$exportWildcard(module.exports, $10e6J);
$parcel$exportWildcard(module.exports, $lxN7y);

});
parcelRegister("3B5Vv", function(module, exports) {

$parcel$export(module.exports, "ReportCard", function () { return (parcelRequire("6Gsv5")).ReportCard; });
$parcel$export(module.exports, "ReportCommentModal", function () { return (parcelRequire("9Du3z")).ReportCommentModal; });
$parcel$export(module.exports, "ReportComplaintCard", function () { return (parcelRequire("iDOhc")).ReportComplaintCard; });
$parcel$export(module.exports, "ReportComplaintListReport", function () { return (parcelRequire("hStsc")).ReportComplaintListReport; });
$parcel$export(module.exports, "ReportComplaintViewReportComplaint", function () { return (parcelRequire("gwO3g")).ReportComplaintViewReportComplaint; });
$parcel$export(module.exports, "ReportListReports", function () { return (parcelRequire("iAJfp")).ReportListReports; });
$parcel$export(module.exports, "ReportPostModal", function () { return (parcelRequire("8XLYp")).ReportPostModal; });
$parcel$export(module.exports, "ReportResolveModal", function () { return (parcelRequire("4gtff")).ReportResolveModal; });
$parcel$export(module.exports, "ReportTrackModal", function () { return (parcelRequire("2ngpN")).ReportTrackModal; });
$parcel$export(module.exports, "ReportUserModal", function () { return (parcelRequire("8ofjB")).ReportUserModal; });
$parcel$export(module.exports, "ReportViewReport", function () { return (parcelRequire("96net")).ReportViewReport; });

var $6Gsv5 = parcelRequire("6Gsv5");

var $9Du3z = parcelRequire("9Du3z");

var $iDOhc = parcelRequire("iDOhc");

var $hStsc = parcelRequire("hStsc");

var $gwO3g = parcelRequire("gwO3g");

var $iAJfp = parcelRequire("iAJfp");

var $8XLYp = parcelRequire("8XLYp");

var $4gtff = parcelRequire("4gtff");

var $2ngpN = parcelRequire("2ngpN");

var $8ofjB = parcelRequire("8ofjB");

var $96net = parcelRequire("96net");

});
parcelRegister("6Gsv5", function(module, exports) {

$parcel$export(module.exports, "ReportCard", function () { return $3822d62db5a2d6fb$export$7bf364c5d17ecc34; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $iU00P = parcelRequire("iU00P");
const $3822d62db5a2d6fb$export$7bf364c5d17ecc34 = ({ report: report, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    const { shortId: shortId, entityType: entityType, status: status, createdAt: createdAt } = report;
    const date = new Date(createdAt || "");
    const dateDay = date.getUTCDate().toString().padStart(2, "0");
    const dateMonth = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const dateYear = date.getUTCFullYear();
    // const dateYear = date.getUTCFullYear() % 100
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $iU00P.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $iU00P.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $iU00P.styles)(theme).card.data.icon,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).AlertTriangle, {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $iU00P.styles)(theme).card.data.identifier,
                        children: `#${shortId}`
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $iU00P.styles)(theme).card.data.type,
                        children: entityType
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $iU00P.styles)(theme).card.data.status,
                        children: status
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $iU00P.styles)(theme).card.data.date,
                        children: `${dateDay}.${dateMonth}.${dateYear}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $iU00P.styles)(theme).card.divider
            })
        ]
    });
};
$3822d62db5a2d6fb$export$7bf364c5d17ecc34.propTypes = {};

});
parcelRegister("iU00P", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $67338e5900def6bb$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $67338e5900def6bb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $67338e5900def6bb$var$_ref = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $67338e5900def6bb$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $67338e5900def6bb$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $67338e5900def6bb$var$_ref4 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $67338e5900def6bb$var$_ref5 = {
    name: "eivff4",
    styles: "display:none"
};
var $67338e5900def6bb$var$_ref6 = {
    name: "1mz29im",
    styles: "display:flex;align-items:center;height:40px"
};
var $67338e5900def6bb$var$_ref7 = {
    name: "1y1se14",
    styles: "display:flex;flex-direction:column;justify-content:space-between;height:60px;cursor:pointer"
};
const $67338e5900def6bb$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $67338e5900def6bb$var$_ref7,
            data: {
                main: $67338e5900def6bb$var$_ref6,
                icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex:0 0 40px;margin-right:10px;", (0, $gln0L.mq).tablet($67338e5900def6bb$var$_ref5), " &>svg{height:22px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                identifier: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 100px;margin-right:10px;", (0, $gln0L.mq).mobile($67338e5900def6bb$var$_ref4), ";", ""),
                type: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).tablet($67338e5900def6bb$var$_ref3), ";", ""),
                status: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).mobile($67338e5900def6bb$var$_ref2), ";", ""),
                date: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;", (0, $gln0L.mq).mobile($67338e5900def6bb$var$_ref), ";", "")
            },
            divider: /*#__PURE__*/ (0, $7hler.css)("width:100%;height:1px;background-color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("9Du3z", function(module, exports) {

$parcel$export(module.exports, "ReportCommentModal", function () { return $62043b3a5d97e007$export$49579d848236fc63; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("hpHpr");
var $acMn6 = parcelRequire("acMn6");

var $aneIa = parcelRequire("aneIa");
const $62043b3a5d97e007$export$49579d848236fc63 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportCommentModalOpen = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportCommentModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $aneIa.styles)().modal.main,
        children: reportCommentModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $10e6J.reportCloseReportCommentModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $aneIa.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $acMn6.ReportCommentCard), {})
            })
        })
    });
};
$62043b3a5d97e007$export$49579d848236fc63.propTypes = {};

});
parcelRegister("hpHpr", function(module, exports) {

$parcel$export(module.exports, "ReportCommentCard", function () { return (parcelRequire("acMn6")).ReportCommentCard; });

var $acMn6 = parcelRequire("acMn6");

});
parcelRegister("acMn6", function(module, exports) {

$parcel$export(module.exports, "ReportCommentCard", function () { return $fe1f08c39de90043$export$3cf652da30bd6e5e; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("cOm6U");
var $9r23Y = parcelRequire("9r23Y");

var $1Lh5x = parcelRequire("1Lh5x");
const $fe1f08c39de90043$export$3cf652da30bd6e5e = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportCommentError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $1Lh5x.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1Lh5x.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $10e6J.reportCloseReportCommentModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1Lh5x.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1Lh5x.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this comment."
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $1Lh5x.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1Lh5x.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9r23Y.ReportCommentForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1Lh5x.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: reportCommentError
                        })
                    })
                ]
            })
        ]
    });
};
$fe1f08c39de90043$export$3cf652da30bd6e5e.propTypes = {};

});
parcelRegister("cOm6U", function(module, exports) {

$parcel$export(module.exports, "ReportCommentForm", function () { return (parcelRequire("9r23Y")).ReportCommentForm; });

var $9r23Y = parcelRequire("9r23Y");

});
parcelRegister("9r23Y", function(module, exports) {

$parcel$export(module.exports, "ReportCommentForm", function () { return $6c440bcbd28edb25$export$ae585ae2d51dd87b; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $512kQ = parcelRequire("512kQ");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $lxN7y = parcelRequire("lxN7y");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $eOdZ3 = parcelRequire("eOdZ3");
var $k1nII = parcelRequire("k1nII");
var $f6nZ0 = parcelRequire("f6nZ0");

var $hMpFZ = parcelRequire("hMpFZ");
const $6c440bcbd28edb25$export$ae585ae2d51dd87b = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportCreateCommentReportComplaintLoading = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportCreateCommentReportComplaintLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalComment = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportCommentModalComment));
    const [complaintType, setComplaintType] = (0, $bh6RR.useState)("");
    const [complaint, setComplaint] = (0, $bh6RR.useState)("");
    const [complaintError, setComplaintError] = (0, $bh6RR.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId } = modalComment ?? {};
    const isCurrentUserComment = profileUserId === artistUserId;
    const submitDisabled = complaint.length > (0, $512kQ.maxReportComplaintLength) || !complaintType || isCurrentUserComment || reportCreateCommentReportComplaintLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $hMpFZ.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $hMpFZ.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $lxN7y.reportCreateCommentReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $hMpFZ.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $k1nII.InputSelect), {
                        placeholder: {
                            id: "report-post-comment-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $512kQ.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $hMpFZ.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eOdZ3.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $512kQ.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $lRNbG.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $hMpFZ.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreateCommentReportComplaintLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$6c440bcbd28edb25$export$ae585ae2d51dd87b.propTypes = {};

});
parcelRegister("hMpFZ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $24247e3171748aec$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $24247e3171748aec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $24247e3171748aec$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $24247e3171748aec$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $24247e3171748aec$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                type: $24247e3171748aec$var$_ref2,
                complaint: $24247e3171748aec$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("1Lh5x", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c83835fe984f772a$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c83835fe984f772a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c83835fe984f772a$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c83835fe984f772a$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c83835fe984f772a$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $c83835fe984f772a$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c83835fe984f772a$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $c83835fe984f772a$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $c83835fe984f772a$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $c83835fe984f772a$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $c83835fe984f772a$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($c83835fe984f772a$var$_ref8), " ", (0, $gln0L.mq).mobile($c83835fe984f772a$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($c83835fe984f772a$var$_ref6), ";", ""),
            title: $c83835fe984f772a$var$_ref5,
            subtitle: $c83835fe984f772a$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($c83835fe984f772a$var$_ref3), ";", ""),
                form: $c83835fe984f772a$var$_ref2,
                error: $c83835fe984f772a$var$_ref
            }
        }
    });

});



parcelRegister("aneIa", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $55fc71e4aac25637$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $55fc71e4aac25637$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $55fc71e4aac25637$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $55fc71e4aac25637$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($55fc71e4aac25637$var$_ref), ";", "")
        }
    });

});


parcelRegister("iDOhc", function(module, exports) {

$parcel$export(module.exports, "ReportComplaintCard", function () { return $6f945791df6a9faf$export$1484efe53c4fb266; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $9j9Wh = parcelRequire("9j9Wh");
const $6f945791df6a9faf$export$1484efe53c4fb266 = ({ reportComplaint: reportComplaint, onUserNameClick: onUserNameClick, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    const { userId: reportComplaintAuthorUserId, complaint: complaint, complaintType: complaintType } = reportComplaint;
    // report complaint author
    const { user: reportComplaintAuthor, isLoading: isReportComplaintAuthorLoading } = (0, $aCYwi.useUserPublic)(reportComplaintAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = reportComplaintAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $jpNoL.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $bh6RR.useState)(false);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $9j9Wh.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $9j9Wh.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $9j9Wh.styles)(theme).card.data.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $9j9Wh.styles)(theme).card.data.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                            css: (0, $9j9Wh.styles)(theme).card.data.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $9j9Wh.styles)(theme).card.data.content.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $9j9Wh.styles)(theme).card.data.content.name,
                                onClick: (e)=>e.stopPropagation(),
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: (0, $9j9Wh.styles)(theme).card.data.content.name,
                                    onClick: (e)=>onUserNameClick(e),
                                    type: "button",
                                    "aria-label": "explore author profile",
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                        children: isReportComplaintAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $9j9Wh.styles)(theme).card.data.content.complaint,
                                children: complaint
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $9j9Wh.styles)(theme).card.type.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $9j9Wh.styles)(theme).card.type.text,
                    children: complaintType?.toString().replace("_", " ")
                })
            })
        ]
    });
};
$6f945791df6a9faf$export$1484efe53c4fb266.propTypes = {};

});
parcelRegister("9j9Wh", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $343a038864d1458d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $343a038864d1458d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $343a038864d1458d$var$_ref = {
    name: "1tltq10",
    styles: "display:flex;align-items:center;margin-left:42px"
};
var $343a038864d1458d$var$_ref2 = {
    name: "1gjs2mp",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-bottom:8px"
};
var $343a038864d1458d$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $343a038864d1458d$var$_ref4 = {
    name: "1479joy",
    styles: "display:flex;flex-direction:column;height:70px;cursor:pointer"
};
const $343a038864d1458d$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $343a038864d1458d$var$_ref4,
            data: {
                main: $343a038864d1458d$var$_ref3,
                avatar: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                    image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                content: {
                    main: $343a038864d1458d$var$_ref2,
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                    complaint: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
                }
            },
            type: {
                main: $343a038864d1458d$var$_ref,
                text: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;text-transform:uppercase;color:", theme.colors.negative.normal, ";font-size:", (0, $gln0L.typography).c, ";font-weight:bold;", "")
            }
        }
    });

});


parcelRegister("hStsc", function(module, exports) {

$parcel$export(module.exports, "ReportComplaintListReport", function () { return $e1acb916f85dfd1e$export$ff07cc9f0adc88a0; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $iDOhc = parcelRequire("iDOhc");
var $lxN7y = parcelRequire("lxN7y");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("5BECW");
var $hx9Yd = parcelRequire("hx9Yd");

var $kFzRT = parcelRequire("kFzRT");
const $e1acb916f85dfd1e$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const reportComplaints = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportComplaints));
    const reportComplaint = reportComplaints[index];
    // if report complaint not fetched
    if (!reportComplaint) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-list-report-complaints-complaint",
                    width: "100%",
                    height: "70px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: reportComplaintId, userId: reportComplaintAuthorUserId, reportId: reportId } = reportComplaint;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kFzRT.styles)().comments.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iDOhc.ReportComplaintCard), {
            reportComplaint: reportComplaint,
            onUserNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${reportComplaintAuthorUserId}`),
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Reports}${(0, $b7fnN.Path).Report}/${reportId}${(0, $b7fnN.Path).Complaint}/${reportComplaintId}`)
        })
    });
});
const $e1acb916f85dfd1e$export$ff07cc9f0adc88a0 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportGetReportComplaintsLoading = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportGetReportComplaintsLoading));
    const reportComplaints = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportComplaints));
    const reportComplaintsCount = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportComplaintsCount));
    const reportComplaintsLength = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportComplaintsLength));
    const reportComplaintsFetched = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportComplaintsFetched));
    const report = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReport));
    const { id: reportId } = report ?? {};
    const reportComplaintCardHeight = 70;
    const reportComplaintCardMarginBottom = 10;
    const itemHeight = reportComplaintCardHeight + reportComplaintCardMarginBottom;
    const itemsToFit = 6;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = itemsToFit * itemHeight;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    // if report is not fetched
    if (!report) // return skeleton
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kFzRT.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kFzRT.styles)().list.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $hx9Yd.Title), {
                    text: "Complaints"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kFzRT.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
                    sections: [
                        {
                            name: "report-list-report-complaints-load",
                            width: "100%",
                            height: `${defaultListHeight}px`,
                            isStatic: false,
                            isDivider: false
                        }
                    ]
                })
            })
        ]
    });
    const isItemLoaded = (index)=>!!reportComplaints[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $lxN7y.reportGetReportComplaints)({
            reportId: reportId || "",
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if report complaints are fetched but length is 0
    if (!reportGetReportComplaintsLoading && reportComplaintsFetched && reportComplaintsLength === 0) // return placeholder
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kFzRT.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kFzRT.styles)().list.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $hx9Yd.Title), {
                    text: "Complaints"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kFzRT.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
                    icon: (0, $bq9l8.icons).CheckCircle,
                    height: `${defaultListHeight}px`,
                    title: "Could not find any complaints"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kFzRT.styles)().list.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kFzRT.styles)().list.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $hx9Yd.Title), {
                    text: "Complaints"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kFzRT.styles)().list.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: reportComplaintsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: reportComplaintsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $e1acb916f85dfd1e$var$Row
                        })
                })
            })
        ]
    });
};
$e1acb916f85dfd1e$export$ff07cc9f0adc88a0.propTypes = {};

});
parcelRegister("5BECW", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return (parcelRequire("hx9Yd")).Title; });

var $hx9Yd = parcelRequire("hx9Yd");

});
parcelRegister("hx9Yd", function(module, exports) {

$parcel$export(module.exports, "Title", function () { return $0acf297ed266be12$export$f99233281efd08a0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $2Y0MP = parcelRequire("2Y0MP");
const $0acf297ed266be12$export$f99233281efd08a0 = ({ text: text })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $2Y0MP.styles)(theme).label.main,
        children: text
    });
};
$0acf297ed266be12$export$f99233281efd08a0.propTypes = {};

});
parcelRegister("2Y0MP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2595e1301f4a21ca$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $2595e1301f4a21ca$export$9dd6ff9ea0189349 = (theme)=>({
        label: {
            main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.light, ";", "")
        }
    });

});



parcelRegister("kFzRT", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8a144e72e96cab01$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $8a144e72e96cab01$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8a144e72e96cab01$var$_ref = {
    name: "1vbruv4",
    styles: "width:100%;margin-bottom:16px"
};
var $8a144e72e96cab01$var$_ref2 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
const $8a144e72e96cab01$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";display:flex;flex-direction:column;overflow:hidden;max-width:800px;margin-bottom:50px;", ""),
            title: $8a144e72e96cab01$var$_ref2,
            content: $8a144e72e96cab01$var$_ref
        },
        comments: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("gwO3g", function(module, exports) {

$parcel$export(module.exports, "ReportComplaintViewReportComplaint", function () { return $a27a9ab004cbacc0$export$ac311a35bb6f30cb; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $1Tgho = parcelRequire("1Tgho");
const $a27a9ab004cbacc0$export$ac311a35bb6f30cb = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const theme = (0, $iwq56.u)();
    const reportComplaint = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportComplaint));
    const reportComplaintFetched = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportComplaintFetched));
    const { userId: reportComplaintAuthorUserId, complaint: complaint, complaintType: complaintType } = reportComplaint ?? {};
    // report complaint author
    const { user: reportComplaintAuthor, isLoading: isReportComplaintAuthorLoading } = (0, $aCYwi.useUserPublic)(reportComplaintAuthorUserId || "");
    const { name: authorName, avatarId: authorAvatarId } = reportComplaintAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorNamePlaceholder = "-";
    const authorHasAvatar = !!authorAvatarId;
    const authorAvatar = (0, $jpNoL.useFile)(authorAvatarId || "");
    const [authorAvatarLoadError, setAuthorAvatarLoadError] = (0, $bh6RR.useState)(false);
    // if report complaint not found
    if (reportComplaintFetched && !reportComplaint) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1Tgho.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).AlertTriangle,
            height: "133px",
            title: "Could not find report complaint"
        })
    });
    // if report complaint found
    if (reportComplaintFetched && reportComplaint) return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $1Tgho.styles)(theme).view.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $1Tgho.styles)(theme).view.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1Tgho.styles)(theme).view.data.avatar.main,
                        children: authorHasAvatar && !authorAvatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $1Tgho.styles)(theme).view.data.avatar.image,
                            onError: ()=>setAuthorAvatarLoadError(true),
                            loading: "lazy",
                            width: "30px",
                            height: "30px",
                            src: authorAvatar,
                            alt: "post author avatar"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                            css: (0, $1Tgho.styles)(theme).view.data.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $1Tgho.styles)(theme).view.data.content.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $1Tgho.styles)(theme).view.data.content.name,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: (0, $1Tgho.styles)(theme).view.data.content.name,
                                    onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${reportComplaintAuthorUserId}`),
                                    type: "button",
                                    "aria-label": "explore author profile",
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                        children: isReportComplaintAuthorLoading ? authorLoadingPlaceholder : authorName || authorNamePlaceholder
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $1Tgho.styles)(theme).view.data.content.complaint,
                                children: complaint
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1Tgho.styles)(theme).view.type.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $1Tgho.styles)(theme).view.type.text,
                    children: complaintType?.toString().replace("_", " ")
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1Tgho.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-complaint-view-report-complaint",
                    width: "100%",
                    height: "133px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$a27a9ab004cbacc0$export$ac311a35bb6f30cb.propTypes = {};

});
parcelRegister("1Tgho", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $99239bbd8977588f$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $99239bbd8977588f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $99239bbd8977588f$var$_ref = {
    name: "1tltq10",
    styles: "display:flex;align-items:center;margin-left:42px"
};
var $99239bbd8977588f$var$_ref2 = {
    name: "1gjs2mp",
    styles: "display:flex;flex-direction:column;justify-content:center;min-width:0;margin-bottom:8px"
};
var $99239bbd8977588f$var$_ref3 = {
    name: "zjik7",
    styles: "display:flex"
};
var $99239bbd8977588f$var$_ref4 = {
    name: "13sxwxr",
    styles: "display:flex;flex-direction:column;max-width:800px"
};
const $99239bbd8977588f$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: $99239bbd8977588f$var$_ref4,
            data: {
                main: $99239bbd8977588f$var$_ref3,
                avatar: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:30px;height:30px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:12px;", ""),
                    image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("width:14px;height:14px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                },
                content: {
                    main: $99239bbd8977588f$var$_ref2,
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;min-width:0;max-width:240px;margin-bottom:2px;&>span{", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";transition:color 0.2s;}&:hover{&>span{color:", theme.colors.accent.normal, ";}}", ""),
                    complaint: /*#__PURE__*/ (0, $7hler.css)("word-break:break-all;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";", "")
                }
            },
            type: {
                main: $99239bbd8977588f$var$_ref,
                text: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;text-transform:uppercase;color:", theme.colors.negative.normal, ";font-size:", (0, $gln0L.typography).c, ";font-weight:bold;", "")
            }
        }
    });

});


parcelRegister("iAJfp", function(module, exports) {

$parcel$export(module.exports, "ReportListReports", function () { return $2b17c432646359cc$export$7b3b208f88d54575; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $6Gsv5 = parcelRequire("6Gsv5");
var $lxN7y = parcelRequire("lxN7y");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $curqj = parcelRequire("curqj");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $lEGHK = parcelRequire("lEGHK");
const $2b17c432646359cc$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const reports = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReports));
    const report = reports[index];
    // if report not fetched
    if (!report) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-list-reports-report",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: reportId } = report;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $lEGHK.styles)().report.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6Gsv5.ReportCard), {
            report: report,
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Reports}${(0, $b7fnN.Path).Report}/${reportId}`)
        })
    });
});
const $2b17c432646359cc$export$7b3b208f88d54575 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportGetReportsLoading = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportGetReportsLoading));
    const reports = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReports));
    const reportsCount = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportsCount));
    const reportsLength = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportsLength));
    const reportsFetched = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportsFetched));
    const reportsFilter = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportsFilter));
    const reportCardHeight = 60;
    const reportCardMarginBottom = 20;
    const itemHeight = reportCardHeight + reportCardMarginBottom;
    const itemsToFit = 6;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = itemsToFit * itemHeight;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!reports[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $lxN7y.reportGetReports)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders report list navigation
    const renderReportListNavigation = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $lEGHK.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $curqj.NavigationScrollable), {
                options: [
                    {
                        id: "14971507-83aa-4bf6-a1af-9bfe525f6d32",
                        label: "User",
                        enabled: reportsFilter === (0, $2gpGl.EntityReportEntityType).User,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $10e6J.reportSetReportsFilter)({
                                filter: (0, $2gpGl.EntityReportEntityType).User
                            }));
                            // refetch reports
                            dispatch((0, $lxN7y.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "9ba9f8d0-624b-4698-b024-e0a6fd752d29",
                        label: "Track",
                        enabled: reportsFilter === (0, $2gpGl.EntityReportEntityType).Track,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $10e6J.reportSetReportsFilter)({
                                filter: (0, $2gpGl.EntityReportEntityType).Track
                            }));
                            // refetch reports
                            dispatch((0, $lxN7y.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "d53b86eb-48e7-4abc-aa96-482944eb7a5b",
                        label: "Post",
                        enabled: reportsFilter === (0, $2gpGl.EntityReportEntityType).Post,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $10e6J.reportSetReportsFilter)({
                                filter: (0, $2gpGl.EntityReportEntityType).Post
                            }));
                            // refetch reports
                            dispatch((0, $lxN7y.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "df95c9e0-99c1-4da9-9baf-939f26bc3d09",
                        label: "Comment",
                        enabled: reportsFilter === (0, $2gpGl.EntityReportEntityType).Comment,
                        onClick: ()=>{
                            // set reports filter
                            dispatch((0, $10e6J.reportSetReportsFilter)({
                                filter: (0, $2gpGl.EntityReportEntityType).Comment
                            }));
                            // refetch reports
                            dispatch((0, $lxN7y.reportGetReports)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    }
                ]
            })
        });
    // renders report list table header
    const renderReportListTableHeader = ()=>/*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $lEGHK.styles)().list.header.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lEGHK.styles)().list.header.placeholder
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lEGHK.styles)().list.header.identifier,
                    children: "Identifier"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lEGHK.styles)().list.header.type,
                    children: "Type"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lEGHK.styles)().list.header.status,
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $lEGHK.styles)().list.header.date,
                    children: "Date"
                })
            ]
        });
    // if reports are fetched but length is 0
    if (!reportGetReportsLoading && reportsFetched && reportsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $lEGHK.styles)().list.main,
        children: [
            renderReportListNavigation(),
            renderReportListTableHeader(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lEGHK.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
                    icon: (0, $bq9l8.icons).CheckCircle,
                    height: `${defaultListHeight}px`,
                    title: "There are no unresolved reports"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $lEGHK.styles)().list.main,
        children: [
            renderReportListNavigation(),
            renderReportListTableHeader(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lEGHK.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: reportsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: reportsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $2b17c432646359cc$var$Row
                        })
                })
            })
        ]
    }));
};
$2b17c432646359cc$export$7b3b208f88d54575.propTypes = {};

});
parcelRegister("lEGHK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1aa507bd65c989d7$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $1aa507bd65c989d7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1aa507bd65c989d7$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
var $1aa507bd65c989d7$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $1aa507bd65c989d7$var$_ref3 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $1aa507bd65c989d7$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $1aa507bd65c989d7$var$_ref5 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $1aa507bd65c989d7$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $1aa507bd65c989d7$var$_ref7 = {
    name: "phodm9",
    styles: "display:flex;max-width:800px;margin-bottom:32px"
};
const $1aa507bd65c989d7$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            header: {
                main: $1aa507bd65c989d7$var$_ref7,
                placeholder: /*#__PURE__*/ (0, $7hler.css)("flex:0 0 40px;margin-right:10px;", (0, $gln0L.mq).tablet($1aa507bd65c989d7$var$_ref6), ";", ""),
                identifier: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 100px;margin-right:10px;", (0, $gln0L.mq).mobile($1aa507bd65c989d7$var$_ref5), ";", ""),
                type: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).tablet($1aa507bd65c989d7$var$_ref4), ";", ""),
                status: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).mobile($1aa507bd65c989d7$var$_ref3), ";", ""),
                date: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;", (0, $gln0L.mq).mobile($1aa507bd65c989d7$var$_ref2), ";", "")
            },
            content: {
                main: $1aa507bd65c989d7$var$_ref
            }
        },
        report: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("8XLYp", function(module, exports) {

$parcel$export(module.exports, "ReportPostModal", function () { return $8a7c2b1ca4fa4691$export$6610c8fff59d8576; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("gwpav");
var $b6IpE = parcelRequire("b6IpE");

var $2jsYv = parcelRequire("2jsYv");
const $8a7c2b1ca4fa4691$export$6610c8fff59d8576 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportPostModalOpen = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportPostModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $2jsYv.styles)().modal.main,
        children: reportPostModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $10e6J.reportCloseReportPostModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2jsYv.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $b6IpE.ReportPostCard), {})
            })
        })
    });
};
$8a7c2b1ca4fa4691$export$6610c8fff59d8576.propTypes = {};

});
parcelRegister("gwpav", function(module, exports) {

$parcel$export(module.exports, "ReportPostCard", function () { return (parcelRequire("b6IpE")).ReportPostCard; });

var $b6IpE = parcelRequire("b6IpE");

});
parcelRegister("b6IpE", function(module, exports) {

$parcel$export(module.exports, "ReportPostCard", function () { return $df9a67309eeafbbc$export$27d18a6e1427506; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("eW4nc");
var $attMR = parcelRequire("attMR");

var $jKExq = parcelRequire("jKExq");
const $df9a67309eeafbbc$export$27d18a6e1427506 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportPostError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $jKExq.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jKExq.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $10e6J.reportCloseReportPostModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jKExq.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jKExq.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this post."
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $jKExq.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $jKExq.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $attMR.ReportPostForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $jKExq.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: reportPostError
                        })
                    })
                ]
            })
        ]
    });
};
$df9a67309eeafbbc$export$27d18a6e1427506.propTypes = {};

});
parcelRegister("eW4nc", function(module, exports) {

$parcel$export(module.exports, "ReportPostForm", function () { return (parcelRequire("attMR")).ReportPostForm; });

var $attMR = parcelRequire("attMR");

});
parcelRegister("attMR", function(module, exports) {

$parcel$export(module.exports, "ReportPostForm", function () { return $f8fe672e702e658f$export$82ab98eea2f39c83; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $512kQ = parcelRequire("512kQ");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $lxN7y = parcelRequire("lxN7y");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $eOdZ3 = parcelRequire("eOdZ3");
var $k1nII = parcelRequire("k1nII");
var $f6nZ0 = parcelRequire("f6nZ0");

var $ihaSD = parcelRequire("ihaSD");
const $f8fe672e702e658f$export$82ab98eea2f39c83 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportCreatePostReportComplaintLoading = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportCreatePostReportComplaintLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalPost = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportPostModalPost));
    const [complaintType, setComplaintType] = (0, $bh6RR.useState)("");
    const [complaint, setComplaint] = (0, $bh6RR.useState)("");
    const [complaintError, setComplaintError] = (0, $bh6RR.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId } = modalPost ?? {};
    const isCurrentUserPost = profileUserId === artistUserId;
    const submitDisabled = complaint.length > (0, $512kQ.maxReportComplaintLength) || !complaintType || isCurrentUserPost || reportCreatePostReportComplaintLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $ihaSD.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $ihaSD.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $lxN7y.reportCreatePostReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $ihaSD.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $k1nII.InputSelect), {
                        placeholder: {
                            id: "report-post-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $512kQ.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $ihaSD.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eOdZ3.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $512kQ.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $lRNbG.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $ihaSD.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreatePostReportComplaintLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$f8fe672e702e658f$export$82ab98eea2f39c83.propTypes = {};

});
parcelRegister("ihaSD", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $463ca4d7c2c2e11d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $463ca4d7c2c2e11d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $463ca4d7c2c2e11d$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $463ca4d7c2c2e11d$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $463ca4d7c2c2e11d$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                type: $463ca4d7c2c2e11d$var$_ref2,
                complaint: $463ca4d7c2c2e11d$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("jKExq", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ae9662e162b5f85a$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ae9662e162b5f85a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ae9662e162b5f85a$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ae9662e162b5f85a$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ae9662e162b5f85a$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ae9662e162b5f85a$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ae9662e162b5f85a$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ae9662e162b5f85a$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $ae9662e162b5f85a$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $ae9662e162b5f85a$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $ae9662e162b5f85a$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($ae9662e162b5f85a$var$_ref8), " ", (0, $gln0L.mq).mobile($ae9662e162b5f85a$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($ae9662e162b5f85a$var$_ref6), ";", ""),
            title: $ae9662e162b5f85a$var$_ref5,
            subtitle: $ae9662e162b5f85a$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($ae9662e162b5f85a$var$_ref3), ";", ""),
                form: $ae9662e162b5f85a$var$_ref2,
                error: $ae9662e162b5f85a$var$_ref
            }
        }
    });

});



parcelRegister("2jsYv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ac766de0edff16a1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ac766de0edff16a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ac766de0edff16a1$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $ac766de0edff16a1$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($ac766de0edff16a1$var$_ref), ";", "")
        }
    });

});


parcelRegister("4gtff", function(module, exports) {

$parcel$export(module.exports, "ReportResolveModal", function () { return $0bf934a1606d3f06$export$e373f5a8b050afe; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("lTSNW");
var $h713B = parcelRequire("h713B");

var $e9fHs = parcelRequire("e9fHs");
const $0bf934a1606d3f06$export$e373f5a8b050afe = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportResolveModalOpen = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportResolveModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $e9fHs.styles)().modal.main,
        children: reportResolveModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $10e6J.reportCloseReportResolveModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $e9fHs.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $h713B.ReportResolveCard), {})
            })
        })
    });
};
$0bf934a1606d3f06$export$e373f5a8b050afe.propTypes = {};

});
parcelRegister("lTSNW", function(module, exports) {

$parcel$export(module.exports, "ReportResolveCard", function () { return (parcelRequire("h713B")).ReportResolveCard; });

var $h713B = parcelRequire("h713B");

});
parcelRegister("h713B", function(module, exports) {

$parcel$export(module.exports, "ReportResolveCard", function () { return $d421f3caffec7902$export$15d37b6ae89a7af2; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("j9ddP");
var $Gxx4h = parcelRequire("Gxx4h");

var $3A0s9 = parcelRequire("3A0s9");
const $d421f3caffec7902$export$15d37b6ae89a7af2 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportResolveError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $3A0s9.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3A0s9.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $10e6J.reportCloseReportResolveModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3A0s9.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Resolve",
                    icon: (0, $bq9l8.icons).Check
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3A0s9.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Resolve the report once the matter has been thoroughly examined and processed."
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $3A0s9.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3A0s9.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $Gxx4h.ReportResolveForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3A0s9.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: reportResolveError
                        })
                    })
                ]
            })
        ]
    });
};
$d421f3caffec7902$export$15d37b6ae89a7af2.propTypes = {};

});
parcelRegister("j9ddP", function(module, exports) {

$parcel$export(module.exports, "ReportResolveForm", function () { return (parcelRequire("Gxx4h")).ReportResolveForm; });

var $Gxx4h = parcelRequire("Gxx4h");

});
parcelRegister("Gxx4h", function(module, exports) {

$parcel$export(module.exports, "ReportResolveForm", function () { return $6466f34fb73b99ad$export$4a431c6a63f35209; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $lxN7y = parcelRequire("lxN7y");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $gjL1I = parcelRequire("gjL1I");
const $6466f34fb73b99ad$export$4a431c6a63f35209 = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportResolveReportLoading = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportResolveReportLoading));
    const modalReport = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportResolveModalReport));
    const { id: reportId, shortId: shortReportId } = modalReport ?? {};
    const submitDisabled = reportResolveReportLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gjL1I.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $gjL1I.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $lxN7y.reportResolveReport)({
                    reportId: reportId || "",
                    cb: ()=>{
                        // navigate to reports page
                        navigate(`${(0, $b7fnN.Path).Reports}`);
                    }
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $gjL1I.styles)().form.content.report,
                    children: `#${shortReportId}`
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $gjL1I.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportResolveReportLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Resolve`
                    })
                })
            ]
        })
    });
};
$6466f34fb73b99ad$export$4a431c6a63f35209.propTypes = {};

});
parcelRegister("gjL1I", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6fa5eae071825cef$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $6fa5eae071825cef$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                report: /*#__PURE__*/ (0, $7hler.css)("margin-bottom:24px;text-align:center;font-size:", (0, $gln0L.typography).h5, ";", ""),
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("3A0s9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $77330f0e22eeb5b9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $77330f0e22eeb5b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $77330f0e22eeb5b9$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $77330f0e22eeb5b9$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $77330f0e22eeb5b9$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $77330f0e22eeb5b9$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $77330f0e22eeb5b9$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $77330f0e22eeb5b9$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $77330f0e22eeb5b9$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $77330f0e22eeb5b9$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $77330f0e22eeb5b9$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($77330f0e22eeb5b9$var$_ref8), " ", (0, $gln0L.mq).mobile($77330f0e22eeb5b9$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($77330f0e22eeb5b9$var$_ref6), ";", ""),
            title: $77330f0e22eeb5b9$var$_ref5,
            subtitle: $77330f0e22eeb5b9$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($77330f0e22eeb5b9$var$_ref3), ";", ""),
                form: $77330f0e22eeb5b9$var$_ref2,
                error: $77330f0e22eeb5b9$var$_ref
            }
        }
    });

});



parcelRegister("e9fHs", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b6f944b0db442335$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $b6f944b0db442335$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b6f944b0db442335$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $b6f944b0db442335$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($b6f944b0db442335$var$_ref), ";", "")
        }
    });

});


parcelRegister("2ngpN", function(module, exports) {

$parcel$export(module.exports, "ReportTrackModal", function () { return $75f79bf6e6bd3ac7$export$234fa7d426a2b82b; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("cFBPd");
var $6V6H2 = parcelRequire("6V6H2");

var $5VzFj = parcelRequire("5VzFj");
const $75f79bf6e6bd3ac7$export$234fa7d426a2b82b = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportTrackModalOpen = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportTrackModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $5VzFj.styles)().modal.main,
        children: reportTrackModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $10e6J.reportCloseReportTrackModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $5VzFj.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6V6H2.ReportTrackCard), {})
            })
        })
    });
};
$75f79bf6e6bd3ac7$export$234fa7d426a2b82b.propTypes = {};

});
parcelRegister("cFBPd", function(module, exports) {

$parcel$export(module.exports, "ReportTrackCard", function () { return (parcelRequire("6V6H2")).ReportTrackCard; });

var $6V6H2 = parcelRequire("6V6H2");

});
parcelRegister("6V6H2", function(module, exports) {

$parcel$export(module.exports, "ReportTrackCard", function () { return $cd4e65084b59a933$export$659fcbb67532e1ba; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("577w2");
var $cxKD6 = parcelRequire("cxKD6");

var $9uNat = parcelRequire("9uNat");
const $cd4e65084b59a933$export$659fcbb67532e1ba = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportTrackError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $9uNat.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $9uNat.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $10e6J.reportCloseReportTrackModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $9uNat.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $9uNat.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this track."
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $9uNat.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $9uNat.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $cxKD6.ReportTrackForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $9uNat.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: reportTrackError
                        })
                    })
                ]
            })
        ]
    });
};
$cd4e65084b59a933$export$659fcbb67532e1ba.propTypes = {};

});
parcelRegister("577w2", function(module, exports) {

$parcel$export(module.exports, "ReportTrackForm", function () { return (parcelRequire("cxKD6")).ReportTrackForm; });

var $cxKD6 = parcelRequire("cxKD6");

});
parcelRegister("cxKD6", function(module, exports) {

$parcel$export(module.exports, "ReportTrackForm", function () { return $4b6a2410711aa029$export$90d0cf6a279f0b72; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $512kQ = parcelRequire("512kQ");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $lxN7y = parcelRequire("lxN7y");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $eOdZ3 = parcelRequire("eOdZ3");
var $k1nII = parcelRequire("k1nII");
var $f6nZ0 = parcelRequire("f6nZ0");

var $dNyas = parcelRequire("dNyas");
const $4b6a2410711aa029$export$90d0cf6a279f0b72 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportCreateTrackReportComplaintLoading = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportCreateTrackReportComplaintLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalTrack = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportTrackModalTrack));
    const [complaintType, setComplaintType] = (0, $bh6RR.useState)("");
    const [complaint, setComplaint] = (0, $bh6RR.useState)("");
    const [complaintError, setComplaintError] = (0, $bh6RR.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId } = modalTrack ?? {};
    const isCurrentUserTrack = profileUserId === artistUserId;
    const submitDisabled = complaint.length > (0, $512kQ.maxReportComplaintLength) || !complaintType || isCurrentUserTrack || reportCreateTrackReportComplaintLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $dNyas.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $dNyas.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $lxN7y.reportCreateTrackReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $dNyas.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $k1nII.InputSelect), {
                        placeholder: {
                            id: "report-track-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $512kQ.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $dNyas.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eOdZ3.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $512kQ.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $lRNbG.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $dNyas.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreateTrackReportComplaintLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$4b6a2410711aa029$export$90d0cf6a279f0b72.propTypes = {};

});
parcelRegister("dNyas", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ab18d182f177e43d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $ab18d182f177e43d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ab18d182f177e43d$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ab18d182f177e43d$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $ab18d182f177e43d$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                type: $ab18d182f177e43d$var$_ref2,
                complaint: $ab18d182f177e43d$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("9uNat", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $40dc37f1ceb2c25b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $40dc37f1ceb2c25b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $40dc37f1ceb2c25b$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $40dc37f1ceb2c25b$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $40dc37f1ceb2c25b$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $40dc37f1ceb2c25b$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $40dc37f1ceb2c25b$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $40dc37f1ceb2c25b$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $40dc37f1ceb2c25b$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $40dc37f1ceb2c25b$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $40dc37f1ceb2c25b$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($40dc37f1ceb2c25b$var$_ref8), " ", (0, $gln0L.mq).mobile($40dc37f1ceb2c25b$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($40dc37f1ceb2c25b$var$_ref6), ";", ""),
            title: $40dc37f1ceb2c25b$var$_ref5,
            subtitle: $40dc37f1ceb2c25b$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($40dc37f1ceb2c25b$var$_ref3), ";", ""),
                form: $40dc37f1ceb2c25b$var$_ref2,
                error: $40dc37f1ceb2c25b$var$_ref
            }
        }
    });

});



parcelRegister("5VzFj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d22c4e0e7bcdcc11$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $d22c4e0e7bcdcc11$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d22c4e0e7bcdcc11$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $d22c4e0e7bcdcc11$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($d22c4e0e7bcdcc11$var$_ref), ";", "")
        }
    });

});


parcelRegister("8ofjB", function(module, exports) {

$parcel$export(module.exports, "ReportUserModal", function () { return $2a32b8266e7cf4e0$export$84a46ec975a11172; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("iatx4");
var $7ldKD = parcelRequire("7ldKD");

var $90Jf8 = parcelRequire("90Jf8");
const $2a32b8266e7cf4e0$export$84a46ec975a11172 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportUserModalOpen = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportUserModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $90Jf8.styles)().modal.main,
        children: reportUserModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $10e6J.reportCloseReportUserModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $90Jf8.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7ldKD.ReportUserCard), {})
            })
        })
    });
};
$2a32b8266e7cf4e0$export$84a46ec975a11172.propTypes = {};

});
parcelRegister("iatx4", function(module, exports) {

$parcel$export(module.exports, "ReportUserCard", function () { return (parcelRequire("7ldKD")).ReportUserCard; });

var $7ldKD = parcelRequire("7ldKD");

});
parcelRegister("7ldKD", function(module, exports) {

$parcel$export(module.exports, "ReportUserCard", function () { return $84e92058244ecc6f$export$8282ae97f8b0dd0; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("btXvY");
var $gtGV5 = parcelRequire("gtGV5");

var $kDjV7 = parcelRequire("kDjV7");
const $84e92058244ecc6f$export$8282ae97f8b0dd0 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportUserError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kDjV7.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kDjV7.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $10e6J.reportCloseReportUserModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kDjV7.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Report",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kDjV7.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Kindly provide details of your concern regarding this user."
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $kDjV7.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $kDjV7.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gtGV5.ReportUserForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $kDjV7.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: reportUserError
                        })
                    })
                ]
            })
        ]
    });
};
$84e92058244ecc6f$export$8282ae97f8b0dd0.propTypes = {};

});
parcelRegister("btXvY", function(module, exports) {

$parcel$export(module.exports, "ReportUserForm", function () { return (parcelRequire("gtGV5")).ReportUserForm; });

var $gtGV5 = parcelRequire("gtGV5");

});
parcelRegister("gtGV5", function(module, exports) {

$parcel$export(module.exports, "ReportUserForm", function () { return $7e4321c9efb8920f$export$3dfcd5665feb50c4; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $512kQ = parcelRequire("512kQ");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $lxN7y = parcelRequire("lxN7y");
var $10e6J = parcelRequire("10e6J");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $eOdZ3 = parcelRequire("eOdZ3");
var $k1nII = parcelRequire("k1nII");
var $f6nZ0 = parcelRequire("f6nZ0");

var $gSKPZ = parcelRequire("gSKPZ");
const $7e4321c9efb8920f$export$3dfcd5665feb50c4 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const reportCreateUserReportComplaintLoading = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportCreateUserReportComplaintLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalUser = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportUserModalUser));
    const [complaintType, setComplaintType] = (0, $bh6RR.useState)("");
    const [complaint, setComplaint] = (0, $bh6RR.useState)("");
    const [complaintError, setComplaintError] = (0, $bh6RR.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { id: currentUserId } = modalUser ?? {};
    const isCurrentUser = profileUserId === currentUserId;
    const submitDisabled = complaint.length > (0, $512kQ.maxReportComplaintLength) || !complaintType || isCurrentUser || reportCreateUserReportComplaintLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gSKPZ.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $gSKPZ.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $lxN7y.reportCreateUserReportComplaint)({
                    complaintType: complaintType,
                    complaint: complaint
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $gSKPZ.styles)().form.content.type,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $k1nII.InputSelect), {
                        placeholder: {
                            id: "report-user-select-placeholder",
                            label: "Select complaint type",
                            value: "select_complaint_type"
                        },
                        options: (0, $512kQ.complaintTypeSelectOptions),
                        setValue: (value)=>setComplaintType(value)
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $gSKPZ.styles)().form.content.complaint,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eOdZ3.InputArea), {
                        name: "report-complaint",
                        label: "report complaint",
                        id: "report-complaint",
                        placeholder: "Describe the details of your concern",
                        value: complaint,
                        maxLength: (0, $512kQ.maxReportComplaintLength),
                        error: complaintError.length > 0,
                        errorMessage: complaintError,
                        rows: 6,
                        onChange: (e)=>setComplaint(e.target.value),
                        onBlur: ()=>{
                            if (complaint !== "") setComplaintError((0, $lRNbG.validateReportComplaint)(complaint));
                        },
                        onFocus: ()=>setComplaintError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $gSKPZ.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create complaint",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: reportCreateUserReportComplaintLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Report`
                    })
                })
            ]
        })
    });
};
$7e4321c9efb8920f$export$3dfcd5665feb50c4.propTypes = {};

});
parcelRegister("gSKPZ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8b12ec83322e2017$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $8b12ec83322e2017$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8b12ec83322e2017$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $8b12ec83322e2017$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $8b12ec83322e2017$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                type: $8b12ec83322e2017$var$_ref2,
                complaint: $8b12ec83322e2017$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("kDjV7", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $37b1586d517d42b1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $37b1586d517d42b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $37b1586d517d42b1$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $37b1586d517d42b1$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $37b1586d517d42b1$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $37b1586d517d42b1$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $37b1586d517d42b1$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $37b1586d517d42b1$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $37b1586d517d42b1$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $37b1586d517d42b1$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $37b1586d517d42b1$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($37b1586d517d42b1$var$_ref8), " ", (0, $gln0L.mq).mobile($37b1586d517d42b1$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($37b1586d517d42b1$var$_ref6), ";", ""),
            title: $37b1586d517d42b1$var$_ref5,
            subtitle: $37b1586d517d42b1$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($37b1586d517d42b1$var$_ref3), ";", ""),
                form: $37b1586d517d42b1$var$_ref2,
                error: $37b1586d517d42b1$var$_ref
            }
        }
    });

});



parcelRegister("90Jf8", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2796052cc17c64e4$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2796052cc17c64e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2796052cc17c64e4$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $2796052cc17c64e4$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($2796052cc17c64e4$var$_ref), ";", "")
        }
    });

});


parcelRegister("96net", function(module, exports) {

$parcel$export(module.exports, "ReportViewReport", function () { return $4259f9d4e31a1587$export$970de5d4d05f74d2; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $K9dw6 = parcelRequire("K9dw6");
var $jMNnt = parcelRequire("jMNnt");
var $i9vCv = parcelRequire("i9vCv");
var $gLN5L = parcelRequire("gLN5L");
parcelRequire("cJvLm");
var $e9SYA = parcelRequire("e9SYA");
var $jAL4t = parcelRequire("jAL4t");
var $a0vy2 = parcelRequire("a0vy2");
var $10e6J = parcelRequire("10e6J");
var $2Vh5B = parcelRequire("2Vh5B");
var $iw5tW = parcelRequire("iw5tW");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("h9Hpf");
var $azVuX = parcelRequire("azVuX");
var $88YQa = parcelRequire("88YQa");

var $jFAzv = parcelRequire("jFAzv");
const $4259f9d4e31a1587$export$970de5d4d05f74d2 = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const report = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReport));
    const reportFetched = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportFetched));
    const reportEntityBlocked = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportEntityBlocked));
    const reportUserBlocked = (0, $gNvvs.useAppSelector)((0, $10e6J.reportSelectReportUserBlocked));
    const { shortId: shortId, entityType: entityType, entityId: entityId, entityUserId: entityUserId } = report ?? {};
    const isTrackReport = entityType === (0, $2gpGl.EntityReportEntityType).Track;
    const isPostReport = entityType === (0, $2gpGl.EntityReportEntityType).Post;
    const isCommentReport = entityType === (0, $2gpGl.EntityReportEntityType).Comment;
    // report user
    const { user: reportUser, isLoading: isReportUserLoading } = (0, $gLN5L.useUser)(entityUserId || "");
    // report track
    const { track: reportTrack, isLoading: isReportTrackLoading } = (0, $i9vCv.useTrack)(isTrackReport ? entityId || "" : "");
    // report post
    const { post: reportPost, isLoading: isReportPostLoading } = (0, $jMNnt.usePost)(isPostReport ? entityId || "" : "");
    // report comment
    const { comment: reportComment, isLoading: isReportCommentLoading } = (0, $K9dw6.useComment)(isCommentReport ? entityId || "" : "");
    const isUserControlsDisabled = isReportUserLoading || !reportUser || reportUserBlocked;
    const isTrackControlsDisabled = isReportTrackLoading || !reportTrack || reportEntityBlocked;
    const isPostControlsDisabled = isReportPostLoading || !reportPost || reportEntityBlocked;
    const isCommentControlsDisabled = isReportCommentLoading || !reportComment || reportEntityBlocked;
    // if report not found
    if (reportFetched && !report) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $jFAzv.styles)().view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).AlertTriangle,
            height: "119px",
            title: "Could not find report"
        })
    });
    const renderReportContentNavigation = ()=>{
        // if content type is track
        if (isTrackReport) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
            appearance: "neutral",
            label: "play track",
            icon: (0, $bq9l8.icons).PlayCircleBold,
            text: "Play track",
            disabled: isTrackControlsDisabled,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: reportTrack
                }))
        });
        // if content type is post
        if (isPostReport) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
            appearance: "neutral",
            label: "navigate to post page",
            icon: (0, $bq9l8.icons).Scope,
            text: "View post",
            disabled: isPostControlsDisabled,
            onClick: ()=>navigate(`${(0, $b7fnN.Path).Post}/${entityId}`)
        });
        // if content type is comment
        if (isCommentReport) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
            appearance: "neutral",
            label: "navigate to comment",
            icon: (0, $bq9l8.icons).Scope,
            text: "View comment",
            disabled: isCommentControlsDisabled,
            onClick: ()=>{
                // add comment to comment depth
                dispatch((0, $e9SYA.commentAddDepth)({
                    comment: reportComment
                }));
                // navigate to post page
                navigate(`${(0, $b7fnN.Path).Post}/${reportComment?.postId}`);
            }
        });
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {});
    };
    const renderReportContentBlockControl = ()=>{
        // if content type is track
        if (isTrackReport) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
            appearance: "negative",
            label: "block track",
            icon: (0, $bq9l8.icons).CrossSquare,
            text: "Block track",
            disabled: isTrackControlsDisabled,
            onClick: ()=>dispatch((0, $2Vh5B.trackOpenTrackBlockModal)({
                    track: reportTrack
                }))
        });
        // if content type is post
        if (isPostReport) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
            appearance: "negative",
            label: "block post",
            icon: (0, $bq9l8.icons).CrossSquare,
            text: "Block post",
            disabled: isPostControlsDisabled,
            onClick: ()=>dispatch((0, $a0vy2.postOpenPostBlockModal)({
                    post: reportPost
                }))
        });
        // if content type is comment
        if (isCommentReport) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
            appearance: "negative",
            label: "block comment",
            icon: (0, $bq9l8.icons).CrossSquare,
            text: "Block comment",
            disabled: isCommentControlsDisabled,
            onClick: ()=>dispatch((0, $e9SYA.commentOpenCommentBlockModal)({
                    comment: reportComment
                }))
        });
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {});
    };
    // if report found
    if (reportFetched && report) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $jFAzv.styles)().view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $jFAzv.styles)().view.content.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $jFAzv.styles)().view.content.identifier,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $88YQa.Identifier), {
                        identifier: shortId || ""
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $jFAzv.styles)().view.content.navigation,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
                            appearance: "neutral",
                            label: "navigate to user page",
                            icon: (0, $bq9l8.icons).UserCircle,
                            text: "View user",
                            disabled: isUserControlsDisabled,
                            onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${entityUserId}`)
                        }),
                        renderReportContentNavigation()
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $jFAzv.styles)().view.content.controls,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
                            appearance: "negative",
                            label: "block user",
                            icon: (0, $bq9l8.icons).CrossSquare,
                            text: "Block user",
                            disabled: isUserControlsDisabled,
                            onClick: ()=>dispatch((0, $iw5tW.userOpenUserBlockModal)({
                                    user: reportUser
                                }))
                        }),
                        renderReportContentBlockControl(),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $azVuX.Control), {
                            appearance: "positive",
                            label: "resolve report",
                            icon: (0, $bq9l8.icons).CheckSquare,
                            text: "Resolve report",
                            disabled: false,
                            onClick: ()=>dispatch((0, $10e6J.reportOpenReportResolveModal)({
                                    report: report
                                }))
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $jFAzv.styles)().view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "report-view-reports-report",
                    width: "100%",
                    height: "119px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$4259f9d4e31a1587$export$970de5d4d05f74d2.propTypes = {};

});
parcelRegister("h9Hpf", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return (parcelRequire("azVuX")).Control; });
$parcel$export(module.exports, "Identifier", function () { return (parcelRequire("88YQa")).Identifier; });

var $azVuX = parcelRequire("azVuX");

var $88YQa = parcelRequire("88YQa");

});
parcelRegister("azVuX", function(module, exports) {

$parcel$export(module.exports, "Control", function () { return $aa0aa03a146fd45b$export$7a7fa4424cb20976; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $fOvjx = parcelRequire("fOvjx");
const $aa0aa03a146fd45b$export$7a7fa4424cb20976 = ({ appearance: appearance = "neutral", label: label, icon: Icon, text: text, disabled: disabled, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fOvjx.styles)(theme).control.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
            css: [
                (0, $fOvjx.styles)(theme).control.content.main,
                appearance === "positive" && (0, $fOvjx.styles)(theme).control.content.positive,
                appearance === "negative" && (0, $fOvjx.styles)(theme).control.content.negative,
                appearance === "neutral" && (0, $fOvjx.styles)(theme).control.content.neutral,
                disabled && (0, $fOvjx.styles)(theme).control.content.disabled,
                "",
                ""
            ],
            onClick: (e)=>onClick(e),
            type: "button",
            "aria-label": label,
            disabled: disabled,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: [
                        (0, $fOvjx.styles)(theme).control.content.icon.main,
                        appearance === "positive" && (0, $fOvjx.styles)(theme).control.content.icon.positive,
                        appearance === "negative" && (0, $fOvjx.styles)(theme).control.content.icon.negative,
                        appearance === "neutral" && (0, $fOvjx.styles)(theme).control.content.icon.neutral,
                        disabled && (0, $fOvjx.styles)(theme).control.content.icon.disabled,
                        "",
                        ""
                    ],
                    children: /*#__PURE__*/ (0, $9awXB.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: [
                        (0, $fOvjx.styles)(theme).control.content.text.main,
                        appearance === "positive" && (0, $fOvjx.styles)(theme).control.content.text.positive,
                        appearance === "negative" && (0, $fOvjx.styles)(theme).control.content.text.negative,
                        appearance === "neutral" && (0, $fOvjx.styles)(theme).control.content.text.neutral,
                        disabled && (0, $fOvjx.styles)(theme).control.content.text.disabled,
                        "",
                        ""
                    ],
                    children: text
                })
            ]
        })
    });
};
$aa0aa03a146fd45b$export$7a7fa4424cb20976.propTypes = {};

});
parcelRegister("fOvjx", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $141f0029bd81e5eb$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $141f0029bd81e5eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $141f0029bd81e5eb$var$_ref = {
    name: "a8rt8v",
    styles: "display:flex;margin-right:10px;&>svg{width:22px;height:22px;}&>svg>path{transition:fill 0.2s;}"
};
var $141f0029bd81e5eb$var$_ref2 = {
    name: "zjik7",
    styles: "display:flex"
};
const $141f0029bd81e5eb$export$9dd6ff9ea0189349 = (theme)=>({
        control: {
            main: $141f0029bd81e5eb$var$_ref2,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;cursor:pointer;min-width:130px;", ""),
                positive: /*#__PURE__*/ (0, $7hler.css)("&:hover{&>div>svg>path{fill:", theme.colors.positive.dark, ";}&>div{color:", theme.colors.positive.dark, ";}}", ""),
                negative: /*#__PURE__*/ (0, $7hler.css)("&:hover{&>div>svg>path{fill:", theme.colors.negative.dark, ";}&>div{color:", theme.colors.negative.dark, ";}}", ""),
                neutral: /*#__PURE__*/ (0, $7hler.css)("&:hover{&>div>svg>path{fill:", theme.colors.accent.normal, ";}&>div{color:", theme.colors.accent.normal, ";}}", ""),
                disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&:hover{&>div>svg>path{fill:", theme.colors.secondary.dark, ";}&>div{color:", theme.colors.secondary.dark, ";}}", ""),
                icon: {
                    main: $141f0029bd81e5eb$var$_ref,
                    positive: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.positive.normal, ";}", ""),
                    negative: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.negative.normal, ";}", ""),
                    neutral: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.secondary.normal, ";}", ""),
                    disabled: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{fill:", theme.colors.secondary.dark, ";}", "")
                },
                text: {
                    main: /*#__PURE__*/ (0, $7hler.css)("white-space:nowrap;font-size:", (0, $gln0L.typography).p, ";text-decoration:underline;transition:color 0.2s;", ""),
                    positive: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.positive.normal, ";", ""),
                    negative: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.negative.normal, ";", ""),
                    neutral: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";", ""),
                    disabled: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.dark, ";", "")
                }
            }
        }
    });

});


parcelRegister("88YQa", function(module, exports) {

$parcel$export(module.exports, "Identifier", function () { return $cfe880e688036601$export$989167234458594d; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $1jA5j = parcelRequire("1jA5j");
const $cfe880e688036601$export$989167234458594d = ({ identifier: identifier })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1jA5j.styles)(theme).identifier.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $1jA5j.styles)(theme).identifier.id,
            children: `#${identifier}`
        })
    });
};
$cfe880e688036601$export$989167234458594d.propTypes = {};

});
parcelRegister("1jA5j", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $880606ea53992baa$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $880606ea53992baa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $880606ea53992baa$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
const $880606ea53992baa$export$9dd6ff9ea0189349 = (theme)=>({
        identifier: {
            main: $880606ea53992baa$var$_ref,
            id: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h5, ";color:", theme.colors.secondary.normal, ";", "")
        }
    });

});



parcelRegister("jFAzv", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9403361bba848dfd$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $9403361bba848dfd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9403361bba848dfd$var$_ref = {
    name: "x5sgny",
    styles: "flex-wrap:wrap;display:flex;&>div{margin-bottom:12px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $9403361bba848dfd$var$_ref2 = {
    name: "g3ivle",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:12px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $9403361bba848dfd$var$_ref3 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $9403361bba848dfd$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $9403361bba848dfd$var$_ref5 = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
const $9403361bba848dfd$export$9dd6ff9ea0189349 = ()=>({
        view: {
            main: $9403361bba848dfd$var$_ref5,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("&:not(:last-of-type){margin-bottom:10px;}", (0, $gln0L.mq).tablet($9403361bba848dfd$var$_ref4), ";", ""),
                identifier: $9403361bba848dfd$var$_ref3,
                navigation: $9403361bba848dfd$var$_ref2,
                controls: $9403361bba848dfd$var$_ref
            }
        }
    });

});



parcelRegister("10e6J", function(module, exports) {

$parcel$export(module.exports, "reportSlice", function () { return $ad70de5fed852ccc$export$5e255acad067a54e; });
$parcel$export(module.exports, "reportResetState", function () { return $ad70de5fed852ccc$export$4aa41af620e6db1f; });
$parcel$export(module.exports, "reportSetReports", function () { return $ad70de5fed852ccc$export$c6dc13d62ffde555; });
$parcel$export(module.exports, "reportSetReport", function () { return $ad70de5fed852ccc$export$807a3c817972ddf4; });
$parcel$export(module.exports, "reportSetReportEntityBlocked", function () { return $ad70de5fed852ccc$export$cfe0ec2b212f109e; });
$parcel$export(module.exports, "reportSetReportUserBlocked", function () { return $ad70de5fed852ccc$export$410f1fa2144476ba; });
$parcel$export(module.exports, "reportResetReport", function () { return $ad70de5fed852ccc$export$47e498ae1d1aa7b8; });
$parcel$export(module.exports, "reportFilterReport", function () { return $ad70de5fed852ccc$export$ecee843e7ecaaa33; });
$parcel$export(module.exports, "reportSetReportComplaints", function () { return $ad70de5fed852ccc$export$6c03dc9270f53f4a; });
$parcel$export(module.exports, "reportResetReportComplaints", function () { return $ad70de5fed852ccc$export$a30022f2b3e383f3; });
$parcel$export(module.exports, "reportSetReportComplaint", function () { return $ad70de5fed852ccc$export$2ed5726b4c4ec1f6; });
$parcel$export(module.exports, "reportResetReportComplaint", function () { return $ad70de5fed852ccc$export$d9d9f1dbb6bc6f52; });
$parcel$export(module.exports, "reportSetReportsFilter", function () { return $ad70de5fed852ccc$export$9113d04ca40739a9; });
$parcel$export(module.exports, "reportOpenReportCommentModal", function () { return $ad70de5fed852ccc$export$5107dc6e51fafca5; });
$parcel$export(module.exports, "reportCloseReportCommentModal", function () { return $ad70de5fed852ccc$export$d0bacaa8e5dd7178; });
$parcel$export(module.exports, "reportOpenReportPostModal", function () { return $ad70de5fed852ccc$export$917709ba97acadd3; });
$parcel$export(module.exports, "reportCloseReportPostModal", function () { return $ad70de5fed852ccc$export$91590c31a4ff5cac; });
$parcel$export(module.exports, "reportOpenReportTrackModal", function () { return $ad70de5fed852ccc$export$d78f822310fc4e7a; });
$parcel$export(module.exports, "reportCloseReportTrackModal", function () { return $ad70de5fed852ccc$export$160906f62c8a66e4; });
$parcel$export(module.exports, "reportOpenReportUserModal", function () { return $ad70de5fed852ccc$export$5d901314f70977e1; });
$parcel$export(module.exports, "reportCloseReportUserModal", function () { return $ad70de5fed852ccc$export$ee2aec68f4e7e51a; });
$parcel$export(module.exports, "reportOpenReportResolveModal", function () { return $ad70de5fed852ccc$export$bf2597e67ee8aec9; });
$parcel$export(module.exports, "reportCloseReportResolveModal", function () { return $ad70de5fed852ccc$export$5e2f470b9ce9dacf; });
$parcel$export(module.exports, "reportSelectReportCommentModalOpen", function () { return $ad70de5fed852ccc$export$d515dbd532d432c2; });
$parcel$export(module.exports, "reportSelectReportCommentModalComment", function () { return $ad70de5fed852ccc$export$720ee0b8715fd1c5; });
$parcel$export(module.exports, "reportSelectReportPostModalOpen", function () { return $ad70de5fed852ccc$export$4a0f866336d17858; });
$parcel$export(module.exports, "reportSelectReportPostModalPost", function () { return $ad70de5fed852ccc$export$90d708d3369e452a; });
$parcel$export(module.exports, "reportSelectReportTrackModalOpen", function () { return $ad70de5fed852ccc$export$2f88bbf212f26e07; });
$parcel$export(module.exports, "reportSelectReportTrackModalTrack", function () { return $ad70de5fed852ccc$export$52db069a822e66b9; });
$parcel$export(module.exports, "reportSelectReportUserModalOpen", function () { return $ad70de5fed852ccc$export$75185cb7f4ea21d8; });
$parcel$export(module.exports, "reportSelectReportUserModalUser", function () { return $ad70de5fed852ccc$export$3170ddea3395ccb5; });
$parcel$export(module.exports, "reportSelectReportResolveModalOpen", function () { return $ad70de5fed852ccc$export$b7a168a21193a4bf; });
$parcel$export(module.exports, "reportSelectReportResolveModalReport", function () { return $ad70de5fed852ccc$export$91163bf7aadb8d46; });
$parcel$export(module.exports, "reportSelectReports", function () { return $ad70de5fed852ccc$export$4a09dd8fa937d22; });
$parcel$export(module.exports, "reportSelectReportsLength", function () { return $ad70de5fed852ccc$export$12cce4392c74ecfe; });
$parcel$export(module.exports, "reportSelectReportsCount", function () { return $ad70de5fed852ccc$export$51bd18952516b6aa; });
$parcel$export(module.exports, "reportSelectReportsFetched", function () { return $ad70de5fed852ccc$export$290a4fe7e6503272; });
$parcel$export(module.exports, "reportSelectReport", function () { return $ad70de5fed852ccc$export$8831e1786fc175d8; });
$parcel$export(module.exports, "reportSelectReportFetched", function () { return $ad70de5fed852ccc$export$94ee103c3bfdff80; });
$parcel$export(module.exports, "reportSelectReportEntityBlocked", function () { return $ad70de5fed852ccc$export$6d231fdd5ff17f03; });
$parcel$export(module.exports, "reportSelectReportUserBlocked", function () { return $ad70de5fed852ccc$export$e05eb5c987aca6d6; });
$parcel$export(module.exports, "reportSelectReportComplaints", function () { return $ad70de5fed852ccc$export$52b27bfc3626b1ff; });
$parcel$export(module.exports, "reportSelectReportComplaintsLength", function () { return $ad70de5fed852ccc$export$3436f3ec4ac50328; });
$parcel$export(module.exports, "reportSelectReportComplaintsCount", function () { return $ad70de5fed852ccc$export$544fbed6aad5dbf3; });
$parcel$export(module.exports, "reportSelectReportComplaintsFetched", function () { return $ad70de5fed852ccc$export$3625a3ea92060238; });
$parcel$export(module.exports, "reportSelectReportComplaint", function () { return $ad70de5fed852ccc$export$2ccc54e674651766; });
$parcel$export(module.exports, "reportSelectReportComplaintFetched", function () { return $ad70de5fed852ccc$export$5dde5b9b2a0f562c; });
$parcel$export(module.exports, "reportSelectReportsFilter", function () { return $ad70de5fed852ccc$export$6259cc22ee5b3e43; });
$parcel$export(module.exports, "reportSelectReportCreateCommentReportComplaintLoading", function () { return $ad70de5fed852ccc$export$75d753259f095069; });
$parcel$export(module.exports, "reportSelectReportCreatePostReportComplaintLoading", function () { return $ad70de5fed852ccc$export$7a8ed540cd7a9abd; });
$parcel$export(module.exports, "reportSelectReportCreateTrackReportComplaintLoading", function () { return $ad70de5fed852ccc$export$5eaf42f513e024a4; });
$parcel$export(module.exports, "reportSelectReportCreateUserReportComplaintLoading", function () { return $ad70de5fed852ccc$export$77b66bf40e9ad71c; });
$parcel$export(module.exports, "reportSelectReportResolveReportLoading", function () { return $ad70de5fed852ccc$export$7e162aba720a43cd; });
$parcel$export(module.exports, "reportSelectReportGetReportsLoading", function () { return $ad70de5fed852ccc$export$a5aafbce27ddaa73; });
$parcel$export(module.exports, "reportSelectReportGetReportLoading", function () { return $ad70de5fed852ccc$export$4144046713ce64ec; });
$parcel$export(module.exports, "reportSelectReportGetReportComplaintsLoading", function () { return $ad70de5fed852ccc$export$1908d68a71fd2c32; });
$parcel$export(module.exports, "reportSelectReportGetReportComplaintLoading", function () { return $ad70de5fed852ccc$export$86fecb91d5a0764f; });
$parcel$export(module.exports, "reportReducer", function () { return $ad70de5fed852ccc$export$e6ea844ef27f6d3a; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $lxN7y = parcelRequire("lxN7y");
const $ad70de5fed852ccc$var$initialState = {
    reports: [],
    reportsCount: 0,
    reportsFetched: false,
    report: undefined,
    reportFetched: false,
    reportEntityBlocked: false,
    reportUserBlocked: false,
    reportComplaints: [],
    reportComplaintsCount: 0,
    reportComplaintsFetched: false,
    reportComplaint: undefined,
    reportComplaintFetched: false,
    reportsFilter: undefined,
    reportCommentModal: {
        comment: undefined,
        open: false
    },
    reportPostModal: {
        post: undefined,
        open: false
    },
    reportTrackModal: {
        track: undefined,
        open: false
    },
    reportUserModal: {
        user: undefined,
        open: false
    },
    reportResolveModal: {
        report: undefined,
        open: false
    },
    reportCreateCommentReportComplaintLoading: false,
    reportCreatePostReportComplaintLoading: false,
    reportCreateTrackReportComplaintLoading: false,
    reportCreateUserReportComplaintLoading: false,
    reportResolveReportLoading: false,
    reportGetReportsLoading: false,
    reportGetReportLoading: false,
    reportGetReportComplaintsLoading: false,
    reportGetReportComplaintLoading: false
};
const $ad70de5fed852ccc$export$5e255acad067a54e = (0, $kvj5V.createSlice)({
    name: "report",
    initialState: $ad70de5fed852ccc$var$initialState,
    reducers: {
        // reset state
        reportResetState: ()=>({
                reports: [],
                reportsCount: 0,
                reportsFetched: false,
                report: undefined,
                reportFetched: false,
                reportEntityBlocked: false,
                reportUserBlocked: false,
                reportComplaints: [],
                reportComplaintsCount: 0,
                reportComplaintsFetched: false,
                reportComplaint: undefined,
                reportComplaintFetched: false,
                reportsFilter: undefined,
                reportCommentModal: {
                    comment: undefined,
                    open: false
                },
                reportPostModal: {
                    post: undefined,
                    open: false
                },
                reportTrackModal: {
                    track: undefined,
                    open: false
                },
                reportUserModal: {
                    user: undefined,
                    open: false
                },
                reportResolveModal: {
                    report: undefined,
                    open: false
                },
                reportCreateCommentReportComplaintLoading: false,
                reportCreatePostReportComplaintLoading: false,
                reportCreateTrackReportComplaintLoading: false,
                reportCreateUserReportComplaintLoading: false,
                reportResolveReportLoading: false,
                reportGetReportsLoading: false,
                reportGetReportLoading: false,
                reportGetReportComplaintsLoading: false,
                reportGetReportComplaintLoading: false
            }),
        // set reports
        reportSetReports: (state, action)=>{
            const { reports: reports, count: count, offset: offset } = action.payload;
            // mutate count
            state.reportsCount = count;
            // mutate reports array
            state.reports = (0, $6Rkyy.mergeArraysAtIndex)(state.reports, reports, offset);
        },
        // set report
        reportSetReport: (state, action)=>{
            const { report: report } = action.payload;
            // update report state
            state.report = report;
        },
        // set report entity blocked
        reportSetReportEntityBlocked: (state)=>({
                ...state,
                reportEntityBlocked: true
            }),
        // set report user blocked
        reportSetReportUserBlocked: (state)=>({
                ...state,
                reportUserBlocked: true
            }),
        // reset report
        reportResetReport: (state)=>({
                ...state,
                report: undefined,
                reportFetched: false,
                reportEntityBlocked: false,
                reportUserBlocked: false
            }),
        // filter report
        reportFilterReport: (state, action)=>{
            const { id: id } = action.payload;
            // check if report exists in reports
            const index = state.reports.findIndex((r)=>r.id === id);
            if (index !== -1) {
                // filter report
                state.reports = state.reports.filter((r)=>r.id !== id);
                state.reportsCount -= 1;
            }
        },
        // set report complaints
        reportSetReportComplaints: (state, action)=>{
            const { reportComplaints: reportComplaints, count: count, offset: offset } = action.payload;
            // mutate count
            state.reportComplaintsCount = count;
            // mutate report complaints array
            state.reportComplaints = (0, $6Rkyy.mergeArraysAtIndex)(state.reportComplaints, reportComplaints, offset);
        },
        // reset report complaints
        reportResetReportComplaints: (state)=>({
                ...state,
                reportComplaints: [],
                reportComplaintsCount: 0,
                reportComplaintsFetched: false
            }),
        // set report complaint
        reportSetReportComplaint: (state, action)=>{
            const { reportComplaint: reportComplaint } = action.payload;
            // update report complaint state
            state.reportComplaint = reportComplaint;
        },
        // reset report complaint
        reportResetReportComplaint: (state)=>({
                ...state,
                reportComplaint: undefined,
                reportComplaintFetched: false
            }),
        // set reports filter
        reportSetReportsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup reports
            state.reports = [];
            state.reportsCount = 0;
            // cleanup report complaints
            state.reportComplaints = [];
            state.reportComplaintsCount = 0;
            // mutate reports filter
            state.reportsFilter = state.reportsFilter === filter ? undefined : filter;
        },
        // open report comment modal
        reportOpenReportCommentModal: (state, action)=>({
                ...state,
                reportCommentModal: {
                    comment: action.payload.comment,
                    open: true
                }
            }),
        // close report comment modal
        reportCloseReportCommentModal: (state)=>({
                ...state,
                reportCommentModal: {
                    comment: undefined,
                    open: false
                },
                error: ""
            }),
        // open report post modal
        reportOpenReportPostModal: (state, action)=>({
                ...state,
                reportPostModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close report post modal
        reportCloseReportPostModal: (state)=>({
                ...state,
                reportPostModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            }),
        // open report track modal
        reportOpenReportTrackModal: (state, action)=>({
                ...state,
                reportTrackModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close report track modal
        reportCloseReportTrackModal: (state)=>({
                ...state,
                reportTrackModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            }),
        // open report user modal
        reportOpenReportUserModal: (state, action)=>({
                ...state,
                reportUserModal: {
                    user: action.payload.user,
                    open: true
                }
            }),
        // close report user modal
        reportCloseReportUserModal: (state)=>({
                ...state,
                reportUserModal: {
                    user: undefined,
                    open: false
                },
                error: ""
            }),
        // open report resolve modal
        reportOpenReportResolveModal: (state, action)=>({
                ...state,
                reportResolveModal: {
                    report: action.payload.report,
                    open: true
                }
            }),
        // close report resolve modal
        reportCloseReportResolveModal: (state)=>({
                ...state,
                reportResolveModal: {
                    report: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // create comment report complaint
        builder.addCase((0, $lxN7y.reportCreateCommentReportComplaint).pending, (state)=>({
                ...state,
                reportCreateCommentReportComplaintLoading: true
            })).addCase((0, $lxN7y.reportCreateCommentReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreateCommentReportComplaintLoading: false
            }));
        // create post report complaint
        builder.addCase((0, $lxN7y.reportCreatePostReportComplaint).pending, (state)=>({
                ...state,
                reportCreatePostReportComplaintLoading: true
            })).addCase((0, $lxN7y.reportCreatePostReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreatePostReportComplaintLoading: false
            }));
        // create track report complaint
        builder.addCase((0, $lxN7y.reportCreateTrackReportComplaint).pending, (state)=>({
                ...state,
                reportCreateTrackReportComplaintLoading: true
            })).addCase((0, $lxN7y.reportCreateTrackReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreateTrackReportComplaintLoading: false
            }));
        // create user report complaint
        builder.addCase((0, $lxN7y.reportCreateUserReportComplaint).pending, (state)=>({
                ...state,
                reportCreateUserReportComplaintLoading: true
            })).addCase((0, $lxN7y.reportCreateUserReportComplaint).fulfilled, (state)=>({
                ...state,
                reportCreateUserReportComplaintLoading: false
            }));
        // resolve report
        builder.addCase((0, $lxN7y.reportResolveReport).pending, (state)=>({
                ...state,
                reportResolveReportLoading: true
            })).addCase((0, $lxN7y.reportResolveReport).fulfilled, (state)=>({
                ...state,
                reportResolveReportLoading: false
            }));
        // get reports
        builder.addCase((0, $lxN7y.reportGetReports).pending, (state)=>({
                ...state,
                reportGetReportsLoading: true
            })).addCase((0, $lxN7y.reportGetReports).fulfilled, (state)=>({
                ...state,
                reportsFetched: true,
                reportGetReportsLoading: false
            }));
        // get report
        builder.addCase((0, $lxN7y.reportGetReport).pending, (state)=>({
                ...state,
                reportGetReportLoading: true
            })).addCase((0, $lxN7y.reportGetReport).fulfilled, (state)=>({
                ...state,
                reportFetched: true,
                reportGetReportLoading: false
            }));
        // get report complaints
        builder.addCase((0, $lxN7y.reportGetReportComplaints).pending, (state)=>({
                ...state,
                reportGetReportComplaintsLoading: true
            })).addCase((0, $lxN7y.reportGetReportComplaints).fulfilled, (state)=>({
                ...state,
                reportComplaintsFetched: true,
                reportGetReportComplaintsLoading: false
            }));
        // get report complaint
        builder.addCase((0, $lxN7y.reportGetReportComplaint).pending, (state)=>({
                ...state,
                reportGetReportComplaintLoading: true
            })).addCase((0, $lxN7y.reportGetReportComplaint).fulfilled, (state)=>({
                ...state,
                reportComplaintFetched: true,
                reportGetReportComplaintLoading: false
            }));
    }
});
const { reportResetState: $ad70de5fed852ccc$export$4aa41af620e6db1f, reportSetReports: $ad70de5fed852ccc$export$c6dc13d62ffde555, reportSetReport: $ad70de5fed852ccc$export$807a3c817972ddf4, reportSetReportEntityBlocked: $ad70de5fed852ccc$export$cfe0ec2b212f109e, reportSetReportUserBlocked: $ad70de5fed852ccc$export$410f1fa2144476ba, reportResetReport: $ad70de5fed852ccc$export$47e498ae1d1aa7b8, reportFilterReport: $ad70de5fed852ccc$export$ecee843e7ecaaa33, reportSetReportComplaints: $ad70de5fed852ccc$export$6c03dc9270f53f4a, reportResetReportComplaints: $ad70de5fed852ccc$export$a30022f2b3e383f3, reportSetReportComplaint: $ad70de5fed852ccc$export$2ed5726b4c4ec1f6, reportResetReportComplaint: $ad70de5fed852ccc$export$d9d9f1dbb6bc6f52, reportSetReportsFilter: $ad70de5fed852ccc$export$9113d04ca40739a9, reportOpenReportCommentModal: $ad70de5fed852ccc$export$5107dc6e51fafca5, reportCloseReportCommentModal: $ad70de5fed852ccc$export$d0bacaa8e5dd7178, reportOpenReportPostModal: $ad70de5fed852ccc$export$917709ba97acadd3, reportCloseReportPostModal: $ad70de5fed852ccc$export$91590c31a4ff5cac, reportOpenReportTrackModal: $ad70de5fed852ccc$export$d78f822310fc4e7a, reportCloseReportTrackModal: $ad70de5fed852ccc$export$160906f62c8a66e4, reportOpenReportUserModal: $ad70de5fed852ccc$export$5d901314f70977e1, reportCloseReportUserModal: $ad70de5fed852ccc$export$ee2aec68f4e7e51a, reportOpenReportResolveModal: $ad70de5fed852ccc$export$bf2597e67ee8aec9, reportCloseReportResolveModal: $ad70de5fed852ccc$export$5e2f470b9ce9dacf } = $ad70de5fed852ccc$export$5e255acad067a54e.actions;
const $ad70de5fed852ccc$export$d515dbd532d432c2 = (state)=>state.report.reportCommentModal.open;
const $ad70de5fed852ccc$export$720ee0b8715fd1c5 = (state)=>state.report.reportCommentModal.comment;
const $ad70de5fed852ccc$export$4a0f866336d17858 = (state)=>state.report.reportPostModal.open;
const $ad70de5fed852ccc$export$90d708d3369e452a = (state)=>state.report.reportPostModal.post;
const $ad70de5fed852ccc$export$2f88bbf212f26e07 = (state)=>state.report.reportTrackModal.open;
const $ad70de5fed852ccc$export$52db069a822e66b9 = (state)=>state.report.reportTrackModal.track;
const $ad70de5fed852ccc$export$75185cb7f4ea21d8 = (state)=>state.report.reportUserModal.open;
const $ad70de5fed852ccc$export$3170ddea3395ccb5 = (state)=>state.report.reportUserModal.user;
const $ad70de5fed852ccc$export$b7a168a21193a4bf = (state)=>state.report.reportResolveModal.open;
const $ad70de5fed852ccc$export$91163bf7aadb8d46 = (state)=>state.report.reportResolveModal.report;
const $ad70de5fed852ccc$export$4a09dd8fa937d22 = (state)=>state.report.reports;
const $ad70de5fed852ccc$export$12cce4392c74ecfe = (state)=>state.report.reports.length;
const $ad70de5fed852ccc$export$51bd18952516b6aa = (state)=>state.report.reportsCount;
const $ad70de5fed852ccc$export$290a4fe7e6503272 = (state)=>state.report.reportsFetched;
const $ad70de5fed852ccc$export$8831e1786fc175d8 = (state)=>state.report.report;
const $ad70de5fed852ccc$export$94ee103c3bfdff80 = (state)=>state.report.reportFetched;
const $ad70de5fed852ccc$export$6d231fdd5ff17f03 = (state)=>state.report.reportEntityBlocked;
const $ad70de5fed852ccc$export$e05eb5c987aca6d6 = (state)=>state.report.reportUserBlocked;
const $ad70de5fed852ccc$export$52b27bfc3626b1ff = (state)=>state.report.reportComplaints;
const $ad70de5fed852ccc$export$3436f3ec4ac50328 = (state)=>state.report.reportComplaints.length;
const $ad70de5fed852ccc$export$544fbed6aad5dbf3 = (state)=>state.report.reportComplaintsCount;
const $ad70de5fed852ccc$export$3625a3ea92060238 = (state)=>state.report.reportComplaintsFetched;
const $ad70de5fed852ccc$export$2ccc54e674651766 = (state)=>state.report.reportComplaint;
const $ad70de5fed852ccc$export$5dde5b9b2a0f562c = (state)=>state.report.reportComplaintFetched;
const $ad70de5fed852ccc$export$6259cc22ee5b3e43 = (state)=>state.report.reportsFilter;
const $ad70de5fed852ccc$export$75d753259f095069 = (state)=>state.report.reportCreateCommentReportComplaintLoading;
const $ad70de5fed852ccc$export$7a8ed540cd7a9abd = (state)=>state.report.reportCreatePostReportComplaintLoading;
const $ad70de5fed852ccc$export$5eaf42f513e024a4 = (state)=>state.report.reportCreateTrackReportComplaintLoading;
const $ad70de5fed852ccc$export$77b66bf40e9ad71c = (state)=>state.report.reportCreateUserReportComplaintLoading;
const $ad70de5fed852ccc$export$7e162aba720a43cd = (state)=>state.report.reportResolveReportLoading;
const $ad70de5fed852ccc$export$a5aafbce27ddaa73 = (state)=>state.report.reportGetReportsLoading;
const $ad70de5fed852ccc$export$4144046713ce64ec = (state)=>state.report.reportGetReportLoading;
const $ad70de5fed852ccc$export$1908d68a71fd2c32 = (state)=>state.report.reportGetReportComplaintsLoading;
const $ad70de5fed852ccc$export$86fecb91d5a0764f = (state)=>state.report.reportGetReportComplaintLoading;
const $ad70de5fed852ccc$export$e6ea844ef27f6d3a = $ad70de5fed852ccc$export$5e255acad067a54e.reducer; // export default reportSlice.reducer

});

parcelRegister("lxN7y", function(module, exports) {

$parcel$export(module.exports, "reportCreateCommentReportComplaint", function () { return $37d6496655b75875$export$d7cbe26bb3456d9c; });
$parcel$export(module.exports, "reportCreatePostReportComplaint", function () { return $37d6496655b75875$export$a71a2ca9a47c6b47; });
$parcel$export(module.exports, "reportCreateTrackReportComplaint", function () { return $37d6496655b75875$export$438c0b3823841eb3; });
$parcel$export(module.exports, "reportCreateUserReportComplaint", function () { return $37d6496655b75875$export$e273bc5cd9838a29; });
$parcel$export(module.exports, "reportResolveReport", function () { return $37d6496655b75875$export$c95dddc860e71bdd; });
$parcel$export(module.exports, "reportGetReports", function () { return $37d6496655b75875$export$ba21c16ccea890ca; });
$parcel$export(module.exports, "reportGetReport", function () { return $37d6496655b75875$export$3eef964a162427f2; });
$parcel$export(module.exports, "reportGetReportComplaints", function () { return $37d6496655b75875$export$bbe2251e57213a83; });
$parcel$export(module.exports, "reportGetReportComplaint", function () { return $37d6496655b75875$export$6c28b1e798254737; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $10e6J = parcelRequire("10e6J");
/**
 * Perform type conversion of complaint type.
 *
 * Takes complaint type as a string and converts it to valid EntityReportComplaintType.
 *
 * @param {string} type - Complaint type.
 * @returns {EntityReportComplaintType} - Complaint type as valid EntityReportComplaintType.
 *
 * @example
 * // complaintType is EntityReportComplaintType.Copyright.
 * const complaintType = convertComplaintType('');
 * // complaintType is EntityReportComplaintType.Spam.
 * const complaintType = convertComplaintType('spam');
 */ const $37d6496655b75875$var$convertComplaintType = (type)=>{
    // convert complaint type
    let complaintType;
    switch(type){
        case (0, $2gpGl.EntityReportComplaintType).ChildAbuse.toString():
            complaintType = (0, $2gpGl.EntityReportComplaintType).ChildAbuse;
            break;
        case (0, $2gpGl.EntityReportComplaintType).Copyright.toString():
            complaintType = (0, $2gpGl.EntityReportComplaintType).Copyright;
            break;
        case (0, $2gpGl.EntityReportComplaintType).Fake.toString():
            complaintType = (0, $2gpGl.EntityReportComplaintType).Fake;
            break;
        case (0, $2gpGl.EntityReportComplaintType).Pornography.toString():
            complaintType = (0, $2gpGl.EntityReportComplaintType).Pornography;
            break;
        case (0, $2gpGl.EntityReportComplaintType).Spam.toString():
            complaintType = (0, $2gpGl.EntityReportComplaintType).Spam;
            break;
        case (0, $2gpGl.EntityReportComplaintType).Violence.toString():
            complaintType = (0, $2gpGl.EntityReportComplaintType).Violence;
            break;
        default:
            complaintType = (0, $2gpGl.EntityReportComplaintType).Copyright;
    }
    return complaintType;
};
const $37d6496655b75875$export$d7cbe26bb3456d9c = (0, $kvj5V.createAsyncThunk)("report/reportCreateCommentReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get comment from modal state
    const modalComment = getState().report.reportCommentModal.comment;
    const { id: commentId, userId: userId } = modalComment ?? {};
    // convert complaint type
    const complaintType = $37d6496655b75875$var$convertComplaintType(inp.complaintType);
    try {
        // create comment report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $2gpGl.EntityReportEntityType).Comment,
            entityId: commentId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report comment modal
        dispatch((0, $10e6J.reportCloseReportCommentModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$a71a2ca9a47c6b47 = (0, $kvj5V.createAsyncThunk)("report/reportCreatePostReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get post from modal state
    const modalPost = getState().report.reportPostModal.post;
    const { id: postId, userId: userId } = modalPost ?? {};
    // convert complaint type
    const complaintType = $37d6496655b75875$var$convertComplaintType(inp.complaintType);
    try {
        // create post report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $2gpGl.EntityReportEntityType).Post,
            entityId: postId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report post modal
        dispatch((0, $10e6J.reportCloseReportPostModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$438c0b3823841eb3 = (0, $kvj5V.createAsyncThunk)("report/reportCreateTrackReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get track from modal state
    const modalTrack = getState().report.reportTrackModal.track;
    const { id: trackId, userId: userId } = modalTrack ?? {};
    // convert complaint type
    const complaintType = $37d6496655b75875$var$convertComplaintType(inp.complaintType);
    try {
        // create track report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $2gpGl.EntityReportEntityType).Track,
            entityId: trackId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report track modal
        dispatch((0, $10e6J.reportCloseReportTrackModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$e273bc5cd9838a29 = (0, $kvj5V.createAsyncThunk)("report/reportCreateUserReportComplaint", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get user from modal state
    const modalUser = getState().report.reportUserModal.user;
    const { id: userId } = modalUser ?? {};
    // convert complaint type
    const complaintType = $37d6496655b75875$var$convertComplaintType(inp.complaintType);
    try {
        // create user report complaint
        await api.reportApi.createReportComplaint({
            entityType: (0, $2gpGl.EntityReportEntityType).User,
            entityId: userId || "",
            entityUserId: userId || "",
            complaintType: complaintType,
            complaint: inp.complaint
        });
        // close report user modal
        dispatch((0, $10e6J.reportCloseReportUserModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully created complaint!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create complaint: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$c95dddc860e71bdd = (0, $kvj5V.createAsyncThunk)("report/reportResolveReport", async ({ reportId: reportId, cb: cb }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // resolve report
        await api.reportApi.resolveReport({
            reportId: reportId
        });
        // close report resolve modal
        dispatch((0, $10e6J.reportCloseReportResolveModal)());
        // filter resolved report
        dispatch((0, $10e6J.reportFilterReport)({
            id: reportId
        }));
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully resolved report!"
            }
        }));
        // if callback provided
        if (cb) cb();
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to resolve report: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$ba21c16ccea890ca = (0, $kvj5V.createAsyncThunk)("report/reportGetReports", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get reports filter
    const filter = getState().report.reportsFilter;
    // define entity type
    let entityType;
    // assert entity type
    switch(filter){
        case (0, $2gpGl.EntityReportEntityType).Comment:
            entityType = "comment";
            break;
        case (0, $2gpGl.EntityReportEntityType).Post:
            entityType = "post";
            break;
        case (0, $2gpGl.EntityReportEntityType).Track:
            entityType = "track";
            break;
        case (0, $2gpGl.EntityReportEntityType).User:
            entityType = "user";
            break;
        default:
            entityType = undefined;
    }
    try {
        // retrieve reports
        const { reports: reports, count: count } = await api.reportApi.getReports(entityType, inp.limit, inp.offset, inp.search);
        // set reports
        dispatch((0, $10e6J.reportSetReports)({
            reports: reports || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$3eef964a162427f2 = (0, $kvj5V.createAsyncThunk)("report/reportGetReport", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve report
        const { report: report } = await api.reportApi.getReport(inp.reportId);
        // set report
        dispatch((0, $10e6J.reportSetReport)({
            report: report || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$bbe2251e57213a83 = (0, $kvj5V.createAsyncThunk)("report/reportGetReportComplaints", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve reports
        const { reportComplaints: reportComplaints, count: count } = await api.reportApi.getReportComplaints(inp.reportId, inp.limit, inp.offset, inp.search);
        // set reports
        dispatch((0, $10e6J.reportSetReportComplaints)({
            reportComplaints: reportComplaints || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $37d6496655b75875$export$6c28b1e798254737 = (0, $kvj5V.createAsyncThunk)("report/reportGetReportComplaint", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve report
        const { reportComplaint: reportComplaint } = await api.reportApi.getReportComplaint(inp.reportComplaintId);
        // set report
        dispatch((0, $10e6J.reportSetReportComplaint)({
            reportComplaint: reportComplaint || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("3wAMG", function(module, exports) {

var $vfCFh = parcelRequire("vfCFh");
$parcel$exportWildcard(module.exports, $vfCFh);

});
parcelRegister("vfCFh", function(module, exports) {

$parcel$export(module.exports, "searchSlice", function () { return $907220d82ab7803e$export$6bc4144c8fcccf9; });
$parcel$export(module.exports, "searchSetTerm", function () { return $907220d82ab7803e$export$e05a1876652a1058; });
$parcel$export(module.exports, "searchResetState", function () { return $907220d82ab7803e$export$f07edb5646340b7; });
$parcel$export(module.exports, "searchSelectTerm", function () { return $907220d82ab7803e$export$4b988c5dcde9bbbe; });
$parcel$export(module.exports, "searchReducer", function () { return $907220d82ab7803e$export$2b7921d28693b007; });

var $kvj5V = parcelRequire("kvj5V");
const $907220d82ab7803e$var$initialState = {
    term: ""
};
const $907220d82ab7803e$export$6bc4144c8fcccf9 = (0, $kvj5V.createSlice)({
    name: "search",
    initialState: $907220d82ab7803e$var$initialState,
    reducers: {
        searchSetTerm: (state, action)=>({
                ...state,
                term: action.payload
            }),
        searchResetState: (state)=>({
                ...state,
                term: ""
            })
    }
});
const { searchSetTerm: $907220d82ab7803e$export$e05a1876652a1058, searchResetState: $907220d82ab7803e$export$f07edb5646340b7 } = $907220d82ab7803e$export$6bc4144c8fcccf9.actions;
const $907220d82ab7803e$export$4b988c5dcde9bbbe = (state)=>state.search.term;
const $907220d82ab7803e$export$2b7921d28693b007 = $907220d82ab7803e$export$6bc4144c8fcccf9.reducer; // export default searchSlice.reducer

});


parcelRegister("034CO", function(module, exports) {
// export {} from './components'

var $3QMY9 = parcelRequire("3QMY9");

var $8NOJ0 = parcelRequire("8NOJ0");
$parcel$exportWildcard(module.exports, $3QMY9);
$parcel$exportWildcard(module.exports, $8NOJ0);

});
parcelRegister("3QMY9", function(module, exports) {

$parcel$export(module.exports, "streamSlice", function () { return $8da9ae7ea28930ab$export$a2c41b2c787127e9; });
$parcel$export(module.exports, "streamResetState", function () { return $8da9ae7ea28930ab$export$f0ef31d06d0835e7; });
$parcel$export(module.exports, "streamSelectStreamCreatePostStreamLoading", function () { return $8da9ae7ea28930ab$export$ac9d46d1ec0de990; });
$parcel$export(module.exports, "streamSelectStreamCreateTrackStreamLoading", function () { return $8da9ae7ea28930ab$export$6fa328fda71219db; });
$parcel$export(module.exports, "streamReducer", function () { return $8da9ae7ea28930ab$export$17d4a5761ee36301; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $8NOJ0 = parcelRequire("8NOJ0");
const $8da9ae7ea28930ab$var$initialState = {
    streamCreatePostStreamLoading: false,
    streamCreateTrackStreamLoading: false
};
const $8da9ae7ea28930ab$export$a2c41b2c787127e9 = (0, $kvj5V.createSlice)({
    name: "stream",
    initialState: $8da9ae7ea28930ab$var$initialState,
    reducers: {
        // reset state
        streamResetState: ()=>({
                streamCreatePostStreamLoading: false,
                streamCreateTrackStreamLoading: false
            })
    },
    extraReducers: (builder)=>{
        // create post stream
        builder.addCase((0, $8NOJ0.streamCreatePostStream).pending, (state)=>({
                ...state,
                streamCreatePostStreamLoading: true
            })).addCase((0, $8NOJ0.streamCreatePostStream).fulfilled, (state)=>({
                ...state,
                streamCreatePostStreamLoading: false
            }));
        // create track stream
        builder.addCase((0, $8NOJ0.streamCreateTrackStream).pending, (state)=>({
                ...state,
                streamCreateTrackStreamLoading: true
            })).addCase((0, $8NOJ0.streamCreateTrackStream).fulfilled, (state)=>({
                ...state,
                streamCreateTrackStreamLoading: false
            }));
    }
});
const { streamResetState: $8da9ae7ea28930ab$export$f0ef31d06d0835e7 } = $8da9ae7ea28930ab$export$a2c41b2c787127e9.actions;
const $8da9ae7ea28930ab$export$ac9d46d1ec0de990 = (state)=>state.stream.streamCreatePostStreamLoading;
const $8da9ae7ea28930ab$export$6fa328fda71219db = (state)=>state.stream.streamCreateTrackStreamLoading;
const $8da9ae7ea28930ab$export$17d4a5761ee36301 = $8da9ae7ea28930ab$export$a2c41b2c787127e9.reducer; // export default streamSlice.reducer

});

parcelRegister("8NOJ0", function(module, exports) {

$parcel$export(module.exports, "streamCreatePostStream", function () { return $72a3f4c6786398d6$export$c874df20ecacc37a; });
$parcel$export(module.exports, "streamCreateTrackStream", function () { return $72a3f4c6786398d6$export$1fe7e6225fc134d2; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
const $72a3f4c6786398d6$export$c874df20ecacc37a = (0, $kvj5V.createAsyncThunk)("stream/streamCreatePostStream", async ({ post: post })=>{
    const { id: postId } = post;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create post stream
        await api.streamApi.createPostStream({
            postId: postId || ""
        });
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $72a3f4c6786398d6$export$1fe7e6225fc134d2 = (0, $kvj5V.createAsyncThunk)("stream/streamCreateTrackStream", async ({ track: track })=>{
    const { id: trackId } = track;
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create track stream
        await api.streamApi.createTrackStream({
            trackId: trackId || ""
        });
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("kdViD", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelModal", function () { return (parcelRequire("dPfHY")).SubscriptionCancelModal; });
$parcel$export(module.exports, "SubscriptionCreateModal", function () { return (parcelRequire("719fy")).SubscriptionCreateModal; });
$parcel$export(module.exports, "SubscriptionRenewModal", function () { return (parcelRequire("5MbvJ")).SubscriptionRenewModal; });
parcelRequire("clynE");
var $dPfHY = parcelRequire("dPfHY");
var $719fy = parcelRequire("719fy");
var $5MbvJ = parcelRequire("5MbvJ");

var $l5cm3 = parcelRequire("l5cm3");

var $aC3hJ = parcelRequire("aC3hJ");
$parcel$exportWildcard(module.exports, $l5cm3);
$parcel$exportWildcard(module.exports, $aC3hJ);

});
parcelRegister("clynE", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelModal", function () { return (parcelRequire("dPfHY")).SubscriptionCancelModal; });
$parcel$export(module.exports, "SubscriptionCreateModal", function () { return (parcelRequire("719fy")).SubscriptionCreateModal; });
$parcel$export(module.exports, "SubscriptionRenewModal", function () { return (parcelRequire("5MbvJ")).SubscriptionRenewModal; });

var $dPfHY = parcelRequire("dPfHY");

var $719fy = parcelRequire("719fy");

var $5MbvJ = parcelRequire("5MbvJ");

});
parcelRegister("dPfHY", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelModal", function () { return $60a3591b7c377667$export$5a67fdbe08953bb5; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("jgxpn");
var $lFodK = parcelRequire("lFodK");

var $1Kjgt = parcelRequire("1Kjgt");
const $60a3591b7c377667$export$5a67fdbe08953bb5 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const subscriptionCancelModalOpen = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCancelModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1Kjgt.styles)().modal.main,
        children: subscriptionCancelModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $l5cm3.subscriptionCloseSubscriptionCancelModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1Kjgt.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $lFodK.SubscriptionCancelCard), {})
            })
        })
    });
};
$60a3591b7c377667$export$5a67fdbe08953bb5.propTypes = {};

});
parcelRegister("jgxpn", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelCard", function () { return (parcelRequire("lFodK")).SubscriptionCancelCard; });

var $lFodK = parcelRequire("lFodK");

});
parcelRegister("lFodK", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelCard", function () { return $083e9b033ccdc530$export$4ceaf13b857fed04; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("igBZC");
var $2XUr4 = parcelRequire("2XUr4");

var $8DQTy = parcelRequire("8DQTy");
const $083e9b033ccdc530$export$4ceaf13b857fed04 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCancelModalArtist));
    const subscriptionError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 160;
    const subtitleAccentEndIndex = 161 + (username?.length || 0);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $8DQTy.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8DQTy.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $l5cm3.subscriptionCloseSubscriptionCancelModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8DQTy.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Unsubscribe",
                    icon: (0, $bq9l8.icons).Lock
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $8DQTy.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: `Your subscription isn't just access, it's an investment in a world of exclusive content curated just for you. Are you sure you want to cancel subscription to - @${username}?`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $8DQTy.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8DQTy.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2XUr4.SubscriptionCancelForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $8DQTy.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: subscriptionError
                        })
                    })
                ]
            })
        ]
    });
};
$083e9b033ccdc530$export$4ceaf13b857fed04.propTypes = {};

});
parcelRegister("igBZC", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelForm", function () { return (parcelRequire("2XUr4")).SubscriptionCancelForm; });

var $2XUr4 = parcelRequire("2XUr4");

});
parcelRegister("2XUr4", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCancelForm", function () { return $315ef684b866e8d1$export$cb7aa5e79cb4b785; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $f1KST = parcelRequire("f1KST");
var $9HBOX = parcelRequire("9HBOX");
var $aC3hJ = parcelRequire("aC3hJ");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $1CADW = parcelRequire("1CADW");
const $315ef684b866e8d1$export$cb7aa5e79cb4b785 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const subscriptionCancelLoading = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCancelSubscriptionLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCancelModalArtist));
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUser = profileUserId === artistUserId;
    const submitDisabled = isCurrentUser || subscriptionCancelLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1CADW.styles)(theme).form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $1CADW.styles)(theme).form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $aC3hJ.subscriptionCancelSubscription)());
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $1CADW.styles)(theme).form.content.product,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f1KST.ArtistCardProduct), {
                        artist: modalArtist || {},
                        onNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`),
                        onUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`)
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $1CADW.styles)(theme).form.content.description.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1CADW.styles)(theme).form.content.description.text,
                        children: "If you cancel your subscription, you will still have access to the content until the end of the current subscription period."
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $1CADW.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "unsubscribe",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: subscriptionCancelLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Unsubscribe`
                    })
                })
            ]
        })
    });
};
$315ef684b866e8d1$export$cb7aa5e79cb4b785.propTypes = {};

});
parcelRegister("1CADW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7d65b281305d1207$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $7d65b281305d1207$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7d65b281305d1207$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $7d65b281305d1207$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                product: $7d65b281305d1207$var$_ref,
                description: {
                    main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";margin-bottom:24px;", ""),
                    text: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    accent: /*#__PURE__*/ (0, $7hler.css)("font-weight:bold;color:", theme.colors.accent.normal, ";", "")
                },
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("8DQTy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $dcb162ce9ad10269$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $dcb162ce9ad10269$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $dcb162ce9ad10269$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $dcb162ce9ad10269$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $dcb162ce9ad10269$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $dcb162ce9ad10269$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $dcb162ce9ad10269$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $dcb162ce9ad10269$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $dcb162ce9ad10269$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $dcb162ce9ad10269$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $dcb162ce9ad10269$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($dcb162ce9ad10269$var$_ref8), " ", (0, $gln0L.mq).mobile($dcb162ce9ad10269$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($dcb162ce9ad10269$var$_ref6), ";", ""),
            title: $dcb162ce9ad10269$var$_ref5,
            subtitle: $dcb162ce9ad10269$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($dcb162ce9ad10269$var$_ref3), ";", ""),
                form: $dcb162ce9ad10269$var$_ref2,
                error: $dcb162ce9ad10269$var$_ref
            }
        }
    });

});



parcelRegister("1Kjgt", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1db933b23b0465a8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $1db933b23b0465a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1db933b23b0465a8$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $1db933b23b0465a8$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($1db933b23b0465a8$var$_ref), ";", "")
        }
    });

});


parcelRegister("719fy", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateModal", function () { return $46ff957b14edfcc2$export$c78fcad8bc8f9efc; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("04emq");
var $hI9bx = parcelRequire("hI9bx");

var $gNUsc = parcelRequire("gNUsc");
const $46ff957b14edfcc2$export$c78fcad8bc8f9efc = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const subscriptionCreateModalOpen = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCreateModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gNUsc.styles)().modal.main,
        children: subscriptionCreateModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $l5cm3.subscriptionCloseSubscriptionCreateModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gNUsc.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $hI9bx.SubscriptionCreateCard), {})
            })
        })
    });
};
$46ff957b14edfcc2$export$c78fcad8bc8f9efc.propTypes = {};

});
parcelRegister("04emq", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateCard", function () { return (parcelRequire("hI9bx")).SubscriptionCreateCard; });

var $hI9bx = parcelRequire("hI9bx");

});
parcelRegister("hI9bx", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateCard", function () { return $9743b54a0c5312ec$export$71949997866b8f3d; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("87aGx");
var $hHAIB = parcelRequire("hHAIB");

var $lLLXL = parcelRequire("lLLXL");
const $9743b54a0c5312ec$export$71949997866b8f3d = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCreateModalArtist));
    const subscriptionError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 54;
    const subtitleAccentEndIndex = 55 + (username?.length || 0);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $lLLXL.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lLLXL.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $l5cm3.subscriptionCloseSubscriptionCreateModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lLLXL.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Subscribe",
                    icon: (0, $bq9l8.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $lLLXL.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: `Unlock a world of exclusive content by subscribing to @${username}!`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $lLLXL.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lLLXL.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $hHAIB.SubscriptionCreateForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $lLLXL.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: subscriptionError
                        })
                    })
                ]
            })
        ]
    });
};
$9743b54a0c5312ec$export$71949997866b8f3d.propTypes = {};

});
parcelRegister("87aGx", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateForm", function () { return (parcelRequire("hHAIB")).SubscriptionCreateForm; });

var $hHAIB = parcelRequire("hHAIB");

});
parcelRegister("hHAIB", function(module, exports) {

$parcel$export(module.exports, "SubscriptionCreateForm", function () { return $2bfe6d082fff7331$export$9ac0eaa010320de1; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $lqGW0 = parcelRequire("lqGW0");
parcelRequire("cJvLm");
var $f1KST = parcelRequire("f1KST");
var $9HBOX = parcelRequire("9HBOX");
var $aC3hJ = parcelRequire("aC3hJ");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $42FT1 = parcelRequire("42FT1");
const $2bfe6d082fff7331$export$9ac0eaa010320de1 = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const subscriptionCreateLoading = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCreateSubscriptionLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionCreateModalArtist));
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUser = profileUserId === artistUserId;
    const submitDisabled = isCurrentUser || subscriptionCreateLoading;
    // subscription price
    const { subscriptionPrice: artistSubscriptionPrice, isLoading: isArtistSubscriptionPriceLoading } = (0, $lqGW0.useSubscriptionPrice)(artistUserId || "");
    const artistSubscriptionPriceLoadingPlaceholder = "Loading...";
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $42FT1.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $42FT1.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $aC3hJ.subscriptionCreateSubscription)());
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $42FT1.styles)().form.content.product,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f1KST.ArtistCardProduct), {
                        artist: modalArtist || {},
                        onNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`),
                        onUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`)
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $42FT1.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "subscribe",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: subscriptionCreateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Subscribe for $${isArtistSubscriptionPriceLoading ? artistSubscriptionPriceLoadingPlaceholder : artistSubscriptionPrice && artistSubscriptionPrice / 100}`
                    })
                })
            ]
        })
    });
};
$2bfe6d082fff7331$export$9ac0eaa010320de1.propTypes = {};

});
parcelRegister("42FT1", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f21dfdbba437ab12$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $f21dfdbba437ab12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f21dfdbba437ab12$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $f21dfdbba437ab12$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                product: $f21dfdbba437ab12$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("lLLXL", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $53ceca262a14d4dd$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $53ceca262a14d4dd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $53ceca262a14d4dd$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $53ceca262a14d4dd$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $53ceca262a14d4dd$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $53ceca262a14d4dd$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $53ceca262a14d4dd$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $53ceca262a14d4dd$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $53ceca262a14d4dd$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $53ceca262a14d4dd$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $53ceca262a14d4dd$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($53ceca262a14d4dd$var$_ref8), " ", (0, $gln0L.mq).mobile($53ceca262a14d4dd$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($53ceca262a14d4dd$var$_ref6), ";", ""),
            title: $53ceca262a14d4dd$var$_ref5,
            subtitle: $53ceca262a14d4dd$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($53ceca262a14d4dd$var$_ref3), ";", ""),
                form: $53ceca262a14d4dd$var$_ref2,
                error: $53ceca262a14d4dd$var$_ref
            }
        }
    });

});



parcelRegister("gNUsc", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $954d53114dc13669$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $954d53114dc13669$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $954d53114dc13669$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $954d53114dc13669$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($954d53114dc13669$var$_ref), ";", "")
        }
    });

});


parcelRegister("5MbvJ", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewModal", function () { return $3de91cd294d9035e$export$8a555acc32002531; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("hxdwh");
var $vibAl = parcelRequire("vibAl");

var $3y6Cr = parcelRequire("3y6Cr");
const $3de91cd294d9035e$export$8a555acc32002531 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const subscriptionRenewModalOpen = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionRenewModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $3y6Cr.styles)().modal.main,
        children: subscriptionRenewModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $l5cm3.subscriptionCloseSubscriptionRenewModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3y6Cr.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $vibAl.SubscriptionRenewCard), {})
            })
        })
    });
};
$3de91cd294d9035e$export$8a555acc32002531.propTypes = {};

});
parcelRegister("hxdwh", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewCard", function () { return (parcelRequire("vibAl")).SubscriptionRenewCard; });

var $vibAl = parcelRequire("vibAl");

});
parcelRegister("vibAl", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewCard", function () { return $b569c4f5cd6110ed$export$aa8da0a6b807e932; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("ciHcd");
var $5Lvso = parcelRequire("5Lvso");

var $dqD4H = parcelRequire("dqD4H");
const $b569c4f5cd6110ed$export$aa8da0a6b807e932 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionRenewModalArtist));
    const subscriptionError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 54;
    const subtitleAccentEndIndex = 55 + (username?.length || 0);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dqD4H.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dqD4H.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $l5cm3.subscriptionCloseSubscriptionRenewModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dqD4H.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Subscribe",
                    icon: (0, $bq9l8.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dqD4H.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: `Unlock a world of exclusive content by subscribing to @${username}!`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $dqD4H.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dqD4H.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $5Lvso.SubscriptionRenewForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dqD4H.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: subscriptionError
                        })
                    })
                ]
            })
        ]
    });
};
$b569c4f5cd6110ed$export$aa8da0a6b807e932.propTypes = {};

});
parcelRegister("ciHcd", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewForm", function () { return (parcelRequire("5Lvso")).SubscriptionRenewForm; });

var $5Lvso = parcelRequire("5Lvso");

});
parcelRegister("5Lvso", function(module, exports) {

$parcel$export(module.exports, "SubscriptionRenewForm", function () { return $25b76610090c9518$export$dc7bf3d983f09351; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $lqGW0 = parcelRequire("lqGW0");
parcelRequire("cJvLm");
var $f1KST = parcelRequire("f1KST");
var $9HBOX = parcelRequire("9HBOX");
var $aC3hJ = parcelRequire("aC3hJ");
var $l5cm3 = parcelRequire("l5cm3");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $h8lFO = parcelRequire("h8lFO");
const $25b76610090c9518$export$dc7bf3d983f09351 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const subscriptionRenewLoading = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionRenewSubscriptionLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectSubscriptionRenewModalArtist));
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUser = profileUserId === artistUserId;
    const submitDisabled = isCurrentUser || subscriptionRenewLoading;
    // subscription price
    const { subscriptionPrice: artistSubscriptionPrice, isLoading: isArtistSubscriptionPriceLoading } = (0, $lqGW0.useSubscriptionPrice)(artistUserId || "");
    const artistSubscriptionPriceLoadingPlaceholder = "Loading...";
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $h8lFO.styles)(theme).form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $h8lFO.styles)(theme).form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $aC3hJ.subscriptionRenewSubscription)());
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $h8lFO.styles)(theme).form.content.product,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f1KST.ArtistCardProduct), {
                        artist: modalArtist || {},
                        onNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`),
                        onUsernameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`)
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $h8lFO.styles)(theme).form.content.description.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $h8lFO.styles)(theme).form.content.description.text,
                        children: "When you renew your subscription, you will be charged at the end of the current subscription period."
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $h8lFO.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "subscribe",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: subscriptionRenewLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Renew subscription for $${isArtistSubscriptionPriceLoading ? artistSubscriptionPriceLoadingPlaceholder : artistSubscriptionPrice && artistSubscriptionPrice / 100}`
                    })
                })
            ]
        })
    });
};
$25b76610090c9518$export$dc7bf3d983f09351.propTypes = {};

});
parcelRegister("h8lFO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0262b46e74a0a7d8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $0262b46e74a0a7d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0262b46e74a0a7d8$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $0262b46e74a0a7d8$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                product: $0262b46e74a0a7d8$var$_ref,
                description: {
                    main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";margin-bottom:24px;", ""),
                    text: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    accent: /*#__PURE__*/ (0, $7hler.css)("font-weight:bold;color:", theme.colors.accent.normal, ";", "")
                },
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("dqD4H", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1d739a7949aa05e6$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $1d739a7949aa05e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1d739a7949aa05e6$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $1d739a7949aa05e6$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $1d739a7949aa05e6$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $1d739a7949aa05e6$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $1d739a7949aa05e6$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $1d739a7949aa05e6$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $1d739a7949aa05e6$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $1d739a7949aa05e6$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $1d739a7949aa05e6$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($1d739a7949aa05e6$var$_ref8), " ", (0, $gln0L.mq).mobile($1d739a7949aa05e6$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($1d739a7949aa05e6$var$_ref6), ";", ""),
            title: $1d739a7949aa05e6$var$_ref5,
            subtitle: $1d739a7949aa05e6$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($1d739a7949aa05e6$var$_ref3), ";", ""),
                form: $1d739a7949aa05e6$var$_ref2,
                error: $1d739a7949aa05e6$var$_ref
            }
        }
    });

});



parcelRegister("3y6Cr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1b08bdfcfa6753b7$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $1b08bdfcfa6753b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1b08bdfcfa6753b7$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $1b08bdfcfa6753b7$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($1b08bdfcfa6753b7$var$_ref), ";", "")
        }
    });

});



parcelRegister("l5cm3", function(module, exports) {

$parcel$export(module.exports, "subscriptionSlice", function () { return $ab6d8e4c47772b14$export$ace45a1139be3d5f; });
$parcel$export(module.exports, "subscriptionResetState", function () { return $ab6d8e4c47772b14$export$c6562e8445940d44; });
$parcel$export(module.exports, "subscriptionSetUserSubscriptions", function () { return $ab6d8e4c47772b14$export$be2dfb7f082907ba; });
$parcel$export(module.exports, "subscriptionAddUserSubscription", function () { return $ab6d8e4c47772b14$export$1b658aed8e1f365d; });
$parcel$export(module.exports, "subscriptionRemoveUserSubscription", function () { return $ab6d8e4c47772b14$export$746b64992b0ece49; });
$parcel$export(module.exports, "subscriptionSetUserSubscriptionsAtPeriodEnd", function () { return $ab6d8e4c47772b14$export$896133c746b42699; });
$parcel$export(module.exports, "subscriptionAddUserSubscriptionAtPeriodEnd", function () { return $ab6d8e4c47772b14$export$24dda4823d975610; });
$parcel$export(module.exports, "subscriptionRemoveUserSubscriptionAtPeriodEnd", function () { return $ab6d8e4c47772b14$export$2a9e53329c48b691; });
$parcel$export(module.exports, "subscriptionOpenSubscriptionCreateModal", function () { return $ab6d8e4c47772b14$export$b16abe21e1f36a60; });
$parcel$export(module.exports, "subscriptionCloseSubscriptionCreateModal", function () { return $ab6d8e4c47772b14$export$e9854fd0d09c5426; });
$parcel$export(module.exports, "subscriptionOpenSubscriptionRenewModal", function () { return $ab6d8e4c47772b14$export$85d65c2bf3e9683f; });
$parcel$export(module.exports, "subscriptionCloseSubscriptionRenewModal", function () { return $ab6d8e4c47772b14$export$70ae45590bebb868; });
$parcel$export(module.exports, "subscriptionOpenSubscriptionCancelModal", function () { return $ab6d8e4c47772b14$export$8fd060939331f66e; });
$parcel$export(module.exports, "subscriptionCloseSubscriptionCancelModal", function () { return $ab6d8e4c47772b14$export$5bcaf9cef8723720; });
$parcel$export(module.exports, "subscriptionSelectUserSubscriptions", function () { return $ab6d8e4c47772b14$export$bd426abebc2f2046; });
$parcel$export(module.exports, "subscriptionSelectUserSubscriptionsAtPeriodEnd", function () { return $ab6d8e4c47772b14$export$f1f864a83a1bcd87; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCreateModalOpen", function () { return $ab6d8e4c47772b14$export$6fbda4ca77fe2914; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCreateModalArtist", function () { return $ab6d8e4c47772b14$export$cc31defa5ce72da6; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionRenewModalOpen", function () { return $ab6d8e4c47772b14$export$c36a45d3024cdbd1; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionRenewModalArtist", function () { return $ab6d8e4c47772b14$export$3264c37037a409a0; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCancelModalOpen", function () { return $ab6d8e4c47772b14$export$9ee81645d1343ff7; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCancelModalArtist", function () { return $ab6d8e4c47772b14$export$58482d974df41afc; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionGetSubscribedUserIdsLoading", function () { return $ab6d8e4c47772b14$export$e7b9d8d895eeb3c6; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionGetSubscribedAtPeriodEndUserIdsLoading", function () { return $ab6d8e4c47772b14$export$ac5c6334c19610fe; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCreateSubscriptionLoading", function () { return $ab6d8e4c47772b14$export$fff48570d90e4132; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionRenewSubscriptionLoading", function () { return $ab6d8e4c47772b14$export$c434295ced29f271; });
$parcel$export(module.exports, "subscriptionSelectSubscriptionCancelSubscriptionLoading", function () { return $ab6d8e4c47772b14$export$5fdfa6e21aff750f; });
$parcel$export(module.exports, "subscriptionReducer", function () { return $ab6d8e4c47772b14$export$c6124c6f9953c008; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $aC3hJ = parcelRequire("aC3hJ");
const $ab6d8e4c47772b14$var$initialState = {
    userSubscriptions: {},
    userSubscriptionsAtPeriodEnd: {},
    subscriptionCreateModal: {
        artist: undefined,
        open: false
    },
    subscriptionRenewModal: {
        artist: undefined,
        open: false
    },
    subscriptionCancelModal: {
        artist: undefined,
        open: false
    },
    subscriptionGetSubscribedUserIdsLoading: false,
    subscriptionGetSubscribedAtPeriodEndUserIdsLoading: false,
    subscriptionCreateSubscriptionLoading: false,
    subscriptionRenewSubscriptionLoading: false,
    subscriptionCancelSubscriptionLoading: false
};
const $ab6d8e4c47772b14$export$ace45a1139be3d5f = (0, $kvj5V.createSlice)({
    name: "subscription",
    initialState: $ab6d8e4c47772b14$var$initialState,
    reducers: {
        // reset state
        subscriptionResetState: ()=>({
                userSubscriptions: {},
                userSubscriptionsAtPeriodEnd: {},
                subscriptionCreateModal: {
                    artist: undefined,
                    open: false
                },
                subscriptionRenewModal: {
                    artist: undefined,
                    open: false
                },
                subscriptionCancelModal: {
                    artist: undefined,
                    open: false
                },
                subscriptionGetSubscribedUserIdsLoading: false,
                subscriptionGetSubscribedAtPeriodEndUserIdsLoading: false,
                subscriptionCreateSubscriptionLoading: false,
                subscriptionRenewSubscriptionLoading: false,
                subscriptionCancelSubscriptionLoading: false
            }),
        // set user subscriptions
        subscriptionSetUserSubscriptions: (state, action)=>{
            const { subscribedUserIds: subscribedUserIds } = action.payload;
            // define user subscriptions map
            const userSubscriptions = {};
            // iterate over each subscribed user id
            subscribedUserIds.forEach((id)=>{
                // add id to the map
                userSubscriptions[id] = true;
            });
            // update state
            state.userSubscriptions = userSubscriptions;
        },
        // add user subscription
        subscriptionAddUserSubscription: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptions[userId] = true;
        },
        // remove user subscription
        subscriptionRemoveUserSubscription: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptions[userId] = false;
        },
        // set user subscriptions at period end
        subscriptionSetUserSubscriptionsAtPeriodEnd: (state, action)=>{
            const { subscribedAtPeriodEndUserIds: subscribedAtPeriodEndUserIds } = action.payload;
            // define user subscriptions at period end map
            const userSubscriptionsAtPeriodEnd = {};
            // iterate over each subscribed user id
            subscribedAtPeriodEndUserIds.forEach((id)=>{
                // add id to the map
                userSubscriptionsAtPeriodEnd[id] = true;
            });
            // update state
            state.userSubscriptionsAtPeriodEnd = userSubscriptionsAtPeriodEnd;
        },
        // add user subscription at period end
        subscriptionAddUserSubscriptionAtPeriodEnd: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptionsAtPeriodEnd[userId] = true;
        },
        // remove user subscription at period end
        subscriptionRemoveUserSubscriptionAtPeriodEnd: (state, action)=>{
            const { userId: userId } = action.payload;
            // update state
            state.userSubscriptionsAtPeriodEnd[userId] = false;
        },
        // open subscription create modal
        subscriptionOpenSubscriptionCreateModal: (state, action)=>({
                ...state,
                subscriptionCreateModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close subscription create modal
        subscriptionCloseSubscriptionCreateModal: (state)=>({
                ...state,
                subscriptionCreateModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            }),
        // open subscription renew modal
        subscriptionOpenSubscriptionRenewModal: (state, action)=>({
                ...state,
                subscriptionRenewModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close subscription renew modal
        subscriptionCloseSubscriptionRenewModal: (state)=>({
                ...state,
                subscriptionRenewModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            }),
        // open subscription cancel modal
        subscriptionOpenSubscriptionCancelModal: (state, action)=>({
                ...state,
                subscriptionCancelModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close subscription cancel modal
        subscriptionCloseSubscriptionCancelModal: (state)=>({
                ...state,
                subscriptionCancelModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get subscribed user ids
        builder.addCase((0, $aC3hJ.subscriptionGetSubscribedUserIds).pending, (state)=>({
                ...state,
                subscriptionGetSubscribedUserIdsLoading: true
            })).addCase((0, $aC3hJ.subscriptionGetSubscribedUserIds).fulfilled, (state)=>({
                ...state,
                subscriptionGetSubscribedUserIdsLoading: false
            }));
        // get subscribed user ids at period end
        builder.addCase((0, $aC3hJ.subscriptionGetSubscribedAtPeriodEndUserIds).pending, (state)=>({
                ...state,
                subscriptionGetSubscribedAtPeriodEndUserIdsLoading: true
            })).addCase((0, $aC3hJ.subscriptionGetSubscribedAtPeriodEndUserIds).fulfilled, (state)=>({
                ...state,
                subscriptionGetSubscribedAtPeriodEndUserIdsLoading: false
            }));
        // create subscription
        builder.addCase((0, $aC3hJ.subscriptionCreateSubscription).pending, (state)=>({
                ...state,
                subscriptionCreateSubscriptionLoading: true
            })).addCase((0, $aC3hJ.subscriptionCreateSubscription).fulfilled, (state)=>({
                ...state,
                subscriptionCreateSubscriptionLoading: false
            }));
        // renew subscription
        builder.addCase((0, $aC3hJ.subscriptionRenewSubscription).pending, (state)=>({
                ...state,
                subscriptionRenewSubscriptionLoading: true
            })).addCase((0, $aC3hJ.subscriptionRenewSubscription).fulfilled, (state)=>({
                ...state,
                subscriptionRenewSubscriptionLoading: false
            }));
        // cancel subscription
        builder.addCase((0, $aC3hJ.subscriptionCancelSubscription).pending, (state)=>({
                ...state,
                subscriptionCancelSubscriptionLoading: true
            })).addCase((0, $aC3hJ.subscriptionCancelSubscription).fulfilled, (state)=>({
                ...state,
                subscriptionCancelSubscriptionLoading: false
            }));
    }
});
const { subscriptionResetState: $ab6d8e4c47772b14$export$c6562e8445940d44, subscriptionSetUserSubscriptions: $ab6d8e4c47772b14$export$be2dfb7f082907ba, subscriptionAddUserSubscription: $ab6d8e4c47772b14$export$1b658aed8e1f365d, subscriptionRemoveUserSubscription: $ab6d8e4c47772b14$export$746b64992b0ece49, subscriptionSetUserSubscriptionsAtPeriodEnd: $ab6d8e4c47772b14$export$896133c746b42699, subscriptionAddUserSubscriptionAtPeriodEnd: $ab6d8e4c47772b14$export$24dda4823d975610, subscriptionRemoveUserSubscriptionAtPeriodEnd: $ab6d8e4c47772b14$export$2a9e53329c48b691, subscriptionOpenSubscriptionCreateModal: $ab6d8e4c47772b14$export$b16abe21e1f36a60, subscriptionCloseSubscriptionCreateModal: $ab6d8e4c47772b14$export$e9854fd0d09c5426, subscriptionOpenSubscriptionRenewModal: $ab6d8e4c47772b14$export$85d65c2bf3e9683f, subscriptionCloseSubscriptionRenewModal: $ab6d8e4c47772b14$export$70ae45590bebb868, subscriptionOpenSubscriptionCancelModal: $ab6d8e4c47772b14$export$8fd060939331f66e, subscriptionCloseSubscriptionCancelModal: $ab6d8e4c47772b14$export$5bcaf9cef8723720 } = $ab6d8e4c47772b14$export$ace45a1139be3d5f.actions;
const $ab6d8e4c47772b14$export$bd426abebc2f2046 = (state)=>state.subscription.userSubscriptions;
const $ab6d8e4c47772b14$export$f1f864a83a1bcd87 = (state)=>state.subscription.userSubscriptionsAtPeriodEnd;
const $ab6d8e4c47772b14$export$6fbda4ca77fe2914 = (state)=>state.subscription.subscriptionCreateModal.open;
const $ab6d8e4c47772b14$export$cc31defa5ce72da6 = (state)=>state.subscription.subscriptionCreateModal.artist;
const $ab6d8e4c47772b14$export$c36a45d3024cdbd1 = (state)=>state.subscription.subscriptionRenewModal.open;
const $ab6d8e4c47772b14$export$3264c37037a409a0 = (state)=>state.subscription.subscriptionRenewModal.artist;
const $ab6d8e4c47772b14$export$9ee81645d1343ff7 = (state)=>state.subscription.subscriptionCancelModal.open;
const $ab6d8e4c47772b14$export$58482d974df41afc = (state)=>state.subscription.subscriptionCancelModal.artist;
const $ab6d8e4c47772b14$export$e7b9d8d895eeb3c6 = (state)=>state.subscription.subscriptionGetSubscribedUserIdsLoading;
const $ab6d8e4c47772b14$export$ac5c6334c19610fe = (state)=>state.subscription.subscriptionGetSubscribedAtPeriodEndUserIdsLoading;
const $ab6d8e4c47772b14$export$fff48570d90e4132 = (state)=>state.subscription.subscriptionCreateSubscriptionLoading;
const $ab6d8e4c47772b14$export$c434295ced29f271 = (state)=>state.subscription.subscriptionRenewSubscriptionLoading;
const $ab6d8e4c47772b14$export$5fdfa6e21aff750f = (state)=>state.subscription.subscriptionCancelSubscriptionLoading;
const $ab6d8e4c47772b14$export$c6124c6f9953c008 = $ab6d8e4c47772b14$export$ace45a1139be3d5f.reducer; // export default subscriptionSlice.reducer

});

parcelRegister("aC3hJ", function(module, exports) {

$parcel$export(module.exports, "subscriptionGetSubscribedUserIds", function () { return $c8cde90ff32ce862$export$5b8f676c64b64b19; });
$parcel$export(module.exports, "subscriptionGetSubscribedAtPeriodEndUserIds", function () { return $c8cde90ff32ce862$export$d69174a1f37ccdff; });
$parcel$export(module.exports, "subscriptionCreateSubscription", function () { return $c8cde90ff32ce862$export$103165c97cc4ec39; });
$parcel$export(module.exports, "subscriptionRenewSubscription", function () { return $c8cde90ff32ce862$export$34ef3162695b788c; });
$parcel$export(module.exports, "subscriptionCancelSubscription", function () { return $c8cde90ff32ce862$export$979222d832fc413b; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $6Qgqx = parcelRequire("6Qgqx");
var $hxwj5 = parcelRequire("hxwj5");
var $l5cm3 = parcelRequire("l5cm3");
const $c8cde90ff32ce862$export$5b8f676c64b64b19 = (0, $kvj5V.createAsyncThunk)("subscription/subscriptionGetSubscribedUserIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve subscribed user ids
        const { subscribedUserIds: subscribedUserIds } = await api.subscriptionApi.getSubscribedUserIds();
        // set user subscriptions
        dispatch((0, $l5cm3.subscriptionSetUserSubscriptions)({
            subscribedUserIds: subscribedUserIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c8cde90ff32ce862$export$d69174a1f37ccdff = (0, $kvj5V.createAsyncThunk)("subscription/subscriptionGetSubscribedAtPeriodEndUserIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve subscribed at period end user ids
        const { subscribedAtPeriodEndUserIds: subscribedAtPeriodEndUserIds } = await api.subscriptionApi.getSubscribedAtPeriodEndUserIds();
        // set user subscriptions
        dispatch((0, $l5cm3.subscriptionSetUserSubscriptionsAtPeriodEnd)({
            subscribedAtPeriodEndUserIds: subscribedAtPeriodEndUserIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c8cde90ff32ce862$export$103165c97cc4ec39 = (0, $kvj5V.createAsyncThunk)("subscription/subscriptionCreateSubscription", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().subscription.subscriptionCreateModal.artist;
    const { id: artistId } = modalArtist ?? {};
    try {
        // create subscription
        const { clientSecret: clientSecret } = await api.subscriptionApi.createSubscription({
            userId: artistId || ""
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close subscription create modal
        dispatch((0, $l5cm3.subscriptionCloseSubscriptionCreateModal)());
        // open payment modal
        dispatch((0, $6Qgqx.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $hxwj5.PaymentOperationType).Subscription,
            operationSubject: modalArtist
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create subscription: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c8cde90ff32ce862$export$34ef3162695b788c = (0, $kvj5V.createAsyncThunk)("subscription/subscriptionRenewSubscription", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().subscription.subscriptionRenewModal.artist;
    const { id: artistId } = modalArtist ?? {};
    try {
        // renew subscription
        await api.subscriptionApi.renewSubscription({
            userId: artistId || ""
        });
        // remove user subscription at period end
        dispatch((0, $l5cm3.subscriptionRemoveUserSubscriptionAtPeriodEnd)({
            userId: artistId || ""
        }));
        // close subscription renew modal
        dispatch((0, $l5cm3.subscriptionCloseSubscriptionRenewModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully renewed subscription!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to renew subscription: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $c8cde90ff32ce862$export$979222d832fc413b = (0, $kvj5V.createAsyncThunk)("subscription/subscriptionCancelSubscription", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().subscription.subscriptionCancelModal.artist;
    const { id: artistId } = modalArtist ?? {};
    try {
        // cancel subscription
        await api.subscriptionApi.cancelSubscription({
            userId: artistId || ""
        });
        // add user subscription at period end
        dispatch((0, $l5cm3.subscriptionAddUserSubscriptionAtPeriodEnd)({
            userId: artistId || ""
        }));
        // close subscription cancel modal
        dispatch((0, $l5cm3.subscriptionCloseSubscriptionCancelModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully canceled subscription!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to cancel subscription: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("lBLhK", function(module, exports) {

var $fIaL3 = parcelRequire("fIaL3");
$parcel$exportWildcard(module.exports, $fIaL3);

});
parcelRegister("fIaL3", function(module, exports) {

$parcel$export(module.exports, "themeSlice", function () { return $c5c53dacacf2ed7b$export$31c2657a77d5afe6; });
$parcel$export(module.exports, "themeToggle", function () { return $c5c53dacacf2ed7b$export$bfcc790a4733fb08; });
$parcel$export(module.exports, "themeSetDark", function () { return $c5c53dacacf2ed7b$export$9171f381a59a2216; });
$parcel$export(module.exports, "themeSetLight", function () { return $c5c53dacacf2ed7b$export$229a2339108e1fc4; });
$parcel$export(module.exports, "themeSelectCurrentTheme", function () { return $c5c53dacacf2ed7b$export$a48c667c917b2365; });
$parcel$export(module.exports, "themeReducer", function () { return $c5c53dacacf2ed7b$export$cb5aa33629c05de0; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $c5c53dacacf2ed7b$var$initialState = {
    currentTheme: (0, $gln0L.ThemeName).Dark
};
const $c5c53dacacf2ed7b$export$31c2657a77d5afe6 = (0, $kvj5V.createSlice)({
    name: "theme",
    initialState: $c5c53dacacf2ed7b$var$initialState,
    reducers: {
        themeToggle: (state)=>({
                ...state,
                currentTheme: state.currentTheme === (0, $gln0L.ThemeName).Dark ? (0, $gln0L.ThemeName).Light : (0, $gln0L.ThemeName).Dark
            }),
        themeSetDark: (state)=>({
                ...state,
                currentTheme: (0, $gln0L.ThemeName).Dark
            }),
        themeSetLight: (state)=>({
                ...state,
                currentTheme: (0, $gln0L.ThemeName).Light
            })
    }
});
const { themeToggle: $c5c53dacacf2ed7b$export$bfcc790a4733fb08, themeSetDark: $c5c53dacacf2ed7b$export$9171f381a59a2216, themeSetLight: $c5c53dacacf2ed7b$export$229a2339108e1fc4 } = $c5c53dacacf2ed7b$export$31c2657a77d5afe6.actions;
const $c5c53dacacf2ed7b$export$a48c667c917b2365 = (state)=>state.theme.currentTheme;
const $c5c53dacacf2ed7b$export$cb5aa33629c05de0 = $c5c53dacacf2ed7b$export$31c2657a77d5afe6.reducer; // export default themeSlice.reducer

});


parcelRegister("1uGI4", function(module, exports) {

$parcel$export(module.exports, "TipModal", function () { return (parcelRequire("kHjvB")).TipModal; });
parcelRequire("cRaRu");
var $kHjvB = parcelRequire("kHjvB");

var $a0GHC = parcelRequire("a0GHC");

var $44jep = parcelRequire("44jep");
$parcel$exportWildcard(module.exports, $a0GHC);
$parcel$exportWildcard(module.exports, $44jep);

});
parcelRegister("cRaRu", function(module, exports) {

$parcel$export(module.exports, "TipModal", function () { return (parcelRequire("kHjvB")).TipModal; });

var $kHjvB = parcelRequire("kHjvB");

});
parcelRegister("kHjvB", function(module, exports) {

$parcel$export(module.exports, "TipModal", function () { return $2e8a49595e131cf5$export$bb27c6f96dfdd7a2; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $a0GHC = parcelRequire("a0GHC");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("6B2VD");
var $jtNl9 = parcelRequire("jtNl9");

var $f2iEe = parcelRequire("f2iEe");
const $2e8a49595e131cf5$export$bb27c6f96dfdd7a2 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const tipModalOpen = (0, $gNvvs.useAppSelector)((0, $a0GHC.tipSelectTipModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $f2iEe.styles)().modal.main,
        children: tipModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $a0GHC.tipCloseTipModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $f2iEe.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $jtNl9.TipCard), {})
            })
        })
    });
};
$2e8a49595e131cf5$export$bb27c6f96dfdd7a2.propTypes = {};

});
parcelRegister("6B2VD", function(module, exports) {

$parcel$export(module.exports, "TipCard", function () { return (parcelRequire("jtNl9")).TipCard; });

var $jtNl9 = parcelRequire("jtNl9");

});
parcelRegister("jtNl9", function(module, exports) {

$parcel$export(module.exports, "TipCard", function () { return $2e34a2968579f8b1$export$aaefb9d354766010; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $a0GHC = parcelRequire("a0GHC");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("6Oksi");
var $apjC8 = parcelRequire("apjC8");

var $bDG7j = parcelRequire("bDG7j");
const $2e34a2968579f8b1$export$aaefb9d354766010 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $a0GHC.tipSelectTipModalArtist));
    const tipError = "";
    const { id: artistUserId, username: username } = modalArtist ?? {};
    const subtitleAccentStartIndex = 31;
    const subtitleAccentEndIndex = 32 + (username?.length || 0);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $bDG7j.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bDG7j.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $a0GHC.tipCloseTipModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bDG7j.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Send Tip",
                    icon: (0, $bq9l8.icons).DollarCircle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bDG7j.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: `Show your appreciation for the @${username} by sending a tip to support their work!`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $bDG7j.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $bDG7j.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $apjC8.TipForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $bDG7j.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: tipError
                        })
                    })
                ]
            })
        ]
    });
};
$2e34a2968579f8b1$export$aaefb9d354766010.propTypes = {};

});
parcelRegister("6Oksi", function(module, exports) {

$parcel$export(module.exports, "TipForm", function () { return (parcelRequire("apjC8")).TipForm; });

var $apjC8 = parcelRequire("apjC8");

});
parcelRegister("apjC8", function(module, exports) {

$parcel$export(module.exports, "TipForm", function () { return $61b2ef727c7e0d56$export$72bbcc7dfc0dee1b; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $lygIl = parcelRequire("lygIl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $44jep = parcelRequire("44jep");
var $a0GHC = parcelRequire("a0GHC");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $9jZXY = parcelRequire("9jZXY");
var $eOdZ3 = parcelRequire("eOdZ3");
var $f6nZ0 = parcelRequire("f6nZ0");

var $jwH6S = parcelRequire("jwH6S");
const $61b2ef727c7e0d56$export$72bbcc7dfc0dee1b = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const tipCreateLoading = (0, $gNvvs.useAppSelector)((0, $a0GHC.tipSelectTipCreateTipLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalArtist = (0, $gNvvs.useAppSelector)((0, $a0GHC.tipSelectTipModalArtist));
    const [tipAmount, setTipAmount] = (0, $bh6RR.useState)(Math.ceil((0, $lygIl.maxTipAmount) / 2));
    const [tipMessage, setTipMessage] = (0, $bh6RR.useState)("");
    const [tipMessageError, setTipMessageError] = (0, $bh6RR.useState)("");
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = modalArtist ?? {};
    const isCurrentUserTip = profileUserId === artistUserId;
    const submitDisabled = tipMessageError !== "" || tipAmount < (0, $lygIl.minTipAmount) || tipAmount > (0, $lygIl.maxTipAmount) || tipMessage.length > (0, $lygIl.maxTipMessageLength) || isCurrentUserTip || tipCreateLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $jwH6S.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $jwH6S.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $44jep.tipCreateTip)({
                    amount: tipAmount,
                    message: tipMessage
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $jwH6S.styles)().form.content.amount,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9jZXY.InputAmount), {
                        name: "tip-amount",
                        label: "tip amount",
                        type: "range",
                        id: "tip-amount",
                        value: tipAmount,
                        min: (0, $lygIl.minTipAmount),
                        max: (0, $lygIl.maxTipAmount),
                        onChange: (e)=>setTipAmount(parseInt(e.target.value, 10))
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $jwH6S.styles)().form.content.message,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $eOdZ3.InputArea), {
                        name: "tip-message",
                        label: "tip message",
                        id: "tip-message",
                        placeholder: "Connect with the artist by sending a message",
                        value: tipMessage,
                        maxLength: (0, $lygIl.maxTipMessageLength),
                        error: tipMessageError.length > 0,
                        errorMessage: tipMessageError,
                        rows: 6,
                        onChange: (e)=>setTipMessage(e.target.value),
                        onBlur: ()=>{
                            if (tipMessage !== "") setTipMessageError((0, $lRNbG.validateTipMessage)(tipMessage));
                        },
                        onFocus: ()=>setTipMessageError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $jwH6S.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "create tip",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: tipCreateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Tip: $${tipAmount}`
                    })
                })
            ]
        })
    });
};
$61b2ef727c7e0d56$export$72bbcc7dfc0dee1b.propTypes = {};

});
parcelRegister("jwH6S", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1e7ed535f6f4c7c9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $1e7ed535f6f4c7c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1e7ed535f6f4c7c9$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $1e7ed535f6f4c7c9$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
const $1e7ed535f6f4c7c9$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                amount: $1e7ed535f6f4c7c9$var$_ref2,
                message: $1e7ed535f6f4c7c9$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("bDG7j", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2ab87d78349c51a6$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2ab87d78349c51a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2ab87d78349c51a6$var$_ref = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ab87d78349c51a6$var$_ref2 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ab87d78349c51a6$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2ab87d78349c51a6$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ab87d78349c51a6$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2ab87d78349c51a6$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $2ab87d78349c51a6$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $2ab87d78349c51a6$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $2ab87d78349c51a6$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($2ab87d78349c51a6$var$_ref8), " ", (0, $gln0L.mq).mobile($2ab87d78349c51a6$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($2ab87d78349c51a6$var$_ref6), ";", ""),
            title: $2ab87d78349c51a6$var$_ref5,
            subtitle: $2ab87d78349c51a6$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($2ab87d78349c51a6$var$_ref3), ";", ""),
                form: $2ab87d78349c51a6$var$_ref2,
                error: $2ab87d78349c51a6$var$_ref
            }
        }
    });

});



parcelRegister("f2iEe", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f38a95ea89673890$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $f38a95ea89673890$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f38a95ea89673890$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $f38a95ea89673890$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($f38a95ea89673890$var$_ref), ";", "")
        }
    });

});



parcelRegister("a0GHC", function(module, exports) {

$parcel$export(module.exports, "tipSlice", function () { return $7c1031372f74163b$export$93392c9cfeaaa30f; });
$parcel$export(module.exports, "tipResetState", function () { return $7c1031372f74163b$export$ecefc37ebfa23d30; });
$parcel$export(module.exports, "tipOpenTipModal", function () { return $7c1031372f74163b$export$46a4ac262f682147; });
$parcel$export(module.exports, "tipCloseTipModal", function () { return $7c1031372f74163b$export$ecfbd433f7956014; });
$parcel$export(module.exports, "tipSelectTipModalOpen", function () { return $7c1031372f74163b$export$a41ea3ae0e42011; });
$parcel$export(module.exports, "tipSelectTipModalArtist", function () { return $7c1031372f74163b$export$407b171f08b12852; });
$parcel$export(module.exports, "tipSelectTipCreateTipLoading", function () { return $7c1031372f74163b$export$519187884b4bea71; });
$parcel$export(module.exports, "tipReducer", function () { return $7c1031372f74163b$export$d8203854a0e4cb14; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $44jep = parcelRequire("44jep");
const $7c1031372f74163b$var$initialState = {
    tipModal: {
        artist: undefined,
        open: false
    },
    tipCreateTipLoading: false
};
const $7c1031372f74163b$export$93392c9cfeaaa30f = (0, $kvj5V.createSlice)({
    name: "tip",
    initialState: $7c1031372f74163b$var$initialState,
    reducers: {
        // reset state
        tipResetState: ()=>({
                tipModal: {
                    artist: undefined,
                    open: false
                },
                tipCreateTipLoading: false
            }),
        // open tip modal
        tipOpenTipModal: (state, action)=>({
                ...state,
                tipModal: {
                    artist: action.payload.artist,
                    open: true
                }
            }),
        // close tip modal
        tipCloseTipModal: (state)=>({
                ...state,
                tipModal: {
                    artist: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // create tip
        builder.addCase((0, $44jep.tipCreateTip).pending, (state)=>({
                ...state,
                tipCreateTipLoading: true
            })).addCase((0, $44jep.tipCreateTip).fulfilled, (state)=>({
                ...state,
                tipCreateTipLoading: false
            }));
    }
});
const { tipResetState: $7c1031372f74163b$export$ecefc37ebfa23d30, tipOpenTipModal: $7c1031372f74163b$export$46a4ac262f682147, tipCloseTipModal: $7c1031372f74163b$export$ecfbd433f7956014 } = $7c1031372f74163b$export$93392c9cfeaaa30f.actions;
const $7c1031372f74163b$export$a41ea3ae0e42011 = (state)=>state.tip.tipModal.open;
const $7c1031372f74163b$export$407b171f08b12852 = (state)=>state.tip.tipModal.artist;
const $7c1031372f74163b$export$519187884b4bea71 = (state)=>state.tip.tipCreateTipLoading;
const $7c1031372f74163b$export$d8203854a0e4cb14 = $7c1031372f74163b$export$93392c9cfeaaa30f.reducer; // export default tipSlice.reducer

});

parcelRegister("44jep", function(module, exports) {

$parcel$export(module.exports, "tipCreateTip", function () { return $7119421de74a3b70$export$13c5a3c45baf7f02; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $6Qgqx = parcelRequire("6Qgqx");
var $hxwj5 = parcelRequire("hxwj5");
var $a0GHC = parcelRequire("a0GHC");
const $7119421de74a3b70$export$13c5a3c45baf7f02 = (0, $kvj5V.createAsyncThunk)("tip/tipCreateTip", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get artist from modal state
    const modalArtist = getState().tip.tipModal.artist;
    // if artist id is not provided
    if (!inp.artistId) // set artist id as modal artist id
    inp.artistId = modalArtist?.id;
    try {
        // create tip
        const { clientSecret: clientSecret } = await api.tipApi.createTip({
            // create tip accepts amount in cents
            // if inp.amount = 1 (one dollar)
            // 1 * 100 = 100 (hundred cents)
            amount: inp.amount * 100,
            artistId: inp.artistId || "",
            message: inp.message
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close tip modal
        dispatch((0, $a0GHC.tipCloseTipModal)());
        // open payment modal
        dispatch((0, $6Qgqx.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $hxwj5.PaymentOperationType).Tip,
            operationSubject: modalArtist
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to create tip: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("boi6x", function(module, exports) {

$parcel$export(module.exports, "TrackBlockModal", function () { return (parcelRequire("c76Dz")).TrackBlockModal; });
$parcel$export(module.exports, "TrackCard", function () { return (parcelRequire("7J6mb")).TrackCard; });
$parcel$export(module.exports, "TrackCardBlockSkeleton", function () { return (parcelRequire("fTQqS")).TrackCardBlockSkeleton; });
$parcel$export(module.exports, "TrackCardLocked", function () { return (parcelRequire("2ahyr")).TrackCardLocked; });
$parcel$export(module.exports, "TrackCardUploaded", function () { return (parcelRequire("l1klG")).TrackCardUploaded; });
$parcel$export(module.exports, "TrackDeleteModal", function () { return (parcelRequire("3n4bn")).TrackDeleteModal; });
$parcel$export(module.exports, "TrackListAudioPlaylist", function () { return (parcelRequire("emkZ3")).TrackListAudioPlaylist; });
$parcel$export(module.exports, "TrackListChartsExclusive", function () { return (parcelRequire("8MtZ5")).TrackListChartsExclusive; });
$parcel$export(module.exports, "TrackListChartsLatest", function () { return (parcelRequire("lwHhz")).TrackListChartsLatest; });
$parcel$export(module.exports, "TrackListChartsPopular", function () { return (parcelRequire("j1S8G")).TrackListChartsPopular; });
$parcel$export(module.exports, "TrackListChartsTrending", function () { return (parcelRequire("3URn4")).TrackListChartsTrending; });
$parcel$export(module.exports, "TrackListFeedPopular", function () { return (parcelRequire("kmm86")).TrackListFeedPopular; });
$parcel$export(module.exports, "TrackListFeedRecommended", function () { return (parcelRequire("c0j9Z")).TrackListFeedRecommended; });
$parcel$export(module.exports, "TrackListHomePublic", function () { return (parcelRequire("lIbIZ")).TrackListHomePublic; });
$parcel$export(module.exports, "TrackListLibraryLiked", function () { return (parcelRequire("j4ytf")).TrackListLibraryLiked; });
$parcel$export(module.exports, "TrackListLibraryUnlocked", function () { return (parcelRequire("1XeI9")).TrackListLibraryUnlocked; });
$parcel$export(module.exports, "TrackListOnboardingUploaded", function () { return (parcelRequire("gRqmZ")).TrackListOnboardingUploaded; });
$parcel$export(module.exports, "TrackListPost", function () { return (parcelRequire("jFCU5")).TrackListPost; });
$parcel$export(module.exports, "TrackListStudioPostUploaded", function () { return (parcelRequire("awTAN")).TrackListStudioPostUploaded; });
$parcel$export(module.exports, "TrackListStudioUploaded", function () { return (parcelRequire("8jd1H")).TrackListStudioUploaded; });
$parcel$export(module.exports, "TrackListUserExclusive", function () { return (parcelRequire("cfBsJ")).TrackListUserExclusive; });
$parcel$export(module.exports, "TrackListUserLatest", function () { return (parcelRequire("gGXoQ")).TrackListUserLatest; });
$parcel$export(module.exports, "TrackListUserPopular", function () { return (parcelRequire("59H0L")).TrackListUserPopular; });
$parcel$export(module.exports, "TrackTile", function () { return (parcelRequire("377Y6")).TrackTile; });
$parcel$export(module.exports, "TrackTileLocked", function () { return (parcelRequire("9NbFe")).TrackTileLocked; });
$parcel$export(module.exports, "TrackTileProduct", function () { return (parcelRequire("4qRw3")).TrackTileProduct; });
$parcel$export(module.exports, "TrackTileSelect", function () { return (parcelRequire("ip1Fa")).TrackTileSelect; });
$parcel$export(module.exports, "TrackViewAudioPlaylist", function () { return (parcelRequire("1yt5C")).TrackViewAudioPlaylist; });
$parcel$export(module.exports, "TrackViewCreateStudio", function () { return (parcelRequire("8p2Dj")).TrackViewCreateStudio; });
$parcel$export(module.exports, "TrackViewEditStudio", function () { return (parcelRequire("3xC6a")).TrackViewEditStudio; });
$parcel$export(module.exports, "trackUtilGetTrackTileSkeletonSections", function () { return (parcelRequire("5zZt1")).trackUtilGetTrackTileSkeletonSections; });
parcelRequire("iOmeC");
var $c76Dz = parcelRequire("c76Dz");
var $7J6mb = parcelRequire("7J6mb");
var $fTQqS = parcelRequire("fTQqS");
var $2ahyr = parcelRequire("2ahyr");
var $l1klG = parcelRequire("l1klG");
var $3n4bn = parcelRequire("3n4bn");
var $emkZ3 = parcelRequire("emkZ3");
var $8MtZ5 = parcelRequire("8MtZ5");
var $lwHhz = parcelRequire("lwHhz");
var $j1S8G = parcelRequire("j1S8G");
var $3URn4 = parcelRequire("3URn4");
var $kmm86 = parcelRequire("kmm86");
var $c0j9Z = parcelRequire("c0j9Z");
var $lIbIZ = parcelRequire("lIbIZ");
var $j4ytf = parcelRequire("j4ytf");
var $1XeI9 = parcelRequire("1XeI9");
var $gRqmZ = parcelRequire("gRqmZ");
var $jFCU5 = parcelRequire("jFCU5");
var $awTAN = parcelRequire("awTAN");
var $8jd1H = parcelRequire("8jd1H");
var $cfBsJ = parcelRequire("cfBsJ");
var $gGXoQ = parcelRequire("gGXoQ");
var $59H0L = parcelRequire("59H0L");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $4qRw3 = parcelRequire("4qRw3");
var $ip1Fa = parcelRequire("ip1Fa");
var $1yt5C = parcelRequire("1yt5C");
var $8p2Dj = parcelRequire("8p2Dj");
var $3xC6a = parcelRequire("3xC6a");

var $5zZt1 = parcelRequire("5zZt1");

var $2Vh5B = parcelRequire("2Vh5B");

var $kwNyE = parcelRequire("kwNyE");
$parcel$exportWildcard(module.exports, $2Vh5B);
$parcel$exportWildcard(module.exports, $kwNyE);

});
parcelRegister("iOmeC", function(module, exports) {

$parcel$export(module.exports, "TrackBlockModal", function () { return (parcelRequire("c76Dz")).TrackBlockModal; });
$parcel$export(module.exports, "TrackCard", function () { return (parcelRequire("7J6mb")).TrackCard; });
$parcel$export(module.exports, "TrackCardBlockSkeleton", function () { return (parcelRequire("fTQqS")).TrackCardBlockSkeleton; });
$parcel$export(module.exports, "TrackCardLocked", function () { return (parcelRequire("2ahyr")).TrackCardLocked; });
$parcel$export(module.exports, "TrackCardUploaded", function () { return (parcelRequire("l1klG")).TrackCardUploaded; });
$parcel$export(module.exports, "TrackDeleteModal", function () { return (parcelRequire("3n4bn")).TrackDeleteModal; });
$parcel$export(module.exports, "TrackListAudioPlaylist", function () { return (parcelRequire("emkZ3")).TrackListAudioPlaylist; });
$parcel$export(module.exports, "TrackListChartsExclusive", function () { return (parcelRequire("8MtZ5")).TrackListChartsExclusive; });
$parcel$export(module.exports, "TrackListChartsLatest", function () { return (parcelRequire("lwHhz")).TrackListChartsLatest; });
$parcel$export(module.exports, "TrackListChartsPopular", function () { return (parcelRequire("j1S8G")).TrackListChartsPopular; });
$parcel$export(module.exports, "TrackListChartsTrending", function () { return (parcelRequire("3URn4")).TrackListChartsTrending; });
$parcel$export(module.exports, "TrackListFeedPopular", function () { return (parcelRequire("kmm86")).TrackListFeedPopular; });
$parcel$export(module.exports, "TrackListFeedRecommended", function () { return (parcelRequire("c0j9Z")).TrackListFeedRecommended; });
$parcel$export(module.exports, "TrackListHomePublic", function () { return (parcelRequire("lIbIZ")).TrackListHomePublic; });
$parcel$export(module.exports, "TrackListLibraryLiked", function () { return (parcelRequire("j4ytf")).TrackListLibraryLiked; });
$parcel$export(module.exports, "TrackListLibraryUnlocked", function () { return (parcelRequire("1XeI9")).TrackListLibraryUnlocked; });
$parcel$export(module.exports, "TrackListOnboardingUploaded", function () { return (parcelRequire("gRqmZ")).TrackListOnboardingUploaded; });
$parcel$export(module.exports, "TrackListPost", function () { return (parcelRequire("jFCU5")).TrackListPost; });
$parcel$export(module.exports, "TrackListStudioPostUploaded", function () { return (parcelRequire("awTAN")).TrackListStudioPostUploaded; });
$parcel$export(module.exports, "TrackListStudioUploaded", function () { return (parcelRequire("8jd1H")).TrackListStudioUploaded; });
$parcel$export(module.exports, "TrackListUserExclusive", function () { return (parcelRequire("cfBsJ")).TrackListUserExclusive; });
$parcel$export(module.exports, "TrackListUserLatest", function () { return (parcelRequire("gGXoQ")).TrackListUserLatest; });
$parcel$export(module.exports, "TrackListUserPopular", function () { return (parcelRequire("59H0L")).TrackListUserPopular; });
$parcel$export(module.exports, "TrackTile", function () { return (parcelRequire("377Y6")).TrackTile; });
$parcel$export(module.exports, "TrackTileLocked", function () { return (parcelRequire("9NbFe")).TrackTileLocked; });
$parcel$export(module.exports, "TrackTileProduct", function () { return (parcelRequire("4qRw3")).TrackTileProduct; });
$parcel$export(module.exports, "TrackTileSelect", function () { return (parcelRequire("ip1Fa")).TrackTileSelect; });
$parcel$export(module.exports, "TrackViewAudioPlaylist", function () { return (parcelRequire("1yt5C")).TrackViewAudioPlaylist; });
$parcel$export(module.exports, "TrackViewCreateStudio", function () { return (parcelRequire("8p2Dj")).TrackViewCreateStudio; });
$parcel$export(module.exports, "TrackViewEditStudio", function () { return (parcelRequire("3xC6a")).TrackViewEditStudio; });

var $c76Dz = parcelRequire("c76Dz");

var $7J6mb = parcelRequire("7J6mb");

var $fTQqS = parcelRequire("fTQqS");

var $2ahyr = parcelRequire("2ahyr");

var $l1klG = parcelRequire("l1klG");

var $3n4bn = parcelRequire("3n4bn");

var $emkZ3 = parcelRequire("emkZ3");

var $8MtZ5 = parcelRequire("8MtZ5");

var $lwHhz = parcelRequire("lwHhz");

var $j1S8G = parcelRequire("j1S8G");

var $3URn4 = parcelRequire("3URn4");

var $kmm86 = parcelRequire("kmm86");

var $c0j9Z = parcelRequire("c0j9Z");

var $lIbIZ = parcelRequire("lIbIZ");

var $j4ytf = parcelRequire("j4ytf");

var $1XeI9 = parcelRequire("1XeI9");

var $gRqmZ = parcelRequire("gRqmZ");

var $jFCU5 = parcelRequire("jFCU5");

var $awTAN = parcelRequire("awTAN");

var $8jd1H = parcelRequire("8jd1H");

var $cfBsJ = parcelRequire("cfBsJ");

var $gGXoQ = parcelRequire("gGXoQ");

var $59H0L = parcelRequire("59H0L");

var $377Y6 = parcelRequire("377Y6");

var $9NbFe = parcelRequire("9NbFe");

var $4qRw3 = parcelRequire("4qRw3");

var $ip1Fa = parcelRequire("ip1Fa");

var $1yt5C = parcelRequire("1yt5C");

var $8p2Dj = parcelRequire("8p2Dj");

var $3xC6a = parcelRequire("3xC6a");

});
parcelRegister("c76Dz", function(module, exports) {

$parcel$export(module.exports, "TrackBlockModal", function () { return $0bb316129a85263c$export$417df2b15edf8238; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("g22S1");
var $6zAFO = parcelRequire("6zAFO");

var $12Syw = parcelRequire("12Syw");
const $0bb316129a85263c$export$417df2b15edf8238 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackBlockModalOpen = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackBlockModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $12Syw.styles)().modal.main,
        children: trackBlockModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $2Vh5B.trackCloseTrackBlockModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $12Syw.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6zAFO.TrackBlockCard), {})
            })
        })
    });
};
$0bb316129a85263c$export$417df2b15edf8238.propTypes = {};

});
parcelRegister("g22S1", function(module, exports) {

$parcel$export(module.exports, "TrackBlockCard", function () { return (parcelRequire("6zAFO")).TrackBlockCard; });

var $6zAFO = parcelRequire("6zAFO");

});
parcelRegister("6zAFO", function(module, exports) {

$parcel$export(module.exports, "TrackBlockCard", function () { return $29d2a83fd6b26903$export$731b3a29637a70bc; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("iZ5nw");
var $fTCDR = parcelRequire("fTCDR");

var $czN2W = parcelRequire("czN2W");
const $29d2a83fd6b26903$export$731b3a29637a70bc = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackBlockError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $czN2W.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $czN2W.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $2Vh5B.trackCloseTrackBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $czN2W.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Block Track",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $czN2W.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Are you sure you want to block this track?"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $czN2W.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $czN2W.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTCDR.TrackBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $czN2W.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: trackBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$29d2a83fd6b26903$export$731b3a29637a70bc.propTypes = {};

});
parcelRegister("iZ5nw", function(module, exports) {

$parcel$export(module.exports, "TrackBlockForm", function () { return (parcelRequire("fTCDR")).TrackBlockForm; });

var $fTCDR = parcelRequire("fTCDR");

});
parcelRegister("fTCDR", function(module, exports) {

$parcel$export(module.exports, "TrackBlockForm", function () { return $4634b9e0f129a8c4$export$267c40b4632b9b65; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $1rRrs = parcelRequire("1rRrs");
const $4634b9e0f129a8c4$export$267c40b4632b9b65 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackBlockLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackBlockLoading));
    const track = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackBlockModalTrack));
    const submitDisabled = trackBlockLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1rRrs.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $1rRrs.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $kwNyE.trackBlock)({
                    id: track?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $1rRrs.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
                        track: track || {},
                        onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                                track: track
                            })),
                        onAuthorNameClick: ()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $1rRrs.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block track",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: trackBlockLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$4634b9e0f129a8c4$export$267c40b4632b9b65.propTypes = {};

});
parcelRegister("1rRrs", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0cc55898f2c1a3d2$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $0cc55898f2c1a3d2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $0cc55898f2c1a3d2$var$_ref = {
    name: "mdhs63",
    styles: "display:flex;justify-content:center;margin-bottom:24px;& div{text-align:center;}& button{text-align:center;}"
};
const $0cc55898f2c1a3d2$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                track: $0cc55898f2c1a3d2$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("czN2W", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2af969221e6c678c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2af969221e6c678c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2af969221e6c678c$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $2af969221e6c678c$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $2af969221e6c678c$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $2af969221e6c678c$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2af969221e6c678c$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $2af969221e6c678c$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $2af969221e6c678c$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $2af969221e6c678c$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $2af969221e6c678c$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($2af969221e6c678c$var$_ref8), " ", (0, $gln0L.mq).mobile($2af969221e6c678c$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($2af969221e6c678c$var$_ref6), ";", ""),
            title: $2af969221e6c678c$var$_ref5,
            subtitle: $2af969221e6c678c$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($2af969221e6c678c$var$_ref3), ";", ""),
                form: $2af969221e6c678c$var$_ref2,
                error: $2af969221e6c678c$var$_ref
            }
        }
    });

});



parcelRegister("12Syw", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $53757afb5c6d74d4$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $53757afb5c6d74d4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $53757afb5c6d74d4$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $53757afb5c6d74d4$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($53757afb5c6d74d4$var$_ref), ";", "")
        }
    });

});


parcelRegister("7J6mb", function(module, exports) {

$parcel$export(module.exports, "TrackCard", function () { return $2ae8e85b9cf0788f$export$e42608234e0cc529; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $b6uWp = parcelRequire("b6uWp");
const $2ae8e85b9cf0788f$export$e42608234e0cc529 = ({ track: track, inProgress: inProgress = false, options: options = [], onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $iwq56.u)();
    const optionsRef = (0, $bh6RR.useRef)(null);
    const isMoreThanTwoOptions = (options?.length || 0) > 2;
    const [isOptionsOpen, setIsOptionsOpen] = (0, $bh6RR.useState)(false);
    const [isOptionsScrollStart, setIsOptionsScrollStart] = (0, $bh6RR.useState)(false);
    const [isOptionsScrollEnd, setIsOptionsScrollEnd] = (0, $bh6RR.useState)(false);
    const { coverId: coverId, name: trackName, userId: userId } = track;
    const trackHasCover = !!coverId;
    const source = (0, $jpNoL.useFile)(coverId || "");
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const handleOptionsScrollArrow = (target)=>{
        // if more than two options provided
        if (isMoreThanTwoOptions) {
            // get node client height, scroll height, and scroll offset
            // clientHeight - height of currently visible content
            // scrollHeight - height of total scroll the element
            // scrollTop  - number of pixels scrolled
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = target;
            // last scroll position
            const lastScrollPosition = scrollHeight - clientHeight;
            // if scroll start reached
            if (scrollTop <= 0) {
                setIsOptionsScrollStart(true);
                setIsOptionsScrollEnd(false);
            }
            // if scroll end reached
            if (scrollTop >= lastScrollPosition) {
                setIsOptionsScrollStart(false);
                setIsOptionsScrollEnd(true);
            }
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        // if node present
        if (optionsRef.current) handleOptionsScrollArrow(optionsRef.current);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        isOptionsOpen
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $b6uWp.styles)(theme).track.main,
        onMouseLeave: ()=>setIsOptionsOpen(false),
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $b6uWp.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b6uWp.styles)(theme).track.cover.overlay.main(!!inProgress),
                        children: inProgress ? /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $b6uWp.styles)(theme).track.cover.overlay.button,
                            onClick: ()=>{},
                            type: "button",
                            "aria-label": "currently playing",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Speaker, {})
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $b6uWp.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "play track",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Play, {})
                        })
                    }),
                    trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                        css: (0, $b6uWp.styles)(theme).track.cover.image,
                        onError: ()=>setCoverLoadError(true),
                        loading: "lazy",
                        width: "60px",
                        height: "60px",
                        src: source,
                        alt: "track album cover"
                    }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b6uWp.styles)(theme).track.cover.placeholder,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $b6uWp.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b6uWp.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $b6uWp.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $b6uWp.styles)(theme).track.menu.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $b6uWp.styles)(theme).track.menu.button,
                        onClick: ()=>{
                            setIsOptionsOpen((isOpen)=>!isOpen);
                        },
                        type: "button",
                        "aria-label": "toggle track options",
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MenuDots, {
                            css: (0, $b6uWp.styles)(theme).track.menu.icon
                        })
                    }),
                    isOptionsOpen && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $b6uWp.styles)(theme).track.menu.options.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: [
                                    (0, $b6uWp.styles)(theme).track.menu.options.overlay.top.shared,
                                    isOptionsScrollEnd && (0, $b6uWp.styles)(theme).track.menu.options.overlay.top.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CaretDown, {})
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $b6uWp.styles)(theme).track.menu.options.list.main,
                                ref: optionsRef,
                                onScroll: (e)=>{
                                    handleOptionsScrollArrow(e.target);
                                },
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("ul", {
                                    css: (0, $b6uWp.styles)(theme).track.menu.options.list.ul,
                                    children: options && options.map(({ id: id, label: label, name: name, danger: danger, onClick: onOptionClick })=>/*#__PURE__*/ (0, $9awXB.jsx)("li", {
                                            css: (0, $b6uWp.styles)(theme).track.menu.options.list.li,
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                                css: [
                                                    (0, $b6uWp.styles)(theme).track.menu.options.list.button.shared,
                                                    danger ? (0, $b6uWp.styles)(theme).track.menu.options.list.button.danger : (0, $b6uWp.styles)(theme).track.menu.options.list.button.regular,
                                                    "",
                                                    ""
                                                ],
                                                onClick: (e)=>onOptionClick(e),
                                                type: "button",
                                                "aria-label": label,
                                                children: name
                                            })
                                        }, `track-option-${id}`))
                                })
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: [
                                    (0, $b6uWp.styles)(theme).track.menu.options.overlay.bottom.shared,
                                    isOptionsScrollStart && (0, $b6uWp.styles)(theme).track.menu.options.overlay.bottom.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CaretDown, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$2ae8e85b9cf0788f$export$e42608234e0cc529.propTypes = {};

});
parcelRegister("b6uWp", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2a6b654be916d854$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2a6b654be916d854$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2a6b654be916d854$var$_ref = {
    name: "qr8q5p",
    styles: "list-style:none"
};
var $2a6b654be916d854$var$_ref2 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $2a6b654be916d854$var$_ref3 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $2a6b654be916d854$var$_ref4 = {
    name: "1ev2zwe",
    styles: "width:20px;height:6px"
};
var $2a6b654be916d854$var$_ref5 = {
    name: "1o3sllj",
    styles: "position:relative;display:flex;align-items:center;justify-content:center;margin-left:16px"
};
var $2a6b654be916d854$var$_ref6 = {
    name: "642qid",
    styles: "display:flex;flex-direction:column;min-width:0;margin-right:auto"
};
var $2a6b654be916d854$var$_ref7 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $2a6b654be916d854$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $2a6b654be916d854$var$_ref7,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: (inProgress)=>/*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.card.overlay, ";position:absolute;left:0;top:0;display:flex;align-items:center;justify-content:center;width:100%;height:100%;transition:opacity 0.2s;opacity:0;", inProgress && "opacity: 1;", " background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:20px;height:20px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $2a6b654be916d854$var$_ref6,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            },
            menu: {
                main: $2a6b654be916d854$var$_ref5,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;cursor:pointer;&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                icon: $2a6b654be916d854$var$_ref4,
                options: {
                    main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.card.menu, ";position:absolute;right:100%;height:60px;min-width:80px;overflow-y:hidden;margin-right:10px;border-radius:4px;border:1px solid ", theme.colors.secondary.darker, ";", ""),
                    overlay: {
                        top: {
                            shared: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, " 0%,\n                ", theme.colors.primary.normal, "00 100%\n              );&>svg{height:10px;width:10px;transform:rotate(180deg);&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $2a6b654be916d854$var$_ref3
                        },
                        bottom: {
                            shared: /*#__PURE__*/ (0, $7hler.css)("position:absolute;bottom:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, "00 0%,\n                ", theme.colors.primary.normal, " 100%\n              );&>svg{height:10px;width:10px;&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $2a6b654be916d854$var$_ref2
                        }
                    },
                    list: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";height:60px;overflow-y:scroll;padding:4px 10px;background-color:", theme.colors.primary.darker, ";", ""),
                        ul: $2a6b654be916d854$var$_ref,
                        li: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        button: {
                            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:24px;cursor:pointer;font-weight:bold;white-space:nowrap;text-align:start;transition:color 0.2s;", ""),
                            regular: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                            danger: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.negative.normal, ";&:hover{color:", theme.colors.negative.normalHover, ";}", "")
                        }
                    }
                }
            }
        }
    });

});


parcelRegister("fTQqS", function(module, exports) {

$parcel$export(module.exports, "TrackCardBlockSkeleton", function () { return $b1ee2771501eb275$export$17e9901570d85c6f; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("1TdPt");
var $42mKz = parcelRequire("42mKz");

var $esJKf = parcelRequire("esJKf");
const $b1ee2771501eb275$export$17e9901570d85c6f = ()=>/*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $esJKf.styles)().skeleton.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
                sections: [
                    {
                        name: "track-card-block-skeleton-cover-1",
                        width: "60px",
                        height: "60px",
                        isStatic: true,
                        isDivider: false
                    },
                    {
                        name: "track-card-block-skeleton-divider-1",
                        width: "16px",
                        height: "60px",
                        isStatic: true,
                        isDivider: true
                    },
                    {
                        name: "track-card-block-skeleton-description-1",
                        width: "100%",
                        height: "60px",
                        isStatic: false,
                        isDivider: false
                    }
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
                sections: [
                    {
                        name: "track-card-block-skeleton-cover-2",
                        width: "60px",
                        height: "60px",
                        isStatic: true,
                        isDivider: false
                    },
                    {
                        name: "track-card-block-skeleton-divider-2",
                        width: "16px",
                        height: "60px",
                        isStatic: true,
                        isDivider: true
                    },
                    {
                        name: "track-card-block-skeleton-description-2",
                        width: "100%",
                        height: "60px",
                        isStatic: false,
                        isDivider: false
                    }
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
                sections: [
                    {
                        name: "track-card-block-skeleton-cover-3",
                        width: "60px",
                        height: "60px",
                        isStatic: true,
                        isDivider: false
                    },
                    {
                        name: "track-card-block-skeleton-divider-3",
                        width: "16px",
                        height: "60px",
                        isStatic: true,
                        isDivider: true
                    },
                    {
                        name: "track-card-block-skeleton-description-3",
                        width: "100%",
                        height: "60px",
                        isStatic: false,
                        isDivider: false
                    }
                ]
            })
        ]
    });
$b1ee2771501eb275$export$17e9901570d85c6f.propTypes = {};

});
parcelRegister("esJKf", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $339307c79acbd6b6$export$9dd6ff9ea0189349; });
function $339307c79acbd6b6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $339307c79acbd6b6$var$_ref = {
    name: "1itg42i",
    styles: "width:280px;&:not(:last-of-type){margin-right:20px;}&>div:not(:last-of-type){margin-bottom:24px;}"
};
const $339307c79acbd6b6$export$9dd6ff9ea0189349 = ()=>({
        skeleton: {
            main: $339307c79acbd6b6$var$_ref
        }
    });

});


parcelRegister("2ahyr", function(module, exports) {

$parcel$export(module.exports, "TrackCardLocked", function () { return $6564ed1f00059b4c$export$ea3bc8a15e6ef2d4; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $b503o = parcelRequire("b503o");
const $6564ed1f00059b4c$export$ea3bc8a15e6ef2d4 = ({ track: track, options: options = [], onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $iwq56.u)();
    const optionsRef = (0, $bh6RR.useRef)(null);
    const isMoreThanTwoOptions = (options?.length || 0) > 2;
    const [isOptionsOpen, setIsOptionsOpen] = (0, $bh6RR.useState)(false);
    const [isOptionsScrollStart, setIsOptionsScrollStart] = (0, $bh6RR.useState)(false);
    const [isOptionsScrollEnd, setIsOptionsScrollEnd] = (0, $bh6RR.useState)(false);
    const { name: trackName, userId: userId } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const handleOptionsScrollArrow = (target)=>{
        // if more than two options provided
        if (isMoreThanTwoOptions) {
            // get node client height, scroll height, and scroll offset
            // clientHeight - height of currently visible content
            // scrollHeight - height of total scroll the element
            // scrollTop  - number of pixels scrolled
            const { clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop } = target;
            // last scroll position
            const lastScrollPosition = scrollHeight - clientHeight;
            // if scroll start reached
            if (scrollTop <= 0) {
                setIsOptionsScrollStart(true);
                setIsOptionsScrollEnd(false);
            }
            // if scroll end reached
            if (scrollTop >= lastScrollPosition) {
                setIsOptionsScrollStart(false);
                setIsOptionsScrollEnd(true);
            }
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        // if node present
        if (optionsRef.current) handleOptionsScrollArrow(optionsRef.current);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        isOptionsOpen
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $b503o.styles)(theme).track.main,
        onMouseLeave: ()=>setIsOptionsOpen(false),
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $b503o.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b503o.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $b503o.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "unlock track",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Unlock, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b503o.styles)(theme).track.cover.lock.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $b503o.styles)(theme).track.cover.lock.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $b503o.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $b503o.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $b503o.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $b503o.styles)(theme).track.menu.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $b503o.styles)(theme).track.menu.button,
                        onClick: ()=>{
                            setIsOptionsOpen(!isOptionsOpen);
                        },
                        type: "button",
                        "aria-label": "toggle track options",
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MenuDots, {
                            css: (0, $b503o.styles)(theme).track.menu.icon
                        })
                    }),
                    isOptionsOpen && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $b503o.styles)(theme).track.menu.options.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: [
                                    (0, $b503o.styles)(theme).track.menu.options.overlay.top.shared,
                                    isOptionsScrollEnd && (0, $b503o.styles)(theme).track.menu.options.overlay.top.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CaretDown, {})
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $b503o.styles)(theme).track.menu.options.list.main,
                                ref: optionsRef,
                                onScroll: (e)=>{
                                    handleOptionsScrollArrow(e.target);
                                },
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("ul", {
                                    css: (0, $b503o.styles)(theme).track.menu.options.list.ul,
                                    children: options && options.map(({ id: id, label: label, name: name, danger: danger, onClick: onOptionClick })=>/*#__PURE__*/ (0, $9awXB.jsx)("li", {
                                            css: (0, $b503o.styles)(theme).track.menu.options.list.li,
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                                css: [
                                                    (0, $b503o.styles)(theme).track.menu.options.list.button.shared,
                                                    danger ? (0, $b503o.styles)(theme).track.menu.options.list.button.danger : (0, $b503o.styles)(theme).track.menu.options.list.button.regular,
                                                    "",
                                                    ""
                                                ],
                                                onClick: (e)=>onOptionClick(e),
                                                type: "button",
                                                "aria-label": label,
                                                children: name
                                            })
                                        }, `track-option-${id}`))
                                })
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: [
                                    (0, $b503o.styles)(theme).track.menu.options.overlay.bottom.shared,
                                    isOptionsScrollStart && (0, $b503o.styles)(theme).track.menu.options.overlay.bottom.visible,
                                    "",
                                    ""
                                ],
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CaretDown, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$6564ed1f00059b4c$export$ea3bc8a15e6ef2d4.propTypes = {};

});
parcelRegister("b503o", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6324b2a30edd4447$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6324b2a30edd4447$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6324b2a30edd4447$var$_ref = {
    name: "qr8q5p",
    styles: "list-style:none"
};
var $6324b2a30edd4447$var$_ref2 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $6324b2a30edd4447$var$_ref3 = {
    name: "14ds6wq",
    styles: "visibility:visible;opacity:1"
};
var $6324b2a30edd4447$var$_ref4 = {
    name: "1ev2zwe",
    styles: "width:20px;height:6px"
};
var $6324b2a30edd4447$var$_ref5 = {
    name: "1o3sllj",
    styles: "position:relative;display:flex;align-items:center;justify-content:center;margin-left:16px"
};
var $6324b2a30edd4447$var$_ref6 = {
    name: "642qid",
    styles: "display:flex;flex-direction:column;min-width:0;margin-right:auto"
};
var $6324b2a30edd4447$var$_ref7 = {
    name: "1kr0l3f",
    styles: "display:flex;&>svg{width:20px;height:20px;}"
};
var $6324b2a30edd4447$var$_ref8 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
var $6324b2a30edd4447$var$_ref9 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $6324b2a30edd4447$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $6324b2a30edd4447$var$_ref9,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.card.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:20px;height:20px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                lock: {
                    main: $6324b2a30edd4447$var$_ref8,
                    icon: $6324b2a30edd4447$var$_ref7
                }
            },
            description: {
                main: $6324b2a30edd4447$var$_ref6,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            },
            menu: {
                main: $6324b2a30edd4447$var$_ref5,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;cursor:pointer;&>svg>path{transition:fill 0.2s;fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                icon: $6324b2a30edd4447$var$_ref4,
                options: {
                    main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.card.menu, ";position:absolute;right:100%;height:60px;min-width:80px;overflow-y:hidden;margin-right:10px;border-radius:4px;border:1px solid ", theme.colors.secondary.darker, ";", ""),
                    overlay: {
                        top: {
                            shared: /*#__PURE__*/ (0, $7hler.css)("position:absolute;top:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, " 0%,\n                ", theme.colors.primary.normal, "00 100%\n              );&>svg{height:10px;width:10px;transform:rotate(180deg);&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $6324b2a30edd4447$var$_ref3
                        },
                        bottom: {
                            shared: /*#__PURE__*/ (0, $7hler.css)("position:absolute;bottom:0;left:0;display:flex;align-items:center;justify-content:center;width:100%;height:12px;visibility:hidden;opacity:0;transition:visibility 0.2s,opacity 0.2s;background:linear-gradient(\n                180deg,\n                ", theme.colors.primary.normal, "00 0%,\n                ", theme.colors.primary.normal, " 100%\n              );&>svg{height:10px;width:10px;&>path{fill:", theme.colors.accent.normal, ";}}", ""),
                            visible: $6324b2a30edd4447$var$_ref2
                        }
                    },
                    list: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";height:60px;overflow-y:scroll;padding:4px 10px;background-color:", theme.colors.primary.darker, ";", ""),
                        ul: $6324b2a30edd4447$var$_ref,
                        li: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        button: {
                            shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:24px;cursor:pointer;font-weight:bold;white-space:nowrap;text-align:start;transition:color 0.2s;", ""),
                            regular: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.secondary.normal, ";&:hover{color:", theme.colors.accent.normal, ";}", ""),
                            danger: /*#__PURE__*/ (0, $7hler.css)("color:", theme.colors.negative.normal, ";&:hover{color:", theme.colors.negative.normalHover, ";}", "")
                        }
                    }
                }
            }
        }
    });

});


parcelRegister("l1klG", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploaded", function () { return $ccbf4cafad402fd3$export$ea0331f1c8aba3f7; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");

var $pJ22R = parcelRequire("pJ22R");
const $ccbf4cafad402fd3$export$ea0331f1c8aba3f7 = ({ track: track, editDisabled: editDisabled = false, deleteDisabled: deleteDisabled = false, onClick: onClick, onEditClick: onEditClick, onDeleteClick: onDeleteClick })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    const { coverId: coverId, name: trackName, genres: genres, visibility: visibility, likesCount: likesCount, unlocksCount: unlocksCount } = track;
    const trackHasCover = !!coverId;
    const source = (0, $jpNoL.useFile)(coverId || "");
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $pJ22R.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $pJ22R.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $pJ22R.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $pJ22R.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "play track",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Play, {})
                        })
                    }),
                    trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                        css: (0, $pJ22R.styles)(theme).track.cover.image,
                        onError: ()=>setCoverLoadError(true),
                        loading: "lazy",
                        width: "60px",
                        height: "60px",
                        src: source,
                        alt: "track album cover"
                    }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $pJ22R.styles)(theme).track.cover.placeholder,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $pJ22R.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $pJ22R.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $pJ22R.styles)(theme).track.description.author,
                        children: genres?.length ? genres?.map((genre, i)=>genres.length - 1 === i ? `${genre}` : `${genre}, `) : `-`
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $pJ22R.styles)(theme).track.description.stats.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                css: (0, $pJ22R.styles)(theme).track.description.stats.likes.main,
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $pJ22R.styles)(theme).track.description.stats.likes.icon,
                                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Heart, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $pJ22R.styles)(theme).track.description.stats.likes.count,
                                        children: (0, $1Fj5G.numbersFormatter)(likesCount || 0)
                                    })
                                ]
                            }),
                            visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                css: (0, $pJ22R.styles)(theme).track.description.stats.unlocks.main,
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $pJ22R.styles)(theme).track.description.stats.unlocks.icon,
                                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $pJ22R.styles)(theme).track.description.stats.unlocks.count,
                                        children: (0, $1Fj5G.numbersFormatter)(unlocksCount || 0)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $pJ22R.styles)(theme).track.options.main,
                children: [
                    onEditClick && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $pJ22R.styles)(theme).track.options.edit.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: [
                                (0, $pJ22R.styles)(theme).track.options.edit.button.shared,
                                editDisabled ? (0, $pJ22R.styles)(theme).track.options.edit.button.disabled : (0, $pJ22R.styles)(theme).track.options.edit.button.enabled,
                                "",
                                ""
                            ],
                            onClick: (e)=>onEditClick(e),
                            disabled: editDisabled,
                            type: "button",
                            "aria-label": "edit track",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Edit, {
                                css: (0, $pJ22R.styles)(theme).track.options.edit.icon
                            })
                        })
                    }),
                    onDeleteClick && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $pJ22R.styles)(theme).track.options.delete.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: [
                                (0, $pJ22R.styles)(theme).track.options.delete.button.shared,
                                deleteDisabled ? (0, $pJ22R.styles)(theme).track.options.delete.button.disabled : (0, $pJ22R.styles)(theme).track.options.delete.button.enabled,
                                "",
                                ""
                            ],
                            onClick: (e)=>onDeleteClick(e),
                            disabled: deleteDisabled,
                            type: "button",
                            "aria-label": "delete track",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Trash, {
                                css: (0, $pJ22R.styles)(theme).track.options.delete.icon
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$ccbf4cafad402fd3$export$ea0331f1c8aba3f7.propTypes = {};

});
parcelRegister("pJ22R", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $24317397faa1eafe$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $24317397faa1eafe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $24317397faa1eafe$var$_ref = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $24317397faa1eafe$var$_ref2 = {
    name: "18jsklt",
    styles: "margin-left:6px"
};
var $24317397faa1eafe$var$_ref3 = {
    name: "s689ky",
    styles: "width:20px;height:20px;&>path{transition:fill 0.2s,color 0.2s;}"
};
var $24317397faa1eafe$var$_ref4 = {
    name: "zjik7",
    styles: "display:flex"
};
var $24317397faa1eafe$var$_ref5 = {
    name: "1rc9f6v",
    styles: "display:flex;align-items:center;margin-right:4px;&>svg{width:10px;height:10px;}"
};
var $24317397faa1eafe$var$_ref6 = {
    name: "14u08z3",
    styles: "display:flex;min-width:0"
};
var $24317397faa1eafe$var$_ref7 = {
    name: "1rc9f6v",
    styles: "display:flex;align-items:center;margin-right:4px;&>svg{width:10px;height:10px;}"
};
var $24317397faa1eafe$var$_ref8 = {
    name: "1wjhvk5",
    styles: "display:flex;margin-right:8px;min-width:0"
};
var $24317397faa1eafe$var$_ref9 = {
    name: "zjik7",
    styles: "display:flex"
};
var $24317397faa1eafe$var$_ref10 = {
    name: "156y8ey",
    styles: "display:flex;flex-direction:column;height:60px;min-width:0;margin-right:auto"
};
var $24317397faa1eafe$var$_ref11 = {
    name: "1x17g94",
    styles: "display:flex;align-items:center;width:100%"
};
const $24317397faa1eafe$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $24317397faa1eafe$var$_ref11,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.card.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:20px;height:20px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $24317397faa1eafe$var$_ref10,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";margin-bottom:3px;", ""),
                stats: {
                    main: $24317397faa1eafe$var$_ref9,
                    likes: {
                        main: $24317397faa1eafe$var$_ref8,
                        icon: $24317397faa1eafe$var$_ref7,
                        count: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";", "")
                    },
                    unlocks: {
                        main: $24317397faa1eafe$var$_ref6,
                        icon: $24317397faa1eafe$var$_ref5,
                        count: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";", "")
                    }
                }
            },
            options: {
                main: $24317397faa1eafe$var$_ref4,
                edit: {
                    main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    button: {
                        shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;", ""),
                        disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                        enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                    },
                    icon: $24317397faa1eafe$var$_ref3
                },
                delete: {
                    main: $24317397faa1eafe$var$_ref2,
                    button: {
                        shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:30px;height:30px;", ""),
                        disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darker, ";}&:hover svg>path{fill:", theme.colors.secondary.darker, ";}", ""),
                        enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", "")
                    },
                    icon: $24317397faa1eafe$var$_ref
                }
            }
        }
    });

});


parcelRegister("3n4bn", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteModal", function () { return $b4559cf77b026b76$export$82da2a81a14d4a1; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("4wKY7");
var $cm5zk = parcelRequire("cm5zk");

var $bmLHn = parcelRequire("bmLHn");
const $b4559cf77b026b76$export$82da2a81a14d4a1 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackDeleteModalOpen = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackDeleteModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $bmLHn.styles)().modal.main,
        children: trackDeleteModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $2Vh5B.trackCloseTrackDeleteModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $bmLHn.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $cm5zk.TrackDeleteCard), {})
            })
        })
    });
};
$b4559cf77b026b76$export$82da2a81a14d4a1.propTypes = {};

});
parcelRegister("4wKY7", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteCard", function () { return (parcelRequire("cm5zk")).TrackDeleteCard; });

var $cm5zk = parcelRequire("cm5zk");

});
parcelRegister("cm5zk", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteCard", function () { return $60fe29f8505542eb$export$e44788248d8aa9e3; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("SgtkX");
var $hkJju = parcelRequire("hkJju");

var $3H9N0 = parcelRequire("3H9N0");
const $60fe29f8505542eb$export$e44788248d8aa9e3 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackDeleteError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $3H9N0.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3H9N0.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $2Vh5B.trackCloseTrackDeleteModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3H9N0.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Delete Track",
                    icon: (0, $bq9l8.icons).Trash
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $3H9N0.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Are you sure you want to delete your track?"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $3H9N0.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3H9N0.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $hkJju.TrackDeleteForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3H9N0.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: trackDeleteError
                        })
                    })
                ]
            })
        ]
    });
};
$60fe29f8505542eb$export$e44788248d8aa9e3.propTypes = {};

});
parcelRegister("SgtkX", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteForm", function () { return (parcelRequire("hkJju")).TrackDeleteForm; });

var $hkJju = parcelRequire("hkJju");

});
parcelRegister("hkJju", function(module, exports) {

$parcel$export(module.exports, "TrackDeleteForm", function () { return $c6f30b1cd76be746$export$2a935b72536776a1; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $9RPY9 = parcelRequire("9RPY9");
const $c6f30b1cd76be746$export$2a935b72536776a1 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackDeleteLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackDeleteLoading));
    const track = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackDeleteModalTrack));
    const submitDisabled = trackDeleteLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9RPY9.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $9RPY9.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $kwNyE.trackDelete)({
                    id: track?.id || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $9RPY9.styles)().form.content.track,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
                        track: track || {},
                        onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                                track: track
                            })),
                        onAuthorNameClick: ()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $9RPY9.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "delete track",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: trackDeleteLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Delete"
                    })
                })
            ]
        })
    });
};
$c6f30b1cd76be746$export$2a935b72536776a1.propTypes = {};

});
parcelRegister("9RPY9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e17f5ee81ffa6ab5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $e17f5ee81ffa6ab5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e17f5ee81ffa6ab5$var$_ref = {
    name: "mdhs63",
    styles: "display:flex;justify-content:center;margin-bottom:24px;& div{text-align:center;}& button{text-align:center;}"
};
const $e17f5ee81ffa6ab5$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                track: $e17f5ee81ffa6ab5$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("3H9N0", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d0df74b19d9bb23a$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $d0df74b19d9bb23a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d0df74b19d9bb23a$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d0df74b19d9bb23a$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d0df74b19d9bb23a$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d0df74b19d9bb23a$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $d0df74b19d9bb23a$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $d0df74b19d9bb23a$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $d0df74b19d9bb23a$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $d0df74b19d9bb23a$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $d0df74b19d9bb23a$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($d0df74b19d9bb23a$var$_ref8), " ", (0, $gln0L.mq).mobile($d0df74b19d9bb23a$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($d0df74b19d9bb23a$var$_ref6), ";", ""),
            title: $d0df74b19d9bb23a$var$_ref5,
            subtitle: $d0df74b19d9bb23a$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($d0df74b19d9bb23a$var$_ref3), ";", ""),
                form: $d0df74b19d9bb23a$var$_ref2,
                error: $d0df74b19d9bb23a$var$_ref
            }
        }
    });

});



parcelRegister("bmLHn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3b5f6353a5aa34ba$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $3b5f6353a5aa34ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3b5f6353a5aa34ba$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $3b5f6353a5aa34ba$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($3b5f6353a5aa34ba$var$_ref), ";", "")
        }
    });

});


parcelRegister("emkZ3", function(module, exports) {

$parcel$export(module.exports, "TrackListAudioPlaylist", function () { return $fbd8b815ea8724f6$export$ec9bc08769ce65b4; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $jAL4t = parcelRequire("jAL4t");
var $10e6J = parcelRequire("10e6J");
var $l5cm3 = parcelRequire("l5cm3");
var $7J6mb = parcelRequire("7J6mb");
var $2ahyr = parcelRequire("2ahyr");
var $2Vh5B = parcelRequire("2Vh5B");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $3JSbW = parcelRequire("3JSbW");
const $fbd8b815ea8724f6$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectTrackLikes));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const playlist = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectPlaylist));
    const playerAudioCurrentTrack = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrack));
    const playerAudioCurrentTrackPlaying = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrackPlaying));
    const track = playlist[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "track-list-audio-playlist-cover",
                    width: "60px",
                    height: "60px",
                    isStatic: true,
                    isDivider: false
                },
                {
                    name: "track-list-audio-playlist-divider",
                    width: "16px",
                    height: "60px",
                    isStatic: true,
                    isDivider: true
                },
                {
                    name: "track-list-audio-playlist-description",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    const { id: currentUserId, role: currentUserRole } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isCurrentUserAdmin = currentUserRole === (0, $2gpGl.EntityUserRole).Admin;
    const isContentLiked = trackLikes[trackId || ""];
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    const { id: playerAudioCurrentTrackId } = playerAudioCurrentTrack ?? {};
    const isTrackInProgress = trackId === playerAudioCurrentTrackId && playerAudioCurrentTrackPlaying;
    const likeOption = {
        id: (0, $itWch.uuid)(),
        label: "like track",
        name: "Like",
        onClick: ()=>dispatch((0, $4cq7L.likeCreateTrackLike)({
                track: track
            }))
    };
    const dislikeOption = {
        id: (0, $itWch.uuid)(),
        label: "dislike track",
        name: "Dislike",
        onClick: ()=>dispatch((0, $4cq7L.likeDeleteTrackLike)({
                track: track
            }))
    };
    const playOption = {
        id: (0, $itWch.uuid)(),
        label: "play track",
        name: "Play",
        onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                track: track
            }))
    };
    const unlockOption = {
        id: (0, $itWch.uuid)(),
        label: "unlock track",
        name: "Unlock",
        onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                track: track
            }))
    };
    const reportOption = {
        id: (0, $itWch.uuid)(),
        label: "report track",
        name: "Report",
        danger: true,
        onClick: ()=>dispatch((0, $10e6J.reportOpenReportTrackModal)({
                track: track
            }))
    };
    const blockOption = {
        id: (0, $itWch.uuid)(),
        label: "block track",
        name: "Block",
        danger: true,
        onClick: ()=>dispatch((0, $2Vh5B.trackOpenTrackBlockModal)({
                track: track
            }))
    };
    const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
    const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
    // there should never be locked track in playlist
    // the following block will guarantee this
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $3JSbW.styles)().list.row,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2ahyr.TrackCardLocked), {
            track: track,
            options: [
                unlockOption,
                likeDislikeOption,
                blockReportOption
            ],
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>{
                navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`);
                dispatch((0, $jAL4t.playerAudioSetClosed)());
            }
        })
    }, `playlist-track-${trackId}`);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $3JSbW.styles)().list.row,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7J6mb.TrackCard), {
            track: track,
            inProgress: isTrackInProgress,
            options: [
                playOption,
                likeDislikeOption,
                blockReportOption
            ],
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>{
                navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`);
                dispatch((0, $jAL4t.playerAudioSetClosed)());
            }
        })
    }, `playlist-track-${trackId}`);
});
const $fbd8b815ea8724f6$export$ec9bc08769ce65b4 = ()=>{
    const playlist = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectPlaylist));
    const playlistLength = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectPlaylistLength));
    const trackCardHeight = 60;
    const trackCardMarginBottom = 24;
    const itemHeight = trackCardHeight + trackCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 420;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!playlist[index];
    const loadMoreItems = ()=>{
    // (startIndex: number, stopIndex: number): void
    };
    // if playlist length is 0
    if (playlistLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $3JSbW.styles)().list.placeholder,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "100%",
            title: "There are no tracks in the playlist"
        })
    });
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $3JSbW.styles)().list.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: playlistLength || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: defaultListHeight,
                    itemSize: itemHeight,
                    itemCount: playlistLength || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "vertical",
                    children: $fbd8b815ea8724f6$var$Row
                })
        })
    }));
};
$fbd8b815ea8724f6$export$ec9bc08769ce65b4.propTypes = {};

});
parcelRegister("3JSbW", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $5fdec1a89fd93b78$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $5fdec1a89fd93b78$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $5fdec1a89fd93b78$var$_ref = {
    name: "uwo13w",
    styles: "width:100%;&:not(:last-of-type){margin-bottom:24px;}"
};
var $5fdec1a89fd93b78$var$_ref2 = {
    name: "13udsys",
    styles: "height:100%"
};
var $5fdec1a89fd93b78$var$_ref3 = {
    name: "1392zxw",
    styles: "width:100%;max-width:800px"
};
const $5fdec1a89fd93b78$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: $5fdec1a89fd93b78$var$_ref3,
            placeholder: $5fdec1a89fd93b78$var$_ref2,
            row: $5fdec1a89fd93b78$var$_ref
        },
        transactions: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("8MtZ5", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsExclusive", function () { return $5e09fa046dc280ad$export$e7efe7625e1c2404; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $kIHAy = parcelRequire("kIHAy");
const $5e09fa046dc280ad$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectExclusiveTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-charts-exclusive")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kIHAy.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kIHAy.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $5e09fa046dc280ad$export$e7efe7625e1c2404 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const exclusiveTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectExclusiveTracks));
    const exclusiveTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectExclusiveTracksCount));
    const exclusiveTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectExclusiveTracksLength));
    const exclusiveTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectExclusiveTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!exclusiveTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetExclusiveTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if exclusive tracks are fetched but length is 0
    if (exclusiveTracksFetched && exclusiveTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $bq9l8.icons).Lock,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: exclusiveTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $bq9l8.icons).Lock,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: exclusiveTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: exclusiveTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: exclusiveTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $5e09fa046dc280ad$var$Row
                })
        })
    });
};
$5e09fa046dc280ad$export$e7efe7625e1c2404.propTypes = {};

});
parcelRegister("kIHAy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $785986395227dcd5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $785986395227dcd5$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("lwHhz", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsLatest", function () { return $59a66a57e677710b$export$acecfac920d8c76a; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $6UltF = parcelRequire("6UltF");
const $59a66a57e677710b$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLatestTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-charts-latest")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $6UltF.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $6UltF.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $59a66a57e677710b$export$acecfac920d8c76a = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const latestTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLatestTracks));
    const latestTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLatestTracksCount));
    const latestTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLatestTracksLength));
    const latestTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLatestTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!latestTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetLatestTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if latest tracks are fetched but length is 0
    if (latestTracksFetched && latestTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $bq9l8.icons).Time,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: latestTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $bq9l8.icons).Time,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: latestTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: latestTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: latestTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $59a66a57e677710b$var$Row
                })
        })
    });
};
$59a66a57e677710b$export$acecfac920d8c76a.propTypes = {};

});
parcelRegister("6UltF", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $316371504f29d19f$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $316371504f29d19f$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("j1S8G", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsPopular", function () { return $36d7269c2ce3c450$export$30e557df93b79829; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $ig1lO = parcelRequire("ig1lO");
const $36d7269c2ce3c450$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-charts-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $ig1lO.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $ig1lO.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $36d7269c2ce3c450$export$30e557df93b79829 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const popularTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracks));
    const popularTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracksCount));
    const popularTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracksLength));
    const popularTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!popularTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetPopularTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if popular tracks are fetched but length is 0
    if (popularTracksFetched && popularTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $bq9l8.icons).Crown,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: popularTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $bq9l8.icons).Crown,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: popularTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: popularTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: popularTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $36d7269c2ce3c450$var$Row
                })
        })
    });
};
$36d7269c2ce3c450$export$30e557df93b79829.propTypes = {};

});
parcelRegister("ig1lO", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2fbe5f0bae3762a9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $2fbe5f0bae3762a9$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("3URn4", function(module, exports) {

$parcel$export(module.exports, "TrackListChartsTrending", function () { return $1070292b11f6cc06$export$db7b83a649dd398c; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $9sxez = parcelRequire("9sxez");
const $1070292b11f6cc06$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrendingTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-charts-trending")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9sxez.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9sxez.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $1070292b11f6cc06$export$db7b83a649dd398c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trendingTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrendingTracks));
    const trendingTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrendingTracksCount));
    const trendingTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrendingTracksLength));
    const trendingTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrendingTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!trendingTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetTrendingTracks)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if trending tracks are fetched but length is 0
    if (trendingTracksFetched && trendingTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Trending",
        icon: (0, $bq9l8.icons).Fire,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: trendingTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Trending",
        icon: (0, $bq9l8.icons).Fire,
        overrideCss: (0, $3sxbD.contentLayout).charts,
        itemWidth: itemWidth,
        itemsCount: trendingTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: trendingTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: trendingTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $1070292b11f6cc06$var$Row
                })
        })
    });
};
$1070292b11f6cc06$export$db7b83a649dd398c.propTypes = {};

});
parcelRegister("9sxez", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $0665a8b2a90a6390$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $0665a8b2a90a6390$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("kmm86", function(module, exports) {

$parcel$export(module.exports, "TrackListFeedPopular", function () { return $40729a262b00c6c4$export$26b62bc63ee81545; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $jAL4t = parcelRequire("jAL4t");
var $10e6J = parcelRequire("10e6J");
var $l5cm3 = parcelRequire("l5cm3");
var $7J6mb = parcelRequire("7J6mb");
var $fTQqS = parcelRequire("fTQqS");
var $2ahyr = parcelRequire("2ahyr");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $er8Um = parcelRequire("er8Um");
const $40729a262b00c6c4$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectTrackLikes));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTQqS.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $er8Um.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $2gpGl.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $itWch.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $4cq7L.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $itWch.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $4cq7L.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $itWch.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $itWch.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $itWch.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $10e6J.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $itWch.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $2Vh5B.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $er8Um.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2ahyr.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `popular-track-${trackId}`);
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $er8Um.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7J6mb.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `popular-track-${trackId}`);
        })
    });
});
const $40729a262b00c6c4$export$26b62bc63ee81545 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const popularTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracks));
    const popularTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPopularTracksCount));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(popularTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!popularTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetPopularTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: popularTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $40729a262b00c6c4$var$Row
                })
        })
    });
};
$40729a262b00c6c4$export$26b62bc63ee81545.propTypes = {};

});
parcelRegister("er8Um", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $eae3e0d8c2947444$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $eae3e0d8c2947444$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $eae3e0d8c2947444$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $eae3e0d8c2947444$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $eae3e0d8c2947444$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $gln0L.mq).mobile($eae3e0d8c2947444$var$_ref2), ";", ""),
            row: $eae3e0d8c2947444$var$_ref
        }
    });

});


parcelRegister("c0j9Z", function(module, exports) {

$parcel$export(module.exports, "TrackListFeedRecommended", function () { return $b5933dfafc668df9$export$19583a68693e044c; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $jAL4t = parcelRequire("jAL4t");
var $10e6J = parcelRequire("10e6J");
var $l5cm3 = parcelRequire("l5cm3");
var $7J6mb = parcelRequire("7J6mb");
var $fTQqS = parcelRequire("fTQqS");
var $2ahyr = parcelRequire("2ahyr");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $cSbVS = parcelRequire("cSbVS");
const $b5933dfafc668df9$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectTrackLikes));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectRecommendedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTQqS.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $cSbVS.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $2gpGl.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $itWch.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $4cq7L.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $itWch.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $4cq7L.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $itWch.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $itWch.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $itWch.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $10e6J.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $itWch.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $2Vh5B.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cSbVS.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2ahyr.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `recommended-track-${trackId}`);
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $cSbVS.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7J6mb.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `recommended-track-${trackId}`);
        })
    });
});
const $b5933dfafc668df9$export$19583a68693e044c = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const recommendedTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectRecommendedTracks));
    const recommendedTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectRecommendedTracksCount));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(recommendedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!recommendedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetRecommendedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: recommendedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $b5933dfafc668df9$var$Row
                })
        })
    });
};
$b5933dfafc668df9$export$19583a68693e044c.propTypes = {};

});
parcelRegister("cSbVS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8c340ebce7142f9e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $8c340ebce7142f9e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8c340ebce7142f9e$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $8c340ebce7142f9e$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $8c340ebce7142f9e$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $gln0L.mq).mobile($8c340ebce7142f9e$var$_ref2), ";", ""),
            row: $8c340ebce7142f9e$var$_ref
        }
    });

});


parcelRegister("lIbIZ", function(module, exports) {

$parcel$export(module.exports, "TrackListHomePublic", function () { return $9175fda096567df1$export$ac9d15d4a41675c1; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $7J6mb = parcelRequire("7J6mb");
var $fTQqS = parcelRequire("fTQqS");
var $2ahyr = parcelRequire("2ahyr");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $jOApy = parcelRequire("jOApy");
const $9175fda096567df1$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPublicTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTQqS.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $jOApy.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: trackId, visibility: visibility } = track;
            const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
            const renderLocked = isContentLocked;
            const likeOption = {
                id: (0, $itWch.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)())
            };
            const playOption = {
                id: (0, $itWch.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)())
            };
            const unlockOption = {
                id: (0, $itWch.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)())
            };
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jOApy.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2ahyr.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeOption
                    ],
                    onClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)()),
                    onAuthorNameClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)())
                })
            }, `public-track-${trackId}`);
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jOApy.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7J6mb.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeOption
                    ],
                    onClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)()),
                    onAuthorNameClick: ()=>dispatch((0, $9HBOX.authOpenJoinModal)())
                })
            }, `public-track-${trackId}`);
        })
    });
});
const $9175fda096567df1$export$ac9d15d4a41675c1 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const publicTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPublicTracks));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 60;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    const isItemLoaded = (index)=>!!publicTracks[index];
    const loadMoreItems = ()=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetPublicTracks)());
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular Tracks",
        overrideCss: (0, $3sxbD.contentLayout).home,
        itemWidth: itemWidth,
        itemsCount: defaultItemsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: defaultItemsCount / subsetLength,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: defaultItemsCount / subsetLength,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $9175fda096567df1$var$Row
                })
        })
    });
};
$9175fda096567df1$export$ac9d15d4a41675c1.propTypes = {};

});
parcelRegister("jOApy", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $deded4f7d6bc33c5$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $deded4f7d6bc33c5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $deded4f7d6bc33c5$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $deded4f7d6bc33c5$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $deded4f7d6bc33c5$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $gln0L.mq).mobile($deded4f7d6bc33c5$var$_ref2), ";", ""),
            row: $deded4f7d6bc33c5$var$_ref
        }
    });

});


parcelRegister("j4ytf", function(module, exports) {

$parcel$export(module.exports, "TrackListLibraryLiked", function () { return $9e2f80244455029a$export$d5cae4b9c49533cf; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $jAL4t = parcelRequire("jAL4t");
var $10e6J = parcelRequire("10e6J");
var $l5cm3 = parcelRequire("l5cm3");
var $7J6mb = parcelRequire("7J6mb");
var $fTQqS = parcelRequire("fTQqS");
var $2ahyr = parcelRequire("2ahyr");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $gnB0h = parcelRequire("gnB0h");
const $9e2f80244455029a$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectTrackLikes));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLikedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTQqS.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gnB0h.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $2gpGl.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $itWch.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $4cq7L.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $itWch.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $4cq7L.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $itWch.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $itWch.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $itWch.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $10e6J.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $itWch.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $2Vh5B.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gnB0h.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2ahyr.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `liked-track-${trackId}`);
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $gnB0h.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7J6mb.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `liked-track-${trackId}`);
        })
    });
});
const $9e2f80244455029a$export$d5cae4b9c49533cf = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const likedTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLikedTracks));
    const likedTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLikedTracksCount));
    const likedTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLikedTracksLength));
    const likedTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectLikedTracksFetched));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(likedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!likedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetLikedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    // if liked tracks are fetched but length is 0
    if (likedTracksFetched && likedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Liked Tracks",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "228px",
            title: "You haven't liked any track yet"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Liked Tracks",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: likedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $9e2f80244455029a$var$Row
                })
        })
    });
};
$9e2f80244455029a$export$d5cae4b9c49533cf.propTypes = {};

});
parcelRegister("gnB0h", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6c4cf4ad67cbbe29$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6c4cf4ad67cbbe29$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6c4cf4ad67cbbe29$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $6c4cf4ad67cbbe29$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $6c4cf4ad67cbbe29$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $gln0L.mq).mobile($6c4cf4ad67cbbe29$var$_ref2), ";", ""),
            row: $6c4cf4ad67cbbe29$var$_ref
        }
    });

});


parcelRegister("1XeI9", function(module, exports) {

$parcel$export(module.exports, "TrackListLibraryUnlocked", function () { return $3a1e5dc828954a69$export$79691f6799fd6030; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $jAL4t = parcelRequire("jAL4t");
var $10e6J = parcelRequire("10e6J");
var $l5cm3 = parcelRequire("l5cm3");
var $7J6mb = parcelRequire("7J6mb");
var $fTQqS = parcelRequire("fTQqS");
var $2ahyr = parcelRequire("2ahyr");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $jXQjX = parcelRequire("jXQjX");
const $3a1e5dc828954a69$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectTrackLikes));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUnlockedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTQqS.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $jXQjX.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: currentUserId, role: currentUserRole } = profile ?? {};
            const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
            const isCurrentUserAdmin = currentUserRole === (0, $2gpGl.EntityUserRole).Admin;
            const isContentLiked = trackLikes[trackId || ""];
            const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
            const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
            const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
            const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
            const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
            const likeOption = {
                id: (0, $itWch.uuid)(),
                label: "like track",
                name: "Like",
                onClick: ()=>dispatch((0, $4cq7L.likeCreateTrackLike)({
                        track: track
                    }))
            };
            const dislikeOption = {
                id: (0, $itWch.uuid)(),
                label: "dislike track",
                name: "Dislike",
                onClick: ()=>dispatch((0, $4cq7L.likeDeleteTrackLike)({
                        track: track
                    }))
            };
            const playOption = {
                id: (0, $itWch.uuid)(),
                label: "play track",
                name: "Play",
                onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                        track: track
                    }))
            };
            const unlockOption = {
                id: (0, $itWch.uuid)(),
                label: "unlock track",
                name: "Unlock",
                onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                        track: track
                    }))
            };
            const reportOption = {
                id: (0, $itWch.uuid)(),
                label: "report track",
                name: "Report",
                danger: true,
                onClick: ()=>dispatch((0, $10e6J.reportOpenReportTrackModal)({
                        track: track
                    }))
            };
            const blockOption = {
                id: (0, $itWch.uuid)(),
                label: "block track",
                name: "Block",
                danger: true,
                onClick: ()=>dispatch((0, $2Vh5B.trackOpenTrackBlockModal)({
                        track: track
                    }))
            };
            const likeDislikeOption = isContentLiked ? dislikeOption : likeOption;
            const blockReportOption = isCurrentUserAdmin ? blockOption : reportOption;
            // if content is locked
            if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jXQjX.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $2ahyr.TrackCardLocked), {
                    track: track,
                    options: [
                        unlockOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `unlocked-track-${trackId}`);
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jXQjX.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7J6mb.TrackCard), {
                    track: track,
                    options: [
                        playOption,
                        likeDislikeOption,
                        blockReportOption
                    ],
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
                })
            }, `unlocked-track-${trackId}`);
        })
    });
});
const $3a1e5dc828954a69$export$79691f6799fd6030 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const unlockedTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUnlockedTracks));
    const unlockedTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUnlockedTracksCount));
    const unlockedTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUnlockedTracksLength));
    const unlockedTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUnlockedTracksFetched));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(unlockedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!unlockedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetUnlockedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    // if liked tracks are fetched but length is 0
    if (unlockedTracksFetched && unlockedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Unlocked Tracks",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "228px",
            title: "You haven't unlocked any track yet"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Unlocked Tracks",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: unlockedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $3a1e5dc828954a69$var$Row
                })
        })
    });
};
$3a1e5dc828954a69$export$79691f6799fd6030.propTypes = {};

});
parcelRegister("jXQjX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a0b30426cd123849$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $a0b30426cd123849$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a0b30426cd123849$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $a0b30426cd123849$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $a0b30426cd123849$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $gln0L.mq).mobile($a0b30426cd123849$var$_ref2), ";", ""),
            row: $a0b30426cd123849$var$_ref
        }
    });

});


parcelRegister("gRqmZ", function(module, exports) {

$parcel$export(module.exports, "TrackListOnboardingUploaded", function () { return $ca987935840c235b$export$d411a758a723e3fd; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");
parcelRequire("myWHj");
var $k7z52 = parcelRequire("k7z52");
var $ikzUI = parcelRequire("ikzUI");

var $izPxM = parcelRequire("izPxM");
const $ca987935840c235b$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackDeleteLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackDeleteLoading));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ikzUI.TrackCardUploadedSkeleton), {})
    });
    const { id: trackId } = track;
    // if track is loading - artist should not be able to delete it
    const deleteDisabled = trackDeleteLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $izPxM.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $k7z52.TrackCardUploaded), {
            track: track,
            deleteDisabled: deleteDisabled,
            onDelete: ()=>dispatch((0, $kwNyE.trackDelete)({
                    id: trackId || ""
                }))
        })
    });
});
const $ca987935840c235b$export$d411a758a723e3fd = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const uploadedTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracks));
    const uploadedTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksCount));
    const trackBlockWidth = 330;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 72;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 700;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!uploadedTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetUploadedTracks)({
            limit: 30,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Uploaded Tracks",
        overrideCss: (0, $3sxbD.contentLayout).onboarding,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: uploadedTracksCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: uploadedTracksCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $ca987935840c235b$var$Row
                })
        })
    });
};
$ca987935840c235b$export$d411a758a723e3fd.propTypes = {};

});
parcelRegister("myWHj", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploaded", function () { return (parcelRequire("k7z52")).TrackCardUploaded; });
$parcel$export(module.exports, "TrackCardUploadedSkeleton", function () { return (parcelRequire("ikzUI")).TrackCardUploadedSkeleton; });

var $k7z52 = parcelRequire("k7z52");

var $ikzUI = parcelRequire("ikzUI");

});
parcelRegister("k7z52", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploaded", function () { return $19a2cb5244e8a91c$export$ea0331f1c8aba3f7; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $aj7N5 = parcelRequire("aj7N5");
const $19a2cb5244e8a91c$export$ea0331f1c8aba3f7 = ({ track: track, deleteDisabled: deleteDisabled, onDelete: onDelete })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    const { userId: userId, coverId: coverId, name: name } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    const trackHasCover = !!coverId;
    const source = (0, $jpNoL.useFile)(coverId || "");
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $aj7N5.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $aj7N5.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $aj7N5.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "60px",
                    height: "60px",
                    src: source,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {
                    css: (0, $aj7N5.styles)(theme).track.cover.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $aj7N5.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $aj7N5.styles)(theme).track.description.name,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                        css: (0, $aj7N5.styles)(theme).track.description.author,
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $aj7N5.styles)(theme).track.delete.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                    css: [
                        (0, $aj7N5.styles)(theme).track.delete.button.shared,
                        deleteDisabled ? (0, $aj7N5.styles)(theme).track.delete.button.disabled : (0, $aj7N5.styles)(theme).track.delete.button.enabled,
                        "",
                        ""
                    ],
                    onClick: (e)=>onDelete(e),
                    disabled: deleteDisabled,
                    type: "button",
                    "aria-label": "delete track",
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Trash, {
                        css: (0, $aj7N5.styles)(theme).track.delete.button.icon
                    })
                })
            })
        ]
    });
};
$19a2cb5244e8a91c$export$ea0331f1c8aba3f7.propTypes = {};

});
parcelRegister("aj7N5", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $941de47077910198$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $941de47077910198$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $941de47077910198$var$_ref = {
    name: "1aynuae",
    styles: "width:20px;height:20px"
};
var $941de47077910198$var$_ref2 = {
    name: "1k9kcx9",
    styles: "display:flex;align-items:center;justify-content:center;margin-left:16px"
};
var $941de47077910198$var$_ref3 = {
    name: "642qid",
    styles: "display:flex;flex-direction:column;min-width:0;margin-right:auto"
};
var $941de47077910198$var$_ref4 = {
    name: "z8hc5m",
    styles: "display:flex;align-items:center;width:330px"
};
const $941de47077910198$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $941de47077910198$var$_ref4,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:60px;height:60px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:16px;&:hover>div{opacity:1;}", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}", "")
            },
            description: {
                main: $941de47077910198$var$_ref3,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";", "")
            },
            delete: {
                main: $941de47077910198$var$_ref2,
                button: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:30px;height:30px;&>svg>path{transition:fill 0.2s,color 0.2s;}", ""),
                    disabled: /*#__PURE__*/ (0, $7hler.css)("cursor:not-allowed;&>svg>path{fill:", theme.colors.secondary.darkHover, ";}&:hover svg>path{fill:", theme.colors.secondary.darkHover, ";}", ""),
                    enabled: /*#__PURE__*/ (0, $7hler.css)("cursor:pointer;&>svg>path{fill:", theme.colors.secondary.normal, ";}&:hover svg>path{fill:", theme.colors.accent.normal, ";}", ""),
                    icon: $941de47077910198$var$_ref
                }
            }
        }
    });

});


parcelRegister("ikzUI", function(module, exports) {

$parcel$export(module.exports, "TrackCardUploadedSkeleton", function () { return $80e7202fef201f22$export$db670e5716b3f9cf; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $agLka = parcelRequire("agLka");
const $80e7202fef201f22$export$db670e5716b3f9cf = ()=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $agLka.styles)(theme).skeleton.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $agLka.styles)(theme).skeleton.cover
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $agLka.styles)(theme).skeleton.divider
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $agLka.styles)(theme).skeleton.description
            })
        ]
    });
};
$80e7202fef201f22$export$db670e5716b3f9cf.propTypes = {};

});
parcelRegister("agLka", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f5a132d75aba7b43$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $f5a132d75aba7b43$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;width:330px;border-radius:4px;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $gln0L.kf).load.shine(-60, 0), ";", ""),
            cover: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;display:flex;width:60px;height:60px;opacity:0.4;border-top-left-radius:4px;border-bottom-left-radius:4px;background-color:", theme.colors.primary.darker, ";", ""),
            divider: /*#__PURE__*/ (0, $7hler.css)("height:60px;width:16px;background-color:", theme.colors.primary.normal, ";", ""),
            description: /*#__PURE__*/ (0, $7hler.css)("flex:1;height:60px;opacity:0.4;border-top-right-radius:4px;border-bottom-right-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
        }
    });

});



parcelRegister("izPxM", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7060b8bc86d0a4a8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $7060b8bc86d0a4a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7060b8bc86d0a4a8$var$_ref = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $7060b8bc86d0a4a8$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).mobile($7060b8bc86d0a4a8$var$_ref), ";", "")
        }
    });

});


parcelRegister("jFCU5", function(module, exports) {

$parcel$export(module.exports, "TrackListPost", function () { return $925d1dfad21247b7$export$6f7408809d010bed; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $a0vy2 = parcelRequire("a0vy2");
var $l5cm3 = parcelRequire("l5cm3");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $gtqtE = parcelRequire("gtqtE");
const $925d1dfad21247b7$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPostTracks));
    const track = tracks?.[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-post")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gtqtE.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gtqtE.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $925d1dfad21247b7$export$6f7408809d010bed = ()=>{
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const postUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectPostUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const post = (0, $gNvvs.useAppSelector)((0, $a0vy2.postSelectPost));
    const postTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPostTracks));
    const postTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectPostTracksFetched));
    const postTracksCount = postTracks?.length || 0;
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!postTracks?.[index];
    const loadMoreItems = ()=>{
    // (startIndex: number, stopIndex: number): void
    };
    const { id: profileUserId } = profile ?? {};
    const { id: postId, userId: postAuthorUserId, visibility: visibility } = post ?? {};
    const isContentLocked = visibility === (0, $2gpGl.EntityPostVisibility).Subscribers;
    const isCurrentUserContentAuthor = profileUserId === postAuthorUserId;
    const isCurrentUserUnlockedContent = postUnlocks[postId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[postAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if post is locked
    if (renderLocked) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).post.current,
        itemWidth: itemWidth,
        itemsCount: 0,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).Lock,
            height: "230px",
            title: "Content is locked"
        })
    });
    // if post tracks fetched but count is 0
    if (postTracksFetched && postTracksCount === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).post.current,
        itemWidth: itemWidth,
        itemsCount: postTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "This post doesn't have any tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).post.current,
        itemWidth: itemWidth,
        itemsCount: postTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: postTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: postTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $925d1dfad21247b7$var$Row
                })
        })
    });
};
$925d1dfad21247b7$export$6f7408809d010bed.propTypes = {};

});
parcelRegister("gtqtE", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9691c7417b679a7e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $9691c7417b679a7e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9691c7417b679a7e$var$_ref = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $9691c7417b679a7e$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).mobile($9691c7417b679a7e$var$_ref), ";", "")
        }
    });

});


parcelRegister("awTAN", function(module, exports) {

$parcel$export(module.exports, "TrackListStudioPostUploaded", function () { return $b1469553ce897f9a$export$1e70de97f8d41367; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $ip1Fa = parcelRequire("ip1Fa");
var $5zZt1 = parcelRequire("5zZt1");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $kc26I = parcelRequire("kc26I");
const $b1469553ce897f9a$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style, data: data })=>{
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-studio-post-uploaded")
        })
    });
    // parent provided props
    const { postTracks: postTracks, addPostTrack: addPostTrack, removePostTrack: removePostTrack } = data;
    const { id: trackId } = track;
    const isTrackAdded = postTracks.findIndex((t)=>t.id === trackId) !== -1;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kc26I.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ip1Fa.TrackTileSelect), {
            track: track,
            selected: isTrackAdded,
            onClick: ()=>isTrackAdded ? removePostTrack(trackId || "") : addPostTrack(track),
            onAuthorNameClick: ()=>{}
        })
    });
});
const $b1469553ce897f9a$export$1e70de97f8d41367 = ({ postTracks: postTracks, addPostTrack: addPostTrack, removePostTrack: removePostTrack })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const uploadedTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracks));
    const uploadedTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksCount));
    const uploadedTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksLength));
    const uploadedTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!uploadedTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetUploadedTracks)({
            limit: 30,
            offset: startIndex
        }));
    };
    // if uploaded tracks are fetched but length is 0
    if (uploadedTracksFetched && uploadedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).post.create,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any uploaded tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).post.create,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: uploadedTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: uploadedTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    itemData: {
                        postTracks: postTracks,
                        addPostTrack: addPostTrack,
                        removePostTrack: removePostTrack
                    },
                    children: $b1469553ce897f9a$var$Row
                })
        })
    });
};
$b1469553ce897f9a$export$1e70de97f8d41367.propTypes = {};

});
parcelRegister("kc26I", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $fdd743906a5a98b1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $fdd743906a5a98b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $fdd743906a5a98b1$var$_ref = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $fdd743906a5a98b1$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).mobile($fdd743906a5a98b1$var$_ref), ";", "")
        }
    });

});


parcelRegister("8jd1H", function(module, exports) {

$parcel$export(module.exports, "TrackListStudioUploaded", function () { return $2eefbefceb23d4a6$export$f3239ff3c0d33624; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $jAL4t = parcelRequire("jAL4t");
var $fTQqS = parcelRequire("fTQqS");
var $l1klG = parcelRequire("l1klG");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $eFl1e = parcelRequire("eFl1e");
const $2eefbefceb23d4a6$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackDeleteLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackDeleteLoading));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracks));
    const subsetLength = 3;
    // create subset
    const subset = tracks.slice(index * subsetLength, index * subsetLength + subsetLength);
    // if tracks not fetched
    if (subset.length === 0) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fTQqS.TrackCardBlockSkeleton), {})
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $eFl1e.styles)().tracks.main,
        style: style,
        children: subset.map((track)=>{
            const { id: trackId, visibility: visibility } = track;
            // if track is locked or loading - artist should not be able to delete it
            const deleteDisabled = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers || trackDeleteLoading;
            return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $eFl1e.styles)().tracks.row,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l1klG.TrackCardUploaded), {
                    track: track,
                    deleteDisabled: deleteDisabled,
                    onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                            track: track
                        })),
                    onEditClick: ()=>navigate(`${(0, $b7fnN.Path).Studio}${(0, $b7fnN.Path).Track}/${trackId}`),
                    onDeleteClick: ()=>dispatch((0, $2Vh5B.trackOpenTrackDeleteModal)({
                            track: track
                        }))
                })
            }, `uploaded-track-${trackId}`);
        })
    });
});
const $2eefbefceb23d4a6$export$f3239ff3c0d33624 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const uploadedTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracks));
    const uploadedTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksCount));
    const uploadedTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksLength));
    const uploadedTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracksFetched));
    const trackBlockWidth = 280;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 228;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const subsetLength = 3; // for each 3 items render one item block
    // items to render in virtualized list
    // each track item holds 3 tracks
    // ceil lets us render required amount of items
    // e.g. if items count is 4: ceil(4/3) = 2 items to render
    // 3 items in first block, 1 item in second
    const itemsCount = Math.ceil(uploadedTracksCount / subsetLength);
    const isItemLoaded = (index)=>!!uploadedTracks[index * subsetLength];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetUploadedTracks)({
            limit: itemsToFetch * subsetLength,
            offset: startIndex * subsetLength
        }));
    };
    // if popular tracks are fetched but length is 0
    if (uploadedTracksFetched && uploadedTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: defaultItemsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any uploaded tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Tracks",
        overrideCss: (0, $3sxbD.contentLayout).studio,
        itemWidth: itemWidth,
        itemsCount: uploadedTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: itemsCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: itemsCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $2eefbefceb23d4a6$var$Row
                })
        })
    });
};
$2eefbefceb23d4a6$export$f3239ff3c0d33624.propTypes = {};

});
parcelRegister("eFl1e", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $39f103b64c4eabf1$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $39f103b64c4eabf1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $39f103b64c4eabf1$var$_ref = {
    name: "16s5rj8",
    styles: "width:280px"
};
var $39f103b64c4eabf1$var$_ref2 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
const $39f103b64c4eabf1$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("&>div:not(:last-of-type){margin-bottom:24px;}", (0, $gln0L.mq).mobile($39f103b64c4eabf1$var$_ref2), ";", ""),
            row: $39f103b64c4eabf1$var$_ref
        }
    });

});


parcelRegister("cfBsJ", function(module, exports) {

$parcel$export(module.exports, "TrackListUserExclusive", function () { return $d0199bd3118340c3$export$debff8c2e21f4bfa; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $42Fd5 = parcelRequire("42Fd5");
const $d0199bd3118340c3$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistExclusiveTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-user-exclusive")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if content is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $42Fd5.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $42Fd5.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $d0199bd3118340c3$export$debff8c2e21f4bfa = ()=>{
    const { userId: userId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const artistExclusiveTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistExclusiveTracks));
    const artistExclusiveTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistExclusiveTracksCount));
    const artistExclusiveTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistExclusiveTracksLength));
    const artistExclusiveTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistExclusiveTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistExclusiveTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetArtistExclusiveTracks)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if exclusive tracks are fetched but length is 0
    if (artistExclusiveTracksFetched && artistExclusiveTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $bq9l8.icons).Lock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusiveTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any exclusive tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Exclusive",
        icon: (0, $bq9l8.icons).Lock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistExclusiveTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistExclusiveTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistExclusiveTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $d0199bd3118340c3$var$Row
                })
        })
    });
};
$d0199bd3118340c3$export$debff8c2e21f4bfa.propTypes = {};

});
parcelRegister("42Fd5", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $86ec8e0a83284454$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $86ec8e0a83284454$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("gGXoQ", function(module, exports) {

$parcel$export(module.exports, "TrackListUserLatest", function () { return $0a477a2f05cd9958$export$6898c25b2545cad1; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $hENoI = parcelRequire("hENoI");
const $0a477a2f05cd9958$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistLatestTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-user-latest")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if track is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $hENoI.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $hENoI.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $0a477a2f05cd9958$export$6898c25b2545cad1 = ()=>{
    const { userId: userId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const artistLatestTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistLatestTracks));
    const artistLatestTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistLatestTracksCount));
    const artistLatestTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistLatestTracksLength));
    const artistLatestTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistLatestTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistLatestTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetArtistLatestTracks)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if latest tracks are fetched but length is 0
    if (artistLatestTracksFetched && artistLatestTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $bq9l8.icons).Clock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any latest tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Latest",
        icon: (0, $bq9l8.icons).Clock,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistLatestTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistLatestTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistLatestTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $0a477a2f05cd9958$var$Row
                })
        })
    });
};
$0a477a2f05cd9958$export$6898c25b2545cad1.propTypes = {};

});
parcelRegister("hENoI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2aba5017300cd8fa$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $2aba5017300cd8fa$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("59H0L", function(module, exports) {

$parcel$export(module.exports, "TrackListUserPopular", function () { return $db6bcbb2b355da56$export$5ae5dcf205976d6b; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
var $377Y6 = parcelRequire("377Y6");
var $9NbFe = parcelRequire("9NbFe");
var $5zZt1 = parcelRequire("5zZt1");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");

var $f27h9 = parcelRequire("f27h9");
const $db6bcbb2b355da56$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackUnlocks = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectTrackUnlocks));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const tracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistPopularTracks));
    const track = tracks[index];
    // if track not fetched
    if (!track) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "180px",
            sections: (0, $5zZt1.trackUtilGetTrackTileSkeletonSections)("track-list-user-popular")
        })
    });
    const { id: currentUserId } = profile ?? {};
    const { id: trackId, userId: trackAuthorUserId, visibility: visibility } = track;
    const isContentLocked = visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers;
    const isCurrentUserContentAuthor = currentUserId === trackAuthorUserId;
    const isCurrentUserUnlockedContent = trackUnlocks[trackId || ""];
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const renderLocked = isContentLocked && !isCurrentUserContentAuthor && !isCurrentUserUnlockedContent && !isCurrentUserSubscribedToContentAuthor;
    // if track is locked
    if (renderLocked) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $f27h9.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9NbFe.TrackTileLocked), {
            track: track,
            onClick: ()=>dispatch((0, $8aXib.unlockOpenUnlockTrackModal)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $f27h9.styles)().tracks.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $377Y6.TrackTile), {
            track: track,
            onClick: ()=>dispatch((0, $jAL4t.playerAudioSetCurrentTrack)({
                    track: track
                })),
            onAuthorNameClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`)
        })
    });
});
const $db6bcbb2b355da56$export$5ae5dcf205976d6b = ()=>{
    const { userId: userId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const artistPopularTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistPopularTracks));
    const artistPopularTracksCount = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistPopularTracksCount));
    const artistPopularTracksLength = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistPopularTracksLength));
    const artistPopularTracksFetched = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectArtistPopularTracksFetched));
    const trackBlockWidth = 180;
    const trackBlockMarginRight = 20;
    const itemWidth = trackBlockWidth + trackBlockMarginRight;
    const trackBlockHeight = 230;
    const trackBlockMarginBottom = 0;
    const itemHeight = trackBlockHeight + trackBlockMarginBottom;
    const defaultItemsCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!artistPopularTracks[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $kwNyE.trackGetArtistPopularTracks)({
            artistId: userId,
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if popular tracks are fetched but length is 0
    if (artistPopularTracksFetched && artistPopularTracksLength === 0) // return place holder
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $bq9l8.icons).Crown,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).MusicNotes,
            height: "230px",
            title: "Couldn't find any popular tracks"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular",
        icon: (0, $bq9l8.icons).Crown,
        overrideCss: (0, $3sxbD.contentLayout).user,
        itemWidth: itemWidth,
        itemsCount: artistPopularTracksCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: artistPopularTracksCount || defaultItemsCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: artistPopularTracksCount || defaultItemsCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $db6bcbb2b355da56$var$Row
                })
        })
    });
};
$db6bcbb2b355da56$export$5ae5dcf205976d6b.propTypes = {};

});
parcelRegister("f27h9", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bdd8762a69a24849$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
const $bdd8762a69a24849$export$9dd6ff9ea0189349 = ()=>({
        tracks: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("377Y6", function(module, exports) {

$parcel$export(module.exports, "TrackTile", function () { return $4254c89f78f11fdb$export$54426ddde2f6035e; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $3gue7 = parcelRequire("3gue7");
const $4254c89f78f11fdb$export$54426ddde2f6035e = ({ track: track, onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    const { coverId: coverId, name: trackName, userId: userId } = track;
    const trackHasCover = !!coverId;
    const source = (0, $jpNoL.useFile)(coverId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $3gue7.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $3gue7.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3gue7.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $3gue7.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "play track",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Play, {})
                        })
                    }),
                    trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                        css: (0, $3gue7.styles)(theme).track.cover.image,
                        onError: ()=>setCoverLoadError(true),
                        loading: "lazy",
                        width: "180px",
                        height: "180px",
                        src: source,
                        alt: "track album cover"
                    }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3gue7.styles)(theme).track.cover.placeholder,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $3gue7.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $3gue7.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $3gue7.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$4254c89f78f11fdb$export$54426ddde2f6035e.propTypes = {};

});
parcelRegister("3gue7", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6c2392bc25b48215$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6c2392bc25b48215$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6c2392bc25b48215$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $6c2392bc25b48215$var$_ref2 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $6c2392bc25b48215$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $6c2392bc25b48215$var$_ref2,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-bottom:10px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.tile.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:30px;height:30px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>svg{width:30px;height:30px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $6c2392bc25b48215$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("9NbFe", function(module, exports) {

$parcel$export(module.exports, "TrackTileLocked", function () { return $5da9ea4238c596b7$export$119f7f506563544d; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $866by = parcelRequire("866by");
const $5da9ea4238c596b7$export$119f7f506563544d = ({ track: track, onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $iwq56.u)();
    const { name: trackName, userId: userId } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $866by.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $866by.styles)(theme).track.cover.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $866by.styles)(theme).track.cover.overlay.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: (0, $866by.styles)(theme).track.cover.overlay.button,
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "unlock track",
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Unlock, {})
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $866by.styles)(theme).track.cover.lock.main,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $866by.styles)(theme).track.cover.lock.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $866by.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $866by.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $866by.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$5da9ea4238c596b7$export$119f7f506563544d.propTypes = {};

});
parcelRegister("866by", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $222664d35cd1fc7d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $222664d35cd1fc7d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $222664d35cd1fc7d$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $222664d35cd1fc7d$var$_ref2 = {
    name: "jpda5q",
    styles: "display:flex;&>svg{width:30px;height:30px;}"
};
var $222664d35cd1fc7d$var$_ref3 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
var $222664d35cd1fc7d$var$_ref4 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $222664d35cd1fc7d$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $222664d35cd1fc7d$var$_ref4,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-bottom:10px;&:hover>div{opacity:1;}", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.tile.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;opacity:0;background-color:", theme.colors.primary.normal, "A0;", ""),
                    button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:30px;height:30px;& path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                lock: {
                    main: $222664d35cd1fc7d$var$_ref3,
                    icon: $222664d35cd1fc7d$var$_ref2
                }
            },
            description: {
                main: $222664d35cd1fc7d$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("4qRw3", function(module, exports) {

$parcel$export(module.exports, "TrackTileProduct", function () { return $bb9810c9aefd4515$export$57508a4e1c467d23; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $dubIn = parcelRequire("dubIn");
const $bb9810c9aefd4515$export$57508a4e1c467d23 = ({ track: track })=>{
    const theme = (0, $iwq56.u)();
    const { name: trackName, userId: userId } = track;
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $dubIn.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $dubIn.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $dubIn.styles)(theme).track.cover.lock.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dubIn.styles)(theme).track.cover.lock.icon,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $dubIn.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dubIn.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $dubIn.styles)(theme).track.description.author,
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$bb9810c9aefd4515$export$57508a4e1c467d23.propTypes = {};

});
parcelRegister("dubIn", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $e651f3affdf7c9f2$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $e651f3affdf7c9f2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $e651f3affdf7c9f2$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $e651f3affdf7c9f2$var$_ref2 = {
    name: "jpda5q",
    styles: "display:flex;&>svg{width:30px;height:30px;}"
};
var $e651f3affdf7c9f2$var$_ref3 = {
    name: "zigog8",
    styles: "display:flex;flex-direction:column;align-items:center"
};
var $e651f3affdf7c9f2$var$_ref4 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $e651f3affdf7c9f2$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $e651f3affdf7c9f2$var$_ref4,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.normal, ";border-radius:4px;overflow:hidden;margin-bottom:10px;&:hover>div{opacity:1;}", ""),
                lock: {
                    main: $e651f3affdf7c9f2$var$_ref3,
                    icon: $e651f3affdf7c9f2$var$_ref2
                },
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>svg{width:30px;height:30px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $e651f3affdf7c9f2$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.secondary.normal, ";font-weight:bold;text-align:center;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:center;", "")
            }
        }
    });

});


parcelRegister("ip1Fa", function(module, exports) {

$parcel$export(module.exports, "TrackTileSelect", function () { return $db920422c648d87f$export$d8d9fad53ea1675d; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $7FBnl = parcelRequire("7FBnl");
const $db920422c648d87f$export$d8d9fad53ea1675d = ({ track: track, selected: selected, onClick: onClick, onAuthorNameClick: onAuthorNameClick })=>{
    const theme = (0, $iwq56.u)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    const { coverId: coverId, name: trackName, userId: userId } = track;
    const trackHasCover = !!coverId;
    const source = (0, $jpNoL.useFile)(coverId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(userId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $7FBnl.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $7FBnl.styles)(theme).track.cover.main,
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
                    css: (0, $7FBnl.styles)(theme).track.cover.button,
                    onClick: (e)=>onClick(e),
                    type: "button",
                    "aria-label": "play track",
                    children: [
                        selected && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $7FBnl.styles)(theme).track.cover.overlay.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $7FBnl.styles)(theme).track.cover.overlay.icon,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CheckCircle, {})
                            })
                        }),
                        trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $7FBnl.styles)(theme).track.cover.image,
                            onError: ()=>setCoverLoadError(true),
                            loading: "lazy",
                            width: "180px",
                            height: "180px",
                            src: source,
                            alt: "track album cover"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $7FBnl.styles)(theme).track.cover.placeholder,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $7FBnl.styles)(theme).track.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $7FBnl.styles)(theme).track.description.name,
                        children: trackName
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $7FBnl.styles)(theme).track.description.author,
                        onClick: (e)=>onAuthorNameClick(e),
                        type: "button",
                        "aria-label": "explore track author",
                        children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                    })
                ]
            })
        ]
    });
};
$db920422c648d87f$export$d8d9fad53ea1675d.propTypes = {};

});
parcelRegister("7FBnl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $682469f63e0dba94$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $682469f63e0dba94$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $682469f63e0dba94$var$_ref = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
var $682469f63e0dba94$var$_ref2 = {
    name: "hebiic",
    styles: "display:flex;flex-direction:column;width:180px"
};
const $682469f63e0dba94$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: $682469f63e0dba94$var$_ref2,
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("position:relative;display:flex;align-items:center;justify-content:center;flex-shrink:0;width:180px;height:180px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-bottom:10px;", ""),
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;width:100%;height:100%;cursor:pointer;", ""),
                overlay: {
                    main: /*#__PURE__*/ (0, $7hler.css)("z-index:", (0, $gln0L.z).features.track.tile.overlay, ";position:absolute;left:0;top:0;width:100%;height:100%;transition:opacity 0.2s;background-color:", theme.colors.primary.normal, "A0;", ""),
                    icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;justify-content:flex-end;margin:10px 10px 0px 0px;&>svg{width:30px;height:30px;&>path{fill:", theme.colors.accent.normal, ";}}", "")
                },
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>svg{width:30px;height:30px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            description: {
                main: $682469f63e0dba94$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;", ""),
                author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:start;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("1yt5C", function(module, exports) {

$parcel$export(module.exports, "TrackViewAudioPlaylist", function () { return $d06c30f67b60b858$export$24ab48c69fdb6c27; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $iLKNg = parcelRequire("iLKNg");
var $jpNoL = parcelRequire("jpNoL");
var $gLN5L = parcelRequire("gLN5L");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $jAL4t = parcelRequire("jAL4t");
var $l5cm3 = parcelRequire("l5cm3");
var $a0GHC = parcelRequire("a0GHC");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $i0Fzj = parcelRequire("i0Fzj");
const $d06c30f67b60b858$export$24ab48c69fdb6c27 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const [coverLoadError, setCoverLoadError] = (0, $bh6RR.useState)(false);
    // profile
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const trackLikes = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectTrackLikes));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const { id: profileUserId } = profile ?? {};
    // track
    const track = (0, $gNvvs.useAppSelector)((0, $jAL4t.playerAudioSelectCurrentTrack));
    const { id: trackId, coverId: coverId, name: trackName, userId: trackAuthorUserId } = track ?? {};
    const trackHasCover = !!coverId;
    const source = (0, $jpNoL.useFile)(coverId || "");
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $gLN5L.useUser)(trackAuthorUserId || "");
    const { name: authorName } = trackAuthor ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userNamePlaceholder = "-";
    // connect ready
    const { ready: connectReady } = (0, $iLKNg.useConnectReady)(trackAuthorUserId || "");
    const likeTrackDisabled = false;
    const dislikeTrackDisabled = false;
    const followAuthorDisabled = false;
    const unfollowAuthorDisabled = false;
    const subscribeToAuthorDisabled = false;
    const unsubscribeFromAuthorDisabled = false;
    const tipAuthorDisabled = false;
    const isTrackAuthorFollowed = userFollows[trackAuthorUserId || ""];
    const isTrackLiked = trackLikes[trackId || ""];
    const isCurrentUserContentAuthor = profileUserId === trackAuthorUserId;
    const isCurrentUserSubscribedToContentAuthor = userSubscriptions[trackAuthorUserId || ""];
    const isCurrentUserSubscribedToContentAuthorAtPeriodEnd = userSubscriptionsAtPeriodEnd[trackAuthorUserId || ""];
    const isAuthorCanReceivePayments = connectReady && !isCurrentUserContentAuthor;
    const subscribeAction = isCurrentUserSubscribedToContentAuthorAtPeriodEnd ? ()=>// renew subscription
        dispatch((0, $l5cm3.subscriptionOpenSubscriptionRenewModal)({
            artist: {
                ...trackAuthor
            }
        })) : ()=>// else create new subscription
        dispatch((0, $l5cm3.subscriptionOpenSubscriptionCreateModal)({
            artist: {
                ...trackAuthor
            }
        }));
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $i0Fzj.styles)(theme).track.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $i0Fzj.styles)(theme).track.cover.main,
                children: trackHasCover && !coverLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $i0Fzj.styles)(theme).track.cover.image,
                    onError: ()=>setCoverLoadError(true),
                    loading: "lazy",
                    width: "200px",
                    height: "200px",
                    src: source,
                    alt: "track album cover"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $i0Fzj.styles)(theme).track.cover.placeholder,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).MusicNote, {})
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $i0Fzj.styles)(theme).track.panel.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $i0Fzj.styles)(theme).track.panel.description.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.description.name,
                                children: trackName
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.description.author,
                                onClick: ()=>{
                                    navigate(`${(0, $b7fnN.Path).User}/${trackAuthorUserId}`);
                                    dispatch((0, $jAL4t.playerAudioSetClosed)());
                                },
                                type: "button",
                                "aria-label": "explore track author",
                                children: isTrackAuthorLoading ? userLoadingPlaceholder : authorName || userNamePlaceholder
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $i0Fzj.styles)(theme).track.panel.features.main,
                        children: [
                            isTrackLiked ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.features.dislike.main,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: [
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.shared,
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.accent,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $4cq7L.likeDeleteTrackLike)({
                                            track: track
                                        })),
                                    type: "button",
                                    "aria-label": "dislike track",
                                    disabled: dislikeTrackDisabled,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Heart, {})
                                })
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.features.like.main,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: [
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.shared,
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $4cq7L.likeCreateTrackLike)({
                                            track: track
                                        })),
                                    type: "button",
                                    "aria-label": "like track",
                                    disabled: likeTrackDisabled,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Heart, {})
                                })
                            }),
                            isTrackAuthorFollowed ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.features.unfollow.main,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: [
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.shared,
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.accent,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
                                            user: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "unfollow track author",
                                    disabled: unfollowAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).UserPlus, {})
                                })
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.features.follow.main,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: [
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.shared,
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
                                            user: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "follow track author",
                                    disabled: followAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).UserPlus, {})
                                })
                            }),
                            isAuthorCanReceivePayments && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.features.tip.main,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: [
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.shared,
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $a0GHC.tipOpenTipModal)({
                                            artist: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "send tip to track author",
                                    disabled: tipAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).DollarCircle, {})
                                })
                            }),
                            isAuthorCanReceivePayments && (isCurrentUserSubscribedToContentAuthor && !isCurrentUserSubscribedToContentAuthorAtPeriodEnd ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.features.unsubscribe.main,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: [
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.shared,
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.accent,
                                        "",
                                        ""
                                    ],
                                    onClick: ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCancelModal)({
                                            artist: {
                                                ...trackAuthor
                                            }
                                        })),
                                    type: "button",
                                    "aria-label": "unsubscribe from track author",
                                    disabled: unsubscribeFromAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                                })
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $i0Fzj.styles)(theme).track.panel.features.subscribe.main,
                                children: /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                                    css: [
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.shared,
                                        (0, $i0Fzj.styles)(theme).track.panel.features.button.normal,
                                        "",
                                        ""
                                    ],
                                    onClick: subscribeAction,
                                    type: "button",
                                    "aria-label": "subscribe to track author",
                                    disabled: subscribeToAuthorDisabled,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                                })
                            }))
                        ]
                    })
                ]
            })
        ]
    });
};
$d06c30f67b60b858$export$24ab48c69fdb6c27.propTypes = {};

});
parcelRegister("i0Fzj", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $84820a4e4bab09de$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $84820a4e4bab09de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $84820a4e4bab09de$var$_ref = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $84820a4e4bab09de$var$_ref2 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $84820a4e4bab09de$var$_ref3 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $84820a4e4bab09de$var$_ref4 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $84820a4e4bab09de$var$_ref5 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $84820a4e4bab09de$var$_ref6 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $84820a4e4bab09de$var$_ref7 = {
    name: "ue7o5o",
    styles: "width:30px;height:30px"
};
var $84820a4e4bab09de$var$_ref8 = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
var $84820a4e4bab09de$var$_ref9 = {
    name: "18uqayh",
    styles: "margin-bottom:16px"
};
var $84820a4e4bab09de$var$_ref10 = {
    name: "pit38s",
    styles: "height:auto"
};
var $84820a4e4bab09de$var$_ref11 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $84820a4e4bab09de$var$_ref12 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $84820a4e4bab09de$export$9dd6ff9ea0189349 = (theme)=>({
        track: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;width:100%;", (0, $gln0L.mq).mobile($84820a4e4bab09de$var$_ref12), ";", ""),
            cover: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:200px;height:200px;background-color:", theme.colors.primary.darker, ";border-radius:4px;overflow:hidden;margin-right:32px;&:hover>div{opacity:1;}", (0, $gln0L.mq).mobile($84820a4e4bab09de$var$_ref11), ";", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                placeholder: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>svg{width:20px;height:20px;&>path{color:", theme.colors.secondary.normal, ";}&>circle{color:", theme.colors.secondary.normal, ";}}", "")
            },
            panel: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:100%;height:200px;min-width:0;", (0, $gln0L.mq).mobile($84820a4e4bab09de$var$_ref10), ";", ""),
                description: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;min-width:0;margin-bottom:auto;", (0, $gln0L.mq).mobile($84820a4e4bab09de$var$_ref9), ";", ""),
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).h5, ";font-weight:bold;", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("text-align:center;font-size:", (0, $gln0L.typography).h6, ";", "")), ";", ""),
                    author: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).h6, ";color:", theme.colors.secondary.normal, ";text-align:start;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", (0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)("text-align:center;font-size:", (0, $gln0L.typography).p, ";", "")), ";", "")
                },
                features: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;&>div:not(:last-of-type){margin-right:16px;}", (0, $gln0L.mq).mobile($84820a4e4bab09de$var$_ref8), ";", ""),
                    like: {
                        main: $84820a4e4bab09de$var$_ref7
                    },
                    dislike: {
                        main: $84820a4e4bab09de$var$_ref6
                    },
                    follow: {
                        main: $84820a4e4bab09de$var$_ref5
                    },
                    unfollow: {
                        main: $84820a4e4bab09de$var$_ref4
                    },
                    tip: {
                        main: $84820a4e4bab09de$var$_ref3
                    },
                    subscribe: {
                        main: $84820a4e4bab09de$var$_ref2
                    },
                    unsubscribe: {
                        main: $84820a4e4bab09de$var$_ref
                    },
                    button: {
                        shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;align-items:center;justify-content:center;width:100%;height:100%;cursor:pointer;&>svg{width:24px;height:24px;}", ""),
                        normal: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.secondary.normal, ";}}", ""),
                        accent: /*#__PURE__*/ (0, $7hler.css)("&>svg{& path{fill:", theme.colors.accent.normal, ";}}", "")
                    }
                }
            }
        }
    });

});


parcelRegister("8p2Dj", function(module, exports) {

$parcel$export(module.exports, "TrackViewCreateStudio", function () { return $f4b11928b645d228$export$f6671100c2776887; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("9F7me");
var $FYPh1 = parcelRequire("FYPh1");

var $ggDzk = parcelRequire("ggDzk");
const $f4b11928b645d228$export$f6671100c2776887 = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $ggDzk.styles)().card.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $ggDzk.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $ggDzk.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $FYPh1.Form), {})
            })
        })
    });
$f4b11928b645d228$export$f6671100c2776887.propTypes = {};

});
parcelRegister("9F7me", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("FYPh1")).Form; });

var $FYPh1 = parcelRequire("FYPh1");

});
parcelRegister("FYPh1", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $84ab1e2b2236bac1$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $9srzl = parcelRequire("9srzl");
var $cGp48 = parcelRequire("cGp48");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $iLKNg = parcelRequire("iLKNg");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $kwNyE = parcelRequire("kwNyE");
var $2Vh5B = parcelRequire("2Vh5B");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $7y6mB = parcelRequire("7y6mB");
var $9HR7l = parcelRequire("9HR7l");
var $iGKn1 = parcelRequire("iGKn1");
var $95KdT = parcelRequire("95KdT");
var $ly71s = parcelRequire("ly71s");
var $9jZXY = parcelRequire("9jZXY");
var $13cuy = parcelRequire("13cuy");
var $6F2CE = parcelRequire("6F2CE");
var $f6nZ0 = parcelRequire("f6nZ0");
var $81gWx = parcelRequire("81gWx");
parcelRequire("d5Ojq");
var $gUgUp = parcelRequire("gUgUp");

var $2lBXZ = parcelRequire("2lBXZ");
const $84ab1e2b2236bac1$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const trackCreateLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackCreateLoading));
    // connect ready
    const { ready: connectReady } = (0, $iLKNg.useConnectReady)(profile?.id || "");
    // cover state
    const [cover, setCover] = (0, $bh6RR.useState)(undefined);
    const [coverPreview, setCoverPreview] = (0, $bh6RR.useState)("");
    const coverFileInputRef = (0, $bh6RR.useRef)(null);
    const [coverError, setCoverError] = (0, $bh6RR.useState)("");
    // track state
    const [track, setTrack] = (0, $bh6RR.useState)(undefined);
    const [trackFileName, setTrackFileName] = (0, $bh6RR.useState)("");
    const trackFileInputRef = (0, $bh6RR.useRef)(null);
    const [trackError, setTrackError] = (0, $bh6RR.useState)("");
    // name state
    const [name, setName] = (0, $bh6RR.useState)("");
    const [nameError, setNameError] = (0, $bh6RR.useState)("");
    // genres state
    const [genres, setGenres] = (0, $bh6RR.useState)([]);
    const [musicGenres, setMusicGenres] = (0, $bh6RR.useState)((0, $cGp48.musicGenres));
    // genres search state
    const [search, setSearch] = (0, $bh6RR.useState)("");
    // visibility state
    const [visibility, setVisibility] = (0, $bh6RR.useState)((0, $2gpGl.EntityTrackVisibility).Public);
    // unlock price state
    const defaultUnlockPrice = Math.ceil((0, $9srzl.maxTrackUnlockPrice) / 2);
    const [unlockPrice, setUnlockPrice] = (0, $bh6RR.useState)(defaultUnlockPrice);
    const submitDisabled = name.length < (0, $9srzl.minTrackNameLength) || name.length > (0, $9srzl.maxTrackNameLength) || unlockPrice < (0, $9srzl.minTrackUnlockPrice) || unlockPrice > (0, $9srzl.maxTrackUnlockPrice) || track === undefined || coverError !== "" || trackError !== "" || nameError !== "" || trackCreateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setCover(undefined);
        setTrack(undefined);
        setName("");
        setTrackFileName("");
        setGenres([]);
        setVisibility((0, $2gpGl.EntityTrackVisibility).Public);
        setUnlockPrice(defaultUnlockPrice);
        // if cover preview was set
        if (coverPreview) {
            // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            setCoverPreview("");
        }
    };
    const onCoverClick = ()=>{
        coverFileInputRef.current?.click();
        setCoverError("");
    };
    const onTrackClick = ()=>{
        trackFileInputRef.current?.click();
        setTrackError("");
    };
    const onCoverFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validateCoverFile)(file);
            if (error) {
                setCoverError(error);
                return;
            }
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            // set file as a preview
            setCoverPreview(URL.createObjectURL(file));
            // store file in state
            setCover(file);
        }
    };
    const onTrackFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validateTrackFile)(file);
            if (error) {
                setTrackError(error);
                return;
            }
            // store file name in state
            setTrackFileName(file.name);
            // store file in state
            setTrack(file);
        }
    };
    (0, $bh6RR.useEffect)(()=>()=>{
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
        });
    (0, $bh6RR.useEffect)(()=>{
        if (!trackCreateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        trackCreateLoading
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $2lBXZ.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $2lBXZ.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $kwNyE.trackCreate)({
                    name: name,
                    track: track,
                    cover: cover,
                    genres: genres,
                    visibility: visibility,
                    unlockPrice: unlockPrice
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $2lBXZ.styles)().form.content.cover.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $2lBXZ.styles)().form.content.cover.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Cover"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $2lBXZ.styles)().form.content.cover.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                                    css: (0, $2lBXZ.styles)().form.content.cover.preview.label,
                                    htmlFor: "cover",
                                    children: [
                                        "cover",
                                        /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                            name: "cover",
                                            type: "file",
                                            id: "cover",
                                            ref: coverFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png",
                                            onChange: (e)=>onCoverFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $2lBXZ.styles)().form.content.cover.preview.image,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $81gWx.MediaFilePreview), {
                                        source: coverPreview,
                                        type: "image",
                                        width: "140px",
                                        height: "140px",
                                        alt: "track cover",
                                        onClick: ()=>onCoverClick(),
                                        // formats={['JPG', 'JPEG', 'PNG', 'WEBP']}
                                        maxFileSize: (0, $9srzl.maxTrackCoverFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $2lBXZ.styles)().form.content.cover.error,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                                error: coverError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $2lBXZ.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6F2CE.InputLine), {
                        name: "name",
                        label: "Name",
                        type: "text",
                        placeholder: "Enter your name",
                        icon: (0, $bq9l8.icons).Edit,
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $9srzl.minTrackNameLength),
                        max: (0, $9srzl.maxTrackNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $lRNbG.validateTrackName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $2lBXZ.styles)().form.content.track.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $2lBXZ.styles)().form.content.track.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Track"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $2lBXZ.styles)().form.content.track.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                                    css: (0, $2lBXZ.styles)().form.content.track.preview.label,
                                    htmlFor: "track",
                                    children: [
                                        "track",
                                        /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                            name: "track",
                                            type: "file",
                                            id: "track",
                                            ref: trackFileInputRef,
                                            accept: ".mp3",
                                            onChange: (e)=>onTrackFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $2lBXZ.styles)().form.content.track.preview.input,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gUgUp.TrackPreview), {
                                            fileName: trackFileName,
                                            label: "change or select track file",
                                            description: "Select track (.mp3)",
                                            error: trackError.length > 0,
                                            errorMessage: trackError,
                                            onClick: ()=>onTrackClick()
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $2lBXZ.styles)().form.content.genres.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $2lBXZ.styles)().form.content.genres.selected.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $2lBXZ.styles)().form.content.genres.selected.label,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                        text: "Genre"
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $2lBXZ.styles)().form.content.genres.selected.genres,
                                    children: genres.map((trackGenre)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $9HR7l.BadgeSelected), {
                                            name: trackGenre,
                                            onRemoveClick: ()=>setGenres((state)=>state.filter((genre)=>genre !== trackGenre))
                                        }, `track-genres-${trackGenre}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $2lBXZ.styles)().form.content.genres.search.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $2lBXZ.styles)().form.content.genres.search.input,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6F2CE.InputLine), {
                                        name: "search",
                                        label: "Select genre",
                                        type: "search",
                                        placeholder: "Find genre",
                                        icon: (0, $bq9l8.icons).Search,
                                        value: search,
                                        onChange: (e)=>{
                                            setSearch(e.target.value);
                                            setMusicGenres((0, $cGp48.musicGenres).filter((genre)=>genre.toLowerCase().includes(e.target.value)));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $2lBXZ.styles)().form.content.genres.search.genres,
                                    children: musicGenres.map((genre)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $7y6mB.Badge), {
                                            name: genre,
                                            disabled: genres.includes(genre) || genres.length >= (0, $cGp48.maxTrackGenresCount),
                                            onClick: ()=>setGenres((state)=>[
                                                        ...state,
                                                        genre
                                                    ])
                                        }, `music-genres-${genre}`))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $2lBXZ.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $2lBXZ.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $2lBXZ.styles)().form.content.visibility.inputs,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the track is made publicly accessible to everyone on the platform",
                                    icon: (0, $bq9l8.icons).Unlock,
                                    checked: visibility === (0, $2gpGl.EntityTrackVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityTrackVisibility).Public)
                                }),
                                connectReady && /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the track is exclusively accessible to subscribers or individuals who unlock it directly",
                                    icon: (0, $bq9l8.icons).Lock,
                                    checked: visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityTrackVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $2lBXZ.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $2lBXZ.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $2lBXZ.styles)().form.content.price.amount,
                            children: [
                                "$",
                                unlockPrice
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $2lBXZ.styles)().form.content.price.input,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9jZXY.InputAmount), {
                                name: "unlock-price",
                                label: "unlock price",
                                type: "range",
                                id: "unlock-price",
                                value: unlockPrice,
                                min: (0, $9srzl.minTrackUnlockPrice),
                                max: (0, $9srzl.maxTrackUnlockPrice),
                                onChange: (e)=>setUnlockPrice(parseInt(e.target.value, 10))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $2lBXZ.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $2lBXZ.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                            type: "submit",
                            "aria-label": "upload track",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: trackCreateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Upload"
                        })
                    })
                })
            ]
        })
    });
};
$84ab1e2b2236bac1$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("d5Ojq", function(module, exports) {

$parcel$export(module.exports, "TrackPreview", function () { return (parcelRequire("gUgUp")).TrackPreview; });

var $gUgUp = parcelRequire("gUgUp");

});
parcelRegister("gUgUp", function(module, exports) {

$parcel$export(module.exports, "TrackPreview", function () { return $632ddd968a9d4034$export$caaa9e2fcf82fb06; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $8Q2yl = parcelRequire("8Q2yl");
const $632ddd968a9d4034$export$caaa9e2fcf82fb06 = ({ fileName: fileName, label: label, description: description, error: error, errorMessage: errorMessage, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $8Q2yl.styles)(theme).preview.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                css: [
                    (0, $8Q2yl.styles)(theme).preview.button.shared,
                    fileName ? (0, $8Q2yl.styles)(theme).preview.button.filled : (0, $8Q2yl.styles)(theme).preview.button.empty,
                    error && (0, $8Q2yl.styles)(theme).preview.button.errored,
                    "",
                    ""
                ],
                onClick: (e)=>onClick(e),
                type: "button",
                "aria-label": label,
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8Q2yl.styles)(theme).preview.button.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8Q2yl.styles)(theme).preview.button.content.name,
                            children: fileName || description
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: [
                                (0, $8Q2yl.styles)(theme).preview.button.content.icon.shared,
                                fileName ? (0, $8Q2yl.styles)(theme).preview.button.content.icon.empty : (0, $8Q2yl.styles)(theme).preview.button.content.icon.filled,
                                error && (0, $8Q2yl.styles)(theme).preview.button.errored,
                                "",
                                ""
                            ],
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Upload, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: [
                    (0, $8Q2yl.styles)(theme).preview.error.shared,
                    errorMessage ? (0, $8Q2yl.styles)(theme).preview.error.visible : (0, $8Q2yl.styles)(theme).preview.error.hidden,
                    "",
                    ""
                ],
                children: /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                    css: [
                        (0, $8Q2yl.styles)(theme).preview.error.text.shared,
                        errorMessage ? (0, $8Q2yl.styles)(theme).preview.error.text.visible : (0, $8Q2yl.styles)(theme).preview.error.text.hidden,
                        "",
                        ""
                    ],
                    children: errorMessage
                })
            })
        ]
    });
};
$632ddd968a9d4034$export$caaa9e2fcf82fb06.propTypes = {};

});
parcelRegister("8Q2yl", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6ebfc9476363c690$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6ebfc9476363c690$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6ebfc9476363c690$var$_ref = {
    name: "mws4fn",
    styles: "opacity:0"
};
var $6ebfc9476363c690$var$_ref2 = {
    name: "3ix1vd",
    styles: "opacity:1"
};
var $6ebfc9476363c690$var$_ref3 = {
    name: "1o1wj7w",
    styles: "height:0px"
};
var $6ebfc9476363c690$var$_ref4 = {
    name: "1ncq4tc",
    styles: "height:24px"
};
var $6ebfc9476363c690$var$_ref5 = {
    name: "13fumqp",
    styles: "display:flex;min-width:0;transition:height 0.2s"
};
var $6ebfc9476363c690$var$_ref6 = {
    name: "1jk7zt8",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0;width:28px;height:28px;&>svg{width:14px;height:14px;&>path{transition:fill 0.2s;}}"
};
var $6ebfc9476363c690$var$_ref7 = {
    name: "zjik7",
    styles: "display:flex"
};
var $6ebfc9476363c690$var$_ref8 = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $6ebfc9476363c690$export$9dd6ff9ea0189349 = (theme)=>({
        preview: {
            main: $6ebfc9476363c690$var$_ref8,
            button: {
                shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";width:100%;height:28px;font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).p, ";font-weight:bold;padding-bottom:2px;transition:border 0.2s,color 0.2s;cursor:pointer;", ""),
                empty: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.darker, ";", ""),
                filled: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.secondary.dark, ";color:", theme.colors.secondary.normal, ";", ""),
                errored: /*#__PURE__*/ (0, $7hler.css)("border-bottom:1px solid ", theme.colors.negative.normal, ";color:", theme.colors.negative.normal, ";", ""),
                content: {
                    main: $6ebfc9476363c690$var$_ref7,
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";margin-right:auto;", ""),
                    icon: {
                        shared: $6ebfc9476363c690$var$_ref6,
                        empty: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{color:", theme.colors.accent.normal, ";}", ""),
                        filled: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{color:", theme.colors.accent.normal, ";}", ""),
                        errored: /*#__PURE__*/ (0, $7hler.css)("&>svg>path{color:", theme.colors.negative.normal, ";}", "")
                    }
                }
            },
            error: {
                shared: $6ebfc9476363c690$var$_ref5,
                visible: $6ebfc9476363c690$var$_ref4,
                hidden: $6ebfc9476363c690$var$_ref3,
                text: {
                    shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";color:", theme.colors.negative.normal, ";transition:opacity 0.4s;padding-left:14px;", ""),
                    visible: $6ebfc9476363c690$var$_ref2,
                    hidden: $6ebfc9476363c690$var$_ref
                }
            }
        }
    });

});



parcelRegister("2lBXZ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $2cb2d181ef769538$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $2cb2d181ef769538$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2cb2d181ef769538$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $2cb2d181ef769538$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $2cb2d181ef769538$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $2cb2d181ef769538$var$_ref4 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $2cb2d181ef769538$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $2cb2d181ef769538$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $2cb2d181ef769538$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $2cb2d181ef769538$var$_ref8 = {
    name: "c1gao8",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:10px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $2cb2d181ef769538$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $2cb2d181ef769538$var$_ref10 = {
    name: "1omvlk4",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:20px;}&>div:not(:last-of-type){margin-right:20px;}"
};
var $2cb2d181ef769538$var$_ref11 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $2cb2d181ef769538$var$_ref12 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $2cb2d181ef769538$var$_ref13 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $2cb2d181ef769538$var$_ref14 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $2cb2d181ef769538$var$_ref15 = {
    name: "eivff4",
    styles: "display:none"
};
var $2cb2d181ef769538$var$_ref16 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $2cb2d181ef769538$var$_ref17 = {
    name: "1e5t4ul",
    styles: "display:flex;flex-direction:column;margin-bottom:50px"
};
var $2cb2d181ef769538$var$_ref18 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $2cb2d181ef769538$var$_ref19 = {
    name: "eivff4",
    styles: "display:none"
};
var $2cb2d181ef769538$var$_ref20 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $2cb2d181ef769538$var$_ref21 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $2cb2d181ef769538$var$_ref22 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $2cb2d181ef769538$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                cover: {
                    main: $2cb2d181ef769538$var$_ref22,
                    label: $2cb2d181ef769538$var$_ref21,
                    preview: {
                        main: $2cb2d181ef769538$var$_ref20,
                        label: $2cb2d181ef769538$var$_ref19,
                        image: /*#__PURE__*/ (0, $7hler.css)("", "")
                    },
                    error: $2cb2d181ef769538$var$_ref18
                },
                track: {
                    main: $2cb2d181ef769538$var$_ref17,
                    label: $2cb2d181ef769538$var$_ref16,
                    preview: {
                        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        label: $2cb2d181ef769538$var$_ref15,
                        input: /*#__PURE__*/ (0, $7hler.css)("", "")
                    }
                },
                name: $2cb2d181ef769538$var$_ref14,
                genres: {
                    main: $2cb2d181ef769538$var$_ref13,
                    selected: {
                        main: $2cb2d181ef769538$var$_ref12,
                        label: $2cb2d181ef769538$var$_ref11,
                        genres: $2cb2d181ef769538$var$_ref10
                    },
                    search: {
                        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        input: $2cb2d181ef769538$var$_ref9,
                        genres: $2cb2d181ef769538$var$_ref8
                    }
                },
                visibility: {
                    main: $2cb2d181ef769538$var$_ref7,
                    label: $2cb2d181ef769538$var$_ref6,
                    inputs: $2cb2d181ef769538$var$_ref5
                },
                price: {
                    main: $2cb2d181ef769538$var$_ref4,
                    label: $2cb2d181ef769538$var$_ref3,
                    amount: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";line-height:24px;margin-bottom:10px;", ""),
                    input: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).tablet($2cb2d181ef769538$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:220px;}", (0, $gln0L.mq).tablet($2cb2d181ef769538$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("ggDzk", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7ec85af81b90fd23$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $7ec85af81b90fd23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7ec85af81b90fd23$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $7ec85af81b90fd23$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $7ec85af81b90fd23$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $7ec85af81b90fd23$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $7ec85af81b90fd23$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:400px;", (0, $gln0L.mq).tablet($7ec85af81b90fd23$var$_ref2), ";", ""),
                form: $7ec85af81b90fd23$var$_ref
            }
        }
    });

});


parcelRegister("3xC6a", function(module, exports) {

$parcel$export(module.exports, "TrackViewEditStudio", function () { return $40aed3995095d028$export$15771b0fb25d25b3; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("7Yrz7");
var $fu2My = parcelRequire("fu2My");

var $55Dcw = parcelRequire("55Dcw");
const $40aed3995095d028$export$15771b0fb25d25b3 = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $55Dcw.styles)().card.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $55Dcw.styles)().card.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $55Dcw.styles)().card.content.form,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $fu2My.Form), {})
            })
        })
    });
$40aed3995095d028$export$15771b0fb25d25b3.propTypes = {};

});
parcelRegister("7Yrz7", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("fu2My")).Form; });

var $fu2My = parcelRequire("fu2My");

});
parcelRegister("fu2My", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $de3e13cf6317a869$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("krTeD");
var $9srzl = parcelRequire("9srzl");
var $cGp48 = parcelRequire("cGp48");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("cJvLm");
var $2Vh5B = parcelRequire("2Vh5B");
var $kwNyE = parcelRequire("kwNyE");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $7y6mB = parcelRequire("7y6mB");
var $9HR7l = parcelRequire("9HR7l");
var $iGKn1 = parcelRequire("iGKn1");
var $95KdT = parcelRequire("95KdT");
var $ly71s = parcelRequire("ly71s");
var $13cuy = parcelRequire("13cuy");
var $6F2CE = parcelRequire("6F2CE");
var $f6nZ0 = parcelRequire("f6nZ0");
var $81gWx = parcelRequire("81gWx");

var $56gEK = parcelRequire("56gEK");
const $de3e13cf6317a869$export$a7fed597f4b8afd8 = ()=>{
    const { trackId: trackId } = (0, $99w1R.useParams)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const trackUpdateLoading = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectTrackUpdateLoading));
    const uploadedTracks = (0, $gNvvs.useAppSelector)((0, $2Vh5B.trackSelectUploadedTracks));
    const track = uploadedTracks.find((t)=>t.id === trackId);
    const { coverId: coverId, name: currentName, genres: currentGenres, visibility: currentVisibility, unlockPrice: currentUnlockPrice } = track ?? {};
    // cover state
    const trackHasCover = !!coverId;
    const trackCover = (0, $jpNoL.useFile)(coverId || "");
    const [cover, setCover] = (0, $bh6RR.useState)(undefined);
    const [coverPreview, setCoverPreview] = (0, $bh6RR.useState)(trackHasCover ? trackCover : "");
    const coverFileInputRef = (0, $bh6RR.useRef)(null);
    const [coverError, setCoverError] = (0, $bh6RR.useState)("");
    // name state
    const [name, setName] = (0, $bh6RR.useState)(currentName || "");
    const [nameError, setNameError] = (0, $bh6RR.useState)("");
    // genres state
    const [genres, setGenres] = (0, $bh6RR.useState)(currentGenres || []);
    const [musicGenres, setMusicGenres] = (0, $bh6RR.useState)((0, $cGp48.musicGenres));
    // genres search state
    const [search, setSearch] = (0, $bh6RR.useState)("");
    // visibility state
    const [visibility, setVisibility] = (0, $bh6RR.useState)(currentVisibility || (0, $2gpGl.EntityTrackVisibility).Public);
    const nameUnchanged = name === currentName;
    const genresUnchanged = genres.join("") === currentGenres?.join("");
    const coverNotSelected = cover === undefined;
    const trackDefaultsUnchanged = nameUnchanged && genresUnchanged && coverNotSelected;
    const submitDisabled = trackDefaultsUnchanged || name.length < (0, $9srzl.minTrackNameLength) || name.length > (0, $9srzl.maxTrackNameLength) || coverError !== "" || nameError !== "" || trackUpdateLoading;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const cleanupState = ()=>{
        setCover(undefined);
        setName(currentName || "");
        setGenres(currentGenres || []);
        setVisibility(currentVisibility || (0, $2gpGl.EntityTrackVisibility).Public);
    };
    const onCoverClick = ()=>{
        coverFileInputRef.current?.click();
        setCoverError("");
    };
    const onCoverFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validateCoverFile)(file);
            if (error) {
                setCoverError(error);
                return;
            }
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
            // set file as a preview
            setCoverPreview(URL.createObjectURL(file));
            // store file in state
            setCover(file);
        }
    };
    (0, $bh6RR.useEffect)(()=>()=>{
            // if cover preview was set
            if (coverPreview) // clean up to avoid memory leaks
            revokePreviewURL(coverPreview);
        });
    (0, $bh6RR.useEffect)(()=>{
        if (!trackUpdateLoading) cleanupState();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        trackUpdateLoading
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $56gEK.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $56gEK.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $kwNyE.trackUpdate)({
                    track: track || {},
                    name: name,
                    cover: cover,
                    genres: genres
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $56gEK.styles)().form.content.cover.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $56gEK.styles)().form.content.cover.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Cover"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $56gEK.styles)().form.content.cover.preview.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                                    css: (0, $56gEK.styles)().form.content.cover.preview.label,
                                    htmlFor: "cover",
                                    children: [
                                        "cover",
                                        /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                            name: "cover",
                                            type: "file",
                                            id: "cover",
                                            ref: coverFileInputRef,
                                            accept: "image/jpeg,image/webp,image/png",
                                            onChange: (e)=>onCoverFileChange(e)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $56gEK.styles)().form.content.cover.preview.image,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $81gWx.MediaFilePreview), {
                                        source: coverPreview,
                                        type: "image",
                                        width: "140px",
                                        height: "140px",
                                        alt: "track cover",
                                        onClick: ()=>onCoverClick(),
                                        // formats={['JPG', 'JPEG', 'PNG', 'WEBP']}
                                        maxFileSize: (0, $9srzl.maxTrackCoverFileSize)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $56gEK.styles)().form.content.cover.error,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                                error: coverError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $56gEK.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6F2CE.InputLine), {
                        name: "name",
                        label: "Name",
                        type: "text",
                        placeholder: "Enter your name",
                        icon: (0, $bq9l8.icons).Edit,
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $9srzl.minTrackNameLength),
                        max: (0, $9srzl.maxTrackNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $lRNbG.validateTrackName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $56gEK.styles)().form.content.genres.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $56gEK.styles)().form.content.genres.selected.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $56gEK.styles)().form.content.genres.selected.label,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                        text: "Genre"
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $56gEK.styles)().form.content.genres.selected.genres,
                                    children: genres.map((trackGenre)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $9HR7l.BadgeSelected), {
                                            name: trackGenre,
                                            onRemoveClick: ()=>setGenres((state)=>state.filter((genre)=>genre !== trackGenre))
                                        }, `track-genres-${trackGenre}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $56gEK.styles)().form.content.genres.search.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $56gEK.styles)().form.content.genres.search.input,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6F2CE.InputLine), {
                                        name: "search",
                                        label: "Select genre",
                                        type: "search",
                                        placeholder: "Find genre",
                                        icon: (0, $bq9l8.icons).Search,
                                        value: search,
                                        onChange: (e)=>{
                                            setSearch(e.target.value);
                                            setMusicGenres((0, $cGp48.musicGenres).filter((genre)=>genre.toLowerCase().includes(e.target.value)));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $56gEK.styles)().form.content.genres.search.genres,
                                    children: musicGenres.map((genre)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $7y6mB.Badge), {
                                            name: genre,
                                            disabled: genres.includes(genre) || genres.length >= (0, $cGp48.maxTrackGenresCount),
                                            onClick: ()=>setGenres((state)=>[
                                                        ...state,
                                                        genre
                                                    ])
                                        }, `music-genres-${genre}`))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $56gEK.styles)().form.content.visibility.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $56gEK.styles)().form.content.visibility.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Visibility"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $56gEK.styles)().form.content.visibility.inputs,
                            children: [
                                visibility === (0, $2gpGl.EntityTrackVisibility).Public && /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Public",
                                    description: "With this visibility option, the track is made publicly accessible to everyone on the platform",
                                    icon: (0, $bq9l8.icons).Unlock,
                                    checked: visibility === (0, $2gpGl.EntityTrackVisibility).Public,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityTrackVisibility).Public)
                                }),
                                visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsx)((0, $95KdT.CheckboxOption), {
                                    name: "Subscribers",
                                    description: "With this visibility option, the track is exclusively accessible to subscribers or individuals who unlock it directly",
                                    icon: (0, $bq9l8.icons).Lock,
                                    checked: visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers,
                                    onCheckboxClick: ()=>setVisibility((0, $2gpGl.EntityTrackVisibility).Subscribers)
                                })
                            ]
                        })
                    ]
                }),
                visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $56gEK.styles)().form.content.price.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $56gEK.styles)().form.content.price.label,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                text: "Price"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $56gEK.styles)().form.content.price.amount,
                            children: [
                                "$",
                                (currentUnlockPrice || 0) / 100
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $56gEK.styles)().form.content.buttons.main,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $56gEK.styles)().form.content.buttons.submit,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                            type: "submit",
                            "aria-label": "update track",
                            disabled: submitDisabled,
                            appearance: "primary",
                            children: trackUpdateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                width: 56,
                                height: 20,
                                appearance: "secondary"
                            }) : "Update"
                        })
                    })
                })
            ]
        })
    });
};
$de3e13cf6317a869$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("56gEK", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $3b1c9bfe1eb08c5c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $3b1c9bfe1eb08c5c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $3b1c9bfe1eb08c5c$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $3b1c9bfe1eb08c5c$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $3b1c9bfe1eb08c5c$var$_ref3 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $3b1c9bfe1eb08c5c$var$_ref4 = {
    name: "j9ove5",
    styles: "margin-bottom:22px"
};
var $3b1c9bfe1eb08c5c$var$_ref5 = {
    name: "1lvxmaz",
    styles: "&>div:not(:last-of-type){margin-bottom:12px;}"
};
var $3b1c9bfe1eb08c5c$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $3b1c9bfe1eb08c5c$var$_ref7 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $3b1c9bfe1eb08c5c$var$_ref8 = {
    name: "c1gao8",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:10px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $3b1c9bfe1eb08c5c$var$_ref9 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $3b1c9bfe1eb08c5c$var$_ref10 = {
    name: "1omvlk4",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:20px;}&>div:not(:last-of-type){margin-right:20px;}"
};
var $3b1c9bfe1eb08c5c$var$_ref11 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $3b1c9bfe1eb08c5c$var$_ref12 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $3b1c9bfe1eb08c5c$var$_ref13 = {
    name: "qkomnt",
    styles: "margin-bottom:40px"
};
var $3b1c9bfe1eb08c5c$var$_ref14 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $3b1c9bfe1eb08c5c$var$_ref15 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $3b1c9bfe1eb08c5c$var$_ref16 = {
    name: "88047v",
    styles: "padding-left:14px;&>div{justify-content:flex-start;}"
};
var $3b1c9bfe1eb08c5c$var$_ref17 = {
    name: "eivff4",
    styles: "display:none"
};
var $3b1c9bfe1eb08c5c$var$_ref18 = {
    name: "xagbzs",
    styles: "margin-bottom:6px"
};
var $3b1c9bfe1eb08c5c$var$_ref19 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $3b1c9bfe1eb08c5c$var$_ref20 = {
    name: "1micmlt",
    styles: "display:flex;flex-direction:column;margin-bottom:44px"
};
const $3b1c9bfe1eb08c5c$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                cover: {
                    main: $3b1c9bfe1eb08c5c$var$_ref20,
                    label: $3b1c9bfe1eb08c5c$var$_ref19,
                    preview: {
                        main: $3b1c9bfe1eb08c5c$var$_ref18,
                        label: $3b1c9bfe1eb08c5c$var$_ref17,
                        image: /*#__PURE__*/ (0, $7hler.css)("", "")
                    },
                    error: $3b1c9bfe1eb08c5c$var$_ref16
                },
                name: $3b1c9bfe1eb08c5c$var$_ref15,
                username: $3b1c9bfe1eb08c5c$var$_ref14,
                genres: {
                    main: $3b1c9bfe1eb08c5c$var$_ref13,
                    selected: {
                        main: $3b1c9bfe1eb08c5c$var$_ref12,
                        label: $3b1c9bfe1eb08c5c$var$_ref11,
                        genres: $3b1c9bfe1eb08c5c$var$_ref10
                    },
                    search: {
                        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        input: $3b1c9bfe1eb08c5c$var$_ref9,
                        genres: $3b1c9bfe1eb08c5c$var$_ref8
                    }
                },
                visibility: {
                    main: $3b1c9bfe1eb08c5c$var$_ref7,
                    label: $3b1c9bfe1eb08c5c$var$_ref6,
                    inputs: $3b1c9bfe1eb08c5c$var$_ref5
                },
                price: {
                    main: $3b1c9bfe1eb08c5c$var$_ref4,
                    label: $3b1c9bfe1eb08c5c$var$_ref3,
                    amount: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h4, ";line-height:24px;margin-bottom:10px;", "")
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).tablet($3b1c9bfe1eb08c5c$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:220px;}", (0, $gln0L.mq).tablet($3b1c9bfe1eb08c5c$var$_ref), ";", "")
                }
            }
        }
    });

});



parcelRegister("55Dcw", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $d5e4f52f8548a98d$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $d5e4f52f8548a98d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d5e4f52f8548a98d$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $d5e4f52f8548a98d$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $d5e4f52f8548a98d$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $d5e4f52f8548a98d$export$9dd6ff9ea0189349 = ()=>({
        card: {
            main: $d5e4f52f8548a98d$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:400px;", (0, $gln0L.mq).tablet($d5e4f52f8548a98d$var$_ref2), ";", ""),
                form: $d5e4f52f8548a98d$var$_ref
            }
        }
    });

});



parcelRegister("5zZt1", function(module, exports) {

$parcel$export(module.exports, "trackUtilGetTrackTileSkeletonSections", function () { return $27f88662490ebf55$export$ce2eef85e2d4c0d7; });
const $27f88662490ebf55$export$ce2eef85e2d4c0d7 = (sectionName)=>[
        {
            name: `${sectionName}-media`,
            width: "180px",
            height: "180px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider`,
            width: "180px",
            height: "10px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-description`,
            width: "180px",
            height: "38px",
            isStatic: true,
            isDivider: false
        }
    ];

});

parcelRegister("2Vh5B", function(module, exports) {

$parcel$export(module.exports, "trackSlice", function () { return $80d7082aabf0aae1$export$a3d6f2521ab23ff4; });
$parcel$export(module.exports, "trackResetState", function () { return $80d7082aabf0aae1$export$91afce20dedb32ac; });
$parcel$export(module.exports, "trackSetPublicTracks", function () { return $80d7082aabf0aae1$export$2d7ecf5aea6fabe7; });
$parcel$export(module.exports, "trackSetPopularTracks", function () { return $80d7082aabf0aae1$export$c911a6cb418acc4a; });
$parcel$export(module.exports, "trackSetExclusiveTracks", function () { return $80d7082aabf0aae1$export$ba92f12611d6e509; });
$parcel$export(module.exports, "trackSetLatestTracks", function () { return $80d7082aabf0aae1$export$821dde0cff897f4c; });
$parcel$export(module.exports, "trackSetTrendingTracks", function () { return $80d7082aabf0aae1$export$85f6b0beeb7c7923; });
$parcel$export(module.exports, "trackSetRecommendedTracks", function () { return $80d7082aabf0aae1$export$535c0003673c0bae; });
$parcel$export(module.exports, "trackSetLikedTracks", function () { return $80d7082aabf0aae1$export$b1024953c618252f; });
$parcel$export(module.exports, "trackSetUnlockedTracks", function () { return $80d7082aabf0aae1$export$4dbbdb417cd9533b; });
$parcel$export(module.exports, "trackSetUploadedTracks", function () { return $80d7082aabf0aae1$export$35e8364feff109ed; });
$parcel$export(module.exports, "trackSetArtistPopularTracks", function () { return $80d7082aabf0aae1$export$7d7c134223540010; });
$parcel$export(module.exports, "trackSetArtistExclusiveTracks", function () { return $80d7082aabf0aae1$export$6429021d85ed6478; });
$parcel$export(module.exports, "trackSetArtistLatestTracks", function () { return $80d7082aabf0aae1$export$420feca5c0f2e889; });
$parcel$export(module.exports, "trackResetArtistTracks", function () { return $80d7082aabf0aae1$export$d742c877f096cf38; });
$parcel$export(module.exports, "trackSetPostTracks", function () { return $80d7082aabf0aae1$export$236c041833b35867; });
$parcel$export(module.exports, "trackResetPostTracks", function () { return $80d7082aabf0aae1$export$1c19257305af6d24; });
$parcel$export(module.exports, "trackAppendLikedTrack", function () { return $80d7082aabf0aae1$export$2c56715bdb589a3d; });
$parcel$export(module.exports, "trackFilterLikedTrack", function () { return $80d7082aabf0aae1$export$105c65e084ab827c; });
$parcel$export(module.exports, "trackAppendUnlockedTrack", function () { return $80d7082aabf0aae1$export$5ca905dee28a2d99; });
$parcel$export(module.exports, "trackFilterUnlockedTrack", function () { return $80d7082aabf0aae1$export$edb49a15130cb96d; });
$parcel$export(module.exports, "trackFilterTrack", function () { return $80d7082aabf0aae1$export$d86d1aaa5820656c; });
$parcel$export(module.exports, "trackFilterUserTracks", function () { return $80d7082aabf0aae1$export$85e845fda476ba58; });
$parcel$export(module.exports, "trackUpdateTrack", function () { return $80d7082aabf0aae1$export$3c3a856b71c10cd2; });
$parcel$export(module.exports, "trackOpenTrackBlockModal", function () { return $80d7082aabf0aae1$export$56e331a908d904d5; });
$parcel$export(module.exports, "trackCloseTrackBlockModal", function () { return $80d7082aabf0aae1$export$6811b8863997ba45; });
$parcel$export(module.exports, "trackOpenTrackDeleteModal", function () { return $80d7082aabf0aae1$export$2de241ab12382de6; });
$parcel$export(module.exports, "trackCloseTrackDeleteModal", function () { return $80d7082aabf0aae1$export$bbe0b92674fa755e; });
$parcel$export(module.exports, "trackSelectPublicTracks", function () { return $80d7082aabf0aae1$export$47564cb5d8147207; });
$parcel$export(module.exports, "trackSelectPublicTracksLength", function () { return $80d7082aabf0aae1$export$f9b9ca0cc1f5cfce; });
$parcel$export(module.exports, "trackSelectPublicTracksCount", function () { return $80d7082aabf0aae1$export$a3ec4174f8290ea1; });
$parcel$export(module.exports, "trackSelectPublicTracksFetched", function () { return $80d7082aabf0aae1$export$f039f0f464c79d83; });
$parcel$export(module.exports, "trackSelectPopularTracks", function () { return $80d7082aabf0aae1$export$4c37c8f4ddb5ccdd; });
$parcel$export(module.exports, "trackSelectPopularTracksLength", function () { return $80d7082aabf0aae1$export$58a8663ddd7bfa52; });
$parcel$export(module.exports, "trackSelectPopularTracksCount", function () { return $80d7082aabf0aae1$export$62d4bca2ea171ac2; });
$parcel$export(module.exports, "trackSelectPopularTracksFetched", function () { return $80d7082aabf0aae1$export$226bc2dcf7547000; });
$parcel$export(module.exports, "trackSelectExclusiveTracks", function () { return $80d7082aabf0aae1$export$e37f1fe62af44d2e; });
$parcel$export(module.exports, "trackSelectExclusiveTracksLength", function () { return $80d7082aabf0aae1$export$ce85ccdd80284243; });
$parcel$export(module.exports, "trackSelectExclusiveTracksCount", function () { return $80d7082aabf0aae1$export$69d3f01427ab5991; });
$parcel$export(module.exports, "trackSelectExclusiveTracksFetched", function () { return $80d7082aabf0aae1$export$c6816f57f96de775; });
$parcel$export(module.exports, "trackSelectLatestTracks", function () { return $80d7082aabf0aae1$export$90d97c0db639420a; });
$parcel$export(module.exports, "trackSelectLatestTracksLength", function () { return $80d7082aabf0aae1$export$9a6fce8c107f08e9; });
$parcel$export(module.exports, "trackSelectLatestTracksCount", function () { return $80d7082aabf0aae1$export$8e8fc430e197b863; });
$parcel$export(module.exports, "trackSelectLatestTracksFetched", function () { return $80d7082aabf0aae1$export$401eea2f5ce1ff4b; });
$parcel$export(module.exports, "trackSelectTrendingTracks", function () { return $80d7082aabf0aae1$export$b5066207a175173a; });
$parcel$export(module.exports, "trackSelectTrendingTracksLength", function () { return $80d7082aabf0aae1$export$43b5c9b6c0d0dadd; });
$parcel$export(module.exports, "trackSelectTrendingTracksCount", function () { return $80d7082aabf0aae1$export$a04c165a82b3cbc4; });
$parcel$export(module.exports, "trackSelectTrendingTracksFetched", function () { return $80d7082aabf0aae1$export$87f17186a6cf9d3b; });
$parcel$export(module.exports, "trackSelectRecommendedTracks", function () { return $80d7082aabf0aae1$export$e5e50bc712e38d93; });
$parcel$export(module.exports, "trackSelectRecommendedTracksLength", function () { return $80d7082aabf0aae1$export$4411836d2a84bab1; });
$parcel$export(module.exports, "trackSelectRecommendedTracksCount", function () { return $80d7082aabf0aae1$export$f1ac8d7f901cff94; });
$parcel$export(module.exports, "trackSelectRecommendedTracksFetched", function () { return $80d7082aabf0aae1$export$bb2b22d1dbb538c5; });
$parcel$export(module.exports, "trackSelectLikedTracks", function () { return $80d7082aabf0aae1$export$35df9b11880abfde; });
$parcel$export(module.exports, "trackSelectLikedTracksLength", function () { return $80d7082aabf0aae1$export$f2f25b45129fd9bf; });
$parcel$export(module.exports, "trackSelectLikedTracksCount", function () { return $80d7082aabf0aae1$export$2146ae74a6c967e9; });
$parcel$export(module.exports, "trackSelectLikedTracksFetched", function () { return $80d7082aabf0aae1$export$928b86b46ccdda3b; });
$parcel$export(module.exports, "trackSelectUnlockedTracks", function () { return $80d7082aabf0aae1$export$a22acbc5ae261a16; });
$parcel$export(module.exports, "trackSelectUnlockedTracksLength", function () { return $80d7082aabf0aae1$export$e8d801ab210db7ab; });
$parcel$export(module.exports, "trackSelectUnlockedTracksCount", function () { return $80d7082aabf0aae1$export$a5125418d1c9c810; });
$parcel$export(module.exports, "trackSelectUnlockedTracksFetched", function () { return $80d7082aabf0aae1$export$504378086fb25edd; });
$parcel$export(module.exports, "trackSelectUploadedTracks", function () { return $80d7082aabf0aae1$export$8207498fbe72f46; });
$parcel$export(module.exports, "trackSelectUploadedTracksLength", function () { return $80d7082aabf0aae1$export$22a092517e09c0d; });
$parcel$export(module.exports, "trackSelectUploadedTracksCount", function () { return $80d7082aabf0aae1$export$27e0ae462cc2be1e; });
$parcel$export(module.exports, "trackSelectUploadedTracksFetched", function () { return $80d7082aabf0aae1$export$a9a4448b2e07780; });
$parcel$export(module.exports, "trackSelectArtistPopularTracks", function () { return $80d7082aabf0aae1$export$111a3c3534ddce76; });
$parcel$export(module.exports, "trackSelectArtistPopularTracksLength", function () { return $80d7082aabf0aae1$export$1092d17ce779b213; });
$parcel$export(module.exports, "trackSelectArtistPopularTracksCount", function () { return $80d7082aabf0aae1$export$2d7a26414c6d58ac; });
$parcel$export(module.exports, "trackSelectArtistPopularTracksFetched", function () { return $80d7082aabf0aae1$export$b65214841fdacb75; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracks", function () { return $80d7082aabf0aae1$export$7ec3893edfc43a66; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracksLength", function () { return $80d7082aabf0aae1$export$ee53d2e211394bc9; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracksCount", function () { return $80d7082aabf0aae1$export$62ac15c1e4cbd19e; });
$parcel$export(module.exports, "trackSelectArtistExclusiveTracksFetched", function () { return $80d7082aabf0aae1$export$5a188b1cb81c365f; });
$parcel$export(module.exports, "trackSelectArtistLatestTracks", function () { return $80d7082aabf0aae1$export$d8936ba0cbd1cc2b; });
$parcel$export(module.exports, "trackSelectArtistLatestTracksLength", function () { return $80d7082aabf0aae1$export$c3e0fa980513d7e3; });
$parcel$export(module.exports, "trackSelectArtistLatestTracksCount", function () { return $80d7082aabf0aae1$export$24fc321fc9d0319a; });
$parcel$export(module.exports, "trackSelectArtistLatestTracksFetched", function () { return $80d7082aabf0aae1$export$b10cc2dffa5268ea; });
$parcel$export(module.exports, "trackSelectPostTracks", function () { return $80d7082aabf0aae1$export$7cfade53894d2355; });
$parcel$export(module.exports, "trackSelectPostTracksFetched", function () { return $80d7082aabf0aae1$export$8bca47c1f4b2b968; });
$parcel$export(module.exports, "trackSelectTrackBlockModalOpen", function () { return $80d7082aabf0aae1$export$e30c4435926569f1; });
$parcel$export(module.exports, "trackSelectTrackBlockModalTrack", function () { return $80d7082aabf0aae1$export$18e4366d1e17c8e0; });
$parcel$export(module.exports, "trackSelectTrackDeleteModalOpen", function () { return $80d7082aabf0aae1$export$6c8a6385741ff7b6; });
$parcel$export(module.exports, "trackSelectTrackDeleteModalTrack", function () { return $80d7082aabf0aae1$export$6cb3e01afd8d3c94; });
$parcel$export(module.exports, "trackSelectTrackGetPublicTracksLoading", function () { return $80d7082aabf0aae1$export$405ef44e6ed74011; });
$parcel$export(module.exports, "trackSelectTrackGetPopularTracksLoading", function () { return $80d7082aabf0aae1$export$ae8b9e001696b5cf; });
$parcel$export(module.exports, "trackSelectTrackGetExclusiveTracksLoading", function () { return $80d7082aabf0aae1$export$d2c296bdb2317093; });
$parcel$export(module.exports, "trackSelectTrackGetLatestTracksLoading", function () { return $80d7082aabf0aae1$export$d335e3779b1f7f7e; });
$parcel$export(module.exports, "trackSelectTrackGetTrendingTracksLoading", function () { return $80d7082aabf0aae1$export$913df1835a6c3f1e; });
$parcel$export(module.exports, "trackSelectTrackGetRecommendedTracksLoading", function () { return $80d7082aabf0aae1$export$cfc3b6c697b820ca; });
$parcel$export(module.exports, "trackSelectTrackGetLikedTracksLoading", function () { return $80d7082aabf0aae1$export$b8b634e26fb18437; });
$parcel$export(module.exports, "trackSelectTrackGetUnlockedTracksLoading", function () { return $80d7082aabf0aae1$export$e693f231ed8581d9; });
$parcel$export(module.exports, "trackSelectTrackGetUploadedTracksLoading", function () { return $80d7082aabf0aae1$export$eb68542484efa1fe; });
$parcel$export(module.exports, "trackSelectTrackGetArtistPopularTracksLoading", function () { return $80d7082aabf0aae1$export$469daa70a5bdb26f; });
$parcel$export(module.exports, "trackSelectTrackGetArtistExclusiveTracksLoading", function () { return $80d7082aabf0aae1$export$a14d11ba620ac874; });
$parcel$export(module.exports, "trackSelectTrackGetArtistLatestTracksLoading", function () { return $80d7082aabf0aae1$export$724cd8f38778db29; });
$parcel$export(module.exports, "trackSelectTrackGetPostTracksLoading", function () { return $80d7082aabf0aae1$export$9aad2ecb49cd085b; });
$parcel$export(module.exports, "trackSelectTrackCreateLoading", function () { return $80d7082aabf0aae1$export$4133c331aede8f7b; });
$parcel$export(module.exports, "trackSelectTrackUpdateLoading", function () { return $80d7082aabf0aae1$export$b23ee01741eaf3c9; });
$parcel$export(module.exports, "trackSelectTrackBlockLoading", function () { return $80d7082aabf0aae1$export$dc2ec62f755fa49a; });
$parcel$export(module.exports, "trackSelectTrackDeleteLoading", function () { return $80d7082aabf0aae1$export$7e1ad1aad8696bcb; });
$parcel$export(module.exports, "trackReducer", function () { return $80d7082aabf0aae1$export$e4057e913f54cc7e; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $kwNyE = parcelRequire("kwNyE");
const $80d7082aabf0aae1$var$initialState = {
    publicTracks: [],
    publicTracksCount: 0,
    publicTracksFetched: false,
    popularTracks: [],
    popularTracksCount: 0,
    popularTracksFetched: false,
    exclusiveTracks: [],
    exclusiveTracksCount: 0,
    exclusiveTracksFetched: false,
    latestTracks: [],
    latestTracksCount: 0,
    latestTracksFetched: false,
    trendingTracks: [],
    trendingTracksCount: 0,
    trendingTracksFetched: false,
    recommendedTracks: [],
    recommendedTracksCount: 0,
    recommendedTracksFetched: false,
    likedTracks: [],
    likedTracksCount: 0,
    likedTracksFetched: false,
    unlockedTracks: [],
    unlockedTracksCount: 0,
    unlockedTracksFetched: false,
    uploadedTracks: [],
    uploadedTracksCount: 0,
    uploadedTracksFetched: false,
    artistPopularTracks: [],
    artistPopularTracksCount: 0,
    artistPopularTracksFetched: false,
    artistExclusiveTracks: [],
    artistExclusiveTracksCount: 0,
    artistExclusiveTracksFetched: false,
    artistLatestTracks: [],
    artistLatestTracksCount: 0,
    artistLatestTracksFetched: false,
    postTracks: [],
    postTracksFetched: false,
    trackBlockModal: {
        track: undefined,
        open: false
    },
    trackDeleteModal: {
        track: undefined,
        open: false
    },
    trackGetPublicTracksLoading: false,
    trackGetPopularTracksLoading: false,
    trackGetExclusiveTracksLoading: false,
    trackGetLatestTracksLoading: false,
    trackGetTrendingTracksLoading: false,
    trackGetRecommendedTracksLoading: false,
    trackGetLikedTracksLoading: false,
    trackGetUnlockedTracksLoading: false,
    trackGetUploadedTracksLoading: false,
    trackGetArtistPopularTracksLoading: false,
    trackGetArtistExclusiveTracksLoading: false,
    trackGetArtistLatestTracksLoading: false,
    trackGetPostTracksLoading: false,
    trackCreateLoading: false,
    trackUpdateLoading: false,
    trackBlockLoading: false,
    trackDeleteLoading: false
};
const $80d7082aabf0aae1$export$a3d6f2521ab23ff4 = (0, $kvj5V.createSlice)({
    name: "track",
    initialState: $80d7082aabf0aae1$var$initialState,
    reducers: {
        // reset state
        trackResetState: ()=>({
                publicTracks: [],
                publicTracksCount: 0,
                publicTracksFetched: false,
                popularTracks: [],
                popularTracksCount: 0,
                popularTracksFetched: false,
                exclusiveTracks: [],
                exclusiveTracksCount: 0,
                exclusiveTracksFetched: false,
                latestTracks: [],
                latestTracksCount: 0,
                latestTracksFetched: false,
                trendingTracks: [],
                trendingTracksCount: 0,
                trendingTracksFetched: false,
                recommendedTracks: [],
                recommendedTracksCount: 0,
                recommendedTracksFetched: false,
                likedTracks: [],
                likedTracksCount: 0,
                likedTracksFetched: false,
                unlockedTracks: [],
                unlockedTracksCount: 0,
                unlockedTracksFetched: false,
                profileTracks: [],
                profileTracksCount: 0,
                profileTracksFetched: false,
                uploadedTracks: [],
                uploadedTracksCount: 0,
                uploadedTracksFetched: false,
                artistPopularTracks: [],
                artistPopularTracksCount: 0,
                artistPopularTracksFetched: false,
                artistExclusiveTracks: [],
                artistExclusiveTracksCount: 0,
                artistExclusiveTracksFetched: false,
                artistLatestTracks: [],
                artistLatestTracksCount: 0,
                artistLatestTracksFetched: false,
                postTracks: [],
                postTracksFetched: false,
                trackBlockModal: {
                    track: undefined,
                    open: false
                },
                trackDeleteModal: {
                    track: undefined,
                    open: false
                },
                trackGetPublicTracksLoading: false,
                trackGetPopularTracksLoading: false,
                trackGetExclusiveTracksLoading: false,
                trackGetLatestTracksLoading: false,
                trackGetTrendingTracksLoading: false,
                trackGetRecommendedTracksLoading: false,
                trackGetLikedTracksLoading: false,
                trackGetUnlockedTracksLoading: false,
                trackGetUploadedTracksLoading: false,
                trackGetArtistPopularTracksLoading: false,
                trackGetArtistExclusiveTracksLoading: false,
                trackGetArtistLatestTracksLoading: false,
                trackGetPostTracksLoading: false,
                trackCreateLoading: false,
                trackUpdateLoading: false,
                trackBlockLoading: false,
                trackDeleteLoading: false
            }),
        // set public tracks
        trackSetPublicTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.publicTracksCount = count;
                // mutate public tracks array
                state.publicTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.publicTracks, tracks, offset);
            }
        },
        // set popular tracks
        trackSetPopularTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.popularTracksCount = count;
                // mutate popular tracks array
                state.popularTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.popularTracks, tracks, offset);
            }
        },
        // set exclusive tracks
        trackSetExclusiveTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.exclusiveTracksCount = count;
                // mutate exclusive tracks array
                state.exclusiveTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.exclusiveTracks, tracks, offset);
            }
        },
        // set latest tracks
        trackSetLatestTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.latestTracksCount = count;
                // mutate latest tracks array
                state.latestTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.latestTracks, tracks, offset);
            }
        },
        // set trending tracks
        trackSetTrendingTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.trendingTracksCount = count;
                // mutate trending tracks array
                state.trendingTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.trendingTracks, tracks, offset);
            }
        },
        // set recommended tracks
        trackSetRecommendedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.recommendedTracksCount = count;
                // mutate recommended tracks array
                state.recommendedTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.recommendedTracks, tracks, offset);
            }
        },
        // set liked tracks
        trackSetLikedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.likedTracksCount = count;
                // mutate liked tracks array
                state.likedTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.likedTracks, tracks, offset);
            }
        },
        // set unlocked tracks
        trackSetUnlockedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.unlockedTracksCount = count;
                // mutate unlocked tracks array
                state.unlockedTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.unlockedTracks, tracks, offset);
            }
        },
        // set uploaded tracks
        trackSetUploadedTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.uploadedTracksCount = count;
                // mutate uploaded tracks array
                state.uploadedTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.uploadedTracks, tracks, offset);
            }
        },
        // set artist popular tracks
        trackSetArtistPopularTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistPopularTracksCount = count;
            // mutate artist popular tracks array
            state.artistPopularTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.artistPopularTracks, tracks, offset);
        },
        // set artist exclusive tracks
        trackSetArtistExclusiveTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistExclusiveTracksCount = count;
            // mutate artist exclusive tracks array
            state.artistExclusiveTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.artistExclusiveTracks, tracks, offset);
        },
        // set artist latest tracks
        trackSetArtistLatestTracks: (state, action)=>{
            const { tracks: tracks, count: count, offset: offset } = action.payload;
            // mutate count
            state.artistLatestTracksCount = count;
            // mutate artist latest tracks array
            state.artistLatestTracks = (0, $6Rkyy.mergeArraysAtIndex)(state.artistLatestTracks, tracks, offset);
        },
        // reset artist tracks
        trackResetArtistTracks: (state)=>({
                ...state,
                artistPopularTracks: [],
                artistPopularTracksCount: 0,
                artistPopularTracksFetched: false,
                artistExclusiveTracks: [],
                artistExclusiveTracksCount: 0,
                artistExclusiveTracksFetched: false,
                artistLatestTracks: [],
                artistLatestTracksCount: 0,
                artistLatestTracksFetched: false
            }),
        // set post tracks
        trackSetPostTracks: (state, action)=>{
            const { tracks: tracks } = action.payload;
            // update post tracks state
            state.postTracks = tracks;
        },
        // reset post tracks
        trackResetPostTracks: (state)=>({
                ...state,
                postTracks: [],
                postTracksFetched: false
            }),
        // append liked track
        trackAppendLikedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if liked tracks are fetched
            if (state.likedTracksFetched) {
                // append track to liked tracks
                state.likedTracks.unshift(track);
                state.likedTracksCount += 1;
            }
        },
        // filter liked track
        trackFilterLikedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if liked tracks are fetched
            if (state.likedTracksFetched) {
                // filter track from liked tracks
                state.likedTracks = state.likedTracks.filter((t)=>t.id !== track.id);
                state.likedTracksCount -= 1;
            }
        },
        // append unlocked track
        trackAppendUnlockedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if unlocked tracks are fetched
            if (state.unlockedTracksFetched) {
                // append track to unlocked tracks
                state.unlockedTracks.unshift(track);
                state.unlockedTracksCount += 1;
            }
        },
        // filter unlocked track
        trackFilterUnlockedTrack: (state, action)=>{
            const { track: track } = action.payload;
            // if unlocked tracks are fetched
            if (state.unlockedTracksFetched) {
                // filter track from unlocked tracks
                state.unlockedTracks = state.unlockedTracks.filter((t)=>t.id !== track.id);
                state.unlockedTracksCount -= 1;
            }
        },
        // filter track
        trackFilterTrack: (state, action)=>{
            const { id: id } = action.payload;
            // check if track exists in public tracks
            const pubIndex = state.publicTracks.findIndex((t)=>t.id === id);
            if (pubIndex !== -1) {
                // filter track
                state.publicTracks = state.publicTracks.filter((t)=>t.id !== id);
                state.publicTracksCount -= 1;
            }
            // check if track exists in popular tracks
            const popIndex = state.popularTracks.findIndex((t)=>t.id === id);
            if (popIndex !== -1) {
                // filter track
                state.popularTracks = state.popularTracks.filter((t)=>t.id !== id);
                state.popularTracksCount -= 1;
            }
            // check if track exists in exclusive tracks
            const exIndex = state.exclusiveTracks.findIndex((t)=>t.id === id);
            if (exIndex !== -1) {
                // filter track
                state.exclusiveTracks = state.exclusiveTracks.filter((t)=>t.id !== id);
                state.exclusiveTracksCount -= 1;
            }
            // check if track exists in latest tracks
            const laIndex = state.latestTracks.findIndex((t)=>t.id === id);
            if (laIndex !== -1) {
                // filter track
                state.latestTracks = state.latestTracks.filter((t)=>t.id !== id);
                state.latestTracksCount -= 1;
            }
            // check if track exists in trending tracks
            const trIndex = state.trendingTracks.findIndex((t)=>t.id === id);
            if (trIndex !== -1) {
                // filter track
                state.trendingTracks = state.trendingTracks.filter((t)=>t.id !== id);
                state.trendingTracksCount -= 1;
            }
            // check if track exists in recommended tracks
            const recIndex = state.recommendedTracks.findIndex((t)=>t.id === id);
            if (recIndex !== -1) {
                // filter track
                state.recommendedTracks = state.recommendedTracks.filter((t)=>t.id !== id);
                state.recommendedTracksCount -= 1;
            }
            // check if track exists in liked tracks
            const lkIndex = state.likedTracks.findIndex((t)=>t.id === id);
            if (lkIndex !== -1) {
                // filter track
                state.likedTracks = state.likedTracks.filter((t)=>t.id !== id);
                state.likedTracksCount -= 1;
            }
            // check if track exists in unlocked tracks
            const unlIndex = state.unlockedTracks.findIndex((t)=>t.id === id);
            if (unlIndex !== -1) {
                // filter track
                state.unlockedTracks = state.unlockedTracks.filter((t)=>t.id !== id);
                state.unlockedTracksCount -= 1;
            }
            // check if track exists in uploaded tracks
            const uplIndex = state.uploadedTracks.findIndex((t)=>t.id === id);
            if (uplIndex !== -1) {
                // filter track
                state.uploadedTracks = state.uploadedTracks.filter((t)=>t.id !== id);
                state.uploadedTracksCount -= 1;
            }
            // check if track exists in artist popular tracks
            const aPopIndex = state.artistPopularTracks.findIndex((t)=>t.id === id);
            if (aPopIndex !== -1) {
                // filter track
                state.artistPopularTracks = state.artistPopularTracks.filter((t)=>t.id !== id);
                state.artistPopularTracksCount -= 1;
            }
            // check if track exists in artist exclusive tracks
            const aExIndex = state.artistExclusiveTracks.findIndex((t)=>t.id === id);
            if (aExIndex !== -1) {
                // filter track
                state.artistExclusiveTracks = state.artistExclusiveTracks.filter((t)=>t.id !== id);
                state.artistExclusiveTracksCount -= 1;
            }
            // check if track exists in artist latest tracks
            const aLatIndex = state.artistLatestTracks.findIndex((t)=>t.id === id);
            if (aLatIndex !== -1) {
                // filter track
                state.artistLatestTracks = state.artistLatestTracks.filter((t)=>t.id !== id);
                state.artistLatestTracksCount -= 1;
            }
            // check if track exists in post tracks
            const ptIndex = state.postTracks.findIndex((t)=>t.id === id);
            if (ptIndex !== -1) // filter track
            state.postTracks = state.postTracks.filter((t)=>t.id !== id);
        },
        // filter user tracks
        trackFilterUserTracks: (state, action)=>{
            const { userId: userId } = action.payload;
            // filter user tracks from public tracks
            const filteredPublicTracks = state.publicTracks.filter((t)=>t.userId !== userId);
            const filteredPublicTracksCount = state.publicTracks.length - filteredPublicTracks.length;
            // if filtered tracks
            if (filteredPublicTracksCount > 0) {
                // update tracks
                state.publicTracks = filteredPublicTracks;
                state.publicTracksCount -= filteredPublicTracksCount;
            }
            // filter user tracks from popular tracks
            const filteredPopularTracks = state.popularTracks.filter((t)=>t.userId !== userId);
            const filteredPopularTracksCount = state.popularTracks.length - filteredPopularTracks.length;
            // if filtered tracks
            if (filteredPopularTracksCount > 0) {
                // update tracks
                state.popularTracks = filteredPopularTracks;
                state.popularTracksCount -= filteredPopularTracksCount;
            }
            // filter user tracks from exclusive tracks
            const filteredExclusiveTracks = state.exclusiveTracks.filter((t)=>t.userId !== userId);
            const filteredExclusiveTracksCount = state.exclusiveTracks.length - filteredExclusiveTracks.length;
            // if filtered tracks
            if (filteredExclusiveTracksCount > 0) {
                // update tracks
                state.exclusiveTracks = filteredExclusiveTracks;
                state.exclusiveTracksCount -= filteredExclusiveTracksCount;
            }
            // filter user tracks from latest tracks
            const filteredLatestTracks = state.latestTracks.filter((t)=>t.userId !== userId);
            const filteredLatestTracksCount = state.latestTracks.length - filteredLatestTracks.length;
            // if filtered tracks
            if (filteredLatestTracksCount > 0) {
                // update tracks
                state.latestTracks = filteredLatestTracks;
                state.latestTracksCount -= filteredLatestTracksCount;
            }
            // filter user tracks from trending tracks
            const filteredTrendingTracks = state.trendingTracks.filter((t)=>t.userId !== userId);
            const filteredTrendingTracksCount = state.trendingTracks.length - filteredTrendingTracks.length;
            // if filtered tracks
            if (filteredTrendingTracksCount > 0) {
                // update tracks
                state.trendingTracks = filteredTrendingTracks;
                state.trendingTracksCount -= filteredTrendingTracksCount;
            }
            // filter user tracks from recommended tracks
            const filteredRecommendedTracks = state.recommendedTracks.filter((t)=>t.userId !== userId);
            const filteredRecommendedTracksCount = state.recommendedTracks.length - filteredRecommendedTracks.length;
            // if filtered tracks
            if (filteredRecommendedTracksCount > 0) {
                // update tracks
                state.recommendedTracks = filteredRecommendedTracks;
                state.recommendedTracksCount -= filteredRecommendedTracksCount;
            }
            // filter user tracks from liked tracks
            const filteredLikedTracks = state.likedTracks.filter((t)=>t.userId !== userId);
            const filteredLikedTracksCount = state.likedTracks.length - filteredLikedTracks.length;
            // if filtered tracks
            if (filteredLikedTracksCount > 0) {
                // update tracks
                state.likedTracks = filteredLikedTracks;
                state.likedTracksCount -= filteredLikedTracksCount;
            }
            // filter user tracks from unlocked tracks
            const filteredUnlockedTracks = state.unlockedTracks.filter((t)=>t.userId !== userId);
            const filteredUnlockedTracksCount = state.unlockedTracks.length - filteredUnlockedTracks.length;
            // if filtered tracks
            if (filteredUnlockedTracksCount > 0) {
                // update tracks
                state.unlockedTracks = filteredUnlockedTracks;
                state.unlockedTracksCount -= filteredUnlockedTracksCount;
            }
            // filter user tracks from uploaded tracks
            const filteredUploadedTracks = state.uploadedTracks.filter((t)=>t.userId !== userId);
            const filteredUploadedTracksCount = state.uploadedTracks.length - filteredUploadedTracks.length;
            // if filtered tracks
            if (filteredUploadedTracksCount > 0) {
                // update tracks
                state.uploadedTracks = filteredUploadedTracks;
                state.uploadedTracksCount -= filteredUploadedTracksCount;
            }
            // filter user tracks from artist popular tracks
            const filteredArtistPopularTracks = state.artistPopularTracks.filter((t)=>t.userId !== userId);
            const filteredArtistPopularTracksCount = state.artistPopularTracks.length - filteredArtistPopularTracks.length;
            // if filtered tracks
            if (filteredArtistPopularTracksCount > 0) {
                // update tracks
                state.artistPopularTracks = filteredArtistPopularTracks;
                state.artistPopularTracksCount -= filteredArtistPopularTracksCount;
            }
            // filter user tracks from artist exclusive tracks
            const filteredArtistExclusiveTracks = state.artistExclusiveTracks.filter((t)=>t.userId !== userId);
            const filteredArtistExclusiveTracksCount = state.artistExclusiveTracks.length - filteredArtistExclusiveTracks.length;
            // if filtered tracks
            if (filteredArtistExclusiveTracksCount > 0) {
                // update tracks
                state.artistExclusiveTracks = filteredArtistExclusiveTracks;
                state.artistExclusiveTracksCount -= filteredArtistExclusiveTracksCount;
            }
            // filter user tracks from artist latest tracks
            const filteredArtistLatestTracks = state.artistLatestTracks.filter((t)=>t.userId !== userId);
            const filteredArtistLatestTracksCount = state.artistLatestTracks.length - filteredArtistLatestTracks.length;
            // if filtered tracks
            if (filteredArtistLatestTracksCount > 0) {
                // update tracks
                state.artistLatestTracks = filteredArtistLatestTracks;
                state.artistLatestTracksCount -= filteredArtistLatestTracksCount;
            }
            // filter user tracks from post tracks
            const filteredPostTracks = state.postTracks.filter((t)=>t.userId !== userId);
            const filteredPostTracksCount = state.postTracks.length - filteredPostTracks.length;
            // if filtered tracks
            if (filteredPostTracksCount > 0) // update tracks
            state.postTracks = filteredPostTracks;
        },
        // update track
        trackUpdateTrack: (state, action)=>{
            const { updatedTrack: updatedTrack } = action.payload;
            // update track in public tracks
            const pubIndex = state.publicTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (pubIndex !== -1) {
                const currentTrack = state.publicTracks[pubIndex];
                state.publicTracks[pubIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in popular tracks
            const popIndex = state.popularTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (popIndex !== -1) {
                const currentTrack = state.popularTracks[popIndex];
                state.popularTracks[popIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in exclusive tracks
            const exIndex = state.exclusiveTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (exIndex !== -1) {
                const currentTrack = state.exclusiveTracks[exIndex];
                state.exclusiveTracks[exIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in latest tracks
            const laIndex = state.latestTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (laIndex !== -1) {
                const currentTrack = state.latestTracks[laIndex];
                state.latestTracks[laIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in trending tracks
            const trIndex = state.trendingTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (trIndex !== -1) {
                const currentTrack = state.trendingTracks[trIndex];
                state.trendingTracks[trIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in recommended tracks
            const recIndex = state.recommendedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (recIndex !== -1) {
                const currentTrack = state.recommendedTracks[recIndex];
                state.recommendedTracks[recIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in liked tracks
            const lkIndex = state.likedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (lkIndex !== -1) {
                const currentTrack = state.likedTracks[lkIndex];
                state.likedTracks[lkIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in unlocked tracks
            const unlIndex = state.unlockedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (unlIndex !== -1) {
                const currentTrack = state.unlockedTracks[unlIndex];
                state.unlockedTracks[unlIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in uploaded tracks
            const uplIndex = state.uploadedTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (uplIndex !== -1) {
                const currentTrack = state.uploadedTracks[uplIndex];
                state.uploadedTracks[uplIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in artist popular tracks
            const aPopIndex = state.artistPopularTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (aPopIndex !== -1) {
                const currentTrack = state.artistPopularTracks[aPopIndex];
                state.artistPopularTracks[aPopIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in artist exclusive tracks
            const aExIndex = state.artistExclusiveTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (aExIndex !== -1) {
                const currentTrack = state.artistExclusiveTracks[aExIndex];
                state.artistExclusiveTracks[aExIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in artist latest tracks
            const aLatIndex = state.artistLatestTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (aLatIndex !== -1) {
                const currentTrack = state.artistLatestTracks[aLatIndex];
                state.artistLatestTracks[aLatIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
            // update track in post tracks
            const ptIndex = state.postTracks.findIndex((t)=>t.id === updatedTrack.id);
            if (ptIndex !== -1) {
                const currentTrack = state.postTracks[ptIndex];
                state.postTracks[ptIndex] = {
                    ...currentTrack,
                    ...updatedTrack
                };
            }
        },
        // open track block modal
        trackOpenTrackBlockModal: (state, action)=>({
                ...state,
                trackBlockModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close track block modal
        trackCloseTrackBlockModal: (state)=>({
                ...state,
                trackBlockModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            }),
        // open track delete modal
        trackOpenTrackDeleteModal: (state, action)=>({
                ...state,
                trackDeleteModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close track delete modal
        trackCloseTrackDeleteModal: (state)=>({
                ...state,
                trackDeleteModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get public tracks
        builder.addCase((0, $kwNyE.trackGetPublicTracks).pending, (state)=>({
                ...state,
                trackGetPublicTracksLoading: true
            })).addCase((0, $kwNyE.trackGetPublicTracks).fulfilled, (state)=>({
                ...state,
                publicTracksFetched: true,
                trackGetPublicTracksLoading: false
            }));
        // get popular tracks
        builder.addCase((0, $kwNyE.trackGetPopularTracks).pending, (state)=>({
                ...state,
                trackGetPopularTracksLoading: true
            })).addCase((0, $kwNyE.trackGetPopularTracks).fulfilled, (state)=>({
                ...state,
                popularTracksFetched: true,
                trackGetPopularTracksLoading: false
            }));
        // get exclusive tracks
        builder.addCase((0, $kwNyE.trackGetExclusiveTracks).pending, (state)=>({
                ...state,
                trackGetExclusiveTracksLoading: true
            })).addCase((0, $kwNyE.trackGetExclusiveTracks).fulfilled, (state)=>({
                ...state,
                exclusiveTracksFetched: true,
                trackGetExclusiveTracksLoading: false
            }));
        // get latest tracks
        builder.addCase((0, $kwNyE.trackGetLatestTracks).pending, (state)=>({
                ...state,
                trackGetLatestTracksLoading: true
            })).addCase((0, $kwNyE.trackGetLatestTracks).fulfilled, (state)=>({
                ...state,
                latestTracksFetched: true,
                trackGetLatestTracksLoading: false
            }));
        // get trending tracks
        builder.addCase((0, $kwNyE.trackGetTrendingTracks).pending, (state)=>({
                ...state,
                trackGetTrendingTracksLoading: true
            })).addCase((0, $kwNyE.trackGetTrendingTracks).fulfilled, (state)=>({
                ...state,
                trendingTracksFetched: true,
                trackGetTrendingTracksLoading: false
            }));
        // get recommended tracks
        builder.addCase((0, $kwNyE.trackGetRecommendedTracks).pending, (state)=>({
                ...state,
                trackGetRecommendedTracksLoading: true
            })).addCase((0, $kwNyE.trackGetRecommendedTracks).fulfilled, (state)=>({
                ...state,
                recommendedTracksFetched: true,
                trackGetRecommendedTracksLoading: false
            }));
        // get liked tracks
        builder.addCase((0, $kwNyE.trackGetLikedTracks).pending, (state)=>({
                ...state,
                trackGetLikedTracksLoading: true
            })).addCase((0, $kwNyE.trackGetLikedTracks).fulfilled, (state)=>({
                ...state,
                likedTracksFetched: true,
                trackGetLikedTracksLoading: false
            }));
        // get unlocked tracks
        builder.addCase((0, $kwNyE.trackGetUnlockedTracks).pending, (state)=>({
                ...state,
                trackGetUnlockedTracksLoading: true
            })).addCase((0, $kwNyE.trackGetUnlockedTracks).fulfilled, (state)=>({
                ...state,
                unlockedTracksFetched: true,
                trackGetUnlockedTracksLoading: false
            }));
        // get uploaded tracks
        builder.addCase((0, $kwNyE.trackGetUploadedTracks).pending, (state)=>({
                ...state,
                trackGetUploadedTracksLoading: true
            })).addCase((0, $kwNyE.trackGetUploadedTracks).fulfilled, (state)=>({
                ...state,
                uploadedTracksFetched: true,
                trackGetUploadedTracksLoading: false
            }));
        // get artist popular tracks
        builder.addCase((0, $kwNyE.trackGetArtistPopularTracks).pending, (state)=>({
                ...state,
                trackGetArtistPopularTracksLoading: true
            })).addCase((0, $kwNyE.trackGetArtistPopularTracks).fulfilled, (state)=>({
                ...state,
                artistPopularTracksFetched: true,
                trackGetArtistPopularTracksLoading: false
            }));
        // get artist exclusive tracks
        builder.addCase((0, $kwNyE.trackGetArtistExclusiveTracks).pending, (state)=>({
                ...state,
                trackGetArtistExclusiveTracksLoading: true
            })).addCase((0, $kwNyE.trackGetArtistExclusiveTracks).fulfilled, (state)=>({
                ...state,
                artistExclusiveTracksFetched: true,
                trackGetArtistExclusiveTracksLoading: false
            }));
        // get artist latest tracks
        builder.addCase((0, $kwNyE.trackGetArtistLatestTracks).pending, (state)=>({
                ...state,
                trackGetArtistLatestTracksLoading: true
            })).addCase((0, $kwNyE.trackGetArtistLatestTracks).fulfilled, (state)=>({
                ...state,
                artistLatestTracksFetched: true,
                trackGetArtistLatestTracksLoading: false
            }));
        // get post tracks
        builder.addCase((0, $kwNyE.trackGetPostTracks).pending, (state)=>({
                ...state,
                trackGetPostTracksLoading: true
            })).addCase((0, $kwNyE.trackGetPostTracks).fulfilled, (state)=>({
                ...state,
                postTracksFetched: true,
                trackGetPostTracksLoading: false
            }));
        // create track
        builder.addCase((0, $kwNyE.trackCreate).pending, (state)=>({
                ...state,
                trackCreateLoading: true
            })).addCase((0, $kwNyE.trackCreate).fulfilled, (state)=>({
                ...state,
                trackCreateLoading: false
            }));
        // update track
        builder.addCase((0, $kwNyE.trackUpdate).pending, (state)=>({
                ...state,
                trackUpdateLoading: true
            })).addCase((0, $kwNyE.trackUpdate).fulfilled, (state)=>({
                ...state,
                trackUpdateLoading: false
            }));
        // block track
        builder.addCase((0, $kwNyE.trackBlock).pending, (state)=>({
                ...state,
                trackBlockLoading: true
            })).addCase((0, $kwNyE.trackBlock).fulfilled, (state)=>({
                ...state,
                trackBlockLoading: false
            }));
        // delete track
        builder.addCase((0, $kwNyE.trackDelete).pending, (state)=>({
                ...state,
                trackDeleteLoading: true
            })).addCase((0, $kwNyE.trackDelete).fulfilled, (state)=>({
                ...state,
                trackDeleteLoading: false
            }));
    }
});
const { trackResetState: $80d7082aabf0aae1$export$91afce20dedb32ac, trackSetPublicTracks: $80d7082aabf0aae1$export$2d7ecf5aea6fabe7, trackSetPopularTracks: $80d7082aabf0aae1$export$c911a6cb418acc4a, trackSetExclusiveTracks: $80d7082aabf0aae1$export$ba92f12611d6e509, trackSetLatestTracks: $80d7082aabf0aae1$export$821dde0cff897f4c, trackSetTrendingTracks: $80d7082aabf0aae1$export$85f6b0beeb7c7923, trackSetRecommendedTracks: $80d7082aabf0aae1$export$535c0003673c0bae, trackSetLikedTracks: $80d7082aabf0aae1$export$b1024953c618252f, trackSetUnlockedTracks: $80d7082aabf0aae1$export$4dbbdb417cd9533b, trackSetUploadedTracks: $80d7082aabf0aae1$export$35e8364feff109ed, trackSetArtistPopularTracks: $80d7082aabf0aae1$export$7d7c134223540010, trackSetArtistExclusiveTracks: $80d7082aabf0aae1$export$6429021d85ed6478, trackSetArtistLatestTracks: $80d7082aabf0aae1$export$420feca5c0f2e889, trackResetArtistTracks: $80d7082aabf0aae1$export$d742c877f096cf38, trackSetPostTracks: $80d7082aabf0aae1$export$236c041833b35867, trackResetPostTracks: $80d7082aabf0aae1$export$1c19257305af6d24, trackAppendLikedTrack: $80d7082aabf0aae1$export$2c56715bdb589a3d, trackFilterLikedTrack: $80d7082aabf0aae1$export$105c65e084ab827c, trackAppendUnlockedTrack: $80d7082aabf0aae1$export$5ca905dee28a2d99, trackFilterUnlockedTrack: $80d7082aabf0aae1$export$edb49a15130cb96d, trackFilterTrack: $80d7082aabf0aae1$export$d86d1aaa5820656c, trackFilterUserTracks: $80d7082aabf0aae1$export$85e845fda476ba58, trackUpdateTrack: $80d7082aabf0aae1$export$3c3a856b71c10cd2, trackOpenTrackBlockModal: $80d7082aabf0aae1$export$56e331a908d904d5, trackCloseTrackBlockModal: $80d7082aabf0aae1$export$6811b8863997ba45, trackOpenTrackDeleteModal: $80d7082aabf0aae1$export$2de241ab12382de6, trackCloseTrackDeleteModal: $80d7082aabf0aae1$export$bbe0b92674fa755e } = $80d7082aabf0aae1$export$a3d6f2521ab23ff4.actions;
const $80d7082aabf0aae1$export$47564cb5d8147207 = (state)=>state.track.publicTracks;
const $80d7082aabf0aae1$export$f9b9ca0cc1f5cfce = (state)=>state.track.publicTracks.length;
const $80d7082aabf0aae1$export$a3ec4174f8290ea1 = (state)=>state.track.publicTracksCount;
const $80d7082aabf0aae1$export$f039f0f464c79d83 = (state)=>state.track.publicTracksFetched;
const $80d7082aabf0aae1$export$4c37c8f4ddb5ccdd = (state)=>state.track.popularTracks;
const $80d7082aabf0aae1$export$58a8663ddd7bfa52 = (state)=>state.track.popularTracks.length;
const $80d7082aabf0aae1$export$62d4bca2ea171ac2 = (state)=>state.track.popularTracksCount;
const $80d7082aabf0aae1$export$226bc2dcf7547000 = (state)=>state.track.popularTracksFetched;
const $80d7082aabf0aae1$export$e37f1fe62af44d2e = (state)=>state.track.exclusiveTracks;
const $80d7082aabf0aae1$export$ce85ccdd80284243 = (state)=>state.track.exclusiveTracks.length;
const $80d7082aabf0aae1$export$69d3f01427ab5991 = (state)=>state.track.exclusiveTracksCount;
const $80d7082aabf0aae1$export$c6816f57f96de775 = (state)=>state.track.exclusiveTracksFetched;
const $80d7082aabf0aae1$export$90d97c0db639420a = (state)=>state.track.latestTracks;
const $80d7082aabf0aae1$export$9a6fce8c107f08e9 = (state)=>state.track.latestTracks.length;
const $80d7082aabf0aae1$export$8e8fc430e197b863 = (state)=>state.track.latestTracksCount;
const $80d7082aabf0aae1$export$401eea2f5ce1ff4b = (state)=>state.track.latestTracksFetched;
const $80d7082aabf0aae1$export$b5066207a175173a = (state)=>state.track.trendingTracks;
const $80d7082aabf0aae1$export$43b5c9b6c0d0dadd = (state)=>state.track.trendingTracks.length;
const $80d7082aabf0aae1$export$a04c165a82b3cbc4 = (state)=>state.track.trendingTracksCount;
const $80d7082aabf0aae1$export$87f17186a6cf9d3b = (state)=>state.track.trendingTracksFetched;
const $80d7082aabf0aae1$export$e5e50bc712e38d93 = (state)=>state.track.recommendedTracks;
const $80d7082aabf0aae1$export$4411836d2a84bab1 = (state)=>state.track.recommendedTracks.length;
const $80d7082aabf0aae1$export$f1ac8d7f901cff94 = (state)=>state.track.recommendedTracksCount;
const $80d7082aabf0aae1$export$bb2b22d1dbb538c5 = (state)=>state.track.recommendedTracksFetched;
const $80d7082aabf0aae1$export$35df9b11880abfde = (state)=>state.track.likedTracks;
const $80d7082aabf0aae1$export$f2f25b45129fd9bf = (state)=>state.track.likedTracks.length;
const $80d7082aabf0aae1$export$2146ae74a6c967e9 = (state)=>state.track.likedTracksCount;
const $80d7082aabf0aae1$export$928b86b46ccdda3b = (state)=>state.track.likedTracksFetched;
const $80d7082aabf0aae1$export$a22acbc5ae261a16 = (state)=>state.track.unlockedTracks;
const $80d7082aabf0aae1$export$e8d801ab210db7ab = (state)=>state.track.unlockedTracks.length;
const $80d7082aabf0aae1$export$a5125418d1c9c810 = (state)=>state.track.unlockedTracksCount;
const $80d7082aabf0aae1$export$504378086fb25edd = (state)=>state.track.unlockedTracksFetched;
const $80d7082aabf0aae1$export$8207498fbe72f46 = (state)=>state.track.uploadedTracks;
const $80d7082aabf0aae1$export$22a092517e09c0d = (state)=>state.track.uploadedTracks.length;
const $80d7082aabf0aae1$export$27e0ae462cc2be1e = (state)=>state.track.uploadedTracksCount;
const $80d7082aabf0aae1$export$a9a4448b2e07780 = (state)=>state.track.uploadedTracksFetched;
const $80d7082aabf0aae1$export$111a3c3534ddce76 = (state)=>state.track.artistPopularTracks;
const $80d7082aabf0aae1$export$1092d17ce779b213 = (state)=>state.track.artistPopularTracks.length;
const $80d7082aabf0aae1$export$2d7a26414c6d58ac = (state)=>state.track.artistPopularTracksCount;
const $80d7082aabf0aae1$export$b65214841fdacb75 = (state)=>state.track.artistPopularTracksFetched;
const $80d7082aabf0aae1$export$7ec3893edfc43a66 = (state)=>state.track.artistExclusiveTracks;
const $80d7082aabf0aae1$export$ee53d2e211394bc9 = (state)=>state.track.artistExclusiveTracks.length;
const $80d7082aabf0aae1$export$62ac15c1e4cbd19e = (state)=>state.track.artistExclusiveTracksCount;
const $80d7082aabf0aae1$export$5a188b1cb81c365f = (state)=>state.track.artistExclusiveTracksFetched;
const $80d7082aabf0aae1$export$d8936ba0cbd1cc2b = (state)=>state.track.artistLatestTracks;
const $80d7082aabf0aae1$export$c3e0fa980513d7e3 = (state)=>state.track.artistLatestTracks.length;
const $80d7082aabf0aae1$export$24fc321fc9d0319a = (state)=>state.track.artistLatestTracksCount;
const $80d7082aabf0aae1$export$b10cc2dffa5268ea = (state)=>state.track.artistLatestTracksFetched;
const $80d7082aabf0aae1$export$7cfade53894d2355 = (state)=>state.track.postTracks;
const $80d7082aabf0aae1$export$8bca47c1f4b2b968 = (state)=>state.track.postTracksFetched;
const $80d7082aabf0aae1$export$e30c4435926569f1 = (state)=>state.track.trackBlockModal.open;
const $80d7082aabf0aae1$export$18e4366d1e17c8e0 = (state)=>state.track.trackBlockModal.track;
const $80d7082aabf0aae1$export$6c8a6385741ff7b6 = (state)=>state.track.trackDeleteModal.open;
const $80d7082aabf0aae1$export$6cb3e01afd8d3c94 = (state)=>state.track.trackDeleteModal.track;
const $80d7082aabf0aae1$export$405ef44e6ed74011 = (state)=>state.track.trackGetPublicTracksLoading;
const $80d7082aabf0aae1$export$ae8b9e001696b5cf = (state)=>state.track.trackGetPopularTracksLoading;
const $80d7082aabf0aae1$export$d2c296bdb2317093 = (state)=>state.track.trackGetExclusiveTracksLoading;
const $80d7082aabf0aae1$export$d335e3779b1f7f7e = (state)=>state.track.trackGetLatestTracksLoading;
const $80d7082aabf0aae1$export$913df1835a6c3f1e = (state)=>state.track.trackGetTrendingTracksLoading;
const $80d7082aabf0aae1$export$cfc3b6c697b820ca = (state)=>state.track.trackGetRecommendedTracksLoading;
const $80d7082aabf0aae1$export$b8b634e26fb18437 = (state)=>state.track.trackGetLikedTracksLoading;
const $80d7082aabf0aae1$export$e693f231ed8581d9 = (state)=>state.track.trackGetUnlockedTracksLoading;
const $80d7082aabf0aae1$export$eb68542484efa1fe = (state)=>state.track.trackGetUploadedTracksLoading;
const $80d7082aabf0aae1$export$469daa70a5bdb26f = (state)=>state.track.trackGetArtistPopularTracksLoading;
const $80d7082aabf0aae1$export$a14d11ba620ac874 = (state)=>state.track.trackGetArtistExclusiveTracksLoading;
const $80d7082aabf0aae1$export$724cd8f38778db29 = (state)=>state.track.trackGetArtistLatestTracksLoading;
const $80d7082aabf0aae1$export$9aad2ecb49cd085b = (state)=>state.track.trackGetPostTracksLoading;
const $80d7082aabf0aae1$export$4133c331aede8f7b = (state)=>state.track.trackCreateLoading;
const $80d7082aabf0aae1$export$b23ee01741eaf3c9 = (state)=>state.track.trackUpdateLoading;
const $80d7082aabf0aae1$export$dc2ec62f755fa49a = (state)=>state.track.trackBlockLoading;
const $80d7082aabf0aae1$export$7e1ad1aad8696bcb = (state)=>state.track.trackDeleteLoading;
const $80d7082aabf0aae1$export$e4057e913f54cc7e = $80d7082aabf0aae1$export$a3d6f2521ab23ff4.reducer; // export default trackSlice.reducer

});

parcelRegister("kwNyE", function(module, exports) {

$parcel$export(module.exports, "trackGetPublicTracks", function () { return $04b4f2ec3f840ab7$export$c829cef6efb837e7; });
$parcel$export(module.exports, "trackGetPopularTracks", function () { return $04b4f2ec3f840ab7$export$5f38273a75885ecd; });
$parcel$export(module.exports, "trackGetExclusiveTracks", function () { return $04b4f2ec3f840ab7$export$18002fac64463f72; });
$parcel$export(module.exports, "trackGetLatestTracks", function () { return $04b4f2ec3f840ab7$export$166b521aba3d1598; });
$parcel$export(module.exports, "trackGetTrendingTracks", function () { return $04b4f2ec3f840ab7$export$5c955a524c656384; });
$parcel$export(module.exports, "trackGetRecommendedTracks", function () { return $04b4f2ec3f840ab7$export$eab441c41d503279; });
$parcel$export(module.exports, "trackGetLikedTracks", function () { return $04b4f2ec3f840ab7$export$8e693b38bc8bb563; });
$parcel$export(module.exports, "trackGetUnlockedTracks", function () { return $04b4f2ec3f840ab7$export$9a98d14b4f79b4be; });
$parcel$export(module.exports, "trackGetUploadedTracks", function () { return $04b4f2ec3f840ab7$export$f9972041e1785b3e; });
$parcel$export(module.exports, "trackGetArtistPopularTracks", function () { return $04b4f2ec3f840ab7$export$6f209b44a74f998; });
$parcel$export(module.exports, "trackGetArtistExclusiveTracks", function () { return $04b4f2ec3f840ab7$export$62b017e555e2b685; });
$parcel$export(module.exports, "trackGetArtistLatestTracks", function () { return $04b4f2ec3f840ab7$export$998d5b1bfd7986a4; });
$parcel$export(module.exports, "trackGetPostTracks", function () { return $04b4f2ec3f840ab7$export$3add8b5587e204a7; });
$parcel$export(module.exports, "trackCreate", function () { return $04b4f2ec3f840ab7$export$f7e7ada7d7555000; });
$parcel$export(module.exports, "trackUpdate", function () { return $04b4f2ec3f840ab7$export$e2f380e887795d02; });
$parcel$export(module.exports, "trackBlock", function () { return $04b4f2ec3f840ab7$export$92cf52a6069bc2b9; });
$parcel$export(module.exports, "trackDelete", function () { return $04b4f2ec3f840ab7$export$8542f6d1e2cb8f0e; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $jAL4t = parcelRequire("jAL4t");
var $10e6J = parcelRequire("10e6J");
var $2Vh5B = parcelRequire("2Vh5B");
const $04b4f2ec3f840ab7$export$c829cef6efb837e7 = (0, $kvj5V.createAsyncThunk)("track/trackGetPublicTracks", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPublicTracks();
        // set public tracks
        dispatch((0, $2Vh5B.trackSetPublicTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$5f38273a75885ecd = (0, $kvj5V.createAsyncThunk)("track/trackGetPopularTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPopularTracks(undefined, inp.limit, inp.offset, inp.search);
        // set popular tracks
        dispatch((0, $2Vh5B.trackSetPopularTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$18002fac64463f72 = (0, $kvj5V.createAsyncThunk)("track/trackGetExclusiveTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getExclusiveTracks(undefined, inp.limit, inp.offset, inp.search);
        // set exclusive tracks
        dispatch((0, $2Vh5B.trackSetExclusiveTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$166b521aba3d1598 = (0, $kvj5V.createAsyncThunk)("track/trackGetLatestTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getLatestTracks(undefined, inp.limit, inp.offset, inp.search);
        // set latest tracks
        dispatch((0, $2Vh5B.trackSetLatestTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$5c955a524c656384 = (0, $kvj5V.createAsyncThunk)("track/trackGetTrendingTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getTrendingTracks(undefined, inp.limit, inp.offset, inp.search);
        // set trending tracks
        dispatch((0, $2Vh5B.trackSetTrendingTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$eab441c41d503279 = (0, $kvj5V.createAsyncThunk)("track/trackGetRecommendedTracks", async (inp, { dispatch: dispatch, getState: getState })=>{
    // get user profile
    const { profile: profile } = getState().auth;
    const userPreferredGenres = profile?.preferredGenres?.join(",");
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve recommended tracks
        const { tracks: tracks, count: count } = await api.trackApi.getRecommendedTracks(userPreferredGenres, inp.limit, inp.offset, inp.search);
        // set recommended tracks
        dispatch((0, $2Vh5B.trackSetRecommendedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$8e693b38bc8bb563 = (0, $kvj5V.createAsyncThunk)("track/trackGetLikedTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve liked tracks
        const { tracks: tracks, count: count } = await api.trackApi.getLikedTracks(inp.limit, inp.offset, inp.search);
        // set liked tracks
        dispatch((0, $2Vh5B.trackSetLikedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$9a98d14b4f79b4be = (0, $kvj5V.createAsyncThunk)("track/trackGetUnlockedTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve liked tracks
        const { tracks: tracks, count: count } = await api.trackApi.getUnlockedTracks(inp.limit, inp.offset, inp.search);
        // set liked tracks
        dispatch((0, $2Vh5B.trackSetUnlockedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$f9972041e1785b3e = (0, $kvj5V.createAsyncThunk)("track/trackGetUploadedTracks", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get currently logged in user id
    const { profile: profile } = getState().auth;
    const userId = profile?.id || "";
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getArtistTracks(userId, inp.limit, inp.offset, inp.search);
        // set uploaded tracks
        dispatch((0, $2Vh5B.trackSetUploadedTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$6f209b44a74f998 = (0, $kvj5V.createAsyncThunk)("track/trackGetArtistPopularTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getPopularTracks(inp.artistId, inp.limit, inp.offset, inp.search);
        // set tracks
        dispatch((0, $2Vh5B.trackSetArtistPopularTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$62b017e555e2b685 = (0, $kvj5V.createAsyncThunk)("track/trackGetArtistExclusiveTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getExclusiveTracks(inp.artistId, inp.limit, inp.offset, inp.search);
        // set tracks
        dispatch((0, $2Vh5B.trackSetArtistExclusiveTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$998d5b1bfd7986a4 = (0, $kvj5V.createAsyncThunk)("track/trackGetArtistLatestTracks", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks, count: count } = await api.trackApi.getLatestTracks(inp.artistId, inp.limit, inp.offset, inp.search);
        // set tracks
        dispatch((0, $2Vh5B.trackSetArtistLatestTracks)({
            tracks: tracks || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$3add8b5587e204a7 = (0, $kvj5V.createAsyncThunk)("track/trackGetPostTracks", async ({ trackIds: trackIds }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve tracks
        const { tracks: tracks } = await api.trackApi.getTracksByIds(trackIds?.join(","));
        // set post tracks
        dispatch((0, $2Vh5B.trackSetPostTracks)({
            tracks: tracks || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$f7e7ada7d7555000 = (0, $kvj5V.createAsyncThunk)("track/trackCreate", async ({ name: name, track: track, cover: cover, genres: genres, visibility: visibility, unlockPrice: unlockPrice }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append name
        formData.append("name", name);
        // if track provided
        if (track) // append track file
        formData.append("track", track);
        // if cover provided
        if (cover) // append cover file
        formData.append("cover", cover);
        // if genres provided
        if (genres && genres.length > 0) // append genres
        formData.append("genres", genres.join(","));
        // if visibility provided
        if (visibility) // append visibility
        formData.append("visibility", visibility.toString());
        // if visibility is subscribers
        // and unlock price provided
        if (visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers && unlockPrice) // append unlock price in cents
        // if unlockPrice = 1 (one dollar)
        // 1 * 100 = 100 (hundred cents)
        formData.append("unlockPrice", (unlockPrice * 100).toString());
        // create track
        await api.trackApi.createTrack({
            body: formData
        });
        // refetch uploaded tracks
        dispatch($04b4f2ec3f840ab7$export$f9972041e1785b3e({
            limit: 30,
            offset: 0
        }));
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully uploaded track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to upload track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$e2f380e887795d02 = (0, $kvj5V.createAsyncThunk)("track/trackUpdate", async ({ track: track, name: name, cover: cover, genres: genres }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // create form data
        const formData = new FormData();
        // append track id
        formData.append("trackId", track.id || "");
        // if name provided
        if (name) // append name
        formData.append("name", name);
        // if cover provided
        if (cover) // append cover
        formData.append("cover", cover);
        // if genres provided
        if (genres && genres.length > 0) // append genres
        formData.append("genres", genres.join(","));
        // update track
        const { track: updatedTrack } = await api.trackApi.updateTrack({
            body: formData
        });
        // update track in track state
        dispatch((0, $2Vh5B.trackUpdateTrack)({
            updatedTrack: updatedTrack || {}
        }));
        // update track in player state
        dispatch((0, $jAL4t.playerAudioUpdatePlaylistTrack)({
            updatedTrack: updatedTrack || {}
        }));
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully updated track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to update track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$92cf52a6069bc2b9 = (0, $kvj5V.createAsyncThunk)("track/trackBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // block track
        await api.trackApi.blockTrack({
            trackId: id
        });
        // filter blocked track from tracks
        dispatch((0, $2Vh5B.trackFilterTrack)({
            id: id
        }));
        // filter blocked track from audio player
        dispatch((0, $jAL4t.playerAudioFilterPlaylistTrack)({
            id: id
        }));
        // set track as blocked in report state
        dispatch((0, $10e6J.reportSetReportEntityBlocked)());
        // close track block modal
        dispatch((0, $2Vh5B.trackCloseTrackBlockModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully blocked track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to block track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $04b4f2ec3f840ab7$export$8542f6d1e2cb8f0e = (0, $kvj5V.createAsyncThunk)("track/trackDelete", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // delete track
        await api.trackApi.deleteTrack(id);
        // filter deleted track from tracks
        dispatch((0, $2Vh5B.trackFilterTrack)({
            id: id
        }));
        // filter deleted track from audio player
        dispatch((0, $jAL4t.playerAudioFilterPlaylistTrack)({
            id: id
        }));
        // close track delete modal
        dispatch((0, $2Vh5B.trackCloseTrackDeleteModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully deleted track!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to delete track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("8wAqI", function(module, exports) {

$parcel$export(module.exports, "TransactionCard", function () { return (parcelRequire("5Kzof")).TransactionCard; });
$parcel$export(module.exports, "TransactionListProfile", function () { return (parcelRequire("eohtw")).TransactionListProfile; });
$parcel$export(module.exports, "TransactionListProfileIncome", function () { return (parcelRequire("hKI6w")).TransactionListProfileIncome; });
$parcel$export(module.exports, "TransactionListProfileOutgoing", function () { return (parcelRequire("1d2Pj")).TransactionListProfileOutgoing; });
parcelRequire("fFcFl");
var $5Kzof = parcelRequire("5Kzof");
var $eohtw = parcelRequire("eohtw");
var $hKI6w = parcelRequire("hKI6w");
var $1d2Pj = parcelRequire("1d2Pj");

var $ht2ql = parcelRequire("ht2ql");

var $2O1h5 = parcelRequire("2O1h5");
$parcel$exportWildcard(module.exports, $ht2ql);
$parcel$exportWildcard(module.exports, $2O1h5);

});
parcelRegister("fFcFl", function(module, exports) {

$parcel$export(module.exports, "TransactionCard", function () { return (parcelRequire("5Kzof")).TransactionCard; });
$parcel$export(module.exports, "TransactionListProfile", function () { return (parcelRequire("eohtw")).TransactionListProfile; });
$parcel$export(module.exports, "TransactionListProfileIncome", function () { return (parcelRequire("hKI6w")).TransactionListProfileIncome; });
$parcel$export(module.exports, "TransactionListProfileOutgoing", function () { return (parcelRequire("1d2Pj")).TransactionListProfileOutgoing; });

var $5Kzof = parcelRequire("5Kzof");

var $eohtw = parcelRequire("eohtw");

var $hKI6w = parcelRequire("hKI6w");

var $1d2Pj = parcelRequire("1d2Pj");

});
parcelRegister("5Kzof", function(module, exports) {

$parcel$export(module.exports, "TransactionCard", function () { return $71ec2e2b74473abe$export$8037f3c5d034dea2; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $1TtH4 = parcelRequire("1TtH4");
const $71ec2e2b74473abe$export$8037f3c5d034dea2 = ({ transaction: transaction, direction: direction, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    const { amount: amount, feeAmount: feeAmount, type: type, status: status, createdAt: createdAt, sourceUserId: sourceUserId, targetUserId: targetUserId } = transaction;
    // source user
    const { user: sourceUser, isLoading: isSourceUserLoading } = (0, $aCYwi.useUserPublic)(sourceUserId || "");
    const { username: sourceUserUsername } = sourceUser ?? {};
    // target user
    const { user: targetUser, isLoading: isTargetUserLoading } = (0, $aCYwi.useUserPublic)(targetUserId || "");
    const { username: targetUserUsername } = targetUser ?? {};
    const userLoadingPlaceholder = "Loading...";
    const userUsernamePlaceholder = "unknown";
    const renderSourceUserUsername = ()=>{
        const username = isSourceUserLoading ? userLoadingPlaceholder : `@${sourceUserUsername || userUsernamePlaceholder}`;
        return username;
    };
    const renderTargetUserUsername = ()=>{
        const username = isTargetUserLoading ? userLoadingPlaceholder : `@${targetUserUsername || userUsernamePlaceholder}`;
        return username;
    };
    const date = new Date(createdAt || "");
    const dateDay = date.getUTCDate().toString().padStart(2, "0");
    const dateMonth = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const dateYear = date.getUTCFullYear();
    // const dateYear = date.getUTCFullYear() % 100
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $1TtH4.styles)(theme).card.main,
        onClick: (e)=>onClick(e),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $1TtH4.styles)(theme).card.data.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $1TtH4.styles)(theme).card.data.icon,
                        children: [
                            direction === "income" && /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CreditCardOutgoing, {}),
                            direction === "outgoing" && /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CreditCardOutgoing, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $1TtH4.styles)(theme).card.data.source,
                        children: [
                            direction === "income" && renderSourceUserUsername(),
                            direction === "outgoing" && renderTargetUserUsername()
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $1TtH4.styles)(theme).card.data.amount,
                        children: [
                            direction === "income" && `$${((amount || 0) - (feeAmount || 0)) / 100}`,
                            direction === "outgoing" && `-- $${(amount || 0) / 100}`
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1TtH4.styles)(theme).card.data.type,
                        children: type
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1TtH4.styles)(theme).card.data.status,
                        children: status
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $1TtH4.styles)(theme).card.data.date,
                        children: `${dateDay}.${dateMonth}.${dateYear}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1TtH4.styles)(theme).card.divider
            })
        ]
    });
};
$71ec2e2b74473abe$export$8037f3c5d034dea2.propTypes = {};

});
parcelRegister("1TtH4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c290950537fd61ef$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c290950537fd61ef$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c290950537fd61ef$var$_ref = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $c290950537fd61ef$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $c290950537fd61ef$var$_ref3 = {
    name: "eivff4",
    styles: "display:none"
};
var $c290950537fd61ef$var$_ref4 = {
    name: "jxcdj8",
    styles: "flex:1 0 50px;max-width:60px"
};
var $c290950537fd61ef$var$_ref5 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $c290950537fd61ef$var$_ref6 = {
    name: "eivff4",
    styles: "display:none"
};
var $c290950537fd61ef$var$_ref7 = {
    name: "1mz29im",
    styles: "display:flex;align-items:center;height:40px"
};
var $c290950537fd61ef$var$_ref8 = {
    name: "d0fgu6",
    styles: "display:flex;flex-direction:column;justify-content:space-between;height:60px"
};
const $c290950537fd61ef$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: $c290950537fd61ef$var$_ref8,
            data: {
                main: $c290950537fd61ef$var$_ref7,
                icon: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex:0 0 40px;margin-right:10px;", (0, $gln0L.mq).tablet($c290950537fd61ef$var$_ref6), " &>svg{height:22px;&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                source: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 100px;margin-right:10px;", (0, $gln0L.mq).mobile($c290950537fd61ef$var$_ref5), ";", ""),
                amount: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;font-weight:bold;margin-right:10px;", (0, $gln0L.mq).mobile($c290950537fd61ef$var$_ref4), ";", ""),
                type: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).tablet($c290950537fd61ef$var$_ref3), ";", ""),
                status: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).mobile($c290950537fd61ef$var$_ref2), ";", ""),
                date: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";flex:1 0 40px;max-width:80px;", (0, $gln0L.mq).mobile($c290950537fd61ef$var$_ref), ";", "")
            },
            divider: /*#__PURE__*/ (0, $7hler.css)("width:100%;height:1px;background-color:", theme.colors.secondary.dark, ";", "")
        }
    });

});


parcelRegister("eohtw", function(module, exports) {

$parcel$export(module.exports, "TransactionListProfile", function () { return $3b8ec18f7316bdc2$export$1c0777ee0b836957; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $hKI6w = parcelRequire("hKI6w");
var $1d2Pj = parcelRequire("1d2Pj");
parcelRequire("1TdPt");
var $d6xWB = parcelRequire("d6xWB");
const $3b8ec18f7316bdc2$export$1c0777ee0b836957 = ()=>{
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const isUserArtist = profile?.role === (0, $2gpGl.EntityUserRole).Artist;
    // if user is artist
    if (isUserArtist) // return artist transaction list
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $d6xWB.SectionsLayout), {
        sections: [
            {
                id: "profile-income-transactions",
                name: "Incomes",
                section: /*#__PURE__*/ (0, $9awXB.jsx)((0, $hKI6w.TransactionListProfileIncome), {})
            },
            {
                id: "profile-outgoing-transactions",
                name: "Outgoings",
                section: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1d2Pj.TransactionListProfileOutgoing), {})
            }
        ]
    });
    // else return fan/admin transaction list (only outgoing)
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $d6xWB.SectionsLayout), {
        sections: [
            {
                id: "profile-outgoing-transactions",
                name: "Outgoings",
                section: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1d2Pj.TransactionListProfileOutgoing), {})
            }
        ]
    });
};
$3b8ec18f7316bdc2$export$1c0777ee0b836957.propTypes = {};

});

parcelRegister("hKI6w", function(module, exports) {

$parcel$export(module.exports, "TransactionListProfileIncome", function () { return $be878855df7d1e2a$export$256622f1daba434; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $5Kzof = parcelRequire("5Kzof");
var $2O1h5 = parcelRequire("2O1h5");
var $ht2ql = parcelRequire("ht2ql");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $curqj = parcelRequire("curqj");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $kdj4K = parcelRequire("kdj4K");
const $be878855df7d1e2a$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const transactions = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectIncomeTransactions));
    const transaction = transactions[index];
    // if transaction not fetched
    if (!transaction) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "transaction-list-transaction-income",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kdj4K.styles)().transactions.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $5Kzof.TransactionCard), {
            direction: "income",
            transaction: transaction,
            onClick: ()=>{}
        })
    });
});
const $be878855df7d1e2a$export$256622f1daba434 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const transactionIncomeLoading = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectTransactionGetIncomeTransactionsLoading));
    const incomeTransactions = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectIncomeTransactions));
    const incomeTransactionsCount = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectIncomeTransactionsCount));
    const incomeTransactionsLength = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectIncomeTransactionsLength));
    const incomeTransactionsFetched = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectIncomeTransactionsFetched));
    const incomeTransactionsFilter = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectIncomeTransactionsFilter));
    const transactionCardHeight = 60;
    const transactionCardMarginBottom = 20;
    const itemHeight = transactionCardHeight + transactionCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 400;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!incomeTransactions[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $2O1h5.transactionGetIncomeTransactions)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders transaction list navigation
    const renderTransactionListNavigation = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $kdj4K.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $curqj.NavigationScrollable), {
                options: [
                    {
                        id: "8117e0a6-74dd-4057-826e-7686c0bacaea",
                        label: "Subscription",
                        enabled: incomeTransactionsFilter === (0, $2gpGl.EntityTransactionType).Subscription,
                        onClick: ()=>{
                            // set transaction filter
                            dispatch((0, $ht2ql.transactionSetIncomeTransactionsFilter)({
                                filter: (0, $2gpGl.EntityTransactionType).Subscription
                            }));
                            // refetch transactions
                            dispatch((0, $2O1h5.transactionGetIncomeTransactions)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "5627276c-1ef7-458d-a969-055ffeba8b31",
                        label: "Unlock",
                        enabled: incomeTransactionsFilter === (0, $2gpGl.EntityTransactionType).Unlock,
                        onClick: ()=>{
                            // set transaction filter
                            dispatch((0, $ht2ql.transactionSetIncomeTransactionsFilter)({
                                filter: (0, $2gpGl.EntityTransactionType).Unlock
                            }));
                            // refetch transactions
                            dispatch((0, $2O1h5.transactionGetIncomeTransactions)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    },
                    {
                        id: "7785a9b4-9e85-4ee5-b415-b317c4781a4f",
                        label: "Tip",
                        enabled: incomeTransactionsFilter === (0, $2gpGl.EntityTransactionType).Tip,
                        onClick: ()=>{
                            // set transaction filter
                            dispatch((0, $ht2ql.transactionSetIncomeTransactionsFilter)({
                                filter: (0, $2gpGl.EntityTransactionType).Tip
                            }));
                            // refetch transactions
                            dispatch((0, $2O1h5.transactionGetIncomeTransactions)({
                                limit: 30,
                                offset: 0
                            }));
                        }
                    }
                ]
            })
        });
    // renders transaction list table header
    const renderTransactionListTableHeader = ()=>/*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $kdj4K.styles)().list.header.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kdj4K.styles)().list.header.placeholder
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kdj4K.styles)().list.header.source,
                    children: "Source"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kdj4K.styles)().list.header.amount,
                    children: "Amount"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kdj4K.styles)().list.header.type,
                    children: "Type"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kdj4K.styles)().list.header.status,
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kdj4K.styles)().list.header.date,
                    children: "Date"
                })
            ]
        });
    // if income transactions are fetched but length is 0
    if (!transactionIncomeLoading && incomeTransactionsFetched && incomeTransactionsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kdj4K.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kdj4K.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
                    icon: (0, $bq9l8.icons).CreditCardIncome,
                    height: "400px",
                    title: "You don't have any income transactions yet"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kdj4K.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kdj4K.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: incomeTransactionsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: incomeTransactionsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $be878855df7d1e2a$var$Row
                        })
                })
            })
        ]
    }));
};
$be878855df7d1e2a$export$256622f1daba434.propTypes = {};

});
parcelRegister("kdj4K", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $6b44c9dbcf1ca6fe$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $6b44c9dbcf1ca6fe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $6b44c9dbcf1ca6fe$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
var $6b44c9dbcf1ca6fe$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $6b44c9dbcf1ca6fe$var$_ref3 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $6b44c9dbcf1ca6fe$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $6b44c9dbcf1ca6fe$var$_ref5 = {
    name: "jxcdj8",
    styles: "flex:1 0 50px;max-width:60px"
};
var $6b44c9dbcf1ca6fe$var$_ref6 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $6b44c9dbcf1ca6fe$var$_ref7 = {
    name: "eivff4",
    styles: "display:none"
};
var $6b44c9dbcf1ca6fe$var$_ref8 = {
    name: "phodm9",
    styles: "display:flex;max-width:800px;margin-bottom:32px"
};
const $6b44c9dbcf1ca6fe$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            header: {
                main: $6b44c9dbcf1ca6fe$var$_ref8,
                placeholder: /*#__PURE__*/ (0, $7hler.css)("flex:0 0 40px;margin-right:10px;", (0, $gln0L.mq).tablet($6b44c9dbcf1ca6fe$var$_ref7), ";", ""),
                source: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 100px;margin-right:10px;", (0, $gln0L.mq).mobile($6b44c9dbcf1ca6fe$var$_ref6), ";", ""),
                amount: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).mobile($6b44c9dbcf1ca6fe$var$_ref5), ";", ""),
                type: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).tablet($6b44c9dbcf1ca6fe$var$_ref4), ";", ""),
                status: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).mobile($6b44c9dbcf1ca6fe$var$_ref3), ";", ""),
                date: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 40px;max-width:80px;", (0, $gln0L.mq).mobile($6b44c9dbcf1ca6fe$var$_ref2), ";", "")
            },
            content: {
                main: $6b44c9dbcf1ca6fe$var$_ref
            }
        },
        transactions: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});


parcelRegister("1d2Pj", function(module, exports) {

$parcel$export(module.exports, "TransactionListProfileOutgoing", function () { return $4ca4922155b4b299$export$2856e0515b6dfb42; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $5Kzof = parcelRequire("5Kzof");
var $2O1h5 = parcelRequire("2O1h5");
var $ht2ql = parcelRequire("ht2ql");
parcelRequire("1TdPt");
var $4sGtG = parcelRequire("4sGtG");
var $curqj = parcelRequire("curqj");
var $42mKz = parcelRequire("42mKz");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $kTYWa = parcelRequire("kTYWa");
const $4ca4922155b4b299$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const transactions = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectOutgoingTransactions));
    const transaction = transactions[index];
    // if transaction not fetched
    if (!transaction) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $42mKz.SkeletonHorizontal), {
            sections: [
                {
                    name: "transaction-list-transaction-income",
                    width: "100%",
                    height: "60px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kTYWa.styles)().transactions.main,
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $5Kzof.TransactionCard), {
            direction: "outgoing",
            transaction: transaction,
            onClick: ()=>{}
        })
    });
});
const $4ca4922155b4b299$export$2856e0515b6dfb42 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const isUserArtist = profile?.role === (0, $2gpGl.EntityUserRole).Artist;
    const transactionOutgoingLoading = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectTransactionGetOutgoingTransactionsLoading));
    const outgoingTransactions = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectOutgoingTransactions));
    const outgoingTransactionsCount = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectOutgoingTransactionsCount));
    const outgoingTransactionsLength = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectOutgoingTransactionsLength));
    const outgoingTransactionsFetched = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectOutgoingTransactionsFetched));
    const outgoingTransactionsFilter = (0, $gNvvs.useAppSelector)((0, $ht2ql.transactionSelectOutgoingTransactionsFilter));
    const transactionCardHeight = 60;
    const transactionCardMarginBottom = 20;
    const itemHeight = transactionCardHeight + transactionCardMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = "100%";
    const defaultListHeight = 400;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 5 rows
    const isItemLoaded = (index)=>!!outgoingTransactions[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $2O1h5.transactionGetOutgoingTransactions)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // renders transaction list navigation
    const renderTransactionListNavigation = ()=>{
        const navigationOptions = [
            {
                id: "c817c390-05a0-451f-84f9-3e0f789f65ec",
                label: "Subscription",
                enabled: outgoingTransactionsFilter === (0, $2gpGl.EntityTransactionType).Subscription,
                onClick: ()=>{
                    // set transaction filter
                    dispatch((0, $ht2ql.transactionSetOutgoingTransactionsFilter)({
                        filter: (0, $2gpGl.EntityTransactionType).Subscription
                    }));
                    // refetch transactions
                    dispatch((0, $2O1h5.transactionGetOutgoingTransactions)({
                        limit: 30,
                        offset: 0
                    }));
                }
            },
            {
                id: "31f31ae6-6941-4c7e-88ea-91e39567bf07",
                label: "Unlock",
                enabled: outgoingTransactionsFilter === (0, $2gpGl.EntityTransactionType).Unlock,
                onClick: ()=>{
                    // set transaction filter
                    dispatch((0, $ht2ql.transactionSetOutgoingTransactionsFilter)({
                        filter: (0, $2gpGl.EntityTransactionType).Unlock
                    }));
                    // refetch transactions
                    dispatch((0, $2O1h5.transactionGetOutgoingTransactions)({
                        limit: 30,
                        offset: 0
                    }));
                }
            },
            {
                id: "cf8fe255-895a-40d0-98e7-0d591cd10450",
                label: "Tip",
                enabled: outgoingTransactionsFilter === (0, $2gpGl.EntityTransactionType).Tip,
                onClick: ()=>{
                    // set transaction filter
                    dispatch((0, $ht2ql.transactionSetOutgoingTransactionsFilter)({
                        filter: (0, $2gpGl.EntityTransactionType).Tip
                    }));
                    // refetch transactions
                    dispatch((0, $2O1h5.transactionGetOutgoingTransactions)({
                        limit: 30,
                        offset: 0
                    }));
                }
            }
        ];
        // if user role is artist
        if (isUserArtist) // add payout option to navigation
        navigationOptions.push({
            id: "a83d837d-2a30-4bef-8992-389ebc3ba340",
            label: "Payout",
            enabled: outgoingTransactionsFilter === (0, $2gpGl.EntityTransactionType).Payout,
            onClick: ()=>{
                // set transaction filter
                dispatch((0, $ht2ql.transactionSetOutgoingTransactionsFilter)({
                    filter: (0, $2gpGl.EntityTransactionType).Payout
                }));
                // refetch transactions
                dispatch((0, $2O1h5.transactionGetOutgoingTransactions)({
                    limit: 30,
                    offset: 0
                }));
            }
        });
        return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $kTYWa.styles)().list.nav.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $curqj.NavigationScrollable), {
                options: navigationOptions
            })
        });
    };
    // renders transaction list table header
    const renderTransactionListTableHeader = ()=>/*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $kTYWa.styles)().list.header.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kTYWa.styles)().list.header.placeholder
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kTYWa.styles)().list.header.source,
                    children: "Destination"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kTYWa.styles)().list.header.amount,
                    children: "Amount"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kTYWa.styles)().list.header.type,
                    children: "Type"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kTYWa.styles)().list.header.status,
                    children: "Status"
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $kTYWa.styles)().list.header.date,
                    children: "Date"
                })
            ]
        });
    // if outgoing transactions are fetched but length is 0
    if (!transactionOutgoingLoading && outgoingTransactionsFetched && outgoingTransactionsLength === 0) // return place holder
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kTYWa.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kTYWa.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
                    icon: (0, $bq9l8.icons).CreditCardOutgoing,
                    height: "400px",
                    title: "You don't have any outgoing transactions yet"
                })
            })
        ]
    }));
    return(// used to be content layout virtualized
    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $kTYWa.styles)().list.main,
        children: [
            renderTransactionListNavigation(),
            renderTransactionListTableHeader(),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kTYWa.styles)().list.content.main,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
                    isItemLoaded: isItemLoaded,
                    loadMoreItems: loadMoreItems,
                    itemCount: outgoingTransactionsCount || defaultContentCount,
                    minimumBatchSize: itemsToFetch,
                    threshold: itemThreshold,
                    children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                            className: "virtualized-list",
                            height: defaultListHeight,
                            itemSize: itemHeight,
                            itemCount: outgoingTransactionsCount || defaultContentCount,
                            onItemsRendered: onItemsRendered,
                            ref: ref,
                            width: defaultListWidth,
                            layout: "vertical",
                            children: $4ca4922155b4b299$var$Row
                        })
                })
            })
        ]
    }));
};
$4ca4922155b4b299$export$2856e0515b6dfb42.propTypes = {};

});
parcelRegister("kTYWa", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $c9070c18b37d0809$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $c9070c18b37d0809$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $c9070c18b37d0809$var$_ref = {
    name: "ddxhyk",
    styles: "max-width:800px"
};
var $c9070c18b37d0809$var$_ref2 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $c9070c18b37d0809$var$_ref3 = {
    name: "nnda3y",
    styles: "flex:1 0 40px;max-width:60px"
};
var $c9070c18b37d0809$var$_ref4 = {
    name: "eivff4",
    styles: "display:none"
};
var $c9070c18b37d0809$var$_ref5 = {
    name: "jxcdj8",
    styles: "flex:1 0 50px;max-width:60px"
};
var $c9070c18b37d0809$var$_ref6 = {
    name: "1jimm12",
    styles: "flex:1 0 80px"
};
var $c9070c18b37d0809$var$_ref7 = {
    name: "eivff4",
    styles: "display:none"
};
var $c9070c18b37d0809$var$_ref8 = {
    name: "phodm9",
    styles: "display:flex;max-width:800px;margin-bottom:32px"
};
const $c9070c18b37d0809$export$9dd6ff9ea0189349 = ()=>({
        list: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            nav: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";display:flex;overflow:hidden;max-width:800px;margin-bottom:50px;", "")
            },
            header: {
                main: $c9070c18b37d0809$var$_ref8,
                placeholder: /*#__PURE__*/ (0, $7hler.css)("flex:0 0 40px;margin-right:10px;", (0, $gln0L.mq).tablet($c9070c18b37d0809$var$_ref7), ";", ""),
                source: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 100px;margin-right:10px;", (0, $gln0L.mq).mobile($c9070c18b37d0809$var$_ref6), ";", ""),
                amount: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).mobile($c9070c18b37d0809$var$_ref5), ";", ""),
                type: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).tablet($c9070c18b37d0809$var$_ref4), ";", ""),
                status: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 60px;max-width:100px;margin-right:10px;", (0, $gln0L.mq).mobile($c9070c18b37d0809$var$_ref3), ";", ""),
                date: /*#__PURE__*/ (0, $7hler.css)("flex:1 0 40px;max-width:80px;", (0, $gln0L.mq).mobile($c9070c18b37d0809$var$_ref2), ";", "")
            },
            content: {
                main: $c9070c18b37d0809$var$_ref
            }
        },
        transactions: {
            main: /*#__PURE__*/ (0, $7hler.css)("", "")
        }
    });

});



parcelRegister("ht2ql", function(module, exports) {

$parcel$export(module.exports, "transactionSlice", function () { return $cdc4be4ccd5ff7c4$export$50753e6b3a2a3e01; });
$parcel$export(module.exports, "transactionResetState", function () { return $cdc4be4ccd5ff7c4$export$e263c55469ea9e92; });
$parcel$export(module.exports, "transactionSetIncomeTransactions", function () { return $cdc4be4ccd5ff7c4$export$8ec75378a6089245; });
$parcel$export(module.exports, "transactionSetOutgoingTransactions", function () { return $cdc4be4ccd5ff7c4$export$2795f70be06408c7; });
$parcel$export(module.exports, "transactionSetIncomeTransactionsFilter", function () { return $cdc4be4ccd5ff7c4$export$d7af09debfce2e95; });
$parcel$export(module.exports, "transactionSetOutgoingTransactionsFilter", function () { return $cdc4be4ccd5ff7c4$export$97080fea7d80893; });
$parcel$export(module.exports, "transactionSelectIncomeTransactions", function () { return $cdc4be4ccd5ff7c4$export$465304041e1948bf; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsLength", function () { return $cdc4be4ccd5ff7c4$export$7ac222d691bc35e6; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsCount", function () { return $cdc4be4ccd5ff7c4$export$2e7acd40b7647d67; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsFetched", function () { return $cdc4be4ccd5ff7c4$export$87c2a19b37b22098; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactions", function () { return $cdc4be4ccd5ff7c4$export$ff6ea9e9968492e0; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsLength", function () { return $cdc4be4ccd5ff7c4$export$876b82d6defea402; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsCount", function () { return $cdc4be4ccd5ff7c4$export$bc7e9b7692977cfb; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsFetched", function () { return $cdc4be4ccd5ff7c4$export$f71580874830fd7c; });
$parcel$export(module.exports, "transactionSelectIncomeTransactionsFilter", function () { return $cdc4be4ccd5ff7c4$export$9ba7c4d71af54507; });
$parcel$export(module.exports, "transactionSelectOutgoingTransactionsFilter", function () { return $cdc4be4ccd5ff7c4$export$e608d6219c20d059; });
$parcel$export(module.exports, "transactionSelectTransactionGetIncomeTransactionsLoading", function () { return $cdc4be4ccd5ff7c4$export$d3ebba3efb840bfd; });
$parcel$export(module.exports, "transactionSelectTransactionGetOutgoingTransactionsLoading", function () { return $cdc4be4ccd5ff7c4$export$5e8e1a9cca35a3db; });
$parcel$export(module.exports, "transactionReducer", function () { return $cdc4be4ccd5ff7c4$export$7effe25fda542ae1; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $2O1h5 = parcelRequire("2O1h5");
const $cdc4be4ccd5ff7c4$var$initialState = {
    incomeTransactions: [],
    incomeTransactionsCount: 0,
    incomeTransactionsFetched: false,
    outgoingTransactions: [],
    outgoingTransactionsCount: 0,
    outgoingTransactionsFetched: false,
    incomeTransactionsFilter: undefined,
    outgoingTransactionsFilter: undefined,
    transactionGetIncomeTransactionsLoading: false,
    transactionGetOutgoingTransactionsLoading: false
};
const $cdc4be4ccd5ff7c4$export$50753e6b3a2a3e01 = (0, $kvj5V.createSlice)({
    name: "transaction",
    initialState: $cdc4be4ccd5ff7c4$var$initialState,
    reducers: {
        // reset state
        transactionResetState: ()=>({
                incomeTransactions: [],
                incomeTransactionsCount: 0,
                incomeTransactionsFetched: false,
                outgoingTransactions: [],
                outgoingTransactionsCount: 0,
                outgoingTransactionsFetched: false,
                incomeTransactionsFilter: undefined,
                outgoingTransactionsFilter: undefined,
                transactionGetIncomeTransactionsLoading: false,
                transactionGetOutgoingTransactionsLoading: false
            }),
        // set income transactions
        transactionSetIncomeTransactions: (state, action)=>{
            const { transactions: transactions, count: count, offset: offset } = action.payload;
            // mutate count
            state.incomeTransactionsCount = count;
            // mutate income transactions array
            state.incomeTransactions = (0, $6Rkyy.mergeArraysAtIndex)(state.incomeTransactions, transactions, offset);
        },
        // set outgoing transactions
        transactionSetOutgoingTransactions: (state, action)=>{
            const { transactions: transactions, count: count, offset: offset } = action.payload;
            // mutate count
            state.outgoingTransactionsCount = count;
            // mutate outgoing transactions array
            state.outgoingTransactions = (0, $6Rkyy.mergeArraysAtIndex)(state.outgoingTransactions, transactions, offset);
        },
        // set income transactions filter
        transactionSetIncomeTransactionsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup income transactions
            state.incomeTransactionsCount = 0;
            state.incomeTransactions = [];
            // mutate income transactions filter
            state.incomeTransactionsFilter = state.incomeTransactionsFilter === filter ? undefined : filter;
        },
        // set outgoing transactions filter
        transactionSetOutgoingTransactionsFilter: (state, action)=>{
            const { filter: filter } = action.payload;
            // cleanup outgoing transactions
            state.outgoingTransactionsCount = 0;
            state.outgoingTransactions = [];
            // mutate outgoing transactions filter
            state.outgoingTransactionsFilter = state.outgoingTransactionsFilter === filter ? undefined : filter;
        }
    },
    extraReducers: (builder)=>{
        // get income transactions
        builder.addCase((0, $2O1h5.transactionGetIncomeTransactions).pending, (state)=>({
                ...state,
                transactionGetIncomeTransactionsLoading: true
            })).addCase((0, $2O1h5.transactionGetIncomeTransactions).fulfilled, (state)=>({
                ...state,
                incomeTransactionsFetched: true,
                transactionGetIncomeTransactionsLoading: false
            }));
        // get outgoing transactions
        builder.addCase((0, $2O1h5.transactionGetOutgoingTransactions).pending, (state)=>({
                ...state,
                transactionGetOutgoingTransactionsLoading: true
            })).addCase((0, $2O1h5.transactionGetOutgoingTransactions).fulfilled, (state)=>({
                ...state,
                outgoingTransactionsFetched: true,
                transactionGetOutgoingTransactionsLoading: false
            }));
    }
});
const { transactionResetState: $cdc4be4ccd5ff7c4$export$e263c55469ea9e92, transactionSetIncomeTransactions: $cdc4be4ccd5ff7c4$export$8ec75378a6089245, transactionSetOutgoingTransactions: $cdc4be4ccd5ff7c4$export$2795f70be06408c7, transactionSetIncomeTransactionsFilter: $cdc4be4ccd5ff7c4$export$d7af09debfce2e95, transactionSetOutgoingTransactionsFilter: $cdc4be4ccd5ff7c4$export$97080fea7d80893 } = $cdc4be4ccd5ff7c4$export$50753e6b3a2a3e01.actions;
const $cdc4be4ccd5ff7c4$export$465304041e1948bf = (state)=>state.transaction.incomeTransactions;
const $cdc4be4ccd5ff7c4$export$7ac222d691bc35e6 = (state)=>state.transaction.incomeTransactions.length;
const $cdc4be4ccd5ff7c4$export$2e7acd40b7647d67 = (state)=>state.transaction.incomeTransactionsCount;
const $cdc4be4ccd5ff7c4$export$87c2a19b37b22098 = (state)=>state.transaction.incomeTransactionsFetched;
const $cdc4be4ccd5ff7c4$export$ff6ea9e9968492e0 = (state)=>state.transaction.outgoingTransactions;
const $cdc4be4ccd5ff7c4$export$876b82d6defea402 = (state)=>state.transaction.outgoingTransactions.length;
const $cdc4be4ccd5ff7c4$export$bc7e9b7692977cfb = (state)=>state.transaction.outgoingTransactionsCount;
const $cdc4be4ccd5ff7c4$export$f71580874830fd7c = (state)=>state.transaction.outgoingTransactionsFetched;
const $cdc4be4ccd5ff7c4$export$9ba7c4d71af54507 = (state)=>state.transaction.incomeTransactionsFilter;
const $cdc4be4ccd5ff7c4$export$e608d6219c20d059 = (state)=>state.transaction.outgoingTransactionsFilter;
const $cdc4be4ccd5ff7c4$export$d3ebba3efb840bfd = (state)=>state.transaction.transactionGetIncomeTransactionsLoading;
const $cdc4be4ccd5ff7c4$export$5e8e1a9cca35a3db = (state)=>state.transaction.transactionGetOutgoingTransactionsLoading;
const $cdc4be4ccd5ff7c4$export$7effe25fda542ae1 = $cdc4be4ccd5ff7c4$export$50753e6b3a2a3e01.reducer; // export default transactionSlice.reducer

});

parcelRegister("2O1h5", function(module, exports) {

$parcel$export(module.exports, "transactionGetIncomeTransactions", function () { return $a5ec7015bf4703be$export$51b0f10822239e5d; });
$parcel$export(module.exports, "transactionGetOutgoingTransactions", function () { return $a5ec7015bf4703be$export$416969724ef90929; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("cJvLm");
var $ht2ql = parcelRequire("ht2ql");
const $a5ec7015bf4703be$export$51b0f10822239e5d = (0, $kvj5V.createAsyncThunk)("transaction/transactionGetIncomeTransactions", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get income transactions filter
    const filter = getState().transaction.incomeTransactionsFilter;
    // define transaction type
    let transactionType;
    // assert transaction type
    switch(filter){
        case (0, $2gpGl.EntityTransactionType).Subscription:
            transactionType = "subscription";
            break;
        case (0, $2gpGl.EntityTransactionType).Tip:
            transactionType = "tip";
            break;
        case (0, $2gpGl.EntityTransactionType).Unlock:
            transactionType = "unlock";
            break;
        case (0, $2gpGl.EntityTransactionType).Payout:
            transactionType = "payout";
            break;
        default:
            transactionType = undefined;
    }
    try {
        // retrieve transactions
        const { transactions: transactions, count: count } = await api.transactionApi.getIncomeTransactions(inp.limit, inp.offset, transactionType);
        // set income transactions
        dispatch((0, $ht2ql.transactionSetIncomeTransactions)({
            transactions: transactions || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $a5ec7015bf4703be$export$416969724ef90929 = (0, $kvj5V.createAsyncThunk)("transaction/transactionGetOutgoingTransactions", async (inp, { getState: getState, dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get outgoing transactions filter
    const filter = getState().transaction.outgoingTransactionsFilter;
    // define transaction type
    let transactionType;
    // assert transaction type
    switch(filter){
        case (0, $2gpGl.EntityTransactionType).Subscription:
            transactionType = "subscription";
            break;
        case (0, $2gpGl.EntityTransactionType).Tip:
            transactionType = "tip";
            break;
        case (0, $2gpGl.EntityTransactionType).Unlock:
            transactionType = "unlock";
            break;
        case (0, $2gpGl.EntityTransactionType).Payout:
            transactionType = "payout";
            break;
        default:
            transactionType = undefined;
    }
    try {
        // retrieve transactions
        const { transactions: transactions, count: count } = await api.transactionApi.getOutgoingTransactions(inp.limit, inp.offset, transactionType);
        // set income transactions
        dispatch((0, $ht2ql.transactionSetOutgoingTransactions)({
            transactions: transactions || [],
            count: count || 0,
            offset: inp.offset || 0
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("8xb3v", function(module, exports) {

$parcel$export(module.exports, "UnlockPostModal", function () { return (parcelRequire("1BGQJ")).UnlockPostModal; });
$parcel$export(module.exports, "UnlockTrackModal", function () { return (parcelRequire("eJWeC")).UnlockTrackModal; });
parcelRequire("0epsV");
var $1BGQJ = parcelRequire("1BGQJ");
var $eJWeC = parcelRequire("eJWeC");

var $8aXib = parcelRequire("8aXib");

var $8EUP6 = parcelRequire("8EUP6");
$parcel$exportWildcard(module.exports, $8aXib);
$parcel$exportWildcard(module.exports, $8EUP6);

});
parcelRegister("0epsV", function(module, exports) {

$parcel$export(module.exports, "UnlockPostModal", function () { return (parcelRequire("1BGQJ")).UnlockPostModal; });
$parcel$export(module.exports, "UnlockTrackModal", function () { return (parcelRequire("eJWeC")).UnlockTrackModal; });

var $1BGQJ = parcelRequire("1BGQJ");

var $eJWeC = parcelRequire("eJWeC");

});
parcelRegister("1BGQJ", function(module, exports) {

$parcel$export(module.exports, "UnlockPostModal", function () { return $84eb08becea72c2f$export$1685d719ed39c512; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("8909H");
var $6oUNk = parcelRequire("6oUNk");

var $1bgdB = parcelRequire("1bgdB");
const $84eb08becea72c2f$export$1685d719ed39c512 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const unlockPostModalOpen = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockPostModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $1bgdB.styles)().modal.main,
        children: unlockPostModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $8aXib.unlockCloseUnlockPostModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $1bgdB.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6oUNk.UnlockPostCard), {})
            })
        })
    });
};
$84eb08becea72c2f$export$1685d719ed39c512.propTypes = {};

});
parcelRegister("8909H", function(module, exports) {

$parcel$export(module.exports, "UnlockPostCard", function () { return (parcelRequire("6oUNk")).UnlockPostCard; });

var $6oUNk = parcelRequire("6oUNk");

});
parcelRegister("6oUNk", function(module, exports) {

$parcel$export(module.exports, "UnlockPostCard", function () { return $e1bb746366179a70$export$595b02be5fd36fca; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("cJvLm");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("dgjcY");
var $176Wf = parcelRequire("176Wf");

var $ik2m4 = parcelRequire("ik2m4");
const $e1bb746366179a70$export$595b02be5fd36fca = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const modalPost = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockPostModalPost));
    const unlockPostError = "";
    const { userId: authorUserId } = modalPost ?? {};
    // post author
    const { user: postAuthor, isLoading: isPostAuthorLoading } = (0, $aCYwi.useUserPublic)(authorUserId || "");
    const { username: authorUsername } = postAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorUsernamePlaceholder = "unknown";
    const subtitleAccentStartIndex = 52;
    const subtitleAccentEndIndex = 53 + (authorUsername?.length || authorLoadingPlaceholder.length || authorUsernamePlaceholder.length);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $ik2m4.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $ik2m4.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $8aXib.unlockCloseUnlockPostModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $ik2m4.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Unlock Post",
                    icon: (0, $bq9l8.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $ik2m4.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: `Access premium content and express your support for @${isPostAuthorLoading ? authorLoadingPlaceholder : authorUsername || authorUsernamePlaceholder} by unlocking exclusive post.`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${authorUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $ik2m4.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $ik2m4.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $176Wf.UnlockPostForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $ik2m4.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: unlockPostError
                        })
                    })
                ]
            })
        ]
    });
};
$e1bb746366179a70$export$595b02be5fd36fca.propTypes = {};

});
parcelRegister("dgjcY", function(module, exports) {

$parcel$export(module.exports, "UnlockPostForm", function () { return (parcelRequire("176Wf")).UnlockPostForm; });

var $176Wf = parcelRequire("176Wf");

});
parcelRegister("176Wf", function(module, exports) {

$parcel$export(module.exports, "UnlockPostForm", function () { return $18f8b43c67087f11$export$685a8e45433d2d9f; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $6uGoQ = parcelRequire("6uGoQ");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $9q2KH = parcelRequire("9q2KH");
var $8EUP6 = parcelRequire("8EUP6");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $9mzhJ = parcelRequire("9mzhJ");
const $18f8b43c67087f11$export$685a8e45433d2d9f = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const unlockCreatePostUnlockLoading = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockCreatePostUnlockLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalPost = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockPostModalPost));
    const { id: profileUserId } = profile ?? {};
    const { userId: artistUserId, unlockPrice: unlockPrice, mediaType: mediaType, trackIds: trackIds } = modalPost ?? {};
    const isCurrentUserContentUnlock = profileUserId === artistUserId;
    const postHasMediaContent = mediaType === (0, $2gpGl.EntityPostMediaType).Image || mediaType === (0, $2gpGl.EntityPostMediaType).Video;
    const postHasTracksContent = trackIds?.length && trackIds.length > 0;
    const displayPostContentDescription = postHasMediaContent || postHasTracksContent;
    const submitDisabled = isCurrentUserContentUnlock || unlockCreatePostUnlockLoading;
    // post tracks
    const { tracks: postTracks, isLoading: isPostTracksLoading } = (0, $6uGoQ.useTracks)(trackIds || []);
    const tracksLoadingPlaceholder = "Loading...";
    const tracksCount = postTracks?.length || 0;
    const lockedTracksCount = postTracks?.reduce((acc, t)=>t.visibility === (0, $2gpGl.EntityTrackVisibility).Subscribers ? acc + 1 : acc, 0);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9mzhJ.styles)(theme).form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $9mzhJ.styles)(theme).form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $8EUP6.unlockCreatePostUnlock)());
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $9mzhJ.styles)(theme).form.content.product,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $9q2KH.PostCardProduct), {})
                }),
                displayPostContentDescription && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $9mzhJ.styles)(theme).form.content.description.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $9mzhJ.styles)(theme).form.content.description.text,
                            children: "This post features a total of:"
                        }),
                        postHasMediaContent && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $9mzhJ.styles)(theme).form.content.description.text,
                            children: [
                                "engaging",
                                " ",
                                /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                    css: (0, $9mzhJ.styles)(theme).form.content.description.accent,
                                    children: mediaType
                                }),
                                " ",
                                "content"
                            ]
                        }),
                        postHasTracksContent && /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $9mzhJ.styles)(theme).form.content.description.text,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                    css: (0, $9mzhJ.styles)(theme).form.content.description.accent,
                                    children: isPostTracksLoading ? tracksLoadingPlaceholder : tracksCount
                                }),
                                " ",
                                "tracks, with",
                                " ",
                                /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                                    css: (0, $9mzhJ.styles)(theme).form.content.description.accent,
                                    children: isPostTracksLoading ? tracksLoadingPlaceholder : lockedTracksCount
                                }),
                                " ",
                                "of them being exclusive"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $9mzhJ.styles)(theme).form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "unlock post",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: unlockCreatePostUnlockLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Unlock for $${unlockPrice && unlockPrice / 100}`
                    })
                })
            ]
        })
    });
};
$18f8b43c67087f11$export$685a8e45433d2d9f.propTypes = {};

});
parcelRegister("9mzhJ", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $700b013d994c24fe$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $700b013d994c24fe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $700b013d994c24fe$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $700b013d994c24fe$export$9dd6ff9ea0189349 = (theme)=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                product: $700b013d994c24fe$var$_ref,
                description: {
                    main: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";text-align:center;color:", theme.colors.secondary.dark, ";margin-bottom:24px;", ""),
                    text: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    accent: /*#__PURE__*/ (0, $7hler.css)("font-weight:bold;color:", theme.colors.accent.normal, ";", "")
                },
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("ik2m4", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f0642f1d666bc38b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $f0642f1d666bc38b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f0642f1d666bc38b$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f0642f1d666bc38b$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f0642f1d666bc38b$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $f0642f1d666bc38b$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $f0642f1d666bc38b$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $f0642f1d666bc38b$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $f0642f1d666bc38b$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $f0642f1d666bc38b$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $f0642f1d666bc38b$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($f0642f1d666bc38b$var$_ref8), " ", (0, $gln0L.mq).mobile($f0642f1d666bc38b$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($f0642f1d666bc38b$var$_ref6), ";", ""),
            title: $f0642f1d666bc38b$var$_ref5,
            subtitle: $f0642f1d666bc38b$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($f0642f1d666bc38b$var$_ref3), ";", ""),
                form: $f0642f1d666bc38b$var$_ref2,
                error: $f0642f1d666bc38b$var$_ref
            }
        }
    });

});



parcelRegister("1bgdB", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $08089f231712e502$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $08089f231712e502$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $08089f231712e502$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $08089f231712e502$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($08089f231712e502$var$_ref), ";", "")
        }
    });

});


parcelRegister("eJWeC", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackModal", function () { return $ad80e87ed01cd964$export$1e592ca8ae9cb6b5; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("5wCHz");
var $gc5yV = parcelRequire("gc5yV");

var $fNXvh = parcelRequire("fNXvh");
const $ad80e87ed01cd964$export$1e592ca8ae9cb6b5 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const unlockTrackModalOpen = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockTrackModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fNXvh.styles)().modal.main,
        children: unlockTrackModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $8aXib.unlockCloseUnlockTrackModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fNXvh.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gc5yV.UnlockTrackCard), {})
            })
        })
    });
};
$ad80e87ed01cd964$export$1e592ca8ae9cb6b5.propTypes = {};

});
parcelRegister("5wCHz", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackCard", function () { return (parcelRequire("gc5yV")).UnlockTrackCard; });

var $gc5yV = parcelRequire("gc5yV");

});
parcelRegister("gc5yV", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackCard", function () { return $9015d4568295d611$export$c893483e3978e7e0; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $aCYwi = parcelRequire("aCYwi");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("cJvLm");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("8hyPF");
var $ddJXi = parcelRequire("ddJXi");

var $2qyui = parcelRequire("2qyui");
const $9015d4568295d611$export$c893483e3978e7e0 = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const modalTrack = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockTrackModalTrack));
    const unlockTrackError = "";
    const { userId: authorUserId } = modalTrack ?? {};
    // track author
    const { user: trackAuthor, isLoading: isTrackAuthorLoading } = (0, $aCYwi.useUserPublic)(authorUserId || "");
    const { username: authorUsername } = trackAuthor ?? {};
    const authorLoadingPlaceholder = "Loading...";
    const authorUsernamePlaceholder = "unknown";
    const subtitleAccentStartIndex = 52;
    const subtitleAccentEndIndex = 53 + (authorUsername?.length || authorLoadingPlaceholder.length || authorUsernamePlaceholder.length);
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $2qyui.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2qyui.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $8aXib.unlockCloseUnlockTrackModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2qyui.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Unlock Track",
                    icon: (0, $bq9l8.icons).Unlock
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $2qyui.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: `Access premium content and express your support for @${isTrackAuthorLoading ? authorLoadingPlaceholder : authorUsername || authorUsernamePlaceholder} by unlocking exclusive track.`,
                    accent: {
                        accentStart: subtitleAccentStartIndex,
                        accentEnd: subtitleAccentEndIndex,
                        onClick: ()=>navigate(`${(0, $b7fnN.Path).User}/${authorUserId}`)
                    }
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $2qyui.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $2qyui.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ddJXi.UnlockTrackForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $2qyui.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: unlockTrackError
                        })
                    })
                ]
            })
        ]
    });
};
$9015d4568295d611$export$c893483e3978e7e0.propTypes = {};

});
parcelRegister("8hyPF", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackForm", function () { return (parcelRequire("ddJXi")).UnlockTrackForm; });

var $ddJXi = parcelRequire("ddJXi");

});
parcelRegister("ddJXi", function(module, exports) {

$parcel$export(module.exports, "UnlockTrackForm", function () { return $5bc969ef6874c34e$export$9f8197e356abe44; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4qRw3 = parcelRequire("4qRw3");
var $8EUP6 = parcelRequire("8EUP6");
var $8aXib = parcelRequire("8aXib");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $3HWvM = parcelRequire("3HWvM");
const $5bc969ef6874c34e$export$9f8197e356abe44 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const unlockCreateTrackUnlockLoading = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockCreateTrackUnlockLoading));
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const modalTrack = (0, $gNvvs.useAppSelector)((0, $8aXib.unlockSelectUnlockTrackModalTrack));
    const { id: profileUserId } = profile ?? {};
    const { unlockPrice: unlockPrice, userId: artistUserId } = modalTrack ?? {};
    const isCurrentUserContentUnlock = profileUserId === artistUserId;
    const submitDisabled = isCurrentUserContentUnlock || unlockCreateTrackUnlockLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $3HWvM.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $3HWvM.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $8EUP6.unlockCreateTrackUnlock)());
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $3HWvM.styles)().form.content.product,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4qRw3.TrackTileProduct), {
                        track: modalTrack || {}
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $3HWvM.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "unlock track",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: unlockCreateTrackUnlockLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : `Unlock for $${unlockPrice && unlockPrice / 100}`
                    })
                })
            ]
        })
    });
};
$5bc969ef6874c34e$export$9f8197e356abe44.propTypes = {};

});
parcelRegister("3HWvM", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ad1d0b4462f6f7c7$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $ad1d0b4462f6f7c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ad1d0b4462f6f7c7$var$_ref = {
    name: "o1dwno",
    styles: "display:flex;justify-content:center;margin-bottom:24px"
};
const $ad1d0b4462f6f7c7$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                product: $ad1d0b4462f6f7c7$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("2qyui", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ebcae56b2a984b19$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ebcae56b2a984b19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ebcae56b2a984b19$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $ebcae56b2a984b19$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $ebcae56b2a984b19$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $ebcae56b2a984b19$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ebcae56b2a984b19$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $ebcae56b2a984b19$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $ebcae56b2a984b19$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $ebcae56b2a984b19$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $ebcae56b2a984b19$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($ebcae56b2a984b19$var$_ref8), " ", (0, $gln0L.mq).mobile($ebcae56b2a984b19$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($ebcae56b2a984b19$var$_ref6), ";", ""),
            title: $ebcae56b2a984b19$var$_ref5,
            subtitle: $ebcae56b2a984b19$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($ebcae56b2a984b19$var$_ref3), ";", ""),
                form: $ebcae56b2a984b19$var$_ref2,
                error: $ebcae56b2a984b19$var$_ref
            }
        }
    });

});



parcelRegister("fNXvh", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $835bb2759848f2b6$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $835bb2759848f2b6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $835bb2759848f2b6$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $835bb2759848f2b6$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($835bb2759848f2b6$var$_ref), ";", "")
        }
    });

});



parcelRegister("8aXib", function(module, exports) {

$parcel$export(module.exports, "unlockSlice", function () { return $87690971a1fabdb6$export$381ce5319c2274da; });
$parcel$export(module.exports, "unlockResetState", function () { return $87690971a1fabdb6$export$35f1884a3da44f69; });
$parcel$export(module.exports, "unlockSetPostUnlocks", function () { return $87690971a1fabdb6$export$2bfaa55cc0ca870d; });
$parcel$export(module.exports, "unlockAddPostUnlock", function () { return $87690971a1fabdb6$export$11e0007326c9d985; });
$parcel$export(module.exports, "unlockRemovePostUnlock", function () { return $87690971a1fabdb6$export$381fca7a8b5f0b4a; });
$parcel$export(module.exports, "unlockSetTrackUnlocks", function () { return $87690971a1fabdb6$export$56e394be1baad6a; });
$parcel$export(module.exports, "unlockAddTrackUnlock", function () { return $87690971a1fabdb6$export$d3ce7022a65cf68b; });
$parcel$export(module.exports, "unlockRemoveTrackUnlock", function () { return $87690971a1fabdb6$export$8c749fae48cabbde; });
$parcel$export(module.exports, "unlockOpenUnlockPostModal", function () { return $87690971a1fabdb6$export$6bf84dbbd6226b5b; });
$parcel$export(module.exports, "unlockCloseUnlockPostModal", function () { return $87690971a1fabdb6$export$1d8ecc069ad7c7f7; });
$parcel$export(module.exports, "unlockOpenUnlockTrackModal", function () { return $87690971a1fabdb6$export$e7859b55a7b4f99c; });
$parcel$export(module.exports, "unlockCloseUnlockTrackModal", function () { return $87690971a1fabdb6$export$8ac968d6a6fbe230; });
$parcel$export(module.exports, "unlockSelectPostUnlocks", function () { return $87690971a1fabdb6$export$784e3adf5ad22d23; });
$parcel$export(module.exports, "unlockSelectTrackUnlocks", function () { return $87690971a1fabdb6$export$bf416d4ed55b04ac; });
$parcel$export(module.exports, "unlockSelectUnlockPostModalOpen", function () { return $87690971a1fabdb6$export$f5cd230b3e742cbc; });
$parcel$export(module.exports, "unlockSelectUnlockPostModalPost", function () { return $87690971a1fabdb6$export$f7ee293c19e0841b; });
$parcel$export(module.exports, "unlockSelectUnlockTrackModalOpen", function () { return $87690971a1fabdb6$export$f3090f5fff7cfeff; });
$parcel$export(module.exports, "unlockSelectUnlockTrackModalTrack", function () { return $87690971a1fabdb6$export$74288cfc472b94ae; });
$parcel$export(module.exports, "unlockSelectUnlockGetUnlockedPostIdsLoading", function () { return $87690971a1fabdb6$export$6e2d9b9989319967; });
$parcel$export(module.exports, "unlockSelectUnlockGetUnlockedTrackIdsLoading", function () { return $87690971a1fabdb6$export$e5e50d8dbe3269a3; });
$parcel$export(module.exports, "unlockSelectUnlockCreatePostUnlockLoading", function () { return $87690971a1fabdb6$export$97bbe41b5cad1b74; });
$parcel$export(module.exports, "unlockSelectUnlockCreateTrackUnlockLoading", function () { return $87690971a1fabdb6$export$2af62a6613a1a5e3; });
$parcel$export(module.exports, "unlockReducer", function () { return $87690971a1fabdb6$export$ec63a4f66cdbe416; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("cJvLm");
var $8EUP6 = parcelRequire("8EUP6");
const $87690971a1fabdb6$var$initialState = {
    postUnlocks: {},
    trackUnlocks: {},
    unlockPostModal: {
        post: undefined,
        open: false
    },
    unlockTrackModal: {
        track: undefined,
        open: false
    },
    unlockGetUnlockedPostIdsLoading: false,
    unlockGetUnlockedTrackIdsLoading: false,
    unlockCreatePostUnlockLoading: false,
    unlockCreateTrackUnlockLoading: false
};
const $87690971a1fabdb6$export$381ce5319c2274da = (0, $kvj5V.createSlice)({
    name: "unlock",
    initialState: $87690971a1fabdb6$var$initialState,
    reducers: {
        // reset state
        unlockResetState: ()=>({
                postUnlocks: {},
                trackUnlocks: {},
                unlockPostModal: {
                    post: undefined,
                    open: false
                },
                unlockTrackModal: {
                    track: undefined,
                    open: false
                },
                unlockGetUnlockedPostIdsLoading: false,
                unlockGetUnlockedTrackIdsLoading: false,
                unlockCreatePostUnlockLoading: false,
                unlockCreateTrackUnlockLoading: false
            }),
        // set post unlocks
        unlockSetPostUnlocks: (state, action)=>{
            const { unlockedPostIds: unlockedPostIds } = action.payload;
            // define post unlocks map
            const postUnlocks = {};
            // iterate over each unlocked post id
            unlockedPostIds.forEach((id)=>{
                // add id to the map
                postUnlocks[id] = true;
            });
            // update state
            state.postUnlocks = postUnlocks;
        },
        // add post unlock
        unlockAddPostUnlock: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postUnlocks[postId] = true;
        },
        // remove post unlock
        unlockRemovePostUnlock: (state, action)=>{
            const { postId: postId } = action.payload;
            // update state
            state.postUnlocks[postId] = false;
        },
        // set track unlocks
        unlockSetTrackUnlocks: (state, action)=>{
            const { unlockedTrackIds: unlockedTrackIds } = action.payload;
            // define track unlocks map
            const trackUnlocks = {};
            // iterate over each unlocked track id
            unlockedTrackIds.forEach((id)=>{
                // add id to the map
                trackUnlocks[id] = true;
            });
            // update state
            state.trackUnlocks = trackUnlocks;
        },
        // add track unlock
        unlockAddTrackUnlock: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackUnlocks[trackId] = true;
        },
        // remove track unlock
        unlockRemoveTrackUnlock: (state, action)=>{
            const { trackId: trackId } = action.payload;
            // update state
            state.trackUnlocks[trackId] = false;
        },
        // open unlock post modal
        unlockOpenUnlockPostModal: (state, action)=>({
                ...state,
                unlockPostModal: {
                    post: action.payload.post,
                    open: true
                }
            }),
        // close unlock post modal
        unlockCloseUnlockPostModal: (state)=>({
                ...state,
                unlockPostModal: {
                    post: undefined,
                    open: false
                },
                error: ""
            }),
        // open unlock track modal
        unlockOpenUnlockTrackModal: (state, action)=>({
                ...state,
                unlockTrackModal: {
                    track: action.payload.track,
                    open: true
                }
            }),
        // close unlock track modal
        unlockCloseUnlockTrackModal: (state)=>({
                ...state,
                unlockTrackModal: {
                    track: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get unlocked post ids
        builder.addCase((0, $8EUP6.unlockGetUnlockedPostIds).pending, (state)=>({
                ...state,
                unlockGetUnlockedPostIdsLoading: true
            })).addCase((0, $8EUP6.unlockGetUnlockedPostIds).fulfilled, (state)=>({
                ...state,
                unlockGetUnlockedPostIdsLoading: false
            }));
        // get unlocked track ids
        builder.addCase((0, $8EUP6.unlockGetUnlockedTrackIds).pending, (state)=>({
                ...state,
                unlockGetUnlockedTrackIdsLoading: true
            })).addCase((0, $8EUP6.unlockGetUnlockedTrackIds).fulfilled, (state)=>({
                ...state,
                unlockGetUnlockedTrackIdsLoading: false
            }));
        // create post unlock
        builder.addCase((0, $8EUP6.unlockCreatePostUnlock).pending, (state)=>({
                ...state,
                unlockCreatePostUnlockLoading: true
            })).addCase((0, $8EUP6.unlockCreatePostUnlock).fulfilled, (state)=>({
                ...state,
                unlockCreatePostUnlockLoading: false
            }));
        // create track unlock
        builder.addCase((0, $8EUP6.unlockCreateTrackUnlock).pending, (state)=>({
                ...state,
                unlockCreateTrackUnlockLoading: true
            })).addCase((0, $8EUP6.unlockCreateTrackUnlock).fulfilled, (state)=>({
                ...state,
                unlockCreateTrackUnlockLoading: false
            }));
    }
});
const { unlockResetState: $87690971a1fabdb6$export$35f1884a3da44f69, unlockSetPostUnlocks: $87690971a1fabdb6$export$2bfaa55cc0ca870d, unlockAddPostUnlock: $87690971a1fabdb6$export$11e0007326c9d985, unlockRemovePostUnlock: $87690971a1fabdb6$export$381fca7a8b5f0b4a, unlockSetTrackUnlocks: $87690971a1fabdb6$export$56e394be1baad6a, unlockAddTrackUnlock: $87690971a1fabdb6$export$d3ce7022a65cf68b, unlockRemoveTrackUnlock: $87690971a1fabdb6$export$8c749fae48cabbde, unlockOpenUnlockPostModal: $87690971a1fabdb6$export$6bf84dbbd6226b5b, unlockCloseUnlockPostModal: $87690971a1fabdb6$export$1d8ecc069ad7c7f7, unlockOpenUnlockTrackModal: $87690971a1fabdb6$export$e7859b55a7b4f99c, unlockCloseUnlockTrackModal: $87690971a1fabdb6$export$8ac968d6a6fbe230 } = $87690971a1fabdb6$export$381ce5319c2274da.actions;
const $87690971a1fabdb6$export$784e3adf5ad22d23 = (state)=>state.unlock.postUnlocks;
const $87690971a1fabdb6$export$bf416d4ed55b04ac = (state)=>state.unlock.trackUnlocks;
const $87690971a1fabdb6$export$f5cd230b3e742cbc = (state)=>state.unlock.unlockPostModal.open;
const $87690971a1fabdb6$export$f7ee293c19e0841b = (state)=>state.unlock.unlockPostModal.post;
const $87690971a1fabdb6$export$f3090f5fff7cfeff = (state)=>state.unlock.unlockTrackModal.open;
const $87690971a1fabdb6$export$74288cfc472b94ae = (state)=>state.unlock.unlockTrackModal.track;
const $87690971a1fabdb6$export$6e2d9b9989319967 = (state)=>state.unlock.unlockGetUnlockedPostIdsLoading;
const $87690971a1fabdb6$export$e5e50d8dbe3269a3 = (state)=>state.unlock.unlockGetUnlockedTrackIdsLoading;
const $87690971a1fabdb6$export$97bbe41b5cad1b74 = (state)=>state.unlock.unlockCreatePostUnlockLoading;
const $87690971a1fabdb6$export$2af62a6613a1a5e3 = (state)=>state.unlock.unlockCreateTrackUnlockLoading;
const $87690971a1fabdb6$export$ec63a4f66cdbe416 = $87690971a1fabdb6$export$381ce5319c2274da.reducer; // export default unlockSlice.reducer

});

parcelRegister("8EUP6", function(module, exports) {

$parcel$export(module.exports, "unlockGetUnlockedPostIds", function () { return $2f7e92ccdd78fea3$export$c237ef55467796dd; });
$parcel$export(module.exports, "unlockGetUnlockedTrackIds", function () { return $2f7e92ccdd78fea3$export$31da728731d1845a; });
$parcel$export(module.exports, "unlockCreatePostUnlock", function () { return $2f7e92ccdd78fea3$export$cbb0f9d459a738f3; });
$parcel$export(module.exports, "unlockCreateTrackUnlock", function () { return $2f7e92ccdd78fea3$export$a38bfc0b487a052d; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $6Qgqx = parcelRequire("6Qgqx");
var $hxwj5 = parcelRequire("hxwj5");
var $8aXib = parcelRequire("8aXib");
const $2f7e92ccdd78fea3$export$c237ef55467796dd = (0, $kvj5V.createAsyncThunk)("unlock/unlockGetUnlockedPostIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve unlocked post ids
        const { unlockedPostIds: unlockedPostIds } = await api.unlockApi.getUnlockedPostIds();
        // set post unlocks
        dispatch((0, $8aXib.unlockSetPostUnlocks)({
            unlockedPostIds: unlockedPostIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f7e92ccdd78fea3$export$31da728731d1845a = (0, $kvj5V.createAsyncThunk)("unlock/unlockGetUnlockedTrackIds", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve unlocked track ids
        const { unlockedTrackIds: unlockedTrackIds } = await api.unlockApi.getUnlockedTrackIds();
        // set track unlocks
        dispatch((0, $8aXib.unlockSetTrackUnlocks)({
            unlockedTrackIds: unlockedTrackIds || []
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f7e92ccdd78fea3$export$cbb0f9d459a738f3 = (0, $kvj5V.createAsyncThunk)("unlock/unlockCreatePostUnlock", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get post from modal state
    const modalPost = getState().unlock.unlockPostModal.post;
    const { id: postId } = modalPost ?? {};
    try {
        // create post unlock
        const { clientSecret: clientSecret } = await api.unlockApi.createPostUnlock({
            postId: postId || ""
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close post unlock modal
        dispatch((0, $8aXib.unlockCloseUnlockPostModal)());
        // open payment modal
        dispatch((0, $6Qgqx.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $hxwj5.PaymentOperationType).PostUnlock,
            operationSubject: modalPost
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to unlock post: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $2f7e92ccdd78fea3$export$a38bfc0b487a052d = (0, $kvj5V.createAsyncThunk)("unlock/unlockCreateTrackUnlock", async (_, { dispatch: dispatch, getState: getState })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    // get track from modal state
    const modalTrack = getState().unlock.unlockTrackModal.track;
    const { id: trackId } = modalTrack ?? {};
    try {
        // create track unlock
        const { clientSecret: clientSecret } = await api.unlockApi.createTrackUnlock({
            trackId: trackId || ""
        });
        // get current default customer payment method
        const { customerPaymentMethod: customerPaymentMethod } = await api.customerApi.getCustomerPaymentMethodDefault();
        // close unlock track modal
        dispatch((0, $8aXib.unlockCloseUnlockTrackModal)());
        // open payment modal
        dispatch((0, $6Qgqx.paymentOpenPaymentModal)({
            clientSecret: clientSecret || "",
            defaultCustomerPaymentMethod: customerPaymentMethod,
            operationType: (0, $hxwj5.PaymentOperationType).TrackUnlock,
            operationSubject: modalTrack
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to unlock track: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});


parcelRegister("3Q8Dc", function(module, exports) {

$parcel$export(module.exports, "ArtistCard", function () { return (parcelRequire("gZIjn")).ArtistCard; });
$parcel$export(module.exports, "ArtistCardProduct", function () { return (parcelRequire("f1KST")).ArtistCardProduct; });
$parcel$export(module.exports, "ArtistListFeedPopular", function () { return (parcelRequire("7Bbxh")).ArtistListFeedPopular; });
$parcel$export(module.exports, "ArtistListFeedRecommended", function () { return (parcelRequire("4Uw8U")).ArtistListFeedRecommended; });
$parcel$export(module.exports, "ArtistListHomePublic", function () { return (parcelRequire("2SbzZ")).ArtistListHomePublic; });
$parcel$export(module.exports, "ArtistListLibraryFollowed", function () { return (parcelRequire("hazyz")).ArtistListLibraryFollowed; });
$parcel$export(module.exports, "ArtistListLibrarySubscribed", function () { return (parcelRequire("crOcW")).ArtistListLibrarySubscribed; });
$parcel$export(module.exports, "ArtistListOnboardingRecommended", function () { return (parcelRequire("gzBMX")).ArtistListOnboardingRecommended; });
$parcel$export(module.exports, "UserBlockModal", function () { return (parcelRequire("a7r6m")).UserBlockModal; });
$parcel$export(module.exports, "UserViewProfile", function () { return (parcelRequire("gX3Fy")).UserViewProfile; });
$parcel$export(module.exports, "UserViewStudio", function () { return (parcelRequire("7b2vs")).UserViewStudio; });
$parcel$export(module.exports, "UserViewUser", function () { return (parcelRequire("1TrNX")).UserViewUser; });
$parcel$export(module.exports, "userUtilRenderArtistActions", function () { return (parcelRequire("aM7LJ")).userUtilRenderArtistActions; });
$parcel$export(module.exports, "userUtilGetArtistCardSkeletonSections", function () { return (parcelRequire("aM7LJ")).userUtilGetArtistCardSkeletonSections; });
parcelRequire("fPmTe");
var $gZIjn = parcelRequire("gZIjn");
var $f1KST = parcelRequire("f1KST");
var $7Bbxh = parcelRequire("7Bbxh");
var $4Uw8U = parcelRequire("4Uw8U");
var $2SbzZ = parcelRequire("2SbzZ");
var $hazyz = parcelRequire("hazyz");
var $crOcW = parcelRequire("crOcW");
var $gzBMX = parcelRequire("gzBMX");
var $a7r6m = parcelRequire("a7r6m");
var $gX3Fy = parcelRequire("gX3Fy");
var $7b2vs = parcelRequire("7b2vs");
var $1TrNX = parcelRequire("1TrNX");

var $aM7LJ = parcelRequire("aM7LJ");

var $iw5tW = parcelRequire("iw5tW");

var $lCHeK = parcelRequire("lCHeK");
$parcel$exportWildcard(module.exports, $iw5tW);
$parcel$exportWildcard(module.exports, $lCHeK);

});
parcelRegister("fPmTe", function(module, exports) {

$parcel$export(module.exports, "ArtistCard", function () { return (parcelRequire("gZIjn")).ArtistCard; });
$parcel$export(module.exports, "ArtistCardProduct", function () { return (parcelRequire("f1KST")).ArtistCardProduct; });
$parcel$export(module.exports, "ArtistListLibraryFollowed", function () { return (parcelRequire("hazyz")).ArtistListLibraryFollowed; });
$parcel$export(module.exports, "ArtistListLibrarySubscribed", function () { return (parcelRequire("crOcW")).ArtistListLibrarySubscribed; });
$parcel$export(module.exports, "ArtistListHomePublic", function () { return (parcelRequire("2SbzZ")).ArtistListHomePublic; });
$parcel$export(module.exports, "ArtistListFeedPopular", function () { return (parcelRequire("7Bbxh")).ArtistListFeedPopular; });
$parcel$export(module.exports, "ArtistListFeedRecommended", function () { return (parcelRequire("4Uw8U")).ArtistListFeedRecommended; });
$parcel$export(module.exports, "ArtistListOnboardingRecommended", function () { return (parcelRequire("gzBMX")).ArtistListOnboardingRecommended; });
$parcel$export(module.exports, "UserBlockModal", function () { return (parcelRequire("a7r6m")).UserBlockModal; });
$parcel$export(module.exports, "UserViewProfile", function () { return (parcelRequire("gX3Fy")).UserViewProfile; });
$parcel$export(module.exports, "UserViewStudio", function () { return (parcelRequire("7b2vs")).UserViewStudio; });
$parcel$export(module.exports, "UserViewUser", function () { return (parcelRequire("1TrNX")).UserViewUser; });

var $gZIjn = parcelRequire("gZIjn");

var $f1KST = parcelRequire("f1KST");

var $hazyz = parcelRequire("hazyz");

var $crOcW = parcelRequire("crOcW");

var $2SbzZ = parcelRequire("2SbzZ");

var $7Bbxh = parcelRequire("7Bbxh");

var $4Uw8U = parcelRequire("4Uw8U");

var $gzBMX = parcelRequire("gzBMX");

var $a7r6m = parcelRequire("a7r6m");

var $gX3Fy = parcelRequire("gX3Fy");

var $7b2vs = parcelRequire("7b2vs");

var $1TrNX = parcelRequire("1TrNX");

});
parcelRegister("gZIjn", function(module, exports) {

$parcel$export(module.exports, "ArtistCard", function () { return $843aaf69721198c2$export$16c3e13019c01108; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $iLKNg = parcelRequire("iLKNg");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("cJvLm");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
parcelRequire("1TdPt");
var $l7e6s = parcelRequire("l7e6s");

var $fwj3S = parcelRequire("fwj3S");
const $843aaf69721198c2$export$16c3e13019c01108 = ({ artist: artist, artistActions: artistActions, onNameClick: onNameClick, onUsernameClick: onUsernameClick })=>{
    const theme = (0, $iwq56.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $bh6RR.useState)(false);
    const { id: artistId, avatarId: avatarId, name: name, username: username } = artist;
    const { isFollowed: isFollowed, isSubscribed: isSubscribed, isSubscribedAtPeriodEnd: isSubscribedAtPeriodEnd, isPublic: isPublic, onFollowClick: onFollowClick, onUnfollowClick: onUnfollowClick, onCreateSubscriptionClick: onCreateSubscriptionClick, onRenewSubscriptionClick: onRenewSubscriptionClick, onCancelSubscriptionClick: onCancelSubscriptionClick } = artistActions ?? {};
    // connect ready
    const { ready: connectReady } = (0, $iLKNg.useConnectReady)(isPublic ? "" : artistId || "");
    const artistHasAvatar = !!avatarId;
    const source = (0, $jpNoL.useFile)(avatarId || "");
    const renderArtistActionsInput = {
        isCurrentUserFollowingArtist: !!isFollowed,
        isCurrentUserSubscribedToArtist: !!isSubscribed,
        isCurrentUserSubscribedToArtistAtPeriodEnd: !!isSubscribedAtPeriodEnd,
        isArtistCanReceivePayments: !!connectReady,
        createUserFollowNode: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
            css: (0, $fwj3S.styles)(theme).artist.buttons.button,
            "aria-label": "follow artist",
            appearance: "primary",
            onClick: onFollowClick ? (e)=>onFollowClick(e) : undefined,
            children: "Follow"
        }),
        deleteUserFollowNode: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
            css: (0, $fwj3S.styles)(theme).artist.buttons.button,
            "aria-label": "unfollow artist",
            appearance: "secondary",
            onClick: onUnfollowClick ? (e)=>onUnfollowClick(e) : undefined,
            children: "Unfollow"
        }),
        createSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
            css: (0, $fwj3S.styles)(theme).artist.buttons.button,
            "aria-label": "subscribe",
            appearance: "primary",
            onClick: onCreateSubscriptionClick ? (e)=>onCreateSubscriptionClick(e) : undefined,
            children: "Subscribe"
        }),
        renewSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
            css: (0, $fwj3S.styles)(theme).artist.buttons.button,
            "aria-label": "subscribe",
            appearance: "primary",
            onClick: onRenewSubscriptionClick ? (e)=>onRenewSubscriptionClick(e) : undefined,
            children: "Subscribe"
        }),
        cancelSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)((0, $l7e6s.ButtonSmall), {
            css: (0, $fwj3S.styles)(theme).artist.buttons.button,
            "aria-label": "unsubscribe",
            appearance: "secondary",
            onClick: onCancelSubscriptionClick ? (e)=>onCancelSubscriptionClick(e) : undefined,
            children: "Unsubscribe"
        }),
        defaultNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {})
    };
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $fwj3S.styles)(theme).artist.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fwj3S.styles)(theme).artist.avatar.main,
                children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $fwj3S.styles)(theme).artist.avatar.image,
                    onError: ()=>setAvatarLoadError(true),
                    loading: "lazy",
                    width: "100px",
                    height: "100px",
                    src: source,
                    alt: "artist avatar"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                    css: (0, $fwj3S.styles)(theme).artist.avatar.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $fwj3S.styles)(theme).artist.info.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $fwj3S.styles)(theme).artist.info.name,
                        onClick: (e)=>onNameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
                        css: (0, $fwj3S.styles)(theme).artist.info.username,
                        onClick: (e)=>onUsernameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: [
                            "@",
                            username
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fwj3S.styles)(theme).artist.followers.main,
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("span", {
                    css: (0, $fwj3S.styles)(theme).artist.followers.count,
                    children: [
                        (0, $1Fj5G.numbersFormatter)(artist.followersCount || 0),
                        " follower(s)"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fwj3S.styles)(theme).artist.buttons.main,
                children: artistActions ? (0, $aM7LJ.userUtilRenderArtistActions)(renderArtistActionsInput) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {})
            })
        ]
    });
};
$843aaf69721198c2$export$16c3e13019c01108.propTypes = {};

});
parcelRegister("fwj3S", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $61527327841d06f4$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $61527327841d06f4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $61527327841d06f4$var$_ref = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
var $61527327841d06f4$var$_ref2 = {
    name: "sb8535",
    styles: "margin-bottom:8px;text-align:center"
};
var $61527327841d06f4$var$_ref3 = {
    name: "19xw8tk",
    styles: "display:flex;flex-direction:column;align-self:center;text-align:center;width:100px;margin-bottom:12px"
};
const $61527327841d06f4$export$9dd6ff9ea0189349 = (theme)=>({
        artist: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:140px;color:", theme.colors.secondary.normal, ";", ""),
            avatar: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;align-self:center;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:12px;", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            info: {
                main: $61527327841d06f4$var$_ref3,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            },
            followers: {
                main: $61527327841d06f4$var$_ref2,
                count: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";", "")
            },
            buttons: {
                main: $61527327841d06f4$var$_ref,
                button: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;padding:6px 16px;max-width:90%;", "")
            }
        }
    });

});


parcelRegister("f1KST", function(module, exports) {

$parcel$export(module.exports, "ArtistCardProduct", function () { return $ed961bf42156abaa$export$51270459d03b74e6; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $NVtDr = parcelRequire("NVtDr");
const $ed961bf42156abaa$export$51270459d03b74e6 = ({ artist: artist, onNameClick: onNameClick, onUsernameClick: onUsernameClick })=>{
    const theme = (0, $iwq56.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $bh6RR.useState)(false);
    const { avatarId: avatarId, name: name, username: username } = artist;
    const artistHasAvatar = !!avatarId;
    const source = (0, $jpNoL.useFile)(avatarId || "");
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $NVtDr.styles)(theme).artist.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $NVtDr.styles)(theme).artist.avatar.main,
                children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $NVtDr.styles)(theme).artist.avatar.image,
                    onError: ()=>setAvatarLoadError(true),
                    loading: "lazy",
                    width: "100px",
                    height: "100px",
                    src: source,
                    alt: "artist avatar"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                    css: (0, $NVtDr.styles)(theme).artist.avatar.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $NVtDr.styles)(theme).artist.info.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                        css: (0, $NVtDr.styles)(theme).artist.info.name,
                        onClick: (e)=>onNameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
                        css: (0, $NVtDr.styles)(theme).artist.info.username,
                        onClick: (e)=>onUsernameClick(e),
                        type: "button",
                        "aria-label": "explore artist",
                        children: [
                            "@",
                            username
                        ]
                    })
                ]
            })
        ]
    });
};
$ed961bf42156abaa$export$51270459d03b74e6.propTypes = {};

});
parcelRegister("NVtDr", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $1346a8727d8ac5f9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $1346a8727d8ac5f9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $1346a8727d8ac5f9$var$_ref = {
    name: "19xw8tk",
    styles: "display:flex;flex-direction:column;align-self:center;text-align:center;width:100px;margin-bottom:12px"
};
const $1346a8727d8ac5f9$export$9dd6ff9ea0189349 = (theme)=>({
        artist: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;width:140px;color:", theme.colors.secondary.normal, ";", ""),
            avatar: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;align-self:center;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:12px;", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            info: {
                main: $1346a8727d8ac5f9$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;color:", theme.colors.secondary.normal, ";text-align:center;margin-bottom:2px;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", ""),
                username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";", (0, $gln0L.helpers).textOverflowEllipsis, ";cursor:pointer;font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.normal, ";text-align:center;transition:color 0.2s;&:hover{color:", theme.colors.accent.normal, ";}", "")
            }
        }
    });

});


parcelRegister("hazyz", function(module, exports) {

$parcel$export(module.exports, "ArtistListLibraryFollowed", function () { return $4720dd9955db445d$export$b26717ecc8534097; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gZIjn = parcelRequire("gZIjn");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $l5cm3 = parcelRequire("l5cm3");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");
const $4720dd9955db445d$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectFollowedArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $aM7LJ.userUtilGetArtistCardSkeletonSections)("artist-list-library-followed")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $4720dd9955db445d$export$b26717ecc8534097 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const followedArtists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectFollowedArtists));
    const followedArtistsCount = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectFollowedArtistsCount));
    const followedArtistsLength = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectFollowedArtistsLength));
    const followedArtistsFetched = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectFollowedArtistsFetched));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!followedArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $lCHeK.userGetFollowedArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if followed artists are fetched but length is 0
    if (followedArtistsFetched && followedArtistsLength === 0) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Followed Artists",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: followedArtistsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).HeartBroken,
            height: "242px",
            title: "You haven't followed any artist yet"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Followed Artists",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: followedArtistsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: followedArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: followedArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $4720dd9955db445d$var$Row
                })
        })
    });
};
$4720dd9955db445d$export$b26717ecc8534097.propTypes = {};

});

parcelRegister("crOcW", function(module, exports) {

$parcel$export(module.exports, "ArtistListLibrarySubscribed", function () { return $f7e372df4d1fbcc0$export$ad83287ed145663d; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gZIjn = parcelRequire("gZIjn");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $l5cm3 = parcelRequire("l5cm3");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");
const $f7e372df4d1fbcc0$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectSubscribedArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $aM7LJ.userUtilGetArtistCardSkeletonSections)("artist-list-library-subscribed")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $f7e372df4d1fbcc0$export$ad83287ed145663d = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const subscribedArtists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectSubscribedArtists));
    const subscribedArtistsCount = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectSubscribedArtistsCount));
    const subscribedArtistsLength = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectSubscribedArtistsLength));
    const subscribedArtistsFetched = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectSubscribedArtistsFetched));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!subscribedArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $lCHeK.userGetSubscribedArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    // if subscribed artists are fetched but length is 0
    if (subscribedArtistsFetched && subscribedArtistsLength === 0) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Subscribed Artists",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: subscribedArtistsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).HeartBroken,
            height: "242px",
            title: "You haven't subscribed to any artist yet"
        })
    });
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Subscribed Artists",
        overrideCss: (0, $3sxbD.contentLayout).library,
        itemWidth: itemWidth,
        itemsCount: subscribedArtistsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: subscribedArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: subscribedArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $f7e372df4d1fbcc0$var$Row
                })
        })
    });
};
$f7e372df4d1fbcc0$export$ad83287ed145663d.propTypes = {};

});

parcelRegister("2SbzZ", function(module, exports) {

$parcel$export(module.exports, "ArtistListHomePublic", function () { return $d975bf2e86bb3e47$export$71eb2018e0fdf5fe; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gZIjn = parcelRequire("gZIjn");
var $9HBOX = parcelRequire("9HBOX");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");
const $d975bf2e86bb3e47$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const artists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectPublicArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $aM7LJ.userUtilGetArtistCardSkeletonSections)("artist-list-home-public")
        })
    });
    const openJoinModal = ()=>dispatch((0, $9HBOX.authOpenJoinModal)());
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: false,
                isSubscribed: false,
                isSubscribedAtPeriodEnd: false,
                isPublic: true,
                onFollowClick: openJoinModal,
                onUnfollowClick: openJoinModal,
                onCreateSubscriptionClick: openJoinModal,
                onRenewSubscriptionClick: openJoinModal,
                onCancelSubscriptionClick: openJoinModal
            },
            onNameClick: openJoinModal,
            onUsernameClick: openJoinModal
        })
    });
});
const $d975bf2e86bb3e47$export$71eb2018e0fdf5fe = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const publicArtists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectPublicArtists));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 60;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!publicArtists[index];
    const loadMoreItems = ()=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $lCHeK.userGetPublicArtists)());
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Popular Artists",
        overrideCss: (0, $3sxbD.contentLayout).home,
        itemWidth: itemWidth,
        itemsCount: defaultContentCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $d975bf2e86bb3e47$var$Row
                })
        })
    });
};
$d975bf2e86bb3e47$export$71eb2018e0fdf5fe.propTypes = {};

});

parcelRegister("7Bbxh", function(module, exports) {

$parcel$export(module.exports, "ArtistListFeedPopular", function () { return $aea0624ab5e92ae5$export$3fa881b2107d7311; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gZIjn = parcelRequire("gZIjn");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $l5cm3 = parcelRequire("l5cm3");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");
const $aea0624ab5e92ae5$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectPopularArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $aM7LJ.userUtilGetArtistCardSkeletonSections)("artist-list-feed-popular")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $aea0624ab5e92ae5$export$3fa881b2107d7311 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const popularArtists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectPopularArtists));
    const popularArtistsCount = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectPopularArtistsCount));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!popularArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $lCHeK.userGetPopularArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Artists",
        overrideCss: (0, $3sxbD.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: popularArtistsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: popularArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: popularArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $aea0624ab5e92ae5$var$Row
                })
        })
    });
};
$aea0624ab5e92ae5$export$3fa881b2107d7311.propTypes = {};

});

parcelRegister("4Uw8U", function(module, exports) {

$parcel$export(module.exports, "ArtistListFeedRecommended", function () { return $bf9658350dbd5b26$export$8533cb9112d3bbf8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $5dy7p = parcelRequire("5dy7p");

var $7VQuT = parcelRequire("7VQuT");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $gZIjn = parcelRequire("gZIjn");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $l5cm3 = parcelRequire("l5cm3");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("1TdPt");
var $2xDls = parcelRequire("2xDls");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("lWWT4");
var $3sxbD = parcelRequire("3sxbD");
const $bf9658350dbd5b26$var$Row = /*#__PURE__*/ (0, $bh6RR.memo)(({ index: index, style: style })=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const artists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectRecommendedArtists));
    const artist = artists[index];
    // if artist not fetched
    if (!artist) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "140px",
            sections: (0, $aM7LJ.userUtilGetArtistCardSkeletonSections)("artist-list-feed-recommended")
        })
    });
    const { id: profileUserId } = profile ?? {};
    const { id: artistUserId } = artist;
    const isCurrentUser = profileUserId === artistUserId;
    const navigateToArtistPage = ()=>navigate(`${(0, $b7fnN.Path).User}/${artistUserId}`);
    // if is current user
    if (isCurrentUser) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
    const isUserFollowed = userFollows[artistUserId || ""];
    const isCurrentUserSubscribedToUser = userSubscriptions[artistUserId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[artistUserId || ""];
    const onFollowClick = ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
            user: artist
        }));
    const onUnfollowClick = ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
            user: artist
        }));
    const onCreateSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCreateModal)({
            artist: artist
        }));
    const onRenewSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionRenewModal)({
            artist: artist
        }));
    const onCancelSubscriptionClick = ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCancelModal)({
            artist: artist
        }));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $gZIjn.ArtistCard), {
            artist: artist,
            artistActions: {
                isFollowed: isUserFollowed,
                isSubscribed: isCurrentUserSubscribedToUser,
                isSubscribedAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
                onFollowClick: onFollowClick,
                onUnfollowClick: onUnfollowClick,
                onCreateSubscriptionClick: onCreateSubscriptionClick,
                onRenewSubscriptionClick: onRenewSubscriptionClick,
                onCancelSubscriptionClick: onCancelSubscriptionClick
            },
            onNameClick: navigateToArtistPage,
            onUsernameClick: navigateToArtistPage
        })
    });
});
const $bf9658350dbd5b26$export$8533cb9112d3bbf8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const recommendedArtists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectRecommendedArtists));
    const recommendedArtistsCount = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectRecommendedArtistsCount));
    const artistBlockWidth = 140;
    const artistBlockMarginRight = 20;
    const itemWidth = artistBlockWidth + artistBlockMarginRight;
    const artistBlockHeight = 242;
    const artistBlockMarginBottom = 0;
    const itemHeight = artistBlockHeight + artistBlockMarginBottom;
    const defaultContentCount = 1000;
    const defaultListWidth = 2238;
    const itemsToFetch = 30; // min number of rows to be loaded at a time
    const itemThreshold = 15; // start fetching data when user scrolls within 15 rows
    const isItemLoaded = (index)=>!!recommendedArtists[index];
    const loadMoreItems = (startIndex)=>{
        // (startIndex: number, stopIndex: number): void
        dispatch((0, $lCHeK.userGetRecommendedArtists)({
            limit: itemsToFetch,
            offset: startIndex
        }));
    };
    return /*#__PURE__*/ (0, $9awXB.jsx)((0, $2xDls.ContentLayoutVirtualized), {
        title: "Artists",
        overrideCss: (0, $3sxbD.contentLayout).feed,
        itemWidth: itemWidth,
        itemsCount: recommendedArtistsCount,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $7VQuT.default), {
            isItemLoaded: isItemLoaded,
            loadMoreItems: loadMoreItems,
            itemCount: recommendedArtistsCount || defaultContentCount,
            minimumBatchSize: itemsToFetch,
            threshold: itemThreshold,
            children: ({ onItemsRendered: onItemsRendered, ref: ref })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $5dy7p.FixedSizeList), {
                    className: "virtualized-list",
                    height: itemHeight,
                    itemSize: itemWidth,
                    itemCount: recommendedArtistsCount || defaultContentCount,
                    onItemsRendered: onItemsRendered,
                    ref: ref,
                    width: defaultListWidth,
                    layout: "horizontal",
                    children: $bf9658350dbd5b26$var$Row
                })
        })
    });
};
$bf9658350dbd5b26$export$8533cb9112d3bbf8.propTypes = {};

});

parcelRegister("gzBMX", function(module, exports) {

$parcel$export(module.exports, "ArtistListOnboardingRecommended", function () { return $65a3c85ac1bc3812$export$7f2e2147f37d34b1; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
parcelRequire("i4dh1");
var $cfY57 = parcelRequire("cfY57");
var $cP8wi = parcelRequire("cP8wi");

var $9hfCS = parcelRequire("9hfCS");
const $65a3c85ac1bc3812$export$7f2e2147f37d34b1 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const recommendedArtists = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectRecommendedArtists));
    const recommendedArtistsLength = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectRecommendedArtistsLength));
    const userGetRecommendedArtistsLoading = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectUserGetRecommendedArtistsLoading));
    const { id: profileUserId } = profile ?? {};
    const defaultContentLength = 20;
    // [0, 1,..., 19]
    const skeletons = Array.from({
        length: defaultContentLength
    }, (_, i)=>i);
    (0, $bh6RR.useEffect)(()=>{
        // if recommended artists is not fetched
        if (recommendedArtistsLength === 0) // fetch artists
        dispatch((0, $lCHeK.userGetRecommendedArtists)({
            limit: 29,
            offset: 0
        }));
    }, [
        dispatch,
        recommendedArtistsLength
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $9hfCS.styles)().artists.main,
        children: userGetRecommendedArtistsLoading ? skeletons.map((n)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $cP8wi.ArtistSkeleton), {}, `onboarding-rec-artist-skeleton-${n}`)) : recommendedArtists.map((artist)=>{
            const { id: artistUserId } = artist;
            const isCurrentUser = profileUserId === artistUserId;
            const isUserFollowed = userFollows[artistUserId || ""];
            const followArtist = ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
                    user: artist
                }));
            const unfollowArtist = ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
                    user: artist
                }));
            const followUnfollowAction = isUserFollowed ? unfollowArtist : followArtist;
            // if is current user
            if (isCurrentUser) return /*#__PURE__*/ (0, $9awXB.jsx)((0, $cfY57.Artist), {
                artist: artist,
                followed: isUserFollowed
            }, `onboarding-rec-artist-${artistUserId}`);
            return /*#__PURE__*/ (0, $9awXB.jsx)((0, $cfY57.Artist), {
                artist: artist,
                followed: isUserFollowed,
                onClick: followUnfollowAction
            }, `onboarding-rec-artist-${artistUserId}`);
        })
    });
};
$65a3c85ac1bc3812$export$7f2e2147f37d34b1.propTypes = {};

});
parcelRegister("i4dh1", function(module, exports) {

$parcel$export(module.exports, "Artist", function () { return (parcelRequire("cfY57")).Artist; });
$parcel$export(module.exports, "ArtistSkeleton", function () { return (parcelRequire("cP8wi")).ArtistSkeleton; });

var $cfY57 = parcelRequire("cfY57");

var $cP8wi = parcelRequire("cP8wi");

});
parcelRegister("cfY57", function(module, exports) {

$parcel$export(module.exports, "Artist", function () { return $d80fb9f46c8b644f$export$1e2322822297ef53; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $jko3S = parcelRequire("jko3S");
const $d80fb9f46c8b644f$export$1e2322822297ef53 = ({ artist: artist, followed: followed, onClick: onClick })=>{
    const theme = (0, $iwq56.u)();
    const [avatarLoadError, setAvatarLoadError] = (0, $bh6RR.useState)(false);
    const { name: name, username: username, avatarId: avatarId } = artist;
    const artistHasAvatar = !!avatarId;
    const source = (0, $jpNoL.useFile)(avatarId || "");
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: [
            (0, $jko3S.styles)(theme).artist.main.shared,
            followed ? (0, $jko3S.styles)(theme).artist.main.followed : (0, $jko3S.styles)(theme).artist.main.unfollowed,
            "",
            ""
        ],
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jko3S.styles)(theme).artist.avatar.main,
                children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $jko3S.styles)(theme).artist.avatar.image,
                    onError: ()=>setAvatarLoadError(true),
                    loading: "lazy",
                    width: "70px",
                    height: "70px",
                    src: source,
                    alt: "artist avatar"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                    css: (0, $jko3S.styles)(theme).artist.avatar.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $jko3S.styles)(theme).artist.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $jko3S.styles)(theme).artist.content.data.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $jko3S.styles)(theme).artist.content.data.name,
                                children: name || ""
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsxs)("span", {
                                css: (0, $jko3S.styles)(theme).artist.content.data.username,
                                children: [
                                    "@",
                                    username || ""
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $jko3S.styles)(theme).artist.content.follow.main,
                        children: onClick ? /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: [
                                (0, $jko3S.styles)(theme).artist.content.follow.button.shared,
                                followed ? (0, $jko3S.styles)(theme).artist.content.follow.button.followed : (0, $jko3S.styles)(theme).artist.content.follow.button.unfollowed,
                                "",
                                ""
                            ],
                            onClick: (e)=>onClick(e),
                            type: "button",
                            "aria-label": "follow/unfollow artist",
                            children: followed ? "Unfollow" : "Follow"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)("button", {
                            css: [
                                (0, $jko3S.styles)(theme).artist.content.follow.button.shared,
                                (0, $jko3S.styles)(theme).artist.content.follow.button.disabled,
                                "",
                                ""
                            ],
                            onClick: ()=>{},
                            disabled: true,
                            type: "button",
                            "aria-label": "follow artist",
                            children: "Follow"
                        })
                    })
                ]
            })
        ]
    });
};
$d80fb9f46c8b644f$export$1e2322822297ef53.propTypes = {};

});
parcelRegister("jko3S", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9fe6833fa6c81df9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $9fe6833fa6c81df9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $9fe6833fa6c81df9$var$_ref = {
    name: "e72zmh",
    styles: "display:flex;flex-direction:column;justify-content:space-between;min-width:0"
};
var $9fe6833fa6c81df9$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $9fe6833fa6c81df9$export$9dd6ff9ea0189349 = (theme)=>({
        artist: {
            main: {
                shared: /*#__PURE__*/ (0, $7hler.css)("display:flex;border:1px solid transparent;border-radius:50px;padding:6px 20px 6px 6px;overflow:hidden;transition:border 0.2s;width:212px;", (0, $gln0L.mq).mobile($9fe6833fa6c81df9$var$_ref2), ";", ""),
                followed: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.accent.normal, ";", ""),
                unfollowed: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.darker, ";", "")
            },
            avatar: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;flex-shrink:0;width:70px;height:70px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:8px;", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.darker, ";}", "")
            },
            content: {
                main: $9fe6833fa6c81df9$var$_ref,
                data: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:center;min-width:0;font-size:", (0, $gln0L.typography).sp, ";", ""),
                    name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";line-height:120%;font-weight:bold;", ""),
                    username: /*#__PURE__*/ (0, $7hler.css)("line-height:120%;", (0, $gln0L.helpers).textOverflowEllipsis, ";", "")
                },
                follow: {
                    main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                    button: {
                        shared: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";font-family:", (0, $gln0L.fonts).primary, ";font-size:", (0, $gln0L.typography).sp, ";font-weight:bold;white-space:nowrap;border-radius:20px;border:1px solid transparent;padding:4px 20px;width:96px;transition:color 0.2s,background-color 0.2s,border 0.2s;", ""),
                        followed: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.accent.normal, ";background-color:", theme.colors.accent.normal, ";color:", theme.colors.primary.normal, ";cursor:pointer;", ""),
                        unfollowed: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.darker, ";color:", theme.colors.primary.normal, ";cursor:pointer;&:hover{background-color:", theme.colors.accent.normal, ";}", ""),
                        disabled: /*#__PURE__*/ (0, $7hler.css)("border:1px solid ", theme.colors.secondary.darker, ";background-color:", theme.colors.secondary.darker, ";color:", theme.colors.primary.normal, ";cursor:not-allowed;&:hover{background-color:", theme.colors.secondary.darker, ";}", "")
                    }
                }
            }
        }
    });

});


parcelRegister("cP8wi", function(module, exports) {

$parcel$export(module.exports, "ArtistSkeleton", function () { return $11b2e42aef722c9a$export$cb9abc247e4df2c4; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $jgb8e = parcelRequire("jgb8e");
const $11b2e42aef722c9a$export$cb9abc247e4df2c4 = ()=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $jgb8e.styles)(theme).skeleton.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $jgb8e.styles)(theme).skeleton.avatar
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $jgb8e.styles)(theme).skeleton.description.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $jgb8e.styles)(theme).skeleton.description.name
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $jgb8e.styles)(theme).skeleton.description.username
                    })
                ]
            })
        ]
    });
};
$11b2e42aef722c9a$export$cb9abc247e4df2c4.propTypes = {};

});
parcelRegister("jgb8e", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $bd3469dce5dac42b$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $bd3469dce5dac42b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $bd3469dce5dac42b$var$_ref = {
    name: "ayzun9",
    styles: "width:100%;height:70"
};
var $bd3469dce5dac42b$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
const $bd3469dce5dac42b$export$9dd6ff9ea0189349 = (theme)=>({
        skeleton: {
            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;width:212px;border:1px solid ", theme.colors.primary.darker, ";border-radius:50px;padding:6px 20px 6px 6px;overflow:hidden;background-color:", theme.colors.primary.normal, ";background-image:linear-gradient(\n        90deg,\n        #ffffff00,\n        ", theme.colors.secondary.darker, ",\n        #ffffff00\n      );background-size:60px 100%;background-repeat:no-repeat;background-position:left -60px top 0;animation:1.4s ease infinite ", (0, $gln0L.kf).load.shine(-60, 0), ";", (0, $gln0L.mq).mobile($bd3469dce5dac42b$var$_ref2), ";", ""),
            avatar: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;display:flex;width:70px;height:70px;opacity:0.4;border-radius:50%;margin-right:8px;background-color:", theme.colors.primary.darker, ";", ""),
            description: {
                main: $bd3469dce5dac42b$var$_ref,
                name: /*#__PURE__*/ (0, $7hler.css)("width:100%;height:28px;opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";margin-bottom:8px;", ""),
                username: /*#__PURE__*/ (0, $7hler.css)("width:100%;height:24px;opacity:0.4;border-radius:4px;background-color:", theme.colors.primary.darker, ";", "")
            }
        }
    });

});



parcelRegister("9hfCS", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $7077c1121dc03c83$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $7077c1121dc03c83$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7077c1121dc03c83$var$_ref = {
    name: "gt7mww",
    styles: "&>div{margin:0px 0px 16px 0px;}"
};
const $7077c1121dc03c83$export$9dd6ff9ea0189349 = ()=>({
        artists: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";display:flex;justify-content:center;flex-wrap:wrap;max-height:400px;overflow:hidden;width:100%;overflow:hidden;overflow-y:scroll;padding:40px 0px;&>div{margin:0px 8px 16px 8px;}", (0, $gln0L.mq).mobile($7077c1121dc03c83$var$_ref), ";", "")
        }
    });

});


parcelRegister("a7r6m", function(module, exports) {

$parcel$export(module.exports, "UserBlockModal", function () { return $733d4f8c86cbeb6b$export$d7c0beabdcbbe792; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $iw5tW = parcelRequire("iw5tW");
parcelRequire("1TdPt");
var $e1re8 = parcelRequire("e1re8");
parcelRequire("cfC0V");
var $6n1mj = parcelRequire("6n1mj");

var $7WWZo = parcelRequire("7WWZo");
const $733d4f8c86cbeb6b$export$d7c0beabdcbbe792 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const userBlockModalOpen = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectUserBlockModalOpen));
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $7WWZo.styles)().modal.main,
        children: userBlockModalOpen && /*#__PURE__*/ (0, $9awXB.jsx)((0, $e1re8.ModalLayout), {
            background: "opaque",
            onOutsideClick: ()=>dispatch((0, $iw5tW.userCloseUserBlockModal)()),
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $7WWZo.styles)().modal.content,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6n1mj.UserBlockCard), {})
            })
        })
    });
};
$733d4f8c86cbeb6b$export$d7c0beabdcbbe792.propTypes = {};

});
parcelRegister("cfC0V", function(module, exports) {

$parcel$export(module.exports, "UserBlockCard", function () { return (parcelRequire("6n1mj")).UserBlockCard; });

var $6n1mj = parcelRequire("6n1mj");

});
parcelRegister("6n1mj", function(module, exports) {

$parcel$export(module.exports, "UserBlockCard", function () { return $393ce34f4ecdc955$export$6934e1ca7c6ba5a4; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $iw5tW = parcelRequire("iw5tW");
parcelRequire("1TdPt");
var $1NE1d = parcelRequire("1NE1d");
var $ly71s = parcelRequire("ly71s");
var $57kXZ = parcelRequire("57kXZ");
var $6GhGJ = parcelRequire("6GhGJ");
parcelRequire("7dfgS");
var $evmc6 = parcelRequire("evmc6");

var $fzjcP = parcelRequire("fzjcP");
const $393ce34f4ecdc955$export$6934e1ca7c6ba5a4 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const userBlockError = "";
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $fzjcP.styles)(theme).card.main,
        onClick: (e)=>e.stopPropagation(),
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fzjcP.styles)(theme).card.header,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1NE1d.CardHeaderMobile), {
                    onCloseClick: ()=>dispatch((0, $iw5tW.userCloseUserBlockModal)())
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fzjcP.styles)(theme).card.title,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6GhGJ.ModalCardTitle), {
                    text: "Block User",
                    icon: (0, $bq9l8.icons).AlertTriangle
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $fzjcP.styles)(theme).card.subtitle,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $57kXZ.ModalCardSubtitle), {
                    text: "Are you sure you want to block this user?"
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $fzjcP.styles)(theme).card.content.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $fzjcP.styles)(theme).card.content.form,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $evmc6.UserBlockForm), {})
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $fzjcP.styles)(theme).card.content.error,
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                            error: userBlockError
                        })
                    })
                ]
            })
        ]
    });
};
$393ce34f4ecdc955$export$6934e1ca7c6ba5a4.propTypes = {};

});
parcelRegister("7dfgS", function(module, exports) {

$parcel$export(module.exports, "UserBlockForm", function () { return (parcelRequire("evmc6")).UserBlockForm; });

var $evmc6 = parcelRequire("evmc6");

});
parcelRegister("evmc6", function(module, exports) {

$parcel$export(module.exports, "UserBlockForm", function () { return $be1593a764831e80$export$4c860f6a8f42e2b6; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $f1KST = parcelRequire("f1KST");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
parcelRequire("1TdPt");
var $dB5kz = parcelRequire("dB5kz");
var $f6nZ0 = parcelRequire("f6nZ0");

var $d9tDc = parcelRequire("d9tDc");
const $be1593a764831e80$export$4c860f6a8f42e2b6 = ()=>{
    const navigate = (0, $99w1R.useNavigate)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const userBlockLoading = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectUserBlockLoading));
    const user = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectUserBlockModalUser));
    const { id: userId } = user ?? {};
    const submitDisabled = userBlockLoading;
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $d9tDc.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $d9tDc.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                dispatch((0, $lCHeK.userBlock)({
                    id: userId || ""
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $d9tDc.styles)().form.content.user,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f1KST.ArtistCardProduct), {
                        artist: user || {},
                        onNameClick: ()=>{
                            // navigate to user page
                            navigate(`${(0, $b7fnN.Path).User}/${userId}`);
                            // close modal
                            dispatch((0, $iw5tW.userCloseUserBlockModal)());
                        },
                        onUsernameClick: ()=>{
                            // navigate to user page
                            navigate(`${(0, $b7fnN.Path).User}/${userId}`);
                            // close modal
                            dispatch((0, $iw5tW.userCloseUserBlockModal)());
                        }
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $d9tDc.styles)().form.content.submit,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $dB5kz.ButtonLarge), {
                        type: "submit",
                        "aria-label": "block user",
                        disabled: submitDisabled,
                        appearance: "primary",
                        children: userBlockLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                            width: 50,
                            height: 20,
                            appearance: "primary"
                        }) : "Block"
                    })
                })
            ]
        })
    });
};
$be1593a764831e80$export$4c860f6a8f42e2b6.propTypes = {};

});
parcelRegister("d9tDc", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $b20da25c24be6b3c$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
function $b20da25c24be6b3c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $b20da25c24be6b3c$var$_ref = {
    name: "mdhs63",
    styles: "display:flex;justify-content:center;margin-bottom:24px;& div{text-align:center;}& button{text-align:center;}"
};
const $b20da25c24be6b3c$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                user: $b20da25c24be6b3c$var$_ref,
                submit: /*#__PURE__*/ (0, $7hler.css)("", "")
            }
        }
    });

});



parcelRegister("fzjcP", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $f6aa9f57d4f34945$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $f6aa9f57d4f34945$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $f6aa9f57d4f34945$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f6aa9f57d4f34945$var$_ref2 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $f6aa9f57d4f34945$var$_ref3 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $f6aa9f57d4f34945$var$_ref4 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $f6aa9f57d4f34945$var$_ref5 = {
    name: "1fgdcyd",
    styles: "margin-bottom:24px"
};
var $f6aa9f57d4f34945$var$_ref6 = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};
var $f6aa9f57d4f34945$var$_ref7 = {
    name: "1i6so7v",
    styles: "padding-top:0px"
};
var $f6aa9f57d4f34945$var$_ref8 = {
    name: "b0uwx7",
    styles: "align-items:normal;width:100%;height:100%;border-radius:0px;padding-top:0px"
};
const $f6aa9f57d4f34945$export$9dd6ff9ea0189349 = (theme)=>({
        card: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).hideScrollbar, ";", (0, $gln0L.helpers).app.padding.full, ";display:flex;flex-direction:column;align-items:center;width:740px;border-radius:10px;overflow:hidden;overflow-y:scroll;background-color:", theme.colors.primary.darker, ";animation:0.4s ease 0.2s backwards ", (0, $gln0L.kf).slideIn.up(50), ";", (0, $gln0L.mq).tablet($f6aa9f57d4f34945$var$_ref8), " ", (0, $gln0L.mq).mobile($f6aa9f57d4f34945$var$_ref7), ";", ""),
            header: /*#__PURE__*/ (0, $7hler.css)("display:none;", (0, $gln0L.mq).tablet($f6aa9f57d4f34945$var$_ref6), ";", ""),
            title: $f6aa9f57d4f34945$var$_ref5,
            subtitle: $f6aa9f57d4f34945$var$_ref4,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:380px;", (0, $gln0L.mq).tablet($f6aa9f57d4f34945$var$_ref3), ";", ""),
                form: $f6aa9f57d4f34945$var$_ref2,
                error: $f6aa9f57d4f34945$var$_ref
            }
        }
    });

});



parcelRegister("7WWZo", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $ca000fd419a66331$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $ca000fd419a66331$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $ca000fd419a66331$var$_ref = {
    name: "w1atjl",
    styles: "width:100%;height:100%"
};
const $ca000fd419a66331$export$9dd6ff9ea0189349 = ()=>({
        modal: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).tablet($ca000fd419a66331$var$_ref), ";", "")
        }
    });

});


parcelRegister("gX3Fy", function(module, exports) {

$parcel$export(module.exports, "UserViewProfile", function () { return $bf9602a90d53b904$export$e2cfce3dd0cbc93d; });

var $9awXB = parcelRequire("9awXB");
parcelRequire("jtzhv");
var $bJUG8 = parcelRequire("bJUG8");

var $kcr3m = parcelRequire("kcr3m");
const $bf9602a90d53b904$export$e2cfce3dd0cbc93d = ()=>/*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $kcr3m.styles)().view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $kcr3m.styles)().view.content.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $kcr3m.styles)().view.content.form,
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bJUG8.Form), {})
            })
        })
    });
$bf9602a90d53b904$export$e2cfce3dd0cbc93d.propTypes = {};

});
parcelRegister("jtzhv", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return (parcelRequire("bJUG8")).Form; });

var $bJUG8 = parcelRequire("bJUG8");

});
parcelRegister("bJUG8", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $17db867489cfc6df$export$a7fed597f4b8afd8; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("krTeD");
var $620EQ = parcelRequire("620EQ");
var $cGp48 = parcelRequire("cGp48");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $lCHeK = parcelRequire("lCHeK");
var $iw5tW = parcelRequire("iw5tW");
parcelRequire("1O2TI");
var $lRNbG = parcelRequire("lRNbG");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1TdPt");
var $7y6mB = parcelRequire("7y6mB");
var $9HR7l = parcelRequire("9HR7l");
var $iGKn1 = parcelRequire("iGKn1");
var $ly71s = parcelRequire("ly71s");
var $13cuy = parcelRequire("13cuy");
var $6F2CE = parcelRequire("6F2CE");
var $f6nZ0 = parcelRequire("f6nZ0");
parcelRequire("hZFVr");
var $es2QF = parcelRequire("es2QF");

var $gc5uI = parcelRequire("gc5uI");
const $17db867489cfc6df$export$a7fed597f4b8afd8 = ()=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userProfileUpdateLoading = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectUserProfileUpdateLoading));
    // avatar state
    const userHasAvatar = !!profile?.avatarId;
    const profileAvatar = (0, $jpNoL.useFile)(profile?.avatarId || "");
    const [avatar, setAvatar] = (0, $bh6RR.useState)(null);
    const [avatarPreview, setAvatarPreview] = (0, $bh6RR.useState)(userHasAvatar ? profileAvatar : "");
    const fileInputRef = (0, $bh6RR.useRef)(null);
    const [avatarError, setAvatarError] = (0, $bh6RR.useState)("");
    // name state
    const [name, setName] = (0, $bh6RR.useState)(profile?.name || "");
    const [nameError, setNameError] = (0, $bh6RR.useState)("");
    // username state
    const [username] = (0, $bh6RR.useState)(profile?.username || "");
    // genres state
    const [preferredGenres, setPreferredGenres] = (0, $bh6RR.useState)(profile?.preferredGenres || []);
    const [musicGenres, setMusicGenres] = (0, $bh6RR.useState)((0, $cGp48.musicGenres));
    // genres search state
    const [search, setSearch] = (0, $bh6RR.useState)("");
    const nameUnchanged = name === profile?.name;
    const genresUnchanged = preferredGenres.join("") === profile?.preferredGenres?.join("");
    const avatarNotSelected = avatar === null;
    const submitDisabled = name.length < (0, $620EQ.minUserNameLength) || nameUnchanged && genresUnchanged && avatarNotSelected || nameError !== "" || avatarError !== "" || userProfileUpdateLoading;
    // TODO: add invite friend logic
    const inviteDisabled = true;
    const revokePreviewURL = (url)=>{
        URL.revokeObjectURL(url);
    };
    const onEditClick = ()=>{
        fileInputRef.current?.click();
        setAvatarError("");
    };
    const onFileChange = (e)=>{
        const { files: files } = e.target;
        // if file selected
        if (files && files.length > 0) {
            const file = files[0];
            // validate file
            const error = (0, $lRNbG.validateAvatarFile)(file);
            if (error) {
                setAvatarError(error);
                return;
            }
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
            // set file as a preview
            setAvatarPreview(URL.createObjectURL(file));
            // store file in state
            setAvatar(file);
        }
    };
    (0, $bh6RR.useEffect)(()=>()=>{
            // if avatar preview was set
            if (avatarPreview) // clean up to avoid memory leaks
            revokePreviewURL(avatarPreview);
        });
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $gc5uI.styles)().form.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("form", {
            css: (0, $gc5uI.styles)().form.content.main,
            onSubmit: (e)=>{
                e.preventDefault();
                setAvatar(null);
                dispatch((0, $lCHeK.userProfileUpdate)({
                    avatar: avatar,
                    name: name,
                    preferredGenres: preferredGenres
                }));
            },
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $gc5uI.styles)().form.content.avatar.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("label", {
                            css: (0, $gc5uI.styles)().form.content.avatar.label,
                            htmlFor: "avatar",
                            children: [
                                "avatar",
                                /*#__PURE__*/ (0, $9awXB.jsx)("input", {
                                    name: "avatar",
                                    type: "file",
                                    id: "avatar",
                                    ref: fileInputRef,
                                    accept: "image/jpeg,image/webp,image/png",
                                    onChange: (e)=>onFileChange(e)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $gc5uI.styles)().form.content.avatar.image,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $es2QF.Avatar), {
                                onEditClick: ()=>onEditClick(),
                                source: avatarPreview
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $gc5uI.styles)().form.content.avatar.error,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $ly71s.Error), {
                                error: avatarError
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $gc5uI.styles)().form.content.name,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6F2CE.InputLine), {
                        name: "name",
                        label: "Name",
                        type: "text",
                        placeholder: "Enter your name",
                        icon: (0, $bq9l8.icons).Edit,
                        value: name,
                        error: nameError.length > 0,
                        errorMessage: nameError,
                        min: (0, $620EQ.minUserNameLength),
                        max: (0, $620EQ.maxUserNameLength),
                        onChange: (e)=>{
                            setName(e.target.value);
                        },
                        onBlur: ()=>setNameError((0, $lRNbG.validateName)(name)),
                        onFocus: ()=>setNameError("")
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                    css: (0, $gc5uI.styles)().form.content.username,
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6F2CE.InputLine), {
                        name: "username",
                        label: "Username",
                        type: "text",
                        placeholder: "Enter your username",
                        icon: (0, $bq9l8.icons).Edit,
                        value: `@${username}`,
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $gc5uI.styles)().form.content.genres.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $gc5uI.styles)().form.content.genres.selected.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $gc5uI.styles)().form.content.genres.selected.label,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $13cuy.InputLabel), {
                                        text: "Preferred genres"
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $gc5uI.styles)().form.content.genres.selected.genres,
                                    children: preferredGenres.map((preferredGenre)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $9HR7l.BadgeSelected), {
                                            name: preferredGenre,
                                            onRemoveClick: ()=>setPreferredGenres((state)=>state.filter((genre)=>genre !== preferredGenre))
                                        }, `profile-user-genres-${preferredGenre}`))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $gc5uI.styles)().form.content.genres.search.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $gc5uI.styles)().form.content.genres.search.input,
                                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6F2CE.InputLine), {
                                        name: "search",
                                        label: "Select genre",
                                        type: "search",
                                        placeholder: "Find genre",
                                        icon: (0, $bq9l8.icons).Search,
                                        value: search,
                                        onChange: (e)=>{
                                            setSearch(e.target.value);
                                            setMusicGenres((0, $cGp48.musicGenres).filter((genre)=>genre.toLowerCase().includes(e.target.value)));
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $gc5uI.styles)().form.content.genres.search.genres,
                                    children: musicGenres.map((genre)=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $7y6mB.Badge), {
                                            name: genre,
                                            disabled: preferredGenres.includes(genre) || preferredGenres.length >= (0, $cGp48.maxUserPreferredGenresCount),
                                            onClick: ()=>setPreferredGenres((state)=>[
                                                        ...state,
                                                        genre
                                                    ])
                                        }, `profile-genres-${genre}`))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $gc5uI.styles)().form.content.buttons.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $gc5uI.styles)().form.content.buttons.submit,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "submit",
                                "aria-label": "update profile data",
                                disabled: submitDisabled,
                                appearance: "primary",
                                children: userProfileUpdateLoading ? /*#__PURE__*/ (0, $9awXB.jsx)((0, $f6nZ0.Loader), {
                                    width: 56,
                                    height: 20,
                                    appearance: "secondary"
                                }) : "Update"
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $gc5uI.styles)().form.content.buttons.share,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "invite friend",
                                disabled: inviteDisabled,
                                appearance: "secondary",
                                children: "Invite friends to RYDDM"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$17db867489cfc6df$export$a7fed597f4b8afd8.propTypes = {};

});
parcelRegister("hZFVr", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return (parcelRequire("es2QF")).Avatar; });

var $es2QF = parcelRequire("es2QF");

});
parcelRegister("es2QF", function(module, exports) {

$parcel$export(module.exports, "Avatar", function () { return $794e7899a1514c4e$export$e2255cf6045e8d47; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $5L31F = parcelRequire("5L31F");
const $794e7899a1514c4e$export$e2255cf6045e8d47 = ({ source: source, onEditClick: onEditClick })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $5L31F.styles)(theme).avatar.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $5L31F.styles)(theme).avatar.content.main,
                children: source ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                    css: (0, $5L31F.styles)(theme).avatar.content.image,
                    loading: "lazy",
                    width: "100px",
                    height: "100px",
                    src: source,
                    alt: "user avatar"
                }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                    css: (0, $5L31F.styles)(theme).avatar.content.icon
                })
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $5L31F.styles)(theme).avatar.edit.main,
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("button", {
                    css: (0, $5L31F.styles)(theme).avatar.edit.button,
                    onClick: (e)=>onEditClick(e),
                    type: "button",
                    "aria-label": "change user avatar",
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                            css: (0, $5L31F.styles)(theme).avatar.edit.text,
                            children: "Edit avatar"
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("span", {
                            css: (0, $5L31F.styles)(theme).avatar.edit.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Edit, {})
                        })
                    ]
                })
            })
        ]
    });
};
$794e7899a1514c4e$export$e2255cf6045e8d47.propTypes = {};

});
parcelRegister("5L31F", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $a592441f08af040e$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $a592441f08af040e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $a592441f08af040e$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $a592441f08af040e$var$_ref2 = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $a592441f08af040e$export$9dd6ff9ea0189349 = (theme)=>({
        avatar: {
            main: $a592441f08af040e$var$_ref2,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;width:100px;height:100px;background-color:", theme.colors.secondary.darker, ";border-radius:50%;overflow:hidden;margin-bottom:8px;", ""),
                image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
            },
            edit: {
                main: $a592441f08af040e$var$_ref,
                button: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).resetDefaults, ";display:flex;justify-content:center;width:100%;height:100%;cursor:pointer;&:hover span:nth-of-type(1){color:", theme.colors.accent.normal, ";}", ""),
                text: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";color:", theme.colors.secondary.dark, ";transition:color 0.2s;margin-right:8px;", ""),
                icon: /*#__PURE__*/ (0, $7hler.css)("&>svg{width:14px;height:14px;&>path{fill:", theme.colors.accent.normal, ";}}", "")
            }
        }
    });

});



parcelRegister("gc5uI", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4d8dfe59361213bd$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4d8dfe59361213bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4d8dfe59361213bd$var$_ref = {
    name: "jzjf1i",
    styles: "margin-right:0px;margin-bottom:20px;&>button{width:100%;}"
};
var $4d8dfe59361213bd$var$_ref2 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
var $4d8dfe59361213bd$var$_ref3 = {
    name: "c1gao8",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:10px;}&>div:not(:last-of-type){margin-right:16px;}"
};
var $4d8dfe59361213bd$var$_ref4 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $4d8dfe59361213bd$var$_ref5 = {
    name: "1omvlk4",
    styles: "display:flex;flex-wrap:wrap;&>div{margin-bottom:20px;}&>div:not(:last-of-type){margin-right:20px;}"
};
var $4d8dfe59361213bd$var$_ref6 = {
    name: "pr10xp",
    styles: "margin-bottom:10px"
};
var $4d8dfe59361213bd$var$_ref7 = {
    name: "g46w8s",
    styles: "margin-bottom:30px"
};
var $4d8dfe59361213bd$var$_ref8 = {
    name: "qkomnt",
    styles: "margin-bottom:40px"
};
var $4d8dfe59361213bd$var$_ref9 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
var $4d8dfe59361213bd$var$_ref10 = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $4d8dfe59361213bd$var$_ref11 = {
    name: "tu77jx",
    styles: "width:100px;margin-bottom:22px"
};
var $4d8dfe59361213bd$var$_ref12 = {
    name: "eivff4",
    styles: "display:none"
};
var $4d8dfe59361213bd$var$_ref13 = {
    name: "tosu4r",
    styles: "align-items:center;justify-content:center"
};
const $4d8dfe59361213bd$export$9dd6ff9ea0189349 = ()=>({
        form: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                avatar: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;margin-bottom:28px;", (0, $gln0L.mq).tablet($4d8dfe59361213bd$var$_ref13), ";", ""),
                    label: $4d8dfe59361213bd$var$_ref12,
                    image: $4d8dfe59361213bd$var$_ref11,
                    error: /*#__PURE__*/ (0, $7hler.css)("", "")
                },
                name: $4d8dfe59361213bd$var$_ref10,
                username: $4d8dfe59361213bd$var$_ref9,
                genres: {
                    main: $4d8dfe59361213bd$var$_ref8,
                    selected: {
                        main: $4d8dfe59361213bd$var$_ref7,
                        label: $4d8dfe59361213bd$var$_ref6,
                        genres: $4d8dfe59361213bd$var$_ref5
                    },
                    search: {
                        main: /*#__PURE__*/ (0, $7hler.css)("", ""),
                        input: $4d8dfe59361213bd$var$_ref4,
                        genres: $4d8dfe59361213bd$var$_ref3
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;", (0, $gln0L.mq).tablet($4d8dfe59361213bd$var$_ref2), ";", ""),
                    submit: /*#__PURE__*/ (0, $7hler.css)("margin-right:20px;&>button{width:130px;}", (0, $gln0L.mq).tablet($4d8dfe59361213bd$var$_ref), ";", ""),
                    share: /*#__PURE__*/ (0, $7hler.css)("", "")
                }
            }
        }
    });

});



parcelRegister("kcr3m", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $8286e6a2ff48bdeb$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $8286e6a2ff48bdeb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8286e6a2ff48bdeb$var$_ref = {
    name: "1s22u92",
    styles: "margin-bottom:32px"
};
var $8286e6a2ff48bdeb$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $8286e6a2ff48bdeb$var$_ref3 = {
    name: "15u9bv0",
    styles: "margin-bottom:50px"
};
const $8286e6a2ff48bdeb$export$9dd6ff9ea0189349 = ()=>({
        view: {
            main: $8286e6a2ff48bdeb$var$_ref3,
            content: {
                main: /*#__PURE__*/ (0, $7hler.css)("width:400px;", (0, $gln0L.mq).tablet($8286e6a2ff48bdeb$var$_ref2), ";", ""),
                form: $8286e6a2ff48bdeb$var$_ref
            }
        }
    });

});


parcelRegister("7b2vs", function(module, exports) {

$parcel$export(module.exports, "UserViewStudio", function () { return $ac5df7edc12fe02d$export$595db161984b810a; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("10WBQ");
var $99w1R = parcelRequire("99w1R");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
var $jpNoL = parcelRequire("jpNoL");
var $lXxtV = parcelRequire("lXxtV");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");
parcelRequire("1O2TI");
var $1Fj5G = parcelRequire("1Fj5G");
parcelRequire("9gV8Y");
var $1Z4ZO = parcelRequire("1Z4ZO");

var $8YoRh = parcelRequire("8YoRh");
const $ac5df7edc12fe02d$export$595db161984b810a = ()=>{
    const theme = (0, $iwq56.u)();
    const navigate = (0, $99w1R.useNavigate)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const [avatarLoadError, setAvatarLoadError] = (0, $bh6RR.useState)(false);
    const { id: userId, name: name, username: username, avatarId: avatarId, followersCount: followersCount, subscribersCount: subscribersCount } = profile ?? {};
    // user stats
    const { postsCount: postsCount, tracksCount: tracksCount, isLoading: isUserStatsLoading } = (0, $lXxtV.useUserStats)(userId || "");
    const userStatsLoadingPlaceholder = "Loading...";
    const artistHasAvatar = !!avatarId;
    const source = (0, $jpNoL.useFile)(avatarId || "");
    const createPostDisabled = false;
    const uploadTrackDisabled = false;
    const stats = [
        {
            id: "studio-user-posts-stat",
            name: "Posts",
            count: (0, $1Fj5G.numbersFormatter)(postsCount || 0)
        },
        {
            id: "studio-user-tracks-stat",
            name: "Tracks",
            count: (0, $1Fj5G.numbersFormatter)(tracksCount || 0)
        },
        {
            id: "studio-user-followers-stat",
            name: "Followers",
            count: (0, $1Fj5G.numbersFormatter)(followersCount || 0)
        },
        {
            id: "studio-user-subscribers-stat",
            name: "Subscribers",
            count: (0, $1Fj5G.numbersFormatter)(subscribersCount || 0)
        }
    ];
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $8YoRh.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $8YoRh.styles)(theme).view.user.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8YoRh.styles)(theme).view.user.profile.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8YoRh.styles)(theme).view.user.profile.avatar.main,
                            children: artistHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                                css: (0, $8YoRh.styles)(theme).view.user.profile.avatar.image,
                                onError: ()=>setAvatarLoadError(true),
                                loading: "lazy",
                                width: "100px",
                                height: "100px",
                                src: source,
                                alt: "artist avatar"
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                                css: (0, $8YoRh.styles)(theme).view.user.profile.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $8YoRh.styles)(theme).view.user.profile.content.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $8YoRh.styles)(theme).view.user.profile.content.data.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $8YoRh.styles)(theme).view.user.profile.content.data.name,
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                            css: (0, $8YoRh.styles)(theme).view.user.profile.content.data.username,
                                            children: [
                                                "@",
                                                username
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $8YoRh.styles)(theme).view.user.profile.content.stats,
                                    children: isUserStatsLoading ? userStatsLoadingPlaceholder : stats.map(({ id: id, name: statName, count: count })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $1Z4ZO.Stat), {
                                            name: statName,
                                            count: count
                                        }, id))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $8YoRh.styles)(theme).view.user.buttons.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8YoRh.styles)(theme).view.user.buttons.create.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "create post",
                                disabled: createPostDisabled,
                                appearance: "secondary",
                                onClick: ()=>navigate(`${(0, $b7fnN.Path).Studio}${(0, $b7fnN.Path).Post}`),
                                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $8YoRh.styles)(theme).view.user.buttons.create.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $8YoRh.styles)(theme).view.user.buttons.create.content.icon,
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlusCircle, {})
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $8YoRh.styles)(theme).view.user.buttons.create.content.text,
                                            children: "Create Post"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $8YoRh.styles)(theme).view.user.buttons.upload.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "upload track",
                                disabled: uploadTrackDisabled,
                                appearance: "secondary",
                                onClick: ()=>navigate(`${(0, $b7fnN.Path).Studio}${(0, $b7fnN.Path).Track}`),
                                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $8YoRh.styles)(theme).view.user.buttons.upload.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $8YoRh.styles)(theme).view.user.buttons.upload.content.icon,
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlusCircle, {})
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $8YoRh.styles)(theme).view.user.buttons.upload.content.text,
                                            children: "Upload Track"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$ac5df7edc12fe02d$export$595db161984b810a.propTypes = {};

});
parcelRegister("9gV8Y", function(module, exports) {

$parcel$export(module.exports, "Stat", function () { return (parcelRequire("1Z4ZO")).Stat; });

var $1Z4ZO = parcelRequire("1Z4ZO");

});
parcelRegister("1Z4ZO", function(module, exports) {

$parcel$export(module.exports, "Stat", function () { return $bc95dcd9078b3bb6$export$cbbc350c1dfc80cb; });

var $9awXB = parcelRequire("9awXB");

var $iwq56 = parcelRequire("iwq56");

var $hxCze = parcelRequire("hxCze");
const $bc95dcd9078b3bb6$export$cbbc350c1dfc80cb = ({ name: name, count: count })=>{
    const theme = (0, $iwq56.u)();
    return /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
        css: (0, $hxCze.styles)(theme).stat.main,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $hxCze.styles)(theme).stat.count,
                children: count
            }),
            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                css: (0, $hxCze.styles)(theme).stat.name,
                children: name
            })
        ]
    });
};
$bc95dcd9078b3bb6$export$cbbc350c1dfc80cb.propTypes = {};

});
parcelRegister("hxCze", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $9637952bce98bb58$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $9637952bce98bb58$export$9dd6ff9ea0189349 = (theme)=>({
        stat: {
            main: /*#__PURE__*/ (0, $7hler.css)("", ""),
            count: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;color:", theme.colors.secondary.normal, ";", ""),
            name: /*#__PURE__*/ (0, $7hler.css)("font-size:", (0, $gln0L.typography).sp, ";", "")
        }
    });

});



parcelRegister("8YoRh", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $4b503a7809b186a9$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $4b503a7809b186a9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $4b503a7809b186a9$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $4b503a7809b186a9$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4b503a7809b186a9$var$_ref3 = {
    name: "1t29t6p",
    styles: "width:50%"
};
var $4b503a7809b186a9$var$_ref4 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $4b503a7809b186a9$var$_ref5 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $4b503a7809b186a9$var$_ref6 = {
    name: "1t29t6p",
    styles: "width:50%"
};
var $4b503a7809b186a9$var$_ref7 = {
    name: "126eje2",
    styles: "flex-direction:column;flex-wrap:nowrap;&>div:nth-of-type(1){margin-right:0px;margin-bottom:12px;}"
};
var $4b503a7809b186a9$var$_ref8 = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
var $4b503a7809b186a9$var$_ref9 = {
    name: "f7ay7b",
    styles: "justify-content:center"
};
var $4b503a7809b186a9$var$_ref10 = {
    name: "1ym5mfs",
    styles: "text-align:center;margin-bottom:10px"
};
var $4b503a7809b186a9$var$_ref11 = {
    name: "e72zmh",
    styles: "display:flex;flex-direction:column;justify-content:space-between;min-width:0"
};
var $4b503a7809b186a9$var$_ref12 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $4b503a7809b186a9$var$_ref13 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $4b503a7809b186a9$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.sides, ";margin-bottom:50px;", ""),
            user: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";", ""),
                profile: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-bottom:24px;", (0, $gln0L.mq).mobile($4b503a7809b186a9$var$_ref13), ";", ""),
                    avatar: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;align-self:center;flex-shrink:0;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:16px;", (0, $gln0L.mq).mobile($4b503a7809b186a9$var$_ref12), ";", ""),
                        image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $7hler.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    content: {
                        main: $4b503a7809b186a9$var$_ref11,
                        data: {
                            main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;min-width:0;", (0, $gln0L.mq).mobile($4b503a7809b186a9$var$_ref10), ";", ""),
                            name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;", ""),
                            username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";", "")
                        },
                        stats: /*#__PURE__*/ (0, $7hler.css)("display:flex;text-align:center;&>div:not(:last-of-type){margin-right:16px;}", (0, $gln0L.mq).mobile($4b503a7809b186a9$var$_ref9), ";", "")
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-wrap:wrap;&>div:nth-of-type(1){margin-right:20px;margin-bottom:12px;}", (0, $gln0L.mq).tablet($4b503a7809b186a9$var$_ref8), " ", (0, $gln0L.mq).mobile($4b503a7809b186a9$var$_ref7), ";", ""),
                    create: {
                        main: /*#__PURE__*/ (0, $7hler.css)("width:206px;", (0, $gln0L.mq).tablet($4b503a7809b186a9$var$_ref6), " ", (0, $gln0L.mq).mobile($4b503a7809b186a9$var$_ref5), ";", ""),
                        content: {
                            main: $4b503a7809b186a9$var$_ref4,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    upload: {
                        main: /*#__PURE__*/ (0, $7hler.css)("width:206px;", (0, $gln0L.mq).tablet($4b503a7809b186a9$var$_ref3), " ", (0, $gln0L.mq).mobile($4b503a7809b186a9$var$_ref2), ";", ""),
                        content: {
                            main: $4b503a7809b186a9$var$_ref,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    }
                }
            }
        }
    });

});


parcelRegister("1TrNX", function(module, exports) {

$parcel$export(module.exports, "UserViewUser", function () { return $38f2f44d275fbce4$export$419e08052d39e013; });

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $iwq56 = parcelRequire("iwq56");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
var $gNvvs = parcelRequire("gNvvs");
var $iLKNg = parcelRequire("iLKNg");
var $jpNoL = parcelRequire("jpNoL");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");
var $4cq7L = parcelRequire("4cq7L");
var $7oPCi = parcelRequire("7oPCi");
var $10e6J = parcelRequire("10e6J");
var $l5cm3 = parcelRequire("l5cm3");
var $a0GHC = parcelRequire("a0GHC");
var $iw5tW = parcelRequire("iw5tW");
var $aM7LJ = parcelRequire("aM7LJ");
parcelRequire("1TdPt");
var $iGKn1 = parcelRequire("iGKn1");
var $4sGtG = parcelRequire("4sGtG");
var $r5GD9 = parcelRequire("r5GD9");
parcelRequire("j8bpm");
var $bq9l8 = parcelRequire("bq9l8");

var $fqWgX = parcelRequire("fqWgX");
const $38f2f44d275fbce4$export$419e08052d39e013 = ()=>{
    const theme = (0, $iwq56.u)();
    const dispatch = (0, $2bja3.useAppDispatch)();
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const userFollows = (0, $gNvvs.useAppSelector)((0, $7oPCi.likeSelectUserFollows));
    const userSubscriptions = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptions));
    const userSubscriptionsAtPeriodEnd = (0, $gNvvs.useAppSelector)((0, $l5cm3.subscriptionSelectUserSubscriptionsAtPeriodEnd));
    const user = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectUser));
    const userFetched = (0, $gNvvs.useAppSelector)((0, $iw5tW.userSelectUserFetched));
    const { id: profileUserId, role: profileUserRole } = profile ?? {};
    const { id: userId, name: name, username: username, avatarId: avatarId, preferredGenres: preferredGenres, role: role } = user ?? {};
    const userHasAvatar = !!avatarId;
    const source = (0, $jpNoL.useFile)(avatarId || "");
    const [avatarLoadError, setAvatarLoadError] = (0, $bh6RR.useState)(false);
    // connect ready
    const { ready: isUserCanReceivePayments } = (0, $iLKNg.useConnectReady)(userId || "");
    const followDisabled = false;
    const unfollowDisabled = false;
    const subscribeDisabled = false;
    const unsubscribeDisabled = false;
    const tipDisabled = false;
    const blockDisabled = false;
    const reportDisabled = false;
    const isUserArtist = role === (0, $2gpGl.EntityUserRole).Artist;
    const isCurrentUserAdmin = profileUserRole === (0, $2gpGl.EntityUserRole).Admin;
    const isUserFollowed = userFollows[userId || ""];
    const isCurrentUserProfile = profileUserId === userId;
    const isCurrentUserSubscribedToUser = userSubscriptions[userId || ""];
    const isCurrentUserSubscribedToUserAtPeriodEnd = userSubscriptionsAtPeriodEnd[userId || ""];
    // if user not found
    if (userFetched && !user) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fqWgX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $4sGtG.ContentPlaceholder), {
            icon: (0, $bq9l8.icons).AlertTriangle,
            height: "180px",
            title: "Could not find user"
        })
    });
    const renderArtistActionsInput = {
        isCurrentUserFollowingArtist: isUserFollowed,
        isCurrentUserSubscribedToArtist: isCurrentUserSubscribedToUser,
        isCurrentUserSubscribedToArtistAtPeriodEnd: isCurrentUserSubscribedToUserAtPeriodEnd,
        isArtistCanReceivePayments: !!isUserCanReceivePayments,
        createUserFollowNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fqWgX.styles)(theme).view.user.buttons.follow.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "follow artist",
                disabled: followDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $4cq7L.likeCreateUserFollow)({
                        user: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fqWgX.styles)(theme).view.user.buttons.follow.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.follow.content.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).PlusCircle, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.follow.content.text,
                            children: "Follow"
                        })
                    ]
                })
            })
        }),
        deleteUserFollowNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fqWgX.styles)(theme).view.user.buttons.unfollow.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "unfollow artist",
                disabled: unfollowDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $4cq7L.likeDeleteUserFollow)({
                        user: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fqWgX.styles)(theme).view.user.buttons.unfollow.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.unfollow.content.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).CrossCircle, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.unfollow.content.text,
                            children: "Unfollow"
                        })
                    ]
                })
            })
        }),
        createSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe to artist",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCreateModal)({
                        artist: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.text,
                            children: "Subscribe"
                        })
                    ]
                })
            })
        }),
        renewSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "subscribe to artist",
                disabled: subscribeDisabled,
                appearance: "primary",
                onClick: ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionRenewModal)({
                        artist: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.text,
                            children: "Subscribe"
                        })
                    ]
                })
            })
        }),
        cancelSubscriptionNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.main,
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                type: "button",
                "aria-label": "unsubscribe from artist",
                disabled: unsubscribeDisabled,
                appearance: "secondary",
                onClick: ()=>dispatch((0, $l5cm3.subscriptionOpenSubscriptionCancelModal)({
                        artist: {
                            ...user
                        }
                    })),
                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.icon,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).Lock, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.subscribe.content.text,
                            children: "Unsubscribe"
                        })
                    ]
                })
            })
        }),
        defaultNode: /*#__PURE__*/ (0, $9awXB.jsx)("div", {})
    };
    // if user found and user is artist
    if (userFetched && user && isUserArtist) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fqWgX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
            css: (0, $fqWgX.styles)(theme).view.user.main,
            children: [
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fqWgX.styles)(theme).view.user.profile.main,
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.profile.avatar.main,
                            children: userHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                                css: (0, $fqWgX.styles)(theme).view.user.profile.avatar.image,
                                onError: ()=>setAvatarLoadError(true),
                                loading: "lazy",
                                width: "100px",
                                height: "100px",
                                src: source,
                                alt: "user avatar"
                            }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                                css: (0, $fqWgX.styles)(theme).view.user.profile.avatar.icon
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.profile.content.main,
                            children: [
                                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $fqWgX.styles)(theme).view.user.profile.content.data.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.profile.content.data.name,
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.profile.content.data.username,
                                            children: [
                                                "@",
                                                username
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                    css: (0, $fqWgX.styles)(theme).view.user.profile.content.genres,
                                    children: preferredGenres?.map((genre, i)=>preferredGenres.length - 1 === i ? `${genre}` : `${genre}, `)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                    css: (0, $fqWgX.styles)(theme).view.user.buttons.main,
                    children: [
                        !isCurrentUserProfile && (0, $aM7LJ.userUtilRenderArtistActions)(renderArtistActionsInput),
                        !isCurrentUserProfile && isUserCanReceivePayments && /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.tip.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "send tip to artist",
                                disabled: tipDisabled,
                                appearance: "primary",
                                onClick: ()=>dispatch((0, $a0GHC.tipOpenTipModal)({
                                        artist: user
                                    })),
                                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $fqWgX.styles)(theme).view.user.buttons.tip.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.buttons.tip.content.icon,
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).DollarCircle, {})
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.buttons.tip.content.text,
                                            children: "Tip"
                                        })
                                    ]
                                })
                            })
                        }),
                        !isCurrentUserProfile && (isCurrentUserAdmin ? /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.block.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "block user",
                                disabled: blockDisabled,
                                appearance: "secondary",
                                onClick: ()=>dispatch((0, $iw5tW.userOpenUserBlockModal)({
                                        user: user
                                    })),
                                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $fqWgX.styles)(theme).view.user.buttons.block.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.buttons.block.content.icon,
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).AlertTriangle, {})
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.buttons.block.content.text,
                                            children: "Block"
                                        })
                                    ]
                                })
                            })
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                            css: (0, $fqWgX.styles)(theme).view.user.buttons.report.main,
                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $iGKn1.ButtonMedium), {
                                type: "button",
                                "aria-label": "report user",
                                disabled: reportDisabled,
                                appearance: "secondary",
                                onClick: ()=>dispatch((0, $10e6J.reportOpenReportUserModal)({
                                        user: user
                                    })),
                                children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                    css: (0, $fqWgX.styles)(theme).view.user.buttons.report.content.main,
                                    children: [
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.buttons.report.content.icon,
                                            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).AlertTriangle, {})
                                        }),
                                        /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                            css: (0, $fqWgX.styles)(theme).view.user.buttons.report.content.text,
                                            children: "Report"
                                        })
                                    ]
                                })
                            })
                        }))
                    ]
                })
            ]
        })
    });
    // if user found but user is not artist
    if (userFetched && user) return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fqWgX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)("div", {
            css: (0, $fqWgX.styles)(theme).view.user.main,
            children: /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                css: (0, $fqWgX.styles)(theme).view.user.profile.main,
                children: [
                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                        css: (0, $fqWgX.styles)(theme).view.user.profile.avatar.main,
                        children: userHasAvatar && !avatarLoadError ? /*#__PURE__*/ (0, $9awXB.jsx)("img", {
                            css: (0, $fqWgX.styles)(theme).view.user.profile.avatar.image,
                            onError: ()=>setAvatarLoadError(true),
                            loading: "lazy",
                            width: "100px",
                            height: "100px",
                            src: source,
                            alt: "user avatar"
                        }) : /*#__PURE__*/ (0, $9awXB.jsx)((0, $bq9l8.icons).User, {
                            css: (0, $fqWgX.styles)(theme).view.user.profile.avatar.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                        css: (0, $fqWgX.styles)(theme).view.user.profile.content.main,
                        children: [
                            /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                css: (0, $fqWgX.styles)(theme).view.user.profile.content.data.main,
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                        css: (0, $fqWgX.styles)(theme).view.user.profile.content.data.name,
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsxs)("div", {
                                        css: (0, $fqWgX.styles)(theme).view.user.profile.content.data.username,
                                        children: [
                                            "@",
                                            username
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9awXB.jsx)("div", {
                                css: (0, $fqWgX.styles)(theme).view.user.profile.content.genres,
                                children: preferredGenres?.map((genre, i)=>preferredGenres.length - 1 === i ? `${genre}` : `${genre}, `)
                            })
                        ]
                    })
                ]
            })
        })
    });
    // default is progress skeleton
    return /*#__PURE__*/ (0, $9awXB.jsx)("div", {
        css: (0, $fqWgX.styles)(theme).view.main,
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $r5GD9.SkeletonVertical), {
            containerWidth: "100%",
            sections: [
                {
                    name: `user-view-user-profile`,
                    width: "100%",
                    height: "100px",
                    isStatic: true,
                    isDivider: false
                },
                {
                    name: `user-view-user-divider`,
                    width: "100%",
                    height: "24px",
                    isStatic: true,
                    isDivider: true
                },
                {
                    name: `user-view-user-buttons`,
                    width: "100%",
                    height: "56px",
                    isStatic: false,
                    isDivider: false
                }
            ]
        })
    });
};
$38f2f44d275fbce4$export$419e08052d39e013.propTypes = {};

});
parcelRegister("fqWgX", function(module, exports) {

$parcel$export(module.exports, "styles", function () { return $84aefa5e75374af8$export$9dd6ff9ea0189349; });

var $7hler = parcelRequire("7hler");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
function $84aefa5e75374af8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $84aefa5e75374af8$var$_ref = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $84aefa5e75374af8$var$_ref2 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $84aefa5e75374af8$var$_ref3 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $84aefa5e75374af8$var$_ref4 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $84aefa5e75374af8$var$_ref5 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $84aefa5e75374af8$var$_ref6 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $84aefa5e75374af8$var$_ref7 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $84aefa5e75374af8$var$_ref8 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $84aefa5e75374af8$var$_ref9 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $84aefa5e75374af8$var$_ref10 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $84aefa5e75374af8$var$_ref11 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $84aefa5e75374af8$var$_ref12 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $84aefa5e75374af8$var$_ref13 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
var $84aefa5e75374af8$var$_ref14 = {
    name: "1d3w5wq",
    styles: "width:100%"
};
var $84aefa5e75374af8$var$_ref15 = {
    name: "ci2ctp",
    styles: "flex-direction:column;flex-wrap:nowrap;&>div{margin-right:0px;margin-bottom:12px;}"
};
var $84aefa5e75374af8$var$_ref16 = {
    name: "8ipy9y",
    styles: "display:flex;flex-direction:column;min-width:0;margin-bottom:4px"
};
var $84aefa5e75374af8$var$_ref17 = {
    name: "1azakc",
    styles: "text-align:center"
};
var $84aefa5e75374af8$var$_ref18 = {
    name: "1ekof46",
    styles: "margin-right:0px;margin-bottom:16px"
};
var $84aefa5e75374af8$var$_ref19 = {
    name: "qdeacm",
    styles: "flex-direction:column"
};
const $84aefa5e75374af8$export$9dd6ff9ea0189349 = (theme)=>({
        view: {
            main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.padding.sides, ";margin-bottom:50px;", ""),
            user: {
                main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).app.screen.width.full, ";", ""),
                profile: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;margin-bottom:24px;", (0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref19), ";", ""),
                    avatar: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;align-items:center;justify-content:center;align-self:center;flex-shrink:0;width:100px;height:100px;background-color:", theme.colors.primary.darker, ";border-radius:50%;overflow:hidden;margin-right:16px;", (0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref18), ";", ""),
                        image: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).image, ";", ""),
                        icon: /*#__PURE__*/ (0, $7hler.css)("width:36px;height:36px;&>path{fill:", theme.colors.secondary.normal, ";}", "")
                    },
                    content: {
                        main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-direction:column;justify-content:space-between;min-width:0;", (0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref17), ";", ""),
                        data: {
                            main: $84aefa5e75374af8$var$_ref16,
                            name: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).h6, ";font-weight:bold;", ""),
                            username: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";font-size:", (0, $gln0L.typography).p, ";", "")
                        },
                        genres: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, " font-size:", (0, $gln0L.typography).p, ";", "")
                    }
                },
                buttons: {
                    main: /*#__PURE__*/ (0, $7hler.css)("display:flex;flex-wrap:wrap;min-height:56px;&>div{margin-right:20px;margin-bottom:12px;}", (0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref15), ";", ""),
                    follow: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref14), ";", ""),
                        content: {
                            main: $84aefa5e75374af8$var$_ref13,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    unfollow: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref12), ";", ""),
                        content: {
                            main: $84aefa5e75374af8$var$_ref11,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    subscribe: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref10), ";", ""),
                        content: {
                            main: $84aefa5e75374af8$var$_ref9,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{color:", theme.colors.primary.normal, ";}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    unsubscribe: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref8), ";", ""),
                        content: {
                            main: $84aefa5e75374af8$var$_ref7,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{color:", theme.colors.primary.normal, ";}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    tip: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref6), ";", ""),
                        content: {
                            main: $84aefa5e75374af8$var$_ref5,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.primary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    block: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref4), ";", ""),
                        content: {
                            main: $84aefa5e75374af8$var$_ref3,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    },
                    report: {
                        main: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile($84aefa5e75374af8$var$_ref2), ";", ""),
                        content: {
                            main: $84aefa5e75374af8$var$_ref,
                            icon: /*#__PURE__*/ (0, $7hler.css)("flex-shrink:0;width:22px;height:22px;margin-right:12px;&>svg{&>path{fill:", theme.colors.secondary.normal, ";}}", ""),
                            text: /*#__PURE__*/ (0, $7hler.css)((0, $gln0L.mq).mobile(/*#__PURE__*/ (0, $7hler.css)((0, $gln0L.helpers).textOverflowEllipsis, ";", "")), ";", "")
                        }
                    }
                }
            }
        }
    });

});



parcelRegister("aM7LJ", function(module, exports) {

$parcel$export(module.exports, "userUtilRenderArtistActions", function () { return $3453f8cb2aec925a$export$ec6eaa0dac0d2233; });
$parcel$export(module.exports, "userUtilGetArtistCardSkeletonSections", function () { return $3453f8cb2aec925a$export$8d0ab8a7361ff3a3; });
const $3453f8cb2aec925a$export$ec6eaa0dac0d2233 = ({ isCurrentUserFollowingArtist: isCurrentUserFollowingArtist, isCurrentUserSubscribedToArtist: isCurrentUserSubscribedToArtist, isCurrentUserSubscribedToArtistAtPeriodEnd: isCurrentUserSubscribedToArtistAtPeriodEnd, isArtistCanReceivePayments: isArtistCanReceivePayments, createUserFollowNode: createUserFollowNode, deleteUserFollowNode: deleteUserFollowNode, createSubscriptionNode: createSubscriptionNode, renewSubscriptionNode: renewSubscriptionNode, cancelSubscriptionNode: cancelSubscriptionNode, defaultNode: defaultNode })=>{
    // if artist is not followed
    if (!isCurrentUserFollowingArtist) return createUserFollowNode;
    // if user is subscribed to the artist and not at period end
    if (isCurrentUserSubscribedToArtist && !isCurrentUserSubscribedToArtistAtPeriodEnd) return cancelSubscriptionNode;
    // if artist is followed
    if (isCurrentUserFollowingArtist) {
        // if artist can receive payments
        if (isArtistCanReceivePayments) {
            if (isCurrentUserSubscribedToArtistAtPeriodEnd) return renewSubscriptionNode;
            return createSubscriptionNode;
        }
        return deleteUserFollowNode;
    }
    // default return is empty
    return defaultNode;
};
const $3453f8cb2aec925a$export$8d0ab8a7361ff3a3 = (sectionName)=>[
        {
            name: `${sectionName}-avatar`,
            width: "140px",
            height: "100px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider-1`,
            width: "140px",
            height: "8px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-name`,
            width: "140px",
            height: "40px",
            isStatic: true,
            isDivider: false
        },
        {
            name: `${sectionName}-divider-2`,
            width: "140px",
            height: "8px",
            isStatic: true,
            isDivider: true
        },
        {
            name: `${sectionName}-username`,
            width: "140px",
            height: "62px",
            isStatic: true,
            isDivider: false
        }
    ];

});

parcelRegister("iw5tW", function(module, exports) {

$parcel$export(module.exports, "userSlice", function () { return $520cbdb0034ed224$export$c90edb45b5aad092; });
$parcel$export(module.exports, "userResetState", function () { return $520cbdb0034ed224$export$95b091457c7c126e; });
$parcel$export(module.exports, "userSetPublicArtists", function () { return $520cbdb0034ed224$export$5b63080958096df9; });
$parcel$export(module.exports, "userSetPopularArtists", function () { return $520cbdb0034ed224$export$5eb2f87cd41fdf86; });
$parcel$export(module.exports, "userSetRecommendedArtists", function () { return $520cbdb0034ed224$export$1f5a79ff50994618; });
$parcel$export(module.exports, "userSetFollowedArtists", function () { return $520cbdb0034ed224$export$69e1f58eca60607f; });
$parcel$export(module.exports, "userSetSubscribedArtists", function () { return $520cbdb0034ed224$export$a2892c430ed1a1dc; });
$parcel$export(module.exports, "userSetUser", function () { return $520cbdb0034ed224$export$8a05346d028c3871; });
$parcel$export(module.exports, "userResetUser", function () { return $520cbdb0034ed224$export$907f16420e87bb26; });
$parcel$export(module.exports, "userAppendFollowedArtist", function () { return $520cbdb0034ed224$export$c60ff6815309afb6; });
$parcel$export(module.exports, "userFilterFollowedArtist", function () { return $520cbdb0034ed224$export$46307c0efb4b0018; });
$parcel$export(module.exports, "userAppendSubscribedArtist", function () { return $520cbdb0034ed224$export$61164a8d1d941b00; });
$parcel$export(module.exports, "userFilterSubscribedArtist", function () { return $520cbdb0034ed224$export$a3bc626b1e7dba85; });
$parcel$export(module.exports, "userFilterUser", function () { return $520cbdb0034ed224$export$cf1e0592bf859245; });
$parcel$export(module.exports, "userOpenUserBlockModal", function () { return $520cbdb0034ed224$export$44502a74e0f4377f; });
$parcel$export(module.exports, "userCloseUserBlockModal", function () { return $520cbdb0034ed224$export$e0a743ddd61c5462; });
$parcel$export(module.exports, "userOpenUserProfileDeleteModal", function () { return $520cbdb0034ed224$export$f2c1fa6a0df33ec5; });
$parcel$export(module.exports, "userCloseUserProfileDeleteModal", function () { return $520cbdb0034ed224$export$3b082fcf0d20ddfa; });
$parcel$export(module.exports, "userSelectPublicArtists", function () { return $520cbdb0034ed224$export$23c096d559788db4; });
$parcel$export(module.exports, "userSelectPublicArtistsLength", function () { return $520cbdb0034ed224$export$ac031b31259b6e0f; });
$parcel$export(module.exports, "userSelectPublicArtistsCount", function () { return $520cbdb0034ed224$export$2e56e8c690b972f; });
$parcel$export(module.exports, "userSelectPublicArtistsFetched", function () { return $520cbdb0034ed224$export$1df8343bc437635; });
$parcel$export(module.exports, "userSelectPopularArtists", function () { return $520cbdb0034ed224$export$9dc108ae8036577a; });
$parcel$export(module.exports, "userSelectPopularArtistsLength", function () { return $520cbdb0034ed224$export$229458ba2c0d8138; });
$parcel$export(module.exports, "userSelectPopularArtistsCount", function () { return $520cbdb0034ed224$export$d43741d5253f8c58; });
$parcel$export(module.exports, "userSelectPopularArtistsFetched", function () { return $520cbdb0034ed224$export$e6605c226abfd042; });
$parcel$export(module.exports, "userSelectRecommendedArtists", function () { return $520cbdb0034ed224$export$d60b09565f9c16ff; });
$parcel$export(module.exports, "userSelectRecommendedArtistsLength", function () { return $520cbdb0034ed224$export$8aa37f3a9487c7f5; });
$parcel$export(module.exports, "userSelectRecommendedArtistsCount", function () { return $520cbdb0034ed224$export$fd89186b25e7e9fc; });
$parcel$export(module.exports, "userSelectRecommendedArtistsFetched", function () { return $520cbdb0034ed224$export$f0471b42de895c20; });
$parcel$export(module.exports, "userSelectFollowedArtists", function () { return $520cbdb0034ed224$export$b7870a53f8c28063; });
$parcel$export(module.exports, "userSelectFollowedArtistsLength", function () { return $520cbdb0034ed224$export$6bf8fe44ba2ca00; });
$parcel$export(module.exports, "userSelectFollowedArtistsCount", function () { return $520cbdb0034ed224$export$4587d4c4e903cb48; });
$parcel$export(module.exports, "userSelectFollowedArtistsFetched", function () { return $520cbdb0034ed224$export$b7914906285fea5f; });
$parcel$export(module.exports, "userSelectSubscribedArtists", function () { return $520cbdb0034ed224$export$4baaaf9b9c6f3333; });
$parcel$export(module.exports, "userSelectSubscribedArtistsLength", function () { return $520cbdb0034ed224$export$c72d7c987fb6d65e; });
$parcel$export(module.exports, "userSelectSubscribedArtistsCount", function () { return $520cbdb0034ed224$export$f26a972e2195b2b9; });
$parcel$export(module.exports, "userSelectSubscribedArtistsFetched", function () { return $520cbdb0034ed224$export$f699e24c41780cef; });
$parcel$export(module.exports, "userSelectUser", function () { return $520cbdb0034ed224$export$6c301dcdea48ae06; });
$parcel$export(module.exports, "userSelectUserFetched", function () { return $520cbdb0034ed224$export$6b8bdda6b6ce3d08; });
$parcel$export(module.exports, "userSelectUserBlockModalOpen", function () { return $520cbdb0034ed224$export$282d505426892166; });
$parcel$export(module.exports, "userSelectUserBlockModalUser", function () { return $520cbdb0034ed224$export$7b83910b7e617c73; });
$parcel$export(module.exports, "userSelectUserProfileDeleteModalOpen", function () { return $520cbdb0034ed224$export$5e50b65e26f8953e; });
$parcel$export(module.exports, "userSelectUserProfileDeleteModalUser", function () { return $520cbdb0034ed224$export$a8592877e5349ef8; });
$parcel$export(module.exports, "userSelectUserGetPublicArtistsLoading", function () { return $520cbdb0034ed224$export$e4239da408785ee7; });
$parcel$export(module.exports, "userSelectUserGetPopularArtistsLoading", function () { return $520cbdb0034ed224$export$aa012b1299b78ac5; });
$parcel$export(module.exports, "userSelectUserGetRecommendedArtistsLoading", function () { return $520cbdb0034ed224$export$a001f30e1f8b11c8; });
$parcel$export(module.exports, "userSelectUserGetFollowedArtistsLoading", function () { return $520cbdb0034ed224$export$83091f92560881a5; });
$parcel$export(module.exports, "userSelectUserGetSubscribedArtistsLoading", function () { return $520cbdb0034ed224$export$cc13c2995a67ae4d; });
$parcel$export(module.exports, "userSelectUserGetUserLoading", function () { return $520cbdb0034ed224$export$222d0fde7b1003fe; });
$parcel$export(module.exports, "userSelectUserBlockLoading", function () { return $520cbdb0034ed224$export$b7ed8dde37cb55e5; });
$parcel$export(module.exports, "userSelectUserProfileUpdateLoading", function () { return $520cbdb0034ed224$export$e636b7125865f0f8; });
$parcel$export(module.exports, "userSelectUserProfileDeleteLoading", function () { return $520cbdb0034ed224$export$2ab7e93c02dc0694; });
$parcel$export(module.exports, "userReducer", function () { return $520cbdb0034ed224$export$c80d1fc788ac90f9; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("1O2TI");
var $6Rkyy = parcelRequire("6Rkyy");
parcelRequire("cJvLm");
var $lCHeK = parcelRequire("lCHeK");
const $520cbdb0034ed224$var$initialState = {
    publicArtists: [],
    publicArtistsCount: 0,
    publicArtistsFetched: false,
    popularArtists: [],
    popularArtistsCount: 0,
    popularArtistsFetched: false,
    recommendedArtists: [],
    recommendedArtistsCount: 0,
    recommendedArtistsFetched: false,
    followedArtists: [],
    followedArtistsCount: 0,
    followedArtistsFetched: false,
    subscribedArtists: [],
    subscribedArtistsCount: 0,
    subscribedArtistsFetched: false,
    user: undefined,
    userFetched: false,
    userBlockModal: {
        user: undefined,
        open: false
    },
    userProfileDeleteModal: {
        user: undefined,
        open: false
    },
    userGetPublicArtistsLoading: false,
    userGetPopularArtistsLoading: false,
    userGetRecommendedArtistsLoading: false,
    userGetFollowedArtistsLoading: false,
    userGetSubscribedArtistsLoading: false,
    userGetUserLoading: false,
    userBlockLoading: false,
    userProfileUpdateLoading: false,
    userProfileDeleteLoading: false
};
const $520cbdb0034ed224$export$c90edb45b5aad092 = (0, $kvj5V.createSlice)({
    name: "user",
    initialState: $520cbdb0034ed224$var$initialState,
    reducers: {
        // reset state
        userResetState: ()=>({
                publicArtists: [],
                publicArtistsCount: 0,
                publicArtistsFetched: false,
                popularArtists: [],
                popularArtistsCount: 0,
                popularArtistsFetched: false,
                recommendedArtists: [],
                recommendedArtistsCount: 0,
                recommendedArtistsFetched: false,
                followedArtists: [],
                followedArtistsCount: 0,
                followedArtistsFetched: false,
                subscribedArtists: [],
                subscribedArtistsCount: 0,
                subscribedArtistsFetched: false,
                user: undefined,
                userFetched: false,
                userBlockModal: {
                    user: undefined,
                    open: false
                },
                userProfileDeleteModal: {
                    user: undefined,
                    open: false
                },
                userGetPublicArtistsLoading: false,
                userGetPopularArtistsLoading: false,
                userGetRecommendedArtistsLoading: false,
                userGetFollowedArtistsLoading: false,
                userGetSubscribedArtistsLoading: false,
                userGetUserLoading: false,
                userBlockLoading: false,
                userProfileUpdateLoading: false,
                userProfileDeleteLoading: false
            }),
        // set public artists
        userSetPublicArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.publicArtistsCount = count;
                // mutate public artists array
                state.publicArtists = (0, $6Rkyy.mergeArraysAtIndex)(state.publicArtists, artists, offset);
            }
        },
        // set popular artists
        userSetPopularArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.popularArtistsCount = count;
                // mutate popular artists array
                state.popularArtists = (0, $6Rkyy.mergeArraysAtIndex)(state.popularArtists, artists, offset);
            }
        },
        // set recommended artists
        userSetRecommendedArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.recommendedArtistsCount = count;
                // mutate recommended artists array
                state.recommendedArtists = (0, $6Rkyy.mergeArraysAtIndex)(state.recommendedArtists, artists, offset);
            }
        },
        // set followed artists
        userSetFollowedArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.followedArtistsCount = count;
                // mutate followed artists array
                state.followedArtists = (0, $6Rkyy.mergeArraysAtIndex)(state.followedArtists, artists, offset);
            }
        },
        // set subscribed artists
        userSetSubscribedArtists: (state, action)=>{
            const { artists: artists, count: count, offset: offset, mutate: mutate } = action.payload;
            // if mutate
            if (mutate) {
                // mutate count
                state.subscribedArtistsCount = count;
                // mutate subscribers artists array
                state.subscribedArtists = (0, $6Rkyy.mergeArraysAtIndex)(state.subscribedArtists, artists, offset);
            }
        },
        // set user
        userSetUser: (state, action)=>{
            const { user: user } = action.payload;
            // update user state
            state.user = user;
        },
        // reset user
        userResetUser: (state)=>({
                ...state,
                user: undefined,
                userFetched: false
            }),
        // append followed artist
        userAppendFollowedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if followed artists are fetched
            if (state.followedArtistsFetched) {
                // append artist to followed artists
                state.followedArtists.unshift(artist);
                state.followedArtistsCount += 1;
            }
        },
        // filter followed artist
        userFilterFollowedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if followed artists are fetched
            if (state.followedArtistsFetched) {
                // filter artist from followed artists
                state.followedArtists = state.followedArtists.filter((a)=>a.id !== artist.id);
                state.followedArtistsCount -= 1;
            }
        },
        // append subscribed artist
        userAppendSubscribedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if subscribed artists are fetched
            if (state.subscribedArtistsFetched) {
                // append artist to subscribed artists
                state.subscribedArtists.unshift(artist);
                state.subscribedArtistsCount += 1;
            }
        },
        // filter subscribed artists
        userFilterSubscribedArtist: (state, action)=>{
            const { artist: artist } = action.payload;
            // if subscribed artists are fetched
            if (state.subscribedArtistsFetched) {
                // filter artist from subscribed artists
                state.subscribedArtists = state.subscribedArtists.filter((a)=>a.id !== artist.id);
                state.subscribedArtistsCount -= 1;
            }
        },
        // filter user
        userFilterUser: (state, action)=>{
            const { id: id } = action.payload;
            // check if user exists in public artists
            const pubIndex = state.publicArtists.findIndex((a)=>a.id === id);
            if (pubIndex !== -1) {
                // filter artist
                state.publicArtists = state.publicArtists.filter((a)=>a.id !== id);
                state.publicArtistsCount -= 1;
            }
            // check if user exists in popular artists
            const popIndex = state.popularArtists.findIndex((a)=>a.id === id);
            if (popIndex !== -1) {
                // filter artist
                state.popularArtists = state.popularArtists.filter((a)=>a.id !== id);
                state.popularArtistsCount -= 1;
            }
            // check if user exists in recommended artists
            const recIndex = state.recommendedArtists.findIndex((a)=>a.id === id);
            if (recIndex !== -1) {
                // filter artist
                state.recommendedArtists = state.recommendedArtists.filter((a)=>a.id !== id);
                state.recommendedArtistsCount -= 1;
            }
            // check if user exists in followed artists
            const folIndex = state.followedArtists.findIndex((a)=>a.id === id);
            if (folIndex !== -1) {
                // filter artist
                state.followedArtists = state.followedArtists.filter((a)=>a.id !== id);
                state.followedArtistsCount -= 1;
            }
            // check if user exists in subscribed artists
            const subIndex = state.subscribedArtists.findIndex((a)=>a.id === id);
            if (subIndex !== -1) {
                // filter artist
                state.subscribedArtists = state.subscribedArtists.filter((a)=>a.id !== id);
                state.subscribedArtistsCount -= 1;
            }
        },
        // open user block modal
        userOpenUserBlockModal: (state, action)=>({
                ...state,
                userBlockModal: {
                    user: action.payload.user,
                    open: true
                }
            }),
        // close user block modal
        userCloseUserBlockModal: (state)=>({
                ...state,
                userBlockModal: {
                    user: undefined,
                    open: false
                },
                error: ""
            }),
        // open user profile delete modal
        userOpenUserProfileDeleteModal: (state, action)=>({
                ...state,
                userProfileDeleteModal: {
                    user: action.payload.user,
                    open: true
                }
            }),
        // close user profile delete modal
        userCloseUserProfileDeleteModal: (state)=>({
                ...state,
                userProfileDeleteModal: {
                    user: undefined,
                    open: false
                },
                error: ""
            })
    },
    extraReducers: (builder)=>{
        // get public artists
        builder.addCase((0, $lCHeK.userGetPublicArtists).pending, (state)=>({
                ...state,
                userGetPublicArtistsLoading: true
            })).addCase((0, $lCHeK.userGetPublicArtists).fulfilled, (state)=>({
                ...state,
                publicArtistsFetched: true,
                userGetPublicArtistsLoading: false
            }));
        // get popular artists
        builder.addCase((0, $lCHeK.userGetPopularArtists).pending, (state)=>({
                ...state,
                userGetPopularArtistsLoading: true
            })).addCase((0, $lCHeK.userGetPopularArtists).fulfilled, (state)=>({
                ...state,
                popularArtistsFetched: true,
                userGetPopularArtistsLoading: false
            }));
        // get recommended artists
        builder.addCase((0, $lCHeK.userGetRecommendedArtists).pending, (state)=>({
                ...state,
                userGetRecommendedArtistsLoading: true
            })).addCase((0, $lCHeK.userGetRecommendedArtists).fulfilled, (state)=>({
                ...state,
                recommendedArtistsFetched: true,
                userGetRecommendedArtistsLoading: false
            }));
        // get followed artists
        builder.addCase((0, $lCHeK.userGetFollowedArtists).pending, (state)=>({
                ...state,
                userGetFollowedArtistsLoading: true
            })).addCase((0, $lCHeK.userGetFollowedArtists).fulfilled, (state)=>({
                ...state,
                followedArtistsFetched: true,
                userGetFollowedArtistsLoading: false
            }));
        // get subscribed artists
        builder.addCase((0, $lCHeK.userGetSubscribedArtists).pending, (state)=>({
                ...state,
                userGetSubscribedArtistsLoading: true
            })).addCase((0, $lCHeK.userGetSubscribedArtists).fulfilled, (state)=>({
                ...state,
                subscribedArtistsFetched: true,
                userGetSubscribedArtistsLoading: false
            }));
        // get user
        builder.addCase((0, $lCHeK.userGetUser).pending, (state)=>({
                ...state,
                userGetUserLoading: true
            })).addCase((0, $lCHeK.userGetUser).fulfilled, (state)=>({
                ...state,
                userFetched: true,
                userGetUserLoading: false
            }));
        // block user
        builder.addCase((0, $lCHeK.userBlock).pending, (state)=>({
                ...state,
                userBlockLoading: true
            })).addCase((0, $lCHeK.userBlock).fulfilled, (state)=>({
                ...state,
                userBlockLoading: false
            }));
        // update profile
        builder.addCase((0, $lCHeK.userProfileUpdate).pending, (state)=>({
                ...state,
                userProfileUpdateLoading: true
            })).addCase((0, $lCHeK.userProfileUpdate).fulfilled, (state)=>({
                ...state,
                userProfileUpdateLoading: false
            }));
        // delete profile
        builder.addCase((0, $lCHeK.userProfileDelete).pending, (state)=>({
                ...state,
                userProfileDeleteLoading: true
            })).addCase((0, $lCHeK.userProfileDelete).fulfilled, (state)=>({
                ...state,
                userProfileDeleteLoading: false
            }));
    }
});
const { userResetState: $520cbdb0034ed224$export$95b091457c7c126e, userSetPublicArtists: $520cbdb0034ed224$export$5b63080958096df9, userSetPopularArtists: $520cbdb0034ed224$export$5eb2f87cd41fdf86, userSetRecommendedArtists: $520cbdb0034ed224$export$1f5a79ff50994618, userSetFollowedArtists: $520cbdb0034ed224$export$69e1f58eca60607f, userSetSubscribedArtists: $520cbdb0034ed224$export$a2892c430ed1a1dc, userSetUser: $520cbdb0034ed224$export$8a05346d028c3871, userResetUser: $520cbdb0034ed224$export$907f16420e87bb26, userAppendFollowedArtist: $520cbdb0034ed224$export$c60ff6815309afb6, userFilterFollowedArtist: $520cbdb0034ed224$export$46307c0efb4b0018, userAppendSubscribedArtist: $520cbdb0034ed224$export$61164a8d1d941b00, userFilterSubscribedArtist: $520cbdb0034ed224$export$a3bc626b1e7dba85, userFilterUser: $520cbdb0034ed224$export$cf1e0592bf859245, userOpenUserBlockModal: $520cbdb0034ed224$export$44502a74e0f4377f, userCloseUserBlockModal: $520cbdb0034ed224$export$e0a743ddd61c5462, userOpenUserProfileDeleteModal: $520cbdb0034ed224$export$f2c1fa6a0df33ec5, userCloseUserProfileDeleteModal: $520cbdb0034ed224$export$3b082fcf0d20ddfa } = $520cbdb0034ed224$export$c90edb45b5aad092.actions;
const $520cbdb0034ed224$export$23c096d559788db4 = (state)=>state.user.publicArtists;
const $520cbdb0034ed224$export$ac031b31259b6e0f = (state)=>state.user.publicArtists.length;
const $520cbdb0034ed224$export$2e56e8c690b972f = (state)=>state.user.publicArtistsCount;
const $520cbdb0034ed224$export$1df8343bc437635 = (state)=>state.user.publicArtistsFetched;
const $520cbdb0034ed224$export$9dc108ae8036577a = (state)=>state.user.popularArtists;
const $520cbdb0034ed224$export$229458ba2c0d8138 = (state)=>state.user.popularArtists.length;
const $520cbdb0034ed224$export$d43741d5253f8c58 = (state)=>state.user.popularArtistsCount;
const $520cbdb0034ed224$export$e6605c226abfd042 = (state)=>state.user.popularArtistsFetched;
const $520cbdb0034ed224$export$d60b09565f9c16ff = (state)=>state.user.recommendedArtists;
const $520cbdb0034ed224$export$8aa37f3a9487c7f5 = (state)=>state.user.recommendedArtists.length;
const $520cbdb0034ed224$export$fd89186b25e7e9fc = (state)=>state.user.recommendedArtistsCount;
const $520cbdb0034ed224$export$f0471b42de895c20 = (state)=>state.user.recommendedArtistsFetched;
const $520cbdb0034ed224$export$b7870a53f8c28063 = (state)=>state.user.followedArtists;
const $520cbdb0034ed224$export$6bf8fe44ba2ca00 = (state)=>state.user.followedArtists.length;
const $520cbdb0034ed224$export$4587d4c4e903cb48 = (state)=>state.user.followedArtistsCount;
const $520cbdb0034ed224$export$b7914906285fea5f = (state)=>state.user.followedArtistsFetched;
const $520cbdb0034ed224$export$4baaaf9b9c6f3333 = (state)=>state.user.subscribedArtists;
const $520cbdb0034ed224$export$c72d7c987fb6d65e = (state)=>state.user.subscribedArtists.length;
const $520cbdb0034ed224$export$f26a972e2195b2b9 = (state)=>state.user.subscribedArtistsCount;
const $520cbdb0034ed224$export$f699e24c41780cef = (state)=>state.user.subscribedArtistsFetched;
const $520cbdb0034ed224$export$6c301dcdea48ae06 = (state)=>state.user.user;
const $520cbdb0034ed224$export$6b8bdda6b6ce3d08 = (state)=>state.user.userFetched;
const $520cbdb0034ed224$export$282d505426892166 = (state)=>state.user.userBlockModal.open;
const $520cbdb0034ed224$export$7b83910b7e617c73 = (state)=>state.user.userBlockModal.user;
const $520cbdb0034ed224$export$5e50b65e26f8953e = (state)=>state.user.userProfileDeleteModal.open;
const $520cbdb0034ed224$export$a8592877e5349ef8 = (state)=>state.user.userProfileDeleteModal.user;
const $520cbdb0034ed224$export$e4239da408785ee7 = (state)=>state.user.userGetPublicArtistsLoading;
const $520cbdb0034ed224$export$aa012b1299b78ac5 = (state)=>state.user.userGetPopularArtistsLoading;
const $520cbdb0034ed224$export$a001f30e1f8b11c8 = (state)=>state.user.userGetRecommendedArtistsLoading;
const $520cbdb0034ed224$export$83091f92560881a5 = (state)=>state.user.userGetFollowedArtistsLoading;
const $520cbdb0034ed224$export$cc13c2995a67ae4d = (state)=>state.user.userGetSubscribedArtistsLoading;
const $520cbdb0034ed224$export$222d0fde7b1003fe = (state)=>state.user.userGetUserLoading;
const $520cbdb0034ed224$export$b7ed8dde37cb55e5 = (state)=>state.user.userBlockLoading;
const $520cbdb0034ed224$export$e636b7125865f0f8 = (state)=>state.user.userProfileUpdateLoading;
const $520cbdb0034ed224$export$2ab7e93c02dc0694 = (state)=>state.user.userProfileDeleteLoading;
const $520cbdb0034ed224$export$c80d1fc788ac90f9 = $520cbdb0034ed224$export$c90edb45b5aad092.reducer; // export default userSlice.reducer

});

parcelRegister("lCHeK", function(module, exports) {

$parcel$export(module.exports, "userGetPublicArtists", function () { return $fdf9ed56123d5300$export$c59641d3fa31905d; });
$parcel$export(module.exports, "userGetPopularArtists", function () { return $fdf9ed56123d5300$export$fc7c67c1bfe3c743; });
$parcel$export(module.exports, "userGetRecommendedArtists", function () { return $fdf9ed56123d5300$export$303c74cf3eaba1ff; });
$parcel$export(module.exports, "userGetFollowedArtists", function () { return $fdf9ed56123d5300$export$e1c127ca98d3f61e; });
$parcel$export(module.exports, "userGetSubscribedArtists", function () { return $fdf9ed56123d5300$export$7605b67b67ab9697; });
$parcel$export(module.exports, "userGetUser", function () { return $fdf9ed56123d5300$export$84db7d5abe15d4ae; });
$parcel$export(module.exports, "userBlock", function () { return $fdf9ed56123d5300$export$62a6756e7dee00e1; });
$parcel$export(module.exports, "userProfileUpdate", function () { return $fdf9ed56123d5300$export$eb529496f4bbc066; });
$parcel$export(module.exports, "userProfileDelete", function () { return $fdf9ed56123d5300$export$3478c3bf87ba9dd4; });

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("fWtjF");
var $dOAPA = parcelRequire("dOAPA");
parcelRequire("1O2TI");
var $itWch = parcelRequire("itWch");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $h7gla = parcelRequire("h7gla");
var $9HBOX = parcelRequire("9HBOX");
var $e9SYA = parcelRequire("e9SYA");
var $jAL4t = parcelRequire("jAL4t");
var $a0vy2 = parcelRequire("a0vy2");
var $10e6J = parcelRequire("10e6J");
var $2Vh5B = parcelRequire("2Vh5B");
var $iw5tW = parcelRequire("iw5tW");
const $fdf9ed56123d5300$export$c59641d3fa31905d = (0, $kvj5V.createAsyncThunk)("user/userGetPublicArtists", async (_, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve public artists
        const { artists: artists, count: count } = await api.userApi.getPublicArtists();
        // set public artists
        dispatch((0, $iw5tW.userSetPublicArtists)({
            artists: artists || [],
            count: count || 0,
            offset: 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$fc7c67c1bfe3c743 = (0, $kvj5V.createAsyncThunk)("user/userGetPopularArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getPopularArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $iw5tW.userSetPopularArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$303c74cf3eaba1ff = (0, $kvj5V.createAsyncThunk)("user/userGetRecommendedArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getRecommendedArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $iw5tW.userSetRecommendedArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$e1c127ca98d3f61e = (0, $kvj5V.createAsyncThunk)("user/userGetFollowedArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getFollowedArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $iw5tW.userSetFollowedArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$7605b67b67ab9697 = (0, $kvj5V.createAsyncThunk)("user/userGetSubscribedArtists", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve recommended artists
        const { artists: artists, count: count } = await api.userApi.getSubscribedArtists(inp.limit, inp.offset, inp.search);
        // set recommended artists
        dispatch((0, $iw5tW.userSetSubscribedArtists)({
            artists: artists || [],
            count: count || 0,
            offset: inp.offset || 0,
            mutate: true
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$84db7d5abe15d4ae = (0, $kvj5V.createAsyncThunk)("user/userGetUser", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // retrieve user
        const { user: user } = await api.userApi.getUser(inp.userId);
        // set user
        dispatch((0, $iw5tW.userSetUser)({
            user: user || {}
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$62a6756e7dee00e1 = (0, $kvj5V.createAsyncThunk)("user/userBlock", async ({ id: id }, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // block user
        await api.userApi.blockUser({
            userId: id
        });
        // reset user page state
        dispatch((0, $iw5tW.userResetUser)());
        // filter blocked user from users
        dispatch((0, $iw5tW.userFilterUser)({
            id: id
        }));
        // filter blocked user tracks from tracks
        dispatch((0, $2Vh5B.trackFilterUserTracks)({
            userId: id
        }));
        // filter blocked user tracks from audio player
        dispatch((0, $jAL4t.playerAudioFilterPlaylistUserTracks)({
            userId: id
        }));
        // filter blocked user posts from posts
        dispatch((0, $a0vy2.postFilterUserPosts)({
            userId: id
        }));
        // filter blocked user comments from comments
        dispatch((0, $e9SYA.commentFilterUserComments)({
            userId: id
        }));
        // set user as blocked in the report state
        dispatch((0, $10e6J.reportSetReportUserBlocked)());
        // close user block modal
        dispatch((0, $iw5tW.userCloseUserBlockModal)());
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully blocked user!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to block user: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$eb529496f4bbc066 = (0, $kvj5V.createAsyncThunk)("user/userProfileUpdate", async (inp, { dispatch: dispatch })=>{
    // get api service
    const api = (0, $dOAPA.apiGetService)();
    try {
        // if avatar provided
        if (inp.avatar) {
            // create form data
            const formData = new FormData();
            // append avatar
            formData.append("file", inp.avatar);
            // update user avatar
            const { user: user } = await api.userApi.updateUserProfileAvatar({
                body: formData
            });
            // update profile
            dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        }
        // if name or preferred genres provided
        if (inp.name || inp.preferredGenres) {
            // update user name and preferred genres
            const { user: user } = await api.userApi.updateUserProfile({
                name: inp.name,
                preferredGenres: inp.preferredGenres
            });
            // update profile
            dispatch((0, $9HBOX.authUpdateProfile)(user || {}));
        }
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully updated user profile!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to update user profile: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});
const $fdf9ed56123d5300$export$3478c3bf87ba9dd4 = (0, $kvj5V.createAsyncThunk)("user/userProfileDelete", async (inp, { dispatch: dispatch })=>{
    // get api service
    // const api = apiGetService()
    try {
        // TODO: implement
        // are you sure you want to delete your profile?
        // on confirm click
        // 1. send email with termination code
        // 2. update modal to render input field
        // on delete click
        // 1. delete user profile
        // 2. log user out
        // launch info alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Info,
                message: "Successfully deleted user profile!"
            }
        }));
        // return empty payload
        return {
            error: ""
        };
    } catch (err) {
        const { message: message } = await (0, $dOAPA.apiHandleError)(err);
        // launch error alert
        dispatch((0, $6tPng.alertAddMessage)({
            message: {
                id: (0, $itWch.uuid)(),
                type: (0, $h7gla.AlertMessageType).Error,
                message: `Failed to delete user profile: ${message}`
            }
        }));
        // return error message in payload
        return {
            error: message
        };
    }
});

});



parcelRegister("gsRju", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = $hffE7("fo4rn").then(()=>parcelRequire("jULDM"));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("lK17b", function(module, exports) {
module.exports = "#clip0_1023_837";

});


var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";

var $6afFj = parcelRequire("6afFj");
var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $6afFj.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $6afFj.hydrateRoot;



var $9awXB = parcelRequire("9awXB");

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $10WBQ = parcelRequire("10WBQ");

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $1c5f962aa5a314d6$export$b16d9fb1a22de840 = (0, $bh6RR.createContext)(null);
const $1c5f962aa5a314d6$var$initialState = {
    didCatch: false,
    error: null
};
class $1c5f962aa5a314d6$export$e926676385687eaf extends (0, $bh6RR.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $1c5f962aa5a314d6$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($1c5f962aa5a314d6$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $1c5f962aa5a314d6$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($1c5f962aa5a314d6$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $bh6RR.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $bh6RR.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $bh6RR.createElement)($1c5f962aa5a314d6$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $1c5f962aa5a314d6$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $1c5f962aa5a314d6$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $1c5f962aa5a314d6$export$c052f6604b7d51fe() {
    const context = (0, $bh6RR.useContext)($1c5f962aa5a314d6$export$b16d9fb1a22de840);
    $1c5f962aa5a314d6$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $bh6RR.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $bh6RR.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $1c5f962aa5a314d6$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $bh6RR.forwardRef)((props, ref)=>(0, $bh6RR.createElement)($1c5f962aa5a314d6$export$e926676385687eaf, errorBoundaryProps, (0, $bh6RR.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}



var $9awXB = parcelRequire("9awXB");

var $I3ixn = parcelRequire("I3ixn");

var $kvj5V = parcelRequire("kvj5V");
parcelRequire("krTeD");
var $2zawF = parcelRequire("2zawF");
parcelRequire("cJvLm");
var $6tPng = parcelRequire("6tPng");
var $9HBOX = parcelRequire("9HBOX");
var $e9SYA = parcelRequire("e9SYA");
var $7u2wt = parcelRequire("7u2wt");
var $2KqxL = parcelRequire("2KqxL");
var $7oPCi = parcelRequire("7oPCi");
var $6Gpkq = parcelRequire("6Gpkq");
var $89C5W = parcelRequire("89C5W");
var $3EkqN = parcelRequire("3EkqN");
var $6Qgqx = parcelRequire("6Qgqx");
var $jAL4t = parcelRequire("jAL4t");
var $a0vy2 = parcelRequire("a0vy2");
var $10e6J = parcelRequire("10e6J");
var $vfCFh = parcelRequire("vfCFh");
var $3QMY9 = parcelRequire("3QMY9");
var $l5cm3 = parcelRequire("l5cm3");
var $fIaL3 = parcelRequire("fIaL3");
var $a0GHC = parcelRequire("a0GHC");
var $2Vh5B = parcelRequire("2Vh5B");
var $ht2ql = parcelRequire("ht2ql");
var $8aXib = parcelRequire("8aXib");
var $iw5tW = parcelRequire("iw5tW");
const $11787dbb726fe3c5$export$6f57813fe9f31bf9 = (0, $kvj5V.configureStore)({
    reducer: {
        alert: (0, $6tPng.alertReducer),
        auth: (0, $9HBOX.authReducer),
        comment: (0, $e9SYA.commentReducer),
        connect: (0, $7u2wt.connectReducer),
        customer: (0, $2KqxL.customerReducer),
        like: (0, $7oPCi.likeReducer),
        navigation: (0, $6Gpkq.navigationReducer),
        notification: (0, $89C5W.notificationReducer),
        onboarding: (0, $3EkqN.onboardingReducer),
        payment: (0, $6Qgqx.paymentReducer),
        player: (0, $jAL4t.playerReducer),
        post: (0, $a0vy2.postReducer),
        report: (0, $10e6J.reportReducer),
        search: (0, $vfCFh.searchReducer),
        stream: (0, $3QMY9.streamReducer),
        subscription: (0, $l5cm3.subscriptionReducer),
        theme: (0, $fIaL3.themeReducer),
        tip: (0, $a0GHC.tipReducer),
        track: (0, $2Vh5B.trackReducer),
        transaction: (0, $ht2ql.transactionReducer),
        unlock: (0, $8aXib.unlockReducer),
        user: (0, $iw5tW.userReducer)
    },
    // remove devtools for production
    devTools: "staging" !== (0, $2zawF.Environment).Production
});


const $44d45091a140173d$export$34db86d2336a2a8e = ({ children: children })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $I3ixn.Provider), {
        store: (0, $11787dbb726fe3c5$export$6f57813fe9f31bf9),
        children: children
    });



var $9awXB = parcelRequire("9awXB");

var $7hler = parcelRequire("7hler");
var $iwq56 = parcelRequire("iwq56");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $fIaL3 = parcelRequire("fIaL3");
parcelRequire("lWWT4");
var $gln0L = parcelRequire("gln0L");
const $52246afb009a745b$export$d8964aec282183a3 = ({ children: children })=>{
    const currentTheme = (0, $gNvvs.useAppSelector)((0, $fIaL3.themeSelectCurrentTheme));
    const theme = (0, $gln0L.getTheme)(currentTheme);
    const global = (0, $gln0L.getGlobal)(currentTheme);
    return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $iwq56.b), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $9awXB.jsx)((0, $7hler.Global), {
                styles: global
            }),
            children
        ]
    });
};



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");
parcelRequire("gWg0P");
var $2bja3 = parcelRequire("2bja3");
parcelRequire("cJvLm");
var $gHHUR = parcelRequire("gHHUR");
const $be762e04297d54a1$export$87091915187a1a85 = ({ children: children })=>{
    const dispatch = (0, $2bja3.useAppDispatch)();
    (0, $bh6RR.useEffect)(()=>{
        dispatch((0, $gHHUR.authRefresh)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $9awXB.jsxs)((0, $9awXB.Fragment), {
        children: [
            " ",
            children,
            " "
        ]
    });
};


parcelRequire("1TdPt");
var $2uUr9 = parcelRequire("2uUr9");
var $kb0tL = parcelRequire("kb0tL");
const $fb4ea54da60f30c2$export$c7dacf3845253dcf = ({ children: children })=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
        fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $kb0tL.SuspenseMainFallback), {}),
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $1c5f962aa5a314d6$export$e926676385687eaf), {
            FallbackComponent: (0, $2uUr9.ErrorFallback),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $44d45091a140173d$export$34db86d2336a2a8e), {
                children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $52246afb009a745b$export$d8964aec282183a3), {
                    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $be762e04297d54a1$export$87091915187a1a85), {
                        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $10WBQ.BrowserRouter), {
                            children: children
                        })
                    })
                })
            })
        })
    });





var $99w1R = parcelRequire("99w1R");
parcelRequire("eVhD3");
var $2gpGl = parcelRequire("2gpGl");
parcelRequire("gWg0P");
var $gNvvs = parcelRequire("gNvvs");
parcelRequire("cJvLm");
var $9HBOX = parcelRequire("9HBOX");

var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("1TdPt");
var $3YnFc = parcelRequire("3YnFc");
var $6aEHC = parcelRequire("6aEHC");
parcelRequire("1O2TI");
var $5qa04 = parcelRequire("5qa04");

// pages
const { ChartsPage: $5873e14fc37870e4$var$ChartsPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ChartsPage");

const { FeedPage: $5873e14fc37870e4$var$FeedPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "FeedPage");

const { LibraryPage: $5873e14fc37870e4$var$LibraryPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "LibraryPage");

const { NotificationsPage: $5873e14fc37870e4$var$NotificationsPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "NotificationsPage");

const { NotificationsNotificationPage: $5873e14fc37870e4$var$NotificationsNotificationPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "NotificationsNotificationPage");

const { PostPage: $5873e14fc37870e4$var$PostPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "PostPage");

const { ProfilePage: $5873e14fc37870e4$var$ProfilePage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ProfilePage");

const { ReportsPage: $5873e14fc37870e4$var$ReportsPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ReportsPage");

const { ReportsReportComplaintPage: $5873e14fc37870e4$var$ReportsReportComplaintPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ReportsReportComplaintPage");

const { ReportsReportPage: $5873e14fc37870e4$var$ReportsReportPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ReportsReportPage");

const { UserPage: $5873e14fc37870e4$var$UserPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "UserPage");
const $5873e14fc37870e4$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $3YnFc.AppLayout), {
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
        })
    });
const $5873e14fc37870e4$export$37e8e188eda774db = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$App, {}),
        children: [
            {
                path: (0, $b7fnN.Path).Library,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$LibraryPage, {})
            },
            {
                path: (0, $b7fnN.Path).Charts,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$ChartsPage, {})
            },
            {
                path: `${(0, $b7fnN.Path).Reports}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$ReportsPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Path).Report}/*`,
                            element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: `${(0, $b7fnN.Params).ReportID}`,
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$ReportsReportPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: `${(0, $b7fnN.Params).ReportID}${(0, $b7fnN.Path).Complaint}/*`,
                                        element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                                            children: [
                                                /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                                    path: `${(0, $b7fnN.Params).ReportComplaintID}`,
                                                    element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$ReportsReportComplaintPage, {})
                                                }),
                                                /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                                        to: "."
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $b7fnN.Path).Profile,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$ProfilePage, {})
            },
            {
                path: `${(0, $b7fnN.Path).Notifications}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$NotificationsPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Path).Notification}/*`,
                            element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: `${(0, $b7fnN.Params).NotificationID}`,
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$NotificationsNotificationPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $b7fnN.Path).User}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Params).UserID}`,
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$UserPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $b7fnN.Path).Post}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Params).PostID}`,
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$PostPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $b7fnN.Path).Feed,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($5873e14fc37870e4$var$FeedPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("1TdPt");
var $3YnFc = parcelRequire("3YnFc");
var $6aEHC = parcelRequire("6aEHC");
parcelRequire("1O2TI");
var $5qa04 = parcelRequire("5qa04");

// pages
const { ChartsPage: $b87673dee8894fec$var$ChartsPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ChartsPage");

const { FeedPage: $b87673dee8894fec$var$FeedPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "FeedPage");

const { LibraryPage: $b87673dee8894fec$var$LibraryPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "LibraryPage");

const { NotificationsPage: $b87673dee8894fec$var$NotificationsPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "NotificationsPage");

const { NotificationsNotificationPage: $b87673dee8894fec$var$NotificationsNotificationPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "NotificationsNotificationPage");

const { PostPage: $b87673dee8894fec$var$PostPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "PostPage");

const { ProfilePage: $b87673dee8894fec$var$ProfilePage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ProfilePage");

const { StudioCreatePostPage: $b87673dee8894fec$var$StudioCreatePostPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "StudioCreatePostPage");

const { StudioCreateTrackPage: $b87673dee8894fec$var$StudioCreateTrackPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "StudioCreateTrackPage");

const { StudioEditPostPage: $b87673dee8894fec$var$StudioEditPostPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "StudioEditPostPage");

const { StudioEditTrackPage: $b87673dee8894fec$var$StudioEditTrackPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "StudioEditTrackPage");

const { StudioPage: $b87673dee8894fec$var$StudioPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "StudioPage");

const { UserPage: $b87673dee8894fec$var$UserPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "UserPage");
const $b87673dee8894fec$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $3YnFc.AppLayout), {
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
        })
    });
const $b87673dee8894fec$export$3da569daebda94b = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$App, {}),
        children: [
            {
                path: (0, $b7fnN.Path).Library,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$LibraryPage, {})
            },
            {
                path: (0, $b7fnN.Path).Charts,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$ChartsPage, {})
            },
            {
                path: `${(0, $b7fnN.Path).Studio}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$StudioPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Path).Post}/*`,
                            element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$StudioCreatePostPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: `${(0, $b7fnN.Params).PostID}`,
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$StudioEditPostPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Path).Track}/*`,
                            element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$StudioCreateTrackPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: `${(0, $b7fnN.Params).TrackID}`,
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$StudioEditTrackPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $b7fnN.Path).Profile,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$ProfilePage, {})
            },
            {
                path: `${(0, $b7fnN.Path).Notifications}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$NotificationsPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Path).Notification}/*`,
                            element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: `${(0, $b7fnN.Params).NotificationID}`,
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$NotificationsNotificationPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $b7fnN.Path).User}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Params).UserID}`,
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$UserPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $b7fnN.Path).Post}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Params).PostID}`,
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$PostPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $b7fnN.Path).Feed,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($b87673dee8894fec$var$FeedPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("krTeD");
var $b7fnN = parcelRequire("b7fnN");
parcelRequire("1TdPt");
var $3YnFc = parcelRequire("3YnFc");
var $6aEHC = parcelRequire("6aEHC");
parcelRequire("1O2TI");
var $5qa04 = parcelRequire("5qa04");

// pages
const { ChartsPage: $55d3dc9bac117cf9$var$ChartsPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ChartsPage");

const { FeedPage: $55d3dc9bac117cf9$var$FeedPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "FeedPage");

const { LibraryPage: $55d3dc9bac117cf9$var$LibraryPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "LibraryPage");

const { NotificationsPage: $55d3dc9bac117cf9$var$NotificationsPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "NotificationsPage");

const { NotificationsNotificationPage: $55d3dc9bac117cf9$var$NotificationsNotificationPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "NotificationsNotificationPage");

const { PostPage: $55d3dc9bac117cf9$var$PostPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "PostPage");

const { ProfilePage: $55d3dc9bac117cf9$var$ProfilePage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "ProfilePage");

const { UserPage: $55d3dc9bac117cf9$var$UserPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "UserPage");
const $55d3dc9bac117cf9$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $3YnFc.AppLayout), {
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
        })
    });
const $55d3dc9bac117cf9$export$5e62f40422be0a85 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$App, {}),
        children: [
            {
                path: (0, $b7fnN.Path).Library,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$LibraryPage, {})
            },
            {
                path: (0, $b7fnN.Path).Charts,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$ChartsPage, {})
            },
            {
                path: (0, $b7fnN.Path).Profile,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$ProfilePage, {})
            },
            {
                path: `${(0, $b7fnN.Path).Notifications}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$NotificationsPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Path).Notification}/*`,
                            element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                                children: [
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: `${(0, $b7fnN.Params).NotificationID}`,
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$NotificationsNotificationPage, {})
                                    }),
                                    /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                            to: "."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $b7fnN.Path).User}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Params).UserID}`,
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$UserPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: `${(0, $b7fnN.Path).Post}/*`,
                element: /*#__PURE__*/ (0, $9awXB.jsxs)((0, $99w1R.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: `${(0, $b7fnN.Params).PostID}`,
                            element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$PostPage, {})
                        }),
                        /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                                to: "."
                            })
                        })
                    ]
                })
            },
            {
                path: (0, $b7fnN.Path).Feed,
                element: /*#__PURE__*/ (0, $9awXB.jsx)($55d3dc9bac117cf9$var$FeedPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("1TdPt");
var $6aEHC = parcelRequire("6aEHC");
parcelRequire("1O2TI");
var $5qa04 = parcelRequire("5qa04");

const { LockPage: $ee2181dee48a4254$var$LockPage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "LockPage");
const $ee2181dee48a4254$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
        fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
            position: "full"
        }),
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
    });
const $ee2181dee48a4254$export$2e9c4093195dd337 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($ee2181dee48a4254$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $9awXB.jsx)($ee2181dee48a4254$var$LockPage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("1TdPt");
var $8BwiX = parcelRequire("8BwiX");
var $6aEHC = parcelRequire("6aEHC");
parcelRequire("1O2TI");
var $5qa04 = parcelRequire("5qa04");

const { Onboarding: $1e4ebb88c6f5116a$var$Onboarding } = (0, $5qa04.importsLazy)(()=>Promise.resolve((parcelRequire("cJvLm"))), "Onboarding");
const $1e4ebb88c6f5116a$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $8BwiX.MainLayout), {
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
                position: "full"
            }),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
        })
    });
const $1e4ebb88c6f5116a$export$aa6e74b9feedcc7d = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($1e4ebb88c6f5116a$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $9awXB.jsx)($1e4ebb88c6f5116a$var$Onboarding, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("1TdPt");
var $3YnFc = parcelRequire("3YnFc");
var $6aEHC = parcelRequire("6aEHC");
parcelRequire("1O2TI");
var $5qa04 = parcelRequire("5qa04");

const { HomePage: $c1d95ac63a14c41c$var$HomePage } = (0, $5qa04.importsLazy)(()=>(parcelRequire("gsRju")), "HomePage");
const $c1d95ac63a14c41c$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $3YnFc.AppLayout), {
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
            fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
                position: "fit"
            }),
            children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
        })
    });
const $c1d95ac63a14c41c$export$a1b9292f6ba50096 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($c1d95ac63a14c41c$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $9awXB.jsx)($c1d95ac63a14c41c$var$HomePage, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("1TdPt");
var $6aEHC = parcelRequire("6aEHC");
parcelRequire("1O2TI");
var $5qa04 = parcelRequire("5qa04");

const { AuthVerificationModal: $ac7a8e812e73aa50$var$AuthVerificationModal } = (0, $5qa04.importsLazy)(()=>Promise.resolve((parcelRequire("cJvLm"))), "AuthVerificationModal");
const $ac7a8e812e73aa50$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
        fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
            position: "full"
        }),
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
    });
const $ac7a8e812e73aa50$export$4977544b3720659f = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($ac7a8e812e73aa50$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $9awXB.jsx)($ac7a8e812e73aa50$var$AuthVerificationModal, {})
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];



var $9awXB = parcelRequire("9awXB");

var $bh6RR = parcelRequire("bh6RR");

var $99w1R = parcelRequire("99w1R");
parcelRequire("1TdPt");
var $6aEHC = parcelRequire("6aEHC");
const $a1dc7490e312bf23$var$App = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $bh6RR.Suspense), {
        fallback: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
            position: "full"
        }),
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Outlet), {})
    });
const $a1dc7490e312bf23$export$73d4a3d2a9928475 = [
    {
        path: "/",
        element: /*#__PURE__*/ (0, $9awXB.jsx)($a1dc7490e312bf23$var$App, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $6aEHC.SuspenseContentFallback), {
                    position: "full"
                })
            },
            {
                path: "*",
                element: /*#__PURE__*/ (0, $9awXB.jsx)((0, $99w1R.Navigate), {
                    to: "."
                })
            }
        ]
    }
];


const $f01c1f764b4e573d$export$37d3279522fbf5e2 = ()=>{
    const profile = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectProfile));
    const emailVerified = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectEmailVerified));
    const authRefreshing = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectRefreshing));
    const authPlatformLocked = (0, $gNvvs.useAppSelector)((0, $9HBOX.authSelectPlatformLocked));
    const platformLocked = !authRefreshing && authPlatformLocked;
    const userSignedOut = !authPlatformLocked && !authRefreshing && !profile;
    const emailIsNotVerified = !authPlatformLocked && !authRefreshing && !emailVerified && profile;
    const onboardingIsNotFinished = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage !== (0, $2gpGl.EntityOnboardingStage).Finished;
    const userIsFan = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage === (0, $2gpGl.EntityOnboardingStage).Finished && profile.role === (0, $2gpGl.EntityUserRole).Fan;
    const userIsArtist = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage === (0, $2gpGl.EntityOnboardingStage).Finished && profile.role === (0, $2gpGl.EntityUserRole).Artist;
    const userIsAdmin = !authPlatformLocked && !authRefreshing && emailVerified && profile && profile.onboardingStage === (0, $2gpGl.EntityOnboardingStage).Finished && profile.role === (0, $2gpGl.EntityUserRole).Admin;
    // default to refreshing routes
    let routes = (0, $a1dc7490e312bf23$export$73d4a3d2a9928475);
    // TODO: remove platform lock once no longer needed
    if (platformLocked) // set locked routes
    routes = (0, $ee2181dee48a4254$export$2e9c4093195dd337);
    if (userSignedOut) // set public routes
    routes = (0, $c1d95ac63a14c41c$export$a1b9292f6ba50096);
    if (emailIsNotVerified) // set verification routes
    routes = (0, $ac7a8e812e73aa50$export$4977544b3720659f);
    if (onboardingIsNotFinished) // set onboarding routes
    routes = (0, $1e4ebb88c6f5116a$export$aa6e74b9feedcc7d);
    if (userIsFan) // render fan routes
    routes = (0, $55d3dc9bac117cf9$export$5e62f40422be0a85);
    if (userIsArtist) // render artist routes
    routes = (0, $b87673dee8894fec$export$3da569daebda94b);
    if (userIsAdmin) // render admin routes
    routes = (0, $5873e14fc37870e4$export$37e8e188eda774db);
    const element = (0, $99w1R.useRoutes)([
        ...routes
    ]);
    return element;
};


const $16e924f086a574be$export$86fbec116b87613f = ()=>/*#__PURE__*/ (0, $9awXB.jsx)((0, $fb4ea54da60f30c2$export$c7dacf3845253dcf), {
        children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $f01c1f764b4e573d$export$37d3279522fbf5e2), {})
    });


const $d0bb92445f8cf837$var$container = document.getElementById("app");
const $d0bb92445f8cf837$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)($d0bb92445f8cf837$var$container);
$d0bb92445f8cf837$var$root.render(/*#__PURE__*/ (0, $9awXB.jsx)($bh6RR.StrictMode, {
    children: /*#__PURE__*/ (0, $9awXB.jsx)((0, $16e924f086a574be$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.ab58ee7c.js.map
